/* This file was auto-generated, do not modify! Run `npm run generate` to re-generate. */
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date, represented as a 'yyyy-mm-dd' string */
  Date: { input: any; output: any };
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: any; output: any };
};

export type Absence = {
  __typename?: 'Absence';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  end: Scalars['DateTime']['output'];
  person: Person;
  personConnection: AbsencePersonConnection;
  reason: AbsenceReason;
  start: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type AbsencePersonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type AbsencePersonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AbsencePersonConnectionSort>>;
  where?: InputMaybe<AbsencePersonConnectionWhere>;
};

export type AbsenceAggregateSelection = {
  __typename?: 'AbsenceAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  end: DateTimeAggregateSelection;
  start: DateTimeAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AbsenceConnectInput = {
  person?: InputMaybe<AbsencePersonConnectFieldInput>;
};

export type AbsenceConnectWhere = {
  node: AbsenceWhere;
};

export type AbsenceCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  person?: InputMaybe<AbsencePersonFieldInput>;
  reason: AbsenceReason;
  start: Scalars['DateTime']['input'];
};

export type AbsenceDeleteInput = {
  person?: InputMaybe<AbsencePersonDeleteFieldInput>;
};

export type AbsenceDisconnectInput = {
  person?: InputMaybe<AbsencePersonDisconnectFieldInput>;
};

export type AbsenceEdge = {
  __typename?: 'AbsenceEdge';
  cursor: Scalars['String']['output'];
  node: Absence;
};

export type AbsenceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AbsenceSort objects to sort Absences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AbsenceSort>>;
};

export type AbsencePersonAggregateInput = {
  AND?: InputMaybe<Array<AbsencePersonAggregateInput>>;
  NOT?: InputMaybe<AbsencePersonAggregateInput>;
  OR?: InputMaybe<Array<AbsencePersonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AbsencePersonNodeAggregationWhereInput>;
};

export type AbsencePersonConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type AbsencePersonConnectOrCreateFieldInput = {
  onCreate: AbsencePersonConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type AbsencePersonConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type AbsencePersonConnection = {
  __typename?: 'AbsencePersonConnection';
  edges: Array<AbsencePersonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AbsencePersonConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type AbsencePersonConnectionWhere = {
  AND?: InputMaybe<Array<AbsencePersonConnectionWhere>>;
  NOT?: InputMaybe<AbsencePersonConnectionWhere>;
  OR?: InputMaybe<Array<AbsencePersonConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type AbsencePersonCreateFieldInput = {
  node: PersonCreateInput;
};

export type AbsencePersonDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<AbsencePersonConnectionWhere>;
};

export type AbsencePersonDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<AbsencePersonConnectionWhere>;
};

export type AbsencePersonFieldInput = {
  connect?: InputMaybe<AbsencePersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<AbsencePersonConnectOrCreateFieldInput>;
  create?: InputMaybe<AbsencePersonCreateFieldInput>;
};

export type AbsencePersonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AbsencePersonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AbsencePersonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AbsencePersonNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AbsencePersonRelationship = {
  __typename?: 'AbsencePersonRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type AbsencePersonUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type AbsencePersonUpdateFieldInput = {
  connect?: InputMaybe<AbsencePersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<AbsencePersonConnectOrCreateFieldInput>;
  create?: InputMaybe<AbsencePersonCreateFieldInput>;
  delete?: InputMaybe<AbsencePersonDeleteFieldInput>;
  disconnect?: InputMaybe<AbsencePersonDisconnectFieldInput>;
  update?: InputMaybe<AbsencePersonUpdateConnectionInput>;
  where?: InputMaybe<AbsencePersonConnectionWhere>;
};

export enum AbsenceReason {
  Business = 'BUSINESS',
  ChildCare = 'CHILD_CARE',
  Emergency = 'EMERGENCY',
  Illness = 'ILLNESS',
  OnLeave = 'ON_LEAVE',
  Other = 'OTHER',
  Privat = 'PRIVAT',
  Training = 'TRAINING',
}

/** Fields to sort Absences by. The order in which sorts are applied is not guaranteed when specifying many fields in one AbsenceSort object. */
export type AbsenceSort = {
  comment?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  reason?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type AbsenceUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  person?: InputMaybe<AbsencePersonUpdateFieldInput>;
  reason?: InputMaybe<AbsenceReason>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AbsenceWhere = {
  AND?: InputMaybe<Array<AbsenceWhere>>;
  NOT?: InputMaybe<AbsenceWhere>;
  OR?: InputMaybe<Array<AbsenceWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  end_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  end_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  person?: InputMaybe<PersonWhere>;
  personAggregate?: InputMaybe<AbsencePersonAggregateInput>;
  personConnection?: InputMaybe<AbsencePersonConnectionWhere>;
  personConnection_NOT?: InputMaybe<AbsencePersonConnectionWhere>;
  person_NOT?: InputMaybe<PersonWhere>;
  reason?: InputMaybe<AbsenceReason>;
  reason_IN?: InputMaybe<Array<AbsenceReason>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT?: InputMaybe<AbsenceReason>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reason_NOT_IN?: InputMaybe<Array<AbsenceReason>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  start_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  start_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type AbsencesConnection = {
  __typename?: 'AbsencesConnection';
  edges: Array<AbsenceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdditionalTeachingLoad = {
  __typename?: 'AdditionalTeachingLoad';
  class?: Maybe<Class>;
  classConnection: AdditionalTeachingLoadClassConnection;
  comment?: Maybe<Scalars['String']['output']>;
  hours: Scalars['Float']['output'];
  hoursRaw?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationConnection: AdditionalTeachingLoadOrganizationConnection;
  schoolYear: SchoolYear;
  schoolYearConnection: AdditionalTeachingLoadSchoolYearConnection;
  subject?: Maybe<Subject>;
  subjectConnection: AdditionalTeachingLoadSubjectConnection;
  teacher: Person;
  teacherConnection: AdditionalTeachingLoadTeacherConnection;
  teacherListName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type AdditionalTeachingLoadClassArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type AdditionalTeachingLoadClassConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AdditionalTeachingLoadClassConnectionSort>>;
  where?: InputMaybe<AdditionalTeachingLoadClassConnectionWhere>;
};

export type AdditionalTeachingLoadOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type AdditionalTeachingLoadOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AdditionalTeachingLoadOrganizationConnectionSort>>;
  where?: InputMaybe<AdditionalTeachingLoadOrganizationConnectionWhere>;
};

export type AdditionalTeachingLoadSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type AdditionalTeachingLoadSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AdditionalTeachingLoadSchoolYearConnectionSort>>;
  where?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectionWhere>;
};

export type AdditionalTeachingLoadSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type AdditionalTeachingLoadSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AdditionalTeachingLoadSubjectConnectionSort>>;
  where?: InputMaybe<AdditionalTeachingLoadSubjectConnectionWhere>;
};

export type AdditionalTeachingLoadTeacherArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type AdditionalTeachingLoadTeacherConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AdditionalTeachingLoadTeacherConnectionSort>>;
  where?: InputMaybe<AdditionalTeachingLoadTeacherConnectionWhere>;
};

export type AdditionalTeachingLoadAggregateSelection = {
  __typename?: 'AdditionalTeachingLoadAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  hours: FloatAggregateSelection;
  hoursRaw: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type AdditionalTeachingLoadClassAggregateInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadClassAggregateInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadClassAggregateInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadClassAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AdditionalTeachingLoadClassNodeAggregationWhereInput>;
};

export type AdditionalTeachingLoadClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type AdditionalTeachingLoadClassConnectOrCreateFieldInput = {
  onCreate: AdditionalTeachingLoadClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type AdditionalTeachingLoadClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type AdditionalTeachingLoadClassConnection = {
  __typename?: 'AdditionalTeachingLoadClassConnection';
  edges: Array<AdditionalTeachingLoadClassRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdditionalTeachingLoadClassConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type AdditionalTeachingLoadClassConnectionWhere = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadClassConnectionWhere>>;
  NOT?: InputMaybe<AdditionalTeachingLoadClassConnectionWhere>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type AdditionalTeachingLoadClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type AdditionalTeachingLoadClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<AdditionalTeachingLoadClassConnectionWhere>;
};

export type AdditionalTeachingLoadClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<AdditionalTeachingLoadClassConnectionWhere>;
};

export type AdditionalTeachingLoadClassFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadClassConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadClassCreateFieldInput>;
};

export type AdditionalTeachingLoadClassNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadClassNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadClassNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadClassNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdditionalTeachingLoadClassRelationship = {
  __typename?: 'AdditionalTeachingLoadClassRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type AdditionalTeachingLoadClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type AdditionalTeachingLoadClassUpdateFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadClassConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadClassCreateFieldInput>;
  delete?: InputMaybe<AdditionalTeachingLoadClassDeleteFieldInput>;
  disconnect?: InputMaybe<AdditionalTeachingLoadClassDisconnectFieldInput>;
  update?: InputMaybe<AdditionalTeachingLoadClassUpdateConnectionInput>;
  where?: InputMaybe<AdditionalTeachingLoadClassConnectionWhere>;
};

export type AdditionalTeachingLoadConnectInput = {
  class?: InputMaybe<AdditionalTeachingLoadClassConnectFieldInput>;
  organization?: InputMaybe<AdditionalTeachingLoadOrganizationConnectFieldInput>;
  schoolYear?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectFieldInput>;
  subject?: InputMaybe<AdditionalTeachingLoadSubjectConnectFieldInput>;
  teacher?: InputMaybe<AdditionalTeachingLoadTeacherConnectFieldInput>;
};

export type AdditionalTeachingLoadConnectWhere = {
  node: AdditionalTeachingLoadWhere;
};

export type AdditionalTeachingLoadCreateInput = {
  class?: InputMaybe<AdditionalTeachingLoadClassFieldInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  hours: Scalars['Float']['input'];
  hoursRaw?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<AdditionalTeachingLoadOrganizationFieldInput>;
  schoolYear?: InputMaybe<AdditionalTeachingLoadSchoolYearFieldInput>;
  subject?: InputMaybe<AdditionalTeachingLoadSubjectFieldInput>;
  teacher?: InputMaybe<AdditionalTeachingLoadTeacherFieldInput>;
};

export type AdditionalTeachingLoadDeleteInput = {
  class?: InputMaybe<AdditionalTeachingLoadClassDeleteFieldInput>;
  organization?: InputMaybe<AdditionalTeachingLoadOrganizationDeleteFieldInput>;
  schoolYear?: InputMaybe<AdditionalTeachingLoadSchoolYearDeleteFieldInput>;
  subject?: InputMaybe<AdditionalTeachingLoadSubjectDeleteFieldInput>;
  teacher?: InputMaybe<AdditionalTeachingLoadTeacherDeleteFieldInput>;
};

export type AdditionalTeachingLoadDisconnectInput = {
  class?: InputMaybe<AdditionalTeachingLoadClassDisconnectFieldInput>;
  organization?: InputMaybe<AdditionalTeachingLoadOrganizationDisconnectFieldInput>;
  schoolYear?: InputMaybe<AdditionalTeachingLoadSchoolYearDisconnectFieldInput>;
  subject?: InputMaybe<AdditionalTeachingLoadSubjectDisconnectFieldInput>;
  teacher?: InputMaybe<AdditionalTeachingLoadTeacherDisconnectFieldInput>;
};

export type AdditionalTeachingLoadEdge = {
  __typename?: 'AdditionalTeachingLoadEdge';
  cursor: Scalars['String']['output'];
  node: AdditionalTeachingLoad;
};

export type AdditionalTeachingLoadOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AdditionalTeachingLoadSort objects to sort AdditionalTeachingLoads by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AdditionalTeachingLoadSort>>;
};

export type AdditionalTeachingLoadOrganizationAggregateInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadOrganizationAggregateInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadOrganizationAggregateInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AdditionalTeachingLoadOrganizationNodeAggregationWhereInput>;
};

export type AdditionalTeachingLoadOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type AdditionalTeachingLoadOrganizationConnectOrCreateFieldInput = {
  onCreate: AdditionalTeachingLoadOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type AdditionalTeachingLoadOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type AdditionalTeachingLoadOrganizationConnection = {
  __typename?: 'AdditionalTeachingLoadOrganizationConnection';
  edges: Array<AdditionalTeachingLoadOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdditionalTeachingLoadOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type AdditionalTeachingLoadOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadOrganizationConnectionWhere>>;
  NOT?: InputMaybe<AdditionalTeachingLoadOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type AdditionalTeachingLoadOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type AdditionalTeachingLoadOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<AdditionalTeachingLoadOrganizationConnectionWhere>;
};

export type AdditionalTeachingLoadOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<AdditionalTeachingLoadOrganizationConnectionWhere>;
};

export type AdditionalTeachingLoadOrganizationFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadOrganizationCreateFieldInput>;
};

export type AdditionalTeachingLoadOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AdditionalTeachingLoadOrganizationRelationship = {
  __typename?: 'AdditionalTeachingLoadOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type AdditionalTeachingLoadOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type AdditionalTeachingLoadOrganizationUpdateFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadOrganizationCreateFieldInput>;
  delete?: InputMaybe<AdditionalTeachingLoadOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<AdditionalTeachingLoadOrganizationDisconnectFieldInput>;
  update?: InputMaybe<AdditionalTeachingLoadOrganizationUpdateConnectionInput>;
  where?: InputMaybe<AdditionalTeachingLoadOrganizationConnectionWhere>;
};

export type AdditionalTeachingLoadSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadSchoolYearAggregateInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AdditionalTeachingLoadSchoolYearNodeAggregationWhereInput>;
};

export type AdditionalTeachingLoadSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type AdditionalTeachingLoadSchoolYearConnection = {
  __typename?: 'AdditionalTeachingLoadSchoolYearConnection';
  edges: Array<AdditionalTeachingLoadSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdditionalTeachingLoadSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type AdditionalTeachingLoadSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type AdditionalTeachingLoadSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type AdditionalTeachingLoadSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectionWhere>;
};

export type AdditionalTeachingLoadSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectionWhere>;
};

export type AdditionalTeachingLoadSchoolYearFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadSchoolYearCreateFieldInput>;
};

export type AdditionalTeachingLoadSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdditionalTeachingLoadSchoolYearRelationship = {
  __typename?: 'AdditionalTeachingLoadSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type AdditionalTeachingLoadSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type AdditionalTeachingLoadSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadSchoolYearCreateFieldInput>;
  delete?: InputMaybe<AdditionalTeachingLoadSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<AdditionalTeachingLoadSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<AdditionalTeachingLoadSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectionWhere>;
};

/** Fields to sort AdditionalTeachingLoads by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdditionalTeachingLoadSort object. */
export type AdditionalTeachingLoadSort = {
  comment?: InputMaybe<SortDirection>;
  hours?: InputMaybe<SortDirection>;
  hoursRaw?: InputMaybe<SortDirection>;
  teacherListName?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type AdditionalTeachingLoadSubjectAggregateInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadSubjectAggregateInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadSubjectAggregateInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadSubjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AdditionalTeachingLoadSubjectNodeAggregationWhereInput>;
};

export type AdditionalTeachingLoadSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type AdditionalTeachingLoadSubjectConnectOrCreateFieldInput = {
  onCreate: AdditionalTeachingLoadSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type AdditionalTeachingLoadSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type AdditionalTeachingLoadSubjectConnection = {
  __typename?: 'AdditionalTeachingLoadSubjectConnection';
  edges: Array<AdditionalTeachingLoadSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdditionalTeachingLoadSubjectConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type AdditionalTeachingLoadSubjectConnectionWhere = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadSubjectConnectionWhere>>;
  NOT?: InputMaybe<AdditionalTeachingLoadSubjectConnectionWhere>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type AdditionalTeachingLoadSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type AdditionalTeachingLoadSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<AdditionalTeachingLoadSubjectConnectionWhere>;
};

export type AdditionalTeachingLoadSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<AdditionalTeachingLoadSubjectConnectionWhere>;
};

export type AdditionalTeachingLoadSubjectFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadSubjectCreateFieldInput>;
};

export type AdditionalTeachingLoadSubjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadSubjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadSubjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadSubjectNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdditionalTeachingLoadSubjectRelationship = {
  __typename?: 'AdditionalTeachingLoadSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type AdditionalTeachingLoadSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type AdditionalTeachingLoadSubjectUpdateFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadSubjectCreateFieldInput>;
  delete?: InputMaybe<AdditionalTeachingLoadSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<AdditionalTeachingLoadSubjectDisconnectFieldInput>;
  update?: InputMaybe<AdditionalTeachingLoadSubjectUpdateConnectionInput>;
  where?: InputMaybe<AdditionalTeachingLoadSubjectConnectionWhere>;
};

export type AdditionalTeachingLoadTeacherAggregateInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadTeacherAggregateInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadTeacherAggregateInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadTeacherAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AdditionalTeachingLoadTeacherNodeAggregationWhereInput>;
};

export type AdditionalTeachingLoadTeacherConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type AdditionalTeachingLoadTeacherConnectOrCreateFieldInput = {
  onCreate: AdditionalTeachingLoadTeacherConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type AdditionalTeachingLoadTeacherConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type AdditionalTeachingLoadTeacherConnection = {
  __typename?: 'AdditionalTeachingLoadTeacherConnection';
  edges: Array<AdditionalTeachingLoadTeacherRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdditionalTeachingLoadTeacherConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type AdditionalTeachingLoadTeacherConnectionWhere = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadTeacherConnectionWhere>>;
  NOT?: InputMaybe<AdditionalTeachingLoadTeacherConnectionWhere>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadTeacherConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type AdditionalTeachingLoadTeacherCreateFieldInput = {
  node: PersonCreateInput;
};

export type AdditionalTeachingLoadTeacherDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<AdditionalTeachingLoadTeacherConnectionWhere>;
};

export type AdditionalTeachingLoadTeacherDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<AdditionalTeachingLoadTeacherConnectionWhere>;
};

export type AdditionalTeachingLoadTeacherFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadTeacherConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadTeacherConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadTeacherCreateFieldInput>;
};

export type AdditionalTeachingLoadTeacherNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadTeacherNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AdditionalTeachingLoadTeacherNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadTeacherNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdditionalTeachingLoadTeacherRelationship = {
  __typename?: 'AdditionalTeachingLoadTeacherRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type AdditionalTeachingLoadTeacherUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type AdditionalTeachingLoadTeacherUpdateFieldInput = {
  connect?: InputMaybe<AdditionalTeachingLoadTeacherConnectFieldInput>;
  connectOrCreate?: InputMaybe<AdditionalTeachingLoadTeacherConnectOrCreateFieldInput>;
  create?: InputMaybe<AdditionalTeachingLoadTeacherCreateFieldInput>;
  delete?: InputMaybe<AdditionalTeachingLoadTeacherDeleteFieldInput>;
  disconnect?: InputMaybe<AdditionalTeachingLoadTeacherDisconnectFieldInput>;
  update?: InputMaybe<AdditionalTeachingLoadTeacherUpdateConnectionInput>;
  where?: InputMaybe<AdditionalTeachingLoadTeacherConnectionWhere>;
};

export type AdditionalTeachingLoadUpdateInput = {
  class?: InputMaybe<AdditionalTeachingLoadClassUpdateFieldInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw?: InputMaybe<Scalars['String']['input']>;
  hours_ADD?: InputMaybe<Scalars['Float']['input']>;
  hours_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  hours_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  hours_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  organization?: InputMaybe<AdditionalTeachingLoadOrganizationUpdateFieldInput>;
  schoolYear?: InputMaybe<AdditionalTeachingLoadSchoolYearUpdateFieldInput>;
  subject?: InputMaybe<AdditionalTeachingLoadSubjectUpdateFieldInput>;
  teacher?: InputMaybe<AdditionalTeachingLoadTeacherUpdateFieldInput>;
};

export type AdditionalTeachingLoadWhere = {
  AND?: InputMaybe<Array<AdditionalTeachingLoadWhere>>;
  NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
  OR?: InputMaybe<Array<AdditionalTeachingLoadWhere>>;
  class?: InputMaybe<ClassWhere>;
  classAggregate?: InputMaybe<AdditionalTeachingLoadClassAggregateInput>;
  classConnection?: InputMaybe<AdditionalTeachingLoadClassConnectionWhere>;
  classConnection_NOT?: InputMaybe<AdditionalTeachingLoadClassConnectionWhere>;
  class_NOT?: InputMaybe<ClassWhere>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw?: InputMaybe<Scalars['String']['input']>;
  hoursRaw_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  hoursRaw_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  hoursRaw_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hoursRaw_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hoursRaw_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hoursRaw_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hoursRaw_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hoursRaw_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hoursRaw_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hours_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  hours_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hours_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hours_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<AdditionalTeachingLoadOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<AdditionalTeachingLoadOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<AdditionalTeachingLoadOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<AdditionalTeachingLoadSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<AdditionalTeachingLoadSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  subject?: InputMaybe<SubjectWhere>;
  subjectAggregate?: InputMaybe<AdditionalTeachingLoadSubjectAggregateInput>;
  subjectConnection?: InputMaybe<AdditionalTeachingLoadSubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<AdditionalTeachingLoadSubjectConnectionWhere>;
  subject_NOT?: InputMaybe<SubjectWhere>;
  teacher?: InputMaybe<PersonWhere>;
  teacherAggregate?: InputMaybe<AdditionalTeachingLoadTeacherAggregateInput>;
  teacherConnection?: InputMaybe<AdditionalTeachingLoadTeacherConnectionWhere>;
  teacherConnection_NOT?: InputMaybe<AdditionalTeachingLoadTeacherConnectionWhere>;
  teacherListName?: InputMaybe<Scalars['String']['input']>;
  teacherListName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  teacherListName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  teacherListName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherListName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherListName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherListName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherListName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherListName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teacherListName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teacher_NOT?: InputMaybe<PersonWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type AdditionalTeachingLoadsConnection = {
  __typename?: 'AdditionalTeachingLoadsConnection';
  edges: Array<AdditionalTeachingLoadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AffectedEntityType {
  Absence = 'ABSENCE',
  Class = 'CLASS',
  Group = 'GROUP',
  OtherEvent = 'OTHER_EVENT',
  Person = 'PERSON',
  Room = 'ROOM',
}

export type AttendancePlanEvent = {
  __typename?: 'AttendancePlanEvent';
  canceled: Scalars['Boolean']['output'];
  class: MinimalClass;
  end: Scalars['DateTime']['output'];
  isClassbookRelevant: Scalars['Boolean']['output'];
  isSchoolEvent: Scalars['Boolean']['output'];
  persons: Array<MinimalPerson>;
  print: Scalars['Boolean']['output'];
  rooms: Array<MinimalRoom>;
  start: Scalars['DateTime']['output'];
  subject: MinimalSubject;
  uuid: Scalars['ID']['output'];
};

export type AvailabilityHolder = Class | Person | Room | Subject;

export type AvailabilityHolderWhere = {
  Class?: InputMaybe<ClassWhere>;
  Person?: InputMaybe<PersonWhere>;
  Room?: InputMaybe<RoomWhere>;
  Subject?: InputMaybe<SubjectWhere>;
};

export enum BillingMethods {
  ContractIsMax = 'CONTRACT_IS_MAX',
  ContractIsMin = 'CONTRACT_IS_MIN',
  Exact = 'EXACT',
  GivenHours = 'GIVEN_HOURS',
}

export type Building = {
  __typename?: 'Building';
  active?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  labels: Array<Label>;
  labelsConnection: BuildingLabelsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: BuildingOrganizationConnection;
  responsiblePerson: Array<Person>;
  responsiblePersonConnection: BuildingResponsiblePersonConnection;
  rooms: Array<Room>;
  roomsAggregate?: Maybe<BuildingRoomRoomsAggregationSelection>;
  roomsConnection: BuildingRoomsConnection;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BuildingLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type BuildingLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BuildingLabelsConnectionSort>>;
  where?: InputMaybe<BuildingLabelsConnectionWhere>;
};

export type BuildingOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type BuildingOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BuildingOrganizationConnectionSort>>;
  where?: InputMaybe<BuildingOrganizationConnectionWhere>;
};

export type BuildingResponsiblePersonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type BuildingResponsiblePersonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BuildingResponsiblePersonConnectionSort>>;
  where?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
};

export type BuildingRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type BuildingRoomsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoomWhere>;
};

export type BuildingRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BuildingRoomsConnectionSort>>;
  where?: InputMaybe<BuildingRoomsConnectionWhere>;
};

export type BuildingAggregateSelection = {
  __typename?: 'BuildingAggregateSelection';
  city: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  houseNumber: StringAggregateSelection;
  name: StringAggregateSelection;
  street: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
  zipCode: StringAggregateSelection;
};

export type BuildingConnectInput = {
  labels?: InputMaybe<Array<BuildingLabelsConnectFieldInput>>;
  organization?: InputMaybe<BuildingOrganizationConnectFieldInput>;
  responsiblePerson?: InputMaybe<Array<BuildingResponsiblePersonConnectFieldInput>>;
  rooms?: InputMaybe<Array<BuildingRoomsConnectFieldInput>>;
};

export type BuildingConnectOrCreateWhere = {
  node: BuildingUniqueWhere;
};

export type BuildingConnectWhere = {
  node: BuildingWhere;
};

export type BuildingCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<BuildingLabelsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<BuildingOrganizationFieldInput>;
  responsiblePerson?: InputMaybe<BuildingResponsiblePersonFieldInput>;
  rooms?: InputMaybe<BuildingRoomsFieldInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingDeleteInput = {
  labels?: InputMaybe<Array<BuildingLabelsDeleteFieldInput>>;
  organization?: InputMaybe<BuildingOrganizationDeleteFieldInput>;
  responsiblePerson?: InputMaybe<Array<BuildingResponsiblePersonDeleteFieldInput>>;
  rooms?: InputMaybe<Array<BuildingRoomsDeleteFieldInput>>;
};

export type BuildingDisconnectInput = {
  labels?: InputMaybe<Array<BuildingLabelsDisconnectFieldInput>>;
  organization?: InputMaybe<BuildingOrganizationDisconnectFieldInput>;
  responsiblePerson?: InputMaybe<Array<BuildingResponsiblePersonDisconnectFieldInput>>;
  rooms?: InputMaybe<Array<BuildingRoomsDisconnectFieldInput>>;
};

export type BuildingEdge = {
  __typename?: 'BuildingEdge';
  cursor: Scalars['String']['output'];
  node: Building;
};

export type BuildingLabelsAggregateInput = {
  AND?: InputMaybe<Array<BuildingLabelsAggregateInput>>;
  NOT?: InputMaybe<BuildingLabelsAggregateInput>;
  OR?: InputMaybe<Array<BuildingLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BuildingLabelsNodeAggregationWhereInput>;
};

export type BuildingLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type BuildingLabelsConnection = {
  __typename?: 'BuildingLabelsConnection';
  edges: Array<BuildingLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuildingLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type BuildingLabelsConnectionWhere = {
  AND?: InputMaybe<Array<BuildingLabelsConnectionWhere>>;
  NOT?: InputMaybe<BuildingLabelsConnectionWhere>;
  OR?: InputMaybe<Array<BuildingLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type BuildingLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type BuildingLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<BuildingLabelsConnectionWhere>;
};

export type BuildingLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<BuildingLabelsConnectionWhere>;
};

export type BuildingLabelsFieldInput = {
  connect?: InputMaybe<Array<BuildingLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<BuildingLabelsCreateFieldInput>>;
};

export type BuildingLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BuildingLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BuildingLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BuildingLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BuildingLabelsRelationship = {
  __typename?: 'BuildingLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type BuildingLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type BuildingLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<BuildingLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<BuildingLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<BuildingLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<BuildingLabelsDisconnectFieldInput>>;
  update?: InputMaybe<BuildingLabelsUpdateConnectionInput>;
  where?: InputMaybe<BuildingLabelsConnectionWhere>;
};

export type BuildingOnCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BuildingSort objects to sort Buildings by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BuildingSort>>;
};

export type BuildingOrganizationAggregateInput = {
  AND?: InputMaybe<Array<BuildingOrganizationAggregateInput>>;
  NOT?: InputMaybe<BuildingOrganizationAggregateInput>;
  OR?: InputMaybe<Array<BuildingOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BuildingOrganizationNodeAggregationWhereInput>;
};

export type BuildingOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type BuildingOrganizationConnectOrCreateFieldInput = {
  onCreate: BuildingOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type BuildingOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type BuildingOrganizationConnection = {
  __typename?: 'BuildingOrganizationConnection';
  edges: Array<BuildingOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuildingOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type BuildingOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<BuildingOrganizationConnectionWhere>>;
  NOT?: InputMaybe<BuildingOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<BuildingOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type BuildingOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type BuildingOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<BuildingOrganizationConnectionWhere>;
};

export type BuildingOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<BuildingOrganizationConnectionWhere>;
};

export type BuildingOrganizationFieldInput = {
  connect?: InputMaybe<BuildingOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<BuildingOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<BuildingOrganizationCreateFieldInput>;
};

export type BuildingOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BuildingOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BuildingOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BuildingOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildingOrganizationRelationship = {
  __typename?: 'BuildingOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type BuildingOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type BuildingOrganizationUpdateFieldInput = {
  connect?: InputMaybe<BuildingOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<BuildingOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<BuildingOrganizationCreateFieldInput>;
  delete?: InputMaybe<BuildingOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<BuildingOrganizationDisconnectFieldInput>;
  update?: InputMaybe<BuildingOrganizationUpdateConnectionInput>;
  where?: InputMaybe<BuildingOrganizationConnectionWhere>;
};

export type BuildingResponsiblePersonAggregateInput = {
  AND?: InputMaybe<Array<BuildingResponsiblePersonAggregateInput>>;
  NOT?: InputMaybe<BuildingResponsiblePersonAggregateInput>;
  OR?: InputMaybe<Array<BuildingResponsiblePersonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BuildingResponsiblePersonNodeAggregationWhereInput>;
};

export type BuildingResponsiblePersonConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type BuildingResponsiblePersonConnectOrCreateFieldInput = {
  onCreate: BuildingResponsiblePersonConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type BuildingResponsiblePersonConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type BuildingResponsiblePersonConnection = {
  __typename?: 'BuildingResponsiblePersonConnection';
  edges: Array<BuildingResponsiblePersonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuildingResponsiblePersonConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type BuildingResponsiblePersonConnectionWhere = {
  AND?: InputMaybe<Array<BuildingResponsiblePersonConnectionWhere>>;
  NOT?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
  OR?: InputMaybe<Array<BuildingResponsiblePersonConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type BuildingResponsiblePersonCreateFieldInput = {
  node: PersonCreateInput;
};

export type BuildingResponsiblePersonDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
};

export type BuildingResponsiblePersonDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
};

export type BuildingResponsiblePersonFieldInput = {
  connect?: InputMaybe<Array<BuildingResponsiblePersonConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<BuildingResponsiblePersonConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<BuildingResponsiblePersonCreateFieldInput>>;
};

export type BuildingResponsiblePersonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BuildingResponsiblePersonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BuildingResponsiblePersonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BuildingResponsiblePersonNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BuildingResponsiblePersonRelationship = {
  __typename?: 'BuildingResponsiblePersonRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type BuildingResponsiblePersonUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type BuildingResponsiblePersonUpdateFieldInput = {
  connect?: InputMaybe<Array<BuildingResponsiblePersonConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<BuildingResponsiblePersonConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<BuildingResponsiblePersonCreateFieldInput>>;
  delete?: InputMaybe<Array<BuildingResponsiblePersonDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<BuildingResponsiblePersonDisconnectFieldInput>>;
  update?: InputMaybe<BuildingResponsiblePersonUpdateConnectionInput>;
  where?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
};

export type BuildingRoomRoomsAggregationSelection = {
  __typename?: 'BuildingRoomRoomsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<BuildingRoomRoomsNodeAggregateSelection>;
};

export type BuildingRoomRoomsNodeAggregateSelection = {
  __typename?: 'BuildingRoomRoomsNodeAggregateSelection';
  capacity: IntAggregateSelection;
  chairs: IntAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  otherInventory: StringAggregateSelection;
  position: StringAggregateSelection;
  roomNumber: StringAggregateSelection;
  size: IntAggregateSelection;
  tables: IntAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type BuildingRoomsAggregateInput = {
  AND?: InputMaybe<Array<BuildingRoomsAggregateInput>>;
  NOT?: InputMaybe<BuildingRoomsAggregateInput>;
  OR?: InputMaybe<Array<BuildingRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BuildingRoomsNodeAggregationWhereInput>;
};

export type BuildingRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type BuildingRoomsConnectOrCreateFieldInput = {
  onCreate: BuildingRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type BuildingRoomsConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type BuildingRoomsConnection = {
  __typename?: 'BuildingRoomsConnection';
  edges: Array<BuildingRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuildingRoomsConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type BuildingRoomsConnectionWhere = {
  AND?: InputMaybe<Array<BuildingRoomsConnectionWhere>>;
  NOT?: InputMaybe<BuildingRoomsConnectionWhere>;
  OR?: InputMaybe<Array<BuildingRoomsConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type BuildingRoomsCreateFieldInput = {
  node: RoomCreateInput;
};

export type BuildingRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<BuildingRoomsConnectionWhere>;
};

export type BuildingRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<BuildingRoomsConnectionWhere>;
};

export type BuildingRoomsFieldInput = {
  connect?: InputMaybe<Array<BuildingRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<BuildingRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<BuildingRoomsCreateFieldInput>>;
};

export type BuildingRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BuildingRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BuildingRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BuildingRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BuildingRoomsRelationship = {
  __typename?: 'BuildingRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type BuildingRoomsUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type BuildingRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<BuildingRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<BuildingRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<BuildingRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<BuildingRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<BuildingRoomsDisconnectFieldInput>>;
  update?: InputMaybe<BuildingRoomsUpdateConnectionInput>;
  where?: InputMaybe<BuildingRoomsConnectionWhere>;
};

/** Fields to sort Buildings by. The order in which sorts are applied is not guaranteed when specifying many fields in one BuildingSort object. */
export type BuildingSort = {
  active?: InputMaybe<SortDirection>;
  city?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  houseNumber?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  street?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  zipCode?: InputMaybe<SortDirection>;
};

export type BuildingUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<BuildingLabelsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<BuildingOrganizationUpdateFieldInput>;
  responsiblePerson?: InputMaybe<Array<BuildingResponsiblePersonUpdateFieldInput>>;
  rooms?: InputMaybe<Array<BuildingRoomsUpdateFieldInput>>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingWhere = {
  AND?: InputMaybe<Array<BuildingWhere>>;
  NOT?: InputMaybe<BuildingWhere>;
  OR?: InputMaybe<Array<BuildingWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  city_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  city_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  city_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  houseNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  houseNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  houseNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  houseNumber_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  houseNumber_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  houseNumber_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  houseNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  houseNumber_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  houseNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<BuildingLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<BuildingLabelsConnectionWhere>;
  /** Return Buildings where all of the related BuildingLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<BuildingLabelsConnectionWhere>;
  /** Return Buildings where none of the related BuildingLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<BuildingLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<BuildingLabelsConnectionWhere>;
  /** Return Buildings where one of the related BuildingLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<BuildingLabelsConnectionWhere>;
  /** Return Buildings where some of the related BuildingLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<BuildingLabelsConnectionWhere>;
  /** Return Buildings where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Buildings where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Buildings where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Buildings where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<BuildingOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<BuildingOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<BuildingOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `responsiblePerson_SOME` instead. */
  responsiblePerson?: InputMaybe<PersonWhere>;
  responsiblePersonAggregate?: InputMaybe<BuildingResponsiblePersonAggregateInput>;
  /** @deprecated Use `responsiblePersonConnection_SOME` instead. */
  responsiblePersonConnection?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
  /** Return Buildings where all of the related BuildingResponsiblePersonConnections match this filter */
  responsiblePersonConnection_ALL?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
  /** Return Buildings where none of the related BuildingResponsiblePersonConnections match this filter */
  responsiblePersonConnection_NONE?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
  /** @deprecated Use `responsiblePersonConnection_NONE` instead. */
  responsiblePersonConnection_NOT?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
  /** Return Buildings where one of the related BuildingResponsiblePersonConnections match this filter */
  responsiblePersonConnection_SINGLE?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
  /** Return Buildings where some of the related BuildingResponsiblePersonConnections match this filter */
  responsiblePersonConnection_SOME?: InputMaybe<BuildingResponsiblePersonConnectionWhere>;
  /** Return Buildings where all of the related People match this filter */
  responsiblePerson_ALL?: InputMaybe<PersonWhere>;
  /** Return Buildings where none of the related People match this filter */
  responsiblePerson_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `responsiblePerson_NONE` instead. */
  responsiblePerson_NOT?: InputMaybe<PersonWhere>;
  /** Return Buildings where one of the related People match this filter */
  responsiblePerson_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Buildings where some of the related People match this filter */
  responsiblePerson_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<BuildingRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<BuildingRoomsConnectionWhere>;
  /** Return Buildings where all of the related BuildingRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<BuildingRoomsConnectionWhere>;
  /** Return Buildings where none of the related BuildingRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<BuildingRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<BuildingRoomsConnectionWhere>;
  /** Return Buildings where one of the related BuildingRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<BuildingRoomsConnectionWhere>;
  /** Return Buildings where some of the related BuildingRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<BuildingRoomsConnectionWhere>;
  /** Return Buildings where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return Buildings where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return Buildings where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return Buildings where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  street_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  street_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  street_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  street_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  street_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  street_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  street_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  street_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  zipCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  zipCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  zipCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  zipCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingsConnection = {
  __typename?: 'BuildingsConnection';
  edges: Array<BuildingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Class = {
  __typename?: 'Class';
  additionalTeachingLoads: Array<AdditionalTeachingLoad>;
  additionalTeachingLoadsConnection: ClassAdditionalTeachingLoadsConnection;
  certificatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultRoom?: Maybe<Room>;
  defaultRoomConnection: ClassDefaultRoomConnection;
  divisions: Array<Division>;
  divisionsAggregate?: Maybe<ClassDivisionDivisionsAggregationSelection>;
  divisionsConnection: ClassDivisionsConnection;
  events: Array<Event>;
  eventsConnection: ClassEventsConnection;
  foreignId?: Maybe<Scalars['String']['output']>;
  functionalClassSubstitutionBehavior?: Maybe<FunctionalClassSubstitutionBehavior>;
  grade?: Maybe<Scalars['Int']['output']>;
  gradeGroup?: Maybe<GradeGroup>;
  gradeGroupConnection: ClassGradeGroupConnection;
  gradeGroupName?: Maybe<Scalars['String']['output']>;
  gradeGroupShortName?: Maybe<Scalars['String']['output']>;
  labels: Array<Label>;
  labelsAggregate?: Maybe<ClassLabelLabelsAggregationSelection>;
  labelsConnection: ClassLabelsConnection;
  lessonClasses: Array<LessonClass>;
  lessonClassesAggregate?: Maybe<ClassLessonClassLessonClassesAggregationSelection>;
  lessonClassesConnection: ClassLessonClassesConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: ClassOrganizationConnection;
  /** Markiert die Klasse als relevant für den Vertretungsplan. DH bei grade != null werden Events erstellt und bei grade = null wird anhand von functionalClassSubstitutionBehavior entschieden */
  relevantForSubstitution?: Maybe<Scalars['Boolean']['output']>;
  schoolYear: SchoolYear;
  schoolYearConnection: ClassSchoolYearConnection;
  shortName: Scalars['String']['output'];
  sortName?: Maybe<Scalars['String']['output']>;
  timetableConfig?: Maybe<TimetableConfig>;
  timetableConfigConnection: ClassTimetableConfigConnection;
  timetableVersions: Array<TimetableVersion>;
  timetableVersionsConnection: ClassTimetableVersionsConnection;
  tutors: Array<Person>;
  tutorsAggregate?: Maybe<ClassPersonTutorsAggregationSelection>;
  tutorsConnection: ClassTutorsConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type ClassAdditionalTeachingLoadsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AdditionalTeachingLoadOptions>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type ClassAdditionalTeachingLoadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassAdditionalTeachingLoadsConnectionSort>>;
  where?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
};

export type ClassDefaultRoomArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type ClassDefaultRoomConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassDefaultRoomConnectionSort>>;
  where?: InputMaybe<ClassDefaultRoomConnectionWhere>;
};

export type ClassDivisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DivisionOptions>;
  where?: InputMaybe<DivisionWhere>;
};

export type ClassDivisionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DivisionWhere>;
};

export type ClassDivisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassDivisionsConnectionSort>>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type ClassEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassEventsConnectionSort>>;
  where?: InputMaybe<ClassEventsConnectionWhere>;
};

export type ClassGradeGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GradeGroupOptions>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type ClassGradeGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassGradeGroupConnectionSort>>;
  where?: InputMaybe<ClassGradeGroupConnectionWhere>;
};

export type ClassLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type ClassLabelsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LabelWhere>;
};

export type ClassLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassLabelsConnectionSort>>;
  where?: InputMaybe<ClassLabelsConnectionWhere>;
};

export type ClassLessonClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonClassOptions>;
  where?: InputMaybe<LessonClassWhere>;
};

export type ClassLessonClassesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonClassWhere>;
};

export type ClassLessonClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassLessonClassesConnectionSort>>;
  where?: InputMaybe<ClassLessonClassesConnectionWhere>;
};

export type ClassOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type ClassOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassOrganizationConnectionSort>>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type ClassSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassSchoolYearConnectionSort>>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

export type ClassTimetableConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableConfigOptions>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type ClassTimetableConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassTimetableConfigConnectionSort>>;
  where?: InputMaybe<ClassTimetableConfigConnectionWhere>;
};

export type ClassTimetableVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type ClassTimetableVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassTimetableVersionsConnectionSort>>;
  where?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
};

export type ClassTutorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type ClassTutorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};

export type ClassTutorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ClassTutorsConnectionSort>>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassAdditionalTeachingLoadsAggregateInput = {
  AND?: InputMaybe<Array<ClassAdditionalTeachingLoadsAggregateInput>>;
  NOT?: InputMaybe<ClassAdditionalTeachingLoadsAggregateInput>;
  OR?: InputMaybe<Array<ClassAdditionalTeachingLoadsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassAdditionalTeachingLoadsNodeAggregationWhereInput>;
};

export type ClassAdditionalTeachingLoadsConnectFieldInput = {
  connect?: InputMaybe<Array<AdditionalTeachingLoadConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AdditionalTeachingLoadConnectWhere>;
};

export type ClassAdditionalTeachingLoadsConnection = {
  __typename?: 'ClassAdditionalTeachingLoadsConnection';
  edges: Array<ClassAdditionalTeachingLoadsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassAdditionalTeachingLoadsConnectionSort = {
  node?: InputMaybe<AdditionalTeachingLoadSort>;
};

export type ClassAdditionalTeachingLoadsConnectionWhere = {
  AND?: InputMaybe<Array<ClassAdditionalTeachingLoadsConnectionWhere>>;
  NOT?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
  OR?: InputMaybe<Array<ClassAdditionalTeachingLoadsConnectionWhere>>;
  node?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type ClassAdditionalTeachingLoadsCreateFieldInput = {
  node: AdditionalTeachingLoadCreateInput;
};

export type ClassAdditionalTeachingLoadsDeleteFieldInput = {
  delete?: InputMaybe<AdditionalTeachingLoadDeleteInput>;
  where?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
};

export type ClassAdditionalTeachingLoadsDisconnectFieldInput = {
  disconnect?: InputMaybe<AdditionalTeachingLoadDisconnectInput>;
  where?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
};

export type ClassAdditionalTeachingLoadsFieldInput = {
  connect?: InputMaybe<Array<ClassAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassAdditionalTeachingLoadsCreateFieldInput>>;
};

export type ClassAdditionalTeachingLoadsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassAdditionalTeachingLoadsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ClassAdditionalTeachingLoadsRelationship = {
  __typename?: 'ClassAdditionalTeachingLoadsRelationship';
  cursor: Scalars['String']['output'];
  node: AdditionalTeachingLoad;
};

export type ClassAdditionalTeachingLoadsUpdateConnectionInput = {
  node?: InputMaybe<AdditionalTeachingLoadUpdateInput>;
};

export type ClassAdditionalTeachingLoadsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassAdditionalTeachingLoadsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassAdditionalTeachingLoadsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassAdditionalTeachingLoadsDisconnectFieldInput>>;
  update?: InputMaybe<ClassAdditionalTeachingLoadsUpdateConnectionInput>;
  where?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
};

export type ClassAggregateSelection = {
  __typename?: 'ClassAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  grade: IntAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassConnectInput = {
  additionalTeachingLoads?: InputMaybe<Array<ClassAdditionalTeachingLoadsConnectFieldInput>>;
  defaultRoom?: InputMaybe<ClassDefaultRoomConnectFieldInput>;
  divisions?: InputMaybe<Array<ClassDivisionsConnectFieldInput>>;
  events?: InputMaybe<Array<ClassEventsConnectFieldInput>>;
  gradeGroup?: InputMaybe<ClassGradeGroupConnectFieldInput>;
  labels?: InputMaybe<Array<ClassLabelsConnectFieldInput>>;
  lessonClasses?: InputMaybe<Array<ClassLessonClassesConnectFieldInput>>;
  organization?: InputMaybe<ClassOrganizationConnectFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearConnectFieldInput>;
  timetableConfig?: InputMaybe<ClassTimetableConfigConnectFieldInput>;
  timetableVersions?: InputMaybe<Array<ClassTimetableVersionsConnectFieldInput>>;
  tutors?: InputMaybe<Array<ClassTutorsConnectFieldInput>>;
};

export type ClassConnectOrCreateWhere = {
  node: ClassUniqueWhere;
};

export type ClassConnectWhere = {
  node: ClassWhere;
};

export type ClassCreateInput = {
  additionalTeachingLoads?: InputMaybe<ClassAdditionalTeachingLoadsFieldInput>;
  certificatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultRoom?: InputMaybe<ClassDefaultRoomFieldInput>;
  divisions?: InputMaybe<ClassDivisionsFieldInput>;
  events?: InputMaybe<ClassEventsFieldInput>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  functionalClassSubstitutionBehavior?: InputMaybe<FunctionalClassSubstitutionBehavior>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup?: InputMaybe<ClassGradeGroupFieldInput>;
  labels?: InputMaybe<ClassLabelsFieldInput>;
  lessonClasses?: InputMaybe<ClassLessonClassesFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<ClassOrganizationFieldInput>;
  relevantForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYear?: InputMaybe<ClassSchoolYearFieldInput>;
  shortName: Scalars['String']['input'];
  timetableConfig?: InputMaybe<ClassTimetableConfigFieldInput>;
  timetableVersions?: InputMaybe<ClassTimetableVersionsFieldInput>;
  tutors?: InputMaybe<ClassTutorsFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassDefaultRoomAggregateInput = {
  AND?: InputMaybe<Array<ClassDefaultRoomAggregateInput>>;
  NOT?: InputMaybe<ClassDefaultRoomAggregateInput>;
  OR?: InputMaybe<Array<ClassDefaultRoomAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassDefaultRoomNodeAggregationWhereInput>;
};

export type ClassDefaultRoomConnectFieldInput = {
  connect?: InputMaybe<RoomConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type ClassDefaultRoomConnectOrCreateFieldInput = {
  onCreate: ClassDefaultRoomConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type ClassDefaultRoomConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type ClassDefaultRoomConnection = {
  __typename?: 'ClassDefaultRoomConnection';
  edges: Array<ClassDefaultRoomRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassDefaultRoomConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type ClassDefaultRoomConnectionWhere = {
  AND?: InputMaybe<Array<ClassDefaultRoomConnectionWhere>>;
  NOT?: InputMaybe<ClassDefaultRoomConnectionWhere>;
  OR?: InputMaybe<Array<ClassDefaultRoomConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type ClassDefaultRoomCreateFieldInput = {
  node: RoomCreateInput;
};

export type ClassDefaultRoomDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<ClassDefaultRoomConnectionWhere>;
};

export type ClassDefaultRoomDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<ClassDefaultRoomConnectionWhere>;
};

export type ClassDefaultRoomFieldInput = {
  connect?: InputMaybe<ClassDefaultRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassDefaultRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassDefaultRoomCreateFieldInput>;
};

export type ClassDefaultRoomNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassDefaultRoomNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassDefaultRoomNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassDefaultRoomNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassDefaultRoomRelationship = {
  __typename?: 'ClassDefaultRoomRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type ClassDefaultRoomUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type ClassDefaultRoomUpdateFieldInput = {
  connect?: InputMaybe<ClassDefaultRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassDefaultRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassDefaultRoomCreateFieldInput>;
  delete?: InputMaybe<ClassDefaultRoomDeleteFieldInput>;
  disconnect?: InputMaybe<ClassDefaultRoomDisconnectFieldInput>;
  update?: InputMaybe<ClassDefaultRoomUpdateConnectionInput>;
  where?: InputMaybe<ClassDefaultRoomConnectionWhere>;
};

export type ClassDeleteInput = {
  additionalTeachingLoads?: InputMaybe<Array<ClassAdditionalTeachingLoadsDeleteFieldInput>>;
  defaultRoom?: InputMaybe<ClassDefaultRoomDeleteFieldInput>;
  divisions?: InputMaybe<Array<ClassDivisionsDeleteFieldInput>>;
  events?: InputMaybe<Array<ClassEventsDeleteFieldInput>>;
  gradeGroup?: InputMaybe<ClassGradeGroupDeleteFieldInput>;
  labels?: InputMaybe<Array<ClassLabelsDeleteFieldInput>>;
  lessonClasses?: InputMaybe<Array<ClassLessonClassesDeleteFieldInput>>;
  organization?: InputMaybe<ClassOrganizationDeleteFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearDeleteFieldInput>;
  timetableConfig?: InputMaybe<ClassTimetableConfigDeleteFieldInput>;
  timetableVersions?: InputMaybe<Array<ClassTimetableVersionsDeleteFieldInput>>;
  tutors?: InputMaybe<Array<ClassTutorsDeleteFieldInput>>;
};

export type ClassDisconnectInput = {
  additionalTeachingLoads?: InputMaybe<Array<ClassAdditionalTeachingLoadsDisconnectFieldInput>>;
  defaultRoom?: InputMaybe<ClassDefaultRoomDisconnectFieldInput>;
  divisions?: InputMaybe<Array<ClassDivisionsDisconnectFieldInput>>;
  events?: InputMaybe<Array<ClassEventsDisconnectFieldInput>>;
  gradeGroup?: InputMaybe<ClassGradeGroupDisconnectFieldInput>;
  labels?: InputMaybe<Array<ClassLabelsDisconnectFieldInput>>;
  lessonClasses?: InputMaybe<Array<ClassLessonClassesDisconnectFieldInput>>;
  organization?: InputMaybe<ClassOrganizationDisconnectFieldInput>;
  schoolYear?: InputMaybe<ClassSchoolYearDisconnectFieldInput>;
  timetableConfig?: InputMaybe<ClassTimetableConfigDisconnectFieldInput>;
  timetableVersions?: InputMaybe<Array<ClassTimetableVersionsDisconnectFieldInput>>;
  tutors?: InputMaybe<Array<ClassTutorsDisconnectFieldInput>>;
};

export type ClassDivisionDivisionsAggregationSelection = {
  __typename?: 'ClassDivisionDivisionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ClassDivisionDivisionsNodeAggregateSelection>;
};

export type ClassDivisionDivisionsNodeAggregateSelection = {
  __typename?: 'ClassDivisionDivisionsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassDivisionsAggregateInput = {
  AND?: InputMaybe<Array<ClassDivisionsAggregateInput>>;
  NOT?: InputMaybe<ClassDivisionsAggregateInput>;
  OR?: InputMaybe<Array<ClassDivisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassDivisionsNodeAggregationWhereInput>;
};

export type ClassDivisionsConnectFieldInput = {
  connect?: InputMaybe<Array<DivisionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DivisionConnectWhere>;
};

export type ClassDivisionsConnectOrCreateFieldInput = {
  onCreate: ClassDivisionsConnectOrCreateFieldInputOnCreate;
  where: DivisionConnectOrCreateWhere;
};

export type ClassDivisionsConnectOrCreateFieldInputOnCreate = {
  node: DivisionOnCreateInput;
};

export type ClassDivisionsConnection = {
  __typename?: 'ClassDivisionsConnection';
  edges: Array<ClassDivisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassDivisionsConnectionSort = {
  node?: InputMaybe<DivisionSort>;
};

export type ClassDivisionsConnectionWhere = {
  AND?: InputMaybe<Array<ClassDivisionsConnectionWhere>>;
  NOT?: InputMaybe<ClassDivisionsConnectionWhere>;
  OR?: InputMaybe<Array<ClassDivisionsConnectionWhere>>;
  node?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DivisionWhere>;
};

export type ClassDivisionsCreateFieldInput = {
  node: DivisionCreateInput;
};

export type ClassDivisionsDeleteFieldInput = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassDivisionsDisconnectFieldInput = {
  disconnect?: InputMaybe<DivisionDisconnectInput>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassDivisionsFieldInput = {
  connect?: InputMaybe<Array<ClassDivisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassDivisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassDivisionsCreateFieldInput>>;
};

export type ClassDivisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassDivisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassDivisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassDivisionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassDivisionsRelationship = {
  __typename?: 'ClassDivisionsRelationship';
  cursor: Scalars['String']['output'];
  node: Division;
};

export type ClassDivisionsUpdateConnectionInput = {
  node?: InputMaybe<DivisionUpdateInput>;
};

export type ClassDivisionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassDivisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassDivisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassDivisionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassDivisionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassDivisionsDisconnectFieldInput>>;
  update?: InputMaybe<ClassDivisionsUpdateConnectionInput>;
  where?: InputMaybe<ClassDivisionsConnectionWhere>;
};

export type ClassEdge = {
  __typename?: 'ClassEdge';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type ClassEventsAggregateInput = {
  AND?: InputMaybe<Array<ClassEventsAggregateInput>>;
  NOT?: InputMaybe<ClassEventsAggregateInput>;
  OR?: InputMaybe<Array<ClassEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassEventsNodeAggregationWhereInput>;
};

export type ClassEventsConnectFieldInput = {
  connect?: InputMaybe<Array<EventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type ClassEventsConnection = {
  __typename?: 'ClassEventsConnection';
  edges: Array<ClassEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type ClassEventsConnectionWhere = {
  AND?: InputMaybe<Array<ClassEventsConnectionWhere>>;
  NOT?: InputMaybe<ClassEventsConnectionWhere>;
  OR?: InputMaybe<Array<ClassEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type ClassEventsCreateFieldInput = {
  node: EventCreateInput;
};

export type ClassEventsDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<ClassEventsConnectionWhere>;
};

export type ClassEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<ClassEventsConnectionWhere>;
};

export type ClassEventsFieldInput = {
  connect?: InputMaybe<Array<ClassEventsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassEventsCreateFieldInput>>;
};

export type ClassEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassEventsRelationship = {
  __typename?: 'ClassEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type ClassEventsUpdateConnectionInput = {
  node?: InputMaybe<EventUpdateInput>;
};

export type ClassEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassEventsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassEventsDisconnectFieldInput>>;
  update?: InputMaybe<ClassEventsUpdateConnectionInput>;
  where?: InputMaybe<ClassEventsConnectionWhere>;
};

export type ClassGradeGroupAggregateInput = {
  AND?: InputMaybe<Array<ClassGradeGroupAggregateInput>>;
  NOT?: InputMaybe<ClassGradeGroupAggregateInput>;
  OR?: InputMaybe<Array<ClassGradeGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassGradeGroupNodeAggregationWhereInput>;
};

export type ClassGradeGroupConnectFieldInput = {
  connect?: InputMaybe<GradeGroupConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GradeGroupConnectWhere>;
};

export type ClassGradeGroupConnection = {
  __typename?: 'ClassGradeGroupConnection';
  edges: Array<ClassGradeGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassGradeGroupConnectionSort = {
  node?: InputMaybe<GradeGroupSort>;
};

export type ClassGradeGroupConnectionWhere = {
  AND?: InputMaybe<Array<ClassGradeGroupConnectionWhere>>;
  NOT?: InputMaybe<ClassGradeGroupConnectionWhere>;
  OR?: InputMaybe<Array<ClassGradeGroupConnectionWhere>>;
  node?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GradeGroupWhere>;
};

export type ClassGradeGroupCreateFieldInput = {
  node: GradeGroupCreateInput;
};

export type ClassGradeGroupDeleteFieldInput = {
  delete?: InputMaybe<GradeGroupDeleteInput>;
  where?: InputMaybe<ClassGradeGroupConnectionWhere>;
};

export type ClassGradeGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GradeGroupDisconnectInput>;
  where?: InputMaybe<ClassGradeGroupConnectionWhere>;
};

export type ClassGradeGroupFieldInput = {
  connect?: InputMaybe<ClassGradeGroupConnectFieldInput>;
  create?: InputMaybe<ClassGradeGroupCreateFieldInput>;
};

export type ClassGradeGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassGradeGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassGradeGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassGradeGroupNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassGradeGroupRelationship = {
  __typename?: 'ClassGradeGroupRelationship';
  cursor: Scalars['String']['output'];
  node: GradeGroup;
};

export type ClassGradeGroupUpdateConnectionInput = {
  node?: InputMaybe<GradeGroupUpdateInput>;
};

export type ClassGradeGroupUpdateFieldInput = {
  connect?: InputMaybe<ClassGradeGroupConnectFieldInput>;
  create?: InputMaybe<ClassGradeGroupCreateFieldInput>;
  delete?: InputMaybe<ClassGradeGroupDeleteFieldInput>;
  disconnect?: InputMaybe<ClassGradeGroupDisconnectFieldInput>;
  update?: InputMaybe<ClassGradeGroupUpdateConnectionInput>;
  where?: InputMaybe<ClassGradeGroupConnectionWhere>;
};

export type ClassGridCard = {
  __typename?: 'ClassGridCard';
  classUuid: Scalars['ID']['output'];
  colors: Array<Scalars['String']['output']>;
  cssGradientString?: Maybe<Scalars['String']['output']>;
  cssHeight?: Maybe<Scalars['String']['output']>;
  cssTop?: Maybe<Scalars['String']['output']>;
  divisionsCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  lessonUuid: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  startTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  timetableCardUuid: Scalars['ID']['output'];
  usedPosition: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};

export type ClassInterface = {
  __typename?: 'ClassInterface';
  grade?: Maybe<Scalars['Int']['output']>;
  gradeGroup?: Maybe<GradeGroup>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ClassLabelLabelsAggregationSelection = {
  __typename?: 'ClassLabelLabelsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ClassLabelLabelsNodeAggregateSelection>;
};

export type ClassLabelLabelsNodeAggregateSelection = {
  __typename?: 'ClassLabelLabelsNodeAggregateSelection';
  color: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassLabelsAggregateInput = {
  AND?: InputMaybe<Array<ClassLabelsAggregateInput>>;
  NOT?: InputMaybe<ClassLabelsAggregateInput>;
  OR?: InputMaybe<Array<ClassLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassLabelsNodeAggregationWhereInput>;
};

export type ClassLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type ClassLabelsConnection = {
  __typename?: 'ClassLabelsConnection';
  edges: Array<ClassLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type ClassLabelsConnectionWhere = {
  AND?: InputMaybe<Array<ClassLabelsConnectionWhere>>;
  NOT?: InputMaybe<ClassLabelsConnectionWhere>;
  OR?: InputMaybe<Array<ClassLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type ClassLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type ClassLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<ClassLabelsConnectionWhere>;
};

export type ClassLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<ClassLabelsConnectionWhere>;
};

export type ClassLabelsFieldInput = {
  connect?: InputMaybe<Array<ClassLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassLabelsCreateFieldInput>>;
};

export type ClassLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassLabelsRelationship = {
  __typename?: 'ClassLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type ClassLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type ClassLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassLabelsDisconnectFieldInput>>;
  update?: InputMaybe<ClassLabelsUpdateConnectionInput>;
  where?: InputMaybe<ClassLabelsConnectionWhere>;
};

export type ClassLessonClassLessonClassesAggregationSelection = {
  __typename?: 'ClassLessonClassLessonClassesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ClassLessonClassLessonClassesNodeAggregateSelection>;
};

export type ClassLessonClassLessonClassesNodeAggregateSelection = {
  __typename?: 'ClassLessonClassLessonClassesNodeAggregateSelection';
  uuid: IdAggregateSelection;
};

export type ClassLessonClassesAggregateInput = {
  AND?: InputMaybe<Array<ClassLessonClassesAggregateInput>>;
  NOT?: InputMaybe<ClassLessonClassesAggregateInput>;
  OR?: InputMaybe<Array<ClassLessonClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassLessonClassesNodeAggregationWhereInput>;
};

export type ClassLessonClassesConnectFieldInput = {
  connect?: InputMaybe<Array<LessonClassConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonClassConnectWhere>;
};

export type ClassLessonClassesConnection = {
  __typename?: 'ClassLessonClassesConnection';
  edges: Array<ClassLessonClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassLessonClassesConnectionSort = {
  node?: InputMaybe<LessonClassSort>;
};

export type ClassLessonClassesConnectionWhere = {
  AND?: InputMaybe<Array<ClassLessonClassesConnectionWhere>>;
  NOT?: InputMaybe<ClassLessonClassesConnectionWhere>;
  OR?: InputMaybe<Array<ClassLessonClassesConnectionWhere>>;
  node?: InputMaybe<LessonClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonClassWhere>;
};

export type ClassLessonClassesCreateFieldInput = {
  node: LessonClassCreateInput;
};

export type ClassLessonClassesDeleteFieldInput = {
  delete?: InputMaybe<LessonClassDeleteInput>;
  where?: InputMaybe<ClassLessonClassesConnectionWhere>;
};

export type ClassLessonClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonClassDisconnectInput>;
  where?: InputMaybe<ClassLessonClassesConnectionWhere>;
};

export type ClassLessonClassesFieldInput = {
  connect?: InputMaybe<Array<ClassLessonClassesConnectFieldInput>>;
  create?: InputMaybe<Array<ClassLessonClassesCreateFieldInput>>;
};

export type ClassLessonClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassLessonClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassLessonClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassLessonClassesNodeAggregationWhereInput>>;
};

export type ClassLessonClassesRelationship = {
  __typename?: 'ClassLessonClassesRelationship';
  cursor: Scalars['String']['output'];
  node: LessonClass;
};

export type ClassLessonClassesUpdateConnectionInput = {
  node?: InputMaybe<LessonClassUpdateInput>;
};

export type ClassLessonClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassLessonClassesConnectFieldInput>>;
  create?: InputMaybe<Array<ClassLessonClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassLessonClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassLessonClassesDisconnectFieldInput>>;
  update?: InputMaybe<ClassLessonClassesUpdateConnectionInput>;
  where?: InputMaybe<ClassLessonClassesConnectionWhere>;
};

export type ClassOnCreateInput = {
  certificatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  functionalClassSubstitutionBehavior?: InputMaybe<FunctionalClassSubstitutionBehavior>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  relevantForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ClassSort objects to sort Classes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ClassSort>>;
};

export type ClassOrGroup = Class | Group;

export type ClassOrGroupWhere = {
  Class?: InputMaybe<ClassWhere>;
  Group?: InputMaybe<GroupWhere>;
};

export type ClassOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ClassOrganizationAggregateInput>>;
  NOT?: InputMaybe<ClassOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ClassOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassOrganizationNodeAggregationWhereInput>;
};

export type ClassOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type ClassOrganizationConnectOrCreateFieldInput = {
  onCreate: ClassOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type ClassOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type ClassOrganizationConnection = {
  __typename?: 'ClassOrganizationConnection';
  edges: Array<ClassOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ClassOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ClassOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ClassOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ClassOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type ClassOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type ClassOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassOrganizationFieldInput = {
  connect?: InputMaybe<ClassOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassOrganizationCreateFieldInput>;
};

export type ClassOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassOrganizationRelationship = {
  __typename?: 'ClassOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type ClassOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type ClassOrganizationUpdateFieldInput = {
  connect?: InputMaybe<ClassOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<ClassOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<ClassOrganizationCreateFieldInput>;
  delete?: InputMaybe<ClassOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<ClassOrganizationDisconnectFieldInput>;
  update?: InputMaybe<ClassOrganizationUpdateConnectionInput>;
  where?: InputMaybe<ClassOrganizationConnectionWhere>;
};

export type ClassPersonTutorsAggregationSelection = {
  __typename?: 'ClassPersonTutorsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ClassPersonTutorsEdgeAggregateSelection>;
  node?: Maybe<ClassPersonTutorsNodeAggregateSelection>;
};

export type ClassPersonTutorsEdgeAggregateSelection = {
  __typename?: 'ClassPersonTutorsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type ClassPersonTutorsNodeAggregateSelection = {
  __typename?: 'ClassPersonTutorsNodeAggregateSelection';
  callingName: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  displayNameShort: StringAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  gender: StringAggregateSelection;
  lastName: StringAggregateSelection;
  personalId: StringAggregateSelection;
  pimProfileUuid: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  title: StringAggregateSelection;
  uniqueFirstName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ClassSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<ClassSchoolYearAggregateInput>>;
  NOT?: InputMaybe<ClassSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<ClassSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassSchoolYearNodeAggregationWhereInput>;
};

export type ClassSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type ClassSchoolYearConnection = {
  __typename?: 'ClassSchoolYearConnection';
  edges: Array<ClassSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type ClassSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<ClassSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<ClassSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<ClassSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type ClassSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type ClassSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

export type ClassSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

export type ClassSchoolYearFieldInput = {
  connect?: InputMaybe<ClassSchoolYearConnectFieldInput>;
  create?: InputMaybe<ClassSchoolYearCreateFieldInput>;
};

export type ClassSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassSchoolYearRelationship = {
  __typename?: 'ClassSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type ClassSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type ClassSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<ClassSchoolYearConnectFieldInput>;
  create?: InputMaybe<ClassSchoolYearCreateFieldInput>;
  delete?: InputMaybe<ClassSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<ClassSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<ClassSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<ClassSchoolYearConnectionWhere>;
};

/** Fields to sort Classes by. The order in which sorts are applied is not guaranteed when specifying many fields in one ClassSort object. */
export type ClassSort = {
  certificatesEnabled?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  functionalClassSubstitutionBehavior?: InputMaybe<SortDirection>;
  grade?: InputMaybe<SortDirection>;
  gradeGroupName?: InputMaybe<SortDirection>;
  gradeGroupShortName?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  relevantForSubstitution?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  sortName?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type ClassTeachingLoad = {
  __typename?: 'ClassTeachingLoad';
  classDisplayName: Scalars['String']['output'];
  classUuid: Scalars['String']['output'];
  countClasses: Scalars['Int']['output'];
  countTeacher: Scalars['Int']['output'];
  deputat: Scalars['Float']['output'];
  factor: Scalars['Float']['output'];
  lessonClass: Array<LessonClassInterface>;
  lessonClassesDisplayName: Scalars['String']['output'];
  lessonUuid: Scalars['String']['output'];
  organization: Organization;
  partialClasses: Scalars['Boolean']['output'];
  relevantFactors: Array<TeachingLoadFactor>;
  schoolYear: SchoolYear;
  studentCards?: Maybe<Scalars['Float']['output']>;
  studentHours?: Maybe<Scalars['Float']['output']>;
  subjectContainerDisplayName?: Maybe<Scalars['String']['output']>;
  subjectContainerUuid?: Maybe<Scalars['String']['output']>;
  subjectDisplayName: Scalars['String']['output'];
  subjectUuid: Scalars['String']['output'];
  teacherCards?: Maybe<Scalars['Float']['output']>;
  teacherHours?: Maybe<Scalars['Float']['output']>;
  teachingBlockWeeks?: Maybe<Scalars['Float']['output']>;
  teachingBlocks?: Maybe<Scalars['Float']['output']>;
  timetableBlockDisplayName?: Maybe<Scalars['String']['output']>;
  timetableBlockSortName?: Maybe<Scalars['String']['output']>;
  timetableBlockUuid?: Maybe<Scalars['String']['output']>;
};

export type ClassTimetableConfigAggregateInput = {
  AND?: InputMaybe<Array<ClassTimetableConfigAggregateInput>>;
  NOT?: InputMaybe<ClassTimetableConfigAggregateInput>;
  OR?: InputMaybe<Array<ClassTimetableConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ClassTimetableConfigNodeAggregationWhereInput>;
};

export type ClassTimetableConfigConnectFieldInput = {
  connect?: InputMaybe<TimetableConfigConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConfigConnectWhere>;
};

export type ClassTimetableConfigConnection = {
  __typename?: 'ClassTimetableConfigConnection';
  edges: Array<ClassTimetableConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassTimetableConfigConnectionSort = {
  node?: InputMaybe<TimetableConfigSort>;
};

export type ClassTimetableConfigConnectionWhere = {
  AND?: InputMaybe<Array<ClassTimetableConfigConnectionWhere>>;
  NOT?: InputMaybe<ClassTimetableConfigConnectionWhere>;
  OR?: InputMaybe<Array<ClassTimetableConfigConnectionWhere>>;
  node?: InputMaybe<TimetableConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableConfigWhere>;
};

export type ClassTimetableConfigCreateFieldInput = {
  node: TimetableConfigCreateInput;
};

export type ClassTimetableConfigDeleteFieldInput = {
  delete?: InputMaybe<TimetableConfigDeleteInput>;
  where?: InputMaybe<ClassTimetableConfigConnectionWhere>;
};

export type ClassTimetableConfigDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableConfigDisconnectInput>;
  where?: InputMaybe<ClassTimetableConfigConnectionWhere>;
};

export type ClassTimetableConfigFieldInput = {
  connect?: InputMaybe<ClassTimetableConfigConnectFieldInput>;
  create?: InputMaybe<ClassTimetableConfigCreateFieldInput>;
};

export type ClassTimetableConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassTimetableConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassTimetableConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassTimetableConfigNodeAggregationWhereInput>>;
  colorLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassTimetableConfigRelationship = {
  __typename?: 'ClassTimetableConfigRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableConfig;
};

export type ClassTimetableConfigUpdateConnectionInput = {
  node?: InputMaybe<TimetableConfigUpdateInput>;
};

export type ClassTimetableConfigUpdateFieldInput = {
  connect?: InputMaybe<ClassTimetableConfigConnectFieldInput>;
  create?: InputMaybe<ClassTimetableConfigCreateFieldInput>;
  delete?: InputMaybe<ClassTimetableConfigDeleteFieldInput>;
  disconnect?: InputMaybe<ClassTimetableConfigDisconnectFieldInput>;
  update?: InputMaybe<ClassTimetableConfigUpdateConnectionInput>;
  where?: InputMaybe<ClassTimetableConfigConnectionWhere>;
};

export type ClassTimetableVersionsAggregateInput = {
  AND?: InputMaybe<Array<ClassTimetableVersionsAggregateInput>>;
  NOT?: InputMaybe<ClassTimetableVersionsAggregateInput>;
  OR?: InputMaybe<Array<ClassTimetableVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TimetableRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<ClassTimetableVersionsNodeAggregationWhereInput>;
};

export type ClassTimetableVersionsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionConnectInput>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type ClassTimetableVersionsConnection = {
  __typename?: 'ClassTimetableVersionsConnection';
  edges: Array<ClassTimetableVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassTimetableVersionsConnectionSort = {
  edge?: InputMaybe<TimetableRelationshipPropertiesSort>;
  node?: InputMaybe<TimetableVersionSort>;
};

export type ClassTimetableVersionsConnectionWhere = {
  AND?: InputMaybe<Array<ClassTimetableVersionsConnectionWhere>>;
  NOT?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
  OR?: InputMaybe<Array<ClassTimetableVersionsConnectionWhere>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type ClassTimetableVersionsCreateFieldInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: TimetableVersionCreateInput;
};

export type ClassTimetableVersionsDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
};

export type ClassTimetableVersionsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
};

export type ClassTimetableVersionsFieldInput = {
  connect?: InputMaybe<Array<ClassTimetableVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassTimetableVersionsCreateFieldInput>>;
};

export type ClassTimetableVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassTimetableVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassTimetableVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassTimetableVersionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassTimetableVersionsRelationship = {
  __typename?: 'ClassTimetableVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
  properties: TimetableRelationshipProperties;
};

export type ClassTimetableVersionsUpdateConnectionInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type ClassTimetableVersionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassTimetableVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<ClassTimetableVersionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassTimetableVersionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassTimetableVersionsDisconnectFieldInput>>;
  update?: InputMaybe<ClassTimetableVersionsUpdateConnectionInput>;
  where?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
};

export type ClassTutorsAggregateInput = {
  AND?: InputMaybe<Array<ClassTutorsAggregateInput>>;
  NOT?: InputMaybe<ClassTutorsAggregateInput>;
  OR?: InputMaybe<Array<ClassTutorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<ClassTutorsNodeAggregationWhereInput>;
};

export type ClassTutorsConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type ClassTutorsConnectOrCreateFieldInput = {
  onCreate: ClassTutorsConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type ClassTutorsConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: PersonOnCreateInput;
};

export type ClassTutorsConnection = {
  __typename?: 'ClassTutorsConnection';
  edges: Array<ClassTutorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClassTutorsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<PersonSort>;
};

export type ClassTutorsConnectionWhere = {
  AND?: InputMaybe<Array<ClassTutorsConnectionWhere>>;
  NOT?: InputMaybe<ClassTutorsConnectionWhere>;
  OR?: InputMaybe<Array<ClassTutorsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type ClassTutorsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: PersonCreateInput;
};

export type ClassTutorsDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassTutorsDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassTutorsFieldInput = {
  connect?: InputMaybe<Array<ClassTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassTutorsCreateFieldInput>>;
};

export type ClassTutorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ClassTutorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ClassTutorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ClassTutorsNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassTutorsRelationship = {
  __typename?: 'ClassTutorsRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: OrderedRelationProperties;
};

export type ClassTutorsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<PersonUpdateInput>;
};

export type ClassTutorsUpdateFieldInput = {
  connect?: InputMaybe<Array<ClassTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ClassTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ClassTutorsCreateFieldInput>>;
  delete?: InputMaybe<Array<ClassTutorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ClassTutorsDisconnectFieldInput>>;
  update?: InputMaybe<ClassTutorsUpdateConnectionInput>;
  where?: InputMaybe<ClassTutorsConnectionWhere>;
};

export type ClassUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type ClassUpdateInput = {
  additionalTeachingLoads?: InputMaybe<Array<ClassAdditionalTeachingLoadsUpdateFieldInput>>;
  certificatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultRoom?: InputMaybe<ClassDefaultRoomUpdateFieldInput>;
  divisions?: InputMaybe<Array<ClassDivisionsUpdateFieldInput>>;
  events?: InputMaybe<Array<ClassEventsUpdateFieldInput>>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  functionalClassSubstitutionBehavior?: InputMaybe<FunctionalClassSubstitutionBehavior>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup?: InputMaybe<ClassGradeGroupUpdateFieldInput>;
  grade_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  grade_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Array<ClassLabelsUpdateFieldInput>>;
  lessonClasses?: InputMaybe<Array<ClassLessonClassesUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<ClassOrganizationUpdateFieldInput>;
  relevantForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYear?: InputMaybe<ClassSchoolYearUpdateFieldInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  timetableConfig?: InputMaybe<ClassTimetableConfigUpdateFieldInput>;
  timetableVersions?: InputMaybe<Array<ClassTimetableVersionsUpdateFieldInput>>;
  tutors?: InputMaybe<Array<ClassTutorsUpdateFieldInput>>;
};

export type ClassWhere = {
  AND?: InputMaybe<Array<ClassWhere>>;
  NOT?: InputMaybe<ClassWhere>;
  OR?: InputMaybe<Array<ClassWhere>>;
  /** @deprecated Use `additionalTeachingLoads_SOME` instead. */
  additionalTeachingLoads?: InputMaybe<AdditionalTeachingLoadWhere>;
  additionalTeachingLoadsAggregate?: InputMaybe<ClassAdditionalTeachingLoadsAggregateInput>;
  /** @deprecated Use `additionalTeachingLoadsConnection_SOME` instead. */
  additionalTeachingLoadsConnection?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
  /** Return Classes where all of the related ClassAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_ALL?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
  /** Return Classes where none of the related ClassAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_NONE?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
  /** @deprecated Use `additionalTeachingLoadsConnection_NONE` instead. */
  additionalTeachingLoadsConnection_NOT?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
  /** Return Classes where one of the related ClassAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SINGLE?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
  /** Return Classes where some of the related ClassAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SOME?: InputMaybe<ClassAdditionalTeachingLoadsConnectionWhere>;
  /** Return Classes where all of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_ALL?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return Classes where none of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_NONE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Use `additionalTeachingLoads_NONE` instead. */
  additionalTeachingLoads_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return Classes where one of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SINGLE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return Classes where some of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SOME?: InputMaybe<AdditionalTeachingLoadWhere>;
  certificatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  certificatesEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  defaultRoom?: InputMaybe<RoomWhere>;
  defaultRoomAggregate?: InputMaybe<ClassDefaultRoomAggregateInput>;
  defaultRoomConnection?: InputMaybe<ClassDefaultRoomConnectionWhere>;
  defaultRoomConnection_NOT?: InputMaybe<ClassDefaultRoomConnectionWhere>;
  defaultRoom_NOT?: InputMaybe<RoomWhere>;
  /** @deprecated Use `divisions_SOME` instead. */
  divisions?: InputMaybe<DivisionWhere>;
  divisionsAggregate?: InputMaybe<ClassDivisionsAggregateInput>;
  /** @deprecated Use `divisionsConnection_SOME` instead. */
  divisionsConnection?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where all of the related ClassDivisionsConnections match this filter */
  divisionsConnection_ALL?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where none of the related ClassDivisionsConnections match this filter */
  divisionsConnection_NONE?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** @deprecated Use `divisionsConnection_NONE` instead. */
  divisionsConnection_NOT?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where one of the related ClassDivisionsConnections match this filter */
  divisionsConnection_SINGLE?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where some of the related ClassDivisionsConnections match this filter */
  divisionsConnection_SOME?: InputMaybe<ClassDivisionsConnectionWhere>;
  /** Return Classes where all of the related Divisions match this filter */
  divisions_ALL?: InputMaybe<DivisionWhere>;
  /** Return Classes where none of the related Divisions match this filter */
  divisions_NONE?: InputMaybe<DivisionWhere>;
  /** @deprecated Use `divisions_NONE` instead. */
  divisions_NOT?: InputMaybe<DivisionWhere>;
  /** Return Classes where one of the related Divisions match this filter */
  divisions_SINGLE?: InputMaybe<DivisionWhere>;
  /** Return Classes where some of the related Divisions match this filter */
  divisions_SOME?: InputMaybe<DivisionWhere>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<ClassEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<ClassEventsConnectionWhere>;
  /** Return Classes where all of the related ClassEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<ClassEventsConnectionWhere>;
  /** Return Classes where none of the related ClassEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<ClassEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<ClassEventsConnectionWhere>;
  /** Return Classes where one of the related ClassEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<ClassEventsConnectionWhere>;
  /** Return Classes where some of the related ClassEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<ClassEventsConnectionWhere>;
  /** Return Classes where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return Classes where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return Classes where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return Classes where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  functionalClassSubstitutionBehavior?: InputMaybe<FunctionalClassSubstitutionBehavior>;
  functionalClassSubstitutionBehavior_IN?: InputMaybe<Array<InputMaybe<FunctionalClassSubstitutionBehavior>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  functionalClassSubstitutionBehavior_NOT?: InputMaybe<FunctionalClassSubstitutionBehavior>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  functionalClassSubstitutionBehavior_NOT_IN?: InputMaybe<Array<InputMaybe<FunctionalClassSubstitutionBehavior>>>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  gradeGroup?: InputMaybe<GradeGroupWhere>;
  gradeGroupAggregate?: InputMaybe<ClassGradeGroupAggregateInput>;
  gradeGroupConnection?: InputMaybe<ClassGradeGroupConnectionWhere>;
  gradeGroupConnection_NOT?: InputMaybe<ClassGradeGroupConnectionWhere>;
  gradeGroupName?: InputMaybe<Scalars['String']['input']>;
  gradeGroupName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gradeGroupName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroupName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroupName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroupShortName?: InputMaybe<Scalars['String']['input']>;
  gradeGroupShortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gradeGroupShortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroupShortName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupShortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupShortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupShortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupShortName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupShortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroupShortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroup_NOT?: InputMaybe<GradeGroupWhere>;
  grade_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  grade_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grade_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grade_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<ClassLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<ClassLabelsConnectionWhere>;
  /** Return Classes where all of the related ClassLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<ClassLabelsConnectionWhere>;
  /** Return Classes where none of the related ClassLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<ClassLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<ClassLabelsConnectionWhere>;
  /** Return Classes where one of the related ClassLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<ClassLabelsConnectionWhere>;
  /** Return Classes where some of the related ClassLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<ClassLabelsConnectionWhere>;
  /** Return Classes where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Classes where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Classes where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Classes where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  /** @deprecated Use `lessonClasses_SOME` instead. */
  lessonClasses?: InputMaybe<LessonClassWhere>;
  lessonClassesAggregate?: InputMaybe<ClassLessonClassesAggregateInput>;
  /** @deprecated Use `lessonClassesConnection_SOME` instead. */
  lessonClassesConnection?: InputMaybe<ClassLessonClassesConnectionWhere>;
  /** Return Classes where all of the related ClassLessonClassesConnections match this filter */
  lessonClassesConnection_ALL?: InputMaybe<ClassLessonClassesConnectionWhere>;
  /** Return Classes where none of the related ClassLessonClassesConnections match this filter */
  lessonClassesConnection_NONE?: InputMaybe<ClassLessonClassesConnectionWhere>;
  /** @deprecated Use `lessonClassesConnection_NONE` instead. */
  lessonClassesConnection_NOT?: InputMaybe<ClassLessonClassesConnectionWhere>;
  /** Return Classes where one of the related ClassLessonClassesConnections match this filter */
  lessonClassesConnection_SINGLE?: InputMaybe<ClassLessonClassesConnectionWhere>;
  /** Return Classes where some of the related ClassLessonClassesConnections match this filter */
  lessonClassesConnection_SOME?: InputMaybe<ClassLessonClassesConnectionWhere>;
  /** Return Classes where all of the related LessonClasses match this filter */
  lessonClasses_ALL?: InputMaybe<LessonClassWhere>;
  /** Return Classes where none of the related LessonClasses match this filter */
  lessonClasses_NONE?: InputMaybe<LessonClassWhere>;
  /** @deprecated Use `lessonClasses_NONE` instead. */
  lessonClasses_NOT?: InputMaybe<LessonClassWhere>;
  /** Return Classes where one of the related LessonClasses match this filter */
  lessonClasses_SINGLE?: InputMaybe<LessonClassWhere>;
  /** Return Classes where some of the related LessonClasses match this filter */
  lessonClasses_SOME?: InputMaybe<LessonClassWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ClassOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ClassOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ClassOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  relevantForSubstitution?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  relevantForSubstitution_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<ClassSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<ClassSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<ClassSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sortName?: InputMaybe<Scalars['String']['input']>;
  sortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sortName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timetableConfig?: InputMaybe<TimetableConfigWhere>;
  timetableConfigAggregate?: InputMaybe<ClassTimetableConfigAggregateInput>;
  timetableConfigConnection?: InputMaybe<ClassTimetableConfigConnectionWhere>;
  timetableConfigConnection_NOT?: InputMaybe<ClassTimetableConfigConnectionWhere>;
  timetableConfig_NOT?: InputMaybe<TimetableConfigWhere>;
  /** @deprecated Use `timetableVersions_SOME` instead. */
  timetableVersions?: InputMaybe<TimetableVersionWhere>;
  timetableVersionsAggregate?: InputMaybe<ClassTimetableVersionsAggregateInput>;
  /** @deprecated Use `timetableVersionsConnection_SOME` instead. */
  timetableVersionsConnection?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
  /** Return Classes where all of the related ClassTimetableVersionsConnections match this filter */
  timetableVersionsConnection_ALL?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
  /** Return Classes where none of the related ClassTimetableVersionsConnections match this filter */
  timetableVersionsConnection_NONE?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
  /** @deprecated Use `timetableVersionsConnection_NONE` instead. */
  timetableVersionsConnection_NOT?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
  /** Return Classes where one of the related ClassTimetableVersionsConnections match this filter */
  timetableVersionsConnection_SINGLE?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
  /** Return Classes where some of the related ClassTimetableVersionsConnections match this filter */
  timetableVersionsConnection_SOME?: InputMaybe<ClassTimetableVersionsConnectionWhere>;
  /** Return Classes where all of the related TimetableVersions match this filter */
  timetableVersions_ALL?: InputMaybe<TimetableVersionWhere>;
  /** Return Classes where none of the related TimetableVersions match this filter */
  timetableVersions_NONE?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `timetableVersions_NONE` instead. */
  timetableVersions_NOT?: InputMaybe<TimetableVersionWhere>;
  /** Return Classes where one of the related TimetableVersions match this filter */
  timetableVersions_SINGLE?: InputMaybe<TimetableVersionWhere>;
  /** Return Classes where some of the related TimetableVersions match this filter */
  timetableVersions_SOME?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `tutors_SOME` instead. */
  tutors?: InputMaybe<PersonWhere>;
  tutorsAggregate?: InputMaybe<ClassTutorsAggregateInput>;
  /** @deprecated Use `tutorsConnection_SOME` instead. */
  tutorsConnection?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where all of the related ClassTutorsConnections match this filter */
  tutorsConnection_ALL?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where none of the related ClassTutorsConnections match this filter */
  tutorsConnection_NONE?: InputMaybe<ClassTutorsConnectionWhere>;
  /** @deprecated Use `tutorsConnection_NONE` instead. */
  tutorsConnection_NOT?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where one of the related ClassTutorsConnections match this filter */
  tutorsConnection_SINGLE?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where some of the related ClassTutorsConnections match this filter */
  tutorsConnection_SOME?: InputMaybe<ClassTutorsConnectionWhere>;
  /** Return Classes where all of the related People match this filter */
  tutors_ALL?: InputMaybe<PersonWhere>;
  /** Return Classes where none of the related People match this filter */
  tutors_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `tutors_NONE` instead. */
  tutors_NOT?: InputMaybe<PersonWhere>;
  /** Return Classes where one of the related People match this filter */
  tutors_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Classes where some of the related People match this filter */
  tutors_SOME?: InputMaybe<PersonWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassesConnection = {
  __typename?: 'ClassesConnection';
  edges: Array<ClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ColumnSort = {
  __typename?: 'ColumnSort';
  desc: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  tableConfig: TableConfig;
  tableConfigConnection: ColumnSortTableConfigConnection;
};

export type ColumnSortTableConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TableConfigOptions>;
  where?: InputMaybe<TableConfigWhere>;
};

export type ColumnSortTableConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ColumnSortTableConfigConnectionSort>>;
  where?: InputMaybe<ColumnSortTableConfigConnectionWhere>;
};

export type ColumnSortAggregateSelection = {
  __typename?: 'ColumnSortAggregateSelection';
  count: Scalars['Int']['output'];
  id: StringAggregateSelection;
};

export type ColumnSortConnectInput = {
  tableConfig?: InputMaybe<ColumnSortTableConfigConnectFieldInput>;
};

export type ColumnSortConnectWhere = {
  node: ColumnSortWhere;
};

export type ColumnSortCreateInput = {
  desc: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  tableConfig?: InputMaybe<ColumnSortTableConfigFieldInput>;
};

export type ColumnSortDeleteInput = {
  tableConfig?: InputMaybe<ColumnSortTableConfigDeleteFieldInput>;
};

export type ColumnSortDisconnectInput = {
  tableConfig?: InputMaybe<ColumnSortTableConfigDisconnectFieldInput>;
};

export type ColumnSortEdge = {
  __typename?: 'ColumnSortEdge';
  cursor: Scalars['String']['output'];
  node: ColumnSort;
};

export type ColumnSortOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ColumnSortSort objects to sort ColumnSorts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ColumnSortSort>>;
};

/** Fields to sort ColumnSorts by. The order in which sorts are applied is not guaranteed when specifying many fields in one ColumnSortSort object. */
export type ColumnSortSort = {
  desc?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type ColumnSortTableConfigAggregateInput = {
  AND?: InputMaybe<Array<ColumnSortTableConfigAggregateInput>>;
  NOT?: InputMaybe<ColumnSortTableConfigAggregateInput>;
  OR?: InputMaybe<Array<ColumnSortTableConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ColumnSortTableConfigNodeAggregationWhereInput>;
};

export type ColumnSortTableConfigConnectFieldInput = {
  connect?: InputMaybe<TableConfigConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TableConfigConnectWhere>;
};

export type ColumnSortTableConfigConnection = {
  __typename?: 'ColumnSortTableConfigConnection';
  edges: Array<ColumnSortTableConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ColumnSortTableConfigConnectionSort = {
  node?: InputMaybe<TableConfigSort>;
};

export type ColumnSortTableConfigConnectionWhere = {
  AND?: InputMaybe<Array<ColumnSortTableConfigConnectionWhere>>;
  NOT?: InputMaybe<ColumnSortTableConfigConnectionWhere>;
  OR?: InputMaybe<Array<ColumnSortTableConfigConnectionWhere>>;
  node?: InputMaybe<TableConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TableConfigWhere>;
};

export type ColumnSortTableConfigCreateFieldInput = {
  node: TableConfigCreateInput;
};

export type ColumnSortTableConfigDeleteFieldInput = {
  delete?: InputMaybe<TableConfigDeleteInput>;
  where?: InputMaybe<ColumnSortTableConfigConnectionWhere>;
};

export type ColumnSortTableConfigDisconnectFieldInput = {
  disconnect?: InputMaybe<TableConfigDisconnectInput>;
  where?: InputMaybe<ColumnSortTableConfigConnectionWhere>;
};

export type ColumnSortTableConfigFieldInput = {
  connect?: InputMaybe<ColumnSortTableConfigConnectFieldInput>;
  create?: InputMaybe<ColumnSortTableConfigCreateFieldInput>;
};

export type ColumnSortTableConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ColumnSortTableConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ColumnSortTableConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ColumnSortTableConfigNodeAggregationWhereInput>>;
  table_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  table_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ColumnSortTableConfigRelationship = {
  __typename?: 'ColumnSortTableConfigRelationship';
  cursor: Scalars['String']['output'];
  node: TableConfig;
};

export type ColumnSortTableConfigUpdateConnectionInput = {
  node?: InputMaybe<TableConfigUpdateInput>;
};

export type ColumnSortTableConfigUpdateFieldInput = {
  connect?: InputMaybe<ColumnSortTableConfigConnectFieldInput>;
  create?: InputMaybe<ColumnSortTableConfigCreateFieldInput>;
  delete?: InputMaybe<ColumnSortTableConfigDeleteFieldInput>;
  disconnect?: InputMaybe<ColumnSortTableConfigDisconnectFieldInput>;
  update?: InputMaybe<ColumnSortTableConfigUpdateConnectionInput>;
  where?: InputMaybe<ColumnSortTableConfigConnectionWhere>;
};

export type ColumnSortUpdateInput = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  tableConfig?: InputMaybe<ColumnSortTableConfigUpdateFieldInput>;
};

export type ColumnSortWhere = {
  AND?: InputMaybe<Array<ColumnSortWhere>>;
  NOT?: InputMaybe<ColumnSortWhere>;
  OR?: InputMaybe<Array<ColumnSortWhere>>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  desc_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  id_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  id_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  id_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  id_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  id_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tableConfig?: InputMaybe<TableConfigWhere>;
  tableConfigAggregate?: InputMaybe<ColumnSortTableConfigAggregateInput>;
  tableConfigConnection?: InputMaybe<ColumnSortTableConfigConnectionWhere>;
  tableConfigConnection_NOT?: InputMaybe<ColumnSortTableConfigConnectionWhere>;
  tableConfig_NOT?: InputMaybe<TableConfigWhere>;
};

export type ColumnSortsConnection = {
  __typename?: 'ColumnSortsConnection';
  edges: Array<ColumnSortEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectDisconnectInput = {
  connect?: InputMaybe<Array<Scalars['ID']['input']>>;
  disconnect?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Contract = {
  __typename?: 'Contract';
  billingMethod?: Maybe<BillingMethods>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  freelancer?: Maybe<Scalars['Boolean']['output']>;
  hoursWeekly?: Maybe<Scalars['Float']['output']>;
  labels: Array<Label>;
  labelsConnection: ContractLabelsConnection;
  limitedToFullTime?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  person: Person;
  personConnection: ContractPersonConnection;
  substituteHours?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  validFrom: Scalars['Date']['output'];
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type ContractLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type ContractLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractLabelsConnectionSort>>;
  where?: InputMaybe<ContractLabelsConnectionWhere>;
};

export type ContractPersonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type ContractPersonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractPersonConnectionSort>>;
  where?: InputMaybe<ContractPersonConnectionWhere>;
};

export type ContractAggregateSelection = {
  __typename?: 'ContractAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  hoursWeekly: FloatAggregateSelection;
  name: StringAggregateSelection;
  substituteHours: FloatAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type ContractConnectInput = {
  labels?: InputMaybe<Array<ContractLabelsConnectFieldInput>>;
  person?: InputMaybe<ContractPersonConnectFieldInput>;
};

export type ContractConnectWhere = {
  node: ContractWhere;
};

export type ContractCreateInput = {
  billingMethod?: InputMaybe<BillingMethods>;
  freelancer?: InputMaybe<Scalars['Boolean']['input']>;
  hoursWeekly?: InputMaybe<Scalars['Float']['input']>;
  labels?: InputMaybe<ContractLabelsFieldInput>;
  limitedToFullTime?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  person?: InputMaybe<ContractPersonFieldInput>;
  substituteHours?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validFrom: Scalars['Date']['input'];
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type ContractDeleteInput = {
  labels?: InputMaybe<Array<ContractLabelsDeleteFieldInput>>;
  person?: InputMaybe<ContractPersonDeleteFieldInput>;
};

export type ContractDisconnectInput = {
  labels?: InputMaybe<Array<ContractLabelsDisconnectFieldInput>>;
  person?: InputMaybe<ContractPersonDisconnectFieldInput>;
};

export type ContractEdge = {
  __typename?: 'ContractEdge';
  cursor: Scalars['String']['output'];
  node: Contract;
};

export type ContractLabelsAggregateInput = {
  AND?: InputMaybe<Array<ContractLabelsAggregateInput>>;
  NOT?: InputMaybe<ContractLabelsAggregateInput>;
  OR?: InputMaybe<Array<ContractLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContractLabelsNodeAggregationWhereInput>;
};

export type ContractLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type ContractLabelsConnection = {
  __typename?: 'ContractLabelsConnection';
  edges: Array<ContractLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type ContractLabelsConnectionWhere = {
  AND?: InputMaybe<Array<ContractLabelsConnectionWhere>>;
  NOT?: InputMaybe<ContractLabelsConnectionWhere>;
  OR?: InputMaybe<Array<ContractLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type ContractLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type ContractLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<ContractLabelsConnectionWhere>;
};

export type ContractLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<ContractLabelsConnectionWhere>;
};

export type ContractLabelsFieldInput = {
  connect?: InputMaybe<Array<ContractLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<ContractLabelsCreateFieldInput>>;
};

export type ContractLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContractLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ContractLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContractLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContractLabelsRelationship = {
  __typename?: 'ContractLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type ContractLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type ContractLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<ContractLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<ContractLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<ContractLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ContractLabelsDisconnectFieldInput>>;
  update?: InputMaybe<ContractLabelsUpdateConnectionInput>;
  where?: InputMaybe<ContractLabelsConnectionWhere>;
};

export type ContractOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ContractSort objects to sort Contracts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ContractSort>>;
};

export type ContractPersonAggregateInput = {
  AND?: InputMaybe<Array<ContractPersonAggregateInput>>;
  NOT?: InputMaybe<ContractPersonAggregateInput>;
  OR?: InputMaybe<Array<ContractPersonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContractPersonNodeAggregationWhereInput>;
};

export type ContractPersonConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type ContractPersonConnectOrCreateFieldInput = {
  onCreate: ContractPersonConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type ContractPersonConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type ContractPersonConnection = {
  __typename?: 'ContractPersonConnection';
  edges: Array<ContractPersonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractPersonConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type ContractPersonConnectionWhere = {
  AND?: InputMaybe<Array<ContractPersonConnectionWhere>>;
  NOT?: InputMaybe<ContractPersonConnectionWhere>;
  OR?: InputMaybe<Array<ContractPersonConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type ContractPersonCreateFieldInput = {
  node: PersonCreateInput;
};

export type ContractPersonDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<ContractPersonConnectionWhere>;
};

export type ContractPersonDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<ContractPersonConnectionWhere>;
};

export type ContractPersonFieldInput = {
  connect?: InputMaybe<ContractPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<ContractPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<ContractPersonCreateFieldInput>;
};

export type ContractPersonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContractPersonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ContractPersonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContractPersonNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContractPersonRelationship = {
  __typename?: 'ContractPersonRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type ContractPersonUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type ContractPersonUpdateFieldInput = {
  connect?: InputMaybe<ContractPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<ContractPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<ContractPersonCreateFieldInput>;
  delete?: InputMaybe<ContractPersonDeleteFieldInput>;
  disconnect?: InputMaybe<ContractPersonDisconnectFieldInput>;
  update?: InputMaybe<ContractPersonUpdateConnectionInput>;
  where?: InputMaybe<ContractPersonConnectionWhere>;
};

/** Fields to sort Contracts by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContractSort object. */
export type ContractSort = {
  billingMethod?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  freelancer?: InputMaybe<SortDirection>;
  hoursWeekly?: InputMaybe<SortDirection>;
  limitedToFullTime?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  substituteHours?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  validFrom?: InputMaybe<SortDirection>;
  validUntil?: InputMaybe<SortDirection>;
};

export type ContractUpdateInput = {
  billingMethod?: InputMaybe<BillingMethods>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  freelancer?: InputMaybe<Scalars['Boolean']['input']>;
  hoursWeekly?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_ADD?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  labels?: InputMaybe<Array<ContractLabelsUpdateFieldInput>>;
  limitedToFullTime?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<ContractPersonUpdateFieldInput>;
  substituteHours?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_ADD?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type ContractWhere = {
  AND?: InputMaybe<Array<ContractWhere>>;
  NOT?: InputMaybe<ContractWhere>;
  OR?: InputMaybe<Array<ContractWhere>>;
  billingMethod?: InputMaybe<BillingMethods>;
  billingMethod_IN?: InputMaybe<Array<InputMaybe<BillingMethods>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  billingMethod_NOT?: InputMaybe<BillingMethods>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  billingMethod_NOT_IN?: InputMaybe<Array<InputMaybe<BillingMethods>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  freelancer?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  freelancer_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  hoursWeekly?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  hoursWeekly_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hoursWeekly_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hoursWeekly_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<ContractLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<ContractLabelsConnectionWhere>;
  /** Return Contracts where all of the related ContractLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<ContractLabelsConnectionWhere>;
  /** Return Contracts where none of the related ContractLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<ContractLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<ContractLabelsConnectionWhere>;
  /** Return Contracts where one of the related ContractLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<ContractLabelsConnectionWhere>;
  /** Return Contracts where some of the related ContractLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<ContractLabelsConnectionWhere>;
  /** Return Contracts where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Contracts where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Contracts where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Contracts where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  limitedToFullTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  limitedToFullTime_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonWhere>;
  personAggregate?: InputMaybe<ContractPersonAggregateInput>;
  personConnection?: InputMaybe<ContractPersonConnectionWhere>;
  personConnection_NOT?: InputMaybe<ContractPersonConnectionWhere>;
  person_NOT?: InputMaybe<PersonWhere>;
  substituteHours?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_GT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_GTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  substituteHours_LT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substituteHours_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substituteHours_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validFrom_GT?: InputMaybe<Scalars['Date']['input']>;
  validFrom_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFrom_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFrom_LT?: InputMaybe<Scalars['Date']['input']>;
  validFrom_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
  validUntil_GT?: InputMaybe<Scalars['Date']['input']>;
  validUntil_GTE?: InputMaybe<Scalars['Date']['input']>;
  validUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validUntil_LT?: InputMaybe<Scalars['Date']['input']>;
  validUntil_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validUntil_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validUntil_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type ContractsConnection = {
  __typename?: 'ContractsConnection';
  edges: Array<ContractEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateAbsenceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  person: Scalars['ID']['input'];
  reason: AbsenceReason;
  start: Scalars['DateTime']['input'];
};

export type CreateAdditionalTeachingLoadsMutationResponse = {
  __typename?: 'CreateAdditionalTeachingLoadsMutationResponse';
  additionalTeachingLoads: Array<AdditionalTeachingLoad>;
  info: CreateInfo;
};

export type CreateBuildingsMutationResponse = {
  __typename?: 'CreateBuildingsMutationResponse';
  buildings: Array<Building>;
  info: CreateInfo;
};

export type CreateClassesMutationResponse = {
  __typename?: 'CreateClassesMutationResponse';
  classes: Array<Class>;
  info: CreateInfo;
};

export type CreateColumnSortsMutationResponse = {
  __typename?: 'CreateColumnSortsMutationResponse';
  columnSorts: Array<ColumnSort>;
  info: CreateInfo;
};

export type CreateContractsMutationResponse = {
  __typename?: 'CreateContractsMutationResponse';
  contracts: Array<Contract>;
  info: CreateInfo;
};

export type CreateCurriculaMutationResponse = {
  __typename?: 'CreateCurriculaMutationResponse';
  curricula: Array<Curriculum>;
  info: CreateInfo;
};

export type CreateCurriculumClassesMutationResponse = {
  __typename?: 'CreateCurriculumClassesMutationResponse';
  curriculumClasses: Array<CurriculumClass>;
  info: CreateInfo;
};

export type CreateCurriculumPeopleMutationResponse = {
  __typename?: 'CreateCurriculumPeopleMutationResponse';
  curriculumPeople: Array<CurriculumPerson>;
  info: CreateInfo;
};

export type CreateCurriculumUnitsMutationResponse = {
  __typename?: 'CreateCurriculumUnitsMutationResponse';
  curriculumUnits: Array<CurriculumUnit>;
  info: CreateInfo;
};

export type CreateCurriculumVersionsMutationResponse = {
  __typename?: 'CreateCurriculumVersionsMutationResponse';
  curriculumVersions: Array<CurriculumVersion>;
  info: CreateInfo;
};

export type CreateDependenciesMutationResponse = {
  __typename?: 'CreateDependenciesMutationResponse';
  dependencies: Array<Dependency>;
  info: CreateInfo;
};

export type CreateDivisionsMutationResponse = {
  __typename?: 'CreateDivisionsMutationResponse';
  divisions: Array<Division>;
  info: CreateInfo;
};

export type CreateEventJobsMutationResponse = {
  __typename?: 'CreateEventJobsMutationResponse';
  eventJobs: Array<EventJob>;
  info: CreateInfo;
};

export type CreateFileEntriesMutationResponse = {
  __typename?: 'CreateFileEntriesMutationResponse';
  fileEntries: Array<FileEntry>;
  info: CreateInfo;
};

export type CreateGradeGroupsMutationResponse = {
  __typename?: 'CreateGradeGroupsMutationResponse';
  gradeGroups: Array<GradeGroup>;
  info: CreateInfo;
};

export type CreateGroupsMutationResponse = {
  __typename?: 'CreateGroupsMutationResponse';
  groups: Array<Group>;
  info: CreateInfo;
};

export type CreateHolidaysMutationResponse = {
  __typename?: 'CreateHolidaysMutationResponse';
  holidays: Array<Holiday>;
  info: CreateInfo;
};

/** Information about the number of nodes and relationships created during a create mutation */
export type CreateInfo = {
  __typename?: 'CreateInfo';
  nodesCreated: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
};

export type CreateLabelsMutationResponse = {
  __typename?: 'CreateLabelsMutationResponse';
  info: CreateInfo;
  labels: Array<Label>;
};

export type CreateLessonClassesMutationResponse = {
  __typename?: 'CreateLessonClassesMutationResponse';
  info: CreateInfo;
  lessonClasses: Array<LessonClass>;
};

export type CreateLessonUnitsMutationResponse = {
  __typename?: 'CreateLessonUnitsMutationResponse';
  info: CreateInfo;
  lessonUnits: Array<LessonUnit>;
};

export type CreateLessonsMutationResponse = {
  __typename?: 'CreateLessonsMutationResponse';
  info: CreateInfo;
  lessons: Array<Lesson>;
};

export type CreateLockedsMutationResponse = {
  __typename?: 'CreateLockedsMutationResponse';
  info: CreateInfo;
  lockeds: Array<Locked>;
};

export type CreateMathplanJobsMutationResponse = {
  __typename?: 'CreateMathplanJobsMutationResponse';
  info: CreateInfo;
  mathplanJobs: Array<MathplanJob>;
};

export type CreateOrganizationsMutationResponse = {
  __typename?: 'CreateOrganizationsMutationResponse';
  info: CreateInfo;
  organizations: Array<Organization>;
};

export type CreatePeopleMutationResponse = {
  __typename?: 'CreatePeopleMutationResponse';
  info: CreateInfo;
  people: Array<Person>;
};

export type CreatePublishedSubstitutionsMutationResponse = {
  __typename?: 'CreatePublishedSubstitutionsMutationResponse';
  info: CreateInfo;
  publishedSubstitutions: Array<PublishedSubstitutions>;
};

export type CreateQualificationsMutationResponse = {
  __typename?: 'CreateQualificationsMutationResponse';
  info: CreateInfo;
  qualifications: Array<Qualification>;
};

export type CreateResponse = {
  __typename?: 'CreateResponse';
  nodeUuids: Array<Scalars['String']['output']>;
  nodesCreated: Scalars['Int']['output'];
};

export type CreateRoomsMutationResponse = {
  __typename?: 'CreateRoomsMutationResponse';
  info: CreateInfo;
  rooms: Array<Room>;
};

export type CreateSchoolYearsMutationResponse = {
  __typename?: 'CreateSchoolYearsMutationResponse';
  info: CreateInfo;
  schoolYears: Array<SchoolYear>;
};

export type CreateSubjectContainersMutationResponse = {
  __typename?: 'CreateSubjectContainersMutationResponse';
  info: CreateInfo;
  subjectContainers: Array<SubjectContainer>;
};

export type CreateSubjectGroupsMutationResponse = {
  __typename?: 'CreateSubjectGroupsMutationResponse';
  info: CreateInfo;
  subjectGroups: Array<SubjectGroup>;
};

export type CreateSubjectsMutationResponse = {
  __typename?: 'CreateSubjectsMutationResponse';
  info: CreateInfo;
  subjects: Array<Subject>;
};

export type CreateSubstitutionAnnouncementsMutationResponse = {
  __typename?: 'CreateSubstitutionAnnouncementsMutationResponse';
  info: CreateInfo;
  substitutionAnnouncements: Array<SubstitutionAnnouncement>;
};

export type CreateSubstitutionAppConfigsMutationResponse = {
  __typename?: 'CreateSubstitutionAppConfigsMutationResponse';
  info: CreateInfo;
  substitutionAppConfigs: Array<SubstitutionAppConfig>;
};

export type CreateSubstitutionPrintColumnConfigsMutationResponse = {
  __typename?: 'CreateSubstitutionPrintColumnConfigsMutationResponse';
  info: CreateInfo;
  substitutionPrintColumnConfigs: Array<SubstitutionPrintColumnConfig>;
};

export type CreateSubstitutionPrintConfigsMutationResponse = {
  __typename?: 'CreateSubstitutionPrintConfigsMutationResponse';
  info: CreateInfo;
  substitutionPrintConfigs: Array<SubstitutionPrintConfig>;
};

export type CreateSubstitutionReportsMutationResponse = {
  __typename?: 'CreateSubstitutionReportsMutationResponse';
  info: CreateInfo;
  substitutionReports: Array<SubstitutionReport>;
};

export type CreateTableConfigsMutationResponse = {
  __typename?: 'CreateTableConfigsMutationResponse';
  info: CreateInfo;
  tableConfigs: Array<TableConfig>;
};

export type CreateTeachingBlockAvailabilityExclusionsMutationResponse = {
  __typename?: 'CreateTeachingBlockAvailabilityExclusionsMutationResponse';
  info: CreateInfo;
  teachingBlockAvailabilityExclusions: Array<TeachingBlockAvailabilityExclusion>;
};

export type CreateTeachingBlockCardsMutationResponse = {
  __typename?: 'CreateTeachingBlockCardsMutationResponse';
  info: CreateInfo;
  teachingBlockCards: Array<TeachingBlockCard>;
};

export type CreateTeachingBlockVersionsMutationResponse = {
  __typename?: 'CreateTeachingBlockVersionsMutationResponse';
  info: CreateInfo;
  teachingBlockVersions: Array<TeachingBlockVersion>;
};

export type CreateTeachingBlocksMutationResponse = {
  __typename?: 'CreateTeachingBlocksMutationResponse';
  info: CreateInfo;
  teachingBlocks: Array<TeachingBlock>;
};

export type CreateTeachingLoadFactorsMutationResponse = {
  __typename?: 'CreateTeachingLoadFactorsMutationResponse';
  info: CreateInfo;
  teachingLoadFactors: Array<TeachingLoadFactor>;
};

export type CreateTeachingLoadReportsMutationResponse = {
  __typename?: 'CreateTeachingLoadReportsMutationResponse';
  info: CreateInfo;
  teachingLoadReports: Array<TeachingLoadReport>;
};

export type CreateTeachingLoadScenariosMutationResponse = {
  __typename?: 'CreateTeachingLoadScenariosMutationResponse';
  info: CreateInfo;
  teachingLoadScenarios: Array<TeachingLoadScenario>;
};

export type CreateTimeGridEntriesMutationResponse = {
  __typename?: 'CreateTimeGridEntriesMutationResponse';
  info: CreateInfo;
  timeGridEntries: Array<TimeGridEntry>;
};

export type CreateTimeGridsMutationResponse = {
  __typename?: 'CreateTimeGridsMutationResponse';
  info: CreateInfo;
  timeGrids: Array<TimeGrid>;
};

export type CreateTimespansMutationResponse = {
  __typename?: 'CreateTimespansMutationResponse';
  info: CreateInfo;
  timespans: Array<Timespan>;
};

export type CreateTimetableBlocksMutationResponse = {
  __typename?: 'CreateTimetableBlocksMutationResponse';
  info: CreateInfo;
  timetableBlocks: Array<TimetableBlock>;
};

export type CreateTimetableCardsMutationResponse = {
  __typename?: 'CreateTimetableCardsMutationResponse';
  info: CreateInfo;
  timetableCards: Array<TimetableCard>;
};

export type CreateTimetableConfigsMutationResponse = {
  __typename?: 'CreateTimetableConfigsMutationResponse';
  info: CreateInfo;
  timetableConfigs: Array<TimetableConfig>;
};

export type CreateTimetablePrintConfigsMutationResponse = {
  __typename?: 'CreateTimetablePrintConfigsMutationResponse';
  info: CreateInfo;
  timetablePrintConfigs: Array<TimetablePrintConfig>;
};

export type CreateTimetableReportsMutationResponse = {
  __typename?: 'CreateTimetableReportsMutationResponse';
  info: CreateInfo;
  timetableReports: Array<TimetableReport>;
};

export type CreateTimetableTimeGridConfigsMutationResponse = {
  __typename?: 'CreateTimetableTimeGridConfigsMutationResponse';
  info: CreateInfo;
  timetableTimeGridConfigs: Array<TimetableTimeGridConfig>;
};

export type CreateTimetableVersionsMutationResponse = {
  __typename?: 'CreateTimetableVersionsMutationResponse';
  info: CreateInfo;
  timetableVersions: Array<TimetableVersion>;
};

export type CreateTimetablesMutationResponse = {
  __typename?: 'CreateTimetablesMutationResponse';
  info: CreateInfo;
  timetables: Array<Timetable>;
};

export type CreateUserConfigsMutationResponse = {
  __typename?: 'CreateUserConfigsMutationResponse';
  info: CreateInfo;
  userConfigs: Array<UserConfig>;
};

export type CurriculaConnection = {
  __typename?: 'CurriculaConnection';
  edges: Array<CurriculumEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Curriculum = {
  __typename?: 'Curriculum';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curriculumClassesNames: Scalars['String']['output'];
  curriculumGrades: Array<CurriculumClass>;
  curriculumGradesConnection: CurriculumCurriculumGradesConnection;
  curriculumUnit: Array<CurriculumUnit>;
  curriculumUnitConnection: CurriculumCurriculumUnitConnection;
  curriculumVersion: CurriculumVersion;
  curriculumVersionConnection: CurriculumCurriculumVersionConnection;
  displayName: Array<Scalars['String']['output']>;
  elective?: Maybe<Scalars['Boolean']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  groupGradeNames: Array<Scalars['String']['output']>;
  isClassTrip?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<Label>;
  labelsConnection: CurriculumLabelsConnection;
  lessonBlueprints: Array<LessonInterface>;
  lessons: Array<Lesson>;
  lessonsConnection: CurriculumLessonsConnection;
  organization: Organization;
  organizationConnection: CurriculumOrganizationConnection;
  persons: Array<CurriculumPerson>;
  personsConnection: CurriculumPersonsConnection;
  roomSupply: Array<Room>;
  roomSupplyAggregate?: Maybe<CurriculumRoomRoomSupplyAggregationSelection>;
  roomSupplyConnection: CurriculumRoomSupplyConnection;
  subTitle?: Maybe<Scalars['String']['output']>;
  subject: SubjectContainerOrSubject;
  subjectConnection: CurriculumSubjectConnection;
  subjectName: Scalars['String']['output'];
  teachingLoadEnabled?: Maybe<Scalars['Boolean']['output']>;
  timetableEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type CurriculumCurriculumGradesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumClassOptions>;
  where?: InputMaybe<CurriculumClassWhere>;
};

export type CurriculumCurriculumGradesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumCurriculumGradesConnectionSort>>;
  where?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
};

export type CurriculumCurriculumUnitArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumUnitOptions>;
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type CurriculumCurriculumUnitConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumCurriculumUnitConnectionSort>>;
  where?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
};

export type CurriculumCurriculumVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumVersionOptions>;
  where?: InputMaybe<CurriculumVersionWhere>;
};

export type CurriculumCurriculumVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumCurriculumVersionConnectionSort>>;
  where?: InputMaybe<CurriculumCurriculumVersionConnectionWhere>;
};

export type CurriculumLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type CurriculumLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumLabelsConnectionSort>>;
  where?: InputMaybe<CurriculumLabelsConnectionWhere>;
};

export type CurriculumLessonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type CurriculumLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumLessonsConnectionSort>>;
  where?: InputMaybe<CurriculumLessonsConnectionWhere>;
};

export type CurriculumOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type CurriculumOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumOrganizationConnectionSort>>;
  where?: InputMaybe<CurriculumOrganizationConnectionWhere>;
};

export type CurriculumPersonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumPersonOptions>;
  where?: InputMaybe<CurriculumPersonWhere>;
};

export type CurriculumPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumPersonsConnectionSort>>;
  where?: InputMaybe<CurriculumPersonsConnectionWhere>;
};

export type CurriculumRoomSupplyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type CurriculumRoomSupplyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoomWhere>;
};

export type CurriculumRoomSupplyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumRoomSupplyConnectionSort>>;
  where?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
};

export type CurriculumSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<SubjectContainerOrSubjectWhere>;
};

export type CurriculumSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CurriculumSubjectConnectionWhere>;
};

export type CurriculumAggregateSelection = {
  __typename?: 'CurriculumAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  subTitle: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CurriculumClass = {
  __typename?: 'CurriculumClass';
  gradeGroups: Array<GradeGroup>;
  gradeGroupsConnection: CurriculumClassGradeGroupsConnection;
  grades: Array<Scalars['Int']['output']>;
  groups: Array<Group>;
  groupsAggregate?: Maybe<CurriculumClassGroupGroupsAggregationSelection>;
  groupsConnection: CurriculumClassGroupsConnection;
  lessonClasses: Array<LessonClassInterface>;
  usedDivision?: Maybe<Division>;
  uuid: Scalars['ID']['output'];
};

export type CurriculumClassGradeGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GradeGroupOptions>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type CurriculumClassGradeGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumClassGradeGroupsConnectionSort>>;
  where?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
};

export type CurriculumClassGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type CurriculumClassGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type CurriculumClassGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumClassGroupsConnectionSort>>;
  where?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
};

export type CurriculumClassAggregateSelection = {
  __typename?: 'CurriculumClassAggregateSelection';
  count: Scalars['Int']['output'];
  uuid: IdAggregateSelection;
};

export type CurriculumClassConnectInput = {
  gradeGroups?: InputMaybe<Array<CurriculumClassGradeGroupsConnectFieldInput>>;
  groups?: InputMaybe<Array<CurriculumClassGroupsConnectFieldInput>>;
};

export type CurriculumClassConnectWhere = {
  node: CurriculumClassWhere;
};

export type CurriculumClassCreateInput = {
  gradeGroups?: InputMaybe<CurriculumClassGradeGroupsFieldInput>;
  grades: Array<Scalars['Int']['input']>;
  groups?: InputMaybe<CurriculumClassGroupsFieldInput>;
};

export type CurriculumClassDeleteInput = {
  gradeGroups?: InputMaybe<Array<CurriculumClassGradeGroupsDeleteFieldInput>>;
  groups?: InputMaybe<Array<CurriculumClassGroupsDeleteFieldInput>>;
};

export type CurriculumClassDisconnectInput = {
  gradeGroups?: InputMaybe<Array<CurriculumClassGradeGroupsDisconnectFieldInput>>;
  groups?: InputMaybe<Array<CurriculumClassGroupsDisconnectFieldInput>>;
};

export type CurriculumClassEdge = {
  __typename?: 'CurriculumClassEdge';
  cursor: Scalars['String']['output'];
  node: CurriculumClass;
};

export type CurriculumClassGradeGroupsAggregateInput = {
  AND?: InputMaybe<Array<CurriculumClassGradeGroupsAggregateInput>>;
  NOT?: InputMaybe<CurriculumClassGradeGroupsAggregateInput>;
  OR?: InputMaybe<Array<CurriculumClassGradeGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumClassGradeGroupsNodeAggregationWhereInput>;
};

export type CurriculumClassGradeGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GradeGroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GradeGroupConnectWhere>;
};

export type CurriculumClassGradeGroupsConnection = {
  __typename?: 'CurriculumClassGradeGroupsConnection';
  edges: Array<CurriculumClassGradeGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumClassGradeGroupsConnectionSort = {
  node?: InputMaybe<GradeGroupSort>;
};

export type CurriculumClassGradeGroupsConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumClassGradeGroupsConnectionWhere>>;
  NOT?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumClassGradeGroupsConnectionWhere>>;
  node?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GradeGroupWhere>;
};

export type CurriculumClassGradeGroupsCreateFieldInput = {
  node: GradeGroupCreateInput;
};

export type CurriculumClassGradeGroupsDeleteFieldInput = {
  delete?: InputMaybe<GradeGroupDeleteInput>;
  where?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
};

export type CurriculumClassGradeGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GradeGroupDisconnectInput>;
  where?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
};

export type CurriculumClassGradeGroupsFieldInput = {
  connect?: InputMaybe<Array<CurriculumClassGradeGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumClassGradeGroupsCreateFieldInput>>;
};

export type CurriculumClassGradeGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumClassGradeGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumClassGradeGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumClassGradeGroupsNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumClassGradeGroupsRelationship = {
  __typename?: 'CurriculumClassGradeGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: GradeGroup;
};

export type CurriculumClassGradeGroupsUpdateConnectionInput = {
  node?: InputMaybe<GradeGroupUpdateInput>;
};

export type CurriculumClassGradeGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumClassGradeGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumClassGradeGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumClassGradeGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumClassGradeGroupsDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumClassGradeGroupsUpdateConnectionInput>;
  where?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
};

export type CurriculumClassGroupGroupsAggregationSelection = {
  __typename?: 'CurriculumClassGroupGroupsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CurriculumClassGroupGroupsNodeAggregateSelection>;
};

export type CurriculumClassGroupGroupsNodeAggregateSelection = {
  __typename?: 'CurriculumClassGroupGroupsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CurriculumClassGroupsAggregateInput = {
  AND?: InputMaybe<Array<CurriculumClassGroupsAggregateInput>>;
  NOT?: InputMaybe<CurriculumClassGroupsAggregateInput>;
  OR?: InputMaybe<Array<CurriculumClassGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumClassGroupsNodeAggregationWhereInput>;
};

export type CurriculumClassGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type CurriculumClassGroupsConnectOrCreateFieldInput = {
  onCreate: CurriculumClassGroupsConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type CurriculumClassGroupsConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type CurriculumClassGroupsConnection = {
  __typename?: 'CurriculumClassGroupsConnection';
  edges: Array<CurriculumClassGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumClassGroupsConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type CurriculumClassGroupsConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumClassGroupsConnectionWhere>>;
  NOT?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumClassGroupsConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type CurriculumClassGroupsCreateFieldInput = {
  node: GroupCreateInput;
};

export type CurriculumClassGroupsDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
};

export type CurriculumClassGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
};

export type CurriculumClassGroupsFieldInput = {
  connect?: InputMaybe<Array<CurriculumClassGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumClassGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumClassGroupsCreateFieldInput>>;
};

export type CurriculumClassGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumClassGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumClassGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumClassGroupsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumClassGroupsRelationship = {
  __typename?: 'CurriculumClassGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type CurriculumClassGroupsUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type CurriculumClassGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumClassGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumClassGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumClassGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumClassGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumClassGroupsDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumClassGroupsUpdateConnectionInput>;
  where?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
};

export type CurriculumClassOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CurriculumClassSort objects to sort CurriculumClasses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CurriculumClassSort>>;
};

/** Fields to sort CurriculumClasses by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurriculumClassSort object. */
export type CurriculumClassSort = {
  usedDivision?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type CurriculumClassUpdateInput = {
  gradeGroups?: InputMaybe<Array<CurriculumClassGradeGroupsUpdateFieldInput>>;
  grades?: InputMaybe<Array<Scalars['Int']['input']>>;
  grades_POP?: InputMaybe<Scalars['Int']['input']>;
  grades_PUSH?: InputMaybe<Array<Scalars['Int']['input']>>;
  groups?: InputMaybe<Array<CurriculumClassGroupsUpdateFieldInput>>;
};

export type CurriculumClassWhere = {
  AND?: InputMaybe<Array<CurriculumClassWhere>>;
  NOT?: InputMaybe<CurriculumClassWhere>;
  OR?: InputMaybe<Array<CurriculumClassWhere>>;
  /** @deprecated Use `gradeGroups_SOME` instead. */
  gradeGroups?: InputMaybe<GradeGroupWhere>;
  gradeGroupsAggregate?: InputMaybe<CurriculumClassGradeGroupsAggregateInput>;
  /** @deprecated Use `gradeGroupsConnection_SOME` instead. */
  gradeGroupsConnection?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
  /** Return CurriculumClasses where all of the related CurriculumClassGradeGroupsConnections match this filter */
  gradeGroupsConnection_ALL?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
  /** Return CurriculumClasses where none of the related CurriculumClassGradeGroupsConnections match this filter */
  gradeGroupsConnection_NONE?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
  /** @deprecated Use `gradeGroupsConnection_NONE` instead. */
  gradeGroupsConnection_NOT?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
  /** Return CurriculumClasses where one of the related CurriculumClassGradeGroupsConnections match this filter */
  gradeGroupsConnection_SINGLE?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
  /** Return CurriculumClasses where some of the related CurriculumClassGradeGroupsConnections match this filter */
  gradeGroupsConnection_SOME?: InputMaybe<CurriculumClassGradeGroupsConnectionWhere>;
  /** Return CurriculumClasses where all of the related GradeGroups match this filter */
  gradeGroups_ALL?: InputMaybe<GradeGroupWhere>;
  /** Return CurriculumClasses where none of the related GradeGroups match this filter */
  gradeGroups_NONE?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Use `gradeGroups_NONE` instead. */
  gradeGroups_NOT?: InputMaybe<GradeGroupWhere>;
  /** Return CurriculumClasses where one of the related GradeGroups match this filter */
  gradeGroups_SINGLE?: InputMaybe<GradeGroupWhere>;
  /** Return CurriculumClasses where some of the related GradeGroups match this filter */
  gradeGroups_SOME?: InputMaybe<GradeGroupWhere>;
  grades?: InputMaybe<Array<Scalars['Int']['input']>>;
  grades_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: InputMaybe<GroupWhere>;
  groupsAggregate?: InputMaybe<CurriculumClassGroupsAggregateInput>;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
  /** Return CurriculumClasses where all of the related CurriculumClassGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
  /** Return CurriculumClasses where none of the related CurriculumClassGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
  /** Return CurriculumClasses where one of the related CurriculumClassGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
  /** Return CurriculumClasses where some of the related CurriculumClassGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<CurriculumClassGroupsConnectionWhere>;
  /** Return CurriculumClasses where all of the related Groups match this filter */
  groups_ALL?: InputMaybe<GroupWhere>;
  /** Return CurriculumClasses where none of the related Groups match this filter */
  groups_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: InputMaybe<GroupWhere>;
  /** Return CurriculumClasses where one of the related Groups match this filter */
  groups_SINGLE?: InputMaybe<GroupWhere>;
  /** Return CurriculumClasses where some of the related Groups match this filter */
  groups_SOME?: InputMaybe<GroupWhere>;
  usedDivision?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  usedDivision_NOT?: InputMaybe<DivisionWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type CurriculumClassesConnection = {
  __typename?: 'CurriculumClassesConnection';
  edges: Array<CurriculumClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumConnectInput = {
  curriculumGrades?: InputMaybe<Array<CurriculumCurriculumGradesConnectFieldInput>>;
  curriculumUnit?: InputMaybe<Array<CurriculumCurriculumUnitConnectFieldInput>>;
  curriculumVersion?: InputMaybe<CurriculumCurriculumVersionConnectFieldInput>;
  labels?: InputMaybe<Array<CurriculumLabelsConnectFieldInput>>;
  lessons?: InputMaybe<Array<CurriculumLessonsConnectFieldInput>>;
  organization?: InputMaybe<CurriculumOrganizationConnectFieldInput>;
  persons?: InputMaybe<Array<CurriculumPersonsConnectFieldInput>>;
  roomSupply?: InputMaybe<Array<CurriculumRoomSupplyConnectFieldInput>>;
  subject?: InputMaybe<CurriculumSubjectConnectInput>;
};

export type CurriculumConnectOrCreateWhere = {
  node: CurriculumUniqueWhere;
};

export type CurriculumConnectWhere = {
  node: CurriculumWhere;
};

export type CurriculumCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  curriculumGrades?: InputMaybe<CurriculumCurriculumGradesFieldInput>;
  curriculumUnit?: InputMaybe<CurriculumCurriculumUnitFieldInput>;
  curriculumVersion?: InputMaybe<CurriculumCurriculumVersionFieldInput>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<CurriculumLabelsFieldInput>;
  lessons?: InputMaybe<CurriculumLessonsFieldInput>;
  organization?: InputMaybe<CurriculumOrganizationFieldInput>;
  persons?: InputMaybe<CurriculumPersonsFieldInput>;
  roomSupply?: InputMaybe<CurriculumRoomSupplyFieldInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<CurriculumSubjectCreateInput>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumCurriculumGradesAggregateInput = {
  AND?: InputMaybe<Array<CurriculumCurriculumGradesAggregateInput>>;
  NOT?: InputMaybe<CurriculumCurriculumGradesAggregateInput>;
  OR?: InputMaybe<Array<CurriculumCurriculumGradesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<CurriculumCurriculumGradesNodeAggregationWhereInput>;
};

export type CurriculumCurriculumGradesConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumClassConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumClassConnectWhere>;
};

export type CurriculumCurriculumGradesConnection = {
  __typename?: 'CurriculumCurriculumGradesConnection';
  edges: Array<CurriculumCurriculumGradesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumCurriculumGradesConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<CurriculumClassSort>;
};

export type CurriculumCurriculumGradesConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumCurriculumGradesConnectionWhere>>;
  NOT?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumCurriculumGradesConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<CurriculumClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumClassWhere>;
};

export type CurriculumCurriculumGradesCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: CurriculumClassCreateInput;
};

export type CurriculumCurriculumGradesDeleteFieldInput = {
  delete?: InputMaybe<CurriculumClassDeleteInput>;
  where?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
};

export type CurriculumCurriculumGradesDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumClassDisconnectInput>;
  where?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
};

export type CurriculumCurriculumGradesFieldInput = {
  connect?: InputMaybe<Array<CurriculumCurriculumGradesConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumCurriculumGradesCreateFieldInput>>;
};

export type CurriculumCurriculumGradesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumCurriculumGradesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumCurriculumGradesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumCurriculumGradesNodeAggregationWhereInput>>;
};

export type CurriculumCurriculumGradesRelationship = {
  __typename?: 'CurriculumCurriculumGradesRelationship';
  cursor: Scalars['String']['output'];
  node: CurriculumClass;
  properties: OrderedRelationProperties;
};

export type CurriculumCurriculumGradesUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<CurriculumClassUpdateInput>;
};

export type CurriculumCurriculumGradesUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumCurriculumGradesConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumCurriculumGradesCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumCurriculumGradesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumCurriculumGradesDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumCurriculumGradesUpdateConnectionInput>;
  where?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
};

export type CurriculumCurriculumUnitAggregateInput = {
  AND?: InputMaybe<Array<CurriculumCurriculumUnitAggregateInput>>;
  NOT?: InputMaybe<CurriculumCurriculumUnitAggregateInput>;
  OR?: InputMaybe<Array<CurriculumCurriculumUnitAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<CurriculumCurriculumUnitNodeAggregationWhereInput>;
};

export type CurriculumCurriculumUnitConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumUnitConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumUnitConnectWhere>;
};

export type CurriculumCurriculumUnitConnection = {
  __typename?: 'CurriculumCurriculumUnitConnection';
  edges: Array<CurriculumCurriculumUnitRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumCurriculumUnitConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<CurriculumUnitSort>;
};

export type CurriculumCurriculumUnitConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumCurriculumUnitConnectionWhere>>;
  NOT?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumCurriculumUnitConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<CurriculumUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumUnitWhere>;
};

export type CurriculumCurriculumUnitCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: CurriculumUnitCreateInput;
};

export type CurriculumCurriculumUnitDeleteFieldInput = {
  delete?: InputMaybe<CurriculumUnitDeleteInput>;
  where?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
};

export type CurriculumCurriculumUnitDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumUnitDisconnectInput>;
  where?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
};

export type CurriculumCurriculumUnitFieldInput = {
  connect?: InputMaybe<Array<CurriculumCurriculumUnitConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumCurriculumUnitCreateFieldInput>>;
};

export type CurriculumCurriculumUnitNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumCurriculumUnitNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumCurriculumUnitNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumCurriculumUnitNodeAggregationWhereInput>>;
  count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumCurriculumUnitRelationship = {
  __typename?: 'CurriculumCurriculumUnitRelationship';
  cursor: Scalars['String']['output'];
  node: CurriculumUnit;
  properties: OrderedRelationProperties;
};

export type CurriculumCurriculumUnitUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<CurriculumUnitUpdateInput>;
};

export type CurriculumCurriculumUnitUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumCurriculumUnitConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumCurriculumUnitCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumCurriculumUnitDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumCurriculumUnitDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumCurriculumUnitUpdateConnectionInput>;
  where?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
};

export type CurriculumCurriculumVersionAggregateInput = {
  AND?: InputMaybe<Array<CurriculumCurriculumVersionAggregateInput>>;
  NOT?: InputMaybe<CurriculumCurriculumVersionAggregateInput>;
  OR?: InputMaybe<Array<CurriculumCurriculumVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumCurriculumVersionNodeAggregationWhereInput>;
};

export type CurriculumCurriculumVersionConnectFieldInput = {
  connect?: InputMaybe<CurriculumVersionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumVersionConnectWhere>;
};

export type CurriculumCurriculumVersionConnectOrCreateFieldInput = {
  onCreate: CurriculumCurriculumVersionConnectOrCreateFieldInputOnCreate;
  where: CurriculumVersionConnectOrCreateWhere;
};

export type CurriculumCurriculumVersionConnectOrCreateFieldInputOnCreate = {
  node: CurriculumVersionOnCreateInput;
};

export type CurriculumCurriculumVersionConnection = {
  __typename?: 'CurriculumCurriculumVersionConnection';
  edges: Array<CurriculumCurriculumVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumCurriculumVersionConnectionSort = {
  node?: InputMaybe<CurriculumVersionSort>;
};

export type CurriculumCurriculumVersionConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumCurriculumVersionConnectionWhere>>;
  NOT?: InputMaybe<CurriculumCurriculumVersionConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumCurriculumVersionConnectionWhere>>;
  node?: InputMaybe<CurriculumVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumVersionWhere>;
};

export type CurriculumCurriculumVersionCreateFieldInput = {
  node: CurriculumVersionCreateInput;
};

export type CurriculumCurriculumVersionDeleteFieldInput = {
  delete?: InputMaybe<CurriculumVersionDeleteInput>;
  where?: InputMaybe<CurriculumCurriculumVersionConnectionWhere>;
};

export type CurriculumCurriculumVersionDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumVersionDisconnectInput>;
  where?: InputMaybe<CurriculumCurriculumVersionConnectionWhere>;
};

export type CurriculumCurriculumVersionFieldInput = {
  connect?: InputMaybe<CurriculumCurriculumVersionConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumCurriculumVersionConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumCurriculumVersionCreateFieldInput>;
};

export type CurriculumCurriculumVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumCurriculumVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumCurriculumVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumCurriculumVersionNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumCurriculumVersionRelationship = {
  __typename?: 'CurriculumCurriculumVersionRelationship';
  cursor: Scalars['String']['output'];
  node: CurriculumVersion;
};

export type CurriculumCurriculumVersionUpdateConnectionInput = {
  node?: InputMaybe<CurriculumVersionUpdateInput>;
};

export type CurriculumCurriculumVersionUpdateFieldInput = {
  connect?: InputMaybe<CurriculumCurriculumVersionConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumCurriculumVersionConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumCurriculumVersionCreateFieldInput>;
  delete?: InputMaybe<CurriculumCurriculumVersionDeleteFieldInput>;
  disconnect?: InputMaybe<CurriculumCurriculumVersionDisconnectFieldInput>;
  update?: InputMaybe<CurriculumCurriculumVersionUpdateConnectionInput>;
  where?: InputMaybe<CurriculumCurriculumVersionConnectionWhere>;
};

export type CurriculumDeleteInput = {
  curriculumGrades?: InputMaybe<Array<CurriculumCurriculumGradesDeleteFieldInput>>;
  curriculumUnit?: InputMaybe<Array<CurriculumCurriculumUnitDeleteFieldInput>>;
  curriculumVersion?: InputMaybe<CurriculumCurriculumVersionDeleteFieldInput>;
  labels?: InputMaybe<Array<CurriculumLabelsDeleteFieldInput>>;
  lessons?: InputMaybe<Array<CurriculumLessonsDeleteFieldInput>>;
  organization?: InputMaybe<CurriculumOrganizationDeleteFieldInput>;
  persons?: InputMaybe<Array<CurriculumPersonsDeleteFieldInput>>;
  roomSupply?: InputMaybe<Array<CurriculumRoomSupplyDeleteFieldInput>>;
  subject?: InputMaybe<CurriculumSubjectDeleteInput>;
};

export type CurriculumDisconnectInput = {
  curriculumGrades?: InputMaybe<Array<CurriculumCurriculumGradesDisconnectFieldInput>>;
  curriculumUnit?: InputMaybe<Array<CurriculumCurriculumUnitDisconnectFieldInput>>;
  curriculumVersion?: InputMaybe<CurriculumCurriculumVersionDisconnectFieldInput>;
  labels?: InputMaybe<Array<CurriculumLabelsDisconnectFieldInput>>;
  lessons?: InputMaybe<Array<CurriculumLessonsDisconnectFieldInput>>;
  organization?: InputMaybe<CurriculumOrganizationDisconnectFieldInput>;
  persons?: InputMaybe<Array<CurriculumPersonsDisconnectFieldInput>>;
  roomSupply?: InputMaybe<Array<CurriculumRoomSupplyDisconnectFieldInput>>;
  subject?: InputMaybe<CurriculumSubjectDisconnectInput>;
};

export type CurriculumEdge = {
  __typename?: 'CurriculumEdge';
  cursor: Scalars['String']['output'];
  node: Curriculum;
};

export type CurriculumLabelsAggregateInput = {
  AND?: InputMaybe<Array<CurriculumLabelsAggregateInput>>;
  NOT?: InputMaybe<CurriculumLabelsAggregateInput>;
  OR?: InputMaybe<Array<CurriculumLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumLabelsNodeAggregationWhereInput>;
};

export type CurriculumLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type CurriculumLabelsConnection = {
  __typename?: 'CurriculumLabelsConnection';
  edges: Array<CurriculumLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type CurriculumLabelsConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumLabelsConnectionWhere>>;
  NOT?: InputMaybe<CurriculumLabelsConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type CurriculumLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type CurriculumLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<CurriculumLabelsConnectionWhere>;
};

export type CurriculumLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<CurriculumLabelsConnectionWhere>;
};

export type CurriculumLabelsFieldInput = {
  connect?: InputMaybe<Array<CurriculumLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumLabelsCreateFieldInput>>;
};

export type CurriculumLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumLabelsRelationship = {
  __typename?: 'CurriculumLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type CurriculumLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type CurriculumLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumLabelsDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumLabelsUpdateConnectionInput>;
  where?: InputMaybe<CurriculumLabelsConnectionWhere>;
};

export type CurriculumLessonsAggregateInput = {
  AND?: InputMaybe<Array<CurriculumLessonsAggregateInput>>;
  NOT?: InputMaybe<CurriculumLessonsAggregateInput>;
  OR?: InputMaybe<Array<CurriculumLessonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumLessonsNodeAggregationWhereInput>;
};

export type CurriculumLessonsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type CurriculumLessonsConnectOrCreateFieldInput = {
  onCreate: CurriculumLessonsConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type CurriculumLessonsConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type CurriculumLessonsConnection = {
  __typename?: 'CurriculumLessonsConnection';
  edges: Array<CurriculumLessonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumLessonsConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type CurriculumLessonsConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumLessonsConnectionWhere>>;
  NOT?: InputMaybe<CurriculumLessonsConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumLessonsConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type CurriculumLessonsCreateFieldInput = {
  node: LessonCreateInput;
};

export type CurriculumLessonsDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<CurriculumLessonsConnectionWhere>;
};

export type CurriculumLessonsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<CurriculumLessonsConnectionWhere>;
};

export type CurriculumLessonsFieldInput = {
  connect?: InputMaybe<Array<CurriculumLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumLessonsCreateFieldInput>>;
};

export type CurriculumLessonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumLessonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumLessonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumLessonsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumLessonsRelationship = {
  __typename?: 'CurriculumLessonsRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type CurriculumLessonsUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type CurriculumLessonsUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumLessonsCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumLessonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumLessonsDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumLessonsUpdateConnectionInput>;
  where?: InputMaybe<CurriculumLessonsConnectionWhere>;
};

export type CurriculumOnCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CurriculumSort objects to sort Curricula by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CurriculumSort>>;
};

export type CurriculumOrganizationAggregateInput = {
  AND?: InputMaybe<Array<CurriculumOrganizationAggregateInput>>;
  NOT?: InputMaybe<CurriculumOrganizationAggregateInput>;
  OR?: InputMaybe<Array<CurriculumOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumOrganizationNodeAggregationWhereInput>;
};

export type CurriculumOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type CurriculumOrganizationConnectOrCreateFieldInput = {
  onCreate: CurriculumOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type CurriculumOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type CurriculumOrganizationConnection = {
  __typename?: 'CurriculumOrganizationConnection';
  edges: Array<CurriculumOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type CurriculumOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumOrganizationConnectionWhere>>;
  NOT?: InputMaybe<CurriculumOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CurriculumOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type CurriculumOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<CurriculumOrganizationConnectionWhere>;
};

export type CurriculumOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<CurriculumOrganizationConnectionWhere>;
};

export type CurriculumOrganizationFieldInput = {
  connect?: InputMaybe<CurriculumOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumOrganizationCreateFieldInput>;
};

export type CurriculumOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumOrganizationRelationship = {
  __typename?: 'CurriculumOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type CurriculumOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type CurriculumOrganizationUpdateFieldInput = {
  connect?: InputMaybe<CurriculumOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumOrganizationCreateFieldInput>;
  delete?: InputMaybe<CurriculumOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<CurriculumOrganizationDisconnectFieldInput>;
  update?: InputMaybe<CurriculumOrganizationUpdateConnectionInput>;
  where?: InputMaybe<CurriculumOrganizationConnectionWhere>;
};

export type CurriculumPeopleConnection = {
  __typename?: 'CurriculumPeopleConnection';
  edges: Array<CurriculumPersonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumPerson = {
  __typename?: 'CurriculumPerson';
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationConnection: CurriculumPersonOrganizationConnection;
  uuid: Scalars['ID']['output'];
};

export type CurriculumPersonOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type CurriculumPersonOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumPersonOrganizationConnectionSort>>;
  where?: InputMaybe<CurriculumPersonOrganizationConnectionWhere>;
};

export type CurriculumPersonAggregateSelection = {
  __typename?: 'CurriculumPersonAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CurriculumPersonConnectInput = {
  organization?: InputMaybe<CurriculumPersonOrganizationConnectFieldInput>;
};

export type CurriculumPersonConnectWhere = {
  node: CurriculumPersonWhere;
};

export type CurriculumPersonCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<CurriculumPersonOrganizationFieldInput>;
};

export type CurriculumPersonDeleteInput = {
  organization?: InputMaybe<CurriculumPersonOrganizationDeleteFieldInput>;
};

export type CurriculumPersonDisconnectInput = {
  organization?: InputMaybe<CurriculumPersonOrganizationDisconnectFieldInput>;
};

export type CurriculumPersonEdge = {
  __typename?: 'CurriculumPersonEdge';
  cursor: Scalars['String']['output'];
  node: CurriculumPerson;
};

export type CurriculumPersonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CurriculumPersonSort objects to sort CurriculumPeople by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CurriculumPersonSort>>;
};

export type CurriculumPersonOrganizationAggregateInput = {
  AND?: InputMaybe<Array<CurriculumPersonOrganizationAggregateInput>>;
  NOT?: InputMaybe<CurriculumPersonOrganizationAggregateInput>;
  OR?: InputMaybe<Array<CurriculumPersonOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumPersonOrganizationNodeAggregationWhereInput>;
};

export type CurriculumPersonOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type CurriculumPersonOrganizationConnectOrCreateFieldInput = {
  onCreate: CurriculumPersonOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type CurriculumPersonOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type CurriculumPersonOrganizationConnection = {
  __typename?: 'CurriculumPersonOrganizationConnection';
  edges: Array<CurriculumPersonOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumPersonOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type CurriculumPersonOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumPersonOrganizationConnectionWhere>>;
  NOT?: InputMaybe<CurriculumPersonOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumPersonOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CurriculumPersonOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type CurriculumPersonOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<CurriculumPersonOrganizationConnectionWhere>;
};

export type CurriculumPersonOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<CurriculumPersonOrganizationConnectionWhere>;
};

export type CurriculumPersonOrganizationFieldInput = {
  connect?: InputMaybe<CurriculumPersonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumPersonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumPersonOrganizationCreateFieldInput>;
};

export type CurriculumPersonOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumPersonOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumPersonOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumPersonOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumPersonOrganizationRelationship = {
  __typename?: 'CurriculumPersonOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type CurriculumPersonOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type CurriculumPersonOrganizationUpdateFieldInput = {
  connect?: InputMaybe<CurriculumPersonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumPersonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumPersonOrganizationCreateFieldInput>;
  delete?: InputMaybe<CurriculumPersonOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<CurriculumPersonOrganizationDisconnectFieldInput>;
  update?: InputMaybe<CurriculumPersonOrganizationUpdateConnectionInput>;
  where?: InputMaybe<CurriculumPersonOrganizationConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * Curriculum.persons
 */
export type CurriculumPersonRelationshipProperties = {
  __typename?: 'CurriculumPersonRelationshipProperties';
  description?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  present?: Maybe<Scalars['Boolean']['output']>;
  teachingLoad?: Maybe<Scalars['Boolean']['output']>;
};

export type CurriculumPersonRelationshipPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumPersonRelationshipPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumPersonRelationshipPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumPersonRelationshipPropertiesAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumPersonRelationshipPropertiesCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  present?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CurriculumPersonRelationshipPropertiesSort = {
  description?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  present?: InputMaybe<SortDirection>;
  teachingLoad?: InputMaybe<SortDirection>;
};

export type CurriculumPersonRelationshipPropertiesUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  present?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CurriculumPersonRelationshipPropertiesWhere = {
  AND?: InputMaybe<Array<CurriculumPersonRelationshipPropertiesWhere>>;
  NOT?: InputMaybe<CurriculumPersonRelationshipPropertiesWhere>;
  OR?: InputMaybe<Array<CurriculumPersonRelationshipPropertiesWhere>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  present?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  present_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoad_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fields to sort CurriculumPeople by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurriculumPersonSort object. */
export type CurriculumPersonSort = {
  name?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type CurriculumPersonUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<CurriculumPersonOrganizationUpdateFieldInput>;
};

export type CurriculumPersonWhere = {
  AND?: InputMaybe<Array<CurriculumPersonWhere>>;
  NOT?: InputMaybe<CurriculumPersonWhere>;
  OR?: InputMaybe<Array<CurriculumPersonWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<CurriculumPersonOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<CurriculumPersonOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<CurriculumPersonOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type CurriculumPersonsAggregateInput = {
  AND?: InputMaybe<Array<CurriculumPersonsAggregateInput>>;
  NOT?: InputMaybe<CurriculumPersonsAggregateInput>;
  OR?: InputMaybe<Array<CurriculumPersonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CurriculumPersonRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<CurriculumPersonsNodeAggregationWhereInput>;
};

export type CurriculumPersonsConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumPersonConnectInput>>;
  edge: CurriculumPersonRelationshipPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumPersonConnectWhere>;
};

export type CurriculumPersonsConnection = {
  __typename?: 'CurriculumPersonsConnection';
  edges: Array<CurriculumPersonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumPersonsConnectionSort = {
  edge?: InputMaybe<CurriculumPersonRelationshipPropertiesSort>;
  node?: InputMaybe<CurriculumPersonSort>;
};

export type CurriculumPersonsConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumPersonsConnectionWhere>>;
  NOT?: InputMaybe<CurriculumPersonsConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumPersonsConnectionWhere>>;
  edge?: InputMaybe<CurriculumPersonRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<CurriculumPersonRelationshipPropertiesWhere>;
  node?: InputMaybe<CurriculumPersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumPersonWhere>;
};

export type CurriculumPersonsCreateFieldInput = {
  edge: CurriculumPersonRelationshipPropertiesCreateInput;
  node: CurriculumPersonCreateInput;
};

export type CurriculumPersonsDeleteFieldInput = {
  delete?: InputMaybe<CurriculumPersonDeleteInput>;
  where?: InputMaybe<CurriculumPersonsConnectionWhere>;
};

export type CurriculumPersonsDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumPersonDisconnectInput>;
  where?: InputMaybe<CurriculumPersonsConnectionWhere>;
};

export type CurriculumPersonsFieldInput = {
  connect?: InputMaybe<Array<CurriculumPersonsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumPersonsCreateFieldInput>>;
};

export type CurriculumPersonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumPersonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumPersonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumPersonsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumPersonsRelationship = {
  __typename?: 'CurriculumPersonsRelationship';
  cursor: Scalars['String']['output'];
  node: CurriculumPerson;
  properties: CurriculumPersonRelationshipProperties;
};

export type CurriculumPersonsUpdateConnectionInput = {
  edge?: InputMaybe<CurriculumPersonRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<CurriculumPersonUpdateInput>;
};

export type CurriculumPersonsUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumPersonsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumPersonsCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumPersonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumPersonsDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumPersonsUpdateConnectionInput>;
  where?: InputMaybe<CurriculumPersonsConnectionWhere>;
};

export type CurriculumRoomRoomSupplyAggregationSelection = {
  __typename?: 'CurriculumRoomRoomSupplyAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CurriculumRoomRoomSupplyEdgeAggregateSelection>;
  node?: Maybe<CurriculumRoomRoomSupplyNodeAggregateSelection>;
};

export type CurriculumRoomRoomSupplyEdgeAggregateSelection = {
  __typename?: 'CurriculumRoomRoomSupplyEdgeAggregateSelection';
  descriptions: StringAggregateSelection;
  order: IntAggregateSelection;
};

export type CurriculumRoomRoomSupplyNodeAggregateSelection = {
  __typename?: 'CurriculumRoomRoomSupplyNodeAggregateSelection';
  capacity: IntAggregateSelection;
  chairs: IntAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  otherInventory: StringAggregateSelection;
  position: StringAggregateSelection;
  roomNumber: StringAggregateSelection;
  size: IntAggregateSelection;
  tables: IntAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CurriculumRoomSupplyAggregateInput = {
  AND?: InputMaybe<Array<CurriculumRoomSupplyAggregateInput>>;
  NOT?: InputMaybe<CurriculumRoomSupplyAggregateInput>;
  OR?: InputMaybe<Array<CurriculumRoomSupplyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<CurriculumRoomSupplyNodeAggregationWhereInput>;
};

export type CurriculumRoomSupplyConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  edge: LessonRoomRelationshipPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type CurriculumRoomSupplyConnectOrCreateFieldInput = {
  onCreate: CurriculumRoomSupplyConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type CurriculumRoomSupplyConnectOrCreateFieldInputOnCreate = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: RoomOnCreateInput;
};

export type CurriculumRoomSupplyConnection = {
  __typename?: 'CurriculumRoomSupplyConnection';
  edges: Array<CurriculumRoomSupplyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumRoomSupplyConnectionSort = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesSort>;
  node?: InputMaybe<RoomSort>;
};

export type CurriculumRoomSupplyConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumRoomSupplyConnectionWhere>>;
  NOT?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumRoomSupplyConnectionWhere>>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type CurriculumRoomSupplyCreateFieldInput = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: RoomCreateInput;
};

export type CurriculumRoomSupplyDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
};

export type CurriculumRoomSupplyDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
};

export type CurriculumRoomSupplyFieldInput = {
  connect?: InputMaybe<Array<CurriculumRoomSupplyConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumRoomSupplyConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumRoomSupplyCreateFieldInput>>;
};

export type CurriculumRoomSupplyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumRoomSupplyNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumRoomSupplyNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumRoomSupplyNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumRoomSupplyRelationship = {
  __typename?: 'CurriculumRoomSupplyRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
  properties: LessonRoomRelationshipProperties;
};

export type CurriculumRoomSupplyUpdateConnectionInput = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<RoomUpdateInput>;
};

export type CurriculumRoomSupplyUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumRoomSupplyConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumRoomSupplyConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumRoomSupplyCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumRoomSupplyDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumRoomSupplyDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumRoomSupplyUpdateConnectionInput>;
  where?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
};

/** Fields to sort Curricula by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurriculumSort object. */
export type CurriculumSort = {
  comment?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  curriculumClassesNames?: InputMaybe<SortDirection>;
  elective?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  isClassTrip?: InputMaybe<SortDirection>;
  subTitle?: InputMaybe<SortDirection>;
  subjectName?: InputMaybe<SortDirection>;
  teachingLoadEnabled?: InputMaybe<SortDirection>;
  timetableEnabled?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type CurriculumSubjectConnectInput = {
  Subject?: InputMaybe<CurriculumSubjectSubjectConnectFieldInput>;
  SubjectContainer?: InputMaybe<CurriculumSubjectSubjectContainerConnectFieldInput>;
};

export type CurriculumSubjectConnection = {
  __typename?: 'CurriculumSubjectConnection';
  edges: Array<CurriculumSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumSubjectConnectionWhere = {
  Subject?: InputMaybe<CurriculumSubjectSubjectConnectionWhere>;
  SubjectContainer?: InputMaybe<CurriculumSubjectSubjectContainerConnectionWhere>;
};

export type CurriculumSubjectCreateInput = {
  Subject?: InputMaybe<CurriculumSubjectSubjectFieldInput>;
  SubjectContainer?: InputMaybe<CurriculumSubjectSubjectContainerFieldInput>;
};

export type CurriculumSubjectDeleteInput = {
  Subject?: InputMaybe<CurriculumSubjectSubjectDeleteFieldInput>;
  SubjectContainer?: InputMaybe<CurriculumSubjectSubjectContainerDeleteFieldInput>;
};

export type CurriculumSubjectDisconnectInput = {
  Subject?: InputMaybe<CurriculumSubjectSubjectDisconnectFieldInput>;
  SubjectContainer?: InputMaybe<CurriculumSubjectSubjectContainerDisconnectFieldInput>;
};

export type CurriculumSubjectRelationship = {
  __typename?: 'CurriculumSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainerOrSubject;
};

export type CurriculumSubjectSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  where?: InputMaybe<SubjectConnectWhere>;
};

export type CurriculumSubjectSubjectConnectOrCreateFieldInput = {
  onCreate: CurriculumSubjectSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type CurriculumSubjectSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type CurriculumSubjectSubjectConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumSubjectSubjectConnectionWhere>>;
  NOT?: InputMaybe<CurriculumSubjectSubjectConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumSubjectSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type CurriculumSubjectSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type CurriculumSubjectSubjectContainerConnectOrCreateFieldInput = {
  onCreate: CurriculumSubjectSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type CurriculumSubjectSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type CurriculumSubjectSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumSubjectSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<CurriculumSubjectSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumSubjectSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type CurriculumSubjectSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type CurriculumSubjectSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<CurriculumSubjectSubjectContainerConnectionWhere>;
};

export type CurriculumSubjectSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<CurriculumSubjectSubjectContainerConnectionWhere>;
};

export type CurriculumSubjectSubjectContainerFieldInput = {
  connect?: InputMaybe<CurriculumSubjectSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumSubjectSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumSubjectSubjectContainerCreateFieldInput>;
};

export type CurriculumSubjectSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type CurriculumSubjectSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<CurriculumSubjectSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumSubjectSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumSubjectSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<CurriculumSubjectSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<CurriculumSubjectSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<CurriculumSubjectSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<CurriculumSubjectSubjectContainerConnectionWhere>;
};

export type CurriculumSubjectSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type CurriculumSubjectSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<CurriculumSubjectSubjectConnectionWhere>;
};

export type CurriculumSubjectSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<CurriculumSubjectSubjectConnectionWhere>;
};

export type CurriculumSubjectSubjectFieldInput = {
  connect?: InputMaybe<CurriculumSubjectSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumSubjectSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumSubjectSubjectCreateFieldInput>;
};

export type CurriculumSubjectSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type CurriculumSubjectSubjectUpdateFieldInput = {
  connect?: InputMaybe<CurriculumSubjectSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumSubjectSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumSubjectSubjectCreateFieldInput>;
  delete?: InputMaybe<CurriculumSubjectSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<CurriculumSubjectSubjectDisconnectFieldInput>;
  update?: InputMaybe<CurriculumSubjectSubjectUpdateConnectionInput>;
  where?: InputMaybe<CurriculumSubjectSubjectConnectionWhere>;
};

export type CurriculumSubjectUpdateInput = {
  Subject?: InputMaybe<CurriculumSubjectSubjectUpdateFieldInput>;
  SubjectContainer?: InputMaybe<CurriculumSubjectSubjectContainerUpdateFieldInput>;
};

export type CurriculumUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type CurriculumUnit = {
  __typename?: 'CurriculumUnit';
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  subjectContainer?: Maybe<SubjectContainer>;
  subjectContainerAggregate?: Maybe<CurriculumUnitSubjectContainerSubjectContainerAggregationSelection>;
  subjectContainerConnection: CurriculumUnitSubjectContainerConnection;
  uuid: Scalars['ID']['output'];
};

export type CurriculumUnitSubjectContainerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectContainerOptions>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type CurriculumUnitSubjectContainerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type CurriculumUnitSubjectContainerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumUnitSubjectContainerConnectionSort>>;
  where?: InputMaybe<CurriculumUnitSubjectContainerConnectionWhere>;
};

export type CurriculumUnitAggregateSelection = {
  __typename?: 'CurriculumUnitAggregateSelection';
  count: IntAggregateSelection;
  duration: IntAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CurriculumUnitConnectInput = {
  subjectContainer?: InputMaybe<CurriculumUnitSubjectContainerConnectFieldInput>;
};

export type CurriculumUnitConnectWhere = {
  node: CurriculumUnitWhere;
};

export type CurriculumUnitCreateInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  subjectContainer?: InputMaybe<CurriculumUnitSubjectContainerFieldInput>;
};

export type CurriculumUnitDeleteInput = {
  subjectContainer?: InputMaybe<CurriculumUnitSubjectContainerDeleteFieldInput>;
};

export type CurriculumUnitDisconnectInput = {
  subjectContainer?: InputMaybe<CurriculumUnitSubjectContainerDisconnectFieldInput>;
};

export type CurriculumUnitEdge = {
  __typename?: 'CurriculumUnitEdge';
  cursor: Scalars['String']['output'];
  node: CurriculumUnit;
};

export type CurriculumUnitOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CurriculumUnitSort objects to sort CurriculumUnits by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CurriculumUnitSort>>;
};

/** Fields to sort CurriculumUnits by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurriculumUnitSort object. */
export type CurriculumUnitSort = {
  count?: InputMaybe<SortDirection>;
  duration?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type CurriculumUnitSubjectContainerAggregateInput = {
  AND?: InputMaybe<Array<CurriculumUnitSubjectContainerAggregateInput>>;
  NOT?: InputMaybe<CurriculumUnitSubjectContainerAggregateInput>;
  OR?: InputMaybe<Array<CurriculumUnitSubjectContainerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumUnitSubjectContainerNodeAggregationWhereInput>;
};

export type CurriculumUnitSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type CurriculumUnitSubjectContainerConnectOrCreateFieldInput = {
  onCreate: CurriculumUnitSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type CurriculumUnitSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type CurriculumUnitSubjectContainerConnection = {
  __typename?: 'CurriculumUnitSubjectContainerConnection';
  edges: Array<CurriculumUnitSubjectContainerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumUnitSubjectContainerConnectionSort = {
  node?: InputMaybe<SubjectContainerSort>;
};

export type CurriculumUnitSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumUnitSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<CurriculumUnitSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumUnitSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type CurriculumUnitSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type CurriculumUnitSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<CurriculumUnitSubjectContainerConnectionWhere>;
};

export type CurriculumUnitSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<CurriculumUnitSubjectContainerConnectionWhere>;
};

export type CurriculumUnitSubjectContainerFieldInput = {
  connect?: InputMaybe<CurriculumUnitSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumUnitSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumUnitSubjectContainerCreateFieldInput>;
};

export type CurriculumUnitSubjectContainerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumUnitSubjectContainerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumUnitSubjectContainerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumUnitSubjectContainerNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumUnitSubjectContainerRelationship = {
  __typename?: 'CurriculumUnitSubjectContainerRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainer;
};

export type CurriculumUnitSubjectContainerSubjectContainerAggregationSelection = {
  __typename?: 'CurriculumUnitSubjectContainerSubjectContainerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CurriculumUnitSubjectContainerSubjectContainerNodeAggregateSelection>;
};

export type CurriculumUnitSubjectContainerSubjectContainerNodeAggregateSelection = {
  __typename?: 'CurriculumUnitSubjectContainerSubjectContainerNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CurriculumUnitSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type CurriculumUnitSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<CurriculumUnitSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumUnitSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumUnitSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<CurriculumUnitSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<CurriculumUnitSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<CurriculumUnitSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<CurriculumUnitSubjectContainerConnectionWhere>;
};

export type CurriculumUnitUpdateInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  count_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  count_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  duration_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  subjectContainer?: InputMaybe<CurriculumUnitSubjectContainerUpdateFieldInput>;
};

export type CurriculumUnitWhere = {
  AND?: InputMaybe<Array<CurriculumUnitWhere>>;
  NOT?: InputMaybe<CurriculumUnitWhere>;
  OR?: InputMaybe<Array<CurriculumUnitWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subjectContainer?: InputMaybe<SubjectContainerWhere>;
  subjectContainerAggregate?: InputMaybe<CurriculumUnitSubjectContainerAggregateInput>;
  subjectContainerConnection?: InputMaybe<CurriculumUnitSubjectContainerConnectionWhere>;
  subjectContainerConnection_NOT?: InputMaybe<CurriculumUnitSubjectContainerConnectionWhere>;
  subjectContainer_NOT?: InputMaybe<SubjectContainerWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type CurriculumUnitsConnection = {
  __typename?: 'CurriculumUnitsConnection';
  edges: Array<CurriculumUnitEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curriculumGrades?: InputMaybe<Array<CurriculumCurriculumGradesUpdateFieldInput>>;
  curriculumUnit?: InputMaybe<Array<CurriculumCurriculumUnitUpdateFieldInput>>;
  curriculumVersion?: InputMaybe<CurriculumCurriculumVersionUpdateFieldInput>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<CurriculumLabelsUpdateFieldInput>>;
  lessons?: InputMaybe<Array<CurriculumLessonsUpdateFieldInput>>;
  organization?: InputMaybe<CurriculumOrganizationUpdateFieldInput>;
  persons?: InputMaybe<Array<CurriculumPersonsUpdateFieldInput>>;
  roomSupply?: InputMaybe<Array<CurriculumRoomSupplyUpdateFieldInput>>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<CurriculumSubjectUpdateInput>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CurriculumVersion = {
  __typename?: 'CurriculumVersion';
  curricula: Array<Curriculum>;
  curriculaConnection: CurriculumVersionCurriculaConnection;
  description?: Maybe<Scalars['String']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: CurriculumVersionOrganizationConnection;
  uuid: Scalars['ID']['output'];
  validFrom?: Maybe<Scalars['Date']['output']>;
  validGradeGroups: Array<GradeGroup>;
  validGradeGroupsConnection: CurriculumVersionValidGradeGroupsConnection;
  validGrades: Array<Scalars['Int']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

export type CurriculumVersionCurriculaArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumOptions>;
  where?: InputMaybe<CurriculumWhere>;
};

export type CurriculumVersionCurriculaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumVersionCurriculaConnectionSort>>;
  where?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
};

export type CurriculumVersionOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type CurriculumVersionOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumVersionOrganizationConnectionSort>>;
  where?: InputMaybe<CurriculumVersionOrganizationConnectionWhere>;
};

export type CurriculumVersionValidGradeGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GradeGroupOptions>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type CurriculumVersionValidGradeGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurriculumVersionValidGradeGroupsConnectionSort>>;
  where?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
};

export type CurriculumVersionAggregateSelection = {
  __typename?: 'CurriculumVersionAggregateSelection';
  count: Scalars['Int']['output'];
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type CurriculumVersionConnectInput = {
  curricula?: InputMaybe<Array<CurriculumVersionCurriculaConnectFieldInput>>;
  organization?: InputMaybe<CurriculumVersionOrganizationConnectFieldInput>;
  validGradeGroups?: InputMaybe<Array<CurriculumVersionValidGradeGroupsConnectFieldInput>>;
};

export type CurriculumVersionConnectOrCreateWhere = {
  node: CurriculumVersionUniqueWhere;
};

export type CurriculumVersionConnectWhere = {
  node: CurriculumVersionWhere;
};

export type CurriculumVersionCreateInput = {
  curricula?: InputMaybe<CurriculumVersionCurriculaFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<CurriculumVersionOrganizationFieldInput>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validGradeGroups?: InputMaybe<CurriculumVersionValidGradeGroupsFieldInput>;
  validGrades: Array<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type CurriculumVersionCurriculaAggregateInput = {
  AND?: InputMaybe<Array<CurriculumVersionCurriculaAggregateInput>>;
  NOT?: InputMaybe<CurriculumVersionCurriculaAggregateInput>;
  OR?: InputMaybe<Array<CurriculumVersionCurriculaAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumVersionCurriculaNodeAggregationWhereInput>;
};

export type CurriculumVersionCurriculaConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumConnectWhere>;
};

export type CurriculumVersionCurriculaConnectOrCreateFieldInput = {
  onCreate: CurriculumVersionCurriculaConnectOrCreateFieldInputOnCreate;
  where: CurriculumConnectOrCreateWhere;
};

export type CurriculumVersionCurriculaConnectOrCreateFieldInputOnCreate = {
  node: CurriculumOnCreateInput;
};

export type CurriculumVersionCurriculaConnection = {
  __typename?: 'CurriculumVersionCurriculaConnection';
  edges: Array<CurriculumVersionCurriculaRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumVersionCurriculaConnectionSort = {
  node?: InputMaybe<CurriculumSort>;
};

export type CurriculumVersionCurriculaConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumVersionCurriculaConnectionWhere>>;
  NOT?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumVersionCurriculaConnectionWhere>>;
  node?: InputMaybe<CurriculumWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumWhere>;
};

export type CurriculumVersionCurriculaCreateFieldInput = {
  node: CurriculumCreateInput;
};

export type CurriculumVersionCurriculaDeleteFieldInput = {
  delete?: InputMaybe<CurriculumDeleteInput>;
  where?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
};

export type CurriculumVersionCurriculaDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumDisconnectInput>;
  where?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
};

export type CurriculumVersionCurriculaFieldInput = {
  connect?: InputMaybe<Array<CurriculumVersionCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumVersionCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumVersionCurriculaCreateFieldInput>>;
};

export type CurriculumVersionCurriculaNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumVersionCurriculaNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumVersionCurriculaNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumVersionCurriculaNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CurriculumVersionCurriculaRelationship = {
  __typename?: 'CurriculumVersionCurriculaRelationship';
  cursor: Scalars['String']['output'];
  node: Curriculum;
};

export type CurriculumVersionCurriculaUpdateConnectionInput = {
  node?: InputMaybe<CurriculumUpdateInput>;
};

export type CurriculumVersionCurriculaUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumVersionCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CurriculumVersionCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CurriculumVersionCurriculaCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumVersionCurriculaDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumVersionCurriculaDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumVersionCurriculaUpdateConnectionInput>;
  where?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
};

export type CurriculumVersionDeleteInput = {
  curricula?: InputMaybe<Array<CurriculumVersionCurriculaDeleteFieldInput>>;
  organization?: InputMaybe<CurriculumVersionOrganizationDeleteFieldInput>;
  validGradeGroups?: InputMaybe<Array<CurriculumVersionValidGradeGroupsDeleteFieldInput>>;
};

export type CurriculumVersionDisconnectInput = {
  curricula?: InputMaybe<Array<CurriculumVersionCurriculaDisconnectFieldInput>>;
  organization?: InputMaybe<CurriculumVersionOrganizationDisconnectFieldInput>;
  validGradeGroups?: InputMaybe<Array<CurriculumVersionValidGradeGroupsDisconnectFieldInput>>;
};

export type CurriculumVersionEdge = {
  __typename?: 'CurriculumVersionEdge';
  cursor: Scalars['String']['output'];
  node: CurriculumVersion;
};

export type CurriculumVersionOnCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validGrades: Array<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type CurriculumVersionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CurriculumVersionSort objects to sort CurriculumVersions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CurriculumVersionSort>>;
};

export type CurriculumVersionOrganizationAggregateInput = {
  AND?: InputMaybe<Array<CurriculumVersionOrganizationAggregateInput>>;
  NOT?: InputMaybe<CurriculumVersionOrganizationAggregateInput>;
  OR?: InputMaybe<Array<CurriculumVersionOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumVersionOrganizationNodeAggregationWhereInput>;
};

export type CurriculumVersionOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type CurriculumVersionOrganizationConnectOrCreateFieldInput = {
  onCreate: CurriculumVersionOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type CurriculumVersionOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type CurriculumVersionOrganizationConnection = {
  __typename?: 'CurriculumVersionOrganizationConnection';
  edges: Array<CurriculumVersionOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumVersionOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type CurriculumVersionOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumVersionOrganizationConnectionWhere>>;
  NOT?: InputMaybe<CurriculumVersionOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumVersionOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type CurriculumVersionOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type CurriculumVersionOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<CurriculumVersionOrganizationConnectionWhere>;
};

export type CurriculumVersionOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<CurriculumVersionOrganizationConnectionWhere>;
};

export type CurriculumVersionOrganizationFieldInput = {
  connect?: InputMaybe<CurriculumVersionOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumVersionOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumVersionOrganizationCreateFieldInput>;
};

export type CurriculumVersionOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumVersionOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumVersionOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumVersionOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumVersionOrganizationRelationship = {
  __typename?: 'CurriculumVersionOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type CurriculumVersionOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type CurriculumVersionOrganizationUpdateFieldInput = {
  connect?: InputMaybe<CurriculumVersionOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CurriculumVersionOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<CurriculumVersionOrganizationCreateFieldInput>;
  delete?: InputMaybe<CurriculumVersionOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<CurriculumVersionOrganizationDisconnectFieldInput>;
  update?: InputMaybe<CurriculumVersionOrganizationUpdateConnectionInput>;
  where?: InputMaybe<CurriculumVersionOrganizationConnectionWhere>;
};

/** Fields to sort CurriculumVersions by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurriculumVersionSort object. */
export type CurriculumVersionSort = {
  description?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  validFrom?: InputMaybe<SortDirection>;
  validUntil?: InputMaybe<SortDirection>;
};

export type CurriculumVersionUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type CurriculumVersionUpdateInput = {
  curricula?: InputMaybe<Array<CurriculumVersionCurriculaUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<CurriculumVersionOrganizationUpdateFieldInput>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validGradeGroups?: InputMaybe<Array<CurriculumVersionValidGradeGroupsUpdateFieldInput>>;
  validGrades?: InputMaybe<Array<Scalars['Int']['input']>>;
  validGrades_POP?: InputMaybe<Scalars['Int']['input']>;
  validGrades_PUSH?: InputMaybe<Array<Scalars['Int']['input']>>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

export type CurriculumVersionValidGradeGroupsAggregateInput = {
  AND?: InputMaybe<Array<CurriculumVersionValidGradeGroupsAggregateInput>>;
  NOT?: InputMaybe<CurriculumVersionValidGradeGroupsAggregateInput>;
  OR?: InputMaybe<Array<CurriculumVersionValidGradeGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurriculumVersionValidGradeGroupsNodeAggregationWhereInput>;
};

export type CurriculumVersionValidGradeGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GradeGroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GradeGroupConnectWhere>;
};

export type CurriculumVersionValidGradeGroupsConnection = {
  __typename?: 'CurriculumVersionValidGradeGroupsConnection';
  edges: Array<CurriculumVersionValidGradeGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumVersionValidGradeGroupsConnectionSort = {
  node?: InputMaybe<GradeGroupSort>;
};

export type CurriculumVersionValidGradeGroupsConnectionWhere = {
  AND?: InputMaybe<Array<CurriculumVersionValidGradeGroupsConnectionWhere>>;
  NOT?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
  OR?: InputMaybe<Array<CurriculumVersionValidGradeGroupsConnectionWhere>>;
  node?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GradeGroupWhere>;
};

export type CurriculumVersionValidGradeGroupsCreateFieldInput = {
  node: GradeGroupCreateInput;
};

export type CurriculumVersionValidGradeGroupsDeleteFieldInput = {
  delete?: InputMaybe<GradeGroupDeleteInput>;
  where?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
};

export type CurriculumVersionValidGradeGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GradeGroupDisconnectInput>;
  where?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
};

export type CurriculumVersionValidGradeGroupsFieldInput = {
  connect?: InputMaybe<Array<CurriculumVersionValidGradeGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumVersionValidGradeGroupsCreateFieldInput>>;
};

export type CurriculumVersionValidGradeGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurriculumVersionValidGradeGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurriculumVersionValidGradeGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurriculumVersionValidGradeGroupsNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurriculumVersionValidGradeGroupsRelationship = {
  __typename?: 'CurriculumVersionValidGradeGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: GradeGroup;
};

export type CurriculumVersionValidGradeGroupsUpdateConnectionInput = {
  node?: InputMaybe<GradeGroupUpdateInput>;
};

export type CurriculumVersionValidGradeGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<CurriculumVersionValidGradeGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<CurriculumVersionValidGradeGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<CurriculumVersionValidGradeGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CurriculumVersionValidGradeGroupsDisconnectFieldInput>>;
  update?: InputMaybe<CurriculumVersionValidGradeGroupsUpdateConnectionInput>;
  where?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
};

export type CurriculumVersionWhere = {
  AND?: InputMaybe<Array<CurriculumVersionWhere>>;
  NOT?: InputMaybe<CurriculumVersionWhere>;
  OR?: InputMaybe<Array<CurriculumVersionWhere>>;
  /** @deprecated Use `curricula_SOME` instead. */
  curricula?: InputMaybe<CurriculumWhere>;
  curriculaAggregate?: InputMaybe<CurriculumVersionCurriculaAggregateInput>;
  /** @deprecated Use `curriculaConnection_SOME` instead. */
  curriculaConnection?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
  /** Return CurriculumVersions where all of the related CurriculumVersionCurriculaConnections match this filter */
  curriculaConnection_ALL?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
  /** Return CurriculumVersions where none of the related CurriculumVersionCurriculaConnections match this filter */
  curriculaConnection_NONE?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
  /** @deprecated Use `curriculaConnection_NONE` instead. */
  curriculaConnection_NOT?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
  /** Return CurriculumVersions where one of the related CurriculumVersionCurriculaConnections match this filter */
  curriculaConnection_SINGLE?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
  /** Return CurriculumVersions where some of the related CurriculumVersionCurriculaConnections match this filter */
  curriculaConnection_SOME?: InputMaybe<CurriculumVersionCurriculaConnectionWhere>;
  /** Return CurriculumVersions where all of the related Curricula match this filter */
  curricula_ALL?: InputMaybe<CurriculumWhere>;
  /** Return CurriculumVersions where none of the related Curricula match this filter */
  curricula_NONE?: InputMaybe<CurriculumWhere>;
  /** @deprecated Use `curricula_NONE` instead. */
  curricula_NOT?: InputMaybe<CurriculumWhere>;
  /** Return CurriculumVersions where one of the related Curricula match this filter */
  curricula_SINGLE?: InputMaybe<CurriculumWhere>;
  /** Return CurriculumVersions where some of the related Curricula match this filter */
  curricula_SOME?: InputMaybe<CurriculumWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<CurriculumVersionOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<CurriculumVersionOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<CurriculumVersionOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validFrom_GT?: InputMaybe<Scalars['Date']['input']>;
  validFrom_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validFrom_LT?: InputMaybe<Scalars['Date']['input']>;
  validFrom_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validFrom_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** @deprecated Use `validGradeGroups_SOME` instead. */
  validGradeGroups?: InputMaybe<GradeGroupWhere>;
  validGradeGroupsAggregate?: InputMaybe<CurriculumVersionValidGradeGroupsAggregateInput>;
  /** @deprecated Use `validGradeGroupsConnection_SOME` instead. */
  validGradeGroupsConnection?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
  /** Return CurriculumVersions where all of the related CurriculumVersionValidGradeGroupsConnections match this filter */
  validGradeGroupsConnection_ALL?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
  /** Return CurriculumVersions where none of the related CurriculumVersionValidGradeGroupsConnections match this filter */
  validGradeGroupsConnection_NONE?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
  /** @deprecated Use `validGradeGroupsConnection_NONE` instead. */
  validGradeGroupsConnection_NOT?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
  /** Return CurriculumVersions where one of the related CurriculumVersionValidGradeGroupsConnections match this filter */
  validGradeGroupsConnection_SINGLE?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
  /** Return CurriculumVersions where some of the related CurriculumVersionValidGradeGroupsConnections match this filter */
  validGradeGroupsConnection_SOME?: InputMaybe<CurriculumVersionValidGradeGroupsConnectionWhere>;
  /** Return CurriculumVersions where all of the related GradeGroups match this filter */
  validGradeGroups_ALL?: InputMaybe<GradeGroupWhere>;
  /** Return CurriculumVersions where none of the related GradeGroups match this filter */
  validGradeGroups_NONE?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Use `validGradeGroups_NONE` instead. */
  validGradeGroups_NOT?: InputMaybe<GradeGroupWhere>;
  /** Return CurriculumVersions where one of the related GradeGroups match this filter */
  validGradeGroups_SINGLE?: InputMaybe<GradeGroupWhere>;
  /** Return CurriculumVersions where some of the related GradeGroups match this filter */
  validGradeGroups_SOME?: InputMaybe<GradeGroupWhere>;
  validGrades?: InputMaybe<Array<Scalars['Int']['input']>>;
  validGrades_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validGrades_NOT?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validGrades_NOT_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
  validUntil_GT?: InputMaybe<Scalars['Date']['input']>;
  validUntil_GTE?: InputMaybe<Scalars['Date']['input']>;
  validUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validUntil_LT?: InputMaybe<Scalars['Date']['input']>;
  validUntil_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validUntil_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  validUntil_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type CurriculumVersionsConnection = {
  __typename?: 'CurriculumVersionsConnection';
  edges: Array<CurriculumVersionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumWhere = {
  AND?: InputMaybe<Array<CurriculumWhere>>;
  NOT?: InputMaybe<CurriculumWhere>;
  OR?: InputMaybe<Array<CurriculumWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  curriculumClassesNames?: InputMaybe<Scalars['String']['input']>;
  curriculumClassesNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  curriculumClassesNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  curriculumClassesNames_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  curriculumClassesNames_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  curriculumClassesNames_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  curriculumClassesNames_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  curriculumClassesNames_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  curriculumClassesNames_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  curriculumClassesNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `curriculumGrades_SOME` instead. */
  curriculumGrades?: InputMaybe<CurriculumClassWhere>;
  curriculumGradesAggregate?: InputMaybe<CurriculumCurriculumGradesAggregateInput>;
  /** @deprecated Use `curriculumGradesConnection_SOME` instead. */
  curriculumGradesConnection?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
  /** Return Curricula where all of the related CurriculumCurriculumGradesConnections match this filter */
  curriculumGradesConnection_ALL?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
  /** Return Curricula where none of the related CurriculumCurriculumGradesConnections match this filter */
  curriculumGradesConnection_NONE?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
  /** @deprecated Use `curriculumGradesConnection_NONE` instead. */
  curriculumGradesConnection_NOT?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
  /** Return Curricula where one of the related CurriculumCurriculumGradesConnections match this filter */
  curriculumGradesConnection_SINGLE?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
  /** Return Curricula where some of the related CurriculumCurriculumGradesConnections match this filter */
  curriculumGradesConnection_SOME?: InputMaybe<CurriculumCurriculumGradesConnectionWhere>;
  /** Return Curricula where all of the related CurriculumClasses match this filter */
  curriculumGrades_ALL?: InputMaybe<CurriculumClassWhere>;
  /** Return Curricula where none of the related CurriculumClasses match this filter */
  curriculumGrades_NONE?: InputMaybe<CurriculumClassWhere>;
  /** @deprecated Use `curriculumGrades_NONE` instead. */
  curriculumGrades_NOT?: InputMaybe<CurriculumClassWhere>;
  /** Return Curricula where one of the related CurriculumClasses match this filter */
  curriculumGrades_SINGLE?: InputMaybe<CurriculumClassWhere>;
  /** Return Curricula where some of the related CurriculumClasses match this filter */
  curriculumGrades_SOME?: InputMaybe<CurriculumClassWhere>;
  /** @deprecated Use `curriculumUnit_SOME` instead. */
  curriculumUnit?: InputMaybe<CurriculumUnitWhere>;
  curriculumUnitAggregate?: InputMaybe<CurriculumCurriculumUnitAggregateInput>;
  /** @deprecated Use `curriculumUnitConnection_SOME` instead. */
  curriculumUnitConnection?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
  /** Return Curricula where all of the related CurriculumCurriculumUnitConnections match this filter */
  curriculumUnitConnection_ALL?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
  /** Return Curricula where none of the related CurriculumCurriculumUnitConnections match this filter */
  curriculumUnitConnection_NONE?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
  /** @deprecated Use `curriculumUnitConnection_NONE` instead. */
  curriculumUnitConnection_NOT?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
  /** Return Curricula where one of the related CurriculumCurriculumUnitConnections match this filter */
  curriculumUnitConnection_SINGLE?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
  /** Return Curricula where some of the related CurriculumCurriculumUnitConnections match this filter */
  curriculumUnitConnection_SOME?: InputMaybe<CurriculumCurriculumUnitConnectionWhere>;
  /** Return Curricula where all of the related CurriculumUnits match this filter */
  curriculumUnit_ALL?: InputMaybe<CurriculumUnitWhere>;
  /** Return Curricula where none of the related CurriculumUnits match this filter */
  curriculumUnit_NONE?: InputMaybe<CurriculumUnitWhere>;
  /** @deprecated Use `curriculumUnit_NONE` instead. */
  curriculumUnit_NOT?: InputMaybe<CurriculumUnitWhere>;
  /** Return Curricula where one of the related CurriculumUnits match this filter */
  curriculumUnit_SINGLE?: InputMaybe<CurriculumUnitWhere>;
  /** Return Curricula where some of the related CurriculumUnits match this filter */
  curriculumUnit_SOME?: InputMaybe<CurriculumUnitWhere>;
  curriculumVersion?: InputMaybe<CurriculumVersionWhere>;
  curriculumVersionAggregate?: InputMaybe<CurriculumCurriculumVersionAggregateInput>;
  curriculumVersionConnection?: InputMaybe<CurriculumCurriculumVersionConnectionWhere>;
  curriculumVersionConnection_NOT?: InputMaybe<CurriculumCurriculumVersionConnectionWhere>;
  curriculumVersion_NOT?: InputMaybe<CurriculumVersionWhere>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elective_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isClassTrip_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<CurriculumLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<CurriculumLabelsConnectionWhere>;
  /** Return Curricula where all of the related CurriculumLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<CurriculumLabelsConnectionWhere>;
  /** Return Curricula where none of the related CurriculumLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<CurriculumLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<CurriculumLabelsConnectionWhere>;
  /** Return Curricula where one of the related CurriculumLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<CurriculumLabelsConnectionWhere>;
  /** Return Curricula where some of the related CurriculumLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<CurriculumLabelsConnectionWhere>;
  /** Return Curricula where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Curricula where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Curricula where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Curricula where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  /** @deprecated Use `lessons_SOME` instead. */
  lessons?: InputMaybe<LessonWhere>;
  lessonsAggregate?: InputMaybe<CurriculumLessonsAggregateInput>;
  /** @deprecated Use `lessonsConnection_SOME` instead. */
  lessonsConnection?: InputMaybe<CurriculumLessonsConnectionWhere>;
  /** Return Curricula where all of the related CurriculumLessonsConnections match this filter */
  lessonsConnection_ALL?: InputMaybe<CurriculumLessonsConnectionWhere>;
  /** Return Curricula where none of the related CurriculumLessonsConnections match this filter */
  lessonsConnection_NONE?: InputMaybe<CurriculumLessonsConnectionWhere>;
  /** @deprecated Use `lessonsConnection_NONE` instead. */
  lessonsConnection_NOT?: InputMaybe<CurriculumLessonsConnectionWhere>;
  /** Return Curricula where one of the related CurriculumLessonsConnections match this filter */
  lessonsConnection_SINGLE?: InputMaybe<CurriculumLessonsConnectionWhere>;
  /** Return Curricula where some of the related CurriculumLessonsConnections match this filter */
  lessonsConnection_SOME?: InputMaybe<CurriculumLessonsConnectionWhere>;
  /** Return Curricula where all of the related Lessons match this filter */
  lessons_ALL?: InputMaybe<LessonWhere>;
  /** Return Curricula where none of the related Lessons match this filter */
  lessons_NONE?: InputMaybe<LessonWhere>;
  /** @deprecated Use `lessons_NONE` instead. */
  lessons_NOT?: InputMaybe<LessonWhere>;
  /** Return Curricula where one of the related Lessons match this filter */
  lessons_SINGLE?: InputMaybe<LessonWhere>;
  /** Return Curricula where some of the related Lessons match this filter */
  lessons_SOME?: InputMaybe<LessonWhere>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<CurriculumOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<CurriculumOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<CurriculumOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `persons_SOME` instead. */
  persons?: InputMaybe<CurriculumPersonWhere>;
  personsAggregate?: InputMaybe<CurriculumPersonsAggregateInput>;
  /** @deprecated Use `personsConnection_SOME` instead. */
  personsConnection?: InputMaybe<CurriculumPersonsConnectionWhere>;
  /** Return Curricula where all of the related CurriculumPersonsConnections match this filter */
  personsConnection_ALL?: InputMaybe<CurriculumPersonsConnectionWhere>;
  /** Return Curricula where none of the related CurriculumPersonsConnections match this filter */
  personsConnection_NONE?: InputMaybe<CurriculumPersonsConnectionWhere>;
  /** @deprecated Use `personsConnection_NONE` instead. */
  personsConnection_NOT?: InputMaybe<CurriculumPersonsConnectionWhere>;
  /** Return Curricula where one of the related CurriculumPersonsConnections match this filter */
  personsConnection_SINGLE?: InputMaybe<CurriculumPersonsConnectionWhere>;
  /** Return Curricula where some of the related CurriculumPersonsConnections match this filter */
  personsConnection_SOME?: InputMaybe<CurriculumPersonsConnectionWhere>;
  /** Return Curricula where all of the related CurriculumPeople match this filter */
  persons_ALL?: InputMaybe<CurriculumPersonWhere>;
  /** Return Curricula where none of the related CurriculumPeople match this filter */
  persons_NONE?: InputMaybe<CurriculumPersonWhere>;
  /** @deprecated Use `persons_NONE` instead. */
  persons_NOT?: InputMaybe<CurriculumPersonWhere>;
  /** Return Curricula where one of the related CurriculumPeople match this filter */
  persons_SINGLE?: InputMaybe<CurriculumPersonWhere>;
  /** Return Curricula where some of the related CurriculumPeople match this filter */
  persons_SOME?: InputMaybe<CurriculumPersonWhere>;
  /** @deprecated Use `roomSupply_SOME` instead. */
  roomSupply?: InputMaybe<RoomWhere>;
  roomSupplyAggregate?: InputMaybe<CurriculumRoomSupplyAggregateInput>;
  /** @deprecated Use `roomSupplyConnection_SOME` instead. */
  roomSupplyConnection?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
  /** Return Curricula where all of the related CurriculumRoomSupplyConnections match this filter */
  roomSupplyConnection_ALL?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
  /** Return Curricula where none of the related CurriculumRoomSupplyConnections match this filter */
  roomSupplyConnection_NONE?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
  /** @deprecated Use `roomSupplyConnection_NONE` instead. */
  roomSupplyConnection_NOT?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
  /** Return Curricula where one of the related CurriculumRoomSupplyConnections match this filter */
  roomSupplyConnection_SINGLE?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
  /** Return Curricula where some of the related CurriculumRoomSupplyConnections match this filter */
  roomSupplyConnection_SOME?: InputMaybe<CurriculumRoomSupplyConnectionWhere>;
  /** Return Curricula where all of the related Rooms match this filter */
  roomSupply_ALL?: InputMaybe<RoomWhere>;
  /** Return Curricula where none of the related Rooms match this filter */
  roomSupply_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `roomSupply_NONE` instead. */
  roomSupply_NOT?: InputMaybe<RoomWhere>;
  /** Return Curricula where one of the related Rooms match this filter */
  roomSupply_SINGLE?: InputMaybe<RoomWhere>;
  /** Return Curricula where some of the related Rooms match this filter */
  roomSupply_SOME?: InputMaybe<RoomWhere>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subTitle_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subTitle_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subTitle_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<SubjectContainerOrSubjectWhere>;
  subjectConnection?: InputMaybe<CurriculumSubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<CurriculumSubjectConnectionWhere>;
  subjectName?: InputMaybe<Scalars['String']['input']>;
  subjectName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subjectName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subject_NOT?: InputMaybe<SubjectContainerOrSubjectWhere>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timetableEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type DateTimeAggregateSelection = {
  __typename?: 'DateTimeAggregateSelection';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export type DeleteInfo = {
  __typename?: 'DeleteInfo';
  nodesDeleted: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type DependenciesConnection = {
  __typename?: 'DependenciesConnection';
  edges: Array<DependencyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Dependency = {
  __typename?: 'Dependency';
  active?: Maybe<Scalars['Boolean']['output']>;
  alias: Scalars['String']['output'];
  classes: Array<Class>;
  classesConnection: DependencyClassesConnection;
  comment?: Maybe<Scalars['String']['output']>;
  otherData?: Maybe<Scalars['String']['output']>;
  priority: DependencyPriority;
  rooms: Array<Room>;
  roomsConnection: DependencyRoomsConnection;
  subjects: Array<Subject>;
  subjectsConnection: DependencySubjectsConnection;
  teachers: Array<Person>;
  teachersConnection: DependencyTeachersConnection;
  timetableVersion: TimetableVersion;
  timetableVersionConnection: DependencyTimetableVersionConnection;
  uuid: Scalars['ID']['output'];
};

export type DependencyClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type DependencyClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DependencyClassesConnectionSort>>;
  where?: InputMaybe<DependencyClassesConnectionWhere>;
};

export type DependencyRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type DependencyRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DependencyRoomsConnectionSort>>;
  where?: InputMaybe<DependencyRoomsConnectionWhere>;
};

export type DependencySubjectsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type DependencySubjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DependencySubjectsConnectionSort>>;
  where?: InputMaybe<DependencySubjectsConnectionWhere>;
};

export type DependencyTeachersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type DependencyTeachersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DependencyTeachersConnectionSort>>;
  where?: InputMaybe<DependencyTeachersConnectionWhere>;
};

export type DependencyTimetableVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type DependencyTimetableVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DependencyTimetableVersionConnectionSort>>;
  where?: InputMaybe<DependencyTimetableVersionConnectionWhere>;
};

export type DependencyAggregateSelection = {
  __typename?: 'DependencyAggregateSelection';
  alias: StringAggregateSelection;
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  otherData: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type DependencyClassesAggregateInput = {
  AND?: InputMaybe<Array<DependencyClassesAggregateInput>>;
  NOT?: InputMaybe<DependencyClassesAggregateInput>;
  OR?: InputMaybe<Array<DependencyClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DependencyClassesNodeAggregationWhereInput>;
};

export type DependencyClassesConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type DependencyClassesConnectOrCreateFieldInput = {
  onCreate: DependencyClassesConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type DependencyClassesConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type DependencyClassesConnection = {
  __typename?: 'DependencyClassesConnection';
  edges: Array<DependencyClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DependencyClassesConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type DependencyClassesConnectionWhere = {
  AND?: InputMaybe<Array<DependencyClassesConnectionWhere>>;
  NOT?: InputMaybe<DependencyClassesConnectionWhere>;
  OR?: InputMaybe<Array<DependencyClassesConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type DependencyClassesCreateFieldInput = {
  node: ClassCreateInput;
};

export type DependencyClassesDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<DependencyClassesConnectionWhere>;
};

export type DependencyClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<DependencyClassesConnectionWhere>;
};

export type DependencyClassesFieldInput = {
  connect?: InputMaybe<Array<DependencyClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencyClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencyClassesCreateFieldInput>>;
};

export type DependencyClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DependencyClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DependencyClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DependencyClassesNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DependencyClassesRelationship = {
  __typename?: 'DependencyClassesRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type DependencyClassesUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type DependencyClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<DependencyClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencyClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencyClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<DependencyClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DependencyClassesDisconnectFieldInput>>;
  update?: InputMaybe<DependencyClassesUpdateConnectionInput>;
  where?: InputMaybe<DependencyClassesConnectionWhere>;
};

export type DependencyConnectInput = {
  classes?: InputMaybe<Array<DependencyClassesConnectFieldInput>>;
  rooms?: InputMaybe<Array<DependencyRoomsConnectFieldInput>>;
  subjects?: InputMaybe<Array<DependencySubjectsConnectFieldInput>>;
  teachers?: InputMaybe<Array<DependencyTeachersConnectFieldInput>>;
  timetableVersion?: InputMaybe<DependencyTimetableVersionConnectFieldInput>;
};

export type DependencyConnectWhere = {
  node: DependencyWhere;
};

export type DependencyCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alias: Scalars['String']['input'];
  classes?: InputMaybe<DependencyClassesFieldInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  otherData?: InputMaybe<Scalars['String']['input']>;
  priority: DependencyPriority;
  rooms?: InputMaybe<DependencyRoomsFieldInput>;
  subjects?: InputMaybe<DependencySubjectsFieldInput>;
  teachers?: InputMaybe<DependencyTeachersFieldInput>;
  timetableVersion?: InputMaybe<DependencyTimetableVersionFieldInput>;
};

export type DependencyDeleteInput = {
  classes?: InputMaybe<Array<DependencyClassesDeleteFieldInput>>;
  rooms?: InputMaybe<Array<DependencyRoomsDeleteFieldInput>>;
  subjects?: InputMaybe<Array<DependencySubjectsDeleteFieldInput>>;
  teachers?: InputMaybe<Array<DependencyTeachersDeleteFieldInput>>;
  timetableVersion?: InputMaybe<DependencyTimetableVersionDeleteFieldInput>;
};

export type DependencyDisconnectInput = {
  classes?: InputMaybe<Array<DependencyClassesDisconnectFieldInput>>;
  rooms?: InputMaybe<Array<DependencyRoomsDisconnectFieldInput>>;
  subjects?: InputMaybe<Array<DependencySubjectsDisconnectFieldInput>>;
  teachers?: InputMaybe<Array<DependencyTeachersDisconnectFieldInput>>;
  timetableVersion?: InputMaybe<DependencyTimetableVersionDisconnectFieldInput>;
};

export type DependencyEdge = {
  __typename?: 'DependencyEdge';
  cursor: Scalars['String']['output'];
  node: Dependency;
};

export type DependencyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DependencySort objects to sort Dependencies by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DependencySort>>;
};

export enum DependencyPriority {
  Important = 'IMPORTANT',
  Mandatory = 'MANDATORY',
  Optimizing = 'OPTIMIZING',
}

export type DependencyRoomsAggregateInput = {
  AND?: InputMaybe<Array<DependencyRoomsAggregateInput>>;
  NOT?: InputMaybe<DependencyRoomsAggregateInput>;
  OR?: InputMaybe<Array<DependencyRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DependencyRoomsNodeAggregationWhereInput>;
};

export type DependencyRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type DependencyRoomsConnectOrCreateFieldInput = {
  onCreate: DependencyRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type DependencyRoomsConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type DependencyRoomsConnection = {
  __typename?: 'DependencyRoomsConnection';
  edges: Array<DependencyRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DependencyRoomsConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type DependencyRoomsConnectionWhere = {
  AND?: InputMaybe<Array<DependencyRoomsConnectionWhere>>;
  NOT?: InputMaybe<DependencyRoomsConnectionWhere>;
  OR?: InputMaybe<Array<DependencyRoomsConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type DependencyRoomsCreateFieldInput = {
  node: RoomCreateInput;
};

export type DependencyRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<DependencyRoomsConnectionWhere>;
};

export type DependencyRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<DependencyRoomsConnectionWhere>;
};

export type DependencyRoomsFieldInput = {
  connect?: InputMaybe<Array<DependencyRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencyRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencyRoomsCreateFieldInput>>;
};

export type DependencyRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DependencyRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DependencyRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DependencyRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DependencyRoomsRelationship = {
  __typename?: 'DependencyRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type DependencyRoomsUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type DependencyRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<DependencyRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencyRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencyRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<DependencyRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DependencyRoomsDisconnectFieldInput>>;
  update?: InputMaybe<DependencyRoomsUpdateConnectionInput>;
  where?: InputMaybe<DependencyRoomsConnectionWhere>;
};

/** Fields to sort Dependencies by. The order in which sorts are applied is not guaranteed when specifying many fields in one DependencySort object. */
export type DependencySort = {
  active?: InputMaybe<SortDirection>;
  alias?: InputMaybe<SortDirection>;
  comment?: InputMaybe<SortDirection>;
  otherData?: InputMaybe<SortDirection>;
  priority?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type DependencySubjectsAggregateInput = {
  AND?: InputMaybe<Array<DependencySubjectsAggregateInput>>;
  NOT?: InputMaybe<DependencySubjectsAggregateInput>;
  OR?: InputMaybe<Array<DependencySubjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DependencySubjectsNodeAggregationWhereInput>;
};

export type DependencySubjectsConnectFieldInput = {
  connect?: InputMaybe<Array<SubjectConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type DependencySubjectsConnectOrCreateFieldInput = {
  onCreate: DependencySubjectsConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type DependencySubjectsConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type DependencySubjectsConnection = {
  __typename?: 'DependencySubjectsConnection';
  edges: Array<DependencySubjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DependencySubjectsConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type DependencySubjectsConnectionWhere = {
  AND?: InputMaybe<Array<DependencySubjectsConnectionWhere>>;
  NOT?: InputMaybe<DependencySubjectsConnectionWhere>;
  OR?: InputMaybe<Array<DependencySubjectsConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type DependencySubjectsCreateFieldInput = {
  node: SubjectCreateInput;
};

export type DependencySubjectsDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<DependencySubjectsConnectionWhere>;
};

export type DependencySubjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<DependencySubjectsConnectionWhere>;
};

export type DependencySubjectsFieldInput = {
  connect?: InputMaybe<Array<DependencySubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencySubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencySubjectsCreateFieldInput>>;
};

export type DependencySubjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DependencySubjectsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DependencySubjectsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DependencySubjectsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DependencySubjectsRelationship = {
  __typename?: 'DependencySubjectsRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type DependencySubjectsUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type DependencySubjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<DependencySubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencySubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencySubjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<DependencySubjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DependencySubjectsDisconnectFieldInput>>;
  update?: InputMaybe<DependencySubjectsUpdateConnectionInput>;
  where?: InputMaybe<DependencySubjectsConnectionWhere>;
};

export type DependencyTeachersAggregateInput = {
  AND?: InputMaybe<Array<DependencyTeachersAggregateInput>>;
  NOT?: InputMaybe<DependencyTeachersAggregateInput>;
  OR?: InputMaybe<Array<DependencyTeachersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DependencyTeachersNodeAggregationWhereInput>;
};

export type DependencyTeachersConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type DependencyTeachersConnectOrCreateFieldInput = {
  onCreate: DependencyTeachersConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type DependencyTeachersConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type DependencyTeachersConnection = {
  __typename?: 'DependencyTeachersConnection';
  edges: Array<DependencyTeachersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DependencyTeachersConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type DependencyTeachersConnectionWhere = {
  AND?: InputMaybe<Array<DependencyTeachersConnectionWhere>>;
  NOT?: InputMaybe<DependencyTeachersConnectionWhere>;
  OR?: InputMaybe<Array<DependencyTeachersConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type DependencyTeachersCreateFieldInput = {
  node: PersonCreateInput;
};

export type DependencyTeachersDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<DependencyTeachersConnectionWhere>;
};

export type DependencyTeachersDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<DependencyTeachersConnectionWhere>;
};

export type DependencyTeachersFieldInput = {
  connect?: InputMaybe<Array<DependencyTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencyTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencyTeachersCreateFieldInput>>;
};

export type DependencyTeachersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DependencyTeachersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DependencyTeachersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DependencyTeachersNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DependencyTeachersRelationship = {
  __typename?: 'DependencyTeachersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type DependencyTeachersUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type DependencyTeachersUpdateFieldInput = {
  connect?: InputMaybe<Array<DependencyTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DependencyTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DependencyTeachersCreateFieldInput>>;
  delete?: InputMaybe<Array<DependencyTeachersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DependencyTeachersDisconnectFieldInput>>;
  update?: InputMaybe<DependencyTeachersUpdateConnectionInput>;
  where?: InputMaybe<DependencyTeachersConnectionWhere>;
};

export type DependencyTimetableVersionAggregateInput = {
  AND?: InputMaybe<Array<DependencyTimetableVersionAggregateInput>>;
  NOT?: InputMaybe<DependencyTimetableVersionAggregateInput>;
  OR?: InputMaybe<Array<DependencyTimetableVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DependencyTimetableVersionNodeAggregationWhereInput>;
};

export type DependencyTimetableVersionConnectFieldInput = {
  connect?: InputMaybe<TimetableVersionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type DependencyTimetableVersionConnection = {
  __typename?: 'DependencyTimetableVersionConnection';
  edges: Array<DependencyTimetableVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DependencyTimetableVersionConnectionSort = {
  node?: InputMaybe<TimetableVersionSort>;
};

export type DependencyTimetableVersionConnectionWhere = {
  AND?: InputMaybe<Array<DependencyTimetableVersionConnectionWhere>>;
  NOT?: InputMaybe<DependencyTimetableVersionConnectionWhere>;
  OR?: InputMaybe<Array<DependencyTimetableVersionConnectionWhere>>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type DependencyTimetableVersionCreateFieldInput = {
  node: TimetableVersionCreateInput;
};

export type DependencyTimetableVersionDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<DependencyTimetableVersionConnectionWhere>;
};

export type DependencyTimetableVersionDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<DependencyTimetableVersionConnectionWhere>;
};

export type DependencyTimetableVersionFieldInput = {
  connect?: InputMaybe<DependencyTimetableVersionConnectFieldInput>;
  create?: InputMaybe<DependencyTimetableVersionCreateFieldInput>;
};

export type DependencyTimetableVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DependencyTimetableVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DependencyTimetableVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DependencyTimetableVersionNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DependencyTimetableVersionRelationship = {
  __typename?: 'DependencyTimetableVersionRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
};

export type DependencyTimetableVersionUpdateConnectionInput = {
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type DependencyTimetableVersionUpdateFieldInput = {
  connect?: InputMaybe<DependencyTimetableVersionConnectFieldInput>;
  create?: InputMaybe<DependencyTimetableVersionCreateFieldInput>;
  delete?: InputMaybe<DependencyTimetableVersionDeleteFieldInput>;
  disconnect?: InputMaybe<DependencyTimetableVersionDisconnectFieldInput>;
  update?: InputMaybe<DependencyTimetableVersionUpdateConnectionInput>;
  where?: InputMaybe<DependencyTimetableVersionConnectionWhere>;
};

export type DependencyUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<Array<DependencyClassesUpdateFieldInput>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  otherData?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<DependencyPriority>;
  rooms?: InputMaybe<Array<DependencyRoomsUpdateFieldInput>>;
  subjects?: InputMaybe<Array<DependencySubjectsUpdateFieldInput>>;
  teachers?: InputMaybe<Array<DependencyTeachersUpdateFieldInput>>;
  timetableVersion?: InputMaybe<DependencyTimetableVersionUpdateFieldInput>;
};

export type DependencyWhere = {
  AND?: InputMaybe<Array<DependencyWhere>>;
  NOT?: InputMaybe<DependencyWhere>;
  OR?: InputMaybe<Array<DependencyWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  alias_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  alias_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  alias_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  alias_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  alias_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  alias_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  alias_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  alias_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  alias_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `classes_SOME` instead. */
  classes?: InputMaybe<ClassWhere>;
  classesAggregate?: InputMaybe<DependencyClassesAggregateInput>;
  /** @deprecated Use `classesConnection_SOME` instead. */
  classesConnection?: InputMaybe<DependencyClassesConnectionWhere>;
  /** Return Dependencies where all of the related DependencyClassesConnections match this filter */
  classesConnection_ALL?: InputMaybe<DependencyClassesConnectionWhere>;
  /** Return Dependencies where none of the related DependencyClassesConnections match this filter */
  classesConnection_NONE?: InputMaybe<DependencyClassesConnectionWhere>;
  /** @deprecated Use `classesConnection_NONE` instead. */
  classesConnection_NOT?: InputMaybe<DependencyClassesConnectionWhere>;
  /** Return Dependencies where one of the related DependencyClassesConnections match this filter */
  classesConnection_SINGLE?: InputMaybe<DependencyClassesConnectionWhere>;
  /** Return Dependencies where some of the related DependencyClassesConnections match this filter */
  classesConnection_SOME?: InputMaybe<DependencyClassesConnectionWhere>;
  /** Return Dependencies where all of the related Classes match this filter */
  classes_ALL?: InputMaybe<ClassWhere>;
  /** Return Dependencies where none of the related Classes match this filter */
  classes_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `classes_NONE` instead. */
  classes_NOT?: InputMaybe<ClassWhere>;
  /** Return Dependencies where one of the related Classes match this filter */
  classes_SINGLE?: InputMaybe<ClassWhere>;
  /** Return Dependencies where some of the related Classes match this filter */
  classes_SOME?: InputMaybe<ClassWhere>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherData?: InputMaybe<Scalars['String']['input']>;
  otherData_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  otherData_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherData_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherData_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherData_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherData_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherData_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherData_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherData_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<DependencyPriority>;
  priority_IN?: InputMaybe<Array<DependencyPriority>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  priority_NOT?: InputMaybe<DependencyPriority>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  priority_NOT_IN?: InputMaybe<Array<DependencyPriority>>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<DependencyRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<DependencyRoomsConnectionWhere>;
  /** Return Dependencies where all of the related DependencyRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<DependencyRoomsConnectionWhere>;
  /** Return Dependencies where none of the related DependencyRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<DependencyRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<DependencyRoomsConnectionWhere>;
  /** Return Dependencies where one of the related DependencyRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<DependencyRoomsConnectionWhere>;
  /** Return Dependencies where some of the related DependencyRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<DependencyRoomsConnectionWhere>;
  /** Return Dependencies where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return Dependencies where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return Dependencies where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return Dependencies where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  /** @deprecated Use `subjects_SOME` instead. */
  subjects?: InputMaybe<SubjectWhere>;
  subjectsAggregate?: InputMaybe<DependencySubjectsAggregateInput>;
  /** @deprecated Use `subjectsConnection_SOME` instead. */
  subjectsConnection?: InputMaybe<DependencySubjectsConnectionWhere>;
  /** Return Dependencies where all of the related DependencySubjectsConnections match this filter */
  subjectsConnection_ALL?: InputMaybe<DependencySubjectsConnectionWhere>;
  /** Return Dependencies where none of the related DependencySubjectsConnections match this filter */
  subjectsConnection_NONE?: InputMaybe<DependencySubjectsConnectionWhere>;
  /** @deprecated Use `subjectsConnection_NONE` instead. */
  subjectsConnection_NOT?: InputMaybe<DependencySubjectsConnectionWhere>;
  /** Return Dependencies where one of the related DependencySubjectsConnections match this filter */
  subjectsConnection_SINGLE?: InputMaybe<DependencySubjectsConnectionWhere>;
  /** Return Dependencies where some of the related DependencySubjectsConnections match this filter */
  subjectsConnection_SOME?: InputMaybe<DependencySubjectsConnectionWhere>;
  /** Return Dependencies where all of the related Subjects match this filter */
  subjects_ALL?: InputMaybe<SubjectWhere>;
  /** Return Dependencies where none of the related Subjects match this filter */
  subjects_NONE?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `subjects_NONE` instead. */
  subjects_NOT?: InputMaybe<SubjectWhere>;
  /** Return Dependencies where one of the related Subjects match this filter */
  subjects_SINGLE?: InputMaybe<SubjectWhere>;
  /** Return Dependencies where some of the related Subjects match this filter */
  subjects_SOME?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `teachers_SOME` instead. */
  teachers?: InputMaybe<PersonWhere>;
  teachersAggregate?: InputMaybe<DependencyTeachersAggregateInput>;
  /** @deprecated Use `teachersConnection_SOME` instead. */
  teachersConnection?: InputMaybe<DependencyTeachersConnectionWhere>;
  /** Return Dependencies where all of the related DependencyTeachersConnections match this filter */
  teachersConnection_ALL?: InputMaybe<DependencyTeachersConnectionWhere>;
  /** Return Dependencies where none of the related DependencyTeachersConnections match this filter */
  teachersConnection_NONE?: InputMaybe<DependencyTeachersConnectionWhere>;
  /** @deprecated Use `teachersConnection_NONE` instead. */
  teachersConnection_NOT?: InputMaybe<DependencyTeachersConnectionWhere>;
  /** Return Dependencies where one of the related DependencyTeachersConnections match this filter */
  teachersConnection_SINGLE?: InputMaybe<DependencyTeachersConnectionWhere>;
  /** Return Dependencies where some of the related DependencyTeachersConnections match this filter */
  teachersConnection_SOME?: InputMaybe<DependencyTeachersConnectionWhere>;
  /** Return Dependencies where all of the related People match this filter */
  teachers_ALL?: InputMaybe<PersonWhere>;
  /** Return Dependencies where none of the related People match this filter */
  teachers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `teachers_NONE` instead. */
  teachers_NOT?: InputMaybe<PersonWhere>;
  /** Return Dependencies where one of the related People match this filter */
  teachers_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Dependencies where some of the related People match this filter */
  teachers_SOME?: InputMaybe<PersonWhere>;
  timetableVersion?: InputMaybe<TimetableVersionWhere>;
  timetableVersionAggregate?: InputMaybe<DependencyTimetableVersionAggregateInput>;
  timetableVersionConnection?: InputMaybe<DependencyTimetableVersionConnectionWhere>;
  timetableVersionConnection_NOT?: InputMaybe<DependencyTimetableVersionConnectionWhere>;
  timetableVersion_NOT?: InputMaybe<TimetableVersionWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type Division = {
  __typename?: 'Division';
  class?: Maybe<Class>;
  classAggregate?: Maybe<DivisionClassClassAggregationSelection>;
  classConnection: DivisionClassConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  groups: Array<Group>;
  groupsAggregate?: Maybe<DivisionGroupGroupsAggregationSelection>;
  groupsConnection: DivisionGroupsConnection;
  labels: Array<Label>;
  labelsConnection: DivisionLabelsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: DivisionOrganizationConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type DivisionClassArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type DivisionClassAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ClassWhere>;
};

export type DivisionClassConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DivisionClassConnectionSort>>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type DivisionGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type DivisionGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DivisionGroupsConnectionSort>>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type DivisionLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DivisionLabelsConnectionSort>>;
  where?: InputMaybe<DivisionLabelsConnectionWhere>;
};

export type DivisionOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type DivisionOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DivisionOrganizationConnectionSort>>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

export type DivisionAggregateSelection = {
  __typename?: 'DivisionAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type DivisionClassAggregateInput = {
  AND?: InputMaybe<Array<DivisionClassAggregateInput>>;
  NOT?: InputMaybe<DivisionClassAggregateInput>;
  OR?: InputMaybe<Array<DivisionClassAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DivisionClassNodeAggregationWhereInput>;
};

export type DivisionClassClassAggregationSelection = {
  __typename?: 'DivisionClassClassAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DivisionClassClassNodeAggregateSelection>;
};

export type DivisionClassClassNodeAggregateSelection = {
  __typename?: 'DivisionClassClassNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  grade: IntAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type DivisionClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type DivisionClassConnectOrCreateFieldInput = {
  onCreate: DivisionClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type DivisionClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type DivisionClassConnection = {
  __typename?: 'DivisionClassConnection';
  edges: Array<DivisionClassRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DivisionClassConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type DivisionClassConnectionWhere = {
  AND?: InputMaybe<Array<DivisionClassConnectionWhere>>;
  NOT?: InputMaybe<DivisionClassConnectionWhere>;
  OR?: InputMaybe<Array<DivisionClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type DivisionClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type DivisionClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionClassFieldInput = {
  connect?: InputMaybe<DivisionClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<DivisionClassConnectOrCreateFieldInput>;
  create?: InputMaybe<DivisionClassCreateFieldInput>;
};

export type DivisionClassNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DivisionClassNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DivisionClassNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DivisionClassNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DivisionClassRelationship = {
  __typename?: 'DivisionClassRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type DivisionClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type DivisionClassUpdateFieldInput = {
  connect?: InputMaybe<DivisionClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<DivisionClassConnectOrCreateFieldInput>;
  create?: InputMaybe<DivisionClassCreateFieldInput>;
  delete?: InputMaybe<DivisionClassDeleteFieldInput>;
  disconnect?: InputMaybe<DivisionClassDisconnectFieldInput>;
  update?: InputMaybe<DivisionClassUpdateConnectionInput>;
  where?: InputMaybe<DivisionClassConnectionWhere>;
};

export type DivisionConnectInput = {
  class?: InputMaybe<DivisionClassConnectFieldInput>;
  groups?: InputMaybe<Array<DivisionGroupsConnectFieldInput>>;
  labels?: InputMaybe<Array<DivisionLabelsConnectFieldInput>>;
  organization?: InputMaybe<DivisionOrganizationConnectFieldInput>;
};

export type DivisionConnectOrCreateWhere = {
  node: DivisionUniqueWhere;
};

export type DivisionConnectWhere = {
  node: DivisionWhere;
};

export type DivisionCreateInput = {
  class?: InputMaybe<DivisionClassFieldInput>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<DivisionGroupsFieldInput>;
  labels?: InputMaybe<DivisionLabelsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<DivisionOrganizationFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DivisionDeleteInput = {
  class?: InputMaybe<DivisionClassDeleteFieldInput>;
  groups?: InputMaybe<Array<DivisionGroupsDeleteFieldInput>>;
  labels?: InputMaybe<Array<DivisionLabelsDeleteFieldInput>>;
  organization?: InputMaybe<DivisionOrganizationDeleteFieldInput>;
};

export type DivisionDisconnectInput = {
  class?: InputMaybe<DivisionClassDisconnectFieldInput>;
  groups?: InputMaybe<Array<DivisionGroupsDisconnectFieldInput>>;
  labels?: InputMaybe<Array<DivisionLabelsDisconnectFieldInput>>;
  organization?: InputMaybe<DivisionOrganizationDisconnectFieldInput>;
};

export type DivisionEdge = {
  __typename?: 'DivisionEdge';
  cursor: Scalars['String']['output'];
  node: Division;
};

export type DivisionGroupGroupsAggregationSelection = {
  __typename?: 'DivisionGroupGroupsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<DivisionGroupGroupsEdgeAggregateSelection>;
  node?: Maybe<DivisionGroupGroupsNodeAggregateSelection>;
};

export type DivisionGroupGroupsEdgeAggregateSelection = {
  __typename?: 'DivisionGroupGroupsEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type DivisionGroupGroupsNodeAggregateSelection = {
  __typename?: 'DivisionGroupGroupsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type DivisionGroupsAggregateInput = {
  AND?: InputMaybe<Array<DivisionGroupsAggregateInput>>;
  NOT?: InputMaybe<DivisionGroupsAggregateInput>;
  OR?: InputMaybe<Array<DivisionGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<DivisionGroupsNodeAggregationWhereInput>;
};

export type DivisionGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type DivisionGroupsConnectOrCreateFieldInput = {
  onCreate: DivisionGroupsConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type DivisionGroupsConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: GroupOnCreateInput;
};

export type DivisionGroupsConnection = {
  __typename?: 'DivisionGroupsConnection';
  edges: Array<DivisionGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DivisionGroupsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<GroupSort>;
};

export type DivisionGroupsConnectionWhere = {
  AND?: InputMaybe<Array<DivisionGroupsConnectionWhere>>;
  NOT?: InputMaybe<DivisionGroupsConnectionWhere>;
  OR?: InputMaybe<Array<DivisionGroupsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type DivisionGroupsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: GroupCreateInput;
};

export type DivisionGroupsDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionGroupsFieldInput = {
  connect?: InputMaybe<Array<DivisionGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DivisionGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DivisionGroupsCreateFieldInput>>;
};

export type DivisionGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DivisionGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DivisionGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DivisionGroupsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DivisionGroupsRelationship = {
  __typename?: 'DivisionGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
  properties: OrderedRelationProperties;
};

export type DivisionGroupsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<GroupUpdateInput>;
};

export type DivisionGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<DivisionGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DivisionGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DivisionGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<DivisionGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DivisionGroupsDisconnectFieldInput>>;
  update?: InputMaybe<DivisionGroupsUpdateConnectionInput>;
  where?: InputMaybe<DivisionGroupsConnectionWhere>;
};

export type DivisionLabelsAggregateInput = {
  AND?: InputMaybe<Array<DivisionLabelsAggregateInput>>;
  NOT?: InputMaybe<DivisionLabelsAggregateInput>;
  OR?: InputMaybe<Array<DivisionLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DivisionLabelsNodeAggregationWhereInput>;
};

export type DivisionLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type DivisionLabelsConnection = {
  __typename?: 'DivisionLabelsConnection';
  edges: Array<DivisionLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DivisionLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type DivisionLabelsConnectionWhere = {
  AND?: InputMaybe<Array<DivisionLabelsConnectionWhere>>;
  NOT?: InputMaybe<DivisionLabelsConnectionWhere>;
  OR?: InputMaybe<Array<DivisionLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type DivisionLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type DivisionLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<DivisionLabelsConnectionWhere>;
};

export type DivisionLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<DivisionLabelsConnectionWhere>;
};

export type DivisionLabelsFieldInput = {
  connect?: InputMaybe<Array<DivisionLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<DivisionLabelsCreateFieldInput>>;
};

export type DivisionLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DivisionLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DivisionLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DivisionLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DivisionLabelsRelationship = {
  __typename?: 'DivisionLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type DivisionLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type DivisionLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<DivisionLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<DivisionLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<DivisionLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DivisionLabelsDisconnectFieldInput>>;
  update?: InputMaybe<DivisionLabelsUpdateConnectionInput>;
  where?: InputMaybe<DivisionLabelsConnectionWhere>;
};

export type DivisionOnCreateInput = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DivisionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DivisionSort objects to sort Divisions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DivisionSort>>;
};

export type DivisionOrganizationAggregateInput = {
  AND?: InputMaybe<Array<DivisionOrganizationAggregateInput>>;
  NOT?: InputMaybe<DivisionOrganizationAggregateInput>;
  OR?: InputMaybe<Array<DivisionOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DivisionOrganizationNodeAggregationWhereInput>;
};

export type DivisionOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type DivisionOrganizationConnectOrCreateFieldInput = {
  onCreate: DivisionOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type DivisionOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type DivisionOrganizationConnection = {
  __typename?: 'DivisionOrganizationConnection';
  edges: Array<DivisionOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DivisionOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type DivisionOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<DivisionOrganizationConnectionWhere>>;
  NOT?: InputMaybe<DivisionOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<DivisionOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type DivisionOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type DivisionOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

export type DivisionOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

export type DivisionOrganizationFieldInput = {
  connect?: InputMaybe<DivisionOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<DivisionOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<DivisionOrganizationCreateFieldInput>;
};

export type DivisionOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DivisionOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DivisionOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DivisionOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DivisionOrganizationRelationship = {
  __typename?: 'DivisionOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type DivisionOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type DivisionOrganizationUpdateFieldInput = {
  connect?: InputMaybe<DivisionOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<DivisionOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<DivisionOrganizationCreateFieldInput>;
  delete?: InputMaybe<DivisionOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<DivisionOrganizationDisconnectFieldInput>;
  update?: InputMaybe<DivisionOrganizationUpdateConnectionInput>;
  where?: InputMaybe<DivisionOrganizationConnectionWhere>;
};

/** Fields to sort Divisions by. The order in which sorts are applied is not guaranteed when specifying many fields in one DivisionSort object. */
export type DivisionSort = {
  createdAt?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type DivisionUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type DivisionUpdateInput = {
  class?: InputMaybe<DivisionClassUpdateFieldInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<DivisionGroupsUpdateFieldInput>>;
  labels?: InputMaybe<Array<DivisionLabelsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<DivisionOrganizationUpdateFieldInput>;
};

export type DivisionWhere = {
  AND?: InputMaybe<Array<DivisionWhere>>;
  NOT?: InputMaybe<DivisionWhere>;
  OR?: InputMaybe<Array<DivisionWhere>>;
  class?: InputMaybe<ClassWhere>;
  classAggregate?: InputMaybe<DivisionClassAggregateInput>;
  classConnection?: InputMaybe<DivisionClassConnectionWhere>;
  classConnection_NOT?: InputMaybe<DivisionClassConnectionWhere>;
  class_NOT?: InputMaybe<ClassWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: InputMaybe<GroupWhere>;
  groupsAggregate?: InputMaybe<DivisionGroupsAggregateInput>;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where all of the related DivisionGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where none of the related DivisionGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where one of the related DivisionGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where some of the related DivisionGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<DivisionGroupsConnectionWhere>;
  /** Return Divisions where all of the related Groups match this filter */
  groups_ALL?: InputMaybe<GroupWhere>;
  /** Return Divisions where none of the related Groups match this filter */
  groups_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: InputMaybe<GroupWhere>;
  /** Return Divisions where one of the related Groups match this filter */
  groups_SINGLE?: InputMaybe<GroupWhere>;
  /** Return Divisions where some of the related Groups match this filter */
  groups_SOME?: InputMaybe<GroupWhere>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<DivisionLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<DivisionLabelsConnectionWhere>;
  /** Return Divisions where all of the related DivisionLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<DivisionLabelsConnectionWhere>;
  /** Return Divisions where none of the related DivisionLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<DivisionLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<DivisionLabelsConnectionWhere>;
  /** Return Divisions where one of the related DivisionLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<DivisionLabelsConnectionWhere>;
  /** Return Divisions where some of the related DivisionLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<DivisionLabelsConnectionWhere>;
  /** Return Divisions where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Divisions where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Divisions where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Divisions where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<DivisionOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<DivisionOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<DivisionOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type DivisionsConnection = {
  __typename?: 'DivisionsConnection';
  edges: Array<DivisionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DuplicateTeachingBlockVersionOptions = {
  includeAvailabilityExclusions?: InputMaybe<Scalars['Boolean']['input']>;
  includeCardPlacements?: InputMaybe<Scalars['Boolean']['input']>;
  includeConditions?: InputMaybe<Scalars['Boolean']['input']>;
  includeVersionLessons?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DuplicateTeachingBlockVersionResponse = {
  __typename?: 'DuplicateTeachingBlockVersionResponse';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type DuplicateTimetableVersionOptions = {
  createNewTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  snapshot?: InputMaybe<Scalars['Boolean']['input']>;
  targetTimetableUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type DuplicateTimetableVersionResponse = {
  __typename?: 'DuplicateTimetableVersionResponse';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type EntitiesUpdateInfo = {
  __typename?: 'EntitiesUpdateInfo';
  entitiesUpdated: Scalars['Int']['output'];
};

export type Event = {
  __typename?: 'Event';
  /** Events aus welchen dieses Event aggregiert wurde */
  aggregatedEvents: Array<Event>;
  aggregatedEventsAggregate?: Maybe<EventEventAggregatedEventsAggregationSelection>;
  aggregatedEventsConnection: EventAggregatedEventsConnection;
  /** Flag falls dieses Event ausfällt (warum auch immer) - wird über entsprechende */
  canceled: Scalars['Boolean']['output'];
  classesOrGroups: Array<ClassOrGroup>;
  classesOrGroupsConnection: EventClassesOrGroupsConnection;
  /** Bei Schulveranstaltungen kann ein Kommentar/Hinweis hinterlegt werden */
  comment?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  /** Json String mit EventStateType[] */
  currentState?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  groupClassNames: Scalars['String']['output'];
  groupClassNamesLong: Scalars['String']['output'];
  /** In classesOrGroups steht die Klasse nur drin wenn die ganze Klasse an diesem Event teilnimmt. Deshalb hier nochmal ein extra Feld für alle beteiligten Klassen. */
  involvedClasses: Array<Class>;
  involvedOriginalClasses: Array<Class>;
  /** Event in welches dieses Event integriert wurde */
  isAggregated?: Maybe<Event>;
  isAggregatedAggregate?: Maybe<EventEventIsAggregatedAggregationSelection>;
  isAggregatedConnection: EventIsAggregatedConnection;
  /**
   * Handelt es sich dabei um eine Klassenfahrt? Dann wird "isSchoolEvent" true, aber es darf trotzdem nicht bearbeitet werden
   * Diese Event werden automatisch aus den "Klassenfahrt" Epochen erzeugt
   */
  isClassTrip?: Maybe<Scalars['Boolean']['output']>;
  /** Ist die Veranstaltung relevant für das Klassenbuch? Bei Events aus Unterrichtsstunde sollte das immer true sein */
  isClassbookRelevant: Scalars['Boolean']['output'];
  /** Handelt es sich dabei um eine Schulveranstaltung? (dann gibt es keine Referenz und keine original...Werte) */
  isSchoolEvent: Scalars['Boolean']['output'];
  /** Alle events die theoretisch zusammengelegt werden können. Es findet kein Filter auf gleiche Klasse / Teilung statt. */
  mergableEvents: Array<Event>;
  organization: Organization;
  organizationConnection: EventOrganizationConnection;
  originalClassesOrGroups: Array<ClassOrGroup>;
  originalClassesOrGroupsConnection: EventOriginalClassesOrGroupsConnection;
  originalEnd?: Maybe<Scalars['DateTime']['output']>;
  originalGroupClassNames: Scalars['String']['output'];
  originalGroupClassNamesLong: Scalars['String']['output'];
  originalPersons: Array<Person>;
  originalPersonsConnection: EventOriginalPersonsConnection;
  originalRooms: Array<Room>;
  originalRoomsAggregate?: Maybe<EventRoomOriginalRoomsAggregationSelection>;
  originalRoomsConnection: EventOriginalRoomsConnection;
  originalStart?: Maybe<Scalars['DateTime']['output']>;
  /** hier wird eine (ReadOnly) Kopie der Daten gehalten, damit wir jederzeit zurücksetzen können */
  originalSubject?: Maybe<Subject>;
  originalSubjectConnection: EventOriginalSubjectConnection;
  /** Alle events die eine überschneidung haben */
  overlappingEvents: Array<Event>;
  persons: Array<Person>;
  personsAggregate?: Maybe<EventPersonPersonsAggregationSelection>;
  personsConnection: EventPersonsConnection;
  /** Wir merken uns ob ein Event gedruckt werden soll. Das ist wichtig für die Vertretungsansicht. */
  print: Scalars['Boolean']['output'];
  printUpdatedByUser?: Maybe<Scalars['Boolean']['output']>;
  publishedSubstitution?: Maybe<PublishedSubstitutions>;
  publishedSubstitutionConnection: EventPublishedSubstitutionConnection;
  recurringEvent?: Maybe<RecurringEvent>;
  recurringEventConnection: EventRecurringEventConnection;
  rooms: Array<Room>;
  roomsAggregate?: Maybe<EventRoomRoomsAggregationSelection>;
  roomsConnection: EventRoomsConnection;
  /** Referenzen auf die Objekte aus denen dieses Event erstellt wurde (gibt es nicht bei Schulveranstaltungen) */
  sourceLesson?: Maybe<Lesson>;
  sourceLessonConnection: EventSourceLessonConnection;
  sourceTeachingBlockCard?: Maybe<TeachingBlockCard>;
  sourceTeachingBlockCardConnection: EventSourceTeachingBlockCardConnection;
  sourceTimeGridEntry?: Maybe<TimeGridEntry>;
  sourceTimeGridEntryConnection: EventSourceTimeGridEntryConnection;
  sourceTimetableCard?: Maybe<TimetableCard>;
  sourceTimetableCardConnection: EventSourceTimetableCardConnection;
  start: Scalars['DateTime']['output'];
  /** ein Event repräsentiert eine Unterrichtsstunde, braucht also auch alle Daten die so einen Unterricht ausmachen */
  subject: Subject;
  subjectConnection: EventSubjectConnection;
  substitutionComment?: Maybe<Scalars['String']['output']>;
  /** für geplante Vertretungen/Änderungen werden diese Daten hier benötigt */
  substitutionReasons?: Maybe<SubstitutionReason>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type EventAggregatedEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type EventAggregatedEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EventWhere>;
};

export type EventAggregatedEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventAggregatedEventsConnectionSort>>;
  where?: InputMaybe<EventAggregatedEventsConnectionWhere>;
};

export type EventClassesOrGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ClassOrGroupWhere>;
};

export type EventClassesOrGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventClassesOrGroupsConnectionWhere>;
};

export type EventIsAggregatedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type EventIsAggregatedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EventWhere>;
};

export type EventIsAggregatedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventIsAggregatedConnectionSort>>;
  where?: InputMaybe<EventIsAggregatedConnectionWhere>;
};

export type EventOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type EventOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventOrganizationConnectionSort>>;
  where?: InputMaybe<EventOrganizationConnectionWhere>;
};

export type EventOriginalClassesOrGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ClassOrGroupWhere>;
};

export type EventOriginalClassesOrGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EventOriginalClassesOrGroupsConnectionWhere>;
};

export type EventOriginalPersonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type EventOriginalPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventOriginalPersonsConnectionSort>>;
  where?: InputMaybe<EventOriginalPersonsConnectionWhere>;
};

export type EventOriginalRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type EventOriginalRoomsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoomWhere>;
};

export type EventOriginalRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventOriginalRoomsConnectionSort>>;
  where?: InputMaybe<EventOriginalRoomsConnectionWhere>;
};

export type EventOriginalSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type EventOriginalSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventOriginalSubjectConnectionSort>>;
  where?: InputMaybe<EventOriginalSubjectConnectionWhere>;
};

export type EventPersonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type EventPersonsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};

export type EventPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventPersonsConnectionSort>>;
  where?: InputMaybe<EventPersonsConnectionWhere>;
};

export type EventPublishedSubstitutionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PublishedSubstitutionsOptions>;
  where?: InputMaybe<PublishedSubstitutionsWhere>;
};

export type EventPublishedSubstitutionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventPublishedSubstitutionConnectionSort>>;
  where?: InputMaybe<EventPublishedSubstitutionConnectionWhere>;
};

export type EventRecurringEventArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecurringEventOptions>;
  where?: InputMaybe<RecurringEventWhere>;
};

export type EventRecurringEventConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventRecurringEventConnectionSort>>;
  where?: InputMaybe<EventRecurringEventConnectionWhere>;
};

export type EventRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type EventRoomsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoomWhere>;
};

export type EventRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventRoomsConnectionSort>>;
  where?: InputMaybe<EventRoomsConnectionWhere>;
};

export type EventSourceLessonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type EventSourceLessonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventSourceLessonConnectionSort>>;
  where?: InputMaybe<EventSourceLessonConnectionWhere>;
};

export type EventSourceTeachingBlockCardArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockCardOptions>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type EventSourceTeachingBlockCardConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventSourceTeachingBlockCardConnectionSort>>;
  where?: InputMaybe<EventSourceTeachingBlockCardConnectionWhere>;
};

export type EventSourceTimeGridEntryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimeGridEntryOptions>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type EventSourceTimeGridEntryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventSourceTimeGridEntryConnectionSort>>;
  where?: InputMaybe<EventSourceTimeGridEntryConnectionWhere>;
};

export type EventSourceTimetableCardArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableCardOptions>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type EventSourceTimetableCardConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventSourceTimetableCardConnectionSort>>;
  where?: InputMaybe<EventSourceTimetableCardConnectionWhere>;
};

export type EventSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type EventSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EventSubjectConnectionSort>>;
  where?: InputMaybe<EventSubjectConnectionWhere>;
};

export type EventAggregateSelection = {
  __typename?: 'EventAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  currentState: StringAggregateSelection;
  end: DateTimeAggregateSelection;
  originalEnd: DateTimeAggregateSelection;
  originalStart: DateTimeAggregateSelection;
  start: DateTimeAggregateSelection;
  substitutionComment: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type EventAggregatedEventsAggregateInput = {
  AND?: InputMaybe<Array<EventAggregatedEventsAggregateInput>>;
  NOT?: InputMaybe<EventAggregatedEventsAggregateInput>;
  OR?: InputMaybe<Array<EventAggregatedEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventAggregatedEventsNodeAggregationWhereInput>;
};

export type EventAggregatedEventsConnectFieldInput = {
  connect?: InputMaybe<Array<EventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type EventAggregatedEventsConnection = {
  __typename?: 'EventAggregatedEventsConnection';
  edges: Array<EventAggregatedEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventAggregatedEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type EventAggregatedEventsConnectionWhere = {
  AND?: InputMaybe<Array<EventAggregatedEventsConnectionWhere>>;
  NOT?: InputMaybe<EventAggregatedEventsConnectionWhere>;
  OR?: InputMaybe<Array<EventAggregatedEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type EventAggregatedEventsCreateFieldInput = {
  node: EventCreateInput;
};

export type EventAggregatedEventsDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<EventAggregatedEventsConnectionWhere>;
};

export type EventAggregatedEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<EventAggregatedEventsConnectionWhere>;
};

export type EventAggregatedEventsFieldInput = {
  connect?: InputMaybe<Array<EventAggregatedEventsConnectFieldInput>>;
  create?: InputMaybe<Array<EventAggregatedEventsCreateFieldInput>>;
};

export type EventAggregatedEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventAggregatedEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventAggregatedEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventAggregatedEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventAggregatedEventsRelationship = {
  __typename?: 'EventAggregatedEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventAggregatedEventsUpdateConnectionInput = {
  node?: InputMaybe<EventUpdateInput>;
};

export type EventAggregatedEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<EventAggregatedEventsConnectFieldInput>>;
  create?: InputMaybe<Array<EventAggregatedEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<EventAggregatedEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<EventAggregatedEventsDisconnectFieldInput>>;
  update?: InputMaybe<EventAggregatedEventsUpdateConnectionInput>;
  where?: InputMaybe<EventAggregatedEventsConnectionWhere>;
};

export type EventClassesOrGroupsClassConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  where?: InputMaybe<ClassConnectWhere>;
};

export type EventClassesOrGroupsClassConnectOrCreateFieldInput = {
  onCreate: EventClassesOrGroupsClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type EventClassesOrGroupsClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type EventClassesOrGroupsClassConnectionWhere = {
  AND?: InputMaybe<Array<EventClassesOrGroupsClassConnectionWhere>>;
  NOT?: InputMaybe<EventClassesOrGroupsClassConnectionWhere>;
  OR?: InputMaybe<Array<EventClassesOrGroupsClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type EventClassesOrGroupsClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type EventClassesOrGroupsClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<EventClassesOrGroupsClassConnectionWhere>;
};

export type EventClassesOrGroupsClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<EventClassesOrGroupsClassConnectionWhere>;
};

export type EventClassesOrGroupsClassFieldInput = {
  connect?: InputMaybe<Array<EventClassesOrGroupsClassConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventClassesOrGroupsClassConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventClassesOrGroupsClassCreateFieldInput>>;
};

export type EventClassesOrGroupsClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type EventClassesOrGroupsClassUpdateFieldInput = {
  connect?: InputMaybe<Array<EventClassesOrGroupsClassConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventClassesOrGroupsClassConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventClassesOrGroupsClassCreateFieldInput>>;
  delete?: InputMaybe<Array<EventClassesOrGroupsClassDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<EventClassesOrGroupsClassDisconnectFieldInput>>;
  update?: InputMaybe<EventClassesOrGroupsClassUpdateConnectionInput>;
  where?: InputMaybe<EventClassesOrGroupsClassConnectionWhere>;
};

export type EventClassesOrGroupsConnectInput = {
  Class?: InputMaybe<Array<EventClassesOrGroupsClassConnectFieldInput>>;
  Group?: InputMaybe<Array<EventClassesOrGroupsGroupConnectFieldInput>>;
};

export type EventClassesOrGroupsConnection = {
  __typename?: 'EventClassesOrGroupsConnection';
  edges: Array<EventClassesOrGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventClassesOrGroupsConnectionWhere = {
  Class?: InputMaybe<EventClassesOrGroupsClassConnectionWhere>;
  Group?: InputMaybe<EventClassesOrGroupsGroupConnectionWhere>;
};

export type EventClassesOrGroupsCreateInput = {
  Class?: InputMaybe<EventClassesOrGroupsClassFieldInput>;
  Group?: InputMaybe<EventClassesOrGroupsGroupFieldInput>;
};

export type EventClassesOrGroupsDeleteInput = {
  Class?: InputMaybe<Array<EventClassesOrGroupsClassDeleteFieldInput>>;
  Group?: InputMaybe<Array<EventClassesOrGroupsGroupDeleteFieldInput>>;
};

export type EventClassesOrGroupsDisconnectInput = {
  Class?: InputMaybe<Array<EventClassesOrGroupsClassDisconnectFieldInput>>;
  Group?: InputMaybe<Array<EventClassesOrGroupsGroupDisconnectFieldInput>>;
};

export type EventClassesOrGroupsGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  where?: InputMaybe<GroupConnectWhere>;
};

export type EventClassesOrGroupsGroupConnectOrCreateFieldInput = {
  onCreate: EventClassesOrGroupsGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type EventClassesOrGroupsGroupConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type EventClassesOrGroupsGroupConnectionWhere = {
  AND?: InputMaybe<Array<EventClassesOrGroupsGroupConnectionWhere>>;
  NOT?: InputMaybe<EventClassesOrGroupsGroupConnectionWhere>;
  OR?: InputMaybe<Array<EventClassesOrGroupsGroupConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type EventClassesOrGroupsGroupCreateFieldInput = {
  node: GroupCreateInput;
};

export type EventClassesOrGroupsGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<EventClassesOrGroupsGroupConnectionWhere>;
};

export type EventClassesOrGroupsGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<EventClassesOrGroupsGroupConnectionWhere>;
};

export type EventClassesOrGroupsGroupFieldInput = {
  connect?: InputMaybe<Array<EventClassesOrGroupsGroupConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventClassesOrGroupsGroupConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventClassesOrGroupsGroupCreateFieldInput>>;
};

export type EventClassesOrGroupsGroupUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type EventClassesOrGroupsGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<EventClassesOrGroupsGroupConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventClassesOrGroupsGroupConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventClassesOrGroupsGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<EventClassesOrGroupsGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<EventClassesOrGroupsGroupDisconnectFieldInput>>;
  update?: InputMaybe<EventClassesOrGroupsGroupUpdateConnectionInput>;
  where?: InputMaybe<EventClassesOrGroupsGroupConnectionWhere>;
};

export type EventClassesOrGroupsRelationship = {
  __typename?: 'EventClassesOrGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: ClassOrGroup;
};

export type EventClassesOrGroupsUpdateInput = {
  Class?: InputMaybe<Array<EventClassesOrGroupsClassUpdateFieldInput>>;
  Group?: InputMaybe<Array<EventClassesOrGroupsGroupUpdateFieldInput>>;
};

export type EventConnectInput = {
  aggregatedEvents?: InputMaybe<Array<EventAggregatedEventsConnectFieldInput>>;
  classesOrGroups?: InputMaybe<EventClassesOrGroupsConnectInput>;
  isAggregated?: InputMaybe<EventIsAggregatedConnectFieldInput>;
  organization?: InputMaybe<EventOrganizationConnectFieldInput>;
  originalClassesOrGroups?: InputMaybe<EventOriginalClassesOrGroupsConnectInput>;
  originalPersons?: InputMaybe<Array<EventOriginalPersonsConnectFieldInput>>;
  originalRooms?: InputMaybe<Array<EventOriginalRoomsConnectFieldInput>>;
  originalSubject?: InputMaybe<EventOriginalSubjectConnectFieldInput>;
  persons?: InputMaybe<Array<EventPersonsConnectFieldInput>>;
  publishedSubstitution?: InputMaybe<EventPublishedSubstitutionConnectFieldInput>;
  recurringEvent?: InputMaybe<EventRecurringEventConnectFieldInput>;
  rooms?: InputMaybe<Array<EventRoomsConnectFieldInput>>;
  sourceLesson?: InputMaybe<EventSourceLessonConnectFieldInput>;
  sourceTeachingBlockCard?: InputMaybe<EventSourceTeachingBlockCardConnectFieldInput>;
  sourceTimeGridEntry?: InputMaybe<EventSourceTimeGridEntryConnectFieldInput>;
  sourceTimetableCard?: InputMaybe<EventSourceTimetableCardConnectFieldInput>;
  subject?: InputMaybe<EventSubjectConnectFieldInput>;
};

export type EventConnectWhere = {
  node: EventWhere;
};

export type EventCreateInput = {
  aggregatedEvents?: InputMaybe<EventAggregatedEventsFieldInput>;
  canceled: Scalars['Boolean']['input'];
  classesOrGroups?: InputMaybe<EventClassesOrGroupsCreateInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  currentState?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  isAggregated?: InputMaybe<EventIsAggregatedFieldInput>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  isClassbookRelevant: Scalars['Boolean']['input'];
  isSchoolEvent: Scalars['Boolean']['input'];
  organization?: InputMaybe<EventOrganizationFieldInput>;
  originalClassesOrGroups?: InputMaybe<EventOriginalClassesOrGroupsCreateInput>;
  originalEnd?: InputMaybe<Scalars['DateTime']['input']>;
  originalPersons?: InputMaybe<EventOriginalPersonsFieldInput>;
  originalRooms?: InputMaybe<EventOriginalRoomsFieldInput>;
  originalStart?: InputMaybe<Scalars['DateTime']['input']>;
  originalSubject?: InputMaybe<EventOriginalSubjectFieldInput>;
  persons?: InputMaybe<EventPersonsFieldInput>;
  print: Scalars['Boolean']['input'];
  printUpdatedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  publishedSubstitution?: InputMaybe<EventPublishedSubstitutionFieldInput>;
  recurringEvent?: InputMaybe<EventRecurringEventFieldInput>;
  rooms?: InputMaybe<EventRoomsFieldInput>;
  sourceLesson?: InputMaybe<EventSourceLessonFieldInput>;
  sourceTeachingBlockCard?: InputMaybe<EventSourceTeachingBlockCardFieldInput>;
  sourceTimeGridEntry?: InputMaybe<EventSourceTimeGridEntryFieldInput>;
  sourceTimetableCard?: InputMaybe<EventSourceTimetableCardFieldInput>;
  start: Scalars['DateTime']['input'];
  subject?: InputMaybe<EventSubjectFieldInput>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  substitutionReasons?: InputMaybe<SubstitutionReason>;
};

export type EventDeleteInput = {
  aggregatedEvents?: InputMaybe<Array<EventAggregatedEventsDeleteFieldInput>>;
  classesOrGroups?: InputMaybe<EventClassesOrGroupsDeleteInput>;
  isAggregated?: InputMaybe<EventIsAggregatedDeleteFieldInput>;
  organization?: InputMaybe<EventOrganizationDeleteFieldInput>;
  originalClassesOrGroups?: InputMaybe<EventOriginalClassesOrGroupsDeleteInput>;
  originalPersons?: InputMaybe<Array<EventOriginalPersonsDeleteFieldInput>>;
  originalRooms?: InputMaybe<Array<EventOriginalRoomsDeleteFieldInput>>;
  originalSubject?: InputMaybe<EventOriginalSubjectDeleteFieldInput>;
  persons?: InputMaybe<Array<EventPersonsDeleteFieldInput>>;
  publishedSubstitution?: InputMaybe<EventPublishedSubstitutionDeleteFieldInput>;
  recurringEvent?: InputMaybe<EventRecurringEventDeleteFieldInput>;
  rooms?: InputMaybe<Array<EventRoomsDeleteFieldInput>>;
  sourceLesson?: InputMaybe<EventSourceLessonDeleteFieldInput>;
  sourceTeachingBlockCard?: InputMaybe<EventSourceTeachingBlockCardDeleteFieldInput>;
  sourceTimeGridEntry?: InputMaybe<EventSourceTimeGridEntryDeleteFieldInput>;
  sourceTimetableCard?: InputMaybe<EventSourceTimetableCardDeleteFieldInput>;
  subject?: InputMaybe<EventSubjectDeleteFieldInput>;
};

export type EventDisconnectInput = {
  aggregatedEvents?: InputMaybe<Array<EventAggregatedEventsDisconnectFieldInput>>;
  classesOrGroups?: InputMaybe<EventClassesOrGroupsDisconnectInput>;
  isAggregated?: InputMaybe<EventIsAggregatedDisconnectFieldInput>;
  organization?: InputMaybe<EventOrganizationDisconnectFieldInput>;
  originalClassesOrGroups?: InputMaybe<EventOriginalClassesOrGroupsDisconnectInput>;
  originalPersons?: InputMaybe<Array<EventOriginalPersonsDisconnectFieldInput>>;
  originalRooms?: InputMaybe<Array<EventOriginalRoomsDisconnectFieldInput>>;
  originalSubject?: InputMaybe<EventOriginalSubjectDisconnectFieldInput>;
  persons?: InputMaybe<Array<EventPersonsDisconnectFieldInput>>;
  publishedSubstitution?: InputMaybe<EventPublishedSubstitutionDisconnectFieldInput>;
  recurringEvent?: InputMaybe<EventRecurringEventDisconnectFieldInput>;
  rooms?: InputMaybe<Array<EventRoomsDisconnectFieldInput>>;
  sourceLesson?: InputMaybe<EventSourceLessonDisconnectFieldInput>;
  sourceTeachingBlockCard?: InputMaybe<EventSourceTeachingBlockCardDisconnectFieldInput>;
  sourceTimeGridEntry?: InputMaybe<EventSourceTimeGridEntryDisconnectFieldInput>;
  sourceTimetableCard?: InputMaybe<EventSourceTimetableCardDisconnectFieldInput>;
  subject?: InputMaybe<EventSubjectDisconnectFieldInput>;
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventEventAggregatedEventsAggregationSelection = {
  __typename?: 'EventEventAggregatedEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EventEventAggregatedEventsNodeAggregateSelection>;
};

export type EventEventAggregatedEventsNodeAggregateSelection = {
  __typename?: 'EventEventAggregatedEventsNodeAggregateSelection';
  comment: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  currentState: StringAggregateSelection;
  end: DateTimeAggregateSelection;
  originalEnd: DateTimeAggregateSelection;
  originalStart: DateTimeAggregateSelection;
  start: DateTimeAggregateSelection;
  substitutionComment: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type EventEventIsAggregatedAggregationSelection = {
  __typename?: 'EventEventIsAggregatedAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EventEventIsAggregatedNodeAggregateSelection>;
};

export type EventEventIsAggregatedNodeAggregateSelection = {
  __typename?: 'EventEventIsAggregatedNodeAggregateSelection';
  comment: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  currentState: StringAggregateSelection;
  end: DateTimeAggregateSelection;
  originalEnd: DateTimeAggregateSelection;
  originalStart: DateTimeAggregateSelection;
  start: DateTimeAggregateSelection;
  substitutionComment: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type EventIsAggregatedAggregateInput = {
  AND?: InputMaybe<Array<EventIsAggregatedAggregateInput>>;
  NOT?: InputMaybe<EventIsAggregatedAggregateInput>;
  OR?: InputMaybe<Array<EventIsAggregatedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventIsAggregatedNodeAggregationWhereInput>;
};

export type EventIsAggregatedConnectFieldInput = {
  connect?: InputMaybe<EventConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type EventIsAggregatedConnection = {
  __typename?: 'EventIsAggregatedConnection';
  edges: Array<EventIsAggregatedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventIsAggregatedConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type EventIsAggregatedConnectionWhere = {
  AND?: InputMaybe<Array<EventIsAggregatedConnectionWhere>>;
  NOT?: InputMaybe<EventIsAggregatedConnectionWhere>;
  OR?: InputMaybe<Array<EventIsAggregatedConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type EventIsAggregatedCreateFieldInput = {
  node: EventCreateInput;
};

export type EventIsAggregatedDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<EventIsAggregatedConnectionWhere>;
};

export type EventIsAggregatedDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<EventIsAggregatedConnectionWhere>;
};

export type EventIsAggregatedFieldInput = {
  connect?: InputMaybe<EventIsAggregatedConnectFieldInput>;
  create?: InputMaybe<EventIsAggregatedCreateFieldInput>;
};

export type EventIsAggregatedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventIsAggregatedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventIsAggregatedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventIsAggregatedNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventIsAggregatedRelationship = {
  __typename?: 'EventIsAggregatedRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type EventIsAggregatedUpdateConnectionInput = {
  node?: InputMaybe<EventUpdateInput>;
};

export type EventIsAggregatedUpdateFieldInput = {
  connect?: InputMaybe<EventIsAggregatedConnectFieldInput>;
  create?: InputMaybe<EventIsAggregatedCreateFieldInput>;
  delete?: InputMaybe<EventIsAggregatedDeleteFieldInput>;
  disconnect?: InputMaybe<EventIsAggregatedDisconnectFieldInput>;
  update?: InputMaybe<EventIsAggregatedUpdateConnectionInput>;
  where?: InputMaybe<EventIsAggregatedConnectionWhere>;
};

export type EventJob = {
  __typename?: 'EventJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventsToProcess?: Maybe<Scalars['Int']['output']>;
  from: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  organizationUuid: Scalars['String']['output'];
  processed?: Maybe<Scalars['Int']['output']>;
  status: EventJobStatus;
  to: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type EventJobAggregateSelection = {
  __typename?: 'EventJobAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  error: StringAggregateSelection;
  eventsToProcess: IntAggregateSelection;
  from: DateTimeAggregateSelection;
  jobId: StringAggregateSelection;
  organizationUuid: StringAggregateSelection;
  processed: IntAggregateSelection;
  to: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type EventJobCreateInput = {
  error?: InputMaybe<Scalars['String']['input']>;
  eventsToProcess?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTime']['input'];
  jobId: Scalars['String']['input'];
  organizationUuid: Scalars['String']['input'];
  processed?: InputMaybe<Scalars['Int']['input']>;
  status: EventJobStatus;
  to: Scalars['DateTime']['input'];
};

export type EventJobEdge = {
  __typename?: 'EventJobEdge';
  cursor: Scalars['String']['output'];
  node: EventJob;
};

export type EventJobOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EventJobSort objects to sort EventJobs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EventJobSort>>;
};

/** Fields to sort EventJobs by. The order in which sorts are applied is not guaranteed when specifying many fields in one EventJobSort object. */
export type EventJobSort = {
  createdAt?: InputMaybe<SortDirection>;
  error?: InputMaybe<SortDirection>;
  eventsToProcess?: InputMaybe<SortDirection>;
  from?: InputMaybe<SortDirection>;
  jobId?: InputMaybe<SortDirection>;
  organizationUuid?: InputMaybe<SortDirection>;
  processed?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export enum EventJobStatus {
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Finished = 'FINISHED',
  Running = 'RUNNING',
}

export type EventJobUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  eventsToProcess?: InputMaybe<Scalars['Int']['input']>;
  eventsToProcess_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  eventsToProcess_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  organizationUuid?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Int']['input']>;
  processed_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  processed_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<EventJobStatus>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventJobWhere = {
  AND?: InputMaybe<Array<EventJobWhere>>;
  NOT?: InputMaybe<EventJobWhere>;
  OR?: InputMaybe<Array<EventJobWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  error?: InputMaybe<Scalars['String']['input']>;
  error_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  error_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  error_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  error_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  error_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  error_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  error_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  error_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  error_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  eventsToProcess?: InputMaybe<Scalars['Int']['input']>;
  eventsToProcess_GT?: InputMaybe<Scalars['Int']['input']>;
  eventsToProcess_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventsToProcess_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eventsToProcess_LT?: InputMaybe<Scalars['Int']['input']>;
  eventsToProcess_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  eventsToProcess_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  eventsToProcess_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  from_GT?: InputMaybe<Scalars['DateTime']['input']>;
  from_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  from_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  from_LT?: InputMaybe<Scalars['DateTime']['input']>;
  from_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  from_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  from_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  jobId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationUuid?: InputMaybe<Scalars['String']['input']>;
  organizationUuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationUuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationUuid_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  organizationUuid_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  organizationUuid_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  organizationUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  organizationUuid_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  organizationUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationUuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Int']['input']>;
  processed_GT?: InputMaybe<Scalars['Int']['input']>;
  processed_GTE?: InputMaybe<Scalars['Int']['input']>;
  processed_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  processed_LT?: InputMaybe<Scalars['Int']['input']>;
  processed_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  processed_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  processed_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<EventJobStatus>;
  status_IN?: InputMaybe<Array<EventJobStatus>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: InputMaybe<EventJobStatus>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: InputMaybe<Array<EventJobStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  to_GT?: InputMaybe<Scalars['DateTime']['input']>;
  to_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  to_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  to_LT?: InputMaybe<Scalars['DateTime']['input']>;
  to_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  to_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  to_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type EventJobsConnection = {
  __typename?: 'EventJobsConnection';
  edges: Array<EventJobEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EventSort objects to sort Events by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EventSort>>;
};

export type EventOrganizationAggregateInput = {
  AND?: InputMaybe<Array<EventOrganizationAggregateInput>>;
  NOT?: InputMaybe<EventOrganizationAggregateInput>;
  OR?: InputMaybe<Array<EventOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventOrganizationNodeAggregationWhereInput>;
};

export type EventOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type EventOrganizationConnectOrCreateFieldInput = {
  onCreate: EventOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type EventOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type EventOrganizationConnection = {
  __typename?: 'EventOrganizationConnection';
  edges: Array<EventOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type EventOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<EventOrganizationConnectionWhere>>;
  NOT?: InputMaybe<EventOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<EventOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type EventOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type EventOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<EventOrganizationConnectionWhere>;
};

export type EventOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<EventOrganizationConnectionWhere>;
};

export type EventOrganizationFieldInput = {
  connect?: InputMaybe<EventOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<EventOrganizationCreateFieldInput>;
};

export type EventOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EventOrganizationRelationship = {
  __typename?: 'EventOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type EventOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type EventOrganizationUpdateFieldInput = {
  connect?: InputMaybe<EventOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<EventOrganizationCreateFieldInput>;
  delete?: InputMaybe<EventOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<EventOrganizationDisconnectFieldInput>;
  update?: InputMaybe<EventOrganizationUpdateConnectionInput>;
  where?: InputMaybe<EventOrganizationConnectionWhere>;
};

export type EventOriginalClassesOrGroupsClassConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  where?: InputMaybe<ClassConnectWhere>;
};

export type EventOriginalClassesOrGroupsClassConnectOrCreateFieldInput = {
  onCreate: EventOriginalClassesOrGroupsClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type EventOriginalClassesOrGroupsClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type EventOriginalClassesOrGroupsClassConnectionWhere = {
  AND?: InputMaybe<Array<EventOriginalClassesOrGroupsClassConnectionWhere>>;
  NOT?: InputMaybe<EventOriginalClassesOrGroupsClassConnectionWhere>;
  OR?: InputMaybe<Array<EventOriginalClassesOrGroupsClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type EventOriginalClassesOrGroupsClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type EventOriginalClassesOrGroupsClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<EventOriginalClassesOrGroupsClassConnectionWhere>;
};

export type EventOriginalClassesOrGroupsClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<EventOriginalClassesOrGroupsClassConnectionWhere>;
};

export type EventOriginalClassesOrGroupsClassFieldInput = {
  connect?: InputMaybe<Array<EventOriginalClassesOrGroupsClassConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventOriginalClassesOrGroupsClassConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventOriginalClassesOrGroupsClassCreateFieldInput>>;
};

export type EventOriginalClassesOrGroupsConnectInput = {
  Class?: InputMaybe<Array<EventOriginalClassesOrGroupsClassConnectFieldInput>>;
  Group?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupConnectFieldInput>>;
};

export type EventOriginalClassesOrGroupsConnection = {
  __typename?: 'EventOriginalClassesOrGroupsConnection';
  edges: Array<EventOriginalClassesOrGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventOriginalClassesOrGroupsConnectionWhere = {
  Class?: InputMaybe<EventOriginalClassesOrGroupsClassConnectionWhere>;
  Group?: InputMaybe<EventOriginalClassesOrGroupsGroupConnectionWhere>;
};

export type EventOriginalClassesOrGroupsCreateInput = {
  Class?: InputMaybe<EventOriginalClassesOrGroupsClassFieldInput>;
  Group?: InputMaybe<EventOriginalClassesOrGroupsGroupFieldInput>;
};

export type EventOriginalClassesOrGroupsDeleteInput = {
  Class?: InputMaybe<Array<EventOriginalClassesOrGroupsClassDeleteFieldInput>>;
  Group?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupDeleteFieldInput>>;
};

export type EventOriginalClassesOrGroupsDisconnectInput = {
  Class?: InputMaybe<Array<EventOriginalClassesOrGroupsClassDisconnectFieldInput>>;
  Group?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupDisconnectFieldInput>>;
};

export type EventOriginalClassesOrGroupsGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  where?: InputMaybe<GroupConnectWhere>;
};

export type EventOriginalClassesOrGroupsGroupConnectOrCreateFieldInput = {
  onCreate: EventOriginalClassesOrGroupsGroupConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type EventOriginalClassesOrGroupsGroupConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type EventOriginalClassesOrGroupsGroupConnectionWhere = {
  AND?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupConnectionWhere>>;
  NOT?: InputMaybe<EventOriginalClassesOrGroupsGroupConnectionWhere>;
  OR?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type EventOriginalClassesOrGroupsGroupCreateFieldInput = {
  node: GroupCreateInput;
};

export type EventOriginalClassesOrGroupsGroupDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<EventOriginalClassesOrGroupsGroupConnectionWhere>;
};

export type EventOriginalClassesOrGroupsGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<EventOriginalClassesOrGroupsGroupConnectionWhere>;
};

export type EventOriginalClassesOrGroupsGroupFieldInput = {
  connect?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventOriginalClassesOrGroupsGroupCreateFieldInput>>;
};

export type EventOriginalClassesOrGroupsRelationship = {
  __typename?: 'EventOriginalClassesOrGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: ClassOrGroup;
};

export type EventOriginalPersonsAggregateInput = {
  AND?: InputMaybe<Array<EventOriginalPersonsAggregateInput>>;
  NOT?: InputMaybe<EventOriginalPersonsAggregateInput>;
  OR?: InputMaybe<Array<EventOriginalPersonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventOriginalPersonsNodeAggregationWhereInput>;
};

export type EventOriginalPersonsConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type EventOriginalPersonsConnectOrCreateFieldInput = {
  onCreate: EventOriginalPersonsConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type EventOriginalPersonsConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type EventOriginalPersonsConnection = {
  __typename?: 'EventOriginalPersonsConnection';
  edges: Array<EventOriginalPersonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventOriginalPersonsConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type EventOriginalPersonsConnectionWhere = {
  AND?: InputMaybe<Array<EventOriginalPersonsConnectionWhere>>;
  NOT?: InputMaybe<EventOriginalPersonsConnectionWhere>;
  OR?: InputMaybe<Array<EventOriginalPersonsConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type EventOriginalPersonsCreateFieldInput = {
  node: PersonCreateInput;
};

export type EventOriginalPersonsDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<EventOriginalPersonsConnectionWhere>;
};

export type EventOriginalPersonsDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<EventOriginalPersonsConnectionWhere>;
};

export type EventOriginalPersonsFieldInput = {
  connect?: InputMaybe<Array<EventOriginalPersonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventOriginalPersonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventOriginalPersonsCreateFieldInput>>;
};

export type EventOriginalPersonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventOriginalPersonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventOriginalPersonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventOriginalPersonsNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventOriginalPersonsRelationship = {
  __typename?: 'EventOriginalPersonsRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type EventOriginalRoomsAggregateInput = {
  AND?: InputMaybe<Array<EventOriginalRoomsAggregateInput>>;
  NOT?: InputMaybe<EventOriginalRoomsAggregateInput>;
  OR?: InputMaybe<Array<EventOriginalRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventOriginalRoomsNodeAggregationWhereInput>;
};

export type EventOriginalRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type EventOriginalRoomsConnectOrCreateFieldInput = {
  onCreate: EventOriginalRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type EventOriginalRoomsConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type EventOriginalRoomsConnection = {
  __typename?: 'EventOriginalRoomsConnection';
  edges: Array<EventOriginalRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventOriginalRoomsConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type EventOriginalRoomsConnectionWhere = {
  AND?: InputMaybe<Array<EventOriginalRoomsConnectionWhere>>;
  NOT?: InputMaybe<EventOriginalRoomsConnectionWhere>;
  OR?: InputMaybe<Array<EventOriginalRoomsConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type EventOriginalRoomsCreateFieldInput = {
  node: RoomCreateInput;
};

export type EventOriginalRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<EventOriginalRoomsConnectionWhere>;
};

export type EventOriginalRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<EventOriginalRoomsConnectionWhere>;
};

export type EventOriginalRoomsFieldInput = {
  connect?: InputMaybe<Array<EventOriginalRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventOriginalRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventOriginalRoomsCreateFieldInput>>;
};

export type EventOriginalRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventOriginalRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventOriginalRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventOriginalRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventOriginalRoomsRelationship = {
  __typename?: 'EventOriginalRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type EventOriginalSubjectAggregateInput = {
  AND?: InputMaybe<Array<EventOriginalSubjectAggregateInput>>;
  NOT?: InputMaybe<EventOriginalSubjectAggregateInput>;
  OR?: InputMaybe<Array<EventOriginalSubjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventOriginalSubjectNodeAggregationWhereInput>;
};

export type EventOriginalSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type EventOriginalSubjectConnectOrCreateFieldInput = {
  onCreate: EventOriginalSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type EventOriginalSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type EventOriginalSubjectConnection = {
  __typename?: 'EventOriginalSubjectConnection';
  edges: Array<EventOriginalSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventOriginalSubjectConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type EventOriginalSubjectConnectionWhere = {
  AND?: InputMaybe<Array<EventOriginalSubjectConnectionWhere>>;
  NOT?: InputMaybe<EventOriginalSubjectConnectionWhere>;
  OR?: InputMaybe<Array<EventOriginalSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type EventOriginalSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type EventOriginalSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<EventOriginalSubjectConnectionWhere>;
};

export type EventOriginalSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<EventOriginalSubjectConnectionWhere>;
};

export type EventOriginalSubjectFieldInput = {
  connect?: InputMaybe<EventOriginalSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventOriginalSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<EventOriginalSubjectCreateFieldInput>;
};

export type EventOriginalSubjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventOriginalSubjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventOriginalSubjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventOriginalSubjectNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventOriginalSubjectRelationship = {
  __typename?: 'EventOriginalSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type EventPersonPersonsAggregationSelection = {
  __typename?: 'EventPersonPersonsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<EventPersonPersonsEdgeAggregateSelection>;
  node?: Maybe<EventPersonPersonsNodeAggregateSelection>;
};

export type EventPersonPersonsEdgeAggregateSelection = {
  __typename?: 'EventPersonPersonsEdgeAggregateSelection';
  givenSubstituteHours: FloatAggregateSelection;
};

export type EventPersonPersonsNodeAggregateSelection = {
  __typename?: 'EventPersonPersonsNodeAggregateSelection';
  callingName: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  displayNameShort: StringAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  gender: StringAggregateSelection;
  lastName: StringAggregateSelection;
  personalId: StringAggregateSelection;
  pimProfileUuid: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  title: StringAggregateSelection;
  uniqueFirstName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type EventPersonRelationInput = {
  givenSubstituteHours?: InputMaybe<Scalars['Float']['input']>;
  isCoveringTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

/**
 * The edge properties for the following fields:
 * * Event.persons
 */
export type EventPersonRelationProperties = {
  __typename?: 'EventPersonRelationProperties';
  /** falls dieser Lehrer für die Vertretung Anrechnungsstunden erhält steht hier die Anzahl der Stunden drin (kann auch Anteilig sein, deshalb float) */
  givenSubstituteHours?: Maybe<Scalars['Float']['output']>;
  /** hier halten wir fest falls es sich bei diesem Lehrer um einen Vertretungslehrer handelt */
  isCoveringTeacher: Scalars['Boolean']['output'];
};

export type EventPersonRelationPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<EventPersonRelationPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<EventPersonRelationPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<EventPersonRelationPropertiesAggregationWhereInput>>;
  givenSubstituteHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type EventPersonRelationPropertiesCreateInput = {
  givenSubstituteHours?: InputMaybe<Scalars['Float']['input']>;
  isCoveringTeacher: Scalars['Boolean']['input'];
};

export type EventPersonRelationPropertiesSort = {
  givenSubstituteHours?: InputMaybe<SortDirection>;
  isCoveringTeacher?: InputMaybe<SortDirection>;
};

export type EventPersonRelationPropertiesUpdateInput = {
  givenSubstituteHours?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_ADD?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  isCoveringTeacher?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventPersonRelationPropertiesWhere = {
  AND?: InputMaybe<Array<EventPersonRelationPropertiesWhere>>;
  NOT?: InputMaybe<EventPersonRelationPropertiesWhere>;
  OR?: InputMaybe<Array<EventPersonRelationPropertiesWhere>>;
  givenSubstituteHours?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_GT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_GTE?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  givenSubstituteHours_LT?: InputMaybe<Scalars['Float']['input']>;
  givenSubstituteHours_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenSubstituteHours_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  givenSubstituteHours_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  isCoveringTeacher?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isCoveringTeacher_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventPersonsAggregateInput = {
  AND?: InputMaybe<Array<EventPersonsAggregateInput>>;
  NOT?: InputMaybe<EventPersonsAggregateInput>;
  OR?: InputMaybe<Array<EventPersonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EventPersonRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<EventPersonsNodeAggregationWhereInput>;
};

export type EventPersonsConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  edge: EventPersonRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type EventPersonsConnectOrCreateFieldInput = {
  onCreate: EventPersonsConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type EventPersonsConnectOrCreateFieldInputOnCreate = {
  edge: EventPersonRelationPropertiesCreateInput;
  node: PersonOnCreateInput;
};

export type EventPersonsConnection = {
  __typename?: 'EventPersonsConnection';
  edges: Array<EventPersonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventPersonsConnectionSort = {
  edge?: InputMaybe<EventPersonRelationPropertiesSort>;
  node?: InputMaybe<PersonSort>;
};

export type EventPersonsConnectionWhere = {
  AND?: InputMaybe<Array<EventPersonsConnectionWhere>>;
  NOT?: InputMaybe<EventPersonsConnectionWhere>;
  OR?: InputMaybe<Array<EventPersonsConnectionWhere>>;
  edge?: InputMaybe<EventPersonRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<EventPersonRelationPropertiesWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type EventPersonsCreateFieldInput = {
  edge: EventPersonRelationPropertiesCreateInput;
  node: PersonCreateInput;
};

export type EventPersonsDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<EventPersonsConnectionWhere>;
};

export type EventPersonsDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<EventPersonsConnectionWhere>;
};

export type EventPersonsFieldInput = {
  connect?: InputMaybe<Array<EventPersonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventPersonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventPersonsCreateFieldInput>>;
};

export type EventPersonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventPersonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventPersonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventPersonsNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventPersonsRelationship = {
  __typename?: 'EventPersonsRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: EventPersonRelationProperties;
};

export type EventPersonsUpdateConnectionInput = {
  edge?: InputMaybe<EventPersonRelationPropertiesUpdateInput>;
  node?: InputMaybe<PersonUpdateInput>;
};

export type EventPersonsUpdateFieldInput = {
  connect?: InputMaybe<Array<EventPersonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventPersonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventPersonsCreateFieldInput>>;
  delete?: InputMaybe<Array<EventPersonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<EventPersonsDisconnectFieldInput>>;
  update?: InputMaybe<EventPersonsUpdateConnectionInput>;
  where?: InputMaybe<EventPersonsConnectionWhere>;
};

export type EventPublishedSubstitutionAggregateInput = {
  AND?: InputMaybe<Array<EventPublishedSubstitutionAggregateInput>>;
  NOT?: InputMaybe<EventPublishedSubstitutionAggregateInput>;
  OR?: InputMaybe<Array<EventPublishedSubstitutionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventPublishedSubstitutionNodeAggregationWhereInput>;
};

export type EventPublishedSubstitutionConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PublishedSubstitutionsConnectWhere>;
};

export type EventPublishedSubstitutionConnectOrCreateFieldInput = {
  onCreate: EventPublishedSubstitutionConnectOrCreateFieldInputOnCreate;
  where: PublishedSubstitutionsConnectOrCreateWhere;
};

export type EventPublishedSubstitutionConnectOrCreateFieldInputOnCreate = {
  node: PublishedSubstitutionsOnCreateInput;
};

export type EventPublishedSubstitutionConnection = {
  __typename?: 'EventPublishedSubstitutionConnection';
  edges: Array<EventPublishedSubstitutionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventPublishedSubstitutionConnectionSort = {
  node?: InputMaybe<PublishedSubstitutionsSort>;
};

export type EventPublishedSubstitutionConnectionWhere = {
  AND?: InputMaybe<Array<EventPublishedSubstitutionConnectionWhere>>;
  NOT?: InputMaybe<EventPublishedSubstitutionConnectionWhere>;
  OR?: InputMaybe<Array<EventPublishedSubstitutionConnectionWhere>>;
  node?: InputMaybe<PublishedSubstitutionsWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PublishedSubstitutionsWhere>;
};

export type EventPublishedSubstitutionCreateFieldInput = {
  node: PublishedSubstitutionsCreateInput;
};

export type EventPublishedSubstitutionDeleteFieldInput = {
  where?: InputMaybe<EventPublishedSubstitutionConnectionWhere>;
};

export type EventPublishedSubstitutionDisconnectFieldInput = {
  where?: InputMaybe<EventPublishedSubstitutionConnectionWhere>;
};

export type EventPublishedSubstitutionFieldInput = {
  connect?: InputMaybe<EventPublishedSubstitutionConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventPublishedSubstitutionConnectOrCreateFieldInput>;
  create?: InputMaybe<EventPublishedSubstitutionCreateFieldInput>;
};

export type EventPublishedSubstitutionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventPublishedSubstitutionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventPublishedSubstitutionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventPublishedSubstitutionNodeAggregationWhereInput>>;
  classes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastPublished_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  notifications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notifications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notifications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notifications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notifications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notifications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notifications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notifications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notifications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notifications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notifications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notifications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notifications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notifications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notifications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachers_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachers_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  teachers_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachers_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  teachers_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachers_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachers_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachers_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachers_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachers_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachers_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachers_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachers_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachers_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachers_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EventPublishedSubstitutionRelationship = {
  __typename?: 'EventPublishedSubstitutionRelationship';
  cursor: Scalars['String']['output'];
  node: PublishedSubstitutions;
};

export type EventPublishedSubstitutionUpdateConnectionInput = {
  node?: InputMaybe<PublishedSubstitutionsUpdateInput>;
};

export type EventPublishedSubstitutionUpdateFieldInput = {
  connect?: InputMaybe<EventPublishedSubstitutionConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventPublishedSubstitutionConnectOrCreateFieldInput>;
  create?: InputMaybe<EventPublishedSubstitutionCreateFieldInput>;
  delete?: InputMaybe<EventPublishedSubstitutionDeleteFieldInput>;
  disconnect?: InputMaybe<EventPublishedSubstitutionDisconnectFieldInput>;
  update?: InputMaybe<EventPublishedSubstitutionUpdateConnectionInput>;
  where?: InputMaybe<EventPublishedSubstitutionConnectionWhere>;
};

export type EventRecurringEventAggregateInput = {
  AND?: InputMaybe<Array<EventRecurringEventAggregateInput>>;
  NOT?: InputMaybe<EventRecurringEventAggregateInput>;
  OR?: InputMaybe<Array<EventRecurringEventAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventRecurringEventNodeAggregationWhereInput>;
};

export type EventRecurringEventConnectFieldInput = {
  connect?: InputMaybe<RecurringEventConnectInput>;
  edge: RecurringEventRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RecurringEventConnectWhere>;
};

export type EventRecurringEventConnection = {
  __typename?: 'EventRecurringEventConnection';
  edges: Array<EventRecurringEventRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventRecurringEventConnectionSort = {
  edge?: InputMaybe<RecurringEventRelationPropertiesSort>;
  node?: InputMaybe<RecurringEventSort>;
};

export type EventRecurringEventConnectionWhere = {
  AND?: InputMaybe<Array<EventRecurringEventConnectionWhere>>;
  NOT?: InputMaybe<EventRecurringEventConnectionWhere>;
  OR?: InputMaybe<Array<EventRecurringEventConnectionWhere>>;
  edge?: InputMaybe<RecurringEventRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RecurringEventRelationPropertiesWhere>;
  node?: InputMaybe<RecurringEventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RecurringEventWhere>;
};

export type EventRecurringEventCreateFieldInput = {
  edge: RecurringEventRelationPropertiesCreateInput;
  node: RecurringEventCreateInput;
};

export type EventRecurringEventDeleteFieldInput = {
  delete?: InputMaybe<RecurringEventDeleteInput>;
  where?: InputMaybe<EventRecurringEventConnectionWhere>;
};

export type EventRecurringEventDisconnectFieldInput = {
  disconnect?: InputMaybe<RecurringEventDisconnectInput>;
  where?: InputMaybe<EventRecurringEventConnectionWhere>;
};

export type EventRecurringEventFieldInput = {
  connect?: InputMaybe<EventRecurringEventConnectFieldInput>;
  create?: InputMaybe<EventRecurringEventCreateFieldInput>;
};

export type EventRecurringEventNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventRecurringEventNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventRecurringEventNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventRecurringEventNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  rrule_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rrule_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rrule_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rrule_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rrule_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rrule_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rrule_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rrule_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rrule_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rrule_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rrule_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rrule_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rrule_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rrule_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rrule_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventRecurringEventRelationship = {
  __typename?: 'EventRecurringEventRelationship';
  cursor: Scalars['String']['output'];
  node: RecurringEvent;
  properties: RecurringEventRelationProperties;
};

export type EventRecurringEventUpdateConnectionInput = {
  edge?: InputMaybe<RecurringEventRelationPropertiesUpdateInput>;
  node?: InputMaybe<RecurringEventUpdateInput>;
};

export type EventRecurringEventUpdateFieldInput = {
  connect?: InputMaybe<EventRecurringEventConnectFieldInput>;
  create?: InputMaybe<EventRecurringEventCreateFieldInput>;
  delete?: InputMaybe<EventRecurringEventDeleteFieldInput>;
  disconnect?: InputMaybe<EventRecurringEventDisconnectFieldInput>;
  update?: InputMaybe<EventRecurringEventUpdateConnectionInput>;
  where?: InputMaybe<EventRecurringEventConnectionWhere>;
};

export type EventRoomOriginalRoomsAggregationSelection = {
  __typename?: 'EventRoomOriginalRoomsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EventRoomOriginalRoomsNodeAggregateSelection>;
};

export type EventRoomOriginalRoomsNodeAggregateSelection = {
  __typename?: 'EventRoomOriginalRoomsNodeAggregateSelection';
  capacity: IntAggregateSelection;
  chairs: IntAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  otherInventory: StringAggregateSelection;
  position: StringAggregateSelection;
  roomNumber: StringAggregateSelection;
  size: IntAggregateSelection;
  tables: IntAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type EventRoomRoomsAggregationSelection = {
  __typename?: 'EventRoomRoomsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EventRoomRoomsNodeAggregateSelection>;
};

export type EventRoomRoomsNodeAggregateSelection = {
  __typename?: 'EventRoomRoomsNodeAggregateSelection';
  capacity: IntAggregateSelection;
  chairs: IntAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  otherInventory: StringAggregateSelection;
  position: StringAggregateSelection;
  roomNumber: StringAggregateSelection;
  size: IntAggregateSelection;
  tables: IntAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type EventRoomsAggregateInput = {
  AND?: InputMaybe<Array<EventRoomsAggregateInput>>;
  NOT?: InputMaybe<EventRoomsAggregateInput>;
  OR?: InputMaybe<Array<EventRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventRoomsNodeAggregationWhereInput>;
};

export type EventRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type EventRoomsConnectOrCreateFieldInput = {
  onCreate: EventRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type EventRoomsConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type EventRoomsConnection = {
  __typename?: 'EventRoomsConnection';
  edges: Array<EventRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventRoomsConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type EventRoomsConnectionWhere = {
  AND?: InputMaybe<Array<EventRoomsConnectionWhere>>;
  NOT?: InputMaybe<EventRoomsConnectionWhere>;
  OR?: InputMaybe<Array<EventRoomsConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type EventRoomsCreateFieldInput = {
  node: RoomCreateInput;
};

export type EventRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<EventRoomsConnectionWhere>;
};

export type EventRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<EventRoomsConnectionWhere>;
};

export type EventRoomsFieldInput = {
  connect?: InputMaybe<Array<EventRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventRoomsCreateFieldInput>>;
};

export type EventRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventRoomsRelationship = {
  __typename?: 'EventRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type EventRoomsUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type EventRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<EventRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<EventRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<EventRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<EventRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<EventRoomsDisconnectFieldInput>>;
  update?: InputMaybe<EventRoomsUpdateConnectionInput>;
  where?: InputMaybe<EventRoomsConnectionWhere>;
};

/** Fields to sort Events by. The order in which sorts are applied is not guaranteed when specifying many fields in one EventSort object. */
export type EventSort = {
  canceled?: InputMaybe<SortDirection>;
  comment?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  currentState?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  isClassTrip?: InputMaybe<SortDirection>;
  isClassbookRelevant?: InputMaybe<SortDirection>;
  isSchoolEvent?: InputMaybe<SortDirection>;
  originalEnd?: InputMaybe<SortDirection>;
  originalStart?: InputMaybe<SortDirection>;
  print?: InputMaybe<SortDirection>;
  printUpdatedByUser?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  substitutionComment?: InputMaybe<SortDirection>;
  substitutionReasons?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type EventSourceLessonAggregateInput = {
  AND?: InputMaybe<Array<EventSourceLessonAggregateInput>>;
  NOT?: InputMaybe<EventSourceLessonAggregateInput>;
  OR?: InputMaybe<Array<EventSourceLessonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventSourceLessonNodeAggregationWhereInput>;
};

export type EventSourceLessonConnectFieldInput = {
  connect?: InputMaybe<LessonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type EventSourceLessonConnectOrCreateFieldInput = {
  onCreate: EventSourceLessonConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type EventSourceLessonConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type EventSourceLessonConnection = {
  __typename?: 'EventSourceLessonConnection';
  edges: Array<EventSourceLessonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventSourceLessonConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type EventSourceLessonConnectionWhere = {
  AND?: InputMaybe<Array<EventSourceLessonConnectionWhere>>;
  NOT?: InputMaybe<EventSourceLessonConnectionWhere>;
  OR?: InputMaybe<Array<EventSourceLessonConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type EventSourceLessonCreateFieldInput = {
  node: LessonCreateInput;
};

export type EventSourceLessonDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<EventSourceLessonConnectionWhere>;
};

export type EventSourceLessonDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<EventSourceLessonConnectionWhere>;
};

export type EventSourceLessonFieldInput = {
  connect?: InputMaybe<EventSourceLessonConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventSourceLessonConnectOrCreateFieldInput>;
  create?: InputMaybe<EventSourceLessonCreateFieldInput>;
};

export type EventSourceLessonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventSourceLessonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventSourceLessonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventSourceLessonNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventSourceLessonRelationship = {
  __typename?: 'EventSourceLessonRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type EventSourceTeachingBlockCardAggregateInput = {
  AND?: InputMaybe<Array<EventSourceTeachingBlockCardAggregateInput>>;
  NOT?: InputMaybe<EventSourceTeachingBlockCardAggregateInput>;
  OR?: InputMaybe<Array<EventSourceTeachingBlockCardAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventSourceTeachingBlockCardNodeAggregationWhereInput>;
};

export type EventSourceTeachingBlockCardConnectFieldInput = {
  connect?: InputMaybe<TeachingBlockCardConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockCardConnectWhere>;
};

export type EventSourceTeachingBlockCardConnectOrCreateFieldInput = {
  onCreate: EventSourceTeachingBlockCardConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockCardConnectOrCreateWhere;
};

export type EventSourceTeachingBlockCardConnectOrCreateFieldInputOnCreate = {
  node: TeachingBlockCardOnCreateInput;
};

export type EventSourceTeachingBlockCardConnection = {
  __typename?: 'EventSourceTeachingBlockCardConnection';
  edges: Array<EventSourceTeachingBlockCardRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventSourceTeachingBlockCardConnectionSort = {
  node?: InputMaybe<TeachingBlockCardSort>;
};

export type EventSourceTeachingBlockCardConnectionWhere = {
  AND?: InputMaybe<Array<EventSourceTeachingBlockCardConnectionWhere>>;
  NOT?: InputMaybe<EventSourceTeachingBlockCardConnectionWhere>;
  OR?: InputMaybe<Array<EventSourceTeachingBlockCardConnectionWhere>>;
  node?: InputMaybe<TeachingBlockCardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockCardWhere>;
};

export type EventSourceTeachingBlockCardCreateFieldInput = {
  node: TeachingBlockCardCreateInput;
};

export type EventSourceTeachingBlockCardDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockCardDeleteInput>;
  where?: InputMaybe<EventSourceTeachingBlockCardConnectionWhere>;
};

export type EventSourceTeachingBlockCardDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockCardDisconnectInput>;
  where?: InputMaybe<EventSourceTeachingBlockCardConnectionWhere>;
};

export type EventSourceTeachingBlockCardFieldInput = {
  connect?: InputMaybe<EventSourceTeachingBlockCardConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventSourceTeachingBlockCardConnectOrCreateFieldInput>;
  create?: InputMaybe<EventSourceTeachingBlockCardCreateFieldInput>;
};

export type EventSourceTeachingBlockCardNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventSourceTeachingBlockCardNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventSourceTeachingBlockCardNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventSourceTeachingBlockCardNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EventSourceTeachingBlockCardRelationship = {
  __typename?: 'EventSourceTeachingBlockCardRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockCard;
};

export type EventSourceTimeGridEntryAggregateInput = {
  AND?: InputMaybe<Array<EventSourceTimeGridEntryAggregateInput>>;
  NOT?: InputMaybe<EventSourceTimeGridEntryAggregateInput>;
  OR?: InputMaybe<Array<EventSourceTimeGridEntryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventSourceTimeGridEntryNodeAggregationWhereInput>;
};

export type EventSourceTimeGridEntryConnectFieldInput = {
  connect?: InputMaybe<TimeGridEntryConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimeGridEntryConnectWhere>;
};

export type EventSourceTimeGridEntryConnectOrCreateFieldInput = {
  onCreate: EventSourceTimeGridEntryConnectOrCreateFieldInputOnCreate;
  where: TimeGridEntryConnectOrCreateWhere;
};

export type EventSourceTimeGridEntryConnectOrCreateFieldInputOnCreate = {
  node: TimeGridEntryOnCreateInput;
};

export type EventSourceTimeGridEntryConnection = {
  __typename?: 'EventSourceTimeGridEntryConnection';
  edges: Array<EventSourceTimeGridEntryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventSourceTimeGridEntryConnectionSort = {
  node?: InputMaybe<TimeGridEntrySort>;
};

export type EventSourceTimeGridEntryConnectionWhere = {
  AND?: InputMaybe<Array<EventSourceTimeGridEntryConnectionWhere>>;
  NOT?: InputMaybe<EventSourceTimeGridEntryConnectionWhere>;
  OR?: InputMaybe<Array<EventSourceTimeGridEntryConnectionWhere>>;
  node?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimeGridEntryWhere>;
};

export type EventSourceTimeGridEntryCreateFieldInput = {
  node: TimeGridEntryCreateInput;
};

export type EventSourceTimeGridEntryDeleteFieldInput = {
  delete?: InputMaybe<TimeGridEntryDeleteInput>;
  where?: InputMaybe<EventSourceTimeGridEntryConnectionWhere>;
};

export type EventSourceTimeGridEntryDisconnectFieldInput = {
  disconnect?: InputMaybe<TimeGridEntryDisconnectInput>;
  where?: InputMaybe<EventSourceTimeGridEntryConnectionWhere>;
};

export type EventSourceTimeGridEntryFieldInput = {
  connect?: InputMaybe<EventSourceTimeGridEntryConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventSourceTimeGridEntryConnectOrCreateFieldInput>;
  create?: InputMaybe<EventSourceTimeGridEntryCreateFieldInput>;
};

export type EventSourceTimeGridEntryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventSourceTimeGridEntryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventSourceTimeGridEntryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventSourceTimeGridEntryNodeAggregationWhereInput>>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventSourceTimeGridEntryRelationship = {
  __typename?: 'EventSourceTimeGridEntryRelationship';
  cursor: Scalars['String']['output'];
  node: TimeGridEntry;
};

export type EventSourceTimetableCardAggregateInput = {
  AND?: InputMaybe<Array<EventSourceTimetableCardAggregateInput>>;
  NOT?: InputMaybe<EventSourceTimetableCardAggregateInput>;
  OR?: InputMaybe<Array<EventSourceTimetableCardAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EventTimetableCardPropertiesAggregationWhereInput>;
  node?: InputMaybe<EventSourceTimetableCardNodeAggregationWhereInput>;
};

export type EventSourceTimetableCardConnectFieldInput = {
  connect?: InputMaybe<TimetableCardConnectInput>;
  edge: EventTimetableCardPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableCardConnectWhere>;
};

export type EventSourceTimetableCardConnectOrCreateFieldInput = {
  onCreate: EventSourceTimetableCardConnectOrCreateFieldInputOnCreate;
  where: TimetableCardConnectOrCreateWhere;
};

export type EventSourceTimetableCardConnectOrCreateFieldInputOnCreate = {
  edge: EventTimetableCardPropertiesCreateInput;
  node: TimetableCardOnCreateInput;
};

export type EventSourceTimetableCardConnection = {
  __typename?: 'EventSourceTimetableCardConnection';
  edges: Array<EventSourceTimetableCardRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventSourceTimetableCardConnectionSort = {
  edge?: InputMaybe<EventTimetableCardPropertiesSort>;
  node?: InputMaybe<TimetableCardSort>;
};

export type EventSourceTimetableCardConnectionWhere = {
  AND?: InputMaybe<Array<EventSourceTimetableCardConnectionWhere>>;
  NOT?: InputMaybe<EventSourceTimetableCardConnectionWhere>;
  OR?: InputMaybe<Array<EventSourceTimetableCardConnectionWhere>>;
  edge?: InputMaybe<EventTimetableCardPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<EventTimetableCardPropertiesWhere>;
  node?: InputMaybe<TimetableCardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableCardWhere>;
};

export type EventSourceTimetableCardCreateFieldInput = {
  edge: EventTimetableCardPropertiesCreateInput;
  node: TimetableCardCreateInput;
};

export type EventSourceTimetableCardDeleteFieldInput = {
  delete?: InputMaybe<TimetableCardDeleteInput>;
  where?: InputMaybe<EventSourceTimetableCardConnectionWhere>;
};

export type EventSourceTimetableCardDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableCardDisconnectInput>;
  where?: InputMaybe<EventSourceTimetableCardConnectionWhere>;
};

export type EventSourceTimetableCardFieldInput = {
  connect?: InputMaybe<EventSourceTimetableCardConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventSourceTimetableCardConnectOrCreateFieldInput>;
  create?: InputMaybe<EventSourceTimetableCardCreateFieldInput>;
};

export type EventSourceTimetableCardNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventSourceTimetableCardNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventSourceTimetableCardNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventSourceTimetableCardNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  weekday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EventSourceTimetableCardRelationship = {
  __typename?: 'EventSourceTimetableCardRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableCard;
  properties: EventTimetableCardProperties;
};

export enum EventState {
  ClassConflict = 'CLASS_CONFLICT',
  ClassNotAvailable = 'CLASS_NOT_AVAILABLE',
  ClassOnSchoolTrip = 'CLASS_ON_SCHOOL_TRIP',
  EventCancelled = 'EVENT_CANCELLED',
  GroupConflict = 'GROUP_CONFLICT',
  GroupNotAvailable = 'GROUP_NOT_AVAILABLE',
  GroupOnSchoolTrip = 'GROUP_ON_SCHOOL_TRIP',
  NeverSubstituted = 'NEVER_SUBSTITUTED',
  PersonConflict = 'PERSON_CONFLICT',
  PersonMissing = 'PERSON_MISSING',
  PersonNotAvailable = 'PERSON_NOT_AVAILABLE',
  PersonOnSchoolTrip = 'PERSON_ON_SCHOOL_TRIP',
  RoomConflict = 'ROOM_CONFLICT',
  RoomNotAvailable = 'ROOM_NOT_AVAILABLE',
}

export type EventStateType = {
  __typename?: 'EventStateType';
  affectedEntityType?: Maybe<AffectedEntityType>;
  /** Gibt bei Konflikten oder nicht Verfügbarkleit die UUID des betroffenen Objekts an (Person, Room, Class, Group). Bei Fehlenden Lehrern ist es die UUID des betroffenen Lehrers */
  affectedEntityUuid?: Maybe<Scalars['String']['output']>;
  conflictedEntityType?: Maybe<AffectedEntityType>;
  /** Gibt bei Konflikten die UUID des Events an, mit dem es zu einem Konflikt kommt */
  conflictedEventUuid?: Maybe<Scalars['String']['output']>;
  /** Gibt an ob z.B PERSON_ON_SCHOOL_TRIP für den ganzen Tag gilt */
  fullDay?: Maybe<Scalars['Boolean']['output']>;
  state: EventState;
};

export type EventStateTypeEdge = {
  __typename?: 'EventStateTypeEdge';
  cursor: Scalars['String']['output'];
  node: EventStateType;
};

export type EventStateTypeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EventStateTypeSort objects to sort EventStateTypes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EventStateTypeSort>>;
};

/** Fields to sort EventStateTypes by. The order in which sorts are applied is not guaranteed when specifying many fields in one EventStateTypeSort object. */
export type EventStateTypeSort = {
  affectedEntityType?: InputMaybe<SortDirection>;
  affectedEntityUuid?: InputMaybe<SortDirection>;
  conflictedEntityType?: InputMaybe<SortDirection>;
  conflictedEventUuid?: InputMaybe<SortDirection>;
  fullDay?: InputMaybe<SortDirection>;
  state?: InputMaybe<SortDirection>;
};

export type EventStateTypeWhere = {
  AND?: InputMaybe<Array<EventStateTypeWhere>>;
  NOT?: InputMaybe<EventStateTypeWhere>;
  OR?: InputMaybe<Array<EventStateTypeWhere>>;
  affectedEntityType?: InputMaybe<AffectedEntityType>;
  affectedEntityType_IN?: InputMaybe<Array<InputMaybe<AffectedEntityType>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  affectedEntityType_NOT?: InputMaybe<AffectedEntityType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  affectedEntityType_NOT_IN?: InputMaybe<Array<InputMaybe<AffectedEntityType>>>;
  affectedEntityUuid?: InputMaybe<Scalars['String']['input']>;
  affectedEntityUuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  affectedEntityUuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  affectedEntityUuid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  affectedEntityUuid_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  affectedEntityUuid_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  affectedEntityUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  affectedEntityUuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  affectedEntityUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  affectedEntityUuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  conflictedEntityType?: InputMaybe<AffectedEntityType>;
  conflictedEntityType_IN?: InputMaybe<Array<InputMaybe<AffectedEntityType>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conflictedEntityType_NOT?: InputMaybe<AffectedEntityType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conflictedEntityType_NOT_IN?: InputMaybe<Array<InputMaybe<AffectedEntityType>>>;
  conflictedEventUuid?: InputMaybe<Scalars['String']['input']>;
  conflictedEventUuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  conflictedEventUuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  conflictedEventUuid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conflictedEventUuid_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conflictedEventUuid_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conflictedEventUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conflictedEventUuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  conflictedEventUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  conflictedEventUuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fullDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullDay_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<EventState>;
  state_IN?: InputMaybe<Array<EventState>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  state_NOT?: InputMaybe<EventState>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  state_NOT_IN?: InputMaybe<Array<EventState>>;
};

export type EventStateTypesConnection = {
  __typename?: 'EventStateTypesConnection';
  edges: Array<EventStateTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventSubjectAggregateInput = {
  AND?: InputMaybe<Array<EventSubjectAggregateInput>>;
  NOT?: InputMaybe<EventSubjectAggregateInput>;
  OR?: InputMaybe<Array<EventSubjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EventSubjectNodeAggregationWhereInput>;
};

export type EventSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type EventSubjectConnectOrCreateFieldInput = {
  onCreate: EventSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type EventSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type EventSubjectConnection = {
  __typename?: 'EventSubjectConnection';
  edges: Array<EventSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventSubjectConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type EventSubjectConnectionWhere = {
  AND?: InputMaybe<Array<EventSubjectConnectionWhere>>;
  NOT?: InputMaybe<EventSubjectConnectionWhere>;
  OR?: InputMaybe<Array<EventSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type EventSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type EventSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<EventSubjectConnectionWhere>;
};

export type EventSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<EventSubjectConnectionWhere>;
};

export type EventSubjectFieldInput = {
  connect?: InputMaybe<EventSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<EventSubjectCreateFieldInput>;
};

export type EventSubjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EventSubjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EventSubjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EventSubjectNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventSubjectRelationship = {
  __typename?: 'EventSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type EventSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type EventSubjectUpdateFieldInput = {
  connect?: InputMaybe<EventSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<EventSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<EventSubjectCreateFieldInput>;
  delete?: InputMaybe<EventSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<EventSubjectDisconnectFieldInput>;
  update?: InputMaybe<EventSubjectUpdateConnectionInput>;
  where?: InputMaybe<EventSubjectConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * Event.sourceTimetableCard
 */
export type EventTimetableCardProperties = {
  __typename?: 'EventTimetableCardProperties';
  /**
   * Wir teilen mehrfachstunden in einzelstunden auf. Damit wir diese beim update abgleichen können, speichern wir hier zusätzlich die order.
   * Diese wird dann für den abgleich hinten an die uuid gehängt
   */
  order: Scalars['Int']['output'];
};

export type EventTimetableCardPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<EventTimetableCardPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<EventTimetableCardPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<EventTimetableCardPropertiesAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EventTimetableCardPropertiesCreateInput = {
  order: Scalars['Int']['input'];
};

export type EventTimetableCardPropertiesSort = {
  order?: InputMaybe<SortDirection>;
};

export type EventTimetableCardPropertiesWhere = {
  AND?: InputMaybe<Array<EventTimetableCardPropertiesWhere>>;
  NOT?: InputMaybe<EventTimetableCardPropertiesWhere>;
  OR?: InputMaybe<Array<EventTimetableCardPropertiesWhere>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EventUpdateInput = {
  aggregatedEvents?: InputMaybe<Array<EventAggregatedEventsUpdateFieldInput>>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  classesOrGroups?: InputMaybe<EventClassesOrGroupsUpdateInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currentState?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  isAggregated?: InputMaybe<EventIsAggregatedUpdateFieldInput>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  isClassbookRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolEvent?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<EventOrganizationUpdateFieldInput>;
  persons?: InputMaybe<Array<EventPersonsUpdateFieldInput>>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  printUpdatedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  publishedSubstitution?: InputMaybe<EventPublishedSubstitutionUpdateFieldInput>;
  recurringEvent?: InputMaybe<EventRecurringEventUpdateFieldInput>;
  rooms?: InputMaybe<Array<EventRoomsUpdateFieldInput>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<EventSubjectUpdateFieldInput>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  substitutionReasons?: InputMaybe<SubstitutionReason>;
};

export type EventWhere = {
  AND?: InputMaybe<Array<EventWhere>>;
  NOT?: InputMaybe<EventWhere>;
  OR?: InputMaybe<Array<EventWhere>>;
  /** @deprecated Use `aggregatedEvents_SOME` instead. */
  aggregatedEvents?: InputMaybe<EventWhere>;
  aggregatedEventsAggregate?: InputMaybe<EventAggregatedEventsAggregateInput>;
  /** @deprecated Use `aggregatedEventsConnection_SOME` instead. */
  aggregatedEventsConnection?: InputMaybe<EventAggregatedEventsConnectionWhere>;
  /** Return Events where all of the related EventAggregatedEventsConnections match this filter */
  aggregatedEventsConnection_ALL?: InputMaybe<EventAggregatedEventsConnectionWhere>;
  /** Return Events where none of the related EventAggregatedEventsConnections match this filter */
  aggregatedEventsConnection_NONE?: InputMaybe<EventAggregatedEventsConnectionWhere>;
  /** @deprecated Use `aggregatedEventsConnection_NONE` instead. */
  aggregatedEventsConnection_NOT?: InputMaybe<EventAggregatedEventsConnectionWhere>;
  /** Return Events where one of the related EventAggregatedEventsConnections match this filter */
  aggregatedEventsConnection_SINGLE?: InputMaybe<EventAggregatedEventsConnectionWhere>;
  /** Return Events where some of the related EventAggregatedEventsConnections match this filter */
  aggregatedEventsConnection_SOME?: InputMaybe<EventAggregatedEventsConnectionWhere>;
  /** Return Events where all of the related Events match this filter */
  aggregatedEvents_ALL?: InputMaybe<EventWhere>;
  /** Return Events where none of the related Events match this filter */
  aggregatedEvents_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `aggregatedEvents_NONE` instead. */
  aggregatedEvents_NOT?: InputMaybe<EventWhere>;
  /** Return Events where one of the related Events match this filter */
  aggregatedEvents_SINGLE?: InputMaybe<EventWhere>;
  /** Return Events where some of the related Events match this filter */
  aggregatedEvents_SOME?: InputMaybe<EventWhere>;
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  canceled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `classesOrGroups_SOME` instead. */
  classesOrGroups?: InputMaybe<ClassOrGroupWhere>;
  /** @deprecated Use `classesOrGroupsConnection_SOME` instead. */
  classesOrGroupsConnection?: InputMaybe<EventClassesOrGroupsConnectionWhere>;
  /** Return Events where all of the related EventClassesOrGroupsConnections match this filter */
  classesOrGroupsConnection_ALL?: InputMaybe<EventClassesOrGroupsConnectionWhere>;
  /** Return Events where none of the related EventClassesOrGroupsConnections match this filter */
  classesOrGroupsConnection_NONE?: InputMaybe<EventClassesOrGroupsConnectionWhere>;
  /** @deprecated Use `classesOrGroupsConnection_NONE` instead. */
  classesOrGroupsConnection_NOT?: InputMaybe<EventClassesOrGroupsConnectionWhere>;
  /** Return Events where one of the related EventClassesOrGroupsConnections match this filter */
  classesOrGroupsConnection_SINGLE?: InputMaybe<EventClassesOrGroupsConnectionWhere>;
  /** Return Events where some of the related EventClassesOrGroupsConnections match this filter */
  classesOrGroupsConnection_SOME?: InputMaybe<EventClassesOrGroupsConnectionWhere>;
  /** Return Events where all of the related ClassOrGroups match this filter */
  classesOrGroups_ALL?: InputMaybe<ClassOrGroupWhere>;
  /** Return Events where none of the related ClassOrGroups match this filter */
  classesOrGroups_NONE?: InputMaybe<ClassOrGroupWhere>;
  /** @deprecated Use `classesOrGroups_NONE` instead. */
  classesOrGroups_NOT?: InputMaybe<ClassOrGroupWhere>;
  /** Return Events where one of the related ClassOrGroups match this filter */
  classesOrGroups_SINGLE?: InputMaybe<ClassOrGroupWhere>;
  /** Return Events where some of the related ClassOrGroups match this filter */
  classesOrGroups_SOME?: InputMaybe<ClassOrGroupWhere>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  currentState?: InputMaybe<Scalars['String']['input']>;
  currentState_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currentState_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentState_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentState_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentState_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentState_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentState_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  currentState_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentState_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  end_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  end_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  involvedClasses?: InputMaybe<ClassWhere>;
  involvedClasses_ALL?: InputMaybe<ClassWhere>;
  involvedClasses_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  involvedClasses_NOT?: InputMaybe<ClassWhere>;
  involvedClasses_SINGLE?: InputMaybe<ClassWhere>;
  involvedClasses_SOME?: InputMaybe<ClassWhere>;
  involvedOriginalClasses?: InputMaybe<ClassWhere>;
  involvedOriginalClasses_ALL?: InputMaybe<ClassWhere>;
  involvedOriginalClasses_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  involvedOriginalClasses_NOT?: InputMaybe<ClassWhere>;
  involvedOriginalClasses_SINGLE?: InputMaybe<ClassWhere>;
  involvedOriginalClasses_SOME?: InputMaybe<ClassWhere>;
  isAggregated?: InputMaybe<EventWhere>;
  isAggregatedAggregate?: InputMaybe<EventIsAggregatedAggregateInput>;
  isAggregatedConnection?: InputMaybe<EventIsAggregatedConnectionWhere>;
  isAggregatedConnection_NOT?: InputMaybe<EventIsAggregatedConnectionWhere>;
  isAggregated_NOT?: InputMaybe<EventWhere>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isClassTrip_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  isClassbookRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isClassbookRelevant_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isSchoolEvent_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  mergableEvents?: InputMaybe<EventWhere>;
  mergableEvents_ALL?: InputMaybe<EventWhere>;
  mergableEvents_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mergableEvents_NOT?: InputMaybe<EventWhere>;
  mergableEvents_SINGLE?: InputMaybe<EventWhere>;
  mergableEvents_SOME?: InputMaybe<EventWhere>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<EventOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<EventOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<EventOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `originalClassesOrGroups_SOME` instead. */
  originalClassesOrGroups?: InputMaybe<ClassOrGroupWhere>;
  /** @deprecated Use `originalClassesOrGroupsConnection_SOME` instead. */
  originalClassesOrGroupsConnection?: InputMaybe<EventOriginalClassesOrGroupsConnectionWhere>;
  /** Return Events where all of the related EventOriginalClassesOrGroupsConnections match this filter */
  originalClassesOrGroupsConnection_ALL?: InputMaybe<EventOriginalClassesOrGroupsConnectionWhere>;
  /** Return Events where none of the related EventOriginalClassesOrGroupsConnections match this filter */
  originalClassesOrGroupsConnection_NONE?: InputMaybe<EventOriginalClassesOrGroupsConnectionWhere>;
  /** @deprecated Use `originalClassesOrGroupsConnection_NONE` instead. */
  originalClassesOrGroupsConnection_NOT?: InputMaybe<EventOriginalClassesOrGroupsConnectionWhere>;
  /** Return Events where one of the related EventOriginalClassesOrGroupsConnections match this filter */
  originalClassesOrGroupsConnection_SINGLE?: InputMaybe<EventOriginalClassesOrGroupsConnectionWhere>;
  /** Return Events where some of the related EventOriginalClassesOrGroupsConnections match this filter */
  originalClassesOrGroupsConnection_SOME?: InputMaybe<EventOriginalClassesOrGroupsConnectionWhere>;
  /** Return Events where all of the related ClassOrGroups match this filter */
  originalClassesOrGroups_ALL?: InputMaybe<ClassOrGroupWhere>;
  /** Return Events where none of the related ClassOrGroups match this filter */
  originalClassesOrGroups_NONE?: InputMaybe<ClassOrGroupWhere>;
  /** @deprecated Use `originalClassesOrGroups_NONE` instead. */
  originalClassesOrGroups_NOT?: InputMaybe<ClassOrGroupWhere>;
  /** Return Events where one of the related ClassOrGroups match this filter */
  originalClassesOrGroups_SINGLE?: InputMaybe<ClassOrGroupWhere>;
  /** Return Events where some of the related ClassOrGroups match this filter */
  originalClassesOrGroups_SOME?: InputMaybe<ClassOrGroupWhere>;
  originalEnd?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  originalEnd_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  originalEnd_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  originalEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `originalPersons_SOME` instead. */
  originalPersons?: InputMaybe<PersonWhere>;
  originalPersonsAggregate?: InputMaybe<EventOriginalPersonsAggregateInput>;
  /** @deprecated Use `originalPersonsConnection_SOME` instead. */
  originalPersonsConnection?: InputMaybe<EventOriginalPersonsConnectionWhere>;
  /** Return Events where all of the related EventOriginalPersonsConnections match this filter */
  originalPersonsConnection_ALL?: InputMaybe<EventOriginalPersonsConnectionWhere>;
  /** Return Events where none of the related EventOriginalPersonsConnections match this filter */
  originalPersonsConnection_NONE?: InputMaybe<EventOriginalPersonsConnectionWhere>;
  /** @deprecated Use `originalPersonsConnection_NONE` instead. */
  originalPersonsConnection_NOT?: InputMaybe<EventOriginalPersonsConnectionWhere>;
  /** Return Events where one of the related EventOriginalPersonsConnections match this filter */
  originalPersonsConnection_SINGLE?: InputMaybe<EventOriginalPersonsConnectionWhere>;
  /** Return Events where some of the related EventOriginalPersonsConnections match this filter */
  originalPersonsConnection_SOME?: InputMaybe<EventOriginalPersonsConnectionWhere>;
  /** Return Events where all of the related People match this filter */
  originalPersons_ALL?: InputMaybe<PersonWhere>;
  /** Return Events where none of the related People match this filter */
  originalPersons_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `originalPersons_NONE` instead. */
  originalPersons_NOT?: InputMaybe<PersonWhere>;
  /** Return Events where one of the related People match this filter */
  originalPersons_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Events where some of the related People match this filter */
  originalPersons_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `originalRooms_SOME` instead. */
  originalRooms?: InputMaybe<RoomWhere>;
  originalRoomsAggregate?: InputMaybe<EventOriginalRoomsAggregateInput>;
  /** @deprecated Use `originalRoomsConnection_SOME` instead. */
  originalRoomsConnection?: InputMaybe<EventOriginalRoomsConnectionWhere>;
  /** Return Events where all of the related EventOriginalRoomsConnections match this filter */
  originalRoomsConnection_ALL?: InputMaybe<EventOriginalRoomsConnectionWhere>;
  /** Return Events where none of the related EventOriginalRoomsConnections match this filter */
  originalRoomsConnection_NONE?: InputMaybe<EventOriginalRoomsConnectionWhere>;
  /** @deprecated Use `originalRoomsConnection_NONE` instead. */
  originalRoomsConnection_NOT?: InputMaybe<EventOriginalRoomsConnectionWhere>;
  /** Return Events where one of the related EventOriginalRoomsConnections match this filter */
  originalRoomsConnection_SINGLE?: InputMaybe<EventOriginalRoomsConnectionWhere>;
  /** Return Events where some of the related EventOriginalRoomsConnections match this filter */
  originalRoomsConnection_SOME?: InputMaybe<EventOriginalRoomsConnectionWhere>;
  /** Return Events where all of the related Rooms match this filter */
  originalRooms_ALL?: InputMaybe<RoomWhere>;
  /** Return Events where none of the related Rooms match this filter */
  originalRooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `originalRooms_NONE` instead. */
  originalRooms_NOT?: InputMaybe<RoomWhere>;
  /** Return Events where one of the related Rooms match this filter */
  originalRooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return Events where some of the related Rooms match this filter */
  originalRooms_SOME?: InputMaybe<RoomWhere>;
  originalStart?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  originalStart_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  originalStart_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  originalStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  originalSubject?: InputMaybe<SubjectWhere>;
  originalSubjectAggregate?: InputMaybe<EventOriginalSubjectAggregateInput>;
  originalSubjectConnection?: InputMaybe<EventOriginalSubjectConnectionWhere>;
  originalSubjectConnection_NOT?: InputMaybe<EventOriginalSubjectConnectionWhere>;
  originalSubject_NOT?: InputMaybe<SubjectWhere>;
  overlappingEvents?: InputMaybe<EventWhere>;
  overlappingEvents_ALL?: InputMaybe<EventWhere>;
  overlappingEvents_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  overlappingEvents_NOT?: InputMaybe<EventWhere>;
  overlappingEvents_SINGLE?: InputMaybe<EventWhere>;
  overlappingEvents_SOME?: InputMaybe<EventWhere>;
  /** @deprecated Use `persons_SOME` instead. */
  persons?: InputMaybe<PersonWhere>;
  personsAggregate?: InputMaybe<EventPersonsAggregateInput>;
  /** @deprecated Use `personsConnection_SOME` instead. */
  personsConnection?: InputMaybe<EventPersonsConnectionWhere>;
  /** Return Events where all of the related EventPersonsConnections match this filter */
  personsConnection_ALL?: InputMaybe<EventPersonsConnectionWhere>;
  /** Return Events where none of the related EventPersonsConnections match this filter */
  personsConnection_NONE?: InputMaybe<EventPersonsConnectionWhere>;
  /** @deprecated Use `personsConnection_NONE` instead. */
  personsConnection_NOT?: InputMaybe<EventPersonsConnectionWhere>;
  /** Return Events where one of the related EventPersonsConnections match this filter */
  personsConnection_SINGLE?: InputMaybe<EventPersonsConnectionWhere>;
  /** Return Events where some of the related EventPersonsConnections match this filter */
  personsConnection_SOME?: InputMaybe<EventPersonsConnectionWhere>;
  /** Return Events where all of the related People match this filter */
  persons_ALL?: InputMaybe<PersonWhere>;
  /** Return Events where none of the related People match this filter */
  persons_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `persons_NONE` instead. */
  persons_NOT?: InputMaybe<PersonWhere>;
  /** Return Events where one of the related People match this filter */
  persons_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Events where some of the related People match this filter */
  persons_SOME?: InputMaybe<PersonWhere>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  printUpdatedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printUpdatedByUser_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  print_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  publishedSubstitution?: InputMaybe<PublishedSubstitutionsWhere>;
  publishedSubstitutionAggregate?: InputMaybe<EventPublishedSubstitutionAggregateInput>;
  publishedSubstitutionConnection?: InputMaybe<EventPublishedSubstitutionConnectionWhere>;
  publishedSubstitutionConnection_NOT?: InputMaybe<EventPublishedSubstitutionConnectionWhere>;
  publishedSubstitution_NOT?: InputMaybe<PublishedSubstitutionsWhere>;
  recurringEvent?: InputMaybe<RecurringEventWhere>;
  recurringEventAggregate?: InputMaybe<EventRecurringEventAggregateInput>;
  recurringEventConnection?: InputMaybe<EventRecurringEventConnectionWhere>;
  recurringEventConnection_NOT?: InputMaybe<EventRecurringEventConnectionWhere>;
  recurringEvent_NOT?: InputMaybe<RecurringEventWhere>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<EventRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<EventRoomsConnectionWhere>;
  /** Return Events where all of the related EventRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<EventRoomsConnectionWhere>;
  /** Return Events where none of the related EventRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<EventRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<EventRoomsConnectionWhere>;
  /** Return Events where one of the related EventRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<EventRoomsConnectionWhere>;
  /** Return Events where some of the related EventRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<EventRoomsConnectionWhere>;
  /** Return Events where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return Events where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return Events where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return Events where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  sourceLesson?: InputMaybe<LessonWhere>;
  sourceLessonAggregate?: InputMaybe<EventSourceLessonAggregateInput>;
  sourceLessonConnection?: InputMaybe<EventSourceLessonConnectionWhere>;
  sourceLessonConnection_NOT?: InputMaybe<EventSourceLessonConnectionWhere>;
  sourceLesson_NOT?: InputMaybe<LessonWhere>;
  sourceTeachingBlockCard?: InputMaybe<TeachingBlockCardWhere>;
  sourceTeachingBlockCardAggregate?: InputMaybe<EventSourceTeachingBlockCardAggregateInput>;
  sourceTeachingBlockCardConnection?: InputMaybe<EventSourceTeachingBlockCardConnectionWhere>;
  sourceTeachingBlockCardConnection_NOT?: InputMaybe<EventSourceTeachingBlockCardConnectionWhere>;
  sourceTeachingBlockCard_NOT?: InputMaybe<TeachingBlockCardWhere>;
  sourceTimeGridEntry?: InputMaybe<TimeGridEntryWhere>;
  sourceTimeGridEntryAggregate?: InputMaybe<EventSourceTimeGridEntryAggregateInput>;
  sourceTimeGridEntryConnection?: InputMaybe<EventSourceTimeGridEntryConnectionWhere>;
  sourceTimeGridEntryConnection_NOT?: InputMaybe<EventSourceTimeGridEntryConnectionWhere>;
  sourceTimeGridEntry_NOT?: InputMaybe<TimeGridEntryWhere>;
  sourceTimetableCard?: InputMaybe<TimetableCardWhere>;
  sourceTimetableCardAggregate?: InputMaybe<EventSourceTimetableCardAggregateInput>;
  sourceTimetableCardConnection?: InputMaybe<EventSourceTimetableCardConnectionWhere>;
  sourceTimetableCardConnection_NOT?: InputMaybe<EventSourceTimetableCardConnectionWhere>;
  sourceTimetableCard_NOT?: InputMaybe<TimetableCardWhere>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  start_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  start_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  subject?: InputMaybe<SubjectWhere>;
  subjectAggregate?: InputMaybe<EventSubjectAggregateInput>;
  subjectConnection?: InputMaybe<EventSubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<EventSubjectConnectionWhere>;
  subject_NOT?: InputMaybe<SubjectWhere>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  substitutionComment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  substitutionComment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutionComment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionComment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionComment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionComment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionComment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionComment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutionComment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutionReasons?: InputMaybe<SubstitutionReason>;
  substitutionReasons_IN?: InputMaybe<Array<InputMaybe<SubstitutionReason>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionReasons_NOT?: InputMaybe<SubstitutionReason>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionReasons_NOT_IN?: InputMaybe<Array<InputMaybe<SubstitutionReason>>>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type EventsConnection = {
  __typename?: 'EventsConnection';
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum FactorType {
  Base = 'BASE',
  Person = 'PERSON',
  Time = 'TIME',
}

export type FileEntriesConnection = {
  __typename?: 'FileEntriesConnection';
  edges: Array<FileEntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileEntry = {
  __typename?: 'FileEntry';
  created: Scalars['DateTime']['output'];
  downloadToken: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  /**
   * The entity that holds this file entry. May be null initially, to
   * allow uploading files before the holder entity is created
   */
  holder?: Maybe<PdfReportHolder>;
  holderConnection: FileEntryHolderConnection;
  mediaType: Scalars['String']['output'];
  /**
   * FileEntry requires an explicit organization as it can exist
   * without a holder.
   */
  organization: Organization;
  organizationConnection: FileEntryOrganizationConnection;
  /**
   * FileEntry requires an explicit owner profile as it can exist
   * without a holder.
   */
  owner?: Maybe<Person>;
  ownerConnection: FileEntryOwnerConnection;
  size: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type FileEntryHolderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PdfReportHolderWhere>;
};

export type FileEntryHolderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileEntryHolderConnectionSort>>;
  where?: InputMaybe<FileEntryHolderConnectionWhere>;
};

export type FileEntryOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type FileEntryOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileEntryOrganizationConnectionSort>>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type FileEntryOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileEntryOwnerConnectionSort>>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

export type FileEntryAggregateSelection = {
  __typename?: 'FileEntryAggregateSelection';
  count: Scalars['Int']['output'];
  created: DateTimeAggregateSelection;
  filename: StringAggregateSelection;
  mediaType: StringAggregateSelection;
  size: IntAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type FileEntryConnectInput = {
  holder?: InputMaybe<FileEntryHolderConnectInput>;
  organization?: InputMaybe<FileEntryOrganizationConnectFieldInput>;
  owner?: InputMaybe<FileEntryOwnerConnectFieldInput>;
};

export type FileEntryConnectWhere = {
  node: FileEntryWhere;
};

export type FileEntryCreateInput = {
  filename: Scalars['String']['input'];
  holder?: InputMaybe<FileEntryHolderCreateInput>;
  mediaType: Scalars['String']['input'];
  organization?: InputMaybe<FileEntryOrganizationFieldInput>;
  owner?: InputMaybe<FileEntryOwnerFieldInput>;
  size: Scalars['Int']['input'];
};

export type FileEntryDeleteInput = {
  holder?: InputMaybe<FileEntryHolderDeleteInput>;
  organization?: InputMaybe<FileEntryOrganizationDeleteFieldInput>;
  owner?: InputMaybe<FileEntryOwnerDeleteFieldInput>;
};

export type FileEntryDisconnectInput = {
  holder?: InputMaybe<FileEntryHolderDisconnectInput>;
  organization?: InputMaybe<FileEntryOrganizationDisconnectFieldInput>;
  owner?: InputMaybe<FileEntryOwnerDisconnectFieldInput>;
};

export type FileEntryEdge = {
  __typename?: 'FileEntryEdge';
  cursor: Scalars['String']['output'];
  node: FileEntry;
};

export type FileEntryHolderConnectInput = {
  SubstitutionReport?: InputMaybe<FileEntryHolderSubstitutionReportConnectFieldInput>;
  TeachingLoadReport?: InputMaybe<FileEntryHolderTeachingLoadReportConnectFieldInput>;
  TimetableReport?: InputMaybe<FileEntryHolderTimetableReportConnectFieldInput>;
};

export type FileEntryHolderConnection = {
  __typename?: 'FileEntryHolderConnection';
  edges: Array<FileEntryHolderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileEntryHolderConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
};

export type FileEntryHolderConnectionWhere = {
  SubstitutionReport?: InputMaybe<FileEntryHolderSubstitutionReportConnectionWhere>;
  TeachingLoadReport?: InputMaybe<FileEntryHolderTeachingLoadReportConnectionWhere>;
  TimetableReport?: InputMaybe<FileEntryHolderTimetableReportConnectionWhere>;
};

export type FileEntryHolderCreateInput = {
  SubstitutionReport?: InputMaybe<FileEntryHolderSubstitutionReportFieldInput>;
  TeachingLoadReport?: InputMaybe<FileEntryHolderTeachingLoadReportFieldInput>;
  TimetableReport?: InputMaybe<FileEntryHolderTimetableReportFieldInput>;
};

export type FileEntryHolderDeleteInput = {
  SubstitutionReport?: InputMaybe<FileEntryHolderSubstitutionReportDeleteFieldInput>;
  TeachingLoadReport?: InputMaybe<FileEntryHolderTeachingLoadReportDeleteFieldInput>;
  TimetableReport?: InputMaybe<FileEntryHolderTimetableReportDeleteFieldInput>;
};

export type FileEntryHolderDisconnectInput = {
  SubstitutionReport?: InputMaybe<FileEntryHolderSubstitutionReportDisconnectFieldInput>;
  TeachingLoadReport?: InputMaybe<FileEntryHolderTeachingLoadReportDisconnectFieldInput>;
  TimetableReport?: InputMaybe<FileEntryHolderTimetableReportDisconnectFieldInput>;
};

export type FileEntryHolderRelationship = {
  __typename?: 'FileEntryHolderRelationship';
  cursor: Scalars['String']['output'];
  node: PdfReportHolder;
  properties: OrderedRelationProperties;
};

export type FileEntryHolderSubstitutionReportConnectFieldInput = {
  connect?: InputMaybe<SubstitutionReportConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<SubstitutionReportConnectWhere>;
};

export type FileEntryHolderSubstitutionReportConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryHolderSubstitutionReportConnectionWhere>>;
  NOT?: InputMaybe<FileEntryHolderSubstitutionReportConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryHolderSubstitutionReportConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<SubstitutionReportWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubstitutionReportWhere>;
};

export type FileEntryHolderSubstitutionReportCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: SubstitutionReportCreateInput;
};

export type FileEntryHolderSubstitutionReportDeleteFieldInput = {
  delete?: InputMaybe<SubstitutionReportDeleteInput>;
  where?: InputMaybe<FileEntryHolderSubstitutionReportConnectionWhere>;
};

export type FileEntryHolderSubstitutionReportDisconnectFieldInput = {
  disconnect?: InputMaybe<SubstitutionReportDisconnectInput>;
  where?: InputMaybe<FileEntryHolderSubstitutionReportConnectionWhere>;
};

export type FileEntryHolderSubstitutionReportFieldInput = {
  connect?: InputMaybe<FileEntryHolderSubstitutionReportConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderSubstitutionReportCreateFieldInput>;
};

export type FileEntryHolderSubstitutionReportUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<SubstitutionReportUpdateInput>;
};

export type FileEntryHolderSubstitutionReportUpdateFieldInput = {
  connect?: InputMaybe<FileEntryHolderSubstitutionReportConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderSubstitutionReportCreateFieldInput>;
  delete?: InputMaybe<FileEntryHolderSubstitutionReportDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryHolderSubstitutionReportDisconnectFieldInput>;
  update?: InputMaybe<FileEntryHolderSubstitutionReportUpdateConnectionInput>;
  where?: InputMaybe<FileEntryHolderSubstitutionReportConnectionWhere>;
};

export type FileEntryHolderTeachingLoadReportConnectFieldInput = {
  connect?: InputMaybe<TeachingLoadReportConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TeachingLoadReportConnectWhere>;
};

export type FileEntryHolderTeachingLoadReportConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryHolderTeachingLoadReportConnectionWhere>>;
  NOT?: InputMaybe<FileEntryHolderTeachingLoadReportConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryHolderTeachingLoadReportConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingLoadReportWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingLoadReportWhere>;
};

export type FileEntryHolderTeachingLoadReportCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingLoadReportCreateInput;
};

export type FileEntryHolderTeachingLoadReportDeleteFieldInput = {
  delete?: InputMaybe<TeachingLoadReportDeleteInput>;
  where?: InputMaybe<FileEntryHolderTeachingLoadReportConnectionWhere>;
};

export type FileEntryHolderTeachingLoadReportDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingLoadReportDisconnectInput>;
  where?: InputMaybe<FileEntryHolderTeachingLoadReportConnectionWhere>;
};

export type FileEntryHolderTeachingLoadReportFieldInput = {
  connect?: InputMaybe<FileEntryHolderTeachingLoadReportConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderTeachingLoadReportCreateFieldInput>;
};

export type FileEntryHolderTeachingLoadReportUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingLoadReportUpdateInput>;
};

export type FileEntryHolderTeachingLoadReportUpdateFieldInput = {
  connect?: InputMaybe<FileEntryHolderTeachingLoadReportConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderTeachingLoadReportCreateFieldInput>;
  delete?: InputMaybe<FileEntryHolderTeachingLoadReportDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryHolderTeachingLoadReportDisconnectFieldInput>;
  update?: InputMaybe<FileEntryHolderTeachingLoadReportUpdateConnectionInput>;
  where?: InputMaybe<FileEntryHolderTeachingLoadReportConnectionWhere>;
};

export type FileEntryHolderTimetableReportConnectFieldInput = {
  connect?: InputMaybe<TimetableReportConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TimetableReportConnectWhere>;
};

export type FileEntryHolderTimetableReportConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryHolderTimetableReportConnectionWhere>>;
  NOT?: InputMaybe<FileEntryHolderTimetableReportConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryHolderTimetableReportConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TimetableReportWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableReportWhere>;
};

export type FileEntryHolderTimetableReportCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TimetableReportCreateInput;
};

export type FileEntryHolderTimetableReportDeleteFieldInput = {
  delete?: InputMaybe<TimetableReportDeleteInput>;
  where?: InputMaybe<FileEntryHolderTimetableReportConnectionWhere>;
};

export type FileEntryHolderTimetableReportDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableReportDisconnectInput>;
  where?: InputMaybe<FileEntryHolderTimetableReportConnectionWhere>;
};

export type FileEntryHolderTimetableReportFieldInput = {
  connect?: InputMaybe<FileEntryHolderTimetableReportConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderTimetableReportCreateFieldInput>;
};

export type FileEntryHolderTimetableReportUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TimetableReportUpdateInput>;
};

export type FileEntryHolderTimetableReportUpdateFieldInput = {
  connect?: InputMaybe<FileEntryHolderTimetableReportConnectFieldInput>;
  create?: InputMaybe<FileEntryHolderTimetableReportCreateFieldInput>;
  delete?: InputMaybe<FileEntryHolderTimetableReportDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryHolderTimetableReportDisconnectFieldInput>;
  update?: InputMaybe<FileEntryHolderTimetableReportUpdateConnectionInput>;
  where?: InputMaybe<FileEntryHolderTimetableReportConnectionWhere>;
};

export type FileEntryHolderUpdateInput = {
  SubstitutionReport?: InputMaybe<FileEntryHolderSubstitutionReportUpdateFieldInput>;
  TeachingLoadReport?: InputMaybe<FileEntryHolderTeachingLoadReportUpdateFieldInput>;
  TimetableReport?: InputMaybe<FileEntryHolderTimetableReportUpdateFieldInput>;
};

export type FileEntryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FileEntrySort objects to sort FileEntries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FileEntrySort>>;
};

export type FileEntryOrganizationAggregateInput = {
  AND?: InputMaybe<Array<FileEntryOrganizationAggregateInput>>;
  NOT?: InputMaybe<FileEntryOrganizationAggregateInput>;
  OR?: InputMaybe<Array<FileEntryOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileEntryOrganizationNodeAggregationWhereInput>;
};

export type FileEntryOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type FileEntryOrganizationConnectOrCreateFieldInput = {
  onCreate: FileEntryOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type FileEntryOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type FileEntryOrganizationConnection = {
  __typename?: 'FileEntryOrganizationConnection';
  edges: Array<FileEntryOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileEntryOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type FileEntryOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryOrganizationConnectionWhere>>;
  NOT?: InputMaybe<FileEntryOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type FileEntryOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type FileEntryOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOrganizationFieldInput = {
  connect?: InputMaybe<FileEntryOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOrganizationCreateFieldInput>;
};

export type FileEntryOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileEntryOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileEntryOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileEntryOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileEntryOrganizationRelationship = {
  __typename?: 'FileEntryOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type FileEntryOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type FileEntryOrganizationUpdateFieldInput = {
  connect?: InputMaybe<FileEntryOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOrganizationCreateFieldInput>;
  delete?: InputMaybe<FileEntryOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryOrganizationDisconnectFieldInput>;
  update?: InputMaybe<FileEntryOrganizationUpdateConnectionInput>;
  where?: InputMaybe<FileEntryOrganizationConnectionWhere>;
};

export type FileEntryOwnerAggregateInput = {
  AND?: InputMaybe<Array<FileEntryOwnerAggregateInput>>;
  NOT?: InputMaybe<FileEntryOwnerAggregateInput>;
  OR?: InputMaybe<Array<FileEntryOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileEntryOwnerNodeAggregationWhereInput>;
};

export type FileEntryOwnerConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type FileEntryOwnerConnectOrCreateFieldInput = {
  onCreate: FileEntryOwnerConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type FileEntryOwnerConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type FileEntryOwnerConnection = {
  __typename?: 'FileEntryOwnerConnection';
  edges: Array<FileEntryOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileEntryOwnerConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type FileEntryOwnerConnectionWhere = {
  AND?: InputMaybe<Array<FileEntryOwnerConnectionWhere>>;
  NOT?: InputMaybe<FileEntryOwnerConnectionWhere>;
  OR?: InputMaybe<Array<FileEntryOwnerConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type FileEntryOwnerCreateFieldInput = {
  node: PersonCreateInput;
};

export type FileEntryOwnerDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

export type FileEntryOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

export type FileEntryOwnerFieldInput = {
  connect?: InputMaybe<FileEntryOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOwnerCreateFieldInput>;
};

export type FileEntryOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileEntryOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileEntryOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileEntryOwnerNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FileEntryOwnerRelationship = {
  __typename?: 'FileEntryOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type FileEntryOwnerUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type FileEntryOwnerUpdateFieldInput = {
  connect?: InputMaybe<FileEntryOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileEntryOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<FileEntryOwnerCreateFieldInput>;
  delete?: InputMaybe<FileEntryOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<FileEntryOwnerDisconnectFieldInput>;
  update?: InputMaybe<FileEntryOwnerUpdateConnectionInput>;
  where?: InputMaybe<FileEntryOwnerConnectionWhere>;
};

/** Fields to sort FileEntries by. The order in which sorts are applied is not guaranteed when specifying many fields in one FileEntrySort object. */
export type FileEntrySort = {
  created?: InputMaybe<SortDirection>;
  filename?: InputMaybe<SortDirection>;
  mediaType?: InputMaybe<SortDirection>;
  size?: InputMaybe<SortDirection>;
  updated?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type FileEntryUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  holder?: InputMaybe<FileEntryHolderUpdateInput>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<FileEntryOrganizationUpdateFieldInput>;
  owner?: InputMaybe<FileEntryOwnerUpdateFieldInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  size_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type FileEntryWhere = {
  AND?: InputMaybe<Array<FileEntryWhere>>;
  NOT?: InputMaybe<FileEntryWhere>;
  OR?: InputMaybe<Array<FileEntryWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  created_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filename_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filename_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  filename_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  holder?: InputMaybe<PdfReportHolderWhere>;
  holderConnection?: InputMaybe<FileEntryHolderConnectionWhere>;
  holderConnection_NOT?: InputMaybe<FileEntryHolderConnectionWhere>;
  holder_NOT?: InputMaybe<PdfReportHolderWhere>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  mediaType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mediaType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mediaType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mediaType_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mediaType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<FileEntryOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<FileEntryOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<FileEntryOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  owner?: InputMaybe<PersonWhere>;
  ownerAggregate?: InputMaybe<FileEntryOwnerAggregateInput>;
  ownerConnection?: InputMaybe<FileEntryOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<FileEntryOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<PersonWhere>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_GT?: InputMaybe<Scalars['Int']['input']>;
  size_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  size_LT?: InputMaybe<Scalars['Int']['input']>;
  size_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  size_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  size_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type FloatAggregateSelection = {
  __typename?: 'FloatAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export enum FunctionalClassSubstitutionBehavior {
  AttendancePlanSource = 'ATTENDANCE_PLAN_SOURCE',
  NormalClassBehavior = 'NORMAL_CLASS_BEHAVIOR',
  ShowInSubstitutionPlan = 'SHOW_IN_SUBSTITUTION_PLAN',
}

export type GradeGroup = {
  __typename?: 'GradeGroup';
  class: Array<Class>;
  classConnection: GradeGroupClassConnection;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: GradeGroupOrganizationConnection;
  shortName: Scalars['String']['output'];
  teachingLoadFactor?: Maybe<TeachingLoadFactor>;
  teachingLoadFactorConnection: GradeGroupTeachingLoadFactorConnection;
  uuid: Scalars['ID']['output'];
};

export type GradeGroupClassArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type GradeGroupClassConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GradeGroupClassConnectionSort>>;
  where?: InputMaybe<GradeGroupClassConnectionWhere>;
};

export type GradeGroupOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type GradeGroupOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GradeGroupOrganizationConnectionSort>>;
  where?: InputMaybe<GradeGroupOrganizationConnectionWhere>;
};

export type GradeGroupTeachingLoadFactorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingLoadFactorOptions>;
  where?: InputMaybe<TeachingLoadFactorWhere>;
};

export type GradeGroupTeachingLoadFactorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GradeGroupTeachingLoadFactorConnectionSort>>;
  where?: InputMaybe<GradeGroupTeachingLoadFactorConnectionWhere>;
};

export type GradeGroupAggregateSelection = {
  __typename?: 'GradeGroupAggregateSelection';
  count: Scalars['Int']['output'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GradeGroupClassAggregateInput = {
  AND?: InputMaybe<Array<GradeGroupClassAggregateInput>>;
  NOT?: InputMaybe<GradeGroupClassAggregateInput>;
  OR?: InputMaybe<Array<GradeGroupClassAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GradeGroupClassNodeAggregationWhereInput>;
};

export type GradeGroupClassConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type GradeGroupClassConnectOrCreateFieldInput = {
  onCreate: GradeGroupClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type GradeGroupClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type GradeGroupClassConnection = {
  __typename?: 'GradeGroupClassConnection';
  edges: Array<GradeGroupClassRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GradeGroupClassConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type GradeGroupClassConnectionWhere = {
  AND?: InputMaybe<Array<GradeGroupClassConnectionWhere>>;
  NOT?: InputMaybe<GradeGroupClassConnectionWhere>;
  OR?: InputMaybe<Array<GradeGroupClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type GradeGroupClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type GradeGroupClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<GradeGroupClassConnectionWhere>;
};

export type GradeGroupClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<GradeGroupClassConnectionWhere>;
};

export type GradeGroupClassFieldInput = {
  connect?: InputMaybe<Array<GradeGroupClassConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GradeGroupClassConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GradeGroupClassCreateFieldInput>>;
};

export type GradeGroupClassNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GradeGroupClassNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GradeGroupClassNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GradeGroupClassNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GradeGroupClassRelationship = {
  __typename?: 'GradeGroupClassRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type GradeGroupClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type GradeGroupClassUpdateFieldInput = {
  connect?: InputMaybe<Array<GradeGroupClassConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<GradeGroupClassConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<GradeGroupClassCreateFieldInput>>;
  delete?: InputMaybe<Array<GradeGroupClassDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GradeGroupClassDisconnectFieldInput>>;
  update?: InputMaybe<GradeGroupClassUpdateConnectionInput>;
  where?: InputMaybe<GradeGroupClassConnectionWhere>;
};

export type GradeGroupConnectInput = {
  class?: InputMaybe<Array<GradeGroupClassConnectFieldInput>>;
  organization?: InputMaybe<GradeGroupOrganizationConnectFieldInput>;
  teachingLoadFactor?: InputMaybe<GradeGroupTeachingLoadFactorConnectFieldInput>;
};

export type GradeGroupConnectWhere = {
  node: GradeGroupWhere;
};

export type GradeGroupCreateInput = {
  class?: InputMaybe<GradeGroupClassFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<GradeGroupOrganizationFieldInput>;
  shortName: Scalars['String']['input'];
  teachingLoadFactor?: InputMaybe<GradeGroupTeachingLoadFactorFieldInput>;
};

export type GradeGroupDeleteInput = {
  class?: InputMaybe<Array<GradeGroupClassDeleteFieldInput>>;
  organization?: InputMaybe<GradeGroupOrganizationDeleteFieldInput>;
  teachingLoadFactor?: InputMaybe<GradeGroupTeachingLoadFactorDeleteFieldInput>;
};

export type GradeGroupDisconnectInput = {
  class?: InputMaybe<Array<GradeGroupClassDisconnectFieldInput>>;
  organization?: InputMaybe<GradeGroupOrganizationDisconnectFieldInput>;
  teachingLoadFactor?: InputMaybe<GradeGroupTeachingLoadFactorDisconnectFieldInput>;
};

export type GradeGroupEdge = {
  __typename?: 'GradeGroupEdge';
  cursor: Scalars['String']['output'];
  node: GradeGroup;
};

export type GradeGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GradeGroupSort objects to sort GradeGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GradeGroupSort>>;
};

export type GradeGroupOrganizationAggregateInput = {
  AND?: InputMaybe<Array<GradeGroupOrganizationAggregateInput>>;
  NOT?: InputMaybe<GradeGroupOrganizationAggregateInput>;
  OR?: InputMaybe<Array<GradeGroupOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GradeGroupOrganizationNodeAggregationWhereInput>;
};

export type GradeGroupOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type GradeGroupOrganizationConnectOrCreateFieldInput = {
  onCreate: GradeGroupOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type GradeGroupOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type GradeGroupOrganizationConnection = {
  __typename?: 'GradeGroupOrganizationConnection';
  edges: Array<GradeGroupOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GradeGroupOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type GradeGroupOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<GradeGroupOrganizationConnectionWhere>>;
  NOT?: InputMaybe<GradeGroupOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<GradeGroupOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type GradeGroupOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type GradeGroupOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<GradeGroupOrganizationConnectionWhere>;
};

export type GradeGroupOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<GradeGroupOrganizationConnectionWhere>;
};

export type GradeGroupOrganizationFieldInput = {
  connect?: InputMaybe<GradeGroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<GradeGroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<GradeGroupOrganizationCreateFieldInput>;
};

export type GradeGroupOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GradeGroupOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GradeGroupOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GradeGroupOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GradeGroupOrganizationRelationship = {
  __typename?: 'GradeGroupOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type GradeGroupOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type GradeGroupOrganizationUpdateFieldInput = {
  connect?: InputMaybe<GradeGroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<GradeGroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<GradeGroupOrganizationCreateFieldInput>;
  delete?: InputMaybe<GradeGroupOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<GradeGroupOrganizationDisconnectFieldInput>;
  update?: InputMaybe<GradeGroupOrganizationUpdateConnectionInput>;
  where?: InputMaybe<GradeGroupOrganizationConnectionWhere>;
};

/** Fields to sort GradeGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one GradeGroupSort object. */
export type GradeGroupSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type GradeGroupTeachingLoadFactorAggregateInput = {
  AND?: InputMaybe<Array<GradeGroupTeachingLoadFactorAggregateInput>>;
  NOT?: InputMaybe<GradeGroupTeachingLoadFactorAggregateInput>;
  OR?: InputMaybe<Array<GradeGroupTeachingLoadFactorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GradeGroupTeachingLoadFactorNodeAggregationWhereInput>;
};

export type GradeGroupTeachingLoadFactorConnectFieldInput = {
  connect?: InputMaybe<TeachingLoadFactorConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingLoadFactorConnectWhere>;
};

export type GradeGroupTeachingLoadFactorConnectOrCreateFieldInput = {
  onCreate: GradeGroupTeachingLoadFactorConnectOrCreateFieldInputOnCreate;
  where: TeachingLoadFactorConnectOrCreateWhere;
};

export type GradeGroupTeachingLoadFactorConnectOrCreateFieldInputOnCreate = {
  node: TeachingLoadFactorOnCreateInput;
};

export type GradeGroupTeachingLoadFactorConnection = {
  __typename?: 'GradeGroupTeachingLoadFactorConnection';
  edges: Array<GradeGroupTeachingLoadFactorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GradeGroupTeachingLoadFactorConnectionSort = {
  node?: InputMaybe<TeachingLoadFactorSort>;
};

export type GradeGroupTeachingLoadFactorConnectionWhere = {
  AND?: InputMaybe<Array<GradeGroupTeachingLoadFactorConnectionWhere>>;
  NOT?: InputMaybe<GradeGroupTeachingLoadFactorConnectionWhere>;
  OR?: InputMaybe<Array<GradeGroupTeachingLoadFactorConnectionWhere>>;
  node?: InputMaybe<TeachingLoadFactorWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingLoadFactorWhere>;
};

export type GradeGroupTeachingLoadFactorCreateFieldInput = {
  node: TeachingLoadFactorCreateInput;
};

export type GradeGroupTeachingLoadFactorDeleteFieldInput = {
  delete?: InputMaybe<TeachingLoadFactorDeleteInput>;
  where?: InputMaybe<GradeGroupTeachingLoadFactorConnectionWhere>;
};

export type GradeGroupTeachingLoadFactorDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingLoadFactorDisconnectInput>;
  where?: InputMaybe<GradeGroupTeachingLoadFactorConnectionWhere>;
};

export type GradeGroupTeachingLoadFactorFieldInput = {
  connect?: InputMaybe<GradeGroupTeachingLoadFactorConnectFieldInput>;
  connectOrCreate?: InputMaybe<GradeGroupTeachingLoadFactorConnectOrCreateFieldInput>;
  create?: InputMaybe<GradeGroupTeachingLoadFactorCreateFieldInput>;
};

export type GradeGroupTeachingLoadFactorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GradeGroupTeachingLoadFactorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GradeGroupTeachingLoadFactorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GradeGroupTeachingLoadFactorNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartial_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type GradeGroupTeachingLoadFactorRelationship = {
  __typename?: 'GradeGroupTeachingLoadFactorRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingLoadFactor;
};

export type GradeGroupTeachingLoadFactorUpdateConnectionInput = {
  node?: InputMaybe<TeachingLoadFactorUpdateInput>;
};

export type GradeGroupTeachingLoadFactorUpdateFieldInput = {
  connect?: InputMaybe<GradeGroupTeachingLoadFactorConnectFieldInput>;
  connectOrCreate?: InputMaybe<GradeGroupTeachingLoadFactorConnectOrCreateFieldInput>;
  create?: InputMaybe<GradeGroupTeachingLoadFactorCreateFieldInput>;
  delete?: InputMaybe<GradeGroupTeachingLoadFactorDeleteFieldInput>;
  disconnect?: InputMaybe<GradeGroupTeachingLoadFactorDisconnectFieldInput>;
  update?: InputMaybe<GradeGroupTeachingLoadFactorUpdateConnectionInput>;
  where?: InputMaybe<GradeGroupTeachingLoadFactorConnectionWhere>;
};

export type GradeGroupUpdateInput = {
  class?: InputMaybe<Array<GradeGroupClassUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<GradeGroupOrganizationUpdateFieldInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  teachingLoadFactor?: InputMaybe<GradeGroupTeachingLoadFactorUpdateFieldInput>;
};

export type GradeGroupWhere = {
  AND?: InputMaybe<Array<GradeGroupWhere>>;
  NOT?: InputMaybe<GradeGroupWhere>;
  OR?: InputMaybe<Array<GradeGroupWhere>>;
  /** @deprecated Use `class_SOME` instead. */
  class?: InputMaybe<ClassWhere>;
  classAggregate?: InputMaybe<GradeGroupClassAggregateInput>;
  /** @deprecated Use `classConnection_SOME` instead. */
  classConnection?: InputMaybe<GradeGroupClassConnectionWhere>;
  /** Return GradeGroups where all of the related GradeGroupClassConnections match this filter */
  classConnection_ALL?: InputMaybe<GradeGroupClassConnectionWhere>;
  /** Return GradeGroups where none of the related GradeGroupClassConnections match this filter */
  classConnection_NONE?: InputMaybe<GradeGroupClassConnectionWhere>;
  /** @deprecated Use `classConnection_NONE` instead. */
  classConnection_NOT?: InputMaybe<GradeGroupClassConnectionWhere>;
  /** Return GradeGroups where one of the related GradeGroupClassConnections match this filter */
  classConnection_SINGLE?: InputMaybe<GradeGroupClassConnectionWhere>;
  /** Return GradeGroups where some of the related GradeGroupClassConnections match this filter */
  classConnection_SOME?: InputMaybe<GradeGroupClassConnectionWhere>;
  /** Return GradeGroups where all of the related Classes match this filter */
  class_ALL?: InputMaybe<ClassWhere>;
  /** Return GradeGroups where none of the related Classes match this filter */
  class_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `class_NONE` instead. */
  class_NOT?: InputMaybe<ClassWhere>;
  /** Return GradeGroups where one of the related Classes match this filter */
  class_SINGLE?: InputMaybe<ClassWhere>;
  /** Return GradeGroups where some of the related Classes match this filter */
  class_SOME?: InputMaybe<ClassWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<GradeGroupOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<GradeGroupOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<GradeGroupOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachingLoadFactor?: InputMaybe<TeachingLoadFactorWhere>;
  teachingLoadFactorAggregate?: InputMaybe<GradeGroupTeachingLoadFactorAggregateInput>;
  teachingLoadFactorConnection?: InputMaybe<GradeGroupTeachingLoadFactorConnectionWhere>;
  teachingLoadFactorConnection_NOT?: InputMaybe<GradeGroupTeachingLoadFactorConnectionWhere>;
  teachingLoadFactor_NOT?: InputMaybe<TeachingLoadFactorWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type GradeGroupsConnection = {
  __typename?: 'GradeGroupsConnection';
  edges: Array<GradeGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Group = {
  __typename?: 'Group';
  classFraction: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  division?: Maybe<Division>;
  divisionConnection: GroupDivisionConnection;
  entireClass?: Maybe<Scalars['Boolean']['output']>;
  events: Array<Event>;
  eventsConnection: GroupEventsConnection;
  foreignId?: Maybe<Scalars['String']['output']>;
  labels: Array<Label>;
  labelsConnection: GroupLabelsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: GroupOrganizationConnection;
  owner?: Maybe<GroupOwner>;
  ownerConnection: GroupOwnerConnection;
  shortName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type GroupDivisionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DivisionOptions>;
  where?: InputMaybe<DivisionWhere>;
};

export type GroupDivisionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupDivisionConnectionSort>>;
  where?: InputMaybe<GroupDivisionConnectionWhere>;
};

export type GroupEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type GroupEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupEventsConnectionSort>>;
  where?: InputMaybe<GroupEventsConnectionWhere>;
};

export type GroupLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type GroupLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupLabelsConnectionSort>>;
  where?: InputMaybe<GroupLabelsConnectionWhere>;
};

export type GroupOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type GroupOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GroupOrganizationConnectionSort>>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<GroupOwnerWhere>;
};

export type GroupOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GroupOwnerConnectionWhere>;
};

export type GroupAggregateSelection = {
  __typename?: 'GroupAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type GroupConnectInput = {
  division?: InputMaybe<GroupDivisionConnectFieldInput>;
  events?: InputMaybe<Array<GroupEventsConnectFieldInput>>;
  labels?: InputMaybe<Array<GroupLabelsConnectFieldInput>>;
  organization?: InputMaybe<GroupOrganizationConnectFieldInput>;
  owner?: InputMaybe<GroupOwnerConnectInput>;
};

export type GroupConnectOrCreateWhere = {
  node: GroupUniqueWhere;
};

export type GroupConnectWhere = {
  node: GroupWhere;
};

export type GroupCreateInput = {
  division?: InputMaybe<GroupDivisionFieldInput>;
  entireClass?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<GroupEventsFieldInput>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<GroupLabelsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<GroupOrganizationFieldInput>;
  owner?: InputMaybe<GroupOwnerCreateInput>;
  shortName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupDeleteInput = {
  division?: InputMaybe<GroupDivisionDeleteFieldInput>;
  events?: InputMaybe<Array<GroupEventsDeleteFieldInput>>;
  labels?: InputMaybe<Array<GroupLabelsDeleteFieldInput>>;
  organization?: InputMaybe<GroupOrganizationDeleteFieldInput>;
  owner?: InputMaybe<GroupOwnerDeleteInput>;
};

export type GroupDisconnectInput = {
  division?: InputMaybe<GroupDivisionDisconnectFieldInput>;
  events?: InputMaybe<Array<GroupEventsDisconnectFieldInput>>;
  labels?: InputMaybe<Array<GroupLabelsDisconnectFieldInput>>;
  organization?: InputMaybe<GroupOrganizationDisconnectFieldInput>;
  owner?: InputMaybe<GroupOwnerDisconnectInput>;
};

export type GroupDivisionAggregateInput = {
  AND?: InputMaybe<Array<GroupDivisionAggregateInput>>;
  NOT?: InputMaybe<GroupDivisionAggregateInput>;
  OR?: InputMaybe<Array<GroupDivisionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<GroupDivisionNodeAggregationWhereInput>;
};

export type GroupDivisionConnectFieldInput = {
  connect?: InputMaybe<DivisionConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DivisionConnectWhere>;
};

export type GroupDivisionConnectOrCreateFieldInput = {
  onCreate: GroupDivisionConnectOrCreateFieldInputOnCreate;
  where: DivisionConnectOrCreateWhere;
};

export type GroupDivisionConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: DivisionOnCreateInput;
};

export type GroupDivisionConnection = {
  __typename?: 'GroupDivisionConnection';
  edges: Array<GroupDivisionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupDivisionConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<DivisionSort>;
};

export type GroupDivisionConnectionWhere = {
  AND?: InputMaybe<Array<GroupDivisionConnectionWhere>>;
  NOT?: InputMaybe<GroupDivisionConnectionWhere>;
  OR?: InputMaybe<Array<GroupDivisionConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DivisionWhere>;
};

export type GroupDivisionCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: DivisionCreateInput;
};

export type GroupDivisionDeleteFieldInput = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<GroupDivisionConnectionWhere>;
};

export type GroupDivisionDisconnectFieldInput = {
  disconnect?: InputMaybe<DivisionDisconnectInput>;
  where?: InputMaybe<GroupDivisionConnectionWhere>;
};

export type GroupDivisionFieldInput = {
  connect?: InputMaybe<GroupDivisionConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupDivisionConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupDivisionCreateFieldInput>;
};

export type GroupDivisionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupDivisionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupDivisionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupDivisionNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupDivisionRelationship = {
  __typename?: 'GroupDivisionRelationship';
  cursor: Scalars['String']['output'];
  node: Division;
  properties: OrderedRelationProperties;
};

export type GroupDivisionUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<DivisionUpdateInput>;
};

export type GroupDivisionUpdateFieldInput = {
  connect?: InputMaybe<GroupDivisionConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupDivisionConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupDivisionCreateFieldInput>;
  delete?: InputMaybe<GroupDivisionDeleteFieldInput>;
  disconnect?: InputMaybe<GroupDivisionDisconnectFieldInput>;
  update?: InputMaybe<GroupDivisionUpdateConnectionInput>;
  where?: InputMaybe<GroupDivisionConnectionWhere>;
};

export type GroupEdge = {
  __typename?: 'GroupEdge';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type GroupEventsAggregateInput = {
  AND?: InputMaybe<Array<GroupEventsAggregateInput>>;
  NOT?: InputMaybe<GroupEventsAggregateInput>;
  OR?: InputMaybe<Array<GroupEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupEventsNodeAggregationWhereInput>;
};

export type GroupEventsConnectFieldInput = {
  connect?: InputMaybe<Array<EventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type GroupEventsConnection = {
  __typename?: 'GroupEventsConnection';
  edges: Array<GroupEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type GroupEventsConnectionWhere = {
  AND?: InputMaybe<Array<GroupEventsConnectionWhere>>;
  NOT?: InputMaybe<GroupEventsConnectionWhere>;
  OR?: InputMaybe<Array<GroupEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type GroupEventsCreateFieldInput = {
  node: EventCreateInput;
};

export type GroupEventsDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<GroupEventsConnectionWhere>;
};

export type GroupEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<GroupEventsConnectionWhere>;
};

export type GroupEventsFieldInput = {
  connect?: InputMaybe<Array<GroupEventsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupEventsCreateFieldInput>>;
};

export type GroupEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupEventsRelationship = {
  __typename?: 'GroupEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type GroupEventsUpdateConnectionInput = {
  node?: InputMaybe<EventUpdateInput>;
};

export type GroupEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupEventsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupEventsDisconnectFieldInput>>;
  update?: InputMaybe<GroupEventsUpdateConnectionInput>;
  where?: InputMaybe<GroupEventsConnectionWhere>;
};

export type GroupLabelsAggregateInput = {
  AND?: InputMaybe<Array<GroupLabelsAggregateInput>>;
  NOT?: InputMaybe<GroupLabelsAggregateInput>;
  OR?: InputMaybe<Array<GroupLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupLabelsNodeAggregationWhereInput>;
};

export type GroupLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type GroupLabelsConnection = {
  __typename?: 'GroupLabelsConnection';
  edges: Array<GroupLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type GroupLabelsConnectionWhere = {
  AND?: InputMaybe<Array<GroupLabelsConnectionWhere>>;
  NOT?: InputMaybe<GroupLabelsConnectionWhere>;
  OR?: InputMaybe<Array<GroupLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type GroupLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type GroupLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<GroupLabelsConnectionWhere>;
};

export type GroupLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<GroupLabelsConnectionWhere>;
};

export type GroupLabelsFieldInput = {
  connect?: InputMaybe<Array<GroupLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupLabelsCreateFieldInput>>;
};

export type GroupLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupLabelsRelationship = {
  __typename?: 'GroupLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type GroupLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type GroupLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<GroupLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<GroupLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<GroupLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<GroupLabelsDisconnectFieldInput>>;
  update?: InputMaybe<GroupLabelsUpdateConnectionInput>;
  where?: InputMaybe<GroupLabelsConnectionWhere>;
};

export type GroupOnCreateInput = {
  entireClass?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GroupSort objects to sort Groups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GroupSort>>;
};

export type GroupOrganizationAggregateInput = {
  AND?: InputMaybe<Array<GroupOrganizationAggregateInput>>;
  NOT?: InputMaybe<GroupOrganizationAggregateInput>;
  OR?: InputMaybe<Array<GroupOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GroupOrganizationNodeAggregationWhereInput>;
};

export type GroupOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type GroupOrganizationConnectOrCreateFieldInput = {
  onCreate: GroupOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type GroupOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type GroupOrganizationConnection = {
  __typename?: 'GroupOrganizationConnection';
  edges: Array<GroupOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type GroupOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<GroupOrganizationConnectionWhere>>;
  NOT?: InputMaybe<GroupOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<GroupOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type GroupOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type GroupOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOrganizationFieldInput = {
  connect?: InputMaybe<GroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupOrganizationCreateFieldInput>;
};

export type GroupOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GroupOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GroupOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GroupOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupOrganizationRelationship = {
  __typename?: 'GroupOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type GroupOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type GroupOrganizationUpdateFieldInput = {
  connect?: InputMaybe<GroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupOrganizationCreateFieldInput>;
  delete?: InputMaybe<GroupOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<GroupOrganizationDisconnectFieldInput>;
  update?: InputMaybe<GroupOrganizationUpdateConnectionInput>;
  where?: InputMaybe<GroupOrganizationConnectionWhere>;
};

export type GroupOwner = Class;

export type GroupOwnerClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  where?: InputMaybe<ClassConnectWhere>;
};

export type GroupOwnerClassConnectOrCreateFieldInput = {
  onCreate: GroupOwnerClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type GroupOwnerClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type GroupOwnerClassConnectionWhere = {
  AND?: InputMaybe<Array<GroupOwnerClassConnectionWhere>>;
  NOT?: InputMaybe<GroupOwnerClassConnectionWhere>;
  OR?: InputMaybe<Array<GroupOwnerClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type GroupOwnerClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type GroupOwnerClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<GroupOwnerClassConnectionWhere>;
};

export type GroupOwnerClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<GroupOwnerClassConnectionWhere>;
};

export type GroupOwnerClassFieldInput = {
  connect?: InputMaybe<GroupOwnerClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupOwnerClassConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupOwnerClassCreateFieldInput>;
};

export type GroupOwnerClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type GroupOwnerClassUpdateFieldInput = {
  connect?: InputMaybe<GroupOwnerClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<GroupOwnerClassConnectOrCreateFieldInput>;
  create?: InputMaybe<GroupOwnerClassCreateFieldInput>;
  delete?: InputMaybe<GroupOwnerClassDeleteFieldInput>;
  disconnect?: InputMaybe<GroupOwnerClassDisconnectFieldInput>;
  update?: InputMaybe<GroupOwnerClassUpdateConnectionInput>;
  where?: InputMaybe<GroupOwnerClassConnectionWhere>;
};

export type GroupOwnerConnectInput = {
  Class?: InputMaybe<GroupOwnerClassConnectFieldInput>;
};

export type GroupOwnerConnection = {
  __typename?: 'GroupOwnerConnection';
  edges: Array<GroupOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupOwnerConnectionWhere = {
  Class?: InputMaybe<GroupOwnerClassConnectionWhere>;
};

export type GroupOwnerCreateInput = {
  Class?: InputMaybe<GroupOwnerClassFieldInput>;
};

export type GroupOwnerDeleteInput = {
  Class?: InputMaybe<GroupOwnerClassDeleteFieldInput>;
};

export type GroupOwnerDisconnectInput = {
  Class?: InputMaybe<GroupOwnerClassDisconnectFieldInput>;
};

export type GroupOwnerRelationship = {
  __typename?: 'GroupOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: GroupOwner;
};

export type GroupOwnerUpdateInput = {
  Class?: InputMaybe<GroupOwnerClassUpdateFieldInput>;
};

export type GroupOwnerWhere = {
  Class?: InputMaybe<ClassWhere>;
};

/** Fields to sort Groups by. The order in which sorts are applied is not guaranteed when specifying many fields in one GroupSort object. */
export type GroupSort = {
  classFraction?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  entireClass?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type GroupUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type GroupUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  division?: InputMaybe<GroupDivisionUpdateFieldInput>;
  entireClass?: InputMaybe<Scalars['Boolean']['input']>;
  events?: InputMaybe<Array<GroupEventsUpdateFieldInput>>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<GroupLabelsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<GroupOrganizationUpdateFieldInput>;
  owner?: InputMaybe<GroupOwnerUpdateInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type GroupWhere = {
  AND?: InputMaybe<Array<GroupWhere>>;
  NOT?: InputMaybe<GroupWhere>;
  OR?: InputMaybe<Array<GroupWhere>>;
  classFraction?: InputMaybe<Scalars['Float']['input']>;
  classFraction_GT?: InputMaybe<Scalars['Float']['input']>;
  classFraction_GTE?: InputMaybe<Scalars['Float']['input']>;
  classFraction_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  classFraction_LT?: InputMaybe<Scalars['Float']['input']>;
  classFraction_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classFraction_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classFraction_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  division?: InputMaybe<DivisionWhere>;
  divisionAggregate?: InputMaybe<GroupDivisionAggregateInput>;
  divisionConnection?: InputMaybe<GroupDivisionConnectionWhere>;
  divisionConnection_NOT?: InputMaybe<GroupDivisionConnectionWhere>;
  division_NOT?: InputMaybe<DivisionWhere>;
  entireClass?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  entireClass_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<GroupEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where all of the related GroupEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where none of the related GroupEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<GroupEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where one of the related GroupEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where some of the related GroupEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<GroupEventsConnectionWhere>;
  /** Return Groups where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return Groups where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return Groups where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return Groups where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<GroupLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<GroupLabelsConnectionWhere>;
  /** Return Groups where all of the related GroupLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<GroupLabelsConnectionWhere>;
  /** Return Groups where none of the related GroupLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<GroupLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<GroupLabelsConnectionWhere>;
  /** Return Groups where one of the related GroupLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<GroupLabelsConnectionWhere>;
  /** Return Groups where some of the related GroupLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<GroupLabelsConnectionWhere>;
  /** Return Groups where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Groups where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Groups where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Groups where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<GroupOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<GroupOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<GroupOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  owner?: InputMaybe<GroupOwnerWhere>;
  ownerConnection?: InputMaybe<GroupOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<GroupOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<GroupOwnerWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  edges: Array<GroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Holiday = {
  __typename?: 'Holiday';
  end: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  start: Scalars['Date']['output'];
  uuid: Scalars['ID']['output'];
};

export type HolidayAggregateSelection = {
  __typename?: 'HolidayAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type HolidayCreateInput = {
  end: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  start: Scalars['Date']['input'];
};

export type HolidayEdge = {
  __typename?: 'HolidayEdge';
  cursor: Scalars['String']['output'];
  node: Holiday;
};

export type HolidayOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more HolidaySort objects to sort Holidays by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<HolidaySort>>;
};

/** Fields to sort Holidays by. The order in which sorts are applied is not guaranteed when specifying many fields in one HolidaySort object. */
export type HolidaySort = {
  end?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type HolidayUpdateInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type HolidayWhere = {
  AND?: InputMaybe<Array<HolidayWhere>>;
  NOT?: InputMaybe<HolidayWhere>;
  OR?: InputMaybe<Array<HolidayWhere>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  end_GT?: InputMaybe<Scalars['Date']['input']>;
  end_GTE?: InputMaybe<Scalars['Date']['input']>;
  end_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  end_LT?: InputMaybe<Scalars['Date']['input']>;
  end_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  start_GT?: InputMaybe<Scalars['Date']['input']>;
  start_GTE?: InputMaybe<Scalars['Date']['input']>;
  start_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  start_LT?: InputMaybe<Scalars['Date']['input']>;
  start_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type HolidaysConnection = {
  __typename?: 'HolidaysConnection';
  edges: Array<HolidayEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IdAggregateSelection = {
  __typename?: 'IDAggregateSelection';
  longest?: Maybe<Scalars['ID']['output']>;
  shortest?: Maybe<Scalars['ID']['output']>;
};

export enum InheritLessonTeachersType {
  SameClassLevel = 'sameClassLevel',
  SameStudents = 'sameStudents',
}

export type IntAggregateSelection = {
  __typename?: 'IntAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  sum?: Maybe<Scalars['Int']['output']>;
};

export type Label = {
  __typename?: 'Label';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  owner?: Maybe<LabelOwner>;
  ownerConnection: LabelOwnerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type LabelOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<LabelOwnerWhere>;
};

export type LabelOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LabelOwnerConnectionWhere>;
};

export type LabelConnectInput = {
  owner?: InputMaybe<LabelOwnerConnectInput>;
};

export type LabelConnectWhere = {
  node: LabelWhere;
};

export type LabelCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  owner?: InputMaybe<LabelOwnerCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LabelDeleteInput = {
  owner?: InputMaybe<LabelOwnerDeleteInput>;
};

export type LabelDisconnectInput = {
  owner?: InputMaybe<LabelOwnerDisconnectInput>;
};

export type LabelEdge = {
  __typename?: 'LabelEdge';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type LabelOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LabelSort objects to sort Labels by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LabelSort>>;
};

export type LabelOwner =
  | Building
  | Class
  | Curriculum
  | Division
  | Person
  | Room
  | Subject
  | SubjectContainer
  | SubjectGroup;

export type LabelOwnerBuildingConnectFieldInput = {
  connect?: InputMaybe<BuildingConnectInput>;
  where?: InputMaybe<BuildingConnectWhere>;
};

export type LabelOwnerBuildingConnectOrCreateFieldInput = {
  onCreate: LabelOwnerBuildingConnectOrCreateFieldInputOnCreate;
  where: BuildingConnectOrCreateWhere;
};

export type LabelOwnerBuildingConnectOrCreateFieldInputOnCreate = {
  node: BuildingOnCreateInput;
};

export type LabelOwnerBuildingConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerBuildingConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerBuildingConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerBuildingConnectionWhere>>;
  node?: InputMaybe<BuildingWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<BuildingWhere>;
};

export type LabelOwnerBuildingCreateFieldInput = {
  node: BuildingCreateInput;
};

export type LabelOwnerBuildingDeleteFieldInput = {
  delete?: InputMaybe<BuildingDeleteInput>;
  where?: InputMaybe<LabelOwnerBuildingConnectionWhere>;
};

export type LabelOwnerBuildingDisconnectFieldInput = {
  disconnect?: InputMaybe<BuildingDisconnectInput>;
  where?: InputMaybe<LabelOwnerBuildingConnectionWhere>;
};

export type LabelOwnerBuildingFieldInput = {
  connect?: InputMaybe<LabelOwnerBuildingConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerBuildingConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerBuildingCreateFieldInput>;
};

export type LabelOwnerBuildingUpdateConnectionInput = {
  node?: InputMaybe<BuildingUpdateInput>;
};

export type LabelOwnerBuildingUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerBuildingConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerBuildingConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerBuildingCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerBuildingDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerBuildingDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerBuildingUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerBuildingConnectionWhere>;
};

export type LabelOwnerClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  where?: InputMaybe<ClassConnectWhere>;
};

export type LabelOwnerClassConnectOrCreateFieldInput = {
  onCreate: LabelOwnerClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type LabelOwnerClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type LabelOwnerClassConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerClassConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerClassConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type LabelOwnerClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type LabelOwnerClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<LabelOwnerClassConnectionWhere>;
};

export type LabelOwnerClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<LabelOwnerClassConnectionWhere>;
};

export type LabelOwnerClassFieldInput = {
  connect?: InputMaybe<LabelOwnerClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerClassConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerClassCreateFieldInput>;
};

export type LabelOwnerClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type LabelOwnerClassUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerClassConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerClassCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerClassDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerClassDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerClassUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerClassConnectionWhere>;
};

export type LabelOwnerConnectInput = {
  Building?: InputMaybe<LabelOwnerBuildingConnectFieldInput>;
  Class?: InputMaybe<LabelOwnerClassConnectFieldInput>;
  Curriculum?: InputMaybe<LabelOwnerCurriculumConnectFieldInput>;
  Division?: InputMaybe<LabelOwnerDivisionConnectFieldInput>;
  Person?: InputMaybe<LabelOwnerPersonConnectFieldInput>;
  Room?: InputMaybe<LabelOwnerRoomConnectFieldInput>;
  Subject?: InputMaybe<LabelOwnerSubjectConnectFieldInput>;
  SubjectContainer?: InputMaybe<LabelOwnerSubjectContainerConnectFieldInput>;
  SubjectGroup?: InputMaybe<LabelOwnerSubjectGroupConnectFieldInput>;
};

export type LabelOwnerConnection = {
  __typename?: 'LabelOwnerConnection';
  edges: Array<LabelOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LabelOwnerConnectionWhere = {
  Building?: InputMaybe<LabelOwnerBuildingConnectionWhere>;
  Class?: InputMaybe<LabelOwnerClassConnectionWhere>;
  Curriculum?: InputMaybe<LabelOwnerCurriculumConnectionWhere>;
  Division?: InputMaybe<LabelOwnerDivisionConnectionWhere>;
  Person?: InputMaybe<LabelOwnerPersonConnectionWhere>;
  Room?: InputMaybe<LabelOwnerRoomConnectionWhere>;
  Subject?: InputMaybe<LabelOwnerSubjectConnectionWhere>;
  SubjectContainer?: InputMaybe<LabelOwnerSubjectContainerConnectionWhere>;
  SubjectGroup?: InputMaybe<LabelOwnerSubjectGroupConnectionWhere>;
};

export type LabelOwnerCreateInput = {
  Building?: InputMaybe<LabelOwnerBuildingFieldInput>;
  Class?: InputMaybe<LabelOwnerClassFieldInput>;
  Curriculum?: InputMaybe<LabelOwnerCurriculumFieldInput>;
  Division?: InputMaybe<LabelOwnerDivisionFieldInput>;
  Person?: InputMaybe<LabelOwnerPersonFieldInput>;
  Room?: InputMaybe<LabelOwnerRoomFieldInput>;
  Subject?: InputMaybe<LabelOwnerSubjectFieldInput>;
  SubjectContainer?: InputMaybe<LabelOwnerSubjectContainerFieldInput>;
  SubjectGroup?: InputMaybe<LabelOwnerSubjectGroupFieldInput>;
};

export type LabelOwnerCurriculumConnectFieldInput = {
  connect?: InputMaybe<CurriculumConnectInput>;
  where?: InputMaybe<CurriculumConnectWhere>;
};

export type LabelOwnerCurriculumConnectOrCreateFieldInput = {
  onCreate: LabelOwnerCurriculumConnectOrCreateFieldInputOnCreate;
  where: CurriculumConnectOrCreateWhere;
};

export type LabelOwnerCurriculumConnectOrCreateFieldInputOnCreate = {
  node: CurriculumOnCreateInput;
};

export type LabelOwnerCurriculumConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerCurriculumConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerCurriculumConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerCurriculumConnectionWhere>>;
  node?: InputMaybe<CurriculumWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumWhere>;
};

export type LabelOwnerCurriculumCreateFieldInput = {
  node: CurriculumCreateInput;
};

export type LabelOwnerCurriculumDeleteFieldInput = {
  delete?: InputMaybe<CurriculumDeleteInput>;
  where?: InputMaybe<LabelOwnerCurriculumConnectionWhere>;
};

export type LabelOwnerCurriculumDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumDisconnectInput>;
  where?: InputMaybe<LabelOwnerCurriculumConnectionWhere>;
};

export type LabelOwnerCurriculumFieldInput = {
  connect?: InputMaybe<LabelOwnerCurriculumConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerCurriculumConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerCurriculumCreateFieldInput>;
};

export type LabelOwnerCurriculumUpdateConnectionInput = {
  node?: InputMaybe<CurriculumUpdateInput>;
};

export type LabelOwnerCurriculumUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerCurriculumConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerCurriculumConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerCurriculumCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerCurriculumDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerCurriculumDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerCurriculumUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerCurriculumConnectionWhere>;
};

export type LabelOwnerDeleteInput = {
  Building?: InputMaybe<LabelOwnerBuildingDeleteFieldInput>;
  Class?: InputMaybe<LabelOwnerClassDeleteFieldInput>;
  Curriculum?: InputMaybe<LabelOwnerCurriculumDeleteFieldInput>;
  Division?: InputMaybe<LabelOwnerDivisionDeleteFieldInput>;
  Person?: InputMaybe<LabelOwnerPersonDeleteFieldInput>;
  Room?: InputMaybe<LabelOwnerRoomDeleteFieldInput>;
  Subject?: InputMaybe<LabelOwnerSubjectDeleteFieldInput>;
  SubjectContainer?: InputMaybe<LabelOwnerSubjectContainerDeleteFieldInput>;
  SubjectGroup?: InputMaybe<LabelOwnerSubjectGroupDeleteFieldInput>;
};

export type LabelOwnerDisconnectInput = {
  Building?: InputMaybe<LabelOwnerBuildingDisconnectFieldInput>;
  Class?: InputMaybe<LabelOwnerClassDisconnectFieldInput>;
  Curriculum?: InputMaybe<LabelOwnerCurriculumDisconnectFieldInput>;
  Division?: InputMaybe<LabelOwnerDivisionDisconnectFieldInput>;
  Person?: InputMaybe<LabelOwnerPersonDisconnectFieldInput>;
  Room?: InputMaybe<LabelOwnerRoomDisconnectFieldInput>;
  Subject?: InputMaybe<LabelOwnerSubjectDisconnectFieldInput>;
  SubjectContainer?: InputMaybe<LabelOwnerSubjectContainerDisconnectFieldInput>;
  SubjectGroup?: InputMaybe<LabelOwnerSubjectGroupDisconnectFieldInput>;
};

export type LabelOwnerDivisionConnectFieldInput = {
  connect?: InputMaybe<DivisionConnectInput>;
  where?: InputMaybe<DivisionConnectWhere>;
};

export type LabelOwnerDivisionConnectOrCreateFieldInput = {
  onCreate: LabelOwnerDivisionConnectOrCreateFieldInputOnCreate;
  where: DivisionConnectOrCreateWhere;
};

export type LabelOwnerDivisionConnectOrCreateFieldInputOnCreate = {
  node: DivisionOnCreateInput;
};

export type LabelOwnerDivisionConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerDivisionConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerDivisionConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerDivisionConnectionWhere>>;
  node?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DivisionWhere>;
};

export type LabelOwnerDivisionCreateFieldInput = {
  node: DivisionCreateInput;
};

export type LabelOwnerDivisionDeleteFieldInput = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<LabelOwnerDivisionConnectionWhere>;
};

export type LabelOwnerDivisionDisconnectFieldInput = {
  disconnect?: InputMaybe<DivisionDisconnectInput>;
  where?: InputMaybe<LabelOwnerDivisionConnectionWhere>;
};

export type LabelOwnerDivisionFieldInput = {
  connect?: InputMaybe<LabelOwnerDivisionConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerDivisionConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerDivisionCreateFieldInput>;
};

export type LabelOwnerDivisionUpdateConnectionInput = {
  node?: InputMaybe<DivisionUpdateInput>;
};

export type LabelOwnerDivisionUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerDivisionConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerDivisionConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerDivisionCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerDivisionDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerDivisionDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerDivisionUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerDivisionConnectionWhere>;
};

export type LabelOwnerPersonConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  where?: InputMaybe<PersonConnectWhere>;
};

export type LabelOwnerPersonConnectOrCreateFieldInput = {
  onCreate: LabelOwnerPersonConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type LabelOwnerPersonConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type LabelOwnerPersonConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerPersonConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerPersonConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerPersonConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type LabelOwnerPersonCreateFieldInput = {
  node: PersonCreateInput;
};

export type LabelOwnerPersonDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<LabelOwnerPersonConnectionWhere>;
};

export type LabelOwnerPersonDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<LabelOwnerPersonConnectionWhere>;
};

export type LabelOwnerPersonFieldInput = {
  connect?: InputMaybe<LabelOwnerPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerPersonCreateFieldInput>;
};

export type LabelOwnerPersonUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type LabelOwnerPersonUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerPersonCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerPersonDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerPersonDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerPersonUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerPersonConnectionWhere>;
};

export type LabelOwnerRelationship = {
  __typename?: 'LabelOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: LabelOwner;
};

export type LabelOwnerRoomConnectFieldInput = {
  connect?: InputMaybe<RoomConnectInput>;
  where?: InputMaybe<RoomConnectWhere>;
};

export type LabelOwnerRoomConnectOrCreateFieldInput = {
  onCreate: LabelOwnerRoomConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type LabelOwnerRoomConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type LabelOwnerRoomConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerRoomConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerRoomConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerRoomConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type LabelOwnerRoomCreateFieldInput = {
  node: RoomCreateInput;
};

export type LabelOwnerRoomDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<LabelOwnerRoomConnectionWhere>;
};

export type LabelOwnerRoomDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<LabelOwnerRoomConnectionWhere>;
};

export type LabelOwnerRoomFieldInput = {
  connect?: InputMaybe<LabelOwnerRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerRoomCreateFieldInput>;
};

export type LabelOwnerRoomUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type LabelOwnerRoomUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerRoomCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerRoomDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerRoomDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerRoomUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerRoomConnectionWhere>;
};

export type LabelOwnerSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  where?: InputMaybe<SubjectConnectWhere>;
};

export type LabelOwnerSubjectConnectOrCreateFieldInput = {
  onCreate: LabelOwnerSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type LabelOwnerSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type LabelOwnerSubjectConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerSubjectConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerSubjectConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type LabelOwnerSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type LabelOwnerSubjectContainerConnectOrCreateFieldInput = {
  onCreate: LabelOwnerSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type LabelOwnerSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type LabelOwnerSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type LabelOwnerSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type LabelOwnerSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<LabelOwnerSubjectContainerConnectionWhere>;
};

export type LabelOwnerSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<LabelOwnerSubjectContainerConnectionWhere>;
};

export type LabelOwnerSubjectContainerFieldInput = {
  connect?: InputMaybe<LabelOwnerSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerSubjectContainerCreateFieldInput>;
};

export type LabelOwnerSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type LabelOwnerSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerSubjectContainerConnectionWhere>;
};

export type LabelOwnerSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type LabelOwnerSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<LabelOwnerSubjectConnectionWhere>;
};

export type LabelOwnerSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<LabelOwnerSubjectConnectionWhere>;
};

export type LabelOwnerSubjectFieldInput = {
  connect?: InputMaybe<LabelOwnerSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerSubjectCreateFieldInput>;
};

export type LabelOwnerSubjectGroupConnectFieldInput = {
  connect?: InputMaybe<SubjectGroupConnectInput>;
  where?: InputMaybe<SubjectGroupConnectWhere>;
};

export type LabelOwnerSubjectGroupConnectionWhere = {
  AND?: InputMaybe<Array<LabelOwnerSubjectGroupConnectionWhere>>;
  NOT?: InputMaybe<LabelOwnerSubjectGroupConnectionWhere>;
  OR?: InputMaybe<Array<LabelOwnerSubjectGroupConnectionWhere>>;
  node?: InputMaybe<SubjectGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectGroupWhere>;
};

export type LabelOwnerSubjectGroupCreateFieldInput = {
  node: SubjectGroupCreateInput;
};

export type LabelOwnerSubjectGroupDeleteFieldInput = {
  delete?: InputMaybe<SubjectGroupDeleteInput>;
  where?: InputMaybe<LabelOwnerSubjectGroupConnectionWhere>;
};

export type LabelOwnerSubjectGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectGroupDisconnectInput>;
  where?: InputMaybe<LabelOwnerSubjectGroupConnectionWhere>;
};

export type LabelOwnerSubjectGroupFieldInput = {
  connect?: InputMaybe<LabelOwnerSubjectGroupConnectFieldInput>;
  create?: InputMaybe<LabelOwnerSubjectGroupCreateFieldInput>;
};

export type LabelOwnerSubjectGroupUpdateConnectionInput = {
  node?: InputMaybe<SubjectGroupUpdateInput>;
};

export type LabelOwnerSubjectGroupUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerSubjectGroupConnectFieldInput>;
  create?: InputMaybe<LabelOwnerSubjectGroupCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerSubjectGroupDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerSubjectGroupDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerSubjectGroupUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerSubjectGroupConnectionWhere>;
};

export type LabelOwnerSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type LabelOwnerSubjectUpdateFieldInput = {
  connect?: InputMaybe<LabelOwnerSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<LabelOwnerSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<LabelOwnerSubjectCreateFieldInput>;
  delete?: InputMaybe<LabelOwnerSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<LabelOwnerSubjectDisconnectFieldInput>;
  update?: InputMaybe<LabelOwnerSubjectUpdateConnectionInput>;
  where?: InputMaybe<LabelOwnerSubjectConnectionWhere>;
};

export type LabelOwnerUpdateInput = {
  Building?: InputMaybe<LabelOwnerBuildingUpdateFieldInput>;
  Class?: InputMaybe<LabelOwnerClassUpdateFieldInput>;
  Curriculum?: InputMaybe<LabelOwnerCurriculumUpdateFieldInput>;
  Division?: InputMaybe<LabelOwnerDivisionUpdateFieldInput>;
  Person?: InputMaybe<LabelOwnerPersonUpdateFieldInput>;
  Room?: InputMaybe<LabelOwnerRoomUpdateFieldInput>;
  Subject?: InputMaybe<LabelOwnerSubjectUpdateFieldInput>;
  SubjectContainer?: InputMaybe<LabelOwnerSubjectContainerUpdateFieldInput>;
  SubjectGroup?: InputMaybe<LabelOwnerSubjectGroupUpdateFieldInput>;
};

export type LabelOwnerWhere = {
  Building?: InputMaybe<BuildingWhere>;
  Class?: InputMaybe<ClassWhere>;
  Curriculum?: InputMaybe<CurriculumWhere>;
  Division?: InputMaybe<DivisionWhere>;
  Person?: InputMaybe<PersonWhere>;
  Room?: InputMaybe<RoomWhere>;
  Subject?: InputMaybe<SubjectWhere>;
  SubjectContainer?: InputMaybe<SubjectContainerWhere>;
  SubjectGroup?: InputMaybe<SubjectGroupWhere>;
};

/** Fields to sort Labels by. The order in which sorts are applied is not guaranteed when specifying many fields in one LabelSort object. */
export type LabelSort = {
  color?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type LabelUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<LabelOwnerUpdateInput>;
};

export type LabelWhere = {
  AND?: InputMaybe<Array<LabelWhere>>;
  NOT?: InputMaybe<LabelWhere>;
  OR?: InputMaybe<Array<LabelWhere>>;
  color?: InputMaybe<Scalars['String']['input']>;
  color_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  color_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<LabelOwnerWhere>;
  ownerConnection?: InputMaybe<LabelOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<LabelOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<LabelOwnerWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type LabelsConnection = {
  __typename?: 'LabelsConnection';
  edges: Array<LabelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Lesson = {
  __typename?: 'Lesson';
  activeTeachingBlocks?: Maybe<Array<Timetable>>;
  activeTimetables?: Maybe<Array<Timetable>>;
  classSort: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curriculum?: Maybe<Curriculum>;
  curriculumAggregate?: Maybe<LessonCurriculumCurriculumAggregationSelection>;
  curriculumConnection: LessonCurriculumConnection;
  displayName: Array<Scalars['String']['output']>;
  elective?: Maybe<Scalars['Boolean']['output']>;
  events: Array<Event>;
  eventsConnection: LessonEventsConnection;
  foreignId?: Maybe<Scalars['String']['output']>;
  gradeGroupUuid?: Maybe<Array<Scalars['ID']['output']>>;
  groupClassNames: Scalars['String']['output'];
  isClassTrip?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<Label>;
  labelsConnection: LessonLabelsConnection;
  lessonClasses: Array<LessonClass>;
  lessonClassesAggregate?: Maybe<LessonLessonClassLessonClassesAggregationSelection>;
  lessonClassesConnection: LessonLessonClassesConnection;
  lessonUnit: Array<LessonUnit>;
  lessonUnitAggregate?: Maybe<LessonLessonUnitLessonUnitAggregationSelection>;
  lessonUnitConnection: LessonLessonUnitConnection;
  onlyInTimetableVersion: Scalars['Boolean']['output'];
  organization: Organization;
  organizationConnection: LessonOrganizationConnection;
  placedCardsCount?: Maybe<Scalars['Int']['output']>;
  roomSupply: Array<Room>;
  roomSupplyAggregate?: Maybe<LessonRoomRoomSupplyAggregationSelection>;
  roomSupplyConnection: LessonRoomSupplyConnection;
  schoolYear: SchoolYear;
  schoolYearConnection: LessonSchoolYearConnection;
  subTitle?: Maybe<Scalars['String']['output']>;
  subject: SubjectContainerOrSubject;
  subjectConnection: LessonSubjectConnection;
  subjectName: Scalars['String']['output'];
  teachers: Array<Person>;
  teachersAggregate?: Maybe<LessonPersonTeachersAggregationSelection>;
  teachersConnection: LessonTeachersConnection;
  teachersSort: Scalars['String']['output'];
  teachingBlockCards: Array<TeachingBlockCard>;
  teachingBlockCardsAggregate?: Maybe<LessonTeachingBlockCardTeachingBlockCardsAggregationSelection>;
  teachingBlockCardsConnection: LessonTeachingBlockCardsConnection;
  teachingBlockPlacedCardsCount?: Maybe<Scalars['Int']['output']>;
  teachingBlockVersions: Array<TeachingBlockVersion>;
  teachingBlockVersionsConnection: LessonTeachingBlockVersionsConnection;
  teachingLoadEnabled?: Maybe<Scalars['Boolean']['output']>;
  timetableCards: Array<TimetableCard>;
  timetableCardsAggregate?: Maybe<LessonTimetableCardTimetableCardsAggregationSelection>;
  timetableCardsConnection: LessonTimetableCardsConnection;
  timetableEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  versions: Array<TimetableVersion>;
  versionsConnection: LessonVersionsConnection;
};

export type LessonCurriculumArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumOptions>;
  where?: InputMaybe<CurriculumWhere>;
};

export type LessonCurriculumAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurriculumWhere>;
};

export type LessonCurriculumConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonCurriculumConnectionSort>>;
  where?: InputMaybe<LessonCurriculumConnectionWhere>;
};

export type LessonEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type LessonEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonEventsConnectionSort>>;
  where?: InputMaybe<LessonEventsConnectionWhere>;
};

export type LessonLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type LessonLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonLabelsConnectionSort>>;
  where?: InputMaybe<LessonLabelsConnectionWhere>;
};

export type LessonLessonClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonClassOptions>;
  where?: InputMaybe<LessonClassWhere>;
};

export type LessonLessonClassesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonClassWhere>;
};

export type LessonLessonClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonLessonClassesConnectionSort>>;
  where?: InputMaybe<LessonLessonClassesConnectionWhere>;
};

export type LessonLessonUnitArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonUnitOptions>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type LessonLessonUnitAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type LessonLessonUnitConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonLessonUnitConnectionSort>>;
  where?: InputMaybe<LessonLessonUnitConnectionWhere>;
};

export type LessonOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type LessonOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonOrganizationConnectionSort>>;
  where?: InputMaybe<LessonOrganizationConnectionWhere>;
};

export type LessonRoomSupplyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type LessonRoomSupplyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoomWhere>;
};

export type LessonRoomSupplyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonRoomSupplyConnectionSort>>;
  where?: InputMaybe<LessonRoomSupplyConnectionWhere>;
};

export type LessonSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type LessonSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonSchoolYearConnectionSort>>;
  where?: InputMaybe<LessonSchoolYearConnectionWhere>;
};

export type LessonSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<SubjectContainerOrSubjectWhere>;
};

export type LessonSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LessonSubjectConnectionWhere>;
};

export type LessonTeachersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type LessonTeachersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PersonWhere>;
};

export type LessonTeachersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonTeachersConnectionSort>>;
  where?: InputMaybe<LessonTeachersConnectionWhere>;
};

export type LessonTeachingBlockCardsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockCardOptions>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type LessonTeachingBlockCardsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type LessonTeachingBlockCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonTeachingBlockCardsConnectionSort>>;
  where?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
};

export type LessonTeachingBlockVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockVersionOptions>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type LessonTeachingBlockVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonTeachingBlockVersionsConnectionSort>>;
  where?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
};

export type LessonTimetableCardsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableCardOptions>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type LessonTimetableCardsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type LessonTimetableCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonTimetableCardsConnectionSort>>;
  where?: InputMaybe<LessonTimetableCardsConnectionWhere>;
};

export type LessonVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type LessonVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonVersionsConnectionSort>>;
  where?: InputMaybe<LessonVersionsConnectionWhere>;
};

export type LessonAggregateSelection = {
  __typename?: 'LessonAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  subTitle: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonClass = {
  __typename?: 'LessonClass';
  class: Class;
  classConnection: LessonClassClassConnection;
  groups: Array<Group>;
  groupsAggregate?: Maybe<LessonClassGroupGroupsAggregationSelection>;
  groupsConnection: LessonClassGroupsConnection;
  lesson?: Maybe<Lesson>;
  lessonAggregate?: Maybe<LessonClassLessonLessonAggregationSelection>;
  lessonConnection: LessonClassLessonConnection;
  usedDivision?: Maybe<Division>;
  uuid: Scalars['ID']['output'];
};

export type LessonClassClassArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type LessonClassClassConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonClassClassConnectionSort>>;
  where?: InputMaybe<LessonClassClassConnectionWhere>;
};

export type LessonClassGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type LessonClassGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GroupWhere>;
};

export type LessonClassGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonClassGroupsConnectionSort>>;
  where?: InputMaybe<LessonClassGroupsConnectionWhere>;
};

export type LessonClassLessonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type LessonClassLessonAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonWhere>;
};

export type LessonClassLessonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonClassLessonConnectionSort>>;
  where?: InputMaybe<LessonClassLessonConnectionWhere>;
};

export type LessonClassAggregateSelection = {
  __typename?: 'LessonClassAggregateSelection';
  count: Scalars['Int']['output'];
  uuid: IdAggregateSelection;
};

export type LessonClassClassAggregateInput = {
  AND?: InputMaybe<Array<LessonClassClassAggregateInput>>;
  NOT?: InputMaybe<LessonClassClassAggregateInput>;
  OR?: InputMaybe<Array<LessonClassClassAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonClassClassNodeAggregationWhereInput>;
};

export type LessonClassClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type LessonClassClassConnectOrCreateFieldInput = {
  onCreate: LessonClassClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type LessonClassClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type LessonClassClassConnection = {
  __typename?: 'LessonClassClassConnection';
  edges: Array<LessonClassClassRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonClassClassConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type LessonClassClassConnectionWhere = {
  AND?: InputMaybe<Array<LessonClassClassConnectionWhere>>;
  NOT?: InputMaybe<LessonClassClassConnectionWhere>;
  OR?: InputMaybe<Array<LessonClassClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type LessonClassClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type LessonClassClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<LessonClassClassConnectionWhere>;
};

export type LessonClassClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<LessonClassClassConnectionWhere>;
};

export type LessonClassClassFieldInput = {
  connect?: InputMaybe<LessonClassClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonClassClassConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonClassClassCreateFieldInput>;
};

export type LessonClassClassNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonClassClassNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonClassClassNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonClassClassNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonClassClassRelationship = {
  __typename?: 'LessonClassClassRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type LessonClassClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type LessonClassClassUpdateFieldInput = {
  connect?: InputMaybe<LessonClassClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonClassClassConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonClassClassCreateFieldInput>;
  delete?: InputMaybe<LessonClassClassDeleteFieldInput>;
  disconnect?: InputMaybe<LessonClassClassDisconnectFieldInput>;
  update?: InputMaybe<LessonClassClassUpdateConnectionInput>;
  where?: InputMaybe<LessonClassClassConnectionWhere>;
};

export type LessonClassConnectInput = {
  class?: InputMaybe<LessonClassClassConnectFieldInput>;
  groups?: InputMaybe<Array<LessonClassGroupsConnectFieldInput>>;
  lesson?: InputMaybe<LessonClassLessonConnectFieldInput>;
};

export type LessonClassConnectWhere = {
  node: LessonClassWhere;
};

export type LessonClassCreateInput = {
  class?: InputMaybe<LessonClassClassFieldInput>;
  groups?: InputMaybe<LessonClassGroupsFieldInput>;
  lesson?: InputMaybe<LessonClassLessonFieldInput>;
};

export type LessonClassDeleteInput = {
  class?: InputMaybe<LessonClassClassDeleteFieldInput>;
  groups?: InputMaybe<Array<LessonClassGroupsDeleteFieldInput>>;
  lesson?: InputMaybe<LessonClassLessonDeleteFieldInput>;
};

export type LessonClassDisconnectInput = {
  class?: InputMaybe<LessonClassClassDisconnectFieldInput>;
  groups?: InputMaybe<Array<LessonClassGroupsDisconnectFieldInput>>;
  lesson?: InputMaybe<LessonClassLessonDisconnectFieldInput>;
};

export type LessonClassEdge = {
  __typename?: 'LessonClassEdge';
  cursor: Scalars['String']['output'];
  node: LessonClass;
};

export type LessonClassGroupGroupsAggregationSelection = {
  __typename?: 'LessonClassGroupGroupsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LessonClassGroupGroupsNodeAggregateSelection>;
};

export type LessonClassGroupGroupsNodeAggregateSelection = {
  __typename?: 'LessonClassGroupGroupsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonClassGroupsAggregateInput = {
  AND?: InputMaybe<Array<LessonClassGroupsAggregateInput>>;
  NOT?: InputMaybe<LessonClassGroupsAggregateInput>;
  OR?: InputMaybe<Array<LessonClassGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonClassGroupsNodeAggregationWhereInput>;
};

export type LessonClassGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<GroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GroupConnectWhere>;
};

export type LessonClassGroupsConnectOrCreateFieldInput = {
  onCreate: LessonClassGroupsConnectOrCreateFieldInputOnCreate;
  where: GroupConnectOrCreateWhere;
};

export type LessonClassGroupsConnectOrCreateFieldInputOnCreate = {
  node: GroupOnCreateInput;
};

export type LessonClassGroupsConnection = {
  __typename?: 'LessonClassGroupsConnection';
  edges: Array<LessonClassGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonClassGroupsConnectionSort = {
  node?: InputMaybe<GroupSort>;
};

export type LessonClassGroupsConnectionWhere = {
  AND?: InputMaybe<Array<LessonClassGroupsConnectionWhere>>;
  NOT?: InputMaybe<LessonClassGroupsConnectionWhere>;
  OR?: InputMaybe<Array<LessonClassGroupsConnectionWhere>>;
  node?: InputMaybe<GroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GroupWhere>;
};

export type LessonClassGroupsCreateFieldInput = {
  node: GroupCreateInput;
};

export type LessonClassGroupsDeleteFieldInput = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<LessonClassGroupsConnectionWhere>;
};

export type LessonClassGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<GroupDisconnectInput>;
  where?: InputMaybe<LessonClassGroupsConnectionWhere>;
};

export type LessonClassGroupsFieldInput = {
  connect?: InputMaybe<Array<LessonClassGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonClassGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonClassGroupsCreateFieldInput>>;
};

export type LessonClassGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonClassGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonClassGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonClassGroupsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonClassGroupsRelationship = {
  __typename?: 'LessonClassGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: Group;
};

export type LessonClassGroupsUpdateConnectionInput = {
  node?: InputMaybe<GroupUpdateInput>;
};

export type LessonClassGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonClassGroupsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonClassGroupsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonClassGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonClassGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonClassGroupsDisconnectFieldInput>>;
  update?: InputMaybe<LessonClassGroupsUpdateConnectionInput>;
  where?: InputMaybe<LessonClassGroupsConnectionWhere>;
};

export type LessonClassInterface = {
  __typename?: 'LessonClassInterface';
  class: ClassInterface;
  groups: Array<Group>;
};

export type LessonClassLessonAggregateInput = {
  AND?: InputMaybe<Array<LessonClassLessonAggregateInput>>;
  NOT?: InputMaybe<LessonClassLessonAggregateInput>;
  OR?: InputMaybe<Array<LessonClassLessonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonClassLessonNodeAggregationWhereInput>;
};

export type LessonClassLessonConnectFieldInput = {
  connect?: InputMaybe<LessonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type LessonClassLessonConnectOrCreateFieldInput = {
  onCreate: LessonClassLessonConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type LessonClassLessonConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type LessonClassLessonConnection = {
  __typename?: 'LessonClassLessonConnection';
  edges: Array<LessonClassLessonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonClassLessonConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type LessonClassLessonConnectionWhere = {
  AND?: InputMaybe<Array<LessonClassLessonConnectionWhere>>;
  NOT?: InputMaybe<LessonClassLessonConnectionWhere>;
  OR?: InputMaybe<Array<LessonClassLessonConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type LessonClassLessonCreateFieldInput = {
  node: LessonCreateInput;
};

export type LessonClassLessonDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<LessonClassLessonConnectionWhere>;
};

export type LessonClassLessonDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<LessonClassLessonConnectionWhere>;
};

export type LessonClassLessonFieldInput = {
  connect?: InputMaybe<LessonClassLessonConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonClassLessonConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonClassLessonCreateFieldInput>;
};

export type LessonClassLessonLessonAggregationSelection = {
  __typename?: 'LessonClassLessonLessonAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LessonClassLessonLessonNodeAggregateSelection>;
};

export type LessonClassLessonLessonNodeAggregateSelection = {
  __typename?: 'LessonClassLessonLessonNodeAggregateSelection';
  comment: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  subTitle: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonClassLessonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonClassLessonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonClassLessonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonClassLessonNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonClassLessonRelationship = {
  __typename?: 'LessonClassLessonRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type LessonClassLessonUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type LessonClassLessonUpdateFieldInput = {
  connect?: InputMaybe<LessonClassLessonConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonClassLessonConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonClassLessonCreateFieldInput>;
  delete?: InputMaybe<LessonClassLessonDeleteFieldInput>;
  disconnect?: InputMaybe<LessonClassLessonDisconnectFieldInput>;
  update?: InputMaybe<LessonClassLessonUpdateConnectionInput>;
  where?: InputMaybe<LessonClassLessonConnectionWhere>;
};

export type LessonClassOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LessonClassSort objects to sort LessonClasses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LessonClassSort>>;
};

/** Fields to sort LessonClasses by. The order in which sorts are applied is not guaranteed when specifying many fields in one LessonClassSort object. */
export type LessonClassSort = {
  usedDivision?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type LessonClassUpdateInput = {
  class?: InputMaybe<LessonClassClassUpdateFieldInput>;
  groups?: InputMaybe<Array<LessonClassGroupsUpdateFieldInput>>;
  lesson?: InputMaybe<LessonClassLessonUpdateFieldInput>;
};

export type LessonClassWhere = {
  AND?: InputMaybe<Array<LessonClassWhere>>;
  NOT?: InputMaybe<LessonClassWhere>;
  OR?: InputMaybe<Array<LessonClassWhere>>;
  class?: InputMaybe<ClassWhere>;
  classAggregate?: InputMaybe<LessonClassClassAggregateInput>;
  classConnection?: InputMaybe<LessonClassClassConnectionWhere>;
  classConnection_NOT?: InputMaybe<LessonClassClassConnectionWhere>;
  class_NOT?: InputMaybe<ClassWhere>;
  /** @deprecated Use `groups_SOME` instead. */
  groups?: InputMaybe<GroupWhere>;
  groupsAggregate?: InputMaybe<LessonClassGroupsAggregateInput>;
  /** @deprecated Use `groupsConnection_SOME` instead. */
  groupsConnection?: InputMaybe<LessonClassGroupsConnectionWhere>;
  /** Return LessonClasses where all of the related LessonClassGroupsConnections match this filter */
  groupsConnection_ALL?: InputMaybe<LessonClassGroupsConnectionWhere>;
  /** Return LessonClasses where none of the related LessonClassGroupsConnections match this filter */
  groupsConnection_NONE?: InputMaybe<LessonClassGroupsConnectionWhere>;
  /** @deprecated Use `groupsConnection_NONE` instead. */
  groupsConnection_NOT?: InputMaybe<LessonClassGroupsConnectionWhere>;
  /** Return LessonClasses where one of the related LessonClassGroupsConnections match this filter */
  groupsConnection_SINGLE?: InputMaybe<LessonClassGroupsConnectionWhere>;
  /** Return LessonClasses where some of the related LessonClassGroupsConnections match this filter */
  groupsConnection_SOME?: InputMaybe<LessonClassGroupsConnectionWhere>;
  /** Return LessonClasses where all of the related Groups match this filter */
  groups_ALL?: InputMaybe<GroupWhere>;
  /** Return LessonClasses where none of the related Groups match this filter */
  groups_NONE?: InputMaybe<GroupWhere>;
  /** @deprecated Use `groups_NONE` instead. */
  groups_NOT?: InputMaybe<GroupWhere>;
  /** Return LessonClasses where one of the related Groups match this filter */
  groups_SINGLE?: InputMaybe<GroupWhere>;
  /** Return LessonClasses where some of the related Groups match this filter */
  groups_SOME?: InputMaybe<GroupWhere>;
  lesson?: InputMaybe<LessonWhere>;
  lessonAggregate?: InputMaybe<LessonClassLessonAggregateInput>;
  lessonConnection?: InputMaybe<LessonClassLessonConnectionWhere>;
  lessonConnection_NOT?: InputMaybe<LessonClassLessonConnectionWhere>;
  lesson_NOT?: InputMaybe<LessonWhere>;
  usedDivision?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  usedDivision_NOT?: InputMaybe<DivisionWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type LessonClassesConnection = {
  __typename?: 'LessonClassesConnection';
  edges: Array<LessonClassEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonConnectInput = {
  curriculum?: InputMaybe<LessonCurriculumConnectFieldInput>;
  labels?: InputMaybe<Array<LessonLabelsConnectFieldInput>>;
  lessonClasses?: InputMaybe<Array<LessonLessonClassesConnectFieldInput>>;
  lessonUnit?: InputMaybe<Array<LessonLessonUnitConnectFieldInput>>;
  organization?: InputMaybe<LessonOrganizationConnectFieldInput>;
  roomSupply?: InputMaybe<Array<LessonRoomSupplyConnectFieldInput>>;
  schoolYear?: InputMaybe<LessonSchoolYearConnectFieldInput>;
  subject?: InputMaybe<LessonSubjectConnectInput>;
  teachers?: InputMaybe<Array<LessonTeachersConnectFieldInput>>;
  teachingBlockCards?: InputMaybe<Array<LessonTeachingBlockCardsConnectFieldInput>>;
  teachingBlockVersions?: InputMaybe<Array<LessonTeachingBlockVersionsConnectFieldInput>>;
  timetableCards?: InputMaybe<Array<LessonTimetableCardsConnectFieldInput>>;
  versions?: InputMaybe<Array<LessonVersionsConnectFieldInput>>;
};

export type LessonConnectOrCreateWhere = {
  node: LessonUniqueWhere;
};

export type LessonConnectWhere = {
  node: LessonWhere;
};

export type LessonCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  curriculum?: InputMaybe<LessonCurriculumFieldInput>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<LessonLabelsFieldInput>;
  lessonClasses?: InputMaybe<LessonLessonClassesFieldInput>;
  lessonUnit?: InputMaybe<LessonLessonUnitFieldInput>;
  onlyInTimetableVersion: Scalars['Boolean']['input'];
  organization?: InputMaybe<LessonOrganizationFieldInput>;
  roomSupply?: InputMaybe<LessonRoomSupplyFieldInput>;
  schoolYear?: InputMaybe<LessonSchoolYearFieldInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<LessonSubjectCreateInput>;
  teachers?: InputMaybe<LessonTeachersFieldInput>;
  teachingBlockCards?: InputMaybe<LessonTeachingBlockCardsFieldInput>;
  teachingBlockVersions?: InputMaybe<LessonTeachingBlockVersionsFieldInput>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableCards?: InputMaybe<LessonTimetableCardsFieldInput>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  versions?: InputMaybe<LessonVersionsFieldInput>;
};

export type LessonCurriculumAggregateInput = {
  AND?: InputMaybe<Array<LessonCurriculumAggregateInput>>;
  NOT?: InputMaybe<LessonCurriculumAggregateInput>;
  OR?: InputMaybe<Array<LessonCurriculumAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonCurriculumNodeAggregationWhereInput>;
};

export type LessonCurriculumConnectFieldInput = {
  connect?: InputMaybe<CurriculumConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumConnectWhere>;
};

export type LessonCurriculumConnectOrCreateFieldInput = {
  onCreate: LessonCurriculumConnectOrCreateFieldInputOnCreate;
  where: CurriculumConnectOrCreateWhere;
};

export type LessonCurriculumConnectOrCreateFieldInputOnCreate = {
  node: CurriculumOnCreateInput;
};

export type LessonCurriculumConnection = {
  __typename?: 'LessonCurriculumConnection';
  edges: Array<LessonCurriculumRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonCurriculumConnectionSort = {
  node?: InputMaybe<CurriculumSort>;
};

export type LessonCurriculumConnectionWhere = {
  AND?: InputMaybe<Array<LessonCurriculumConnectionWhere>>;
  NOT?: InputMaybe<LessonCurriculumConnectionWhere>;
  OR?: InputMaybe<Array<LessonCurriculumConnectionWhere>>;
  node?: InputMaybe<CurriculumWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumWhere>;
};

export type LessonCurriculumCreateFieldInput = {
  node: CurriculumCreateInput;
};

export type LessonCurriculumCurriculumAggregationSelection = {
  __typename?: 'LessonCurriculumCurriculumAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LessonCurriculumCurriculumNodeAggregateSelection>;
};

export type LessonCurriculumCurriculumNodeAggregateSelection = {
  __typename?: 'LessonCurriculumCurriculumNodeAggregateSelection';
  comment: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  subTitle: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonCurriculumDeleteFieldInput = {
  delete?: InputMaybe<CurriculumDeleteInput>;
  where?: InputMaybe<LessonCurriculumConnectionWhere>;
};

export type LessonCurriculumDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumDisconnectInput>;
  where?: InputMaybe<LessonCurriculumConnectionWhere>;
};

export type LessonCurriculumFieldInput = {
  connect?: InputMaybe<LessonCurriculumConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonCurriculumConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonCurriculumCreateFieldInput>;
};

export type LessonCurriculumNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonCurriculumNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonCurriculumNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonCurriculumNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonCurriculumRelationship = {
  __typename?: 'LessonCurriculumRelationship';
  cursor: Scalars['String']['output'];
  node: Curriculum;
};

export type LessonCurriculumUpdateConnectionInput = {
  node?: InputMaybe<CurriculumUpdateInput>;
};

export type LessonCurriculumUpdateFieldInput = {
  connect?: InputMaybe<LessonCurriculumConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonCurriculumConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonCurriculumCreateFieldInput>;
  delete?: InputMaybe<LessonCurriculumDeleteFieldInput>;
  disconnect?: InputMaybe<LessonCurriculumDisconnectFieldInput>;
  update?: InputMaybe<LessonCurriculumUpdateConnectionInput>;
  where?: InputMaybe<LessonCurriculumConnectionWhere>;
};

export type LessonDeleteInput = {
  curriculum?: InputMaybe<LessonCurriculumDeleteFieldInput>;
  labels?: InputMaybe<Array<LessonLabelsDeleteFieldInput>>;
  lessonClasses?: InputMaybe<Array<LessonLessonClassesDeleteFieldInput>>;
  lessonUnit?: InputMaybe<Array<LessonLessonUnitDeleteFieldInput>>;
  organization?: InputMaybe<LessonOrganizationDeleteFieldInput>;
  roomSupply?: InputMaybe<Array<LessonRoomSupplyDeleteFieldInput>>;
  schoolYear?: InputMaybe<LessonSchoolYearDeleteFieldInput>;
  subject?: InputMaybe<LessonSubjectDeleteInput>;
  teachers?: InputMaybe<Array<LessonTeachersDeleteFieldInput>>;
  teachingBlockCards?: InputMaybe<Array<LessonTeachingBlockCardsDeleteFieldInput>>;
  teachingBlockVersions?: InputMaybe<Array<LessonTeachingBlockVersionsDeleteFieldInput>>;
  timetableCards?: InputMaybe<Array<LessonTimetableCardsDeleteFieldInput>>;
  versions?: InputMaybe<Array<LessonVersionsDeleteFieldInput>>;
};

export type LessonDisconnectInput = {
  curriculum?: InputMaybe<LessonCurriculumDisconnectFieldInput>;
  labels?: InputMaybe<Array<LessonLabelsDisconnectFieldInput>>;
  lessonClasses?: InputMaybe<Array<LessonLessonClassesDisconnectFieldInput>>;
  lessonUnit?: InputMaybe<Array<LessonLessonUnitDisconnectFieldInput>>;
  organization?: InputMaybe<LessonOrganizationDisconnectFieldInput>;
  roomSupply?: InputMaybe<Array<LessonRoomSupplyDisconnectFieldInput>>;
  schoolYear?: InputMaybe<LessonSchoolYearDisconnectFieldInput>;
  subject?: InputMaybe<LessonSubjectDisconnectInput>;
  teachers?: InputMaybe<Array<LessonTeachersDisconnectFieldInput>>;
  teachingBlockCards?: InputMaybe<Array<LessonTeachingBlockCardsDisconnectFieldInput>>;
  teachingBlockVersions?: InputMaybe<Array<LessonTeachingBlockVersionsDisconnectFieldInput>>;
  timetableCards?: InputMaybe<Array<LessonTimetableCardsDisconnectFieldInput>>;
  versions?: InputMaybe<Array<LessonVersionsDisconnectFieldInput>>;
};

export type LessonEdge = {
  __typename?: 'LessonEdge';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type LessonEventsAggregateInput = {
  AND?: InputMaybe<Array<LessonEventsAggregateInput>>;
  NOT?: InputMaybe<LessonEventsAggregateInput>;
  OR?: InputMaybe<Array<LessonEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonEventsNodeAggregationWhereInput>;
};

export type LessonEventsConnection = {
  __typename?: 'LessonEventsConnection';
  edges: Array<LessonEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type LessonEventsConnectionWhere = {
  AND?: InputMaybe<Array<LessonEventsConnectionWhere>>;
  NOT?: InputMaybe<LessonEventsConnectionWhere>;
  OR?: InputMaybe<Array<LessonEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type LessonEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonEventsRelationship = {
  __typename?: 'LessonEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type LessonInterface = {
  __typename?: 'LessonInterface';
  comment?: Maybe<Scalars['String']['output']>;
  displayName: Array<Scalars['String']['output']>;
  elective?: Maybe<Scalars['Boolean']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  lessonClasses: Array<LessonClassInterface>;
  lessonUnit: Array<LessonUnit>;
  onlyInTimetableVersion: Scalars['Boolean']['output'];
  organization: Organization;
  roomSupply: Array<Room>;
  subTitle?: Maybe<Scalars['String']['output']>;
  subject: SubjectContainerOrSubject;
  subjectConnection: LessonInterfaceSubjectConnection;
  teachers: Array<Person>;
  teachingLoadEnabled?: Maybe<Scalars['Boolean']['output']>;
  timetableEnabled?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type LessonInterfaceSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<SubjectContainerOrSubjectWhere>;
};

export type LessonInterfaceSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LessonInterfaceSubjectConnectionWhere>;
};

export type LessonInterfaceSubjectConnection = {
  __typename?: 'LessonInterfaceSubjectConnection';
  edges: Array<LessonInterfaceSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonInterfaceSubjectConnectionWhere = {
  Subject?: InputMaybe<LessonInterfaceSubjectSubjectConnectionWhere>;
  SubjectContainer?: InputMaybe<LessonInterfaceSubjectSubjectContainerConnectionWhere>;
};

export type LessonInterfaceSubjectRelationship = {
  __typename?: 'LessonInterfaceSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainerOrSubject;
};

export type LessonInterfaceSubjectSubjectConnectionWhere = {
  AND?: InputMaybe<Array<LessonInterfaceSubjectSubjectConnectionWhere>>;
  NOT?: InputMaybe<LessonInterfaceSubjectSubjectConnectionWhere>;
  OR?: InputMaybe<Array<LessonInterfaceSubjectSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type LessonInterfaceSubjectSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<LessonInterfaceSubjectSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<LessonInterfaceSubjectSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<LessonInterfaceSubjectSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type LessonLabelsAggregateInput = {
  AND?: InputMaybe<Array<LessonLabelsAggregateInput>>;
  NOT?: InputMaybe<LessonLabelsAggregateInput>;
  OR?: InputMaybe<Array<LessonLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonLabelsNodeAggregationWhereInput>;
};

export type LessonLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type LessonLabelsConnection = {
  __typename?: 'LessonLabelsConnection';
  edges: Array<LessonLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type LessonLabelsConnectionWhere = {
  AND?: InputMaybe<Array<LessonLabelsConnectionWhere>>;
  NOT?: InputMaybe<LessonLabelsConnectionWhere>;
  OR?: InputMaybe<Array<LessonLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type LessonLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type LessonLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<LessonLabelsConnectionWhere>;
};

export type LessonLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<LessonLabelsConnectionWhere>;
};

export type LessonLabelsFieldInput = {
  connect?: InputMaybe<Array<LessonLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<LessonLabelsCreateFieldInput>>;
};

export type LessonLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonLabelsRelationship = {
  __typename?: 'LessonLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type LessonLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type LessonLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<LessonLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonLabelsDisconnectFieldInput>>;
  update?: InputMaybe<LessonLabelsUpdateConnectionInput>;
  where?: InputMaybe<LessonLabelsConnectionWhere>;
};

export type LessonLessonClassLessonClassesAggregationSelection = {
  __typename?: 'LessonLessonClassLessonClassesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<LessonLessonClassLessonClassesEdgeAggregateSelection>;
  node?: Maybe<LessonLessonClassLessonClassesNodeAggregateSelection>;
};

export type LessonLessonClassLessonClassesEdgeAggregateSelection = {
  __typename?: 'LessonLessonClassLessonClassesEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type LessonLessonClassLessonClassesNodeAggregateSelection = {
  __typename?: 'LessonLessonClassLessonClassesNodeAggregateSelection';
  uuid: IdAggregateSelection;
};

export type LessonLessonClassesAggregateInput = {
  AND?: InputMaybe<Array<LessonLessonClassesAggregateInput>>;
  NOT?: InputMaybe<LessonLessonClassesAggregateInput>;
  OR?: InputMaybe<Array<LessonLessonClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<LessonLessonClassesNodeAggregationWhereInput>;
};

export type LessonLessonClassesConnectFieldInput = {
  connect?: InputMaybe<Array<LessonClassConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonClassConnectWhere>;
};

export type LessonLessonClassesConnection = {
  __typename?: 'LessonLessonClassesConnection';
  edges: Array<LessonLessonClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonLessonClassesConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<LessonClassSort>;
};

export type LessonLessonClassesConnectionWhere = {
  AND?: InputMaybe<Array<LessonLessonClassesConnectionWhere>>;
  NOT?: InputMaybe<LessonLessonClassesConnectionWhere>;
  OR?: InputMaybe<Array<LessonLessonClassesConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<LessonClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonClassWhere>;
};

export type LessonLessonClassesCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: LessonClassCreateInput;
};

export type LessonLessonClassesDeleteFieldInput = {
  delete?: InputMaybe<LessonClassDeleteInput>;
  where?: InputMaybe<LessonLessonClassesConnectionWhere>;
};

export type LessonLessonClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonClassDisconnectInput>;
  where?: InputMaybe<LessonLessonClassesConnectionWhere>;
};

export type LessonLessonClassesFieldInput = {
  connect?: InputMaybe<Array<LessonLessonClassesConnectFieldInput>>;
  create?: InputMaybe<Array<LessonLessonClassesCreateFieldInput>>;
};

export type LessonLessonClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonLessonClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonLessonClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonLessonClassesNodeAggregationWhereInput>>;
};

export type LessonLessonClassesRelationship = {
  __typename?: 'LessonLessonClassesRelationship';
  cursor: Scalars['String']['output'];
  node: LessonClass;
  properties: OrderedRelationProperties;
};

export type LessonLessonClassesUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<LessonClassUpdateInput>;
};

export type LessonLessonClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonLessonClassesConnectFieldInput>>;
  create?: InputMaybe<Array<LessonLessonClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonLessonClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonLessonClassesDisconnectFieldInput>>;
  update?: InputMaybe<LessonLessonClassesUpdateConnectionInput>;
  where?: InputMaybe<LessonLessonClassesConnectionWhere>;
};

export type LessonLessonUnitAggregateInput = {
  AND?: InputMaybe<Array<LessonLessonUnitAggregateInput>>;
  NOT?: InputMaybe<LessonLessonUnitAggregateInput>;
  OR?: InputMaybe<Array<LessonLessonUnitAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<LessonLessonUnitNodeAggregationWhereInput>;
};

export type LessonLessonUnitConnectFieldInput = {
  connect?: InputMaybe<Array<LessonUnitConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonUnitConnectWhere>;
};

export type LessonLessonUnitConnection = {
  __typename?: 'LessonLessonUnitConnection';
  edges: Array<LessonLessonUnitRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonLessonUnitConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<LessonUnitSort>;
};

export type LessonLessonUnitConnectionWhere = {
  AND?: InputMaybe<Array<LessonLessonUnitConnectionWhere>>;
  NOT?: InputMaybe<LessonLessonUnitConnectionWhere>;
  OR?: InputMaybe<Array<LessonLessonUnitConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<LessonUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonUnitWhere>;
};

export type LessonLessonUnitCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: LessonUnitCreateInput;
};

export type LessonLessonUnitDeleteFieldInput = {
  delete?: InputMaybe<LessonUnitDeleteInput>;
  where?: InputMaybe<LessonLessonUnitConnectionWhere>;
};

export type LessonLessonUnitDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonUnitDisconnectInput>;
  where?: InputMaybe<LessonLessonUnitConnectionWhere>;
};

export type LessonLessonUnitFieldInput = {
  connect?: InputMaybe<Array<LessonLessonUnitConnectFieldInput>>;
  create?: InputMaybe<Array<LessonLessonUnitCreateFieldInput>>;
};

export type LessonLessonUnitLessonUnitAggregationSelection = {
  __typename?: 'LessonLessonUnitLessonUnitAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<LessonLessonUnitLessonUnitEdgeAggregateSelection>;
  node?: Maybe<LessonLessonUnitLessonUnitNodeAggregateSelection>;
};

export type LessonLessonUnitLessonUnitEdgeAggregateSelection = {
  __typename?: 'LessonLessonUnitLessonUnitEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type LessonLessonUnitLessonUnitNodeAggregateSelection = {
  __typename?: 'LessonLessonUnitLessonUnitNodeAggregateSelection';
  count: IntAggregateSelection;
  duration: IntAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonLessonUnitNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonLessonUnitNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonLessonUnitNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonLessonUnitNodeAggregationWhereInput>>;
  count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonLessonUnitRelationship = {
  __typename?: 'LessonLessonUnitRelationship';
  cursor: Scalars['String']['output'];
  node: LessonUnit;
  properties: OrderedRelationProperties;
};

export type LessonLessonUnitUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<LessonUnitUpdateInput>;
};

export type LessonLessonUnitUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonLessonUnitConnectFieldInput>>;
  create?: InputMaybe<Array<LessonLessonUnitCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonLessonUnitDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonLessonUnitDisconnectFieldInput>>;
  update?: InputMaybe<LessonLessonUnitUpdateConnectionInput>;
  where?: InputMaybe<LessonLessonUnitConnectionWhere>;
};

export type LessonOnCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInTimetableVersion: Scalars['Boolean']['input'];
  subTitle?: InputMaybe<Scalars['String']['input']>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LessonSort objects to sort Lessons by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LessonSort>>;
};

export type LessonOrganizationAggregateInput = {
  AND?: InputMaybe<Array<LessonOrganizationAggregateInput>>;
  NOT?: InputMaybe<LessonOrganizationAggregateInput>;
  OR?: InputMaybe<Array<LessonOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonOrganizationNodeAggregationWhereInput>;
};

export type LessonOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type LessonOrganizationConnectOrCreateFieldInput = {
  onCreate: LessonOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type LessonOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type LessonOrganizationConnection = {
  __typename?: 'LessonOrganizationConnection';
  edges: Array<LessonOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type LessonOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<LessonOrganizationConnectionWhere>>;
  NOT?: InputMaybe<LessonOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<LessonOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type LessonOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type LessonOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<LessonOrganizationConnectionWhere>;
};

export type LessonOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<LessonOrganizationConnectionWhere>;
};

export type LessonOrganizationFieldInput = {
  connect?: InputMaybe<LessonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonOrganizationCreateFieldInput>;
};

export type LessonOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonOrganizationRelationship = {
  __typename?: 'LessonOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type LessonOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type LessonOrganizationUpdateFieldInput = {
  connect?: InputMaybe<LessonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonOrganizationCreateFieldInput>;
  delete?: InputMaybe<LessonOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<LessonOrganizationDisconnectFieldInput>;
  update?: InputMaybe<LessonOrganizationUpdateConnectionInput>;
  where?: InputMaybe<LessonOrganizationConnectionWhere>;
};

export type LessonPersonTeachersAggregationSelection = {
  __typename?: 'LessonPersonTeachersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<LessonPersonTeachersEdgeAggregateSelection>;
  node?: Maybe<LessonPersonTeachersNodeAggregateSelection>;
};

export type LessonPersonTeachersEdgeAggregateSelection = {
  __typename?: 'LessonPersonTeachersEdgeAggregateSelection';
  description: StringAggregateSelection;
  order: IntAggregateSelection;
  teachingLoadHours: FloatAggregateSelection;
};

export type LessonPersonTeachersNodeAggregateSelection = {
  __typename?: 'LessonPersonTeachersNodeAggregateSelection';
  callingName: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  displayNameShort: StringAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  gender: StringAggregateSelection;
  lastName: StringAggregateSelection;
  personalId: StringAggregateSelection;
  pimProfileUuid: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  title: StringAggregateSelection;
  uniqueFirstName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

/**
 * The edge properties for the following fields:
 * * Lesson.roomSupply
 * * Curriculum.roomSupply
 * * Room.lessons
 * * Room.curricula
 */
export type LessonRoomRelationshipProperties = {
  __typename?: 'LessonRoomRelationshipProperties';
  descriptions?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
};

export type LessonRoomRelationshipPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonRoomRelationshipPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<LessonRoomRelationshipPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonRoomRelationshipPropertiesAggregationWhereInput>>;
  descriptions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonRoomRelationshipPropertiesCreateInput = {
  descriptions?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
};

export type LessonRoomRelationshipPropertiesSort = {
  descriptions?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type LessonRoomRelationshipPropertiesUpdateInput = {
  descriptions?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonRoomRelationshipPropertiesWhere = {
  AND?: InputMaybe<Array<LessonRoomRelationshipPropertiesWhere>>;
  NOT?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  OR?: InputMaybe<Array<LessonRoomRelationshipPropertiesWhere>>;
  descriptions?: InputMaybe<Scalars['String']['input']>;
  descriptions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptions_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptions_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptions_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptions_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptions_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  descriptions_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LessonRoomRoomSupplyAggregationSelection = {
  __typename?: 'LessonRoomRoomSupplyAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<LessonRoomRoomSupplyEdgeAggregateSelection>;
  node?: Maybe<LessonRoomRoomSupplyNodeAggregateSelection>;
};

export type LessonRoomRoomSupplyEdgeAggregateSelection = {
  __typename?: 'LessonRoomRoomSupplyEdgeAggregateSelection';
  descriptions: StringAggregateSelection;
  order: IntAggregateSelection;
};

export type LessonRoomRoomSupplyNodeAggregateSelection = {
  __typename?: 'LessonRoomRoomSupplyNodeAggregateSelection';
  capacity: IntAggregateSelection;
  chairs: IntAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  otherInventory: StringAggregateSelection;
  position: StringAggregateSelection;
  roomNumber: StringAggregateSelection;
  size: IntAggregateSelection;
  tables: IntAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonRoomSupplyAggregateInput = {
  AND?: InputMaybe<Array<LessonRoomSupplyAggregateInput>>;
  NOT?: InputMaybe<LessonRoomSupplyAggregateInput>;
  OR?: InputMaybe<Array<LessonRoomSupplyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<LessonRoomSupplyNodeAggregationWhereInput>;
};

export type LessonRoomSupplyConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  edge: LessonRoomRelationshipPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type LessonRoomSupplyConnectOrCreateFieldInput = {
  onCreate: LessonRoomSupplyConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type LessonRoomSupplyConnectOrCreateFieldInputOnCreate = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: RoomOnCreateInput;
};

export type LessonRoomSupplyConnection = {
  __typename?: 'LessonRoomSupplyConnection';
  edges: Array<LessonRoomSupplyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonRoomSupplyConnectionSort = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesSort>;
  node?: InputMaybe<RoomSort>;
};

export type LessonRoomSupplyConnectionWhere = {
  AND?: InputMaybe<Array<LessonRoomSupplyConnectionWhere>>;
  NOT?: InputMaybe<LessonRoomSupplyConnectionWhere>;
  OR?: InputMaybe<Array<LessonRoomSupplyConnectionWhere>>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type LessonRoomSupplyCreateFieldInput = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: RoomCreateInput;
};

export type LessonRoomSupplyDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<LessonRoomSupplyConnectionWhere>;
};

export type LessonRoomSupplyDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<LessonRoomSupplyConnectionWhere>;
};

export type LessonRoomSupplyFieldInput = {
  connect?: InputMaybe<Array<LessonRoomSupplyConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonRoomSupplyConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonRoomSupplyCreateFieldInput>>;
};

export type LessonRoomSupplyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonRoomSupplyNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonRoomSupplyNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonRoomSupplyNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonRoomSupplyRelationship = {
  __typename?: 'LessonRoomSupplyRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
  properties: LessonRoomRelationshipProperties;
};

export type LessonRoomSupplyUpdateConnectionInput = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<RoomUpdateInput>;
};

export type LessonRoomSupplyUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonRoomSupplyConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonRoomSupplyConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonRoomSupplyCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonRoomSupplyDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonRoomSupplyDisconnectFieldInput>>;
  update?: InputMaybe<LessonRoomSupplyUpdateConnectionInput>;
  where?: InputMaybe<LessonRoomSupplyConnectionWhere>;
};

export type LessonSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<LessonSchoolYearAggregateInput>>;
  NOT?: InputMaybe<LessonSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<LessonSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonSchoolYearNodeAggregationWhereInput>;
};

export type LessonSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type LessonSchoolYearConnection = {
  __typename?: 'LessonSchoolYearConnection';
  edges: Array<LessonSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type LessonSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<LessonSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<LessonSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<LessonSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type LessonSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type LessonSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<LessonSchoolYearConnectionWhere>;
};

export type LessonSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<LessonSchoolYearConnectionWhere>;
};

export type LessonSchoolYearFieldInput = {
  connect?: InputMaybe<LessonSchoolYearConnectFieldInput>;
  create?: InputMaybe<LessonSchoolYearCreateFieldInput>;
};

export type LessonSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonSchoolYearRelationship = {
  __typename?: 'LessonSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type LessonSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type LessonSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<LessonSchoolYearConnectFieldInput>;
  create?: InputMaybe<LessonSchoolYearCreateFieldInput>;
  delete?: InputMaybe<LessonSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<LessonSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<LessonSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<LessonSchoolYearConnectionWhere>;
};

/** Fields to sort Lessons by. The order in which sorts are applied is not guaranteed when specifying many fields in one LessonSort object. */
export type LessonSort = {
  classSort?: InputMaybe<SortDirection>;
  comment?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  elective?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  isClassTrip?: InputMaybe<SortDirection>;
  onlyInTimetableVersion?: InputMaybe<SortDirection>;
  placedCardsCount?: InputMaybe<SortDirection>;
  subTitle?: InputMaybe<SortDirection>;
  subjectName?: InputMaybe<SortDirection>;
  teachersSort?: InputMaybe<SortDirection>;
  teachingBlockPlacedCardsCount?: InputMaybe<SortDirection>;
  teachingLoadEnabled?: InputMaybe<SortDirection>;
  timetableEnabled?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type LessonSubjectConnectInput = {
  Subject?: InputMaybe<LessonSubjectSubjectConnectFieldInput>;
  SubjectContainer?: InputMaybe<LessonSubjectSubjectContainerConnectFieldInput>;
};

export type LessonSubjectConnection = {
  __typename?: 'LessonSubjectConnection';
  edges: Array<LessonSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonSubjectConnectionWhere = {
  Subject?: InputMaybe<LessonSubjectSubjectConnectionWhere>;
  SubjectContainer?: InputMaybe<LessonSubjectSubjectContainerConnectionWhere>;
};

export type LessonSubjectCreateInput = {
  Subject?: InputMaybe<LessonSubjectSubjectFieldInput>;
  SubjectContainer?: InputMaybe<LessonSubjectSubjectContainerFieldInput>;
};

export type LessonSubjectDeleteInput = {
  Subject?: InputMaybe<LessonSubjectSubjectDeleteFieldInput>;
  SubjectContainer?: InputMaybe<LessonSubjectSubjectContainerDeleteFieldInput>;
};

export type LessonSubjectDisconnectInput = {
  Subject?: InputMaybe<LessonSubjectSubjectDisconnectFieldInput>;
  SubjectContainer?: InputMaybe<LessonSubjectSubjectContainerDisconnectFieldInput>;
};

export type LessonSubjectRelationship = {
  __typename?: 'LessonSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainerOrSubject;
};

export type LessonSubjectSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  where?: InputMaybe<SubjectConnectWhere>;
};

export type LessonSubjectSubjectConnectOrCreateFieldInput = {
  onCreate: LessonSubjectSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type LessonSubjectSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type LessonSubjectSubjectConnectionWhere = {
  AND?: InputMaybe<Array<LessonSubjectSubjectConnectionWhere>>;
  NOT?: InputMaybe<LessonSubjectSubjectConnectionWhere>;
  OR?: InputMaybe<Array<LessonSubjectSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type LessonSubjectSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type LessonSubjectSubjectContainerConnectOrCreateFieldInput = {
  onCreate: LessonSubjectSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type LessonSubjectSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type LessonSubjectSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<LessonSubjectSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<LessonSubjectSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<LessonSubjectSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type LessonSubjectSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type LessonSubjectSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<LessonSubjectSubjectContainerConnectionWhere>;
};

export type LessonSubjectSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<LessonSubjectSubjectContainerConnectionWhere>;
};

export type LessonSubjectSubjectContainerFieldInput = {
  connect?: InputMaybe<LessonSubjectSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonSubjectSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonSubjectSubjectContainerCreateFieldInput>;
};

export type LessonSubjectSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type LessonSubjectSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<LessonSubjectSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonSubjectSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonSubjectSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<LessonSubjectSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<LessonSubjectSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<LessonSubjectSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<LessonSubjectSubjectContainerConnectionWhere>;
};

export type LessonSubjectSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type LessonSubjectSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<LessonSubjectSubjectConnectionWhere>;
};

export type LessonSubjectSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<LessonSubjectSubjectConnectionWhere>;
};

export type LessonSubjectSubjectFieldInput = {
  connect?: InputMaybe<LessonSubjectSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonSubjectSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonSubjectSubjectCreateFieldInput>;
};

export type LessonSubjectSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type LessonSubjectSubjectUpdateFieldInput = {
  connect?: InputMaybe<LessonSubjectSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonSubjectSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonSubjectSubjectCreateFieldInput>;
  delete?: InputMaybe<LessonSubjectSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<LessonSubjectSubjectDisconnectFieldInput>;
  update?: InputMaybe<LessonSubjectSubjectUpdateConnectionInput>;
  where?: InputMaybe<LessonSubjectSubjectConnectionWhere>;
};

export type LessonSubjectUpdateInput = {
  Subject?: InputMaybe<LessonSubjectSubjectUpdateFieldInput>;
  SubjectContainer?: InputMaybe<LessonSubjectSubjectContainerUpdateFieldInput>;
};

/**
 * The edge properties for the following fields:
 * * Lesson.teachers
 */
export type LessonTeacherRelationshipProperties = {
  __typename?: 'LessonTeacherRelationshipProperties';
  description?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  present?: Maybe<Scalars['Boolean']['output']>;
  teachingLoad?: Maybe<Scalars['Boolean']['output']>;
  teachingLoadHours?: Maybe<Scalars['Float']['output']>;
  writesCertificate?: Maybe<Scalars['Boolean']['output']>;
};

export type LessonTeacherRelationshipPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonTeacherRelationshipPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<LessonTeacherRelationshipPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonTeacherRelationshipPropertiesAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type LessonTeacherRelationshipPropertiesCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  present?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoadHours?: InputMaybe<Scalars['Float']['input']>;
  writesCertificate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LessonTeacherRelationshipPropertiesSort = {
  description?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  present?: InputMaybe<SortDirection>;
  teachingLoad?: InputMaybe<SortDirection>;
  teachingLoadHours?: InputMaybe<SortDirection>;
  writesCertificate?: InputMaybe<SortDirection>;
};

export type LessonTeacherRelationshipPropertiesUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  present?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoadHours?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_ADD?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  writesCertificate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LessonTeacherRelationshipPropertiesWhere = {
  AND?: InputMaybe<Array<LessonTeacherRelationshipPropertiesWhere>>;
  NOT?: InputMaybe<LessonTeacherRelationshipPropertiesWhere>;
  OR?: InputMaybe<Array<LessonTeacherRelationshipPropertiesWhere>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  present?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  present_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoad?: InputMaybe<Scalars['Boolean']['input']>;
  teachingLoadHours?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  teachingLoadHours_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadHours_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadHours_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadHours_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoad_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  writesCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  writesCertificate_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LessonTeachersAggregateInput = {
  AND?: InputMaybe<Array<LessonTeachersAggregateInput>>;
  NOT?: InputMaybe<LessonTeachersAggregateInput>;
  OR?: InputMaybe<Array<LessonTeachersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LessonTeacherRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<LessonTeachersNodeAggregationWhereInput>;
};

export type LessonTeachersConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  edge: LessonTeacherRelationshipPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type LessonTeachersConnectOrCreateFieldInput = {
  onCreate: LessonTeachersConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type LessonTeachersConnectOrCreateFieldInputOnCreate = {
  edge: LessonTeacherRelationshipPropertiesCreateInput;
  node: PersonOnCreateInput;
};

export type LessonTeachersConnection = {
  __typename?: 'LessonTeachersConnection';
  edges: Array<LessonTeachersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonTeachersConnectionSort = {
  edge?: InputMaybe<LessonTeacherRelationshipPropertiesSort>;
  node?: InputMaybe<PersonSort>;
};

export type LessonTeachersConnectionWhere = {
  AND?: InputMaybe<Array<LessonTeachersConnectionWhere>>;
  NOT?: InputMaybe<LessonTeachersConnectionWhere>;
  OR?: InputMaybe<Array<LessonTeachersConnectionWhere>>;
  edge?: InputMaybe<LessonTeacherRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LessonTeacherRelationshipPropertiesWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type LessonTeachersCreateFieldInput = {
  edge: LessonTeacherRelationshipPropertiesCreateInput;
  node: PersonCreateInput;
};

export type LessonTeachersDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<LessonTeachersConnectionWhere>;
};

export type LessonTeachersDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<LessonTeachersConnectionWhere>;
};

export type LessonTeachersFieldInput = {
  connect?: InputMaybe<Array<LessonTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonTeachersCreateFieldInput>>;
};

export type LessonTeachersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonTeachersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonTeachersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonTeachersNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonTeachersRelationship = {
  __typename?: 'LessonTeachersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: LessonTeacherRelationshipProperties;
};

export type LessonTeachersUpdateConnectionInput = {
  edge?: InputMaybe<LessonTeacherRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<PersonUpdateInput>;
};

export type LessonTeachersUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonTeachersCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonTeachersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonTeachersDisconnectFieldInput>>;
  update?: InputMaybe<LessonTeachersUpdateConnectionInput>;
  where?: InputMaybe<LessonTeachersConnectionWhere>;
};

export type LessonTeachingBlockCardTeachingBlockCardsAggregationSelection = {
  __typename?: 'LessonTeachingBlockCardTeachingBlockCardsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LessonTeachingBlockCardTeachingBlockCardsNodeAggregateSelection>;
};

export type LessonTeachingBlockCardTeachingBlockCardsNodeAggregateSelection = {
  __typename?: 'LessonTeachingBlockCardTeachingBlockCardsNodeAggregateSelection';
  duration: IntAggregateSelection;
  foreignId: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonTeachingBlockCardsAggregateInput = {
  AND?: InputMaybe<Array<LessonTeachingBlockCardsAggregateInput>>;
  NOT?: InputMaybe<LessonTeachingBlockCardsAggregateInput>;
  OR?: InputMaybe<Array<LessonTeachingBlockCardsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonTeachingBlockCardsNodeAggregationWhereInput>;
};

export type LessonTeachingBlockCardsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockCardConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockCardConnectWhere>;
};

export type LessonTeachingBlockCardsConnectOrCreateFieldInput = {
  onCreate: LessonTeachingBlockCardsConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockCardConnectOrCreateWhere;
};

export type LessonTeachingBlockCardsConnectOrCreateFieldInputOnCreate = {
  node: TeachingBlockCardOnCreateInput;
};

export type LessonTeachingBlockCardsConnection = {
  __typename?: 'LessonTeachingBlockCardsConnection';
  edges: Array<LessonTeachingBlockCardsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonTeachingBlockCardsConnectionSort = {
  node?: InputMaybe<TeachingBlockCardSort>;
};

export type LessonTeachingBlockCardsConnectionWhere = {
  AND?: InputMaybe<Array<LessonTeachingBlockCardsConnectionWhere>>;
  NOT?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
  OR?: InputMaybe<Array<LessonTeachingBlockCardsConnectionWhere>>;
  node?: InputMaybe<TeachingBlockCardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockCardWhere>;
};

export type LessonTeachingBlockCardsCreateFieldInput = {
  node: TeachingBlockCardCreateInput;
};

export type LessonTeachingBlockCardsDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockCardDeleteInput>;
  where?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
};

export type LessonTeachingBlockCardsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockCardDisconnectInput>;
  where?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
};

export type LessonTeachingBlockCardsFieldInput = {
  connect?: InputMaybe<Array<LessonTeachingBlockCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonTeachingBlockCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonTeachingBlockCardsCreateFieldInput>>;
};

export type LessonTeachingBlockCardsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonTeachingBlockCardsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonTeachingBlockCardsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonTeachingBlockCardsNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonTeachingBlockCardsRelationship = {
  __typename?: 'LessonTeachingBlockCardsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockCard;
};

export type LessonTeachingBlockCardsUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockCardUpdateInput>;
};

export type LessonTeachingBlockCardsUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonTeachingBlockCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonTeachingBlockCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonTeachingBlockCardsCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonTeachingBlockCardsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonTeachingBlockCardsDisconnectFieldInput>>;
  update?: InputMaybe<LessonTeachingBlockCardsUpdateConnectionInput>;
  where?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
};

export type LessonTeachingBlockVersionsAggregateInput = {
  AND?: InputMaybe<Array<LessonTeachingBlockVersionsAggregateInput>>;
  NOT?: InputMaybe<LessonTeachingBlockVersionsAggregateInput>;
  OR?: InputMaybe<Array<LessonTeachingBlockVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonTeachingBlockVersionsNodeAggregationWhereInput>;
};

export type LessonTeachingBlockVersionsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockVersionConnectWhere>;
};

export type LessonTeachingBlockVersionsConnection = {
  __typename?: 'LessonTeachingBlockVersionsConnection';
  edges: Array<LessonTeachingBlockVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonTeachingBlockVersionsConnectionSort = {
  node?: InputMaybe<TeachingBlockVersionSort>;
};

export type LessonTeachingBlockVersionsConnectionWhere = {
  AND?: InputMaybe<Array<LessonTeachingBlockVersionsConnectionWhere>>;
  NOT?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
  OR?: InputMaybe<Array<LessonTeachingBlockVersionsConnectionWhere>>;
  node?: InputMaybe<TeachingBlockVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockVersionWhere>;
};

export type LessonTeachingBlockVersionsCreateFieldInput = {
  node: TeachingBlockVersionCreateInput;
};

export type LessonTeachingBlockVersionsDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockVersionDeleteInput>;
  where?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
};

export type LessonTeachingBlockVersionsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockVersionDisconnectInput>;
  where?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
};

export type LessonTeachingBlockVersionsFieldInput = {
  connect?: InputMaybe<Array<LessonTeachingBlockVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<LessonTeachingBlockVersionsCreateFieldInput>>;
};

export type LessonTeachingBlockVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonTeachingBlockVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonTeachingBlockVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonTeachingBlockVersionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonTeachingBlockVersionsRelationship = {
  __typename?: 'LessonTeachingBlockVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockVersion;
};

export type LessonTeachingBlockVersionsUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockVersionUpdateInput>;
};

export type LessonTeachingBlockVersionsUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonTeachingBlockVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<LessonTeachingBlockVersionsCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonTeachingBlockVersionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonTeachingBlockVersionsDisconnectFieldInput>>;
  update?: InputMaybe<LessonTeachingBlockVersionsUpdateConnectionInput>;
  where?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
};

export type LessonTimetableCardTimetableCardsAggregationSelection = {
  __typename?: 'LessonTimetableCardTimetableCardsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LessonTimetableCardTimetableCardsNodeAggregateSelection>;
};

export type LessonTimetableCardTimetableCardsNodeAggregateSelection = {
  __typename?: 'LessonTimetableCardTimetableCardsNodeAggregateSelection';
  duration: IntAggregateSelection;
  foreignId: StringAggregateSelection;
  uuid: IdAggregateSelection;
  weekday: StringAggregateSelection;
};

export type LessonTimetableCardsAggregateInput = {
  AND?: InputMaybe<Array<LessonTimetableCardsAggregateInput>>;
  NOT?: InputMaybe<LessonTimetableCardsAggregateInput>;
  OR?: InputMaybe<Array<LessonTimetableCardsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonTimetableCardsNodeAggregationWhereInput>;
};

export type LessonTimetableCardsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableCardConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableCardConnectWhere>;
};

export type LessonTimetableCardsConnectOrCreateFieldInput = {
  onCreate: LessonTimetableCardsConnectOrCreateFieldInputOnCreate;
  where: TimetableCardConnectOrCreateWhere;
};

export type LessonTimetableCardsConnectOrCreateFieldInputOnCreate = {
  node: TimetableCardOnCreateInput;
};

export type LessonTimetableCardsConnection = {
  __typename?: 'LessonTimetableCardsConnection';
  edges: Array<LessonTimetableCardsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonTimetableCardsConnectionSort = {
  node?: InputMaybe<TimetableCardSort>;
};

export type LessonTimetableCardsConnectionWhere = {
  AND?: InputMaybe<Array<LessonTimetableCardsConnectionWhere>>;
  NOT?: InputMaybe<LessonTimetableCardsConnectionWhere>;
  OR?: InputMaybe<Array<LessonTimetableCardsConnectionWhere>>;
  node?: InputMaybe<TimetableCardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableCardWhere>;
};

export type LessonTimetableCardsCreateFieldInput = {
  node: TimetableCardCreateInput;
};

export type LessonTimetableCardsDeleteFieldInput = {
  delete?: InputMaybe<TimetableCardDeleteInput>;
  where?: InputMaybe<LessonTimetableCardsConnectionWhere>;
};

export type LessonTimetableCardsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableCardDisconnectInput>;
  where?: InputMaybe<LessonTimetableCardsConnectionWhere>;
};

export type LessonTimetableCardsFieldInput = {
  connect?: InputMaybe<Array<LessonTimetableCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonTimetableCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonTimetableCardsCreateFieldInput>>;
};

export type LessonTimetableCardsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonTimetableCardsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonTimetableCardsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonTimetableCardsNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  weekday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonTimetableCardsRelationship = {
  __typename?: 'LessonTimetableCardsRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableCard;
};

export type LessonTimetableCardsUpdateConnectionInput = {
  node?: InputMaybe<TimetableCardUpdateInput>;
};

export type LessonTimetableCardsUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonTimetableCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LessonTimetableCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LessonTimetableCardsCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonTimetableCardsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonTimetableCardsDisconnectFieldInput>>;
  update?: InputMaybe<LessonTimetableCardsUpdateConnectionInput>;
  where?: InputMaybe<LessonTimetableCardsConnectionWhere>;
};

export type LessonUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type LessonUnit = {
  __typename?: 'LessonUnit';
  count?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  subjectContainer?: Maybe<SubjectContainer>;
  subjectContainerAggregate?: Maybe<LessonUnitSubjectContainerSubjectContainerAggregationSelection>;
  subjectContainerConnection: LessonUnitSubjectContainerConnection;
  uuid: Scalars['ID']['output'];
};

export type LessonUnitSubjectContainerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectContainerOptions>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type LessonUnitSubjectContainerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type LessonUnitSubjectContainerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LessonUnitSubjectContainerConnectionSort>>;
  where?: InputMaybe<LessonUnitSubjectContainerConnectionWhere>;
};

export type LessonUnitAggregateSelection = {
  __typename?: 'LessonUnitAggregateSelection';
  count: IntAggregateSelection;
  duration: IntAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonUnitConnectInput = {
  subjectContainer?: InputMaybe<LessonUnitSubjectContainerConnectFieldInput>;
};

export type LessonUnitConnectWhere = {
  node: LessonUnitWhere;
};

export type LessonUnitCreateInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  subjectContainer?: InputMaybe<LessonUnitSubjectContainerFieldInput>;
};

export type LessonUnitDeleteInput = {
  subjectContainer?: InputMaybe<LessonUnitSubjectContainerDeleteFieldInput>;
};

export type LessonUnitDisconnectInput = {
  subjectContainer?: InputMaybe<LessonUnitSubjectContainerDisconnectFieldInput>;
};

export type LessonUnitEdge = {
  __typename?: 'LessonUnitEdge';
  cursor: Scalars['String']['output'];
  node: LessonUnit;
};

export type LessonUnitOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LessonUnitSort objects to sort LessonUnits by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LessonUnitSort>>;
};

/** Fields to sort LessonUnits by. The order in which sorts are applied is not guaranteed when specifying many fields in one LessonUnitSort object. */
export type LessonUnitSort = {
  count?: InputMaybe<SortDirection>;
  duration?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type LessonUnitSubjectContainerAggregateInput = {
  AND?: InputMaybe<Array<LessonUnitSubjectContainerAggregateInput>>;
  NOT?: InputMaybe<LessonUnitSubjectContainerAggregateInput>;
  OR?: InputMaybe<Array<LessonUnitSubjectContainerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonUnitSubjectContainerNodeAggregationWhereInput>;
};

export type LessonUnitSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type LessonUnitSubjectContainerConnectOrCreateFieldInput = {
  onCreate: LessonUnitSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type LessonUnitSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type LessonUnitSubjectContainerConnection = {
  __typename?: 'LessonUnitSubjectContainerConnection';
  edges: Array<LessonUnitSubjectContainerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonUnitSubjectContainerConnectionSort = {
  node?: InputMaybe<SubjectContainerSort>;
};

export type LessonUnitSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<LessonUnitSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<LessonUnitSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<LessonUnitSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type LessonUnitSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type LessonUnitSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<LessonUnitSubjectContainerConnectionWhere>;
};

export type LessonUnitSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<LessonUnitSubjectContainerConnectionWhere>;
};

export type LessonUnitSubjectContainerFieldInput = {
  connect?: InputMaybe<LessonUnitSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonUnitSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonUnitSubjectContainerCreateFieldInput>;
};

export type LessonUnitSubjectContainerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonUnitSubjectContainerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonUnitSubjectContainerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonUnitSubjectContainerNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonUnitSubjectContainerRelationship = {
  __typename?: 'LessonUnitSubjectContainerRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainer;
};

export type LessonUnitSubjectContainerSubjectContainerAggregationSelection = {
  __typename?: 'LessonUnitSubjectContainerSubjectContainerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LessonUnitSubjectContainerSubjectContainerNodeAggregateSelection>;
};

export type LessonUnitSubjectContainerSubjectContainerNodeAggregateSelection = {
  __typename?: 'LessonUnitSubjectContainerSubjectContainerNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type LessonUnitSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type LessonUnitSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<LessonUnitSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<LessonUnitSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<LessonUnitSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<LessonUnitSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<LessonUnitSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<LessonUnitSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<LessonUnitSubjectContainerConnectionWhere>;
};

export type LessonUnitUpdateInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  count_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  count_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  duration_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  subjectContainer?: InputMaybe<LessonUnitSubjectContainerUpdateFieldInput>;
};

export type LessonUnitWhere = {
  AND?: InputMaybe<Array<LessonUnitWhere>>;
  NOT?: InputMaybe<LessonUnitWhere>;
  OR?: InputMaybe<Array<LessonUnitWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  count_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subjectContainer?: InputMaybe<SubjectContainerWhere>;
  subjectContainerAggregate?: InputMaybe<LessonUnitSubjectContainerAggregateInput>;
  subjectContainerConnection?: InputMaybe<LessonUnitSubjectContainerConnectionWhere>;
  subjectContainerConnection_NOT?: InputMaybe<LessonUnitSubjectContainerConnectionWhere>;
  subjectContainer_NOT?: InputMaybe<SubjectContainerWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type LessonUnitsConnection = {
  __typename?: 'LessonUnitsConnection';
  edges: Array<LessonUnitEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curriculum?: InputMaybe<LessonCurriculumUpdateFieldInput>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<LessonLabelsUpdateFieldInput>>;
  lessonClasses?: InputMaybe<Array<LessonLessonClassesUpdateFieldInput>>;
  lessonUnit?: InputMaybe<Array<LessonLessonUnitUpdateFieldInput>>;
  onlyInTimetableVersion?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<LessonOrganizationUpdateFieldInput>;
  roomSupply?: InputMaybe<Array<LessonRoomSupplyUpdateFieldInput>>;
  schoolYear?: InputMaybe<LessonSchoolYearUpdateFieldInput>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<LessonSubjectUpdateInput>;
  teachers?: InputMaybe<Array<LessonTeachersUpdateFieldInput>>;
  teachingBlockCards?: InputMaybe<Array<LessonTeachingBlockCardsUpdateFieldInput>>;
  teachingBlockVersions?: InputMaybe<Array<LessonTeachingBlockVersionsUpdateFieldInput>>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableCards?: InputMaybe<Array<LessonTimetableCardsUpdateFieldInput>>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  versions?: InputMaybe<Array<LessonVersionsUpdateFieldInput>>;
};

export type LessonVersionsAggregateInput = {
  AND?: InputMaybe<Array<LessonVersionsAggregateInput>>;
  NOT?: InputMaybe<LessonVersionsAggregateInput>;
  OR?: InputMaybe<Array<LessonVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LessonVersionsNodeAggregationWhereInput>;
};

export type LessonVersionsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type LessonVersionsConnection = {
  __typename?: 'LessonVersionsConnection';
  edges: Array<LessonVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LessonVersionsConnectionSort = {
  node?: InputMaybe<TimetableVersionSort>;
};

export type LessonVersionsConnectionWhere = {
  AND?: InputMaybe<Array<LessonVersionsConnectionWhere>>;
  NOT?: InputMaybe<LessonVersionsConnectionWhere>;
  OR?: InputMaybe<Array<LessonVersionsConnectionWhere>>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type LessonVersionsCreateFieldInput = {
  node: TimetableVersionCreateInput;
};

export type LessonVersionsDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<LessonVersionsConnectionWhere>;
};

export type LessonVersionsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<LessonVersionsConnectionWhere>;
};

export type LessonVersionsFieldInput = {
  connect?: InputMaybe<Array<LessonVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<LessonVersionsCreateFieldInput>>;
};

export type LessonVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LessonVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LessonVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LessonVersionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LessonVersionsRelationship = {
  __typename?: 'LessonVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
};

export type LessonVersionsUpdateConnectionInput = {
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type LessonVersionsUpdateFieldInput = {
  connect?: InputMaybe<Array<LessonVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<LessonVersionsCreateFieldInput>>;
  delete?: InputMaybe<Array<LessonVersionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LessonVersionsDisconnectFieldInput>>;
  update?: InputMaybe<LessonVersionsUpdateConnectionInput>;
  where?: InputMaybe<LessonVersionsConnectionWhere>;
};

export type LessonWhere = {
  AND?: InputMaybe<Array<LessonWhere>>;
  NOT?: InputMaybe<LessonWhere>;
  OR?: InputMaybe<Array<LessonWhere>>;
  activeTeachingBlocks?: InputMaybe<TimetableWhere>;
  activeTeachingBlocks_ALL?: InputMaybe<TimetableWhere>;
  activeTeachingBlocks_NONE?: InputMaybe<TimetableWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  activeTeachingBlocks_NOT?: InputMaybe<TimetableWhere>;
  activeTeachingBlocks_SINGLE?: InputMaybe<TimetableWhere>;
  activeTeachingBlocks_SOME?: InputMaybe<TimetableWhere>;
  activeTimetables?: InputMaybe<TimetableWhere>;
  activeTimetables_ALL?: InputMaybe<TimetableWhere>;
  activeTimetables_NONE?: InputMaybe<TimetableWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  activeTimetables_NOT?: InputMaybe<TimetableWhere>;
  activeTimetables_SINGLE?: InputMaybe<TimetableWhere>;
  activeTimetables_SOME?: InputMaybe<TimetableWhere>;
  classSort?: InputMaybe<Scalars['String']['input']>;
  classSort_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classSort_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classSort_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classSort_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classSort_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classSort_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classSort_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classSort_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classSort_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  curriculum?: InputMaybe<CurriculumWhere>;
  curriculumAggregate?: InputMaybe<LessonCurriculumAggregateInput>;
  curriculumConnection?: InputMaybe<LessonCurriculumConnectionWhere>;
  curriculumConnection_NOT?: InputMaybe<LessonCurriculumConnectionWhere>;
  curriculum_NOT?: InputMaybe<CurriculumWhere>;
  elective?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  elective_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<LessonEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<LessonEventsConnectionWhere>;
  /** Return Lessons where all of the related LessonEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<LessonEventsConnectionWhere>;
  /** Return Lessons where none of the related LessonEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<LessonEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<LessonEventsConnectionWhere>;
  /** Return Lessons where one of the related LessonEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<LessonEventsConnectionWhere>;
  /** Return Lessons where some of the related LessonEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<LessonEventsConnectionWhere>;
  /** Return Lessons where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return Lessons where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return Lessons where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return Lessons where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeGroupUuid?: InputMaybe<Array<Scalars['ID']['input']>>;
  gradeGroupUuid_INCLUDES?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupUuid_NOT?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gradeGroupUuid_NOT_INCLUDES?: InputMaybe<Scalars['ID']['input']>;
  isClassTrip?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isClassTrip_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<LessonLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<LessonLabelsConnectionWhere>;
  /** Return Lessons where all of the related LessonLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<LessonLabelsConnectionWhere>;
  /** Return Lessons where none of the related LessonLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<LessonLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<LessonLabelsConnectionWhere>;
  /** Return Lessons where one of the related LessonLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<LessonLabelsConnectionWhere>;
  /** Return Lessons where some of the related LessonLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<LessonLabelsConnectionWhere>;
  /** Return Lessons where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Lessons where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Lessons where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Lessons where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  /** @deprecated Use `lessonClasses_SOME` instead. */
  lessonClasses?: InputMaybe<LessonClassWhere>;
  lessonClassesAggregate?: InputMaybe<LessonLessonClassesAggregateInput>;
  /** @deprecated Use `lessonClassesConnection_SOME` instead. */
  lessonClassesConnection?: InputMaybe<LessonLessonClassesConnectionWhere>;
  /** Return Lessons where all of the related LessonLessonClassesConnections match this filter */
  lessonClassesConnection_ALL?: InputMaybe<LessonLessonClassesConnectionWhere>;
  /** Return Lessons where none of the related LessonLessonClassesConnections match this filter */
  lessonClassesConnection_NONE?: InputMaybe<LessonLessonClassesConnectionWhere>;
  /** @deprecated Use `lessonClassesConnection_NONE` instead. */
  lessonClassesConnection_NOT?: InputMaybe<LessonLessonClassesConnectionWhere>;
  /** Return Lessons where one of the related LessonLessonClassesConnections match this filter */
  lessonClassesConnection_SINGLE?: InputMaybe<LessonLessonClassesConnectionWhere>;
  /** Return Lessons where some of the related LessonLessonClassesConnections match this filter */
  lessonClassesConnection_SOME?: InputMaybe<LessonLessonClassesConnectionWhere>;
  /** Return Lessons where all of the related LessonClasses match this filter */
  lessonClasses_ALL?: InputMaybe<LessonClassWhere>;
  /** Return Lessons where none of the related LessonClasses match this filter */
  lessonClasses_NONE?: InputMaybe<LessonClassWhere>;
  /** @deprecated Use `lessonClasses_NONE` instead. */
  lessonClasses_NOT?: InputMaybe<LessonClassWhere>;
  /** Return Lessons where one of the related LessonClasses match this filter */
  lessonClasses_SINGLE?: InputMaybe<LessonClassWhere>;
  /** Return Lessons where some of the related LessonClasses match this filter */
  lessonClasses_SOME?: InputMaybe<LessonClassWhere>;
  /** @deprecated Use `lessonUnit_SOME` instead. */
  lessonUnit?: InputMaybe<LessonUnitWhere>;
  lessonUnitAggregate?: InputMaybe<LessonLessonUnitAggregateInput>;
  /** @deprecated Use `lessonUnitConnection_SOME` instead. */
  lessonUnitConnection?: InputMaybe<LessonLessonUnitConnectionWhere>;
  /** Return Lessons where all of the related LessonLessonUnitConnections match this filter */
  lessonUnitConnection_ALL?: InputMaybe<LessonLessonUnitConnectionWhere>;
  /** Return Lessons where none of the related LessonLessonUnitConnections match this filter */
  lessonUnitConnection_NONE?: InputMaybe<LessonLessonUnitConnectionWhere>;
  /** @deprecated Use `lessonUnitConnection_NONE` instead. */
  lessonUnitConnection_NOT?: InputMaybe<LessonLessonUnitConnectionWhere>;
  /** Return Lessons where one of the related LessonLessonUnitConnections match this filter */
  lessonUnitConnection_SINGLE?: InputMaybe<LessonLessonUnitConnectionWhere>;
  /** Return Lessons where some of the related LessonLessonUnitConnections match this filter */
  lessonUnitConnection_SOME?: InputMaybe<LessonLessonUnitConnectionWhere>;
  /** Return Lessons where all of the related LessonUnits match this filter */
  lessonUnit_ALL?: InputMaybe<LessonUnitWhere>;
  /** Return Lessons where none of the related LessonUnits match this filter */
  lessonUnit_NONE?: InputMaybe<LessonUnitWhere>;
  /** @deprecated Use `lessonUnit_NONE` instead. */
  lessonUnit_NOT?: InputMaybe<LessonUnitWhere>;
  /** Return Lessons where one of the related LessonUnits match this filter */
  lessonUnit_SINGLE?: InputMaybe<LessonUnitWhere>;
  /** Return Lessons where some of the related LessonUnits match this filter */
  lessonUnit_SOME?: InputMaybe<LessonUnitWhere>;
  onlyInTimetableVersion?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  onlyInTimetableVersion_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<LessonOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<LessonOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<LessonOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  placedCardsCount?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_GT?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  placedCardsCount_LT?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  placedCardsCount_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  placedCardsCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** @deprecated Use `roomSupply_SOME` instead. */
  roomSupply?: InputMaybe<RoomWhere>;
  roomSupplyAggregate?: InputMaybe<LessonRoomSupplyAggregateInput>;
  /** @deprecated Use `roomSupplyConnection_SOME` instead. */
  roomSupplyConnection?: InputMaybe<LessonRoomSupplyConnectionWhere>;
  /** Return Lessons where all of the related LessonRoomSupplyConnections match this filter */
  roomSupplyConnection_ALL?: InputMaybe<LessonRoomSupplyConnectionWhere>;
  /** Return Lessons where none of the related LessonRoomSupplyConnections match this filter */
  roomSupplyConnection_NONE?: InputMaybe<LessonRoomSupplyConnectionWhere>;
  /** @deprecated Use `roomSupplyConnection_NONE` instead. */
  roomSupplyConnection_NOT?: InputMaybe<LessonRoomSupplyConnectionWhere>;
  /** Return Lessons where one of the related LessonRoomSupplyConnections match this filter */
  roomSupplyConnection_SINGLE?: InputMaybe<LessonRoomSupplyConnectionWhere>;
  /** Return Lessons where some of the related LessonRoomSupplyConnections match this filter */
  roomSupplyConnection_SOME?: InputMaybe<LessonRoomSupplyConnectionWhere>;
  /** Return Lessons where all of the related Rooms match this filter */
  roomSupply_ALL?: InputMaybe<RoomWhere>;
  /** Return Lessons where none of the related Rooms match this filter */
  roomSupply_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `roomSupply_NONE` instead. */
  roomSupply_NOT?: InputMaybe<RoomWhere>;
  /** Return Lessons where one of the related Rooms match this filter */
  roomSupply_SINGLE?: InputMaybe<RoomWhere>;
  /** Return Lessons where some of the related Rooms match this filter */
  roomSupply_SOME?: InputMaybe<RoomWhere>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<LessonSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<LessonSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<LessonSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  subTitle_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subTitle_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subTitle_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subTitle_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subTitle_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<SubjectContainerOrSubjectWhere>;
  subjectConnection?: InputMaybe<LessonSubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<LessonSubjectConnectionWhere>;
  subjectName?: InputMaybe<Scalars['String']['input']>;
  subjectName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subjectName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subject_NOT?: InputMaybe<SubjectContainerOrSubjectWhere>;
  /** @deprecated Use `teachers_SOME` instead. */
  teachers?: InputMaybe<PersonWhere>;
  teachersAggregate?: InputMaybe<LessonTeachersAggregateInput>;
  /** @deprecated Use `teachersConnection_SOME` instead. */
  teachersConnection?: InputMaybe<LessonTeachersConnectionWhere>;
  /** Return Lessons where all of the related LessonTeachersConnections match this filter */
  teachersConnection_ALL?: InputMaybe<LessonTeachersConnectionWhere>;
  /** Return Lessons where none of the related LessonTeachersConnections match this filter */
  teachersConnection_NONE?: InputMaybe<LessonTeachersConnectionWhere>;
  /** @deprecated Use `teachersConnection_NONE` instead. */
  teachersConnection_NOT?: InputMaybe<LessonTeachersConnectionWhere>;
  /** Return Lessons where one of the related LessonTeachersConnections match this filter */
  teachersConnection_SINGLE?: InputMaybe<LessonTeachersConnectionWhere>;
  /** Return Lessons where some of the related LessonTeachersConnections match this filter */
  teachersConnection_SOME?: InputMaybe<LessonTeachersConnectionWhere>;
  teachersSort?: InputMaybe<Scalars['String']['input']>;
  teachersSort_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  teachersSort_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachersSort_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachersSort_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachersSort_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachersSort_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachersSort_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachersSort_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachersSort_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** Return Lessons where all of the related People match this filter */
  teachers_ALL?: InputMaybe<PersonWhere>;
  /** Return Lessons where none of the related People match this filter */
  teachers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `teachers_NONE` instead. */
  teachers_NOT?: InputMaybe<PersonWhere>;
  /** Return Lessons where one of the related People match this filter */
  teachers_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Lessons where some of the related People match this filter */
  teachers_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `teachingBlockCards_SOME` instead. */
  teachingBlockCards?: InputMaybe<TeachingBlockCardWhere>;
  teachingBlockCardsAggregate?: InputMaybe<LessonTeachingBlockCardsAggregateInput>;
  /** @deprecated Use `teachingBlockCardsConnection_SOME` instead. */
  teachingBlockCardsConnection?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
  /** Return Lessons where all of the related LessonTeachingBlockCardsConnections match this filter */
  teachingBlockCardsConnection_ALL?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
  /** Return Lessons where none of the related LessonTeachingBlockCardsConnections match this filter */
  teachingBlockCardsConnection_NONE?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
  /** @deprecated Use `teachingBlockCardsConnection_NONE` instead. */
  teachingBlockCardsConnection_NOT?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
  /** Return Lessons where one of the related LessonTeachingBlockCardsConnections match this filter */
  teachingBlockCardsConnection_SINGLE?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
  /** Return Lessons where some of the related LessonTeachingBlockCardsConnections match this filter */
  teachingBlockCardsConnection_SOME?: InputMaybe<LessonTeachingBlockCardsConnectionWhere>;
  /** Return Lessons where all of the related TeachingBlockCards match this filter */
  teachingBlockCards_ALL?: InputMaybe<TeachingBlockCardWhere>;
  /** Return Lessons where none of the related TeachingBlockCards match this filter */
  teachingBlockCards_NONE?: InputMaybe<TeachingBlockCardWhere>;
  /** @deprecated Use `teachingBlockCards_NONE` instead. */
  teachingBlockCards_NOT?: InputMaybe<TeachingBlockCardWhere>;
  /** Return Lessons where one of the related TeachingBlockCards match this filter */
  teachingBlockCards_SINGLE?: InputMaybe<TeachingBlockCardWhere>;
  /** Return Lessons where some of the related TeachingBlockCards match this filter */
  teachingBlockCards_SOME?: InputMaybe<TeachingBlockCardWhere>;
  teachingBlockPlacedCardsCount?: InputMaybe<Scalars['Int']['input']>;
  teachingBlockPlacedCardsCount_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingBlockPlacedCardsCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingBlockPlacedCardsCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  teachingBlockPlacedCardsCount_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingBlockPlacedCardsCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingBlockPlacedCardsCount_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingBlockPlacedCardsCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** @deprecated Use `teachingBlockVersions_SOME` instead. */
  teachingBlockVersions?: InputMaybe<TeachingBlockVersionWhere>;
  teachingBlockVersionsAggregate?: InputMaybe<LessonTeachingBlockVersionsAggregateInput>;
  /** @deprecated Use `teachingBlockVersionsConnection_SOME` instead. */
  teachingBlockVersionsConnection?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
  /** Return Lessons where all of the related LessonTeachingBlockVersionsConnections match this filter */
  teachingBlockVersionsConnection_ALL?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
  /** Return Lessons where none of the related LessonTeachingBlockVersionsConnections match this filter */
  teachingBlockVersionsConnection_NONE?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
  /** @deprecated Use `teachingBlockVersionsConnection_NONE` instead. */
  teachingBlockVersionsConnection_NOT?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
  /** Return Lessons where one of the related LessonTeachingBlockVersionsConnections match this filter */
  teachingBlockVersionsConnection_SINGLE?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
  /** Return Lessons where some of the related LessonTeachingBlockVersionsConnections match this filter */
  teachingBlockVersionsConnection_SOME?: InputMaybe<LessonTeachingBlockVersionsConnectionWhere>;
  /** Return Lessons where all of the related TeachingBlockVersions match this filter */
  teachingBlockVersions_ALL?: InputMaybe<TeachingBlockVersionWhere>;
  /** Return Lessons where none of the related TeachingBlockVersions match this filter */
  teachingBlockVersions_NONE?: InputMaybe<TeachingBlockVersionWhere>;
  /** @deprecated Use `teachingBlockVersions_NONE` instead. */
  teachingBlockVersions_NOT?: InputMaybe<TeachingBlockVersionWhere>;
  /** Return Lessons where one of the related TeachingBlockVersions match this filter */
  teachingBlockVersions_SINGLE?: InputMaybe<TeachingBlockVersionWhere>;
  /** Return Lessons where some of the related TeachingBlockVersions match this filter */
  teachingBlockVersions_SOME?: InputMaybe<TeachingBlockVersionWhere>;
  teachingLoadEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `timetableCards_SOME` instead. */
  timetableCards?: InputMaybe<TimetableCardWhere>;
  timetableCardsAggregate?: InputMaybe<LessonTimetableCardsAggregateInput>;
  /** @deprecated Use `timetableCardsConnection_SOME` instead. */
  timetableCardsConnection?: InputMaybe<LessonTimetableCardsConnectionWhere>;
  /** Return Lessons where all of the related LessonTimetableCardsConnections match this filter */
  timetableCardsConnection_ALL?: InputMaybe<LessonTimetableCardsConnectionWhere>;
  /** Return Lessons where none of the related LessonTimetableCardsConnections match this filter */
  timetableCardsConnection_NONE?: InputMaybe<LessonTimetableCardsConnectionWhere>;
  /** @deprecated Use `timetableCardsConnection_NONE` instead. */
  timetableCardsConnection_NOT?: InputMaybe<LessonTimetableCardsConnectionWhere>;
  /** Return Lessons where one of the related LessonTimetableCardsConnections match this filter */
  timetableCardsConnection_SINGLE?: InputMaybe<LessonTimetableCardsConnectionWhere>;
  /** Return Lessons where some of the related LessonTimetableCardsConnections match this filter */
  timetableCardsConnection_SOME?: InputMaybe<LessonTimetableCardsConnectionWhere>;
  /** Return Lessons where all of the related TimetableCards match this filter */
  timetableCards_ALL?: InputMaybe<TimetableCardWhere>;
  /** Return Lessons where none of the related TimetableCards match this filter */
  timetableCards_NONE?: InputMaybe<TimetableCardWhere>;
  /** @deprecated Use `timetableCards_NONE` instead. */
  timetableCards_NOT?: InputMaybe<TimetableCardWhere>;
  /** Return Lessons where one of the related TimetableCards match this filter */
  timetableCards_SINGLE?: InputMaybe<TimetableCardWhere>;
  /** Return Lessons where some of the related TimetableCards match this filter */
  timetableCards_SOME?: InputMaybe<TimetableCardWhere>;
  timetableEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timetableEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `versions_SOME` instead. */
  versions?: InputMaybe<TimetableVersionWhere>;
  versionsAggregate?: InputMaybe<LessonVersionsAggregateInput>;
  /** @deprecated Use `versionsConnection_SOME` instead. */
  versionsConnection?: InputMaybe<LessonVersionsConnectionWhere>;
  /** Return Lessons where all of the related LessonVersionsConnections match this filter */
  versionsConnection_ALL?: InputMaybe<LessonVersionsConnectionWhere>;
  /** Return Lessons where none of the related LessonVersionsConnections match this filter */
  versionsConnection_NONE?: InputMaybe<LessonVersionsConnectionWhere>;
  /** @deprecated Use `versionsConnection_NONE` instead. */
  versionsConnection_NOT?: InputMaybe<LessonVersionsConnectionWhere>;
  /** Return Lessons where one of the related LessonVersionsConnections match this filter */
  versionsConnection_SINGLE?: InputMaybe<LessonVersionsConnectionWhere>;
  /** Return Lessons where some of the related LessonVersionsConnections match this filter */
  versionsConnection_SOME?: InputMaybe<LessonVersionsConnectionWhere>;
  /** Return Lessons where all of the related TimetableVersions match this filter */
  versions_ALL?: InputMaybe<TimetableVersionWhere>;
  /** Return Lessons where none of the related TimetableVersions match this filter */
  versions_NONE?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `versions_NONE` instead. */
  versions_NOT?: InputMaybe<TimetableVersionWhere>;
  /** Return Lessons where one of the related TimetableVersions match this filter */
  versions_SINGLE?: InputMaybe<TimetableVersionWhere>;
  /** Return Lessons where some of the related TimetableVersions match this filter */
  versions_SOME?: InputMaybe<TimetableVersionWhere>;
};

export type LessonsConnection = {
  __typename?: 'LessonsConnection';
  edges: Array<LessonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Locked = {
  __typename?: 'Locked';
  duration?: Maybe<Scalars['Int']['output']>;
  lockedBy: Scalars['String']['output'];
  lockedSince: Scalars['DateTime']['output'];
};

export type LockedAggregateSelection = {
  __typename?: 'LockedAggregateSelection';
  count: Scalars['Int']['output'];
  duration: IntAggregateSelection;
  lockedBy: StringAggregateSelection;
  lockedSince: DateTimeAggregateSelection;
};

export type LockedConnectWhere = {
  node: LockedWhere;
};

export type LockedCreateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  lockedBy: Scalars['String']['input'];
  lockedSince: Scalars['DateTime']['input'];
};

export type LockedEdge = {
  __typename?: 'LockedEdge';
  cursor: Scalars['String']['output'];
  node: Locked;
};

export type LockedOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LockedSort objects to sort Lockeds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LockedSort>>;
};

/** Fields to sort Lockeds by. The order in which sorts are applied is not guaranteed when specifying many fields in one LockedSort object. */
export type LockedSort = {
  duration?: InputMaybe<SortDirection>;
  lockedBy?: InputMaybe<SortDirection>;
  lockedSince?: InputMaybe<SortDirection>;
};

export type LockedUpdateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  duration_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy?: InputMaybe<Scalars['String']['input']>;
  lockedSince?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LockedWhere = {
  AND?: InputMaybe<Array<LockedWhere>>;
  NOT?: InputMaybe<LockedWhere>;
  OR?: InputMaybe<Array<LockedWhere>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lockedBy?: InputMaybe<Scalars['String']['input']>;
  lockedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lockedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lockedBy_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lockedBy_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lockedBy_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lockedBy_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lockedBy_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lockedBy_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lockedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lockedSince?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lockedSince_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lockedSince_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lockedSince_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type LockedsConnection = {
  __typename?: 'LockedsConnection';
  edges: Array<LockedEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MathplanJob = {
  __typename?: 'MathplanJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  gap: Scalars['Float']['output'];
  jobId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<Scalars['String']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
  solutionFound: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  timetableVersion: TimetableVersion;
  timetableVersionConnection: MathplanJobTimetableVersionConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MathplanJobTimetableVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type MathplanJobTimetableVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MathplanJobTimetableVersionConnectionSort>>;
  where?: InputMaybe<MathplanJobTimetableVersionConnectionWhere>;
};

export type MathplanJobAggregateSelection = {
  __typename?: 'MathplanJobAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  errors: StringAggregateSelection;
  gap: FloatAggregateSelection;
  jobId: StringAggregateSelection;
  log: StringAggregateSelection;
  problem: StringAggregateSelection;
  solution: StringAggregateSelection;
  status: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type MathplanJobCreateInput = {
  errors?: InputMaybe<Scalars['String']['input']>;
  gap: Scalars['Float']['input'];
  jobId: Scalars['String']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  solutionFound: Scalars['Boolean']['input'];
  status: Scalars['String']['input'];
  timetableVersion?: InputMaybe<MathplanJobTimetableVersionFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MathplanJobDeleteInput = {
  timetableVersion?: InputMaybe<MathplanJobTimetableVersionDeleteFieldInput>;
};

export type MathplanJobEdge = {
  __typename?: 'MathplanJobEdge';
  cursor: Scalars['String']['output'];
  node: MathplanJob;
};

export type MathplanJobOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MathplanJobSort objects to sort MathplanJobs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MathplanJobSort>>;
};

/** Fields to sort MathplanJobs by. The order in which sorts are applied is not guaranteed when specifying many fields in one MathplanJobSort object. */
export type MathplanJobSort = {
  createdAt?: InputMaybe<SortDirection>;
  errors?: InputMaybe<SortDirection>;
  gap?: InputMaybe<SortDirection>;
  jobId?: InputMaybe<SortDirection>;
  log?: InputMaybe<SortDirection>;
  problem?: InputMaybe<SortDirection>;
  solution?: InputMaybe<SortDirection>;
  solutionFound?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type MathplanJobTimetableVersionAggregateInput = {
  AND?: InputMaybe<Array<MathplanJobTimetableVersionAggregateInput>>;
  NOT?: InputMaybe<MathplanJobTimetableVersionAggregateInput>;
  OR?: InputMaybe<Array<MathplanJobTimetableVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MathplanJobTimetableVersionNodeAggregationWhereInput>;
};

export type MathplanJobTimetableVersionConnectFieldInput = {
  connect?: InputMaybe<TimetableVersionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type MathplanJobTimetableVersionConnection = {
  __typename?: 'MathplanJobTimetableVersionConnection';
  edges: Array<MathplanJobTimetableVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MathplanJobTimetableVersionConnectionSort = {
  node?: InputMaybe<TimetableVersionSort>;
};

export type MathplanJobTimetableVersionConnectionWhere = {
  AND?: InputMaybe<Array<MathplanJobTimetableVersionConnectionWhere>>;
  NOT?: InputMaybe<MathplanJobTimetableVersionConnectionWhere>;
  OR?: InputMaybe<Array<MathplanJobTimetableVersionConnectionWhere>>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type MathplanJobTimetableVersionCreateFieldInput = {
  node: TimetableVersionCreateInput;
};

export type MathplanJobTimetableVersionDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<MathplanJobTimetableVersionConnectionWhere>;
};

export type MathplanJobTimetableVersionDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<MathplanJobTimetableVersionConnectionWhere>;
};

export type MathplanJobTimetableVersionFieldInput = {
  connect?: InputMaybe<MathplanJobTimetableVersionConnectFieldInput>;
  create?: InputMaybe<MathplanJobTimetableVersionCreateFieldInput>;
};

export type MathplanJobTimetableVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MathplanJobTimetableVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MathplanJobTimetableVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MathplanJobTimetableVersionNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MathplanJobTimetableVersionRelationship = {
  __typename?: 'MathplanJobTimetableVersionRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
};

export type MathplanJobTimetableVersionUpdateConnectionInput = {
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type MathplanJobTimetableVersionUpdateFieldInput = {
  connect?: InputMaybe<MathplanJobTimetableVersionConnectFieldInput>;
  create?: InputMaybe<MathplanJobTimetableVersionCreateFieldInput>;
  delete?: InputMaybe<MathplanJobTimetableVersionDeleteFieldInput>;
  disconnect?: InputMaybe<MathplanJobTimetableVersionDisconnectFieldInput>;
  update?: InputMaybe<MathplanJobTimetableVersionUpdateConnectionInput>;
  where?: InputMaybe<MathplanJobTimetableVersionConnectionWhere>;
};

export type MathplanJobUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errors?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['Float']['input']>;
  gap_ADD?: InputMaybe<Scalars['Float']['input']>;
  gap_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  gap_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  gap_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  solutionFound?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timetableVersion?: InputMaybe<MathplanJobTimetableVersionUpdateFieldInput>;
};

export type MathplanJobWhere = {
  AND?: InputMaybe<Array<MathplanJobWhere>>;
  NOT?: InputMaybe<MathplanJobWhere>;
  OR?: InputMaybe<Array<MathplanJobWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  errors?: InputMaybe<Scalars['String']['input']>;
  errors_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  errors_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  errors_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  errors_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  errors_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  errors_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  errors_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  errors_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  errors_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gap?: InputMaybe<Scalars['Float']['input']>;
  gap_GT?: InputMaybe<Scalars['Float']['input']>;
  gap_GTE?: InputMaybe<Scalars['Float']['input']>;
  gap_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  gap_LT?: InputMaybe<Scalars['Float']['input']>;
  gap_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gap_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gap_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  jobId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  log_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  log_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  log_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  log_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  log_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  log_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  log_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  log_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  log_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  problem_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  problem_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  problem_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  problem_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  problem_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  problem_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  problem_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  problem_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  problem_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
  solutionFound?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  solutionFound_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  solution_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  solution_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  solution_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  solution_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  solution_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  solution_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  solution_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  solution_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  solution_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  status_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timetableVersion?: InputMaybe<TimetableVersionWhere>;
  timetableVersionAggregate?: InputMaybe<MathplanJobTimetableVersionAggregateInput>;
  timetableVersionConnection?: InputMaybe<MathplanJobTimetableVersionConnectionWhere>;
  timetableVersionConnection_NOT?: InputMaybe<MathplanJobTimetableVersionConnectionWhere>;
  timetableVersion_NOT?: InputMaybe<TimetableVersionWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type MathplanJobsConnection = {
  __typename?: 'MathplanJobsConnection';
  edges: Array<MathplanJobEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MergeLessonNewCardsInput = {
  count: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
};

export type MinimalClass = {
  __typename?: 'MinimalClass';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalClassWhere = {
  AND?: InputMaybe<Array<MinimalClassWhere>>;
  NOT?: InputMaybe<MinimalClassWhere>;
  OR?: InputMaybe<Array<MinimalClassWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type MinimalGroup = {
  __typename?: 'MinimalGroup';
  divisionUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalGroupWhere = {
  AND?: InputMaybe<Array<MinimalGroupWhere>>;
  NOT?: InputMaybe<MinimalGroupWhere>;
  OR?: InputMaybe<Array<MinimalGroupWhere>>;
  divisionUuid?: InputMaybe<Scalars['String']['input']>;
  divisionUuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  divisionUuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  divisionUuid_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  divisionUuid_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  divisionUuid_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  divisionUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  divisionUuid_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  divisionUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  divisionUuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type MinimalPerson = {
  __typename?: 'MinimalPerson';
  displayName: Scalars['String']['output'];
  displayNameShort?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  pimProfileUuid?: Maybe<Scalars['String']['output']>;
  selectName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalRoom = {
  __typename?: 'MinimalRoom';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MinimalSubject = {
  __typename?: 'MinimalSubject';
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addUser: PimProfile;
  cancelEvent: EntitiesUpdateInfo;
  connectEntityWithVersion?: Maybe<EntitiesUpdateInfo>;
  connectLessonsToTimetableVersion: UpdateResponse;
  copyLessonsToTimetableVersion: CreateResponse;
  createAbsence: CreateResponse;
  createAdditionalTeachingLoads: CreateAdditionalTeachingLoadsMutationResponse;
  createBackendTeachingBlockVersion: CreateTeachingBlockVersionsMutationResponse;
  createBuildings: CreateBuildingsMutationResponse;
  createClasses: CreateClassesMutationResponse;
  createColumnSorts: CreateColumnSortsMutationResponse;
  createContracts: CreateContractsMutationResponse;
  createCurricula: CreateCurriculaMutationResponse;
  createCurriculumClasses: CreateCurriculumClassesMutationResponse;
  createCurriculumPeople: CreateCurriculumPeopleMutationResponse;
  createCurriculumUnits: CreateCurriculumUnitsMutationResponse;
  createCurriculumVersions: CreateCurriculumVersionsMutationResponse;
  createDependencies: CreateDependenciesMutationResponse;
  createDivisions: CreateDivisionsMutationResponse;
  createEventJobs: CreateEventJobsMutationResponse;
  createFileEntries: CreateFileEntriesMutationResponse;
  createGradeGroups: CreateGradeGroupsMutationResponse;
  createGroups: CreateGroupsMutationResponse;
  createHolidays: CreateHolidaysMutationResponse;
  createLabels: CreateLabelsMutationResponse;
  createLessonClasses: CreateLessonClassesMutationResponse;
  createLessonUnits: CreateLessonUnitsMutationResponse;
  createLessons: CreateLessonsMutationResponse;
  createLockeds: CreateLockedsMutationResponse;
  createMathplanJobs: CreateMathplanJobsMutationResponse;
  createOrganizations: CreateOrganizationsMutationResponse;
  createPeople: CreatePeopleMutationResponse;
  createPublishedSubstitutions: CreatePublishedSubstitutionsMutationResponse;
  createQualifications: CreateQualificationsMutationResponse;
  createRecurrenceSchoolEvents: CreateResponse;
  createRooms: CreateRoomsMutationResponse;
  createSchoolEvent: CreateResponse;
  createSchoolYears: CreateSchoolYearsMutationResponse;
  createSubjectContainers: CreateSubjectContainersMutationResponse;
  createSubjectGroups: CreateSubjectGroupsMutationResponse;
  createSubjects: CreateSubjectsMutationResponse;
  createSubstitutionAnnouncements: CreateSubstitutionAnnouncementsMutationResponse;
  createSubstitutionAppConfigs: CreateSubstitutionAppConfigsMutationResponse;
  createSubstitutionPrintColumnConfigs: CreateSubstitutionPrintColumnConfigsMutationResponse;
  createSubstitutionPrintConfigs: CreateSubstitutionPrintConfigsMutationResponse;
  createSubstitutionReports: CreateSubstitutionReportsMutationResponse;
  createTableConfigs: CreateTableConfigsMutationResponse;
  createTeachingBlockAvailabilityExclusions: CreateTeachingBlockAvailabilityExclusionsMutationResponse;
  createTeachingBlockCards: CreateTeachingBlockCardsMutationResponse;
  createTeachingBlockVersions: CreateTeachingBlockVersionsMutationResponse;
  createTeachingBlocks: CreateTeachingBlocksMutationResponse;
  createTeachingLoadFactors: CreateTeachingLoadFactorsMutationResponse;
  createTeachingLoadReports: CreateTeachingLoadReportsMutationResponse;
  createTeachingLoadScenarios: CreateTeachingLoadScenariosMutationResponse;
  createTimeGridEntries: CreateTimeGridEntriesMutationResponse;
  createTimeGrids: CreateTimeGridsMutationResponse;
  createTimespans: CreateTimespansMutationResponse;
  createTimetableBlocks: CreateTimetableBlocksMutationResponse;
  createTimetableCards: CreateTimetableCardsMutationResponse;
  createTimetableConfigs: CreateTimetableConfigsMutationResponse;
  createTimetablePrintConfigs: CreateTimetablePrintConfigsMutationResponse;
  createTimetableReports: CreateTimetableReportsMutationResponse;
  createTimetableTimeGridConfigs: CreateTimetableTimeGridConfigsMutationResponse;
  createTimetableVersion: CreateTimetableVersionsMutationResponse;
  createTimetableVersions: CreateTimetableVersionsMutationResponse;
  createTimetables: CreateTimetablesMutationResponse;
  createUserConfigs: CreateUserConfigsMutationResponse;
  deleteAbsence: DeleteInfo;
  deleteAdditionalTeachingLoads: DeleteInfo;
  deleteBuildings: DeleteInfo;
  deleteClasses: DeleteInfo;
  deleteColumnSorts: DeleteInfo;
  deleteContracts: DeleteInfo;
  deleteCurricula: DeleteInfo;
  deleteCurriculumClasses: DeleteInfo;
  deleteCurriculumPeople: DeleteInfo;
  deleteCurriculumUnits: DeleteInfo;
  deleteCurriculumVersions: DeleteInfo;
  deleteDependencies: DeleteInfo;
  deleteDivisions: DeleteInfo;
  deleteEventJobs: DeleteInfo;
  deleteFileEntries: DeleteInfo;
  deleteGradeGroups: DeleteInfo;
  deleteGroups: DeleteInfo;
  deleteHolidays: DeleteInfo;
  deleteLabels: DeleteInfo;
  deleteLessonClasses: DeleteInfo;
  deleteLessonUnits: DeleteInfo;
  deleteLessons: DeleteInfo;
  deleteLockeds: DeleteInfo;
  deleteMathplanJobs: DeleteInfo;
  deleteOrganizations: DeleteInfo;
  deletePeople: DeleteInfo;
  deletePublishedSubstitutions: DeleteInfo;
  deleteQualifications: DeleteInfo;
  deleteRecurrenceSchoolEvents: DeleteInfo;
  deleteRooms: DeleteInfo;
  deleteSchoolEvents: DeleteInfo;
  deleteSchoolYears: DeleteInfo;
  deleteSubjectContainers: DeleteInfo;
  deleteSubjectGroups: DeleteInfo;
  deleteSubjects: DeleteInfo;
  deleteSubstitutionAnnouncements: DeleteInfo;
  deleteSubstitutionAppConfigs: DeleteInfo;
  deleteSubstitutionPrintColumnConfigs: DeleteInfo;
  deleteSubstitutionPrintConfigs: DeleteInfo;
  deleteSubstitutionReports: DeleteInfo;
  deleteTableConfigs: DeleteInfo;
  deleteTeachingBlockAvailabilityExclusions: DeleteInfo;
  deleteTeachingBlockCards: DeleteInfo;
  deleteTeachingBlockVersions: DeleteInfo;
  deleteTeachingBlocks: DeleteInfo;
  deleteTeachingLoadFactors: DeleteInfo;
  deleteTeachingLoadReports: DeleteInfo;
  deleteTeachingLoadScenarios: DeleteInfo;
  deleteTimeGridEntries: DeleteInfo;
  deleteTimeGrids: DeleteInfo;
  deleteTimespans: DeleteInfo;
  deleteTimetableBlocks: DeleteInfo;
  deleteTimetableCards: DeleteInfo;
  deleteTimetableConfigs: DeleteInfo;
  deleteTimetablePrintConfigs: DeleteInfo;
  deleteTimetableReports: DeleteInfo;
  deleteTimetableTimeGridConfigs: DeleteInfo;
  deleteTimetableVersion: DeleteInfo;
  deleteTimetableVersions: DeleteInfo;
  deleteTimetables: DeleteInfo;
  deleteUserConfigs: DeleteInfo;
  disconnectLessonsFromTimetableVersion: EntitiesUpdateInfo;
  duplicateTeachingBlockVersion: DuplicateTeachingBlockVersionResponse;
  duplicateTimetableVersion: DuplicateTimetableVersionResponse;
  inheritLessonTeachers: EntitiesUpdateInfo;
  inviteUser: PimProfile;
  mergeEvents: EntitiesUpdateInfo;
  mergeLessons: CreateResponse;
  moveEvent: EntitiesUpdateInfo;
  removeLessonsFromTimetableVersion: EntitiesUpdateInfo;
  removePlanungAccess: PimProfile;
  resetEvent: EntitiesUpdateInfo;
  setPrintEvent: EntitiesUpdateInfo;
  setSelfWorkForEvent: EntitiesUpdateInfo;
  setSubstitution: EntitiesUpdateInfo;
  updateAbsence: UpdateResponse;
  updateAdditionalTeachingLoads: UpdateAdditionalTeachingLoadsMutationResponse;
  updateBuildings: UpdateBuildingsMutationResponse;
  updateClasses: UpdateClassesMutationResponse;
  updateColumnSorts: UpdateColumnSortsMutationResponse;
  updateContracts: UpdateContractsMutationResponse;
  updateCurricula: UpdateCurriculaMutationResponse;
  updateCurriculumClasses: UpdateCurriculumClassesMutationResponse;
  updateCurriculumPeople: UpdateCurriculumPeopleMutationResponse;
  updateCurriculumUnits: UpdateCurriculumUnitsMutationResponse;
  updateCurriculumVersions: UpdateCurriculumVersionsMutationResponse;
  updateDependencies: UpdateDependenciesMutationResponse;
  updateDivisions: UpdateDivisionsMutationResponse;
  updateEventJobs: UpdateEventJobsMutationResponse;
  updateFileEntries: UpdateFileEntriesMutationResponse;
  updateGradeGroups: UpdateGradeGroupsMutationResponse;
  updateGrantedProfiles: EntitiesUpdateInfo;
  updateGroups: UpdateGroupsMutationResponse;
  updateHolidays: UpdateHolidaysMutationResponse;
  updateLabels: UpdateLabelsMutationResponse;
  updateLessonClasses: UpdateLessonClassesMutationResponse;
  updateLessonUnits: UpdateLessonUnitsMutationResponse;
  updateLessons: UpdateLessonsMutationResponse;
  updateLockeds: UpdateLockedsMutationResponse;
  updateMathplanJobs: UpdateMathplanJobsMutationResponse;
  updateOrganizations: UpdateOrganizationsMutationResponse;
  updatePasswords: UpdatePasswordsMutationResponse;
  updatePeople: UpdatePeopleMutationResponse;
  updatePublishedSubstitutions: UpdatePublishedSubstitutionsMutationResponse;
  updateQualifications: UpdateQualificationsMutationResponse;
  updateRecurrenceSchoolEvents: UpdateResponse;
  updateRooms: UpdateRoomsMutationResponse;
  updateSchoolEvent: UpdateResponse;
  updateSchoolYears: UpdateSchoolYearsMutationResponse;
  updateShortNames?: Maybe<UpdateShortNamesMutationResponse>;
  updateSubjectContainers: UpdateSubjectContainersMutationResponse;
  updateSubjectGroups: UpdateSubjectGroupsMutationResponse;
  updateSubjects: UpdateSubjectsMutationResponse;
  updateSubstitutionAnnouncements: UpdateSubstitutionAnnouncementsMutationResponse;
  updateSubstitutionAppConfigs: UpdateSubstitutionAppConfigsMutationResponse;
  updateSubstitutionPrintColumnConfigs: UpdateSubstitutionPrintColumnConfigsMutationResponse;
  updateSubstitutionPrintConfigs: UpdateSubstitutionPrintConfigsMutationResponse;
  updateSubstitutionReports: UpdateSubstitutionReportsMutationResponse;
  updateTableConfigs: UpdateTableConfigsMutationResponse;
  updateTeachingBlockAvailabilityExclusions: UpdateTeachingBlockAvailabilityExclusionsMutationResponse;
  updateTeachingBlockCards: UpdateTeachingBlockCardsMutationResponse;
  updateTeachingBlockVersions: UpdateTeachingBlockVersionsMutationResponse;
  updateTeachingBlocks: UpdateTeachingBlocksMutationResponse;
  updateTeachingLoadFactors: UpdateTeachingLoadFactorsMutationResponse;
  updateTeachingLoadReports: UpdateTeachingLoadReportsMutationResponse;
  updateTeachingLoadScenarios: UpdateTeachingLoadScenariosMutationResponse;
  updateTimeGridEntries: UpdateTimeGridEntriesMutationResponse;
  updateTimeGrids: UpdateTimeGridsMutationResponse;
  updateTimespans: UpdateTimespansMutationResponse;
  updateTimetableBlocks: UpdateTimetableBlocksMutationResponse;
  updateTimetableCards: UpdateTimetableCardsMutationResponse;
  updateTimetableConfigs: UpdateTimetableConfigsMutationResponse;
  updateTimetablePrintConfigs: UpdateTimetablePrintConfigsMutationResponse;
  updateTimetableReports: UpdateTimetableReportsMutationResponse;
  updateTimetableTimeGridConfigs: UpdateTimetableTimeGridConfigsMutationResponse;
  updateTimetableVersions: UpdateTimetableVersionsMutationResponse;
  updateTimetables: UpdateTimetablesMutationResponse;
  updateUserConfigs: UpdateUserConfigsMutationResponse;
  updateUserPermissions: PimProfile;
};

export type MutationAddUserArgs = {
  email: Scalars['String']['input'];
  frontendUri: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  planungPersonUuid: Scalars['ID']['input'];
  profileUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCancelEventArgs = {
  eventUuid: Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationConnectEntityWithVersionArgs = {
  entityType: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
};

export type MutationConnectLessonsToTimetableVersionArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationCopyLessonsToTimetableVersionArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationCreateAbsenceArgs = {
  input: CreateAbsenceInput;
};

export type MutationCreateAdditionalTeachingLoadsArgs = {
  input: Array<AdditionalTeachingLoadCreateInput>;
};

export type MutationCreateBackendTeachingBlockVersionArgs = {
  connectLessons?: InputMaybe<Scalars['Boolean']['input']>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  subjectContainerUuid: Scalars['ID']['input'];
};

export type MutationCreateBuildingsArgs = {
  input: Array<BuildingCreateInput>;
};

export type MutationCreateClassesArgs = {
  input: Array<ClassCreateInput>;
};

export type MutationCreateColumnSortsArgs = {
  input: Array<ColumnSortCreateInput>;
};

export type MutationCreateContractsArgs = {
  input: Array<ContractCreateInput>;
};

export type MutationCreateCurriculaArgs = {
  input: Array<CurriculumCreateInput>;
};

export type MutationCreateCurriculumClassesArgs = {
  input: Array<CurriculumClassCreateInput>;
};

export type MutationCreateCurriculumPeopleArgs = {
  input: Array<CurriculumPersonCreateInput>;
};

export type MutationCreateCurriculumUnitsArgs = {
  input: Array<CurriculumUnitCreateInput>;
};

export type MutationCreateCurriculumVersionsArgs = {
  input: Array<CurriculumVersionCreateInput>;
};

export type MutationCreateDependenciesArgs = {
  input: Array<DependencyCreateInput>;
};

export type MutationCreateDivisionsArgs = {
  input: Array<DivisionCreateInput>;
};

export type MutationCreateEventJobsArgs = {
  input: Array<EventJobCreateInput>;
};

export type MutationCreateFileEntriesArgs = {
  input: Array<FileEntryCreateInput>;
};

export type MutationCreateGradeGroupsArgs = {
  input: Array<GradeGroupCreateInput>;
};

export type MutationCreateGroupsArgs = {
  input: Array<GroupCreateInput>;
};

export type MutationCreateHolidaysArgs = {
  input: Array<HolidayCreateInput>;
};

export type MutationCreateLabelsArgs = {
  input: Array<LabelCreateInput>;
};

export type MutationCreateLessonClassesArgs = {
  input: Array<LessonClassCreateInput>;
};

export type MutationCreateLessonUnitsArgs = {
  input: Array<LessonUnitCreateInput>;
};

export type MutationCreateLessonsArgs = {
  input: Array<LessonCreateInput>;
};

export type MutationCreateLockedsArgs = {
  input: Array<LockedCreateInput>;
};

export type MutationCreateMathplanJobsArgs = {
  input: Array<MathplanJobCreateInput>;
};

export type MutationCreateOrganizationsArgs = {
  input: Array<OrganizationCreateInput>;
};

export type MutationCreatePeopleArgs = {
  input: Array<PersonCreateInput>;
};

export type MutationCreatePublishedSubstitutionsArgs = {
  input: Array<PublishedSubstitutionsCreateInput>;
};

export type MutationCreateQualificationsArgs = {
  input: Array<QualificationCreateInput>;
};

export type MutationCreateRecurrenceSchoolEventsArgs = {
  input: RecurrenceSchoolEventCreateInput;
};

export type MutationCreateRoomsArgs = {
  input: Array<RoomCreateInput>;
};

export type MutationCreateSchoolEventArgs = {
  input: SchoolEventCreateInput;
};

export type MutationCreateSchoolYearsArgs = {
  input: Array<SchoolYearCreateInput>;
};

export type MutationCreateSubjectContainersArgs = {
  input: Array<SubjectContainerCreateInput>;
};

export type MutationCreateSubjectGroupsArgs = {
  input: Array<SubjectGroupCreateInput>;
};

export type MutationCreateSubjectsArgs = {
  input: Array<SubjectCreateInput>;
};

export type MutationCreateSubstitutionAnnouncementsArgs = {
  input: Array<SubstitutionAnnouncementCreateInput>;
};

export type MutationCreateSubstitutionAppConfigsArgs = {
  input: Array<SubstitutionAppConfigCreateInput>;
};

export type MutationCreateSubstitutionPrintColumnConfigsArgs = {
  input: Array<SubstitutionPrintColumnConfigCreateInput>;
};

export type MutationCreateSubstitutionPrintConfigsArgs = {
  input: Array<SubstitutionPrintConfigCreateInput>;
};

export type MutationCreateSubstitutionReportsArgs = {
  input: Array<SubstitutionReportCreateInput>;
};

export type MutationCreateTableConfigsArgs = {
  input: Array<TableConfigCreateInput>;
};

export type MutationCreateTeachingBlockAvailabilityExclusionsArgs = {
  input: Array<TeachingBlockAvailabilityExclusionCreateInput>;
};

export type MutationCreateTeachingBlockCardsArgs = {
  input: Array<TeachingBlockCardCreateInput>;
};

export type MutationCreateTeachingBlockVersionsArgs = {
  input: Array<TeachingBlockVersionCreateInput>;
};

export type MutationCreateTeachingBlocksArgs = {
  input: Array<TeachingBlockCreateInput>;
};

export type MutationCreateTeachingLoadFactorsArgs = {
  input: Array<TeachingLoadFactorCreateInput>;
};

export type MutationCreateTeachingLoadReportsArgs = {
  input: Array<TeachingLoadReportCreateInput>;
};

export type MutationCreateTeachingLoadScenariosArgs = {
  input: Array<TeachingLoadScenarioCreateInput>;
};

export type MutationCreateTimeGridEntriesArgs = {
  input: Array<TimeGridEntryCreateInput>;
};

export type MutationCreateTimeGridsArgs = {
  input: Array<TimeGridCreateInput>;
};

export type MutationCreateTimespansArgs = {
  input: Array<TimespanCreateInput>;
};

export type MutationCreateTimetableBlocksArgs = {
  input: Array<TimetableBlockCreateInput>;
};

export type MutationCreateTimetableCardsArgs = {
  input: Array<TimetableCardCreateInput>;
};

export type MutationCreateTimetableConfigsArgs = {
  input: Array<TimetableConfigCreateInput>;
};

export type MutationCreateTimetablePrintConfigsArgs = {
  input: Array<TimetablePrintConfigCreateInput>;
};

export type MutationCreateTimetableReportsArgs = {
  input: Array<TimetableReportCreateInput>;
};

export type MutationCreateTimetableTimeGridConfigsArgs = {
  input: Array<TimetableTimeGridConfigCreateInput>;
};

export type MutationCreateTimetableVersionArgs = {
  organizationUuid: Scalars['ID']['input'];
  timetableUuid: Scalars['ID']['input'];
};

export type MutationCreateTimetableVersionsArgs = {
  input: Array<TimetableVersionCreateInput>;
};

export type MutationCreateTimetablesArgs = {
  input: Array<TimetableCreateInput>;
};

export type MutationCreateUserConfigsArgs = {
  input: Array<UserConfigCreateInput>;
};

export type MutationDeleteAbsenceArgs = {
  removeSubstitutions: Scalars['Boolean']['input'];
  where: OnlyUuids;
};

export type MutationDeleteAdditionalTeachingLoadsArgs = {
  delete?: InputMaybe<AdditionalTeachingLoadDeleteInput>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type MutationDeleteBuildingsArgs = {
  delete?: InputMaybe<BuildingDeleteInput>;
  where?: InputMaybe<BuildingWhere>;
};

export type MutationDeleteClassesArgs = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<ClassWhere>;
};

export type MutationDeleteColumnSortsArgs = {
  delete?: InputMaybe<ColumnSortDeleteInput>;
  where?: InputMaybe<ColumnSortWhere>;
};

export type MutationDeleteContractsArgs = {
  delete?: InputMaybe<ContractDeleteInput>;
  where?: InputMaybe<ContractWhere>;
};

export type MutationDeleteCurriculaArgs = {
  delete?: InputMaybe<CurriculumDeleteInput>;
  where?: InputMaybe<CurriculumWhere>;
};

export type MutationDeleteCurriculumClassesArgs = {
  delete?: InputMaybe<CurriculumClassDeleteInput>;
  where?: InputMaybe<CurriculumClassWhere>;
};

export type MutationDeleteCurriculumPeopleArgs = {
  delete?: InputMaybe<CurriculumPersonDeleteInput>;
  where?: InputMaybe<CurriculumPersonWhere>;
};

export type MutationDeleteCurriculumUnitsArgs = {
  delete?: InputMaybe<CurriculumUnitDeleteInput>;
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type MutationDeleteCurriculumVersionsArgs = {
  delete?: InputMaybe<CurriculumVersionDeleteInput>;
  where?: InputMaybe<CurriculumVersionWhere>;
};

export type MutationDeleteDependenciesArgs = {
  delete?: InputMaybe<DependencyDeleteInput>;
  where?: InputMaybe<DependencyWhere>;
};

export type MutationDeleteDivisionsArgs = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<DivisionWhere>;
};

export type MutationDeleteEventJobsArgs = {
  where?: InputMaybe<EventJobWhere>;
};

export type MutationDeleteFileEntriesArgs = {
  delete?: InputMaybe<FileEntryDeleteInput>;
  where?: InputMaybe<FileEntryWhere>;
};

export type MutationDeleteGradeGroupsArgs = {
  delete?: InputMaybe<GradeGroupDeleteInput>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type MutationDeleteGroupsArgs = {
  delete?: InputMaybe<GroupDeleteInput>;
  where?: InputMaybe<GroupWhere>;
};

export type MutationDeleteHolidaysArgs = {
  where?: InputMaybe<HolidayWhere>;
};

export type MutationDeleteLabelsArgs = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<LabelWhere>;
};

export type MutationDeleteLessonClassesArgs = {
  delete?: InputMaybe<LessonClassDeleteInput>;
  where?: InputMaybe<LessonClassWhere>;
};

export type MutationDeleteLessonUnitsArgs = {
  delete?: InputMaybe<LessonUnitDeleteInput>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type MutationDeleteLessonsArgs = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<LessonWhere>;
};

export type MutationDeleteLockedsArgs = {
  where?: InputMaybe<LockedWhere>;
};

export type MutationDeleteMathplanJobsArgs = {
  delete?: InputMaybe<MathplanJobDeleteInput>;
  where?: InputMaybe<MathplanJobWhere>;
};

export type MutationDeleteOrganizationsArgs = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<OrganizationWhere>;
};

export type MutationDeletePeopleArgs = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<PersonWhere>;
};

export type MutationDeletePublishedSubstitutionsArgs = {
  where?: InputMaybe<PublishedSubstitutionsWhere>;
};

export type MutationDeleteQualificationsArgs = {
  delete?: InputMaybe<QualificationDeleteInput>;
  where?: InputMaybe<QualificationWhere>;
};

export type MutationDeleteRecurrenceSchoolEventsArgs = {
  recurrenceUuid: Scalars['ID']['input'];
};

export type MutationDeleteRoomsArgs = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<RoomWhere>;
};

export type MutationDeleteSchoolEventsArgs = {
  where: OnlyUuids;
};

export type MutationDeleteSchoolYearsArgs = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type MutationDeleteSubjectContainersArgs = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type MutationDeleteSubjectGroupsArgs = {
  delete?: InputMaybe<SubjectGroupDeleteInput>;
  where?: InputMaybe<SubjectGroupWhere>;
};

export type MutationDeleteSubjectsArgs = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<SubjectWhere>;
};

export type MutationDeleteSubstitutionAnnouncementsArgs = {
  where?: InputMaybe<SubstitutionAnnouncementWhere>;
};

export type MutationDeleteSubstitutionAppConfigsArgs = {
  where?: InputMaybe<SubstitutionAppConfigWhere>;
};

export type MutationDeleteSubstitutionPrintColumnConfigsArgs = {
  where?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
};

export type MutationDeleteSubstitutionPrintConfigsArgs = {
  delete?: InputMaybe<SubstitutionPrintConfigDeleteInput>;
  where?: InputMaybe<SubstitutionPrintConfigWhere>;
};

export type MutationDeleteSubstitutionReportsArgs = {
  delete?: InputMaybe<SubstitutionReportDeleteInput>;
  where?: InputMaybe<SubstitutionReportWhere>;
};

export type MutationDeleteTableConfigsArgs = {
  delete?: InputMaybe<TableConfigDeleteInput>;
  where?: InputMaybe<TableConfigWhere>;
};

export type MutationDeleteTeachingBlockAvailabilityExclusionsArgs = {
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionDeleteInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
};

export type MutationDeleteTeachingBlockCardsArgs = {
  delete?: InputMaybe<TeachingBlockCardDeleteInput>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type MutationDeleteTeachingBlockVersionsArgs = {
  delete?: InputMaybe<TeachingBlockVersionDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type MutationDeleteTeachingBlocksArgs = {
  delete?: InputMaybe<TeachingBlockDeleteInput>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type MutationDeleteTeachingLoadFactorsArgs = {
  delete?: InputMaybe<TeachingLoadFactorDeleteInput>;
  where?: InputMaybe<TeachingLoadFactorWhere>;
};

export type MutationDeleteTeachingLoadReportsArgs = {
  delete?: InputMaybe<TeachingLoadReportDeleteInput>;
  where?: InputMaybe<TeachingLoadReportWhere>;
};

export type MutationDeleteTeachingLoadScenariosArgs = {
  where?: InputMaybe<TeachingLoadScenarioWhere>;
};

export type MutationDeleteTimeGridEntriesArgs = {
  delete?: InputMaybe<TimeGridEntryDeleteInput>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type MutationDeleteTimeGridsArgs = {
  delete?: InputMaybe<TimeGridDeleteInput>;
  where?: InputMaybe<TimeGridWhere>;
};

export type MutationDeleteTimespansArgs = {
  where?: InputMaybe<TimespanWhere>;
};

export type MutationDeleteTimetableBlocksArgs = {
  delete?: InputMaybe<TimetableBlockDeleteInput>;
  where?: InputMaybe<TimetableBlockWhere>;
};

export type MutationDeleteTimetableCardsArgs = {
  delete?: InputMaybe<TimetableCardDeleteInput>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type MutationDeleteTimetableConfigsArgs = {
  delete?: InputMaybe<TimetableConfigDeleteInput>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type MutationDeleteTimetablePrintConfigsArgs = {
  delete?: InputMaybe<TimetablePrintConfigDeleteInput>;
  where?: InputMaybe<TimetablePrintConfigWhere>;
};

export type MutationDeleteTimetableReportsArgs = {
  delete?: InputMaybe<TimetableReportDeleteInput>;
  where?: InputMaybe<TimetableReportWhere>;
};

export type MutationDeleteTimetableTimeGridConfigsArgs = {
  delete?: InputMaybe<TimetableTimeGridConfigDeleteInput>;
  where?: InputMaybe<TimetableTimeGridConfigWhere>;
};

export type MutationDeleteTimetableVersionArgs = {
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationDeleteTimetableVersionsArgs = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type MutationDeleteTimetablesArgs = {
  delete?: InputMaybe<TimetableDeleteInput>;
  where?: InputMaybe<TimetableWhere>;
};

export type MutationDeleteUserConfigsArgs = {
  delete?: InputMaybe<UserConfigDeleteInput>;
  where?: InputMaybe<UserConfigWhere>;
};

export type MutationDisconnectLessonsFromTimetableVersionArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationDuplicateTeachingBlockVersionArgs = {
  options: DuplicateTeachingBlockVersionOptions;
  organizationUuid: Scalars['ID']['input'];
  teachingBlockVersionUuid: Scalars['ID']['input'];
};

export type MutationDuplicateTimetableVersionArgs = {
  options: DuplicateTimetableVersionOptions;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationInheritLessonTeachersArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  type: InheritLessonTeachersType;
};

export type MutationInviteUserArgs = {
  email: Scalars['String']['input'];
  frontendUri?: InputMaybe<Scalars['String']['input']>;
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
};

export type MutationMergeEventsArgs = {
  eventsToMerge: Array<Scalars['ID']['input']>;
  rooms: Array<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  targetEvent: Scalars['ID']['input'];
};

export type MutationMergeLessonsArgs = {
  cardsFromLesson?: InputMaybe<Scalars['ID']['input']>;
  lessonUuids: Array<Scalars['ID']['input']>;
  newCards: Array<MergeLessonNewCardsInput>;
  removePlacedCards: Scalars['Boolean']['input'];
  timetableVersion?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationMoveEventArgs = {
  eventUuid: Scalars['ID']['input'];
  newEnd: Scalars['DateTime']['input'];
  newStart: Scalars['DateTime']['input'];
};

export type MutationRemoveLessonsFromTimetableVersionArgs = {
  lessonUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
};

export type MutationRemovePlanungAccessArgs = {
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
};

export type MutationResetEventArgs = {
  eventUuid: Scalars['ID']['input'];
};

export type MutationSetPrintEventArgs = {
  eventUuid: Scalars['ID']['input'];
  print: Scalars['Boolean']['input'];
};

export type MutationSetSelfWorkForEventArgs = {
  eventUuid: Scalars['ID']['input'];
  rooms: Array<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSetSubstitutionArgs = {
  coveringTeachers: Array<SetCoveringTeachersInput>;
  eventUuid: Scalars['ID']['input'];
  rooms: Array<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAbsenceArgs = {
  update: UpdateAbsenceInput;
  where: OnlyUuids;
};

export type MutationUpdateAdditionalTeachingLoadsArgs = {
  update?: InputMaybe<AdditionalTeachingLoadUpdateInput>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type MutationUpdateBuildingsArgs = {
  update?: InputMaybe<BuildingUpdateInput>;
  where?: InputMaybe<BuildingWhere>;
};

export type MutationUpdateClassesArgs = {
  update?: InputMaybe<ClassUpdateInput>;
  where?: InputMaybe<ClassWhere>;
};

export type MutationUpdateColumnSortsArgs = {
  update?: InputMaybe<ColumnSortUpdateInput>;
  where?: InputMaybe<ColumnSortWhere>;
};

export type MutationUpdateContractsArgs = {
  update?: InputMaybe<ContractUpdateInput>;
  where?: InputMaybe<ContractWhere>;
};

export type MutationUpdateCurriculaArgs = {
  update?: InputMaybe<CurriculumUpdateInput>;
  where?: InputMaybe<CurriculumWhere>;
};

export type MutationUpdateCurriculumClassesArgs = {
  update?: InputMaybe<CurriculumClassUpdateInput>;
  where?: InputMaybe<CurriculumClassWhere>;
};

export type MutationUpdateCurriculumPeopleArgs = {
  update?: InputMaybe<CurriculumPersonUpdateInput>;
  where?: InputMaybe<CurriculumPersonWhere>;
};

export type MutationUpdateCurriculumUnitsArgs = {
  update?: InputMaybe<CurriculumUnitUpdateInput>;
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type MutationUpdateCurriculumVersionsArgs = {
  update?: InputMaybe<CurriculumVersionUpdateInput>;
  where?: InputMaybe<CurriculumVersionWhere>;
};

export type MutationUpdateDependenciesArgs = {
  update?: InputMaybe<DependencyUpdateInput>;
  where?: InputMaybe<DependencyWhere>;
};

export type MutationUpdateDivisionsArgs = {
  update?: InputMaybe<DivisionUpdateInput>;
  where?: InputMaybe<DivisionWhere>;
};

export type MutationUpdateEventJobsArgs = {
  update?: InputMaybe<EventJobUpdateInput>;
  where?: InputMaybe<EventJobWhere>;
};

export type MutationUpdateFileEntriesArgs = {
  update?: InputMaybe<FileEntryUpdateInput>;
  where?: InputMaybe<FileEntryWhere>;
};

export type MutationUpdateGradeGroupsArgs = {
  update?: InputMaybe<GradeGroupUpdateInput>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type MutationUpdateGrantedProfilesArgs = {
  frontendUri?: InputMaybe<Scalars['String']['input']>;
  organizationUuid: Scalars['ID']['input'];
  profiles: Array<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationUpdateGroupsArgs = {
  update?: InputMaybe<GroupUpdateInput>;
  where?: InputMaybe<GroupWhere>;
};

export type MutationUpdateHolidaysArgs = {
  update?: InputMaybe<HolidayUpdateInput>;
  where?: InputMaybe<HolidayWhere>;
};

export type MutationUpdateLabelsArgs = {
  update?: InputMaybe<LabelUpdateInput>;
  where?: InputMaybe<LabelWhere>;
};

export type MutationUpdateLessonClassesArgs = {
  update?: InputMaybe<LessonClassUpdateInput>;
  where?: InputMaybe<LessonClassWhere>;
};

export type MutationUpdateLessonUnitsArgs = {
  update?: InputMaybe<LessonUnitUpdateInput>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type MutationUpdateLessonsArgs = {
  update?: InputMaybe<LessonUpdateInput>;
  where?: InputMaybe<LessonWhere>;
};

export type MutationUpdateLockedsArgs = {
  update?: InputMaybe<LockedUpdateInput>;
  where?: InputMaybe<LockedWhere>;
};

export type MutationUpdateMathplanJobsArgs = {
  update?: InputMaybe<MathplanJobUpdateInput>;
  where?: InputMaybe<MathplanJobWhere>;
};

export type MutationUpdateOrganizationsArgs = {
  update?: InputMaybe<OrganizationUpdateInput>;
  where?: InputMaybe<OrganizationWhere>;
};

export type MutationUpdatePasswordsArgs = {
  update: PasswordUpdateInput;
  where: PasswordWhere;
};

export type MutationUpdatePeopleArgs = {
  update?: InputMaybe<PersonUpdateInput>;
  where?: InputMaybe<PersonWhere>;
};

export type MutationUpdatePublishedSubstitutionsArgs = {
  update?: InputMaybe<PublishedSubstitutionsUpdateInput>;
  where?: InputMaybe<PublishedSubstitutionsWhere>;
};

export type MutationUpdateQualificationsArgs = {
  update?: InputMaybe<QualificationUpdateInput>;
  where?: InputMaybe<QualificationWhere>;
};

export type MutationUpdateRecurrenceSchoolEventsArgs = {
  excludeHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  recurrenceUuid: Scalars['ID']['input'];
  rrule: Scalars['String']['input'];
  update: SchoolEventUpdateInput;
};

export type MutationUpdateRoomsArgs = {
  update?: InputMaybe<RoomUpdateInput>;
  where?: InputMaybe<RoomWhere>;
};

export type MutationUpdateSchoolEventArgs = {
  eventUuid: Scalars['ID']['input'];
  update: SchoolEventUpdateInput;
};

export type MutationUpdateSchoolYearsArgs = {
  update?: InputMaybe<SchoolYearUpdateInput>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type MutationUpdateShortNamesArgs = {
  organizationUuid: Scalars['ID']['input'];
};

export type MutationUpdateSubjectContainersArgs = {
  update?: InputMaybe<SubjectContainerUpdateInput>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type MutationUpdateSubjectGroupsArgs = {
  update?: InputMaybe<SubjectGroupUpdateInput>;
  where?: InputMaybe<SubjectGroupWhere>;
};

export type MutationUpdateSubjectsArgs = {
  update?: InputMaybe<SubjectUpdateInput>;
  where?: InputMaybe<SubjectWhere>;
};

export type MutationUpdateSubstitutionAnnouncementsArgs = {
  update?: InputMaybe<SubstitutionAnnouncementUpdateInput>;
  where?: InputMaybe<SubstitutionAnnouncementWhere>;
};

export type MutationUpdateSubstitutionAppConfigsArgs = {
  update?: InputMaybe<SubstitutionAppConfigUpdateInput>;
  where?: InputMaybe<SubstitutionAppConfigWhere>;
};

export type MutationUpdateSubstitutionPrintColumnConfigsArgs = {
  update?: InputMaybe<SubstitutionPrintColumnConfigUpdateInput>;
  where?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
};

export type MutationUpdateSubstitutionPrintConfigsArgs = {
  update?: InputMaybe<SubstitutionPrintConfigUpdateInput>;
  where?: InputMaybe<SubstitutionPrintConfigWhere>;
};

export type MutationUpdateSubstitutionReportsArgs = {
  update?: InputMaybe<SubstitutionReportUpdateInput>;
  where?: InputMaybe<SubstitutionReportWhere>;
};

export type MutationUpdateTableConfigsArgs = {
  update?: InputMaybe<TableConfigUpdateInput>;
  where?: InputMaybe<TableConfigWhere>;
};

export type MutationUpdateTeachingBlockAvailabilityExclusionsArgs = {
  update?: InputMaybe<TeachingBlockAvailabilityExclusionUpdateInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
};

export type MutationUpdateTeachingBlockCardsArgs = {
  update?: InputMaybe<TeachingBlockCardUpdateInput>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type MutationUpdateTeachingBlockVersionsArgs = {
  update?: InputMaybe<TeachingBlockVersionUpdateInput>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type MutationUpdateTeachingBlocksArgs = {
  update?: InputMaybe<TeachingBlockUpdateInput>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type MutationUpdateTeachingLoadFactorsArgs = {
  update?: InputMaybe<TeachingLoadFactorUpdateInput>;
  where?: InputMaybe<TeachingLoadFactorWhere>;
};

export type MutationUpdateTeachingLoadReportsArgs = {
  update?: InputMaybe<TeachingLoadReportUpdateInput>;
  where?: InputMaybe<TeachingLoadReportWhere>;
};

export type MutationUpdateTeachingLoadScenariosArgs = {
  update?: InputMaybe<TeachingLoadScenarioUpdateInput>;
  where?: InputMaybe<TeachingLoadScenarioWhere>;
};

export type MutationUpdateTimeGridEntriesArgs = {
  update?: InputMaybe<TimeGridEntryUpdateInput>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type MutationUpdateTimeGridsArgs = {
  update?: InputMaybe<TimeGridUpdateInput>;
  where?: InputMaybe<TimeGridWhere>;
};

export type MutationUpdateTimespansArgs = {
  update?: InputMaybe<TimespanUpdateInput>;
  where?: InputMaybe<TimespanWhere>;
};

export type MutationUpdateTimetableBlocksArgs = {
  update?: InputMaybe<TimetableBlockUpdateInput>;
  where?: InputMaybe<TimetableBlockWhere>;
};

export type MutationUpdateTimetableCardsArgs = {
  update?: InputMaybe<TimetableCardUpdateInput>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type MutationUpdateTimetableConfigsArgs = {
  update?: InputMaybe<TimetableConfigUpdateInput>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type MutationUpdateTimetablePrintConfigsArgs = {
  update?: InputMaybe<TimetablePrintConfigUpdateInput>;
  where?: InputMaybe<TimetablePrintConfigWhere>;
};

export type MutationUpdateTimetableReportsArgs = {
  update?: InputMaybe<TimetableReportUpdateInput>;
  where?: InputMaybe<TimetableReportWhere>;
};

export type MutationUpdateTimetableTimeGridConfigsArgs = {
  update?: InputMaybe<TimetableTimeGridConfigUpdateInput>;
  where?: InputMaybe<TimetableTimeGridConfigWhere>;
};

export type MutationUpdateTimetableVersionsArgs = {
  update?: InputMaybe<TimetableVersionUpdateInput>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type MutationUpdateTimetablesArgs = {
  update?: InputMaybe<TimetableUpdateInput>;
  where?: InputMaybe<TimetableWhere>;
};

export type MutationUpdateUserConfigsArgs = {
  update?: InputMaybe<UserConfigUpdateInput>;
  where?: InputMaybe<UserConfigWhere>;
};

export type MutationUpdateUserPermissionsArgs = {
  organizationUuid: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
  profileUuid: Scalars['ID']['input'];
};

export type OnlyUuids = {
  uuids: Array<Scalars['ID']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Class.tutors
 * * Person.classes
 * * Person.rooms
 * * Division.groups
 * * Group.division
 * * Lesson.lessonClasses
 * * Lesson.lessonUnit
 * * Curriculum.curriculumGrades
 * * Curriculum.curriculumUnit
 * * Subject.defaultRooms
 * * Room.responsiblePersons
 * * TableConfig.columnsSort
 * * Timetable.timegridConfigs
 * * TeachingLoadReport.context
 * * TeachingLoadReport.fileEntries
 * * TimetableReport.context
 * * TimetableReport.fileEntries
 * * SubstitutionReport.context
 * * SubstitutionReport.fileEntries
 * * FileEntry.holder
 */
export type OrderedRelationProperties = {
  __typename?: 'OrderedRelationProperties';
  order: Scalars['Int']['output'];
};

export type OrderedRelationPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<OrderedRelationPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<OrderedRelationPropertiesAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderedRelationPropertiesCreateInput = {
  order: Scalars['Int']['input'];
};

export type OrderedRelationPropertiesSort = {
  order?: InputMaybe<SortDirection>;
};

export type OrderedRelationPropertiesUpdateInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderedRelationPropertiesWhere = {
  AND?: InputMaybe<Array<OrderedRelationPropertiesWhere>>;
  NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  OR?: InputMaybe<Array<OrderedRelationPropertiesWhere>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Organization = {
  __typename?: 'Organization';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  divisions: Array<Division>;
  divisionsConnection: OrganizationDivisionsConnection;
  events: Array<Event>;
  eventsConnection: OrganizationEventsConnection;
  iphisSubstitutionProps?: Maybe<Scalars['String']['output']>;
  /** Optional. (string) list of booked/licensed modules */
  licensedModules?: Maybe<Array<Scalars['String']['output']>>;
  locale: Scalars['String']['output'];
  persons: Array<Person>;
  personsConnection: OrganizationPersonsConnection;
  subjectGroups: Array<SubjectGroup>;
  subjectGroupsConnection: OrganizationSubjectGroupsConnection;
  substitutionProps?: Maybe<Scalars['String']['output']>;
  timetableConfigs: Array<TimetableConfig>;
  timetableConfigsConnection: OrganizationTimetableConfigsConnection;
  timezone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  vpoSubstitutionProps?: Maybe<Scalars['String']['output']>;
};

export type OrganizationDivisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DivisionOptions>;
  where?: InputMaybe<DivisionWhere>;
};

export type OrganizationDivisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationDivisionsConnectionSort>>;
  where?: InputMaybe<OrganizationDivisionsConnectionWhere>;
};

export type OrganizationEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type OrganizationEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationEventsConnectionSort>>;
  where?: InputMaybe<OrganizationEventsConnectionWhere>;
};

export type OrganizationPersonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type OrganizationPersonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationPersonsConnectionSort>>;
  where?: InputMaybe<OrganizationPersonsConnectionWhere>;
};

export type OrganizationSubjectGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectGroupOptions>;
  where?: InputMaybe<SubjectGroupWhere>;
};

export type OrganizationSubjectGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationSubjectGroupsConnectionSort>>;
  where?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
};

export type OrganizationTimetableConfigsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableConfigOptions>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type OrganizationTimetableConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationTimetableConfigsConnectionSort>>;
  where?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
};

export type OrganizationAggregateSelection = {
  __typename?: 'OrganizationAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  iphisSubstitutionProps: StringAggregateSelection;
  locale: StringAggregateSelection;
  substitutionProps: StringAggregateSelection;
  timezone: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
  vpoSubstitutionProps: StringAggregateSelection;
};

export type OrganizationConnectInput = {
  divisions?: InputMaybe<Array<OrganizationDivisionsConnectFieldInput>>;
  events?: InputMaybe<Array<OrganizationEventsConnectFieldInput>>;
  persons?: InputMaybe<Array<OrganizationPersonsConnectFieldInput>>;
  subjectGroups?: InputMaybe<Array<OrganizationSubjectGroupsConnectFieldInput>>;
  timetableConfigs?: InputMaybe<Array<OrganizationTimetableConfigsConnectFieldInput>>;
};

export type OrganizationConnectOrCreateWhere = {
  node: OrganizationUniqueWhere;
};

export type OrganizationConnectWhere = {
  node: OrganizationWhere;
};

export type OrganizationCreateInput = {
  divisions?: InputMaybe<OrganizationDivisionsFieldInput>;
  events?: InputMaybe<OrganizationEventsFieldInput>;
  iphisSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
  licensedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  locale: Scalars['String']['input'];
  persons?: InputMaybe<OrganizationPersonsFieldInput>;
  subjectGroups?: InputMaybe<OrganizationSubjectGroupsFieldInput>;
  substitutionProps?: InputMaybe<Scalars['String']['input']>;
  timetableConfigs?: InputMaybe<OrganizationTimetableConfigsFieldInput>;
  timezone: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['ID']['input'];
  vpoSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationDeleteInput = {
  divisions?: InputMaybe<Array<OrganizationDivisionsDeleteFieldInput>>;
  events?: InputMaybe<Array<OrganizationEventsDeleteFieldInput>>;
  persons?: InputMaybe<Array<OrganizationPersonsDeleteFieldInput>>;
  subjectGroups?: InputMaybe<Array<OrganizationSubjectGroupsDeleteFieldInput>>;
  timetableConfigs?: InputMaybe<Array<OrganizationTimetableConfigsDeleteFieldInput>>;
};

export type OrganizationDisconnectInput = {
  divisions?: InputMaybe<Array<OrganizationDivisionsDisconnectFieldInput>>;
  events?: InputMaybe<Array<OrganizationEventsDisconnectFieldInput>>;
  persons?: InputMaybe<Array<OrganizationPersonsDisconnectFieldInput>>;
  subjectGroups?: InputMaybe<Array<OrganizationSubjectGroupsDisconnectFieldInput>>;
  timetableConfigs?: InputMaybe<Array<OrganizationTimetableConfigsDisconnectFieldInput>>;
};

export type OrganizationDivisionsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationDivisionsAggregateInput>>;
  NOT?: InputMaybe<OrganizationDivisionsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationDivisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationDivisionsNodeAggregationWhereInput>;
};

export type OrganizationDivisionsConnectFieldInput = {
  connect?: InputMaybe<Array<DivisionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DivisionConnectWhere>;
};

export type OrganizationDivisionsConnectOrCreateFieldInput = {
  onCreate: OrganizationDivisionsConnectOrCreateFieldInputOnCreate;
  where: DivisionConnectOrCreateWhere;
};

export type OrganizationDivisionsConnectOrCreateFieldInputOnCreate = {
  node: DivisionOnCreateInput;
};

export type OrganizationDivisionsConnection = {
  __typename?: 'OrganizationDivisionsConnection';
  edges: Array<OrganizationDivisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationDivisionsConnectionSort = {
  node?: InputMaybe<DivisionSort>;
};

export type OrganizationDivisionsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationDivisionsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationDivisionsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationDivisionsConnectionWhere>>;
  node?: InputMaybe<DivisionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DivisionWhere>;
};

export type OrganizationDivisionsCreateFieldInput = {
  node: DivisionCreateInput;
};

export type OrganizationDivisionsDeleteFieldInput = {
  delete?: InputMaybe<DivisionDeleteInput>;
  where?: InputMaybe<OrganizationDivisionsConnectionWhere>;
};

export type OrganizationDivisionsDisconnectFieldInput = {
  disconnect?: InputMaybe<DivisionDisconnectInput>;
  where?: InputMaybe<OrganizationDivisionsConnectionWhere>;
};

export type OrganizationDivisionsFieldInput = {
  connect?: InputMaybe<Array<OrganizationDivisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationDivisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<OrganizationDivisionsCreateFieldInput>>;
};

export type OrganizationDivisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationDivisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationDivisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationDivisionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganizationDivisionsRelationship = {
  __typename?: 'OrganizationDivisionsRelationship';
  cursor: Scalars['String']['output'];
  node: Division;
};

export type OrganizationDivisionsUpdateConnectionInput = {
  node?: InputMaybe<DivisionUpdateInput>;
};

export type OrganizationDivisionsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationDivisionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationDivisionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<OrganizationDivisionsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationDivisionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationDivisionsDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationDivisionsUpdateConnectionInput>;
  where?: InputMaybe<OrganizationDivisionsConnectionWhere>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationEventsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationEventsAggregateInput>>;
  NOT?: InputMaybe<OrganizationEventsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationEventsNodeAggregationWhereInput>;
};

export type OrganizationEventsConnectFieldInput = {
  connect?: InputMaybe<Array<EventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type OrganizationEventsConnection = {
  __typename?: 'OrganizationEventsConnection';
  edges: Array<OrganizationEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type OrganizationEventsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationEventsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationEventsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type OrganizationEventsCreateFieldInput = {
  node: EventCreateInput;
};

export type OrganizationEventsDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<OrganizationEventsConnectionWhere>;
};

export type OrganizationEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<OrganizationEventsConnectionWhere>;
};

export type OrganizationEventsFieldInput = {
  connect?: InputMaybe<Array<OrganizationEventsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationEventsCreateFieldInput>>;
};

export type OrganizationEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganizationEventsRelationship = {
  __typename?: 'OrganizationEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type OrganizationEventsUpdateConnectionInput = {
  node?: InputMaybe<EventUpdateInput>;
};

export type OrganizationEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationEventsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationEventsDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationEventsUpdateConnectionInput>;
  where?: InputMaybe<OrganizationEventsConnectionWhere>;
};

export type OrganizationOnCreateInput = {
  iphisSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
  licensedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  locale: Scalars['String']['input'];
  substitutionProps?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['ID']['input'];
  vpoSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OrganizationSort objects to sort Organizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationSort>>;
};

export type OrganizationPersonsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationPersonsAggregateInput>>;
  NOT?: InputMaybe<OrganizationPersonsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationPersonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationPersonsNodeAggregationWhereInput>;
};

export type OrganizationPersonsConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  edge: RoleNameCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type OrganizationPersonsConnectOrCreateFieldInput = {
  onCreate: OrganizationPersonsConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type OrganizationPersonsConnectOrCreateFieldInputOnCreate = {
  edge: RoleNameCreateInput;
  node: PersonOnCreateInput;
};

export type OrganizationPersonsConnection = {
  __typename?: 'OrganizationPersonsConnection';
  edges: Array<OrganizationPersonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationPersonsConnectionSort = {
  edge?: InputMaybe<RoleNameSort>;
  node?: InputMaybe<PersonSort>;
};

export type OrganizationPersonsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationPersonsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationPersonsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationPersonsConnectionWhere>>;
  edge?: InputMaybe<RoleNameWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNameWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type OrganizationPersonsCreateFieldInput = {
  edge: RoleNameCreateInput;
  node: PersonCreateInput;
};

export type OrganizationPersonsDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<OrganizationPersonsConnectionWhere>;
};

export type OrganizationPersonsDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<OrganizationPersonsConnectionWhere>;
};

export type OrganizationPersonsFieldInput = {
  connect?: InputMaybe<Array<OrganizationPersonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationPersonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<OrganizationPersonsCreateFieldInput>>;
};

export type OrganizationPersonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationPersonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationPersonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationPersonsNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganizationPersonsRelationship = {
  __typename?: 'OrganizationPersonsRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: RoleName;
};

export type OrganizationPersonsUpdateConnectionInput = {
  edge?: InputMaybe<RoleNameUpdateInput>;
  node?: InputMaybe<PersonUpdateInput>;
};

export type OrganizationPersonsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationPersonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationPersonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<OrganizationPersonsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationPersonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationPersonsDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationPersonsUpdateConnectionInput>;
  where?: InputMaybe<OrganizationPersonsConnectionWhere>;
};

/** Fields to sort Organizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationSort object. */
export type OrganizationSort = {
  createdAt?: InputMaybe<SortDirection>;
  iphisSubstitutionProps?: InputMaybe<SortDirection>;
  locale?: InputMaybe<SortDirection>;
  substitutionProps?: InputMaybe<SortDirection>;
  timezone?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  vpoSubstitutionProps?: InputMaybe<SortDirection>;
};

export type OrganizationSubjectGroupsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationSubjectGroupsAggregateInput>>;
  NOT?: InputMaybe<OrganizationSubjectGroupsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationSubjectGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationSubjectGroupsNodeAggregationWhereInput>;
};

export type OrganizationSubjectGroupsConnectFieldInput = {
  connect?: InputMaybe<Array<SubjectGroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectGroupConnectWhere>;
};

export type OrganizationSubjectGroupsConnection = {
  __typename?: 'OrganizationSubjectGroupsConnection';
  edges: Array<OrganizationSubjectGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationSubjectGroupsConnectionSort = {
  node?: InputMaybe<SubjectGroupSort>;
};

export type OrganizationSubjectGroupsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationSubjectGroupsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationSubjectGroupsConnectionWhere>>;
  node?: InputMaybe<SubjectGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectGroupWhere>;
};

export type OrganizationSubjectGroupsCreateFieldInput = {
  node: SubjectGroupCreateInput;
};

export type OrganizationSubjectGroupsDeleteFieldInput = {
  delete?: InputMaybe<SubjectGroupDeleteInput>;
  where?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
};

export type OrganizationSubjectGroupsDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectGroupDisconnectInput>;
  where?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
};

export type OrganizationSubjectGroupsFieldInput = {
  connect?: InputMaybe<Array<OrganizationSubjectGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationSubjectGroupsCreateFieldInput>>;
};

export type OrganizationSubjectGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationSubjectGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationSubjectGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationSubjectGroupsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrganizationSubjectGroupsRelationship = {
  __typename?: 'OrganizationSubjectGroupsRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectGroup;
};

export type OrganizationSubjectGroupsUpdateConnectionInput = {
  node?: InputMaybe<SubjectGroupUpdateInput>;
};

export type OrganizationSubjectGroupsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationSubjectGroupsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationSubjectGroupsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationSubjectGroupsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationSubjectGroupsDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationSubjectGroupsUpdateConnectionInput>;
  where?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
};

export type OrganizationTimetableConfigsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationTimetableConfigsAggregateInput>>;
  NOT?: InputMaybe<OrganizationTimetableConfigsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationTimetableConfigsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationTimetableConfigsNodeAggregationWhereInput>;
};

export type OrganizationTimetableConfigsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableConfigConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConfigConnectWhere>;
};

export type OrganizationTimetableConfigsConnection = {
  __typename?: 'OrganizationTimetableConfigsConnection';
  edges: Array<OrganizationTimetableConfigsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationTimetableConfigsConnectionSort = {
  node?: InputMaybe<TimetableConfigSort>;
};

export type OrganizationTimetableConfigsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationTimetableConfigsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationTimetableConfigsConnectionWhere>>;
  node?: InputMaybe<TimetableConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableConfigWhere>;
};

export type OrganizationTimetableConfigsCreateFieldInput = {
  node: TimetableConfigCreateInput;
};

export type OrganizationTimetableConfigsDeleteFieldInput = {
  delete?: InputMaybe<TimetableConfigDeleteInput>;
  where?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
};

export type OrganizationTimetableConfigsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableConfigDisconnectInput>;
  where?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
};

export type OrganizationTimetableConfigsFieldInput = {
  connect?: InputMaybe<Array<OrganizationTimetableConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationTimetableConfigsCreateFieldInput>>;
};

export type OrganizationTimetableConfigsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationTimetableConfigsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationTimetableConfigsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationTimetableConfigsNodeAggregationWhereInput>>;
  colorLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationTimetableConfigsRelationship = {
  __typename?: 'OrganizationTimetableConfigsRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableConfig;
};

export type OrganizationTimetableConfigsUpdateConnectionInput = {
  node?: InputMaybe<TimetableConfigUpdateInput>;
};

export type OrganizationTimetableConfigsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrganizationTimetableConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<OrganizationTimetableConfigsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrganizationTimetableConfigsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrganizationTimetableConfigsDisconnectFieldInput>>;
  update?: InputMaybe<OrganizationTimetableConfigsUpdateConnectionInput>;
  where?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
};

export type OrganizationUniqueWhere = {
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  divisions?: InputMaybe<Array<OrganizationDivisionsUpdateFieldInput>>;
  events?: InputMaybe<Array<OrganizationEventsUpdateFieldInput>>;
  iphisSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
  licensedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  licensedModules_POP?: InputMaybe<Scalars['Int']['input']>;
  licensedModules_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  persons?: InputMaybe<Array<OrganizationPersonsUpdateFieldInput>>;
  subjectGroups?: InputMaybe<Array<OrganizationSubjectGroupsUpdateFieldInput>>;
  substitutionProps?: InputMaybe<Scalars['String']['input']>;
  timetableConfigs?: InputMaybe<Array<OrganizationTimetableConfigsUpdateFieldInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  vpoSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationWhere = {
  AND?: InputMaybe<Array<OrganizationWhere>>;
  NOT?: InputMaybe<OrganizationWhere>;
  OR?: InputMaybe<Array<OrganizationWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `divisions_SOME` instead. */
  divisions?: InputMaybe<DivisionWhere>;
  divisionsAggregate?: InputMaybe<OrganizationDivisionsAggregateInput>;
  /** @deprecated Use `divisionsConnection_SOME` instead. */
  divisionsConnection?: InputMaybe<OrganizationDivisionsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationDivisionsConnections match this filter */
  divisionsConnection_ALL?: InputMaybe<OrganizationDivisionsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationDivisionsConnections match this filter */
  divisionsConnection_NONE?: InputMaybe<OrganizationDivisionsConnectionWhere>;
  /** @deprecated Use `divisionsConnection_NONE` instead. */
  divisionsConnection_NOT?: InputMaybe<OrganizationDivisionsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationDivisionsConnections match this filter */
  divisionsConnection_SINGLE?: InputMaybe<OrganizationDivisionsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationDivisionsConnections match this filter */
  divisionsConnection_SOME?: InputMaybe<OrganizationDivisionsConnectionWhere>;
  /** Return Organizations where all of the related Divisions match this filter */
  divisions_ALL?: InputMaybe<DivisionWhere>;
  /** Return Organizations where none of the related Divisions match this filter */
  divisions_NONE?: InputMaybe<DivisionWhere>;
  /** @deprecated Use `divisions_NONE` instead. */
  divisions_NOT?: InputMaybe<DivisionWhere>;
  /** Return Organizations where one of the related Divisions match this filter */
  divisions_SINGLE?: InputMaybe<DivisionWhere>;
  /** Return Organizations where some of the related Divisions match this filter */
  divisions_SOME?: InputMaybe<DivisionWhere>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<OrganizationEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<OrganizationEventsConnectionWhere>;
  /** Return Organizations where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return Organizations where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return Organizations where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return Organizations where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  iphisSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
  iphisSubstitutionProps_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  iphisSubstitutionProps_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  iphisSubstitutionProps_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  iphisSubstitutionProps_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  iphisSubstitutionProps_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  iphisSubstitutionProps_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  iphisSubstitutionProps_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  iphisSubstitutionProps_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  iphisSubstitutionProps_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  licensedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  licensedModules_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locale_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  locale_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  locale_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  locale_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `persons_SOME` instead. */
  persons?: InputMaybe<PersonWhere>;
  personsAggregate?: InputMaybe<OrganizationPersonsAggregateInput>;
  /** @deprecated Use `personsConnection_SOME` instead. */
  personsConnection?: InputMaybe<OrganizationPersonsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationPersonsConnections match this filter */
  personsConnection_ALL?: InputMaybe<OrganizationPersonsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationPersonsConnections match this filter */
  personsConnection_NONE?: InputMaybe<OrganizationPersonsConnectionWhere>;
  /** @deprecated Use `personsConnection_NONE` instead. */
  personsConnection_NOT?: InputMaybe<OrganizationPersonsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationPersonsConnections match this filter */
  personsConnection_SINGLE?: InputMaybe<OrganizationPersonsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationPersonsConnections match this filter */
  personsConnection_SOME?: InputMaybe<OrganizationPersonsConnectionWhere>;
  /** Return Organizations where all of the related People match this filter */
  persons_ALL?: InputMaybe<PersonWhere>;
  /** Return Organizations where none of the related People match this filter */
  persons_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `persons_NONE` instead. */
  persons_NOT?: InputMaybe<PersonWhere>;
  /** Return Organizations where one of the related People match this filter */
  persons_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Organizations where some of the related People match this filter */
  persons_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `subjectGroups_SOME` instead. */
  subjectGroups?: InputMaybe<SubjectGroupWhere>;
  subjectGroupsAggregate?: InputMaybe<OrganizationSubjectGroupsAggregateInput>;
  /** @deprecated Use `subjectGroupsConnection_SOME` instead. */
  subjectGroupsConnection?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationSubjectGroupsConnections match this filter */
  subjectGroupsConnection_ALL?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationSubjectGroupsConnections match this filter */
  subjectGroupsConnection_NONE?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
  /** @deprecated Use `subjectGroupsConnection_NONE` instead. */
  subjectGroupsConnection_NOT?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationSubjectGroupsConnections match this filter */
  subjectGroupsConnection_SINGLE?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationSubjectGroupsConnections match this filter */
  subjectGroupsConnection_SOME?: InputMaybe<OrganizationSubjectGroupsConnectionWhere>;
  /** Return Organizations where all of the related SubjectGroups match this filter */
  subjectGroups_ALL?: InputMaybe<SubjectGroupWhere>;
  /** Return Organizations where none of the related SubjectGroups match this filter */
  subjectGroups_NONE?: InputMaybe<SubjectGroupWhere>;
  /** @deprecated Use `subjectGroups_NONE` instead. */
  subjectGroups_NOT?: InputMaybe<SubjectGroupWhere>;
  /** Return Organizations where one of the related SubjectGroups match this filter */
  subjectGroups_SINGLE?: InputMaybe<SubjectGroupWhere>;
  /** Return Organizations where some of the related SubjectGroups match this filter */
  subjectGroups_SOME?: InputMaybe<SubjectGroupWhere>;
  substitutionProps?: InputMaybe<Scalars['String']['input']>;
  substitutionProps_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  substitutionProps_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutionProps_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionProps_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionProps_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionProps_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionProps_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutionProps_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutionProps_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `timetableConfigs_SOME` instead. */
  timetableConfigs?: InputMaybe<TimetableConfigWhere>;
  timetableConfigsAggregate?: InputMaybe<OrganizationTimetableConfigsAggregateInput>;
  /** @deprecated Use `timetableConfigsConnection_SOME` instead. */
  timetableConfigsConnection?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
  /** Return Organizations where all of the related OrganizationTimetableConfigsConnections match this filter */
  timetableConfigsConnection_ALL?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationTimetableConfigsConnections match this filter */
  timetableConfigsConnection_NONE?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
  /** @deprecated Use `timetableConfigsConnection_NONE` instead. */
  timetableConfigsConnection_NOT?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationTimetableConfigsConnections match this filter */
  timetableConfigsConnection_SINGLE?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationTimetableConfigsConnections match this filter */
  timetableConfigsConnection_SOME?: InputMaybe<OrganizationTimetableConfigsConnectionWhere>;
  /** Return Organizations where all of the related TimetableConfigs match this filter */
  timetableConfigs_ALL?: InputMaybe<TimetableConfigWhere>;
  /** Return Organizations where none of the related TimetableConfigs match this filter */
  timetableConfigs_NONE?: InputMaybe<TimetableConfigWhere>;
  /** @deprecated Use `timetableConfigs_NONE` instead. */
  timetableConfigs_NOT?: InputMaybe<TimetableConfigWhere>;
  /** Return Organizations where one of the related TimetableConfigs match this filter */
  timetableConfigs_SINGLE?: InputMaybe<TimetableConfigWhere>;
  /** Return Organizations where some of the related TimetableConfigs match this filter */
  timetableConfigs_SOME?: InputMaybe<TimetableConfigWhere>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  timezone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timezone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  vpoSubstitutionProps?: InputMaybe<Scalars['String']['input']>;
  vpoSubstitutionProps_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  vpoSubstitutionProps_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  vpoSubstitutionProps_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  vpoSubstitutionProps_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  vpoSubstitutionProps_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  vpoSubstitutionProps_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  vpoSubstitutionProps_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  vpoSubstitutionProps_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  vpoSubstitutionProps_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * The edge properties for the following fields:
 * * TimetableVersion.parent
 * * TimetableVersion.children
 */
export type ParentVersionProperties = {
  __typename?: 'ParentVersionProperties';
  description?: Maybe<Scalars['String']['output']>;
};

export type ParentVersionPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<ParentVersionPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<ParentVersionPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<ParentVersionPropertiesAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ParentVersionPropertiesCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ParentVersionPropertiesSort = {
  description?: InputMaybe<SortDirection>;
};

export type ParentVersionPropertiesUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ParentVersionPropertiesWhere = {
  AND?: InputMaybe<Array<ParentVersionPropertiesWhere>>;
  NOT?: InputMaybe<ParentVersionPropertiesWhere>;
  OR?: InputMaybe<Array<ParentVersionPropertiesWhere>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordUpdateInput = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordWhere = {
  uuid: Scalars['ID']['input'];
};

export type PdfReportContext = SchoolYear | TeachingBlock | TimetableBlock;

export type PdfReportContextWhere = {
  SchoolYear?: InputMaybe<SchoolYearWhere>;
  TeachingBlock?: InputMaybe<TeachingBlockWhere>;
  TimetableBlock?: InputMaybe<TimetableBlockWhere>;
};

export type PdfReportHolder = SubstitutionReport | TeachingLoadReport | TimetableReport;

export type PdfReportHolderWhere = {
  SubstitutionReport?: InputMaybe<SubstitutionReportWhere>;
  TeachingLoadReport?: InputMaybe<TeachingLoadReportWhere>;
  TimetableReport?: InputMaybe<TimetableReportWhere>;
};

export type PeopleConnection = {
  __typename?: 'PeopleConnection';
  edges: Array<PersonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Person = {
  __typename?: 'Person';
  absences: Array<Absence>;
  absencesConnection: PersonAbsencesConnection;
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalTeachingLoads: Array<AdditionalTeachingLoad>;
  additionalTeachingLoadsConnection: PersonAdditionalTeachingLoadsConnection;
  birthday?: Maybe<Scalars['Date']['output']>;
  callingName?: Maybe<Scalars['String']['output']>;
  classes: Array<Class>;
  classesConnection: PersonClassesConnection;
  contracts: Array<Contract>;
  contractsAggregate?: Maybe<PersonContractContractsAggregationSelection>;
  contractsConnection: PersonContractsConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currentContract?: Maybe<Contract>;
  defaultRoom?: Maybe<Room>;
  defaultRoomConnection: PersonDefaultRoomConnection;
  displayName: Scalars['String']['output'];
  displayNameShort?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  eventsConnection: PersonEventsConnection;
  firstName: Scalars['String']['output'];
  foreignId?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  labels: Array<Label>;
  labelsConnection: PersonLabelsConnection;
  lastName: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: PersonOrganizationConnection;
  personalId?: Maybe<Scalars['String']['output']>;
  pimProfileUuid?: Maybe<Scalars['String']['output']>;
  prefixName?: Maybe<Scalars['String']['output']>;
  qualifications: Array<Qualification>;
  qualificationsAggregate?: Maybe<PersonQualificationQualificationsAggregationSelection>;
  qualificationsConnection: PersonQualificationsConnection;
  rooms: Array<Room>;
  roomsConnection: PersonRoomsConnection;
  salutation?: Maybe<Scalars['String']['output']>;
  selectName: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  timetableConfig?: Maybe<TimetableConfig>;
  timetableConfigConnection: PersonTimetableConfigConnection;
  title?: Maybe<Scalars['String']['output']>;
  uniqueFirstName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type PersonAbsencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AbsenceOptions>;
  where?: InputMaybe<AbsenceWhere>;
};

export type PersonAbsencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonAbsencesConnectionSort>>;
  where?: InputMaybe<PersonAbsencesConnectionWhere>;
};

export type PersonAdditionalTeachingLoadsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AdditionalTeachingLoadOptions>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type PersonAdditionalTeachingLoadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonAdditionalTeachingLoadsConnectionSort>>;
  where?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
};

export type PersonClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type PersonClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonClassesConnectionSort>>;
  where?: InputMaybe<PersonClassesConnectionWhere>;
};

export type PersonContractsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ContractOptions>;
  where?: InputMaybe<ContractWhere>;
};

export type PersonContractsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContractWhere>;
};

export type PersonContractsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonContractsConnectionSort>>;
  where?: InputMaybe<PersonContractsConnectionWhere>;
};

export type PersonCurrentContractArgs = {
  schoolYearUuid: Scalars['String']['input'];
};

export type PersonDefaultRoomArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type PersonDefaultRoomConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonDefaultRoomConnectionSort>>;
  where?: InputMaybe<PersonDefaultRoomConnectionWhere>;
};

export type PersonEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type PersonEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonEventsConnectionSort>>;
  where?: InputMaybe<PersonEventsConnectionWhere>;
};

export type PersonLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type PersonLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonLabelsConnectionSort>>;
  where?: InputMaybe<PersonLabelsConnectionWhere>;
};

export type PersonOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type PersonOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonOrganizationConnectionSort>>;
  where?: InputMaybe<PersonOrganizationConnectionWhere>;
};

export type PersonQualificationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QualificationOptions>;
  where?: InputMaybe<QualificationWhere>;
};

export type PersonQualificationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QualificationWhere>;
};

export type PersonQualificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonQualificationsConnectionSort>>;
  where?: InputMaybe<PersonQualificationsConnectionWhere>;
};

export type PersonRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type PersonRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonRoomsConnectionSort>>;
  where?: InputMaybe<PersonRoomsConnectionWhere>;
};

export type PersonTimetableConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableConfigOptions>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type PersonTimetableConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PersonTimetableConfigConnectionSort>>;
  where?: InputMaybe<PersonTimetableConfigConnectionWhere>;
};

export type PersonAbsencesAggregateInput = {
  AND?: InputMaybe<Array<PersonAbsencesAggregateInput>>;
  NOT?: InputMaybe<PersonAbsencesAggregateInput>;
  OR?: InputMaybe<Array<PersonAbsencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonAbsencesNodeAggregationWhereInput>;
};

export type PersonAbsencesConnectFieldInput = {
  connect?: InputMaybe<Array<AbsenceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AbsenceConnectWhere>;
};

export type PersonAbsencesConnection = {
  __typename?: 'PersonAbsencesConnection';
  edges: Array<PersonAbsencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonAbsencesConnectionSort = {
  node?: InputMaybe<AbsenceSort>;
};

export type PersonAbsencesConnectionWhere = {
  AND?: InputMaybe<Array<PersonAbsencesConnectionWhere>>;
  NOT?: InputMaybe<PersonAbsencesConnectionWhere>;
  OR?: InputMaybe<Array<PersonAbsencesConnectionWhere>>;
  node?: InputMaybe<AbsenceWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AbsenceWhere>;
};

export type PersonAbsencesCreateFieldInput = {
  node: AbsenceCreateInput;
};

export type PersonAbsencesDeleteFieldInput = {
  delete?: InputMaybe<AbsenceDeleteInput>;
  where?: InputMaybe<PersonAbsencesConnectionWhere>;
};

export type PersonAbsencesDisconnectFieldInput = {
  disconnect?: InputMaybe<AbsenceDisconnectInput>;
  where?: InputMaybe<PersonAbsencesConnectionWhere>;
};

export type PersonAbsencesFieldInput = {
  connect?: InputMaybe<Array<PersonAbsencesConnectFieldInput>>;
  create?: InputMaybe<Array<PersonAbsencesCreateFieldInput>>;
};

export type PersonAbsencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonAbsencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonAbsencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonAbsencesNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonAbsencesRelationship = {
  __typename?: 'PersonAbsencesRelationship';
  cursor: Scalars['String']['output'];
  node: Absence;
};

export type PersonAbsencesUpdateConnectionInput = {
  node?: InputMaybe<AbsenceUpdateInput>;
};

export type PersonAbsencesUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonAbsencesConnectFieldInput>>;
  create?: InputMaybe<Array<PersonAbsencesCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonAbsencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonAbsencesDisconnectFieldInput>>;
  update?: InputMaybe<PersonAbsencesUpdateConnectionInput>;
  where?: InputMaybe<PersonAbsencesConnectionWhere>;
};

export type PersonAdditionalTeachingLoadsAggregateInput = {
  AND?: InputMaybe<Array<PersonAdditionalTeachingLoadsAggregateInput>>;
  NOT?: InputMaybe<PersonAdditionalTeachingLoadsAggregateInput>;
  OR?: InputMaybe<Array<PersonAdditionalTeachingLoadsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonAdditionalTeachingLoadsNodeAggregationWhereInput>;
};

export type PersonAdditionalTeachingLoadsConnectFieldInput = {
  connect?: InputMaybe<Array<AdditionalTeachingLoadConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AdditionalTeachingLoadConnectWhere>;
};

export type PersonAdditionalTeachingLoadsConnection = {
  __typename?: 'PersonAdditionalTeachingLoadsConnection';
  edges: Array<PersonAdditionalTeachingLoadsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonAdditionalTeachingLoadsConnectionSort = {
  node?: InputMaybe<AdditionalTeachingLoadSort>;
};

export type PersonAdditionalTeachingLoadsConnectionWhere = {
  AND?: InputMaybe<Array<PersonAdditionalTeachingLoadsConnectionWhere>>;
  NOT?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
  OR?: InputMaybe<Array<PersonAdditionalTeachingLoadsConnectionWhere>>;
  node?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type PersonAdditionalTeachingLoadsCreateFieldInput = {
  node: AdditionalTeachingLoadCreateInput;
};

export type PersonAdditionalTeachingLoadsDeleteFieldInput = {
  delete?: InputMaybe<AdditionalTeachingLoadDeleteInput>;
  where?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
};

export type PersonAdditionalTeachingLoadsDisconnectFieldInput = {
  disconnect?: InputMaybe<AdditionalTeachingLoadDisconnectInput>;
  where?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
};

export type PersonAdditionalTeachingLoadsFieldInput = {
  connect?: InputMaybe<Array<PersonAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonAdditionalTeachingLoadsCreateFieldInput>>;
};

export type PersonAdditionalTeachingLoadsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonAdditionalTeachingLoadsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PersonAdditionalTeachingLoadsRelationship = {
  __typename?: 'PersonAdditionalTeachingLoadsRelationship';
  cursor: Scalars['String']['output'];
  node: AdditionalTeachingLoad;
};

export type PersonAdditionalTeachingLoadsUpdateConnectionInput = {
  node?: InputMaybe<AdditionalTeachingLoadUpdateInput>;
};

export type PersonAdditionalTeachingLoadsUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonAdditionalTeachingLoadsCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonAdditionalTeachingLoadsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonAdditionalTeachingLoadsDisconnectFieldInput>>;
  update?: InputMaybe<PersonAdditionalTeachingLoadsUpdateConnectionInput>;
  where?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
};

export type PersonAggregateSelection = {
  __typename?: 'PersonAggregateSelection';
  callingName: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  displayNameShort: StringAggregateSelection;
  email: StringAggregateSelection;
  firstName: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  gender: StringAggregateSelection;
  lastName: StringAggregateSelection;
  personalId: StringAggregateSelection;
  pimProfileUuid: StringAggregateSelection;
  prefixName: StringAggregateSelection;
  salutation: StringAggregateSelection;
  shortName: StringAggregateSelection;
  title: StringAggregateSelection;
  uniqueFirstName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type PersonClassesAggregateInput = {
  AND?: InputMaybe<Array<PersonClassesAggregateInput>>;
  NOT?: InputMaybe<PersonClassesAggregateInput>;
  OR?: InputMaybe<Array<PersonClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<PersonClassesNodeAggregationWhereInput>;
};

export type PersonClassesConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type PersonClassesConnectOrCreateFieldInput = {
  onCreate: PersonClassesConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type PersonClassesConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ClassOnCreateInput;
};

export type PersonClassesConnection = {
  __typename?: 'PersonClassesConnection';
  edges: Array<PersonClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonClassesConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<ClassSort>;
};

export type PersonClassesConnectionWhere = {
  AND?: InputMaybe<Array<PersonClassesConnectionWhere>>;
  NOT?: InputMaybe<PersonClassesConnectionWhere>;
  OR?: InputMaybe<Array<PersonClassesConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type PersonClassesCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ClassCreateInput;
};

export type PersonClassesDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<PersonClassesConnectionWhere>;
};

export type PersonClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<PersonClassesConnectionWhere>;
};

export type PersonClassesFieldInput = {
  connect?: InputMaybe<Array<PersonClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PersonClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PersonClassesCreateFieldInput>>;
};

export type PersonClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonClassesNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonClassesRelationship = {
  __typename?: 'PersonClassesRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
  properties: OrderedRelationProperties;
};

export type PersonClassesUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<ClassUpdateInput>;
};

export type PersonClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PersonClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PersonClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonClassesDisconnectFieldInput>>;
  update?: InputMaybe<PersonClassesUpdateConnectionInput>;
  where?: InputMaybe<PersonClassesConnectionWhere>;
};

export type PersonConnectDisconnectInput = {
  connect: Array<EventPersonRelationInput>;
  disconnect?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PersonConnectInput = {
  absences?: InputMaybe<Array<PersonAbsencesConnectFieldInput>>;
  additionalTeachingLoads?: InputMaybe<Array<PersonAdditionalTeachingLoadsConnectFieldInput>>;
  classes?: InputMaybe<Array<PersonClassesConnectFieldInput>>;
  contracts?: InputMaybe<Array<PersonContractsConnectFieldInput>>;
  defaultRoom?: InputMaybe<PersonDefaultRoomConnectFieldInput>;
  events?: InputMaybe<Array<PersonEventsConnectFieldInput>>;
  labels?: InputMaybe<Array<PersonLabelsConnectFieldInput>>;
  organization?: InputMaybe<PersonOrganizationConnectFieldInput>;
  qualifications?: InputMaybe<Array<PersonQualificationsConnectFieldInput>>;
  rooms?: InputMaybe<Array<PersonRoomsConnectFieldInput>>;
  timetableConfig?: InputMaybe<PersonTimetableConfigConnectFieldInput>;
};

export type PersonConnectOrCreateWhere = {
  node: PersonUniqueWhere;
};

export type PersonConnectWhere = {
  node: PersonWhere;
};

export type PersonContractContractsAggregationSelection = {
  __typename?: 'PersonContractContractsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PersonContractContractsNodeAggregateSelection>;
};

export type PersonContractContractsNodeAggregateSelection = {
  __typename?: 'PersonContractContractsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  hoursWeekly: FloatAggregateSelection;
  name: StringAggregateSelection;
  substituteHours: FloatAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type PersonContractsAggregateInput = {
  AND?: InputMaybe<Array<PersonContractsAggregateInput>>;
  NOT?: InputMaybe<PersonContractsAggregateInput>;
  OR?: InputMaybe<Array<PersonContractsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonContractsNodeAggregationWhereInput>;
};

export type PersonContractsConnectFieldInput = {
  connect?: InputMaybe<Array<ContractConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ContractConnectWhere>;
};

export type PersonContractsConnection = {
  __typename?: 'PersonContractsConnection';
  edges: Array<PersonContractsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonContractsConnectionSort = {
  node?: InputMaybe<ContractSort>;
};

export type PersonContractsConnectionWhere = {
  AND?: InputMaybe<Array<PersonContractsConnectionWhere>>;
  NOT?: InputMaybe<PersonContractsConnectionWhere>;
  OR?: InputMaybe<Array<PersonContractsConnectionWhere>>;
  node?: InputMaybe<ContractWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ContractWhere>;
};

export type PersonContractsCreateFieldInput = {
  node: ContractCreateInput;
};

export type PersonContractsDeleteFieldInput = {
  delete?: InputMaybe<ContractDeleteInput>;
  where?: InputMaybe<PersonContractsConnectionWhere>;
};

export type PersonContractsDisconnectFieldInput = {
  disconnect?: InputMaybe<ContractDisconnectInput>;
  where?: InputMaybe<PersonContractsConnectionWhere>;
};

export type PersonContractsFieldInput = {
  connect?: InputMaybe<Array<PersonContractsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonContractsCreateFieldInput>>;
};

export type PersonContractsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonContractsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonContractsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonContractsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  hoursWeekly_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursWeekly_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substituteHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  substituteHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonContractsRelationship = {
  __typename?: 'PersonContractsRelationship';
  cursor: Scalars['String']['output'];
  node: Contract;
};

export type PersonContractsUpdateConnectionInput = {
  node?: InputMaybe<ContractUpdateInput>;
};

export type PersonContractsUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonContractsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonContractsCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonContractsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonContractsDisconnectFieldInput>>;
  update?: InputMaybe<PersonContractsUpdateConnectionInput>;
  where?: InputMaybe<PersonContractsConnectionWhere>;
};

export type PersonCreateInput = {
  absences?: InputMaybe<PersonAbsencesFieldInput>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalTeachingLoads?: InputMaybe<PersonAdditionalTeachingLoadsFieldInput>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  callingName?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<PersonClassesFieldInput>;
  contracts?: InputMaybe<PersonContractsFieldInput>;
  defaultRoom?: InputMaybe<PersonDefaultRoomFieldInput>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<PersonEventsFieldInput>;
  firstName: Scalars['String']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<PersonLabelsFieldInput>;
  lastName: Scalars['String']['input'];
  organization?: InputMaybe<PersonOrganizationFieldInput>;
  personalId?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid?: InputMaybe<Scalars['String']['input']>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<PersonQualificationsFieldInput>;
  rooms?: InputMaybe<PersonRoomsFieldInput>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  timetableConfig?: InputMaybe<PersonTimetableConfigFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonDefaultRoomAggregateInput = {
  AND?: InputMaybe<Array<PersonDefaultRoomAggregateInput>>;
  NOT?: InputMaybe<PersonDefaultRoomAggregateInput>;
  OR?: InputMaybe<Array<PersonDefaultRoomAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonDefaultRoomNodeAggregationWhereInput>;
};

export type PersonDefaultRoomConnectFieldInput = {
  connect?: InputMaybe<RoomConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type PersonDefaultRoomConnectOrCreateFieldInput = {
  onCreate: PersonDefaultRoomConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type PersonDefaultRoomConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type PersonDefaultRoomConnection = {
  __typename?: 'PersonDefaultRoomConnection';
  edges: Array<PersonDefaultRoomRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonDefaultRoomConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type PersonDefaultRoomConnectionWhere = {
  AND?: InputMaybe<Array<PersonDefaultRoomConnectionWhere>>;
  NOT?: InputMaybe<PersonDefaultRoomConnectionWhere>;
  OR?: InputMaybe<Array<PersonDefaultRoomConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type PersonDefaultRoomCreateFieldInput = {
  node: RoomCreateInput;
};

export type PersonDefaultRoomDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<PersonDefaultRoomConnectionWhere>;
};

export type PersonDefaultRoomDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<PersonDefaultRoomConnectionWhere>;
};

export type PersonDefaultRoomFieldInput = {
  connect?: InputMaybe<PersonDefaultRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<PersonDefaultRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<PersonDefaultRoomCreateFieldInput>;
};

export type PersonDefaultRoomNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonDefaultRoomNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonDefaultRoomNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonDefaultRoomNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonDefaultRoomRelationship = {
  __typename?: 'PersonDefaultRoomRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type PersonDefaultRoomUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type PersonDefaultRoomUpdateFieldInput = {
  connect?: InputMaybe<PersonDefaultRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<PersonDefaultRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<PersonDefaultRoomCreateFieldInput>;
  delete?: InputMaybe<PersonDefaultRoomDeleteFieldInput>;
  disconnect?: InputMaybe<PersonDefaultRoomDisconnectFieldInput>;
  update?: InputMaybe<PersonDefaultRoomUpdateConnectionInput>;
  where?: InputMaybe<PersonDefaultRoomConnectionWhere>;
};

export type PersonDeleteInput = {
  absences?: InputMaybe<Array<PersonAbsencesDeleteFieldInput>>;
  additionalTeachingLoads?: InputMaybe<Array<PersonAdditionalTeachingLoadsDeleteFieldInput>>;
  classes?: InputMaybe<Array<PersonClassesDeleteFieldInput>>;
  contracts?: InputMaybe<Array<PersonContractsDeleteFieldInput>>;
  defaultRoom?: InputMaybe<PersonDefaultRoomDeleteFieldInput>;
  events?: InputMaybe<Array<PersonEventsDeleteFieldInput>>;
  labels?: InputMaybe<Array<PersonLabelsDeleteFieldInput>>;
  organization?: InputMaybe<PersonOrganizationDeleteFieldInput>;
  qualifications?: InputMaybe<Array<PersonQualificationsDeleteFieldInput>>;
  rooms?: InputMaybe<Array<PersonRoomsDeleteFieldInput>>;
  timetableConfig?: InputMaybe<PersonTimetableConfigDeleteFieldInput>;
};

export type PersonDisconnectInput = {
  absences?: InputMaybe<Array<PersonAbsencesDisconnectFieldInput>>;
  additionalTeachingLoads?: InputMaybe<Array<PersonAdditionalTeachingLoadsDisconnectFieldInput>>;
  classes?: InputMaybe<Array<PersonClassesDisconnectFieldInput>>;
  contracts?: InputMaybe<Array<PersonContractsDisconnectFieldInput>>;
  defaultRoom?: InputMaybe<PersonDefaultRoomDisconnectFieldInput>;
  events?: InputMaybe<Array<PersonEventsDisconnectFieldInput>>;
  labels?: InputMaybe<Array<PersonLabelsDisconnectFieldInput>>;
  organization?: InputMaybe<PersonOrganizationDisconnectFieldInput>;
  qualifications?: InputMaybe<Array<PersonQualificationsDisconnectFieldInput>>;
  rooms?: InputMaybe<Array<PersonRoomsDisconnectFieldInput>>;
  timetableConfig?: InputMaybe<PersonTimetableConfigDisconnectFieldInput>;
};

export type PersonEdge = {
  __typename?: 'PersonEdge';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type PersonEventsAggregateInput = {
  AND?: InputMaybe<Array<PersonEventsAggregateInput>>;
  NOT?: InputMaybe<PersonEventsAggregateInput>;
  OR?: InputMaybe<Array<PersonEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonEventsNodeAggregationWhereInput>;
};

export type PersonEventsConnectFieldInput = {
  connect?: InputMaybe<Array<EventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type PersonEventsConnection = {
  __typename?: 'PersonEventsConnection';
  edges: Array<PersonEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type PersonEventsConnectionWhere = {
  AND?: InputMaybe<Array<PersonEventsConnectionWhere>>;
  NOT?: InputMaybe<PersonEventsConnectionWhere>;
  OR?: InputMaybe<Array<PersonEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type PersonEventsCreateFieldInput = {
  node: EventCreateInput;
};

export type PersonEventsDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<PersonEventsConnectionWhere>;
};

export type PersonEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<PersonEventsConnectionWhere>;
};

export type PersonEventsFieldInput = {
  connect?: InputMaybe<Array<PersonEventsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonEventsCreateFieldInput>>;
};

export type PersonEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonEventsRelationship = {
  __typename?: 'PersonEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type PersonEventsUpdateConnectionInput = {
  node?: InputMaybe<EventUpdateInput>;
};

export type PersonEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonEventsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonEventsDisconnectFieldInput>>;
  update?: InputMaybe<PersonEventsUpdateConnectionInput>;
  where?: InputMaybe<PersonEventsConnectionWhere>;
};

export type PersonLabelsAggregateInput = {
  AND?: InputMaybe<Array<PersonLabelsAggregateInput>>;
  NOT?: InputMaybe<PersonLabelsAggregateInput>;
  OR?: InputMaybe<Array<PersonLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonLabelsNodeAggregationWhereInput>;
};

export type PersonLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type PersonLabelsConnection = {
  __typename?: 'PersonLabelsConnection';
  edges: Array<PersonLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type PersonLabelsConnectionWhere = {
  AND?: InputMaybe<Array<PersonLabelsConnectionWhere>>;
  NOT?: InputMaybe<PersonLabelsConnectionWhere>;
  OR?: InputMaybe<Array<PersonLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type PersonLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type PersonLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<PersonLabelsConnectionWhere>;
};

export type PersonLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<PersonLabelsConnectionWhere>;
};

export type PersonLabelsFieldInput = {
  connect?: InputMaybe<Array<PersonLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonLabelsCreateFieldInput>>;
};

export type PersonLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonLabelsRelationship = {
  __typename?: 'PersonLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type PersonLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type PersonLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonLabelsDisconnectFieldInput>>;
  update?: InputMaybe<PersonLabelsUpdateConnectionInput>;
  where?: InputMaybe<PersonLabelsConnectionWhere>;
};

export type PersonOnCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  callingName?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  personalId?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid?: InputMaybe<Scalars['String']['input']>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  shortName: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PersonSort objects to sort People by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PersonSort>>;
};

export type PersonOrganizationAggregateInput = {
  AND?: InputMaybe<Array<PersonOrganizationAggregateInput>>;
  NOT?: InputMaybe<PersonOrganizationAggregateInput>;
  OR?: InputMaybe<Array<PersonOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonOrganizationNodeAggregationWhereInput>;
};

export type PersonOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  edge: RoleNameCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type PersonOrganizationConnectOrCreateFieldInput = {
  onCreate: PersonOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type PersonOrganizationConnectOrCreateFieldInputOnCreate = {
  edge: RoleNameCreateInput;
  node: OrganizationOnCreateInput;
};

export type PersonOrganizationConnection = {
  __typename?: 'PersonOrganizationConnection';
  edges: Array<PersonOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonOrganizationConnectionSort = {
  edge?: InputMaybe<RoleNameSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type PersonOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<PersonOrganizationConnectionWhere>>;
  NOT?: InputMaybe<PersonOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<PersonOrganizationConnectionWhere>>;
  edge?: InputMaybe<RoleNameWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RoleNameWhere>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type PersonOrganizationCreateFieldInput = {
  edge: RoleNameCreateInput;
  node: OrganizationCreateInput;
};

export type PersonOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<PersonOrganizationConnectionWhere>;
};

export type PersonOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<PersonOrganizationConnectionWhere>;
};

export type PersonOrganizationFieldInput = {
  connect?: InputMaybe<PersonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<PersonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<PersonOrganizationCreateFieldInput>;
};

export type PersonOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonOrganizationRelationship = {
  __typename?: 'PersonOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
  properties: RoleName;
};

export type PersonOrganizationUpdateConnectionInput = {
  edge?: InputMaybe<RoleNameUpdateInput>;
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type PersonOrganizationUpdateFieldInput = {
  connect?: InputMaybe<PersonOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<PersonOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<PersonOrganizationCreateFieldInput>;
  delete?: InputMaybe<PersonOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<PersonOrganizationDisconnectFieldInput>;
  update?: InputMaybe<PersonOrganizationUpdateConnectionInput>;
  where?: InputMaybe<PersonOrganizationConnectionWhere>;
};

export type PersonQualificationQualificationsAggregationSelection = {
  __typename?: 'PersonQualificationQualificationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PersonQualificationQualificationsNodeAggregateSelection>;
};

export type PersonQualificationQualificationsNodeAggregateSelection = {
  __typename?: 'PersonQualificationQualificationsNodeAggregateSelection';
  maxGrade: IntAggregateSelection;
  maxTeachingLoad: IntAggregateSelection;
  minGrade: IntAggregateSelection;
};

export type PersonQualificationsAggregateInput = {
  AND?: InputMaybe<Array<PersonQualificationsAggregateInput>>;
  NOT?: InputMaybe<PersonQualificationsAggregateInput>;
  OR?: InputMaybe<Array<PersonQualificationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonQualificationsNodeAggregationWhereInput>;
};

export type PersonQualificationsConnectFieldInput = {
  connect?: InputMaybe<Array<QualificationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QualificationConnectWhere>;
};

export type PersonQualificationsConnection = {
  __typename?: 'PersonQualificationsConnection';
  edges: Array<PersonQualificationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonQualificationsConnectionSort = {
  node?: InputMaybe<QualificationSort>;
};

export type PersonQualificationsConnectionWhere = {
  AND?: InputMaybe<Array<PersonQualificationsConnectionWhere>>;
  NOT?: InputMaybe<PersonQualificationsConnectionWhere>;
  OR?: InputMaybe<Array<PersonQualificationsConnectionWhere>>;
  node?: InputMaybe<QualificationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<QualificationWhere>;
};

export type PersonQualificationsCreateFieldInput = {
  node: QualificationCreateInput;
};

export type PersonQualificationsDeleteFieldInput = {
  delete?: InputMaybe<QualificationDeleteInput>;
  where?: InputMaybe<PersonQualificationsConnectionWhere>;
};

export type PersonQualificationsDisconnectFieldInput = {
  disconnect?: InputMaybe<QualificationDisconnectInput>;
  where?: InputMaybe<PersonQualificationsConnectionWhere>;
};

export type PersonQualificationsFieldInput = {
  connect?: InputMaybe<Array<PersonQualificationsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonQualificationsCreateFieldInput>>;
};

export type PersonQualificationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonQualificationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonQualificationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonQualificationsNodeAggregationWhereInput>>;
  maxGrade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxGrade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxGrade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxGrade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxGrade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxGrade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxTeachingLoad_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxTeachingLoad_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxTeachingLoad_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxTeachingLoad_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxTeachingLoad_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minGrade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minGrade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minGrade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minGrade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minGrade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minGrade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minGrade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minGrade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minGrade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonQualificationsRelationship = {
  __typename?: 'PersonQualificationsRelationship';
  cursor: Scalars['String']['output'];
  node: Qualification;
};

export type PersonQualificationsUpdateConnectionInput = {
  node?: InputMaybe<QualificationUpdateInput>;
};

export type PersonQualificationsUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonQualificationsConnectFieldInput>>;
  create?: InputMaybe<Array<PersonQualificationsCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonQualificationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonQualificationsDisconnectFieldInput>>;
  update?: InputMaybe<PersonQualificationsUpdateConnectionInput>;
  where?: InputMaybe<PersonQualificationsConnectionWhere>;
};

export enum PersonRole {
  Other = 'OTHER',
  Teacher = 'TEACHER',
}

export type PersonRoomsAggregateInput = {
  AND?: InputMaybe<Array<PersonRoomsAggregateInput>>;
  NOT?: InputMaybe<PersonRoomsAggregateInput>;
  OR?: InputMaybe<Array<PersonRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<PersonRoomsNodeAggregationWhereInput>;
};

export type PersonRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type PersonRoomsConnectOrCreateFieldInput = {
  onCreate: PersonRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type PersonRoomsConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: RoomOnCreateInput;
};

export type PersonRoomsConnection = {
  __typename?: 'PersonRoomsConnection';
  edges: Array<PersonRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonRoomsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<RoomSort>;
};

export type PersonRoomsConnectionWhere = {
  AND?: InputMaybe<Array<PersonRoomsConnectionWhere>>;
  NOT?: InputMaybe<PersonRoomsConnectionWhere>;
  OR?: InputMaybe<Array<PersonRoomsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type PersonRoomsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: RoomCreateInput;
};

export type PersonRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<PersonRoomsConnectionWhere>;
};

export type PersonRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<PersonRoomsConnectionWhere>;
};

export type PersonRoomsFieldInput = {
  connect?: InputMaybe<Array<PersonRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PersonRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PersonRoomsCreateFieldInput>>;
};

export type PersonRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonRoomsRelationship = {
  __typename?: 'PersonRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
  properties: OrderedRelationProperties;
};

export type PersonRoomsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<RoomUpdateInput>;
};

export type PersonRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<PersonRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PersonRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PersonRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<PersonRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PersonRoomsDisconnectFieldInput>>;
  update?: InputMaybe<PersonRoomsUpdateConnectionInput>;
  where?: InputMaybe<PersonRoomsConnectionWhere>;
};

/** Fields to sort People by. The order in which sorts are applied is not guaranteed when specifying many fields in one PersonSort object. */
export type PersonSort = {
  active?: InputMaybe<SortDirection>;
  birthday?: InputMaybe<SortDirection>;
  callingName?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  currentContract?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  displayNameShort?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  fullName?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  listName?: InputMaybe<SortDirection>;
  personalId?: InputMaybe<SortDirection>;
  pimProfileUuid?: InputMaybe<SortDirection>;
  prefixName?: InputMaybe<SortDirection>;
  salutation?: InputMaybe<SortDirection>;
  selectName?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  uniqueFirstName?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type PersonTimetableConfigAggregateInput = {
  AND?: InputMaybe<Array<PersonTimetableConfigAggregateInput>>;
  NOT?: InputMaybe<PersonTimetableConfigAggregateInput>;
  OR?: InputMaybe<Array<PersonTimetableConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PersonTimetableConfigNodeAggregationWhereInput>;
};

export type PersonTimetableConfigConnectFieldInput = {
  connect?: InputMaybe<TimetableConfigConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConfigConnectWhere>;
};

export type PersonTimetableConfigConnection = {
  __typename?: 'PersonTimetableConfigConnection';
  edges: Array<PersonTimetableConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PersonTimetableConfigConnectionSort = {
  node?: InputMaybe<TimetableConfigSort>;
};

export type PersonTimetableConfigConnectionWhere = {
  AND?: InputMaybe<Array<PersonTimetableConfigConnectionWhere>>;
  NOT?: InputMaybe<PersonTimetableConfigConnectionWhere>;
  OR?: InputMaybe<Array<PersonTimetableConfigConnectionWhere>>;
  node?: InputMaybe<TimetableConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableConfigWhere>;
};

export type PersonTimetableConfigCreateFieldInput = {
  node: TimetableConfigCreateInput;
};

export type PersonTimetableConfigDeleteFieldInput = {
  delete?: InputMaybe<TimetableConfigDeleteInput>;
  where?: InputMaybe<PersonTimetableConfigConnectionWhere>;
};

export type PersonTimetableConfigDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableConfigDisconnectInput>;
  where?: InputMaybe<PersonTimetableConfigConnectionWhere>;
};

export type PersonTimetableConfigFieldInput = {
  connect?: InputMaybe<PersonTimetableConfigConnectFieldInput>;
  create?: InputMaybe<PersonTimetableConfigCreateFieldInput>;
};

export type PersonTimetableConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PersonTimetableConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PersonTimetableConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PersonTimetableConfigNodeAggregationWhereInput>>;
  colorLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonTimetableConfigRelationship = {
  __typename?: 'PersonTimetableConfigRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableConfig;
};

export type PersonTimetableConfigUpdateConnectionInput = {
  node?: InputMaybe<TimetableConfigUpdateInput>;
};

export type PersonTimetableConfigUpdateFieldInput = {
  connect?: InputMaybe<PersonTimetableConfigConnectFieldInput>;
  create?: InputMaybe<PersonTimetableConfigCreateFieldInput>;
  delete?: InputMaybe<PersonTimetableConfigDeleteFieldInput>;
  disconnect?: InputMaybe<PersonTimetableConfigDisconnectFieldInput>;
  update?: InputMaybe<PersonTimetableConfigUpdateConnectionInput>;
  where?: InputMaybe<PersonTimetableConfigConnectionWhere>;
};

export type PersonUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type PersonUpdateInput = {
  absences?: InputMaybe<Array<PersonAbsencesUpdateFieldInput>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalTeachingLoads?: InputMaybe<Array<PersonAdditionalTeachingLoadsUpdateFieldInput>>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  callingName?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<Array<PersonClassesUpdateFieldInput>>;
  contracts?: InputMaybe<Array<PersonContractsUpdateFieldInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultRoom?: InputMaybe<PersonDefaultRoomUpdateFieldInput>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<PersonEventsUpdateFieldInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<PersonLabelsUpdateFieldInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<PersonOrganizationUpdateFieldInput>;
  personalId?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid?: InputMaybe<Scalars['String']['input']>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<PersonQualificationsUpdateFieldInput>>;
  rooms?: InputMaybe<Array<PersonRoomsUpdateFieldInput>>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  timetableConfig?: InputMaybe<PersonTimetableConfigUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName?: InputMaybe<Scalars['String']['input']>;
};

export type PersonWhere = {
  AND?: InputMaybe<Array<PersonWhere>>;
  NOT?: InputMaybe<PersonWhere>;
  OR?: InputMaybe<Array<PersonWhere>>;
  /** @deprecated Use `absences_SOME` instead. */
  absences?: InputMaybe<AbsenceWhere>;
  absencesAggregate?: InputMaybe<PersonAbsencesAggregateInput>;
  /** @deprecated Use `absencesConnection_SOME` instead. */
  absencesConnection?: InputMaybe<PersonAbsencesConnectionWhere>;
  /** Return People where all of the related PersonAbsencesConnections match this filter */
  absencesConnection_ALL?: InputMaybe<PersonAbsencesConnectionWhere>;
  /** Return People where none of the related PersonAbsencesConnections match this filter */
  absencesConnection_NONE?: InputMaybe<PersonAbsencesConnectionWhere>;
  /** @deprecated Use `absencesConnection_NONE` instead. */
  absencesConnection_NOT?: InputMaybe<PersonAbsencesConnectionWhere>;
  /** Return People where one of the related PersonAbsencesConnections match this filter */
  absencesConnection_SINGLE?: InputMaybe<PersonAbsencesConnectionWhere>;
  /** Return People where some of the related PersonAbsencesConnections match this filter */
  absencesConnection_SOME?: InputMaybe<PersonAbsencesConnectionWhere>;
  /** Return People where all of the related Absences match this filter */
  absences_ALL?: InputMaybe<AbsenceWhere>;
  /** Return People where none of the related Absences match this filter */
  absences_NONE?: InputMaybe<AbsenceWhere>;
  /** @deprecated Use `absences_NONE` instead. */
  absences_NOT?: InputMaybe<AbsenceWhere>;
  /** Return People where one of the related Absences match this filter */
  absences_SINGLE?: InputMaybe<AbsenceWhere>;
  /** Return People where some of the related Absences match this filter */
  absences_SOME?: InputMaybe<AbsenceWhere>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `additionalTeachingLoads_SOME` instead. */
  additionalTeachingLoads?: InputMaybe<AdditionalTeachingLoadWhere>;
  additionalTeachingLoadsAggregate?: InputMaybe<PersonAdditionalTeachingLoadsAggregateInput>;
  /** @deprecated Use `additionalTeachingLoadsConnection_SOME` instead. */
  additionalTeachingLoadsConnection?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
  /** Return People where all of the related PersonAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_ALL?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
  /** Return People where none of the related PersonAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_NONE?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
  /** @deprecated Use `additionalTeachingLoadsConnection_NONE` instead. */
  additionalTeachingLoadsConnection_NOT?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
  /** Return People where one of the related PersonAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SINGLE?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
  /** Return People where some of the related PersonAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SOME?: InputMaybe<PersonAdditionalTeachingLoadsConnectionWhere>;
  /** Return People where all of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_ALL?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return People where none of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_NONE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Use `additionalTeachingLoads_NONE` instead. */
  additionalTeachingLoads_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return People where one of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SINGLE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return People where some of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SOME?: InputMaybe<AdditionalTeachingLoadWhere>;
  birthday?: InputMaybe<Scalars['Date']['input']>;
  birthday_GT?: InputMaybe<Scalars['Date']['input']>;
  birthday_GTE?: InputMaybe<Scalars['Date']['input']>;
  birthday_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  birthday_LT?: InputMaybe<Scalars['Date']['input']>;
  birthday_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  birthday_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  callingName?: InputMaybe<Scalars['String']['input']>;
  callingName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  callingName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  callingName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  callingName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  callingName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  callingName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  callingName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  callingName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  callingName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `classes_SOME` instead. */
  classes?: InputMaybe<ClassWhere>;
  classesAggregate?: InputMaybe<PersonClassesAggregateInput>;
  /** @deprecated Use `classesConnection_SOME` instead. */
  classesConnection?: InputMaybe<PersonClassesConnectionWhere>;
  /** Return People where all of the related PersonClassesConnections match this filter */
  classesConnection_ALL?: InputMaybe<PersonClassesConnectionWhere>;
  /** Return People where none of the related PersonClassesConnections match this filter */
  classesConnection_NONE?: InputMaybe<PersonClassesConnectionWhere>;
  /** @deprecated Use `classesConnection_NONE` instead. */
  classesConnection_NOT?: InputMaybe<PersonClassesConnectionWhere>;
  /** Return People where one of the related PersonClassesConnections match this filter */
  classesConnection_SINGLE?: InputMaybe<PersonClassesConnectionWhere>;
  /** Return People where some of the related PersonClassesConnections match this filter */
  classesConnection_SOME?: InputMaybe<PersonClassesConnectionWhere>;
  /** Return People where all of the related Classes match this filter */
  classes_ALL?: InputMaybe<ClassWhere>;
  /** Return People where none of the related Classes match this filter */
  classes_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `classes_NONE` instead. */
  classes_NOT?: InputMaybe<ClassWhere>;
  /** Return People where one of the related Classes match this filter */
  classes_SINGLE?: InputMaybe<ClassWhere>;
  /** Return People where some of the related Classes match this filter */
  classes_SOME?: InputMaybe<ClassWhere>;
  /** @deprecated Use `contracts_SOME` instead. */
  contracts?: InputMaybe<ContractWhere>;
  contractsAggregate?: InputMaybe<PersonContractsAggregateInput>;
  /** @deprecated Use `contractsConnection_SOME` instead. */
  contractsConnection?: InputMaybe<PersonContractsConnectionWhere>;
  /** Return People where all of the related PersonContractsConnections match this filter */
  contractsConnection_ALL?: InputMaybe<PersonContractsConnectionWhere>;
  /** Return People where none of the related PersonContractsConnections match this filter */
  contractsConnection_NONE?: InputMaybe<PersonContractsConnectionWhere>;
  /** @deprecated Use `contractsConnection_NONE` instead. */
  contractsConnection_NOT?: InputMaybe<PersonContractsConnectionWhere>;
  /** Return People where one of the related PersonContractsConnections match this filter */
  contractsConnection_SINGLE?: InputMaybe<PersonContractsConnectionWhere>;
  /** Return People where some of the related PersonContractsConnections match this filter */
  contractsConnection_SOME?: InputMaybe<PersonContractsConnectionWhere>;
  /** Return People where all of the related Contracts match this filter */
  contracts_ALL?: InputMaybe<ContractWhere>;
  /** Return People where none of the related Contracts match this filter */
  contracts_NONE?: InputMaybe<ContractWhere>;
  /** @deprecated Use `contracts_NONE` instead. */
  contracts_NOT?: InputMaybe<ContractWhere>;
  /** Return People where one of the related Contracts match this filter */
  contracts_SINGLE?: InputMaybe<ContractWhere>;
  /** Return People where some of the related Contracts match this filter */
  contracts_SOME?: InputMaybe<ContractWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  defaultRoom?: InputMaybe<RoomWhere>;
  defaultRoomAggregate?: InputMaybe<PersonDefaultRoomAggregateInput>;
  defaultRoomConnection?: InputMaybe<PersonDefaultRoomConnectionWhere>;
  defaultRoomConnection_NOT?: InputMaybe<PersonDefaultRoomConnectionWhere>;
  defaultRoom_NOT?: InputMaybe<RoomWhere>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayNameShort?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayNameShort_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayNameShort_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  displayName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  email_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<PersonEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<PersonEventsConnectionWhere>;
  /** Return People where all of the related PersonEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<PersonEventsConnectionWhere>;
  /** Return People where none of the related PersonEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<PersonEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<PersonEventsConnectionWhere>;
  /** Return People where one of the related PersonEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<PersonEventsConnectionWhere>;
  /** Return People where some of the related PersonEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<PersonEventsConnectionWhere>;
  /** Return People where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return People where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return People where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return People where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  firstName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fullName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fullName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fullName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fullName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gender_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gender_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  gender_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gender_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<PersonLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<PersonLabelsConnectionWhere>;
  /** Return People where all of the related PersonLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<PersonLabelsConnectionWhere>;
  /** Return People where none of the related PersonLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<PersonLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<PersonLabelsConnectionWhere>;
  /** Return People where one of the related PersonLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<PersonLabelsConnectionWhere>;
  /** Return People where some of the related PersonLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<PersonLabelsConnectionWhere>;
  /** Return People where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return People where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return People where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return People where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  listName?: InputMaybe<Scalars['String']['input']>;
  listName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  listName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  listName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  listName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  listName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<PersonOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<PersonOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<PersonOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  personalId?: InputMaybe<Scalars['String']['input']>;
  personalId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  personalId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  personalId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personalId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personalId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personalId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personalId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  personalId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  personalId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pimProfileUuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  prefixName?: InputMaybe<Scalars['String']['input']>;
  prefixName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  prefixName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  prefixName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  prefixName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  prefixName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `qualifications_SOME` instead. */
  qualifications?: InputMaybe<QualificationWhere>;
  qualificationsAggregate?: InputMaybe<PersonQualificationsAggregateInput>;
  /** @deprecated Use `qualificationsConnection_SOME` instead. */
  qualificationsConnection?: InputMaybe<PersonQualificationsConnectionWhere>;
  /** Return People where all of the related PersonQualificationsConnections match this filter */
  qualificationsConnection_ALL?: InputMaybe<PersonQualificationsConnectionWhere>;
  /** Return People where none of the related PersonQualificationsConnections match this filter */
  qualificationsConnection_NONE?: InputMaybe<PersonQualificationsConnectionWhere>;
  /** @deprecated Use `qualificationsConnection_NONE` instead. */
  qualificationsConnection_NOT?: InputMaybe<PersonQualificationsConnectionWhere>;
  /** Return People where one of the related PersonQualificationsConnections match this filter */
  qualificationsConnection_SINGLE?: InputMaybe<PersonQualificationsConnectionWhere>;
  /** Return People where some of the related PersonQualificationsConnections match this filter */
  qualificationsConnection_SOME?: InputMaybe<PersonQualificationsConnectionWhere>;
  /** Return People where all of the related Qualifications match this filter */
  qualifications_ALL?: InputMaybe<QualificationWhere>;
  /** Return People where none of the related Qualifications match this filter */
  qualifications_NONE?: InputMaybe<QualificationWhere>;
  /** @deprecated Use `qualifications_NONE` instead. */
  qualifications_NOT?: InputMaybe<QualificationWhere>;
  /** Return People where one of the related Qualifications match this filter */
  qualifications_SINGLE?: InputMaybe<QualificationWhere>;
  /** Return People where some of the related Qualifications match this filter */
  qualifications_SOME?: InputMaybe<QualificationWhere>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<PersonRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<PersonRoomsConnectionWhere>;
  /** Return People where all of the related PersonRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<PersonRoomsConnectionWhere>;
  /** Return People where none of the related PersonRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<PersonRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<PersonRoomsConnectionWhere>;
  /** Return People where one of the related PersonRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<PersonRoomsConnectionWhere>;
  /** Return People where some of the related PersonRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<PersonRoomsConnectionWhere>;
  /** Return People where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return People where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return People where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return People where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  salutation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  salutation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  salutation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  salutation_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  salutation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  selectName?: InputMaybe<Scalars['String']['input']>;
  selectName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  selectName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  selectName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  selectName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  selectName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timetableConfig?: InputMaybe<TimetableConfigWhere>;
  timetableConfigAggregate?: InputMaybe<PersonTimetableConfigAggregateInput>;
  timetableConfigConnection?: InputMaybe<PersonTimetableConfigConnectionWhere>;
  timetableConfigConnection_NOT?: InputMaybe<PersonTimetableConfigConnectionWhere>;
  timetableConfig_NOT?: InputMaybe<TimetableConfigWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uniqueFirstName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uniqueFirstName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uniqueFirstName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uniqueFirstName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uniqueFirstName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uniqueFirstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type PimOrganization = {
  __typename?: 'PimOrganization';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  bpEnabled?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  iphisEnabled?: Maybe<Scalars['Boolean']['output']>;
  iphisVplanEnabled?: Maybe<Scalars['Boolean']['output']>;
  licensedModules?: Maybe<Array<Scalars['String']['output']>>;
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  planungEnabled?: Maybe<Scalars['Boolean']['output']>;
  timezone: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  vpoEnabled?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PimOrganizationEdge = {
  __typename?: 'PimOrganizationEdge';
  cursor: Scalars['String']['output'];
  node: PimOrganization;
};

export type PimOrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PimOrganizationSort objects to sort PimOrganizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PimOrganizationSort>>;
};

/** Fields to sort PimOrganizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one PimOrganizationSort object. */
export type PimOrganizationSort = {
  address1?: InputMaybe<SortDirection>;
  address2?: InputMaybe<SortDirection>;
  address3?: InputMaybe<SortDirection>;
  bpEnabled?: InputMaybe<SortDirection>;
  city?: InputMaybe<SortDirection>;
  country?: InputMaybe<SortDirection>;
  iphisEnabled?: InputMaybe<SortDirection>;
  iphisVplanEnabled?: InputMaybe<SortDirection>;
  locale?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  planungEnabled?: InputMaybe<SortDirection>;
  timezone?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  vpoEnabled?: InputMaybe<SortDirection>;
  zipCode?: InputMaybe<SortDirection>;
};

export type PimOrganizationWhere = {
  AND?: InputMaybe<Array<PimOrganizationWhere>>;
  NOT?: InputMaybe<PimOrganizationWhere>;
  OR?: InputMaybe<Array<PimOrganizationWhere>>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address1_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address1_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address1_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address1_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address1_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address2_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address2_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address2_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address2_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address3_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  address3_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  address3_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  address3_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  bpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bpEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  city_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  city_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  city_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  city_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  country_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  country_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  country_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  iphisEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  iphisEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  iphisVplanEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  iphisVplanEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  licensedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  licensedModules_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  licensedModules_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locale_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  locale_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  locale_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locale_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  locale_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  planungEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  planungEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  timezone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timezone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timezone_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  vpoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  vpoEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  zipCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  zipCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  zipCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  zipCode_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  zipCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PimOrganizationsConnection = {
  __typename?: 'PimOrganizationsConnection';
  edges: Array<PimOrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PimProfile = {
  __typename?: 'PimProfile';
  accessGranted?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayNameShort?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  firstNames?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  listName?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  prefixName?: Maybe<Scalars['String']['output']>;
  profileEmail?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  selectName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userStatus?: Maybe<UserStatus>;
  uuid: Scalars['ID']['output'];
};

export type PublishedSubstitutions = {
  __typename?: 'PublishedSubstitutions';
  classes: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  lastPublished: Scalars['DateTime']['output'];
  notifications: Scalars['String']['output'];
  substitutions: Scalars['String']['output'];
  teachers: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type PublishedSubstitutionsAggregateSelection = {
  __typename?: 'PublishedSubstitutionsAggregateSelection';
  classes: StringAggregateSelection;
  count: Scalars['Int']['output'];
  lastPublished: DateTimeAggregateSelection;
  notifications: StringAggregateSelection;
  substitutions: StringAggregateSelection;
  teachers: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type PublishedSubstitutionsConnectOrCreateWhere = {
  node: PublishedSubstitutionsUniqueWhere;
};

export type PublishedSubstitutionsConnectWhere = {
  node: PublishedSubstitutionsWhere;
};

export type PublishedSubstitutionsConnection = {
  __typename?: 'PublishedSubstitutionsConnection';
  edges: Array<PublishedSubstitutionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublishedSubstitutionsCreateInput = {
  classes: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  notifications: Scalars['String']['input'];
  substitutions: Scalars['String']['input'];
  teachers: Scalars['String']['input'];
};

export type PublishedSubstitutionsEdge = {
  __typename?: 'PublishedSubstitutionsEdge';
  cursor: Scalars['String']['output'];
  node: PublishedSubstitutions;
};

export type PublishedSubstitutionsOnCreateInput = {
  classes: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  notifications: Scalars['String']['input'];
  substitutions: Scalars['String']['input'];
  teachers: Scalars['String']['input'];
};

export type PublishedSubstitutionsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublishedSubstitutionsSort objects to sort PublishedSubstitutions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublishedSubstitutionsSort>>;
};

/** Fields to sort PublishedSubstitutions by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublishedSubstitutionsSort object. */
export type PublishedSubstitutionsSort = {
  classes?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  lastPublished?: InputMaybe<SortDirection>;
  notifications?: InputMaybe<SortDirection>;
  substitutions?: InputMaybe<SortDirection>;
  teachers?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type PublishedSubstitutionsUniqueWhere = {
  date?: InputMaybe<Scalars['Date']['input']>;
};

export type PublishedSubstitutionsUpdateInput = {
  classes?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  substitutions?: InputMaybe<Scalars['String']['input']>;
  teachers?: InputMaybe<Scalars['String']['input']>;
};

export type PublishedSubstitutionsWhere = {
  AND?: InputMaybe<Array<PublishedSubstitutionsWhere>>;
  NOT?: InputMaybe<PublishedSubstitutionsWhere>;
  OR?: InputMaybe<Array<PublishedSubstitutionsWhere>>;
  classes?: InputMaybe<Scalars['String']['input']>;
  classes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classes_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classes_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classes_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classes_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classes_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classes_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  lastPublished?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastPublished_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastPublished_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastPublished_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lastPublished_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  notifications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  notifications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  notifications_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notifications_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notifications_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notifications_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notifications_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  notifications_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notifications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutions?: InputMaybe<Scalars['String']['input']>;
  substitutions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  substitutions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutions_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutions_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutions_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutions_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutions_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  substitutions_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  substitutions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachers?: InputMaybe<Scalars['String']['input']>;
  teachers_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  teachers_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachers_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachers_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachers_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachers_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachers_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachers_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachers_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type Qualification = {
  __typename?: 'Qualification';
  maxGrade?: Maybe<Scalars['Int']['output']>;
  maxTeachingLoad?: Maybe<Scalars['Int']['output']>;
  minGrade?: Maybe<Scalars['Int']['output']>;
  owner: Person;
  ownerConnection: QualificationOwnerConnection;
  subject: Subject;
  subjectConnection: QualificationSubjectConnection;
};

export type QualificationOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type QualificationOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QualificationOwnerConnectionSort>>;
  where?: InputMaybe<QualificationOwnerConnectionWhere>;
};

export type QualificationSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type QualificationSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QualificationSubjectConnectionSort>>;
  where?: InputMaybe<QualificationSubjectConnectionWhere>;
};

export type QualificationAggregateSelection = {
  __typename?: 'QualificationAggregateSelection';
  count: Scalars['Int']['output'];
  maxGrade: IntAggregateSelection;
  maxTeachingLoad: IntAggregateSelection;
  minGrade: IntAggregateSelection;
};

export type QualificationConnectInput = {
  owner?: InputMaybe<QualificationOwnerConnectFieldInput>;
  subject?: InputMaybe<QualificationSubjectConnectFieldInput>;
};

export type QualificationConnectWhere = {
  node: QualificationWhere;
};

export type QualificationCreateInput = {
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad?: InputMaybe<Scalars['Int']['input']>;
  minGrade?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<QualificationOwnerFieldInput>;
  subject?: InputMaybe<QualificationSubjectFieldInput>;
};

export type QualificationDeleteInput = {
  owner?: InputMaybe<QualificationOwnerDeleteFieldInput>;
  subject?: InputMaybe<QualificationSubjectDeleteFieldInput>;
};

export type QualificationDisconnectInput = {
  owner?: InputMaybe<QualificationOwnerDisconnectFieldInput>;
  subject?: InputMaybe<QualificationSubjectDisconnectFieldInput>;
};

export type QualificationEdge = {
  __typename?: 'QualificationEdge';
  cursor: Scalars['String']['output'];
  node: Qualification;
};

export type QualificationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QualificationSort objects to sort Qualifications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QualificationSort>>;
};

export type QualificationOwnerAggregateInput = {
  AND?: InputMaybe<Array<QualificationOwnerAggregateInput>>;
  NOT?: InputMaybe<QualificationOwnerAggregateInput>;
  OR?: InputMaybe<Array<QualificationOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QualificationOwnerNodeAggregationWhereInput>;
};

export type QualificationOwnerConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type QualificationOwnerConnectOrCreateFieldInput = {
  onCreate: QualificationOwnerConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type QualificationOwnerConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type QualificationOwnerConnection = {
  __typename?: 'QualificationOwnerConnection';
  edges: Array<QualificationOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QualificationOwnerConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type QualificationOwnerConnectionWhere = {
  AND?: InputMaybe<Array<QualificationOwnerConnectionWhere>>;
  NOT?: InputMaybe<QualificationOwnerConnectionWhere>;
  OR?: InputMaybe<Array<QualificationOwnerConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type QualificationOwnerCreateFieldInput = {
  node: PersonCreateInput;
};

export type QualificationOwnerDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<QualificationOwnerConnectionWhere>;
};

export type QualificationOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<QualificationOwnerConnectionWhere>;
};

export type QualificationOwnerFieldInput = {
  connect?: InputMaybe<QualificationOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<QualificationOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<QualificationOwnerCreateFieldInput>;
};

export type QualificationOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QualificationOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QualificationOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QualificationOwnerNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QualificationOwnerRelationship = {
  __typename?: 'QualificationOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type QualificationOwnerUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type QualificationOwnerUpdateFieldInput = {
  connect?: InputMaybe<QualificationOwnerConnectFieldInput>;
  connectOrCreate?: InputMaybe<QualificationOwnerConnectOrCreateFieldInput>;
  create?: InputMaybe<QualificationOwnerCreateFieldInput>;
  delete?: InputMaybe<QualificationOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<QualificationOwnerDisconnectFieldInput>;
  update?: InputMaybe<QualificationOwnerUpdateConnectionInput>;
  where?: InputMaybe<QualificationOwnerConnectionWhere>;
};

/** Fields to sort Qualifications by. The order in which sorts are applied is not guaranteed when specifying many fields in one QualificationSort object. */
export type QualificationSort = {
  maxGrade?: InputMaybe<SortDirection>;
  maxTeachingLoad?: InputMaybe<SortDirection>;
  minGrade?: InputMaybe<SortDirection>;
};

export type QualificationSubjectAggregateInput = {
  AND?: InputMaybe<Array<QualificationSubjectAggregateInput>>;
  NOT?: InputMaybe<QualificationSubjectAggregateInput>;
  OR?: InputMaybe<Array<QualificationSubjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QualificationSubjectNodeAggregationWhereInput>;
};

export type QualificationSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type QualificationSubjectConnectOrCreateFieldInput = {
  onCreate: QualificationSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type QualificationSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type QualificationSubjectConnection = {
  __typename?: 'QualificationSubjectConnection';
  edges: Array<QualificationSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QualificationSubjectConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type QualificationSubjectConnectionWhere = {
  AND?: InputMaybe<Array<QualificationSubjectConnectionWhere>>;
  NOT?: InputMaybe<QualificationSubjectConnectionWhere>;
  OR?: InputMaybe<Array<QualificationSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type QualificationSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type QualificationSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<QualificationSubjectConnectionWhere>;
};

export type QualificationSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<QualificationSubjectConnectionWhere>;
};

export type QualificationSubjectFieldInput = {
  connect?: InputMaybe<QualificationSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<QualificationSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<QualificationSubjectCreateFieldInput>;
};

export type QualificationSubjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QualificationSubjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QualificationSubjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QualificationSubjectNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QualificationSubjectRelationship = {
  __typename?: 'QualificationSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type QualificationSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type QualificationSubjectUpdateFieldInput = {
  connect?: InputMaybe<QualificationSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<QualificationSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<QualificationSubjectCreateFieldInput>;
  delete?: InputMaybe<QualificationSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<QualificationSubjectDisconnectFieldInput>;
  update?: InputMaybe<QualificationSubjectUpdateConnectionInput>;
  where?: InputMaybe<QualificationSubjectConnectionWhere>;
};

export type QualificationUpdateInput = {
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  minGrade?: InputMaybe<Scalars['Int']['input']>;
  minGrade_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<QualificationOwnerUpdateFieldInput>;
  subject?: InputMaybe<QualificationSubjectUpdateFieldInput>;
};

export type QualificationWhere = {
  AND?: InputMaybe<Array<QualificationWhere>>;
  NOT?: InputMaybe<QualificationWhere>;
  OR?: InputMaybe<Array<QualificationWhere>>;
  maxGrade?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_GT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxGrade_LT?: InputMaybe<Scalars['Int']['input']>;
  maxGrade_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxGrade_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxGrade_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxTeachingLoad?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_GT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxTeachingLoad_LT?: InputMaybe<Scalars['Int']['input']>;
  maxTeachingLoad_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxTeachingLoad_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  maxTeachingLoad_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minGrade?: InputMaybe<Scalars['Int']['input']>;
  minGrade_GT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_GTE?: InputMaybe<Scalars['Int']['input']>;
  minGrade_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minGrade_LT?: InputMaybe<Scalars['Int']['input']>;
  minGrade_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  minGrade_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  minGrade_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  owner?: InputMaybe<PersonWhere>;
  ownerAggregate?: InputMaybe<QualificationOwnerAggregateInput>;
  ownerConnection?: InputMaybe<QualificationOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<QualificationOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<PersonWhere>;
  subject?: InputMaybe<SubjectWhere>;
  subjectAggregate?: InputMaybe<QualificationSubjectAggregateInput>;
  subjectConnection?: InputMaybe<QualificationSubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<QualificationSubjectConnectionWhere>;
  subject_NOT?: InputMaybe<SubjectWhere>;
};

export type QualificationsConnection = {
  __typename?: 'QualificationsConnection';
  edges: Array<QualificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  absences: Array<Absence>;
  absencesAggregate: AbsenceAggregateSelection;
  absencesConnection: AbsencesConnection;
  additionalTeachingLoads: Array<AdditionalTeachingLoad>;
  additionalTeachingLoadsAggregate: AdditionalTeachingLoadAggregateSelection;
  additionalTeachingLoadsConnection: AdditionalTeachingLoadsConnection;
  attendancePlanEvents: Array<AttendancePlanEvent>;
  availabilityHolders: Array<AvailabilityHolder>;
  buildings: Array<Building>;
  buildingsAggregate: BuildingAggregateSelection;
  buildingsConnection: BuildingsConnection;
  classGridCards: Array<ClassGridCard>;
  classOrGroups: Array<ClassOrGroup>;
  classes: Array<Class>;
  classesAggregate: ClassAggregateSelection;
  classesConnection: ClassesConnection;
  columnSorts: Array<ColumnSort>;
  columnSortsAggregate: ColumnSortAggregateSelection;
  columnSortsConnection: ColumnSortsConnection;
  contracts: Array<Contract>;
  contractsAggregate: ContractAggregateSelection;
  contractsConnection: ContractsConnection;
  curricula: Array<Curriculum>;
  curriculaAggregate: CurriculumAggregateSelection;
  curriculaConnection: CurriculaConnection;
  curriculumClasses: Array<CurriculumClass>;
  curriculumClassesAggregate: CurriculumClassAggregateSelection;
  curriculumClassesConnection: CurriculumClassesConnection;
  curriculumPeople: Array<CurriculumPerson>;
  curriculumPeopleAggregate: CurriculumPersonAggregateSelection;
  curriculumPeopleConnection: CurriculumPeopleConnection;
  curriculumUnits: Array<CurriculumUnit>;
  curriculumUnitsAggregate: CurriculumUnitAggregateSelection;
  curriculumUnitsConnection: CurriculumUnitsConnection;
  curriculumVersions: Array<CurriculumVersion>;
  curriculumVersionsAggregate: CurriculumVersionAggregateSelection;
  curriculumVersionsConnection: CurriculumVersionsConnection;
  dependencies: Array<Dependency>;
  dependenciesAggregate: DependencyAggregateSelection;
  dependenciesConnection: DependenciesConnection;
  divisions: Array<Division>;
  divisionsAggregate: DivisionAggregateSelection;
  divisionsConnection: DivisionsConnection;
  eventJobs: Array<EventJob>;
  eventJobsAggregate: EventJobAggregateSelection;
  eventJobsConnection: EventJobsConnection;
  eventStateTypes: Array<EventStateType>;
  eventStateTypesConnection: EventStateTypesConnection;
  events: Array<Event>;
  eventsAggregate: EventAggregateSelection;
  eventsConnection: EventsConnection;
  fileEntries: Array<FileEntry>;
  fileEntriesAggregate: FileEntryAggregateSelection;
  fileEntriesConnection: FileEntriesConnection;
  gradeGroups: Array<GradeGroup>;
  gradeGroupsAggregate: GradeGroupAggregateSelection;
  gradeGroupsConnection: GradeGroupsConnection;
  groupOwners: Array<GroupOwner>;
  groups: Array<Group>;
  groupsAggregate: GroupAggregateSelection;
  groupsConnection: GroupsConnection;
  holidays: Array<Holiday>;
  holidaysAggregate: HolidayAggregateSelection;
  holidaysConnection: HolidaysConnection;
  labelOwners: Array<LabelOwner>;
  labels: Array<Label>;
  labelsConnection: LabelsConnection;
  lessonClasses: Array<LessonClass>;
  lessonClassesAggregate: LessonClassAggregateSelection;
  lessonClassesConnection: LessonClassesConnection;
  lessonUnits: Array<LessonUnit>;
  lessonUnitsAggregate: LessonUnitAggregateSelection;
  lessonUnitsConnection: LessonUnitsConnection;
  lessons: Array<Lesson>;
  lessonsAggregate: LessonAggregateSelection;
  lessonsConnection: LessonsConnection;
  lockeds: Array<Locked>;
  lockedsAggregate: LockedAggregateSelection;
  lockedsConnection: LockedsConnection;
  mathplanJobs: Array<MathplanJob>;
  mathplanJobsAggregate: MathplanJobAggregateSelection;
  mathplanJobsConnection: MathplanJobsConnection;
  organizations: Array<Organization>;
  organizationsAggregate: OrganizationAggregateSelection;
  organizationsConnection: OrganizationsConnection;
  pdfReportContexts: Array<PdfReportContext>;
  pdfReportHolders: Array<PdfReportHolder>;
  people: Array<Person>;
  peopleAggregate: PersonAggregateSelection;
  peopleConnection: PeopleConnection;
  pimOrganizations: Array<PimOrganization>;
  pimOrganizationsConnection: PimOrganizationsConnection;
  pimProfiles: Array<PimProfile>;
  plannedTeachingLoadByClass: Array<ClassTeachingLoad>;
  plannedTeachingLoadByTeacher: Array<TeacherTeachingLoad>;
  publishedSubstitutions: Array<PublishedSubstitutions>;
  publishedSubstitutionsAggregate: PublishedSubstitutionsAggregateSelection;
  publishedSubstitutionsConnection: PublishedSubstitutionsConnection;
  qualifications: Array<Qualification>;
  qualificationsAggregate: QualificationAggregateSelection;
  qualificationsConnection: QualificationsConnection;
  recurringEvents: Array<RecurringEvent>;
  recurringEventsAggregate: RecurringEventAggregateSelection;
  recurringEventsConnection: RecurringEventsConnection;
  roomGridCards: Array<RoomGridCard>;
  rooms: Array<Room>;
  roomsAggregate: RoomAggregateSelection;
  roomsConnection: RoomsConnection;
  schoolEventClassOrGroups: Array<SchoolEventClassOrGroup>;
  schoolEvents: Array<SchoolEvent>;
  schoolYears: Array<SchoolYear>;
  schoolYearsAggregate: SchoolYearAggregateSelection;
  schoolYearsConnection: SchoolYearsConnection;
  subjectContainerOrSubjects: Array<SubjectContainerOrSubject>;
  subjectContainers: Array<SubjectContainer>;
  subjectContainersAggregate: SubjectContainerAggregateSelection;
  subjectContainersConnection: SubjectContainersConnection;
  subjectGridCards: Array<SubjectGridCard>;
  subjectGroups: Array<SubjectGroup>;
  subjectGroupsAggregate: SubjectGroupAggregateSelection;
  subjectGroupsConnection: SubjectGroupsConnection;
  subjects: Array<Subject>;
  subjectsAggregate: SubjectAggregateSelection;
  subjectsConnection: SubjectsConnection;
  substitutionAnnouncements: Array<SubstitutionAnnouncement>;
  substitutionAnnouncementsAggregate: SubstitutionAnnouncementAggregateSelection;
  substitutionAnnouncementsConnection: SubstitutionAnnouncementsConnection;
  substitutionAppConfigs: Array<SubstitutionAppConfig>;
  substitutionAppConfigsAggregate: SubstitutionAppConfigAggregateSelection;
  substitutionAppConfigsConnection: SubstitutionAppConfigsConnection;
  substitutionPrintColumnConfigs: Array<SubstitutionPrintColumnConfig>;
  substitutionPrintColumnConfigsAggregate: SubstitutionPrintColumnConfigAggregateSelection;
  substitutionPrintColumnConfigsConnection: SubstitutionPrintColumnConfigsConnection;
  substitutionPrintConfigs: Array<SubstitutionPrintConfig>;
  substitutionPrintConfigsAggregate: SubstitutionPrintConfigAggregateSelection;
  substitutionPrintConfigsConnection: SubstitutionPrintConfigsConnection;
  substitutionReports: Array<SubstitutionReport>;
  substitutionReportsAggregate: SubstitutionReportAggregateSelection;
  substitutionReportsConnection: SubstitutionReportsConnection;
  tableConfigs: Array<TableConfig>;
  tableConfigsAggregate: TableConfigAggregateSelection;
  tableConfigsConnection: TableConfigsConnection;
  teacherGridCards: Array<TeacherGridCard>;
  teachersSubstitutions: Array<TeacherSubstitutionStats>;
  teachingBlockAvailabilityExclusions: Array<TeachingBlockAvailabilityExclusion>;
  teachingBlockAvailabilityExclusionsAggregate: TeachingBlockAvailabilityExclusionAggregateSelection;
  teachingBlockAvailabilityExclusionsConnection: TeachingBlockAvailabilityExclusionsConnection;
  teachingBlockCards: Array<TeachingBlockCard>;
  teachingBlockCardsAggregate: TeachingBlockCardAggregateSelection;
  teachingBlockCardsConnection: TeachingBlockCardsConnection;
  teachingBlockClassGridCards: Array<TeachingBlockClassGridCard>;
  teachingBlockRoomGridCards: Array<TeachingBlockRoomGridCard>;
  teachingBlockSubjectGridCards: Array<TeachingBlockSubjectGridCard>;
  teachingBlockTeacherGridCards: Array<TeachingBlockTeacherGridCard>;
  teachingBlockVersions: Array<TeachingBlockVersion>;
  teachingBlockVersionsAggregate: TeachingBlockVersionAggregateSelection;
  teachingBlockVersionsConnection: TeachingBlockVersionsConnection;
  teachingBlocks: Array<TeachingBlock>;
  teachingBlocksAggregate: TeachingBlockAggregateSelection;
  teachingBlocksConnection: TeachingBlocksConnection;
  teachingLoadByClass: Array<ClassTeachingLoad>;
  teachingLoadByTeacher: Array<TeacherTeachingLoad>;
  teachingLoadFactors: Array<TeachingLoadFactor>;
  teachingLoadFactorsAggregate: TeachingLoadFactorAggregateSelection;
  teachingLoadFactorsConnection: TeachingLoadFactorsConnection;
  teachingLoadReports: Array<TeachingLoadReport>;
  teachingLoadReportsAggregate: TeachingLoadReportAggregateSelection;
  teachingLoadReportsConnection: TeachingLoadReportsConnection;
  teachingLoadScenarios: Array<TeachingLoadScenario>;
  teachingLoadScenariosAggregate: TeachingLoadScenarioAggregateSelection;
  teachingLoadScenariosConnection: TeachingLoadScenariosConnection;
  timeGridEntries: Array<TimeGridEntry>;
  timeGridEntriesAggregate: TimeGridEntryAggregateSelection;
  timeGridEntriesConnection: TimeGridEntriesConnection;
  timeGrids: Array<TimeGrid>;
  timeGridsAggregate: TimeGridAggregateSelection;
  timeGridsConnection: TimeGridsConnection;
  timespans: Array<Timespan>;
  timespansAggregate: TimespanAggregateSelection;
  timespansConnection: TimespansConnection;
  timetableBlocks: Array<TimetableBlock>;
  timetableBlocksAggregate: TimetableBlockAggregateSelection;
  timetableBlocksConnection: TimetableBlocksConnection;
  timetableCardAvailabilities: Array<TimetableCardAvailability>;
  timetableCards: Array<TimetableCard>;
  timetableCardsAggregate: TimetableCardAggregateSelection;
  timetableCardsConnection: TimetableCardsConnection;
  timetableConfigOwners: Array<TimetableConfigOwner>;
  timetableConfigs: Array<TimetableConfig>;
  timetableConfigsAggregate: TimetableConfigAggregateSelection;
  timetableConfigsConnection: TimetableConfigsConnection;
  timetablePrintConfigs: Array<TimetablePrintConfig>;
  timetablePrintConfigsAggregate: TimetablePrintConfigAggregateSelection;
  timetablePrintConfigsConnection: TimetablePrintConfigsConnection;
  timetableReports: Array<TimetableReport>;
  timetableReportsAggregate: TimetableReportAggregateSelection;
  timetableReportsConnection: TimetableReportsConnection;
  timetableTimeGridConfigs: Array<TimetableTimeGridConfig>;
  timetableTimeGridConfigsAggregate: TimetableTimeGridConfigAggregateSelection;
  timetableTimeGridConfigsConnection: TimetableTimeGridConfigsConnection;
  timetableVersions: Array<TimetableVersion>;
  timetableVersionsAggregate: TimetableVersionAggregateSelection;
  timetableVersionsConnection: TimetableVersionsConnection;
  timetables: Array<Timetable>;
  timetablesAggregate: TimetableAggregateSelection;
  timetablesConnection: TimetablesConnection;
  userConfigs: Array<UserConfig>;
  userConfigsAggregate: UserConfigAggregateSelection;
  userConfigsConnection: UserConfigsConnection;
};

export type QueryAbsencesArgs = {
  options?: InputMaybe<AbsenceOptions>;
  where?: InputMaybe<AbsenceWhere>;
};

export type QueryAbsencesAggregateArgs = {
  where?: InputMaybe<AbsenceWhere>;
};

export type QueryAbsencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AbsenceSort>>>;
  where?: InputMaybe<AbsenceWhere>;
};

export type QueryAdditionalTeachingLoadsArgs = {
  options?: InputMaybe<AdditionalTeachingLoadOptions>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type QueryAdditionalTeachingLoadsAggregateArgs = {
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type QueryAdditionalTeachingLoadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdditionalTeachingLoadSort>>>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type QueryAttendancePlanEventsArgs = {
  day: Scalars['Date']['input'];
  organizationUuid: Scalars['ID']['input'];
};

export type QueryAvailabilityHoldersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<AvailabilityHolderWhere>;
};

export type QueryBuildingsArgs = {
  options?: InputMaybe<BuildingOptions>;
  where?: InputMaybe<BuildingWhere>;
};

export type QueryBuildingsAggregateArgs = {
  where?: InputMaybe<BuildingWhere>;
};

export type QueryBuildingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BuildingSort>>>;
  where?: InputMaybe<BuildingWhere>;
};

export type QueryClassGridCardsArgs = {
  where?: InputMaybe<TimetableCardWhere>;
};

export type QueryClassOrGroupsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<ClassOrGroupWhere>;
};

export type QueryClassesArgs = {
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type QueryClassesAggregateArgs = {
  where?: InputMaybe<ClassWhere>;
};

export type QueryClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClassSort>>>;
  where?: InputMaybe<ClassWhere>;
};

export type QueryColumnSortsArgs = {
  options?: InputMaybe<ColumnSortOptions>;
  where?: InputMaybe<ColumnSortWhere>;
};

export type QueryColumnSortsAggregateArgs = {
  where?: InputMaybe<ColumnSortWhere>;
};

export type QueryColumnSortsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ColumnSortSort>>>;
  where?: InputMaybe<ColumnSortWhere>;
};

export type QueryContractsArgs = {
  options?: InputMaybe<ContractOptions>;
  where?: InputMaybe<ContractWhere>;
};

export type QueryContractsAggregateArgs = {
  where?: InputMaybe<ContractWhere>;
};

export type QueryContractsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ContractSort>>>;
  where?: InputMaybe<ContractWhere>;
};

export type QueryCurriculaArgs = {
  options?: InputMaybe<CurriculumOptions>;
  where?: InputMaybe<CurriculumWhere>;
};

export type QueryCurriculaAggregateArgs = {
  where?: InputMaybe<CurriculumWhere>;
};

export type QueryCurriculaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumSort>>>;
  where?: InputMaybe<CurriculumWhere>;
};

export type QueryCurriculumClassesArgs = {
  options?: InputMaybe<CurriculumClassOptions>;
  where?: InputMaybe<CurriculumClassWhere>;
};

export type QueryCurriculumClassesAggregateArgs = {
  where?: InputMaybe<CurriculumClassWhere>;
};

export type QueryCurriculumClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumClassSort>>>;
  where?: InputMaybe<CurriculumClassWhere>;
};

export type QueryCurriculumPeopleArgs = {
  options?: InputMaybe<CurriculumPersonOptions>;
  where?: InputMaybe<CurriculumPersonWhere>;
};

export type QueryCurriculumPeopleAggregateArgs = {
  where?: InputMaybe<CurriculumPersonWhere>;
};

export type QueryCurriculumPeopleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumPersonSort>>>;
  where?: InputMaybe<CurriculumPersonWhere>;
};

export type QueryCurriculumUnitsArgs = {
  options?: InputMaybe<CurriculumUnitOptions>;
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type QueryCurriculumUnitsAggregateArgs = {
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type QueryCurriculumUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumUnitSort>>>;
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type QueryCurriculumVersionsArgs = {
  options?: InputMaybe<CurriculumVersionOptions>;
  where?: InputMaybe<CurriculumVersionWhere>;
};

export type QueryCurriculumVersionsAggregateArgs = {
  where?: InputMaybe<CurriculumVersionWhere>;
};

export type QueryCurriculumVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurriculumVersionSort>>>;
  where?: InputMaybe<CurriculumVersionWhere>;
};

export type QueryDependenciesArgs = {
  options?: InputMaybe<DependencyOptions>;
  where?: InputMaybe<DependencyWhere>;
};

export type QueryDependenciesAggregateArgs = {
  where?: InputMaybe<DependencyWhere>;
};

export type QueryDependenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DependencySort>>>;
  where?: InputMaybe<DependencyWhere>;
};

export type QueryDivisionsArgs = {
  options?: InputMaybe<DivisionOptions>;
  where?: InputMaybe<DivisionWhere>;
};

export type QueryDivisionsAggregateArgs = {
  where?: InputMaybe<DivisionWhere>;
};

export type QueryDivisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DivisionSort>>>;
  where?: InputMaybe<DivisionWhere>;
};

export type QueryEventJobsArgs = {
  options?: InputMaybe<EventJobOptions>;
  where?: InputMaybe<EventJobWhere>;
};

export type QueryEventJobsAggregateArgs = {
  where?: InputMaybe<EventJobWhere>;
};

export type QueryEventJobsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EventJobSort>>>;
  where?: InputMaybe<EventJobWhere>;
};

export type QueryEventStateTypesArgs = {
  options?: InputMaybe<EventStateTypeOptions>;
  where?: InputMaybe<EventStateTypeWhere>;
};

export type QueryEventStateTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EventStateTypeSort>>>;
  where?: InputMaybe<EventStateTypeWhere>;
};

export type QueryEventsArgs = {
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type QueryEventsAggregateArgs = {
  where?: InputMaybe<EventWhere>;
};

export type QueryEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EventSort>>>;
  where?: InputMaybe<EventWhere>;
};

export type QueryFileEntriesArgs = {
  options?: InputMaybe<FileEntryOptions>;
  where?: InputMaybe<FileEntryWhere>;
};

export type QueryFileEntriesAggregateArgs = {
  where?: InputMaybe<FileEntryWhere>;
};

export type QueryFileEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FileEntrySort>>>;
  where?: InputMaybe<FileEntryWhere>;
};

export type QueryGradeGroupsArgs = {
  options?: InputMaybe<GradeGroupOptions>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type QueryGradeGroupsAggregateArgs = {
  where?: InputMaybe<GradeGroupWhere>;
};

export type QueryGradeGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GradeGroupSort>>>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type QueryGroupOwnersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<GroupOwnerWhere>;
};

export type QueryGroupsArgs = {
  options?: InputMaybe<GroupOptions>;
  where?: InputMaybe<GroupWhere>;
};

export type QueryGroupsAggregateArgs = {
  where?: InputMaybe<GroupWhere>;
};

export type QueryGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GroupSort>>>;
  where?: InputMaybe<GroupWhere>;
};

export type QueryHolidaysArgs = {
  options?: InputMaybe<HolidayOptions>;
  where?: InputMaybe<HolidayWhere>;
};

export type QueryHolidaysAggregateArgs = {
  where?: InputMaybe<HolidayWhere>;
};

export type QueryHolidaysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<HolidaySort>>>;
  where?: InputMaybe<HolidayWhere>;
};

export type QueryLabelOwnersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<LabelOwnerWhere>;
};

export type QueryLabelsArgs = {
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type QueryLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LabelSort>>>;
  where?: InputMaybe<LabelWhere>;
};

export type QueryLessonClassesArgs = {
  options?: InputMaybe<LessonClassOptions>;
  where?: InputMaybe<LessonClassWhere>;
};

export type QueryLessonClassesAggregateArgs = {
  where?: InputMaybe<LessonClassWhere>;
};

export type QueryLessonClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LessonClassSort>>>;
  where?: InputMaybe<LessonClassWhere>;
};

export type QueryLessonUnitsArgs = {
  options?: InputMaybe<LessonUnitOptions>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type QueryLessonUnitsAggregateArgs = {
  where?: InputMaybe<LessonUnitWhere>;
};

export type QueryLessonUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LessonUnitSort>>>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type QueryLessonsArgs = {
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type QueryLessonsAggregateArgs = {
  where?: InputMaybe<LessonWhere>;
};

export type QueryLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LessonSort>>>;
  where?: InputMaybe<LessonWhere>;
};

export type QueryLockedsArgs = {
  options?: InputMaybe<LockedOptions>;
  where?: InputMaybe<LockedWhere>;
};

export type QueryLockedsAggregateArgs = {
  where?: InputMaybe<LockedWhere>;
};

export type QueryLockedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LockedSort>>>;
  where?: InputMaybe<LockedWhere>;
};

export type QueryMathplanJobsArgs = {
  options?: InputMaybe<MathplanJobOptions>;
  where?: InputMaybe<MathplanJobWhere>;
};

export type QueryMathplanJobsAggregateArgs = {
  where?: InputMaybe<MathplanJobWhere>;
};

export type QueryMathplanJobsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MathplanJobSort>>>;
  where?: InputMaybe<MathplanJobWhere>;
};

export type QueryOrganizationsArgs = {
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsAggregateArgs = {
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationSort>>>;
  where?: InputMaybe<OrganizationWhere>;
};

export type QueryPdfReportContextsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PdfReportContextWhere>;
};

export type QueryPdfReportHoldersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PdfReportHolderWhere>;
};

export type QueryPeopleArgs = {
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type QueryPeopleAggregateArgs = {
  where?: InputMaybe<PersonWhere>;
};

export type QueryPeopleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PersonSort>>>;
  where?: InputMaybe<PersonWhere>;
};

export type QueryPimOrganizationsArgs = {
  options?: InputMaybe<PimOrganizationOptions>;
  where?: InputMaybe<PimOrganizationWhere>;
};

export type QueryPimOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PimOrganizationSort>>>;
  where?: InputMaybe<PimOrganizationWhere>;
};

export type QueryPimProfilesArgs = {
  organizationUuid: Scalars['ID']['input'];
};

export type QueryPlannedTeachingLoadByClassArgs = {
  classUuid?: InputMaybe<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
};

export type QueryPlannedTeachingLoadByTeacherArgs = {
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPublishedSubstitutionsArgs = {
  options?: InputMaybe<PublishedSubstitutionsOptions>;
  where?: InputMaybe<PublishedSubstitutionsWhere>;
};

export type QueryPublishedSubstitutionsAggregateArgs = {
  where?: InputMaybe<PublishedSubstitutionsWhere>;
};

export type QueryPublishedSubstitutionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublishedSubstitutionsSort>>>;
  where?: InputMaybe<PublishedSubstitutionsWhere>;
};

export type QueryQualificationsArgs = {
  options?: InputMaybe<QualificationOptions>;
  where?: InputMaybe<QualificationWhere>;
};

export type QueryQualificationsAggregateArgs = {
  where?: InputMaybe<QualificationWhere>;
};

export type QueryQualificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QualificationSort>>>;
  where?: InputMaybe<QualificationWhere>;
};

export type QueryRecurringEventsArgs = {
  options?: InputMaybe<RecurringEventOptions>;
  where?: InputMaybe<RecurringEventWhere>;
};

export type QueryRecurringEventsAggregateArgs = {
  where?: InputMaybe<RecurringEventWhere>;
};

export type QueryRecurringEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RecurringEventSort>>>;
  where?: InputMaybe<RecurringEventWhere>;
};

export type QueryRoomGridCardsArgs = {
  where?: InputMaybe<TimetableCardWhere>;
};

export type QueryRoomsArgs = {
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type QueryRoomsAggregateArgs = {
  where?: InputMaybe<RoomWhere>;
};

export type QueryRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RoomSort>>>;
  where?: InputMaybe<RoomWhere>;
};

export type QuerySchoolEventClassOrGroupsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<SchoolEventClassOrGroupWhere>;
};

export type QuerySchoolEventsArgs = {
  from: Scalars['Date']['input'];
  organizationUuid: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};

export type QuerySchoolYearsArgs = {
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type QuerySchoolYearsAggregateArgs = {
  where?: InputMaybe<SchoolYearWhere>;
};

export type QuerySchoolYearsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SchoolYearSort>>>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type QuerySubjectContainerOrSubjectsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<SubjectContainerOrSubjectWhere>;
};

export type QuerySubjectContainersArgs = {
  options?: InputMaybe<SubjectContainerOptions>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type QuerySubjectContainersAggregateArgs = {
  where?: InputMaybe<SubjectContainerWhere>;
};

export type QuerySubjectContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectContainerSort>>>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type QuerySubjectGridCardsArgs = {
  where?: InputMaybe<TimetableCardWhere>;
};

export type QuerySubjectGroupsArgs = {
  options?: InputMaybe<SubjectGroupOptions>;
  where?: InputMaybe<SubjectGroupWhere>;
};

export type QuerySubjectGroupsAggregateArgs = {
  where?: InputMaybe<SubjectGroupWhere>;
};

export type QuerySubjectGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectGroupSort>>>;
  where?: InputMaybe<SubjectGroupWhere>;
};

export type QuerySubjectsArgs = {
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type QuerySubjectsAggregateArgs = {
  where?: InputMaybe<SubjectWhere>;
};

export type QuerySubjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubjectSort>>>;
  where?: InputMaybe<SubjectWhere>;
};

export type QuerySubstitutionAnnouncementsArgs = {
  options?: InputMaybe<SubstitutionAnnouncementOptions>;
  where?: InputMaybe<SubstitutionAnnouncementWhere>;
};

export type QuerySubstitutionAnnouncementsAggregateArgs = {
  where?: InputMaybe<SubstitutionAnnouncementWhere>;
};

export type QuerySubstitutionAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubstitutionAnnouncementSort>>>;
  where?: InputMaybe<SubstitutionAnnouncementWhere>;
};

export type QuerySubstitutionAppConfigsArgs = {
  options?: InputMaybe<SubstitutionAppConfigOptions>;
  where?: InputMaybe<SubstitutionAppConfigWhere>;
};

export type QuerySubstitutionAppConfigsAggregateArgs = {
  where?: InputMaybe<SubstitutionAppConfigWhere>;
};

export type QuerySubstitutionAppConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubstitutionAppConfigSort>>>;
  where?: InputMaybe<SubstitutionAppConfigWhere>;
};

export type QuerySubstitutionPrintColumnConfigsArgs = {
  options?: InputMaybe<SubstitutionPrintColumnConfigOptions>;
  where?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
};

export type QuerySubstitutionPrintColumnConfigsAggregateArgs = {
  where?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
};

export type QuerySubstitutionPrintColumnConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubstitutionPrintColumnConfigSort>>>;
  where?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
};

export type QuerySubstitutionPrintConfigsArgs = {
  options?: InputMaybe<SubstitutionPrintConfigOptions>;
  where?: InputMaybe<SubstitutionPrintConfigWhere>;
};

export type QuerySubstitutionPrintConfigsAggregateArgs = {
  where?: InputMaybe<SubstitutionPrintConfigWhere>;
};

export type QuerySubstitutionPrintConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubstitutionPrintConfigSort>>>;
  where?: InputMaybe<SubstitutionPrintConfigWhere>;
};

export type QuerySubstitutionReportsArgs = {
  options?: InputMaybe<SubstitutionReportOptions>;
  where?: InputMaybe<SubstitutionReportWhere>;
};

export type QuerySubstitutionReportsAggregateArgs = {
  where?: InputMaybe<SubstitutionReportWhere>;
};

export type QuerySubstitutionReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SubstitutionReportSort>>>;
  where?: InputMaybe<SubstitutionReportWhere>;
};

export type QueryTableConfigsArgs = {
  options?: InputMaybe<TableConfigOptions>;
  where?: InputMaybe<TableConfigWhere>;
};

export type QueryTableConfigsAggregateArgs = {
  where?: InputMaybe<TableConfigWhere>;
};

export type QueryTableConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TableConfigSort>>>;
  where?: InputMaybe<TableConfigWhere>;
};

export type QueryTeacherGridCardsArgs = {
  where?: InputMaybe<TimetableCardWhere>;
};

export type QueryTeachersSubstitutionsArgs = {
  classUuids: Array<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  subjectUuid?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTeachingBlockAvailabilityExclusionsArgs = {
  options?: InputMaybe<TeachingBlockAvailabilityExclusionOptions>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
};

export type QueryTeachingBlockAvailabilityExclusionsAggregateArgs = {
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
};

export type QueryTeachingBlockAvailabilityExclusionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingBlockAvailabilityExclusionSort>>>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
};

export type QueryTeachingBlockCardsArgs = {
  options?: InputMaybe<TeachingBlockCardOptions>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type QueryTeachingBlockCardsAggregateArgs = {
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type QueryTeachingBlockCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingBlockCardSort>>>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type QueryTeachingBlockClassGridCardsArgs = {
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type QueryTeachingBlockRoomGridCardsArgs = {
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type QueryTeachingBlockSubjectGridCardsArgs = {
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type QueryTeachingBlockTeacherGridCardsArgs = {
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type QueryTeachingBlockVersionsArgs = {
  options?: InputMaybe<TeachingBlockVersionOptions>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type QueryTeachingBlockVersionsAggregateArgs = {
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type QueryTeachingBlockVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingBlockVersionSort>>>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type QueryTeachingBlocksArgs = {
  options?: InputMaybe<TeachingBlockOptions>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type QueryTeachingBlocksAggregateArgs = {
  where?: InputMaybe<TeachingBlockWhere>;
};

export type QueryTeachingBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingBlockSort>>>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type QueryTeachingLoadByClassArgs = {
  classUuid?: InputMaybe<Scalars['ID']['input']>;
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  timetableBlockUuid: Scalars['ID']['input'];
};

export type QueryTeachingLoadByTeacherArgs = {
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
  timetableBlockUuid: Scalars['ID']['input'];
};

export type QueryTeachingLoadFactorsArgs = {
  options?: InputMaybe<TeachingLoadFactorOptions>;
  where?: InputMaybe<TeachingLoadFactorWhere>;
};

export type QueryTeachingLoadFactorsAggregateArgs = {
  where?: InputMaybe<TeachingLoadFactorWhere>;
};

export type QueryTeachingLoadFactorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingLoadFactorSort>>>;
  where?: InputMaybe<TeachingLoadFactorWhere>;
};

export type QueryTeachingLoadReportsArgs = {
  options?: InputMaybe<TeachingLoadReportOptions>;
  where?: InputMaybe<TeachingLoadReportWhere>;
};

export type QueryTeachingLoadReportsAggregateArgs = {
  where?: InputMaybe<TeachingLoadReportWhere>;
};

export type QueryTeachingLoadReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingLoadReportSort>>>;
  where?: InputMaybe<TeachingLoadReportWhere>;
};

export type QueryTeachingLoadScenariosArgs = {
  options?: InputMaybe<TeachingLoadScenarioOptions>;
  where?: InputMaybe<TeachingLoadScenarioWhere>;
};

export type QueryTeachingLoadScenariosAggregateArgs = {
  where?: InputMaybe<TeachingLoadScenarioWhere>;
};

export type QueryTeachingLoadScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TeachingLoadScenarioSort>>>;
  where?: InputMaybe<TeachingLoadScenarioWhere>;
};

export type QueryTimeGridEntriesArgs = {
  options?: InputMaybe<TimeGridEntryOptions>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type QueryTimeGridEntriesAggregateArgs = {
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type QueryTimeGridEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimeGridEntrySort>>>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type QueryTimeGridsArgs = {
  options?: InputMaybe<TimeGridOptions>;
  where?: InputMaybe<TimeGridWhere>;
};

export type QueryTimeGridsAggregateArgs = {
  where?: InputMaybe<TimeGridWhere>;
};

export type QueryTimeGridsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimeGridSort>>>;
  where?: InputMaybe<TimeGridWhere>;
};

export type QueryTimespansArgs = {
  options?: InputMaybe<TimespanOptions>;
  where?: InputMaybe<TimespanWhere>;
};

export type QueryTimespansAggregateArgs = {
  where?: InputMaybe<TimespanWhere>;
};

export type QueryTimespansConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimespanSort>>>;
  where?: InputMaybe<TimespanWhere>;
};

export type QueryTimetableBlocksArgs = {
  options?: InputMaybe<TimetableBlockOptions>;
  where?: InputMaybe<TimetableBlockWhere>;
};

export type QueryTimetableBlocksAggregateArgs = {
  where?: InputMaybe<TimetableBlockWhere>;
};

export type QueryTimetableBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimetableBlockSort>>>;
  where?: InputMaybe<TimetableBlockWhere>;
};

export type QueryTimetableCardAvailabilitiesArgs = {
  timetableCardUuids: Array<Scalars['ID']['input']>;
  versionUuid: Scalars['ID']['input'];
};

export type QueryTimetableCardsArgs = {
  options?: InputMaybe<TimetableCardOptions>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type QueryTimetableCardsAggregateArgs = {
  where?: InputMaybe<TimetableCardWhere>;
};

export type QueryTimetableCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimetableCardSort>>>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type QueryTimetableConfigOwnersArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<TimetableConfigOwnerWhere>;
};

export type QueryTimetableConfigsArgs = {
  options?: InputMaybe<TimetableConfigOptions>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type QueryTimetableConfigsAggregateArgs = {
  where?: InputMaybe<TimetableConfigWhere>;
};

export type QueryTimetableConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimetableConfigSort>>>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type QueryTimetablePrintConfigsArgs = {
  options?: InputMaybe<TimetablePrintConfigOptions>;
  where?: InputMaybe<TimetablePrintConfigWhere>;
};

export type QueryTimetablePrintConfigsAggregateArgs = {
  where?: InputMaybe<TimetablePrintConfigWhere>;
};

export type QueryTimetablePrintConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimetablePrintConfigSort>>>;
  where?: InputMaybe<TimetablePrintConfigWhere>;
};

export type QueryTimetableReportsArgs = {
  options?: InputMaybe<TimetableReportOptions>;
  where?: InputMaybe<TimetableReportWhere>;
};

export type QueryTimetableReportsAggregateArgs = {
  where?: InputMaybe<TimetableReportWhere>;
};

export type QueryTimetableReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimetableReportSort>>>;
  where?: InputMaybe<TimetableReportWhere>;
};

export type QueryTimetableTimeGridConfigsArgs = {
  options?: InputMaybe<TimetableTimeGridConfigOptions>;
  where?: InputMaybe<TimetableTimeGridConfigWhere>;
};

export type QueryTimetableTimeGridConfigsAggregateArgs = {
  where?: InputMaybe<TimetableTimeGridConfigWhere>;
};

export type QueryTimetableTimeGridConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TimetableTimeGridConfigWhere>;
};

export type QueryTimetableVersionsArgs = {
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type QueryTimetableVersionsAggregateArgs = {
  where?: InputMaybe<TimetableVersionWhere>;
};

export type QueryTimetableVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimetableVersionSort>>>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type QueryTimetablesArgs = {
  options?: InputMaybe<TimetableOptions>;
  where?: InputMaybe<TimetableWhere>;
};

export type QueryTimetablesAggregateArgs = {
  where?: InputMaybe<TimetableWhere>;
};

export type QueryTimetablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TimetableSort>>>;
  where?: InputMaybe<TimetableWhere>;
};

export type QueryUserConfigsArgs = {
  options?: InputMaybe<UserConfigOptions>;
  where?: InputMaybe<UserConfigWhere>;
};

export type QueryUserConfigsAggregateArgs = {
  where?: InputMaybe<UserConfigWhere>;
};

export type QueryUserConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserConfigSort>>>;
  where?: InputMaybe<UserConfigWhere>;
};

/** Input type for options that can be specified on a query operation. */
export type QueryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RecurrenceSchoolEventCreateInput = {
  classes?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  excludeHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClassbookRelevant: Scalars['Boolean']['input'];
  persons?: InputMaybe<Array<Scalars['ID']['input']>>;
  rooms?: InputMaybe<Array<Scalars['ID']['input']>>;
  rrule: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  subject: Scalars['ID']['input'];
};

export type RecurringEvent = {
  __typename?: 'RecurringEvent';
  createdAt: Scalars['DateTime']['output'];
  events: Array<Event>;
  eventsAggregate?: Maybe<RecurringEventEventEventsAggregationSelection>;
  eventsConnection: RecurringEventEventsConnection;
  excludeHolidays: Scalars['Boolean']['output'];
  futureEvents: Array<Event>;
  organization: Organization;
  organizationConnection: RecurringEventOrganizationConnection;
  rrule: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type RecurringEventEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type RecurringEventEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EventWhere>;
};

export type RecurringEventEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecurringEventEventsConnectionSort>>;
  where?: InputMaybe<RecurringEventEventsConnectionWhere>;
};

export type RecurringEventOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type RecurringEventOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecurringEventOrganizationConnectionSort>>;
  where?: InputMaybe<RecurringEventOrganizationConnectionWhere>;
};

export type RecurringEventAggregateSelection = {
  __typename?: 'RecurringEventAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  rrule: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type RecurringEventConnectInput = {
  events?: InputMaybe<Array<RecurringEventEventsConnectFieldInput>>;
  organization?: InputMaybe<RecurringEventOrganizationConnectFieldInput>;
};

export type RecurringEventConnectWhere = {
  node: RecurringEventWhere;
};

export type RecurringEventCreateInput = {
  events?: InputMaybe<RecurringEventEventsFieldInput>;
  excludeHolidays: Scalars['Boolean']['input'];
  organization?: InputMaybe<RecurringEventOrganizationFieldInput>;
  rrule: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export type RecurringEventDeleteInput = {
  events?: InputMaybe<Array<RecurringEventEventsDeleteFieldInput>>;
  organization?: InputMaybe<RecurringEventOrganizationDeleteFieldInput>;
};

export type RecurringEventDisconnectInput = {
  events?: InputMaybe<Array<RecurringEventEventsDisconnectFieldInput>>;
  organization?: InputMaybe<RecurringEventOrganizationDisconnectFieldInput>;
};

export type RecurringEventEdge = {
  __typename?: 'RecurringEventEdge';
  cursor: Scalars['String']['output'];
  node: RecurringEvent;
};

export type RecurringEventEventEventsAggregationSelection = {
  __typename?: 'RecurringEventEventEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RecurringEventEventEventsNodeAggregateSelection>;
};

export type RecurringEventEventEventsNodeAggregateSelection = {
  __typename?: 'RecurringEventEventEventsNodeAggregateSelection';
  comment: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  currentState: StringAggregateSelection;
  end: DateTimeAggregateSelection;
  originalEnd: DateTimeAggregateSelection;
  originalStart: DateTimeAggregateSelection;
  start: DateTimeAggregateSelection;
  substitutionComment: StringAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type RecurringEventEventsAggregateInput = {
  AND?: InputMaybe<Array<RecurringEventEventsAggregateInput>>;
  NOT?: InputMaybe<RecurringEventEventsAggregateInput>;
  OR?: InputMaybe<Array<RecurringEventEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecurringEventEventsNodeAggregationWhereInput>;
};

export type RecurringEventEventsConnectFieldInput = {
  connect?: InputMaybe<Array<EventConnectInput>>;
  edge: RecurringEventRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type RecurringEventEventsConnection = {
  __typename?: 'RecurringEventEventsConnection';
  edges: Array<RecurringEventEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecurringEventEventsConnectionSort = {
  edge?: InputMaybe<RecurringEventRelationPropertiesSort>;
  node?: InputMaybe<EventSort>;
};

export type RecurringEventEventsConnectionWhere = {
  AND?: InputMaybe<Array<RecurringEventEventsConnectionWhere>>;
  NOT?: InputMaybe<RecurringEventEventsConnectionWhere>;
  OR?: InputMaybe<Array<RecurringEventEventsConnectionWhere>>;
  edge?: InputMaybe<RecurringEventRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<RecurringEventRelationPropertiesWhere>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type RecurringEventEventsCreateFieldInput = {
  edge: RecurringEventRelationPropertiesCreateInput;
  node: EventCreateInput;
};

export type RecurringEventEventsDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<RecurringEventEventsConnectionWhere>;
};

export type RecurringEventEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<RecurringEventEventsConnectionWhere>;
};

export type RecurringEventEventsFieldInput = {
  connect?: InputMaybe<Array<RecurringEventEventsConnectFieldInput>>;
  create?: InputMaybe<Array<RecurringEventEventsCreateFieldInput>>;
};

export type RecurringEventEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecurringEventEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecurringEventEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecurringEventEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecurringEventEventsRelationship = {
  __typename?: 'RecurringEventEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
  properties: RecurringEventRelationProperties;
};

export type RecurringEventEventsUpdateConnectionInput = {
  edge?: InputMaybe<RecurringEventRelationPropertiesUpdateInput>;
  node?: InputMaybe<EventUpdateInput>;
};

export type RecurringEventEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<RecurringEventEventsConnectFieldInput>>;
  create?: InputMaybe<Array<RecurringEventEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<RecurringEventEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RecurringEventEventsDisconnectFieldInput>>;
  update?: InputMaybe<RecurringEventEventsUpdateConnectionInput>;
  where?: InputMaybe<RecurringEventEventsConnectionWhere>;
};

export type RecurringEventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RecurringEventSort objects to sort RecurringEvents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RecurringEventSort>>;
};

export type RecurringEventOrganizationAggregateInput = {
  AND?: InputMaybe<Array<RecurringEventOrganizationAggregateInput>>;
  NOT?: InputMaybe<RecurringEventOrganizationAggregateInput>;
  OR?: InputMaybe<Array<RecurringEventOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecurringEventOrganizationNodeAggregationWhereInput>;
};

export type RecurringEventOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type RecurringEventOrganizationConnectOrCreateFieldInput = {
  onCreate: RecurringEventOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type RecurringEventOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type RecurringEventOrganizationConnection = {
  __typename?: 'RecurringEventOrganizationConnection';
  edges: Array<RecurringEventOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecurringEventOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type RecurringEventOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<RecurringEventOrganizationConnectionWhere>>;
  NOT?: InputMaybe<RecurringEventOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<RecurringEventOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type RecurringEventOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type RecurringEventOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<RecurringEventOrganizationConnectionWhere>;
};

export type RecurringEventOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<RecurringEventOrganizationConnectionWhere>;
};

export type RecurringEventOrganizationFieldInput = {
  connect?: InputMaybe<RecurringEventOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<RecurringEventOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<RecurringEventOrganizationCreateFieldInput>;
};

export type RecurringEventOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecurringEventOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecurringEventOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecurringEventOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RecurringEventOrganizationRelationship = {
  __typename?: 'RecurringEventOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type RecurringEventOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type RecurringEventOrganizationUpdateFieldInput = {
  connect?: InputMaybe<RecurringEventOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<RecurringEventOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<RecurringEventOrganizationCreateFieldInput>;
  delete?: InputMaybe<RecurringEventOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<RecurringEventOrganizationDisconnectFieldInput>;
  update?: InputMaybe<RecurringEventOrganizationUpdateConnectionInput>;
  where?: InputMaybe<RecurringEventOrganizationConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * RecurringEvent.events
 * * Event.recurringEvent
 */
export type RecurringEventRelationProperties = {
  __typename?: 'RecurringEventRelationProperties';
  excluded: Scalars['Boolean']['output'];
};

export type RecurringEventRelationPropertiesCreateInput = {
  excluded: Scalars['Boolean']['input'];
};

export type RecurringEventRelationPropertiesSort = {
  excluded?: InputMaybe<SortDirection>;
};

export type RecurringEventRelationPropertiesUpdateInput = {
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecurringEventRelationPropertiesWhere = {
  AND?: InputMaybe<Array<RecurringEventRelationPropertiesWhere>>;
  NOT?: InputMaybe<RecurringEventRelationPropertiesWhere>;
  OR?: InputMaybe<Array<RecurringEventRelationPropertiesWhere>>;
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  excluded_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fields to sort RecurringEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecurringEventSort object. */
export type RecurringEventSort = {
  createdAt?: InputMaybe<SortDirection>;
  excludeHolidays?: InputMaybe<SortDirection>;
  rrule?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type RecurringEventUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<Array<RecurringEventEventsUpdateFieldInput>>;
  excludeHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<RecurringEventOrganizationUpdateFieldInput>;
  rrule?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringEventWhere = {
  AND?: InputMaybe<Array<RecurringEventWhere>>;
  NOT?: InputMaybe<RecurringEventWhere>;
  OR?: InputMaybe<Array<RecurringEventWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<RecurringEventEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<RecurringEventEventsConnectionWhere>;
  /** Return RecurringEvents where all of the related RecurringEventEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<RecurringEventEventsConnectionWhere>;
  /** Return RecurringEvents where none of the related RecurringEventEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<RecurringEventEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<RecurringEventEventsConnectionWhere>;
  /** Return RecurringEvents where one of the related RecurringEventEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<RecurringEventEventsConnectionWhere>;
  /** Return RecurringEvents where some of the related RecurringEventEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<RecurringEventEventsConnectionWhere>;
  /** Return RecurringEvents where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return RecurringEvents where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return RecurringEvents where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return RecurringEvents where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  excludeHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  excludeHolidays_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  futureEvents?: InputMaybe<EventWhere>;
  futureEvents_ALL?: InputMaybe<EventWhere>;
  futureEvents_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  futureEvents_NOT?: InputMaybe<EventWhere>;
  futureEvents_SINGLE?: InputMaybe<EventWhere>;
  futureEvents_SOME?: InputMaybe<EventWhere>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<RecurringEventOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<RecurringEventOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<RecurringEventOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  rrule?: InputMaybe<Scalars['String']['input']>;
  rrule_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rrule_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rrule_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  rrule_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  rrule_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  rrule_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  rrule_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  rrule_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  rrule_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type RecurringEventsConnection = {
  __typename?: 'RecurringEventsConnection';
  edges: Array<RecurringEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * The edge properties for the following fields:
 * * Organization.persons
 * * Person.organization
 */
export type RoleName = {
  __typename?: 'RoleName';
  name: PersonRole;
};

export type RoleNameCreateInput = {
  name: PersonRole;
};

export type RoleNameSort = {
  name?: InputMaybe<SortDirection>;
};

export type RoleNameUpdateInput = {
  name?: InputMaybe<PersonRole>;
};

export type RoleNameWhere = {
  AND?: InputMaybe<Array<RoleNameWhere>>;
  NOT?: InputMaybe<RoleNameWhere>;
  OR?: InputMaybe<Array<RoleNameWhere>>;
  name?: InputMaybe<PersonRole>;
  name_IN?: InputMaybe<Array<PersonRole>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<PersonRole>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<PersonRole>>;
};

export type Room = {
  __typename?: 'Room';
  barrierFree?: Maybe<Scalars['Boolean']['output']>;
  building?: Maybe<Building>;
  buildingConnection: RoomBuildingConnection;
  /** Verdunklung möglich */
  canBeDarkened?: Maybe<Scalars['Boolean']['output']>;
  canBeLeased?: Maybe<Scalars['Boolean']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  chairs?: Maybe<Scalars['Int']['output']>;
  classroom?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curricula: Array<Curriculum>;
  curriculaConnection: RoomCurriculaConnection;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  eventsConnection: RoomEventsConnection;
  foreignId?: Maybe<Scalars['String']['output']>;
  /** Medienschrank */
  hasMediaCabinet?: Maybe<Scalars['Boolean']['output']>;
  /** Klavier */
  hasPiano?: Maybe<Scalars['Boolean']['output']>;
  /** Beamer */
  hasProjector?: Maybe<Scalars['Boolean']['output']>;
  /** Leinwand */
  hasScreen?: Maybe<Scalars['Boolean']['output']>;
  labels: Array<Label>;
  labelsConnection: RoomLabelsConnection;
  lessons: Array<Lesson>;
  lessonsConnection: RoomLessonsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: RoomOrganizationConnection;
  otherInventory?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  responsiblePersons: Array<Person>;
  responsiblePersonsConnection: RoomResponsiblePersonsConnection;
  roomNumber?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  tables?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type RoomBuildingArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BuildingOptions>;
  where?: InputMaybe<BuildingWhere>;
};

export type RoomBuildingConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoomBuildingConnectionSort>>;
  where?: InputMaybe<RoomBuildingConnectionWhere>;
};

export type RoomCurriculaArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumOptions>;
  where?: InputMaybe<CurriculumWhere>;
};

export type RoomCurriculaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoomCurriculaConnectionSort>>;
  where?: InputMaybe<RoomCurriculaConnectionWhere>;
};

export type RoomEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type RoomEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoomEventsConnectionSort>>;
  where?: InputMaybe<RoomEventsConnectionWhere>;
};

export type RoomLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type RoomLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoomLabelsConnectionSort>>;
  where?: InputMaybe<RoomLabelsConnectionWhere>;
};

export type RoomLessonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type RoomLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoomLessonsConnectionSort>>;
  where?: InputMaybe<RoomLessonsConnectionWhere>;
};

export type RoomOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type RoomOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoomOrganizationConnectionSort>>;
  where?: InputMaybe<RoomOrganizationConnectionWhere>;
};

export type RoomResponsiblePersonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type RoomResponsiblePersonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoomResponsiblePersonsConnectionSort>>;
  where?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
};

export type RoomAggregateSelection = {
  __typename?: 'RoomAggregateSelection';
  capacity: IntAggregateSelection;
  chairs: IntAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  otherInventory: StringAggregateSelection;
  position: StringAggregateSelection;
  roomNumber: StringAggregateSelection;
  size: IntAggregateSelection;
  tables: IntAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type RoomBuildingAggregateInput = {
  AND?: InputMaybe<Array<RoomBuildingAggregateInput>>;
  NOT?: InputMaybe<RoomBuildingAggregateInput>;
  OR?: InputMaybe<Array<RoomBuildingAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RoomBuildingNodeAggregationWhereInput>;
};

export type RoomBuildingConnectFieldInput = {
  connect?: InputMaybe<BuildingConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<BuildingConnectWhere>;
};

export type RoomBuildingConnectOrCreateFieldInput = {
  onCreate: RoomBuildingConnectOrCreateFieldInputOnCreate;
  where: BuildingConnectOrCreateWhere;
};

export type RoomBuildingConnectOrCreateFieldInputOnCreate = {
  node: BuildingOnCreateInput;
};

export type RoomBuildingConnection = {
  __typename?: 'RoomBuildingConnection';
  edges: Array<RoomBuildingRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoomBuildingConnectionSort = {
  node?: InputMaybe<BuildingSort>;
};

export type RoomBuildingConnectionWhere = {
  AND?: InputMaybe<Array<RoomBuildingConnectionWhere>>;
  NOT?: InputMaybe<RoomBuildingConnectionWhere>;
  OR?: InputMaybe<Array<RoomBuildingConnectionWhere>>;
  node?: InputMaybe<BuildingWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<BuildingWhere>;
};

export type RoomBuildingCreateFieldInput = {
  node: BuildingCreateInput;
};

export type RoomBuildingDeleteFieldInput = {
  delete?: InputMaybe<BuildingDeleteInput>;
  where?: InputMaybe<RoomBuildingConnectionWhere>;
};

export type RoomBuildingDisconnectFieldInput = {
  disconnect?: InputMaybe<BuildingDisconnectInput>;
  where?: InputMaybe<RoomBuildingConnectionWhere>;
};

export type RoomBuildingFieldInput = {
  connect?: InputMaybe<RoomBuildingConnectFieldInput>;
  connectOrCreate?: InputMaybe<RoomBuildingConnectOrCreateFieldInput>;
  create?: InputMaybe<RoomBuildingCreateFieldInput>;
};

export type RoomBuildingNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoomBuildingNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoomBuildingNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoomBuildingNodeAggregationWhereInput>>;
  city_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  city_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  city_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  city_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  city_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  city_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  city_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  city_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  city_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  city_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  city_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  city_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  city_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  city_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  city_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  houseNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  houseNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  houseNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  houseNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  houseNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  houseNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  street_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  street_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  street_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  street_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  street_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  street_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  street_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  street_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  street_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  street_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  street_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  street_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  street_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  street_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  street_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  zipCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  zipCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  zipCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  zipCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  zipCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  zipCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zipCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zipCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zipCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zipCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  zipCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  zipCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  zipCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  zipCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  zipCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RoomBuildingRelationship = {
  __typename?: 'RoomBuildingRelationship';
  cursor: Scalars['String']['output'];
  node: Building;
};

export type RoomBuildingUpdateConnectionInput = {
  node?: InputMaybe<BuildingUpdateInput>;
};

export type RoomBuildingUpdateFieldInput = {
  connect?: InputMaybe<RoomBuildingConnectFieldInput>;
  connectOrCreate?: InputMaybe<RoomBuildingConnectOrCreateFieldInput>;
  create?: InputMaybe<RoomBuildingCreateFieldInput>;
  delete?: InputMaybe<RoomBuildingDeleteFieldInput>;
  disconnect?: InputMaybe<RoomBuildingDisconnectFieldInput>;
  update?: InputMaybe<RoomBuildingUpdateConnectionInput>;
  where?: InputMaybe<RoomBuildingConnectionWhere>;
};

export type RoomConnectInput = {
  building?: InputMaybe<RoomBuildingConnectFieldInput>;
  curricula?: InputMaybe<Array<RoomCurriculaConnectFieldInput>>;
  events?: InputMaybe<Array<RoomEventsConnectFieldInput>>;
  labels?: InputMaybe<Array<RoomLabelsConnectFieldInput>>;
  lessons?: InputMaybe<Array<RoomLessonsConnectFieldInput>>;
  organization?: InputMaybe<RoomOrganizationConnectFieldInput>;
  responsiblePersons?: InputMaybe<Array<RoomResponsiblePersonsConnectFieldInput>>;
};

export type RoomConnectOrCreateWhere = {
  node: RoomUniqueWhere;
};

export type RoomConnectWhere = {
  node: RoomWhere;
};

export type RoomCreateInput = {
  barrierFree?: InputMaybe<Scalars['Boolean']['input']>;
  building?: InputMaybe<RoomBuildingFieldInput>;
  canBeDarkened?: InputMaybe<Scalars['Boolean']['input']>;
  canBeLeased?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  chairs?: InputMaybe<Scalars['Int']['input']>;
  classroom?: InputMaybe<Scalars['Boolean']['input']>;
  curricula?: InputMaybe<RoomCurriculaFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<RoomEventsFieldInput>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  hasMediaCabinet?: InputMaybe<Scalars['Boolean']['input']>;
  hasPiano?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjector?: InputMaybe<Scalars['Boolean']['input']>;
  hasScreen?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<RoomLabelsFieldInput>;
  lessons?: InputMaybe<RoomLessonsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<RoomOrganizationFieldInput>;
  otherInventory?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  responsiblePersons?: InputMaybe<RoomResponsiblePersonsFieldInput>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tables?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RoomCurriculaAggregateInput = {
  AND?: InputMaybe<Array<RoomCurriculaAggregateInput>>;
  NOT?: InputMaybe<RoomCurriculaAggregateInput>;
  OR?: InputMaybe<Array<RoomCurriculaAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<RoomCurriculaNodeAggregationWhereInput>;
};

export type RoomCurriculaConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumConnectInput>>;
  edge: LessonRoomRelationshipPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumConnectWhere>;
};

export type RoomCurriculaConnectOrCreateFieldInput = {
  onCreate: RoomCurriculaConnectOrCreateFieldInputOnCreate;
  where: CurriculumConnectOrCreateWhere;
};

export type RoomCurriculaConnectOrCreateFieldInputOnCreate = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: CurriculumOnCreateInput;
};

export type RoomCurriculaConnection = {
  __typename?: 'RoomCurriculaConnection';
  edges: Array<RoomCurriculaRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoomCurriculaConnectionSort = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesSort>;
  node?: InputMaybe<CurriculumSort>;
};

export type RoomCurriculaConnectionWhere = {
  AND?: InputMaybe<Array<RoomCurriculaConnectionWhere>>;
  NOT?: InputMaybe<RoomCurriculaConnectionWhere>;
  OR?: InputMaybe<Array<RoomCurriculaConnectionWhere>>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  node?: InputMaybe<CurriculumWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumWhere>;
};

export type RoomCurriculaCreateFieldInput = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: CurriculumCreateInput;
};

export type RoomCurriculaDeleteFieldInput = {
  delete?: InputMaybe<CurriculumDeleteInput>;
  where?: InputMaybe<RoomCurriculaConnectionWhere>;
};

export type RoomCurriculaDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumDisconnectInput>;
  where?: InputMaybe<RoomCurriculaConnectionWhere>;
};

export type RoomCurriculaFieldInput = {
  connect?: InputMaybe<Array<RoomCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoomCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoomCurriculaCreateFieldInput>>;
};

export type RoomCurriculaNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoomCurriculaNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoomCurriculaNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoomCurriculaNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RoomCurriculaRelationship = {
  __typename?: 'RoomCurriculaRelationship';
  cursor: Scalars['String']['output'];
  node: Curriculum;
  properties: LessonRoomRelationshipProperties;
};

export type RoomCurriculaUpdateConnectionInput = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<CurriculumUpdateInput>;
};

export type RoomCurriculaUpdateFieldInput = {
  connect?: InputMaybe<Array<RoomCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoomCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoomCurriculaCreateFieldInput>>;
  delete?: InputMaybe<Array<RoomCurriculaDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RoomCurriculaDisconnectFieldInput>>;
  update?: InputMaybe<RoomCurriculaUpdateConnectionInput>;
  where?: InputMaybe<RoomCurriculaConnectionWhere>;
};

export type RoomDeleteInput = {
  building?: InputMaybe<RoomBuildingDeleteFieldInput>;
  curricula?: InputMaybe<Array<RoomCurriculaDeleteFieldInput>>;
  events?: InputMaybe<Array<RoomEventsDeleteFieldInput>>;
  labels?: InputMaybe<Array<RoomLabelsDeleteFieldInput>>;
  lessons?: InputMaybe<Array<RoomLessonsDeleteFieldInput>>;
  organization?: InputMaybe<RoomOrganizationDeleteFieldInput>;
  responsiblePersons?: InputMaybe<Array<RoomResponsiblePersonsDeleteFieldInput>>;
};

export type RoomDisconnectInput = {
  building?: InputMaybe<RoomBuildingDisconnectFieldInput>;
  curricula?: InputMaybe<Array<RoomCurriculaDisconnectFieldInput>>;
  events?: InputMaybe<Array<RoomEventsDisconnectFieldInput>>;
  labels?: InputMaybe<Array<RoomLabelsDisconnectFieldInput>>;
  lessons?: InputMaybe<Array<RoomLessonsDisconnectFieldInput>>;
  organization?: InputMaybe<RoomOrganizationDisconnectFieldInput>;
  responsiblePersons?: InputMaybe<Array<RoomResponsiblePersonsDisconnectFieldInput>>;
};

export type RoomEdge = {
  __typename?: 'RoomEdge';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type RoomEventsAggregateInput = {
  AND?: InputMaybe<Array<RoomEventsAggregateInput>>;
  NOT?: InputMaybe<RoomEventsAggregateInput>;
  OR?: InputMaybe<Array<RoomEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RoomEventsNodeAggregationWhereInput>;
};

export type RoomEventsConnectFieldInput = {
  connect?: InputMaybe<Array<EventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EventConnectWhere>;
};

export type RoomEventsConnection = {
  __typename?: 'RoomEventsConnection';
  edges: Array<RoomEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoomEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type RoomEventsConnectionWhere = {
  AND?: InputMaybe<Array<RoomEventsConnectionWhere>>;
  NOT?: InputMaybe<RoomEventsConnectionWhere>;
  OR?: InputMaybe<Array<RoomEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type RoomEventsCreateFieldInput = {
  node: EventCreateInput;
};

export type RoomEventsDeleteFieldInput = {
  delete?: InputMaybe<EventDeleteInput>;
  where?: InputMaybe<RoomEventsConnectionWhere>;
};

export type RoomEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<EventDisconnectInput>;
  where?: InputMaybe<RoomEventsConnectionWhere>;
};

export type RoomEventsFieldInput = {
  connect?: InputMaybe<Array<RoomEventsConnectFieldInput>>;
  create?: InputMaybe<Array<RoomEventsCreateFieldInput>>;
};

export type RoomEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoomEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoomEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoomEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RoomEventsRelationship = {
  __typename?: 'RoomEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type RoomEventsUpdateConnectionInput = {
  node?: InputMaybe<EventUpdateInput>;
};

export type RoomEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<RoomEventsConnectFieldInput>>;
  create?: InputMaybe<Array<RoomEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<RoomEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RoomEventsDisconnectFieldInput>>;
  update?: InputMaybe<RoomEventsUpdateConnectionInput>;
  where?: InputMaybe<RoomEventsConnectionWhere>;
};

export type RoomGridCard = {
  __typename?: 'RoomGridCard';
  building: Scalars['ID']['output'];
  colors: Array<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  room: Scalars['ID']['output'];
  startTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  timetableCardUuid: Scalars['ID']['output'];
  uuid: Scalars['ID']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};

export type RoomLabelsAggregateInput = {
  AND?: InputMaybe<Array<RoomLabelsAggregateInput>>;
  NOT?: InputMaybe<RoomLabelsAggregateInput>;
  OR?: InputMaybe<Array<RoomLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RoomLabelsNodeAggregationWhereInput>;
};

export type RoomLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type RoomLabelsConnection = {
  __typename?: 'RoomLabelsConnection';
  edges: Array<RoomLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoomLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type RoomLabelsConnectionWhere = {
  AND?: InputMaybe<Array<RoomLabelsConnectionWhere>>;
  NOT?: InputMaybe<RoomLabelsConnectionWhere>;
  OR?: InputMaybe<Array<RoomLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type RoomLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type RoomLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<RoomLabelsConnectionWhere>;
};

export type RoomLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<RoomLabelsConnectionWhere>;
};

export type RoomLabelsFieldInput = {
  connect?: InputMaybe<Array<RoomLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<RoomLabelsCreateFieldInput>>;
};

export type RoomLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoomLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoomLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoomLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RoomLabelsRelationship = {
  __typename?: 'RoomLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type RoomLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type RoomLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<RoomLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<RoomLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<RoomLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RoomLabelsDisconnectFieldInput>>;
  update?: InputMaybe<RoomLabelsUpdateConnectionInput>;
  where?: InputMaybe<RoomLabelsConnectionWhere>;
};

export type RoomLessonsAggregateInput = {
  AND?: InputMaybe<Array<RoomLessonsAggregateInput>>;
  NOT?: InputMaybe<RoomLessonsAggregateInput>;
  OR?: InputMaybe<Array<RoomLessonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<RoomLessonsNodeAggregationWhereInput>;
};

export type RoomLessonsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonConnectInput>>;
  edge: LessonRoomRelationshipPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type RoomLessonsConnectOrCreateFieldInput = {
  onCreate: RoomLessonsConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type RoomLessonsConnectOrCreateFieldInputOnCreate = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: LessonOnCreateInput;
};

export type RoomLessonsConnection = {
  __typename?: 'RoomLessonsConnection';
  edges: Array<RoomLessonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoomLessonsConnectionSort = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesSort>;
  node?: InputMaybe<LessonSort>;
};

export type RoomLessonsConnectionWhere = {
  AND?: InputMaybe<Array<RoomLessonsConnectionWhere>>;
  NOT?: InputMaybe<RoomLessonsConnectionWhere>;
  OR?: InputMaybe<Array<RoomLessonsConnectionWhere>>;
  edge?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<LessonRoomRelationshipPropertiesWhere>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type RoomLessonsCreateFieldInput = {
  edge: LessonRoomRelationshipPropertiesCreateInput;
  node: LessonCreateInput;
};

export type RoomLessonsDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<RoomLessonsConnectionWhere>;
};

export type RoomLessonsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<RoomLessonsConnectionWhere>;
};

export type RoomLessonsFieldInput = {
  connect?: InputMaybe<Array<RoomLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoomLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoomLessonsCreateFieldInput>>;
};

export type RoomLessonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoomLessonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoomLessonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoomLessonsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RoomLessonsRelationship = {
  __typename?: 'RoomLessonsRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
  properties: LessonRoomRelationshipProperties;
};

export type RoomLessonsUpdateConnectionInput = {
  edge?: InputMaybe<LessonRoomRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<LessonUpdateInput>;
};

export type RoomLessonsUpdateFieldInput = {
  connect?: InputMaybe<Array<RoomLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoomLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoomLessonsCreateFieldInput>>;
  delete?: InputMaybe<Array<RoomLessonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RoomLessonsDisconnectFieldInput>>;
  update?: InputMaybe<RoomLessonsUpdateConnectionInput>;
  where?: InputMaybe<RoomLessonsConnectionWhere>;
};

export type RoomOnCreateInput = {
  barrierFree?: InputMaybe<Scalars['Boolean']['input']>;
  canBeDarkened?: InputMaybe<Scalars['Boolean']['input']>;
  canBeLeased?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  chairs?: InputMaybe<Scalars['Int']['input']>;
  classroom?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  hasMediaCabinet?: InputMaybe<Scalars['Boolean']['input']>;
  hasPiano?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjector?: InputMaybe<Scalars['Boolean']['input']>;
  hasScreen?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  otherInventory?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tables?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RoomOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RoomSort objects to sort Rooms by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RoomSort>>;
};

export type RoomOrganizationAggregateInput = {
  AND?: InputMaybe<Array<RoomOrganizationAggregateInput>>;
  NOT?: InputMaybe<RoomOrganizationAggregateInput>;
  OR?: InputMaybe<Array<RoomOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RoomOrganizationNodeAggregationWhereInput>;
};

export type RoomOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type RoomOrganizationConnectOrCreateFieldInput = {
  onCreate: RoomOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type RoomOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type RoomOrganizationConnection = {
  __typename?: 'RoomOrganizationConnection';
  edges: Array<RoomOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoomOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type RoomOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<RoomOrganizationConnectionWhere>>;
  NOT?: InputMaybe<RoomOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<RoomOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type RoomOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type RoomOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<RoomOrganizationConnectionWhere>;
};

export type RoomOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<RoomOrganizationConnectionWhere>;
};

export type RoomOrganizationFieldInput = {
  connect?: InputMaybe<RoomOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<RoomOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<RoomOrganizationCreateFieldInput>;
};

export type RoomOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoomOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoomOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoomOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RoomOrganizationRelationship = {
  __typename?: 'RoomOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type RoomOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type RoomOrganizationUpdateFieldInput = {
  connect?: InputMaybe<RoomOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<RoomOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<RoomOrganizationCreateFieldInput>;
  delete?: InputMaybe<RoomOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<RoomOrganizationDisconnectFieldInput>;
  update?: InputMaybe<RoomOrganizationUpdateConnectionInput>;
  where?: InputMaybe<RoomOrganizationConnectionWhere>;
};

export type RoomResponsiblePersonsAggregateInput = {
  AND?: InputMaybe<Array<RoomResponsiblePersonsAggregateInput>>;
  NOT?: InputMaybe<RoomResponsiblePersonsAggregateInput>;
  OR?: InputMaybe<Array<RoomResponsiblePersonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<RoomResponsiblePersonsNodeAggregationWhereInput>;
};

export type RoomResponsiblePersonsConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type RoomResponsiblePersonsConnectOrCreateFieldInput = {
  onCreate: RoomResponsiblePersonsConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type RoomResponsiblePersonsConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: PersonOnCreateInput;
};

export type RoomResponsiblePersonsConnection = {
  __typename?: 'RoomResponsiblePersonsConnection';
  edges: Array<RoomResponsiblePersonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoomResponsiblePersonsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<PersonSort>;
};

export type RoomResponsiblePersonsConnectionWhere = {
  AND?: InputMaybe<Array<RoomResponsiblePersonsConnectionWhere>>;
  NOT?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
  OR?: InputMaybe<Array<RoomResponsiblePersonsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type RoomResponsiblePersonsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: PersonCreateInput;
};

export type RoomResponsiblePersonsDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
};

export type RoomResponsiblePersonsDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
};

export type RoomResponsiblePersonsFieldInput = {
  connect?: InputMaybe<Array<RoomResponsiblePersonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoomResponsiblePersonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoomResponsiblePersonsCreateFieldInput>>;
};

export type RoomResponsiblePersonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoomResponsiblePersonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoomResponsiblePersonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoomResponsiblePersonsNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RoomResponsiblePersonsRelationship = {
  __typename?: 'RoomResponsiblePersonsRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: OrderedRelationProperties;
};

export type RoomResponsiblePersonsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<PersonUpdateInput>;
};

export type RoomResponsiblePersonsUpdateFieldInput = {
  connect?: InputMaybe<Array<RoomResponsiblePersonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoomResponsiblePersonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoomResponsiblePersonsCreateFieldInput>>;
  delete?: InputMaybe<Array<RoomResponsiblePersonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RoomResponsiblePersonsDisconnectFieldInput>>;
  update?: InputMaybe<RoomResponsiblePersonsUpdateConnectionInput>;
  where?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
};

/** Fields to sort Rooms by. The order in which sorts are applied is not guaranteed when specifying many fields in one RoomSort object. */
export type RoomSort = {
  barrierFree?: InputMaybe<SortDirection>;
  canBeDarkened?: InputMaybe<SortDirection>;
  canBeLeased?: InputMaybe<SortDirection>;
  capacity?: InputMaybe<SortDirection>;
  chairs?: InputMaybe<SortDirection>;
  classroom?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  hasMediaCabinet?: InputMaybe<SortDirection>;
  hasPiano?: InputMaybe<SortDirection>;
  hasProjector?: InputMaybe<SortDirection>;
  hasScreen?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  otherInventory?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  roomNumber?: InputMaybe<SortDirection>;
  size?: InputMaybe<SortDirection>;
  tables?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type RoomUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type RoomUpdateInput = {
  barrierFree?: InputMaybe<Scalars['Boolean']['input']>;
  building?: InputMaybe<RoomBuildingUpdateFieldInput>;
  canBeDarkened?: InputMaybe<Scalars['Boolean']['input']>;
  canBeLeased?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  capacity_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  capacity_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  chairs?: InputMaybe<Scalars['Int']['input']>;
  chairs_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  chairs_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  classroom?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curricula?: InputMaybe<Array<RoomCurriculaUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Array<RoomEventsUpdateFieldInput>>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  hasMediaCabinet?: InputMaybe<Scalars['Boolean']['input']>;
  hasPiano?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjector?: InputMaybe<Scalars['Boolean']['input']>;
  hasScreen?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<RoomLabelsUpdateFieldInput>>;
  lessons?: InputMaybe<Array<RoomLessonsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<RoomOrganizationUpdateFieldInput>;
  otherInventory?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  responsiblePersons?: InputMaybe<Array<RoomResponsiblePersonsUpdateFieldInput>>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  size_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  tables?: InputMaybe<Scalars['Int']['input']>;
  tables_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  tables_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type RoomWhere = {
  AND?: InputMaybe<Array<RoomWhere>>;
  NOT?: InputMaybe<RoomWhere>;
  OR?: InputMaybe<Array<RoomWhere>>;
  barrierFree?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  barrierFree_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  building?: InputMaybe<BuildingWhere>;
  buildingAggregate?: InputMaybe<RoomBuildingAggregateInput>;
  buildingConnection?: InputMaybe<RoomBuildingConnectionWhere>;
  buildingConnection_NOT?: InputMaybe<RoomBuildingConnectionWhere>;
  building_NOT?: InputMaybe<BuildingWhere>;
  canBeDarkened?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  canBeDarkened_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  canBeLeased?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  canBeLeased_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  capacity_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  capacity_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  capacity_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  capacity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  chairs?: InputMaybe<Scalars['Int']['input']>;
  chairs_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  chairs_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  chairs_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  chairs_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  classroom?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  classroom_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `curricula_SOME` instead. */
  curricula?: InputMaybe<CurriculumWhere>;
  curriculaAggregate?: InputMaybe<RoomCurriculaAggregateInput>;
  /** @deprecated Use `curriculaConnection_SOME` instead. */
  curriculaConnection?: InputMaybe<RoomCurriculaConnectionWhere>;
  /** Return Rooms where all of the related RoomCurriculaConnections match this filter */
  curriculaConnection_ALL?: InputMaybe<RoomCurriculaConnectionWhere>;
  /** Return Rooms where none of the related RoomCurriculaConnections match this filter */
  curriculaConnection_NONE?: InputMaybe<RoomCurriculaConnectionWhere>;
  /** @deprecated Use `curriculaConnection_NONE` instead. */
  curriculaConnection_NOT?: InputMaybe<RoomCurriculaConnectionWhere>;
  /** Return Rooms where one of the related RoomCurriculaConnections match this filter */
  curriculaConnection_SINGLE?: InputMaybe<RoomCurriculaConnectionWhere>;
  /** Return Rooms where some of the related RoomCurriculaConnections match this filter */
  curriculaConnection_SOME?: InputMaybe<RoomCurriculaConnectionWhere>;
  /** Return Rooms where all of the related Curricula match this filter */
  curricula_ALL?: InputMaybe<CurriculumWhere>;
  /** Return Rooms where none of the related Curricula match this filter */
  curricula_NONE?: InputMaybe<CurriculumWhere>;
  /** @deprecated Use `curricula_NONE` instead. */
  curricula_NOT?: InputMaybe<CurriculumWhere>;
  /** Return Rooms where one of the related Curricula match this filter */
  curricula_SINGLE?: InputMaybe<CurriculumWhere>;
  /** Return Rooms where some of the related Curricula match this filter */
  curricula_SOME?: InputMaybe<CurriculumWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<RoomEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<RoomEventsConnectionWhere>;
  /** Return Rooms where all of the related RoomEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<RoomEventsConnectionWhere>;
  /** Return Rooms where none of the related RoomEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<RoomEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<RoomEventsConnectionWhere>;
  /** Return Rooms where one of the related RoomEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<RoomEventsConnectionWhere>;
  /** Return Rooms where some of the related RoomEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<RoomEventsConnectionWhere>;
  /** Return Rooms where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return Rooms where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return Rooms where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return Rooms where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasMediaCabinet?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hasMediaCabinet_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  hasPiano?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hasPiano_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  hasProjector?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hasProjector_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  hasScreen?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hasScreen_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<RoomLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<RoomLabelsConnectionWhere>;
  /** Return Rooms where all of the related RoomLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<RoomLabelsConnectionWhere>;
  /** Return Rooms where none of the related RoomLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<RoomLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<RoomLabelsConnectionWhere>;
  /** Return Rooms where one of the related RoomLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<RoomLabelsConnectionWhere>;
  /** Return Rooms where some of the related RoomLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<RoomLabelsConnectionWhere>;
  /** Return Rooms where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Rooms where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Rooms where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Rooms where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  /** @deprecated Use `lessons_SOME` instead. */
  lessons?: InputMaybe<LessonWhere>;
  lessonsAggregate?: InputMaybe<RoomLessonsAggregateInput>;
  /** @deprecated Use `lessonsConnection_SOME` instead. */
  lessonsConnection?: InputMaybe<RoomLessonsConnectionWhere>;
  /** Return Rooms where all of the related RoomLessonsConnections match this filter */
  lessonsConnection_ALL?: InputMaybe<RoomLessonsConnectionWhere>;
  /** Return Rooms where none of the related RoomLessonsConnections match this filter */
  lessonsConnection_NONE?: InputMaybe<RoomLessonsConnectionWhere>;
  /** @deprecated Use `lessonsConnection_NONE` instead. */
  lessonsConnection_NOT?: InputMaybe<RoomLessonsConnectionWhere>;
  /** Return Rooms where one of the related RoomLessonsConnections match this filter */
  lessonsConnection_SINGLE?: InputMaybe<RoomLessonsConnectionWhere>;
  /** Return Rooms where some of the related RoomLessonsConnections match this filter */
  lessonsConnection_SOME?: InputMaybe<RoomLessonsConnectionWhere>;
  /** Return Rooms where all of the related Lessons match this filter */
  lessons_ALL?: InputMaybe<LessonWhere>;
  /** Return Rooms where none of the related Lessons match this filter */
  lessons_NONE?: InputMaybe<LessonWhere>;
  /** @deprecated Use `lessons_NONE` instead. */
  lessons_NOT?: InputMaybe<LessonWhere>;
  /** Return Rooms where one of the related Lessons match this filter */
  lessons_SINGLE?: InputMaybe<LessonWhere>;
  /** Return Rooms where some of the related Lessons match this filter */
  lessons_SOME?: InputMaybe<LessonWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<RoomOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<RoomOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<RoomOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  otherInventory?: InputMaybe<Scalars['String']['input']>;
  otherInventory_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  otherInventory_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherInventory_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherInventory_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherInventory_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherInventory_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherInventory_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  otherInventory_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  otherInventory_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  position_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  position_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  position_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  position_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  position_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  position_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  position_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  position_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `responsiblePersons_SOME` instead. */
  responsiblePersons?: InputMaybe<PersonWhere>;
  responsiblePersonsAggregate?: InputMaybe<RoomResponsiblePersonsAggregateInput>;
  /** @deprecated Use `responsiblePersonsConnection_SOME` instead. */
  responsiblePersonsConnection?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
  /** Return Rooms where all of the related RoomResponsiblePersonsConnections match this filter */
  responsiblePersonsConnection_ALL?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
  /** Return Rooms where none of the related RoomResponsiblePersonsConnections match this filter */
  responsiblePersonsConnection_NONE?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
  /** @deprecated Use `responsiblePersonsConnection_NONE` instead. */
  responsiblePersonsConnection_NOT?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
  /** Return Rooms where one of the related RoomResponsiblePersonsConnections match this filter */
  responsiblePersonsConnection_SINGLE?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
  /** Return Rooms where some of the related RoomResponsiblePersonsConnections match this filter */
  responsiblePersonsConnection_SOME?: InputMaybe<RoomResponsiblePersonsConnectionWhere>;
  /** Return Rooms where all of the related People match this filter */
  responsiblePersons_ALL?: InputMaybe<PersonWhere>;
  /** Return Rooms where none of the related People match this filter */
  responsiblePersons_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `responsiblePersons_NONE` instead. */
  responsiblePersons_NOT?: InputMaybe<PersonWhere>;
  /** Return Rooms where one of the related People match this filter */
  responsiblePersons_SINGLE?: InputMaybe<PersonWhere>;
  /** Return Rooms where some of the related People match this filter */
  responsiblePersons_SOME?: InputMaybe<PersonWhere>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  roomNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  roomNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  roomNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roomNumber_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roomNumber_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roomNumber_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roomNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  roomNumber_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  roomNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_GT?: InputMaybe<Scalars['Int']['input']>;
  size_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_LT?: InputMaybe<Scalars['Int']['input']>;
  size_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  size_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  size_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tables?: InputMaybe<Scalars['Int']['input']>;
  tables_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tables_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tables_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tables_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type RoomsConnection = {
  __typename?: 'RoomsConnection';
  edges: Array<RoomEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolEvent = {
  __typename?: 'SchoolEvent';
  canceled: Scalars['Boolean']['output'];
  classesOrGroups: Array<SchoolEventClassOrGroup>;
  comment?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  groupClassNames: Scalars['String']['output'];
  groupClassNamesLong: Scalars['String']['output'];
  isClassTrip: Scalars['Boolean']['output'];
  isClassbookRelevant: Scalars['Boolean']['output'];
  isSchoolEvent: Scalars['Boolean']['output'];
  persons: Array<MinimalPerson>;
  print: Scalars['Boolean']['output'];
  recurrenceUuid?: Maybe<Scalars['String']['output']>;
  rooms: Array<MinimalRoom>;
  start: Scalars['DateTime']['output'];
  subject: MinimalSubject;
  uuid: Scalars['ID']['output'];
};

export type SchoolEventClassOrGroup = MinimalClass | MinimalGroup;

export type SchoolEventClassOrGroupWhere = {
  MinimalClass?: InputMaybe<MinimalClassWhere>;
  MinimalGroup?: InputMaybe<MinimalGroupWhere>;
};

export type SchoolEventCreateInput = {
  classes?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  groups?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClassbookRelevant: Scalars['Boolean']['input'];
  isSchoolEvent: Scalars['Boolean']['input'];
  persons?: InputMaybe<Array<Scalars['ID']['input']>>;
  rooms?: InputMaybe<Array<Scalars['ID']['input']>>;
  start: Scalars['DateTime']['input'];
  subject: Scalars['ID']['input'];
};

export type SchoolEventUpdateInput = {
  canceled?: InputMaybe<Scalars['Boolean']['input']>;
  classes?: InputMaybe<ConnectDisconnectInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  groups?: InputMaybe<ConnectDisconnectInput>;
  isClassbookRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  persons?: InputMaybe<PersonConnectDisconnectInput>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  printUpdatedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  rooms?: InputMaybe<ConnectDisconnectInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['ID']['input']>;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  substitutionReason?: InputMaybe<SubstitutionReason>;
};

export type SchoolYear = {
  __typename?: 'SchoolYear';
  additionalTeachingLoads: Array<AdditionalTeachingLoad>;
  additionalTeachingLoadsConnection: SchoolYearAdditionalTeachingLoadsConnection;
  classes: Array<Class>;
  classesConnection: SchoolYearClassesConnection;
  costPerHour?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  end: Scalars['Date']['output'];
  fullTimeHours?: Maybe<Scalars['Float']['output']>;
  holidays: Array<Holiday>;
  labels: Array<Label>;
  labelsConnection: SchoolYearLabelsConnection;
  lessons: Array<Lesson>;
  lessonsConnection: SchoolYearLessonsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: SchoolYearOrganizationConnection;
  shortName: Scalars['String']['output'];
  start: Scalars['Date']['output'];
  teachingBlocks: Array<TeachingBlock>;
  teachingBlocksConnection: SchoolYearTeachingBlocksConnection;
  teachingLoadFactors: Array<TeachingLoadFactor>;
  teachingLoadFactorsConnection: SchoolYearTeachingLoadFactorsConnection;
  timetableBlocks: Array<TimetableBlock>;
  timetableBlocksConnection: SchoolYearTimetableBlocksConnection;
  timetables: Array<Timetable>;
  timetablesConnection: SchoolYearTimetablesConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type SchoolYearAdditionalTeachingLoadsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AdditionalTeachingLoadOptions>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type SchoolYearAdditionalTeachingLoadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsConnectionSort>>;
  where?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
};

export type SchoolYearClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type SchoolYearClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearClassesConnectionSort>>;
  where?: InputMaybe<SchoolYearClassesConnectionWhere>;
};

export type SchoolYearLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type SchoolYearLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearLabelsConnectionSort>>;
  where?: InputMaybe<SchoolYearLabelsConnectionWhere>;
};

export type SchoolYearLessonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type SchoolYearLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearLessonsConnectionSort>>;
  where?: InputMaybe<SchoolYearLessonsConnectionWhere>;
};

export type SchoolYearOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type SchoolYearOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearOrganizationConnectionSort>>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

export type SchoolYearTeachingBlocksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockOptions>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type SchoolYearTeachingBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearTeachingBlocksConnectionSort>>;
  where?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
};

export type SchoolYearTeachingLoadFactorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingLoadFactorOptions>;
  where?: InputMaybe<TeachingLoadFactorWhere>;
};

export type SchoolYearTeachingLoadFactorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectionSort>>;
  where?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
};

export type SchoolYearTimetableBlocksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableBlockOptions>;
  where?: InputMaybe<TimetableBlockWhere>;
};

export type SchoolYearTimetableBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearTimetableBlocksConnectionSort>>;
  where?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
};

export type SchoolYearTimetablesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableOptions>;
  where?: InputMaybe<TimetableWhere>;
};

export type SchoolYearTimetablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolYearTimetablesConnectionSort>>;
  where?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
};

export type SchoolYearAdditionalTeachingLoadsAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsAggregateInput>>;
  NOT?: InputMaybe<SchoolYearAdditionalTeachingLoadsAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearAdditionalTeachingLoadsNodeAggregationWhereInput>;
};

export type SchoolYearAdditionalTeachingLoadsConnectFieldInput = {
  connect?: InputMaybe<Array<AdditionalTeachingLoadConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AdditionalTeachingLoadConnectWhere>;
};

export type SchoolYearAdditionalTeachingLoadsConnection = {
  __typename?: 'SchoolYearAdditionalTeachingLoadsConnection';
  edges: Array<SchoolYearAdditionalTeachingLoadsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearAdditionalTeachingLoadsConnectionSort = {
  node?: InputMaybe<AdditionalTeachingLoadSort>;
};

export type SchoolYearAdditionalTeachingLoadsConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsConnectionWhere>>;
  node?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type SchoolYearAdditionalTeachingLoadsCreateFieldInput = {
  node: AdditionalTeachingLoadCreateInput;
};

export type SchoolYearAdditionalTeachingLoadsDeleteFieldInput = {
  delete?: InputMaybe<AdditionalTeachingLoadDeleteInput>;
  where?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
};

export type SchoolYearAdditionalTeachingLoadsDisconnectFieldInput = {
  disconnect?: InputMaybe<AdditionalTeachingLoadDisconnectInput>;
  where?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
};

export type SchoolYearAdditionalTeachingLoadsFieldInput = {
  connect?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsCreateFieldInput>>;
};

export type SchoolYearAdditionalTeachingLoadsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearAdditionalTeachingLoadsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type SchoolYearAdditionalTeachingLoadsRelationship = {
  __typename?: 'SchoolYearAdditionalTeachingLoadsRelationship';
  cursor: Scalars['String']['output'];
  node: AdditionalTeachingLoad;
};

export type SchoolYearAdditionalTeachingLoadsUpdateConnectionInput = {
  node?: InputMaybe<AdditionalTeachingLoadUpdateInput>;
};

export type SchoolYearAdditionalTeachingLoadsUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearAdditionalTeachingLoadsUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
};

export type SchoolYearAggregateSelection = {
  __typename?: 'SchoolYearAggregateSelection';
  costPerHour: FloatAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  fullTimeHours: FloatAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SchoolYearClassesAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearClassesAggregateInput>>;
  NOT?: InputMaybe<SchoolYearClassesAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearClassesNodeAggregationWhereInput>;
};

export type SchoolYearClassesConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type SchoolYearClassesConnectOrCreateFieldInput = {
  onCreate: SchoolYearClassesConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type SchoolYearClassesConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type SchoolYearClassesConnection = {
  __typename?: 'SchoolYearClassesConnection';
  edges: Array<SchoolYearClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearClassesConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type SchoolYearClassesConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearClassesConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearClassesConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearClassesConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type SchoolYearClassesCreateFieldInput = {
  node: ClassCreateInput;
};

export type SchoolYearClassesDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<SchoolYearClassesConnectionWhere>;
};

export type SchoolYearClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<SchoolYearClassesConnectionWhere>;
};

export type SchoolYearClassesFieldInput = {
  connect?: InputMaybe<Array<SchoolYearClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearClassesCreateFieldInput>>;
};

export type SchoolYearClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearClassesNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearClassesRelationship = {
  __typename?: 'SchoolYearClassesRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type SchoolYearClassesUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type SchoolYearClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearClassesDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearClassesUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearClassesConnectionWhere>;
};

export type SchoolYearConnectInput = {
  additionalTeachingLoads?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsConnectFieldInput>>;
  classes?: InputMaybe<Array<SchoolYearClassesConnectFieldInput>>;
  labels?: InputMaybe<Array<SchoolYearLabelsConnectFieldInput>>;
  lessons?: InputMaybe<Array<SchoolYearLessonsConnectFieldInput>>;
  organization?: InputMaybe<SchoolYearOrganizationConnectFieldInput>;
  teachingBlocks?: InputMaybe<Array<SchoolYearTeachingBlocksConnectFieldInput>>;
  teachingLoadFactors?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectFieldInput>>;
  timetableBlocks?: InputMaybe<Array<SchoolYearTimetableBlocksConnectFieldInput>>;
  timetables?: InputMaybe<Array<SchoolYearTimetablesConnectFieldInput>>;
};

export type SchoolYearConnectWhere = {
  node: SchoolYearWhere;
};

export type SchoolYearCreateInput = {
  additionalTeachingLoads?: InputMaybe<SchoolYearAdditionalTeachingLoadsFieldInput>;
  classes?: InputMaybe<SchoolYearClassesFieldInput>;
  costPerHour?: InputMaybe<Scalars['Float']['input']>;
  end: Scalars['Date']['input'];
  fullTimeHours?: InputMaybe<Scalars['Float']['input']>;
  labels?: InputMaybe<SchoolYearLabelsFieldInput>;
  lessons?: InputMaybe<SchoolYearLessonsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<SchoolYearOrganizationFieldInput>;
  shortName: Scalars['String']['input'];
  start: Scalars['Date']['input'];
  teachingBlocks?: InputMaybe<SchoolYearTeachingBlocksFieldInput>;
  teachingLoadFactors?: InputMaybe<SchoolYearTeachingLoadFactorsFieldInput>;
  timetableBlocks?: InputMaybe<SchoolYearTimetableBlocksFieldInput>;
  timetables?: InputMaybe<SchoolYearTimetablesFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearDeleteInput = {
  additionalTeachingLoads?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsDeleteFieldInput>>;
  classes?: InputMaybe<Array<SchoolYearClassesDeleteFieldInput>>;
  labels?: InputMaybe<Array<SchoolYearLabelsDeleteFieldInput>>;
  lessons?: InputMaybe<Array<SchoolYearLessonsDeleteFieldInput>>;
  organization?: InputMaybe<SchoolYearOrganizationDeleteFieldInput>;
  teachingBlocks?: InputMaybe<Array<SchoolYearTeachingBlocksDeleteFieldInput>>;
  teachingLoadFactors?: InputMaybe<Array<SchoolYearTeachingLoadFactorsDeleteFieldInput>>;
  timetableBlocks?: InputMaybe<Array<SchoolYearTimetableBlocksDeleteFieldInput>>;
  timetables?: InputMaybe<Array<SchoolYearTimetablesDeleteFieldInput>>;
};

export type SchoolYearDisconnectInput = {
  additionalTeachingLoads?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsDisconnectFieldInput>>;
  classes?: InputMaybe<Array<SchoolYearClassesDisconnectFieldInput>>;
  labels?: InputMaybe<Array<SchoolYearLabelsDisconnectFieldInput>>;
  lessons?: InputMaybe<Array<SchoolYearLessonsDisconnectFieldInput>>;
  organization?: InputMaybe<SchoolYearOrganizationDisconnectFieldInput>;
  teachingBlocks?: InputMaybe<Array<SchoolYearTeachingBlocksDisconnectFieldInput>>;
  teachingLoadFactors?: InputMaybe<Array<SchoolYearTeachingLoadFactorsDisconnectFieldInput>>;
  timetableBlocks?: InputMaybe<Array<SchoolYearTimetableBlocksDisconnectFieldInput>>;
  timetables?: InputMaybe<Array<SchoolYearTimetablesDisconnectFieldInput>>;
};

export type SchoolYearEdge = {
  __typename?: 'SchoolYearEdge';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type SchoolYearLabelsAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearLabelsAggregateInput>>;
  NOT?: InputMaybe<SchoolYearLabelsAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearLabelsNodeAggregationWhereInput>;
};

export type SchoolYearLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type SchoolYearLabelsConnection = {
  __typename?: 'SchoolYearLabelsConnection';
  edges: Array<SchoolYearLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type SchoolYearLabelsConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearLabelsConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearLabelsConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type SchoolYearLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type SchoolYearLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<SchoolYearLabelsConnectionWhere>;
};

export type SchoolYearLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<SchoolYearLabelsConnectionWhere>;
};

export type SchoolYearLabelsFieldInput = {
  connect?: InputMaybe<Array<SchoolYearLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SchoolYearLabelsCreateFieldInput>>;
};

export type SchoolYearLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearLabelsRelationship = {
  __typename?: 'SchoolYearLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type SchoolYearLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type SchoolYearLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SchoolYearLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearLabelsDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearLabelsUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearLabelsConnectionWhere>;
};

export type SchoolYearLessonsAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearLessonsAggregateInput>>;
  NOT?: InputMaybe<SchoolYearLessonsAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearLessonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearLessonsNodeAggregationWhereInput>;
};

export type SchoolYearLessonsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type SchoolYearLessonsConnectOrCreateFieldInput = {
  onCreate: SchoolYearLessonsConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type SchoolYearLessonsConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type SchoolYearLessonsConnection = {
  __typename?: 'SchoolYearLessonsConnection';
  edges: Array<SchoolYearLessonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearLessonsConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type SchoolYearLessonsConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearLessonsConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearLessonsConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearLessonsConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type SchoolYearLessonsCreateFieldInput = {
  node: LessonCreateInput;
};

export type SchoolYearLessonsDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<SchoolYearLessonsConnectionWhere>;
};

export type SchoolYearLessonsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<SchoolYearLessonsConnectionWhere>;
};

export type SchoolYearLessonsFieldInput = {
  connect?: InputMaybe<Array<SchoolYearLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearLessonsCreateFieldInput>>;
};

export type SchoolYearLessonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearLessonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearLessonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearLessonsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearLessonsRelationship = {
  __typename?: 'SchoolYearLessonsRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type SchoolYearLessonsUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type SchoolYearLessonsUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearLessonsCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearLessonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearLessonsDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearLessonsUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearLessonsConnectionWhere>;
};

export type SchoolYearOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SchoolYearSort objects to sort SchoolYears by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SchoolYearSort>>;
};

export type SchoolYearOrganizationAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearOrganizationAggregateInput>>;
  NOT?: InputMaybe<SchoolYearOrganizationAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearOrganizationNodeAggregationWhereInput>;
};

export type SchoolYearOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type SchoolYearOrganizationConnectOrCreateFieldInput = {
  onCreate: SchoolYearOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type SchoolYearOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type SchoolYearOrganizationConnection = {
  __typename?: 'SchoolYearOrganizationConnection';
  edges: Array<SchoolYearOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type SchoolYearOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearOrganizationConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type SchoolYearOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type SchoolYearOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

export type SchoolYearOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

export type SchoolYearOrganizationFieldInput = {
  connect?: InputMaybe<SchoolYearOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SchoolYearOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SchoolYearOrganizationCreateFieldInput>;
};

export type SchoolYearOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolYearOrganizationRelationship = {
  __typename?: 'SchoolYearOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type SchoolYearOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type SchoolYearOrganizationUpdateFieldInput = {
  connect?: InputMaybe<SchoolYearOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SchoolYearOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SchoolYearOrganizationCreateFieldInput>;
  delete?: InputMaybe<SchoolYearOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<SchoolYearOrganizationDisconnectFieldInput>;
  update?: InputMaybe<SchoolYearOrganizationUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
};

/** Fields to sort SchoolYears by. The order in which sorts are applied is not guaranteed when specifying many fields in one SchoolYearSort object. */
export type SchoolYearSort = {
  costPerHour?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  fullTimeHours?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SchoolYearTeachingBlocksAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearTeachingBlocksAggregateInput>>;
  NOT?: InputMaybe<SchoolYearTeachingBlocksAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearTeachingBlocksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearTeachingBlocksNodeAggregationWhereInput>;
};

export type SchoolYearTeachingBlocksConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockConnectWhere>;
};

export type SchoolYearTeachingBlocksConnectOrCreateFieldInput = {
  onCreate: SchoolYearTeachingBlocksConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockConnectOrCreateWhere;
};

export type SchoolYearTeachingBlocksConnectOrCreateFieldInputOnCreate = {
  node: TeachingBlockOnCreateInput;
};

export type SchoolYearTeachingBlocksConnection = {
  __typename?: 'SchoolYearTeachingBlocksConnection';
  edges: Array<SchoolYearTeachingBlocksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearTeachingBlocksConnectionSort = {
  node?: InputMaybe<TeachingBlockSort>;
};

export type SchoolYearTeachingBlocksConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearTeachingBlocksConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearTeachingBlocksConnectionWhere>>;
  node?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockWhere>;
};

export type SchoolYearTeachingBlocksCreateFieldInput = {
  node: TeachingBlockCreateInput;
};

export type SchoolYearTeachingBlocksDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockDeleteInput>;
  where?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
};

export type SchoolYearTeachingBlocksDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockDisconnectInput>;
  where?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
};

export type SchoolYearTeachingBlocksFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTeachingBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearTeachingBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTeachingBlocksCreateFieldInput>>;
};

export type SchoolYearTeachingBlocksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearTeachingBlocksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearTeachingBlocksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearTeachingBlocksNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearTeachingBlocksRelationship = {
  __typename?: 'SchoolYearTeachingBlocksRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlock;
};

export type SchoolYearTeachingBlocksUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockUpdateInput>;
};

export type SchoolYearTeachingBlocksUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTeachingBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearTeachingBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTeachingBlocksCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearTeachingBlocksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearTeachingBlocksDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearTeachingBlocksUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
};

export type SchoolYearTeachingLoadFactorsAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearTeachingLoadFactorsAggregateInput>>;
  NOT?: InputMaybe<SchoolYearTeachingLoadFactorsAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearTeachingLoadFactorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearTeachingLoadFactorsNodeAggregationWhereInput>;
};

export type SchoolYearTeachingLoadFactorsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingLoadFactorConnectWhere>;
};

export type SchoolYearTeachingLoadFactorsConnectOrCreateFieldInput = {
  onCreate: SchoolYearTeachingLoadFactorsConnectOrCreateFieldInputOnCreate;
  where: TeachingLoadFactorConnectOrCreateWhere;
};

export type SchoolYearTeachingLoadFactorsConnectOrCreateFieldInputOnCreate = {
  node: TeachingLoadFactorOnCreateInput;
};

export type SchoolYearTeachingLoadFactorsConnection = {
  __typename?: 'SchoolYearTeachingLoadFactorsConnection';
  edges: Array<SchoolYearTeachingLoadFactorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearTeachingLoadFactorsConnectionSort = {
  node?: InputMaybe<TeachingLoadFactorSort>;
};

export type SchoolYearTeachingLoadFactorsConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectionWhere>>;
  node?: InputMaybe<TeachingLoadFactorWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingLoadFactorWhere>;
};

export type SchoolYearTeachingLoadFactorsCreateFieldInput = {
  node: TeachingLoadFactorCreateInput;
};

export type SchoolYearTeachingLoadFactorsDeleteFieldInput = {
  delete?: InputMaybe<TeachingLoadFactorDeleteInput>;
  where?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
};

export type SchoolYearTeachingLoadFactorsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingLoadFactorDisconnectInput>;
  where?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
};

export type SchoolYearTeachingLoadFactorsFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTeachingLoadFactorsCreateFieldInput>>;
};

export type SchoolYearTeachingLoadFactorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearTeachingLoadFactorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearTeachingLoadFactorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearTeachingLoadFactorsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valuePartialRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valuePartial_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  valueRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  valueRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type SchoolYearTeachingLoadFactorsRelationship = {
  __typename?: 'SchoolYearTeachingLoadFactorsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingLoadFactor;
};

export type SchoolYearTeachingLoadFactorsUpdateConnectionInput = {
  node?: InputMaybe<TeachingLoadFactorUpdateInput>;
};

export type SchoolYearTeachingLoadFactorsUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearTeachingLoadFactorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTeachingLoadFactorsCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearTeachingLoadFactorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearTeachingLoadFactorsDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearTeachingLoadFactorsUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
};

export type SchoolYearTimetableBlocksAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearTimetableBlocksAggregateInput>>;
  NOT?: InputMaybe<SchoolYearTimetableBlocksAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearTimetableBlocksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearTimetableBlocksNodeAggregationWhereInput>;
};

export type SchoolYearTimetableBlocksConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableBlockConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableBlockConnectWhere>;
};

export type SchoolYearTimetableBlocksConnection = {
  __typename?: 'SchoolYearTimetableBlocksConnection';
  edges: Array<SchoolYearTimetableBlocksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearTimetableBlocksConnectionSort = {
  node?: InputMaybe<TimetableBlockSort>;
};

export type SchoolYearTimetableBlocksConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearTimetableBlocksConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearTimetableBlocksConnectionWhere>>;
  node?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableBlockWhere>;
};

export type SchoolYearTimetableBlocksCreateFieldInput = {
  node: TimetableBlockCreateInput;
};

export type SchoolYearTimetableBlocksDeleteFieldInput = {
  delete?: InputMaybe<TimetableBlockDeleteInput>;
  where?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
};

export type SchoolYearTimetableBlocksDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableBlockDisconnectInput>;
  where?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
};

export type SchoolYearTimetableBlocksFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTimetableBlocksConnectFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTimetableBlocksCreateFieldInput>>;
};

export type SchoolYearTimetableBlocksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearTimetableBlocksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearTimetableBlocksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearTimetableBlocksNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  teachingLoadCalculated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadFactor_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearTimetableBlocksRelationship = {
  __typename?: 'SchoolYearTimetableBlocksRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableBlock;
};

export type SchoolYearTimetableBlocksUpdateConnectionInput = {
  node?: InputMaybe<TimetableBlockUpdateInput>;
};

export type SchoolYearTimetableBlocksUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTimetableBlocksConnectFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTimetableBlocksCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearTimetableBlocksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearTimetableBlocksDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearTimetableBlocksUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
};

export type SchoolYearTimetablesAggregateInput = {
  AND?: InputMaybe<Array<SchoolYearTimetablesAggregateInput>>;
  NOT?: InputMaybe<SchoolYearTimetablesAggregateInput>;
  OR?: InputMaybe<Array<SchoolYearTimetablesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolYearTimetablesNodeAggregationWhereInput>;
};

export type SchoolYearTimetablesConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConnectWhere>;
};

export type SchoolYearTimetablesConnectOrCreateFieldInput = {
  onCreate: SchoolYearTimetablesConnectOrCreateFieldInputOnCreate;
  where: TimetableConnectOrCreateWhere;
};

export type SchoolYearTimetablesConnectOrCreateFieldInputOnCreate = {
  node: TimetableOnCreateInput;
};

export type SchoolYearTimetablesConnection = {
  __typename?: 'SchoolYearTimetablesConnection';
  edges: Array<SchoolYearTimetablesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolYearTimetablesConnectionSort = {
  node?: InputMaybe<TimetableSort>;
};

export type SchoolYearTimetablesConnectionWhere = {
  AND?: InputMaybe<Array<SchoolYearTimetablesConnectionWhere>>;
  NOT?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
  OR?: InputMaybe<Array<SchoolYearTimetablesConnectionWhere>>;
  node?: InputMaybe<TimetableWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableWhere>;
};

export type SchoolYearTimetablesCreateFieldInput = {
  node: TimetableCreateInput;
};

export type SchoolYearTimetablesDeleteFieldInput = {
  delete?: InputMaybe<TimetableDeleteInput>;
  where?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
};

export type SchoolYearTimetablesDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableDisconnectInput>;
  where?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
};

export type SchoolYearTimetablesFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTimetablesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearTimetablesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTimetablesCreateFieldInput>>;
};

export type SchoolYearTimetablesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolYearTimetablesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolYearTimetablesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolYearTimetablesNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolYearTimetablesRelationship = {
  __typename?: 'SchoolYearTimetablesRelationship';
  cursor: Scalars['String']['output'];
  node: Timetable;
};

export type SchoolYearTimetablesUpdateConnectionInput = {
  node?: InputMaybe<TimetableUpdateInput>;
};

export type SchoolYearTimetablesUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolYearTimetablesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolYearTimetablesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolYearTimetablesCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolYearTimetablesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolYearTimetablesDisconnectFieldInput>>;
  update?: InputMaybe<SchoolYearTimetablesUpdateConnectionInput>;
  where?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
};

export type SchoolYearUpdateInput = {
  additionalTeachingLoads?: InputMaybe<Array<SchoolYearAdditionalTeachingLoadsUpdateFieldInput>>;
  classes?: InputMaybe<Array<SchoolYearClassesUpdateFieldInput>>;
  costPerHour?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_ADD?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  fullTimeHours?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_ADD?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  labels?: InputMaybe<Array<SchoolYearLabelsUpdateFieldInput>>;
  lessons?: InputMaybe<Array<SchoolYearLessonsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<SchoolYearOrganizationUpdateFieldInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  teachingBlocks?: InputMaybe<Array<SchoolYearTeachingBlocksUpdateFieldInput>>;
  teachingLoadFactors?: InputMaybe<Array<SchoolYearTeachingLoadFactorsUpdateFieldInput>>;
  timetableBlocks?: InputMaybe<Array<SchoolYearTimetableBlocksUpdateFieldInput>>;
  timetables?: InputMaybe<Array<SchoolYearTimetablesUpdateFieldInput>>;
};

export type SchoolYearWhere = {
  AND?: InputMaybe<Array<SchoolYearWhere>>;
  NOT?: InputMaybe<SchoolYearWhere>;
  OR?: InputMaybe<Array<SchoolYearWhere>>;
  /** @deprecated Use `additionalTeachingLoads_SOME` instead. */
  additionalTeachingLoads?: InputMaybe<AdditionalTeachingLoadWhere>;
  additionalTeachingLoadsAggregate?: InputMaybe<SchoolYearAdditionalTeachingLoadsAggregateInput>;
  /** @deprecated Use `additionalTeachingLoadsConnection_SOME` instead. */
  additionalTeachingLoadsConnection?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_ALL?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_NONE?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
  /** @deprecated Use `additionalTeachingLoadsConnection_NONE` instead. */
  additionalTeachingLoadsConnection_NOT?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SINGLE?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SOME?: InputMaybe<SchoolYearAdditionalTeachingLoadsConnectionWhere>;
  /** Return SchoolYears where all of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_ALL?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return SchoolYears where none of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_NONE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Use `additionalTeachingLoads_NONE` instead. */
  additionalTeachingLoads_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return SchoolYears where one of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SINGLE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return SchoolYears where some of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SOME?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Use `classes_SOME` instead. */
  classes?: InputMaybe<ClassWhere>;
  classesAggregate?: InputMaybe<SchoolYearClassesAggregateInput>;
  /** @deprecated Use `classesConnection_SOME` instead. */
  classesConnection?: InputMaybe<SchoolYearClassesConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearClassesConnections match this filter */
  classesConnection_ALL?: InputMaybe<SchoolYearClassesConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearClassesConnections match this filter */
  classesConnection_NONE?: InputMaybe<SchoolYearClassesConnectionWhere>;
  /** @deprecated Use `classesConnection_NONE` instead. */
  classesConnection_NOT?: InputMaybe<SchoolYearClassesConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearClassesConnections match this filter */
  classesConnection_SINGLE?: InputMaybe<SchoolYearClassesConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearClassesConnections match this filter */
  classesConnection_SOME?: InputMaybe<SchoolYearClassesConnectionWhere>;
  /** Return SchoolYears where all of the related Classes match this filter */
  classes_ALL?: InputMaybe<ClassWhere>;
  /** Return SchoolYears where none of the related Classes match this filter */
  classes_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `classes_NONE` instead. */
  classes_NOT?: InputMaybe<ClassWhere>;
  /** Return SchoolYears where one of the related Classes match this filter */
  classes_SINGLE?: InputMaybe<ClassWhere>;
  /** Return SchoolYears where some of the related Classes match this filter */
  classes_SOME?: InputMaybe<ClassWhere>;
  costPerHour?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  costPerHour_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  costPerHour_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  costPerHour_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  end_GT?: InputMaybe<Scalars['Date']['input']>;
  end_GTE?: InputMaybe<Scalars['Date']['input']>;
  end_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  end_LT?: InputMaybe<Scalars['Date']['input']>;
  end_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  fullTimeHours?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  fullTimeHours_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullTimeHours_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fullTimeHours_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  holidays?: InputMaybe<HolidayWhere>;
  holidays_ALL?: InputMaybe<HolidayWhere>;
  holidays_NONE?: InputMaybe<HolidayWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  holidays_NOT?: InputMaybe<HolidayWhere>;
  holidays_SINGLE?: InputMaybe<HolidayWhere>;
  holidays_SOME?: InputMaybe<HolidayWhere>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<SchoolYearLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<SchoolYearLabelsConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<SchoolYearLabelsConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<SchoolYearLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<SchoolYearLabelsConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<SchoolYearLabelsConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<SchoolYearLabelsConnectionWhere>;
  /** Return SchoolYears where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return SchoolYears where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return SchoolYears where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return SchoolYears where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  /** @deprecated Use `lessons_SOME` instead. */
  lessons?: InputMaybe<LessonWhere>;
  lessonsAggregate?: InputMaybe<SchoolYearLessonsAggregateInput>;
  /** @deprecated Use `lessonsConnection_SOME` instead. */
  lessonsConnection?: InputMaybe<SchoolYearLessonsConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearLessonsConnections match this filter */
  lessonsConnection_ALL?: InputMaybe<SchoolYearLessonsConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearLessonsConnections match this filter */
  lessonsConnection_NONE?: InputMaybe<SchoolYearLessonsConnectionWhere>;
  /** @deprecated Use `lessonsConnection_NONE` instead. */
  lessonsConnection_NOT?: InputMaybe<SchoolYearLessonsConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearLessonsConnections match this filter */
  lessonsConnection_SINGLE?: InputMaybe<SchoolYearLessonsConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearLessonsConnections match this filter */
  lessonsConnection_SOME?: InputMaybe<SchoolYearLessonsConnectionWhere>;
  /** Return SchoolYears where all of the related Lessons match this filter */
  lessons_ALL?: InputMaybe<LessonWhere>;
  /** Return SchoolYears where none of the related Lessons match this filter */
  lessons_NONE?: InputMaybe<LessonWhere>;
  /** @deprecated Use `lessons_NONE` instead. */
  lessons_NOT?: InputMaybe<LessonWhere>;
  /** Return SchoolYears where one of the related Lessons match this filter */
  lessons_SINGLE?: InputMaybe<LessonWhere>;
  /** Return SchoolYears where some of the related Lessons match this filter */
  lessons_SOME?: InputMaybe<LessonWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<SchoolYearOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<SchoolYearOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  start_GT?: InputMaybe<Scalars['Date']['input']>;
  start_GTE?: InputMaybe<Scalars['Date']['input']>;
  start_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  start_LT?: InputMaybe<Scalars['Date']['input']>;
  start_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** @deprecated Use `teachingBlocks_SOME` instead. */
  teachingBlocks?: InputMaybe<TeachingBlockWhere>;
  teachingBlocksAggregate?: InputMaybe<SchoolYearTeachingBlocksAggregateInput>;
  /** @deprecated Use `teachingBlocksConnection_SOME` instead. */
  teachingBlocksConnection?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearTeachingBlocksConnections match this filter */
  teachingBlocksConnection_ALL?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearTeachingBlocksConnections match this filter */
  teachingBlocksConnection_NONE?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
  /** @deprecated Use `teachingBlocksConnection_NONE` instead. */
  teachingBlocksConnection_NOT?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearTeachingBlocksConnections match this filter */
  teachingBlocksConnection_SINGLE?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearTeachingBlocksConnections match this filter */
  teachingBlocksConnection_SOME?: InputMaybe<SchoolYearTeachingBlocksConnectionWhere>;
  /** Return SchoolYears where all of the related TeachingBlocks match this filter */
  teachingBlocks_ALL?: InputMaybe<TeachingBlockWhere>;
  /** Return SchoolYears where none of the related TeachingBlocks match this filter */
  teachingBlocks_NONE?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Use `teachingBlocks_NONE` instead. */
  teachingBlocks_NOT?: InputMaybe<TeachingBlockWhere>;
  /** Return SchoolYears where one of the related TeachingBlocks match this filter */
  teachingBlocks_SINGLE?: InputMaybe<TeachingBlockWhere>;
  /** Return SchoolYears where some of the related TeachingBlocks match this filter */
  teachingBlocks_SOME?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Use `teachingLoadFactors_SOME` instead. */
  teachingLoadFactors?: InputMaybe<TeachingLoadFactorWhere>;
  teachingLoadFactorsAggregate?: InputMaybe<SchoolYearTeachingLoadFactorsAggregateInput>;
  /** @deprecated Use `teachingLoadFactorsConnection_SOME` instead. */
  teachingLoadFactorsConnection?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearTeachingLoadFactorsConnections match this filter */
  teachingLoadFactorsConnection_ALL?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearTeachingLoadFactorsConnections match this filter */
  teachingLoadFactorsConnection_NONE?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
  /** @deprecated Use `teachingLoadFactorsConnection_NONE` instead. */
  teachingLoadFactorsConnection_NOT?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearTeachingLoadFactorsConnections match this filter */
  teachingLoadFactorsConnection_SINGLE?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearTeachingLoadFactorsConnections match this filter */
  teachingLoadFactorsConnection_SOME?: InputMaybe<SchoolYearTeachingLoadFactorsConnectionWhere>;
  /** Return SchoolYears where all of the related TeachingLoadFactors match this filter */
  teachingLoadFactors_ALL?: InputMaybe<TeachingLoadFactorWhere>;
  /** Return SchoolYears where none of the related TeachingLoadFactors match this filter */
  teachingLoadFactors_NONE?: InputMaybe<TeachingLoadFactorWhere>;
  /** @deprecated Use `teachingLoadFactors_NONE` instead. */
  teachingLoadFactors_NOT?: InputMaybe<TeachingLoadFactorWhere>;
  /** Return SchoolYears where one of the related TeachingLoadFactors match this filter */
  teachingLoadFactors_SINGLE?: InputMaybe<TeachingLoadFactorWhere>;
  /** Return SchoolYears where some of the related TeachingLoadFactors match this filter */
  teachingLoadFactors_SOME?: InputMaybe<TeachingLoadFactorWhere>;
  /** @deprecated Use `timetableBlocks_SOME` instead. */
  timetableBlocks?: InputMaybe<TimetableBlockWhere>;
  timetableBlocksAggregate?: InputMaybe<SchoolYearTimetableBlocksAggregateInput>;
  /** @deprecated Use `timetableBlocksConnection_SOME` instead. */
  timetableBlocksConnection?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearTimetableBlocksConnections match this filter */
  timetableBlocksConnection_ALL?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearTimetableBlocksConnections match this filter */
  timetableBlocksConnection_NONE?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
  /** @deprecated Use `timetableBlocksConnection_NONE` instead. */
  timetableBlocksConnection_NOT?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearTimetableBlocksConnections match this filter */
  timetableBlocksConnection_SINGLE?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearTimetableBlocksConnections match this filter */
  timetableBlocksConnection_SOME?: InputMaybe<SchoolYearTimetableBlocksConnectionWhere>;
  /** Return SchoolYears where all of the related TimetableBlocks match this filter */
  timetableBlocks_ALL?: InputMaybe<TimetableBlockWhere>;
  /** Return SchoolYears where none of the related TimetableBlocks match this filter */
  timetableBlocks_NONE?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Use `timetableBlocks_NONE` instead. */
  timetableBlocks_NOT?: InputMaybe<TimetableBlockWhere>;
  /** Return SchoolYears where one of the related TimetableBlocks match this filter */
  timetableBlocks_SINGLE?: InputMaybe<TimetableBlockWhere>;
  /** Return SchoolYears where some of the related TimetableBlocks match this filter */
  timetableBlocks_SOME?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Use `timetables_SOME` instead. */
  timetables?: InputMaybe<TimetableWhere>;
  timetablesAggregate?: InputMaybe<SchoolYearTimetablesAggregateInput>;
  /** @deprecated Use `timetablesConnection_SOME` instead. */
  timetablesConnection?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
  /** Return SchoolYears where all of the related SchoolYearTimetablesConnections match this filter */
  timetablesConnection_ALL?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
  /** Return SchoolYears where none of the related SchoolYearTimetablesConnections match this filter */
  timetablesConnection_NONE?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
  /** @deprecated Use `timetablesConnection_NONE` instead. */
  timetablesConnection_NOT?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
  /** Return SchoolYears where one of the related SchoolYearTimetablesConnections match this filter */
  timetablesConnection_SINGLE?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
  /** Return SchoolYears where some of the related SchoolYearTimetablesConnections match this filter */
  timetablesConnection_SOME?: InputMaybe<SchoolYearTimetablesConnectionWhere>;
  /** Return SchoolYears where all of the related Timetables match this filter */
  timetables_ALL?: InputMaybe<TimetableWhere>;
  /** Return SchoolYears where none of the related Timetables match this filter */
  timetables_NONE?: InputMaybe<TimetableWhere>;
  /** @deprecated Use `timetables_NONE` instead. */
  timetables_NOT?: InputMaybe<TimetableWhere>;
  /** Return SchoolYears where one of the related Timetables match this filter */
  timetables_SINGLE?: InputMaybe<TimetableWhere>;
  /** Return SchoolYears where some of the related Timetables match this filter */
  timetables_SOME?: InputMaybe<TimetableWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolYearsConnection = {
  __typename?: 'SchoolYearsConnection';
  edges: Array<SchoolYearEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SetCoveringTeachersInput = {
  givenSubstituteHours?: InputMaybe<Scalars['Float']['input']>;
  teacherUuid: Scalars['ID']['input'];
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC',
}

export type StringAggregateSelection = {
  __typename?: 'StringAggregateSelection';
  longest?: Maybe<Scalars['String']['output']>;
  shortest?: Maybe<Scalars['String']['output']>;
};

export type Subject = {
  __typename?: 'Subject';
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalTeachingLoads: Array<AdditionalTeachingLoad>;
  additionalTeachingLoadsAggregate?: Maybe<SubjectAdditionalTeachingLoadAdditionalTeachingLoadsAggregationSelection>;
  additionalTeachingLoadsConnection: SubjectAdditionalTeachingLoadsConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curricula: Array<Curriculum>;
  curriculaConnection: SubjectCurriculaConnection;
  defaultRooms: Array<Room>;
  defaultRoomsConnection: SubjectDefaultRoomsConnection;
  epochEnabled?: Maybe<Scalars['Boolean']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  labels: Array<Label>;
  labelsAggregate?: Maybe<SubjectLabelLabelsAggregationSelection>;
  labelsConnection: SubjectLabelsConnection;
  lessons: Array<Lesson>;
  lessonsAggregate?: Maybe<SubjectLessonLessonsAggregationSelection>;
  lessonsConnection: SubjectLessonsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: SubjectOrganizationConnection;
  other?: Maybe<Scalars['Boolean']['output']>;
  shortName: Scalars['String']['output'];
  subjectGroup?: Maybe<SubjectGroup>;
  subjectGroupConnection: SubjectSubjectGroupConnection;
  subjectHourEnabled?: Maybe<Scalars['Boolean']['output']>;
  timetableConfig?: Maybe<TimetableConfig>;
  timetableConfigConnection: SubjectTimetableConfigConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type SubjectAdditionalTeachingLoadsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AdditionalTeachingLoadOptions>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type SubjectAdditionalTeachingLoadsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type SubjectAdditionalTeachingLoadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectAdditionalTeachingLoadsConnectionSort>>;
  where?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
};

export type SubjectCurriculaArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumOptions>;
  where?: InputMaybe<CurriculumWhere>;
};

export type SubjectCurriculaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectCurriculaConnectionSort>>;
  where?: InputMaybe<SubjectCurriculaConnectionWhere>;
};

export type SubjectDefaultRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type SubjectDefaultRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectDefaultRoomsConnectionSort>>;
  where?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
};

export type SubjectLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type SubjectLabelsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LabelWhere>;
};

export type SubjectLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectLabelsConnectionSort>>;
  where?: InputMaybe<SubjectLabelsConnectionWhere>;
};

export type SubjectLessonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type SubjectLessonsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonWhere>;
};

export type SubjectLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectLessonsConnectionSort>>;
  where?: InputMaybe<SubjectLessonsConnectionWhere>;
};

export type SubjectOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type SubjectOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectOrganizationConnectionSort>>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

export type SubjectSubjectGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectGroupOptions>;
  where?: InputMaybe<SubjectGroupWhere>;
};

export type SubjectSubjectGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectSubjectGroupConnectionSort>>;
  where?: InputMaybe<SubjectSubjectGroupConnectionWhere>;
};

export type SubjectTimetableConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableConfigOptions>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type SubjectTimetableConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectTimetableConfigConnectionSort>>;
  where?: InputMaybe<SubjectTimetableConfigConnectionWhere>;
};

export type SubjectAdditionalTeachingLoadAdditionalTeachingLoadsAggregationSelection = {
  __typename?: 'SubjectAdditionalTeachingLoadAdditionalTeachingLoadsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubjectAdditionalTeachingLoadAdditionalTeachingLoadsNodeAggregateSelection>;
};

export type SubjectAdditionalTeachingLoadAdditionalTeachingLoadsNodeAggregateSelection = {
  __typename?: 'SubjectAdditionalTeachingLoadAdditionalTeachingLoadsNodeAggregateSelection';
  comment: StringAggregateSelection;
  hours: FloatAggregateSelection;
  hoursRaw: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectAdditionalTeachingLoadsAggregateInput = {
  AND?: InputMaybe<Array<SubjectAdditionalTeachingLoadsAggregateInput>>;
  NOT?: InputMaybe<SubjectAdditionalTeachingLoadsAggregateInput>;
  OR?: InputMaybe<Array<SubjectAdditionalTeachingLoadsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectAdditionalTeachingLoadsNodeAggregationWhereInput>;
};

export type SubjectAdditionalTeachingLoadsConnectFieldInput = {
  connect?: InputMaybe<Array<AdditionalTeachingLoadConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AdditionalTeachingLoadConnectWhere>;
};

export type SubjectAdditionalTeachingLoadsConnection = {
  __typename?: 'SubjectAdditionalTeachingLoadsConnection';
  edges: Array<SubjectAdditionalTeachingLoadsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectAdditionalTeachingLoadsConnectionSort = {
  node?: InputMaybe<AdditionalTeachingLoadSort>;
};

export type SubjectAdditionalTeachingLoadsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectAdditionalTeachingLoadsConnectionWhere>>;
  NOT?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectAdditionalTeachingLoadsConnectionWhere>>;
  node?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
};

export type SubjectAdditionalTeachingLoadsCreateFieldInput = {
  node: AdditionalTeachingLoadCreateInput;
};

export type SubjectAdditionalTeachingLoadsDeleteFieldInput = {
  delete?: InputMaybe<AdditionalTeachingLoadDeleteInput>;
  where?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
};

export type SubjectAdditionalTeachingLoadsDisconnectFieldInput = {
  disconnect?: InputMaybe<AdditionalTeachingLoadDisconnectInput>;
  where?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
};

export type SubjectAdditionalTeachingLoadsFieldInput = {
  connect?: InputMaybe<Array<SubjectAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectAdditionalTeachingLoadsCreateFieldInput>>;
};

export type SubjectAdditionalTeachingLoadsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectAdditionalTeachingLoadsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectAdditionalTeachingLoadsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  hoursRaw_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  hoursRaw_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  hours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  hours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type SubjectAdditionalTeachingLoadsRelationship = {
  __typename?: 'SubjectAdditionalTeachingLoadsRelationship';
  cursor: Scalars['String']['output'];
  node: AdditionalTeachingLoad;
};

export type SubjectAdditionalTeachingLoadsUpdateConnectionInput = {
  node?: InputMaybe<AdditionalTeachingLoadUpdateInput>;
};

export type SubjectAdditionalTeachingLoadsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectAdditionalTeachingLoadsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectAdditionalTeachingLoadsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectAdditionalTeachingLoadsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectAdditionalTeachingLoadsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectAdditionalTeachingLoadsUpdateConnectionInput>;
  where?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
};

export type SubjectAggregateSelection = {
  __typename?: 'SubjectAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectConnectInput = {
  additionalTeachingLoads?: InputMaybe<Array<SubjectAdditionalTeachingLoadsConnectFieldInput>>;
  curricula?: InputMaybe<Array<SubjectCurriculaConnectFieldInput>>;
  defaultRooms?: InputMaybe<Array<SubjectDefaultRoomsConnectFieldInput>>;
  labels?: InputMaybe<Array<SubjectLabelsConnectFieldInput>>;
  lessons?: InputMaybe<Array<SubjectLessonsConnectFieldInput>>;
  organization?: InputMaybe<SubjectOrganizationConnectFieldInput>;
  subjectGroup?: InputMaybe<SubjectSubjectGroupConnectFieldInput>;
  timetableConfig?: InputMaybe<SubjectTimetableConfigConnectFieldInput>;
};

export type SubjectConnectOrCreateWhere = {
  node: SubjectUniqueWhere;
};

export type SubjectConnectWhere = {
  node: SubjectWhere;
};

export type SubjectContainer = {
  __typename?: 'SubjectContainer';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  curricula: Array<Curriculum>;
  curriculaConnection: SubjectContainerCurriculaConnection;
  curriculumUnits: Array<CurriculumUnit>;
  curriculumUnitsAggregate?: Maybe<SubjectContainerCurriculumUnitCurriculumUnitsAggregationSelection>;
  curriculumUnitsConnection: SubjectContainerCurriculumUnitsConnection;
  foreignId?: Maybe<Scalars['String']['output']>;
  gradeGroup: Array<GradeGroup>;
  gradeGroupConnection: SubjectContainerGradeGroupConnection;
  grades: Array<Scalars['Int']['output']>;
  labels: Array<Label>;
  labelsConnection: SubjectContainerLabelsConnection;
  lessonUnits: Array<LessonUnit>;
  lessonUnitsAggregate?: Maybe<SubjectContainerLessonUnitLessonUnitsAggregationSelection>;
  lessonUnitsConnection: SubjectContainerLessonUnitsConnection;
  lessons: Array<Lesson>;
  lessonsConnection: SubjectContainerLessonsConnection;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  organization: Organization;
  organizationConnection: SubjectContainerOrganizationConnection;
  shortName: Scalars['String']['output'];
  teachingBlocks: Array<TeachingBlock>;
  teachingBlocksAggregate?: Maybe<SubjectContainerTeachingBlockTeachingBlocksAggregationSelection>;
  teachingBlocksConnection: SubjectContainerTeachingBlocksConnection;
  timetableConfig?: Maybe<TimetableConfig>;
  timetableConfigConnection: SubjectContainerTimetableConfigConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  validFrom?: Maybe<SchoolYear>;
  validFromConnection: SubjectContainerValidFromConnection;
  validUntil?: Maybe<SchoolYear>;
  validUntilConnection: SubjectContainerValidUntilConnection;
};

export type SubjectContainerCurriculaArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumOptions>;
  where?: InputMaybe<CurriculumWhere>;
};

export type SubjectContainerCurriculaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerCurriculaConnectionSort>>;
  where?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
};

export type SubjectContainerCurriculumUnitsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurriculumUnitOptions>;
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type SubjectContainerCurriculumUnitsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurriculumUnitWhere>;
};

export type SubjectContainerCurriculumUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerCurriculumUnitsConnectionSort>>;
  where?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
};

export type SubjectContainerGradeGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GradeGroupOptions>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type SubjectContainerGradeGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerGradeGroupConnectionSort>>;
  where?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
};

export type SubjectContainerLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type SubjectContainerLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerLabelsConnectionSort>>;
  where?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
};

export type SubjectContainerLessonUnitsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonUnitOptions>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type SubjectContainerLessonUnitsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonUnitWhere>;
};

export type SubjectContainerLessonUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerLessonUnitsConnectionSort>>;
  where?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
};

export type SubjectContainerLessonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type SubjectContainerLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerLessonsConnectionSort>>;
  where?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
};

export type SubjectContainerOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type SubjectContainerOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerOrganizationConnectionSort>>;
  where?: InputMaybe<SubjectContainerOrganizationConnectionWhere>;
};

export type SubjectContainerTeachingBlocksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockOptions>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type SubjectContainerTeachingBlocksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type SubjectContainerTeachingBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectionSort>>;
  where?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
};

export type SubjectContainerTimetableConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableConfigOptions>;
  where?: InputMaybe<TimetableConfigWhere>;
};

export type SubjectContainerTimetableConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerTimetableConfigConnectionSort>>;
  where?: InputMaybe<SubjectContainerTimetableConfigConnectionWhere>;
};

export type SubjectContainerValidFromArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type SubjectContainerValidFromConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerValidFromConnectionSort>>;
  where?: InputMaybe<SubjectContainerValidFromConnectionWhere>;
};

export type SubjectContainerValidUntilArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type SubjectContainerValidUntilConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectContainerValidUntilConnectionSort>>;
  where?: InputMaybe<SubjectContainerValidUntilConnectionWhere>;
};

export type SubjectContainerAggregateSelection = {
  __typename?: 'SubjectContainerAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectContainerConnectInput = {
  curricula?: InputMaybe<Array<SubjectContainerCurriculaConnectFieldInput>>;
  curriculumUnits?: InputMaybe<Array<SubjectContainerCurriculumUnitsConnectFieldInput>>;
  gradeGroup?: InputMaybe<Array<SubjectContainerGradeGroupConnectFieldInput>>;
  labels?: InputMaybe<Array<SubjectContainerLabelsConnectFieldInput>>;
  lessonUnits?: InputMaybe<Array<SubjectContainerLessonUnitsConnectFieldInput>>;
  lessons?: InputMaybe<Array<SubjectContainerLessonsConnectFieldInput>>;
  organization?: InputMaybe<SubjectContainerOrganizationConnectFieldInput>;
  teachingBlocks?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectFieldInput>>;
  timetableConfig?: InputMaybe<SubjectContainerTimetableConfigConnectFieldInput>;
  validFrom?: InputMaybe<SubjectContainerValidFromConnectFieldInput>;
  validUntil?: InputMaybe<SubjectContainerValidUntilConnectFieldInput>;
};

export type SubjectContainerConnectOrCreateWhere = {
  node: SubjectContainerUniqueWhere;
};

export type SubjectContainerConnectWhere = {
  node: SubjectContainerWhere;
};

export type SubjectContainerCreateInput = {
  curricula?: InputMaybe<SubjectContainerCurriculaFieldInput>;
  curriculumUnits?: InputMaybe<SubjectContainerCurriculumUnitsFieldInput>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  gradeGroup?: InputMaybe<SubjectContainerGradeGroupFieldInput>;
  grades: Array<Scalars['Int']['input']>;
  labels?: InputMaybe<SubjectContainerLabelsFieldInput>;
  lessonUnits?: InputMaybe<SubjectContainerLessonUnitsFieldInput>;
  lessons?: InputMaybe<SubjectContainerLessonsFieldInput>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<SubjectContainerOrganizationFieldInput>;
  shortName: Scalars['String']['input'];
  teachingBlocks?: InputMaybe<SubjectContainerTeachingBlocksFieldInput>;
  timetableConfig?: InputMaybe<SubjectContainerTimetableConfigFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validFrom?: InputMaybe<SubjectContainerValidFromFieldInput>;
  validUntil?: InputMaybe<SubjectContainerValidUntilFieldInput>;
};

export type SubjectContainerCurriculaAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerCurriculaAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerCurriculaAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerCurriculaAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerCurriculaNodeAggregationWhereInput>;
};

export type SubjectContainerCurriculaConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumConnectWhere>;
};

export type SubjectContainerCurriculaConnectOrCreateFieldInput = {
  onCreate: SubjectContainerCurriculaConnectOrCreateFieldInputOnCreate;
  where: CurriculumConnectOrCreateWhere;
};

export type SubjectContainerCurriculaConnectOrCreateFieldInputOnCreate = {
  node: CurriculumOnCreateInput;
};

export type SubjectContainerCurriculaConnection = {
  __typename?: 'SubjectContainerCurriculaConnection';
  edges: Array<SubjectContainerCurriculaRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerCurriculaConnectionSort = {
  node?: InputMaybe<CurriculumSort>;
};

export type SubjectContainerCurriculaConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerCurriculaConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerCurriculaConnectionWhere>>;
  node?: InputMaybe<CurriculumWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumWhere>;
};

export type SubjectContainerCurriculaCreateFieldInput = {
  node: CurriculumCreateInput;
};

export type SubjectContainerCurriculaDeleteFieldInput = {
  delete?: InputMaybe<CurriculumDeleteInput>;
  where?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
};

export type SubjectContainerCurriculaDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumDisconnectInput>;
  where?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
};

export type SubjectContainerCurriculaFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectContainerCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerCurriculaCreateFieldInput>>;
};

export type SubjectContainerCurriculaNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerCurriculaNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerCurriculaNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerCurriculaNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectContainerCurriculaRelationship = {
  __typename?: 'SubjectContainerCurriculaRelationship';
  cursor: Scalars['String']['output'];
  node: Curriculum;
};

export type SubjectContainerCurriculaUpdateConnectionInput = {
  node?: InputMaybe<CurriculumUpdateInput>;
};

export type SubjectContainerCurriculaUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectContainerCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerCurriculaCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectContainerCurriculaDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectContainerCurriculaDisconnectFieldInput>>;
  update?: InputMaybe<SubjectContainerCurriculaUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
};

export type SubjectContainerCurriculumUnitCurriculumUnitsAggregationSelection = {
  __typename?: 'SubjectContainerCurriculumUnitCurriculumUnitsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubjectContainerCurriculumUnitCurriculumUnitsNodeAggregateSelection>;
};

export type SubjectContainerCurriculumUnitCurriculumUnitsNodeAggregateSelection = {
  __typename?: 'SubjectContainerCurriculumUnitCurriculumUnitsNodeAggregateSelection';
  count: IntAggregateSelection;
  duration: IntAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectContainerCurriculumUnitsAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerCurriculumUnitsAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerCurriculumUnitsAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerCurriculumUnitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerCurriculumUnitsNodeAggregationWhereInput>;
};

export type SubjectContainerCurriculumUnitsConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumUnitConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumUnitConnectWhere>;
};

export type SubjectContainerCurriculumUnitsConnection = {
  __typename?: 'SubjectContainerCurriculumUnitsConnection';
  edges: Array<SubjectContainerCurriculumUnitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerCurriculumUnitsConnectionSort = {
  node?: InputMaybe<CurriculumUnitSort>;
};

export type SubjectContainerCurriculumUnitsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerCurriculumUnitsConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerCurriculumUnitsConnectionWhere>>;
  node?: InputMaybe<CurriculumUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumUnitWhere>;
};

export type SubjectContainerCurriculumUnitsCreateFieldInput = {
  node: CurriculumUnitCreateInput;
};

export type SubjectContainerCurriculumUnitsDeleteFieldInput = {
  delete?: InputMaybe<CurriculumUnitDeleteInput>;
  where?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
};

export type SubjectContainerCurriculumUnitsDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumUnitDisconnectInput>;
  where?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
};

export type SubjectContainerCurriculumUnitsFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerCurriculumUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerCurriculumUnitsCreateFieldInput>>;
};

export type SubjectContainerCurriculumUnitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerCurriculumUnitsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerCurriculumUnitsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerCurriculumUnitsNodeAggregationWhereInput>>;
  count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectContainerCurriculumUnitsRelationship = {
  __typename?: 'SubjectContainerCurriculumUnitsRelationship';
  cursor: Scalars['String']['output'];
  node: CurriculumUnit;
};

export type SubjectContainerCurriculumUnitsUpdateConnectionInput = {
  node?: InputMaybe<CurriculumUnitUpdateInput>;
};

export type SubjectContainerCurriculumUnitsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerCurriculumUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerCurriculumUnitsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectContainerCurriculumUnitsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectContainerCurriculumUnitsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectContainerCurriculumUnitsUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
};

export type SubjectContainerDeleteInput = {
  curricula?: InputMaybe<Array<SubjectContainerCurriculaDeleteFieldInput>>;
  curriculumUnits?: InputMaybe<Array<SubjectContainerCurriculumUnitsDeleteFieldInput>>;
  gradeGroup?: InputMaybe<Array<SubjectContainerGradeGroupDeleteFieldInput>>;
  labels?: InputMaybe<Array<SubjectContainerLabelsDeleteFieldInput>>;
  lessonUnits?: InputMaybe<Array<SubjectContainerLessonUnitsDeleteFieldInput>>;
  lessons?: InputMaybe<Array<SubjectContainerLessonsDeleteFieldInput>>;
  organization?: InputMaybe<SubjectContainerOrganizationDeleteFieldInput>;
  teachingBlocks?: InputMaybe<Array<SubjectContainerTeachingBlocksDeleteFieldInput>>;
  timetableConfig?: InputMaybe<SubjectContainerTimetableConfigDeleteFieldInput>;
  validFrom?: InputMaybe<SubjectContainerValidFromDeleteFieldInput>;
  validUntil?: InputMaybe<SubjectContainerValidUntilDeleteFieldInput>;
};

export type SubjectContainerDisconnectInput = {
  curricula?: InputMaybe<Array<SubjectContainerCurriculaDisconnectFieldInput>>;
  curriculumUnits?: InputMaybe<Array<SubjectContainerCurriculumUnitsDisconnectFieldInput>>;
  gradeGroup?: InputMaybe<Array<SubjectContainerGradeGroupDisconnectFieldInput>>;
  labels?: InputMaybe<Array<SubjectContainerLabelsDisconnectFieldInput>>;
  lessonUnits?: InputMaybe<Array<SubjectContainerLessonUnitsDisconnectFieldInput>>;
  lessons?: InputMaybe<Array<SubjectContainerLessonsDisconnectFieldInput>>;
  organization?: InputMaybe<SubjectContainerOrganizationDisconnectFieldInput>;
  teachingBlocks?: InputMaybe<Array<SubjectContainerTeachingBlocksDisconnectFieldInput>>;
  timetableConfig?: InputMaybe<SubjectContainerTimetableConfigDisconnectFieldInput>;
  validFrom?: InputMaybe<SubjectContainerValidFromDisconnectFieldInput>;
  validUntil?: InputMaybe<SubjectContainerValidUntilDisconnectFieldInput>;
};

export type SubjectContainerEdge = {
  __typename?: 'SubjectContainerEdge';
  cursor: Scalars['String']['output'];
  node: SubjectContainer;
};

export type SubjectContainerGradeGroupAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerGradeGroupAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerGradeGroupAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerGradeGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerGradeGroupNodeAggregationWhereInput>;
};

export type SubjectContainerGradeGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GradeGroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GradeGroupConnectWhere>;
};

export type SubjectContainerGradeGroupConnection = {
  __typename?: 'SubjectContainerGradeGroupConnection';
  edges: Array<SubjectContainerGradeGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerGradeGroupConnectionSort = {
  node?: InputMaybe<GradeGroupSort>;
};

export type SubjectContainerGradeGroupConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerGradeGroupConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerGradeGroupConnectionWhere>>;
  node?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GradeGroupWhere>;
};

export type SubjectContainerGradeGroupCreateFieldInput = {
  node: GradeGroupCreateInput;
};

export type SubjectContainerGradeGroupDeleteFieldInput = {
  delete?: InputMaybe<GradeGroupDeleteInput>;
  where?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
};

export type SubjectContainerGradeGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GradeGroupDisconnectInput>;
  where?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
};

export type SubjectContainerGradeGroupFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerGradeGroupConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerGradeGroupCreateFieldInput>>;
};

export type SubjectContainerGradeGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerGradeGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerGradeGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerGradeGroupNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectContainerGradeGroupRelationship = {
  __typename?: 'SubjectContainerGradeGroupRelationship';
  cursor: Scalars['String']['output'];
  node: GradeGroup;
};

export type SubjectContainerGradeGroupUpdateConnectionInput = {
  node?: InputMaybe<GradeGroupUpdateInput>;
};

export type SubjectContainerGradeGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerGradeGroupConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerGradeGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectContainerGradeGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectContainerGradeGroupDisconnectFieldInput>>;
  update?: InputMaybe<SubjectContainerGradeGroupUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
};

export type SubjectContainerLabelsAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerLabelsAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerLabelsAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerLabelsNodeAggregationWhereInput>;
};

export type SubjectContainerLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type SubjectContainerLabelsConnection = {
  __typename?: 'SubjectContainerLabelsConnection';
  edges: Array<SubjectContainerLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type SubjectContainerLabelsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerLabelsConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type SubjectContainerLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type SubjectContainerLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
};

export type SubjectContainerLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
};

export type SubjectContainerLabelsFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerLabelsCreateFieldInput>>;
};

export type SubjectContainerLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectContainerLabelsRelationship = {
  __typename?: 'SubjectContainerLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type SubjectContainerLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type SubjectContainerLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectContainerLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectContainerLabelsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectContainerLabelsUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
};

export type SubjectContainerLessonUnitLessonUnitsAggregationSelection = {
  __typename?: 'SubjectContainerLessonUnitLessonUnitsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubjectContainerLessonUnitLessonUnitsNodeAggregateSelection>;
};

export type SubjectContainerLessonUnitLessonUnitsNodeAggregateSelection = {
  __typename?: 'SubjectContainerLessonUnitLessonUnitsNodeAggregateSelection';
  count: IntAggregateSelection;
  duration: IntAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectContainerLessonUnitsAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerLessonUnitsAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerLessonUnitsAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerLessonUnitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerLessonUnitsNodeAggregationWhereInput>;
};

export type SubjectContainerLessonUnitsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonUnitConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonUnitConnectWhere>;
};

export type SubjectContainerLessonUnitsConnection = {
  __typename?: 'SubjectContainerLessonUnitsConnection';
  edges: Array<SubjectContainerLessonUnitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerLessonUnitsConnectionSort = {
  node?: InputMaybe<LessonUnitSort>;
};

export type SubjectContainerLessonUnitsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerLessonUnitsConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerLessonUnitsConnectionWhere>>;
  node?: InputMaybe<LessonUnitWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonUnitWhere>;
};

export type SubjectContainerLessonUnitsCreateFieldInput = {
  node: LessonUnitCreateInput;
};

export type SubjectContainerLessonUnitsDeleteFieldInput = {
  delete?: InputMaybe<LessonUnitDeleteInput>;
  where?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
};

export type SubjectContainerLessonUnitsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonUnitDisconnectInput>;
  where?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
};

export type SubjectContainerLessonUnitsFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerLessonUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerLessonUnitsCreateFieldInput>>;
};

export type SubjectContainerLessonUnitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerLessonUnitsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerLessonUnitsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerLessonUnitsNodeAggregationWhereInput>>;
  count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectContainerLessonUnitsRelationship = {
  __typename?: 'SubjectContainerLessonUnitsRelationship';
  cursor: Scalars['String']['output'];
  node: LessonUnit;
};

export type SubjectContainerLessonUnitsUpdateConnectionInput = {
  node?: InputMaybe<LessonUnitUpdateInput>;
};

export type SubjectContainerLessonUnitsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerLessonUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerLessonUnitsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectContainerLessonUnitsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectContainerLessonUnitsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectContainerLessonUnitsUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
};

export type SubjectContainerLessonsAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerLessonsAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerLessonsAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerLessonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerLessonsNodeAggregationWhereInput>;
};

export type SubjectContainerLessonsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type SubjectContainerLessonsConnectOrCreateFieldInput = {
  onCreate: SubjectContainerLessonsConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type SubjectContainerLessonsConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type SubjectContainerLessonsConnection = {
  __typename?: 'SubjectContainerLessonsConnection';
  edges: Array<SubjectContainerLessonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerLessonsConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type SubjectContainerLessonsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerLessonsConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerLessonsConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type SubjectContainerLessonsCreateFieldInput = {
  node: LessonCreateInput;
};

export type SubjectContainerLessonsDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
};

export type SubjectContainerLessonsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
};

export type SubjectContainerLessonsFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectContainerLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerLessonsCreateFieldInput>>;
};

export type SubjectContainerLessonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerLessonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerLessonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerLessonsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectContainerLessonsRelationship = {
  __typename?: 'SubjectContainerLessonsRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type SubjectContainerLessonsUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type SubjectContainerLessonsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectContainerLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerLessonsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectContainerLessonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectContainerLessonsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectContainerLessonsUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
};

export type SubjectContainerOnCreateInput = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
  grades: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  shortName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectContainerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubjectContainerSort objects to sort SubjectContainers by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubjectContainerSort>>;
};

export type SubjectContainerOrSubject = Subject | SubjectContainer;

export type SubjectContainerOrSubjectWhere = {
  Subject?: InputMaybe<SubjectWhere>;
  SubjectContainer?: InputMaybe<SubjectContainerWhere>;
};

export type SubjectContainerOrganizationAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerOrganizationAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerOrganizationAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerOrganizationNodeAggregationWhereInput>;
};

export type SubjectContainerOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type SubjectContainerOrganizationConnectOrCreateFieldInput = {
  onCreate: SubjectContainerOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type SubjectContainerOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type SubjectContainerOrganizationConnection = {
  __typename?: 'SubjectContainerOrganizationConnection';
  edges: Array<SubjectContainerOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type SubjectContainerOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerOrganizationConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type SubjectContainerOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type SubjectContainerOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<SubjectContainerOrganizationConnectionWhere>;
};

export type SubjectContainerOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<SubjectContainerOrganizationConnectionWhere>;
};

export type SubjectContainerOrganizationFieldInput = {
  connect?: InputMaybe<SubjectContainerOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectContainerOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectContainerOrganizationCreateFieldInput>;
};

export type SubjectContainerOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectContainerOrganizationRelationship = {
  __typename?: 'SubjectContainerOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type SubjectContainerOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type SubjectContainerOrganizationUpdateFieldInput = {
  connect?: InputMaybe<SubjectContainerOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectContainerOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectContainerOrganizationCreateFieldInput>;
  delete?: InputMaybe<SubjectContainerOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectContainerOrganizationDisconnectFieldInput>;
  update?: InputMaybe<SubjectContainerOrganizationUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerOrganizationConnectionWhere>;
};

/** Fields to sort SubjectContainers by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubjectContainerSort object. */
export type SubjectContainerSort = {
  createdAt?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SubjectContainerTeachingBlockTeachingBlocksAggregationSelection = {
  __typename?: 'SubjectContainerTeachingBlockTeachingBlocksAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubjectContainerTeachingBlockTeachingBlocksNodeAggregateSelection>;
};

export type SubjectContainerTeachingBlockTeachingBlocksNodeAggregateSelection = {
  __typename?: 'SubjectContainerTeachingBlockTeachingBlocksNodeAggregateSelection';
  comment: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectContainerTeachingBlocksAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerTeachingBlocksAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerTeachingBlocksAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerTeachingBlocksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerTeachingBlocksNodeAggregationWhereInput>;
};

export type SubjectContainerTeachingBlocksConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockConnectWhere>;
};

export type SubjectContainerTeachingBlocksConnectOrCreateFieldInput = {
  onCreate: SubjectContainerTeachingBlocksConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockConnectOrCreateWhere;
};

export type SubjectContainerTeachingBlocksConnectOrCreateFieldInputOnCreate = {
  node: TeachingBlockOnCreateInput;
};

export type SubjectContainerTeachingBlocksConnection = {
  __typename?: 'SubjectContainerTeachingBlocksConnection';
  edges: Array<SubjectContainerTeachingBlocksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerTeachingBlocksConnectionSort = {
  node?: InputMaybe<TeachingBlockSort>;
};

export type SubjectContainerTeachingBlocksConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectionWhere>>;
  node?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockWhere>;
};

export type SubjectContainerTeachingBlocksCreateFieldInput = {
  node: TeachingBlockCreateInput;
};

export type SubjectContainerTeachingBlocksDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockDeleteInput>;
  where?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
};

export type SubjectContainerTeachingBlocksDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockDisconnectInput>;
  where?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
};

export type SubjectContainerTeachingBlocksFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerTeachingBlocksCreateFieldInput>>;
};

export type SubjectContainerTeachingBlocksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerTeachingBlocksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerTeachingBlocksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerTeachingBlocksNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectContainerTeachingBlocksRelationship = {
  __typename?: 'SubjectContainerTeachingBlocksRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlock;
};

export type SubjectContainerTeachingBlocksUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockUpdateInput>;
};

export type SubjectContainerTeachingBlocksUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectContainerTeachingBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectContainerTeachingBlocksCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectContainerTeachingBlocksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectContainerTeachingBlocksDisconnectFieldInput>>;
  update?: InputMaybe<SubjectContainerTeachingBlocksUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
};

export type SubjectContainerTimetableConfigAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerTimetableConfigAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerTimetableConfigAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerTimetableConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerTimetableConfigNodeAggregationWhereInput>;
};

export type SubjectContainerTimetableConfigConnectFieldInput = {
  connect?: InputMaybe<TimetableConfigConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConfigConnectWhere>;
};

export type SubjectContainerTimetableConfigConnection = {
  __typename?: 'SubjectContainerTimetableConfigConnection';
  edges: Array<SubjectContainerTimetableConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerTimetableConfigConnectionSort = {
  node?: InputMaybe<TimetableConfigSort>;
};

export type SubjectContainerTimetableConfigConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerTimetableConfigConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerTimetableConfigConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerTimetableConfigConnectionWhere>>;
  node?: InputMaybe<TimetableConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableConfigWhere>;
};

export type SubjectContainerTimetableConfigCreateFieldInput = {
  node: TimetableConfigCreateInput;
};

export type SubjectContainerTimetableConfigDeleteFieldInput = {
  delete?: InputMaybe<TimetableConfigDeleteInput>;
  where?: InputMaybe<SubjectContainerTimetableConfigConnectionWhere>;
};

export type SubjectContainerTimetableConfigDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableConfigDisconnectInput>;
  where?: InputMaybe<SubjectContainerTimetableConfigConnectionWhere>;
};

export type SubjectContainerTimetableConfigFieldInput = {
  connect?: InputMaybe<SubjectContainerTimetableConfigConnectFieldInput>;
  create?: InputMaybe<SubjectContainerTimetableConfigCreateFieldInput>;
};

export type SubjectContainerTimetableConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerTimetableConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerTimetableConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerTimetableConfigNodeAggregationWhereInput>>;
  colorLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectContainerTimetableConfigRelationship = {
  __typename?: 'SubjectContainerTimetableConfigRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableConfig;
};

export type SubjectContainerTimetableConfigUpdateConnectionInput = {
  node?: InputMaybe<TimetableConfigUpdateInput>;
};

export type SubjectContainerTimetableConfigUpdateFieldInput = {
  connect?: InputMaybe<SubjectContainerTimetableConfigConnectFieldInput>;
  create?: InputMaybe<SubjectContainerTimetableConfigCreateFieldInput>;
  delete?: InputMaybe<SubjectContainerTimetableConfigDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectContainerTimetableConfigDisconnectFieldInput>;
  update?: InputMaybe<SubjectContainerTimetableConfigUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerTimetableConfigConnectionWhere>;
};

export type SubjectContainerUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectContainerUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curricula?: InputMaybe<Array<SubjectContainerCurriculaUpdateFieldInput>>;
  curriculumUnits?: InputMaybe<Array<SubjectContainerCurriculumUnitsUpdateFieldInput>>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  gradeGroup?: InputMaybe<Array<SubjectContainerGradeGroupUpdateFieldInput>>;
  grades?: InputMaybe<Array<Scalars['Int']['input']>>;
  grades_POP?: InputMaybe<Scalars['Int']['input']>;
  grades_PUSH?: InputMaybe<Array<Scalars['Int']['input']>>;
  labels?: InputMaybe<Array<SubjectContainerLabelsUpdateFieldInput>>;
  lessonUnits?: InputMaybe<Array<SubjectContainerLessonUnitsUpdateFieldInput>>;
  lessons?: InputMaybe<Array<SubjectContainerLessonsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<SubjectContainerOrganizationUpdateFieldInput>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  teachingBlocks?: InputMaybe<Array<SubjectContainerTeachingBlocksUpdateFieldInput>>;
  timetableConfig?: InputMaybe<SubjectContainerTimetableConfigUpdateFieldInput>;
  validFrom?: InputMaybe<SubjectContainerValidFromUpdateFieldInput>;
  validUntil?: InputMaybe<SubjectContainerValidUntilUpdateFieldInput>;
};

export type SubjectContainerValidFromAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerValidFromAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerValidFromAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerValidFromAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerValidFromNodeAggregationWhereInput>;
};

export type SubjectContainerValidFromConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type SubjectContainerValidFromConnection = {
  __typename?: 'SubjectContainerValidFromConnection';
  edges: Array<SubjectContainerValidFromRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerValidFromConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type SubjectContainerValidFromConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerValidFromConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerValidFromConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerValidFromConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type SubjectContainerValidFromCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type SubjectContainerValidFromDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<SubjectContainerValidFromConnectionWhere>;
};

export type SubjectContainerValidFromDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<SubjectContainerValidFromConnectionWhere>;
};

export type SubjectContainerValidFromFieldInput = {
  connect?: InputMaybe<SubjectContainerValidFromConnectFieldInput>;
  create?: InputMaybe<SubjectContainerValidFromCreateFieldInput>;
};

export type SubjectContainerValidFromNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerValidFromNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerValidFromNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerValidFromNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectContainerValidFromRelationship = {
  __typename?: 'SubjectContainerValidFromRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type SubjectContainerValidFromUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type SubjectContainerValidFromUpdateFieldInput = {
  connect?: InputMaybe<SubjectContainerValidFromConnectFieldInput>;
  create?: InputMaybe<SubjectContainerValidFromCreateFieldInput>;
  delete?: InputMaybe<SubjectContainerValidFromDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectContainerValidFromDisconnectFieldInput>;
  update?: InputMaybe<SubjectContainerValidFromUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerValidFromConnectionWhere>;
};

export type SubjectContainerValidUntilAggregateInput = {
  AND?: InputMaybe<Array<SubjectContainerValidUntilAggregateInput>>;
  NOT?: InputMaybe<SubjectContainerValidUntilAggregateInput>;
  OR?: InputMaybe<Array<SubjectContainerValidUntilAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectContainerValidUntilNodeAggregationWhereInput>;
};

export type SubjectContainerValidUntilConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type SubjectContainerValidUntilConnection = {
  __typename?: 'SubjectContainerValidUntilConnection';
  edges: Array<SubjectContainerValidUntilRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectContainerValidUntilConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type SubjectContainerValidUntilConnectionWhere = {
  AND?: InputMaybe<Array<SubjectContainerValidUntilConnectionWhere>>;
  NOT?: InputMaybe<SubjectContainerValidUntilConnectionWhere>;
  OR?: InputMaybe<Array<SubjectContainerValidUntilConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type SubjectContainerValidUntilCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type SubjectContainerValidUntilDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<SubjectContainerValidUntilConnectionWhere>;
};

export type SubjectContainerValidUntilDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<SubjectContainerValidUntilConnectionWhere>;
};

export type SubjectContainerValidUntilFieldInput = {
  connect?: InputMaybe<SubjectContainerValidUntilConnectFieldInput>;
  create?: InputMaybe<SubjectContainerValidUntilCreateFieldInput>;
};

export type SubjectContainerValidUntilNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectContainerValidUntilNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectContainerValidUntilNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectContainerValidUntilNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectContainerValidUntilRelationship = {
  __typename?: 'SubjectContainerValidUntilRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type SubjectContainerValidUntilUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type SubjectContainerValidUntilUpdateFieldInput = {
  connect?: InputMaybe<SubjectContainerValidUntilConnectFieldInput>;
  create?: InputMaybe<SubjectContainerValidUntilCreateFieldInput>;
  delete?: InputMaybe<SubjectContainerValidUntilDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectContainerValidUntilDisconnectFieldInput>;
  update?: InputMaybe<SubjectContainerValidUntilUpdateConnectionInput>;
  where?: InputMaybe<SubjectContainerValidUntilConnectionWhere>;
};

export type SubjectContainerWhere = {
  AND?: InputMaybe<Array<SubjectContainerWhere>>;
  NOT?: InputMaybe<SubjectContainerWhere>;
  OR?: InputMaybe<Array<SubjectContainerWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `curricula_SOME` instead. */
  curricula?: InputMaybe<CurriculumWhere>;
  curriculaAggregate?: InputMaybe<SubjectContainerCurriculaAggregateInput>;
  /** @deprecated Use `curriculaConnection_SOME` instead. */
  curriculaConnection?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
  /** Return SubjectContainers where all of the related SubjectContainerCurriculaConnections match this filter */
  curriculaConnection_ALL?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
  /** Return SubjectContainers where none of the related SubjectContainerCurriculaConnections match this filter */
  curriculaConnection_NONE?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
  /** @deprecated Use `curriculaConnection_NONE` instead. */
  curriculaConnection_NOT?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
  /** Return SubjectContainers where one of the related SubjectContainerCurriculaConnections match this filter */
  curriculaConnection_SINGLE?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
  /** Return SubjectContainers where some of the related SubjectContainerCurriculaConnections match this filter */
  curriculaConnection_SOME?: InputMaybe<SubjectContainerCurriculaConnectionWhere>;
  /** Return SubjectContainers where all of the related Curricula match this filter */
  curricula_ALL?: InputMaybe<CurriculumWhere>;
  /** Return SubjectContainers where none of the related Curricula match this filter */
  curricula_NONE?: InputMaybe<CurriculumWhere>;
  /** @deprecated Use `curricula_NONE` instead. */
  curricula_NOT?: InputMaybe<CurriculumWhere>;
  /** Return SubjectContainers where one of the related Curricula match this filter */
  curricula_SINGLE?: InputMaybe<CurriculumWhere>;
  /** Return SubjectContainers where some of the related Curricula match this filter */
  curricula_SOME?: InputMaybe<CurriculumWhere>;
  /** @deprecated Use `curriculumUnits_SOME` instead. */
  curriculumUnits?: InputMaybe<CurriculumUnitWhere>;
  curriculumUnitsAggregate?: InputMaybe<SubjectContainerCurriculumUnitsAggregateInput>;
  /** @deprecated Use `curriculumUnitsConnection_SOME` instead. */
  curriculumUnitsConnection?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
  /** Return SubjectContainers where all of the related SubjectContainerCurriculumUnitsConnections match this filter */
  curriculumUnitsConnection_ALL?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
  /** Return SubjectContainers where none of the related SubjectContainerCurriculumUnitsConnections match this filter */
  curriculumUnitsConnection_NONE?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
  /** @deprecated Use `curriculumUnitsConnection_NONE` instead. */
  curriculumUnitsConnection_NOT?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
  /** Return SubjectContainers where one of the related SubjectContainerCurriculumUnitsConnections match this filter */
  curriculumUnitsConnection_SINGLE?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
  /** Return SubjectContainers where some of the related SubjectContainerCurriculumUnitsConnections match this filter */
  curriculumUnitsConnection_SOME?: InputMaybe<SubjectContainerCurriculumUnitsConnectionWhere>;
  /** Return SubjectContainers where all of the related CurriculumUnits match this filter */
  curriculumUnits_ALL?: InputMaybe<CurriculumUnitWhere>;
  /** Return SubjectContainers where none of the related CurriculumUnits match this filter */
  curriculumUnits_NONE?: InputMaybe<CurriculumUnitWhere>;
  /** @deprecated Use `curriculumUnits_NONE` instead. */
  curriculumUnits_NOT?: InputMaybe<CurriculumUnitWhere>;
  /** Return SubjectContainers where one of the related CurriculumUnits match this filter */
  curriculumUnits_SINGLE?: InputMaybe<CurriculumUnitWhere>;
  /** Return SubjectContainers where some of the related CurriculumUnits match this filter */
  curriculumUnits_SOME?: InputMaybe<CurriculumUnitWhere>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `gradeGroup_SOME` instead. */
  gradeGroup?: InputMaybe<GradeGroupWhere>;
  gradeGroupAggregate?: InputMaybe<SubjectContainerGradeGroupAggregateInput>;
  /** @deprecated Use `gradeGroupConnection_SOME` instead. */
  gradeGroupConnection?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
  /** Return SubjectContainers where all of the related SubjectContainerGradeGroupConnections match this filter */
  gradeGroupConnection_ALL?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
  /** Return SubjectContainers where none of the related SubjectContainerGradeGroupConnections match this filter */
  gradeGroupConnection_NONE?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
  /** @deprecated Use `gradeGroupConnection_NONE` instead. */
  gradeGroupConnection_NOT?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
  /** Return SubjectContainers where one of the related SubjectContainerGradeGroupConnections match this filter */
  gradeGroupConnection_SINGLE?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
  /** Return SubjectContainers where some of the related SubjectContainerGradeGroupConnections match this filter */
  gradeGroupConnection_SOME?: InputMaybe<SubjectContainerGradeGroupConnectionWhere>;
  /** Return SubjectContainers where all of the related GradeGroups match this filter */
  gradeGroup_ALL?: InputMaybe<GradeGroupWhere>;
  /** Return SubjectContainers where none of the related GradeGroups match this filter */
  gradeGroup_NONE?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Use `gradeGroup_NONE` instead. */
  gradeGroup_NOT?: InputMaybe<GradeGroupWhere>;
  /** Return SubjectContainers where one of the related GradeGroups match this filter */
  gradeGroup_SINGLE?: InputMaybe<GradeGroupWhere>;
  /** Return SubjectContainers where some of the related GradeGroups match this filter */
  gradeGroup_SOME?: InputMaybe<GradeGroupWhere>;
  grades?: InputMaybe<Array<Scalars['Int']['input']>>;
  grades_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<SubjectContainerLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
  /** Return SubjectContainers where all of the related SubjectContainerLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
  /** Return SubjectContainers where none of the related SubjectContainerLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
  /** Return SubjectContainers where one of the related SubjectContainerLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
  /** Return SubjectContainers where some of the related SubjectContainerLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<SubjectContainerLabelsConnectionWhere>;
  /** Return SubjectContainers where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return SubjectContainers where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return SubjectContainers where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return SubjectContainers where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  /** @deprecated Use `lessonUnits_SOME` instead. */
  lessonUnits?: InputMaybe<LessonUnitWhere>;
  lessonUnitsAggregate?: InputMaybe<SubjectContainerLessonUnitsAggregateInput>;
  /** @deprecated Use `lessonUnitsConnection_SOME` instead. */
  lessonUnitsConnection?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
  /** Return SubjectContainers where all of the related SubjectContainerLessonUnitsConnections match this filter */
  lessonUnitsConnection_ALL?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
  /** Return SubjectContainers where none of the related SubjectContainerLessonUnitsConnections match this filter */
  lessonUnitsConnection_NONE?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
  /** @deprecated Use `lessonUnitsConnection_NONE` instead. */
  lessonUnitsConnection_NOT?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
  /** Return SubjectContainers where one of the related SubjectContainerLessonUnitsConnections match this filter */
  lessonUnitsConnection_SINGLE?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
  /** Return SubjectContainers where some of the related SubjectContainerLessonUnitsConnections match this filter */
  lessonUnitsConnection_SOME?: InputMaybe<SubjectContainerLessonUnitsConnectionWhere>;
  /** Return SubjectContainers where all of the related LessonUnits match this filter */
  lessonUnits_ALL?: InputMaybe<LessonUnitWhere>;
  /** Return SubjectContainers where none of the related LessonUnits match this filter */
  lessonUnits_NONE?: InputMaybe<LessonUnitWhere>;
  /** @deprecated Use `lessonUnits_NONE` instead. */
  lessonUnits_NOT?: InputMaybe<LessonUnitWhere>;
  /** Return SubjectContainers where one of the related LessonUnits match this filter */
  lessonUnits_SINGLE?: InputMaybe<LessonUnitWhere>;
  /** Return SubjectContainers where some of the related LessonUnits match this filter */
  lessonUnits_SOME?: InputMaybe<LessonUnitWhere>;
  /** @deprecated Use `lessons_SOME` instead. */
  lessons?: InputMaybe<LessonWhere>;
  lessonsAggregate?: InputMaybe<SubjectContainerLessonsAggregateInput>;
  /** @deprecated Use `lessonsConnection_SOME` instead. */
  lessonsConnection?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
  /** Return SubjectContainers where all of the related SubjectContainerLessonsConnections match this filter */
  lessonsConnection_ALL?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
  /** Return SubjectContainers where none of the related SubjectContainerLessonsConnections match this filter */
  lessonsConnection_NONE?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
  /** @deprecated Use `lessonsConnection_NONE` instead. */
  lessonsConnection_NOT?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
  /** Return SubjectContainers where one of the related SubjectContainerLessonsConnections match this filter */
  lessonsConnection_SINGLE?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
  /** Return SubjectContainers where some of the related SubjectContainerLessonsConnections match this filter */
  lessonsConnection_SOME?: InputMaybe<SubjectContainerLessonsConnectionWhere>;
  /** Return SubjectContainers where all of the related Lessons match this filter */
  lessons_ALL?: InputMaybe<LessonWhere>;
  /** Return SubjectContainers where none of the related Lessons match this filter */
  lessons_NONE?: InputMaybe<LessonWhere>;
  /** @deprecated Use `lessons_NONE` instead. */
  lessons_NOT?: InputMaybe<LessonWhere>;
  /** Return SubjectContainers where one of the related Lessons match this filter */
  lessons_SINGLE?: InputMaybe<LessonWhere>;
  /** Return SubjectContainers where some of the related Lessons match this filter */
  lessons_SOME?: InputMaybe<LessonWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<SubjectContainerOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<SubjectContainerOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<SubjectContainerOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `teachingBlocks_SOME` instead. */
  teachingBlocks?: InputMaybe<TeachingBlockWhere>;
  teachingBlocksAggregate?: InputMaybe<SubjectContainerTeachingBlocksAggregateInput>;
  /** @deprecated Use `teachingBlocksConnection_SOME` instead. */
  teachingBlocksConnection?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
  /** Return SubjectContainers where all of the related SubjectContainerTeachingBlocksConnections match this filter */
  teachingBlocksConnection_ALL?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
  /** Return SubjectContainers where none of the related SubjectContainerTeachingBlocksConnections match this filter */
  teachingBlocksConnection_NONE?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
  /** @deprecated Use `teachingBlocksConnection_NONE` instead. */
  teachingBlocksConnection_NOT?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
  /** Return SubjectContainers where one of the related SubjectContainerTeachingBlocksConnections match this filter */
  teachingBlocksConnection_SINGLE?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
  /** Return SubjectContainers where some of the related SubjectContainerTeachingBlocksConnections match this filter */
  teachingBlocksConnection_SOME?: InputMaybe<SubjectContainerTeachingBlocksConnectionWhere>;
  /** Return SubjectContainers where all of the related TeachingBlocks match this filter */
  teachingBlocks_ALL?: InputMaybe<TeachingBlockWhere>;
  /** Return SubjectContainers where none of the related TeachingBlocks match this filter */
  teachingBlocks_NONE?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Use `teachingBlocks_NONE` instead. */
  teachingBlocks_NOT?: InputMaybe<TeachingBlockWhere>;
  /** Return SubjectContainers where one of the related TeachingBlocks match this filter */
  teachingBlocks_SINGLE?: InputMaybe<TeachingBlockWhere>;
  /** Return SubjectContainers where some of the related TeachingBlocks match this filter */
  teachingBlocks_SOME?: InputMaybe<TeachingBlockWhere>;
  timetableConfig?: InputMaybe<TimetableConfigWhere>;
  timetableConfigAggregate?: InputMaybe<SubjectContainerTimetableConfigAggregateInput>;
  timetableConfigConnection?: InputMaybe<SubjectContainerTimetableConfigConnectionWhere>;
  timetableConfigConnection_NOT?: InputMaybe<SubjectContainerTimetableConfigConnectionWhere>;
  timetableConfig_NOT?: InputMaybe<TimetableConfigWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  validFrom?: InputMaybe<SchoolYearWhere>;
  validFromAggregate?: InputMaybe<SubjectContainerValidFromAggregateInput>;
  validFromConnection?: InputMaybe<SubjectContainerValidFromConnectionWhere>;
  validFromConnection_NOT?: InputMaybe<SubjectContainerValidFromConnectionWhere>;
  validFrom_NOT?: InputMaybe<SchoolYearWhere>;
  validUntil?: InputMaybe<SchoolYearWhere>;
  validUntilAggregate?: InputMaybe<SubjectContainerValidUntilAggregateInput>;
  validUntilConnection?: InputMaybe<SubjectContainerValidUntilConnectionWhere>;
  validUntilConnection_NOT?: InputMaybe<SubjectContainerValidUntilConnectionWhere>;
  validUntil_NOT?: InputMaybe<SchoolYearWhere>;
};

export type SubjectContainersConnection = {
  __typename?: 'SubjectContainersConnection';
  edges: Array<SubjectContainerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalTeachingLoads?: InputMaybe<SubjectAdditionalTeachingLoadsFieldInput>;
  curricula?: InputMaybe<SubjectCurriculaFieldInput>;
  defaultRooms?: InputMaybe<SubjectDefaultRoomsFieldInput>;
  epochEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<SubjectLabelsFieldInput>;
  lessons?: InputMaybe<SubjectLessonsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<SubjectOrganizationFieldInput>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  subjectGroup?: InputMaybe<SubjectSubjectGroupFieldInput>;
  subjectHourEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableConfig?: InputMaybe<SubjectTimetableConfigFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectCurriculaAggregateInput = {
  AND?: InputMaybe<Array<SubjectCurriculaAggregateInput>>;
  NOT?: InputMaybe<SubjectCurriculaAggregateInput>;
  OR?: InputMaybe<Array<SubjectCurriculaAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectCurriculaNodeAggregationWhereInput>;
};

export type SubjectCurriculaConnectFieldInput = {
  connect?: InputMaybe<Array<CurriculumConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CurriculumConnectWhere>;
};

export type SubjectCurriculaConnectOrCreateFieldInput = {
  onCreate: SubjectCurriculaConnectOrCreateFieldInputOnCreate;
  where: CurriculumConnectOrCreateWhere;
};

export type SubjectCurriculaConnectOrCreateFieldInputOnCreate = {
  node: CurriculumOnCreateInput;
};

export type SubjectCurriculaConnection = {
  __typename?: 'SubjectCurriculaConnection';
  edges: Array<SubjectCurriculaRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectCurriculaConnectionSort = {
  node?: InputMaybe<CurriculumSort>;
};

export type SubjectCurriculaConnectionWhere = {
  AND?: InputMaybe<Array<SubjectCurriculaConnectionWhere>>;
  NOT?: InputMaybe<SubjectCurriculaConnectionWhere>;
  OR?: InputMaybe<Array<SubjectCurriculaConnectionWhere>>;
  node?: InputMaybe<CurriculumWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<CurriculumWhere>;
};

export type SubjectCurriculaCreateFieldInput = {
  node: CurriculumCreateInput;
};

export type SubjectCurriculaDeleteFieldInput = {
  delete?: InputMaybe<CurriculumDeleteInput>;
  where?: InputMaybe<SubjectCurriculaConnectionWhere>;
};

export type SubjectCurriculaDisconnectFieldInput = {
  disconnect?: InputMaybe<CurriculumDisconnectInput>;
  where?: InputMaybe<SubjectCurriculaConnectionWhere>;
};

export type SubjectCurriculaFieldInput = {
  connect?: InputMaybe<Array<SubjectCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectCurriculaCreateFieldInput>>;
};

export type SubjectCurriculaNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectCurriculaNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectCurriculaNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectCurriculaNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectCurriculaRelationship = {
  __typename?: 'SubjectCurriculaRelationship';
  cursor: Scalars['String']['output'];
  node: Curriculum;
};

export type SubjectCurriculaUpdateConnectionInput = {
  node?: InputMaybe<CurriculumUpdateInput>;
};

export type SubjectCurriculaUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectCurriculaConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectCurriculaConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectCurriculaCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectCurriculaDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectCurriculaDisconnectFieldInput>>;
  update?: InputMaybe<SubjectCurriculaUpdateConnectionInput>;
  where?: InputMaybe<SubjectCurriculaConnectionWhere>;
};

export type SubjectDefaultRoomsAggregateInput = {
  AND?: InputMaybe<Array<SubjectDefaultRoomsAggregateInput>>;
  NOT?: InputMaybe<SubjectDefaultRoomsAggregateInput>;
  OR?: InputMaybe<Array<SubjectDefaultRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<SubjectDefaultRoomsNodeAggregationWhereInput>;
};

export type SubjectDefaultRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type SubjectDefaultRoomsConnectOrCreateFieldInput = {
  onCreate: SubjectDefaultRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type SubjectDefaultRoomsConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: RoomOnCreateInput;
};

export type SubjectDefaultRoomsConnection = {
  __typename?: 'SubjectDefaultRoomsConnection';
  edges: Array<SubjectDefaultRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectDefaultRoomsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<RoomSort>;
};

export type SubjectDefaultRoomsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectDefaultRoomsConnectionWhere>>;
  NOT?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectDefaultRoomsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type SubjectDefaultRoomsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: RoomCreateInput;
};

export type SubjectDefaultRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
};

export type SubjectDefaultRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
};

export type SubjectDefaultRoomsFieldInput = {
  connect?: InputMaybe<Array<SubjectDefaultRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectDefaultRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectDefaultRoomsCreateFieldInput>>;
};

export type SubjectDefaultRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectDefaultRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectDefaultRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectDefaultRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectDefaultRoomsRelationship = {
  __typename?: 'SubjectDefaultRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
  properties: OrderedRelationProperties;
};

export type SubjectDefaultRoomsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<RoomUpdateInput>;
};

export type SubjectDefaultRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectDefaultRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectDefaultRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectDefaultRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectDefaultRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectDefaultRoomsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectDefaultRoomsUpdateConnectionInput>;
  where?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
};

export type SubjectDeleteInput = {
  additionalTeachingLoads?: InputMaybe<Array<SubjectAdditionalTeachingLoadsDeleteFieldInput>>;
  curricula?: InputMaybe<Array<SubjectCurriculaDeleteFieldInput>>;
  defaultRooms?: InputMaybe<Array<SubjectDefaultRoomsDeleteFieldInput>>;
  labels?: InputMaybe<Array<SubjectLabelsDeleteFieldInput>>;
  lessons?: InputMaybe<Array<SubjectLessonsDeleteFieldInput>>;
  organization?: InputMaybe<SubjectOrganizationDeleteFieldInput>;
  subjectGroup?: InputMaybe<SubjectSubjectGroupDeleteFieldInput>;
  timetableConfig?: InputMaybe<SubjectTimetableConfigDeleteFieldInput>;
};

export type SubjectDisconnectInput = {
  additionalTeachingLoads?: InputMaybe<Array<SubjectAdditionalTeachingLoadsDisconnectFieldInput>>;
  curricula?: InputMaybe<Array<SubjectCurriculaDisconnectFieldInput>>;
  defaultRooms?: InputMaybe<Array<SubjectDefaultRoomsDisconnectFieldInput>>;
  labels?: InputMaybe<Array<SubjectLabelsDisconnectFieldInput>>;
  lessons?: InputMaybe<Array<SubjectLessonsDisconnectFieldInput>>;
  organization?: InputMaybe<SubjectOrganizationDisconnectFieldInput>;
  subjectGroup?: InputMaybe<SubjectSubjectGroupDisconnectFieldInput>;
  timetableConfig?: InputMaybe<SubjectTimetableConfigDisconnectFieldInput>;
};

export type SubjectEdge = {
  __typename?: 'SubjectEdge';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type SubjectGridCard = {
  __typename?: 'SubjectGridCard';
  colors: Array<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  startTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  subject: Scalars['ID']['output'];
  timetableCardUuid: Scalars['ID']['output'];
  uuid: Scalars['ID']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};

export type SubjectGroup = {
  __typename?: 'SubjectGroup';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  labels: Array<Label>;
  labelsConnection: SubjectGroupLabelsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: SubjectGroupOrganizationConnection;
  subjects: Array<Subject>;
  subjectsAggregate?: Maybe<SubjectGroupSubjectSubjectsAggregationSelection>;
  subjectsConnection: SubjectGroupSubjectsConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type SubjectGroupLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type SubjectGroupLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectGroupLabelsConnectionSort>>;
  where?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
};

export type SubjectGroupOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type SubjectGroupOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectGroupOrganizationConnectionSort>>;
  where?: InputMaybe<SubjectGroupOrganizationConnectionWhere>;
};

export type SubjectGroupSubjectsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type SubjectGroupSubjectsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubjectWhere>;
};

export type SubjectGroupSubjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubjectGroupSubjectsConnectionSort>>;
  where?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
};

export type SubjectGroupAggregateSelection = {
  __typename?: 'SubjectGroupAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectGroupConnectInput = {
  labels?: InputMaybe<Array<SubjectGroupLabelsConnectFieldInput>>;
  organization?: InputMaybe<SubjectGroupOrganizationConnectFieldInput>;
  subjects?: InputMaybe<Array<SubjectGroupSubjectsConnectFieldInput>>;
};

export type SubjectGroupConnectWhere = {
  node: SubjectGroupWhere;
};

export type SubjectGroupCreateInput = {
  labels?: InputMaybe<SubjectGroupLabelsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<SubjectGroupOrganizationFieldInput>;
  subjects?: InputMaybe<SubjectGroupSubjectsFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectGroupDeleteInput = {
  labels?: InputMaybe<Array<SubjectGroupLabelsDeleteFieldInput>>;
  organization?: InputMaybe<SubjectGroupOrganizationDeleteFieldInput>;
  subjects?: InputMaybe<Array<SubjectGroupSubjectsDeleteFieldInput>>;
};

export type SubjectGroupDisconnectInput = {
  labels?: InputMaybe<Array<SubjectGroupLabelsDisconnectFieldInput>>;
  organization?: InputMaybe<SubjectGroupOrganizationDisconnectFieldInput>;
  subjects?: InputMaybe<Array<SubjectGroupSubjectsDisconnectFieldInput>>;
};

export type SubjectGroupEdge = {
  __typename?: 'SubjectGroupEdge';
  cursor: Scalars['String']['output'];
  node: SubjectGroup;
};

export type SubjectGroupLabelsAggregateInput = {
  AND?: InputMaybe<Array<SubjectGroupLabelsAggregateInput>>;
  NOT?: InputMaybe<SubjectGroupLabelsAggregateInput>;
  OR?: InputMaybe<Array<SubjectGroupLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectGroupLabelsNodeAggregationWhereInput>;
};

export type SubjectGroupLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type SubjectGroupLabelsConnection = {
  __typename?: 'SubjectGroupLabelsConnection';
  edges: Array<SubjectGroupLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectGroupLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type SubjectGroupLabelsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectGroupLabelsConnectionWhere>>;
  NOT?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectGroupLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type SubjectGroupLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type SubjectGroupLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
};

export type SubjectGroupLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
};

export type SubjectGroupLabelsFieldInput = {
  connect?: InputMaybe<Array<SubjectGroupLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectGroupLabelsCreateFieldInput>>;
};

export type SubjectGroupLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectGroupLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectGroupLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectGroupLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectGroupLabelsRelationship = {
  __typename?: 'SubjectGroupLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type SubjectGroupLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type SubjectGroupLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectGroupLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectGroupLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectGroupLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectGroupLabelsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectGroupLabelsUpdateConnectionInput>;
  where?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
};

export type SubjectGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubjectGroupSort objects to sort SubjectGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubjectGroupSort>>;
};

export type SubjectGroupOrganizationAggregateInput = {
  AND?: InputMaybe<Array<SubjectGroupOrganizationAggregateInput>>;
  NOT?: InputMaybe<SubjectGroupOrganizationAggregateInput>;
  OR?: InputMaybe<Array<SubjectGroupOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectGroupOrganizationNodeAggregationWhereInput>;
};

export type SubjectGroupOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type SubjectGroupOrganizationConnectOrCreateFieldInput = {
  onCreate: SubjectGroupOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type SubjectGroupOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type SubjectGroupOrganizationConnection = {
  __typename?: 'SubjectGroupOrganizationConnection';
  edges: Array<SubjectGroupOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectGroupOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type SubjectGroupOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<SubjectGroupOrganizationConnectionWhere>>;
  NOT?: InputMaybe<SubjectGroupOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<SubjectGroupOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type SubjectGroupOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type SubjectGroupOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<SubjectGroupOrganizationConnectionWhere>;
};

export type SubjectGroupOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<SubjectGroupOrganizationConnectionWhere>;
};

export type SubjectGroupOrganizationFieldInput = {
  connect?: InputMaybe<SubjectGroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectGroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectGroupOrganizationCreateFieldInput>;
};

export type SubjectGroupOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectGroupOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectGroupOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectGroupOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectGroupOrganizationRelationship = {
  __typename?: 'SubjectGroupOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type SubjectGroupOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type SubjectGroupOrganizationUpdateFieldInput = {
  connect?: InputMaybe<SubjectGroupOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectGroupOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectGroupOrganizationCreateFieldInput>;
  delete?: InputMaybe<SubjectGroupOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectGroupOrganizationDisconnectFieldInput>;
  update?: InputMaybe<SubjectGroupOrganizationUpdateConnectionInput>;
  where?: InputMaybe<SubjectGroupOrganizationConnectionWhere>;
};

/** Fields to sort SubjectGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubjectGroupSort object. */
export type SubjectGroupSort = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SubjectGroupSubjectSubjectsAggregationSelection = {
  __typename?: 'SubjectGroupSubjectSubjectsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubjectGroupSubjectSubjectsNodeAggregateSelection>;
};

export type SubjectGroupSubjectSubjectsNodeAggregateSelection = {
  __typename?: 'SubjectGroupSubjectSubjectsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectGroupSubjectsAggregateInput = {
  AND?: InputMaybe<Array<SubjectGroupSubjectsAggregateInput>>;
  NOT?: InputMaybe<SubjectGroupSubjectsAggregateInput>;
  OR?: InputMaybe<Array<SubjectGroupSubjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectGroupSubjectsNodeAggregationWhereInput>;
};

export type SubjectGroupSubjectsConnectFieldInput = {
  connect?: InputMaybe<Array<SubjectConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type SubjectGroupSubjectsConnectOrCreateFieldInput = {
  onCreate: SubjectGroupSubjectsConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type SubjectGroupSubjectsConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type SubjectGroupSubjectsConnection = {
  __typename?: 'SubjectGroupSubjectsConnection';
  edges: Array<SubjectGroupSubjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectGroupSubjectsConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type SubjectGroupSubjectsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectGroupSubjectsConnectionWhere>>;
  NOT?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectGroupSubjectsConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type SubjectGroupSubjectsCreateFieldInput = {
  node: SubjectCreateInput;
};

export type SubjectGroupSubjectsDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
};

export type SubjectGroupSubjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
};

export type SubjectGroupSubjectsFieldInput = {
  connect?: InputMaybe<Array<SubjectGroupSubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectGroupSubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectGroupSubjectsCreateFieldInput>>;
};

export type SubjectGroupSubjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectGroupSubjectsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectGroupSubjectsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectGroupSubjectsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectGroupSubjectsRelationship = {
  __typename?: 'SubjectGroupSubjectsRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type SubjectGroupSubjectsUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type SubjectGroupSubjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectGroupSubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectGroupSubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectGroupSubjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectGroupSubjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectGroupSubjectsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectGroupSubjectsUpdateConnectionInput>;
  where?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
};

export type SubjectGroupUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  labels?: InputMaybe<Array<SubjectGroupLabelsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<SubjectGroupOrganizationUpdateFieldInput>;
  subjects?: InputMaybe<Array<SubjectGroupSubjectsUpdateFieldInput>>;
};

export type SubjectGroupWhere = {
  AND?: InputMaybe<Array<SubjectGroupWhere>>;
  NOT?: InputMaybe<SubjectGroupWhere>;
  OR?: InputMaybe<Array<SubjectGroupWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<SubjectGroupLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
  /** Return SubjectGroups where all of the related SubjectGroupLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
  /** Return SubjectGroups where none of the related SubjectGroupLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
  /** Return SubjectGroups where one of the related SubjectGroupLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
  /** Return SubjectGroups where some of the related SubjectGroupLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<SubjectGroupLabelsConnectionWhere>;
  /** Return SubjectGroups where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return SubjectGroups where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return SubjectGroups where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return SubjectGroups where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<SubjectGroupOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<SubjectGroupOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<SubjectGroupOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  /** @deprecated Use `subjects_SOME` instead. */
  subjects?: InputMaybe<SubjectWhere>;
  subjectsAggregate?: InputMaybe<SubjectGroupSubjectsAggregateInput>;
  /** @deprecated Use `subjectsConnection_SOME` instead. */
  subjectsConnection?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
  /** Return SubjectGroups where all of the related SubjectGroupSubjectsConnections match this filter */
  subjectsConnection_ALL?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
  /** Return SubjectGroups where none of the related SubjectGroupSubjectsConnections match this filter */
  subjectsConnection_NONE?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
  /** @deprecated Use `subjectsConnection_NONE` instead. */
  subjectsConnection_NOT?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
  /** Return SubjectGroups where one of the related SubjectGroupSubjectsConnections match this filter */
  subjectsConnection_SINGLE?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
  /** Return SubjectGroups where some of the related SubjectGroupSubjectsConnections match this filter */
  subjectsConnection_SOME?: InputMaybe<SubjectGroupSubjectsConnectionWhere>;
  /** Return SubjectGroups where all of the related Subjects match this filter */
  subjects_ALL?: InputMaybe<SubjectWhere>;
  /** Return SubjectGroups where none of the related Subjects match this filter */
  subjects_NONE?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `subjects_NONE` instead. */
  subjects_NOT?: InputMaybe<SubjectWhere>;
  /** Return SubjectGroups where one of the related Subjects match this filter */
  subjects_SINGLE?: InputMaybe<SubjectWhere>;
  /** Return SubjectGroups where some of the related Subjects match this filter */
  subjects_SOME?: InputMaybe<SubjectWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectGroupsConnection = {
  __typename?: 'SubjectGroupsConnection';
  edges: Array<SubjectGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectLabelLabelsAggregationSelection = {
  __typename?: 'SubjectLabelLabelsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubjectLabelLabelsNodeAggregateSelection>;
};

export type SubjectLabelLabelsNodeAggregateSelection = {
  __typename?: 'SubjectLabelLabelsNodeAggregateSelection';
  color: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectLabelsAggregateInput = {
  AND?: InputMaybe<Array<SubjectLabelsAggregateInput>>;
  NOT?: InputMaybe<SubjectLabelsAggregateInput>;
  OR?: InputMaybe<Array<SubjectLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectLabelsNodeAggregationWhereInput>;
};

export type SubjectLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type SubjectLabelsConnection = {
  __typename?: 'SubjectLabelsConnection';
  edges: Array<SubjectLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type SubjectLabelsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectLabelsConnectionWhere>>;
  NOT?: InputMaybe<SubjectLabelsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type SubjectLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type SubjectLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<SubjectLabelsConnectionWhere>;
};

export type SubjectLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<SubjectLabelsConnectionWhere>;
};

export type SubjectLabelsFieldInput = {
  connect?: InputMaybe<Array<SubjectLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectLabelsCreateFieldInput>>;
};

export type SubjectLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectLabelsRelationship = {
  __typename?: 'SubjectLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type SubjectLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type SubjectLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<SubjectLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectLabelsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectLabelsUpdateConnectionInput>;
  where?: InputMaybe<SubjectLabelsConnectionWhere>;
};

export type SubjectLessonLessonsAggregationSelection = {
  __typename?: 'SubjectLessonLessonsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubjectLessonLessonsNodeAggregateSelection>;
};

export type SubjectLessonLessonsNodeAggregateSelection = {
  __typename?: 'SubjectLessonLessonsNodeAggregateSelection';
  comment: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  subTitle: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubjectLessonsAggregateInput = {
  AND?: InputMaybe<Array<SubjectLessonsAggregateInput>>;
  NOT?: InputMaybe<SubjectLessonsAggregateInput>;
  OR?: InputMaybe<Array<SubjectLessonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectLessonsNodeAggregationWhereInput>;
};

export type SubjectLessonsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type SubjectLessonsConnectOrCreateFieldInput = {
  onCreate: SubjectLessonsConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type SubjectLessonsConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type SubjectLessonsConnection = {
  __typename?: 'SubjectLessonsConnection';
  edges: Array<SubjectLessonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectLessonsConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type SubjectLessonsConnectionWhere = {
  AND?: InputMaybe<Array<SubjectLessonsConnectionWhere>>;
  NOT?: InputMaybe<SubjectLessonsConnectionWhere>;
  OR?: InputMaybe<Array<SubjectLessonsConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type SubjectLessonsCreateFieldInput = {
  node: LessonCreateInput;
};

export type SubjectLessonsDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<SubjectLessonsConnectionWhere>;
};

export type SubjectLessonsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<SubjectLessonsConnectionWhere>;
};

export type SubjectLessonsFieldInput = {
  connect?: InputMaybe<Array<SubjectLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectLessonsCreateFieldInput>>;
};

export type SubjectLessonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectLessonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectLessonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectLessonsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectLessonsRelationship = {
  __typename?: 'SubjectLessonsRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type SubjectLessonsUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type SubjectLessonsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubjectLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubjectLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubjectLessonsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubjectLessonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubjectLessonsDisconnectFieldInput>>;
  update?: InputMaybe<SubjectLessonsUpdateConnectionInput>;
  where?: InputMaybe<SubjectLessonsConnectionWhere>;
};

export type SubjectOnCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  epochEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  other?: InputMaybe<Scalars['Boolean']['input']>;
  shortName: Scalars['String']['input'];
  subjectHourEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubjectSort objects to sort Subjects by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubjectSort>>;
};

export type SubjectOrganizationAggregateInput = {
  AND?: InputMaybe<Array<SubjectOrganizationAggregateInput>>;
  NOT?: InputMaybe<SubjectOrganizationAggregateInput>;
  OR?: InputMaybe<Array<SubjectOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectOrganizationNodeAggregationWhereInput>;
};

export type SubjectOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type SubjectOrganizationConnectOrCreateFieldInput = {
  onCreate: SubjectOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type SubjectOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type SubjectOrganizationConnection = {
  __typename?: 'SubjectOrganizationConnection';
  edges: Array<SubjectOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type SubjectOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<SubjectOrganizationConnectionWhere>>;
  NOT?: InputMaybe<SubjectOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<SubjectOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type SubjectOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type SubjectOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

export type SubjectOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

export type SubjectOrganizationFieldInput = {
  connect?: InputMaybe<SubjectOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectOrganizationCreateFieldInput>;
};

export type SubjectOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectOrganizationRelationship = {
  __typename?: 'SubjectOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type SubjectOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type SubjectOrganizationUpdateFieldInput = {
  connect?: InputMaybe<SubjectOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubjectOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<SubjectOrganizationCreateFieldInput>;
  delete?: InputMaybe<SubjectOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectOrganizationDisconnectFieldInput>;
  update?: InputMaybe<SubjectOrganizationUpdateConnectionInput>;
  where?: InputMaybe<SubjectOrganizationConnectionWhere>;
};

/** Fields to sort Subjects by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubjectSort object. */
export type SubjectSort = {
  active?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  epochEnabled?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  other?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  subjectHourEnabled?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SubjectSubjectGroupAggregateInput = {
  AND?: InputMaybe<Array<SubjectSubjectGroupAggregateInput>>;
  NOT?: InputMaybe<SubjectSubjectGroupAggregateInput>;
  OR?: InputMaybe<Array<SubjectSubjectGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectSubjectGroupNodeAggregationWhereInput>;
};

export type SubjectSubjectGroupConnectFieldInput = {
  connect?: InputMaybe<SubjectGroupConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectGroupConnectWhere>;
};

export type SubjectSubjectGroupConnection = {
  __typename?: 'SubjectSubjectGroupConnection';
  edges: Array<SubjectSubjectGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectSubjectGroupConnectionSort = {
  node?: InputMaybe<SubjectGroupSort>;
};

export type SubjectSubjectGroupConnectionWhere = {
  AND?: InputMaybe<Array<SubjectSubjectGroupConnectionWhere>>;
  NOT?: InputMaybe<SubjectSubjectGroupConnectionWhere>;
  OR?: InputMaybe<Array<SubjectSubjectGroupConnectionWhere>>;
  node?: InputMaybe<SubjectGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectGroupWhere>;
};

export type SubjectSubjectGroupCreateFieldInput = {
  node: SubjectGroupCreateInput;
};

export type SubjectSubjectGroupDeleteFieldInput = {
  delete?: InputMaybe<SubjectGroupDeleteInput>;
  where?: InputMaybe<SubjectSubjectGroupConnectionWhere>;
};

export type SubjectSubjectGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectGroupDisconnectInput>;
  where?: InputMaybe<SubjectSubjectGroupConnectionWhere>;
};

export type SubjectSubjectGroupFieldInput = {
  connect?: InputMaybe<SubjectSubjectGroupConnectFieldInput>;
  create?: InputMaybe<SubjectSubjectGroupCreateFieldInput>;
};

export type SubjectSubjectGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectSubjectGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectSubjectGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectSubjectGroupNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubjectSubjectGroupRelationship = {
  __typename?: 'SubjectSubjectGroupRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectGroup;
};

export type SubjectSubjectGroupUpdateConnectionInput = {
  node?: InputMaybe<SubjectGroupUpdateInput>;
};

export type SubjectSubjectGroupUpdateFieldInput = {
  connect?: InputMaybe<SubjectSubjectGroupConnectFieldInput>;
  create?: InputMaybe<SubjectSubjectGroupCreateFieldInput>;
  delete?: InputMaybe<SubjectSubjectGroupDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectSubjectGroupDisconnectFieldInput>;
  update?: InputMaybe<SubjectSubjectGroupUpdateConnectionInput>;
  where?: InputMaybe<SubjectSubjectGroupConnectionWhere>;
};

export type SubjectTimetableConfigAggregateInput = {
  AND?: InputMaybe<Array<SubjectTimetableConfigAggregateInput>>;
  NOT?: InputMaybe<SubjectTimetableConfigAggregateInput>;
  OR?: InputMaybe<Array<SubjectTimetableConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubjectTimetableConfigNodeAggregationWhereInput>;
};

export type SubjectTimetableConfigConnectFieldInput = {
  connect?: InputMaybe<TimetableConfigConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConfigConnectWhere>;
};

export type SubjectTimetableConfigConnection = {
  __typename?: 'SubjectTimetableConfigConnection';
  edges: Array<SubjectTimetableConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubjectTimetableConfigConnectionSort = {
  node?: InputMaybe<TimetableConfigSort>;
};

export type SubjectTimetableConfigConnectionWhere = {
  AND?: InputMaybe<Array<SubjectTimetableConfigConnectionWhere>>;
  NOT?: InputMaybe<SubjectTimetableConfigConnectionWhere>;
  OR?: InputMaybe<Array<SubjectTimetableConfigConnectionWhere>>;
  node?: InputMaybe<TimetableConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableConfigWhere>;
};

export type SubjectTimetableConfigCreateFieldInput = {
  node: TimetableConfigCreateInput;
};

export type SubjectTimetableConfigDeleteFieldInput = {
  delete?: InputMaybe<TimetableConfigDeleteInput>;
  where?: InputMaybe<SubjectTimetableConfigConnectionWhere>;
};

export type SubjectTimetableConfigDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableConfigDisconnectInput>;
  where?: InputMaybe<SubjectTimetableConfigConnectionWhere>;
};

export type SubjectTimetableConfigFieldInput = {
  connect?: InputMaybe<SubjectTimetableConfigConnectFieldInput>;
  create?: InputMaybe<SubjectTimetableConfigCreateFieldInput>;
};

export type SubjectTimetableConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubjectTimetableConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubjectTimetableConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubjectTimetableConfigNodeAggregationWhereInput>>;
  colorLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  colorLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  colorLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printOrder_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printOrder_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  printPageNr_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubjectTimetableConfigRelationship = {
  __typename?: 'SubjectTimetableConfigRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableConfig;
};

export type SubjectTimetableConfigUpdateConnectionInput = {
  node?: InputMaybe<TimetableConfigUpdateInput>;
};

export type SubjectTimetableConfigUpdateFieldInput = {
  connect?: InputMaybe<SubjectTimetableConfigConnectFieldInput>;
  create?: InputMaybe<SubjectTimetableConfigCreateFieldInput>;
  delete?: InputMaybe<SubjectTimetableConfigDeleteFieldInput>;
  disconnect?: InputMaybe<SubjectTimetableConfigDisconnectFieldInput>;
  update?: InputMaybe<SubjectTimetableConfigUpdateConnectionInput>;
  where?: InputMaybe<SubjectTimetableConfigConnectionWhere>;
};

export type SubjectUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type SubjectUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalTeachingLoads?: InputMaybe<Array<SubjectAdditionalTeachingLoadsUpdateFieldInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curricula?: InputMaybe<Array<SubjectCurriculaUpdateFieldInput>>;
  defaultRooms?: InputMaybe<Array<SubjectDefaultRoomsUpdateFieldInput>>;
  epochEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<SubjectLabelsUpdateFieldInput>>;
  lessons?: InputMaybe<Array<SubjectLessonsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<SubjectOrganizationUpdateFieldInput>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  subjectGroup?: InputMaybe<SubjectSubjectGroupUpdateFieldInput>;
  subjectHourEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timetableConfig?: InputMaybe<SubjectTimetableConfigUpdateFieldInput>;
};

export type SubjectWhere = {
  AND?: InputMaybe<Array<SubjectWhere>>;
  NOT?: InputMaybe<SubjectWhere>;
  OR?: InputMaybe<Array<SubjectWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `additionalTeachingLoads_SOME` instead. */
  additionalTeachingLoads?: InputMaybe<AdditionalTeachingLoadWhere>;
  additionalTeachingLoadsAggregate?: InputMaybe<SubjectAdditionalTeachingLoadsAggregateInput>;
  /** @deprecated Use `additionalTeachingLoadsConnection_SOME` instead. */
  additionalTeachingLoadsConnection?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
  /** Return Subjects where all of the related SubjectAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_ALL?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
  /** Return Subjects where none of the related SubjectAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_NONE?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
  /** @deprecated Use `additionalTeachingLoadsConnection_NONE` instead. */
  additionalTeachingLoadsConnection_NOT?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
  /** Return Subjects where one of the related SubjectAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SINGLE?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
  /** Return Subjects where some of the related SubjectAdditionalTeachingLoadsConnections match this filter */
  additionalTeachingLoadsConnection_SOME?: InputMaybe<SubjectAdditionalTeachingLoadsConnectionWhere>;
  /** Return Subjects where all of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_ALL?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return Subjects where none of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_NONE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** @deprecated Use `additionalTeachingLoads_NONE` instead. */
  additionalTeachingLoads_NOT?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return Subjects where one of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SINGLE?: InputMaybe<AdditionalTeachingLoadWhere>;
  /** Return Subjects where some of the related AdditionalTeachingLoads match this filter */
  additionalTeachingLoads_SOME?: InputMaybe<AdditionalTeachingLoadWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `curricula_SOME` instead. */
  curricula?: InputMaybe<CurriculumWhere>;
  curriculaAggregate?: InputMaybe<SubjectCurriculaAggregateInput>;
  /** @deprecated Use `curriculaConnection_SOME` instead. */
  curriculaConnection?: InputMaybe<SubjectCurriculaConnectionWhere>;
  /** Return Subjects where all of the related SubjectCurriculaConnections match this filter */
  curriculaConnection_ALL?: InputMaybe<SubjectCurriculaConnectionWhere>;
  /** Return Subjects where none of the related SubjectCurriculaConnections match this filter */
  curriculaConnection_NONE?: InputMaybe<SubjectCurriculaConnectionWhere>;
  /** @deprecated Use `curriculaConnection_NONE` instead. */
  curriculaConnection_NOT?: InputMaybe<SubjectCurriculaConnectionWhere>;
  /** Return Subjects where one of the related SubjectCurriculaConnections match this filter */
  curriculaConnection_SINGLE?: InputMaybe<SubjectCurriculaConnectionWhere>;
  /** Return Subjects where some of the related SubjectCurriculaConnections match this filter */
  curriculaConnection_SOME?: InputMaybe<SubjectCurriculaConnectionWhere>;
  /** Return Subjects where all of the related Curricula match this filter */
  curricula_ALL?: InputMaybe<CurriculumWhere>;
  /** Return Subjects where none of the related Curricula match this filter */
  curricula_NONE?: InputMaybe<CurriculumWhere>;
  /** @deprecated Use `curricula_NONE` instead. */
  curricula_NOT?: InputMaybe<CurriculumWhere>;
  /** Return Subjects where one of the related Curricula match this filter */
  curricula_SINGLE?: InputMaybe<CurriculumWhere>;
  /** Return Subjects where some of the related Curricula match this filter */
  curricula_SOME?: InputMaybe<CurriculumWhere>;
  /** @deprecated Use `defaultRooms_SOME` instead. */
  defaultRooms?: InputMaybe<RoomWhere>;
  defaultRoomsAggregate?: InputMaybe<SubjectDefaultRoomsAggregateInput>;
  /** @deprecated Use `defaultRoomsConnection_SOME` instead. */
  defaultRoomsConnection?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
  /** Return Subjects where all of the related SubjectDefaultRoomsConnections match this filter */
  defaultRoomsConnection_ALL?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
  /** Return Subjects where none of the related SubjectDefaultRoomsConnections match this filter */
  defaultRoomsConnection_NONE?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
  /** @deprecated Use `defaultRoomsConnection_NONE` instead. */
  defaultRoomsConnection_NOT?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
  /** Return Subjects where one of the related SubjectDefaultRoomsConnections match this filter */
  defaultRoomsConnection_SINGLE?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
  /** Return Subjects where some of the related SubjectDefaultRoomsConnections match this filter */
  defaultRoomsConnection_SOME?: InputMaybe<SubjectDefaultRoomsConnectionWhere>;
  /** Return Subjects where all of the related Rooms match this filter */
  defaultRooms_ALL?: InputMaybe<RoomWhere>;
  /** Return Subjects where none of the related Rooms match this filter */
  defaultRooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `defaultRooms_NONE` instead. */
  defaultRooms_NOT?: InputMaybe<RoomWhere>;
  /** Return Subjects where one of the related Rooms match this filter */
  defaultRooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return Subjects where some of the related Rooms match this filter */
  defaultRooms_SOME?: InputMaybe<RoomWhere>;
  epochEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  epochEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<SubjectLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<SubjectLabelsConnectionWhere>;
  /** Return Subjects where all of the related SubjectLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<SubjectLabelsConnectionWhere>;
  /** Return Subjects where none of the related SubjectLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<SubjectLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<SubjectLabelsConnectionWhere>;
  /** Return Subjects where one of the related SubjectLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<SubjectLabelsConnectionWhere>;
  /** Return Subjects where some of the related SubjectLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<SubjectLabelsConnectionWhere>;
  /** Return Subjects where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return Subjects where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return Subjects where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return Subjects where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  /** @deprecated Use `lessons_SOME` instead. */
  lessons?: InputMaybe<LessonWhere>;
  lessonsAggregate?: InputMaybe<SubjectLessonsAggregateInput>;
  /** @deprecated Use `lessonsConnection_SOME` instead. */
  lessonsConnection?: InputMaybe<SubjectLessonsConnectionWhere>;
  /** Return Subjects where all of the related SubjectLessonsConnections match this filter */
  lessonsConnection_ALL?: InputMaybe<SubjectLessonsConnectionWhere>;
  /** Return Subjects where none of the related SubjectLessonsConnections match this filter */
  lessonsConnection_NONE?: InputMaybe<SubjectLessonsConnectionWhere>;
  /** @deprecated Use `lessonsConnection_NONE` instead. */
  lessonsConnection_NOT?: InputMaybe<SubjectLessonsConnectionWhere>;
  /** Return Subjects where one of the related SubjectLessonsConnections match this filter */
  lessonsConnection_SINGLE?: InputMaybe<SubjectLessonsConnectionWhere>;
  /** Return Subjects where some of the related SubjectLessonsConnections match this filter */
  lessonsConnection_SOME?: InputMaybe<SubjectLessonsConnectionWhere>;
  /** Return Subjects where all of the related Lessons match this filter */
  lessons_ALL?: InputMaybe<LessonWhere>;
  /** Return Subjects where none of the related Lessons match this filter */
  lessons_NONE?: InputMaybe<LessonWhere>;
  /** @deprecated Use `lessons_NONE` instead. */
  lessons_NOT?: InputMaybe<LessonWhere>;
  /** Return Subjects where one of the related Lessons match this filter */
  lessons_SINGLE?: InputMaybe<LessonWhere>;
  /** Return Subjects where some of the related Lessons match this filter */
  lessons_SOME?: InputMaybe<LessonWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<SubjectOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<SubjectOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<SubjectOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  other_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectGroup?: InputMaybe<SubjectGroupWhere>;
  subjectGroupAggregate?: InputMaybe<SubjectSubjectGroupAggregateInput>;
  subjectGroupConnection?: InputMaybe<SubjectSubjectGroupConnectionWhere>;
  subjectGroupConnection_NOT?: InputMaybe<SubjectSubjectGroupConnectionWhere>;
  subjectGroup_NOT?: InputMaybe<SubjectGroupWhere>;
  subjectHourEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  subjectHourEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  timetableConfig?: InputMaybe<TimetableConfigWhere>;
  timetableConfigAggregate?: InputMaybe<SubjectTimetableConfigAggregateInput>;
  timetableConfigConnection?: InputMaybe<SubjectTimetableConfigConnectionWhere>;
  timetableConfigConnection_NOT?: InputMaybe<SubjectTimetableConfigConnectionWhere>;
  timetableConfig_NOT?: InputMaybe<TimetableConfigWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubjectsConnection = {
  __typename?: 'SubjectsConnection';
  edges: Array<SubjectEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubstitutionAnnouncement = {
  __typename?: 'SubstitutionAnnouncement';
  date: Scalars['Date']['output'];
  internalAnnouncement?: Maybe<Scalars['String']['output']>;
  publicAnnouncement?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type SubstitutionAnnouncementAggregateSelection = {
  __typename?: 'SubstitutionAnnouncementAggregateSelection';
  count: Scalars['Int']['output'];
  internalAnnouncement: StringAggregateSelection;
  publicAnnouncement: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubstitutionAnnouncementCreateInput = {
  date: Scalars['Date']['input'];
  internalAnnouncement?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement?: InputMaybe<Scalars['String']['input']>;
};

export type SubstitutionAnnouncementEdge = {
  __typename?: 'SubstitutionAnnouncementEdge';
  cursor: Scalars['String']['output'];
  node: SubstitutionAnnouncement;
};

export type SubstitutionAnnouncementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubstitutionAnnouncementSort objects to sort SubstitutionAnnouncements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubstitutionAnnouncementSort>>;
};

/** Fields to sort SubstitutionAnnouncements by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubstitutionAnnouncementSort object. */
export type SubstitutionAnnouncementSort = {
  date?: InputMaybe<SortDirection>;
  internalAnnouncement?: InputMaybe<SortDirection>;
  publicAnnouncement?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SubstitutionAnnouncementUpdateInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  internalAnnouncement?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement?: InputMaybe<Scalars['String']['input']>;
};

export type SubstitutionAnnouncementWhere = {
  AND?: InputMaybe<Array<SubstitutionAnnouncementWhere>>;
  NOT?: InputMaybe<SubstitutionAnnouncementWhere>;
  OR?: InputMaybe<Array<SubstitutionAnnouncementWhere>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  date_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  internalAnnouncement?: InputMaybe<Scalars['String']['input']>;
  internalAnnouncement_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  internalAnnouncement_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  internalAnnouncement_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  internalAnnouncement_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  internalAnnouncement_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  internalAnnouncement_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  internalAnnouncement_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  internalAnnouncement_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  internalAnnouncement_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicAnnouncement_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicAnnouncement_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicAnnouncement_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicAnnouncement_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  publicAnnouncement_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicAnnouncement_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubstitutionAnnouncementsConnection = {
  __typename?: 'SubstitutionAnnouncementsConnection';
  edges: Array<SubstitutionAnnouncementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubstitutionAppConfig = {
  __typename?: 'SubstitutionAppConfig';
  allowIndividualLogins: Scalars['Boolean']['output'];
  showClassGroups: Scalars['Boolean']['output'];
  showCurrentSubject: Scalars['Boolean']['output'];
  showHolidays: Scalars['Boolean']['output'];
  showOriginalSubject: Scalars['Boolean']['output'];
  studentPassword: Scalars['String']['output'];
  teacherPassword: Scalars['String']['output'];
  timeDisplayMode: Scalars['String']['output'];
  useClassShortname: Scalars['Boolean']['output'];
  useRoomShortname: Scalars['Boolean']['output'];
  useTeacherShortname: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export type SubstitutionAppConfigAggregateSelection = {
  __typename?: 'SubstitutionAppConfigAggregateSelection';
  count: Scalars['Int']['output'];
  studentPassword: StringAggregateSelection;
  teacherPassword: StringAggregateSelection;
  timeDisplayMode: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubstitutionAppConfigCreateInput = {
  allowIndividualLogins: Scalars['Boolean']['input'];
  showClassGroups: Scalars['Boolean']['input'];
  showCurrentSubject: Scalars['Boolean']['input'];
  showHolidays: Scalars['Boolean']['input'];
  showOriginalSubject: Scalars['Boolean']['input'];
  studentPassword: Scalars['String']['input'];
  teacherPassword: Scalars['String']['input'];
  timeDisplayMode: Scalars['String']['input'];
  useClassShortname: Scalars['Boolean']['input'];
  useRoomShortname: Scalars['Boolean']['input'];
  useTeacherShortname: Scalars['Boolean']['input'];
};

export type SubstitutionAppConfigEdge = {
  __typename?: 'SubstitutionAppConfigEdge';
  cursor: Scalars['String']['output'];
  node: SubstitutionAppConfig;
};

export type SubstitutionAppConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubstitutionAppConfigSort objects to sort SubstitutionAppConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubstitutionAppConfigSort>>;
};

/** Fields to sort SubstitutionAppConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubstitutionAppConfigSort object. */
export type SubstitutionAppConfigSort = {
  allowIndividualLogins?: InputMaybe<SortDirection>;
  showClassGroups?: InputMaybe<SortDirection>;
  showCurrentSubject?: InputMaybe<SortDirection>;
  showHolidays?: InputMaybe<SortDirection>;
  showOriginalSubject?: InputMaybe<SortDirection>;
  studentPassword?: InputMaybe<SortDirection>;
  teacherPassword?: InputMaybe<SortDirection>;
  timeDisplayMode?: InputMaybe<SortDirection>;
  useClassShortname?: InputMaybe<SortDirection>;
  useRoomShortname?: InputMaybe<SortDirection>;
  useTeacherShortname?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SubstitutionAppConfigUpdateInput = {
  allowIndividualLogins?: InputMaybe<Scalars['Boolean']['input']>;
  showClassGroups?: InputMaybe<Scalars['Boolean']['input']>;
  showCurrentSubject?: InputMaybe<Scalars['Boolean']['input']>;
  showHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  showOriginalSubject?: InputMaybe<Scalars['Boolean']['input']>;
  studentPassword?: InputMaybe<Scalars['String']['input']>;
  teacherPassword?: InputMaybe<Scalars['String']['input']>;
  timeDisplayMode?: InputMaybe<Scalars['String']['input']>;
  useClassShortname?: InputMaybe<Scalars['Boolean']['input']>;
  useRoomShortname?: InputMaybe<Scalars['Boolean']['input']>;
  useTeacherShortname?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubstitutionAppConfigWhere = {
  AND?: InputMaybe<Array<SubstitutionAppConfigWhere>>;
  NOT?: InputMaybe<SubstitutionAppConfigWhere>;
  OR?: InputMaybe<Array<SubstitutionAppConfigWhere>>;
  allowIndividualLogins?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  allowIndividualLogins_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showClassGroups?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showClassGroups_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showCurrentSubject?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showCurrentSubject_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showHolidays_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showOriginalSubject?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showOriginalSubject_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  studentPassword?: InputMaybe<Scalars['String']['input']>;
  studentPassword_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  studentPassword_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  studentPassword_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentPassword_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentPassword_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentPassword_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentPassword_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  studentPassword_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  studentPassword_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teacherPassword?: InputMaybe<Scalars['String']['input']>;
  teacherPassword_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  teacherPassword_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  teacherPassword_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherPassword_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherPassword_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherPassword_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherPassword_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teacherPassword_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teacherPassword_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeDisplayMode?: InputMaybe<Scalars['String']['input']>;
  timeDisplayMode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timeDisplayMode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeDisplayMode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeDisplayMode_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeDisplayMode_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeDisplayMode_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeDisplayMode_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeDisplayMode_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeDisplayMode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  useClassShortname?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  useClassShortname_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  useRoomShortname?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  useRoomShortname_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  useTeacherShortname?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  useTeacherShortname_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubstitutionAppConfigsConnection = {
  __typename?: 'SubstitutionAppConfigsConnection';
  edges: Array<SubstitutionAppConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SubstitutionColumns {
  Class = 'class',
  Comment = 'comment',
  Lesson = 'lesson',
  Missing = 'missing',
  Original = 'original',
  Reason = 'reason',
  Room = 'room',
  Subject = 'subject',
  Teacher = 'teacher',
}

export type SubstitutionPrintColumnConfig = {
  __typename?: 'SubstitutionPrintColumnConfig';
  column: SubstitutionColumns;
  position: Scalars['Int']['output'];
  print: Scalars['Boolean']['output'];
  sortDirection: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  width: Scalars['Float']['output'];
};

export type SubstitutionPrintColumnConfigAggregateSelection = {
  __typename?: 'SubstitutionPrintColumnConfigAggregateSelection';
  count: Scalars['Int']['output'];
  position: IntAggregateSelection;
  sortDirection: StringAggregateSelection;
  sortOrder: IntAggregateSelection;
  width: FloatAggregateSelection;
};

export type SubstitutionPrintColumnConfigConnectWhere = {
  node: SubstitutionPrintColumnConfigWhere;
};

export type SubstitutionPrintColumnConfigCreateInput = {
  column: SubstitutionColumns;
  position: Scalars['Int']['input'];
  print: Scalars['Boolean']['input'];
  sortDirection: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  width: Scalars['Float']['input'];
};

export type SubstitutionPrintColumnConfigEdge = {
  __typename?: 'SubstitutionPrintColumnConfigEdge';
  cursor: Scalars['String']['output'];
  node: SubstitutionPrintColumnConfig;
};

export type SubstitutionPrintColumnConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubstitutionPrintColumnConfigSort objects to sort SubstitutionPrintColumnConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubstitutionPrintColumnConfigSort>>;
};

/** Fields to sort SubstitutionPrintColumnConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubstitutionPrintColumnConfigSort object. */
export type SubstitutionPrintColumnConfigSort = {
  column?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  print?: InputMaybe<SortDirection>;
  sortDirection?: InputMaybe<SortDirection>;
  sortOrder?: InputMaybe<SortDirection>;
  width?: InputMaybe<SortDirection>;
};

export type SubstitutionPrintColumnConfigUpdateInput = {
  column?: InputMaybe<SubstitutionColumns>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  position_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_ADD?: InputMaybe<Scalars['Float']['input']>;
  width_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  width_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  width_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type SubstitutionPrintColumnConfigWhere = {
  AND?: InputMaybe<Array<SubstitutionPrintColumnConfigWhere>>;
  NOT?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  OR?: InputMaybe<Array<SubstitutionPrintColumnConfigWhere>>;
  column?: InputMaybe<SubstitutionColumns>;
  column_IN?: InputMaybe<Array<SubstitutionColumns>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  column_NOT?: InputMaybe<SubstitutionColumns>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  column_NOT_IN?: InputMaybe<Array<SubstitutionColumns>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_GT?: InputMaybe<Scalars['Int']['input']>;
  position_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  position_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  position_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  print_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortDirection_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sortDirection_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sortDirection_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortDirection_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortDirection_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortDirection_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortDirection_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortDirection_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sortDirection_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_GT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrder_LT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortOrder_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sortOrder_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  width?: InputMaybe<Scalars['Float']['input']>;
  width_GT?: InputMaybe<Scalars['Float']['input']>;
  width_GTE?: InputMaybe<Scalars['Float']['input']>;
  width_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  width_LT?: InputMaybe<Scalars['Float']['input']>;
  width_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  width_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  width_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type SubstitutionPrintColumnConfigsConnection = {
  __typename?: 'SubstitutionPrintColumnConfigsConnection';
  edges: Array<SubstitutionPrintColumnConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubstitutionPrintConfig = {
  __typename?: 'SubstitutionPrintConfig';
  columnConfigs: Array<SubstitutionPrintColumnConfig>;
  columnConfigsConnection: SubstitutionPrintConfigColumnConfigsConnection;
  fontScale: Scalars['Float']['output'];
  lineScale: Scalars['Float']['output'];
  pageOrientation: Scalars['String']['output'];
  printImages: Scalars['Boolean']['output'];
  showAnnouncements: Scalars['Boolean']['output'];
  showMissingTeachers: Scalars['Boolean']['output'];
  showMissingTeachersShortName: Scalars['Boolean']['output'];
  showSchoolEvents: Scalars['Boolean']['output'];
  useLessonName: Scalars['Boolean']['output'];
  useTeacherShortname: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export type SubstitutionPrintConfigColumnConfigsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubstitutionPrintColumnConfigOptions>;
  where?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
};

export type SubstitutionPrintConfigColumnConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsConnectionSort>>;
  where?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
};

export type SubstitutionPrintConfigAggregateSelection = {
  __typename?: 'SubstitutionPrintConfigAggregateSelection';
  count: Scalars['Int']['output'];
  fontScale: FloatAggregateSelection;
  lineScale: FloatAggregateSelection;
  pageOrientation: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubstitutionPrintConfigColumnConfigsAggregateInput = {
  AND?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsAggregateInput>>;
  NOT?: InputMaybe<SubstitutionPrintConfigColumnConfigsAggregateInput>;
  OR?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubstitutionPrintConfigColumnConfigsNodeAggregationWhereInput>;
};

export type SubstitutionPrintConfigColumnConfigsConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubstitutionPrintColumnConfigConnectWhere>;
};

export type SubstitutionPrintConfigColumnConfigsConnection = {
  __typename?: 'SubstitutionPrintConfigColumnConfigsConnection';
  edges: Array<SubstitutionPrintConfigColumnConfigsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubstitutionPrintConfigColumnConfigsConnectionSort = {
  node?: InputMaybe<SubstitutionPrintColumnConfigSort>;
};

export type SubstitutionPrintConfigColumnConfigsConnectionWhere = {
  AND?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsConnectionWhere>>;
  NOT?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
  OR?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsConnectionWhere>>;
  node?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
};

export type SubstitutionPrintConfigColumnConfigsCreateFieldInput = {
  node: SubstitutionPrintColumnConfigCreateInput;
};

export type SubstitutionPrintConfigColumnConfigsDeleteFieldInput = {
  where?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
};

export type SubstitutionPrintConfigColumnConfigsDisconnectFieldInput = {
  where?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
};

export type SubstitutionPrintConfigColumnConfigsFieldInput = {
  connect?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsCreateFieldInput>>;
};

export type SubstitutionPrintConfigColumnConfigsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubstitutionPrintConfigColumnConfigsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsNodeAggregationWhereInput>>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sortDirection_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sortDirection_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sortDirection_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sortDirection_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sortDirection_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sortDirection_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sortOrder_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sortOrder_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sortOrder_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sortOrder_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sortOrder_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  sortOrder_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  width_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  width_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  width_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  width_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  width_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  width_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  width_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  width_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  width_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  width_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  width_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  width_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  width_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  width_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  width_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  width_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  width_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  width_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  width_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  width_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type SubstitutionPrintConfigColumnConfigsRelationship = {
  __typename?: 'SubstitutionPrintConfigColumnConfigsRelationship';
  cursor: Scalars['String']['output'];
  node: SubstitutionPrintColumnConfig;
};

export type SubstitutionPrintConfigColumnConfigsUpdateConnectionInput = {
  node?: InputMaybe<SubstitutionPrintColumnConfigUpdateInput>;
};

export type SubstitutionPrintConfigColumnConfigsUpdateFieldInput = {
  connect?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsCreateFieldInput>>;
  delete?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsDisconnectFieldInput>>;
  update?: InputMaybe<SubstitutionPrintConfigColumnConfigsUpdateConnectionInput>;
  where?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
};

export type SubstitutionPrintConfigCreateInput = {
  columnConfigs?: InputMaybe<SubstitutionPrintConfigColumnConfigsFieldInput>;
  fontScale: Scalars['Float']['input'];
  lineScale: Scalars['Float']['input'];
  pageOrientation: Scalars['String']['input'];
  printImages: Scalars['Boolean']['input'];
  showAnnouncements: Scalars['Boolean']['input'];
  showMissingTeachers: Scalars['Boolean']['input'];
  showMissingTeachersShortName: Scalars['Boolean']['input'];
  showSchoolEvents: Scalars['Boolean']['input'];
  useLessonName: Scalars['Boolean']['input'];
  useTeacherShortname: Scalars['Boolean']['input'];
};

export type SubstitutionPrintConfigDeleteInput = {
  columnConfigs?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsDeleteFieldInput>>;
};

export type SubstitutionPrintConfigEdge = {
  __typename?: 'SubstitutionPrintConfigEdge';
  cursor: Scalars['String']['output'];
  node: SubstitutionPrintConfig;
};

export type SubstitutionPrintConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubstitutionPrintConfigSort objects to sort SubstitutionPrintConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubstitutionPrintConfigSort>>;
};

/** Fields to sort SubstitutionPrintConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubstitutionPrintConfigSort object. */
export type SubstitutionPrintConfigSort = {
  fontScale?: InputMaybe<SortDirection>;
  lineScale?: InputMaybe<SortDirection>;
  pageOrientation?: InputMaybe<SortDirection>;
  printImages?: InputMaybe<SortDirection>;
  showAnnouncements?: InputMaybe<SortDirection>;
  showMissingTeachers?: InputMaybe<SortDirection>;
  showMissingTeachersShortName?: InputMaybe<SortDirection>;
  showSchoolEvents?: InputMaybe<SortDirection>;
  useLessonName?: InputMaybe<SortDirection>;
  useTeacherShortname?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type SubstitutionPrintConfigUpdateInput = {
  columnConfigs?: InputMaybe<Array<SubstitutionPrintConfigColumnConfigsUpdateFieldInput>>;
  fontScale?: InputMaybe<Scalars['Float']['input']>;
  fontScale_ADD?: InputMaybe<Scalars['Float']['input']>;
  fontScale_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  fontScale_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  fontScale_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  lineScale?: InputMaybe<Scalars['Float']['input']>;
  lineScale_ADD?: InputMaybe<Scalars['Float']['input']>;
  lineScale_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  lineScale_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  lineScale_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  pageOrientation?: InputMaybe<Scalars['String']['input']>;
  printImages?: InputMaybe<Scalars['Boolean']['input']>;
  showAnnouncements?: InputMaybe<Scalars['Boolean']['input']>;
  showMissingTeachers?: InputMaybe<Scalars['Boolean']['input']>;
  showMissingTeachersShortName?: InputMaybe<Scalars['Boolean']['input']>;
  showSchoolEvents?: InputMaybe<Scalars['Boolean']['input']>;
  useLessonName?: InputMaybe<Scalars['Boolean']['input']>;
  useTeacherShortname?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubstitutionPrintConfigWhere = {
  AND?: InputMaybe<Array<SubstitutionPrintConfigWhere>>;
  NOT?: InputMaybe<SubstitutionPrintConfigWhere>;
  OR?: InputMaybe<Array<SubstitutionPrintConfigWhere>>;
  /** @deprecated Use `columnConfigs_SOME` instead. */
  columnConfigs?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  columnConfigsAggregate?: InputMaybe<SubstitutionPrintConfigColumnConfigsAggregateInput>;
  /** @deprecated Use `columnConfigsConnection_SOME` instead. */
  columnConfigsConnection?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
  /** Return SubstitutionPrintConfigs where all of the related SubstitutionPrintConfigColumnConfigsConnections match this filter */
  columnConfigsConnection_ALL?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
  /** Return SubstitutionPrintConfigs where none of the related SubstitutionPrintConfigColumnConfigsConnections match this filter */
  columnConfigsConnection_NONE?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
  /** @deprecated Use `columnConfigsConnection_NONE` instead. */
  columnConfigsConnection_NOT?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
  /** Return SubstitutionPrintConfigs where one of the related SubstitutionPrintConfigColumnConfigsConnections match this filter */
  columnConfigsConnection_SINGLE?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
  /** Return SubstitutionPrintConfigs where some of the related SubstitutionPrintConfigColumnConfigsConnections match this filter */
  columnConfigsConnection_SOME?: InputMaybe<SubstitutionPrintConfigColumnConfigsConnectionWhere>;
  /** Return SubstitutionPrintConfigs where all of the related SubstitutionPrintColumnConfigs match this filter */
  columnConfigs_ALL?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  /** Return SubstitutionPrintConfigs where none of the related SubstitutionPrintColumnConfigs match this filter */
  columnConfigs_NONE?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  /** @deprecated Use `columnConfigs_NONE` instead. */
  columnConfigs_NOT?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  /** Return SubstitutionPrintConfigs where one of the related SubstitutionPrintColumnConfigs match this filter */
  columnConfigs_SINGLE?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  /** Return SubstitutionPrintConfigs where some of the related SubstitutionPrintColumnConfigs match this filter */
  columnConfigs_SOME?: InputMaybe<SubstitutionPrintColumnConfigWhere>;
  fontScale?: InputMaybe<Scalars['Float']['input']>;
  fontScale_GT?: InputMaybe<Scalars['Float']['input']>;
  fontScale_GTE?: InputMaybe<Scalars['Float']['input']>;
  fontScale_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  fontScale_LT?: InputMaybe<Scalars['Float']['input']>;
  fontScale_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fontScale_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fontScale_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  lineScale?: InputMaybe<Scalars['Float']['input']>;
  lineScale_GT?: InputMaybe<Scalars['Float']['input']>;
  lineScale_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineScale_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  lineScale_LT?: InputMaybe<Scalars['Float']['input']>;
  lineScale_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lineScale_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lineScale_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  pageOrientation?: InputMaybe<Scalars['String']['input']>;
  pageOrientation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pageOrientation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pageOrientation_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pageOrientation_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pageOrientation_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pageOrientation_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pageOrientation_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pageOrientation_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pageOrientation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  printImages?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printImages_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showAnnouncements?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showAnnouncements_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showMissingTeachers?: InputMaybe<Scalars['Boolean']['input']>;
  showMissingTeachersShortName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showMissingTeachersShortName_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showMissingTeachers_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showSchoolEvents?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showSchoolEvents_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  useLessonName?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  useLessonName_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  useTeacherShortname?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  useTeacherShortname_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubstitutionPrintConfigsConnection = {
  __typename?: 'SubstitutionPrintConfigsConnection';
  edges: Array<SubstitutionPrintConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SubstitutionReason {
  Aggregated = 'AGGREGATED',
  Cancelled = 'CANCELLED',
  Moved = 'MOVED',
  SelfWork = 'SELF_WORK',
  Substituted = 'SUBSTITUTED',
}

export type SubstitutionReport = {
  __typename?: 'SubstitutionReport';
  context: PdfReportContext;
  contextConnection: SubstitutionReportContextConnection;
  fileEntries: Array<FileEntry>;
  fileEntriesAggregate?: Maybe<SubstitutionReportFileEntryFileEntriesAggregationSelection>;
  fileEntriesConnection: SubstitutionReportFileEntriesConnection;
  jobConfiguration: Scalars['String']['output'];
  jobCreated: Scalars['DateTime']['output'];
  jobFinished: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: SubstitutionReportType;
  uuid: Scalars['ID']['output'];
};

export type SubstitutionReportContextArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PdfReportContextWhere>;
};

export type SubstitutionReportContextConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubstitutionReportContextConnectionSort>>;
  where?: InputMaybe<SubstitutionReportContextConnectionWhere>;
};

export type SubstitutionReportFileEntriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileEntryOptions>;
  where?: InputMaybe<FileEntryWhere>;
};

export type SubstitutionReportFileEntriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileEntryWhere>;
};

export type SubstitutionReportFileEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubstitutionReportFileEntriesConnectionSort>>;
  where?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
};

export type SubstitutionReportAggregateSelection = {
  __typename?: 'SubstitutionReportAggregateSelection';
  count: Scalars['Int']['output'];
  jobConfiguration: StringAggregateSelection;
  jobCreated: DateTimeAggregateSelection;
  jobFinished: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubstitutionReportConnectInput = {
  context?: InputMaybe<SubstitutionReportContextConnectInput>;
  fileEntries?: InputMaybe<Array<SubstitutionReportFileEntriesConnectFieldInput>>;
};

export type SubstitutionReportConnectWhere = {
  node: SubstitutionReportWhere;
};

export type SubstitutionReportContextConnectInput = {
  SchoolYear?: InputMaybe<SubstitutionReportContextSchoolYearConnectFieldInput>;
  TeachingBlock?: InputMaybe<SubstitutionReportContextTeachingBlockConnectFieldInput>;
  TimetableBlock?: InputMaybe<SubstitutionReportContextTimetableBlockConnectFieldInput>;
};

export type SubstitutionReportContextConnection = {
  __typename?: 'SubstitutionReportContextConnection';
  edges: Array<SubstitutionReportContextRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubstitutionReportContextConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
};

export type SubstitutionReportContextConnectionWhere = {
  SchoolYear?: InputMaybe<SubstitutionReportContextSchoolYearConnectionWhere>;
  TeachingBlock?: InputMaybe<SubstitutionReportContextTeachingBlockConnectionWhere>;
  TimetableBlock?: InputMaybe<SubstitutionReportContextTimetableBlockConnectionWhere>;
};

export type SubstitutionReportContextCreateInput = {
  SchoolYear?: InputMaybe<SubstitutionReportContextSchoolYearFieldInput>;
  TeachingBlock?: InputMaybe<SubstitutionReportContextTeachingBlockFieldInput>;
  TimetableBlock?: InputMaybe<SubstitutionReportContextTimetableBlockFieldInput>;
};

export type SubstitutionReportContextDeleteInput = {
  SchoolYear?: InputMaybe<SubstitutionReportContextSchoolYearDeleteFieldInput>;
  TeachingBlock?: InputMaybe<SubstitutionReportContextTeachingBlockDeleteFieldInput>;
  TimetableBlock?: InputMaybe<SubstitutionReportContextTimetableBlockDeleteFieldInput>;
};

export type SubstitutionReportContextDisconnectInput = {
  SchoolYear?: InputMaybe<SubstitutionReportContextSchoolYearDisconnectFieldInput>;
  TeachingBlock?: InputMaybe<SubstitutionReportContextTeachingBlockDisconnectFieldInput>;
  TimetableBlock?: InputMaybe<SubstitutionReportContextTimetableBlockDisconnectFieldInput>;
};

export type SubstitutionReportContextRelationship = {
  __typename?: 'SubstitutionReportContextRelationship';
  cursor: Scalars['String']['output'];
  node: PdfReportContext;
  properties: OrderedRelationProperties;
};

export type SubstitutionReportContextSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type SubstitutionReportContextSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<SubstitutionReportContextSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<SubstitutionReportContextSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<SubstitutionReportContextSchoolYearConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type SubstitutionReportContextSchoolYearCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: SchoolYearCreateInput;
};

export type SubstitutionReportContextSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<SubstitutionReportContextSchoolYearConnectionWhere>;
};

export type SubstitutionReportContextSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<SubstitutionReportContextSchoolYearConnectionWhere>;
};

export type SubstitutionReportContextSchoolYearFieldInput = {
  connect?: InputMaybe<SubstitutionReportContextSchoolYearConnectFieldInput>;
  create?: InputMaybe<SubstitutionReportContextSchoolYearCreateFieldInput>;
};

export type SubstitutionReportContextSchoolYearUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type SubstitutionReportContextSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<SubstitutionReportContextSchoolYearConnectFieldInput>;
  create?: InputMaybe<SubstitutionReportContextSchoolYearCreateFieldInput>;
  delete?: InputMaybe<SubstitutionReportContextSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<SubstitutionReportContextSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<SubstitutionReportContextSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<SubstitutionReportContextSchoolYearConnectionWhere>;
};

export type SubstitutionReportContextTeachingBlockConnectFieldInput = {
  connect?: InputMaybe<TeachingBlockConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TeachingBlockConnectWhere>;
};

export type SubstitutionReportContextTeachingBlockConnectOrCreateFieldInput = {
  onCreate: SubstitutionReportContextTeachingBlockConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockConnectOrCreateWhere;
};

export type SubstitutionReportContextTeachingBlockConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingBlockOnCreateInput;
};

export type SubstitutionReportContextTeachingBlockConnectionWhere = {
  AND?: InputMaybe<Array<SubstitutionReportContextTeachingBlockConnectionWhere>>;
  NOT?: InputMaybe<SubstitutionReportContextTeachingBlockConnectionWhere>;
  OR?: InputMaybe<Array<SubstitutionReportContextTeachingBlockConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockWhere>;
};

export type SubstitutionReportContextTeachingBlockCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingBlockCreateInput;
};

export type SubstitutionReportContextTeachingBlockDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockDeleteInput>;
  where?: InputMaybe<SubstitutionReportContextTeachingBlockConnectionWhere>;
};

export type SubstitutionReportContextTeachingBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockDisconnectInput>;
  where?: InputMaybe<SubstitutionReportContextTeachingBlockConnectionWhere>;
};

export type SubstitutionReportContextTeachingBlockFieldInput = {
  connect?: InputMaybe<SubstitutionReportContextTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubstitutionReportContextTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<SubstitutionReportContextTeachingBlockCreateFieldInput>;
};

export type SubstitutionReportContextTeachingBlockUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingBlockUpdateInput>;
};

export type SubstitutionReportContextTeachingBlockUpdateFieldInput = {
  connect?: InputMaybe<SubstitutionReportContextTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubstitutionReportContextTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<SubstitutionReportContextTeachingBlockCreateFieldInput>;
  delete?: InputMaybe<SubstitutionReportContextTeachingBlockDeleteFieldInput>;
  disconnect?: InputMaybe<SubstitutionReportContextTeachingBlockDisconnectFieldInput>;
  update?: InputMaybe<SubstitutionReportContextTeachingBlockUpdateConnectionInput>;
  where?: InputMaybe<SubstitutionReportContextTeachingBlockConnectionWhere>;
};

export type SubstitutionReportContextTimetableBlockConnectFieldInput = {
  connect?: InputMaybe<TimetableBlockConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TimetableBlockConnectWhere>;
};

export type SubstitutionReportContextTimetableBlockConnectionWhere = {
  AND?: InputMaybe<Array<SubstitutionReportContextTimetableBlockConnectionWhere>>;
  NOT?: InputMaybe<SubstitutionReportContextTimetableBlockConnectionWhere>;
  OR?: InputMaybe<Array<SubstitutionReportContextTimetableBlockConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableBlockWhere>;
};

export type SubstitutionReportContextTimetableBlockCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TimetableBlockCreateInput;
};

export type SubstitutionReportContextTimetableBlockDeleteFieldInput = {
  delete?: InputMaybe<TimetableBlockDeleteInput>;
  where?: InputMaybe<SubstitutionReportContextTimetableBlockConnectionWhere>;
};

export type SubstitutionReportContextTimetableBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableBlockDisconnectInput>;
  where?: InputMaybe<SubstitutionReportContextTimetableBlockConnectionWhere>;
};

export type SubstitutionReportContextTimetableBlockFieldInput = {
  connect?: InputMaybe<SubstitutionReportContextTimetableBlockConnectFieldInput>;
  create?: InputMaybe<SubstitutionReportContextTimetableBlockCreateFieldInput>;
};

export type SubstitutionReportContextTimetableBlockUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TimetableBlockUpdateInput>;
};

export type SubstitutionReportContextTimetableBlockUpdateFieldInput = {
  connect?: InputMaybe<SubstitutionReportContextTimetableBlockConnectFieldInput>;
  create?: InputMaybe<SubstitutionReportContextTimetableBlockCreateFieldInput>;
  delete?: InputMaybe<SubstitutionReportContextTimetableBlockDeleteFieldInput>;
  disconnect?: InputMaybe<SubstitutionReportContextTimetableBlockDisconnectFieldInput>;
  update?: InputMaybe<SubstitutionReportContextTimetableBlockUpdateConnectionInput>;
  where?: InputMaybe<SubstitutionReportContextTimetableBlockConnectionWhere>;
};

export type SubstitutionReportContextUpdateInput = {
  SchoolYear?: InputMaybe<SubstitutionReportContextSchoolYearUpdateFieldInput>;
  TeachingBlock?: InputMaybe<SubstitutionReportContextTeachingBlockUpdateFieldInput>;
  TimetableBlock?: InputMaybe<SubstitutionReportContextTimetableBlockUpdateFieldInput>;
};

export type SubstitutionReportCreateInput = {
  context?: InputMaybe<SubstitutionReportContextCreateInput>;
  fileEntries?: InputMaybe<SubstitutionReportFileEntriesFieldInput>;
  jobConfiguration: Scalars['String']['input'];
  jobFinished: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: SubstitutionReportType;
};

export type SubstitutionReportDeleteInput = {
  context?: InputMaybe<SubstitutionReportContextDeleteInput>;
  fileEntries?: InputMaybe<Array<SubstitutionReportFileEntriesDeleteFieldInput>>;
};

export type SubstitutionReportDisconnectInput = {
  context?: InputMaybe<SubstitutionReportContextDisconnectInput>;
  fileEntries?: InputMaybe<Array<SubstitutionReportFileEntriesDisconnectFieldInput>>;
};

export type SubstitutionReportEdge = {
  __typename?: 'SubstitutionReportEdge';
  cursor: Scalars['String']['output'];
  node: SubstitutionReport;
};

export type SubstitutionReportFileEntriesAggregateInput = {
  AND?: InputMaybe<Array<SubstitutionReportFileEntriesAggregateInput>>;
  NOT?: InputMaybe<SubstitutionReportFileEntriesAggregateInput>;
  OR?: InputMaybe<Array<SubstitutionReportFileEntriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<SubstitutionReportFileEntriesNodeAggregationWhereInput>;
};

export type SubstitutionReportFileEntriesConnectFieldInput = {
  connect?: InputMaybe<Array<FileEntryConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileEntryConnectWhere>;
};

export type SubstitutionReportFileEntriesConnection = {
  __typename?: 'SubstitutionReportFileEntriesConnection';
  edges: Array<SubstitutionReportFileEntriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubstitutionReportFileEntriesConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<FileEntrySort>;
};

export type SubstitutionReportFileEntriesConnectionWhere = {
  AND?: InputMaybe<Array<SubstitutionReportFileEntriesConnectionWhere>>;
  NOT?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
  OR?: InputMaybe<Array<SubstitutionReportFileEntriesConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<FileEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<FileEntryWhere>;
};

export type SubstitutionReportFileEntriesCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: FileEntryCreateInput;
};

export type SubstitutionReportFileEntriesDeleteFieldInput = {
  delete?: InputMaybe<FileEntryDeleteInput>;
  where?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
};

export type SubstitutionReportFileEntriesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileEntryDisconnectInput>;
  where?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
};

export type SubstitutionReportFileEntriesFieldInput = {
  connect?: InputMaybe<Array<SubstitutionReportFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<SubstitutionReportFileEntriesCreateFieldInput>>;
};

export type SubstitutionReportFileEntriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubstitutionReportFileEntriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubstitutionReportFileEntriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubstitutionReportFileEntriesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filename_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filename_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubstitutionReportFileEntriesRelationship = {
  __typename?: 'SubstitutionReportFileEntriesRelationship';
  cursor: Scalars['String']['output'];
  node: FileEntry;
  properties: OrderedRelationProperties;
};

export type SubstitutionReportFileEntriesUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<FileEntryUpdateInput>;
};

export type SubstitutionReportFileEntriesUpdateFieldInput = {
  connect?: InputMaybe<Array<SubstitutionReportFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<SubstitutionReportFileEntriesCreateFieldInput>>;
  delete?: InputMaybe<Array<SubstitutionReportFileEntriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubstitutionReportFileEntriesDisconnectFieldInput>>;
  update?: InputMaybe<SubstitutionReportFileEntriesUpdateConnectionInput>;
  where?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
};

export type SubstitutionReportFileEntryFileEntriesAggregationSelection = {
  __typename?: 'SubstitutionReportFileEntryFileEntriesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<SubstitutionReportFileEntryFileEntriesEdgeAggregateSelection>;
  node?: Maybe<SubstitutionReportFileEntryFileEntriesNodeAggregateSelection>;
};

export type SubstitutionReportFileEntryFileEntriesEdgeAggregateSelection = {
  __typename?: 'SubstitutionReportFileEntryFileEntriesEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type SubstitutionReportFileEntryFileEntriesNodeAggregateSelection = {
  __typename?: 'SubstitutionReportFileEntryFileEntriesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  filename: StringAggregateSelection;
  mediaType: StringAggregateSelection;
  size: IntAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type SubstitutionReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubstitutionReportSort objects to sort SubstitutionReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubstitutionReportSort>>;
};

/** Fields to sort SubstitutionReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubstitutionReportSort object. */
export type SubstitutionReportSort = {
  jobConfiguration?: InputMaybe<SortDirection>;
  jobCreated?: InputMaybe<SortDirection>;
  jobFinished?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export enum SubstitutionReportType {
  StatisticExcel = 'statisticExcel',
  StatisticMonth = 'statisticMonth',
  StatisticTotal = 'statisticTotal',
}

export type SubstitutionReportUpdateInput = {
  context?: InputMaybe<SubstitutionReportContextUpdateInput>;
  fileEntries?: InputMaybe<Array<SubstitutionReportFileEntriesUpdateFieldInput>>;
  jobConfiguration?: InputMaybe<Scalars['String']['input']>;
  jobCreated?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SubstitutionReportType>;
};

export type SubstitutionReportWhere = {
  AND?: InputMaybe<Array<SubstitutionReportWhere>>;
  NOT?: InputMaybe<SubstitutionReportWhere>;
  OR?: InputMaybe<Array<SubstitutionReportWhere>>;
  context?: InputMaybe<PdfReportContextWhere>;
  contextConnection?: InputMaybe<SubstitutionReportContextConnectionWhere>;
  contextConnection_NOT?: InputMaybe<SubstitutionReportContextConnectionWhere>;
  context_NOT?: InputMaybe<PdfReportContextWhere>;
  /** @deprecated Use `fileEntries_SOME` instead. */
  fileEntries?: InputMaybe<FileEntryWhere>;
  fileEntriesAggregate?: InputMaybe<SubstitutionReportFileEntriesAggregateInput>;
  /** @deprecated Use `fileEntriesConnection_SOME` instead. */
  fileEntriesConnection?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
  /** Return SubstitutionReports where all of the related SubstitutionReportFileEntriesConnections match this filter */
  fileEntriesConnection_ALL?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
  /** Return SubstitutionReports where none of the related SubstitutionReportFileEntriesConnections match this filter */
  fileEntriesConnection_NONE?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
  /** @deprecated Use `fileEntriesConnection_NONE` instead. */
  fileEntriesConnection_NOT?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
  /** Return SubstitutionReports where one of the related SubstitutionReportFileEntriesConnections match this filter */
  fileEntriesConnection_SINGLE?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
  /** Return SubstitutionReports where some of the related SubstitutionReportFileEntriesConnections match this filter */
  fileEntriesConnection_SOME?: InputMaybe<SubstitutionReportFileEntriesConnectionWhere>;
  /** Return SubstitutionReports where all of the related FileEntries match this filter */
  fileEntries_ALL?: InputMaybe<FileEntryWhere>;
  /** Return SubstitutionReports where none of the related FileEntries match this filter */
  fileEntries_NONE?: InputMaybe<FileEntryWhere>;
  /** @deprecated Use `fileEntries_NONE` instead. */
  fileEntries_NOT?: InputMaybe<FileEntryWhere>;
  /** Return SubstitutionReports where one of the related FileEntries match this filter */
  fileEntries_SINGLE?: InputMaybe<FileEntryWhere>;
  /** Return SubstitutionReports where some of the related FileEntries match this filter */
  fileEntries_SOME?: InputMaybe<FileEntryWhere>;
  jobConfiguration?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobCreated?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobCreated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobCreated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobCreated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobFinished?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_GT?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobFinished_LT?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobFinished_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobFinished_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SubstitutionReportType>;
  type_IN?: InputMaybe<Array<SubstitutionReportType>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT?: InputMaybe<SubstitutionReportType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT_IN?: InputMaybe<Array<SubstitutionReportType>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SubstitutionReportsConnection = {
  __typename?: 'SubstitutionReportsConnection';
  edges: Array<SubstitutionReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TableConfig = {
  __typename?: 'TableConfig';
  columnsSort: Array<ColumnSort>;
  columnsSortConnection: TableConfigColumnsSortConnection;
  hiddenColumns: Array<Scalars['String']['output']>;
  owner: UserConfig;
  ownerConnection: TableConfigOwnerConnection;
  table: Scalars['String']['output'];
};

export type TableConfigColumnsSortArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ColumnSortOptions>;
  where?: InputMaybe<ColumnSortWhere>;
};

export type TableConfigColumnsSortConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TableConfigColumnsSortConnectionSort>>;
  where?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
};

export type TableConfigOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserConfigOptions>;
  where?: InputMaybe<UserConfigWhere>;
};

export type TableConfigOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TableConfigOwnerConnectionSort>>;
  where?: InputMaybe<TableConfigOwnerConnectionWhere>;
};

export type TableConfigAggregateSelection = {
  __typename?: 'TableConfigAggregateSelection';
  count: Scalars['Int']['output'];
  table: StringAggregateSelection;
};

export type TableConfigColumnsSortAggregateInput = {
  AND?: InputMaybe<Array<TableConfigColumnsSortAggregateInput>>;
  NOT?: InputMaybe<TableConfigColumnsSortAggregateInput>;
  OR?: InputMaybe<Array<TableConfigColumnsSortAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<TableConfigColumnsSortNodeAggregationWhereInput>;
};

export type TableConfigColumnsSortConnectFieldInput = {
  connect?: InputMaybe<Array<ColumnSortConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ColumnSortConnectWhere>;
};

export type TableConfigColumnsSortConnection = {
  __typename?: 'TableConfigColumnsSortConnection';
  edges: Array<TableConfigColumnsSortRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TableConfigColumnsSortConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<ColumnSortSort>;
};

export type TableConfigColumnsSortConnectionWhere = {
  AND?: InputMaybe<Array<TableConfigColumnsSortConnectionWhere>>;
  NOT?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
  OR?: InputMaybe<Array<TableConfigColumnsSortConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<ColumnSortWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ColumnSortWhere>;
};

export type TableConfigColumnsSortCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: ColumnSortCreateInput;
};

export type TableConfigColumnsSortDeleteFieldInput = {
  delete?: InputMaybe<ColumnSortDeleteInput>;
  where?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
};

export type TableConfigColumnsSortDisconnectFieldInput = {
  disconnect?: InputMaybe<ColumnSortDisconnectInput>;
  where?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
};

export type TableConfigColumnsSortFieldInput = {
  connect?: InputMaybe<Array<TableConfigColumnsSortConnectFieldInput>>;
  create?: InputMaybe<Array<TableConfigColumnsSortCreateFieldInput>>;
};

export type TableConfigColumnsSortNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TableConfigColumnsSortNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TableConfigColumnsSortNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TableConfigColumnsSortNodeAggregationWhereInput>>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TableConfigColumnsSortRelationship = {
  __typename?: 'TableConfigColumnsSortRelationship';
  cursor: Scalars['String']['output'];
  node: ColumnSort;
  properties: OrderedRelationProperties;
};

export type TableConfigColumnsSortUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<ColumnSortUpdateInput>;
};

export type TableConfigColumnsSortUpdateFieldInput = {
  connect?: InputMaybe<Array<TableConfigColumnsSortConnectFieldInput>>;
  create?: InputMaybe<Array<TableConfigColumnsSortCreateFieldInput>>;
  delete?: InputMaybe<Array<TableConfigColumnsSortDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TableConfigColumnsSortDisconnectFieldInput>>;
  update?: InputMaybe<TableConfigColumnsSortUpdateConnectionInput>;
  where?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
};

export type TableConfigConnectInput = {
  columnsSort?: InputMaybe<Array<TableConfigColumnsSortConnectFieldInput>>;
  owner?: InputMaybe<TableConfigOwnerConnectFieldInput>;
};

export type TableConfigConnectWhere = {
  node: TableConfigWhere;
};

export type TableConfigCreateInput = {
  columnsSort?: InputMaybe<TableConfigColumnsSortFieldInput>;
  hiddenColumns: Array<Scalars['String']['input']>;
  owner?: InputMaybe<TableConfigOwnerFieldInput>;
  table: Scalars['String']['input'];
};

export type TableConfigDeleteInput = {
  columnsSort?: InputMaybe<Array<TableConfigColumnsSortDeleteFieldInput>>;
  owner?: InputMaybe<TableConfigOwnerDeleteFieldInput>;
};

export type TableConfigDisconnectInput = {
  columnsSort?: InputMaybe<Array<TableConfigColumnsSortDisconnectFieldInput>>;
  owner?: InputMaybe<TableConfigOwnerDisconnectFieldInput>;
};

export type TableConfigEdge = {
  __typename?: 'TableConfigEdge';
  cursor: Scalars['String']['output'];
  node: TableConfig;
};

export type TableConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TableConfigSort objects to sort TableConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TableConfigSort>>;
};

export type TableConfigOwnerAggregateInput = {
  AND?: InputMaybe<Array<TableConfigOwnerAggregateInput>>;
  NOT?: InputMaybe<TableConfigOwnerAggregateInput>;
  OR?: InputMaybe<Array<TableConfigOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TableConfigOwnerNodeAggregationWhereInput>;
};

export type TableConfigOwnerConnectFieldInput = {
  connect?: InputMaybe<UserConfigConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConfigConnectWhere>;
};

export type TableConfigOwnerConnection = {
  __typename?: 'TableConfigOwnerConnection';
  edges: Array<TableConfigOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TableConfigOwnerConnectionSort = {
  node?: InputMaybe<UserConfigSort>;
};

export type TableConfigOwnerConnectionWhere = {
  AND?: InputMaybe<Array<TableConfigOwnerConnectionWhere>>;
  NOT?: InputMaybe<TableConfigOwnerConnectionWhere>;
  OR?: InputMaybe<Array<TableConfigOwnerConnectionWhere>>;
  node?: InputMaybe<UserConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<UserConfigWhere>;
};

export type TableConfigOwnerCreateFieldInput = {
  node: UserConfigCreateInput;
};

export type TableConfigOwnerDeleteFieldInput = {
  delete?: InputMaybe<UserConfigDeleteInput>;
  where?: InputMaybe<TableConfigOwnerConnectionWhere>;
};

export type TableConfigOwnerDisconnectFieldInput = {
  disconnect?: InputMaybe<UserConfigDisconnectInput>;
  where?: InputMaybe<TableConfigOwnerConnectionWhere>;
};

export type TableConfigOwnerFieldInput = {
  connect?: InputMaybe<TableConfigOwnerConnectFieldInput>;
  create?: InputMaybe<TableConfigOwnerCreateFieldInput>;
};

export type TableConfigOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TableConfigOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TableConfigOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TableConfigOwnerNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TableConfigOwnerRelationship = {
  __typename?: 'TableConfigOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: UserConfig;
};

export type TableConfigOwnerUpdateConnectionInput = {
  node?: InputMaybe<UserConfigUpdateInput>;
};

export type TableConfigOwnerUpdateFieldInput = {
  connect?: InputMaybe<TableConfigOwnerConnectFieldInput>;
  create?: InputMaybe<TableConfigOwnerCreateFieldInput>;
  delete?: InputMaybe<TableConfigOwnerDeleteFieldInput>;
  disconnect?: InputMaybe<TableConfigOwnerDisconnectFieldInput>;
  update?: InputMaybe<TableConfigOwnerUpdateConnectionInput>;
  where?: InputMaybe<TableConfigOwnerConnectionWhere>;
};

/** Fields to sort TableConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one TableConfigSort object. */
export type TableConfigSort = {
  table?: InputMaybe<SortDirection>;
};

export type TableConfigUpdateInput = {
  columnsSort?: InputMaybe<Array<TableConfigColumnsSortUpdateFieldInput>>;
  hiddenColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  hiddenColumns_POP?: InputMaybe<Scalars['Int']['input']>;
  hiddenColumns_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  owner?: InputMaybe<TableConfigOwnerUpdateFieldInput>;
  table?: InputMaybe<Scalars['String']['input']>;
};

export type TableConfigWhere = {
  AND?: InputMaybe<Array<TableConfigWhere>>;
  NOT?: InputMaybe<TableConfigWhere>;
  OR?: InputMaybe<Array<TableConfigWhere>>;
  /** @deprecated Use `columnsSort_SOME` instead. */
  columnsSort?: InputMaybe<ColumnSortWhere>;
  columnsSortAggregate?: InputMaybe<TableConfigColumnsSortAggregateInput>;
  /** @deprecated Use `columnsSortConnection_SOME` instead. */
  columnsSortConnection?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
  /** Return TableConfigs where all of the related TableConfigColumnsSortConnections match this filter */
  columnsSortConnection_ALL?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
  /** Return TableConfigs where none of the related TableConfigColumnsSortConnections match this filter */
  columnsSortConnection_NONE?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
  /** @deprecated Use `columnsSortConnection_NONE` instead. */
  columnsSortConnection_NOT?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
  /** Return TableConfigs where one of the related TableConfigColumnsSortConnections match this filter */
  columnsSortConnection_SINGLE?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
  /** Return TableConfigs where some of the related TableConfigColumnsSortConnections match this filter */
  columnsSortConnection_SOME?: InputMaybe<TableConfigColumnsSortConnectionWhere>;
  /** Return TableConfigs where all of the related ColumnSorts match this filter */
  columnsSort_ALL?: InputMaybe<ColumnSortWhere>;
  /** Return TableConfigs where none of the related ColumnSorts match this filter */
  columnsSort_NONE?: InputMaybe<ColumnSortWhere>;
  /** @deprecated Use `columnsSort_NONE` instead. */
  columnsSort_NOT?: InputMaybe<ColumnSortWhere>;
  /** Return TableConfigs where one of the related ColumnSorts match this filter */
  columnsSort_SINGLE?: InputMaybe<ColumnSortWhere>;
  /** Return TableConfigs where some of the related ColumnSorts match this filter */
  columnsSort_SOME?: InputMaybe<ColumnSortWhere>;
  hiddenColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  hiddenColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hiddenColumns_NOT?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  hiddenColumns_NOT_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UserConfigWhere>;
  ownerAggregate?: InputMaybe<TableConfigOwnerAggregateInput>;
  ownerConnection?: InputMaybe<TableConfigOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<TableConfigOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<UserConfigWhere>;
  table?: InputMaybe<Scalars['String']['input']>;
  table_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  table_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  table_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  table_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  table_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  table_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  table_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  table_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  table_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TableConfigsConnection = {
  __typename?: 'TableConfigsConnection';
  edges: Array<TableConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeacherGridCard = {
  __typename?: 'TeacherGridCard';
  colors: Array<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  startTimeGridEntryUuid?: Maybe<Scalars['ID']['output']>;
  teacherUuid: Scalars['ID']['output'];
  timetableCardUuid: Scalars['ID']['output'];
  uuid: Scalars['ID']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};

export type TeacherSubstitutionStats = {
  __typename?: 'TeacherSubstitutionStats';
  givenSubstituteHours: Scalars['Int']['output'];
  sameClass?: Maybe<Scalars['Boolean']['output']>;
  sameSubject?: Maybe<Scalars['Boolean']['output']>;
  substituteHours?: Maybe<Scalars['Int']['output']>;
  teacherUuid: Scalars['ID']['output'];
};

export type TeacherTeachingLoad = {
  __typename?: 'TeacherTeachingLoad';
  countClasses: Scalars['Int']['output'];
  countTeacher: Scalars['Int']['output'];
  deputat: Scalars['Float']['output'];
  factor: Scalars['Float']['output'];
  lessonClass: Array<LessonClassInterface>;
  lessonClassesDisplayName: Scalars['String']['output'];
  lessonUuid: Scalars['String']['output'];
  organization: Organization;
  partialClasses: Scalars['Boolean']['output'];
  relevantFactors: Array<TeachingLoadFactor>;
  schoolYear: SchoolYear;
  studentCards?: Maybe<Scalars['Float']['output']>;
  studentHours?: Maybe<Scalars['Float']['output']>;
  subjectContainerDisplayName?: Maybe<Scalars['String']['output']>;
  subjectContainerUuid?: Maybe<Scalars['String']['output']>;
  subjectDisplayName: Scalars['String']['output'];
  subjectUuid: Scalars['String']['output'];
  teacherCards?: Maybe<Scalars['Float']['output']>;
  teacherDisplayName: Scalars['String']['output'];
  teacherHours?: Maybe<Scalars['Float']['output']>;
  teacherUuid: Scalars['String']['output'];
  teachingBlockWeeks?: Maybe<Scalars['Float']['output']>;
  teachingBlocks?: Maybe<Scalars['Float']['output']>;
  timetableBlockDisplayName?: Maybe<Scalars['String']['output']>;
  timetableBlockSortName?: Maybe<Scalars['String']['output']>;
  timetableBlockUuid?: Maybe<Scalars['String']['output']>;
};

export type TeachingBlock = {
  __typename?: 'TeachingBlock';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  draft: Scalars['Boolean']['output'];
  foreignId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: TeachingBlockOrganizationConnection;
  schoolYear: SchoolYear;
  schoolYearConnection: TeachingBlockSchoolYearConnection;
  subjectContainer: SubjectContainer;
  subjectContainerAggregate?: Maybe<TeachingBlockSubjectContainerSubjectContainerAggregationSelection>;
  subjectContainerConnection: TeachingBlockSubjectContainerConnection;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  versions: Array<TeachingBlockVersion>;
  versionsAggregate?: Maybe<TeachingBlockTeachingBlockVersionVersionsAggregationSelection>;
  versionsConnection: TeachingBlockVersionsConnection;
};

export type TeachingBlockOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TeachingBlockOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockOrganizationConnectionSort>>;
  where?: InputMaybe<TeachingBlockOrganizationConnectionWhere>;
};

export type TeachingBlockSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type TeachingBlockSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockSchoolYearConnectionSort>>;
  where?: InputMaybe<TeachingBlockSchoolYearConnectionWhere>;
};

export type TeachingBlockSubjectContainerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectContainerOptions>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type TeachingBlockSubjectContainerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type TeachingBlockSubjectContainerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockSubjectContainerConnectionSort>>;
  where?: InputMaybe<TeachingBlockSubjectContainerConnectionWhere>;
};

export type TeachingBlockVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockVersionOptions>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlockVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlockVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionsConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
};

export type TeachingBlockAggregateSelection = {
  __typename?: 'TeachingBlockAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingBlockAvailabilityExclusion = {
  __typename?: 'TeachingBlockAvailabilityExclusion';
  comment?: Maybe<Scalars['String']['output']>;
  from: Scalars['DateTime']['output'];
  holder: AvailabilityHolder;
  holderConnection: TeachingBlockAvailabilityExclusionHolderConnection;
  priority: Scalars['Int']['output'];
  teachingBlockVersion: TeachingBlockVersion;
  teachingBlockVersionConnection: TeachingBlockAvailabilityExclusionTeachingBlockVersionConnection;
  to: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockAvailabilityExclusionHolderArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<AvailabilityHolderWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockVersionOptions>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionSort>>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionAggregateSelection = {
  __typename?: 'TeachingBlockAvailabilityExclusionAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  from: DateTimeAggregateSelection;
  priority: IntAggregateSelection;
  to: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingBlockAvailabilityExclusionConnectInput = {
  holder?: InputMaybe<TeachingBlockAvailabilityExclusionHolderConnectInput>;
  teachingBlockVersion?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectFieldInput>;
};

export type TeachingBlockAvailabilityExclusionConnectWhere = {
  node: TeachingBlockAvailabilityExclusionWhere;
};

export type TeachingBlockAvailabilityExclusionCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['DateTime']['input'];
  holder?: InputMaybe<TeachingBlockAvailabilityExclusionHolderCreateInput>;
  priority: Scalars['Int']['input'];
  teachingBlockVersion?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionFieldInput>;
  to: Scalars['DateTime']['input'];
};

export type TeachingBlockAvailabilityExclusionDeleteInput = {
  holder?: InputMaybe<TeachingBlockAvailabilityExclusionHolderDeleteInput>;
  teachingBlockVersion?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionDeleteFieldInput>;
};

export type TeachingBlockAvailabilityExclusionDisconnectInput = {
  holder?: InputMaybe<TeachingBlockAvailabilityExclusionHolderDisconnectInput>;
  teachingBlockVersion?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionDisconnectFieldInput>;
};

export type TeachingBlockAvailabilityExclusionEdge = {
  __typename?: 'TeachingBlockAvailabilityExclusionEdge';
  cursor: Scalars['String']['output'];
  node: TeachingBlockAvailabilityExclusion;
};

export type TeachingBlockAvailabilityExclusionHolderClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  where?: InputMaybe<ClassConnectWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderClassConnectOrCreateFieldInput = {
  onCreate: TeachingBlockAvailabilityExclusionHolderClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type TeachingBlockAvailabilityExclusionHolderClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderClassConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderClassConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderClassFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassCreateFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type TeachingBlockAvailabilityExclusionHolderClassUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderConnectInput = {
  Class?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectFieldInput>;
  Person?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectFieldInput>;
  Room?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectFieldInput>;
  Subject?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderConnection = {
  __typename?: 'TeachingBlockAvailabilityExclusionHolderConnection';
  edges: Array<TeachingBlockAvailabilityExclusionHolderRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockAvailabilityExclusionHolderConnectionWhere = {
  Class?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassConnectionWhere>;
  Person?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere>;
  Room?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere>;
  Subject?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderCreateInput = {
  Class?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassFieldInput>;
  Person?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonFieldInput>;
  Room?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomFieldInput>;
  Subject?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderDeleteInput = {
  Class?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassDeleteFieldInput>;
  Person?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonDeleteFieldInput>;
  Room?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomDeleteFieldInput>;
  Subject?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectDeleteFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderDisconnectInput = {
  Class?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassDisconnectFieldInput>;
  Person?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonDisconnectFieldInput>;
  Room?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomDisconnectFieldInput>;
  Subject?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectDisconnectFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderPersonConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  where?: InputMaybe<PersonConnectWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderPersonConnectOrCreateFieldInput = {
  onCreate: TeachingBlockAvailabilityExclusionHolderPersonConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type TeachingBlockAvailabilityExclusionHolderPersonConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderPersonCreateFieldInput = {
  node: PersonCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderPersonDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderPersonDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderPersonFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonCreateFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderPersonUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type TeachingBlockAvailabilityExclusionHolderPersonUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderRelationship = {
  __typename?: 'TeachingBlockAvailabilityExclusionHolderRelationship';
  cursor: Scalars['String']['output'];
  node: AvailabilityHolder;
};

export type TeachingBlockAvailabilityExclusionHolderRoomConnectFieldInput = {
  connect?: InputMaybe<RoomConnectInput>;
  where?: InputMaybe<RoomConnectWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderRoomConnectOrCreateFieldInput = {
  onCreate: TeachingBlockAvailabilityExclusionHolderRoomConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type TeachingBlockAvailabilityExclusionHolderRoomConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderRoomCreateFieldInput = {
  node: RoomCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderRoomDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderRoomDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderRoomFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomCreateFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderRoomUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type TeachingBlockAvailabilityExclusionHolderRoomUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  where?: InputMaybe<SubjectConnectWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectConnectOrCreateFieldInput = {
  onCreate: TeachingBlockAvailabilityExclusionHolderSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectCreateFieldInput>;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type TeachingBlockAvailabilityExclusionHolderSubjectUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionHolderUpdateInput = {
  Class?: InputMaybe<TeachingBlockAvailabilityExclusionHolderClassUpdateFieldInput>;
  Person?: InputMaybe<TeachingBlockAvailabilityExclusionHolderPersonUpdateFieldInput>;
  Room?: InputMaybe<TeachingBlockAvailabilityExclusionHolderRoomUpdateFieldInput>;
  Subject?: InputMaybe<TeachingBlockAvailabilityExclusionHolderSubjectUpdateFieldInput>;
};

export type TeachingBlockAvailabilityExclusionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingBlockAvailabilityExclusionSort objects to sort TeachingBlockAvailabilityExclusions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingBlockAvailabilityExclusionSort>>;
};

/** Fields to sort TeachingBlockAvailabilityExclusions by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingBlockAvailabilityExclusionSort object. */
export type TeachingBlockAvailabilityExclusionSort = {
  comment?: InputMaybe<SortDirection>;
  from?: InputMaybe<SortDirection>;
  priority?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionNodeAggregationWhereInput>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectFieldInput = {
  connect?: InputMaybe<TeachingBlockVersionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockVersionConnectWhere>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionConnection = {
  __typename?: 'TeachingBlockAvailabilityExclusionTeachingBlockVersionConnection';
  edges: Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionSort = {
  node?: InputMaybe<TeachingBlockVersionSort>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>>;
  node?: InputMaybe<TeachingBlockVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionCreateFieldInput = {
  node: TeachingBlockVersionCreateInput;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockVersionDeleteInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockVersionDisconnectInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionCreateFieldInput>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionTeachingBlockVersionNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionRelationship = {
  __typename?: 'TeachingBlockAvailabilityExclusionTeachingBlockVersionRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockVersion;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockVersionUpdateInput>;
};

export type TeachingBlockAvailabilityExclusionTeachingBlockVersionUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectFieldInput>;
  create?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockAvailabilityExclusionUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  holder?: InputMaybe<TeachingBlockAvailabilityExclusionHolderUpdateInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  priority_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  priority_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  teachingBlockVersion?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionUpdateFieldInput>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockAvailabilityExclusionWhere = {
  AND?: InputMaybe<Array<TeachingBlockAvailabilityExclusionWhere>>;
  NOT?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  OR?: InputMaybe<Array<TeachingBlockAvailabilityExclusionWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  from_GT?: InputMaybe<Scalars['DateTime']['input']>;
  from_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  from_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  from_LT?: InputMaybe<Scalars['DateTime']['input']>;
  from_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  from_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  from_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  holder?: InputMaybe<AvailabilityHolderWhere>;
  holderConnection?: InputMaybe<TeachingBlockAvailabilityExclusionHolderConnectionWhere>;
  holderConnection_NOT?: InputMaybe<TeachingBlockAvailabilityExclusionHolderConnectionWhere>;
  holder_NOT?: InputMaybe<AvailabilityHolderWhere>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  priority_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  priority_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  priority_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  priority_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  teachingBlockVersion?: InputMaybe<TeachingBlockVersionWhere>;
  teachingBlockVersionAggregate?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionAggregateInput>;
  teachingBlockVersionConnection?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>;
  teachingBlockVersionConnection_NOT?: InputMaybe<TeachingBlockAvailabilityExclusionTeachingBlockVersionConnectionWhere>;
  teachingBlockVersion_NOT?: InputMaybe<TeachingBlockVersionWhere>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  to_GT?: InputMaybe<Scalars['DateTime']['input']>;
  to_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  to_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  to_LT?: InputMaybe<Scalars['DateTime']['input']>;
  to_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  to_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  to_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TeachingBlockAvailabilityExclusionsConnection = {
  __typename?: 'TeachingBlockAvailabilityExclusionsConnection';
  edges: Array<TeachingBlockAvailabilityExclusionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockCard = {
  __typename?: 'TeachingBlockCard';
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  events: Array<Event>;
  eventsConnection: TeachingBlockCardEventsConnection;
  foreignId?: Maybe<Scalars['String']['output']>;
  includeHoliday: Scalars['Boolean']['output'];
  lesson: Lesson;
  lessonClasses: Array<LessonClass>;
  lessonConnection: TeachingBlockCardLessonConnection;
  locked: Scalars['Boolean']['output'];
  rooms: Array<Room>;
  roomsConnection: TeachingBlockCardRoomsConnection;
  startDate?: Maybe<Scalars['Date']['output']>;
  subject: SubjectContainerOrSubject;
  teachers: Array<Person>;
  teachersPresent: Array<Person>;
  teachingBlockVersion: TeachingBlockVersion;
  teachingBlockVersionConnection: TeachingBlockCardTeachingBlockVersionConnection;
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockCardEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type TeachingBlockCardEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockCardEventsConnectionSort>>;
  where?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
};

export type TeachingBlockCardLessonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type TeachingBlockCardLessonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockCardLessonConnectionSort>>;
  where?: InputMaybe<TeachingBlockCardLessonConnectionWhere>;
};

export type TeachingBlockCardRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type TeachingBlockCardRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockCardRoomsConnectionSort>>;
  where?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
};

export type TeachingBlockCardTeachingBlockVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockVersionOptions>;
  where?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlockCardTeachingBlockVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockCardTeachingBlockVersionConnectionSort>>;
  where?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockCardAggregateSelection = {
  __typename?: 'TeachingBlockCardAggregateSelection';
  count: Scalars['Int']['output'];
  duration: IntAggregateSelection;
  foreignId: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingBlockCardConnectInput = {
  lesson?: InputMaybe<TeachingBlockCardLessonConnectFieldInput>;
  rooms?: InputMaybe<Array<TeachingBlockCardRoomsConnectFieldInput>>;
  teachingBlockVersion?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectFieldInput>;
};

export type TeachingBlockCardConnectOrCreateWhere = {
  node: TeachingBlockCardUniqueWhere;
};

export type TeachingBlockCardConnectWhere = {
  node: TeachingBlockCardWhere;
};

export type TeachingBlockCardCreateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  includeHoliday: Scalars['Boolean']['input'];
  lesson?: InputMaybe<TeachingBlockCardLessonFieldInput>;
  locked: Scalars['Boolean']['input'];
  rooms?: InputMaybe<TeachingBlockCardRoomsFieldInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teachingBlockVersion?: InputMaybe<TeachingBlockCardTeachingBlockVersionFieldInput>;
};

export type TeachingBlockCardDeleteInput = {
  lesson?: InputMaybe<TeachingBlockCardLessonDeleteFieldInput>;
  rooms?: InputMaybe<Array<TeachingBlockCardRoomsDeleteFieldInput>>;
  teachingBlockVersion?: InputMaybe<TeachingBlockCardTeachingBlockVersionDeleteFieldInput>;
};

export type TeachingBlockCardDisconnectInput = {
  lesson?: InputMaybe<TeachingBlockCardLessonDisconnectFieldInput>;
  rooms?: InputMaybe<Array<TeachingBlockCardRoomsDisconnectFieldInput>>;
  teachingBlockVersion?: InputMaybe<TeachingBlockCardTeachingBlockVersionDisconnectFieldInput>;
};

export type TeachingBlockCardEdge = {
  __typename?: 'TeachingBlockCardEdge';
  cursor: Scalars['String']['output'];
  node: TeachingBlockCard;
};

export type TeachingBlockCardEventsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockCardEventsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockCardEventsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockCardEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockCardEventsNodeAggregationWhereInput>;
};

export type TeachingBlockCardEventsConnection = {
  __typename?: 'TeachingBlockCardEventsConnection';
  edges: Array<TeachingBlockCardEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockCardEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type TeachingBlockCardEventsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockCardEventsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockCardEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type TeachingBlockCardEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockCardEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockCardEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockCardEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockCardEventsRelationship = {
  __typename?: 'TeachingBlockCardEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type TeachingBlockCardLessonAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockCardLessonAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockCardLessonAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockCardLessonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockCardLessonNodeAggregationWhereInput>;
};

export type TeachingBlockCardLessonConnectFieldInput = {
  connect?: InputMaybe<LessonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type TeachingBlockCardLessonConnectOrCreateFieldInput = {
  onCreate: TeachingBlockCardLessonConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type TeachingBlockCardLessonConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type TeachingBlockCardLessonConnection = {
  __typename?: 'TeachingBlockCardLessonConnection';
  edges: Array<TeachingBlockCardLessonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockCardLessonConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type TeachingBlockCardLessonConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockCardLessonConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockCardLessonConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockCardLessonConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type TeachingBlockCardLessonCreateFieldInput = {
  node: LessonCreateInput;
};

export type TeachingBlockCardLessonDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<TeachingBlockCardLessonConnectionWhere>;
};

export type TeachingBlockCardLessonDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<TeachingBlockCardLessonConnectionWhere>;
};

export type TeachingBlockCardLessonFieldInput = {
  connect?: InputMaybe<TeachingBlockCardLessonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockCardLessonConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockCardLessonCreateFieldInput>;
};

export type TeachingBlockCardLessonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockCardLessonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockCardLessonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockCardLessonNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockCardLessonRelationship = {
  __typename?: 'TeachingBlockCardLessonRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type TeachingBlockCardLessonUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type TeachingBlockCardLessonUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockCardLessonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockCardLessonConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockCardLessonCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockCardLessonDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockCardLessonDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockCardLessonUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockCardLessonConnectionWhere>;
};

export type TeachingBlockCardOnCreateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  includeHoliday: Scalars['Boolean']['input'];
  locked: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type TeachingBlockCardOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingBlockCardSort objects to sort TeachingBlockCards by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingBlockCardSort>>;
};

export type TeachingBlockCardRoomsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockCardRoomsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockCardRoomsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockCardRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockCardRoomsNodeAggregationWhereInput>;
};

export type TeachingBlockCardRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type TeachingBlockCardRoomsConnectOrCreateFieldInput = {
  onCreate: TeachingBlockCardRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type TeachingBlockCardRoomsConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type TeachingBlockCardRoomsConnection = {
  __typename?: 'TeachingBlockCardRoomsConnection';
  edges: Array<TeachingBlockCardRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockCardRoomsConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type TeachingBlockCardRoomsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockCardRoomsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockCardRoomsConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type TeachingBlockCardRoomsCreateFieldInput = {
  node: RoomCreateInput;
};

export type TeachingBlockCardRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
};

export type TeachingBlockCardRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
};

export type TeachingBlockCardRoomsFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockCardRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockCardRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockCardRoomsCreateFieldInput>>;
};

export type TeachingBlockCardRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockCardRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockCardRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockCardRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockCardRoomsRelationship = {
  __typename?: 'TeachingBlockCardRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type TeachingBlockCardRoomsUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type TeachingBlockCardRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockCardRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockCardRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockCardRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockCardRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockCardRoomsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockCardRoomsUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
};

/** Fields to sort TeachingBlockCards by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingBlockCardSort object. */
export type TeachingBlockCardSort = {
  duration?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  includeHoliday?: InputMaybe<SortDirection>;
  locked?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  subject?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TeachingBlockCardTeachingBlockVersionAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockCardTeachingBlockVersionAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockCardTeachingBlockVersionAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockCardTeachingBlockVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockCardTeachingBlockVersionNodeAggregationWhereInput>;
};

export type TeachingBlockCardTeachingBlockVersionConnectFieldInput = {
  connect?: InputMaybe<TeachingBlockVersionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockVersionConnectWhere>;
};

export type TeachingBlockCardTeachingBlockVersionConnection = {
  __typename?: 'TeachingBlockCardTeachingBlockVersionConnection';
  edges: Array<TeachingBlockCardTeachingBlockVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockCardTeachingBlockVersionConnectionSort = {
  node?: InputMaybe<TeachingBlockVersionSort>;
};

export type TeachingBlockCardTeachingBlockVersionConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockCardTeachingBlockVersionConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockCardTeachingBlockVersionConnectionWhere>>;
  node?: InputMaybe<TeachingBlockVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlockCardTeachingBlockVersionCreateFieldInput = {
  node: TeachingBlockVersionCreateInput;
};

export type TeachingBlockCardTeachingBlockVersionDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockVersionDeleteInput>;
  where?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockCardTeachingBlockVersionDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockVersionDisconnectInput>;
  where?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockCardTeachingBlockVersionFieldInput = {
  connect?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectFieldInput>;
  create?: InputMaybe<TeachingBlockCardTeachingBlockVersionCreateFieldInput>;
};

export type TeachingBlockCardTeachingBlockVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockCardTeachingBlockVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockCardTeachingBlockVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockCardTeachingBlockVersionNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingBlockCardTeachingBlockVersionRelationship = {
  __typename?: 'TeachingBlockCardTeachingBlockVersionRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockVersion;
};

export type TeachingBlockCardTeachingBlockVersionUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockVersionUpdateInput>;
};

export type TeachingBlockCardTeachingBlockVersionUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectFieldInput>;
  create?: InputMaybe<TeachingBlockCardTeachingBlockVersionCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockCardTeachingBlockVersionDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockCardTeachingBlockVersionDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockCardTeachingBlockVersionUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectionWhere>;
};

export type TeachingBlockCardUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingBlockCardUpdateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  duration_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  includeHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  lesson?: InputMaybe<TeachingBlockCardLessonUpdateFieldInput>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  rooms?: InputMaybe<Array<TeachingBlockCardRoomsUpdateFieldInput>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  teachingBlockVersion?: InputMaybe<TeachingBlockCardTeachingBlockVersionUpdateFieldInput>;
};

export type TeachingBlockCardWhere = {
  AND?: InputMaybe<Array<TeachingBlockCardWhere>>;
  NOT?: InputMaybe<TeachingBlockCardWhere>;
  OR?: InputMaybe<Array<TeachingBlockCardWhere>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDate_GT?: InputMaybe<Scalars['Date']['input']>;
  endDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  endDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  endDate_LT?: InputMaybe<Scalars['Date']['input']>;
  endDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  endDate_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  endDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<TeachingBlockCardEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
  /** Return TeachingBlockCards where all of the related TeachingBlockCardEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
  /** Return TeachingBlockCards where none of the related TeachingBlockCardEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
  /** Return TeachingBlockCards where one of the related TeachingBlockCardEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
  /** Return TeachingBlockCards where some of the related TeachingBlockCardEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<TeachingBlockCardEventsConnectionWhere>;
  /** Return TeachingBlockCards where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return TeachingBlockCards where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return TeachingBlockCards where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return TeachingBlockCards where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  includeHoliday?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  includeHoliday_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  lesson?: InputMaybe<LessonWhere>;
  lessonAggregate?: InputMaybe<TeachingBlockCardLessonAggregateInput>;
  lessonClasses?: InputMaybe<LessonClassWhere>;
  lessonClasses_ALL?: InputMaybe<LessonClassWhere>;
  lessonClasses_NONE?: InputMaybe<LessonClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lessonClasses_NOT?: InputMaybe<LessonClassWhere>;
  lessonClasses_SINGLE?: InputMaybe<LessonClassWhere>;
  lessonClasses_SOME?: InputMaybe<LessonClassWhere>;
  lessonConnection?: InputMaybe<TeachingBlockCardLessonConnectionWhere>;
  lessonConnection_NOT?: InputMaybe<TeachingBlockCardLessonConnectionWhere>;
  lesson_NOT?: InputMaybe<LessonWhere>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locked_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<TeachingBlockCardRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
  /** Return TeachingBlockCards where all of the related TeachingBlockCardRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
  /** Return TeachingBlockCards where none of the related TeachingBlockCardRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
  /** Return TeachingBlockCards where one of the related TeachingBlockCardRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
  /** Return TeachingBlockCards where some of the related TeachingBlockCardRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<TeachingBlockCardRoomsConnectionWhere>;
  /** Return TeachingBlockCards where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return TeachingBlockCards where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return TeachingBlockCards where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return TeachingBlockCards where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDate_GT?: InputMaybe<Scalars['Date']['input']>;
  startDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  startDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startDate_LT?: InputMaybe<Scalars['Date']['input']>;
  startDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  startDate_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  startDate_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  teachers?: InputMaybe<PersonWhere>;
  teachersPresent?: InputMaybe<PersonWhere>;
  teachersPresent_ALL?: InputMaybe<PersonWhere>;
  teachersPresent_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachersPresent_NOT?: InputMaybe<PersonWhere>;
  teachersPresent_SINGLE?: InputMaybe<PersonWhere>;
  teachersPresent_SOME?: InputMaybe<PersonWhere>;
  teachers_ALL?: InputMaybe<PersonWhere>;
  teachers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachers_NOT?: InputMaybe<PersonWhere>;
  teachers_SINGLE?: InputMaybe<PersonWhere>;
  teachers_SOME?: InputMaybe<PersonWhere>;
  teachingBlockVersion?: InputMaybe<TeachingBlockVersionWhere>;
  teachingBlockVersionAggregate?: InputMaybe<TeachingBlockCardTeachingBlockVersionAggregateInput>;
  teachingBlockVersionConnection?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectionWhere>;
  teachingBlockVersionConnection_NOT?: InputMaybe<TeachingBlockCardTeachingBlockVersionConnectionWhere>;
  teachingBlockVersion_NOT?: InputMaybe<TeachingBlockVersionWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TeachingBlockCardsConnection = {
  __typename?: 'TeachingBlockCardsConnection';
  edges: Array<TeachingBlockCardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockClassGridCard = {
  __typename?: 'TeachingBlockClassGridCard';
  classUuid: Scalars['ID']['output'];
  colors: Array<Scalars['String']['output']>;
  cssGradientString?: Maybe<Scalars['String']['output']>;
  cssHeight?: Maybe<Scalars['String']['output']>;
  cssTop?: Maybe<Scalars['String']['output']>;
  divisionsCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  includeHoliday: Scalars['Boolean']['output'];
  lessonUuid: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  teachingBlockCardUuid: Scalars['ID']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  usedPosition: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockConnectInput = {
  organization?: InputMaybe<TeachingBlockOrganizationConnectFieldInput>;
  schoolYear?: InputMaybe<TeachingBlockSchoolYearConnectFieldInput>;
  subjectContainer?: InputMaybe<TeachingBlockSubjectContainerConnectFieldInput>;
  versions?: InputMaybe<Array<TeachingBlockVersionsConnectFieldInput>>;
};

export type TeachingBlockConnectOrCreateWhere = {
  node: TeachingBlockUniqueWhere;
};

export type TeachingBlockConnectWhere = {
  node: TeachingBlockWhere;
};

export type TeachingBlockCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['Boolean']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<TeachingBlockOrganizationFieldInput>;
  schoolYear?: InputMaybe<TeachingBlockSchoolYearFieldInput>;
  subjectContainer?: InputMaybe<TeachingBlockSubjectContainerFieldInput>;
  updatedAt: Scalars['DateTime']['input'];
  versions?: InputMaybe<TeachingBlockVersionsFieldInput>;
};

export type TeachingBlockDeleteInput = {
  organization?: InputMaybe<TeachingBlockOrganizationDeleteFieldInput>;
  schoolYear?: InputMaybe<TeachingBlockSchoolYearDeleteFieldInput>;
  subjectContainer?: InputMaybe<TeachingBlockSubjectContainerDeleteFieldInput>;
  versions?: InputMaybe<Array<TeachingBlockVersionsDeleteFieldInput>>;
};

export type TeachingBlockDisconnectInput = {
  organization?: InputMaybe<TeachingBlockOrganizationDisconnectFieldInput>;
  schoolYear?: InputMaybe<TeachingBlockSchoolYearDisconnectFieldInput>;
  subjectContainer?: InputMaybe<TeachingBlockSubjectContainerDisconnectFieldInput>;
  versions?: InputMaybe<Array<TeachingBlockVersionsDisconnectFieldInput>>;
};

export type TeachingBlockEdge = {
  __typename?: 'TeachingBlockEdge';
  cursor: Scalars['String']['output'];
  node: TeachingBlock;
};

export type TeachingBlockOnCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['Boolean']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
};

export type TeachingBlockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingBlockSort objects to sort TeachingBlocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingBlockSort>>;
};

export type TeachingBlockOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockOrganizationAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockOrganizationNodeAggregationWhereInput>;
};

export type TeachingBlockOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TeachingBlockOrganizationConnectOrCreateFieldInput = {
  onCreate: TeachingBlockOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TeachingBlockOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TeachingBlockOrganizationConnection = {
  __typename?: 'TeachingBlockOrganizationConnection';
  edges: Array<TeachingBlockOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TeachingBlockOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TeachingBlockOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TeachingBlockOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TeachingBlockOrganizationConnectionWhere>;
};

export type TeachingBlockOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TeachingBlockOrganizationConnectionWhere>;
};

export type TeachingBlockOrganizationFieldInput = {
  connect?: InputMaybe<TeachingBlockOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockOrganizationCreateFieldInput>;
};

export type TeachingBlockOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingBlockOrganizationRelationship = {
  __typename?: 'TeachingBlockOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TeachingBlockOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TeachingBlockOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockOrganizationCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockOrganizationConnectionWhere>;
};

/**
 * The edge properties for the following fields:
 * * TeachingBlockVersion.subjects
 * * TeachingBlockVersion.teachers
 * * TeachingBlockVersion.classes
 * * TeachingBlockVersion.rooms
 */
export type TeachingBlockRelationshipProperties = {
  __typename?: 'TeachingBlockRelationshipProperties';
  constraints?: Maybe<Scalars['String']['output']>;
};

export type TeachingBlockRelationshipPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockRelationshipPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockRelationshipPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockRelationshipPropertiesAggregationWhereInput>>;
  constraints_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  constraints_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingBlockRelationshipPropertiesCreateInput = {
  constraints?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingBlockRelationshipPropertiesSort = {
  constraints?: InputMaybe<SortDirection>;
};

export type TeachingBlockRelationshipPropertiesUpdateInput = {
  constraints?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingBlockRelationshipPropertiesWhere = {
  AND?: InputMaybe<Array<TeachingBlockRelationshipPropertiesWhere>>;
  NOT?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  OR?: InputMaybe<Array<TeachingBlockRelationshipPropertiesWhere>>;
  constraints?: InputMaybe<Scalars['String']['input']>;
  constraints_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  constraints_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  constraints_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  constraints_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingBlockRoomGridCard = {
  __typename?: 'TeachingBlockRoomGridCard';
  colors: Array<Scalars['String']['output']>;
  cssGradientString?: Maybe<Scalars['String']['output']>;
  cssHeight?: Maybe<Scalars['String']['output']>;
  cssTop?: Maybe<Scalars['String']['output']>;
  divisionsCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  includeHoliday: Scalars['Boolean']['output'];
  lessonUuid: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  roomUuid: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  teachingBlockCardUuid: Scalars['ID']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  usedPosition: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockSchoolYearAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockSchoolYearNodeAggregationWhereInput>;
};

export type TeachingBlockSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type TeachingBlockSchoolYearConnection = {
  __typename?: 'TeachingBlockSchoolYearConnection';
  edges: Array<TeachingBlockSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type TeachingBlockSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type TeachingBlockSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type TeachingBlockSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<TeachingBlockSchoolYearConnectionWhere>;
};

export type TeachingBlockSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<TeachingBlockSchoolYearConnectionWhere>;
};

export type TeachingBlockSchoolYearFieldInput = {
  connect?: InputMaybe<TeachingBlockSchoolYearConnectFieldInput>;
  create?: InputMaybe<TeachingBlockSchoolYearCreateFieldInput>;
};

export type TeachingBlockSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockSchoolYearRelationship = {
  __typename?: 'TeachingBlockSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type TeachingBlockSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type TeachingBlockSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockSchoolYearConnectFieldInput>;
  create?: InputMaybe<TeachingBlockSchoolYearCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockSchoolYearConnectionWhere>;
};

/** Fields to sort TeachingBlocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingBlockSort object. */
export type TeachingBlockSort = {
  comment?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  draft?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TeachingBlockSubjectContainerAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockSubjectContainerAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockSubjectContainerAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockSubjectContainerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockSubjectContainerNodeAggregationWhereInput>;
};

export type TeachingBlockSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type TeachingBlockSubjectContainerConnectOrCreateFieldInput = {
  onCreate: TeachingBlockSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type TeachingBlockSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type TeachingBlockSubjectContainerConnection = {
  __typename?: 'TeachingBlockSubjectContainerConnection';
  edges: Array<TeachingBlockSubjectContainerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockSubjectContainerConnectionSort = {
  node?: InputMaybe<SubjectContainerSort>;
};

export type TeachingBlockSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type TeachingBlockSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type TeachingBlockSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<TeachingBlockSubjectContainerConnectionWhere>;
};

export type TeachingBlockSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<TeachingBlockSubjectContainerConnectionWhere>;
};

export type TeachingBlockSubjectContainerFieldInput = {
  connect?: InputMaybe<TeachingBlockSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockSubjectContainerCreateFieldInput>;
};

export type TeachingBlockSubjectContainerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockSubjectContainerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockSubjectContainerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockSubjectContainerNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockSubjectContainerRelationship = {
  __typename?: 'TeachingBlockSubjectContainerRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainer;
};

export type TeachingBlockSubjectContainerSubjectContainerAggregationSelection = {
  __typename?: 'TeachingBlockSubjectContainerSubjectContainerAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingBlockSubjectContainerSubjectContainerNodeAggregateSelection>;
};

export type TeachingBlockSubjectContainerSubjectContainerNodeAggregateSelection = {
  __typename?: 'TeachingBlockSubjectContainerSubjectContainerNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  shortName: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingBlockSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type TeachingBlockSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockSubjectContainerConnectionWhere>;
};

export type TeachingBlockSubjectGridCard = {
  __typename?: 'TeachingBlockSubjectGridCard';
  colors: Array<Scalars['String']['output']>;
  cssGradientString?: Maybe<Scalars['String']['output']>;
  cssHeight?: Maybe<Scalars['String']['output']>;
  cssTop?: Maybe<Scalars['String']['output']>;
  divisionsCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  includeHoliday: Scalars['Boolean']['output'];
  lessonUuid: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  subjectUuid: Scalars['ID']['output'];
  teachingBlockCardUuid: Scalars['ID']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  usedPosition: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockTeacherGridCard = {
  __typename?: 'TeachingBlockTeacherGridCard';
  colors: Array<Scalars['String']['output']>;
  cssGradientString?: Maybe<Scalars['String']['output']>;
  cssHeight?: Maybe<Scalars['String']['output']>;
  cssTop?: Maybe<Scalars['String']['output']>;
  divisionsCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  includeHoliday: Scalars['Boolean']['output'];
  lessonUuid: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  teacherUuid: Scalars['ID']['output'];
  teachingBlockCardUuid: Scalars['ID']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  usedPosition: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingBlockTeachingBlockVersionVersionsAggregationSelection = {
  __typename?: 'TeachingBlockTeachingBlockVersionVersionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingBlockTeachingBlockVersionVersionsNodeAggregateSelection>;
};

export type TeachingBlockTeachingBlockVersionVersionsNodeAggregateSelection = {
  __typename?: 'TeachingBlockTeachingBlockVersionVersionsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
  version: IntAggregateSelection;
};

export type TeachingBlockUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingBlockUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<TeachingBlockOrganizationUpdateFieldInput>;
  schoolYear?: InputMaybe<TeachingBlockSchoolYearUpdateFieldInput>;
  subjectContainer?: InputMaybe<TeachingBlockSubjectContainerUpdateFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  versions?: InputMaybe<Array<TeachingBlockVersionsUpdateFieldInput>>;
};

export type TeachingBlockVersion = {
  __typename?: 'TeachingBlockVersion';
  active?: Maybe<Scalars['Boolean']['output']>;
  availabilityExclusions: Array<TeachingBlockAvailabilityExclusion>;
  availabilityExclusionsConnection: TeachingBlockVersionAvailabilityExclusionsConnection;
  cards: Array<TeachingBlockCard>;
  cardsAggregate?: Maybe<TeachingBlockVersionTeachingBlockCardCardsAggregationSelection>;
  cardsConnection: TeachingBlockVersionCardsConnection;
  classes: Array<Class>;
  classesConnection: TeachingBlockVersionClassesConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lessons: Array<Lesson>;
  lessonsAggregate?: Maybe<TeachingBlockVersionLessonLessonsAggregationSelection>;
  lessonsConnection: TeachingBlockVersionLessonsConnection;
  locked?: Maybe<Locked>;
  lockedConnection: TeachingBlockVersionLockedConnection;
  rooms: Array<Room>;
  roomsConnection: TeachingBlockVersionRoomsConnection;
  subjects: Array<Subject>;
  subjectsConnection: TeachingBlockVersionSubjectsConnection;
  teachers: Array<Person>;
  teachersConnection: TeachingBlockVersionTeachersConnection;
  teachingBlock: TeachingBlock;
  teachingBlockConnection: TeachingBlockVersionTeachingBlockConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type TeachingBlockVersionAvailabilityExclusionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockAvailabilityExclusionOptions>;
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
};

export type TeachingBlockVersionAvailabilityExclusionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
};

export type TeachingBlockVersionCardsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockCardOptions>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type TeachingBlockVersionCardsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TeachingBlockCardWhere>;
};

export type TeachingBlockVersionCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionCardsConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
};

export type TeachingBlockVersionClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type TeachingBlockVersionClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionClassesConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
};

export type TeachingBlockVersionLessonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type TeachingBlockVersionLessonsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonWhere>;
};

export type TeachingBlockVersionLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionLessonsConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
};

export type TeachingBlockVersionLockedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LockedOptions>;
  where?: InputMaybe<LockedWhere>;
};

export type TeachingBlockVersionLockedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionLockedConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionLockedConnectionWhere>;
};

export type TeachingBlockVersionRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type TeachingBlockVersionRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionRoomsConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
};

export type TeachingBlockVersionSubjectsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type TeachingBlockVersionSubjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
};

export type TeachingBlockVersionTeachersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type TeachingBlockVersionTeachersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionTeachersConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
};

export type TeachingBlockVersionTeachingBlockArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TeachingBlockOptions>;
  where?: InputMaybe<TeachingBlockWhere>;
};

export type TeachingBlockVersionTeachingBlockConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingBlockVersionTeachingBlockConnectionSort>>;
  where?: InputMaybe<TeachingBlockVersionTeachingBlockConnectionWhere>;
};

export type TeachingBlockVersionAggregateSelection = {
  __typename?: 'TeachingBlockVersionAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
  version: IntAggregateSelection;
};

export type TeachingBlockVersionAvailabilityExclusionsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsNodeAggregationWhereInput>;
};

export type TeachingBlockVersionAvailabilityExclusionsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockAvailabilityExclusionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockAvailabilityExclusionConnectWhere>;
};

export type TeachingBlockVersionAvailabilityExclusionsConnection = {
  __typename?: 'TeachingBlockVersionAvailabilityExclusionsConnection';
  edges: Array<TeachingBlockVersionAvailabilityExclusionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionAvailabilityExclusionsConnectionSort = {
  node?: InputMaybe<TeachingBlockAvailabilityExclusionSort>;
};

export type TeachingBlockVersionAvailabilityExclusionsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>>;
  node?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
};

export type TeachingBlockVersionAvailabilityExclusionsCreateFieldInput = {
  node: TeachingBlockAvailabilityExclusionCreateInput;
};

export type TeachingBlockVersionAvailabilityExclusionsDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
};

export type TeachingBlockVersionAvailabilityExclusionsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockAvailabilityExclusionDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
};

export type TeachingBlockVersionAvailabilityExclusionsFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsCreateFieldInput>>;
};

export type TeachingBlockVersionAvailabilityExclusionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  from_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  from_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  from_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  from_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  from_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  from_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  from_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  from_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  from_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  to_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  to_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  to_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  to_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  to_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  to_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  to_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  to_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  to_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionAvailabilityExclusionsRelationship = {
  __typename?: 'TeachingBlockVersionAvailabilityExclusionsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockAvailabilityExclusion;
};

export type TeachingBlockVersionAvailabilityExclusionsUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockAvailabilityExclusionUpdateInput>;
};

export type TeachingBlockVersionAvailabilityExclusionsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
};

export type TeachingBlockVersionCardsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionCardsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionCardsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionCardsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockVersionCardsNodeAggregationWhereInput>;
};

export type TeachingBlockVersionCardsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockCardConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockCardConnectWhere>;
};

export type TeachingBlockVersionCardsConnectOrCreateFieldInput = {
  onCreate: TeachingBlockVersionCardsConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockCardConnectOrCreateWhere;
};

export type TeachingBlockVersionCardsConnectOrCreateFieldInputOnCreate = {
  node: TeachingBlockCardOnCreateInput;
};

export type TeachingBlockVersionCardsConnection = {
  __typename?: 'TeachingBlockVersionCardsConnection';
  edges: Array<TeachingBlockVersionCardsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionCardsConnectionSort = {
  node?: InputMaybe<TeachingBlockCardSort>;
};

export type TeachingBlockVersionCardsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionCardsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionCardsConnectionWhere>>;
  node?: InputMaybe<TeachingBlockCardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockCardWhere>;
};

export type TeachingBlockVersionCardsCreateFieldInput = {
  node: TeachingBlockCardCreateInput;
};

export type TeachingBlockVersionCardsDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockCardDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
};

export type TeachingBlockVersionCardsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockCardDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
};

export type TeachingBlockVersionCardsFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionCardsCreateFieldInput>>;
};

export type TeachingBlockVersionCardsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionCardsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionCardsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionCardsNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingBlockVersionCardsRelationship = {
  __typename?: 'TeachingBlockVersionCardsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockCard;
};

export type TeachingBlockVersionCardsUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockCardUpdateInput>;
};

export type TeachingBlockVersionCardsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionCardsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionCardsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionCardsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionCardsUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
};

export type TeachingBlockVersionClassesAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionClassesAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionClassesAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TeachingBlockVersionClassesNodeAggregationWhereInput>;
};

export type TeachingBlockVersionClassesConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type TeachingBlockVersionClassesConnectOrCreateFieldInput = {
  onCreate: TeachingBlockVersionClassesConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type TeachingBlockVersionClassesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: ClassOnCreateInput;
};

export type TeachingBlockVersionClassesConnection = {
  __typename?: 'TeachingBlockVersionClassesConnection';
  edges: Array<TeachingBlockVersionClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionClassesConnectionSort = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesSort>;
  node?: InputMaybe<ClassSort>;
};

export type TeachingBlockVersionClassesConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionClassesConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionClassesConnectionWhere>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type TeachingBlockVersionClassesCreateFieldInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: ClassCreateInput;
};

export type TeachingBlockVersionClassesDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
};

export type TeachingBlockVersionClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
};

export type TeachingBlockVersionClassesFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionClassesCreateFieldInput>>;
};

export type TeachingBlockVersionClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionClassesNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionClassesRelationship = {
  __typename?: 'TeachingBlockVersionClassesRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
  properties: TeachingBlockRelationshipProperties;
};

export type TeachingBlockVersionClassesUpdateConnectionInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<ClassUpdateInput>;
};

export type TeachingBlockVersionClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionClassesDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionClassesUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
};

export type TeachingBlockVersionConnectInput = {
  availabilityExclusions?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsConnectFieldInput>>;
  cards?: InputMaybe<Array<TeachingBlockVersionCardsConnectFieldInput>>;
  classes?: InputMaybe<Array<TeachingBlockVersionClassesConnectFieldInput>>;
  lessons?: InputMaybe<Array<TeachingBlockVersionLessonsConnectFieldInput>>;
  locked?: InputMaybe<TeachingBlockVersionLockedConnectFieldInput>;
  rooms?: InputMaybe<Array<TeachingBlockVersionRoomsConnectFieldInput>>;
  subjects?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectFieldInput>>;
  teachers?: InputMaybe<Array<TeachingBlockVersionTeachersConnectFieldInput>>;
  teachingBlock?: InputMaybe<TeachingBlockVersionTeachingBlockConnectFieldInput>;
};

export type TeachingBlockVersionConnectWhere = {
  node: TeachingBlockVersionWhere;
};

export type TeachingBlockVersionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityExclusions?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsFieldInput>;
  cards?: InputMaybe<TeachingBlockVersionCardsFieldInput>;
  classes?: InputMaybe<TeachingBlockVersionClassesFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  lessons?: InputMaybe<TeachingBlockVersionLessonsFieldInput>;
  locked?: InputMaybe<TeachingBlockVersionLockedFieldInput>;
  rooms?: InputMaybe<TeachingBlockVersionRoomsFieldInput>;
  subjects?: InputMaybe<TeachingBlockVersionSubjectsFieldInput>;
  teachers?: InputMaybe<TeachingBlockVersionTeachersFieldInput>;
  teachingBlock?: InputMaybe<TeachingBlockVersionTeachingBlockFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version: Scalars['Int']['input'];
};

export type TeachingBlockVersionDeleteInput = {
  availabilityExclusions?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsDeleteFieldInput>>;
  cards?: InputMaybe<Array<TeachingBlockVersionCardsDeleteFieldInput>>;
  classes?: InputMaybe<Array<TeachingBlockVersionClassesDeleteFieldInput>>;
  lessons?: InputMaybe<Array<TeachingBlockVersionLessonsDeleteFieldInput>>;
  locked?: InputMaybe<TeachingBlockVersionLockedDeleteFieldInput>;
  rooms?: InputMaybe<Array<TeachingBlockVersionRoomsDeleteFieldInput>>;
  subjects?: InputMaybe<Array<TeachingBlockVersionSubjectsDeleteFieldInput>>;
  teachers?: InputMaybe<Array<TeachingBlockVersionTeachersDeleteFieldInput>>;
  teachingBlock?: InputMaybe<TeachingBlockVersionTeachingBlockDeleteFieldInput>;
};

export type TeachingBlockVersionDisconnectInput = {
  availabilityExclusions?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsDisconnectFieldInput>>;
  cards?: InputMaybe<Array<TeachingBlockVersionCardsDisconnectFieldInput>>;
  classes?: InputMaybe<Array<TeachingBlockVersionClassesDisconnectFieldInput>>;
  lessons?: InputMaybe<Array<TeachingBlockVersionLessonsDisconnectFieldInput>>;
  locked?: InputMaybe<TeachingBlockVersionLockedDisconnectFieldInput>;
  rooms?: InputMaybe<Array<TeachingBlockVersionRoomsDisconnectFieldInput>>;
  subjects?: InputMaybe<Array<TeachingBlockVersionSubjectsDisconnectFieldInput>>;
  teachers?: InputMaybe<Array<TeachingBlockVersionTeachersDisconnectFieldInput>>;
  teachingBlock?: InputMaybe<TeachingBlockVersionTeachingBlockDisconnectFieldInput>;
};

export type TeachingBlockVersionEdge = {
  __typename?: 'TeachingBlockVersionEdge';
  cursor: Scalars['String']['output'];
  node: TeachingBlockVersion;
};

export type TeachingBlockVersionLessonLessonsAggregationSelection = {
  __typename?: 'TeachingBlockVersionLessonLessonsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingBlockVersionLessonLessonsNodeAggregateSelection>;
};

export type TeachingBlockVersionLessonLessonsNodeAggregateSelection = {
  __typename?: 'TeachingBlockVersionLessonLessonsNodeAggregateSelection';
  comment: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  subTitle: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingBlockVersionLessonsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionLessonsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionLessonsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionLessonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockVersionLessonsNodeAggregationWhereInput>;
};

export type TeachingBlockVersionLessonsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type TeachingBlockVersionLessonsConnectOrCreateFieldInput = {
  onCreate: TeachingBlockVersionLessonsConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type TeachingBlockVersionLessonsConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type TeachingBlockVersionLessonsConnection = {
  __typename?: 'TeachingBlockVersionLessonsConnection';
  edges: Array<TeachingBlockVersionLessonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionLessonsConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type TeachingBlockVersionLessonsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionLessonsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionLessonsConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type TeachingBlockVersionLessonsCreateFieldInput = {
  node: LessonCreateInput;
};

export type TeachingBlockVersionLessonsDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
};

export type TeachingBlockVersionLessonsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
};

export type TeachingBlockVersionLessonsFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionLessonsCreateFieldInput>>;
};

export type TeachingBlockVersionLessonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionLessonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionLessonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionLessonsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionLessonsRelationship = {
  __typename?: 'TeachingBlockVersionLessonsRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type TeachingBlockVersionLessonsUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type TeachingBlockVersionLessonsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionLessonsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionLessonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionLessonsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionLessonsUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
};

export type TeachingBlockVersionLockedAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionLockedAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionLockedAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionLockedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockVersionLockedNodeAggregationWhereInput>;
};

export type TeachingBlockVersionLockedConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LockedConnectWhere>;
};

export type TeachingBlockVersionLockedConnection = {
  __typename?: 'TeachingBlockVersionLockedConnection';
  edges: Array<TeachingBlockVersionLockedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionLockedConnectionSort = {
  node?: InputMaybe<LockedSort>;
};

export type TeachingBlockVersionLockedConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionLockedConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionLockedConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionLockedConnectionWhere>>;
  node?: InputMaybe<LockedWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LockedWhere>;
};

export type TeachingBlockVersionLockedCreateFieldInput = {
  node: LockedCreateInput;
};

export type TeachingBlockVersionLockedDeleteFieldInput = {
  where?: InputMaybe<TeachingBlockVersionLockedConnectionWhere>;
};

export type TeachingBlockVersionLockedDisconnectFieldInput = {
  where?: InputMaybe<TeachingBlockVersionLockedConnectionWhere>;
};

export type TeachingBlockVersionLockedFieldInput = {
  connect?: InputMaybe<TeachingBlockVersionLockedConnectFieldInput>;
  create?: InputMaybe<TeachingBlockVersionLockedCreateFieldInput>;
};

export type TeachingBlockVersionLockedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionLockedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionLockedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionLockedNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSince_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionLockedRelationship = {
  __typename?: 'TeachingBlockVersionLockedRelationship';
  cursor: Scalars['String']['output'];
  node: Locked;
};

export type TeachingBlockVersionLockedUpdateConnectionInput = {
  node?: InputMaybe<LockedUpdateInput>;
};

export type TeachingBlockVersionLockedUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockVersionLockedConnectFieldInput>;
  create?: InputMaybe<TeachingBlockVersionLockedCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockVersionLockedDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockVersionLockedDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockVersionLockedUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionLockedConnectionWhere>;
};

export type TeachingBlockVersionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingBlockVersionSort objects to sort TeachingBlockVersions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingBlockVersionSort>>;
};

export type TeachingBlockVersionRoomsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionRoomsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionRoomsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TeachingBlockVersionRoomsNodeAggregationWhereInput>;
};

export type TeachingBlockVersionRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type TeachingBlockVersionRoomsConnectOrCreateFieldInput = {
  onCreate: TeachingBlockVersionRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type TeachingBlockVersionRoomsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: RoomOnCreateInput;
};

export type TeachingBlockVersionRoomsConnection = {
  __typename?: 'TeachingBlockVersionRoomsConnection';
  edges: Array<TeachingBlockVersionRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionRoomsConnectionSort = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesSort>;
  node?: InputMaybe<RoomSort>;
};

export type TeachingBlockVersionRoomsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionRoomsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionRoomsConnectionWhere>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type TeachingBlockVersionRoomsCreateFieldInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: RoomCreateInput;
};

export type TeachingBlockVersionRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
};

export type TeachingBlockVersionRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
};

export type TeachingBlockVersionRoomsFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionRoomsCreateFieldInput>>;
};

export type TeachingBlockVersionRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionRoomsRelationship = {
  __typename?: 'TeachingBlockVersionRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
  properties: TeachingBlockRelationshipProperties;
};

export type TeachingBlockVersionRoomsUpdateConnectionInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<RoomUpdateInput>;
};

export type TeachingBlockVersionRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionRoomsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionRoomsUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
};

/** Fields to sort TeachingBlockVersions by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingBlockVersionSort object. */
export type TeachingBlockVersionSort = {
  active?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type TeachingBlockVersionSubjectsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionSubjectsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionSubjectsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionSubjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TeachingBlockVersionSubjectsNodeAggregationWhereInput>;
};

export type TeachingBlockVersionSubjectsConnectFieldInput = {
  connect?: InputMaybe<Array<SubjectConnectInput>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type TeachingBlockVersionSubjectsConnectOrCreateFieldInput = {
  onCreate: TeachingBlockVersionSubjectsConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type TeachingBlockVersionSubjectsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: SubjectOnCreateInput;
};

export type TeachingBlockVersionSubjectsConnection = {
  __typename?: 'TeachingBlockVersionSubjectsConnection';
  edges: Array<TeachingBlockVersionSubjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionSubjectsConnectionSort = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesSort>;
  node?: InputMaybe<SubjectSort>;
};

export type TeachingBlockVersionSubjectsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectionWhere>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type TeachingBlockVersionSubjectsCreateFieldInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: SubjectCreateInput;
};

export type TeachingBlockVersionSubjectsDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
};

export type TeachingBlockVersionSubjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
};

export type TeachingBlockVersionSubjectsFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionSubjectsCreateFieldInput>>;
};

export type TeachingBlockVersionSubjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionSubjectsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionSubjectsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionSubjectsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionSubjectsRelationship = {
  __typename?: 'TeachingBlockVersionSubjectsRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
  properties: TeachingBlockRelationshipProperties;
};

export type TeachingBlockVersionSubjectsUpdateConnectionInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<SubjectUpdateInput>;
};

export type TeachingBlockVersionSubjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionSubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionSubjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionSubjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionSubjectsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionSubjectsUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
};

export type TeachingBlockVersionTeachersAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionTeachersAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionTeachersAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionTeachersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TeachingBlockVersionTeachersNodeAggregationWhereInput>;
};

export type TeachingBlockVersionTeachersConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type TeachingBlockVersionTeachersConnectOrCreateFieldInput = {
  onCreate: TeachingBlockVersionTeachersConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type TeachingBlockVersionTeachersConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: PersonOnCreateInput;
};

export type TeachingBlockVersionTeachersConnection = {
  __typename?: 'TeachingBlockVersionTeachersConnection';
  edges: Array<TeachingBlockVersionTeachersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionTeachersConnectionSort = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesSort>;
  node?: InputMaybe<PersonSort>;
};

export type TeachingBlockVersionTeachersConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionTeachersConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionTeachersConnectionWhere>>;
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TeachingBlockRelationshipPropertiesWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type TeachingBlockVersionTeachersCreateFieldInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesCreateInput>;
  node: PersonCreateInput;
};

export type TeachingBlockVersionTeachersDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
};

export type TeachingBlockVersionTeachersDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
};

export type TeachingBlockVersionTeachersFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionTeachersCreateFieldInput>>;
};

export type TeachingBlockVersionTeachersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionTeachersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionTeachersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionTeachersNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionTeachersRelationship = {
  __typename?: 'TeachingBlockVersionTeachersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: TeachingBlockRelationshipProperties;
};

export type TeachingBlockVersionTeachersUpdateConnectionInput = {
  edge?: InputMaybe<TeachingBlockRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<PersonUpdateInput>;
};

export type TeachingBlockVersionTeachersUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingBlockVersionTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionTeachersCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionTeachersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionTeachersDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionTeachersUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
};

export type TeachingBlockVersionTeachingBlockAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionTeachingBlockAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionTeachingBlockAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionTeachingBlockAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockVersionTeachingBlockNodeAggregationWhereInput>;
};

export type TeachingBlockVersionTeachingBlockCardCardsAggregationSelection = {
  __typename?: 'TeachingBlockVersionTeachingBlockCardCardsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TeachingBlockVersionTeachingBlockCardCardsNodeAggregateSelection>;
};

export type TeachingBlockVersionTeachingBlockCardCardsNodeAggregateSelection = {
  __typename?: 'TeachingBlockVersionTeachingBlockCardCardsNodeAggregateSelection';
  duration: IntAggregateSelection;
  foreignId: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingBlockVersionTeachingBlockConnectFieldInput = {
  connect?: InputMaybe<TeachingBlockConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockConnectWhere>;
};

export type TeachingBlockVersionTeachingBlockConnectOrCreateFieldInput = {
  onCreate: TeachingBlockVersionTeachingBlockConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockConnectOrCreateWhere;
};

export type TeachingBlockVersionTeachingBlockConnectOrCreateFieldInputOnCreate = {
  node: TeachingBlockOnCreateInput;
};

export type TeachingBlockVersionTeachingBlockConnection = {
  __typename?: 'TeachingBlockVersionTeachingBlockConnection';
  edges: Array<TeachingBlockVersionTeachingBlockRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionTeachingBlockConnectionSort = {
  node?: InputMaybe<TeachingBlockSort>;
};

export type TeachingBlockVersionTeachingBlockConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionTeachingBlockConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionTeachingBlockConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionTeachingBlockConnectionWhere>>;
  node?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockWhere>;
};

export type TeachingBlockVersionTeachingBlockCreateFieldInput = {
  node: TeachingBlockCreateInput;
};

export type TeachingBlockVersionTeachingBlockDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionTeachingBlockConnectionWhere>;
};

export type TeachingBlockVersionTeachingBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionTeachingBlockConnectionWhere>;
};

export type TeachingBlockVersionTeachingBlockFieldInput = {
  connect?: InputMaybe<TeachingBlockVersionTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockVersionTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockVersionTeachingBlockCreateFieldInput>;
};

export type TeachingBlockVersionTeachingBlockNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionTeachingBlockNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionTeachingBlockNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionTeachingBlockNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingBlockVersionTeachingBlockRelationship = {
  __typename?: 'TeachingBlockVersionTeachingBlockRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlock;
};

export type TeachingBlockVersionTeachingBlockUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockUpdateInput>;
};

export type TeachingBlockVersionTeachingBlockUpdateFieldInput = {
  connect?: InputMaybe<TeachingBlockVersionTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingBlockVersionTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingBlockVersionTeachingBlockCreateFieldInput>;
  delete?: InputMaybe<TeachingBlockVersionTeachingBlockDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingBlockVersionTeachingBlockDisconnectFieldInput>;
  update?: InputMaybe<TeachingBlockVersionTeachingBlockUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionTeachingBlockConnectionWhere>;
};

export type TeachingBlockVersionUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityExclusions?: InputMaybe<Array<TeachingBlockVersionAvailabilityExclusionsUpdateFieldInput>>;
  cards?: InputMaybe<Array<TeachingBlockVersionCardsUpdateFieldInput>>;
  classes?: InputMaybe<Array<TeachingBlockVersionClassesUpdateFieldInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lessons?: InputMaybe<Array<TeachingBlockVersionLessonsUpdateFieldInput>>;
  locked?: InputMaybe<TeachingBlockVersionLockedUpdateFieldInput>;
  rooms?: InputMaybe<Array<TeachingBlockVersionRoomsUpdateFieldInput>>;
  subjects?: InputMaybe<Array<TeachingBlockVersionSubjectsUpdateFieldInput>>;
  teachers?: InputMaybe<Array<TeachingBlockVersionTeachersUpdateFieldInput>>;
  teachingBlock?: InputMaybe<TeachingBlockVersionTeachingBlockUpdateFieldInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  version_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingBlockVersionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `availabilityExclusions_SOME` instead. */
  availabilityExclusions?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  availabilityExclusionsAggregate?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsAggregateInput>;
  /** @deprecated Use `availabilityExclusionsConnection_SOME` instead. */
  availabilityExclusionsConnection?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockVersionAvailabilityExclusionsConnections match this filter */
  availabilityExclusionsConnection_ALL?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockVersionAvailabilityExclusionsConnections match this filter */
  availabilityExclusionsConnection_NONE?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
  /** @deprecated Use `availabilityExclusionsConnection_NONE` instead. */
  availabilityExclusionsConnection_NOT?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockVersionAvailabilityExclusionsConnections match this filter */
  availabilityExclusionsConnection_SINGLE?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockVersionAvailabilityExclusionsConnections match this filter */
  availabilityExclusionsConnection_SOME?: InputMaybe<TeachingBlockVersionAvailabilityExclusionsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockAvailabilityExclusions match this filter */
  availabilityExclusions_ALL?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockAvailabilityExclusions match this filter */
  availabilityExclusions_NONE?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  /** @deprecated Use `availabilityExclusions_NONE` instead. */
  availabilityExclusions_NOT?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockAvailabilityExclusions match this filter */
  availabilityExclusions_SINGLE?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockAvailabilityExclusions match this filter */
  availabilityExclusions_SOME?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  /** @deprecated Use `cards_SOME` instead. */
  cards?: InputMaybe<TeachingBlockCardWhere>;
  cardsAggregate?: InputMaybe<TeachingBlockVersionCardsAggregateInput>;
  /** @deprecated Use `cardsConnection_SOME` instead. */
  cardsConnection?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockVersionCardsConnections match this filter */
  cardsConnection_ALL?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockVersionCardsConnections match this filter */
  cardsConnection_NONE?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
  /** @deprecated Use `cardsConnection_NONE` instead. */
  cardsConnection_NOT?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockVersionCardsConnections match this filter */
  cardsConnection_SINGLE?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockVersionCardsConnections match this filter */
  cardsConnection_SOME?: InputMaybe<TeachingBlockVersionCardsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockCards match this filter */
  cards_ALL?: InputMaybe<TeachingBlockCardWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockCards match this filter */
  cards_NONE?: InputMaybe<TeachingBlockCardWhere>;
  /** @deprecated Use `cards_NONE` instead. */
  cards_NOT?: InputMaybe<TeachingBlockCardWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockCards match this filter */
  cards_SINGLE?: InputMaybe<TeachingBlockCardWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockCards match this filter */
  cards_SOME?: InputMaybe<TeachingBlockCardWhere>;
  /** @deprecated Use `classes_SOME` instead. */
  classes?: InputMaybe<ClassWhere>;
  classesAggregate?: InputMaybe<TeachingBlockVersionClassesAggregateInput>;
  /** @deprecated Use `classesConnection_SOME` instead. */
  classesConnection?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockVersionClassesConnections match this filter */
  classesConnection_ALL?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockVersionClassesConnections match this filter */
  classesConnection_NONE?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
  /** @deprecated Use `classesConnection_NONE` instead. */
  classesConnection_NOT?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockVersionClassesConnections match this filter */
  classesConnection_SINGLE?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockVersionClassesConnections match this filter */
  classesConnection_SOME?: InputMaybe<TeachingBlockVersionClassesConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related Classes match this filter */
  classes_ALL?: InputMaybe<ClassWhere>;
  /** Return TeachingBlockVersions where none of the related Classes match this filter */
  classes_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `classes_NONE` instead. */
  classes_NOT?: InputMaybe<ClassWhere>;
  /** Return TeachingBlockVersions where one of the related Classes match this filter */
  classes_SINGLE?: InputMaybe<ClassWhere>;
  /** Return TeachingBlockVersions where some of the related Classes match this filter */
  classes_SOME?: InputMaybe<ClassWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `lessons_SOME` instead. */
  lessons?: InputMaybe<LessonWhere>;
  lessonsAggregate?: InputMaybe<TeachingBlockVersionLessonsAggregateInput>;
  /** @deprecated Use `lessonsConnection_SOME` instead. */
  lessonsConnection?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockVersionLessonsConnections match this filter */
  lessonsConnection_ALL?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockVersionLessonsConnections match this filter */
  lessonsConnection_NONE?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
  /** @deprecated Use `lessonsConnection_NONE` instead. */
  lessonsConnection_NOT?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockVersionLessonsConnections match this filter */
  lessonsConnection_SINGLE?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockVersionLessonsConnections match this filter */
  lessonsConnection_SOME?: InputMaybe<TeachingBlockVersionLessonsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related Lessons match this filter */
  lessons_ALL?: InputMaybe<LessonWhere>;
  /** Return TeachingBlockVersions where none of the related Lessons match this filter */
  lessons_NONE?: InputMaybe<LessonWhere>;
  /** @deprecated Use `lessons_NONE` instead. */
  lessons_NOT?: InputMaybe<LessonWhere>;
  /** Return TeachingBlockVersions where one of the related Lessons match this filter */
  lessons_SINGLE?: InputMaybe<LessonWhere>;
  /** Return TeachingBlockVersions where some of the related Lessons match this filter */
  lessons_SOME?: InputMaybe<LessonWhere>;
  locked?: InputMaybe<LockedWhere>;
  lockedAggregate?: InputMaybe<TeachingBlockVersionLockedAggregateInput>;
  lockedConnection?: InputMaybe<TeachingBlockVersionLockedConnectionWhere>;
  lockedConnection_NOT?: InputMaybe<TeachingBlockVersionLockedConnectionWhere>;
  locked_NOT?: InputMaybe<LockedWhere>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<TeachingBlockVersionRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockVersionRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockVersionRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockVersionRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockVersionRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<TeachingBlockVersionRoomsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return TeachingBlockVersions where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return TeachingBlockVersions where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return TeachingBlockVersions where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  /** @deprecated Use `subjects_SOME` instead. */
  subjects?: InputMaybe<SubjectWhere>;
  subjectsAggregate?: InputMaybe<TeachingBlockVersionSubjectsAggregateInput>;
  /** @deprecated Use `subjectsConnection_SOME` instead. */
  subjectsConnection?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockVersionSubjectsConnections match this filter */
  subjectsConnection_ALL?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockVersionSubjectsConnections match this filter */
  subjectsConnection_NONE?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
  /** @deprecated Use `subjectsConnection_NONE` instead. */
  subjectsConnection_NOT?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockVersionSubjectsConnections match this filter */
  subjectsConnection_SINGLE?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockVersionSubjectsConnections match this filter */
  subjectsConnection_SOME?: InputMaybe<TeachingBlockVersionSubjectsConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related Subjects match this filter */
  subjects_ALL?: InputMaybe<SubjectWhere>;
  /** Return TeachingBlockVersions where none of the related Subjects match this filter */
  subjects_NONE?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `subjects_NONE` instead. */
  subjects_NOT?: InputMaybe<SubjectWhere>;
  /** Return TeachingBlockVersions where one of the related Subjects match this filter */
  subjects_SINGLE?: InputMaybe<SubjectWhere>;
  /** Return TeachingBlockVersions where some of the related Subjects match this filter */
  subjects_SOME?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `teachers_SOME` instead. */
  teachers?: InputMaybe<PersonWhere>;
  teachersAggregate?: InputMaybe<TeachingBlockVersionTeachersAggregateInput>;
  /** @deprecated Use `teachersConnection_SOME` instead. */
  teachersConnection?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related TeachingBlockVersionTeachersConnections match this filter */
  teachersConnection_ALL?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
  /** Return TeachingBlockVersions where none of the related TeachingBlockVersionTeachersConnections match this filter */
  teachersConnection_NONE?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
  /** @deprecated Use `teachersConnection_NONE` instead. */
  teachersConnection_NOT?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
  /** Return TeachingBlockVersions where one of the related TeachingBlockVersionTeachersConnections match this filter */
  teachersConnection_SINGLE?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
  /** Return TeachingBlockVersions where some of the related TeachingBlockVersionTeachersConnections match this filter */
  teachersConnection_SOME?: InputMaybe<TeachingBlockVersionTeachersConnectionWhere>;
  /** Return TeachingBlockVersions where all of the related People match this filter */
  teachers_ALL?: InputMaybe<PersonWhere>;
  /** Return TeachingBlockVersions where none of the related People match this filter */
  teachers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `teachers_NONE` instead. */
  teachers_NOT?: InputMaybe<PersonWhere>;
  /** Return TeachingBlockVersions where one of the related People match this filter */
  teachers_SINGLE?: InputMaybe<PersonWhere>;
  /** Return TeachingBlockVersions where some of the related People match this filter */
  teachers_SOME?: InputMaybe<PersonWhere>;
  teachingBlock?: InputMaybe<TeachingBlockWhere>;
  teachingBlockAggregate?: InputMaybe<TeachingBlockVersionTeachingBlockAggregateInput>;
  teachingBlockConnection?: InputMaybe<TeachingBlockVersionTeachingBlockConnectionWhere>;
  teachingBlockConnection_NOT?: InputMaybe<TeachingBlockVersionTeachingBlockConnectionWhere>;
  teachingBlock_NOT?: InputMaybe<TeachingBlockWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TeachingBlockVersionsAggregateInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionsAggregateInput>>;
  NOT?: InputMaybe<TeachingBlockVersionsAggregateInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingBlockVersionsNodeAggregationWhereInput>;
};

export type TeachingBlockVersionsConnectFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TeachingBlockVersionConnectWhere>;
};

export type TeachingBlockVersionsConnection = {
  __typename?: 'TeachingBlockVersionsConnection';
  edges: Array<TeachingBlockVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingBlockVersionsConnectionSort = {
  node?: InputMaybe<TeachingBlockVersionSort>;
};

export type TeachingBlockVersionsConnectionWhere = {
  AND?: InputMaybe<Array<TeachingBlockVersionsConnectionWhere>>;
  NOT?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
  OR?: InputMaybe<Array<TeachingBlockVersionsConnectionWhere>>;
  node?: InputMaybe<TeachingBlockVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlockVersionsCreateFieldInput = {
  node: TeachingBlockVersionCreateInput;
};

export type TeachingBlockVersionsDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockVersionDeleteInput>;
  where?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
};

export type TeachingBlockVersionsDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockVersionDisconnectInput>;
  where?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
};

export type TeachingBlockVersionsFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionsCreateFieldInput>>;
};

export type TeachingBlockVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingBlockVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingBlockVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingBlockVersionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingBlockVersionsRelationship = {
  __typename?: 'TeachingBlockVersionsRelationship';
  cursor: Scalars['String']['output'];
  node: TeachingBlockVersion;
};

export type TeachingBlockVersionsUpdateConnectionInput = {
  node?: InputMaybe<TeachingBlockVersionUpdateInput>;
};

export type TeachingBlockVersionsUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingBlockVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingBlockVersionsCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingBlockVersionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingBlockVersionsDisconnectFieldInput>>;
  update?: InputMaybe<TeachingBlockVersionsUpdateConnectionInput>;
  where?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
};

export type TeachingBlockWhere = {
  AND?: InputMaybe<Array<TeachingBlockWhere>>;
  NOT?: InputMaybe<TeachingBlockWhere>;
  OR?: InputMaybe<Array<TeachingBlockWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  draft_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TeachingBlockOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TeachingBlockOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TeachingBlockOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<TeachingBlockSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<TeachingBlockSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<TeachingBlockSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  subjectContainer?: InputMaybe<SubjectContainerWhere>;
  subjectContainerAggregate?: InputMaybe<TeachingBlockSubjectContainerAggregateInput>;
  subjectContainerConnection?: InputMaybe<TeachingBlockSubjectContainerConnectionWhere>;
  subjectContainerConnection_NOT?: InputMaybe<TeachingBlockSubjectContainerConnectionWhere>;
  subjectContainer_NOT?: InputMaybe<SubjectContainerWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `versions_SOME` instead. */
  versions?: InputMaybe<TeachingBlockVersionWhere>;
  versionsAggregate?: InputMaybe<TeachingBlockVersionsAggregateInput>;
  /** @deprecated Use `versionsConnection_SOME` instead. */
  versionsConnection?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
  /** Return TeachingBlocks where all of the related TeachingBlockVersionsConnections match this filter */
  versionsConnection_ALL?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
  /** Return TeachingBlocks where none of the related TeachingBlockVersionsConnections match this filter */
  versionsConnection_NONE?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
  /** @deprecated Use `versionsConnection_NONE` instead. */
  versionsConnection_NOT?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
  /** Return TeachingBlocks where one of the related TeachingBlockVersionsConnections match this filter */
  versionsConnection_SINGLE?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
  /** Return TeachingBlocks where some of the related TeachingBlockVersionsConnections match this filter */
  versionsConnection_SOME?: InputMaybe<TeachingBlockVersionsConnectionWhere>;
  /** Return TeachingBlocks where all of the related TeachingBlockVersions match this filter */
  versions_ALL?: InputMaybe<TeachingBlockVersionWhere>;
  /** Return TeachingBlocks where none of the related TeachingBlockVersions match this filter */
  versions_NONE?: InputMaybe<TeachingBlockVersionWhere>;
  /** @deprecated Use `versions_NONE` instead. */
  versions_NOT?: InputMaybe<TeachingBlockVersionWhere>;
  /** Return TeachingBlocks where one of the related TeachingBlockVersions match this filter */
  versions_SINGLE?: InputMaybe<TeachingBlockVersionWhere>;
  /** Return TeachingBlocks where some of the related TeachingBlockVersions match this filter */
  versions_SOME?: InputMaybe<TeachingBlockVersionWhere>;
};

export type TeachingBlocksConnection = {
  __typename?: 'TeachingBlocksConnection';
  edges: Array<TeachingBlockEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadFactor = {
  __typename?: 'TeachingLoadFactor';
  active: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  factorType: FactorType;
  foreignId?: Maybe<Scalars['String']['output']>;
  gradeGroup: Array<GradeGroup>;
  gradeGroupConnection: TeachingLoadFactorGradeGroupConnection;
  grades: Array<Scalars['Int']['output']>;
  scenario?: Maybe<TeachingLoadScenario>;
  schoolYear: SchoolYear;
  schoolYearConnection: TeachingLoadFactorSchoolYearConnection;
  subject: Array<Subject>;
  subjectConnection: TeachingLoadFactorSubjectConnection;
  subjectContainer: Array<SubjectContainer>;
  subjectContainerConnection: TeachingLoadFactorSubjectContainerConnection;
  teachers: Array<Person>;
  teachersConnection: TeachingLoadFactorTeachersConnection;
  timeGridEntries: Array<TimeGridEntry>;
  timeGridEntriesConnection: TeachingLoadFactorTimeGridEntriesConnection;
  uuid: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
  valueMode: ValueMode;
  valuePartial?: Maybe<Scalars['Float']['output']>;
  valuePartialRaw?: Maybe<Scalars['String']['output']>;
  valueRaw: Scalars['String']['output'];
};

export type TeachingLoadFactorGradeGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GradeGroupOptions>;
  where?: InputMaybe<GradeGroupWhere>;
};

export type TeachingLoadFactorGradeGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadFactorGradeGroupConnectionSort>>;
  where?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
};

export type TeachingLoadFactorSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type TeachingLoadFactorSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadFactorSchoolYearConnectionSort>>;
  where?: InputMaybe<TeachingLoadFactorSchoolYearConnectionWhere>;
};

export type TeachingLoadFactorSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type TeachingLoadFactorSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadFactorSubjectConnectionSort>>;
  where?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
};

export type TeachingLoadFactorSubjectContainerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectContainerOptions>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type TeachingLoadFactorSubjectContainerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectionSort>>;
  where?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
};

export type TeachingLoadFactorTeachersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type TeachingLoadFactorTeachersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadFactorTeachersConnectionSort>>;
  where?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
};

export type TeachingLoadFactorTimeGridEntriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimeGridEntryOptions>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type TeachingLoadFactorTimeGridEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectionSort>>;
  where?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
};

export type TeachingLoadFactorAggregateSelection = {
  __typename?: 'TeachingLoadFactorAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  foreignId: StringAggregateSelection;
  uuid: IdAggregateSelection;
  value: FloatAggregateSelection;
  valuePartial: FloatAggregateSelection;
  valuePartialRaw: StringAggregateSelection;
  valueRaw: StringAggregateSelection;
};

export type TeachingLoadFactorConnectInput = {
  gradeGroup?: InputMaybe<Array<TeachingLoadFactorGradeGroupConnectFieldInput>>;
  schoolYear?: InputMaybe<TeachingLoadFactorSchoolYearConnectFieldInput>;
  subject?: InputMaybe<Array<TeachingLoadFactorSubjectConnectFieldInput>>;
  subjectContainer?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectFieldInput>>;
  teachers?: InputMaybe<Array<TeachingLoadFactorTeachersConnectFieldInput>>;
  timeGridEntries?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectFieldInput>>;
};

export type TeachingLoadFactorConnectOrCreateWhere = {
  node: TeachingLoadFactorUniqueWhere;
};

export type TeachingLoadFactorConnectWhere = {
  node: TeachingLoadFactorWhere;
};

export type TeachingLoadFactorCreateInput = {
  active: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  factorType: FactorType;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  gradeGroup?: InputMaybe<TeachingLoadFactorGradeGroupFieldInput>;
  grades: Array<Scalars['Int']['input']>;
  schoolYear?: InputMaybe<TeachingLoadFactorSchoolYearFieldInput>;
  subject?: InputMaybe<TeachingLoadFactorSubjectFieldInput>;
  subjectContainer?: InputMaybe<TeachingLoadFactorSubjectContainerFieldInput>;
  teachers?: InputMaybe<TeachingLoadFactorTeachersFieldInput>;
  timeGridEntries?: InputMaybe<TeachingLoadFactorTimeGridEntriesFieldInput>;
  value: Scalars['Float']['input'];
  valueMode: ValueMode;
  valuePartial?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw?: InputMaybe<Scalars['String']['input']>;
  valueRaw: Scalars['String']['input'];
};

export type TeachingLoadFactorDeleteInput = {
  gradeGroup?: InputMaybe<Array<TeachingLoadFactorGradeGroupDeleteFieldInput>>;
  schoolYear?: InputMaybe<TeachingLoadFactorSchoolYearDeleteFieldInput>;
  subject?: InputMaybe<Array<TeachingLoadFactorSubjectDeleteFieldInput>>;
  subjectContainer?: InputMaybe<Array<TeachingLoadFactorSubjectContainerDeleteFieldInput>>;
  teachers?: InputMaybe<Array<TeachingLoadFactorTeachersDeleteFieldInput>>;
  timeGridEntries?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesDeleteFieldInput>>;
};

export type TeachingLoadFactorDisconnectInput = {
  gradeGroup?: InputMaybe<Array<TeachingLoadFactorGradeGroupDisconnectFieldInput>>;
  schoolYear?: InputMaybe<TeachingLoadFactorSchoolYearDisconnectFieldInput>;
  subject?: InputMaybe<Array<TeachingLoadFactorSubjectDisconnectFieldInput>>;
  subjectContainer?: InputMaybe<Array<TeachingLoadFactorSubjectContainerDisconnectFieldInput>>;
  teachers?: InputMaybe<Array<TeachingLoadFactorTeachersDisconnectFieldInput>>;
  timeGridEntries?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesDisconnectFieldInput>>;
};

export type TeachingLoadFactorEdge = {
  __typename?: 'TeachingLoadFactorEdge';
  cursor: Scalars['String']['output'];
  node: TeachingLoadFactor;
};

export type TeachingLoadFactorGradeGroupAggregateInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorGradeGroupAggregateInput>>;
  NOT?: InputMaybe<TeachingLoadFactorGradeGroupAggregateInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorGradeGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingLoadFactorGradeGroupNodeAggregationWhereInput>;
};

export type TeachingLoadFactorGradeGroupConnectFieldInput = {
  connect?: InputMaybe<Array<GradeGroupConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<GradeGroupConnectWhere>;
};

export type TeachingLoadFactorGradeGroupConnection = {
  __typename?: 'TeachingLoadFactorGradeGroupConnection';
  edges: Array<TeachingLoadFactorGradeGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadFactorGradeGroupConnectionSort = {
  node?: InputMaybe<GradeGroupSort>;
};

export type TeachingLoadFactorGradeGroupConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadFactorGradeGroupConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadFactorGradeGroupConnectionWhere>>;
  node?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<GradeGroupWhere>;
};

export type TeachingLoadFactorGradeGroupCreateFieldInput = {
  node: GradeGroupCreateInput;
};

export type TeachingLoadFactorGradeGroupDeleteFieldInput = {
  delete?: InputMaybe<GradeGroupDeleteInput>;
  where?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
};

export type TeachingLoadFactorGradeGroupDisconnectFieldInput = {
  disconnect?: InputMaybe<GradeGroupDisconnectInput>;
  where?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
};

export type TeachingLoadFactorGradeGroupFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorGradeGroupConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorGradeGroupCreateFieldInput>>;
};

export type TeachingLoadFactorGradeGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorGradeGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingLoadFactorGradeGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorGradeGroupNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TeachingLoadFactorGradeGroupRelationship = {
  __typename?: 'TeachingLoadFactorGradeGroupRelationship';
  cursor: Scalars['String']['output'];
  node: GradeGroup;
};

export type TeachingLoadFactorGradeGroupUpdateConnectionInput = {
  node?: InputMaybe<GradeGroupUpdateInput>;
};

export type TeachingLoadFactorGradeGroupUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorGradeGroupConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorGradeGroupCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingLoadFactorGradeGroupDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingLoadFactorGradeGroupDisconnectFieldInput>>;
  update?: InputMaybe<TeachingLoadFactorGradeGroupUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
};

export type TeachingLoadFactorOnCreateInput = {
  active: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  factorType: FactorType;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  grades: Array<Scalars['Int']['input']>;
  value: Scalars['Float']['input'];
  valueMode: ValueMode;
  valuePartial?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw?: InputMaybe<Scalars['String']['input']>;
  valueRaw: Scalars['String']['input'];
};

export type TeachingLoadFactorOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingLoadFactorSort objects to sort TeachingLoadFactors by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingLoadFactorSort>>;
};

export type TeachingLoadFactorSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorSchoolYearAggregateInput>>;
  NOT?: InputMaybe<TeachingLoadFactorSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingLoadFactorSchoolYearNodeAggregationWhereInput>;
};

export type TeachingLoadFactorSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type TeachingLoadFactorSchoolYearConnection = {
  __typename?: 'TeachingLoadFactorSchoolYearConnection';
  edges: Array<TeachingLoadFactorSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadFactorSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type TeachingLoadFactorSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadFactorSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadFactorSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadFactorSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type TeachingLoadFactorSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type TeachingLoadFactorSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<TeachingLoadFactorSchoolYearConnectionWhere>;
};

export type TeachingLoadFactorSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<TeachingLoadFactorSchoolYearConnectionWhere>;
};

export type TeachingLoadFactorSchoolYearFieldInput = {
  connect?: InputMaybe<TeachingLoadFactorSchoolYearConnectFieldInput>;
  create?: InputMaybe<TeachingLoadFactorSchoolYearCreateFieldInput>;
};

export type TeachingLoadFactorSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingLoadFactorSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingLoadFactorSchoolYearRelationship = {
  __typename?: 'TeachingLoadFactorSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type TeachingLoadFactorSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type TeachingLoadFactorSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<TeachingLoadFactorSchoolYearConnectFieldInput>;
  create?: InputMaybe<TeachingLoadFactorSchoolYearCreateFieldInput>;
  delete?: InputMaybe<TeachingLoadFactorSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingLoadFactorSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<TeachingLoadFactorSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadFactorSchoolYearConnectionWhere>;
};

/** Fields to sort TeachingLoadFactors by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingLoadFactorSort object. */
export type TeachingLoadFactorSort = {
  active?: InputMaybe<SortDirection>;
  comment?: InputMaybe<SortDirection>;
  factorType?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
  valueMode?: InputMaybe<SortDirection>;
  valuePartial?: InputMaybe<SortDirection>;
  valuePartialRaw?: InputMaybe<SortDirection>;
  valueRaw?: InputMaybe<SortDirection>;
};

export type TeachingLoadFactorSubjectAggregateInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorSubjectAggregateInput>>;
  NOT?: InputMaybe<TeachingLoadFactorSubjectAggregateInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorSubjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingLoadFactorSubjectNodeAggregationWhereInput>;
};

export type TeachingLoadFactorSubjectConnectFieldInput = {
  connect?: InputMaybe<Array<SubjectConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type TeachingLoadFactorSubjectConnectOrCreateFieldInput = {
  onCreate: TeachingLoadFactorSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type TeachingLoadFactorSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type TeachingLoadFactorSubjectConnection = {
  __typename?: 'TeachingLoadFactorSubjectConnection';
  edges: Array<TeachingLoadFactorSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadFactorSubjectConnectionSort = {
  node?: InputMaybe<SubjectSort>;
};

export type TeachingLoadFactorSubjectConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadFactorSubjectConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadFactorSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type TeachingLoadFactorSubjectContainerAggregateInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorSubjectContainerAggregateInput>>;
  NOT?: InputMaybe<TeachingLoadFactorSubjectContainerAggregateInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorSubjectContainerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingLoadFactorSubjectContainerNodeAggregationWhereInput>;
};

export type TeachingLoadFactorSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<Array<SubjectContainerConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type TeachingLoadFactorSubjectContainerConnectOrCreateFieldInput = {
  onCreate: TeachingLoadFactorSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type TeachingLoadFactorSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type TeachingLoadFactorSubjectContainerConnection = {
  __typename?: 'TeachingLoadFactorSubjectContainerConnection';
  edges: Array<TeachingLoadFactorSubjectContainerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadFactorSubjectContainerConnectionSort = {
  node?: InputMaybe<SubjectContainerSort>;
};

export type TeachingLoadFactorSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type TeachingLoadFactorSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type TeachingLoadFactorSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
};

export type TeachingLoadFactorSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
};

export type TeachingLoadFactorSubjectContainerFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorSubjectContainerCreateFieldInput>>;
};

export type TeachingLoadFactorSubjectContainerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorSubjectContainerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingLoadFactorSubjectContainerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorSubjectContainerNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingLoadFactorSubjectContainerRelationship = {
  __typename?: 'TeachingLoadFactorSubjectContainerRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainer;
};

export type TeachingLoadFactorSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type TeachingLoadFactorSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorSubjectContainerConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorSubjectContainerCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingLoadFactorSubjectContainerDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingLoadFactorSubjectContainerDisconnectFieldInput>>;
  update?: InputMaybe<TeachingLoadFactorSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
};

export type TeachingLoadFactorSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type TeachingLoadFactorSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
};

export type TeachingLoadFactorSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
};

export type TeachingLoadFactorSubjectFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorSubjectConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorSubjectConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorSubjectCreateFieldInput>>;
};

export type TeachingLoadFactorSubjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorSubjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingLoadFactorSubjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorSubjectNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingLoadFactorSubjectRelationship = {
  __typename?: 'TeachingLoadFactorSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
};

export type TeachingLoadFactorSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type TeachingLoadFactorSubjectUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorSubjectConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorSubjectConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorSubjectCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingLoadFactorSubjectDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingLoadFactorSubjectDisconnectFieldInput>>;
  update?: InputMaybe<TeachingLoadFactorSubjectUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
};

export type TeachingLoadFactorTeachersAggregateInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorTeachersAggregateInput>>;
  NOT?: InputMaybe<TeachingLoadFactorTeachersAggregateInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorTeachersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingLoadFactorTeachersNodeAggregationWhereInput>;
};

export type TeachingLoadFactorTeachersConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type TeachingLoadFactorTeachersConnectOrCreateFieldInput = {
  onCreate: TeachingLoadFactorTeachersConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type TeachingLoadFactorTeachersConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type TeachingLoadFactorTeachersConnection = {
  __typename?: 'TeachingLoadFactorTeachersConnection';
  edges: Array<TeachingLoadFactorTeachersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadFactorTeachersConnectionSort = {
  node?: InputMaybe<PersonSort>;
};

export type TeachingLoadFactorTeachersConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadFactorTeachersConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadFactorTeachersConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type TeachingLoadFactorTeachersCreateFieldInput = {
  node: PersonCreateInput;
};

export type TeachingLoadFactorTeachersDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
};

export type TeachingLoadFactorTeachersDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
};

export type TeachingLoadFactorTeachersFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorTeachersCreateFieldInput>>;
};

export type TeachingLoadFactorTeachersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorTeachersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingLoadFactorTeachersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorTeachersNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingLoadFactorTeachersRelationship = {
  __typename?: 'TeachingLoadFactorTeachersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
};

export type TeachingLoadFactorTeachersUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type TeachingLoadFactorTeachersUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorTeachersCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingLoadFactorTeachersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingLoadFactorTeachersDisconnectFieldInput>>;
  update?: InputMaybe<TeachingLoadFactorTeachersUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
};

export type TeachingLoadFactorTimeGridEntriesAggregateInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesAggregateInput>>;
  NOT?: InputMaybe<TeachingLoadFactorTimeGridEntriesAggregateInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TeachingLoadFactorTimeGridEntriesNodeAggregationWhereInput>;
};

export type TeachingLoadFactorTimeGridEntriesConnectFieldInput = {
  connect?: InputMaybe<Array<TimeGridEntryConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimeGridEntryConnectWhere>;
};

export type TeachingLoadFactorTimeGridEntriesConnectOrCreateFieldInput = {
  onCreate: TeachingLoadFactorTimeGridEntriesConnectOrCreateFieldInputOnCreate;
  where: TimeGridEntryConnectOrCreateWhere;
};

export type TeachingLoadFactorTimeGridEntriesConnectOrCreateFieldInputOnCreate = {
  node: TimeGridEntryOnCreateInput;
};

export type TeachingLoadFactorTimeGridEntriesConnection = {
  __typename?: 'TeachingLoadFactorTimeGridEntriesConnection';
  edges: Array<TeachingLoadFactorTimeGridEntriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadFactorTimeGridEntriesConnectionSort = {
  node?: InputMaybe<TimeGridEntrySort>;
};

export type TeachingLoadFactorTimeGridEntriesConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectionWhere>>;
  node?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimeGridEntryWhere>;
};

export type TeachingLoadFactorTimeGridEntriesCreateFieldInput = {
  node: TimeGridEntryCreateInput;
};

export type TeachingLoadFactorTimeGridEntriesDeleteFieldInput = {
  delete?: InputMaybe<TimeGridEntryDeleteInput>;
  where?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
};

export type TeachingLoadFactorTimeGridEntriesDisconnectFieldInput = {
  disconnect?: InputMaybe<TimeGridEntryDisconnectInput>;
  where?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
};

export type TeachingLoadFactorTimeGridEntriesFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesCreateFieldInput>>;
};

export type TeachingLoadFactorTimeGridEntriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingLoadFactorTimeGridEntriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesNodeAggregationWhereInput>>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingLoadFactorTimeGridEntriesRelationship = {
  __typename?: 'TeachingLoadFactorTimeGridEntriesRelationship';
  cursor: Scalars['String']['output'];
  node: TimeGridEntry;
};

export type TeachingLoadFactorTimeGridEntriesUpdateConnectionInput = {
  node?: InputMaybe<TimeGridEntryUpdateInput>;
};

export type TeachingLoadFactorTimeGridEntriesUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesDisconnectFieldInput>>;
  update?: InputMaybe<TeachingLoadFactorTimeGridEntriesUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
};

export type TeachingLoadFactorUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingLoadFactorUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  factorType?: InputMaybe<FactorType>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  gradeGroup?: InputMaybe<Array<TeachingLoadFactorGradeGroupUpdateFieldInput>>;
  grades?: InputMaybe<Array<Scalars['Int']['input']>>;
  grades_POP?: InputMaybe<Scalars['Int']['input']>;
  grades_PUSH?: InputMaybe<Array<Scalars['Int']['input']>>;
  schoolYear?: InputMaybe<TeachingLoadFactorSchoolYearUpdateFieldInput>;
  subject?: InputMaybe<Array<TeachingLoadFactorSubjectUpdateFieldInput>>;
  subjectContainer?: InputMaybe<Array<TeachingLoadFactorSubjectContainerUpdateFieldInput>>;
  teachers?: InputMaybe<Array<TeachingLoadFactorTeachersUpdateFieldInput>>;
  timeGridEntries?: InputMaybe<Array<TeachingLoadFactorTimeGridEntriesUpdateFieldInput>>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueMode?: InputMaybe<ValueMode>;
  valuePartial?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw?: InputMaybe<Scalars['String']['input']>;
  valuePartial_ADD?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  valueRaw?: InputMaybe<Scalars['String']['input']>;
  value_ADD?: InputMaybe<Scalars['Float']['input']>;
  value_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  value_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  value_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type TeachingLoadFactorWhere = {
  AND?: InputMaybe<Array<TeachingLoadFactorWhere>>;
  NOT?: InputMaybe<TeachingLoadFactorWhere>;
  OR?: InputMaybe<Array<TeachingLoadFactorWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  factorType?: InputMaybe<FactorType>;
  factorType_IN?: InputMaybe<Array<FactorType>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  factorType_NOT?: InputMaybe<FactorType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  factorType_NOT_IN?: InputMaybe<Array<FactorType>>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `gradeGroup_SOME` instead. */
  gradeGroup?: InputMaybe<GradeGroupWhere>;
  gradeGroupAggregate?: InputMaybe<TeachingLoadFactorGradeGroupAggregateInput>;
  /** @deprecated Use `gradeGroupConnection_SOME` instead. */
  gradeGroupConnection?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related TeachingLoadFactorGradeGroupConnections match this filter */
  gradeGroupConnection_ALL?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
  /** Return TeachingLoadFactors where none of the related TeachingLoadFactorGradeGroupConnections match this filter */
  gradeGroupConnection_NONE?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
  /** @deprecated Use `gradeGroupConnection_NONE` instead. */
  gradeGroupConnection_NOT?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
  /** Return TeachingLoadFactors where one of the related TeachingLoadFactorGradeGroupConnections match this filter */
  gradeGroupConnection_SINGLE?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
  /** Return TeachingLoadFactors where some of the related TeachingLoadFactorGradeGroupConnections match this filter */
  gradeGroupConnection_SOME?: InputMaybe<TeachingLoadFactorGradeGroupConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related GradeGroups match this filter */
  gradeGroup_ALL?: InputMaybe<GradeGroupWhere>;
  /** Return TeachingLoadFactors where none of the related GradeGroups match this filter */
  gradeGroup_NONE?: InputMaybe<GradeGroupWhere>;
  /** @deprecated Use `gradeGroup_NONE` instead. */
  gradeGroup_NOT?: InputMaybe<GradeGroupWhere>;
  /** Return TeachingLoadFactors where one of the related GradeGroups match this filter */
  gradeGroup_SINGLE?: InputMaybe<GradeGroupWhere>;
  /** Return TeachingLoadFactors where some of the related GradeGroups match this filter */
  gradeGroup_SOME?: InputMaybe<GradeGroupWhere>;
  grades?: InputMaybe<Array<Scalars['Int']['input']>>;
  grades_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  grades_NOT_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<TeachingLoadFactorSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<TeachingLoadFactorSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<TeachingLoadFactorSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Use `subject_SOME` instead. */
  subject?: InputMaybe<SubjectWhere>;
  subjectAggregate?: InputMaybe<TeachingLoadFactorSubjectAggregateInput>;
  /** @deprecated Use `subjectConnection_SOME` instead. */
  subjectConnection?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related TeachingLoadFactorSubjectConnections match this filter */
  subjectConnection_ALL?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
  /** Return TeachingLoadFactors where none of the related TeachingLoadFactorSubjectConnections match this filter */
  subjectConnection_NONE?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
  /** @deprecated Use `subjectConnection_NONE` instead. */
  subjectConnection_NOT?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
  /** Return TeachingLoadFactors where one of the related TeachingLoadFactorSubjectConnections match this filter */
  subjectConnection_SINGLE?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
  /** Return TeachingLoadFactors where some of the related TeachingLoadFactorSubjectConnections match this filter */
  subjectConnection_SOME?: InputMaybe<TeachingLoadFactorSubjectConnectionWhere>;
  /** @deprecated Use `subjectContainer_SOME` instead. */
  subjectContainer?: InputMaybe<SubjectContainerWhere>;
  subjectContainerAggregate?: InputMaybe<TeachingLoadFactorSubjectContainerAggregateInput>;
  /** @deprecated Use `subjectContainerConnection_SOME` instead. */
  subjectContainerConnection?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related TeachingLoadFactorSubjectContainerConnections match this filter */
  subjectContainerConnection_ALL?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
  /** Return TeachingLoadFactors where none of the related TeachingLoadFactorSubjectContainerConnections match this filter */
  subjectContainerConnection_NONE?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
  /** @deprecated Use `subjectContainerConnection_NONE` instead. */
  subjectContainerConnection_NOT?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
  /** Return TeachingLoadFactors where one of the related TeachingLoadFactorSubjectContainerConnections match this filter */
  subjectContainerConnection_SINGLE?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
  /** Return TeachingLoadFactors where some of the related TeachingLoadFactorSubjectContainerConnections match this filter */
  subjectContainerConnection_SOME?: InputMaybe<TeachingLoadFactorSubjectContainerConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related SubjectContainers match this filter */
  subjectContainer_ALL?: InputMaybe<SubjectContainerWhere>;
  /** Return TeachingLoadFactors where none of the related SubjectContainers match this filter */
  subjectContainer_NONE?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Use `subjectContainer_NONE` instead. */
  subjectContainer_NOT?: InputMaybe<SubjectContainerWhere>;
  /** Return TeachingLoadFactors where one of the related SubjectContainers match this filter */
  subjectContainer_SINGLE?: InputMaybe<SubjectContainerWhere>;
  /** Return TeachingLoadFactors where some of the related SubjectContainers match this filter */
  subjectContainer_SOME?: InputMaybe<SubjectContainerWhere>;
  /** Return TeachingLoadFactors where all of the related Subjects match this filter */
  subject_ALL?: InputMaybe<SubjectWhere>;
  /** Return TeachingLoadFactors where none of the related Subjects match this filter */
  subject_NONE?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `subject_NONE` instead. */
  subject_NOT?: InputMaybe<SubjectWhere>;
  /** Return TeachingLoadFactors where one of the related Subjects match this filter */
  subject_SINGLE?: InputMaybe<SubjectWhere>;
  /** Return TeachingLoadFactors where some of the related Subjects match this filter */
  subject_SOME?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `teachers_SOME` instead. */
  teachers?: InputMaybe<PersonWhere>;
  teachersAggregate?: InputMaybe<TeachingLoadFactorTeachersAggregateInput>;
  /** @deprecated Use `teachersConnection_SOME` instead. */
  teachersConnection?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related TeachingLoadFactorTeachersConnections match this filter */
  teachersConnection_ALL?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
  /** Return TeachingLoadFactors where none of the related TeachingLoadFactorTeachersConnections match this filter */
  teachersConnection_NONE?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
  /** @deprecated Use `teachersConnection_NONE` instead. */
  teachersConnection_NOT?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
  /** Return TeachingLoadFactors where one of the related TeachingLoadFactorTeachersConnections match this filter */
  teachersConnection_SINGLE?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
  /** Return TeachingLoadFactors where some of the related TeachingLoadFactorTeachersConnections match this filter */
  teachersConnection_SOME?: InputMaybe<TeachingLoadFactorTeachersConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related People match this filter */
  teachers_ALL?: InputMaybe<PersonWhere>;
  /** Return TeachingLoadFactors where none of the related People match this filter */
  teachers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `teachers_NONE` instead. */
  teachers_NOT?: InputMaybe<PersonWhere>;
  /** Return TeachingLoadFactors where one of the related People match this filter */
  teachers_SINGLE?: InputMaybe<PersonWhere>;
  /** Return TeachingLoadFactors where some of the related People match this filter */
  teachers_SOME?: InputMaybe<PersonWhere>;
  /** @deprecated Use `timeGridEntries_SOME` instead. */
  timeGridEntries?: InputMaybe<TimeGridEntryWhere>;
  timeGridEntriesAggregate?: InputMaybe<TeachingLoadFactorTimeGridEntriesAggregateInput>;
  /** @deprecated Use `timeGridEntriesConnection_SOME` instead. */
  timeGridEntriesConnection?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related TeachingLoadFactorTimeGridEntriesConnections match this filter */
  timeGridEntriesConnection_ALL?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
  /** Return TeachingLoadFactors where none of the related TeachingLoadFactorTimeGridEntriesConnections match this filter */
  timeGridEntriesConnection_NONE?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
  /** @deprecated Use `timeGridEntriesConnection_NONE` instead. */
  timeGridEntriesConnection_NOT?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
  /** Return TeachingLoadFactors where one of the related TeachingLoadFactorTimeGridEntriesConnections match this filter */
  timeGridEntriesConnection_SINGLE?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
  /** Return TeachingLoadFactors where some of the related TeachingLoadFactorTimeGridEntriesConnections match this filter */
  timeGridEntriesConnection_SOME?: InputMaybe<TeachingLoadFactorTimeGridEntriesConnectionWhere>;
  /** Return TeachingLoadFactors where all of the related TimeGridEntries match this filter */
  timeGridEntries_ALL?: InputMaybe<TimeGridEntryWhere>;
  /** Return TeachingLoadFactors where none of the related TimeGridEntries match this filter */
  timeGridEntries_NONE?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Use `timeGridEntries_NONE` instead. */
  timeGridEntries_NOT?: InputMaybe<TimeGridEntryWhere>;
  /** Return TeachingLoadFactors where one of the related TimeGridEntries match this filter */
  timeGridEntries_SINGLE?: InputMaybe<TimeGridEntryWhere>;
  /** Return TeachingLoadFactors where some of the related TimeGridEntries match this filter */
  timeGridEntries_SOME?: InputMaybe<TimeGridEntryWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueMode?: InputMaybe<ValueMode>;
  valueMode_IN?: InputMaybe<Array<ValueMode>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valueMode_NOT?: InputMaybe<ValueMode>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valueMode_NOT_IN?: InputMaybe<Array<ValueMode>>;
  valuePartial?: InputMaybe<Scalars['Float']['input']>;
  valuePartialRaw?: InputMaybe<Scalars['String']['input']>;
  valuePartialRaw_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  valuePartialRaw_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  valuePartialRaw_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valuePartialRaw_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valuePartialRaw_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valuePartialRaw_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valuePartialRaw_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valuePartialRaw_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valuePartialRaw_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valuePartial_GT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_GTE?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  valuePartial_LT?: InputMaybe<Scalars['Float']['input']>;
  valuePartial_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valuePartial_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valuePartial_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  valueRaw?: InputMaybe<Scalars['String']['input']>;
  valueRaw_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  valueRaw_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  valueRaw_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valueRaw_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valueRaw_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valueRaw_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valueRaw_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  valueRaw_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valueRaw_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  value_NOT_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type TeachingLoadFactorsConnection = {
  __typename?: 'TeachingLoadFactorsConnection';
  edges: Array<TeachingLoadFactorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadReport = {
  __typename?: 'TeachingLoadReport';
  context: PdfReportContext;
  contextConnection: TeachingLoadReportContextConnection;
  fileEntries: Array<FileEntry>;
  fileEntriesAggregate?: Maybe<TeachingLoadReportFileEntryFileEntriesAggregationSelection>;
  fileEntriesConnection: TeachingLoadReportFileEntriesConnection;
  jobConfiguration: Scalars['String']['output'];
  jobCreated: Scalars['DateTime']['output'];
  jobFinished: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: TeachingLoadReportType;
  uuid: Scalars['ID']['output'];
};

export type TeachingLoadReportContextArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PdfReportContextWhere>;
};

export type TeachingLoadReportContextConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadReportContextConnectionSort>>;
  where?: InputMaybe<TeachingLoadReportContextConnectionWhere>;
};

export type TeachingLoadReportFileEntriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileEntryOptions>;
  where?: InputMaybe<FileEntryWhere>;
};

export type TeachingLoadReportFileEntriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileEntryWhere>;
};

export type TeachingLoadReportFileEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TeachingLoadReportFileEntriesConnectionSort>>;
  where?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
};

export type TeachingLoadReportAggregateSelection = {
  __typename?: 'TeachingLoadReportAggregateSelection';
  count: Scalars['Int']['output'];
  jobConfiguration: StringAggregateSelection;
  jobCreated: DateTimeAggregateSelection;
  jobFinished: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingLoadReportConnectInput = {
  context?: InputMaybe<TeachingLoadReportContextConnectInput>;
  fileEntries?: InputMaybe<Array<TeachingLoadReportFileEntriesConnectFieldInput>>;
};

export type TeachingLoadReportConnectWhere = {
  node: TeachingLoadReportWhere;
};

export type TeachingLoadReportContextConnectInput = {
  SchoolYear?: InputMaybe<TeachingLoadReportContextSchoolYearConnectFieldInput>;
  TeachingBlock?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectFieldInput>;
  TimetableBlock?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectFieldInput>;
};

export type TeachingLoadReportContextConnection = {
  __typename?: 'TeachingLoadReportContextConnection';
  edges: Array<TeachingLoadReportContextRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadReportContextConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
};

export type TeachingLoadReportContextConnectionWhere = {
  SchoolYear?: InputMaybe<TeachingLoadReportContextSchoolYearConnectionWhere>;
  TeachingBlock?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectionWhere>;
  TimetableBlock?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectionWhere>;
};

export type TeachingLoadReportContextCreateInput = {
  SchoolYear?: InputMaybe<TeachingLoadReportContextSchoolYearFieldInput>;
  TeachingBlock?: InputMaybe<TeachingLoadReportContextTeachingBlockFieldInput>;
  TimetableBlock?: InputMaybe<TeachingLoadReportContextTimetableBlockFieldInput>;
};

export type TeachingLoadReportContextDeleteInput = {
  SchoolYear?: InputMaybe<TeachingLoadReportContextSchoolYearDeleteFieldInput>;
  TeachingBlock?: InputMaybe<TeachingLoadReportContextTeachingBlockDeleteFieldInput>;
  TimetableBlock?: InputMaybe<TeachingLoadReportContextTimetableBlockDeleteFieldInput>;
};

export type TeachingLoadReportContextDisconnectInput = {
  SchoolYear?: InputMaybe<TeachingLoadReportContextSchoolYearDisconnectFieldInput>;
  TeachingBlock?: InputMaybe<TeachingLoadReportContextTeachingBlockDisconnectFieldInput>;
  TimetableBlock?: InputMaybe<TeachingLoadReportContextTimetableBlockDisconnectFieldInput>;
};

export type TeachingLoadReportContextRelationship = {
  __typename?: 'TeachingLoadReportContextRelationship';
  cursor: Scalars['String']['output'];
  node: PdfReportContext;
  properties: OrderedRelationProperties;
};

export type TeachingLoadReportContextSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type TeachingLoadReportContextSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadReportContextSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadReportContextSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadReportContextSchoolYearConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type TeachingLoadReportContextSchoolYearCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: SchoolYearCreateInput;
};

export type TeachingLoadReportContextSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<TeachingLoadReportContextSchoolYearConnectionWhere>;
};

export type TeachingLoadReportContextSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<TeachingLoadReportContextSchoolYearConnectionWhere>;
};

export type TeachingLoadReportContextSchoolYearFieldInput = {
  connect?: InputMaybe<TeachingLoadReportContextSchoolYearConnectFieldInput>;
  create?: InputMaybe<TeachingLoadReportContextSchoolYearCreateFieldInput>;
};

export type TeachingLoadReportContextSchoolYearUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type TeachingLoadReportContextSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<TeachingLoadReportContextSchoolYearConnectFieldInput>;
  create?: InputMaybe<TeachingLoadReportContextSchoolYearCreateFieldInput>;
  delete?: InputMaybe<TeachingLoadReportContextSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingLoadReportContextSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<TeachingLoadReportContextSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadReportContextSchoolYearConnectionWhere>;
};

export type TeachingLoadReportContextTeachingBlockConnectFieldInput = {
  connect?: InputMaybe<TeachingBlockConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TeachingBlockConnectWhere>;
};

export type TeachingLoadReportContextTeachingBlockConnectOrCreateFieldInput = {
  onCreate: TeachingLoadReportContextTeachingBlockConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockConnectOrCreateWhere;
};

export type TeachingLoadReportContextTeachingBlockConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingBlockOnCreateInput;
};

export type TeachingLoadReportContextTeachingBlockConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadReportContextTeachingBlockConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadReportContextTeachingBlockConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockWhere>;
};

export type TeachingLoadReportContextTeachingBlockCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingBlockCreateInput;
};

export type TeachingLoadReportContextTeachingBlockDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockDeleteInput>;
  where?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectionWhere>;
};

export type TeachingLoadReportContextTeachingBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockDisconnectInput>;
  where?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectionWhere>;
};

export type TeachingLoadReportContextTeachingBlockFieldInput = {
  connect?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingLoadReportContextTeachingBlockCreateFieldInput>;
};

export type TeachingLoadReportContextTeachingBlockUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingBlockUpdateInput>;
};

export type TeachingLoadReportContextTeachingBlockUpdateFieldInput = {
  connect?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<TeachingLoadReportContextTeachingBlockCreateFieldInput>;
  delete?: InputMaybe<TeachingLoadReportContextTeachingBlockDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingLoadReportContextTeachingBlockDisconnectFieldInput>;
  update?: InputMaybe<TeachingLoadReportContextTeachingBlockUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadReportContextTeachingBlockConnectionWhere>;
};

export type TeachingLoadReportContextTimetableBlockConnectFieldInput = {
  connect?: InputMaybe<TimetableBlockConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TimetableBlockConnectWhere>;
};

export type TeachingLoadReportContextTimetableBlockConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadReportContextTimetableBlockConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadReportContextTimetableBlockConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableBlockWhere>;
};

export type TeachingLoadReportContextTimetableBlockCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TimetableBlockCreateInput;
};

export type TeachingLoadReportContextTimetableBlockDeleteFieldInput = {
  delete?: InputMaybe<TimetableBlockDeleteInput>;
  where?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectionWhere>;
};

export type TeachingLoadReportContextTimetableBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableBlockDisconnectInput>;
  where?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectionWhere>;
};

export type TeachingLoadReportContextTimetableBlockFieldInput = {
  connect?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectFieldInput>;
  create?: InputMaybe<TeachingLoadReportContextTimetableBlockCreateFieldInput>;
};

export type TeachingLoadReportContextTimetableBlockUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TimetableBlockUpdateInput>;
};

export type TeachingLoadReportContextTimetableBlockUpdateFieldInput = {
  connect?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectFieldInput>;
  create?: InputMaybe<TeachingLoadReportContextTimetableBlockCreateFieldInput>;
  delete?: InputMaybe<TeachingLoadReportContextTimetableBlockDeleteFieldInput>;
  disconnect?: InputMaybe<TeachingLoadReportContextTimetableBlockDisconnectFieldInput>;
  update?: InputMaybe<TeachingLoadReportContextTimetableBlockUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadReportContextTimetableBlockConnectionWhere>;
};

export type TeachingLoadReportContextUpdateInput = {
  SchoolYear?: InputMaybe<TeachingLoadReportContextSchoolYearUpdateFieldInput>;
  TeachingBlock?: InputMaybe<TeachingLoadReportContextTeachingBlockUpdateFieldInput>;
  TimetableBlock?: InputMaybe<TeachingLoadReportContextTimetableBlockUpdateFieldInput>;
};

export type TeachingLoadReportCreateInput = {
  context?: InputMaybe<TeachingLoadReportContextCreateInput>;
  fileEntries?: InputMaybe<TeachingLoadReportFileEntriesFieldInput>;
  jobConfiguration: Scalars['String']['input'];
  jobFinished: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: TeachingLoadReportType;
};

export type TeachingLoadReportDeleteInput = {
  context?: InputMaybe<TeachingLoadReportContextDeleteInput>;
  fileEntries?: InputMaybe<Array<TeachingLoadReportFileEntriesDeleteFieldInput>>;
};

export type TeachingLoadReportDisconnectInput = {
  context?: InputMaybe<TeachingLoadReportContextDisconnectInput>;
  fileEntries?: InputMaybe<Array<TeachingLoadReportFileEntriesDisconnectFieldInput>>;
};

export type TeachingLoadReportEdge = {
  __typename?: 'TeachingLoadReportEdge';
  cursor: Scalars['String']['output'];
  node: TeachingLoadReport;
};

export type TeachingLoadReportFileEntriesAggregateInput = {
  AND?: InputMaybe<Array<TeachingLoadReportFileEntriesAggregateInput>>;
  NOT?: InputMaybe<TeachingLoadReportFileEntriesAggregateInput>;
  OR?: InputMaybe<Array<TeachingLoadReportFileEntriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<TeachingLoadReportFileEntriesNodeAggregationWhereInput>;
};

export type TeachingLoadReportFileEntriesConnectFieldInput = {
  connect?: InputMaybe<Array<FileEntryConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileEntryConnectWhere>;
};

export type TeachingLoadReportFileEntriesConnection = {
  __typename?: 'TeachingLoadReportFileEntriesConnection';
  edges: Array<TeachingLoadReportFileEntriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadReportFileEntriesConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<FileEntrySort>;
};

export type TeachingLoadReportFileEntriesConnectionWhere = {
  AND?: InputMaybe<Array<TeachingLoadReportFileEntriesConnectionWhere>>;
  NOT?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
  OR?: InputMaybe<Array<TeachingLoadReportFileEntriesConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<FileEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<FileEntryWhere>;
};

export type TeachingLoadReportFileEntriesCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: FileEntryCreateInput;
};

export type TeachingLoadReportFileEntriesDeleteFieldInput = {
  delete?: InputMaybe<FileEntryDeleteInput>;
  where?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
};

export type TeachingLoadReportFileEntriesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileEntryDisconnectInput>;
  where?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
};

export type TeachingLoadReportFileEntriesFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadReportFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadReportFileEntriesCreateFieldInput>>;
};

export type TeachingLoadReportFileEntriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TeachingLoadReportFileEntriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TeachingLoadReportFileEntriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TeachingLoadReportFileEntriesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filename_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filename_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeachingLoadReportFileEntriesRelationship = {
  __typename?: 'TeachingLoadReportFileEntriesRelationship';
  cursor: Scalars['String']['output'];
  node: FileEntry;
  properties: OrderedRelationProperties;
};

export type TeachingLoadReportFileEntriesUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<FileEntryUpdateInput>;
};

export type TeachingLoadReportFileEntriesUpdateFieldInput = {
  connect?: InputMaybe<Array<TeachingLoadReportFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<TeachingLoadReportFileEntriesCreateFieldInput>>;
  delete?: InputMaybe<Array<TeachingLoadReportFileEntriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TeachingLoadReportFileEntriesDisconnectFieldInput>>;
  update?: InputMaybe<TeachingLoadReportFileEntriesUpdateConnectionInput>;
  where?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
};

export type TeachingLoadReportFileEntryFileEntriesAggregationSelection = {
  __typename?: 'TeachingLoadReportFileEntryFileEntriesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TeachingLoadReportFileEntryFileEntriesEdgeAggregateSelection>;
  node?: Maybe<TeachingLoadReportFileEntryFileEntriesNodeAggregateSelection>;
};

export type TeachingLoadReportFileEntryFileEntriesEdgeAggregateSelection = {
  __typename?: 'TeachingLoadReportFileEntryFileEntriesEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type TeachingLoadReportFileEntryFileEntriesNodeAggregateSelection = {
  __typename?: 'TeachingLoadReportFileEntryFileEntriesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  filename: StringAggregateSelection;
  mediaType: StringAggregateSelection;
  size: IntAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingLoadReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingLoadReportSort objects to sort TeachingLoadReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingLoadReportSort>>;
};

/** Fields to sort TeachingLoadReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingLoadReportSort object. */
export type TeachingLoadReportSort = {
  jobConfiguration?: InputMaybe<SortDirection>;
  jobCreated?: InputMaybe<SortDirection>;
  jobFinished?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export enum TeachingLoadReportType {
  CurrentClass = 'currentClass',
  CurrentExcel = 'currentExcel',
  CurrentExcelBerlin = 'currentExcelBerlin',
  CurrentKeyFigures = 'currentKeyFigures',
  CurrentLeliste = 'currentLeliste',
  CurrentOverview = 'currentOverview',
  CurrentSingleTeacher = 'currentSingleTeacher',
  CurrentSubjectGroup = 'currentSubjectGroup',
  Curriculum = 'curriculum',
  Metrics = 'metrics',
  PlanClass = 'planClass',
  PlanExcel = 'planExcel',
  PlanExcelBerlin = 'planExcelBerlin',
  PlanKeyFigures = 'planKeyFigures',
  PlanLeliste = 'planLeliste',
  PlanOverview = 'planOverview',
  PlanSingleTeacher = 'planSingleTeacher',
  PlanSubjectGroup = 'planSubjectGroup',
}

export type TeachingLoadReportUpdateInput = {
  context?: InputMaybe<TeachingLoadReportContextUpdateInput>;
  fileEntries?: InputMaybe<Array<TeachingLoadReportFileEntriesUpdateFieldInput>>;
  jobConfiguration?: InputMaybe<Scalars['String']['input']>;
  jobCreated?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TeachingLoadReportType>;
};

export type TeachingLoadReportWhere = {
  AND?: InputMaybe<Array<TeachingLoadReportWhere>>;
  NOT?: InputMaybe<TeachingLoadReportWhere>;
  OR?: InputMaybe<Array<TeachingLoadReportWhere>>;
  context?: InputMaybe<PdfReportContextWhere>;
  contextConnection?: InputMaybe<TeachingLoadReportContextConnectionWhere>;
  contextConnection_NOT?: InputMaybe<TeachingLoadReportContextConnectionWhere>;
  context_NOT?: InputMaybe<PdfReportContextWhere>;
  /** @deprecated Use `fileEntries_SOME` instead. */
  fileEntries?: InputMaybe<FileEntryWhere>;
  fileEntriesAggregate?: InputMaybe<TeachingLoadReportFileEntriesAggregateInput>;
  /** @deprecated Use `fileEntriesConnection_SOME` instead. */
  fileEntriesConnection?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
  /** Return TeachingLoadReports where all of the related TeachingLoadReportFileEntriesConnections match this filter */
  fileEntriesConnection_ALL?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
  /** Return TeachingLoadReports where none of the related TeachingLoadReportFileEntriesConnections match this filter */
  fileEntriesConnection_NONE?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
  /** @deprecated Use `fileEntriesConnection_NONE` instead. */
  fileEntriesConnection_NOT?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
  /** Return TeachingLoadReports where one of the related TeachingLoadReportFileEntriesConnections match this filter */
  fileEntriesConnection_SINGLE?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
  /** Return TeachingLoadReports where some of the related TeachingLoadReportFileEntriesConnections match this filter */
  fileEntriesConnection_SOME?: InputMaybe<TeachingLoadReportFileEntriesConnectionWhere>;
  /** Return TeachingLoadReports where all of the related FileEntries match this filter */
  fileEntries_ALL?: InputMaybe<FileEntryWhere>;
  /** Return TeachingLoadReports where none of the related FileEntries match this filter */
  fileEntries_NONE?: InputMaybe<FileEntryWhere>;
  /** @deprecated Use `fileEntries_NONE` instead. */
  fileEntries_NOT?: InputMaybe<FileEntryWhere>;
  /** Return TeachingLoadReports where one of the related FileEntries match this filter */
  fileEntries_SINGLE?: InputMaybe<FileEntryWhere>;
  /** Return TeachingLoadReports where some of the related FileEntries match this filter */
  fileEntries_SOME?: InputMaybe<FileEntryWhere>;
  jobConfiguration?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobCreated?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobCreated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobCreated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobCreated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobFinished?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_GT?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobFinished_LT?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobFinished_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobFinished_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TeachingLoadReportType>;
  type_IN?: InputMaybe<Array<TeachingLoadReportType>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT?: InputMaybe<TeachingLoadReportType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT_IN?: InputMaybe<Array<TeachingLoadReportType>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TeachingLoadReportsConnection = {
  __typename?: 'TeachingLoadReportsConnection';
  edges: Array<TeachingLoadReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeachingLoadScenario = {
  __typename?: 'TeachingLoadScenario';
  comment?: Maybe<Scalars['String']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type TeachingLoadScenarioAggregateSelection = {
  __typename?: 'TeachingLoadScenarioAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TeachingLoadScenarioCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TeachingLoadScenarioEdge = {
  __typename?: 'TeachingLoadScenarioEdge';
  cursor: Scalars['String']['output'];
  node: TeachingLoadScenario;
};

export type TeachingLoadScenarioOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TeachingLoadScenarioSort objects to sort TeachingLoadScenarios by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TeachingLoadScenarioSort>>;
};

/** Fields to sort TeachingLoadScenarios by. The order in which sorts are applied is not guaranteed when specifying many fields in one TeachingLoadScenarioSort object. */
export type TeachingLoadScenarioSort = {
  comment?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TeachingLoadScenarioUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TeachingLoadScenarioWhere = {
  AND?: InputMaybe<Array<TeachingLoadScenarioWhere>>;
  NOT?: InputMaybe<TeachingLoadScenarioWhere>;
  OR?: InputMaybe<Array<TeachingLoadScenarioWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TeachingLoadScenariosConnection = {
  __typename?: 'TeachingLoadScenariosConnection';
  edges: Array<TeachingLoadScenarioEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeGrid = {
  __typename?: 'TimeGrid';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  foreignId?: Maybe<Scalars['String']['output']>;
  items: Array<TimeGridEntry>;
  itemsAggregate?: Maybe<TimeGridTimeGridEntryItemsAggregationSelection>;
  itemsConnection: TimeGridItemsConnection;
  labels: Array<Label>;
  labelsConnection: TimeGridLabelsConnection;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: TimeGridOrganizationConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimeGridItemsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimeGridEntryOptions>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type TimeGridItemsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type TimeGridItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimeGridItemsConnectionSort>>;
  where?: InputMaybe<TimeGridItemsConnectionWhere>;
};

export type TimeGridLabelsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LabelOptions>;
  where?: InputMaybe<LabelWhere>;
};

export type TimeGridLabelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimeGridLabelsConnectionSort>>;
  where?: InputMaybe<TimeGridLabelsConnectionWhere>;
};

export type TimeGridOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TimeGridOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimeGridOrganizationConnectionSort>>;
  where?: InputMaybe<TimeGridOrganizationConnectionWhere>;
};

export type TimeGridAggregateSelection = {
  __typename?: 'TimeGridAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimeGridConnectInput = {
  items?: InputMaybe<Array<TimeGridItemsConnectFieldInput>>;
  labels?: InputMaybe<Array<TimeGridLabelsConnectFieldInput>>;
  organization?: InputMaybe<TimeGridOrganizationConnectFieldInput>;
};

export type TimeGridConnectOrCreateWhere = {
  node: TimeGridUniqueWhere;
};

export type TimeGridConnectWhere = {
  node: TimeGridWhere;
};

export type TimeGridCreateInput = {
  description: Scalars['String']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<TimeGridItemsFieldInput>;
  labels?: InputMaybe<TimeGridLabelsFieldInput>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<TimeGridOrganizationFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeGridDeleteInput = {
  items?: InputMaybe<Array<TimeGridItemsDeleteFieldInput>>;
  labels?: InputMaybe<Array<TimeGridLabelsDeleteFieldInput>>;
  organization?: InputMaybe<TimeGridOrganizationDeleteFieldInput>;
};

export type TimeGridDisconnectInput = {
  items?: InputMaybe<Array<TimeGridItemsDisconnectFieldInput>>;
  labels?: InputMaybe<Array<TimeGridLabelsDisconnectFieldInput>>;
  organization?: InputMaybe<TimeGridOrganizationDisconnectFieldInput>;
};

export type TimeGridEdge = {
  __typename?: 'TimeGridEdge';
  cursor: Scalars['String']['output'];
  node: TimeGrid;
};

export type TimeGridEntriesConnection = {
  __typename?: 'TimeGridEntriesConnection';
  edges: Array<TimeGridEntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeGridEntry = {
  __typename?: 'TimeGridEntry';
  end: Scalars['DateTime']['output'];
  foreignId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  pause: Scalars['Boolean']['output'];
  print: Scalars['Boolean']['output'];
  reliable: Scalars['Boolean']['output'];
  shortName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  timeGrid?: Maybe<TimeGrid>;
  timeGridConnection: TimeGridEntryTimeGridConnection;
  uuid: Scalars['ID']['output'];
};

export type TimeGridEntryTimeGridArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimeGridOptions>;
  where?: InputMaybe<TimeGridWhere>;
};

export type TimeGridEntryTimeGridConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimeGridEntryTimeGridConnectionSort>>;
  where?: InputMaybe<TimeGridEntryTimeGridConnectionWhere>;
};

export type TimeGridEntryAggregateSelection = {
  __typename?: 'TimeGridEntryAggregateSelection';
  count: Scalars['Int']['output'];
  end: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  shortName: StringAggregateSelection;
  start: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimeGridEntryConnectInput = {
  timeGrid?: InputMaybe<TimeGridEntryTimeGridConnectFieldInput>;
};

export type TimeGridEntryConnectOrCreateWhere = {
  node: TimeGridEntryUniqueWhere;
};

export type TimeGridEntryConnectWhere = {
  node: TimeGridEntryWhere;
};

export type TimeGridEntryCreateInput = {
  end: Scalars['DateTime']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  pause: Scalars['Boolean']['input'];
  print: Scalars['Boolean']['input'];
  reliable: Scalars['Boolean']['input'];
  shortName: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  timeGrid?: InputMaybe<TimeGridEntryTimeGridFieldInput>;
};

export type TimeGridEntryDeleteInput = {
  timeGrid?: InputMaybe<TimeGridEntryTimeGridDeleteFieldInput>;
};

export type TimeGridEntryDisconnectInput = {
  timeGrid?: InputMaybe<TimeGridEntryTimeGridDisconnectFieldInput>;
};

export type TimeGridEntryEdge = {
  __typename?: 'TimeGridEntryEdge';
  cursor: Scalars['String']['output'];
  node: TimeGridEntry;
};

export type TimeGridEntryOnCreateInput = {
  end: Scalars['DateTime']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  pause: Scalars['Boolean']['input'];
  print: Scalars['Boolean']['input'];
  reliable: Scalars['Boolean']['input'];
  shortName: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
};

export type TimeGridEntryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimeGridEntrySort objects to sort TimeGridEntries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimeGridEntrySort>>;
};

/** Fields to sort TimeGridEntries by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimeGridEntrySort object. */
export type TimeGridEntrySort = {
  end?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  pause?: InputMaybe<SortDirection>;
  print?: InputMaybe<SortDirection>;
  reliable?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TimeGridEntryTimeGridAggregateInput = {
  AND?: InputMaybe<Array<TimeGridEntryTimeGridAggregateInput>>;
  NOT?: InputMaybe<TimeGridEntryTimeGridAggregateInput>;
  OR?: InputMaybe<Array<TimeGridEntryTimeGridAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimeGridEntryTimeGridNodeAggregationWhereInput>;
};

export type TimeGridEntryTimeGridConnectFieldInput = {
  connect?: InputMaybe<TimeGridConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimeGridConnectWhere>;
};

export type TimeGridEntryTimeGridConnectOrCreateFieldInput = {
  onCreate: TimeGridEntryTimeGridConnectOrCreateFieldInputOnCreate;
  where: TimeGridConnectOrCreateWhere;
};

export type TimeGridEntryTimeGridConnectOrCreateFieldInputOnCreate = {
  node: TimeGridOnCreateInput;
};

export type TimeGridEntryTimeGridConnection = {
  __typename?: 'TimeGridEntryTimeGridConnection';
  edges: Array<TimeGridEntryTimeGridRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeGridEntryTimeGridConnectionSort = {
  node?: InputMaybe<TimeGridSort>;
};

export type TimeGridEntryTimeGridConnectionWhere = {
  AND?: InputMaybe<Array<TimeGridEntryTimeGridConnectionWhere>>;
  NOT?: InputMaybe<TimeGridEntryTimeGridConnectionWhere>;
  OR?: InputMaybe<Array<TimeGridEntryTimeGridConnectionWhere>>;
  node?: InputMaybe<TimeGridWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimeGridWhere>;
};

export type TimeGridEntryTimeGridCreateFieldInput = {
  node: TimeGridCreateInput;
};

export type TimeGridEntryTimeGridDeleteFieldInput = {
  delete?: InputMaybe<TimeGridDeleteInput>;
  where?: InputMaybe<TimeGridEntryTimeGridConnectionWhere>;
};

export type TimeGridEntryTimeGridDisconnectFieldInput = {
  disconnect?: InputMaybe<TimeGridDisconnectInput>;
  where?: InputMaybe<TimeGridEntryTimeGridConnectionWhere>;
};

export type TimeGridEntryTimeGridFieldInput = {
  connect?: InputMaybe<TimeGridEntryTimeGridConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimeGridEntryTimeGridConnectOrCreateFieldInput>;
  create?: InputMaybe<TimeGridEntryTimeGridCreateFieldInput>;
};

export type TimeGridEntryTimeGridNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimeGridEntryTimeGridNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimeGridEntryTimeGridNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimeGridEntryTimeGridNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeGridEntryTimeGridRelationship = {
  __typename?: 'TimeGridEntryTimeGridRelationship';
  cursor: Scalars['String']['output'];
  node: TimeGrid;
};

export type TimeGridEntryTimeGridUpdateConnectionInput = {
  node?: InputMaybe<TimeGridUpdateInput>;
};

export type TimeGridEntryTimeGridUpdateFieldInput = {
  connect?: InputMaybe<TimeGridEntryTimeGridConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimeGridEntryTimeGridConnectOrCreateFieldInput>;
  create?: InputMaybe<TimeGridEntryTimeGridCreateFieldInput>;
  delete?: InputMaybe<TimeGridEntryTimeGridDeleteFieldInput>;
  disconnect?: InputMaybe<TimeGridEntryTimeGridDisconnectFieldInput>;
  update?: InputMaybe<TimeGridEntryTimeGridUpdateConnectionInput>;
  where?: InputMaybe<TimeGridEntryTimeGridConnectionWhere>;
};

export type TimeGridEntryUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type TimeGridEntryUpdateInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  reliable?: InputMaybe<Scalars['Boolean']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  timeGrid?: InputMaybe<TimeGridEntryTimeGridUpdateFieldInput>;
};

export type TimeGridEntryWhere = {
  AND?: InputMaybe<Array<TimeGridEntryWhere>>;
  NOT?: InputMaybe<TimeGridEntryWhere>;
  OR?: InputMaybe<Array<TimeGridEntryWhere>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  end_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  end_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  order_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pause_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  print?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  print_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  reliable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  reliable_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  shortName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  start_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  start_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  timeGrid?: InputMaybe<TimeGridWhere>;
  timeGridAggregate?: InputMaybe<TimeGridEntryTimeGridAggregateInput>;
  timeGridConnection?: InputMaybe<TimeGridEntryTimeGridConnectionWhere>;
  timeGridConnection_NOT?: InputMaybe<TimeGridEntryTimeGridConnectionWhere>;
  timeGrid_NOT?: InputMaybe<TimeGridWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeGridItemsAggregateInput = {
  AND?: InputMaybe<Array<TimeGridItemsAggregateInput>>;
  NOT?: InputMaybe<TimeGridItemsAggregateInput>;
  OR?: InputMaybe<Array<TimeGridItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimeGridItemsNodeAggregationWhereInput>;
};

export type TimeGridItemsConnectFieldInput = {
  connect?: InputMaybe<Array<TimeGridEntryConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimeGridEntryConnectWhere>;
};

export type TimeGridItemsConnectOrCreateFieldInput = {
  onCreate: TimeGridItemsConnectOrCreateFieldInputOnCreate;
  where: TimeGridEntryConnectOrCreateWhere;
};

export type TimeGridItemsConnectOrCreateFieldInputOnCreate = {
  node: TimeGridEntryOnCreateInput;
};

export type TimeGridItemsConnection = {
  __typename?: 'TimeGridItemsConnection';
  edges: Array<TimeGridItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeGridItemsConnectionSort = {
  node?: InputMaybe<TimeGridEntrySort>;
};

export type TimeGridItemsConnectionWhere = {
  AND?: InputMaybe<Array<TimeGridItemsConnectionWhere>>;
  NOT?: InputMaybe<TimeGridItemsConnectionWhere>;
  OR?: InputMaybe<Array<TimeGridItemsConnectionWhere>>;
  node?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimeGridEntryWhere>;
};

export type TimeGridItemsCreateFieldInput = {
  node: TimeGridEntryCreateInput;
};

export type TimeGridItemsDeleteFieldInput = {
  delete?: InputMaybe<TimeGridEntryDeleteInput>;
  where?: InputMaybe<TimeGridItemsConnectionWhere>;
};

export type TimeGridItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimeGridEntryDisconnectInput>;
  where?: InputMaybe<TimeGridItemsConnectionWhere>;
};

export type TimeGridItemsFieldInput = {
  connect?: InputMaybe<Array<TimeGridItemsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimeGridItemsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimeGridItemsCreateFieldInput>>;
};

export type TimeGridItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimeGridItemsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimeGridItemsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimeGridItemsNodeAggregationWhereInput>>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeGridItemsRelationship = {
  __typename?: 'TimeGridItemsRelationship';
  cursor: Scalars['String']['output'];
  node: TimeGridEntry;
};

export type TimeGridItemsUpdateConnectionInput = {
  node?: InputMaybe<TimeGridEntryUpdateInput>;
};

export type TimeGridItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimeGridItemsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimeGridItemsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimeGridItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimeGridItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimeGridItemsDisconnectFieldInput>>;
  update?: InputMaybe<TimeGridItemsUpdateConnectionInput>;
  where?: InputMaybe<TimeGridItemsConnectionWhere>;
};

export type TimeGridLabelsAggregateInput = {
  AND?: InputMaybe<Array<TimeGridLabelsAggregateInput>>;
  NOT?: InputMaybe<TimeGridLabelsAggregateInput>;
  OR?: InputMaybe<Array<TimeGridLabelsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimeGridLabelsNodeAggregationWhereInput>;
};

export type TimeGridLabelsConnectFieldInput = {
  connect?: InputMaybe<Array<LabelConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LabelConnectWhere>;
};

export type TimeGridLabelsConnection = {
  __typename?: 'TimeGridLabelsConnection';
  edges: Array<TimeGridLabelsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeGridLabelsConnectionSort = {
  node?: InputMaybe<LabelSort>;
};

export type TimeGridLabelsConnectionWhere = {
  AND?: InputMaybe<Array<TimeGridLabelsConnectionWhere>>;
  NOT?: InputMaybe<TimeGridLabelsConnectionWhere>;
  OR?: InputMaybe<Array<TimeGridLabelsConnectionWhere>>;
  node?: InputMaybe<LabelWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LabelWhere>;
};

export type TimeGridLabelsCreateFieldInput = {
  node: LabelCreateInput;
};

export type TimeGridLabelsDeleteFieldInput = {
  delete?: InputMaybe<LabelDeleteInput>;
  where?: InputMaybe<TimeGridLabelsConnectionWhere>;
};

export type TimeGridLabelsDisconnectFieldInput = {
  disconnect?: InputMaybe<LabelDisconnectInput>;
  where?: InputMaybe<TimeGridLabelsConnectionWhere>;
};

export type TimeGridLabelsFieldInput = {
  connect?: InputMaybe<Array<TimeGridLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<TimeGridLabelsCreateFieldInput>>;
};

export type TimeGridLabelsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimeGridLabelsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimeGridLabelsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimeGridLabelsNodeAggregationWhereInput>>;
  color_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  color_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  color_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  color_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeGridLabelsRelationship = {
  __typename?: 'TimeGridLabelsRelationship';
  cursor: Scalars['String']['output'];
  node: Label;
};

export type TimeGridLabelsUpdateConnectionInput = {
  node?: InputMaybe<LabelUpdateInput>;
};

export type TimeGridLabelsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimeGridLabelsConnectFieldInput>>;
  create?: InputMaybe<Array<TimeGridLabelsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimeGridLabelsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimeGridLabelsDisconnectFieldInput>>;
  update?: InputMaybe<TimeGridLabelsUpdateConnectionInput>;
  where?: InputMaybe<TimeGridLabelsConnectionWhere>;
};

export type TimeGridOnCreateInput = {
  description: Scalars['String']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimeGridOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimeGridSort objects to sort TimeGrids by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimeGridSort>>;
};

export type TimeGridOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TimeGridOrganizationAggregateInput>>;
  NOT?: InputMaybe<TimeGridOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TimeGridOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimeGridOrganizationNodeAggregationWhereInput>;
};

export type TimeGridOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TimeGridOrganizationConnectOrCreateFieldInput = {
  onCreate: TimeGridOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TimeGridOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TimeGridOrganizationConnection = {
  __typename?: 'TimeGridOrganizationConnection';
  edges: Array<TimeGridOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeGridOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TimeGridOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TimeGridOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TimeGridOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TimeGridOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TimeGridOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TimeGridOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TimeGridOrganizationConnectionWhere>;
};

export type TimeGridOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TimeGridOrganizationConnectionWhere>;
};

export type TimeGridOrganizationFieldInput = {
  connect?: InputMaybe<TimeGridOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimeGridOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimeGridOrganizationCreateFieldInput>;
};

export type TimeGridOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimeGridOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimeGridOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimeGridOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeGridOrganizationRelationship = {
  __typename?: 'TimeGridOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TimeGridOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TimeGridOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TimeGridOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimeGridOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimeGridOrganizationCreateFieldInput>;
  delete?: InputMaybe<TimeGridOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TimeGridOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TimeGridOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TimeGridOrganizationConnectionWhere>;
};

/** Fields to sort TimeGrids by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimeGridSort object. */
export type TimeGridSort = {
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TimeGridTimeGridEntryItemsAggregationSelection = {
  __typename?: 'TimeGridTimeGridEntryItemsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TimeGridTimeGridEntryItemsNodeAggregateSelection>;
};

export type TimeGridTimeGridEntryItemsNodeAggregateSelection = {
  __typename?: 'TimeGridTimeGridEntryItemsNodeAggregateSelection';
  end: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  shortName: StringAggregateSelection;
  start: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimeGridUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type TimeGridUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<TimeGridItemsUpdateFieldInput>>;
  labels?: InputMaybe<Array<TimeGridLabelsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<TimeGridOrganizationUpdateFieldInput>;
};

export type TimeGridWhere = {
  AND?: InputMaybe<Array<TimeGridWhere>>;
  NOT?: InputMaybe<TimeGridWhere>;
  OR?: InputMaybe<Array<TimeGridWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `items_SOME` instead. */
  items?: InputMaybe<TimeGridEntryWhere>;
  itemsAggregate?: InputMaybe<TimeGridItemsAggregateInput>;
  /** @deprecated Use `itemsConnection_SOME` instead. */
  itemsConnection?: InputMaybe<TimeGridItemsConnectionWhere>;
  /** Return TimeGrids where all of the related TimeGridItemsConnections match this filter */
  itemsConnection_ALL?: InputMaybe<TimeGridItemsConnectionWhere>;
  /** Return TimeGrids where none of the related TimeGridItemsConnections match this filter */
  itemsConnection_NONE?: InputMaybe<TimeGridItemsConnectionWhere>;
  /** @deprecated Use `itemsConnection_NONE` instead. */
  itemsConnection_NOT?: InputMaybe<TimeGridItemsConnectionWhere>;
  /** Return TimeGrids where one of the related TimeGridItemsConnections match this filter */
  itemsConnection_SINGLE?: InputMaybe<TimeGridItemsConnectionWhere>;
  /** Return TimeGrids where some of the related TimeGridItemsConnections match this filter */
  itemsConnection_SOME?: InputMaybe<TimeGridItemsConnectionWhere>;
  /** Return TimeGrids where all of the related TimeGridEntries match this filter */
  items_ALL?: InputMaybe<TimeGridEntryWhere>;
  /** Return TimeGrids where none of the related TimeGridEntries match this filter */
  items_NONE?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Use `items_NONE` instead. */
  items_NOT?: InputMaybe<TimeGridEntryWhere>;
  /** Return TimeGrids where one of the related TimeGridEntries match this filter */
  items_SINGLE?: InputMaybe<TimeGridEntryWhere>;
  /** Return TimeGrids where some of the related TimeGridEntries match this filter */
  items_SOME?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Use `labels_SOME` instead. */
  labels?: InputMaybe<LabelWhere>;
  labelsAggregate?: InputMaybe<TimeGridLabelsAggregateInput>;
  /** @deprecated Use `labelsConnection_SOME` instead. */
  labelsConnection?: InputMaybe<TimeGridLabelsConnectionWhere>;
  /** Return TimeGrids where all of the related TimeGridLabelsConnections match this filter */
  labelsConnection_ALL?: InputMaybe<TimeGridLabelsConnectionWhere>;
  /** Return TimeGrids where none of the related TimeGridLabelsConnections match this filter */
  labelsConnection_NONE?: InputMaybe<TimeGridLabelsConnectionWhere>;
  /** @deprecated Use `labelsConnection_NONE` instead. */
  labelsConnection_NOT?: InputMaybe<TimeGridLabelsConnectionWhere>;
  /** Return TimeGrids where one of the related TimeGridLabelsConnections match this filter */
  labelsConnection_SINGLE?: InputMaybe<TimeGridLabelsConnectionWhere>;
  /** Return TimeGrids where some of the related TimeGridLabelsConnections match this filter */
  labelsConnection_SOME?: InputMaybe<TimeGridLabelsConnectionWhere>;
  /** Return TimeGrids where all of the related Labels match this filter */
  labels_ALL?: InputMaybe<LabelWhere>;
  /** Return TimeGrids where none of the related Labels match this filter */
  labels_NONE?: InputMaybe<LabelWhere>;
  /** @deprecated Use `labels_NONE` instead. */
  labels_NOT?: InputMaybe<LabelWhere>;
  /** Return TimeGrids where one of the related Labels match this filter */
  labels_SINGLE?: InputMaybe<LabelWhere>;
  /** Return TimeGrids where some of the related Labels match this filter */
  labels_SOME?: InputMaybe<LabelWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TimeGridOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TimeGridOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TimeGridOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TimeGridsConnection = {
  __typename?: 'TimeGridsConnection';
  edges: Array<TimeGridEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Timespan = {
  __typename?: 'Timespan';
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type TimespanAggregateSelection = {
  __typename?: 'TimespanAggregateSelection';
  count: Scalars['Int']['output'];
  description: StringAggregateSelection;
  end: DateTimeAggregateSelection;
  start: DateTimeAggregateSelection;
};

export type TimespanCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type TimespanEdge = {
  __typename?: 'TimespanEdge';
  cursor: Scalars['String']['output'];
  node: Timespan;
};

export type TimespanOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimespanSort objects to sort Timespans by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimespanSort>>;
};

/** Fields to sort Timespans by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimespanSort object. */
export type TimespanSort = {
  description?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
};

export type TimespanUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimespanWhere = {
  AND?: InputMaybe<Array<TimespanWhere>>;
  NOT?: InputMaybe<TimespanWhere>;
  OR?: InputMaybe<Array<TimespanWhere>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  end_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  end_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  start_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  start_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type TimespansConnection = {
  __typename?: 'TimespansConnection';
  edges: Array<TimespanEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Timetable = {
  __typename?: 'Timetable';
  activeVersion?: Maybe<TimetableVersion>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  draft: Scalars['Boolean']['output'];
  foreignId?: Maybe<Scalars['String']['output']>;
  friEnabled?: Maybe<Scalars['Boolean']['output']>;
  monEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: TimetableOrganizationConnection;
  satEnabled?: Maybe<Scalars['Boolean']['output']>;
  schoolYear: SchoolYear;
  schoolYearConnection: TimetableSchoolYearConnection;
  sunEnabled?: Maybe<Scalars['Boolean']['output']>;
  thuEnabled?: Maybe<Scalars['Boolean']['output']>;
  timegridConfigs: Array<TimetableTimeGridConfig>;
  timegridConfigsConnection: TimetableTimegridConfigsConnection;
  timetableBlocks: Array<TimetableBlock>;
  timetableBlocksAggregate?: Maybe<TimetableTimetableBlockTimetableBlocksAggregationSelection>;
  timetableBlocksConnection: TimetableTimetableBlocksConnection;
  tueEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uuid: Scalars['ID']['output'];
  versions: Array<TimetableVersion>;
  versionsAggregate?: Maybe<TimetableTimetableVersionVersionsAggregationSelection>;
  versionsConnection: TimetableVersionsConnection;
  wedEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type TimetableOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TimetableOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableOrganizationConnectionSort>>;
  where?: InputMaybe<TimetableOrganizationConnectionWhere>;
};

export type TimetableSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type TimetableSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableSchoolYearConnectionSort>>;
  where?: InputMaybe<TimetableSchoolYearConnectionWhere>;
};

export type TimetableTimegridConfigsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableTimeGridConfigOptions>;
  where?: InputMaybe<TimetableTimeGridConfigWhere>;
};

export type TimetableTimegridConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableTimegridConfigsConnectionSort>>;
  where?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
};

export type TimetableTimetableBlocksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableBlockOptions>;
  where?: InputMaybe<TimetableBlockWhere>;
};

export type TimetableTimetableBlocksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TimetableBlockWhere>;
};

export type TimetableTimetableBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableTimetableBlocksConnectionSort>>;
  where?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
};

export type TimetableVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionsConnectionSort>>;
  where?: InputMaybe<TimetableVersionsConnectionWhere>;
};

export type TimetableAggregateSelection = {
  __typename?: 'TimetableAggregateSelection';
  comment: StringAggregateSelection;
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableBlock = {
  __typename?: 'TimetableBlock';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  end: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  organizationConnection: TimetableBlockOrganizationConnection;
  schoolYear: SchoolYear;
  schoolYearConnection: TimetableBlockSchoolYearConnection;
  start: Scalars['Date']['output'];
  teachingLoadCalculated?: Maybe<Scalars['Float']['output']>;
  teachingLoadComment?: Maybe<Scalars['String']['output']>;
  teachingLoadFactor?: Maybe<Scalars['Float']['output']>;
  timetables: Array<Timetable>;
  timetablesAggregate?: Maybe<TimetableBlockTimetableTimetablesAggregationSelection>;
  timetablesConnection: TimetableBlockTimetablesConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableBlockOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TimetableBlockOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableBlockOrganizationConnectionSort>>;
  where?: InputMaybe<TimetableBlockOrganizationConnectionWhere>;
};

export type TimetableBlockSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type TimetableBlockSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableBlockSchoolYearConnectionSort>>;
  where?: InputMaybe<TimetableBlockSchoolYearConnectionWhere>;
};

export type TimetableBlockTimetablesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableOptions>;
  where?: InputMaybe<TimetableWhere>;
};

export type TimetableBlockTimetablesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TimetableWhere>;
};

export type TimetableBlockTimetablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableBlockTimetablesConnectionSort>>;
  where?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
};

export type TimetableBlockAggregateSelection = {
  __typename?: 'TimetableBlockAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  teachingLoadCalculated: FloatAggregateSelection;
  teachingLoadComment: StringAggregateSelection;
  teachingLoadFactor: FloatAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableBlockConnectInput = {
  organization?: InputMaybe<TimetableBlockOrganizationConnectFieldInput>;
  schoolYear?: InputMaybe<TimetableBlockSchoolYearConnectFieldInput>;
  timetables?: InputMaybe<Array<TimetableBlockTimetablesConnectFieldInput>>;
};

export type TimetableBlockConnectWhere = {
  node: TimetableBlockWhere;
};

export type TimetableBlockCreateInput = {
  end: Scalars['Date']['input'];
  organization?: InputMaybe<TimetableBlockOrganizationFieldInput>;
  schoolYear?: InputMaybe<TimetableBlockSchoolYearFieldInput>;
  start: Scalars['Date']['input'];
  teachingLoadCalculated?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment?: InputMaybe<Scalars['String']['input']>;
  teachingLoadFactor?: InputMaybe<Scalars['Float']['input']>;
  timetables?: InputMaybe<TimetableBlockTimetablesFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableBlockDeleteInput = {
  organization?: InputMaybe<TimetableBlockOrganizationDeleteFieldInput>;
  schoolYear?: InputMaybe<TimetableBlockSchoolYearDeleteFieldInput>;
  timetables?: InputMaybe<Array<TimetableBlockTimetablesDeleteFieldInput>>;
};

export type TimetableBlockDisconnectInput = {
  organization?: InputMaybe<TimetableBlockOrganizationDisconnectFieldInput>;
  schoolYear?: InputMaybe<TimetableBlockSchoolYearDisconnectFieldInput>;
  timetables?: InputMaybe<Array<TimetableBlockTimetablesDisconnectFieldInput>>;
};

export type TimetableBlockEdge = {
  __typename?: 'TimetableBlockEdge';
  cursor: Scalars['String']['output'];
  node: TimetableBlock;
};

export type TimetableBlockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimetableBlockSort objects to sort TimetableBlocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimetableBlockSort>>;
};

export type TimetableBlockOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TimetableBlockOrganizationAggregateInput>>;
  NOT?: InputMaybe<TimetableBlockOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TimetableBlockOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableBlockOrganizationNodeAggregationWhereInput>;
};

export type TimetableBlockOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TimetableBlockOrganizationConnectOrCreateFieldInput = {
  onCreate: TimetableBlockOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TimetableBlockOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TimetableBlockOrganizationConnection = {
  __typename?: 'TimetableBlockOrganizationConnection';
  edges: Array<TimetableBlockOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableBlockOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TimetableBlockOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TimetableBlockOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TimetableBlockOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TimetableBlockOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TimetableBlockOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TimetableBlockOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TimetableBlockOrganizationConnectionWhere>;
};

export type TimetableBlockOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TimetableBlockOrganizationConnectionWhere>;
};

export type TimetableBlockOrganizationFieldInput = {
  connect?: InputMaybe<TimetableBlockOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableBlockOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableBlockOrganizationCreateFieldInput>;
};

export type TimetableBlockOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableBlockOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableBlockOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableBlockOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableBlockOrganizationRelationship = {
  __typename?: 'TimetableBlockOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TimetableBlockOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TimetableBlockOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TimetableBlockOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableBlockOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableBlockOrganizationCreateFieldInput>;
  delete?: InputMaybe<TimetableBlockOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableBlockOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TimetableBlockOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TimetableBlockOrganizationConnectionWhere>;
};

export type TimetableBlockSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<TimetableBlockSchoolYearAggregateInput>>;
  NOT?: InputMaybe<TimetableBlockSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<TimetableBlockSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableBlockSchoolYearNodeAggregationWhereInput>;
};

export type TimetableBlockSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type TimetableBlockSchoolYearConnection = {
  __typename?: 'TimetableBlockSchoolYearConnection';
  edges: Array<TimetableBlockSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableBlockSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type TimetableBlockSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<TimetableBlockSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<TimetableBlockSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<TimetableBlockSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type TimetableBlockSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type TimetableBlockSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<TimetableBlockSchoolYearConnectionWhere>;
};

export type TimetableBlockSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<TimetableBlockSchoolYearConnectionWhere>;
};

export type TimetableBlockSchoolYearFieldInput = {
  connect?: InputMaybe<TimetableBlockSchoolYearConnectFieldInput>;
  create?: InputMaybe<TimetableBlockSchoolYearCreateFieldInput>;
};

export type TimetableBlockSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableBlockSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableBlockSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableBlockSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableBlockSchoolYearRelationship = {
  __typename?: 'TimetableBlockSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type TimetableBlockSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type TimetableBlockSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<TimetableBlockSchoolYearConnectFieldInput>;
  create?: InputMaybe<TimetableBlockSchoolYearCreateFieldInput>;
  delete?: InputMaybe<TimetableBlockSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableBlockSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<TimetableBlockSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<TimetableBlockSchoolYearConnectionWhere>;
};

/** Fields to sort TimetableBlocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimetableBlockSort object. */
export type TimetableBlockSort = {
  createdAt?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
  teachingLoadCalculated?: InputMaybe<SortDirection>;
  teachingLoadComment?: InputMaybe<SortDirection>;
  teachingLoadFactor?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TimetableBlockTimetableTimetablesAggregationSelection = {
  __typename?: 'TimetableBlockTimetableTimetablesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TimetableBlockTimetableTimetablesNodeAggregateSelection>;
};

export type TimetableBlockTimetableTimetablesNodeAggregateSelection = {
  __typename?: 'TimetableBlockTimetableTimetablesNodeAggregateSelection';
  comment: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableBlockTimetablesAggregateInput = {
  AND?: InputMaybe<Array<TimetableBlockTimetablesAggregateInput>>;
  NOT?: InputMaybe<TimetableBlockTimetablesAggregateInput>;
  OR?: InputMaybe<Array<TimetableBlockTimetablesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableBlockTimetablesNodeAggregationWhereInput>;
};

export type TimetableBlockTimetablesConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConnectWhere>;
};

export type TimetableBlockTimetablesConnectOrCreateFieldInput = {
  onCreate: TimetableBlockTimetablesConnectOrCreateFieldInputOnCreate;
  where: TimetableConnectOrCreateWhere;
};

export type TimetableBlockTimetablesConnectOrCreateFieldInputOnCreate = {
  node: TimetableOnCreateInput;
};

export type TimetableBlockTimetablesConnection = {
  __typename?: 'TimetableBlockTimetablesConnection';
  edges: Array<TimetableBlockTimetablesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableBlockTimetablesConnectionSort = {
  node?: InputMaybe<TimetableSort>;
};

export type TimetableBlockTimetablesConnectionWhere = {
  AND?: InputMaybe<Array<TimetableBlockTimetablesConnectionWhere>>;
  NOT?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
  OR?: InputMaybe<Array<TimetableBlockTimetablesConnectionWhere>>;
  node?: InputMaybe<TimetableWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableWhere>;
};

export type TimetableBlockTimetablesCreateFieldInput = {
  node: TimetableCreateInput;
};

export type TimetableBlockTimetablesDeleteFieldInput = {
  delete?: InputMaybe<TimetableDeleteInput>;
  where?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
};

export type TimetableBlockTimetablesDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableDisconnectInput>;
  where?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
};

export type TimetableBlockTimetablesFieldInput = {
  connect?: InputMaybe<Array<TimetableBlockTimetablesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableBlockTimetablesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableBlockTimetablesCreateFieldInput>>;
};

export type TimetableBlockTimetablesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableBlockTimetablesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableBlockTimetablesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableBlockTimetablesNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableBlockTimetablesRelationship = {
  __typename?: 'TimetableBlockTimetablesRelationship';
  cursor: Scalars['String']['output'];
  node: Timetable;
};

export type TimetableBlockTimetablesUpdateConnectionInput = {
  node?: InputMaybe<TimetableUpdateInput>;
};

export type TimetableBlockTimetablesUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableBlockTimetablesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableBlockTimetablesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableBlockTimetablesCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableBlockTimetablesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableBlockTimetablesDisconnectFieldInput>>;
  update?: InputMaybe<TimetableBlockTimetablesUpdateConnectionInput>;
  where?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
};

export type TimetableBlockUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  organization?: InputMaybe<TimetableBlockOrganizationUpdateFieldInput>;
  schoolYear?: InputMaybe<TimetableBlockSchoolYearUpdateFieldInput>;
  start?: InputMaybe<Scalars['Date']['input']>;
  teachingLoadCalculated?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_ADD?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment?: InputMaybe<Scalars['String']['input']>;
  teachingLoadFactor?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_ADD?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  timetables?: InputMaybe<Array<TimetableBlockTimetablesUpdateFieldInput>>;
};

export type TimetableBlockWhere = {
  AND?: InputMaybe<Array<TimetableBlockWhere>>;
  NOT?: InputMaybe<TimetableBlockWhere>;
  OR?: InputMaybe<Array<TimetableBlockWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  end_GT?: InputMaybe<Scalars['Date']['input']>;
  end_GTE?: InputMaybe<Scalars['Date']['input']>;
  end_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  end_LT?: InputMaybe<Scalars['Date']['input']>;
  end_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  end_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TimetableBlockOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TimetableBlockOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TimetableBlockOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<TimetableBlockSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<TimetableBlockSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<TimetableBlockSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  start?: InputMaybe<Scalars['Date']['input']>;
  start_GT?: InputMaybe<Scalars['Date']['input']>;
  start_GTE?: InputMaybe<Scalars['Date']['input']>;
  start_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  start_LT?: InputMaybe<Scalars['Date']['input']>;
  start_LTE?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  start_NOT_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  teachingLoadCalculated?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  teachingLoadCalculated_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadCalculated_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadCalculated_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  teachingLoadComment?: InputMaybe<Scalars['String']['input']>;
  teachingLoadComment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  teachingLoadComment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachingLoadComment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadComment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadComment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadComment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadComment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadComment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachingLoadComment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachingLoadFactor?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  teachingLoadFactor_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_LTE?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadFactor_NOT?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachingLoadFactor_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** @deprecated Use `timetables_SOME` instead. */
  timetables?: InputMaybe<TimetableWhere>;
  timetablesAggregate?: InputMaybe<TimetableBlockTimetablesAggregateInput>;
  /** @deprecated Use `timetablesConnection_SOME` instead. */
  timetablesConnection?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
  /** Return TimetableBlocks where all of the related TimetableBlockTimetablesConnections match this filter */
  timetablesConnection_ALL?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
  /** Return TimetableBlocks where none of the related TimetableBlockTimetablesConnections match this filter */
  timetablesConnection_NONE?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
  /** @deprecated Use `timetablesConnection_NONE` instead. */
  timetablesConnection_NOT?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
  /** Return TimetableBlocks where one of the related TimetableBlockTimetablesConnections match this filter */
  timetablesConnection_SINGLE?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
  /** Return TimetableBlocks where some of the related TimetableBlockTimetablesConnections match this filter */
  timetablesConnection_SOME?: InputMaybe<TimetableBlockTimetablesConnectionWhere>;
  /** Return TimetableBlocks where all of the related Timetables match this filter */
  timetables_ALL?: InputMaybe<TimetableWhere>;
  /** Return TimetableBlocks where none of the related Timetables match this filter */
  timetables_NONE?: InputMaybe<TimetableWhere>;
  /** @deprecated Use `timetables_NONE` instead. */
  timetables_NOT?: InputMaybe<TimetableWhere>;
  /** Return TimetableBlocks where one of the related Timetables match this filter */
  timetables_SINGLE?: InputMaybe<TimetableWhere>;
  /** Return TimetableBlocks where some of the related Timetables match this filter */
  timetables_SOME?: InputMaybe<TimetableWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TimetableBlocksConnection = {
  __typename?: 'TimetableBlocksConnection';
  edges: Array<TimetableBlockEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCard = {
  __typename?: 'TimetableCard';
  duration?: Maybe<Scalars['Int']['output']>;
  endTimeGridEntry?: Maybe<TimeGridEntry>;
  endTimeGridEntryConnection: TimetableCardEndTimeGridEntryConnection;
  events: Array<Event>;
  eventsConnection: TimetableCardEventsConnection;
  foreignId?: Maybe<Scalars['String']['output']>;
  lesson: Lesson;
  lessonClasses: Array<LessonClass>;
  lessonConnection: TimetableCardLessonConnection;
  locked: Scalars['Boolean']['output'];
  realEnd?: Maybe<Scalars['DateTime']['output']>;
  realStart?: Maybe<Scalars['DateTime']['output']>;
  rooms: Array<Room>;
  roomsConnection: TimetableCardRoomsConnection;
  startTimeGridEntry?: Maybe<TimeGridEntry>;
  startTimeGridEntryConnection: TimetableCardStartTimeGridEntryConnection;
  subject: SubjectContainerOrSubject;
  subjectContainer?: Maybe<SubjectContainer>;
  subjectContainerConnection: TimetableCardSubjectContainerConnection;
  teachers: Array<Person>;
  timetableVersion: TimetableVersion;
  timetableVersionConnection: TimetableCardTimetableVersionConnection;
  uuid: Scalars['ID']['output'];
  weekday?: Maybe<Scalars['String']['output']>;
};

export type TimetableCardEndTimeGridEntryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimeGridEntryOptions>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type TimetableCardEndTimeGridEntryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableCardEndTimeGridEntryConnectionSort>>;
  where?: InputMaybe<TimetableCardEndTimeGridEntryConnectionWhere>;
};

export type TimetableCardEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EventOptions>;
  where?: InputMaybe<EventWhere>;
};

export type TimetableCardEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableCardEventsConnectionSort>>;
  where?: InputMaybe<TimetableCardEventsConnectionWhere>;
};

export type TimetableCardLessonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type TimetableCardLessonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableCardLessonConnectionSort>>;
  where?: InputMaybe<TimetableCardLessonConnectionWhere>;
};

export type TimetableCardRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type TimetableCardRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableCardRoomsConnectionSort>>;
  where?: InputMaybe<TimetableCardRoomsConnectionWhere>;
};

export type TimetableCardStartTimeGridEntryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimeGridEntryOptions>;
  where?: InputMaybe<TimeGridEntryWhere>;
};

export type TimetableCardStartTimeGridEntryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableCardStartTimeGridEntryConnectionSort>>;
  where?: InputMaybe<TimetableCardStartTimeGridEntryConnectionWhere>;
};

export type TimetableCardSubjectContainerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectContainerOptions>;
  where?: InputMaybe<SubjectContainerWhere>;
};

export type TimetableCardSubjectContainerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableCardSubjectContainerConnectionSort>>;
  where?: InputMaybe<TimetableCardSubjectContainerConnectionWhere>;
};

export type TimetableCardTimetableVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableCardTimetableVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableCardTimetableVersionConnectionSort>>;
  where?: InputMaybe<TimetableCardTimetableVersionConnectionWhere>;
};

export type TimetableCardAggregateSelection = {
  __typename?: 'TimetableCardAggregateSelection';
  count: Scalars['Int']['output'];
  duration: IntAggregateSelection;
  foreignId: StringAggregateSelection;
  uuid: IdAggregateSelection;
  weekday: StringAggregateSelection;
};

export type TimetableCardAvailability = {
  __typename?: 'TimetableCardAvailability';
  fri?: Maybe<Scalars['String']['output']>;
  mon?: Maybe<Scalars['String']['output']>;
  sat?: Maybe<Scalars['String']['output']>;
  sun?: Maybe<Scalars['String']['output']>;
  thu?: Maybe<Scalars['String']['output']>;
  timetableCardUuid: Scalars['ID']['output'];
  tue?: Maybe<Scalars['String']['output']>;
  wed?: Maybe<Scalars['String']['output']>;
};

export type TimetableCardConnectInput = {
  endTimeGridEntry?: InputMaybe<TimetableCardEndTimeGridEntryConnectFieldInput>;
  lesson?: InputMaybe<TimetableCardLessonConnectFieldInput>;
  rooms?: InputMaybe<Array<TimetableCardRoomsConnectFieldInput>>;
  startTimeGridEntry?: InputMaybe<TimetableCardStartTimeGridEntryConnectFieldInput>;
  subjectContainer?: InputMaybe<TimetableCardSubjectContainerConnectFieldInput>;
  timetableVersion?: InputMaybe<TimetableCardTimetableVersionConnectFieldInput>;
};

export type TimetableCardConnectOrCreateWhere = {
  node: TimetableCardUniqueWhere;
};

export type TimetableCardConnectWhere = {
  node: TimetableCardWhere;
};

export type TimetableCardCreateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  endTimeGridEntry?: InputMaybe<TimetableCardEndTimeGridEntryFieldInput>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  lesson?: InputMaybe<TimetableCardLessonFieldInput>;
  locked: Scalars['Boolean']['input'];
  rooms?: InputMaybe<TimetableCardRoomsFieldInput>;
  startTimeGridEntry?: InputMaybe<TimetableCardStartTimeGridEntryFieldInput>;
  subjectContainer?: InputMaybe<TimetableCardSubjectContainerFieldInput>;
  timetableVersion?: InputMaybe<TimetableCardTimetableVersionFieldInput>;
  weekday?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableCardDeleteInput = {
  endTimeGridEntry?: InputMaybe<TimetableCardEndTimeGridEntryDeleteFieldInput>;
  lesson?: InputMaybe<TimetableCardLessonDeleteFieldInput>;
  rooms?: InputMaybe<Array<TimetableCardRoomsDeleteFieldInput>>;
  startTimeGridEntry?: InputMaybe<TimetableCardStartTimeGridEntryDeleteFieldInput>;
  subjectContainer?: InputMaybe<TimetableCardSubjectContainerDeleteFieldInput>;
  timetableVersion?: InputMaybe<TimetableCardTimetableVersionDeleteFieldInput>;
};

export type TimetableCardDisconnectInput = {
  endTimeGridEntry?: InputMaybe<TimetableCardEndTimeGridEntryDisconnectFieldInput>;
  lesson?: InputMaybe<TimetableCardLessonDisconnectFieldInput>;
  rooms?: InputMaybe<Array<TimetableCardRoomsDisconnectFieldInput>>;
  startTimeGridEntry?: InputMaybe<TimetableCardStartTimeGridEntryDisconnectFieldInput>;
  subjectContainer?: InputMaybe<TimetableCardSubjectContainerDisconnectFieldInput>;
  timetableVersion?: InputMaybe<TimetableCardTimetableVersionDisconnectFieldInput>;
};

export type TimetableCardEdge = {
  __typename?: 'TimetableCardEdge';
  cursor: Scalars['String']['output'];
  node: TimetableCard;
};

export type TimetableCardEndTimeGridEntryAggregateInput = {
  AND?: InputMaybe<Array<TimetableCardEndTimeGridEntryAggregateInput>>;
  NOT?: InputMaybe<TimetableCardEndTimeGridEntryAggregateInput>;
  OR?: InputMaybe<Array<TimetableCardEndTimeGridEntryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableCardEndTimeGridEntryNodeAggregationWhereInput>;
};

export type TimetableCardEndTimeGridEntryConnectFieldInput = {
  connect?: InputMaybe<TimeGridEntryConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimeGridEntryConnectWhere>;
};

export type TimetableCardEndTimeGridEntryConnectOrCreateFieldInput = {
  onCreate: TimetableCardEndTimeGridEntryConnectOrCreateFieldInputOnCreate;
  where: TimeGridEntryConnectOrCreateWhere;
};

export type TimetableCardEndTimeGridEntryConnectOrCreateFieldInputOnCreate = {
  node: TimeGridEntryOnCreateInput;
};

export type TimetableCardEndTimeGridEntryConnection = {
  __typename?: 'TimetableCardEndTimeGridEntryConnection';
  edges: Array<TimetableCardEndTimeGridEntryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCardEndTimeGridEntryConnectionSort = {
  node?: InputMaybe<TimeGridEntrySort>;
};

export type TimetableCardEndTimeGridEntryConnectionWhere = {
  AND?: InputMaybe<Array<TimetableCardEndTimeGridEntryConnectionWhere>>;
  NOT?: InputMaybe<TimetableCardEndTimeGridEntryConnectionWhere>;
  OR?: InputMaybe<Array<TimetableCardEndTimeGridEntryConnectionWhere>>;
  node?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimeGridEntryWhere>;
};

export type TimetableCardEndTimeGridEntryCreateFieldInput = {
  node: TimeGridEntryCreateInput;
};

export type TimetableCardEndTimeGridEntryDeleteFieldInput = {
  delete?: InputMaybe<TimeGridEntryDeleteInput>;
  where?: InputMaybe<TimetableCardEndTimeGridEntryConnectionWhere>;
};

export type TimetableCardEndTimeGridEntryDisconnectFieldInput = {
  disconnect?: InputMaybe<TimeGridEntryDisconnectInput>;
  where?: InputMaybe<TimetableCardEndTimeGridEntryConnectionWhere>;
};

export type TimetableCardEndTimeGridEntryFieldInput = {
  connect?: InputMaybe<TimetableCardEndTimeGridEntryConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardEndTimeGridEntryConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardEndTimeGridEntryCreateFieldInput>;
};

export type TimetableCardEndTimeGridEntryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableCardEndTimeGridEntryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableCardEndTimeGridEntryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableCardEndTimeGridEntryNodeAggregationWhereInput>>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableCardEndTimeGridEntryRelationship = {
  __typename?: 'TimetableCardEndTimeGridEntryRelationship';
  cursor: Scalars['String']['output'];
  node: TimeGridEntry;
};

export type TimetableCardEndTimeGridEntryUpdateConnectionInput = {
  node?: InputMaybe<TimeGridEntryUpdateInput>;
};

export type TimetableCardEndTimeGridEntryUpdateFieldInput = {
  connect?: InputMaybe<TimetableCardEndTimeGridEntryConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardEndTimeGridEntryConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardEndTimeGridEntryCreateFieldInput>;
  delete?: InputMaybe<TimetableCardEndTimeGridEntryDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableCardEndTimeGridEntryDisconnectFieldInput>;
  update?: InputMaybe<TimetableCardEndTimeGridEntryUpdateConnectionInput>;
  where?: InputMaybe<TimetableCardEndTimeGridEntryConnectionWhere>;
};

export type TimetableCardEventsAggregateInput = {
  AND?: InputMaybe<Array<TimetableCardEventsAggregateInput>>;
  NOT?: InputMaybe<TimetableCardEventsAggregateInput>;
  OR?: InputMaybe<Array<TimetableCardEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableCardEventsNodeAggregationWhereInput>;
};

export type TimetableCardEventsConnection = {
  __typename?: 'TimetableCardEventsConnection';
  edges: Array<TimetableCardEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCardEventsConnectionSort = {
  node?: InputMaybe<EventSort>;
};

export type TimetableCardEventsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableCardEventsConnectionWhere>>;
  NOT?: InputMaybe<TimetableCardEventsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableCardEventsConnectionWhere>>;
  node?: InputMaybe<EventWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<EventWhere>;
};

export type TimetableCardEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableCardEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableCardEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableCardEventsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentState_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentState_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentState_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentState_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  originalStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  substitutionComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableCardEventsRelationship = {
  __typename?: 'TimetableCardEventsRelationship';
  cursor: Scalars['String']['output'];
  node: Event;
};

export type TimetableCardLessonAggregateInput = {
  AND?: InputMaybe<Array<TimetableCardLessonAggregateInput>>;
  NOT?: InputMaybe<TimetableCardLessonAggregateInput>;
  OR?: InputMaybe<Array<TimetableCardLessonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableCardLessonNodeAggregationWhereInput>;
};

export type TimetableCardLessonConnectFieldInput = {
  connect?: InputMaybe<LessonConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type TimetableCardLessonConnectOrCreateFieldInput = {
  onCreate: TimetableCardLessonConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type TimetableCardLessonConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type TimetableCardLessonConnection = {
  __typename?: 'TimetableCardLessonConnection';
  edges: Array<TimetableCardLessonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCardLessonConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type TimetableCardLessonConnectionWhere = {
  AND?: InputMaybe<Array<TimetableCardLessonConnectionWhere>>;
  NOT?: InputMaybe<TimetableCardLessonConnectionWhere>;
  OR?: InputMaybe<Array<TimetableCardLessonConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type TimetableCardLessonCreateFieldInput = {
  node: LessonCreateInput;
};

export type TimetableCardLessonDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<TimetableCardLessonConnectionWhere>;
};

export type TimetableCardLessonDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<TimetableCardLessonConnectionWhere>;
};

export type TimetableCardLessonFieldInput = {
  connect?: InputMaybe<TimetableCardLessonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardLessonConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardLessonCreateFieldInput>;
};

export type TimetableCardLessonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableCardLessonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableCardLessonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableCardLessonNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableCardLessonRelationship = {
  __typename?: 'TimetableCardLessonRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type TimetableCardLessonUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type TimetableCardLessonUpdateFieldInput = {
  connect?: InputMaybe<TimetableCardLessonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardLessonConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardLessonCreateFieldInput>;
  delete?: InputMaybe<TimetableCardLessonDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableCardLessonDisconnectFieldInput>;
  update?: InputMaybe<TimetableCardLessonUpdateConnectionInput>;
  where?: InputMaybe<TimetableCardLessonConnectionWhere>;
};

export type TimetableCardOnCreateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  locked: Scalars['Boolean']['input'];
  weekday?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableCardOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimetableCardSort objects to sort TimetableCards by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimetableCardSort>>;
};

export type TimetableCardRoomsAggregateInput = {
  AND?: InputMaybe<Array<TimetableCardRoomsAggregateInput>>;
  NOT?: InputMaybe<TimetableCardRoomsAggregateInput>;
  OR?: InputMaybe<Array<TimetableCardRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableCardRoomsNodeAggregationWhereInput>;
};

export type TimetableCardRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type TimetableCardRoomsConnectOrCreateFieldInput = {
  onCreate: TimetableCardRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type TimetableCardRoomsConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type TimetableCardRoomsConnection = {
  __typename?: 'TimetableCardRoomsConnection';
  edges: Array<TimetableCardRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCardRoomsConnectionSort = {
  node?: InputMaybe<RoomSort>;
};

export type TimetableCardRoomsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableCardRoomsConnectionWhere>>;
  NOT?: InputMaybe<TimetableCardRoomsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableCardRoomsConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type TimetableCardRoomsCreateFieldInput = {
  node: RoomCreateInput;
};

export type TimetableCardRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<TimetableCardRoomsConnectionWhere>;
};

export type TimetableCardRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<TimetableCardRoomsConnectionWhere>;
};

export type TimetableCardRoomsFieldInput = {
  connect?: InputMaybe<Array<TimetableCardRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableCardRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableCardRoomsCreateFieldInput>>;
};

export type TimetableCardRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableCardRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableCardRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableCardRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableCardRoomsRelationship = {
  __typename?: 'TimetableCardRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
};

export type TimetableCardRoomsUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type TimetableCardRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableCardRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableCardRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableCardRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableCardRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableCardRoomsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableCardRoomsUpdateConnectionInput>;
  where?: InputMaybe<TimetableCardRoomsConnectionWhere>;
};

/** Fields to sort TimetableCards by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimetableCardSort object. */
export type TimetableCardSort = {
  duration?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  locked?: InputMaybe<SortDirection>;
  realEnd?: InputMaybe<SortDirection>;
  realStart?: InputMaybe<SortDirection>;
  subject?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  weekday?: InputMaybe<SortDirection>;
};

export type TimetableCardStartTimeGridEntryAggregateInput = {
  AND?: InputMaybe<Array<TimetableCardStartTimeGridEntryAggregateInput>>;
  NOT?: InputMaybe<TimetableCardStartTimeGridEntryAggregateInput>;
  OR?: InputMaybe<Array<TimetableCardStartTimeGridEntryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableCardStartTimeGridEntryNodeAggregationWhereInput>;
};

export type TimetableCardStartTimeGridEntryConnectFieldInput = {
  connect?: InputMaybe<TimeGridEntryConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimeGridEntryConnectWhere>;
};

export type TimetableCardStartTimeGridEntryConnectOrCreateFieldInput = {
  onCreate: TimetableCardStartTimeGridEntryConnectOrCreateFieldInputOnCreate;
  where: TimeGridEntryConnectOrCreateWhere;
};

export type TimetableCardStartTimeGridEntryConnectOrCreateFieldInputOnCreate = {
  node: TimeGridEntryOnCreateInput;
};

export type TimetableCardStartTimeGridEntryConnection = {
  __typename?: 'TimetableCardStartTimeGridEntryConnection';
  edges: Array<TimetableCardStartTimeGridEntryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCardStartTimeGridEntryConnectionSort = {
  node?: InputMaybe<TimeGridEntrySort>;
};

export type TimetableCardStartTimeGridEntryConnectionWhere = {
  AND?: InputMaybe<Array<TimetableCardStartTimeGridEntryConnectionWhere>>;
  NOT?: InputMaybe<TimetableCardStartTimeGridEntryConnectionWhere>;
  OR?: InputMaybe<Array<TimetableCardStartTimeGridEntryConnectionWhere>>;
  node?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimeGridEntryWhere>;
};

export type TimetableCardStartTimeGridEntryCreateFieldInput = {
  node: TimeGridEntryCreateInput;
};

export type TimetableCardStartTimeGridEntryDeleteFieldInput = {
  delete?: InputMaybe<TimeGridEntryDeleteInput>;
  where?: InputMaybe<TimetableCardStartTimeGridEntryConnectionWhere>;
};

export type TimetableCardStartTimeGridEntryDisconnectFieldInput = {
  disconnect?: InputMaybe<TimeGridEntryDisconnectInput>;
  where?: InputMaybe<TimetableCardStartTimeGridEntryConnectionWhere>;
};

export type TimetableCardStartTimeGridEntryFieldInput = {
  connect?: InputMaybe<TimetableCardStartTimeGridEntryConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardStartTimeGridEntryConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardStartTimeGridEntryCreateFieldInput>;
};

export type TimetableCardStartTimeGridEntryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableCardStartTimeGridEntryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableCardStartTimeGridEntryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableCardStartTimeGridEntryNodeAggregationWhereInput>>;
  end_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  end_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  start_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableCardStartTimeGridEntryRelationship = {
  __typename?: 'TimetableCardStartTimeGridEntryRelationship';
  cursor: Scalars['String']['output'];
  node: TimeGridEntry;
};

export type TimetableCardStartTimeGridEntryUpdateConnectionInput = {
  node?: InputMaybe<TimeGridEntryUpdateInput>;
};

export type TimetableCardStartTimeGridEntryUpdateFieldInput = {
  connect?: InputMaybe<TimetableCardStartTimeGridEntryConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardStartTimeGridEntryConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardStartTimeGridEntryCreateFieldInput>;
  delete?: InputMaybe<TimetableCardStartTimeGridEntryDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableCardStartTimeGridEntryDisconnectFieldInput>;
  update?: InputMaybe<TimetableCardStartTimeGridEntryUpdateConnectionInput>;
  where?: InputMaybe<TimetableCardStartTimeGridEntryConnectionWhere>;
};

export type TimetableCardSubjectContainerAggregateInput = {
  AND?: InputMaybe<Array<TimetableCardSubjectContainerAggregateInput>>;
  NOT?: InputMaybe<TimetableCardSubjectContainerAggregateInput>;
  OR?: InputMaybe<Array<TimetableCardSubjectContainerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableCardSubjectContainerNodeAggregationWhereInput>;
};

export type TimetableCardSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type TimetableCardSubjectContainerConnectOrCreateFieldInput = {
  onCreate: TimetableCardSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type TimetableCardSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type TimetableCardSubjectContainerConnection = {
  __typename?: 'TimetableCardSubjectContainerConnection';
  edges: Array<TimetableCardSubjectContainerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCardSubjectContainerConnectionSort = {
  node?: InputMaybe<SubjectContainerSort>;
};

export type TimetableCardSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<TimetableCardSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<TimetableCardSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<TimetableCardSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type TimetableCardSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type TimetableCardSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<TimetableCardSubjectContainerConnectionWhere>;
};

export type TimetableCardSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<TimetableCardSubjectContainerConnectionWhere>;
};

export type TimetableCardSubjectContainerFieldInput = {
  connect?: InputMaybe<TimetableCardSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardSubjectContainerCreateFieldInput>;
};

export type TimetableCardSubjectContainerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableCardSubjectContainerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableCardSubjectContainerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableCardSubjectContainerNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableCardSubjectContainerRelationship = {
  __typename?: 'TimetableCardSubjectContainerRelationship';
  cursor: Scalars['String']['output'];
  node: SubjectContainer;
};

export type TimetableCardSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type TimetableCardSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<TimetableCardSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableCardSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableCardSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<TimetableCardSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableCardSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<TimetableCardSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<TimetableCardSubjectContainerConnectionWhere>;
};

export type TimetableCardTimetableVersionAggregateInput = {
  AND?: InputMaybe<Array<TimetableCardTimetableVersionAggregateInput>>;
  NOT?: InputMaybe<TimetableCardTimetableVersionAggregateInput>;
  OR?: InputMaybe<Array<TimetableCardTimetableVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableCardTimetableVersionNodeAggregationWhereInput>;
};

export type TimetableCardTimetableVersionConnectFieldInput = {
  connect?: InputMaybe<TimetableVersionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type TimetableCardTimetableVersionConnection = {
  __typename?: 'TimetableCardTimetableVersionConnection';
  edges: Array<TimetableCardTimetableVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableCardTimetableVersionConnectionSort = {
  node?: InputMaybe<TimetableVersionSort>;
};

export type TimetableCardTimetableVersionConnectionWhere = {
  AND?: InputMaybe<Array<TimetableCardTimetableVersionConnectionWhere>>;
  NOT?: InputMaybe<TimetableCardTimetableVersionConnectionWhere>;
  OR?: InputMaybe<Array<TimetableCardTimetableVersionConnectionWhere>>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableCardTimetableVersionCreateFieldInput = {
  node: TimetableVersionCreateInput;
};

export type TimetableCardTimetableVersionDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<TimetableCardTimetableVersionConnectionWhere>;
};

export type TimetableCardTimetableVersionDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<TimetableCardTimetableVersionConnectionWhere>;
};

export type TimetableCardTimetableVersionFieldInput = {
  connect?: InputMaybe<TimetableCardTimetableVersionConnectFieldInput>;
  create?: InputMaybe<TimetableCardTimetableVersionCreateFieldInput>;
};

export type TimetableCardTimetableVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableCardTimetableVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableCardTimetableVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableCardTimetableVersionNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableCardTimetableVersionRelationship = {
  __typename?: 'TimetableCardTimetableVersionRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
};

export type TimetableCardTimetableVersionUpdateConnectionInput = {
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type TimetableCardTimetableVersionUpdateFieldInput = {
  connect?: InputMaybe<TimetableCardTimetableVersionConnectFieldInput>;
  create?: InputMaybe<TimetableCardTimetableVersionCreateFieldInput>;
  delete?: InputMaybe<TimetableCardTimetableVersionDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableCardTimetableVersionDisconnectFieldInput>;
  update?: InputMaybe<TimetableCardTimetableVersionUpdateConnectionInput>;
  where?: InputMaybe<TimetableCardTimetableVersionConnectionWhere>;
};

export type TimetableCardUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableCardUpdateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  duration_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  endTimeGridEntry?: InputMaybe<TimetableCardEndTimeGridEntryUpdateFieldInput>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  lesson?: InputMaybe<TimetableCardLessonUpdateFieldInput>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  rooms?: InputMaybe<Array<TimetableCardRoomsUpdateFieldInput>>;
  startTimeGridEntry?: InputMaybe<TimetableCardStartTimeGridEntryUpdateFieldInput>;
  subjectContainer?: InputMaybe<TimetableCardSubjectContainerUpdateFieldInput>;
  timetableVersion?: InputMaybe<TimetableCardTimetableVersionUpdateFieldInput>;
  weekday?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableCardWhere = {
  AND?: InputMaybe<Array<TimetableCardWhere>>;
  NOT?: InputMaybe<TimetableCardWhere>;
  OR?: InputMaybe<Array<TimetableCardWhere>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  duration_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endTimeGridEntry?: InputMaybe<TimeGridEntryWhere>;
  endTimeGridEntryAggregate?: InputMaybe<TimetableCardEndTimeGridEntryAggregateInput>;
  endTimeGridEntryConnection?: InputMaybe<TimetableCardEndTimeGridEntryConnectionWhere>;
  endTimeGridEntryConnection_NOT?: InputMaybe<TimetableCardEndTimeGridEntryConnectionWhere>;
  endTimeGridEntry_NOT?: InputMaybe<TimeGridEntryWhere>;
  /** @deprecated Use `events_SOME` instead. */
  events?: InputMaybe<EventWhere>;
  eventsAggregate?: InputMaybe<TimetableCardEventsAggregateInput>;
  /** @deprecated Use `eventsConnection_SOME` instead. */
  eventsConnection?: InputMaybe<TimetableCardEventsConnectionWhere>;
  /** Return TimetableCards where all of the related TimetableCardEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<TimetableCardEventsConnectionWhere>;
  /** Return TimetableCards where none of the related TimetableCardEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<TimetableCardEventsConnectionWhere>;
  /** @deprecated Use `eventsConnection_NONE` instead. */
  eventsConnection_NOT?: InputMaybe<TimetableCardEventsConnectionWhere>;
  /** Return TimetableCards where one of the related TimetableCardEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<TimetableCardEventsConnectionWhere>;
  /** Return TimetableCards where some of the related TimetableCardEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<TimetableCardEventsConnectionWhere>;
  /** Return TimetableCards where all of the related Events match this filter */
  events_ALL?: InputMaybe<EventWhere>;
  /** Return TimetableCards where none of the related Events match this filter */
  events_NONE?: InputMaybe<EventWhere>;
  /** @deprecated Use `events_NONE` instead. */
  events_NOT?: InputMaybe<EventWhere>;
  /** Return TimetableCards where one of the related Events match this filter */
  events_SINGLE?: InputMaybe<EventWhere>;
  /** Return TimetableCards where some of the related Events match this filter */
  events_SOME?: InputMaybe<EventWhere>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lesson?: InputMaybe<LessonWhere>;
  lessonAggregate?: InputMaybe<TimetableCardLessonAggregateInput>;
  lessonClasses?: InputMaybe<LessonClassWhere>;
  lessonClasses_ALL?: InputMaybe<LessonClassWhere>;
  lessonClasses_NONE?: InputMaybe<LessonClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  lessonClasses_NOT?: InputMaybe<LessonClassWhere>;
  lessonClasses_SINGLE?: InputMaybe<LessonClassWhere>;
  lessonClasses_SOME?: InputMaybe<LessonClassWhere>;
  lessonConnection?: InputMaybe<TimetableCardLessonConnectionWhere>;
  lessonConnection_NOT?: InputMaybe<TimetableCardLessonConnectionWhere>;
  lesson_NOT?: InputMaybe<LessonWhere>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  locked_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  realEnd?: InputMaybe<Scalars['DateTime']['input']>;
  realEnd_GT?: InputMaybe<Scalars['DateTime']['input']>;
  realEnd_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  realEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  realEnd_LT?: InputMaybe<Scalars['DateTime']['input']>;
  realEnd_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  realEnd_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  realEnd_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  realStart?: InputMaybe<Scalars['DateTime']['input']>;
  realStart_GT?: InputMaybe<Scalars['DateTime']['input']>;
  realStart_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  realStart_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  realStart_LT?: InputMaybe<Scalars['DateTime']['input']>;
  realStart_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  realStart_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  realStart_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<TimetableCardRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<TimetableCardRoomsConnectionWhere>;
  /** Return TimetableCards where all of the related TimetableCardRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<TimetableCardRoomsConnectionWhere>;
  /** Return TimetableCards where none of the related TimetableCardRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<TimetableCardRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<TimetableCardRoomsConnectionWhere>;
  /** Return TimetableCards where one of the related TimetableCardRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<TimetableCardRoomsConnectionWhere>;
  /** Return TimetableCards where some of the related TimetableCardRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<TimetableCardRoomsConnectionWhere>;
  /** Return TimetableCards where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return TimetableCards where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return TimetableCards where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return TimetableCards where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  startTimeGridEntry?: InputMaybe<TimeGridEntryWhere>;
  startTimeGridEntryAggregate?: InputMaybe<TimetableCardStartTimeGridEntryAggregateInput>;
  startTimeGridEntryConnection?: InputMaybe<TimetableCardStartTimeGridEntryConnectionWhere>;
  startTimeGridEntryConnection_NOT?: InputMaybe<TimetableCardStartTimeGridEntryConnectionWhere>;
  startTimeGridEntry_NOT?: InputMaybe<TimeGridEntryWhere>;
  subjectContainer?: InputMaybe<SubjectContainerWhere>;
  subjectContainerAggregate?: InputMaybe<TimetableCardSubjectContainerAggregateInput>;
  subjectContainerConnection?: InputMaybe<TimetableCardSubjectContainerConnectionWhere>;
  subjectContainerConnection_NOT?: InputMaybe<TimetableCardSubjectContainerConnectionWhere>;
  subjectContainer_NOT?: InputMaybe<SubjectContainerWhere>;
  teachers?: InputMaybe<PersonWhere>;
  teachers_ALL?: InputMaybe<PersonWhere>;
  teachers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  teachers_NOT?: InputMaybe<PersonWhere>;
  teachers_SINGLE?: InputMaybe<PersonWhere>;
  teachers_SOME?: InputMaybe<PersonWhere>;
  timetableVersion?: InputMaybe<TimetableVersionWhere>;
  timetableVersionAggregate?: InputMaybe<TimetableCardTimetableVersionAggregateInput>;
  timetableVersionConnection?: InputMaybe<TimetableCardTimetableVersionConnectionWhere>;
  timetableVersionConnection_NOT?: InputMaybe<TimetableCardTimetableVersionConnectionWhere>;
  timetableVersion_NOT?: InputMaybe<TimetableVersionWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  weekday?: InputMaybe<Scalars['String']['input']>;
  weekday_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  weekday_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  weekday_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  weekday_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  weekday_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  weekday_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  weekday_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  weekday_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  weekday_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableCardsConnection = {
  __typename?: 'TimetableCardsConnection';
  edges: Array<TimetableCardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableConfig = {
  __typename?: 'TimetableConfig';
  children?: Maybe<Array<Maybe<TimetableConfig>>>;
  color?: Maybe<Scalars['String']['output']>;
  colorLabel?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  organization: Organization;
  organizationConnection: TimetableConfigOrganizationConnection;
  owner: TimetableConfigOwner;
  ownerConnection: TimetableConfigOwnerConnection;
  printOrder?: Maybe<Scalars['Int']['output']>;
  printPageNr?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TimetableConfigOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TimetableConfigOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableConfigOrganizationConnectionSort>>;
  where?: InputMaybe<TimetableConfigOrganizationConnectionWhere>;
};

export type TimetableConfigOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<TimetableConfigOwnerWhere>;
};

export type TimetableConfigOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TimetableConfigOwnerConnectionWhere>;
};

export type TimetableConfigAggregateSelection = {
  __typename?: 'TimetableConfigAggregateSelection';
  color: StringAggregateSelection;
  colorLabel: StringAggregateSelection;
  count: Scalars['Int']['output'];
  printOrder: IntAggregateSelection;
  printPageNr: IntAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableConfigConnectInput = {
  organization?: InputMaybe<TimetableConfigOrganizationConnectFieldInput>;
  owner?: InputMaybe<TimetableConfigOwnerConnectInput>;
};

export type TimetableConfigConnectWhere = {
  node: TimetableConfigWhere;
};

export type TimetableConfigCreateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  colorLabel?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<TimetableConfigOrganizationFieldInput>;
  owner?: InputMaybe<TimetableConfigOwnerCreateInput>;
  printOrder?: InputMaybe<Scalars['Int']['input']>;
  printPageNr?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableConfigDeleteInput = {
  organization?: InputMaybe<TimetableConfigOrganizationDeleteFieldInput>;
  owner?: InputMaybe<TimetableConfigOwnerDeleteInput>;
};

export type TimetableConfigDisconnectInput = {
  organization?: InputMaybe<TimetableConfigOrganizationDisconnectFieldInput>;
  owner?: InputMaybe<TimetableConfigOwnerDisconnectInput>;
};

export type TimetableConfigEdge = {
  __typename?: 'TimetableConfigEdge';
  cursor: Scalars['String']['output'];
  node: TimetableConfig;
};

export type TimetableConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimetableConfigSort objects to sort TimetableConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimetableConfigSort>>;
};

export type TimetableConfigOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TimetableConfigOrganizationAggregateInput>>;
  NOT?: InputMaybe<TimetableConfigOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TimetableConfigOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableConfigOrganizationNodeAggregationWhereInput>;
};

export type TimetableConfigOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TimetableConfigOrganizationConnectOrCreateFieldInput = {
  onCreate: TimetableConfigOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TimetableConfigOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TimetableConfigOrganizationConnection = {
  __typename?: 'TimetableConfigOrganizationConnection';
  edges: Array<TimetableConfigOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableConfigOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TimetableConfigOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TimetableConfigOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TimetableConfigOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TimetableConfigOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TimetableConfigOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TimetableConfigOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TimetableConfigOrganizationConnectionWhere>;
};

export type TimetableConfigOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TimetableConfigOrganizationConnectionWhere>;
};

export type TimetableConfigOrganizationFieldInput = {
  connect?: InputMaybe<TimetableConfigOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOrganizationCreateFieldInput>;
};

export type TimetableConfigOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableConfigOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableConfigOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableConfigOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableConfigOrganizationRelationship = {
  __typename?: 'TimetableConfigOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TimetableConfigOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TimetableConfigOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TimetableConfigOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOrganizationCreateFieldInput>;
  delete?: InputMaybe<TimetableConfigOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableConfigOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TimetableConfigOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TimetableConfigOrganizationConnectionWhere>;
};

export type TimetableConfigOwner = Class | Person | Room | Subject | SubjectContainer;

export type TimetableConfigOwnerClassConnectFieldInput = {
  connect?: InputMaybe<ClassConnectInput>;
  where?: InputMaybe<ClassConnectWhere>;
};

export type TimetableConfigOwnerClassConnectOrCreateFieldInput = {
  onCreate: TimetableConfigOwnerClassConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type TimetableConfigOwnerClassConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type TimetableConfigOwnerClassConnectionWhere = {
  AND?: InputMaybe<Array<TimetableConfigOwnerClassConnectionWhere>>;
  NOT?: InputMaybe<TimetableConfigOwnerClassConnectionWhere>;
  OR?: InputMaybe<Array<TimetableConfigOwnerClassConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type TimetableConfigOwnerClassCreateFieldInput = {
  node: ClassCreateInput;
};

export type TimetableConfigOwnerClassDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<TimetableConfigOwnerClassConnectionWhere>;
};

export type TimetableConfigOwnerClassDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<TimetableConfigOwnerClassConnectionWhere>;
};

export type TimetableConfigOwnerClassFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerClassConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerClassCreateFieldInput>;
};

export type TimetableConfigOwnerClassUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type TimetableConfigOwnerClassUpdateFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerClassConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerClassConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerClassCreateFieldInput>;
  delete?: InputMaybe<TimetableConfigOwnerClassDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableConfigOwnerClassDisconnectFieldInput>;
  update?: InputMaybe<TimetableConfigOwnerClassUpdateConnectionInput>;
  where?: InputMaybe<TimetableConfigOwnerClassConnectionWhere>;
};

export type TimetableConfigOwnerConnectInput = {
  Class?: InputMaybe<TimetableConfigOwnerClassConnectFieldInput>;
  Person?: InputMaybe<TimetableConfigOwnerPersonConnectFieldInput>;
  Room?: InputMaybe<TimetableConfigOwnerRoomConnectFieldInput>;
  Subject?: InputMaybe<TimetableConfigOwnerSubjectConnectFieldInput>;
  SubjectContainer?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectFieldInput>;
};

export type TimetableConfigOwnerConnection = {
  __typename?: 'TimetableConfigOwnerConnection';
  edges: Array<TimetableConfigOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableConfigOwnerConnectionWhere = {
  Class?: InputMaybe<TimetableConfigOwnerClassConnectionWhere>;
  Person?: InputMaybe<TimetableConfigOwnerPersonConnectionWhere>;
  Room?: InputMaybe<TimetableConfigOwnerRoomConnectionWhere>;
  Subject?: InputMaybe<TimetableConfigOwnerSubjectConnectionWhere>;
  SubjectContainer?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectionWhere>;
};

export type TimetableConfigOwnerCreateInput = {
  Class?: InputMaybe<TimetableConfigOwnerClassFieldInput>;
  Person?: InputMaybe<TimetableConfigOwnerPersonFieldInput>;
  Room?: InputMaybe<TimetableConfigOwnerRoomFieldInput>;
  Subject?: InputMaybe<TimetableConfigOwnerSubjectFieldInput>;
  SubjectContainer?: InputMaybe<TimetableConfigOwnerSubjectContainerFieldInput>;
};

export type TimetableConfigOwnerDeleteInput = {
  Class?: InputMaybe<TimetableConfigOwnerClassDeleteFieldInput>;
  Person?: InputMaybe<TimetableConfigOwnerPersonDeleteFieldInput>;
  Room?: InputMaybe<TimetableConfigOwnerRoomDeleteFieldInput>;
  Subject?: InputMaybe<TimetableConfigOwnerSubjectDeleteFieldInput>;
  SubjectContainer?: InputMaybe<TimetableConfigOwnerSubjectContainerDeleteFieldInput>;
};

export type TimetableConfigOwnerDisconnectInput = {
  Class?: InputMaybe<TimetableConfigOwnerClassDisconnectFieldInput>;
  Person?: InputMaybe<TimetableConfigOwnerPersonDisconnectFieldInput>;
  Room?: InputMaybe<TimetableConfigOwnerRoomDisconnectFieldInput>;
  Subject?: InputMaybe<TimetableConfigOwnerSubjectDisconnectFieldInput>;
  SubjectContainer?: InputMaybe<TimetableConfigOwnerSubjectContainerDisconnectFieldInput>;
};

export type TimetableConfigOwnerPersonConnectFieldInput = {
  connect?: InputMaybe<PersonConnectInput>;
  where?: InputMaybe<PersonConnectWhere>;
};

export type TimetableConfigOwnerPersonConnectOrCreateFieldInput = {
  onCreate: TimetableConfigOwnerPersonConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type TimetableConfigOwnerPersonConnectOrCreateFieldInputOnCreate = {
  node: PersonOnCreateInput;
};

export type TimetableConfigOwnerPersonConnectionWhere = {
  AND?: InputMaybe<Array<TimetableConfigOwnerPersonConnectionWhere>>;
  NOT?: InputMaybe<TimetableConfigOwnerPersonConnectionWhere>;
  OR?: InputMaybe<Array<TimetableConfigOwnerPersonConnectionWhere>>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type TimetableConfigOwnerPersonCreateFieldInput = {
  node: PersonCreateInput;
};

export type TimetableConfigOwnerPersonDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<TimetableConfigOwnerPersonConnectionWhere>;
};

export type TimetableConfigOwnerPersonDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<TimetableConfigOwnerPersonConnectionWhere>;
};

export type TimetableConfigOwnerPersonFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerPersonCreateFieldInput>;
};

export type TimetableConfigOwnerPersonUpdateConnectionInput = {
  node?: InputMaybe<PersonUpdateInput>;
};

export type TimetableConfigOwnerPersonUpdateFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerPersonConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerPersonConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerPersonCreateFieldInput>;
  delete?: InputMaybe<TimetableConfigOwnerPersonDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableConfigOwnerPersonDisconnectFieldInput>;
  update?: InputMaybe<TimetableConfigOwnerPersonUpdateConnectionInput>;
  where?: InputMaybe<TimetableConfigOwnerPersonConnectionWhere>;
};

export type TimetableConfigOwnerRelationship = {
  __typename?: 'TimetableConfigOwnerRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableConfigOwner;
};

export type TimetableConfigOwnerRoomConnectFieldInput = {
  connect?: InputMaybe<RoomConnectInput>;
  where?: InputMaybe<RoomConnectWhere>;
};

export type TimetableConfigOwnerRoomConnectOrCreateFieldInput = {
  onCreate: TimetableConfigOwnerRoomConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type TimetableConfigOwnerRoomConnectOrCreateFieldInputOnCreate = {
  node: RoomOnCreateInput;
};

export type TimetableConfigOwnerRoomConnectionWhere = {
  AND?: InputMaybe<Array<TimetableConfigOwnerRoomConnectionWhere>>;
  NOT?: InputMaybe<TimetableConfigOwnerRoomConnectionWhere>;
  OR?: InputMaybe<Array<TimetableConfigOwnerRoomConnectionWhere>>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type TimetableConfigOwnerRoomCreateFieldInput = {
  node: RoomCreateInput;
};

export type TimetableConfigOwnerRoomDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<TimetableConfigOwnerRoomConnectionWhere>;
};

export type TimetableConfigOwnerRoomDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<TimetableConfigOwnerRoomConnectionWhere>;
};

export type TimetableConfigOwnerRoomFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerRoomCreateFieldInput>;
};

export type TimetableConfigOwnerRoomUpdateConnectionInput = {
  node?: InputMaybe<RoomUpdateInput>;
};

export type TimetableConfigOwnerRoomUpdateFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerRoomConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerRoomConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerRoomCreateFieldInput>;
  delete?: InputMaybe<TimetableConfigOwnerRoomDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableConfigOwnerRoomDisconnectFieldInput>;
  update?: InputMaybe<TimetableConfigOwnerRoomUpdateConnectionInput>;
  where?: InputMaybe<TimetableConfigOwnerRoomConnectionWhere>;
};

export type TimetableConfigOwnerSubjectConnectFieldInput = {
  connect?: InputMaybe<SubjectConnectInput>;
  where?: InputMaybe<SubjectConnectWhere>;
};

export type TimetableConfigOwnerSubjectConnectOrCreateFieldInput = {
  onCreate: TimetableConfigOwnerSubjectConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type TimetableConfigOwnerSubjectConnectOrCreateFieldInputOnCreate = {
  node: SubjectOnCreateInput;
};

export type TimetableConfigOwnerSubjectConnectionWhere = {
  AND?: InputMaybe<Array<TimetableConfigOwnerSubjectConnectionWhere>>;
  NOT?: InputMaybe<TimetableConfigOwnerSubjectConnectionWhere>;
  OR?: InputMaybe<Array<TimetableConfigOwnerSubjectConnectionWhere>>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type TimetableConfigOwnerSubjectContainerConnectFieldInput = {
  connect?: InputMaybe<SubjectContainerConnectInput>;
  where?: InputMaybe<SubjectContainerConnectWhere>;
};

export type TimetableConfigOwnerSubjectContainerConnectOrCreateFieldInput = {
  onCreate: TimetableConfigOwnerSubjectContainerConnectOrCreateFieldInputOnCreate;
  where: SubjectContainerConnectOrCreateWhere;
};

export type TimetableConfigOwnerSubjectContainerConnectOrCreateFieldInputOnCreate = {
  node: SubjectContainerOnCreateInput;
};

export type TimetableConfigOwnerSubjectContainerConnectionWhere = {
  AND?: InputMaybe<Array<TimetableConfigOwnerSubjectContainerConnectionWhere>>;
  NOT?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectionWhere>;
  OR?: InputMaybe<Array<TimetableConfigOwnerSubjectContainerConnectionWhere>>;
  node?: InputMaybe<SubjectContainerWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectContainerWhere>;
};

export type TimetableConfigOwnerSubjectContainerCreateFieldInput = {
  node: SubjectContainerCreateInput;
};

export type TimetableConfigOwnerSubjectContainerDeleteFieldInput = {
  delete?: InputMaybe<SubjectContainerDeleteInput>;
  where?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectionWhere>;
};

export type TimetableConfigOwnerSubjectContainerDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectContainerDisconnectInput>;
  where?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectionWhere>;
};

export type TimetableConfigOwnerSubjectContainerFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerSubjectContainerCreateFieldInput>;
};

export type TimetableConfigOwnerSubjectContainerUpdateConnectionInput = {
  node?: InputMaybe<SubjectContainerUpdateInput>;
};

export type TimetableConfigOwnerSubjectContainerUpdateFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerSubjectContainerCreateFieldInput>;
  delete?: InputMaybe<TimetableConfigOwnerSubjectContainerDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableConfigOwnerSubjectContainerDisconnectFieldInput>;
  update?: InputMaybe<TimetableConfigOwnerSubjectContainerUpdateConnectionInput>;
  where?: InputMaybe<TimetableConfigOwnerSubjectContainerConnectionWhere>;
};

export type TimetableConfigOwnerSubjectCreateFieldInput = {
  node: SubjectCreateInput;
};

export type TimetableConfigOwnerSubjectDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<TimetableConfigOwnerSubjectConnectionWhere>;
};

export type TimetableConfigOwnerSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<TimetableConfigOwnerSubjectConnectionWhere>;
};

export type TimetableConfigOwnerSubjectFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerSubjectCreateFieldInput>;
};

export type TimetableConfigOwnerSubjectUpdateConnectionInput = {
  node?: InputMaybe<SubjectUpdateInput>;
};

export type TimetableConfigOwnerSubjectUpdateFieldInput = {
  connect?: InputMaybe<TimetableConfigOwnerSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableConfigOwnerSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableConfigOwnerSubjectCreateFieldInput>;
  delete?: InputMaybe<TimetableConfigOwnerSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableConfigOwnerSubjectDisconnectFieldInput>;
  update?: InputMaybe<TimetableConfigOwnerSubjectUpdateConnectionInput>;
  where?: InputMaybe<TimetableConfigOwnerSubjectConnectionWhere>;
};

export type TimetableConfigOwnerUpdateInput = {
  Class?: InputMaybe<TimetableConfigOwnerClassUpdateFieldInput>;
  Person?: InputMaybe<TimetableConfigOwnerPersonUpdateFieldInput>;
  Room?: InputMaybe<TimetableConfigOwnerRoomUpdateFieldInput>;
  Subject?: InputMaybe<TimetableConfigOwnerSubjectUpdateFieldInput>;
  SubjectContainer?: InputMaybe<TimetableConfigOwnerSubjectContainerUpdateFieldInput>;
};

export type TimetableConfigOwnerWhere = {
  Class?: InputMaybe<ClassWhere>;
  Person?: InputMaybe<PersonWhere>;
  Room?: InputMaybe<RoomWhere>;
  Subject?: InputMaybe<SubjectWhere>;
  SubjectContainer?: InputMaybe<SubjectContainerWhere>;
};

/** Fields to sort TimetableConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimetableConfigSort object. */
export type TimetableConfigSort = {
  color?: InputMaybe<SortDirection>;
  colorLabel?: InputMaybe<SortDirection>;
  isEnabled?: InputMaybe<SortDirection>;
  printOrder?: InputMaybe<SortDirection>;
  printPageNr?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TimetableConfigUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  colorLabel?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<TimetableConfigOrganizationUpdateFieldInput>;
  owner?: InputMaybe<TimetableConfigOwnerUpdateInput>;
  printOrder?: InputMaybe<Scalars['Int']['input']>;
  printOrder_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableConfigWhere = {
  AND?: InputMaybe<Array<TimetableConfigWhere>>;
  NOT?: InputMaybe<TimetableConfigWhere>;
  OR?: InputMaybe<Array<TimetableConfigWhere>>;
  color?: InputMaybe<Scalars['String']['input']>;
  colorLabel?: InputMaybe<Scalars['String']['input']>;
  colorLabel_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  colorLabel_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  colorLabel_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  colorLabel_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  colorLabel_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  colorLabel_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  colorLabel_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  colorLabel_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  colorLabel_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  color_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  color_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  color_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TimetableConfigOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TimetableConfigOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TimetableConfigOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  owner?: InputMaybe<TimetableConfigOwnerWhere>;
  ownerConnection?: InputMaybe<TimetableConfigOwnerConnectionWhere>;
  ownerConnection_NOT?: InputMaybe<TimetableConfigOwnerConnectionWhere>;
  owner_NOT?: InputMaybe<TimetableConfigOwnerWhere>;
  printOrder?: InputMaybe<Scalars['Int']['input']>;
  printOrder_GT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_GTE?: InputMaybe<Scalars['Int']['input']>;
  printOrder_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  printOrder_LT?: InputMaybe<Scalars['Int']['input']>;
  printOrder_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printOrder_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printOrder_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  printPageNr?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_GT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_GTE?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  printPageNr_LT?: InputMaybe<Scalars['Int']['input']>;
  printPageNr_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printPageNr_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printPageNr_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TimetableConfigsConnection = {
  __typename?: 'TimetableConfigsConnection';
  edges: Array<TimetableConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableConnectInput = {
  organization?: InputMaybe<TimetableOrganizationConnectFieldInput>;
  schoolYear?: InputMaybe<TimetableSchoolYearConnectFieldInput>;
  timegridConfigs?: InputMaybe<Array<TimetableTimegridConfigsConnectFieldInput>>;
  timetableBlocks?: InputMaybe<Array<TimetableTimetableBlocksConnectFieldInput>>;
  versions?: InputMaybe<Array<TimetableVersionsConnectFieldInput>>;
};

export type TimetableConnectOrCreateWhere = {
  node: TimetableUniqueWhere;
};

export type TimetableConnectWhere = {
  node: TimetableWhere;
};

export type TimetableCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['Boolean']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  friEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  monEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organization?: InputMaybe<TimetableOrganizationFieldInput>;
  satEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYear?: InputMaybe<TimetableSchoolYearFieldInput>;
  sunEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  thuEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timegridConfigs?: InputMaybe<TimetableTimegridConfigsFieldInput>;
  timetableBlocks?: InputMaybe<TimetableTimetableBlocksFieldInput>;
  tueEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt: Scalars['DateTime']['input'];
  versions?: InputMaybe<TimetableVersionsFieldInput>;
  wedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimetableDeleteInput = {
  organization?: InputMaybe<TimetableOrganizationDeleteFieldInput>;
  schoolYear?: InputMaybe<TimetableSchoolYearDeleteFieldInput>;
  timegridConfigs?: InputMaybe<Array<TimetableTimegridConfigsDeleteFieldInput>>;
  timetableBlocks?: InputMaybe<Array<TimetableTimetableBlocksDeleteFieldInput>>;
  versions?: InputMaybe<Array<TimetableVersionsDeleteFieldInput>>;
};

export type TimetableDisconnectInput = {
  organization?: InputMaybe<TimetableOrganizationDisconnectFieldInput>;
  schoolYear?: InputMaybe<TimetableSchoolYearDisconnectFieldInput>;
  timegridConfigs?: InputMaybe<Array<TimetableTimegridConfigsDisconnectFieldInput>>;
  timetableBlocks?: InputMaybe<Array<TimetableTimetableBlocksDisconnectFieldInput>>;
  versions?: InputMaybe<Array<TimetableVersionsDisconnectFieldInput>>;
};

export type TimetableEdge = {
  __typename?: 'TimetableEdge';
  cursor: Scalars['String']['output'];
  node: Timetable;
};

export type TimetableOnCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  draft: Scalars['Boolean']['input'];
  foreignId?: InputMaybe<Scalars['String']['input']>;
  friEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  monEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  satEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sunEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  thuEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tueEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt: Scalars['DateTime']['input'];
  wedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimetableOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimetableSort objects to sort Timetables by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimetableSort>>;
};

export type TimetableOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TimetableOrganizationAggregateInput>>;
  NOT?: InputMaybe<TimetableOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TimetableOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableOrganizationNodeAggregationWhereInput>;
};

export type TimetableOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TimetableOrganizationConnectOrCreateFieldInput = {
  onCreate: TimetableOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TimetableOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TimetableOrganizationConnection = {
  __typename?: 'TimetableOrganizationConnection';
  edges: Array<TimetableOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TimetableOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TimetableOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TimetableOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TimetableOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TimetableOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TimetableOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TimetableOrganizationConnectionWhere>;
};

export type TimetableOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TimetableOrganizationConnectionWhere>;
};

export type TimetableOrganizationFieldInput = {
  connect?: InputMaybe<TimetableOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableOrganizationCreateFieldInput>;
};

export type TimetableOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableOrganizationRelationship = {
  __typename?: 'TimetableOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TimetableOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TimetableOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TimetableOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableOrganizationCreateFieldInput>;
  delete?: InputMaybe<TimetableOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TimetableOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TimetableOrganizationConnectionWhere>;
};

export enum TimetablePrintColorOrigins {
  Class = 'class',
  None = 'none',
  Room = 'room',
  Subject = 'subject',
  Teacher = 'teacher',
}

export enum TimetablePrintColorPositions {
  Bottom = 'bottom',
  Full = 'full',
  Left = 'left',
  None = 'none',
  Right = 'right',
  Top = 'top',
}

export type TimetablePrintConfig = {
  __typename?: 'TimetablePrintConfig';
  addSubjectContainerCards?: Maybe<Scalars['Boolean']['output']>;
  bottomCenter?: Maybe<TimetablePrintLayoutOptions>;
  bottomLeft?: Maybe<TimetablePrintLayoutOptions>;
  bottomRight?: Maybe<TimetablePrintLayoutOptions>;
  center?: Maybe<TimetablePrintLayoutOptions>;
  exactMinute?: Maybe<Scalars['Boolean']['output']>;
  largeFont?: Maybe<Scalars['Boolean']['output']>;
  organization: Organization;
  organizationConnection: TimetablePrintConfigOrganizationConnection;
  printClasses?: Maybe<Scalars['Boolean']['output']>;
  printColorOrigin?: Maybe<TimetablePrintColorOrigins>;
  printColorPosition?: Maybe<TimetablePrintColorPositions>;
  printLogo?: Maybe<Scalars['Boolean']['output']>;
  printSubtitle?: Maybe<Scalars['Boolean']['output']>;
  scaleText?: Maybe<Scalars['Boolean']['output']>;
  showCalendarWeeks?: Maybe<Scalars['Boolean']['output']>;
  showSchoolWeeks?: Maybe<Scalars['Boolean']['output']>;
  showWeekSchoolDays?: Maybe<Scalars['Boolean']['output']>;
  timeHorizontal?: Maybe<Scalars['Boolean']['output']>;
  topCenter?: Maybe<TimetablePrintLayoutOptions>;
  topLeft?: Maybe<TimetablePrintLayoutOptions>;
  topRight?: Maybe<TimetablePrintLayoutOptions>;
  type: TimetableReportType;
  uuid: Scalars['ID']['output'];
};

export type TimetablePrintConfigOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};

export type TimetablePrintConfigOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetablePrintConfigOrganizationConnectionSort>>;
  where?: InputMaybe<TimetablePrintConfigOrganizationConnectionWhere>;
};

export type TimetablePrintConfigAggregateSelection = {
  __typename?: 'TimetablePrintConfigAggregateSelection';
  count: Scalars['Int']['output'];
  uuid: IdAggregateSelection;
};

export type TimetablePrintConfigCreateInput = {
  addSubjectContainerCards?: InputMaybe<Scalars['Boolean']['input']>;
  bottomCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomRight?: InputMaybe<TimetablePrintLayoutOptions>;
  center?: InputMaybe<TimetablePrintLayoutOptions>;
  exactMinute?: InputMaybe<Scalars['Boolean']['input']>;
  largeFont?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<TimetablePrintConfigOrganizationFieldInput>;
  printClasses?: InputMaybe<Scalars['Boolean']['input']>;
  printColorOrigin?: InputMaybe<TimetablePrintColorOrigins>;
  printColorPosition?: InputMaybe<TimetablePrintColorPositions>;
  printLogo?: InputMaybe<Scalars['Boolean']['input']>;
  printSubtitle?: InputMaybe<Scalars['Boolean']['input']>;
  scaleText?: InputMaybe<Scalars['Boolean']['input']>;
  showCalendarWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  showSchoolWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  showWeekSchoolDays?: InputMaybe<Scalars['Boolean']['input']>;
  timeHorizontal?: InputMaybe<Scalars['Boolean']['input']>;
  topCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  topLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  topRight?: InputMaybe<TimetablePrintLayoutOptions>;
  type: TimetableReportType;
};

export type TimetablePrintConfigDeleteInput = {
  organization?: InputMaybe<TimetablePrintConfigOrganizationDeleteFieldInput>;
};

export type TimetablePrintConfigEdge = {
  __typename?: 'TimetablePrintConfigEdge';
  cursor: Scalars['String']['output'];
  node: TimetablePrintConfig;
};

export type TimetablePrintConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimetablePrintConfigSort objects to sort TimetablePrintConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimetablePrintConfigSort>>;
};

export type TimetablePrintConfigOrganizationAggregateInput = {
  AND?: InputMaybe<Array<TimetablePrintConfigOrganizationAggregateInput>>;
  NOT?: InputMaybe<TimetablePrintConfigOrganizationAggregateInput>;
  OR?: InputMaybe<Array<TimetablePrintConfigOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetablePrintConfigOrganizationNodeAggregationWhereInput>;
};

export type TimetablePrintConfigOrganizationConnectFieldInput = {
  connect?: InputMaybe<OrganizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OrganizationConnectWhere>;
};

export type TimetablePrintConfigOrganizationConnectOrCreateFieldInput = {
  onCreate: TimetablePrintConfigOrganizationConnectOrCreateFieldInputOnCreate;
  where: OrganizationConnectOrCreateWhere;
};

export type TimetablePrintConfigOrganizationConnectOrCreateFieldInputOnCreate = {
  node: OrganizationOnCreateInput;
};

export type TimetablePrintConfigOrganizationConnection = {
  __typename?: 'TimetablePrintConfigOrganizationConnection';
  edges: Array<TimetablePrintConfigOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetablePrintConfigOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type TimetablePrintConfigOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<TimetablePrintConfigOrganizationConnectionWhere>>;
  NOT?: InputMaybe<TimetablePrintConfigOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<TimetablePrintConfigOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<OrganizationWhere>;
};

export type TimetablePrintConfigOrganizationCreateFieldInput = {
  node: OrganizationCreateInput;
};

export type TimetablePrintConfigOrganizationDeleteFieldInput = {
  delete?: InputMaybe<OrganizationDeleteInput>;
  where?: InputMaybe<TimetablePrintConfigOrganizationConnectionWhere>;
};

export type TimetablePrintConfigOrganizationDisconnectFieldInput = {
  disconnect?: InputMaybe<OrganizationDisconnectInput>;
  where?: InputMaybe<TimetablePrintConfigOrganizationConnectionWhere>;
};

export type TimetablePrintConfigOrganizationFieldInput = {
  connect?: InputMaybe<TimetablePrintConfigOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetablePrintConfigOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetablePrintConfigOrganizationCreateFieldInput>;
};

export type TimetablePrintConfigOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetablePrintConfigOrganizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetablePrintConfigOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetablePrintConfigOrganizationNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iphisSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  locale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  locale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  locale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  substitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  substitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vpoSubstitutionProps_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetablePrintConfigOrganizationRelationship = {
  __typename?: 'TimetablePrintConfigOrganizationRelationship';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type TimetablePrintConfigOrganizationUpdateConnectionInput = {
  node?: InputMaybe<OrganizationUpdateInput>;
};

export type TimetablePrintConfigOrganizationUpdateFieldInput = {
  connect?: InputMaybe<TimetablePrintConfigOrganizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetablePrintConfigOrganizationConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetablePrintConfigOrganizationCreateFieldInput>;
  delete?: InputMaybe<TimetablePrintConfigOrganizationDeleteFieldInput>;
  disconnect?: InputMaybe<TimetablePrintConfigOrganizationDisconnectFieldInput>;
  update?: InputMaybe<TimetablePrintConfigOrganizationUpdateConnectionInput>;
  where?: InputMaybe<TimetablePrintConfigOrganizationConnectionWhere>;
};

/** Fields to sort TimetablePrintConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimetablePrintConfigSort object. */
export type TimetablePrintConfigSort = {
  addSubjectContainerCards?: InputMaybe<SortDirection>;
  bottomCenter?: InputMaybe<SortDirection>;
  bottomLeft?: InputMaybe<SortDirection>;
  bottomRight?: InputMaybe<SortDirection>;
  center?: InputMaybe<SortDirection>;
  exactMinute?: InputMaybe<SortDirection>;
  largeFont?: InputMaybe<SortDirection>;
  printClasses?: InputMaybe<SortDirection>;
  printColorOrigin?: InputMaybe<SortDirection>;
  printColorPosition?: InputMaybe<SortDirection>;
  printLogo?: InputMaybe<SortDirection>;
  printSubtitle?: InputMaybe<SortDirection>;
  scaleText?: InputMaybe<SortDirection>;
  showCalendarWeeks?: InputMaybe<SortDirection>;
  showSchoolWeeks?: InputMaybe<SortDirection>;
  showWeekSchoolDays?: InputMaybe<SortDirection>;
  timeHorizontal?: InputMaybe<SortDirection>;
  topCenter?: InputMaybe<SortDirection>;
  topLeft?: InputMaybe<SortDirection>;
  topRight?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type TimetablePrintConfigUpdateInput = {
  addSubjectContainerCards?: InputMaybe<Scalars['Boolean']['input']>;
  bottomCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomRight?: InputMaybe<TimetablePrintLayoutOptions>;
  center?: InputMaybe<TimetablePrintLayoutOptions>;
  exactMinute?: InputMaybe<Scalars['Boolean']['input']>;
  largeFont?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<TimetablePrintConfigOrganizationUpdateFieldInput>;
  printClasses?: InputMaybe<Scalars['Boolean']['input']>;
  printColorOrigin?: InputMaybe<TimetablePrintColorOrigins>;
  printColorPosition?: InputMaybe<TimetablePrintColorPositions>;
  printLogo?: InputMaybe<Scalars['Boolean']['input']>;
  printSubtitle?: InputMaybe<Scalars['Boolean']['input']>;
  scaleText?: InputMaybe<Scalars['Boolean']['input']>;
  showCalendarWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  showSchoolWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  showWeekSchoolDays?: InputMaybe<Scalars['Boolean']['input']>;
  timeHorizontal?: InputMaybe<Scalars['Boolean']['input']>;
  topCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  topLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  topRight?: InputMaybe<TimetablePrintLayoutOptions>;
  type?: InputMaybe<TimetableReportType>;
};

export type TimetablePrintConfigWhere = {
  AND?: InputMaybe<Array<TimetablePrintConfigWhere>>;
  NOT?: InputMaybe<TimetablePrintConfigWhere>;
  OR?: InputMaybe<Array<TimetablePrintConfigWhere>>;
  addSubjectContainerCards?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  addSubjectContainerCards_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  bottomCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomCenter_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bottomCenter_NOT?: InputMaybe<TimetablePrintLayoutOptions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bottomCenter_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  bottomLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomLeft_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bottomLeft_NOT?: InputMaybe<TimetablePrintLayoutOptions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bottomLeft_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  bottomRight?: InputMaybe<TimetablePrintLayoutOptions>;
  bottomRight_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bottomRight_NOT?: InputMaybe<TimetablePrintLayoutOptions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  bottomRight_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  center?: InputMaybe<TimetablePrintLayoutOptions>;
  center_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  center_NOT?: InputMaybe<TimetablePrintLayoutOptions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  center_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  exactMinute?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  exactMinute_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  largeFont?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  largeFont_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TimetablePrintConfigOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TimetablePrintConfigOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TimetablePrintConfigOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  printClasses?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printClasses_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  printColorOrigin?: InputMaybe<TimetablePrintColorOrigins>;
  printColorOrigin_IN?: InputMaybe<Array<InputMaybe<TimetablePrintColorOrigins>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printColorOrigin_NOT?: InputMaybe<TimetablePrintColorOrigins>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printColorOrigin_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintColorOrigins>>>;
  printColorPosition?: InputMaybe<TimetablePrintColorPositions>;
  printColorPosition_IN?: InputMaybe<Array<InputMaybe<TimetablePrintColorPositions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printColorPosition_NOT?: InputMaybe<TimetablePrintColorPositions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printColorPosition_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintColorPositions>>>;
  printLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printLogo_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  printSubtitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  printSubtitle_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  scaleText?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  scaleText_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showCalendarWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showCalendarWeeks_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showSchoolWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showSchoolWeeks_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  showWeekSchoolDays?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  showWeekSchoolDays_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  timeHorizontal?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  timeHorizontal_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  topCenter?: InputMaybe<TimetablePrintLayoutOptions>;
  topCenter_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topCenter_NOT?: InputMaybe<TimetablePrintLayoutOptions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topCenter_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  topLeft?: InputMaybe<TimetablePrintLayoutOptions>;
  topLeft_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topLeft_NOT?: InputMaybe<TimetablePrintLayoutOptions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topLeft_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  topRight?: InputMaybe<TimetablePrintLayoutOptions>;
  topRight_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topRight_NOT?: InputMaybe<TimetablePrintLayoutOptions>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  topRight_NOT_IN?: InputMaybe<Array<InputMaybe<TimetablePrintLayoutOptions>>>;
  type?: InputMaybe<TimetableReportType>;
  type_IN?: InputMaybe<Array<TimetableReportType>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT?: InputMaybe<TimetableReportType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT_IN?: InputMaybe<Array<TimetableReportType>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TimetablePrintConfigsConnection = {
  __typename?: 'TimetablePrintConfigsConnection';
  edges: Array<TimetablePrintConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum TimetablePrintLayoutOptions {
  ClassAndGroup = 'classAndGroup',
  ClassName = 'className',
  Empty = 'empty',
  GroupName = 'groupName',
  RoomName = 'roomName',
  RoomNumber = 'roomNumber',
  SubjectClassAndGroup = 'subjectClassAndGroup',
  SubjectLong = 'subjectLong',
  SubjectShort = 'subjectShort',
  TeacherAndRoom = 'teacherAndRoom',
  TeacherLong = 'teacherLong',
  TeacherShort = 'teacherShort',
}

/**
 * The edge properties for the following fields:
 * * Class.timetableVersions
 * * TimetableVersion.subjects
 * * TimetableVersion.teachers
 * * TimetableVersion.classes
 * * TimetableVersion.rooms
 */
export type TimetableRelationshipProperties = {
  __typename?: 'TimetableRelationshipProperties';
  constraints?: Maybe<Scalars['String']['output']>;
  fri?: Maybe<Scalars['String']['output']>;
  mon?: Maybe<Scalars['String']['output']>;
  sat?: Maybe<Scalars['String']['output']>;
  sun?: Maybe<Scalars['String']['output']>;
  thu?: Maybe<Scalars['String']['output']>;
  tue?: Maybe<Scalars['String']['output']>;
  wed?: Maybe<Scalars['String']['output']>;
};

export type TimetableRelationshipPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableRelationshipPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableRelationshipPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableRelationshipPropertiesAggregationWhereInput>>;
  constraints_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  constraints_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  constraints_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  constraints_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  constraints_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fri_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fri_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fri_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fri_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fri_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fri_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fri_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fri_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fri_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fri_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fri_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fri_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fri_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fri_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fri_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mon_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mon_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mon_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mon_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mon_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mon_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mon_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mon_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mon_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mon_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mon_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mon_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mon_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mon_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mon_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sat_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sat_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sat_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sat_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sat_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sat_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sat_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sat_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sat_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sat_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sat_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sat_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sat_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sat_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sat_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sun_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sun_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sun_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sun_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sun_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sun_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sun_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sun_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sun_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sun_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sun_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sun_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sun_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sun_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sun_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thu_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thu_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thu_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thu_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thu_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thu_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thu_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thu_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thu_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thu_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thu_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thu_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thu_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thu_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thu_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  wed_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  wed_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  wed_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  wed_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  wed_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  wed_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  wed_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  wed_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  wed_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  wed_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  wed_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  wed_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  wed_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  wed_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  wed_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableRelationshipPropertiesCreateInput = {
  constraints?: InputMaybe<Scalars['String']['input']>;
  fri?: InputMaybe<Scalars['String']['input']>;
  mon?: InputMaybe<Scalars['String']['input']>;
  sat?: InputMaybe<Scalars['String']['input']>;
  sun?: InputMaybe<Scalars['String']['input']>;
  thu?: InputMaybe<Scalars['String']['input']>;
  tue?: InputMaybe<Scalars['String']['input']>;
  wed?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableRelationshipPropertiesSort = {
  constraints?: InputMaybe<SortDirection>;
  fri?: InputMaybe<SortDirection>;
  mon?: InputMaybe<SortDirection>;
  sat?: InputMaybe<SortDirection>;
  sun?: InputMaybe<SortDirection>;
  thu?: InputMaybe<SortDirection>;
  tue?: InputMaybe<SortDirection>;
  wed?: InputMaybe<SortDirection>;
};

export type TimetableRelationshipPropertiesUpdateInput = {
  constraints?: InputMaybe<Scalars['String']['input']>;
  fri?: InputMaybe<Scalars['String']['input']>;
  mon?: InputMaybe<Scalars['String']['input']>;
  sat?: InputMaybe<Scalars['String']['input']>;
  sun?: InputMaybe<Scalars['String']['input']>;
  thu?: InputMaybe<Scalars['String']['input']>;
  tue?: InputMaybe<Scalars['String']['input']>;
  wed?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableRelationshipPropertiesWhere = {
  AND?: InputMaybe<Array<TimetableRelationshipPropertiesWhere>>;
  NOT?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  OR?: InputMaybe<Array<TimetableRelationshipPropertiesWhere>>;
  constraints?: InputMaybe<Scalars['String']['input']>;
  constraints_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  constraints_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  constraints_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  constraints_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  constraints_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fri?: InputMaybe<Scalars['String']['input']>;
  fri_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fri_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fri_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fri_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fri_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fri_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fri_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  fri_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fri_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mon?: InputMaybe<Scalars['String']['input']>;
  mon_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mon_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mon_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mon_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mon_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mon_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mon_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  mon_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mon_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sat?: InputMaybe<Scalars['String']['input']>;
  sat_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sat_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sat_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sat_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sat_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sat_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sat_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sat_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sat_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sun?: InputMaybe<Scalars['String']['input']>;
  sun_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sun_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sun_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sun_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sun_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sun_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sun_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sun_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sun_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  thu?: InputMaybe<Scalars['String']['input']>;
  thu_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  thu_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  thu_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thu_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thu_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thu_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thu_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thu_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  thu_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tue?: InputMaybe<Scalars['String']['input']>;
  tue_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tue_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tue_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tue_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tue_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tue_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tue_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tue_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tue_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  wed?: InputMaybe<Scalars['String']['input']>;
  wed_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  wed_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  wed_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  wed_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  wed_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  wed_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  wed_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  wed_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  wed_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableReport = {
  __typename?: 'TimetableReport';
  context: PdfReportContext;
  contextConnection: TimetableReportContextConnection;
  fileEntries: Array<FileEntry>;
  fileEntriesAggregate?: Maybe<TimetableReportFileEntryFileEntriesAggregationSelection>;
  fileEntriesConnection: TimetableReportFileEntriesConnection;
  jobConfiguration: Scalars['String']['output'];
  jobCreated: Scalars['DateTime']['output'];
  jobFinished: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: TimetableReportType;
  uuid: Scalars['ID']['output'];
};

export type TimetableReportContextArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<PdfReportContextWhere>;
};

export type TimetableReportContextConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableReportContextConnectionSort>>;
  where?: InputMaybe<TimetableReportContextConnectionWhere>;
};

export type TimetableReportFileEntriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileEntryOptions>;
  where?: InputMaybe<FileEntryWhere>;
};

export type TimetableReportFileEntriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileEntryWhere>;
};

export type TimetableReportFileEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableReportFileEntriesConnectionSort>>;
  where?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
};

export type TimetableReportAggregateSelection = {
  __typename?: 'TimetableReportAggregateSelection';
  count: Scalars['Int']['output'];
  jobConfiguration: StringAggregateSelection;
  jobCreated: DateTimeAggregateSelection;
  jobFinished: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableReportConnectInput = {
  context?: InputMaybe<TimetableReportContextConnectInput>;
  fileEntries?: InputMaybe<Array<TimetableReportFileEntriesConnectFieldInput>>;
};

export type TimetableReportConnectWhere = {
  node: TimetableReportWhere;
};

export type TimetableReportContextConnectInput = {
  SchoolYear?: InputMaybe<TimetableReportContextSchoolYearConnectFieldInput>;
  TeachingBlock?: InputMaybe<TimetableReportContextTeachingBlockConnectFieldInput>;
  TimetableBlock?: InputMaybe<TimetableReportContextTimetableBlockConnectFieldInput>;
};

export type TimetableReportContextConnection = {
  __typename?: 'TimetableReportContextConnection';
  edges: Array<TimetableReportContextRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableReportContextConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
};

export type TimetableReportContextConnectionWhere = {
  SchoolYear?: InputMaybe<TimetableReportContextSchoolYearConnectionWhere>;
  TeachingBlock?: InputMaybe<TimetableReportContextTeachingBlockConnectionWhere>;
  TimetableBlock?: InputMaybe<TimetableReportContextTimetableBlockConnectionWhere>;
};

export type TimetableReportContextCreateInput = {
  SchoolYear?: InputMaybe<TimetableReportContextSchoolYearFieldInput>;
  TeachingBlock?: InputMaybe<TimetableReportContextTeachingBlockFieldInput>;
  TimetableBlock?: InputMaybe<TimetableReportContextTimetableBlockFieldInput>;
};

export type TimetableReportContextDeleteInput = {
  SchoolYear?: InputMaybe<TimetableReportContextSchoolYearDeleteFieldInput>;
  TeachingBlock?: InputMaybe<TimetableReportContextTeachingBlockDeleteFieldInput>;
  TimetableBlock?: InputMaybe<TimetableReportContextTimetableBlockDeleteFieldInput>;
};

export type TimetableReportContextDisconnectInput = {
  SchoolYear?: InputMaybe<TimetableReportContextSchoolYearDisconnectFieldInput>;
  TeachingBlock?: InputMaybe<TimetableReportContextTeachingBlockDisconnectFieldInput>;
  TimetableBlock?: InputMaybe<TimetableReportContextTimetableBlockDisconnectFieldInput>;
};

export type TimetableReportContextRelationship = {
  __typename?: 'TimetableReportContextRelationship';
  cursor: Scalars['String']['output'];
  node: PdfReportContext;
  properties: OrderedRelationProperties;
};

export type TimetableReportContextSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type TimetableReportContextSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<TimetableReportContextSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<TimetableReportContextSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<TimetableReportContextSchoolYearConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type TimetableReportContextSchoolYearCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: SchoolYearCreateInput;
};

export type TimetableReportContextSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<TimetableReportContextSchoolYearConnectionWhere>;
};

export type TimetableReportContextSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<TimetableReportContextSchoolYearConnectionWhere>;
};

export type TimetableReportContextSchoolYearFieldInput = {
  connect?: InputMaybe<TimetableReportContextSchoolYearConnectFieldInput>;
  create?: InputMaybe<TimetableReportContextSchoolYearCreateFieldInput>;
};

export type TimetableReportContextSchoolYearUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type TimetableReportContextSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<TimetableReportContextSchoolYearConnectFieldInput>;
  create?: InputMaybe<TimetableReportContextSchoolYearCreateFieldInput>;
  delete?: InputMaybe<TimetableReportContextSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableReportContextSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<TimetableReportContextSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<TimetableReportContextSchoolYearConnectionWhere>;
};

export type TimetableReportContextTeachingBlockConnectFieldInput = {
  connect?: InputMaybe<TeachingBlockConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TeachingBlockConnectWhere>;
};

export type TimetableReportContextTeachingBlockConnectOrCreateFieldInput = {
  onCreate: TimetableReportContextTeachingBlockConnectOrCreateFieldInputOnCreate;
  where: TeachingBlockConnectOrCreateWhere;
};

export type TimetableReportContextTeachingBlockConnectOrCreateFieldInputOnCreate = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingBlockOnCreateInput;
};

export type TimetableReportContextTeachingBlockConnectionWhere = {
  AND?: InputMaybe<Array<TimetableReportContextTeachingBlockConnectionWhere>>;
  NOT?: InputMaybe<TimetableReportContextTeachingBlockConnectionWhere>;
  OR?: InputMaybe<Array<TimetableReportContextTeachingBlockConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TeachingBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TeachingBlockWhere>;
};

export type TimetableReportContextTeachingBlockCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TeachingBlockCreateInput;
};

export type TimetableReportContextTeachingBlockDeleteFieldInput = {
  delete?: InputMaybe<TeachingBlockDeleteInput>;
  where?: InputMaybe<TimetableReportContextTeachingBlockConnectionWhere>;
};

export type TimetableReportContextTeachingBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<TeachingBlockDisconnectInput>;
  where?: InputMaybe<TimetableReportContextTeachingBlockConnectionWhere>;
};

export type TimetableReportContextTeachingBlockFieldInput = {
  connect?: InputMaybe<TimetableReportContextTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableReportContextTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableReportContextTeachingBlockCreateFieldInput>;
};

export type TimetableReportContextTeachingBlockUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TeachingBlockUpdateInput>;
};

export type TimetableReportContextTeachingBlockUpdateFieldInput = {
  connect?: InputMaybe<TimetableReportContextTeachingBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableReportContextTeachingBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableReportContextTeachingBlockCreateFieldInput>;
  delete?: InputMaybe<TimetableReportContextTeachingBlockDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableReportContextTeachingBlockDisconnectFieldInput>;
  update?: InputMaybe<TimetableReportContextTeachingBlockUpdateConnectionInput>;
  where?: InputMaybe<TimetableReportContextTeachingBlockConnectionWhere>;
};

export type TimetableReportContextTimetableBlockConnectFieldInput = {
  connect?: InputMaybe<TimetableBlockConnectInput>;
  edge: OrderedRelationPropertiesCreateInput;
  where?: InputMaybe<TimetableBlockConnectWhere>;
};

export type TimetableReportContextTimetableBlockConnectionWhere = {
  AND?: InputMaybe<Array<TimetableReportContextTimetableBlockConnectionWhere>>;
  NOT?: InputMaybe<TimetableReportContextTimetableBlockConnectionWhere>;
  OR?: InputMaybe<Array<TimetableReportContextTimetableBlockConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableBlockWhere>;
};

export type TimetableReportContextTimetableBlockCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TimetableBlockCreateInput;
};

export type TimetableReportContextTimetableBlockDeleteFieldInput = {
  delete?: InputMaybe<TimetableBlockDeleteInput>;
  where?: InputMaybe<TimetableReportContextTimetableBlockConnectionWhere>;
};

export type TimetableReportContextTimetableBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableBlockDisconnectInput>;
  where?: InputMaybe<TimetableReportContextTimetableBlockConnectionWhere>;
};

export type TimetableReportContextTimetableBlockFieldInput = {
  connect?: InputMaybe<TimetableReportContextTimetableBlockConnectFieldInput>;
  create?: InputMaybe<TimetableReportContextTimetableBlockCreateFieldInput>;
};

export type TimetableReportContextTimetableBlockUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TimetableBlockUpdateInput>;
};

export type TimetableReportContextTimetableBlockUpdateFieldInput = {
  connect?: InputMaybe<TimetableReportContextTimetableBlockConnectFieldInput>;
  create?: InputMaybe<TimetableReportContextTimetableBlockCreateFieldInput>;
  delete?: InputMaybe<TimetableReportContextTimetableBlockDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableReportContextTimetableBlockDisconnectFieldInput>;
  update?: InputMaybe<TimetableReportContextTimetableBlockUpdateConnectionInput>;
  where?: InputMaybe<TimetableReportContextTimetableBlockConnectionWhere>;
};

export type TimetableReportContextUpdateInput = {
  SchoolYear?: InputMaybe<TimetableReportContextSchoolYearUpdateFieldInput>;
  TeachingBlock?: InputMaybe<TimetableReportContextTeachingBlockUpdateFieldInput>;
  TimetableBlock?: InputMaybe<TimetableReportContextTimetableBlockUpdateFieldInput>;
};

export type TimetableReportCreateInput = {
  context?: InputMaybe<TimetableReportContextCreateInput>;
  fileEntries?: InputMaybe<TimetableReportFileEntriesFieldInput>;
  jobConfiguration: Scalars['String']['input'];
  jobFinished: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: TimetableReportType;
};

export type TimetableReportDeleteInput = {
  context?: InputMaybe<TimetableReportContextDeleteInput>;
  fileEntries?: InputMaybe<Array<TimetableReportFileEntriesDeleteFieldInput>>;
};

export type TimetableReportDisconnectInput = {
  context?: InputMaybe<TimetableReportContextDisconnectInput>;
  fileEntries?: InputMaybe<Array<TimetableReportFileEntriesDisconnectFieldInput>>;
};

export type TimetableReportEdge = {
  __typename?: 'TimetableReportEdge';
  cursor: Scalars['String']['output'];
  node: TimetableReport;
};

export type TimetableReportFileEntriesAggregateInput = {
  AND?: InputMaybe<Array<TimetableReportFileEntriesAggregateInput>>;
  NOT?: InputMaybe<TimetableReportFileEntriesAggregateInput>;
  OR?: InputMaybe<Array<TimetableReportFileEntriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
  node?: InputMaybe<TimetableReportFileEntriesNodeAggregationWhereInput>;
};

export type TimetableReportFileEntriesConnectFieldInput = {
  connect?: InputMaybe<Array<FileEntryConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileEntryConnectWhere>;
};

export type TimetableReportFileEntriesConnection = {
  __typename?: 'TimetableReportFileEntriesConnection';
  edges: Array<TimetableReportFileEntriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableReportFileEntriesConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
  node?: InputMaybe<FileEntrySort>;
};

export type TimetableReportFileEntriesConnectionWhere = {
  AND?: InputMaybe<Array<TimetableReportFileEntriesConnectionWhere>>;
  NOT?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
  OR?: InputMaybe<Array<TimetableReportFileEntriesConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<FileEntryWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<FileEntryWhere>;
};

export type TimetableReportFileEntriesCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: FileEntryCreateInput;
};

export type TimetableReportFileEntriesDeleteFieldInput = {
  delete?: InputMaybe<FileEntryDeleteInput>;
  where?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
};

export type TimetableReportFileEntriesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileEntryDisconnectInput>;
  where?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
};

export type TimetableReportFileEntriesFieldInput = {
  connect?: InputMaybe<Array<TimetableReportFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableReportFileEntriesCreateFieldInput>>;
};

export type TimetableReportFileEntriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableReportFileEntriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableReportFileEntriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableReportFileEntriesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filename_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filename_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filename_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filename_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mediaType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mediaType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mediaType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updated_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableReportFileEntriesRelationship = {
  __typename?: 'TimetableReportFileEntriesRelationship';
  cursor: Scalars['String']['output'];
  node: FileEntry;
  properties: OrderedRelationProperties;
};

export type TimetableReportFileEntriesUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<FileEntryUpdateInput>;
};

export type TimetableReportFileEntriesUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableReportFileEntriesConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableReportFileEntriesCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableReportFileEntriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableReportFileEntriesDisconnectFieldInput>>;
  update?: InputMaybe<TimetableReportFileEntriesUpdateConnectionInput>;
  where?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
};

export type TimetableReportFileEntryFileEntriesAggregationSelection = {
  __typename?: 'TimetableReportFileEntryFileEntriesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TimetableReportFileEntryFileEntriesEdgeAggregateSelection>;
  node?: Maybe<TimetableReportFileEntryFileEntriesNodeAggregateSelection>;
};

export type TimetableReportFileEntryFileEntriesEdgeAggregateSelection = {
  __typename?: 'TimetableReportFileEntryFileEntriesEdgeAggregateSelection';
  order: IntAggregateSelection;
};

export type TimetableReportFileEntryFileEntriesNodeAggregateSelection = {
  __typename?: 'TimetableReportFileEntryFileEntriesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  filename: StringAggregateSelection;
  mediaType: StringAggregateSelection;
  size: IntAggregateSelection;
  updated: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimetableReportSort objects to sort TimetableReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimetableReportSort>>;
};

/** Fields to sort TimetableReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimetableReportSort object. */
export type TimetableReportSort = {
  jobConfiguration?: InputMaybe<SortDirection>;
  jobCreated?: InputMaybe<SortDirection>;
  jobFinished?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export enum TimetableReportType {
  AllClasses = 'allClasses',
  AllRooms = 'allRooms',
  AllSubjects = 'allSubjects',
  AllTeachers = 'allTeachers',
  AttendanceSchedule = 'attendanceSchedule',
  DoorSigns = 'doorSigns',
  SchoolTrips = 'schoolTrips',
  SingleClass = 'singleClass',
  SingleRoom = 'singleRoom',
  SingleSubject = 'singleSubject',
  SingleTeacher = 'singleTeacher',
  TeachingBlocksClass = 'teachingBlocksClass',
  TeachingBlocksRoom = 'teachingBlocksRoom',
  TeachingBlocksSubject = 'teachingBlocksSubject',
  TeachingBlocksTeacher = 'teachingBlocksTeacher',
}

export type TimetableReportUpdateInput = {
  context?: InputMaybe<TimetableReportContextUpdateInput>;
  fileEntries?: InputMaybe<Array<TimetableReportFileEntriesUpdateFieldInput>>;
  jobConfiguration?: InputMaybe<Scalars['String']['input']>;
  jobCreated?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TimetableReportType>;
};

export type TimetableReportWhere = {
  AND?: InputMaybe<Array<TimetableReportWhere>>;
  NOT?: InputMaybe<TimetableReportWhere>;
  OR?: InputMaybe<Array<TimetableReportWhere>>;
  context?: InputMaybe<PdfReportContextWhere>;
  contextConnection?: InputMaybe<TimetableReportContextConnectionWhere>;
  contextConnection_NOT?: InputMaybe<TimetableReportContextConnectionWhere>;
  context_NOT?: InputMaybe<PdfReportContextWhere>;
  /** @deprecated Use `fileEntries_SOME` instead. */
  fileEntries?: InputMaybe<FileEntryWhere>;
  fileEntriesAggregate?: InputMaybe<TimetableReportFileEntriesAggregateInput>;
  /** @deprecated Use `fileEntriesConnection_SOME` instead. */
  fileEntriesConnection?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
  /** Return TimetableReports where all of the related TimetableReportFileEntriesConnections match this filter */
  fileEntriesConnection_ALL?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
  /** Return TimetableReports where none of the related TimetableReportFileEntriesConnections match this filter */
  fileEntriesConnection_NONE?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
  /** @deprecated Use `fileEntriesConnection_NONE` instead. */
  fileEntriesConnection_NOT?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
  /** Return TimetableReports where one of the related TimetableReportFileEntriesConnections match this filter */
  fileEntriesConnection_SINGLE?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
  /** Return TimetableReports where some of the related TimetableReportFileEntriesConnections match this filter */
  fileEntriesConnection_SOME?: InputMaybe<TimetableReportFileEntriesConnectionWhere>;
  /** Return TimetableReports where all of the related FileEntries match this filter */
  fileEntries_ALL?: InputMaybe<FileEntryWhere>;
  /** Return TimetableReports where none of the related FileEntries match this filter */
  fileEntries_NONE?: InputMaybe<FileEntryWhere>;
  /** @deprecated Use `fileEntries_NONE` instead. */
  fileEntries_NOT?: InputMaybe<FileEntryWhere>;
  /** Return TimetableReports where one of the related FileEntries match this filter */
  fileEntries_SINGLE?: InputMaybe<FileEntryWhere>;
  /** Return TimetableReports where some of the related FileEntries match this filter */
  fileEntries_SOME?: InputMaybe<FileEntryWhere>;
  jobConfiguration?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobConfiguration_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobConfiguration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  jobCreated?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_GT?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobCreated_LT?: InputMaybe<Scalars['DateTime']['input']>;
  jobCreated_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobCreated_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobCreated_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobFinished?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_GT?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  jobFinished_LT?: InputMaybe<Scalars['DateTime']['input']>;
  jobFinished_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobFinished_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  jobFinished_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  title_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TimetableReportType>;
  type_IN?: InputMaybe<Array<TimetableReportType>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT?: InputMaybe<TimetableReportType>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  type_NOT_IN?: InputMaybe<Array<TimetableReportType>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type TimetableReportsConnection = {
  __typename?: 'TimetableReportsConnection';
  edges: Array<TimetableReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<TimetableSchoolYearAggregateInput>>;
  NOT?: InputMaybe<TimetableSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<TimetableSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableSchoolYearNodeAggregationWhereInput>;
};

export type TimetableSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type TimetableSchoolYearConnection = {
  __typename?: 'TimetableSchoolYearConnection';
  edges: Array<TimetableSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type TimetableSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<TimetableSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<TimetableSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<TimetableSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type TimetableSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type TimetableSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<TimetableSchoolYearConnectionWhere>;
};

export type TimetableSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<TimetableSchoolYearConnectionWhere>;
};

export type TimetableSchoolYearFieldInput = {
  connect?: InputMaybe<TimetableSchoolYearConnectFieldInput>;
  create?: InputMaybe<TimetableSchoolYearCreateFieldInput>;
};

export type TimetableSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableSchoolYearRelationship = {
  __typename?: 'TimetableSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type TimetableSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type TimetableSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<TimetableSchoolYearConnectFieldInput>;
  create?: InputMaybe<TimetableSchoolYearCreateFieldInput>;
  delete?: InputMaybe<TimetableSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<TimetableSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<TimetableSchoolYearConnectionWhere>;
};

/** Fields to sort Timetables by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimetableSort object. */
export type TimetableSort = {
  activeVersion?: InputMaybe<SortDirection>;
  comment?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  draft?: InputMaybe<SortDirection>;
  foreignId?: InputMaybe<SortDirection>;
  friEnabled?: InputMaybe<SortDirection>;
  monEnabled?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  satEnabled?: InputMaybe<SortDirection>;
  sunEnabled?: InputMaybe<SortDirection>;
  thuEnabled?: InputMaybe<SortDirection>;
  tueEnabled?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  wedEnabled?: InputMaybe<SortDirection>;
};

export type TimetableTimeGridConfig = {
  __typename?: 'TimetableTimeGridConfig';
  classes: Array<Class>;
  classesConnection: TimetableTimeGridConfigClassesConnection;
  timegrid?: Maybe<TimeGrid>;
  timegridConnection: TimetableTimeGridConfigTimegridConnection;
};

export type TimetableTimeGridConfigClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type TimetableTimeGridConfigClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectionSort>>;
  where?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
};

export type TimetableTimeGridConfigTimegridArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimeGridOptions>;
  where?: InputMaybe<TimeGridWhere>;
};

export type TimetableTimeGridConfigTimegridConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableTimeGridConfigTimegridConnectionSort>>;
  where?: InputMaybe<TimetableTimeGridConfigTimegridConnectionWhere>;
};

export type TimetableTimeGridConfigAggregateSelection = {
  __typename?: 'TimetableTimeGridConfigAggregateSelection';
  count: Scalars['Int']['output'];
};

export type TimetableTimeGridConfigClassesAggregateInput = {
  AND?: InputMaybe<Array<TimetableTimeGridConfigClassesAggregateInput>>;
  NOT?: InputMaybe<TimetableTimeGridConfigClassesAggregateInput>;
  OR?: InputMaybe<Array<TimetableTimeGridConfigClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableTimeGridConfigClassesNodeAggregationWhereInput>;
};

export type TimetableTimeGridConfigClassesConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type TimetableTimeGridConfigClassesConnectOrCreateFieldInput = {
  onCreate: TimetableTimeGridConfigClassesConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type TimetableTimeGridConfigClassesConnectOrCreateFieldInputOnCreate = {
  node: ClassOnCreateInput;
};

export type TimetableTimeGridConfigClassesConnection = {
  __typename?: 'TimetableTimeGridConfigClassesConnection';
  edges: Array<TimetableTimeGridConfigClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableTimeGridConfigClassesConnectionSort = {
  node?: InputMaybe<ClassSort>;
};

export type TimetableTimeGridConfigClassesConnectionWhere = {
  AND?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectionWhere>>;
  NOT?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
  OR?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectionWhere>>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type TimetableTimeGridConfigClassesCreateFieldInput = {
  node: ClassCreateInput;
};

export type TimetableTimeGridConfigClassesDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
};

export type TimetableTimeGridConfigClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
};

export type TimetableTimeGridConfigClassesFieldInput = {
  connect?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableTimeGridConfigClassesCreateFieldInput>>;
};

export type TimetableTimeGridConfigClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableTimeGridConfigClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableTimeGridConfigClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableTimeGridConfigClassesNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableTimeGridConfigClassesRelationship = {
  __typename?: 'TimetableTimeGridConfigClassesRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
};

export type TimetableTimeGridConfigClassesUpdateConnectionInput = {
  node?: InputMaybe<ClassUpdateInput>;
};

export type TimetableTimeGridConfigClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableTimeGridConfigClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableTimeGridConfigClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableTimeGridConfigClassesDisconnectFieldInput>>;
  update?: InputMaybe<TimetableTimeGridConfigClassesUpdateConnectionInput>;
  where?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
};

export type TimetableTimeGridConfigConnectInput = {
  classes?: InputMaybe<Array<TimetableTimeGridConfigClassesConnectFieldInput>>;
  timegrid?: InputMaybe<TimetableTimeGridConfigTimegridConnectFieldInput>;
};

export type TimetableTimeGridConfigConnectWhere = {
  node: TimetableTimeGridConfigWhere;
};

export type TimetableTimeGridConfigCreateInput = {
  classes?: InputMaybe<TimetableTimeGridConfigClassesFieldInput>;
  timegrid?: InputMaybe<TimetableTimeGridConfigTimegridFieldInput>;
};

export type TimetableTimeGridConfigDeleteInput = {
  classes?: InputMaybe<Array<TimetableTimeGridConfigClassesDeleteFieldInput>>;
  timegrid?: InputMaybe<TimetableTimeGridConfigTimegridDeleteFieldInput>;
};

export type TimetableTimeGridConfigDisconnectInput = {
  classes?: InputMaybe<Array<TimetableTimeGridConfigClassesDisconnectFieldInput>>;
  timegrid?: InputMaybe<TimetableTimeGridConfigTimegridDisconnectFieldInput>;
};

export type TimetableTimeGridConfigEdge = {
  __typename?: 'TimetableTimeGridConfigEdge';
  cursor: Scalars['String']['output'];
  node: TimetableTimeGridConfig;
};

export type TimetableTimeGridConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableTimeGridConfigTimegridAggregateInput = {
  AND?: InputMaybe<Array<TimetableTimeGridConfigTimegridAggregateInput>>;
  NOT?: InputMaybe<TimetableTimeGridConfigTimegridAggregateInput>;
  OR?: InputMaybe<Array<TimetableTimeGridConfigTimegridAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableTimeGridConfigTimegridNodeAggregationWhereInput>;
};

export type TimetableTimeGridConfigTimegridConnectFieldInput = {
  connect?: InputMaybe<TimeGridConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimeGridConnectWhere>;
};

export type TimetableTimeGridConfigTimegridConnectOrCreateFieldInput = {
  onCreate: TimetableTimeGridConfigTimegridConnectOrCreateFieldInputOnCreate;
  where: TimeGridConnectOrCreateWhere;
};

export type TimetableTimeGridConfigTimegridConnectOrCreateFieldInputOnCreate = {
  node: TimeGridOnCreateInput;
};

export type TimetableTimeGridConfigTimegridConnection = {
  __typename?: 'TimetableTimeGridConfigTimegridConnection';
  edges: Array<TimetableTimeGridConfigTimegridRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableTimeGridConfigTimegridConnectionSort = {
  node?: InputMaybe<TimeGridSort>;
};

export type TimetableTimeGridConfigTimegridConnectionWhere = {
  AND?: InputMaybe<Array<TimetableTimeGridConfigTimegridConnectionWhere>>;
  NOT?: InputMaybe<TimetableTimeGridConfigTimegridConnectionWhere>;
  OR?: InputMaybe<Array<TimetableTimeGridConfigTimegridConnectionWhere>>;
  node?: InputMaybe<TimeGridWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimeGridWhere>;
};

export type TimetableTimeGridConfigTimegridCreateFieldInput = {
  node: TimeGridCreateInput;
};

export type TimetableTimeGridConfigTimegridDeleteFieldInput = {
  delete?: InputMaybe<TimeGridDeleteInput>;
  where?: InputMaybe<TimetableTimeGridConfigTimegridConnectionWhere>;
};

export type TimetableTimeGridConfigTimegridDisconnectFieldInput = {
  disconnect?: InputMaybe<TimeGridDisconnectInput>;
  where?: InputMaybe<TimetableTimeGridConfigTimegridConnectionWhere>;
};

export type TimetableTimeGridConfigTimegridFieldInput = {
  connect?: InputMaybe<TimetableTimeGridConfigTimegridConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableTimeGridConfigTimegridConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableTimeGridConfigTimegridCreateFieldInput>;
};

export type TimetableTimeGridConfigTimegridNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableTimeGridConfigTimegridNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableTimeGridConfigTimegridNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableTimeGridConfigTimegridNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableTimeGridConfigTimegridRelationship = {
  __typename?: 'TimetableTimeGridConfigTimegridRelationship';
  cursor: Scalars['String']['output'];
  node: TimeGrid;
};

export type TimetableTimeGridConfigTimegridUpdateConnectionInput = {
  node?: InputMaybe<TimeGridUpdateInput>;
};

export type TimetableTimeGridConfigTimegridUpdateFieldInput = {
  connect?: InputMaybe<TimetableTimeGridConfigTimegridConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableTimeGridConfigTimegridConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableTimeGridConfigTimegridCreateFieldInput>;
  delete?: InputMaybe<TimetableTimeGridConfigTimegridDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableTimeGridConfigTimegridDisconnectFieldInput>;
  update?: InputMaybe<TimetableTimeGridConfigTimegridUpdateConnectionInput>;
  where?: InputMaybe<TimetableTimeGridConfigTimegridConnectionWhere>;
};

export type TimetableTimeGridConfigUpdateInput = {
  classes?: InputMaybe<Array<TimetableTimeGridConfigClassesUpdateFieldInput>>;
  timegrid?: InputMaybe<TimetableTimeGridConfigTimegridUpdateFieldInput>;
};

export type TimetableTimeGridConfigWhere = {
  AND?: InputMaybe<Array<TimetableTimeGridConfigWhere>>;
  NOT?: InputMaybe<TimetableTimeGridConfigWhere>;
  OR?: InputMaybe<Array<TimetableTimeGridConfigWhere>>;
  /** @deprecated Use `classes_SOME` instead. */
  classes?: InputMaybe<ClassWhere>;
  classesAggregate?: InputMaybe<TimetableTimeGridConfigClassesAggregateInput>;
  /** @deprecated Use `classesConnection_SOME` instead. */
  classesConnection?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
  /** Return TimetableTimeGridConfigs where all of the related TimetableTimeGridConfigClassesConnections match this filter */
  classesConnection_ALL?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
  /** Return TimetableTimeGridConfigs where none of the related TimetableTimeGridConfigClassesConnections match this filter */
  classesConnection_NONE?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
  /** @deprecated Use `classesConnection_NONE` instead. */
  classesConnection_NOT?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
  /** Return TimetableTimeGridConfigs where one of the related TimetableTimeGridConfigClassesConnections match this filter */
  classesConnection_SINGLE?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
  /** Return TimetableTimeGridConfigs where some of the related TimetableTimeGridConfigClassesConnections match this filter */
  classesConnection_SOME?: InputMaybe<TimetableTimeGridConfigClassesConnectionWhere>;
  /** Return TimetableTimeGridConfigs where all of the related Classes match this filter */
  classes_ALL?: InputMaybe<ClassWhere>;
  /** Return TimetableTimeGridConfigs where none of the related Classes match this filter */
  classes_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `classes_NONE` instead. */
  classes_NOT?: InputMaybe<ClassWhere>;
  /** Return TimetableTimeGridConfigs where one of the related Classes match this filter */
  classes_SINGLE?: InputMaybe<ClassWhere>;
  /** Return TimetableTimeGridConfigs where some of the related Classes match this filter */
  classes_SOME?: InputMaybe<ClassWhere>;
  timegrid?: InputMaybe<TimeGridWhere>;
  timegridAggregate?: InputMaybe<TimetableTimeGridConfigTimegridAggregateInput>;
  timegridConnection?: InputMaybe<TimetableTimeGridConfigTimegridConnectionWhere>;
  timegridConnection_NOT?: InputMaybe<TimetableTimeGridConfigTimegridConnectionWhere>;
  timegrid_NOT?: InputMaybe<TimeGridWhere>;
};

export type TimetableTimeGridConfigsConnection = {
  __typename?: 'TimetableTimeGridConfigsConnection';
  edges: Array<TimetableTimeGridConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableTimegridConfigsAggregateInput = {
  AND?: InputMaybe<Array<TimetableTimegridConfigsAggregateInput>>;
  NOT?: InputMaybe<TimetableTimegridConfigsAggregateInput>;
  OR?: InputMaybe<Array<TimetableTimegridConfigsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrderedRelationPropertiesAggregationWhereInput>;
};

export type TimetableTimegridConfigsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableTimeGridConfigConnectInput>>;
  edge: OrderedRelationPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableTimeGridConfigConnectWhere>;
};

export type TimetableTimegridConfigsConnection = {
  __typename?: 'TimetableTimegridConfigsConnection';
  edges: Array<TimetableTimegridConfigsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableTimegridConfigsConnectionSort = {
  edge?: InputMaybe<OrderedRelationPropertiesSort>;
};

export type TimetableTimegridConfigsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableTimegridConfigsConnectionWhere>>;
  NOT?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableTimegridConfigsConnectionWhere>>;
  edge?: InputMaybe<OrderedRelationPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<OrderedRelationPropertiesWhere>;
  node?: InputMaybe<TimetableTimeGridConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableTimeGridConfigWhere>;
};

export type TimetableTimegridConfigsCreateFieldInput = {
  edge: OrderedRelationPropertiesCreateInput;
  node: TimetableTimeGridConfigCreateInput;
};

export type TimetableTimegridConfigsDeleteFieldInput = {
  delete?: InputMaybe<TimetableTimeGridConfigDeleteInput>;
  where?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
};

export type TimetableTimegridConfigsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableTimeGridConfigDisconnectInput>;
  where?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
};

export type TimetableTimegridConfigsFieldInput = {
  connect?: InputMaybe<Array<TimetableTimegridConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableTimegridConfigsCreateFieldInput>>;
};

export type TimetableTimegridConfigsRelationship = {
  __typename?: 'TimetableTimegridConfigsRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableTimeGridConfig;
  properties: OrderedRelationProperties;
};

export type TimetableTimegridConfigsUpdateConnectionInput = {
  edge?: InputMaybe<OrderedRelationPropertiesUpdateInput>;
  node?: InputMaybe<TimetableTimeGridConfigUpdateInput>;
};

export type TimetableTimegridConfigsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableTimegridConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableTimegridConfigsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableTimegridConfigsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableTimegridConfigsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableTimegridConfigsUpdateConnectionInput>;
  where?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
};

export type TimetableTimetableBlockTimetableBlocksAggregationSelection = {
  __typename?: 'TimetableTimetableBlockTimetableBlocksAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TimetableTimetableBlockTimetableBlocksNodeAggregateSelection>;
};

export type TimetableTimetableBlockTimetableBlocksNodeAggregateSelection = {
  __typename?: 'TimetableTimetableBlockTimetableBlocksNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  teachingLoadCalculated: FloatAggregateSelection;
  teachingLoadComment: StringAggregateSelection;
  teachingLoadFactor: FloatAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableTimetableBlocksAggregateInput = {
  AND?: InputMaybe<Array<TimetableTimetableBlocksAggregateInput>>;
  NOT?: InputMaybe<TimetableTimetableBlocksAggregateInput>;
  OR?: InputMaybe<Array<TimetableTimetableBlocksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableTimetableBlocksNodeAggregationWhereInput>;
};

export type TimetableTimetableBlocksConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableBlockConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableBlockConnectWhere>;
};

export type TimetableTimetableBlocksConnection = {
  __typename?: 'TimetableTimetableBlocksConnection';
  edges: Array<TimetableTimetableBlocksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableTimetableBlocksConnectionSort = {
  node?: InputMaybe<TimetableBlockSort>;
};

export type TimetableTimetableBlocksConnectionWhere = {
  AND?: InputMaybe<Array<TimetableTimetableBlocksConnectionWhere>>;
  NOT?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
  OR?: InputMaybe<Array<TimetableTimetableBlocksConnectionWhere>>;
  node?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableBlockWhere>;
};

export type TimetableTimetableBlocksCreateFieldInput = {
  node: TimetableBlockCreateInput;
};

export type TimetableTimetableBlocksDeleteFieldInput = {
  delete?: InputMaybe<TimetableBlockDeleteInput>;
  where?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
};

export type TimetableTimetableBlocksDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableBlockDisconnectInput>;
  where?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
};

export type TimetableTimetableBlocksFieldInput = {
  connect?: InputMaybe<Array<TimetableTimetableBlocksConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableTimetableBlocksCreateFieldInput>>;
};

export type TimetableTimetableBlocksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableTimetableBlocksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableTimetableBlocksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableTimetableBlocksNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  teachingLoadCalculated_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadCalculated_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingLoadFactor_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingLoadFactor_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableTimetableBlocksRelationship = {
  __typename?: 'TimetableTimetableBlocksRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableBlock;
};

export type TimetableTimetableBlocksUpdateConnectionInput = {
  node?: InputMaybe<TimetableBlockUpdateInput>;
};

export type TimetableTimetableBlocksUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableTimetableBlocksConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableTimetableBlocksCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableTimetableBlocksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableTimetableBlocksDisconnectFieldInput>>;
  update?: InputMaybe<TimetableTimetableBlocksUpdateConnectionInput>;
  where?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
};

export type TimetableTimetableVersionVersionsAggregationSelection = {
  __typename?: 'TimetableTimetableVersionVersionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TimetableTimetableVersionVersionsNodeAggregateSelection>;
};

export type TimetableTimetableVersionVersionsNodeAggregateSelection = {
  __typename?: 'TimetableTimetableVersionVersionsNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
  version: IntAggregateSelection;
};

export type TimetableUniqueWhere = {
  foreignId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TimetableUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  friEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  monEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<TimetableOrganizationUpdateFieldInput>;
  satEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYear?: InputMaybe<TimetableSchoolYearUpdateFieldInput>;
  sunEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  thuEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timegridConfigs?: InputMaybe<Array<TimetableTimegridConfigsUpdateFieldInput>>;
  timetableBlocks?: InputMaybe<Array<TimetableTimetableBlocksUpdateFieldInput>>;
  tueEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  versions?: InputMaybe<Array<TimetableVersionsUpdateFieldInput>>;
  wedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimetableVersion = {
  __typename?: 'TimetableVersion';
  active?: Maybe<Scalars['Boolean']['output']>;
  cards: Array<TimetableCard>;
  cardsAggregate?: Maybe<TimetableVersionTimetableCardCardsAggregationSelection>;
  cardsConnection: TimetableVersionCardsConnection;
  children: Array<TimetableVersion>;
  childrenConnection: TimetableVersionChildrenConnection;
  classes: Array<Class>;
  classesConnection: TimetableVersionClassesConnection;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dependencies: Array<Dependency>;
  dependenciesConnection: TimetableVersionDependenciesConnection;
  description?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  generating?: Maybe<Scalars['Boolean']['output']>;
  isSnapshot?: Maybe<Scalars['Boolean']['output']>;
  lessons: Array<Lesson>;
  lessonsAggregate?: Maybe<TimetableVersionLessonLessonsAggregationSelection>;
  lessonsConnection: TimetableVersionLessonsConnection;
  locked?: Maybe<Locked>;
  lockedAggregate?: Maybe<TimetableVersionLockedLockedAggregationSelection>;
  lockedConnection: TimetableVersionLockedConnection;
  original?: Maybe<TimetableVersion>;
  originalConnection: TimetableVersionOriginalConnection;
  parent?: Maybe<TimetableVersion>;
  parentConnection: TimetableVersionParentConnection;
  placedCardsCount?: Maybe<Scalars['Int']['output']>;
  rooms: Array<Room>;
  roomsConnection: TimetableVersionRoomsConnection;
  snapshots: Array<TimetableVersion>;
  snapshotsConnection: TimetableVersionSnapshotsConnection;
  subjects: Array<Subject>;
  subjectsConnection: TimetableVersionSubjectsConnection;
  teachers: Array<Person>;
  teachersConnection: TimetableVersionTeachersConnection;
  timetable: Timetable;
  timetableConnection: TimetableVersionTimetableConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type TimetableVersionCardsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableCardOptions>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type TimetableVersionCardsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TimetableCardWhere>;
};

export type TimetableVersionCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionCardsConnectionSort>>;
  where?: InputMaybe<TimetableVersionCardsConnectionWhere>;
};

export type TimetableVersionChildrenArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionChildrenConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionChildrenConnectionSort>>;
  where?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
};

export type TimetableVersionClassesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ClassOptions>;
  where?: InputMaybe<ClassWhere>;
};

export type TimetableVersionClassesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionClassesConnectionSort>>;
  where?: InputMaybe<TimetableVersionClassesConnectionWhere>;
};

export type TimetableVersionDependenciesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DependencyOptions>;
  where?: InputMaybe<DependencyWhere>;
};

export type TimetableVersionDependenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionDependenciesConnectionSort>>;
  where?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
};

export type TimetableVersionLessonsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LessonOptions>;
  where?: InputMaybe<LessonWhere>;
};

export type TimetableVersionLessonsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LessonWhere>;
};

export type TimetableVersionLessonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionLessonsConnectionSort>>;
  where?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
};

export type TimetableVersionLockedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LockedOptions>;
  where?: InputMaybe<LockedWhere>;
};

export type TimetableVersionLockedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LockedWhere>;
};

export type TimetableVersionLockedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionLockedConnectionSort>>;
  where?: InputMaybe<TimetableVersionLockedConnectionWhere>;
};

export type TimetableVersionOriginalArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionOriginalConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionOriginalConnectionSort>>;
  where?: InputMaybe<TimetableVersionOriginalConnectionWhere>;
};

export type TimetableVersionParentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionParentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionParentConnectionSort>>;
  where?: InputMaybe<TimetableVersionParentConnectionWhere>;
};

export type TimetableVersionRoomsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoomOptions>;
  where?: InputMaybe<RoomWhere>;
};

export type TimetableVersionRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionRoomsConnectionSort>>;
  where?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
};

export type TimetableVersionSnapshotsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableVersionOptions>;
  where?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionSnapshotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionSnapshotsConnectionSort>>;
  where?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
};

export type TimetableVersionSubjectsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubjectOptions>;
  where?: InputMaybe<SubjectWhere>;
};

export type TimetableVersionSubjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionSubjectsConnectionSort>>;
  where?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
};

export type TimetableVersionTeachersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PersonOptions>;
  where?: InputMaybe<PersonWhere>;
};

export type TimetableVersionTeachersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionTeachersConnectionSort>>;
  where?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
};

export type TimetableVersionTimetableArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TimetableOptions>;
  where?: InputMaybe<TimetableWhere>;
};

export type TimetableVersionTimetableConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TimetableVersionTimetableConnectionSort>>;
  where?: InputMaybe<TimetableVersionTimetableConnectionWhere>;
};

export type TimetableVersionAggregateSelection = {
  __typename?: 'TimetableVersionAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
  version: IntAggregateSelection;
};

export type TimetableVersionCardsAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionCardsAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionCardsAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionCardsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionCardsNodeAggregationWhereInput>;
};

export type TimetableVersionCardsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableCardConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableCardConnectWhere>;
};

export type TimetableVersionCardsConnectOrCreateFieldInput = {
  onCreate: TimetableVersionCardsConnectOrCreateFieldInputOnCreate;
  where: TimetableCardConnectOrCreateWhere;
};

export type TimetableVersionCardsConnectOrCreateFieldInputOnCreate = {
  node: TimetableCardOnCreateInput;
};

export type TimetableVersionCardsConnection = {
  __typename?: 'TimetableVersionCardsConnection';
  edges: Array<TimetableVersionCardsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionCardsConnectionSort = {
  node?: InputMaybe<TimetableCardSort>;
};

export type TimetableVersionCardsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionCardsConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionCardsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionCardsConnectionWhere>>;
  node?: InputMaybe<TimetableCardWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableCardWhere>;
};

export type TimetableVersionCardsCreateFieldInput = {
  node: TimetableCardCreateInput;
};

export type TimetableVersionCardsDeleteFieldInput = {
  delete?: InputMaybe<TimetableCardDeleteInput>;
  where?: InputMaybe<TimetableVersionCardsConnectionWhere>;
};

export type TimetableVersionCardsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableCardDisconnectInput>;
  where?: InputMaybe<TimetableVersionCardsConnectionWhere>;
};

export type TimetableVersionCardsFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionCardsCreateFieldInput>>;
};

export type TimetableVersionCardsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionCardsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionCardsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionCardsNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  weekday_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  weekday_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  weekday_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  weekday_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionCardsRelationship = {
  __typename?: 'TimetableVersionCardsRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableCard;
};

export type TimetableVersionCardsUpdateConnectionInput = {
  node?: InputMaybe<TimetableCardUpdateInput>;
};

export type TimetableVersionCardsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionCardsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionCardsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionCardsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionCardsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionCardsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionCardsUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionCardsConnectionWhere>;
};

export type TimetableVersionChildrenAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionChildrenAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionChildrenAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionChildrenAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ParentVersionPropertiesAggregationWhereInput>;
  node?: InputMaybe<TimetableVersionChildrenNodeAggregationWhereInput>;
};

export type TimetableVersionChildrenConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionConnectInput>>;
  edge?: InputMaybe<ParentVersionPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type TimetableVersionChildrenConnection = {
  __typename?: 'TimetableVersionChildrenConnection';
  edges: Array<TimetableVersionChildrenRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionChildrenConnectionSort = {
  edge?: InputMaybe<ParentVersionPropertiesSort>;
  node?: InputMaybe<TimetableVersionSort>;
};

export type TimetableVersionChildrenConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionChildrenConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionChildrenConnectionWhere>>;
  edge?: InputMaybe<ParentVersionPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ParentVersionPropertiesWhere>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionChildrenCreateFieldInput = {
  edge?: InputMaybe<ParentVersionPropertiesCreateInput>;
  node: TimetableVersionCreateInput;
};

export type TimetableVersionChildrenDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
};

export type TimetableVersionChildrenDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
};

export type TimetableVersionChildrenFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionChildrenConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionChildrenCreateFieldInput>>;
};

export type TimetableVersionChildrenNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionChildrenNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionChildrenNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionChildrenNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionChildrenRelationship = {
  __typename?: 'TimetableVersionChildrenRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
  properties: ParentVersionProperties;
};

export type TimetableVersionChildrenUpdateConnectionInput = {
  edge?: InputMaybe<ParentVersionPropertiesUpdateInput>;
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type TimetableVersionChildrenUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionChildrenConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionChildrenCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionChildrenDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionChildrenDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionChildrenUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
};

export type TimetableVersionClassesAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionClassesAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionClassesAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionClassesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TimetableRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TimetableVersionClassesNodeAggregationWhereInput>;
};

export type TimetableVersionClassesConnectFieldInput = {
  connect?: InputMaybe<Array<ClassConnectInput>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ClassConnectWhere>;
};

export type TimetableVersionClassesConnectOrCreateFieldInput = {
  onCreate: TimetableVersionClassesConnectOrCreateFieldInputOnCreate;
  where: ClassConnectOrCreateWhere;
};

export type TimetableVersionClassesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: ClassOnCreateInput;
};

export type TimetableVersionClassesConnection = {
  __typename?: 'TimetableVersionClassesConnection';
  edges: Array<TimetableVersionClassesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionClassesConnectionSort = {
  edge?: InputMaybe<TimetableRelationshipPropertiesSort>;
  node?: InputMaybe<ClassSort>;
};

export type TimetableVersionClassesConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionClassesConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionClassesConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionClassesConnectionWhere>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  node?: InputMaybe<ClassWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<ClassWhere>;
};

export type TimetableVersionClassesCreateFieldInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: ClassCreateInput;
};

export type TimetableVersionClassesDeleteFieldInput = {
  delete?: InputMaybe<ClassDeleteInput>;
  where?: InputMaybe<TimetableVersionClassesConnectionWhere>;
};

export type TimetableVersionClassesDisconnectFieldInput = {
  disconnect?: InputMaybe<ClassDisconnectInput>;
  where?: InputMaybe<TimetableVersionClassesConnectionWhere>;
};

export type TimetableVersionClassesFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionClassesCreateFieldInput>>;
};

export type TimetableVersionClassesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionClassesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionClassesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionClassesNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableVersionClassesRelationship = {
  __typename?: 'TimetableVersionClassesRelationship';
  cursor: Scalars['String']['output'];
  node: Class;
  properties: TimetableRelationshipProperties;
};

export type TimetableVersionClassesUpdateConnectionInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<ClassUpdateInput>;
};

export type TimetableVersionClassesUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionClassesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionClassesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionClassesCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionClassesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionClassesDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionClassesUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionClassesConnectionWhere>;
};

export type TimetableVersionConnectInput = {
  cards?: InputMaybe<Array<TimetableVersionCardsConnectFieldInput>>;
  children?: InputMaybe<Array<TimetableVersionChildrenConnectFieldInput>>;
  classes?: InputMaybe<Array<TimetableVersionClassesConnectFieldInput>>;
  dependencies?: InputMaybe<Array<TimetableVersionDependenciesConnectFieldInput>>;
  lessons?: InputMaybe<Array<TimetableVersionLessonsConnectFieldInput>>;
  locked?: InputMaybe<TimetableVersionLockedConnectFieldInput>;
  original?: InputMaybe<TimetableVersionOriginalConnectFieldInput>;
  parent?: InputMaybe<TimetableVersionParentConnectFieldInput>;
  rooms?: InputMaybe<Array<TimetableVersionRoomsConnectFieldInput>>;
  snapshots?: InputMaybe<Array<TimetableVersionSnapshotsConnectFieldInput>>;
  subjects?: InputMaybe<Array<TimetableVersionSubjectsConnectFieldInput>>;
  teachers?: InputMaybe<Array<TimetableVersionTeachersConnectFieldInput>>;
  timetable?: InputMaybe<TimetableVersionTimetableConnectFieldInput>;
};

export type TimetableVersionConnectWhere = {
  node: TimetableVersionWhere;
};

export type TimetableVersionCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<TimetableVersionCardsFieldInput>;
  children?: InputMaybe<TimetableVersionChildrenFieldInput>;
  classes?: InputMaybe<TimetableVersionClassesFieldInput>;
  dependencies?: InputMaybe<TimetableVersionDependenciesFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  generating?: InputMaybe<Scalars['Boolean']['input']>;
  lessons?: InputMaybe<TimetableVersionLessonsFieldInput>;
  locked?: InputMaybe<TimetableVersionLockedFieldInput>;
  original?: InputMaybe<TimetableVersionOriginalFieldInput>;
  parent?: InputMaybe<TimetableVersionParentFieldInput>;
  rooms?: InputMaybe<TimetableVersionRoomsFieldInput>;
  snapshots?: InputMaybe<TimetableVersionSnapshotsFieldInput>;
  subjects?: InputMaybe<TimetableVersionSubjectsFieldInput>;
  teachers?: InputMaybe<TimetableVersionTeachersFieldInput>;
  timetable?: InputMaybe<TimetableVersionTimetableFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version: Scalars['Int']['input'];
};

export type TimetableVersionDeleteInput = {
  cards?: InputMaybe<Array<TimetableVersionCardsDeleteFieldInput>>;
  children?: InputMaybe<Array<TimetableVersionChildrenDeleteFieldInput>>;
  classes?: InputMaybe<Array<TimetableVersionClassesDeleteFieldInput>>;
  dependencies?: InputMaybe<Array<TimetableVersionDependenciesDeleteFieldInput>>;
  lessons?: InputMaybe<Array<TimetableVersionLessonsDeleteFieldInput>>;
  locked?: InputMaybe<TimetableVersionLockedDeleteFieldInput>;
  original?: InputMaybe<TimetableVersionOriginalDeleteFieldInput>;
  parent?: InputMaybe<TimetableVersionParentDeleteFieldInput>;
  rooms?: InputMaybe<Array<TimetableVersionRoomsDeleteFieldInput>>;
  snapshots?: InputMaybe<Array<TimetableVersionSnapshotsDeleteFieldInput>>;
  subjects?: InputMaybe<Array<TimetableVersionSubjectsDeleteFieldInput>>;
  teachers?: InputMaybe<Array<TimetableVersionTeachersDeleteFieldInput>>;
  timetable?: InputMaybe<TimetableVersionTimetableDeleteFieldInput>;
};

export type TimetableVersionDependenciesAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionDependenciesAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionDependenciesAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionDependenciesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionDependenciesNodeAggregationWhereInput>;
};

export type TimetableVersionDependenciesConnectFieldInput = {
  connect?: InputMaybe<Array<DependencyConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DependencyConnectWhere>;
};

export type TimetableVersionDependenciesConnection = {
  __typename?: 'TimetableVersionDependenciesConnection';
  edges: Array<TimetableVersionDependenciesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionDependenciesConnectionSort = {
  node?: InputMaybe<DependencySort>;
};

export type TimetableVersionDependenciesConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionDependenciesConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionDependenciesConnectionWhere>>;
  node?: InputMaybe<DependencyWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<DependencyWhere>;
};

export type TimetableVersionDependenciesCreateFieldInput = {
  node: DependencyCreateInput;
};

export type TimetableVersionDependenciesDeleteFieldInput = {
  delete?: InputMaybe<DependencyDeleteInput>;
  where?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
};

export type TimetableVersionDependenciesDisconnectFieldInput = {
  disconnect?: InputMaybe<DependencyDisconnectInput>;
  where?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
};

export type TimetableVersionDependenciesFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionDependenciesConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionDependenciesCreateFieldInput>>;
};

export type TimetableVersionDependenciesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionDependenciesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionDependenciesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionDependenciesNodeAggregationWhereInput>>;
  alias_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alias_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alias_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alias_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alias_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionDependenciesRelationship = {
  __typename?: 'TimetableVersionDependenciesRelationship';
  cursor: Scalars['String']['output'];
  node: Dependency;
};

export type TimetableVersionDependenciesUpdateConnectionInput = {
  node?: InputMaybe<DependencyUpdateInput>;
};

export type TimetableVersionDependenciesUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionDependenciesConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionDependenciesCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionDependenciesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionDependenciesDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionDependenciesUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
};

export type TimetableVersionDisconnectInput = {
  cards?: InputMaybe<Array<TimetableVersionCardsDisconnectFieldInput>>;
  children?: InputMaybe<Array<TimetableVersionChildrenDisconnectFieldInput>>;
  classes?: InputMaybe<Array<TimetableVersionClassesDisconnectFieldInput>>;
  dependencies?: InputMaybe<Array<TimetableVersionDependenciesDisconnectFieldInput>>;
  lessons?: InputMaybe<Array<TimetableVersionLessonsDisconnectFieldInput>>;
  locked?: InputMaybe<TimetableVersionLockedDisconnectFieldInput>;
  original?: InputMaybe<TimetableVersionOriginalDisconnectFieldInput>;
  parent?: InputMaybe<TimetableVersionParentDisconnectFieldInput>;
  rooms?: InputMaybe<Array<TimetableVersionRoomsDisconnectFieldInput>>;
  snapshots?: InputMaybe<Array<TimetableVersionSnapshotsDisconnectFieldInput>>;
  subjects?: InputMaybe<Array<TimetableVersionSubjectsDisconnectFieldInput>>;
  teachers?: InputMaybe<Array<TimetableVersionTeachersDisconnectFieldInput>>;
  timetable?: InputMaybe<TimetableVersionTimetableDisconnectFieldInput>;
};

export type TimetableVersionEdge = {
  __typename?: 'TimetableVersionEdge';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
};

export type TimetableVersionLessonLessonsAggregationSelection = {
  __typename?: 'TimetableVersionLessonLessonsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TimetableVersionLessonLessonsNodeAggregateSelection>;
};

export type TimetableVersionLessonLessonsNodeAggregateSelection = {
  __typename?: 'TimetableVersionLessonLessonsNodeAggregateSelection';
  comment: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  foreignId: StringAggregateSelection;
  subTitle: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
  uuid: IdAggregateSelection;
};

export type TimetableVersionLessonsAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionLessonsAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionLessonsAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionLessonsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionLessonsNodeAggregationWhereInput>;
};

export type TimetableVersionLessonsConnectFieldInput = {
  connect?: InputMaybe<Array<LessonConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LessonConnectWhere>;
};

export type TimetableVersionLessonsConnectOrCreateFieldInput = {
  onCreate: TimetableVersionLessonsConnectOrCreateFieldInputOnCreate;
  where: LessonConnectOrCreateWhere;
};

export type TimetableVersionLessonsConnectOrCreateFieldInputOnCreate = {
  node: LessonOnCreateInput;
};

export type TimetableVersionLessonsConnection = {
  __typename?: 'TimetableVersionLessonsConnection';
  edges: Array<TimetableVersionLessonsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionLessonsConnectionSort = {
  node?: InputMaybe<LessonSort>;
};

export type TimetableVersionLessonsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionLessonsConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionLessonsConnectionWhere>>;
  node?: InputMaybe<LessonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LessonWhere>;
};

export type TimetableVersionLessonsCreateFieldInput = {
  node: LessonCreateInput;
};

export type TimetableVersionLessonsDeleteFieldInput = {
  delete?: InputMaybe<LessonDeleteInput>;
  where?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
};

export type TimetableVersionLessonsDisconnectFieldInput = {
  disconnect?: InputMaybe<LessonDisconnectInput>;
  where?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
};

export type TimetableVersionLessonsFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionLessonsCreateFieldInput>>;
};

export type TimetableVersionLessonsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionLessonsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionLessonsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionLessonsNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableVersionLessonsRelationship = {
  __typename?: 'TimetableVersionLessonsRelationship';
  cursor: Scalars['String']['output'];
  node: Lesson;
};

export type TimetableVersionLessonsUpdateConnectionInput = {
  node?: InputMaybe<LessonUpdateInput>;
};

export type TimetableVersionLessonsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionLessonsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionLessonsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionLessonsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionLessonsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionLessonsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionLessonsUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
};

export type TimetableVersionLockedAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionLockedAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionLockedAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionLockedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionLockedNodeAggregationWhereInput>;
};

export type TimetableVersionLockedConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LockedConnectWhere>;
};

export type TimetableVersionLockedConnection = {
  __typename?: 'TimetableVersionLockedConnection';
  edges: Array<TimetableVersionLockedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionLockedConnectionSort = {
  node?: InputMaybe<LockedSort>;
};

export type TimetableVersionLockedConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionLockedConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionLockedConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionLockedConnectionWhere>>;
  node?: InputMaybe<LockedWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<LockedWhere>;
};

export type TimetableVersionLockedCreateFieldInput = {
  node: LockedCreateInput;
};

export type TimetableVersionLockedDeleteFieldInput = {
  where?: InputMaybe<TimetableVersionLockedConnectionWhere>;
};

export type TimetableVersionLockedDisconnectFieldInput = {
  where?: InputMaybe<TimetableVersionLockedConnectionWhere>;
};

export type TimetableVersionLockedFieldInput = {
  connect?: InputMaybe<TimetableVersionLockedConnectFieldInput>;
  create?: InputMaybe<TimetableVersionLockedCreateFieldInput>;
};

export type TimetableVersionLockedLockedAggregationSelection = {
  __typename?: 'TimetableVersionLockedLockedAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TimetableVersionLockedLockedNodeAggregateSelection>;
};

export type TimetableVersionLockedLockedNodeAggregateSelection = {
  __typename?: 'TimetableVersionLockedLockedNodeAggregateSelection';
  duration: IntAggregateSelection;
  lockedBy: StringAggregateSelection;
  lockedSince: DateTimeAggregateSelection;
};

export type TimetableVersionLockedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionLockedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionLockedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionLockedNodeAggregationWhereInput>>;
  duration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  duration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  duration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  duration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lockedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSince_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSince_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableVersionLockedRelationship = {
  __typename?: 'TimetableVersionLockedRelationship';
  cursor: Scalars['String']['output'];
  node: Locked;
};

export type TimetableVersionLockedUpdateConnectionInput = {
  node?: InputMaybe<LockedUpdateInput>;
};

export type TimetableVersionLockedUpdateFieldInput = {
  connect?: InputMaybe<TimetableVersionLockedConnectFieldInput>;
  create?: InputMaybe<TimetableVersionLockedCreateFieldInput>;
  delete?: InputMaybe<TimetableVersionLockedDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableVersionLockedDisconnectFieldInput>;
  update?: InputMaybe<TimetableVersionLockedUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionLockedConnectionWhere>;
};

export type TimetableVersionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TimetableVersionSort objects to sort TimetableVersions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TimetableVersionSort>>;
};

export type TimetableVersionOriginalAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionOriginalAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionOriginalAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionOriginalAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionOriginalNodeAggregationWhereInput>;
};

export type TimetableVersionOriginalConnectFieldInput = {
  connect?: InputMaybe<TimetableVersionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type TimetableVersionOriginalConnection = {
  __typename?: 'TimetableVersionOriginalConnection';
  edges: Array<TimetableVersionOriginalRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionOriginalConnectionSort = {
  node?: InputMaybe<TimetableVersionSort>;
};

export type TimetableVersionOriginalConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionOriginalConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionOriginalConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionOriginalConnectionWhere>>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionOriginalCreateFieldInput = {
  node: TimetableVersionCreateInput;
};

export type TimetableVersionOriginalDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<TimetableVersionOriginalConnectionWhere>;
};

export type TimetableVersionOriginalDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<TimetableVersionOriginalConnectionWhere>;
};

export type TimetableVersionOriginalFieldInput = {
  connect?: InputMaybe<TimetableVersionOriginalConnectFieldInput>;
  create?: InputMaybe<TimetableVersionOriginalCreateFieldInput>;
};

export type TimetableVersionOriginalNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionOriginalNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionOriginalNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionOriginalNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionOriginalRelationship = {
  __typename?: 'TimetableVersionOriginalRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
};

export type TimetableVersionOriginalUpdateConnectionInput = {
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type TimetableVersionOriginalUpdateFieldInput = {
  connect?: InputMaybe<TimetableVersionOriginalConnectFieldInput>;
  create?: InputMaybe<TimetableVersionOriginalCreateFieldInput>;
  delete?: InputMaybe<TimetableVersionOriginalDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableVersionOriginalDisconnectFieldInput>;
  update?: InputMaybe<TimetableVersionOriginalUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionOriginalConnectionWhere>;
};

export type TimetableVersionParentAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionParentAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionParentAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionParentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ParentVersionPropertiesAggregationWhereInput>;
  node?: InputMaybe<TimetableVersionParentNodeAggregationWhereInput>;
};

export type TimetableVersionParentConnectFieldInput = {
  connect?: InputMaybe<TimetableVersionConnectInput>;
  edge?: InputMaybe<ParentVersionPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type TimetableVersionParentConnection = {
  __typename?: 'TimetableVersionParentConnection';
  edges: Array<TimetableVersionParentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionParentConnectionSort = {
  edge?: InputMaybe<ParentVersionPropertiesSort>;
  node?: InputMaybe<TimetableVersionSort>;
};

export type TimetableVersionParentConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionParentConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionParentConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionParentConnectionWhere>>;
  edge?: InputMaybe<ParentVersionPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<ParentVersionPropertiesWhere>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionParentCreateFieldInput = {
  edge?: InputMaybe<ParentVersionPropertiesCreateInput>;
  node: TimetableVersionCreateInput;
};

export type TimetableVersionParentDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<TimetableVersionParentConnectionWhere>;
};

export type TimetableVersionParentDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<TimetableVersionParentConnectionWhere>;
};

export type TimetableVersionParentFieldInput = {
  connect?: InputMaybe<TimetableVersionParentConnectFieldInput>;
  create?: InputMaybe<TimetableVersionParentCreateFieldInput>;
};

export type TimetableVersionParentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionParentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionParentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionParentNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionParentRelationship = {
  __typename?: 'TimetableVersionParentRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
  properties: ParentVersionProperties;
};

export type TimetableVersionParentUpdateConnectionInput = {
  edge?: InputMaybe<ParentVersionPropertiesUpdateInput>;
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type TimetableVersionParentUpdateFieldInput = {
  connect?: InputMaybe<TimetableVersionParentConnectFieldInput>;
  create?: InputMaybe<TimetableVersionParentCreateFieldInput>;
  delete?: InputMaybe<TimetableVersionParentDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableVersionParentDisconnectFieldInput>;
  update?: InputMaybe<TimetableVersionParentUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionParentConnectionWhere>;
};

export type TimetableVersionRoomsAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionRoomsAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionRoomsAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionRoomsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TimetableRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TimetableVersionRoomsNodeAggregationWhereInput>;
};

export type TimetableVersionRoomsConnectFieldInput = {
  connect?: InputMaybe<Array<RoomConnectInput>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoomConnectWhere>;
};

export type TimetableVersionRoomsConnectOrCreateFieldInput = {
  onCreate: TimetableVersionRoomsConnectOrCreateFieldInputOnCreate;
  where: RoomConnectOrCreateWhere;
};

export type TimetableVersionRoomsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: RoomOnCreateInput;
};

export type TimetableVersionRoomsConnection = {
  __typename?: 'TimetableVersionRoomsConnection';
  edges: Array<TimetableVersionRoomsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionRoomsConnectionSort = {
  edge?: InputMaybe<TimetableRelationshipPropertiesSort>;
  node?: InputMaybe<RoomSort>;
};

export type TimetableVersionRoomsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionRoomsConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionRoomsConnectionWhere>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  node?: InputMaybe<RoomWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<RoomWhere>;
};

export type TimetableVersionRoomsCreateFieldInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: RoomCreateInput;
};

export type TimetableVersionRoomsDeleteFieldInput = {
  delete?: InputMaybe<RoomDeleteInput>;
  where?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
};

export type TimetableVersionRoomsDisconnectFieldInput = {
  disconnect?: InputMaybe<RoomDisconnectInput>;
  where?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
};

export type TimetableVersionRoomsFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionRoomsCreateFieldInput>>;
};

export type TimetableVersionRoomsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionRoomsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionRoomsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionRoomsNodeAggregationWhereInput>>;
  capacity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  capacity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  capacity_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  capacity_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  chairs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  chairs_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  chairs_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otherInventory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otherInventory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  roomNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  roomNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  size_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  size_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  size_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  size_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  tables_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  tables_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  tables_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableVersionRoomsRelationship = {
  __typename?: 'TimetableVersionRoomsRelationship';
  cursor: Scalars['String']['output'];
  node: Room;
  properties: TimetableRelationshipProperties;
};

export type TimetableVersionRoomsUpdateConnectionInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<RoomUpdateInput>;
};

export type TimetableVersionRoomsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionRoomsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionRoomsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionRoomsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionRoomsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionRoomsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionRoomsUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
};

export type TimetableVersionSnapshotsAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionSnapshotsAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionSnapshotsAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionSnapshotsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionSnapshotsNodeAggregationWhereInput>;
};

export type TimetableVersionSnapshotsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type TimetableVersionSnapshotsConnection = {
  __typename?: 'TimetableVersionSnapshotsConnection';
  edges: Array<TimetableVersionSnapshotsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionSnapshotsConnectionSort = {
  node?: InputMaybe<TimetableVersionSort>;
};

export type TimetableVersionSnapshotsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionSnapshotsConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionSnapshotsConnectionWhere>>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionSnapshotsCreateFieldInput = {
  node: TimetableVersionCreateInput;
};

export type TimetableVersionSnapshotsDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
};

export type TimetableVersionSnapshotsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
};

export type TimetableVersionSnapshotsFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionSnapshotsConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionSnapshotsCreateFieldInput>>;
};

export type TimetableVersionSnapshotsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionSnapshotsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionSnapshotsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionSnapshotsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionSnapshotsRelationship = {
  __typename?: 'TimetableVersionSnapshotsRelationship';
  cursor: Scalars['String']['output'];
  node: TimetableVersion;
};

export type TimetableVersionSnapshotsUpdateConnectionInput = {
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type TimetableVersionSnapshotsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionSnapshotsConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionSnapshotsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionSnapshotsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionSnapshotsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionSnapshotsUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
};

/** Fields to sort TimetableVersions by. The order in which sorts are applied is not guaranteed when specifying many fields in one TimetableVersionSort object. */
export type TimetableVersionSort = {
  active?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  editable?: InputMaybe<SortDirection>;
  generating?: InputMaybe<SortDirection>;
  isSnapshot?: InputMaybe<SortDirection>;
  placedCardsCount?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type TimetableVersionSubjectsAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionSubjectsAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionSubjectsAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionSubjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TimetableRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TimetableVersionSubjectsNodeAggregationWhereInput>;
};

export type TimetableVersionSubjectsConnectFieldInput = {
  connect?: InputMaybe<Array<SubjectConnectInput>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubjectConnectWhere>;
};

export type TimetableVersionSubjectsConnectOrCreateFieldInput = {
  onCreate: TimetableVersionSubjectsConnectOrCreateFieldInputOnCreate;
  where: SubjectConnectOrCreateWhere;
};

export type TimetableVersionSubjectsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: SubjectOnCreateInput;
};

export type TimetableVersionSubjectsConnection = {
  __typename?: 'TimetableVersionSubjectsConnection';
  edges: Array<TimetableVersionSubjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionSubjectsConnectionSort = {
  edge?: InputMaybe<TimetableRelationshipPropertiesSort>;
  node?: InputMaybe<SubjectSort>;
};

export type TimetableVersionSubjectsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionSubjectsConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionSubjectsConnectionWhere>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  node?: InputMaybe<SubjectWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SubjectWhere>;
};

export type TimetableVersionSubjectsCreateFieldInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: SubjectCreateInput;
};

export type TimetableVersionSubjectsDeleteFieldInput = {
  delete?: InputMaybe<SubjectDeleteInput>;
  where?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
};

export type TimetableVersionSubjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<SubjectDisconnectInput>;
  where?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
};

export type TimetableVersionSubjectsFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionSubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionSubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionSubjectsCreateFieldInput>>;
};

export type TimetableVersionSubjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionSubjectsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionSubjectsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionSubjectsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableVersionSubjectsRelationship = {
  __typename?: 'TimetableVersionSubjectsRelationship';
  cursor: Scalars['String']['output'];
  node: Subject;
  properties: TimetableRelationshipProperties;
};

export type TimetableVersionSubjectsUpdateConnectionInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<SubjectUpdateInput>;
};

export type TimetableVersionSubjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionSubjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionSubjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionSubjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionSubjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionSubjectsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionSubjectsUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
};

export type TimetableVersionTeachersAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionTeachersAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionTeachersAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionTeachersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TimetableRelationshipPropertiesAggregationWhereInput>;
  node?: InputMaybe<TimetableVersionTeachersNodeAggregationWhereInput>;
};

export type TimetableVersionTeachersConnectFieldInput = {
  connect?: InputMaybe<Array<PersonConnectInput>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PersonConnectWhere>;
};

export type TimetableVersionTeachersConnectOrCreateFieldInput = {
  onCreate: TimetableVersionTeachersConnectOrCreateFieldInputOnCreate;
  where: PersonConnectOrCreateWhere;
};

export type TimetableVersionTeachersConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: PersonOnCreateInput;
};

export type TimetableVersionTeachersConnection = {
  __typename?: 'TimetableVersionTeachersConnection';
  edges: Array<TimetableVersionTeachersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionTeachersConnectionSort = {
  edge?: InputMaybe<TimetableRelationshipPropertiesSort>;
  node?: InputMaybe<PersonSort>;
};

export type TimetableVersionTeachersConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionTeachersConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionTeachersConnectionWhere>>;
  edge?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  edge_NOT?: InputMaybe<TimetableRelationshipPropertiesWhere>;
  node?: InputMaybe<PersonWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<PersonWhere>;
};

export type TimetableVersionTeachersCreateFieldInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesCreateInput>;
  node: PersonCreateInput;
};

export type TimetableVersionTeachersDeleteFieldInput = {
  delete?: InputMaybe<PersonDeleteInput>;
  where?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
};

export type TimetableVersionTeachersDisconnectFieldInput = {
  disconnect?: InputMaybe<PersonDisconnectInput>;
  where?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
};

export type TimetableVersionTeachersFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionTeachersCreateFieldInput>>;
};

export type TimetableVersionTeachersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionTeachersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionTeachersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionTeachersNodeAggregationWhereInput>>;
  callingName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callingName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callingName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callingName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayNameShort_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayNameShort_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayNameShort_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  personalId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  personalId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  personalId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pimProfileUuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pimProfileUuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  prefixName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  prefixName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  prefixName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  salutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  salutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  salutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableVersionTeachersRelationship = {
  __typename?: 'TimetableVersionTeachersRelationship';
  cursor: Scalars['String']['output'];
  node: Person;
  properties: TimetableRelationshipProperties;
};

export type TimetableVersionTeachersUpdateConnectionInput = {
  edge?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
  node?: InputMaybe<PersonUpdateInput>;
};

export type TimetableVersionTeachersUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionTeachersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TimetableVersionTeachersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionTeachersCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionTeachersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionTeachersDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionTeachersUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
};

export type TimetableVersionTimetableAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionTimetableAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionTimetableAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionTimetableAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionTimetableNodeAggregationWhereInput>;
};

export type TimetableVersionTimetableCardCardsAggregationSelection = {
  __typename?: 'TimetableVersionTimetableCardCardsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TimetableVersionTimetableCardCardsNodeAggregateSelection>;
};

export type TimetableVersionTimetableCardCardsNodeAggregateSelection = {
  __typename?: 'TimetableVersionTimetableCardCardsNodeAggregateSelection';
  duration: IntAggregateSelection;
  foreignId: StringAggregateSelection;
  uuid: IdAggregateSelection;
  weekday: StringAggregateSelection;
};

export type TimetableVersionTimetableConnectFieldInput = {
  connect?: InputMaybe<TimetableConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableConnectWhere>;
};

export type TimetableVersionTimetableConnectOrCreateFieldInput = {
  onCreate: TimetableVersionTimetableConnectOrCreateFieldInputOnCreate;
  where: TimetableConnectOrCreateWhere;
};

export type TimetableVersionTimetableConnectOrCreateFieldInputOnCreate = {
  node: TimetableOnCreateInput;
};

export type TimetableVersionTimetableConnection = {
  __typename?: 'TimetableVersionTimetableConnection';
  edges: Array<TimetableVersionTimetableRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionTimetableConnectionSort = {
  node?: InputMaybe<TimetableSort>;
};

export type TimetableVersionTimetableConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionTimetableConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionTimetableConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionTimetableConnectionWhere>>;
  node?: InputMaybe<TimetableWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableWhere>;
};

export type TimetableVersionTimetableCreateFieldInput = {
  node: TimetableCreateInput;
};

export type TimetableVersionTimetableDeleteFieldInput = {
  delete?: InputMaybe<TimetableDeleteInput>;
  where?: InputMaybe<TimetableVersionTimetableConnectionWhere>;
};

export type TimetableVersionTimetableDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableDisconnectInput>;
  where?: InputMaybe<TimetableVersionTimetableConnectionWhere>;
};

export type TimetableVersionTimetableFieldInput = {
  connect?: InputMaybe<TimetableVersionTimetableConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableVersionTimetableConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableVersionTimetableCreateFieldInput>;
};

export type TimetableVersionTimetableNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionTimetableNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionTimetableNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionTimetableNodeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  foreignId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  foreignId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  foreignId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  foreignId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TimetableVersionTimetableRelationship = {
  __typename?: 'TimetableVersionTimetableRelationship';
  cursor: Scalars['String']['output'];
  node: Timetable;
};

export type TimetableVersionTimetableUpdateConnectionInput = {
  node?: InputMaybe<TimetableUpdateInput>;
};

export type TimetableVersionTimetableUpdateFieldInput = {
  connect?: InputMaybe<TimetableVersionTimetableConnectFieldInput>;
  connectOrCreate?: InputMaybe<TimetableVersionTimetableConnectOrCreateFieldInput>;
  create?: InputMaybe<TimetableVersionTimetableCreateFieldInput>;
  delete?: InputMaybe<TimetableVersionTimetableDeleteFieldInput>;
  disconnect?: InputMaybe<TimetableVersionTimetableDisconnectFieldInput>;
  update?: InputMaybe<TimetableVersionTimetableUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionTimetableConnectionWhere>;
};

export type TimetableVersionUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cards?: InputMaybe<Array<TimetableVersionCardsUpdateFieldInput>>;
  children?: InputMaybe<Array<TimetableVersionChildrenUpdateFieldInput>>;
  classes?: InputMaybe<Array<TimetableVersionClassesUpdateFieldInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<TimetableVersionDependenciesUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  generating?: InputMaybe<Scalars['Boolean']['input']>;
  lessons?: InputMaybe<Array<TimetableVersionLessonsUpdateFieldInput>>;
  locked?: InputMaybe<TimetableVersionLockedUpdateFieldInput>;
  original?: InputMaybe<TimetableVersionOriginalUpdateFieldInput>;
  parent?: InputMaybe<TimetableVersionParentUpdateFieldInput>;
  rooms?: InputMaybe<Array<TimetableVersionRoomsUpdateFieldInput>>;
  snapshots?: InputMaybe<Array<TimetableVersionSnapshotsUpdateFieldInput>>;
  subjects?: InputMaybe<Array<TimetableVersionSubjectsUpdateFieldInput>>;
  teachers?: InputMaybe<Array<TimetableVersionTeachersUpdateFieldInput>>;
  timetable?: InputMaybe<TimetableVersionTimetableUpdateFieldInput>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  version_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionWhere = {
  AND?: InputMaybe<Array<TimetableVersionWhere>>;
  NOT?: InputMaybe<TimetableVersionWhere>;
  OR?: InputMaybe<Array<TimetableVersionWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  active_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `cards_SOME` instead. */
  cards?: InputMaybe<TimetableCardWhere>;
  cardsAggregate?: InputMaybe<TimetableVersionCardsAggregateInput>;
  /** @deprecated Use `cardsConnection_SOME` instead. */
  cardsConnection?: InputMaybe<TimetableVersionCardsConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionCardsConnections match this filter */
  cardsConnection_ALL?: InputMaybe<TimetableVersionCardsConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionCardsConnections match this filter */
  cardsConnection_NONE?: InputMaybe<TimetableVersionCardsConnectionWhere>;
  /** @deprecated Use `cardsConnection_NONE` instead. */
  cardsConnection_NOT?: InputMaybe<TimetableVersionCardsConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionCardsConnections match this filter */
  cardsConnection_SINGLE?: InputMaybe<TimetableVersionCardsConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionCardsConnections match this filter */
  cardsConnection_SOME?: InputMaybe<TimetableVersionCardsConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableCards match this filter */
  cards_ALL?: InputMaybe<TimetableCardWhere>;
  /** Return TimetableVersions where none of the related TimetableCards match this filter */
  cards_NONE?: InputMaybe<TimetableCardWhere>;
  /** @deprecated Use `cards_NONE` instead. */
  cards_NOT?: InputMaybe<TimetableCardWhere>;
  /** Return TimetableVersions where one of the related TimetableCards match this filter */
  cards_SINGLE?: InputMaybe<TimetableCardWhere>;
  /** Return TimetableVersions where some of the related TimetableCards match this filter */
  cards_SOME?: InputMaybe<TimetableCardWhere>;
  /** @deprecated Use `children_SOME` instead. */
  children?: InputMaybe<TimetableVersionWhere>;
  childrenAggregate?: InputMaybe<TimetableVersionChildrenAggregateInput>;
  /** @deprecated Use `childrenConnection_SOME` instead. */
  childrenConnection?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionChildrenConnections match this filter */
  childrenConnection_ALL?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionChildrenConnections match this filter */
  childrenConnection_NONE?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
  /** @deprecated Use `childrenConnection_NONE` instead. */
  childrenConnection_NOT?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionChildrenConnections match this filter */
  childrenConnection_SINGLE?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionChildrenConnections match this filter */
  childrenConnection_SOME?: InputMaybe<TimetableVersionChildrenConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersions match this filter */
  children_ALL?: InputMaybe<TimetableVersionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersions match this filter */
  children_NONE?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `children_NONE` instead. */
  children_NOT?: InputMaybe<TimetableVersionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersions match this filter */
  children_SINGLE?: InputMaybe<TimetableVersionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersions match this filter */
  children_SOME?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `classes_SOME` instead. */
  classes?: InputMaybe<ClassWhere>;
  classesAggregate?: InputMaybe<TimetableVersionClassesAggregateInput>;
  /** @deprecated Use `classesConnection_SOME` instead. */
  classesConnection?: InputMaybe<TimetableVersionClassesConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionClassesConnections match this filter */
  classesConnection_ALL?: InputMaybe<TimetableVersionClassesConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionClassesConnections match this filter */
  classesConnection_NONE?: InputMaybe<TimetableVersionClassesConnectionWhere>;
  /** @deprecated Use `classesConnection_NONE` instead. */
  classesConnection_NOT?: InputMaybe<TimetableVersionClassesConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionClassesConnections match this filter */
  classesConnection_SINGLE?: InputMaybe<TimetableVersionClassesConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionClassesConnections match this filter */
  classesConnection_SOME?: InputMaybe<TimetableVersionClassesConnectionWhere>;
  /** Return TimetableVersions where all of the related Classes match this filter */
  classes_ALL?: InputMaybe<ClassWhere>;
  /** Return TimetableVersions where none of the related Classes match this filter */
  classes_NONE?: InputMaybe<ClassWhere>;
  /** @deprecated Use `classes_NONE` instead. */
  classes_NOT?: InputMaybe<ClassWhere>;
  /** Return TimetableVersions where one of the related Classes match this filter */
  classes_SINGLE?: InputMaybe<ClassWhere>;
  /** Return TimetableVersions where some of the related Classes match this filter */
  classes_SOME?: InputMaybe<ClassWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** @deprecated Use `dependencies_SOME` instead. */
  dependencies?: InputMaybe<DependencyWhere>;
  dependenciesAggregate?: InputMaybe<TimetableVersionDependenciesAggregateInput>;
  /** @deprecated Use `dependenciesConnection_SOME` instead. */
  dependenciesConnection?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionDependenciesConnections match this filter */
  dependenciesConnection_ALL?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionDependenciesConnections match this filter */
  dependenciesConnection_NONE?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
  /** @deprecated Use `dependenciesConnection_NONE` instead. */
  dependenciesConnection_NOT?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionDependenciesConnections match this filter */
  dependenciesConnection_SINGLE?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionDependenciesConnections match this filter */
  dependenciesConnection_SOME?: InputMaybe<TimetableVersionDependenciesConnectionWhere>;
  /** Return TimetableVersions where all of the related Dependencies match this filter */
  dependencies_ALL?: InputMaybe<DependencyWhere>;
  /** Return TimetableVersions where none of the related Dependencies match this filter */
  dependencies_NONE?: InputMaybe<DependencyWhere>;
  /** @deprecated Use `dependencies_NONE` instead. */
  dependencies_NOT?: InputMaybe<DependencyWhere>;
  /** Return TimetableVersions where one of the related Dependencies match this filter */
  dependencies_SINGLE?: InputMaybe<DependencyWhere>;
  /** Return TimetableVersions where some of the related Dependencies match this filter */
  dependencies_SOME?: InputMaybe<DependencyWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  editable_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  generating?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  generating_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  isSnapshot?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  isSnapshot_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `lessons_SOME` instead. */
  lessons?: InputMaybe<LessonWhere>;
  lessonsAggregate?: InputMaybe<TimetableVersionLessonsAggregateInput>;
  /** @deprecated Use `lessonsConnection_SOME` instead. */
  lessonsConnection?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionLessonsConnections match this filter */
  lessonsConnection_ALL?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionLessonsConnections match this filter */
  lessonsConnection_NONE?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
  /** @deprecated Use `lessonsConnection_NONE` instead. */
  lessonsConnection_NOT?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionLessonsConnections match this filter */
  lessonsConnection_SINGLE?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionLessonsConnections match this filter */
  lessonsConnection_SOME?: InputMaybe<TimetableVersionLessonsConnectionWhere>;
  /** Return TimetableVersions where all of the related Lessons match this filter */
  lessons_ALL?: InputMaybe<LessonWhere>;
  /** Return TimetableVersions where none of the related Lessons match this filter */
  lessons_NONE?: InputMaybe<LessonWhere>;
  /** @deprecated Use `lessons_NONE` instead. */
  lessons_NOT?: InputMaybe<LessonWhere>;
  /** Return TimetableVersions where one of the related Lessons match this filter */
  lessons_SINGLE?: InputMaybe<LessonWhere>;
  /** Return TimetableVersions where some of the related Lessons match this filter */
  lessons_SOME?: InputMaybe<LessonWhere>;
  locked?: InputMaybe<LockedWhere>;
  lockedAggregate?: InputMaybe<TimetableVersionLockedAggregateInput>;
  lockedConnection?: InputMaybe<TimetableVersionLockedConnectionWhere>;
  lockedConnection_NOT?: InputMaybe<TimetableVersionLockedConnectionWhere>;
  locked_NOT?: InputMaybe<LockedWhere>;
  original?: InputMaybe<TimetableVersionWhere>;
  originalAggregate?: InputMaybe<TimetableVersionOriginalAggregateInput>;
  originalConnection?: InputMaybe<TimetableVersionOriginalConnectionWhere>;
  originalConnection_NOT?: InputMaybe<TimetableVersionOriginalConnectionWhere>;
  original_NOT?: InputMaybe<TimetableVersionWhere>;
  parent?: InputMaybe<TimetableVersionWhere>;
  parentAggregate?: InputMaybe<TimetableVersionParentAggregateInput>;
  parentConnection?: InputMaybe<TimetableVersionParentConnectionWhere>;
  parentConnection_NOT?: InputMaybe<TimetableVersionParentConnectionWhere>;
  parent_NOT?: InputMaybe<TimetableVersionWhere>;
  placedCardsCount?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_GT?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  placedCardsCount_LT?: InputMaybe<Scalars['Int']['input']>;
  placedCardsCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  placedCardsCount_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  placedCardsCount_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** @deprecated Use `rooms_SOME` instead. */
  rooms?: InputMaybe<RoomWhere>;
  roomsAggregate?: InputMaybe<TimetableVersionRoomsAggregateInput>;
  /** @deprecated Use `roomsConnection_SOME` instead. */
  roomsConnection?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionRoomsConnections match this filter */
  roomsConnection_ALL?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionRoomsConnections match this filter */
  roomsConnection_NONE?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
  /** @deprecated Use `roomsConnection_NONE` instead. */
  roomsConnection_NOT?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionRoomsConnections match this filter */
  roomsConnection_SINGLE?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionRoomsConnections match this filter */
  roomsConnection_SOME?: InputMaybe<TimetableVersionRoomsConnectionWhere>;
  /** Return TimetableVersions where all of the related Rooms match this filter */
  rooms_ALL?: InputMaybe<RoomWhere>;
  /** Return TimetableVersions where none of the related Rooms match this filter */
  rooms_NONE?: InputMaybe<RoomWhere>;
  /** @deprecated Use `rooms_NONE` instead. */
  rooms_NOT?: InputMaybe<RoomWhere>;
  /** Return TimetableVersions where one of the related Rooms match this filter */
  rooms_SINGLE?: InputMaybe<RoomWhere>;
  /** Return TimetableVersions where some of the related Rooms match this filter */
  rooms_SOME?: InputMaybe<RoomWhere>;
  /** @deprecated Use `snapshots_SOME` instead. */
  snapshots?: InputMaybe<TimetableVersionWhere>;
  snapshotsAggregate?: InputMaybe<TimetableVersionSnapshotsAggregateInput>;
  /** @deprecated Use `snapshotsConnection_SOME` instead. */
  snapshotsConnection?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionSnapshotsConnections match this filter */
  snapshotsConnection_ALL?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionSnapshotsConnections match this filter */
  snapshotsConnection_NONE?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
  /** @deprecated Use `snapshotsConnection_NONE` instead. */
  snapshotsConnection_NOT?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionSnapshotsConnections match this filter */
  snapshotsConnection_SINGLE?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionSnapshotsConnections match this filter */
  snapshotsConnection_SOME?: InputMaybe<TimetableVersionSnapshotsConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersions match this filter */
  snapshots_ALL?: InputMaybe<TimetableVersionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersions match this filter */
  snapshots_NONE?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `snapshots_NONE` instead. */
  snapshots_NOT?: InputMaybe<TimetableVersionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersions match this filter */
  snapshots_SINGLE?: InputMaybe<TimetableVersionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersions match this filter */
  snapshots_SOME?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `subjects_SOME` instead. */
  subjects?: InputMaybe<SubjectWhere>;
  subjectsAggregate?: InputMaybe<TimetableVersionSubjectsAggregateInput>;
  /** @deprecated Use `subjectsConnection_SOME` instead. */
  subjectsConnection?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionSubjectsConnections match this filter */
  subjectsConnection_ALL?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionSubjectsConnections match this filter */
  subjectsConnection_NONE?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
  /** @deprecated Use `subjectsConnection_NONE` instead. */
  subjectsConnection_NOT?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionSubjectsConnections match this filter */
  subjectsConnection_SINGLE?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionSubjectsConnections match this filter */
  subjectsConnection_SOME?: InputMaybe<TimetableVersionSubjectsConnectionWhere>;
  /** Return TimetableVersions where all of the related Subjects match this filter */
  subjects_ALL?: InputMaybe<SubjectWhere>;
  /** Return TimetableVersions where none of the related Subjects match this filter */
  subjects_NONE?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `subjects_NONE` instead. */
  subjects_NOT?: InputMaybe<SubjectWhere>;
  /** Return TimetableVersions where one of the related Subjects match this filter */
  subjects_SINGLE?: InputMaybe<SubjectWhere>;
  /** Return TimetableVersions where some of the related Subjects match this filter */
  subjects_SOME?: InputMaybe<SubjectWhere>;
  /** @deprecated Use `teachers_SOME` instead. */
  teachers?: InputMaybe<PersonWhere>;
  teachersAggregate?: InputMaybe<TimetableVersionTeachersAggregateInput>;
  /** @deprecated Use `teachersConnection_SOME` instead. */
  teachersConnection?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
  /** Return TimetableVersions where all of the related TimetableVersionTeachersConnections match this filter */
  teachersConnection_ALL?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
  /** Return TimetableVersions where none of the related TimetableVersionTeachersConnections match this filter */
  teachersConnection_NONE?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
  /** @deprecated Use `teachersConnection_NONE` instead. */
  teachersConnection_NOT?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
  /** Return TimetableVersions where one of the related TimetableVersionTeachersConnections match this filter */
  teachersConnection_SINGLE?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
  /** Return TimetableVersions where some of the related TimetableVersionTeachersConnections match this filter */
  teachersConnection_SOME?: InputMaybe<TimetableVersionTeachersConnectionWhere>;
  /** Return TimetableVersions where all of the related People match this filter */
  teachers_ALL?: InputMaybe<PersonWhere>;
  /** Return TimetableVersions where none of the related People match this filter */
  teachers_NONE?: InputMaybe<PersonWhere>;
  /** @deprecated Use `teachers_NONE` instead. */
  teachers_NOT?: InputMaybe<PersonWhere>;
  /** Return TimetableVersions where one of the related People match this filter */
  teachers_SINGLE?: InputMaybe<PersonWhere>;
  /** Return TimetableVersions where some of the related People match this filter */
  teachers_SOME?: InputMaybe<PersonWhere>;
  timetable?: InputMaybe<TimetableWhere>;
  timetableAggregate?: InputMaybe<TimetableVersionTimetableAggregateInput>;
  timetableConnection?: InputMaybe<TimetableVersionTimetableConnectionWhere>;
  timetableConnection_NOT?: InputMaybe<TimetableVersionTimetableConnectionWhere>;
  timetable_NOT?: InputMaybe<TimetableWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  version_NOT_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TimetableVersionsAggregateInput = {
  AND?: InputMaybe<Array<TimetableVersionsAggregateInput>>;
  NOT?: InputMaybe<TimetableVersionsAggregateInput>;
  OR?: InputMaybe<Array<TimetableVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TimetableVersionsNodeAggregationWhereInput>;
};

export type TimetableVersionsConnectFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TimetableVersionConnectWhere>;
};

export type TimetableVersionsConnection = {
  __typename?: 'TimetableVersionsConnection';
  edges: Array<TimetableVersionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimetableVersionsConnectionSort = {
  node?: InputMaybe<TimetableVersionSort>;
};

export type TimetableVersionsConnectionWhere = {
  AND?: InputMaybe<Array<TimetableVersionsConnectionWhere>>;
  NOT?: InputMaybe<TimetableVersionsConnectionWhere>;
  OR?: InputMaybe<Array<TimetableVersionsConnectionWhere>>;
  node?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TimetableVersionWhere>;
};

export type TimetableVersionsCreateFieldInput = {
  node: TimetableVersionCreateInput;
};

export type TimetableVersionsDeleteFieldInput = {
  delete?: InputMaybe<TimetableVersionDeleteInput>;
  where?: InputMaybe<TimetableVersionsConnectionWhere>;
};

export type TimetableVersionsDisconnectFieldInput = {
  disconnect?: InputMaybe<TimetableVersionDisconnectInput>;
  where?: InputMaybe<TimetableVersionsConnectionWhere>;
};

export type TimetableVersionsFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionsCreateFieldInput>>;
};

export type TimetableVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TimetableVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TimetableVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TimetableVersionsNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TimetableVersionsUpdateConnectionInput = {
  node?: InputMaybe<TimetableVersionUpdateInput>;
};

export type TimetableVersionsUpdateFieldInput = {
  connect?: InputMaybe<Array<TimetableVersionsConnectFieldInput>>;
  create?: InputMaybe<Array<TimetableVersionsCreateFieldInput>>;
  delete?: InputMaybe<Array<TimetableVersionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TimetableVersionsDisconnectFieldInput>>;
  update?: InputMaybe<TimetableVersionsUpdateConnectionInput>;
  where?: InputMaybe<TimetableVersionsConnectionWhere>;
};

export type TimetableWhere = {
  AND?: InputMaybe<Array<TimetableWhere>>;
  NOT?: InputMaybe<TimetableWhere>;
  OR?: InputMaybe<Array<TimetableWhere>>;
  activeVersion?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  activeVersion_NOT?: InputMaybe<TimetableVersionWhere>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  comment_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  draft_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  foreignId?: InputMaybe<Scalars['String']['input']>;
  foreignId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  foreignId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  foreignId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  foreignId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  friEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  friEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  monEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  monEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<TimetableOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<TimetableOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<TimetableOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  satEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  satEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<TimetableSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<TimetableSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<TimetableSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  sunEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  sunEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  thuEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  thuEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `timegridConfigs_SOME` instead. */
  timegridConfigs?: InputMaybe<TimetableTimeGridConfigWhere>;
  timegridConfigsAggregate?: InputMaybe<TimetableTimegridConfigsAggregateInput>;
  /** @deprecated Use `timegridConfigsConnection_SOME` instead. */
  timegridConfigsConnection?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
  /** Return Timetables where all of the related TimetableTimegridConfigsConnections match this filter */
  timegridConfigsConnection_ALL?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
  /** Return Timetables where none of the related TimetableTimegridConfigsConnections match this filter */
  timegridConfigsConnection_NONE?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
  /** @deprecated Use `timegridConfigsConnection_NONE` instead. */
  timegridConfigsConnection_NOT?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
  /** Return Timetables where one of the related TimetableTimegridConfigsConnections match this filter */
  timegridConfigsConnection_SINGLE?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
  /** Return Timetables where some of the related TimetableTimegridConfigsConnections match this filter */
  timegridConfigsConnection_SOME?: InputMaybe<TimetableTimegridConfigsConnectionWhere>;
  /** Return Timetables where all of the related TimetableTimeGridConfigs match this filter */
  timegridConfigs_ALL?: InputMaybe<TimetableTimeGridConfigWhere>;
  /** Return Timetables where none of the related TimetableTimeGridConfigs match this filter */
  timegridConfigs_NONE?: InputMaybe<TimetableTimeGridConfigWhere>;
  /** @deprecated Use `timegridConfigs_NONE` instead. */
  timegridConfigs_NOT?: InputMaybe<TimetableTimeGridConfigWhere>;
  /** Return Timetables where one of the related TimetableTimeGridConfigs match this filter */
  timegridConfigs_SINGLE?: InputMaybe<TimetableTimeGridConfigWhere>;
  /** Return Timetables where some of the related TimetableTimeGridConfigs match this filter */
  timegridConfigs_SOME?: InputMaybe<TimetableTimeGridConfigWhere>;
  /** @deprecated Use `timetableBlocks_SOME` instead. */
  timetableBlocks?: InputMaybe<TimetableBlockWhere>;
  timetableBlocksAggregate?: InputMaybe<TimetableTimetableBlocksAggregateInput>;
  /** @deprecated Use `timetableBlocksConnection_SOME` instead. */
  timetableBlocksConnection?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
  /** Return Timetables where all of the related TimetableTimetableBlocksConnections match this filter */
  timetableBlocksConnection_ALL?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
  /** Return Timetables where none of the related TimetableTimetableBlocksConnections match this filter */
  timetableBlocksConnection_NONE?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
  /** @deprecated Use `timetableBlocksConnection_NONE` instead. */
  timetableBlocksConnection_NOT?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
  /** Return Timetables where one of the related TimetableTimetableBlocksConnections match this filter */
  timetableBlocksConnection_SINGLE?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
  /** Return Timetables where some of the related TimetableTimetableBlocksConnections match this filter */
  timetableBlocksConnection_SOME?: InputMaybe<TimetableTimetableBlocksConnectionWhere>;
  /** Return Timetables where all of the related TimetableBlocks match this filter */
  timetableBlocks_ALL?: InputMaybe<TimetableBlockWhere>;
  /** Return Timetables where none of the related TimetableBlocks match this filter */
  timetableBlocks_NONE?: InputMaybe<TimetableBlockWhere>;
  /** @deprecated Use `timetableBlocks_NONE` instead. */
  timetableBlocks_NOT?: InputMaybe<TimetableBlockWhere>;
  /** Return Timetables where one of the related TimetableBlocks match this filter */
  timetableBlocks_SINGLE?: InputMaybe<TimetableBlockWhere>;
  /** Return Timetables where some of the related TimetableBlocks match this filter */
  timetableBlocks_SOME?: InputMaybe<TimetableBlockWhere>;
  tueEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  tueEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  uuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `versions_SOME` instead. */
  versions?: InputMaybe<TimetableVersionWhere>;
  versionsAggregate?: InputMaybe<TimetableVersionsAggregateInput>;
  /** @deprecated Use `versionsConnection_SOME` instead. */
  versionsConnection?: InputMaybe<TimetableVersionsConnectionWhere>;
  /** Return Timetables where all of the related TimetableVersionsConnections match this filter */
  versionsConnection_ALL?: InputMaybe<TimetableVersionsConnectionWhere>;
  /** Return Timetables where none of the related TimetableVersionsConnections match this filter */
  versionsConnection_NONE?: InputMaybe<TimetableVersionsConnectionWhere>;
  /** @deprecated Use `versionsConnection_NONE` instead. */
  versionsConnection_NOT?: InputMaybe<TimetableVersionsConnectionWhere>;
  /** Return Timetables where one of the related TimetableVersionsConnections match this filter */
  versionsConnection_SINGLE?: InputMaybe<TimetableVersionsConnectionWhere>;
  /** Return Timetables where some of the related TimetableVersionsConnections match this filter */
  versionsConnection_SOME?: InputMaybe<TimetableVersionsConnectionWhere>;
  /** Return Timetables where all of the related TimetableVersions match this filter */
  versions_ALL?: InputMaybe<TimetableVersionWhere>;
  /** Return Timetables where none of the related TimetableVersions match this filter */
  versions_NONE?: InputMaybe<TimetableVersionWhere>;
  /** @deprecated Use `versions_NONE` instead. */
  versions_NOT?: InputMaybe<TimetableVersionWhere>;
  /** Return Timetables where one of the related TimetableVersions match this filter */
  versions_SINGLE?: InputMaybe<TimetableVersionWhere>;
  /** Return Timetables where some of the related TimetableVersions match this filter */
  versions_SOME?: InputMaybe<TimetableVersionWhere>;
  wedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  wedEnabled_NOT?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimetablesConnection = {
  __typename?: 'TimetablesConnection';
  edges: Array<TimetableEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UpdateAbsenceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<AbsenceReason>;
  removeSubstitutions?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateAdditionalTeachingLoadsMutationResponse = {
  __typename?: 'UpdateAdditionalTeachingLoadsMutationResponse';
  additionalTeachingLoads: Array<AdditionalTeachingLoad>;
  info: UpdateInfo;
};

export type UpdateBuildingsMutationResponse = {
  __typename?: 'UpdateBuildingsMutationResponse';
  buildings: Array<Building>;
  info: UpdateInfo;
};

export type UpdateClassesMutationResponse = {
  __typename?: 'UpdateClassesMutationResponse';
  classes: Array<Class>;
  info: UpdateInfo;
};

export type UpdateColumnSortsMutationResponse = {
  __typename?: 'UpdateColumnSortsMutationResponse';
  columnSorts: Array<ColumnSort>;
  info: UpdateInfo;
};

export type UpdateContractsMutationResponse = {
  __typename?: 'UpdateContractsMutationResponse';
  contracts: Array<Contract>;
  info: UpdateInfo;
};

export type UpdateCurriculaMutationResponse = {
  __typename?: 'UpdateCurriculaMutationResponse';
  curricula: Array<Curriculum>;
  info: UpdateInfo;
};

export type UpdateCurriculumClassesMutationResponse = {
  __typename?: 'UpdateCurriculumClassesMutationResponse';
  curriculumClasses: Array<CurriculumClass>;
  info: UpdateInfo;
};

export type UpdateCurriculumPeopleMutationResponse = {
  __typename?: 'UpdateCurriculumPeopleMutationResponse';
  curriculumPeople: Array<CurriculumPerson>;
  info: UpdateInfo;
};

export type UpdateCurriculumUnitsMutationResponse = {
  __typename?: 'UpdateCurriculumUnitsMutationResponse';
  curriculumUnits: Array<CurriculumUnit>;
  info: UpdateInfo;
};

export type UpdateCurriculumVersionsMutationResponse = {
  __typename?: 'UpdateCurriculumVersionsMutationResponse';
  curriculumVersions: Array<CurriculumVersion>;
  info: UpdateInfo;
};

export type UpdateDependenciesMutationResponse = {
  __typename?: 'UpdateDependenciesMutationResponse';
  dependencies: Array<Dependency>;
  info: UpdateInfo;
};

export type UpdateDivisionsMutationResponse = {
  __typename?: 'UpdateDivisionsMutationResponse';
  divisions: Array<Division>;
  info: UpdateInfo;
};

export type UpdateEventJobsMutationResponse = {
  __typename?: 'UpdateEventJobsMutationResponse';
  eventJobs: Array<EventJob>;
  info: UpdateInfo;
};

export type UpdateFileEntriesMutationResponse = {
  __typename?: 'UpdateFileEntriesMutationResponse';
  fileEntries: Array<FileEntry>;
  info: UpdateInfo;
};

export type UpdateGradeGroupsMutationResponse = {
  __typename?: 'UpdateGradeGroupsMutationResponse';
  gradeGroups: Array<GradeGroup>;
  info: UpdateInfo;
};

export type UpdateGroupsMutationResponse = {
  __typename?: 'UpdateGroupsMutationResponse';
  groups: Array<Group>;
  info: UpdateInfo;
};

export type UpdateHolidaysMutationResponse = {
  __typename?: 'UpdateHolidaysMutationResponse';
  holidays: Array<Holiday>;
  info: UpdateInfo;
};

/** Information about the number of nodes and relationships created and deleted during an update mutation */
export type UpdateInfo = {
  __typename?: 'UpdateInfo';
  nodesCreated: Scalars['Int']['output'];
  nodesDeleted: Scalars['Int']['output'];
  relationshipsCreated: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type UpdateLabelsMutationResponse = {
  __typename?: 'UpdateLabelsMutationResponse';
  info: UpdateInfo;
  labels: Array<Label>;
};

export type UpdateLessonClassesMutationResponse = {
  __typename?: 'UpdateLessonClassesMutationResponse';
  info: UpdateInfo;
  lessonClasses: Array<LessonClass>;
};

export type UpdateLessonUnitsMutationResponse = {
  __typename?: 'UpdateLessonUnitsMutationResponse';
  info: UpdateInfo;
  lessonUnits: Array<LessonUnit>;
};

export type UpdateLessonsMutationResponse = {
  __typename?: 'UpdateLessonsMutationResponse';
  info: UpdateInfo;
  lessons: Array<Lesson>;
};

export type UpdateLockedsMutationResponse = {
  __typename?: 'UpdateLockedsMutationResponse';
  info: UpdateInfo;
  lockeds: Array<Locked>;
};

export type UpdateMathplanJobsMutationResponse = {
  __typename?: 'UpdateMathplanJobsMutationResponse';
  info: UpdateInfo;
  mathplanJobs: Array<MathplanJob>;
};

export type UpdateOrganizationsMutationResponse = {
  __typename?: 'UpdateOrganizationsMutationResponse';
  info: UpdateInfo;
  organizations: Array<Organization>;
};

export type UpdatePasswordsMutationResponse = {
  __typename?: 'UpdatePasswordsMutationResponse';
  users: Array<Scalars['ID']['output']>;
};

export type UpdatePeopleMutationResponse = {
  __typename?: 'UpdatePeopleMutationResponse';
  info: UpdateInfo;
  people: Array<Person>;
};

export type UpdatePublishedSubstitutionsMutationResponse = {
  __typename?: 'UpdatePublishedSubstitutionsMutationResponse';
  info: UpdateInfo;
  publishedSubstitutions: Array<PublishedSubstitutions>;
};

export type UpdateQualificationsMutationResponse = {
  __typename?: 'UpdateQualificationsMutationResponse';
  info: UpdateInfo;
  qualifications: Array<Qualification>;
};

export type UpdateResponse = {
  __typename?: 'UpdateResponse';
  nodeUuids: Array<Scalars['String']['output']>;
  nodesUpdated: Scalars['Int']['output'];
};

export type UpdateRoomsMutationResponse = {
  __typename?: 'UpdateRoomsMutationResponse';
  info: UpdateInfo;
  rooms: Array<Room>;
};

export type UpdateSchoolYearsMutationResponse = {
  __typename?: 'UpdateSchoolYearsMutationResponse';
  info: UpdateInfo;
  schoolYears: Array<SchoolYear>;
};

/** Custom mutations */
export type UpdateShortNamesMutationResponse = {
  __typename?: 'UpdateShortNamesMutationResponse';
  updated: Scalars['Int']['output'];
};

export type UpdateSubjectContainersMutationResponse = {
  __typename?: 'UpdateSubjectContainersMutationResponse';
  info: UpdateInfo;
  subjectContainers: Array<SubjectContainer>;
};

export type UpdateSubjectGroupsMutationResponse = {
  __typename?: 'UpdateSubjectGroupsMutationResponse';
  info: UpdateInfo;
  subjectGroups: Array<SubjectGroup>;
};

export type UpdateSubjectsMutationResponse = {
  __typename?: 'UpdateSubjectsMutationResponse';
  info: UpdateInfo;
  subjects: Array<Subject>;
};

export type UpdateSubstitutionAnnouncementsMutationResponse = {
  __typename?: 'UpdateSubstitutionAnnouncementsMutationResponse';
  info: UpdateInfo;
  substitutionAnnouncements: Array<SubstitutionAnnouncement>;
};

export type UpdateSubstitutionAppConfigsMutationResponse = {
  __typename?: 'UpdateSubstitutionAppConfigsMutationResponse';
  info: UpdateInfo;
  substitutionAppConfigs: Array<SubstitutionAppConfig>;
};

export type UpdateSubstitutionPrintColumnConfigsMutationResponse = {
  __typename?: 'UpdateSubstitutionPrintColumnConfigsMutationResponse';
  info: UpdateInfo;
  substitutionPrintColumnConfigs: Array<SubstitutionPrintColumnConfig>;
};

export type UpdateSubstitutionPrintConfigsMutationResponse = {
  __typename?: 'UpdateSubstitutionPrintConfigsMutationResponse';
  info: UpdateInfo;
  substitutionPrintConfigs: Array<SubstitutionPrintConfig>;
};

export type UpdateSubstitutionReportsMutationResponse = {
  __typename?: 'UpdateSubstitutionReportsMutationResponse';
  info: UpdateInfo;
  substitutionReports: Array<SubstitutionReport>;
};

export type UpdateTableConfigsMutationResponse = {
  __typename?: 'UpdateTableConfigsMutationResponse';
  info: UpdateInfo;
  tableConfigs: Array<TableConfig>;
};

export type UpdateTeachingBlockAvailabilityExclusionsMutationResponse = {
  __typename?: 'UpdateTeachingBlockAvailabilityExclusionsMutationResponse';
  info: UpdateInfo;
  teachingBlockAvailabilityExclusions: Array<TeachingBlockAvailabilityExclusion>;
};

export type UpdateTeachingBlockCardsMutationResponse = {
  __typename?: 'UpdateTeachingBlockCardsMutationResponse';
  info: UpdateInfo;
  teachingBlockCards: Array<TeachingBlockCard>;
};

export type UpdateTeachingBlockVersionsMutationResponse = {
  __typename?: 'UpdateTeachingBlockVersionsMutationResponse';
  info: UpdateInfo;
  teachingBlockVersions: Array<TeachingBlockVersion>;
};

export type UpdateTeachingBlocksMutationResponse = {
  __typename?: 'UpdateTeachingBlocksMutationResponse';
  info: UpdateInfo;
  teachingBlocks: Array<TeachingBlock>;
};

export type UpdateTeachingLoadFactorsMutationResponse = {
  __typename?: 'UpdateTeachingLoadFactorsMutationResponse';
  info: UpdateInfo;
  teachingLoadFactors: Array<TeachingLoadFactor>;
};

export type UpdateTeachingLoadReportsMutationResponse = {
  __typename?: 'UpdateTeachingLoadReportsMutationResponse';
  info: UpdateInfo;
  teachingLoadReports: Array<TeachingLoadReport>;
};

export type UpdateTeachingLoadScenariosMutationResponse = {
  __typename?: 'UpdateTeachingLoadScenariosMutationResponse';
  info: UpdateInfo;
  teachingLoadScenarios: Array<TeachingLoadScenario>;
};

export type UpdateTimeGridEntriesMutationResponse = {
  __typename?: 'UpdateTimeGridEntriesMutationResponse';
  info: UpdateInfo;
  timeGridEntries: Array<TimeGridEntry>;
};

export type UpdateTimeGridsMutationResponse = {
  __typename?: 'UpdateTimeGridsMutationResponse';
  info: UpdateInfo;
  timeGrids: Array<TimeGrid>;
};

export type UpdateTimespansMutationResponse = {
  __typename?: 'UpdateTimespansMutationResponse';
  info: UpdateInfo;
  timespans: Array<Timespan>;
};

export type UpdateTimetableBlocksMutationResponse = {
  __typename?: 'UpdateTimetableBlocksMutationResponse';
  info: UpdateInfo;
  timetableBlocks: Array<TimetableBlock>;
};

export type UpdateTimetableCardsMutationResponse = {
  __typename?: 'UpdateTimetableCardsMutationResponse';
  info: UpdateInfo;
  timetableCards: Array<TimetableCard>;
};

export type UpdateTimetableConfigsMutationResponse = {
  __typename?: 'UpdateTimetableConfigsMutationResponse';
  info: UpdateInfo;
  timetableConfigs: Array<TimetableConfig>;
};

export type UpdateTimetablePrintConfigsMutationResponse = {
  __typename?: 'UpdateTimetablePrintConfigsMutationResponse';
  info: UpdateInfo;
  timetablePrintConfigs: Array<TimetablePrintConfig>;
};

export type UpdateTimetableReportsMutationResponse = {
  __typename?: 'UpdateTimetableReportsMutationResponse';
  info: UpdateInfo;
  timetableReports: Array<TimetableReport>;
};

export type UpdateTimetableTimeGridConfigsMutationResponse = {
  __typename?: 'UpdateTimetableTimeGridConfigsMutationResponse';
  info: UpdateInfo;
  timetableTimeGridConfigs: Array<TimetableTimeGridConfig>;
};

export type UpdateTimetableVersionsMutationResponse = {
  __typename?: 'UpdateTimetableVersionsMutationResponse';
  info: UpdateInfo;
  timetableVersions: Array<TimetableVersion>;
};

export type UpdateTimetablesMutationResponse = {
  __typename?: 'UpdateTimetablesMutationResponse';
  info: UpdateInfo;
  timetables: Array<Timetable>;
};

export type UpdateUserConfigsMutationResponse = {
  __typename?: 'UpdateUserConfigsMutationResponse';
  info: UpdateInfo;
  userConfigs: Array<UserConfig>;
};

export type UserConfig = {
  __typename?: 'UserConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  pimProfileUuid: Scalars['ID']['output'];
  schoolYear?: Maybe<SchoolYear>;
  schoolYearConnection: UserConfigSchoolYearConnection;
  tableConfigs: Array<TableConfig>;
  tableConfigsConnection: UserConfigTableConfigsConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserConfigSchoolYearArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolYearOptions>;
  where?: InputMaybe<SchoolYearWhere>;
};

export type UserConfigSchoolYearConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserConfigSchoolYearConnectionSort>>;
  where?: InputMaybe<UserConfigSchoolYearConnectionWhere>;
};

export type UserConfigTableConfigsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TableConfigOptions>;
  where?: InputMaybe<TableConfigWhere>;
};

export type UserConfigTableConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserConfigTableConfigsConnectionSort>>;
  where?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
};

export type UserConfigAggregateSelection = {
  __typename?: 'UserConfigAggregateSelection';
  count: Scalars['Int']['output'];
  createdAt: DateTimeAggregateSelection;
  pimProfileUuid: IdAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type UserConfigConnectInput = {
  schoolYear?: InputMaybe<UserConfigSchoolYearConnectFieldInput>;
  tableConfigs?: InputMaybe<Array<UserConfigTableConfigsConnectFieldInput>>;
};

export type UserConfigConnectWhere = {
  node: UserConfigWhere;
};

export type UserConfigCreateInput = {
  pimProfileUuid: Scalars['ID']['input'];
  schoolYear?: InputMaybe<UserConfigSchoolYearFieldInput>;
  tableConfigs?: InputMaybe<UserConfigTableConfigsFieldInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserConfigDeleteInput = {
  schoolYear?: InputMaybe<UserConfigSchoolYearDeleteFieldInput>;
  tableConfigs?: InputMaybe<Array<UserConfigTableConfigsDeleteFieldInput>>;
};

export type UserConfigDisconnectInput = {
  schoolYear?: InputMaybe<UserConfigSchoolYearDisconnectFieldInput>;
  tableConfigs?: InputMaybe<Array<UserConfigTableConfigsDisconnectFieldInput>>;
};

export type UserConfigEdge = {
  __typename?: 'UserConfigEdge';
  cursor: Scalars['String']['output'];
  node: UserConfig;
};

export type UserConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserConfigSort objects to sort UserConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserConfigSort>>;
};

export type UserConfigSchoolYearAggregateInput = {
  AND?: InputMaybe<Array<UserConfigSchoolYearAggregateInput>>;
  NOT?: InputMaybe<UserConfigSchoolYearAggregateInput>;
  OR?: InputMaybe<Array<UserConfigSchoolYearAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserConfigSchoolYearNodeAggregationWhereInput>;
};

export type UserConfigSchoolYearConnectFieldInput = {
  connect?: InputMaybe<SchoolYearConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolYearConnectWhere>;
};

export type UserConfigSchoolYearConnection = {
  __typename?: 'UserConfigSchoolYearConnection';
  edges: Array<UserConfigSchoolYearRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserConfigSchoolYearConnectionSort = {
  node?: InputMaybe<SchoolYearSort>;
};

export type UserConfigSchoolYearConnectionWhere = {
  AND?: InputMaybe<Array<UserConfigSchoolYearConnectionWhere>>;
  NOT?: InputMaybe<UserConfigSchoolYearConnectionWhere>;
  OR?: InputMaybe<Array<UserConfigSchoolYearConnectionWhere>>;
  node?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<SchoolYearWhere>;
};

export type UserConfigSchoolYearCreateFieldInput = {
  node: SchoolYearCreateInput;
};

export type UserConfigSchoolYearDeleteFieldInput = {
  delete?: InputMaybe<SchoolYearDeleteInput>;
  where?: InputMaybe<UserConfigSchoolYearConnectionWhere>;
};

export type UserConfigSchoolYearDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolYearDisconnectInput>;
  where?: InputMaybe<UserConfigSchoolYearConnectionWhere>;
};

export type UserConfigSchoolYearFieldInput = {
  connect?: InputMaybe<UserConfigSchoolYearConnectFieldInput>;
  create?: InputMaybe<UserConfigSchoolYearCreateFieldInput>;
};

export type UserConfigSchoolYearNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserConfigSchoolYearNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserConfigSchoolYearNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserConfigSchoolYearNodeAggregationWhereInput>>;
  costPerHour_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  costPerHour_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fullTimeHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTimeHours_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserConfigSchoolYearRelationship = {
  __typename?: 'UserConfigSchoolYearRelationship';
  cursor: Scalars['String']['output'];
  node: SchoolYear;
};

export type UserConfigSchoolYearUpdateConnectionInput = {
  node?: InputMaybe<SchoolYearUpdateInput>;
};

export type UserConfigSchoolYearUpdateFieldInput = {
  connect?: InputMaybe<UserConfigSchoolYearConnectFieldInput>;
  create?: InputMaybe<UserConfigSchoolYearCreateFieldInput>;
  delete?: InputMaybe<UserConfigSchoolYearDeleteFieldInput>;
  disconnect?: InputMaybe<UserConfigSchoolYearDisconnectFieldInput>;
  update?: InputMaybe<UserConfigSchoolYearUpdateConnectionInput>;
  where?: InputMaybe<UserConfigSchoolYearConnectionWhere>;
};

/** Fields to sort UserConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserConfigSort object. */
export type UserConfigSort = {
  createdAt?: InputMaybe<SortDirection>;
  pimProfileUuid?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type UserConfigTableConfigsAggregateInput = {
  AND?: InputMaybe<Array<UserConfigTableConfigsAggregateInput>>;
  NOT?: InputMaybe<UserConfigTableConfigsAggregateInput>;
  OR?: InputMaybe<Array<UserConfigTableConfigsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserConfigTableConfigsNodeAggregationWhereInput>;
};

export type UserConfigTableConfigsConnectFieldInput = {
  connect?: InputMaybe<Array<TableConfigConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TableConfigConnectWhere>;
};

export type UserConfigTableConfigsConnection = {
  __typename?: 'UserConfigTableConfigsConnection';
  edges: Array<UserConfigTableConfigsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserConfigTableConfigsConnectionSort = {
  node?: InputMaybe<TableConfigSort>;
};

export type UserConfigTableConfigsConnectionWhere = {
  AND?: InputMaybe<Array<UserConfigTableConfigsConnectionWhere>>;
  NOT?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
  OR?: InputMaybe<Array<UserConfigTableConfigsConnectionWhere>>;
  node?: InputMaybe<TableConfigWhere>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  node_NOT?: InputMaybe<TableConfigWhere>;
};

export type UserConfigTableConfigsCreateFieldInput = {
  node: TableConfigCreateInput;
};

export type UserConfigTableConfigsDeleteFieldInput = {
  delete?: InputMaybe<TableConfigDeleteInput>;
  where?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
};

export type UserConfigTableConfigsDisconnectFieldInput = {
  disconnect?: InputMaybe<TableConfigDisconnectInput>;
  where?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
};

export type UserConfigTableConfigsFieldInput = {
  connect?: InputMaybe<Array<UserConfigTableConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<UserConfigTableConfigsCreateFieldInput>>;
};

export type UserConfigTableConfigsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserConfigTableConfigsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserConfigTableConfigsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserConfigTableConfigsNodeAggregationWhereInput>>;
  table_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  table_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  table_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  table_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  table_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserConfigTableConfigsRelationship = {
  __typename?: 'UserConfigTableConfigsRelationship';
  cursor: Scalars['String']['output'];
  node: TableConfig;
};

export type UserConfigTableConfigsUpdateConnectionInput = {
  node?: InputMaybe<TableConfigUpdateInput>;
};

export type UserConfigTableConfigsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserConfigTableConfigsConnectFieldInput>>;
  create?: InputMaybe<Array<UserConfigTableConfigsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserConfigTableConfigsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserConfigTableConfigsDisconnectFieldInput>>;
  update?: InputMaybe<UserConfigTableConfigsUpdateConnectionInput>;
  where?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
};

export type UserConfigUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  pimProfileUuid?: InputMaybe<Scalars['ID']['input']>;
  schoolYear?: InputMaybe<UserConfigSchoolYearUpdateFieldInput>;
  tableConfigs?: InputMaybe<Array<UserConfigTableConfigsUpdateFieldInput>>;
};

export type UserConfigWhere = {
  AND?: InputMaybe<Array<UserConfigWhere>>;
  NOT?: InputMaybe<UserConfigWhere>;
  OR?: InputMaybe<Array<UserConfigWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  createdAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pimProfileUuid?: InputMaybe<Scalars['ID']['input']>;
  pimProfileUuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  pimProfileUuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  pimProfileUuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  pimProfileUuid_NOT_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  pimProfileUuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  schoolYear?: InputMaybe<SchoolYearWhere>;
  schoolYearAggregate?: InputMaybe<UserConfigSchoolYearAggregateInput>;
  schoolYearConnection?: InputMaybe<UserConfigSchoolYearConnectionWhere>;
  schoolYearConnection_NOT?: InputMaybe<UserConfigSchoolYearConnectionWhere>;
  schoolYear_NOT?: InputMaybe<SchoolYearWhere>;
  /** @deprecated Use `tableConfigs_SOME` instead. */
  tableConfigs?: InputMaybe<TableConfigWhere>;
  tableConfigsAggregate?: InputMaybe<UserConfigTableConfigsAggregateInput>;
  /** @deprecated Use `tableConfigsConnection_SOME` instead. */
  tableConfigsConnection?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
  /** Return UserConfigs where all of the related UserConfigTableConfigsConnections match this filter */
  tableConfigsConnection_ALL?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
  /** Return UserConfigs where none of the related UserConfigTableConfigsConnections match this filter */
  tableConfigsConnection_NONE?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
  /** @deprecated Use `tableConfigsConnection_NONE` instead. */
  tableConfigsConnection_NOT?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
  /** Return UserConfigs where one of the related UserConfigTableConfigsConnections match this filter */
  tableConfigsConnection_SINGLE?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
  /** Return UserConfigs where some of the related UserConfigTableConfigsConnections match this filter */
  tableConfigsConnection_SOME?: InputMaybe<UserConfigTableConfigsConnectionWhere>;
  /** Return UserConfigs where all of the related TableConfigs match this filter */
  tableConfigs_ALL?: InputMaybe<TableConfigWhere>;
  /** Return UserConfigs where none of the related TableConfigs match this filter */
  tableConfigs_NONE?: InputMaybe<TableConfigWhere>;
  /** @deprecated Use `tableConfigs_NONE` instead. */
  tableConfigs_NOT?: InputMaybe<TableConfigWhere>;
  /** Return UserConfigs where one of the related TableConfigs match this filter */
  tableConfigs_SINGLE?: InputMaybe<TableConfigWhere>;
  /** Return UserConfigs where some of the related TableConfigs match this filter */
  tableConfigs_SOME?: InputMaybe<TableConfigWhere>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Negation filters will be deprecated, use the NOT operator to achieve the same behavior */
  updatedAt_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export type UserConfigsConnection = {
  __typename?: 'UserConfigsConnection';
  edges: Array<UserConfigEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum UserStatus {
  Full = 'full',
  ImpersonateOnly = 'impersonateOnly',
  Invited = 'invited',
  None = 'none',
}

export enum ValueMode {
  Lesson = 'LESSON',
  UnitCount = 'UNIT_COUNT',
  UnitDurationCount = 'UNIT_DURATION_COUNT',
}

export type AbsencesQueryVariables = Exact<{
  where: AbsenceWhere;
}>;

export type AbsencesQuery = {
  __typename?: 'Query';
  absences: Array<{
    __typename?: 'Absence';
    uuid: string;
    reason: AbsenceReason;
    start: any;
    end: any;
    comment?: string | null;
    person: { __typename?: 'Person'; uuid: string; listName: string; displayNameShort?: string | null };
  }>;
};

export type CreateAbsenceMutationVariables = Exact<{
  input: CreateAbsenceInput;
}>;

export type CreateAbsenceMutation = {
  __typename?: 'Mutation';
  createAbsence: { __typename?: 'CreateResponse'; nodeUuids: Array<string> };
};

export type DeleteAbsenceMutationVariables = Exact<{
  input: OnlyUuids;
  removeSubstitutions: Scalars['Boolean']['input'];
}>;

export type DeleteAbsenceMutation = {
  __typename?: 'Mutation';
  deleteAbsence: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateAbsenceMutationVariables = Exact<{
  input: OnlyUuids;
  update: UpdateAbsenceInput;
}>;

export type UpdateAbsenceMutation = {
  __typename?: 'Mutation';
  updateAbsence: { __typename?: 'UpdateResponse'; nodeUuids: Array<string> };
};

export type CreateBuildingsMutationVariables = Exact<{
  input: Array<BuildingCreateInput> | BuildingCreateInput;
}>;

export type CreateBuildingsMutation = {
  __typename?: 'Mutation';
  createBuildings: {
    __typename?: 'CreateBuildingsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateBuildingsMutationVariables = Exact<{
  where?: InputMaybe<BuildingWhere>;
  update?: InputMaybe<BuildingUpdateInput>;
}>;

export type UpdateBuildingsMutation = {
  __typename?: 'Mutation';
  updateBuildings: {
    __typename?: 'UpdateBuildingsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type DeleteBuildingsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteBuildingsMutation = {
  __typename?: 'Mutation';
  deleteBuildings: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type BuildingsListQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  buildingUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type BuildingsListQuery = {
  __typename?: 'Query';
  buildings: Array<{
    __typename?: 'Building';
    uuid: string;
    name: string;
    description?: string | null;
    active?: boolean | null;
  }>;
};

export type DeleteClassDivisionsMutationVariables = Exact<{
  where?: InputMaybe<DivisionWhere>;
}>;

export type DeleteClassDivisionsMutation = {
  __typename?: 'Mutation';
  deleteDivisions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateClassDivisionsMutationVariables = Exact<{
  input: Array<DivisionCreateInput> | DivisionCreateInput;
}>;

export type CreateClassDivisionsMutation = {
  __typename?: 'Mutation';
  createDivisions: {
    __typename?: 'CreateDivisionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateClassDivisionsMutationVariables = Exact<{
  where?: InputMaybe<DivisionWhere>;
  update?: InputMaybe<DivisionUpdateInput>;
}>;

export type UpdateClassDivisionsMutation = {
  __typename?: 'Mutation';
  updateDivisions: {
    __typename?: 'UpdateDivisionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type ClassDivisionsClassesListQueryVariables = Exact<{
  where?: InputMaybe<ClassWhere>;
}>;

export type ClassDivisionsClassesListQuery = {
  __typename?: 'Query';
  classes: Array<{
    __typename?: 'Class';
    uuid: string;
    name: string;
    shortName: string;
    grade?: number | null;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null; colorLabel?: string | null } | null;
    divisionsAggregate?: { __typename?: 'ClassDivisionDivisionsAggregationSelection'; count: number } | null;
  }>;
};

export type ClassDivisionsListQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  classUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ClassDivisionsListQuery = {
  __typename?: 'Query';
  divisions: Array<{
    __typename?: 'Division';
    name: string;
    uuid: string;
    groupsConnection: {
      __typename?: 'DivisionGroupsConnection';
      edges: Array<{
        __typename?: 'DivisionGroupsRelationship';
        node: { __typename?: 'Group'; uuid: string; shortName: string; name: string };
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
      }>;
    };
  }>;
  classes: Array<{ __typename?: 'Class'; name: string; uuid: string }>;
};

export type DeleteClassesMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteClassesMutation = {
  __typename?: 'Mutation';
  deleteClasses: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateClassesMutationVariables = Exact<{
  where?: InputMaybe<ClassWhere>;
  update?: InputMaybe<ClassUpdateInput>;
  resultTutorsSort?: InputMaybe<Array<ClassTutorsConnectionSort> | ClassTutorsConnectionSort>;
}>;

export type UpdateClassesMutation = {
  __typename?: 'Mutation';
  updateClasses: {
    __typename?: 'UpdateClassesMutationResponse';
    classes: Array<{
      __typename?: 'Class';
      uuid: string;
      name: string;
      shortName: string;
      grade?: number | null;
      certificatesEnabled?: boolean | null;
      gradeGroup?: {
        __typename?: 'GradeGroup';
        uuid: string;
        name: string;
        shortName: string;
        description?: string | null;
        class: Array<{ __typename?: 'Class'; uuid: string }>;
      } | null;
      timetableConfig?: {
        __typename?: 'TimetableConfig';
        color?: string | null;
        colorLabel?: string | null;
        printOrder?: number | null;
        printPageNr?: number | null;
      } | null;
      tutorsConnection: {
        __typename?: 'ClassTutorsConnection';
        edges: Array<{
          __typename?: 'ClassTutorsRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: {
            __typename?: 'Person';
            uuid: string;
            personalId?: string | null;
            email?: string | null;
            birthday?: any | null;
            firstName: string;
            lastName: string;
            fullName: string;
            shortName: string;
          };
        }>;
      };
    }>;
  };
};

export type CreateClassMutationVariables = Exact<{
  input: Array<ClassCreateInput> | ClassCreateInput;
  resultTutorsSort?: InputMaybe<Array<ClassTutorsConnectionSort> | ClassTutorsConnectionSort>;
}>;

export type CreateClassMutation = {
  __typename?: 'Mutation';
  createClasses: {
    __typename?: 'CreateClassesMutationResponse';
    classes: Array<{
      __typename?: 'Class';
      uuid: string;
      name: string;
      shortName: string;
      grade?: number | null;
      certificatesEnabled?: boolean | null;
      gradeGroup?: {
        __typename?: 'GradeGroup';
        uuid: string;
        name: string;
        shortName: string;
        description?: string | null;
        class: Array<{ __typename?: 'Class'; uuid: string }>;
      } | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string; name: string };
      timetableConfig?: {
        __typename?: 'TimetableConfig';
        color?: string | null;
        colorLabel?: string | null;
        printOrder?: number | null;
        printPageNr?: number | null;
      } | null;
      tutorsConnection: {
        __typename?: 'ClassTutorsConnection';
        edges: Array<{
          __typename?: 'ClassTutorsRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: {
            __typename?: 'Person';
            uuid: string;
            personalId?: string | null;
            email?: string | null;
            birthday?: any | null;
            firstName: string;
            lastName: string;
            fullName: string;
            shortName: string;
          };
        }>;
      };
    }>;
  };
};

export type _UpdateClassesColorsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  color: Scalars['String']['input'];
}>;

export type _UpdateClassesColorsMutation = {
  __typename?: 'Mutation';
  updateClasses: {
    __typename?: 'UpdateClassesMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type _UpdateClassesAttendancePlanShowInSubstitutionPlanMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  functionalClassSubstitutionBehavior?: InputMaybe<FunctionalClassSubstitutionBehavior>;
}>;

export type _UpdateClassesAttendancePlanShowInSubstitutionPlanMutation = {
  __typename?: 'Mutation';
  updateClasses: {
    __typename?: 'UpdateClassesMutationResponse';
    info: { __typename: 'UpdateInfo'; nodesCreated: number };
  };
};

export type ClassesListQueryVariables = Exact<{
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  schoolYearUuid?: InputMaybe<Scalars['ID']['input']>;
  classUuid?: InputMaybe<Scalars['ID']['input']>;
  sort?: InputMaybe<Array<ClassSort> | ClassSort>;
}>;

export type ClassesListQuery = {
  __typename?: 'Query';
  classes: Array<{
    __typename?: 'Class';
    uuid: string;
    name: string;
    shortName: string;
    grade?: number | null;
    certificatesEnabled?: boolean | null;
    defaultRoom?: { __typename?: 'Room'; uuid: string } | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    divisions: Array<{
      __typename?: 'Division';
      uuid: string;
      name: string;
      groupsConnection: {
        __typename?: 'DivisionGroupsConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'DivisionGroupsRelationship';
          node: { __typename?: 'Group'; uuid: string; name: string; shortName: string; classFraction: number };
        }>;
      };
      class?: { __typename?: 'Class'; uuid: string } | null;
    }>;
    gradeGroup?: {
      __typename?: 'GradeGroup';
      uuid: string;
      name: string;
      shortName: string;
      description?: string | null;
      class: Array<{ __typename?: 'Class'; uuid: string }>;
    } | null;
    timetableConfig?: {
      __typename?: 'TimetableConfig';
      color?: string | null;
      colorLabel?: string | null;
      printOrder?: number | null;
      printPageNr?: number | null;
    } | null;
    tutorsConnection: {
      __typename?: 'ClassTutorsConnection';
      edges: Array<{
        __typename?: 'ClassTutorsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: {
          __typename?: 'Person';
          uuid: string;
          personalId?: string | null;
          email?: string | null;
          birthday?: any | null;
          firstName: string;
          lastName: string;
          fullName: string;
          shortName: string;
          displayNameShort?: string | null;
          listName: string;
          selectName: string;
        };
      }>;
    };
  }>;
  people: Array<{
    __typename?: 'Person';
    uuid: string;
    firstName: string;
    lastName: string;
    fullName: string;
    displayNameShort?: string | null;
    selectName: string;
  }>;
};

export type ClassesQueryVariables = Exact<{
  where?: InputMaybe<ClassWhere>;
}>;

export type ClassesQuery = {
  __typename?: 'Query';
  classes: Array<{
    __typename?: 'Class';
    uuid: string;
    name: string;
    shortName: string;
    grade?: number | null;
    gradeGroup?: {
      __typename?: 'GradeGroup';
      uuid: string;
      name: string;
      shortName: string;
      description?: string | null;
      class: Array<{ __typename?: 'Class'; uuid: string }>;
    } | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
  }>;
};

export type CreateCurriculaMutationVariables = Exact<{
  input: Array<CurriculumCreateInput> | CurriculumCreateInput;
}>;

export type CreateCurriculaMutation = {
  __typename?: 'Mutation';
  createCurricula: {
    __typename?: 'CreateCurriculaMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type CreateCurriculumVersionMutationVariables = Exact<{
  input: Array<CurriculumVersionCreateInput> | CurriculumVersionCreateInput;
}>;

export type CreateCurriculumVersionMutation = {
  __typename?: 'Mutation';
  createCurriculumVersions: {
    __typename?: 'CreateCurriculumVersionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type DeleteCurriculumVersionMutationVariables = Exact<{
  where: CurriculumVersionWhere;
}>;

export type DeleteCurriculumVersionMutation = {
  __typename?: 'Mutation';
  deleteCurriculumVersions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateLabelsMutationVariables = Exact<{
  input: Array<LabelCreateInput> | LabelCreateInput;
}>;

export type CreateLabelsMutation = {
  __typename?: 'Mutation';
  createLabels: { __typename?: 'CreateLabelsMutationResponse'; labels: Array<{ __typename?: 'Label'; uuid: string }> };
};

export type UpdateCurriculumVersionsMutationVariables = Exact<{
  update?: InputMaybe<CurriculumVersionUpdateInput>;
  where?: InputMaybe<CurriculumVersionWhere>;
}>;

export type UpdateCurriculumVersionsMutation = {
  __typename?: 'Mutation';
  updateCurriculumVersions: {
    __typename?: 'UpdateCurriculumVersionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type UpdateCurriculaMutationVariables = Exact<{
  where?: InputMaybe<CurriculumWhere>;
  update?: InputMaybe<CurriculumUpdateInput>;
}>;

export type UpdateCurriculaMutation = {
  __typename?: 'Mutation';
  updateCurricula: {
    __typename?: 'UpdateCurriculaMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type DeleteCurriculaMutationVariables = Exact<{
  where?: InputMaybe<CurriculumWhere>;
  delete?: InputMaybe<CurriculumDeleteInput>;
}>;

export type DeleteCurriculaMutation = {
  __typename?: 'Mutation';
  deleteCurricula: { __typename?: 'DeleteInfo'; nodesDeleted: number; relationshipsDeleted: number };
};

export type CurriculumVersionsListQueryVariables = Exact<{
  where?: InputMaybe<CurriculumVersionWhere>;
}>;

export type CurriculumVersionsListQuery = {
  __typename?: 'Query';
  curriculumVersions: Array<{
    __typename?: 'CurriculumVersion';
    uuid: string;
    name: string;
    description?: string | null;
    curricula: Array<{
      __typename?: 'Curriculum';
      comment?: string | null;
      createdAt?: any | null;
      displayName: Array<string>;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      subTitle?: string | null;
      uuid: string;
      timetableEnabled?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      groupGradeNames: Array<string>;
      lessons: Array<{
        __typename?: 'Lesson';
        uuid: string;
        lessonClassesAggregate?: {
          __typename?: 'LessonLessonClassLessonClassesAggregationSelection';
          count: number;
        } | null;
        schoolYear: { __typename?: 'SchoolYear'; uuid: string };
      }>;
      subject:
        | {
            __typename?: 'Subject';
            uuid: string;
            name: string;
            shortName: string;
            epochEnabled?: boolean | null;
            subjectHourEnabled?: boolean | null;
            active?: boolean | null;
            other?: boolean | null;
            createdAt?: any | null;
            updatedAt?: any | null;
          }
        | {
            __typename?: 'SubjectContainer';
            uuid: string;
            name: string;
            shortName: string;
            order?: number | null;
            grades: Array<number>;
            createdAt?: any | null;
            updatedAt?: any | null;
          };
      curriculumUnit: Array<{
        __typename?: 'CurriculumUnit';
        uuid: string;
        duration?: number | null;
        count?: number | null;
        subjectContainer?: {
          __typename?: 'SubjectContainer';
          uuid: string;
          name: string;
          shortName: string;
          order?: number | null;
          grades: Array<number>;
          createdAt?: any | null;
          updatedAt?: any | null;
        } | null;
      }>;
      curriculumUnitConnection: {
        __typename?: 'CurriculumCurriculumUnitConnection';
        edges: Array<{
          __typename?: 'CurriculumCurriculumUnitRelationship';
          node: {
            __typename?: 'CurriculumUnit';
            uuid: string;
            subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string } | null;
          };
        }>;
      };
      curriculumGrades: Array<{
        __typename?: 'CurriculumClass';
        uuid: string;
        grades: Array<number>;
        gradeGroups: Array<{
          __typename?: 'GradeGroup';
          uuid: string;
          name: string;
          shortName: string;
          description?: string | null;
          class: Array<{ __typename?: 'Class'; uuid: string }>;
        }>;
        groups: Array<{ __typename?: 'Group'; uuid: string; name: string; classFraction: number }>;
        lessonClasses: Array<{
          __typename?: 'LessonClassInterface';
          class: {
            __typename?: 'ClassInterface';
            name: string;
            shortName: string;
            grade?: number | null;
            gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string; shortName: string } | null;
          };
          groups: Array<{
            __typename?: 'Group';
            uuid: string;
            name: string;
            shortName: string;
            classFraction: number;
            division?: {
              __typename?: 'Division';
              uuid: string;
              name: string;
              groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
            } | null;
          }>;
        }>;
      }>;
      roomSupply: Array<{ __typename?: 'Room'; uuid: string; roomNumber?: string | null; description?: string | null }>;
      roomSupplyConnection: {
        __typename?: 'CurriculumRoomSupplyConnection';
        edges: Array<{
          __typename?: 'CurriculumRoomSupplyRelationship';
          node: { __typename?: 'Room'; uuid: string };
          properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
        }>;
      };
      persons: Array<{ __typename?: 'CurriculumPerson'; name?: string | null; uuid: string }>;
      personsConnection: {
        __typename?: 'CurriculumPersonsConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'CurriculumPersonsRelationship';
          node: { __typename?: 'CurriculumPerson'; uuid: string; name?: string | null };
          properties: {
            __typename?: 'CurriculumPersonRelationshipProperties';
            description?: string | null;
            order: number;
            present?: boolean | null;
            teachingLoad?: boolean | null;
          };
        }>;
      };
      labels: Array<{ __typename?: 'Label'; uuid: string; color?: string | null; name: string }>;
      lessonBlueprints: Array<{
        __typename?: 'LessonInterface';
        uuid: string;
        foreignId?: string | null;
        subTitle?: string | null;
        comment?: string | null;
        displayName: Array<string>;
        teachingLoadEnabled?: boolean | null;
        timetableEnabled?: boolean | null;
        elective?: boolean | null;
        onlyInTimetableVersion: boolean;
        lessonClasses: Array<{
          __typename?: 'LessonClassInterface';
          class: {
            __typename?: 'ClassInterface';
            uuid: string;
            name: string;
            shortName: string;
            grade?: number | null;
            gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
          };
          groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
        }>;
        teachers: Array<{
          __typename?: 'Person';
          uuid: string;
          pimProfileUuid?: string | null;
          displayNameShort?: string | null;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }>;
        lessonUnit: Array<{
          __typename?: 'LessonUnit';
          uuid: string;
          duration?: number | null;
          count?: number | null;
          subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
        }>;
        roomSupply: Array<{
          __typename?: 'Room';
          uuid: string;
          roomNumber?: string | null;
          description?: string | null;
        }>;
      }>;
    }>;
  }>;
};

export type CurriculaListQueryVariables = Exact<{
  where?: InputMaybe<CurriculumWhere>;
  organizationUuid: Scalars['ID']['input'];
  sort?: InputMaybe<Array<CurriculumSort> | CurriculumSort>;
}>;

export type CurriculaListQuery = {
  __typename?: 'Query';
  curricula: Array<{
    __typename?: 'Curriculum';
    comment?: string | null;
    createdAt?: any | null;
    displayName: Array<string>;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    subTitle?: string | null;
    uuid: string;
    timetableEnabled?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    groupGradeNames: Array<string>;
    lessons: Array<{
      __typename?: 'Lesson';
      uuid: string;
      lessonClassesAggregate?: {
        __typename?: 'LessonLessonClassLessonClassesAggregationSelection';
        count: number;
      } | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    }>;
    subject:
      | {
          __typename?: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          epochEnabled?: boolean | null;
          subjectHourEnabled?: boolean | null;
          active?: boolean | null;
          other?: boolean | null;
          createdAt?: any | null;
          updatedAt?: any | null;
        }
      | {
          __typename?: 'SubjectContainer';
          uuid: string;
          name: string;
          shortName: string;
          order?: number | null;
          grades: Array<number>;
          createdAt?: any | null;
          updatedAt?: any | null;
        };
    curriculumUnit: Array<{
      __typename?: 'CurriculumUnit';
      uuid: string;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: {
        __typename?: 'SubjectContainer';
        uuid: string;
        name: string;
        shortName: string;
        order?: number | null;
        grades: Array<number>;
        createdAt?: any | null;
        updatedAt?: any | null;
      } | null;
    }>;
    curriculumUnitConnection: {
      __typename?: 'CurriculumCurriculumUnitConnection';
      edges: Array<{
        __typename?: 'CurriculumCurriculumUnitRelationship';
        node: {
          __typename?: 'CurriculumUnit';
          uuid: string;
          subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string } | null;
        };
      }>;
    };
    curriculumGrades: Array<{
      __typename?: 'CurriculumClass';
      uuid: string;
      grades: Array<number>;
      gradeGroups: Array<{
        __typename?: 'GradeGroup';
        uuid: string;
        name: string;
        shortName: string;
        description?: string | null;
        class: Array<{ __typename?: 'Class'; uuid: string }>;
      }>;
      groups: Array<{ __typename?: 'Group'; uuid: string; name: string; classFraction: number }>;
      lessonClasses: Array<{
        __typename?: 'LessonClassInterface';
        class: {
          __typename?: 'ClassInterface';
          name: string;
          shortName: string;
          grade?: number | null;
          gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string; shortName: string } | null;
        };
        groups: Array<{
          __typename?: 'Group';
          uuid: string;
          name: string;
          shortName: string;
          classFraction: number;
          division?: {
            __typename?: 'Division';
            uuid: string;
            name: string;
            groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
          } | null;
        }>;
      }>;
    }>;
    roomSupply: Array<{ __typename?: 'Room'; uuid: string; roomNumber?: string | null; description?: string | null }>;
    roomSupplyConnection: {
      __typename?: 'CurriculumRoomSupplyConnection';
      edges: Array<{
        __typename?: 'CurriculumRoomSupplyRelationship';
        node: { __typename?: 'Room'; uuid: string };
        properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
      }>;
    };
    persons: Array<{ __typename?: 'CurriculumPerson'; name?: string | null; uuid: string }>;
    personsConnection: {
      __typename?: 'CurriculumPersonsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'CurriculumPersonsRelationship';
        node: { __typename?: 'CurriculumPerson'; uuid: string; name?: string | null };
        properties: {
          __typename?: 'CurriculumPersonRelationshipProperties';
          description?: string | null;
          order: number;
          present?: boolean | null;
          teachingLoad?: boolean | null;
        };
      }>;
    };
    labels: Array<{ __typename?: 'Label'; uuid: string; color?: string | null; name: string }>;
    lessonBlueprints: Array<{
      __typename?: 'LessonInterface';
      uuid: string;
      foreignId?: string | null;
      subTitle?: string | null;
      comment?: string | null;
      displayName: Array<string>;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      elective?: boolean | null;
      onlyInTimetableVersion: boolean;
      lessonClasses: Array<{
        __typename?: 'LessonClassInterface';
        class: {
          __typename?: 'ClassInterface';
          uuid: string;
          name: string;
          shortName: string;
          grade?: number | null;
          gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
        };
        groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
      }>;
      teachers: Array<{
        __typename?: 'Person';
        uuid: string;
        pimProfileUuid?: string | null;
        displayNameShort?: string | null;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      }>;
      lessonUnit: Array<{
        __typename?: 'LessonUnit';
        uuid: string;
        duration?: number | null;
        count?: number | null;
        subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
      }>;
      roomSupply: Array<{ __typename?: 'Room'; uuid: string; roomNumber?: string | null; description?: string | null }>;
    }>;
  }>;
  subjects: Array<{
    __typename?: 'Subject';
    uuid: string;
    name: string;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
  }>;
  curriculumUnits: Array<{
    __typename?: 'CurriculumUnit';
    uuid: string;
    count?: number | null;
    duration?: number | null;
    subjectContainer?: {
      __typename?: 'SubjectContainer';
      uuid: string;
      name: string;
      shortName: string;
      order?: number | null;
      grades: Array<number>;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null;
  }>;
  classes: Array<{ __typename?: 'Class'; uuid: string; name: string }>;
  curriculumClasses: Array<{
    __typename?: 'CurriculumClass';
    uuid: string;
    grades: Array<number>;
    gradeGroups: Array<{
      __typename?: 'GradeGroup';
      uuid: string;
      name: string;
      shortName: string;
      description?: string | null;
      class: Array<{ __typename?: 'Class'; uuid: string }>;
    }>;
    groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        name: string;
        shortName: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroup'; shortName: string } | null;
      };
      groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
    }>;
  }>;
  rooms: Array<{ __typename?: 'Room'; uuid: string; name: string; roomNumber?: string | null }>;
};

export type CurriculumPersonsListQueryVariables = Exact<{
  where?: InputMaybe<CurriculumPersonWhere>;
}>;

export type CurriculumPersonsListQuery = {
  __typename?: 'Query';
  curriculumPeople: Array<{ __typename?: 'CurriculumPerson'; uuid: string; name?: string | null }>;
};

export type CurriculumClassesListQueryVariables = Exact<{
  where?: InputMaybe<CurriculumClassWhere>;
}>;

export type CurriculumClassesListQuery = {
  __typename?: 'Query';
  curriculumClasses: Array<{
    __typename?: 'CurriculumClass';
    uuid: string;
    grades: Array<number>;
    groups: Array<{ __typename?: 'Group'; uuid: string; name: string }>;
    gradeGroups: Array<{
      __typename?: 'GradeGroup';
      uuid: string;
      name: string;
      shortName: string;
      description?: string | null;
      class: Array<{ __typename?: 'Class'; uuid: string }>;
    }>;
    usedDivision?: {
      __typename?: 'Division';
      uuid: string;
      name: string;
      labels: Array<{ __typename?: 'Label'; uuid: string; name: string; color?: string | null }>;
    } | null;
  }>;
};

export type GroupsListQueryVariables = Exact<{
  where?: InputMaybe<GroupWhere>;
}>;

export type GroupsListQuery = {
  __typename?: 'Query';
  groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string }>;
};

export type CreateDependenciesMutationVariables = Exact<{
  input: Array<DependencyCreateInput> | DependencyCreateInput;
}>;

export type CreateDependenciesMutation = {
  __typename?: 'Mutation';
  createDependencies: {
    __typename?: 'CreateDependenciesMutationResponse';
    dependencies: Array<{ __typename?: 'Dependency'; uuid: string }>;
  };
};

export type UpdateDependenciesMutationVariables = Exact<{
  update: DependencyUpdateInput;
  where?: InputMaybe<DependencyWhere>;
}>;

export type UpdateDependenciesMutation = {
  __typename?: 'Mutation';
  updateDependencies: {
    __typename?: 'UpdateDependenciesMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type DependenciesQueryVariables = Exact<{
  timetableVersion?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
}>;

export type DependenciesQuery = {
  __typename?: 'Query';
  dependencies: Array<{
    __typename?: 'Dependency';
    uuid: string;
    priority: DependencyPriority;
    comment?: string | null;
    active?: boolean | null;
    alias: string;
    otherData?: string | null;
    subjects: Array<{ __typename?: 'Subject'; uuid: string; name: string; shortName: string }>;
    classes: Array<{ __typename?: 'Class'; uuid: string; name: string; shortName: string }>;
    teachers: Array<{ __typename?: 'Person'; uuid: string; displayName: string }>;
  }>;
};

export type DeleteDependenciesMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteDependenciesMutation = {
  __typename?: 'Mutation';
  deleteDependencies: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type ListPlannedTeacherTeachingLoadQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListPlannedTeacherTeachingLoadQuery = {
  __typename?: 'Query';
  plannedTeachingLoadByTeacher: Array<{
    __typename?: 'TeacherTeachingLoad';
    teacherUuid: string;
    teacherDisplayName: string;
    lessonUuid: string;
    subjectUuid: string;
    subjectDisplayName: string;
    subjectContainerUuid?: string | null;
    subjectContainerDisplayName?: string | null;
    partialClasses: boolean;
    lessonClassesDisplayName: string;
    countClasses: number;
    countTeacher: number;
    studentCards?: number | null;
    teacherCards?: number | null;
    studentHours?: number | null;
    teacherHours?: number | null;
    teachingBlockWeeks?: number | null;
    teachingBlocks?: number | null;
    factor: number;
    deputat: number;
    organization: { __typename?: 'Organization'; uuid: string };
    schoolYear: { __typename?: 'SchoolYear'; uuid: string; name: string };
    lessonClass: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        uuid: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string; shortName: string } | null;
      };
      groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
    }>;
    relevantFactors: Array<{
      __typename?: 'TeachingLoadFactor';
      uuid: string;
      value: number;
      valueRaw: string;
      valuePartial?: number | null;
      valuePartialRaw?: string | null;
    }>;
  }>;
};

export type ListPlannedClassesTeachingLoadQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  classUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListPlannedClassesTeachingLoadQuery = {
  __typename?: 'Query';
  plannedTeachingLoadByClass: Array<{
    __typename?: 'ClassTeachingLoad';
    classUuid: string;
    classDisplayName: string;
    lessonUuid: string;
    subjectUuid: string;
    subjectDisplayName: string;
    subjectContainerUuid?: string | null;
    subjectContainerDisplayName?: string | null;
    partialClasses: boolean;
    lessonClassesDisplayName: string;
    countClasses: number;
    countTeacher: number;
    studentCards?: number | null;
    teacherCards?: number | null;
    studentHours?: number | null;
    teacherHours?: number | null;
    teachingBlockWeeks?: number | null;
    teachingBlocks?: number | null;
    factor: number;
    deputat: number;
    organization: { __typename?: 'Organization'; uuid: string };
    schoolYear: { __typename?: 'SchoolYear'; uuid: string; name: string };
    lessonClass: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        uuid: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string; shortName: string } | null;
      };
      groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
    }>;
    relevantFactors: Array<{
      __typename?: 'TeachingLoadFactor';
      uuid: string;
      value: number;
      valueRaw: string;
      valuePartial?: number | null;
      valuePartialRaw?: string | null;
    }>;
  }>;
};

export type ListTeacherTeachingLoadQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  timetableBlockUuid: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListTeacherTeachingLoadQuery = {
  __typename?: 'Query';
  teachingLoadByTeacher: Array<{
    __typename?: 'TeacherTeachingLoad';
    teacherUuid: string;
    teacherDisplayName: string;
    subjectUuid: string;
    subjectDisplayName: string;
    subjectContainerUuid?: string | null;
    subjectContainerDisplayName?: string | null;
    partialClasses: boolean;
    lessonClassesDisplayName: string;
    countClasses: number;
    countTeacher: number;
    studentCards?: number | null;
    teacherCards?: number | null;
    studentHours?: number | null;
    teacherHours?: number | null;
    teachingBlockWeeks?: number | null;
    teachingBlocks?: number | null;
    factor: number;
    deputat: number;
    timetableBlockUuid?: string | null;
    timetableBlockDisplayName?: string | null;
    timetableBlockSortName?: string | null;
    organization: { __typename?: 'Organization'; uuid: string };
    schoolYear: { __typename?: 'SchoolYear'; uuid: string; name: string };
    lessonClass: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        uuid: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string; shortName: string } | null;
      };
      groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
    }>;
    relevantFactors: Array<{
      __typename?: 'TeachingLoadFactor';
      uuid: string;
      value: number;
      valueRaw: string;
      valuePartial?: number | null;
      valuePartialRaw?: string | null;
    }>;
  }>;
};

export type DeleteDivisionsMutationVariables = Exact<{
  where?: InputMaybe<DivisionWhere>;
}>;

export type DeleteDivisionsMutation = {
  __typename?: 'Mutation';
  deleteDivisions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateDivisionsMutationVariables = Exact<{
  divisionName: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
  groups?: InputMaybe<Array<DivisionGroupsCreateFieldInput> | DivisionGroupsCreateFieldInput>;
  classUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateDivisionsMutation = {
  __typename?: 'Mutation';
  createDivisions: {
    __typename?: 'CreateDivisionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateDivisionsMutationVariables = Exact<{
  divisionName: Scalars['String']['input'];
  divisionUuid: Scalars['ID']['input'];
  groups?: InputMaybe<Array<DivisionGroupsUpdateFieldInput> | DivisionGroupsUpdateFieldInput>;
}>;

export type UpdateDivisionsMutation = {
  __typename?: 'Mutation';
  updateDivisions: {
    __typename?: 'UpdateDivisionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type AddDivisionGroupsMutationVariables = Exact<{
  divisionUuid: Scalars['ID']['input'];
  groups?: InputMaybe<Array<DivisionGroupsCreateFieldInput> | DivisionGroupsCreateFieldInput>;
}>;

export type AddDivisionGroupsMutation = {
  __typename?: 'Mutation';
  updateDivisions: {
    __typename?: 'UpdateDivisionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type DivisionsFormQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  divisionUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DivisionsFormQuery = {
  __typename?: 'Query';
  currentDivision: Array<{
    __typename?: 'Division';
    uuid: string;
    name: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    groupsConnection: {
      __typename?: 'DivisionGroupsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'DivisionGroupsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename?: 'Group'; uuid: string; name: string; shortName: string };
      }>;
    };
    class?: { __typename?: 'Class'; uuid: string } | null;
  }>;
  divisions: Array<{
    __typename?: 'Division';
    uuid: string;
    name: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    groupsConnection: {
      __typename?: 'DivisionGroupsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'DivisionGroupsRelationship';
        node: { __typename?: 'Group'; name: string; shortName: string };
      }>;
    };
    class?: { __typename?: 'Class'; uuid: string } | null;
  }>;
  defaultDivisions: Array<{
    __typename?: 'Division';
    uuid: string;
    name: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    groupsConnection: {
      __typename?: 'DivisionGroupsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'DivisionGroupsRelationship';
        node: { __typename?: 'Group'; name: string; shortName: string };
      }>;
    };
  }>;
};

export type DivisionsQueryVariables = Exact<{
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  classCount?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DivisionsQuery = {
  __typename?: 'Query';
  divisions: Array<{
    __typename?: 'Division';
    uuid: string;
    name: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    groupsConnection: {
      __typename?: 'DivisionGroupsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'DivisionGroupsRelationship';
        node: { __typename?: 'Group'; uuid: string; name: string; shortName: string };
      }>;
    };
    classAggregate?: { __typename?: 'DivisionClassClassAggregationSelection'; count: number } | null;
  }>;
};

export type TimetableReportsQueryVariables = Exact<{
  where?: InputMaybe<TimetableReportWhere>;
  options?: InputMaybe<TimetableReportOptions>;
}>;

export type TimetableReportsQuery = {
  __typename?: 'Query';
  timetableReports: Array<{
    __typename?: 'TimetableReport';
    uuid: string;
    title: string;
    type: TimetableReportType;
    jobCreated: any;
    jobFinished: any;
    context:
      | { __typename?: 'SchoolYear'; uuid: string; name: string }
      | { __typename?: 'TeachingBlock'; uuid: string; name: string }
      | { __typename?: 'TimetableBlock'; uuid: string; name: string };
    fileEntries: Array<{ __typename?: 'FileEntry'; uuid: string; filename: string; created: any; updated: any }>;
  }>;
};

export type TeachingLoadReportsQueryVariables = Exact<{
  where?: InputMaybe<TeachingLoadReportWhere>;
  options?: InputMaybe<TeachingLoadReportOptions>;
}>;

export type TeachingLoadReportsQuery = {
  __typename?: 'Query';
  teachingLoadReports: Array<{
    __typename?: 'TeachingLoadReport';
    uuid: string;
    title: string;
    type: TeachingLoadReportType;
    jobCreated: any;
    jobFinished: any;
    context:
      | { __typename: 'SchoolYear'; uuid: string; name: string }
      | {
          __typename: 'TeachingBlock';
          uuid: string;
          name: string;
          schoolYear: { __typename?: 'SchoolYear'; uuid: string };
        }
      | {
          __typename: 'TimetableBlock';
          uuid: string;
          name: string;
          schoolYear: { __typename?: 'SchoolYear'; uuid: string };
        };
    fileEntries: Array<{ __typename?: 'FileEntry'; uuid: string; filename: string; created: any; updated: any }>;
  }>;
};

export type UpdateTeachingBlockAvailabilityExclusionMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  update?: InputMaybe<TeachingBlockAvailabilityExclusionUpdateInput>;
}>;

export type UpdateTeachingBlockAvailabilityExclusionMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockAvailabilityExclusions: {
    __typename?: 'UpdateTeachingBlockAvailabilityExclusionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type CreateTeachingBlockAvailabilityExclusionMutationVariables = Exact<{
  input: Array<TeachingBlockAvailabilityExclusionCreateInput> | TeachingBlockAvailabilityExclusionCreateInput;
}>;

export type CreateTeachingBlockAvailabilityExclusionMutation = {
  __typename?: 'Mutation';
  createTeachingBlockAvailabilityExclusions: {
    __typename?: 'CreateTeachingBlockAvailabilityExclusionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type DeleteTeachingBlockAvailabilityExclusionMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
}>;

export type DeleteTeachingBlockAvailabilityExclusionMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockAvailabilityExclusions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DeleteTeachingLoadFactorMutationVariables = Exact<{
  where?: InputMaybe<TeachingLoadFactorWhere>;
  delete?: InputMaybe<TeachingLoadFactorDeleteInput>;
}>;

export type DeleteTeachingLoadFactorMutation = {
  __typename?: 'Mutation';
  deleteTeachingLoadFactors: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateTeachingLoadFactorMutationVariables = Exact<{
  input: Array<TeachingLoadFactorCreateInput> | TeachingLoadFactorCreateInput;
}>;

export type CreateTeachingLoadFactorMutation = {
  __typename?: 'Mutation';
  createTeachingLoadFactors: {
    __typename?: 'CreateTeachingLoadFactorsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number; relationshipsCreated: number };
  };
};

export type UpdateTeachingLoadFactorMutationVariables = Exact<{
  where?: InputMaybe<TeachingLoadFactorWhere>;
  update?: InputMaybe<TeachingLoadFactorUpdateInput>;
}>;

export type UpdateTeachingLoadFactorMutation = {
  __typename?: 'Mutation';
  updateTeachingLoadFactors: {
    __typename?: 'UpdateTeachingLoadFactorsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; relationshipsCreated: number };
  };
};

export type TeachingLoadFactorsQueryVariables = Exact<{
  where?: InputMaybe<TeachingLoadFactorWhere>;
  options?: InputMaybe<TeachingLoadFactorOptions>;
}>;

export type TeachingLoadFactorsQuery = {
  __typename?: 'Query';
  teachingLoadFactors: Array<{
    __typename?: 'TeachingLoadFactor';
    uuid: string;
    active: boolean;
    factorType: FactorType;
    grades: Array<number>;
    value: number;
    valueRaw: string;
    valuePartial?: number | null;
    valuePartialRaw?: string | null;
    valueMode: ValueMode;
    comment?: string | null;
    scenario?: {
      __typename?: 'TeachingLoadScenario';
      uuid: string;
      foreignId?: string | null;
      name: string;
      comment?: string | null;
    } | null;
    subjectContainer: Array<{
      __typename?: 'SubjectContainer';
      uuid: string;
      name: string;
      shortName: string;
      order?: number | null;
      createdAt?: any | null;
      updatedAt?: any | null;
    }>;
    teachers: Array<{
      __typename?: 'Person';
      uuid: string;
      fullName: string;
      shortName: string;
      displayName: string;
      displayNameShort?: string | null;
      listName: string;
    }>;
    subject: Array<{
      __typename?: 'Subject';
      uuid: string;
      foreignId?: string | null;
      name: string;
      shortName: string;
      subjectHourEnabled?: boolean | null;
      epochEnabled?: boolean | null;
      active?: boolean | null;
      other?: boolean | null;
      createdAt?: any | null;
      updatedAt?: any | null;
    }>;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    gradeGroup: Array<{
      __typename?: 'GradeGroup';
      uuid: string;
      name: string;
      shortName: string;
      description?: string | null;
      class: Array<{ __typename?: 'Class'; uuid: string }>;
    }>;
    timeGridEntries: Array<{ __typename?: 'TimeGridEntry'; uuid: string; name: string }>;
  }>;
};

export type TeachingLoadScenariosQueryVariables = Exact<{
  where?: InputMaybe<TeachingLoadScenarioWhere>;
  options?: InputMaybe<TeachingLoadScenarioOptions>;
}>;

export type TeachingLoadScenariosQuery = {
  __typename?: 'Query';
  teachingLoadScenarios: Array<{
    __typename?: 'TeachingLoadScenario';
    comment?: string | null;
    name: string;
    uuid: string;
  }>;
};

export type CreateGradeGroupsMutationVariables = Exact<{
  input: Array<GradeGroupCreateInput> | GradeGroupCreateInput;
}>;

export type CreateGradeGroupsMutation = {
  __typename?: 'Mutation';
  createGradeGroups: {
    __typename?: 'CreateGradeGroupsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type DeleteGradeGroupsMutationVariables = Exact<{
  where?: InputMaybe<GradeGroupWhere>;
  delete?: InputMaybe<GradeGroupDeleteInput>;
}>;

export type DeleteGradeGroupsMutation = {
  __typename?: 'Mutation';
  deleteGradeGroups: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateGradeGroupsMutationVariables = Exact<{
  where?: InputMaybe<GradeGroupWhere>;
  update?: InputMaybe<GradeGroupUpdateInput>;
}>;

export type UpdateGradeGroupsMutation = {
  __typename?: 'Mutation';
  updateGradeGroups: {
    __typename?: 'UpdateGradeGroupsMutationResponse';
    info: {
      __typename?: 'UpdateInfo';
      nodesCreated: number;
      nodesDeleted: number;
      relationshipsCreated: number;
      relationshipsDeleted: number;
    };
  };
};

export type GradeGroupsListQueryVariables = Exact<{
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GradeGroupsListQuery = {
  __typename?: 'Query';
  gradeGroups: Array<{
    __typename?: 'GradeGroup';
    uuid: string;
    name: string;
    shortName: string;
    description?: string | null;
  }>;
};

export type DeleteHolidaysMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteHolidaysMutation = {
  __typename?: 'Mutation';
  deleteHolidays: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateHolidaysMutationVariables = Exact<{
  where?: InputMaybe<HolidayWhere>;
  update?: InputMaybe<HolidayUpdateInput>;
}>;

export type UpdateHolidaysMutation = {
  __typename?: 'Mutation';
  updateHolidays: {
    __typename?: 'UpdateHolidaysMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type CreateHolidaysMutationVariables = Exact<{
  input: Array<HolidayCreateInput> | HolidayCreateInput;
}>;

export type CreateHolidaysMutation = {
  __typename?: 'Mutation';
  createHolidays: {
    __typename?: 'CreateHolidaysMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type HolidaysQueryVariables = Exact<{
  where?: InputMaybe<HolidayWhere>;
  options?: InputMaybe<HolidayOptions>;
}>;

export type HolidaysQuery = {
  __typename?: 'Query';
  holidays: Array<{ __typename?: 'Holiday'; uuid: string; name: string; start: any; end: any }>;
};

export type CreateLessonsMutationVariables = Exact<{
  input: Array<LessonCreateInput> | LessonCreateInput;
}>;

export type CreateLessonsMutation = {
  __typename?: 'Mutation';
  createLessons: {
    __typename?: 'CreateLessonsMutationResponse';
    lessons: Array<{
      __typename?: 'Lesson';
      uuid: string;
      groupClassNames: string;
      gradeGroupUuid?: Array<string> | null;
      onlyInTimetableVersion: boolean;
      classSort: string;
      teachersSort: string;
      placedCardsCount?: number | null;
      teachingBlockPlacedCardsCount?: number | null;
      subTitle?: string | null;
      comment?: string | null;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      curriculum?: {
        __typename?: 'Curriculum';
        uuid: string;
        personsConnection: {
          __typename?: 'CurriculumPersonsConnection';
          totalCount: number;
          edges: Array<{
            __typename?: 'CurriculumPersonsRelationship';
            properties: {
              __typename?: 'CurriculumPersonRelationshipProperties';
              description?: string | null;
              order: number;
              present?: boolean | null;
              teachingLoad?: boolean | null;
            };
            node: { __typename?: 'CurriculumPerson'; uuid: string };
          }>;
        };
      } | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string };
      subject:
        | {
            __typename: 'Subject';
            uuid: string;
            name: string;
            shortName: string;
            epochEnabled?: boolean | null;
            subjectHourEnabled?: boolean | null;
            active?: boolean | null;
            defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          }
        | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
      versions: Array<{
        __typename?: 'TimetableVersion';
        uuid: string;
        active?: boolean | null;
        editable?: boolean | null;
        version: number;
        timetable: { __typename?: 'Timetable'; uuid: string; name: string };
      }>;
      teachingBlockVersions: Array<{
        __typename?: 'TeachingBlockVersion';
        uuid: string;
        active?: boolean | null;
        version: number;
        teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
      }>;
      activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      lessonClassesConnection: {
        __typename?: 'LessonLessonClassesConnection';
        edges: Array<{
          __typename?: 'LessonLessonClassesRelationship';
          node: {
            __typename?: 'LessonClass';
            uuid: string;
            class: {
              __typename?: 'Class';
              uuid: string;
              name: string;
              shortName: string;
              grade?: number | null;
              defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
              gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
              divisions: Array<{
                __typename?: 'Division';
                uuid: string;
                groups: Array<{ __typename?: 'Group'; uuid: string }>;
              }>;
              timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
            };
            groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
            groups: Array<{
              __typename?: 'Group';
              uuid: string;
              shortName: string;
              name: string;
              classFraction: number;
            }>;
            usedDivision?: {
              __typename?: 'Division';
              uuid: string;
              name: string;
              groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
              groupsConnection: {
                __typename?: 'DivisionGroupsConnection';
                edges: Array<{
                  __typename?: 'DivisionGroupsRelationship';
                  properties: { __typename?: 'OrderedRelationProperties'; order: number };
                  node: { __typename?: 'Group'; uuid: string; name: string };
                }>;
              };
            } | null;
          };
        }>;
      };
      lessonUnitConnection: {
        __typename?: 'LessonLessonUnitConnection';
        edges: Array<{
          __typename?: 'LessonLessonUnitRelationship';
          node: {
            __typename?: 'LessonUnit';
            uuid: string;
            duration?: number | null;
            count?: number | null;
            subjectContainer?: {
              __typename?: 'SubjectContainer';
              uuid: string;
              name: string;
              shortName: string;
            } | null;
          };
        }>;
      };
      teachersConnection: {
        __typename?: 'LessonTeachersConnection';
        edges: Array<{
          __typename?: 'LessonTeachersRelationship';
          properties: {
            __typename?: 'LessonTeacherRelationshipProperties';
            description?: string | null;
            present?: boolean | null;
            teachingLoad?: boolean | null;
            teachingLoadHours?: number | null;
            writesCertificate?: boolean | null;
          };
          node: {
            __typename?: 'Person';
            uuid: string;
            shortName: string;
            fullName: string;
            firstName: string;
            lastName: string;
            displayNameShort?: string | null;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
        }>;
      };
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
          node: { __typename?: 'Room'; uuid: string; name: string };
        }>;
      };
    }>;
  };
};

export type UpdateLessonsMutationVariables = Exact<{
  where?: InputMaybe<LessonWhere>;
  update?: InputMaybe<LessonUpdateInput>;
}>;

export type UpdateLessonsMutation = {
  __typename?: 'Mutation';
  updateLessons: {
    __typename?: 'UpdateLessonsMutationResponse';
    lessons: Array<{
      __typename?: 'Lesson';
      uuid: string;
      groupClassNames: string;
      gradeGroupUuid?: Array<string> | null;
      onlyInTimetableVersion: boolean;
      classSort: string;
      teachersSort: string;
      placedCardsCount?: number | null;
      teachingBlockPlacedCardsCount?: number | null;
      subTitle?: string | null;
      comment?: string | null;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      curriculum?: {
        __typename?: 'Curriculum';
        uuid: string;
        personsConnection: {
          __typename?: 'CurriculumPersonsConnection';
          totalCount: number;
          edges: Array<{
            __typename?: 'CurriculumPersonsRelationship';
            properties: {
              __typename?: 'CurriculumPersonRelationshipProperties';
              description?: string | null;
              order: number;
              present?: boolean | null;
              teachingLoad?: boolean | null;
            };
            node: { __typename?: 'CurriculumPerson'; uuid: string };
          }>;
        };
      } | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string };
      subject:
        | {
            __typename: 'Subject';
            uuid: string;
            name: string;
            shortName: string;
            epochEnabled?: boolean | null;
            subjectHourEnabled?: boolean | null;
            active?: boolean | null;
            defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          }
        | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
      versions: Array<{
        __typename?: 'TimetableVersion';
        uuid: string;
        active?: boolean | null;
        editable?: boolean | null;
        version: number;
        timetable: { __typename?: 'Timetable'; uuid: string; name: string };
      }>;
      teachingBlockVersions: Array<{
        __typename?: 'TeachingBlockVersion';
        uuid: string;
        active?: boolean | null;
        version: number;
        teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
      }>;
      activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      lessonClassesConnection: {
        __typename?: 'LessonLessonClassesConnection';
        edges: Array<{
          __typename?: 'LessonLessonClassesRelationship';
          node: {
            __typename?: 'LessonClass';
            uuid: string;
            class: {
              __typename?: 'Class';
              uuid: string;
              name: string;
              shortName: string;
              grade?: number | null;
              defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
              gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
              divisions: Array<{
                __typename?: 'Division';
                uuid: string;
                groups: Array<{ __typename?: 'Group'; uuid: string }>;
              }>;
              timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
            };
            groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
            groups: Array<{
              __typename?: 'Group';
              uuid: string;
              shortName: string;
              name: string;
              classFraction: number;
            }>;
            usedDivision?: {
              __typename?: 'Division';
              uuid: string;
              name: string;
              groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
              groupsConnection: {
                __typename?: 'DivisionGroupsConnection';
                edges: Array<{
                  __typename?: 'DivisionGroupsRelationship';
                  properties: { __typename?: 'OrderedRelationProperties'; order: number };
                  node: { __typename?: 'Group'; uuid: string; name: string };
                }>;
              };
            } | null;
          };
        }>;
      };
      lessonUnitConnection: {
        __typename?: 'LessonLessonUnitConnection';
        edges: Array<{
          __typename?: 'LessonLessonUnitRelationship';
          node: {
            __typename?: 'LessonUnit';
            uuid: string;
            duration?: number | null;
            count?: number | null;
            subjectContainer?: {
              __typename?: 'SubjectContainer';
              uuid: string;
              name: string;
              shortName: string;
            } | null;
          };
        }>;
      };
      teachersConnection: {
        __typename?: 'LessonTeachersConnection';
        edges: Array<{
          __typename?: 'LessonTeachersRelationship';
          properties: {
            __typename?: 'LessonTeacherRelationshipProperties';
            description?: string | null;
            present?: boolean | null;
            teachingLoad?: boolean | null;
            teachingLoadHours?: number | null;
            writesCertificate?: boolean | null;
          };
          node: {
            __typename?: 'Person';
            uuid: string;
            shortName: string;
            fullName: string;
            firstName: string;
            lastName: string;
            displayNameShort?: string | null;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
        }>;
      };
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
          node: { __typename?: 'Room'; uuid: string; name: string };
        }>;
      };
    }>;
  };
};

export type DeleteLessonsMutationVariables = Exact<{
  where?: InputMaybe<LessonWhere>;
  delete?: InputMaybe<LessonDeleteInput>;
}>;

export type DeleteLessonsMutation = {
  __typename?: 'Mutation';
  deleteLessons: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type ConnectLessonsToTimetableVersionMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type ConnectLessonsToTimetableVersionMutation = {
  __typename?: 'Mutation';
  connectLessonsToTimetableVersion: { __typename?: 'UpdateResponse'; nodesUpdated: number; nodeUuids: Array<string> };
};

export type InheritLessonTeachersMutationVariables = Exact<{
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  type: InheritLessonTeachersType;
}>;

export type InheritLessonTeachersMutation = {
  __typename?: 'Mutation';
  inheritLessonTeachers: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type CopyLessonsToTimetableVersionMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  timetableVersionUuid: Scalars['ID']['input'];
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type CopyLessonsToTimetableVersionMutation = {
  __typename?: 'Mutation';
  copyLessonsToTimetableVersion: { __typename?: 'CreateResponse'; nodesCreated: number; nodeUuids: Array<string> };
};

export type MergeLessonsMutationVariables = Exact<{
  cardsFromLesson?: InputMaybe<Scalars['ID']['input']>;
  lessonUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  newCards: Array<MergeLessonNewCardsInput> | MergeLessonNewCardsInput;
  removePlacedCards: Scalars['Boolean']['input'];
  timetableVersion?: InputMaybe<Scalars['ID']['input']>;
}>;

export type MergeLessonsMutation = {
  __typename?: 'Mutation';
  mergeLessons: { __typename?: 'CreateResponse'; nodeUuids: Array<string>; nodesCreated: number };
};

export type LessonsQueryVariables = Exact<{
  lessonWhere?: InputMaybe<LessonWhere>;
  timetableCardsWhere?: InputMaybe<TimetableCardWhere>;
  organizationUuid: Scalars['ID']['input'];
  options?: InputMaybe<LessonOptions>;
}>;

export type LessonsQuery = {
  __typename?: 'Query';
  lessons: Array<{
    __typename?: 'Lesson';
    uuid: string;
    groupClassNames: string;
    gradeGroupUuid?: Array<string> | null;
    onlyInTimetableVersion: boolean;
    classSort: string;
    teachersSort: string;
    placedCardsCount?: number | null;
    teachingBlockPlacedCardsCount?: number | null;
    subTitle?: string | null;
    comment?: string | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    curriculum?: {
      __typename?: 'Curriculum';
      uuid: string;
      personsConnection: {
        __typename?: 'CurriculumPersonsConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'CurriculumPersonsRelationship';
          properties: {
            __typename?: 'CurriculumPersonRelationshipProperties';
            description?: string | null;
            order: number;
            present?: boolean | null;
            teachingLoad?: boolean | null;
          };
          node: { __typename?: 'CurriculumPerson'; uuid: string };
        }>;
      };
    } | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    subject:
      | {
          __typename: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          epochEnabled?: boolean | null;
          subjectHourEnabled?: boolean | null;
          active?: boolean | null;
          defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }
      | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
    versions: Array<{
      __typename?: 'TimetableVersion';
      uuid: string;
      active?: boolean | null;
      editable?: boolean | null;
      version: number;
      timetable: { __typename?: 'Timetable'; uuid: string; name: string };
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'TeachingBlockVersion';
      uuid: string;
      active?: boolean | null;
      version: number;
      teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
    }>;
    activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    lessonClassesConnection: {
      __typename?: 'LessonLessonClassesConnection';
      edges: Array<{
        __typename?: 'LessonLessonClassesRelationship';
        node: {
          __typename?: 'LessonClass';
          uuid: string;
          class: {
            __typename?: 'Class';
            uuid: string;
            name: string;
            shortName: string;
            grade?: number | null;
            defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
            gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
            divisions: Array<{
              __typename?: 'Division';
              uuid: string;
              groups: Array<{ __typename?: 'Group'; uuid: string }>;
            }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
          groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
          groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
          usedDivision?: {
            __typename?: 'Division';
            uuid: string;
            name: string;
            groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
            groupsConnection: {
              __typename?: 'DivisionGroupsConnection';
              edges: Array<{
                __typename?: 'DivisionGroupsRelationship';
                properties: { __typename?: 'OrderedRelationProperties'; order: number };
                node: { __typename?: 'Group'; uuid: string; name: string };
              }>;
            };
          } | null;
        };
      }>;
    };
    lessonUnitConnection: {
      __typename?: 'LessonLessonUnitConnection';
      edges: Array<{
        __typename?: 'LessonLessonUnitRelationship';
        node: {
          __typename?: 'LessonUnit';
          uuid: string;
          duration?: number | null;
          count?: number | null;
          subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'LessonTeachersConnection';
      edges: Array<{
        __typename?: 'LessonTeachersRelationship';
        properties: {
          __typename?: 'LessonTeacherRelationshipProperties';
          description?: string | null;
          present?: boolean | null;
          teachingLoad?: boolean | null;
          teachingLoadHours?: number | null;
          writesCertificate?: boolean | null;
        };
        node: {
          __typename?: 'Person';
          uuid: string;
          shortName: string;
          fullName: string;
          firstName: string;
          lastName: string;
          displayNameShort?: string | null;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
      }>;
    };
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
        node: { __typename?: 'Room'; uuid: string; name: string };
      }>;
    };
  }>;
  timetableCards: Array<{
    __typename?: 'TimetableCard';
    uuid: string;
    weekday?: string | null;
    duration?: number | null;
    locked: boolean;
    timetableVersion: {
      __typename?: 'TimetableVersion';
      version: number;
      uuid: string;
      timetable: { __typename?: 'Timetable'; name: string };
    };
    rooms: Array<{ __typename?: 'Room'; name: string; uuid: string }>;
    teachers: Array<{
      __typename?: 'Person';
      uuid: string;
      pimProfileUuid?: string | null;
      displayNameShort?: string | null;
      defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
      timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
    }>;
    lesson: {
      __typename?: 'Lesson';
      uuid: string;
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          node: {
            __typename?: 'Room';
            uuid: string;
            name: string;
            building?: { __typename?: 'Building'; name: string } | null;
          };
        }>;
      };
    };
    subject:
      | {
          __typename?: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }
      | {
          __typename?: 'SubjectContainer';
          uuid: string;
          name: string;
          shortName: string;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
    lessonClasses: Array<{
      __typename?: 'LessonClass';
      uuid: string;
      class: {
        __typename?: 'Class';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
        divisions: Array<{
          __typename?: 'Division';
          uuid: string;
          groups: Array<{ __typename?: 'Group'; uuid: string }>;
        }>;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      };
      groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
      groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
      usedDivision?: {
        __typename?: 'Division';
        uuid: string;
        name: string;
        groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
        groupsConnection: {
          __typename?: 'DivisionGroupsConnection';
          edges: Array<{
            __typename?: 'DivisionGroupsRelationship';
            properties: { __typename?: 'OrderedRelationProperties'; order: number };
            node: { __typename?: 'Group'; uuid: string; name: string };
          }>;
        };
      } | null;
    }>;
    subjectContainer?: {
      __typename?: 'SubjectContainer';
      uuid: string;
      name: string;
      shortName: string;
      order?: number | null;
      lessons: Array<{ __typename?: 'Lesson'; uuid: string }>;
    } | null;
    startTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
    endTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
  }>;
  people: Array<{
    __typename?: 'Person';
    uuid: string;
    selectName: string;
    qualifications: Array<{ __typename?: 'Qualification'; subject: { __typename?: 'Subject'; uuid: string } }>;
  }>;
  subjects: Array<{
    __typename?: 'Subject';
    uuid: string;
    name: string;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
  }>;
  classes: Array<{ __typename?: 'Class'; uuid: string; name: string }>;
  rooms: Array<{ __typename?: 'Room'; uuid: string; name: string; roomNumber?: string | null }>;
};

export type TimetableVersionLessonsQueryVariables = Exact<{
  lessonWhere?: InputMaybe<LessonWhere>;
  options?: InputMaybe<LessonOptions>;
}>;

export type TimetableVersionLessonsQuery = {
  __typename?: 'Query';
  lessons: Array<{
    __typename?: 'Lesson';
    uuid: string;
    groupClassNames: string;
    gradeGroupUuid?: Array<string> | null;
    onlyInTimetableVersion: boolean;
    classSort: string;
    teachersSort: string;
    placedCardsCount?: number | null;
    teachingBlockPlacedCardsCount?: number | null;
    subTitle?: string | null;
    comment?: string | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    curriculum?: {
      __typename?: 'Curriculum';
      uuid: string;
      personsConnection: {
        __typename?: 'CurriculumPersonsConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'CurriculumPersonsRelationship';
          properties: {
            __typename?: 'CurriculumPersonRelationshipProperties';
            description?: string | null;
            order: number;
            present?: boolean | null;
            teachingLoad?: boolean | null;
          };
          node: { __typename?: 'CurriculumPerson'; uuid: string };
        }>;
      };
    } | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    subject:
      | {
          __typename: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          epochEnabled?: boolean | null;
          subjectHourEnabled?: boolean | null;
          active?: boolean | null;
          defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }
      | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
    versions: Array<{
      __typename?: 'TimetableVersion';
      uuid: string;
      active?: boolean | null;
      editable?: boolean | null;
      version: number;
      timetable: { __typename?: 'Timetable'; uuid: string; name: string };
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'TeachingBlockVersion';
      uuid: string;
      active?: boolean | null;
      version: number;
      teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
    }>;
    activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    lessonClassesConnection: {
      __typename?: 'LessonLessonClassesConnection';
      edges: Array<{
        __typename?: 'LessonLessonClassesRelationship';
        node: {
          __typename?: 'LessonClass';
          uuid: string;
          class: {
            __typename?: 'Class';
            uuid: string;
            name: string;
            shortName: string;
            grade?: number | null;
            defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
            gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
            divisions: Array<{
              __typename?: 'Division';
              uuid: string;
              groups: Array<{ __typename?: 'Group'; uuid: string }>;
            }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
          groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
          groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
          usedDivision?: {
            __typename?: 'Division';
            uuid: string;
            name: string;
            groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
            groupsConnection: {
              __typename?: 'DivisionGroupsConnection';
              edges: Array<{
                __typename?: 'DivisionGroupsRelationship';
                properties: { __typename?: 'OrderedRelationProperties'; order: number };
                node: { __typename?: 'Group'; uuid: string; name: string };
              }>;
            };
          } | null;
        };
      }>;
    };
    lessonUnitConnection: {
      __typename?: 'LessonLessonUnitConnection';
      edges: Array<{
        __typename?: 'LessonLessonUnitRelationship';
        node: {
          __typename?: 'LessonUnit';
          uuid: string;
          duration?: number | null;
          count?: number | null;
          subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'LessonTeachersConnection';
      edges: Array<{
        __typename?: 'LessonTeachersRelationship';
        properties: {
          __typename?: 'LessonTeacherRelationshipProperties';
          description?: string | null;
          present?: boolean | null;
          teachingLoad?: boolean | null;
          teachingLoadHours?: number | null;
          writesCertificate?: boolean | null;
        };
        node: {
          __typename?: 'Person';
          uuid: string;
          shortName: string;
          fullName: string;
          firstName: string;
          lastName: string;
          displayNameShort?: string | null;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
      }>;
    };
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
        node: { __typename?: 'Room'; uuid: string; name: string };
      }>;
    };
  }>;
};

export type LessonsWithoutCardsQueryVariables = Exact<{
  lessonWhere?: InputMaybe<LessonWhere>;
  organizationUuid: Scalars['ID']['input'];
  options?: InputMaybe<LessonOptions>;
}>;

export type LessonsWithoutCardsQuery = {
  __typename?: 'Query';
  lessons: Array<{
    __typename?: 'Lesson';
    uuid: string;
    groupClassNames: string;
    gradeGroupUuid?: Array<string> | null;
    onlyInTimetableVersion: boolean;
    classSort: string;
    teachersSort: string;
    placedCardsCount?: number | null;
    teachingBlockPlacedCardsCount?: number | null;
    subTitle?: string | null;
    comment?: string | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    curriculum?: {
      __typename?: 'Curriculum';
      uuid: string;
      personsConnection: {
        __typename?: 'CurriculumPersonsConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'CurriculumPersonsRelationship';
          properties: {
            __typename?: 'CurriculumPersonRelationshipProperties';
            description?: string | null;
            order: number;
            present?: boolean | null;
            teachingLoad?: boolean | null;
          };
          node: { __typename?: 'CurriculumPerson'; uuid: string };
        }>;
      };
    } | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    subject:
      | {
          __typename: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          epochEnabled?: boolean | null;
          subjectHourEnabled?: boolean | null;
          active?: boolean | null;
          defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }
      | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
    versions: Array<{
      __typename?: 'TimetableVersion';
      uuid: string;
      active?: boolean | null;
      editable?: boolean | null;
      version: number;
      timetable: { __typename?: 'Timetable'; uuid: string; name: string };
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'TeachingBlockVersion';
      uuid: string;
      active?: boolean | null;
      version: number;
      teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
    }>;
    activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    lessonClassesConnection: {
      __typename?: 'LessonLessonClassesConnection';
      edges: Array<{
        __typename?: 'LessonLessonClassesRelationship';
        node: {
          __typename?: 'LessonClass';
          uuid: string;
          class: {
            __typename?: 'Class';
            uuid: string;
            name: string;
            shortName: string;
            grade?: number | null;
            defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
            gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
            divisions: Array<{
              __typename?: 'Division';
              uuid: string;
              groups: Array<{ __typename?: 'Group'; uuid: string }>;
            }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
          groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
          groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
          usedDivision?: {
            __typename?: 'Division';
            uuid: string;
            name: string;
            groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
            groupsConnection: {
              __typename?: 'DivisionGroupsConnection';
              edges: Array<{
                __typename?: 'DivisionGroupsRelationship';
                properties: { __typename?: 'OrderedRelationProperties'; order: number };
                node: { __typename?: 'Group'; uuid: string; name: string };
              }>;
            };
          } | null;
        };
      }>;
    };
    lessonUnitConnection: {
      __typename?: 'LessonLessonUnitConnection';
      edges: Array<{
        __typename?: 'LessonLessonUnitRelationship';
        node: {
          __typename?: 'LessonUnit';
          uuid: string;
          duration?: number | null;
          count?: number | null;
          subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'LessonTeachersConnection';
      edges: Array<{
        __typename?: 'LessonTeachersRelationship';
        properties: {
          __typename?: 'LessonTeacherRelationshipProperties';
          description?: string | null;
          present?: boolean | null;
          teachingLoad?: boolean | null;
          teachingLoadHours?: number | null;
          writesCertificate?: boolean | null;
        };
        node: {
          __typename?: 'Person';
          uuid: string;
          shortName: string;
          fullName: string;
          firstName: string;
          lastName: string;
          displayNameShort?: string | null;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
      }>;
    };
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
        node: { __typename?: 'Room'; uuid: string; name: string };
      }>;
    };
  }>;
  people: Array<{
    __typename?: 'Person';
    uuid: string;
    selectName: string;
    qualifications: Array<{ __typename?: 'Qualification'; subject: { __typename?: 'Subject'; uuid: string } }>;
  }>;
  subjects: Array<{
    __typename?: 'Subject';
    uuid: string;
    name: string;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
  }>;
  classes: Array<{ __typename?: 'Class'; uuid: string; name: string }>;
  rooms: Array<{ __typename?: 'Room'; uuid: string; name: string; roomNumber?: string | null }>;
};

export type TeachingBlockLessonsQueryVariables = Exact<{
  lessonWhere?: InputMaybe<LessonWhere>;
  options?: InputMaybe<LessonOptions>;
  organizationUuid: Scalars['ID']['input'];
}>;

export type TeachingBlockLessonsQuery = {
  __typename?: 'Query';
  lessons: Array<{
    __typename?: 'Lesson';
    uuid: string;
    groupClassNames: string;
    gradeGroupUuid?: Array<string> | null;
    onlyInTimetableVersion: boolean;
    classSort: string;
    teachersSort: string;
    placedCardsCount?: number | null;
    teachingBlockPlacedCardsCount?: number | null;
    subTitle?: string | null;
    comment?: string | null;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    curriculum?: {
      __typename?: 'Curriculum';
      uuid: string;
      personsConnection: {
        __typename?: 'CurriculumPersonsConnection';
        totalCount: number;
        edges: Array<{
          __typename?: 'CurriculumPersonsRelationship';
          properties: {
            __typename?: 'CurriculumPersonRelationshipProperties';
            description?: string | null;
            order: number;
            present?: boolean | null;
            teachingLoad?: boolean | null;
          };
          node: { __typename?: 'CurriculumPerson'; uuid: string };
        }>;
      };
    } | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    subject:
      | {
          __typename: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          epochEnabled?: boolean | null;
          subjectHourEnabled?: boolean | null;
          active?: boolean | null;
          defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }
      | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
    versions: Array<{
      __typename?: 'TimetableVersion';
      uuid: string;
      active?: boolean | null;
      editable?: boolean | null;
      version: number;
      timetable: { __typename?: 'Timetable'; uuid: string; name: string };
    }>;
    teachingBlockVersions: Array<{
      __typename?: 'TeachingBlockVersion';
      uuid: string;
      active?: boolean | null;
      version: number;
      teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
    }>;
    activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
    lessonClassesConnection: {
      __typename?: 'LessonLessonClassesConnection';
      edges: Array<{
        __typename?: 'LessonLessonClassesRelationship';
        node: {
          __typename?: 'LessonClass';
          uuid: string;
          class: {
            __typename?: 'Class';
            uuid: string;
            name: string;
            shortName: string;
            grade?: number | null;
            defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
            gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
            divisions: Array<{
              __typename?: 'Division';
              uuid: string;
              groups: Array<{ __typename?: 'Group'; uuid: string }>;
            }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
          groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
          groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
          usedDivision?: {
            __typename?: 'Division';
            uuid: string;
            name: string;
            groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
            groupsConnection: {
              __typename?: 'DivisionGroupsConnection';
              edges: Array<{
                __typename?: 'DivisionGroupsRelationship';
                properties: { __typename?: 'OrderedRelationProperties'; order: number };
                node: { __typename?: 'Group'; uuid: string; name: string };
              }>;
            };
          } | null;
        };
      }>;
    };
    lessonUnitConnection: {
      __typename?: 'LessonLessonUnitConnection';
      edges: Array<{
        __typename?: 'LessonLessonUnitRelationship';
        node: {
          __typename?: 'LessonUnit';
          uuid: string;
          duration?: number | null;
          count?: number | null;
          subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'LessonTeachersConnection';
      edges: Array<{
        __typename?: 'LessonTeachersRelationship';
        properties: {
          __typename?: 'LessonTeacherRelationshipProperties';
          description?: string | null;
          present?: boolean | null;
          teachingLoad?: boolean | null;
          teachingLoadHours?: number | null;
          writesCertificate?: boolean | null;
        };
        node: {
          __typename?: 'Person';
          uuid: string;
          shortName: string;
          fullName: string;
          firstName: string;
          lastName: string;
          displayNameShort?: string | null;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
      }>;
    };
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
        node: { __typename?: 'Room'; uuid: string; name: string };
      }>;
    };
  }>;
  people: Array<{
    __typename?: 'Person';
    uuid: string;
    selectName: string;
    qualifications: Array<{ __typename?: 'Qualification'; subject: { __typename?: 'Subject'; uuid: string } }>;
  }>;
  subjects: Array<{
    __typename?: 'Subject';
    uuid: string;
    name: string;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
  }>;
  classes: Array<{ __typename?: 'Class'; uuid: string; name: string }>;
  rooms: Array<{ __typename?: 'Room'; uuid: string; name: string; roomNumber?: string | null }>;
};

export type MathplanJobQueryVariables = Exact<{
  where: MathplanJobWhere;
  options?: InputMaybe<MathplanJobOptions>;
}>;

export type MathplanJobQuery = {
  __typename?: 'Query';
  mathplanJobs: Array<{
    __typename?: 'MathplanJob';
    jobId: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    status: string;
    gap: number;
    solutionFound: boolean;
    solution?: string | null;
    problem?: string | null;
    log?: string | null;
    errors?: string | null;
    timetableVersion: {
      __typename?: 'TimetableVersion';
      uuid: string;
      version: number;
      active?: boolean | null;
      timetable: {
        __typename?: 'Timetable';
        uuid: string;
        name: string;
        schoolYear: { __typename?: 'SchoolYear'; uuid: string; name: string };
      };
    };
  }>;
};

export type PimOrganizationsQueryVariables = Exact<{
  where?: InputMaybe<PimOrganizationWhere>;
}>;

export type PimOrganizationsQuery = {
  __typename?: 'Query';
  pimOrganizations: Array<{
    __typename?: 'PimOrganization';
    uuid: string;
    name: string;
    planungEnabled?: boolean | null;
    iphisVplanEnabled?: boolean | null;
    vpoEnabled?: boolean | null;
  }>;
};

export type OrganizationsQueryVariables = Exact<{
  where?: InputMaybe<OrganizationWhere>;
}>;

export type OrganizationsQuery = {
  __typename?: 'Query';
  organizations: Array<{
    __typename?: 'Organization';
    uuid: string;
    vpoSubstitutionProps?: string | null;
    iphisSubstitutionProps?: string | null;
  }>;
};

export type CreatePeopleMutationVariables = Exact<{
  input: Array<PersonCreateInput> | PersonCreateInput;
}>;

export type CreatePeopleMutation = {
  __typename?: 'Mutation';
  createPeople: {
    __typename?: 'CreatePeopleMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdatePeopleMutationVariables = Exact<{
  where?: InputMaybe<PersonWhere>;
  update?: InputMaybe<PersonUpdateInput>;
}>;

export type UpdatePeopleMutation = {
  __typename?: 'Mutation';
  updatePeople: {
    __typename?: 'UpdatePeopleMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type DeletePeopleMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeletePeopleMutation = {
  __typename?: 'Mutation';
  deletePeople: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateShortNamesMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type UpdateShortNamesMutation = {
  __typename?: 'Mutation';
  updateShortNames?: { __typename?: 'UpdateShortNamesMutationResponse'; updated: number } | null;
};

export type UpdateActivePeopleMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateActivePeopleMutation = {
  __typename?: 'Mutation';
  updatePeople: {
    __typename?: 'UpdatePeopleMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type UpdatePeopleColorMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  color: Scalars['String']['input'];
}>;

export type UpdatePeopleColorMutation = {
  __typename?: 'Mutation';
  updatePeople: {
    __typename?: 'UpdatePeopleMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type PersonsQueryVariables = Exact<{
  where?: InputMaybe<PersonWhere>;
  contractOptions?: InputMaybe<ContractOptions>;
  subjectsWhere?: InputMaybe<SubjectWhere>;
  currentDate?: InputMaybe<Scalars['Date']['input']>;
  schoolYearUuid: Scalars['String']['input'];
  sortOptions?: InputMaybe<Array<PersonSort> | PersonSort>;
}>;

export type PersonsQuery = {
  __typename?: 'Query';
  people: Array<{
    __typename?: 'Person';
    uuid: string;
    pimProfileUuid?: string | null;
    personalId?: string | null;
    listName: string;
    firstName: string;
    lastName: string;
    fullName: string;
    selectName: string;
    shortName: string;
    uniqueFirstName?: string | null;
    callingName?: string | null;
    prefixName?: string | null;
    salutation?: string | null;
    title?: string | null;
    email?: string | null;
    birthday?: any | null;
    gender?: string | null;
    active?: boolean | null;
    displayNameShort?: string | null;
    displayName: string;
    defaultRoom?: { __typename?: 'Room'; uuid: string } | null;
    contractsAggregate?: { __typename?: 'PersonContractContractsAggregationSelection'; count: number } | null;
    organizationConnection: {
      __typename?: 'PersonOrganizationConnection';
      edges: Array<{
        __typename?: 'PersonOrganizationRelationship';
        properties: { __typename?: 'RoleName'; name: PersonRole };
      }>;
    };
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null; colorLabel?: string | null } | null;
    contracts: Array<{
      __typename?: 'Contract';
      uuid: string;
      name: string;
      validFrom: any;
      validUntil?: any | null;
      hoursWeekly?: number | null;
      freelancer?: boolean | null;
      billingMethod?: BillingMethods | null;
      limitedToFullTime?: boolean | null;
      substituteHours?: number | null;
    }>;
    currentContract?: {
      __typename?: 'Contract';
      uuid: string;
      name: string;
      validFrom: any;
      validUntil?: any | null;
      hoursWeekly?: number | null;
      freelancer?: boolean | null;
      billingMethod?: BillingMethods | null;
      limitedToFullTime?: boolean | null;
      substituteHours?: number | null;
    } | null;
    currentContractOpenEnd: Array<{
      __typename?: 'Contract';
      uuid: string;
      name: string;
      validFrom: any;
      validUntil?: any | null;
      hoursWeekly?: number | null;
      freelancer?: boolean | null;
      billingMethod?: BillingMethods | null;
      limitedToFullTime?: boolean | null;
      substituteHours?: number | null;
    }>;
    qualificationsAggregate?: {
      __typename?: 'PersonQualificationQualificationsAggregationSelection';
      count: number;
    } | null;
    qualifications: Array<{
      __typename?: 'Qualification';
      maxGrade?: number | null;
      minGrade?: number | null;
      maxTeachingLoad?: number | null;
      subject: { __typename?: 'Subject'; uuid: string; name: string; shortName: string };
    }>;
  }>;
  subjects: Array<{ __typename?: 'Subject'; uuid: string; name: string }>;
};

export type _PublishedSubstitutionsQueryVariables = Exact<{
  where?: InputMaybe<PublishedSubstitutionsWhere>;
  options?: InputMaybe<PublishedSubstitutionsOptions>;
}>;

export type _PublishedSubstitutionsQuery = {
  __typename?: 'Query';
  publishedSubstitutions: Array<{
    __typename?: 'PublishedSubstitutions';
    uuid: string;
    date: any;
    lastPublished: any;
    teachers: string;
    classes: string;
    substitutions: string;
    notifications: string;
  }>;
};

export type CreateRoomsMutationVariables = Exact<{
  input: Array<RoomCreateInput> | RoomCreateInput;
}>;

export type CreateRoomsMutation = {
  __typename?: 'Mutation';
  createRooms: {
    __typename?: 'CreateRoomsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateRoomsMutationVariables = Exact<{
  where?: InputMaybe<RoomWhere>;
  update?: InputMaybe<RoomUpdateInput>;
}>;

export type UpdateRoomsMutation = {
  __typename?: 'Mutation';
  updateRooms: {
    __typename?: 'UpdateRoomsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; nodesDeleted: number };
  };
};

export type DeleteRoomsMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteRoomsMutation = {
  __typename?: 'Mutation';
  deleteRooms: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type RoomsListQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type RoomsListQuery = {
  __typename?: 'Query';
  rooms: Array<{
    __typename?: 'Room';
    uuid: string;
    name: string;
    position?: string | null;
    roomNumber?: string | null;
    description?: string | null;
    classroom?: boolean | null;
    canBeLeased?: boolean | null;
    capacity?: number | null;
    chairs?: number | null;
    tables?: number | null;
    size?: number | null;
    otherInventory?: string | null;
    barrierFree?: boolean | null;
    canBeDarkened?: boolean | null;
    hasProjector?: boolean | null;
    hasScreen?: boolean | null;
    hasMediaCabinet?: boolean | null;
    hasPiano?: boolean | null;
    building?: { __typename?: 'Building'; uuid: string; name: string } | null;
    responsiblePersonsConnection: {
      __typename?: 'RoomResponsiblePersonsConnection';
      edges: Array<{
        __typename?: 'RoomResponsiblePersonsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename?: 'Person'; uuid: string; displayNameShort?: string | null };
      }>;
    };
  }>;
  buildings: Array<{ __typename?: 'Building'; uuid: string; name: string }>;
  people: Array<{
    __typename?: 'Person';
    uuid: string;
    firstName: string;
    lastName: string;
    displayNameShort?: string | null;
  }>;
};

export type CreateSchoolYearsMutationVariables = Exact<{
  input: Array<SchoolYearCreateInput> | SchoolYearCreateInput;
}>;

export type CreateSchoolYearsMutation = {
  __typename?: 'Mutation';
  createSchoolYears: {
    __typename?: 'CreateSchoolYearsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateSchoolYearsMutationVariables = Exact<{
  where?: InputMaybe<SchoolYearWhere>;
  update?: InputMaybe<SchoolYearUpdateInput>;
}>;

export type UpdateSchoolYearsMutation = {
  __typename?: 'Mutation';
  updateSchoolYears: {
    __typename?: 'UpdateSchoolYearsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type DeleteSchoolYearsMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteSchoolYearsMutation = {
  __typename?: 'Mutation';
  deleteSchoolYears: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type SchoolYearsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type SchoolYearsQuery = {
  __typename?: 'Query';
  schoolYears: Array<{
    __typename?: 'SchoolYear';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
    fullTimeHours?: number | null;
    holidays: Array<{ __typename?: 'Holiday'; uuid: string; name: string; start: any; end: any }>;
  }>;
};

export type DeleteSubjectContainerMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteSubjectContainerMutation = {
  __typename?: 'Mutation';
  deleteSubjectContainers: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateSubjectContainerMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update?: InputMaybe<SubjectContainerUpdateInput>;
}>;

export type UpdateSubjectContainerMutation = {
  __typename?: 'Mutation';
  updateSubjectContainers: {
    __typename?: 'UpdateSubjectContainersMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type CreateSubjectContainersMutationVariables = Exact<{
  input: Array<SubjectContainerCreateInput> | SubjectContainerCreateInput;
}>;

export type CreateSubjectContainersMutation = {
  __typename?: 'Mutation';
  createSubjectContainers: {
    __typename?: 'CreateSubjectContainersMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type SubjectContainersListQueryVariables = Exact<{
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  subjectContainerUuid?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<SubjectContainerOptions>;
}>;

export type SubjectContainersListQuery = {
  __typename?: 'Query';
  subjectContainers: Array<{
    __typename?: 'SubjectContainer';
    uuid: string;
    name: string;
    grades: Array<number>;
    shortName: string;
    order?: number | null;
    gradeGroup: Array<{ __typename?: 'GradeGroup'; uuid: string; name: string; shortName: string }>;
    validFrom?: {
      __typename?: 'SchoolYear';
      uuid: string;
      name: string;
      shortName: string;
      start: any;
      end: any;
    } | null;
    validUntil?: {
      __typename?: 'SchoolYear';
      uuid: string;
      name: string;
      shortName: string;
      start: any;
      end: any;
    } | null;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null; colorLabel?: string | null } | null;
  }>;
  schoolYears: Array<{
    __typename?: 'SchoolYear';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
  }>;
};

export type _SubjectContainersUsedInQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  options?: InputMaybe<SubjectContainerOptions>;
}>;

export type _SubjectContainersUsedInQuery = {
  __typename?: 'Query';
  subjectContainers: Array<{
    __typename: 'SubjectContainer';
    uuid: string;
    name: string;
    teachingBlocksAggregate?: {
      __typename?: 'SubjectContainerTeachingBlockTeachingBlocksAggregationSelection';
      count: number;
    } | null;
    lessonUnitsAggregate?: {
      __typename?: 'SubjectContainerLessonUnitLessonUnitsAggregationSelection';
      count: number;
    } | null;
    lessons: Array<{
      __typename?: 'Lesson';
      uuid: string;
      displayName: Array<string>;
      versions: Array<{
        __typename?: 'TimetableVersion';
        uuid: string;
        version: number;
        description?: string | null;
        timetable: { __typename?: 'Timetable'; name: string };
      }>;
    }>;
    curricula: Array<{ __typename?: 'Curriculum'; uuid: string; displayName: Array<string> }>;
  }>;
};

export type DeleteSubjectGroupMutationVariables = Exact<{
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DeleteSubjectGroupMutation = {
  __typename?: 'Mutation';
  deleteSubjectGroups: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateSubjectGroupMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update?: InputMaybe<SubjectGroupUpdateInput>;
}>;

export type UpdateSubjectGroupMutation = {
  __typename?: 'Mutation';
  updateSubjectGroups: {
    __typename?: 'UpdateSubjectGroupsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type CreateSubjectGroupMutationVariables = Exact<{
  input: Array<SubjectGroupCreateInput> | SubjectGroupCreateInput;
}>;

export type CreateSubjectGroupMutation = {
  __typename?: 'Mutation';
  createSubjectGroups: {
    __typename?: 'CreateSubjectGroupsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type SubjectGroupsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  subjectGroupUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SubjectGroupsQuery = {
  __typename?: 'Query';
  subjectGroups: Array<{ __typename?: 'SubjectGroup'; uuid: string; name: string }>;
};

export type SubjectFragmentFragment = {
  __typename?: 'Subject';
  name: string;
  uuid: string;
  shortName: string;
  subjectHourEnabled?: boolean | null;
  epochEnabled?: boolean | null;
  active?: boolean | null;
  other?: boolean | null;
  defaultRoomsConnection: {
    __typename?: 'SubjectDefaultRoomsConnection';
    edges: Array<{
      __typename?: 'SubjectDefaultRoomsRelationship';
      node: { __typename?: 'Room'; uuid: string; name: string };
    }>;
  };
  subjectGroup?: { __typename?: 'SubjectGroup'; uuid: string; name: string } | null;
  timetableConfig?: {
    __typename?: 'TimetableConfig';
    uuid: string;
    color?: string | null;
    colorLabel?: string | null;
  } | null;
};

export type DeleteSubjectsMutationVariables = Exact<{
  where?: InputMaybe<SubjectWhere>;
}>;

export type DeleteSubjectsMutation = {
  __typename?: 'Mutation';
  deleteSubjects: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DeleteQualificationMutationVariables = Exact<{
  where?: InputMaybe<QualificationWhere>;
}>;

export type DeleteQualificationMutation = {
  __typename?: 'Mutation';
  deleteQualifications: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateSubjectsMutationVariables = Exact<{
  where?: InputMaybe<SubjectWhere>;
  update?: InputMaybe<SubjectUpdateInput>;
}>;

export type UpdateSubjectsMutation = {
  __typename?: 'Mutation';
  updateSubjects: {
    __typename?: 'UpdateSubjectsMutationResponse';
    subjects: Array<{
      __typename?: 'Subject';
      name: string;
      uuid: string;
      shortName: string;
      subjectHourEnabled?: boolean | null;
      epochEnabled?: boolean | null;
      active?: boolean | null;
      other?: boolean | null;
      defaultRoomsConnection: {
        __typename?: 'SubjectDefaultRoomsConnection';
        edges: Array<{
          __typename?: 'SubjectDefaultRoomsRelationship';
          node: { __typename?: 'Room'; uuid: string; name: string };
        }>;
      };
      subjectGroup?: { __typename?: 'SubjectGroup'; uuid: string; name: string } | null;
      timetableConfig?: {
        __typename?: 'TimetableConfig';
        uuid: string;
        color?: string | null;
        colorLabel?: string | null;
      } | null;
    }>;
  };
};

export type CreateSubjectMutationVariables = Exact<{
  input: Array<SubjectCreateInput> | SubjectCreateInput;
}>;

export type CreateSubjectMutation = {
  __typename?: 'Mutation';
  createSubjects: {
    __typename?: 'CreateSubjectsMutationResponse';
    subjects: Array<{
      __typename?: 'Subject';
      name: string;
      uuid: string;
      shortName: string;
      subjectHourEnabled?: boolean | null;
      epochEnabled?: boolean | null;
      active?: boolean | null;
      other?: boolean | null;
      defaultRoomsConnection: {
        __typename?: 'SubjectDefaultRoomsConnection';
        edges: Array<{
          __typename?: 'SubjectDefaultRoomsRelationship';
          node: { __typename?: 'Room'; uuid: string; name: string };
        }>;
      };
      subjectGroup?: { __typename?: 'SubjectGroup'; uuid: string; name: string } | null;
      timetableConfig?: {
        __typename?: 'TimetableConfig';
        uuid: string;
        color?: string | null;
        colorLabel?: string | null;
      } | null;
    }>;
  };
};

export type SubjectsListQueryVariables = Exact<{
  where?: InputMaybe<SubjectWhere>;
  options?: InputMaybe<SubjectOptions>;
}>;

export type SubjectsListQuery = {
  __typename?: 'Query';
  subjects: Array<{
    __typename?: 'Subject';
    name: string;
    uuid: string;
    shortName: string;
    subjectHourEnabled?: boolean | null;
    epochEnabled?: boolean | null;
    active?: boolean | null;
    other?: boolean | null;
    timetableConfig?: {
      __typename?: 'TimetableConfig';
      color?: string | null;
      colorLabel?: string | null;
      printOrder?: number | null;
      printPageNr?: number | null;
      uuid: string;
    } | null;
    defaultRoomsConnection: {
      __typename?: 'SubjectDefaultRoomsConnection';
      edges: Array<{
        __typename?: 'SubjectDefaultRoomsRelationship';
        node: { __typename?: 'Room'; uuid: string; name: string };
      }>;
    };
    subjectGroup?: { __typename?: 'SubjectGroup'; uuid: string; name: string } | null;
  }>;
};

export type UpdateSubstitutionSettingsMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  update?: InputMaybe<OrganizationUpdateInput>;
}>;

export type UpdateSubstitutionSettingsMutation = {
  __typename?: 'Mutation';
  updateOrganizations: {
    __typename?: 'UpdateOrganizationsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type TeachersSubstitutionsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  classUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  subjectUuid?: InputMaybe<Scalars['String']['input']>;
}>;

export type TeachersSubstitutionsQuery = {
  __typename?: 'Query';
  teachersSubstitutions: Array<{
    __typename?: 'TeacherSubstitutionStats';
    givenSubstituteHours: number;
    sameClass?: boolean | null;
    sameSubject?: boolean | null;
    substituteHours?: number | null;
    teacherUuid: string;
  }>;
};

export type SubstitutionAnnouncementsQueryVariables = Exact<{
  selectedDay: Scalars['Date']['input'];
}>;

export type SubstitutionAnnouncementsQuery = {
  __typename?: 'Query';
  substitutionAnnouncements: Array<{
    __typename?: 'SubstitutionAnnouncement';
    uuid: string;
    date: any;
    publicAnnouncement?: string | null;
    internalAnnouncement?: string | null;
  }>;
};

export type CreateSubstitutionAnnouncementsMutationVariables = Exact<{
  input: SubstitutionAnnouncementCreateInput;
}>;

export type CreateSubstitutionAnnouncementsMutation = {
  __typename?: 'Mutation';
  createSubstitutionAnnouncements: {
    __typename?: 'CreateSubstitutionAnnouncementsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateSubstitutionAnnouncementsMutationVariables = Exact<{
  where: SubstitutionAnnouncementWhere;
  update: SubstitutionAnnouncementUpdateInput;
}>;

export type UpdateSubstitutionAnnouncementsMutation = {
  __typename?: 'Mutation';
  updateSubstitutionAnnouncements: {
    __typename?: 'UpdateSubstitutionAnnouncementsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type SubstitutionPrintConfigsQueryVariables = Exact<{
  where: SubstitutionPrintConfigWhere;
}>;

export type SubstitutionPrintConfigsQuery = {
  __typename?: 'Query';
  substitutionPrintConfigs: Array<{
    __typename?: 'SubstitutionPrintConfig';
    uuid: string;
    showMissingTeachers: boolean;
    showMissingTeachersShortName: boolean;
    showAnnouncements: boolean;
    showSchoolEvents: boolean;
    useTeacherShortname: boolean;
    pageOrientation: string;
    printImages: boolean;
    useLessonName: boolean;
    lineScale: number;
    fontScale: number;
    columnConfigs: Array<{
      __typename?: 'SubstitutionPrintColumnConfig';
      position: number;
      column: SubstitutionColumns;
      print: boolean;
      width: number;
      sortOrder: number;
      sortDirection: string;
    }>;
  }>;
};

export type CreateSubstitutionPrintConfigsMutationVariables = Exact<{
  input: SubstitutionPrintConfigCreateInput;
}>;

export type CreateSubstitutionPrintConfigsMutation = {
  __typename?: 'Mutation';
  createSubstitutionPrintConfigs: {
    __typename?: 'CreateSubstitutionPrintConfigsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateSubstitutionPrintConfigsMutationVariables = Exact<{
  where: SubstitutionPrintConfigWhere;
  update: SubstitutionPrintConfigUpdateInput;
}>;

export type UpdateSubstitutionPrintConfigsMutation = {
  __typename?: 'Mutation';
  updateSubstitutionPrintConfigs: {
    __typename?: 'UpdateSubstitutionPrintConfigsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type SubstitutionAppConfigsQueryVariables = Exact<{
  where: SubstitutionAppConfigWhere;
}>;

export type SubstitutionAppConfigsQuery = {
  __typename?: 'Query';
  substitutionAppConfigs: Array<{
    __typename?: 'SubstitutionAppConfig';
    uuid: string;
    teacherPassword: string;
    studentPassword: string;
    allowIndividualLogins: boolean;
    useTeacherShortname: boolean;
    useClassShortname: boolean;
    useRoomShortname: boolean;
    timeDisplayMode: string;
    showClassGroups: boolean;
    showOriginalSubject: boolean;
    showCurrentSubject: boolean;
    showHolidays: boolean;
  }>;
};

export type CreateSubstitutionAppConfigsMutationVariables = Exact<{
  input: SubstitutionAppConfigCreateInput;
}>;

export type CreateSubstitutionAppConfigsMutation = {
  __typename?: 'Mutation';
  createSubstitutionAppConfigs: {
    __typename?: 'CreateSubstitutionAppConfigsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateSubstitutionAppConfigsMutationVariables = Exact<{
  where: SubstitutionAppConfigWhere;
  update: SubstitutionAppConfigUpdateInput;
}>;

export type UpdateSubstitutionAppConfigsMutation = {
  __typename?: 'Mutation';
  updateSubstitutionAppConfigs: {
    __typename?: 'UpdateSubstitutionAppConfigsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number };
  };
};

export type SubstitutionReportQueryVariables = Exact<{
  where: SubstitutionReportWhere;
  options?: InputMaybe<SubstitutionReportOptions>;
}>;

export type SubstitutionReportQuery = {
  __typename?: 'Query';
  substitutionReports: Array<{
    __typename?: 'SubstitutionReport';
    uuid: string;
    type: SubstitutionReportType;
    title: string;
    jobCreated: any;
    jobFinished: any;
    jobConfiguration: string;
    context:
      | { __typename?: 'SchoolYear'; uuid: string; name: string }
      | { __typename?: 'TeachingBlock'; uuid: string; name: string }
      | { __typename?: 'TimetableBlock'; uuid: string; name: string };
    fileEntries: Array<{ __typename?: 'FileEntry'; uuid: string; filename: string; created: any; updated: any }>;
  }>;
};

export type AttendancePlanEventsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  day: Scalars['Date']['input'];
}>;

export type AttendancePlanEventsQuery = {
  __typename?: 'Query';
  attendancePlanEvents: Array<{
    __typename?: 'AttendancePlanEvent';
    uuid: string;
    start: any;
    end: any;
    subject: { __typename?: 'MinimalSubject'; uuid: string; shortName: string; name: string };
    persons: Array<{
      __typename: 'MinimalPerson';
      uuid: string;
      displayName: string;
      firstName: string;
      lastName: string;
      listName: string;
      selectName: string;
    }>;
    rooms: Array<{ __typename?: 'MinimalRoom'; uuid: string; name: string }>;
    class: { __typename?: 'MinimalClass'; uuid: string; shortName: string; name: string };
  }>;
};

export type _CancelSynchronisationEventMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update?: InputMaybe<EventJobUpdateInput>;
}>;

export type _CancelSynchronisationEventMutation = {
  __typename?: 'Mutation';
  updateEventJobs: {
    __typename?: 'UpdateEventJobsMutationResponse';
    eventJobs: Array<{ __typename?: 'EventJob'; uuid: string }>;
  };
};

export type TeachingBlockClassGridCardsQueryVariables = Exact<{
  teachingBlockVersionUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TeachingBlockClassGridCardsQuery = {
  __typename?: 'Query';
  teachingBlockClassGridCards: Array<{
    __typename?: 'TeachingBlockClassGridCard';
    uuid: string;
    teachingBlockCardUuid: string;
    classUuid: string;
    lessonUuid: string;
    divisionsCount?: number | null;
    usedPosition: number;
    cssGradientString?: string | null;
    cssHeight?: string | null;
    cssTop?: string | null;
    textColor?: string | null;
    colors: Array<string>;
    locked?: boolean | null;
    startDate?: any | null;
    endDate?: any | null;
    duration?: number | null;
    includeHoliday: boolean;
  }>;
};

export type CreateTeachingBlockMutationVariables = Exact<{
  input: Array<TeachingBlockCreateInput> | TeachingBlockCreateInput;
}>;

export type CreateTeachingBlockMutation = {
  __typename?: 'Mutation';
  createTeachingBlocks: {
    __typename?: 'CreateTeachingBlocksMutationResponse';
    teachingBlocks: Array<{ __typename?: 'TeachingBlock'; uuid: string }>;
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type DeleteTeachingBlockMutationVariables = Exact<{
  delete?: InputMaybe<TeachingBlockDeleteInput>;
}>;

export type DeleteTeachingBlockMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlocks: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateTeachingBlockMutationVariables = Exact<{
  update?: InputMaybe<TeachingBlockUpdateInput>;
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type UpdateTeachingBlockMutation = {
  __typename?: 'Mutation';
  updateTeachingBlocks: {
    __typename?: 'UpdateTeachingBlocksMutationResponse';
    teachingBlocks: Array<{ __typename?: 'TeachingBlock'; uuid: string; updatedAt: any }>;
  };
};

export type CreateTeachingBlockVersionsMutationVariables = Exact<{
  version: Scalars['Int']['input'];
  rooms?: InputMaybe<TeachingBlockVersionRoomsFieldInput>;
  teachers?: InputMaybe<TeachingBlockVersionTeachersFieldInput>;
  classes?: InputMaybe<TeachingBlockVersionClassesFieldInput>;
  subjects?: InputMaybe<TeachingBlockVersionSubjectsFieldInput>;
  teachingBlock?: InputMaybe<TeachingBlockVersionTeachingBlockFieldInput>;
  cards?: InputMaybe<TeachingBlockVersionCardsFieldInput>;
}>;

export type CreateTeachingBlockVersionsMutation = {
  __typename?: 'Mutation';
  createTeachingBlockVersions: {
    __typename?: 'CreateTeachingBlockVersionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type CreateBackendTeachingBlockVersionMutationVariables = Exact<{
  subjectContainerUuid: Scalars['ID']['input'];
  schoolYearUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  connectLessons?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateBackendTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  createBackendTeachingBlockVersion: {
    __typename?: 'CreateTeachingBlockVersionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
    teachingBlockVersions: Array<{ __typename?: 'TeachingBlockVersion'; uuid: string }>;
  };
};

export type UpdateTeachingBlockVersionsMutationVariables = Exact<{
  where: TeachingBlockVersionWhere;
  update: TeachingBlockVersionUpdateInput;
}>;

export type UpdateTeachingBlockVersionsMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockVersions: {
    __typename?: 'UpdateTeachingBlockVersionsMutationResponse';
    teachingBlockVersions: Array<{ __typename?: 'TeachingBlockVersion'; uuid: string }>;
  };
};

export type DeleteTeachingBlockVersionsMutationVariables = Exact<{
  versionUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type DeleteTeachingBlockVersionsMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockVersions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DeleteTeachingBlockCardsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockCardWhere>;
  delete?: InputMaybe<TeachingBlockCardDeleteInput>;
}>;

export type DeleteTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockCards: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateTeachingBlockCardMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  lessonUuid: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
}>;

export type CreateTeachingBlockCardMutation = {
  __typename?: 'Mutation';
  createTeachingBlockCards: {
    __typename?: 'CreateTeachingBlockCardsMutationResponse';
    teachingBlockCards: Array<{ __typename?: 'TeachingBlockCard'; uuid: string }>;
  };
};

export type UpdateTeachingBlockCardsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockCardWhere>;
  update?: InputMaybe<TeachingBlockCardUpdateInput>;
}>;

export type UpdateTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockCards: {
    __typename?: 'UpdateTeachingBlockCardsMutationResponse';
    teachingBlockCards: Array<{ __typename?: 'TeachingBlockCard'; uuid: string }>;
  };
};

export type DuplicateTeachingBlockVersionMutationVariables = Exact<{
  teachingBlockVersionUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  options: DuplicateTeachingBlockVersionOptions;
}>;

export type DuplicateTeachingBlockVersionMutation = {
  __typename?: 'Mutation';
  duplicateTeachingBlockVersion: {
    __typename?: 'DuplicateTeachingBlockVersionResponse';
    active?: boolean | null;
    description?: string | null;
    uuid: string;
    version: number;
  };
};

export type TeachingBlockDraftQueryVariables = Exact<{
  where?: InputMaybe<TeachingBlockWhere>;
}>;

export type TeachingBlockDraftQuery = {
  __typename?: 'Query';
  teachingBlocks: Array<{
    __typename?: 'TeachingBlock';
    uuid: string;
    name: string;
    subjectContainer: { __typename?: 'SubjectContainer'; uuid: string };
    versions: Array<{
      __typename?: 'TeachingBlockVersion';
      uuid: string;
      active?: boolean | null;
      version: number;
      updatedAt?: any | null;
      createdAt?: any | null;
      description?: string | null;
      cardsAggregate?: {
        __typename?: 'TeachingBlockVersionTeachingBlockCardCardsAggregationSelection';
        count: number;
      } | null;
    }>;
  }>;
};

export type TeachingBlockCardsQueryVariables = Exact<{
  where: TeachingBlockCardWhere;
}>;

export type TeachingBlockCardsQuery = {
  __typename?: 'Query';
  teachingBlockCards: Array<{
    __typename?: 'TeachingBlockCard';
    uuid: string;
    duration?: number | null;
    startDate?: any | null;
    includeHoliday: boolean;
    endDate?: any | null;
    locked: boolean;
    rooms: Array<{ __typename?: 'Room'; name: string; uuid: string }>;
    teachingBlockVersion: { __typename?: 'TeachingBlockVersion'; version: number };
    teachers: Array<{
      __typename?: 'Person';
      uuid: string;
      pimProfileUuid?: string | null;
      displayNameShort?: string | null;
      timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
    }>;
    lesson: {
      __typename?: 'Lesson';
      uuid: string;
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          node: {
            __typename?: 'Room';
            uuid: string;
            name: string;
            building?: { __typename?: 'Building'; name: string } | null;
          };
        }>;
      };
    };
    subject:
      | {
          __typename?: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }
      | {
          __typename?: 'SubjectContainer';
          uuid: string;
          name: string;
          shortName: string;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
    lessonClasses: Array<{
      __typename?: 'LessonClass';
      uuid: string;
      class: {
        __typename?: 'Class';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
        divisions: Array<{
          __typename?: 'Division';
          uuid: string;
          groups: Array<{ __typename?: 'Group'; uuid: string }>;
        }>;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      };
      groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
      groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
      usedDivision?: {
        __typename?: 'Division';
        uuid: string;
        name: string;
        groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
        groupsConnection: {
          __typename?: 'DivisionGroupsConnection';
          edges: Array<{
            __typename?: 'DivisionGroupsRelationship';
            properties: { __typename?: 'OrderedRelationProperties'; order: number };
            node: { __typename?: 'Group'; uuid: string; name: string };
          }>;
        };
      } | null;
    }>;
  }>;
};

export type TeachingBlockVersionsQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type TeachingBlockVersionsQuery = {
  __typename?: 'Query';
  teachingBlockVersions: Array<{
    __typename?: 'TeachingBlockVersion';
    uuid: string;
    version: number;
    description?: string | null;
    active?: boolean | null;
    cards: Array<{
      __typename?: 'TeachingBlockCard';
      uuid: string;
      duration?: number | null;
      startDate?: any | null;
      includeHoliday: boolean;
      endDate?: any | null;
      locked: boolean;
      rooms: Array<{ __typename?: 'Room'; name: string; uuid: string }>;
      teachingBlockVersion: { __typename?: 'TeachingBlockVersion'; version: number };
      teachers: Array<{
        __typename?: 'Person';
        uuid: string;
        pimProfileUuid?: string | null;
        displayNameShort?: string | null;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      }>;
      lesson: {
        __typename?: 'Lesson';
        uuid: string;
        roomSupplyConnection: {
          __typename?: 'LessonRoomSupplyConnection';
          edges: Array<{
            __typename?: 'LessonRoomSupplyRelationship';
            node: {
              __typename?: 'Room';
              uuid: string;
              name: string;
              building?: { __typename?: 'Building'; name: string } | null;
            };
          }>;
        };
      };
      subject:
        | {
            __typename?: 'Subject';
            uuid: string;
            name: string;
            shortName: string;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          }
        | {
            __typename?: 'SubjectContainer';
            uuid: string;
            name: string;
            shortName: string;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
      lessonClasses: Array<{
        __typename?: 'LessonClass';
        uuid: string;
        class: {
          __typename?: 'Class';
          uuid: string;
          name: string;
          shortName: string;
          grade?: number | null;
          defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
          gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
          divisions: Array<{
            __typename?: 'Division';
            uuid: string;
            groups: Array<{ __typename?: 'Group'; uuid: string }>;
          }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
        groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
        groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
        usedDivision?: {
          __typename?: 'Division';
          uuid: string;
          name: string;
          groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
          groupsConnection: {
            __typename?: 'DivisionGroupsConnection';
            edges: Array<{
              __typename?: 'DivisionGroupsRelationship';
              properties: { __typename?: 'OrderedRelationProperties'; order: number };
              node: { __typename?: 'Group'; uuid: string; name: string };
            }>;
          };
        } | null;
      }>;
    }>;
    teachingBlock: {
      __typename?: 'TeachingBlock';
      uuid: string;
      name: string;
      subjectContainer: { __typename?: 'SubjectContainer'; uuid: string };
    };
    availabilityExclusions: Array<{
      __typename?: 'TeachingBlockAvailabilityExclusion';
      uuid: string;
      from: any;
      to: any;
      priority: number;
      comment?: string | null;
      holder:
        | { __typename: 'Class'; uuid: string }
        | { __typename: 'Person'; uuid: string }
        | { __typename: 'Room'; uuid: string }
        | { __typename: 'Subject'; uuid: string };
    }>;
    classesConnection: {
      __typename?: 'TeachingBlockVersionClassesConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionClassesRelationship';
        node: {
          __typename?: 'Class';
          uuid: string;
          name: string;
          shortName: string;
          grade?: number | null;
          certificatesEnabled?: boolean | null;
          gradeGroup?: {
            __typename?: 'GradeGroup';
            uuid: string;
            name: string;
            shortName: string;
            description?: string | null;
            class: Array<{ __typename?: 'Class'; uuid: string }>;
          } | null;
          timetableConfig?: {
            __typename?: 'TimetableConfig';
            color?: string | null;
            colorLabel?: string | null;
            printOrder?: number | null;
            printPageNr?: number | null;
          } | null;
          tutorsConnection: {
            __typename?: 'ClassTutorsConnection';
            edges: Array<{
              __typename?: 'ClassTutorsRelationship';
              properties: { __typename?: 'OrderedRelationProperties'; order: number };
              node: {
                __typename?: 'Person';
                uuid: string;
                personalId?: string | null;
                email?: string | null;
                birthday?: any | null;
                firstName: string;
                lastName: string;
                fullName: string;
                shortName: string;
                displayNameShort?: string | null;
              };
            }>;
          };
        };
      }>;
    };
    subjectsConnection: {
      __typename?: 'TeachingBlockVersionSubjectsConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionSubjectsRelationship';
        node: {
          __typename?: 'Subject';
          name: string;
          uuid: string;
          shortName: string;
          subjectHourEnabled?: boolean | null;
          epochEnabled?: boolean | null;
          active?: boolean | null;
          other?: boolean | null;
          subjectGroup?: { __typename?: 'SubjectGroup'; name: string } | null;
          timetableConfig?: {
            __typename?: 'TimetableConfig';
            color?: string | null;
            colorLabel?: string | null;
          } | null;
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'TeachingBlockVersionTeachersConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionTeachersRelationship';
        node: {
          __typename?: 'Person';
          uuid: string;
          personalId?: string | null;
          firstName: string;
          lastName: string;
          fullName: string;
          shortName: string;
          callingName?: string | null;
          prefixName?: string | null;
          uniqueFirstName?: string | null;
          salutation?: string | null;
          title?: string | null;
          email?: string | null;
          birthday?: any | null;
          gender?: string | null;
          active?: boolean | null;
          displayName: string;
          displayNameShort?: string | null;
          timetableConfig?: {
            __typename?: 'TimetableConfig';
            color?: string | null;
            colorLabel?: string | null;
          } | null;
        };
      }>;
    };
    roomsConnection: {
      __typename?: 'TeachingBlockVersionRoomsConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionRoomsRelationship';
        node: {
          __typename?: 'Room';
          uuid: string;
          name: string;
          position?: string | null;
          roomNumber?: string | null;
          description?: string | null;
          classroom?: boolean | null;
          canBeLeased?: boolean | null;
          capacity?: number | null;
          chairs?: number | null;
          tables?: number | null;
          size?: number | null;
          otherInventory?: string | null;
          barrierFree?: boolean | null;
          canBeDarkened?: boolean | null;
          hasProjector?: boolean | null;
          hasScreen?: boolean | null;
          hasMediaCabinet?: boolean | null;
          hasPiano?: boolean | null;
          building?: { __typename?: 'Building'; uuid: string; name: string } | null;
        };
      }>;
    };
    lessons: Array<{
      __typename?: 'Lesson';
      uuid: string;
      groupClassNames: string;
      gradeGroupUuid?: Array<string> | null;
      onlyInTimetableVersion: boolean;
      classSort: string;
      teachersSort: string;
      placedCardsCount?: number | null;
      teachingBlockPlacedCardsCount?: number | null;
      subTitle?: string | null;
      comment?: string | null;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      curriculum?: {
        __typename?: 'Curriculum';
        uuid: string;
        personsConnection: {
          __typename?: 'CurriculumPersonsConnection';
          totalCount: number;
          edges: Array<{
            __typename?: 'CurriculumPersonsRelationship';
            properties: {
              __typename?: 'CurriculumPersonRelationshipProperties';
              description?: string | null;
              order: number;
              present?: boolean | null;
              teachingLoad?: boolean | null;
            };
            node: { __typename?: 'CurriculumPerson'; uuid: string };
          }>;
        };
      } | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string };
      subject:
        | {
            __typename: 'Subject';
            uuid: string;
            name: string;
            shortName: string;
            epochEnabled?: boolean | null;
            subjectHourEnabled?: boolean | null;
            active?: boolean | null;
            defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          }
        | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
      versions: Array<{
        __typename?: 'TimetableVersion';
        uuid: string;
        active?: boolean | null;
        editable?: boolean | null;
        version: number;
        timetable: { __typename?: 'Timetable'; uuid: string; name: string };
      }>;
      teachingBlockVersions: Array<{
        __typename?: 'TeachingBlockVersion';
        uuid: string;
        active?: boolean | null;
        version: number;
        teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
      }>;
      activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      lessonClassesConnection: {
        __typename?: 'LessonLessonClassesConnection';
        edges: Array<{
          __typename?: 'LessonLessonClassesRelationship';
          node: {
            __typename?: 'LessonClass';
            uuid: string;
            class: {
              __typename?: 'Class';
              uuid: string;
              name: string;
              shortName: string;
              grade?: number | null;
              defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
              gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
              divisions: Array<{
                __typename?: 'Division';
                uuid: string;
                groups: Array<{ __typename?: 'Group'; uuid: string }>;
              }>;
              timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
            };
            groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
            groups: Array<{
              __typename?: 'Group';
              uuid: string;
              shortName: string;
              name: string;
              classFraction: number;
            }>;
            usedDivision?: {
              __typename?: 'Division';
              uuid: string;
              name: string;
              groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
              groupsConnection: {
                __typename?: 'DivisionGroupsConnection';
                edges: Array<{
                  __typename?: 'DivisionGroupsRelationship';
                  properties: { __typename?: 'OrderedRelationProperties'; order: number };
                  node: { __typename?: 'Group'; uuid: string; name: string };
                }>;
              };
            } | null;
          };
        }>;
      };
      lessonUnitConnection: {
        __typename?: 'LessonLessonUnitConnection';
        edges: Array<{
          __typename?: 'LessonLessonUnitRelationship';
          node: {
            __typename?: 'LessonUnit';
            uuid: string;
            duration?: number | null;
            count?: number | null;
            subjectContainer?: {
              __typename?: 'SubjectContainer';
              uuid: string;
              name: string;
              shortName: string;
            } | null;
          };
        }>;
      };
      teachersConnection: {
        __typename?: 'LessonTeachersConnection';
        edges: Array<{
          __typename?: 'LessonTeachersRelationship';
          properties: {
            __typename?: 'LessonTeacherRelationshipProperties';
            description?: string | null;
            present?: boolean | null;
            teachingLoad?: boolean | null;
            teachingLoadHours?: number | null;
            writesCertificate?: boolean | null;
          };
          node: {
            __typename?: 'Person';
            uuid: string;
            shortName: string;
            fullName: string;
            firstName: string;
            lastName: string;
            displayNameShort?: string | null;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
        }>;
      };
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
          node: { __typename?: 'Room'; uuid: string; name: string };
        }>;
      };
    }>;
  }>;
};

export type TeachingBlockQueryVariables = Exact<{
  where?: InputMaybe<TeachingBlockWhere>;
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  schoolyearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TeachingBlockQuery = {
  __typename?: 'Query';
  teachingBlocks: Array<{
    __typename: 'TeachingBlock';
    uuid: string;
    name: string;
    createdAt?: any | null;
    updatedAt: any;
    draft: boolean;
    comment?: string | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
    subjectContainer: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string };
    versions: Array<{
      __typename: 'TeachingBlockVersion';
      uuid: string;
      version: number;
      classes: Array<{ __typename?: 'Class'; uuid: string }>;
      classesConnection: {
        __typename?: 'TeachingBlockVersionClassesConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionClassesRelationship';
          node: { __typename?: 'Class'; uuid: string };
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        }>;
      };
      lessons: Array<{ __typename?: 'Lesson'; uuid: string }>;
      teachers: Array<{ __typename?: 'Person'; uuid: string }>;
      teachersConnection: {
        __typename?: 'TeachingBlockVersionTeachersConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionTeachersRelationship';
          node: { __typename?: 'Person'; uuid: string };
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        }>;
      };
      rooms: Array<{ __typename?: 'Room'; uuid: string }>;
      roomsConnection: {
        __typename?: 'TeachingBlockVersionRoomsConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionRoomsRelationship';
          node: { __typename?: 'Room'; uuid: string };
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        }>;
      };
      subjectsConnection: {
        __typename?: 'TeachingBlockVersionSubjectsConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionSubjectsRelationship';
          node: { __typename?: 'Subject'; uuid: string };
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        }>;
      };
      subjects: Array<{ __typename?: 'Subject'; uuid: string }>;
      availabilityExclusions: Array<{ __typename?: 'TeachingBlockAvailabilityExclusion'; uuid: string }>;
    }>;
  }>;
  schoolYears: Array<{
    __typename?: 'SchoolYear';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
  }>;
  classes: Array<{ __typename?: 'Class'; grade?: number | null; uuid: string; name: string; shortName: string }>;
  rooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
  people: Array<{ __typename?: 'Person'; uuid: string; fullName: string; displayNameShort?: string | null }>;
  subjects: Array<{ __typename?: 'Subject'; uuid: string; name: string }>;
  lessons: Array<{
    __typename?: 'Lesson';
    uuid: string;
    roomSupplyAggregate?: { __typename?: 'LessonRoomRoomSupplyAggregationSelection'; count: number } | null;
    roomSupply: Array<{ __typename?: 'Room'; uuid: string }>;
    lessonUnit: Array<{
      __typename?: 'LessonUnit';
      count?: number | null;
      duration?: number | null;
      uuid: string;
      subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string } | null;
    }>;
  }>;
};

export type TimeGridEntryFragment = {
  __typename?: 'TimeGridEntry';
  uuid: string;
  name: string;
  shortName: string;
  start: any;
  end: any;
  order: number;
  reliable: boolean;
  pause: boolean;
  print: boolean;
};

export type TimeGridFragment = {
  __typename?: 'TimeGrid';
  uuid: string;
  name: string;
  description: string;
  itemsConnection: {
    __typename?: 'TimeGridItemsConnection';
    edges: Array<{
      __typename?: 'TimeGridItemsRelationship';
      node: {
        __typename?: 'TimeGridEntry';
        uuid: string;
        name: string;
        shortName: string;
        start: any;
        end: any;
        order: number;
        reliable: boolean;
        pause: boolean;
        print: boolean;
      };
    }>;
  };
  itemsWithoutPause: {
    __typename?: 'TimeGridItemsConnection';
    edges: Array<{
      __typename?: 'TimeGridItemsRelationship';
      node: {
        __typename?: 'TimeGridEntry';
        uuid: string;
        name: string;
        shortName: string;
        start: any;
        end: any;
        order: number;
        reliable: boolean;
        pause: boolean;
        print: boolean;
      };
    }>;
  };
};

export type DeleteTimeGridEntryMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteTimeGridEntryMutation = {
  __typename?: 'Mutation';
  deleteTimeGridEntries: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateTimeGridEntryMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update: TimeGridEntryUpdateInput;
}>;

export type UpdateTimeGridEntryMutation = {
  __typename?: 'Mutation';
  updateTimeGridEntries: {
    __typename?: 'UpdateTimeGridEntriesMutationResponse';
    timeGridEntries: Array<{
      __typename?: 'TimeGridEntry';
      uuid: string;
      name: string;
      shortName: string;
      start: any;
      end: any;
      order: number;
      reliable: boolean;
      pause: boolean;
      print: boolean;
    }>;
  };
};

export type UpdateTimeGridEntriesMutationVariables = Exact<{
  where?: InputMaybe<TimeGridEntryWhere>;
  update: TimeGridEntryUpdateInput;
}>;

export type UpdateTimeGridEntriesMutation = {
  __typename?: 'Mutation';
  updateTimeGridEntries: {
    __typename?: 'UpdateTimeGridEntriesMutationResponse';
    timeGridEntries: Array<{
      __typename?: 'TimeGridEntry';
      uuid: string;
      name: string;
      shortName: string;
      start: any;
      end: any;
      order: number;
      reliable: boolean;
      pause: boolean;
      print: boolean;
    }>;
  };
};

export type CreateTimeGridEntryMutationVariables = Exact<{
  input: Array<TimeGridEntryCreateInput> | TimeGridEntryCreateInput;
}>;

export type CreateTimeGridEntryMutation = {
  __typename?: 'Mutation';
  createTimeGridEntries: {
    __typename?: 'CreateTimeGridEntriesMutationResponse';
    timeGridEntries: Array<{
      __typename?: 'TimeGridEntry';
      uuid: string;
      name: string;
      shortName: string;
      start: any;
      end: any;
      order: number;
      reliable: boolean;
      pause: boolean;
      print: boolean;
    }>;
  };
};

export type DeleteTimeGridMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteTimeGridMutation = {
  __typename?: 'Mutation';
  deleteTimeGrids: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateTimeGridMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
  update: TimeGridUpdateInput;
}>;

export type UpdateTimeGridMutation = {
  __typename?: 'Mutation';
  updateTimeGrids: {
    __typename?: 'UpdateTimeGridsMutationResponse';
    timeGrids: Array<{
      __typename?: 'TimeGrid';
      uuid: string;
      name: string;
      description: string;
      itemsConnection: {
        __typename?: 'TimeGridItemsConnection';
        edges: Array<{
          __typename?: 'TimeGridItemsRelationship';
          node: {
            __typename?: 'TimeGridEntry';
            uuid: string;
            name: string;
            shortName: string;
            start: any;
            end: any;
            order: number;
            reliable: boolean;
            pause: boolean;
            print: boolean;
          };
        }>;
      };
      itemsWithoutPause: {
        __typename?: 'TimeGridItemsConnection';
        edges: Array<{
          __typename?: 'TimeGridItemsRelationship';
          node: {
            __typename?: 'TimeGridEntry';
            uuid: string;
            name: string;
            shortName: string;
            start: any;
            end: any;
            order: number;
            reliable: boolean;
            pause: boolean;
            print: boolean;
          };
        }>;
      };
    }>;
  };
};

export type CreateTimeGridMutationVariables = Exact<{
  input: Array<TimeGridCreateInput> | TimeGridCreateInput;
}>;

export type CreateTimeGridMutation = {
  __typename?: 'Mutation';
  createTimeGrids: {
    __typename?: 'CreateTimeGridsMutationResponse';
    timeGrids: Array<{
      __typename?: 'TimeGrid';
      uuid: string;
      name: string;
      description: string;
      itemsConnection: {
        __typename?: 'TimeGridItemsConnection';
        edges: Array<{
          __typename?: 'TimeGridItemsRelationship';
          node: {
            __typename?: 'TimeGridEntry';
            uuid: string;
            name: string;
            shortName: string;
            start: any;
            end: any;
            order: number;
            reliable: boolean;
            pause: boolean;
            print: boolean;
          };
        }>;
      };
      itemsWithoutPause: {
        __typename?: 'TimeGridItemsConnection';
        edges: Array<{
          __typename?: 'TimeGridItemsRelationship';
          node: {
            __typename?: 'TimeGridEntry';
            uuid: string;
            name: string;
            shortName: string;
            start: any;
            end: any;
            order: number;
            reliable: boolean;
            pause: boolean;
            print: boolean;
          };
        }>;
      };
    }>;
  };
};

export type TimeGridEntriesByTimeGridQueryVariables = Exact<{
  timeGridUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TimeGridEntriesByTimeGridQuery = {
  __typename?: 'Query';
  timeGridEntries: Array<{
    __typename?: 'TimeGridEntry';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
    order: number;
    reliable: boolean;
    pause: boolean;
    print: boolean;
  }>;
};

export type TimeGridEntryQueryVariables = Exact<{
  timeGridEntriesUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type TimeGridEntryQuery = {
  __typename?: 'Query';
  timeGridEntries: Array<{
    __typename?: 'TimeGridEntry';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
    order: number;
    reliable: boolean;
    pause: boolean;
    print: boolean;
  }>;
};

export type TimeGridQueryVariables = Exact<{
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  timeGridUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TimeGridQuery = {
  __typename?: 'Query';
  timeGrids: Array<{
    __typename?: 'TimeGrid';
    uuid: string;
    name: string;
    description: string;
    itemsConnection: {
      __typename?: 'TimeGridItemsConnection';
      edges: Array<{
        __typename?: 'TimeGridItemsRelationship';
        node: {
          __typename?: 'TimeGridEntry';
          uuid: string;
          name: string;
          shortName: string;
          start: any;
          end: any;
          order: number;
          reliable: boolean;
          pause: boolean;
          print: boolean;
        };
      }>;
    };
    itemsWithoutPause: {
      __typename?: 'TimeGridItemsConnection';
      edges: Array<{
        __typename?: 'TimeGridItemsRelationship';
        node: {
          __typename?: 'TimeGridEntry';
          uuid: string;
          name: string;
          shortName: string;
          start: any;
          end: any;
          order: number;
          reliable: boolean;
          pause: boolean;
          print: boolean;
        };
      }>;
    };
  }>;
};

export type CreateTimetableMutationVariables = Exact<{
  input: Array<TimetableCreateInput> | TimetableCreateInput;
}>;

export type CreateTimetableMutation = {
  __typename?: 'Mutation';
  createTimetables: {
    __typename?: 'CreateTimetablesMutationResponse';
    timetables: Array<{ __typename?: 'Timetable'; uuid: string }>;
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type DeleteTimetableMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteTimetableMutation = {
  __typename?: 'Mutation';
  deleteTimetables: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateTimetableMutationVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  update?: InputMaybe<TimetableUpdateInput>;
}>;

export type UpdateTimetableMutation = {
  __typename?: 'Mutation';
  updateTimetables: {
    __typename?: 'UpdateTimetablesMutationResponse';
    timetables: Array<{
      __typename?: 'Timetable';
      uuid: string;
      draft: boolean;
      name: string;
      comment?: string | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string };
      versions: Array<{ __typename?: 'TimetableVersion'; uuid: string }>;
    }>;
  };
};

export type TimetableQueryVariables = Exact<{
  where?: InputMaybe<TimetableWhere>;
  organizationUuid?: InputMaybe<Scalars['ID']['input']>;
  schoolyearUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TimetableQuery = {
  __typename?: 'Query';
  timetables: Array<{
    __typename?: 'Timetable';
    uuid: string;
    draft: boolean;
    name: string;
    comment?: string | null;
    createdAt?: any | null;
    updatedAt: any;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string; name: string; start: any; end: any };
    timegridConfigs: Array<{
      __typename?: 'TimetableTimeGridConfig';
      timegrid?: { __typename?: 'TimeGrid'; uuid: string; name: string } | null;
      classes: Array<{ __typename?: 'Class'; uuid: string; name: string; shortName: string; grade?: number | null }>;
    }>;
    versions: Array<{
      __typename?: 'TimetableVersion';
      uuid: string;
      version: number;
      description?: string | null;
      classes: Array<{ __typename?: 'Class'; uuid: string }>;
      lessons: Array<{ __typename?: 'Lesson'; uuid: string }>;
      teachers: Array<{ __typename?: 'Person'; uuid: string }>;
      rooms: Array<{ __typename?: 'Room'; uuid: string }>;
      subjects: Array<{ __typename?: 'Subject'; uuid: string }>;
    }>;
  }>;
  schoolYears: Array<{
    __typename?: 'SchoolYear';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
  }>;
  timeGrids: Array<{ __typename?: 'TimeGrid'; uuid: string; name: string }>;
  classes: Array<{ __typename?: 'Class'; grade?: number | null; uuid: string; name: string; shortName: string }>;
  rooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
  people: Array<{ __typename?: 'Person'; uuid: string; fullName: string; displayNameShort?: string | null }>;
  subjects: Array<{ __typename?: 'Subject'; uuid: string; name: string }>;
  lessons: Array<{
    __typename?: 'Lesson';
    uuid: string;
    roomSupplyAggregate?: { __typename?: 'LessonRoomRoomSupplyAggregationSelection'; count: number } | null;
    roomSupply: Array<{ __typename?: 'Room'; uuid: string }>;
    lessonUnit: Array<{
      __typename?: 'LessonUnit';
      count?: number | null;
      duration?: number | null;
      uuid: string;
      subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string } | null;
    }>;
  }>;
};

export type TimetableDraftQueryVariables = Exact<{
  draftUuid: Scalars['ID']['input'];
}>;

export type TimetableDraftQuery = {
  __typename?: 'Query';
  timetables: Array<{
    __typename?: 'Timetable';
    uuid: string;
    name: string;
    timegridConfigsConnection: {
      __typename?: 'TimetableTimegridConfigsConnection';
      edges: Array<{
        __typename?: 'TimetableTimegridConfigsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: {
          __typename?: 'TimetableTimeGridConfig';
          timegrid?: { __typename?: 'TimeGrid'; uuid: string } | null;
          classes: Array<{ __typename?: 'Class'; uuid: string }>;
        };
      }>;
    };
    versions: Array<{
      __typename?: 'TimetableVersion';
      uuid: string;
      active?: boolean | null;
      editable?: boolean | null;
      version: number;
      updatedAt?: any | null;
      createdAt?: any | null;
      description?: string | null;
      isSnapshot?: boolean | null;
      placedCardsCount?: number | null;
      cardsAggregate?: { __typename?: 'TimetableVersionTimetableCardCardsAggregationSelection'; count: number } | null;
      original?: { __typename?: 'TimetableVersion'; uuid: string } | null;
      parent?: { __typename?: 'TimetableVersion'; uuid: string } | null;
    }>;
  }>;
};

export type CreateTimetableBlocksMutationVariables = Exact<{
  input: Array<TimetableBlockCreateInput> | TimetableBlockCreateInput;
}>;

export type CreateTimetableBlocksMutation = {
  __typename?: 'Mutation';
  createTimetableBlocks: {
    __typename?: 'CreateTimetableBlocksMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number; relationshipsCreated: number };
  };
};

export type UpdateTimetableBlocksMutationVariables = Exact<{
  update: TimetableBlockUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type UpdateTimetableBlocksMutation = {
  __typename?: 'Mutation';
  updateTimetableBlocks: {
    __typename?: 'UpdateTimetableBlocksMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; relationshipsCreated: number; nodesDeleted: number };
  };
};

export type DeleteTimetableBlocksMutationVariables = Exact<{
  where?: InputMaybe<TimetableBlockWhere>;
}>;

export type DeleteTimetableBlocksMutation = {
  __typename?: 'Mutation';
  deleteTimetableBlocks: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type TimetableBlocksQueryVariables = Exact<{
  where?: InputMaybe<TimetableBlockWhere>;
  options?: InputMaybe<TimetableBlockOptions>;
}>;

export type TimetableBlocksQuery = {
  __typename?: 'Query';
  timetableBlocks: Array<{
    __typename?: 'TimetableBlock';
    uuid: string;
    name: string;
    end: any;
    start: any;
    teachingLoadFactor?: number | null;
    teachingLoadComment?: string | null;
    teachingLoadCalculated?: number | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string; start: any; end: any };
    timetables: Array<{
      __typename?: 'Timetable';
      uuid: string;
      name: string;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string; start: any; end: any };
      versions: Array<{
        __typename?: 'TimetableVersion';
        uuid: string;
        active?: boolean | null;
        classes: Array<{ __typename?: 'Class'; uuid: string }>;
      }>;
    }>;
  }>;
};

export type CreateTimetableVersionsMutationVariables = Exact<{
  version: Scalars['Int']['input'];
  rooms?: InputMaybe<TimetableVersionRoomsFieldInput>;
  teachers?: InputMaybe<TimetableVersionTeachersFieldInput>;
  classes?: InputMaybe<TimetableVersionClassesFieldInput>;
  subjects?: InputMaybe<TimetableVersionSubjectsFieldInput>;
  timetable?: InputMaybe<TimetableVersionTimetableFieldInput>;
  cards?: InputMaybe<TimetableVersionCardsFieldInput>;
}>;

export type CreateTimetableVersionsMutation = {
  __typename?: 'Mutation';
  createTimetableVersions: {
    __typename?: 'CreateTimetableVersionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type UpdateTimetableVersionMutationVariables = Exact<{
  versionUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  update?: InputMaybe<TimetableVersionUpdateInput>;
}>;

export type UpdateTimetableVersionMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename: 'UpdateInfo' };
  };
};

export type SetTimetableVersionsInactiveMutationVariables = Exact<{
  timetableUuid: Scalars['ID']['input'];
}>;

export type SetTimetableVersionsInactiveMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename: 'UpdateInfo' };
  };
};

export type DeleteTimetableVersionsMutationVariables = Exact<{
  versionUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type DeleteTimetableVersionsMutation = {
  __typename?: 'Mutation';
  deleteTimetableVersions: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type UpdateTimetableVersionSubjectAvailabilityMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  subjectUuid: Scalars['ID']['input'];
  data?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
}>;

export type UpdateTimetableVersionSubjectAvailabilityMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number };
  };
};

export type UpdateTimetableVersionRoomAvailabilityMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  roomUuid: Scalars['ID']['input'];
  data?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
}>;

export type UpdateTimetableVersionRoomAvailabilityMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number };
  };
};

export type UpdateTimetableVersionClassAvailabilityMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  classUuid: Scalars['ID']['input'];
  data?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
}>;

export type UpdateTimetableVersionClassAvailabilityMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number };
  };
};

export type UpdateTimetableVersionClassConditionsMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  classUuid: Scalars['ID']['input'];
  data: Scalars['String']['input'];
}>;

export type UpdateTimetableVersionClassConditionsMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename: 'UpdateInfo' };
  };
};

export type UpdateTimetableVersionTeachersAvailabilityMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
  data?: InputMaybe<TimetableRelationshipPropertiesUpdateInput>;
}>;

export type UpdateTimetableVersionTeachersAvailabilityMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number };
  };
};

export type UpdateCardMutationVariables = Exact<{
  cardUuid: Scalars['ID']['input'];
  card?: InputMaybe<TimetableCardUpdateInput>;
}>;

export type UpdateCardMutation = {
  __typename?: 'Mutation';
  updateTimetableCards: { __typename?: 'UpdateTimetableCardsMutationResponse'; info: { __typename: 'UpdateInfo' } };
};

export type UpdateCardsMutationVariables = Exact<{
  where?: InputMaybe<TimetableCardWhere>;
  update?: InputMaybe<TimetableCardUpdateInput>;
}>;

export type UpdateCardsMutation = {
  __typename?: 'Mutation';
  updateTimetableCards: { __typename?: 'UpdateTimetableCardsMutationResponse'; info: { __typename: 'UpdateInfo' } };
};

export type DeleteCardsByUuidMutationVariables = Exact<{
  cardUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type DeleteCardsByUuidMutation = {
  __typename?: 'Mutation';
  deleteTimetableCards: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type DeleteCardsMutationVariables = Exact<{
  where?: InputMaybe<TimetableCardWhere>;
  delete?: InputMaybe<TimetableCardDeleteInput>;
}>;

export type DeleteCardsMutation = {
  __typename?: 'Mutation';
  deleteTimetableCards: { __typename?: 'DeleteInfo'; nodesDeleted: number };
};

export type CreateCardMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  lessonUuid: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
}>;

export type CreateCardMutation = {
  __typename?: 'Mutation';
  createTimetableCards: {
    __typename?: 'CreateTimetableCardsMutationResponse';
    timetableCards: Array<{ __typename?: 'TimetableCard'; uuid: string }>;
  };
};

export type CreateSubjectContainerCardMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  lessonUuid: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
  subjectContainerUuid: Scalars['ID']['input'];
}>;

export type CreateSubjectContainerCardMutation = {
  __typename?: 'Mutation';
  createTimetableCards: {
    __typename?: 'CreateTimetableCardsMutationResponse';
    timetableCards: Array<{ __typename?: 'TimetableCard'; uuid: string }>;
  };
};

export type CreateTimetableVersionMutationVariables = Exact<{
  timetableUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
}>;

export type CreateTimetableVersionMutation = {
  __typename?: 'Mutation';
  createTimetableVersion: {
    __typename?: 'CreateTimetableVersionsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number };
  };
};

export type DuplicateTimetableVersionMutationVariables = Exact<{
  timetableVersionUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  options: DuplicateTimetableVersionOptions;
}>;

export type DuplicateTimetableVersionMutation = {
  __typename?: 'Mutation';
  duplicateTimetableVersion: {
    __typename?: 'DuplicateTimetableVersionResponse';
    active?: boolean | null;
    description?: string | null;
    uuid: string;
    version: number;
  };
};

export type UpdateTimetableVersionClassesMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  classes?: InputMaybe<Array<TimetableVersionClassesUpdateFieldInput> | TimetableVersionClassesUpdateFieldInput>;
}>;

export type UpdateTimetableVersionClassesMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number };
  };
};

export type UpdateTimetableVersionSubjectsMutationVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  subjects?: InputMaybe<Array<TimetableVersionSubjectsUpdateFieldInput> | TimetableVersionSubjectsUpdateFieldInput>;
}>;

export type UpdateTimetableVersionSubjectsMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number };
  };
};

export type TimetableCardsQueryVariables = Exact<{
  where?: InputMaybe<TimetableCardWhere>;
  options?: InputMaybe<TimetableCardOptions>;
}>;

export type TimetableCardsQuery = {
  __typename?: 'Query';
  timetableCards: Array<{
    __typename?: 'TimetableCard';
    uuid: string;
    weekday?: string | null;
    duration?: number | null;
    locked: boolean;
    timetableVersion: {
      __typename?: 'TimetableVersion';
      version: number;
      uuid: string;
      timetable: { __typename?: 'Timetable'; name: string };
    };
    rooms: Array<{ __typename?: 'Room'; name: string; uuid: string }>;
    teachers: Array<{
      __typename?: 'Person';
      uuid: string;
      pimProfileUuid?: string | null;
      displayNameShort?: string | null;
      defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
      timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
    }>;
    lesson: {
      __typename?: 'Lesson';
      uuid: string;
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          node: {
            __typename?: 'Room';
            uuid: string;
            name: string;
            building?: { __typename?: 'Building'; name: string } | null;
          };
        }>;
      };
    };
    subject:
      | {
          __typename?: 'Subject';
          uuid: string;
          name: string;
          shortName: string;
          defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        }
      | {
          __typename?: 'SubjectContainer';
          uuid: string;
          name: string;
          shortName: string;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
    lessonClasses: Array<{
      __typename?: 'LessonClass';
      uuid: string;
      class: {
        __typename?: 'Class';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
        divisions: Array<{
          __typename?: 'Division';
          uuid: string;
          groups: Array<{ __typename?: 'Group'; uuid: string }>;
        }>;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      };
      groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
      groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
      usedDivision?: {
        __typename?: 'Division';
        uuid: string;
        name: string;
        groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
        groupsConnection: {
          __typename?: 'DivisionGroupsConnection';
          edges: Array<{
            __typename?: 'DivisionGroupsRelationship';
            properties: { __typename?: 'OrderedRelationProperties'; order: number };
            node: { __typename?: 'Group'; uuid: string; name: string };
          }>;
        };
      } | null;
    }>;
    subjectContainer?: {
      __typename?: 'SubjectContainer';
      uuid: string;
      name: string;
      shortName: string;
      order?: number | null;
      lessons: Array<{ __typename?: 'Lesson'; uuid: string }>;
    } | null;
    startTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
    endTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
  }>;
};

export type TimetableCardAggregateQueryVariables = Exact<{
  where?: InputMaybe<TimetableCardWhere>;
}>;

export type TimetableCardAggregateQuery = {
  __typename?: 'Query';
  timetableCardsAggregate: { __typename?: 'TimetableCardAggregateSelection'; count: number };
};

export type TimetableVersionsQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type TimetableVersionsQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    uuid: string;
    version: number;
    description?: string | null;
    active?: boolean | null;
    cards: Array<{
      __typename?: 'TimetableCard';
      uuid: string;
      weekday?: string | null;
      duration?: number | null;
      locked: boolean;
      timetableVersion: {
        __typename?: 'TimetableVersion';
        version: number;
        uuid: string;
        timetable: { __typename?: 'Timetable'; name: string };
      };
      rooms: Array<{ __typename?: 'Room'; name: string; uuid: string }>;
      teachers: Array<{
        __typename?: 'Person';
        uuid: string;
        pimProfileUuid?: string | null;
        displayNameShort?: string | null;
        defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      }>;
      lesson: {
        __typename?: 'Lesson';
        uuid: string;
        roomSupplyConnection: {
          __typename?: 'LessonRoomSupplyConnection';
          edges: Array<{
            __typename?: 'LessonRoomSupplyRelationship';
            node: {
              __typename?: 'Room';
              uuid: string;
              name: string;
              building?: { __typename?: 'Building'; name: string } | null;
            };
          }>;
        };
      };
      subject:
        | {
            __typename?: 'Subject';
            uuid: string;
            name: string;
            shortName: string;
            defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          }
        | {
            __typename?: 'SubjectContainer';
            uuid: string;
            name: string;
            shortName: string;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
      lessonClasses: Array<{
        __typename?: 'LessonClass';
        uuid: string;
        class: {
          __typename?: 'Class';
          uuid: string;
          name: string;
          shortName: string;
          grade?: number | null;
          defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
          gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
          divisions: Array<{
            __typename?: 'Division';
            uuid: string;
            groups: Array<{ __typename?: 'Group'; uuid: string }>;
          }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
        groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
        groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
        usedDivision?: {
          __typename?: 'Division';
          uuid: string;
          name: string;
          groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
          groupsConnection: {
            __typename?: 'DivisionGroupsConnection';
            edges: Array<{
              __typename?: 'DivisionGroupsRelationship';
              properties: { __typename?: 'OrderedRelationProperties'; order: number };
              node: { __typename?: 'Group'; uuid: string; name: string };
            }>;
          };
        } | null;
      }>;
      subjectContainer?: {
        __typename?: 'SubjectContainer';
        uuid: string;
        name: string;
        shortName: string;
        order?: number | null;
        lessons: Array<{ __typename?: 'Lesson'; uuid: string }>;
      } | null;
      startTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
      endTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
    }>;
    timetable: {
      __typename?: 'Timetable';
      uuid: string;
      name: string;
      monEnabled?: boolean | null;
      tueEnabled?: boolean | null;
      wedEnabled?: boolean | null;
      thuEnabled?: boolean | null;
      friEnabled?: boolean | null;
      satEnabled?: boolean | null;
      sunEnabled?: boolean | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string };
      timegridConfigs: Array<{
        __typename?: 'TimetableTimeGridConfig';
        timegrid?: {
          __typename?: 'TimeGrid';
          uuid: string;
          name: string;
          description: string;
          itemsConnection: {
            __typename?: 'TimeGridItemsConnection';
            edges: Array<{
              __typename?: 'TimeGridItemsRelationship';
              node: {
                __typename?: 'TimeGridEntry';
                uuid: string;
                name: string;
                shortName: string;
                start: any;
                end: any;
                order: number;
                reliable: boolean;
                pause: boolean;
                print: boolean;
              };
            }>;
          };
          itemsWithoutPause: {
            __typename?: 'TimeGridItemsConnection';
            edges: Array<{
              __typename?: 'TimeGridItemsRelationship';
              node: {
                __typename?: 'TimeGridEntry';
                uuid: string;
                name: string;
                shortName: string;
                start: any;
                end: any;
                order: number;
                reliable: boolean;
                pause: boolean;
                print: boolean;
              };
            }>;
          };
        } | null;
      }>;
    };
    classesConnection: {
      __typename?: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        node: {
          __typename?: 'Class';
          uuid: string;
          name: string;
          shortName: string;
          grade?: number | null;
          certificatesEnabled?: boolean | null;
          gradeGroup?: {
            __typename?: 'GradeGroup';
            uuid: string;
            name: string;
            shortName: string;
            description?: string | null;
            class: Array<{ __typename?: 'Class'; uuid: string }>;
          } | null;
          timetableConfig?: {
            __typename?: 'TimetableConfig';
            color?: string | null;
            colorLabel?: string | null;
            printOrder?: number | null;
            printPageNr?: number | null;
          } | null;
          tutorsConnection: {
            __typename?: 'ClassTutorsConnection';
            edges: Array<{
              __typename?: 'ClassTutorsRelationship';
              properties: { __typename?: 'OrderedRelationProperties'; order: number };
              node: {
                __typename?: 'Person';
                uuid: string;
                personalId?: string | null;
                email?: string | null;
                birthday?: any | null;
                firstName: string;
                lastName: string;
                fullName: string;
                shortName: string;
                displayNameShort?: string | null;
              };
            }>;
          };
        };
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
      }>;
    };
    subjectsConnection: {
      __typename?: 'TimetableVersionSubjectsConnection';
      edges: Array<{
        __typename?: 'TimetableVersionSubjectsRelationship';
        node: {
          __typename?: 'Subject';
          name: string;
          uuid: string;
          shortName: string;
          subjectHourEnabled?: boolean | null;
          epochEnabled?: boolean | null;
          active?: boolean | null;
          other?: boolean | null;
          subjectGroup?: { __typename?: 'SubjectGroup'; name: string } | null;
          timetableConfig?: {
            __typename?: 'TimetableConfig';
            color?: string | null;
            colorLabel?: string | null;
          } | null;
        };
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'TimetableVersionTeachersConnection';
      edges: Array<{
        __typename?: 'TimetableVersionTeachersRelationship';
        node: {
          __typename?: 'Person';
          uuid: string;
          personalId?: string | null;
          firstName: string;
          lastName: string;
          fullName: string;
          shortName: string;
          callingName?: string | null;
          prefixName?: string | null;
          uniqueFirstName?: string | null;
          salutation?: string | null;
          title?: string | null;
          email?: string | null;
          birthday?: any | null;
          gender?: string | null;
          active?: boolean | null;
          displayName: string;
          displayNameShort?: string | null;
          timetableConfig?: {
            __typename?: 'TimetableConfig';
            color?: string | null;
            colorLabel?: string | null;
          } | null;
        };
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
      }>;
    };
    roomsConnection: {
      __typename?: 'TimetableVersionRoomsConnection';
      edges: Array<{
        __typename?: 'TimetableVersionRoomsRelationship';
        node: {
          __typename?: 'Room';
          uuid: string;
          name: string;
          position?: string | null;
          roomNumber?: string | null;
          description?: string | null;
          classroom?: boolean | null;
          canBeLeased?: boolean | null;
          capacity?: number | null;
          chairs?: number | null;
          tables?: number | null;
          size?: number | null;
          otherInventory?: string | null;
          barrierFree?: boolean | null;
          canBeDarkened?: boolean | null;
          hasProjector?: boolean | null;
          hasScreen?: boolean | null;
          hasMediaCabinet?: boolean | null;
          hasPiano?: boolean | null;
          building?: { __typename?: 'Building'; uuid: string; name: string } | null;
        };
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
      }>;
    };
    lessons: Array<{
      __typename?: 'Lesson';
      uuid: string;
      groupClassNames: string;
      gradeGroupUuid?: Array<string> | null;
      onlyInTimetableVersion: boolean;
      classSort: string;
      teachersSort: string;
      placedCardsCount?: number | null;
      teachingBlockPlacedCardsCount?: number | null;
      subTitle?: string | null;
      comment?: string | null;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      curriculum?: {
        __typename?: 'Curriculum';
        uuid: string;
        personsConnection: {
          __typename?: 'CurriculumPersonsConnection';
          totalCount: number;
          edges: Array<{
            __typename?: 'CurriculumPersonsRelationship';
            properties: {
              __typename?: 'CurriculumPersonRelationshipProperties';
              description?: string | null;
              order: number;
              present?: boolean | null;
              teachingLoad?: boolean | null;
            };
            node: { __typename?: 'CurriculumPerson'; uuid: string };
          }>;
        };
      } | null;
      schoolYear: { __typename?: 'SchoolYear'; uuid: string };
      subject:
        | {
            __typename: 'Subject';
            uuid: string;
            name: string;
            shortName: string;
            epochEnabled?: boolean | null;
            subjectHourEnabled?: boolean | null;
            active?: boolean | null;
            defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          }
        | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
      versions: Array<{
        __typename?: 'TimetableVersion';
        uuid: string;
        active?: boolean | null;
        editable?: boolean | null;
        version: number;
        timetable: { __typename?: 'Timetable'; uuid: string; name: string };
      }>;
      teachingBlockVersions: Array<{
        __typename?: 'TeachingBlockVersion';
        uuid: string;
        active?: boolean | null;
        version: number;
        teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
      }>;
      activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
      lessonClassesConnection: {
        __typename?: 'LessonLessonClassesConnection';
        edges: Array<{
          __typename?: 'LessonLessonClassesRelationship';
          node: {
            __typename?: 'LessonClass';
            uuid: string;
            class: {
              __typename?: 'Class';
              uuid: string;
              name: string;
              shortName: string;
              grade?: number | null;
              defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
              gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
              divisions: Array<{
                __typename?: 'Division';
                uuid: string;
                groups: Array<{ __typename?: 'Group'; uuid: string }>;
              }>;
              timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
            };
            groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
            groups: Array<{
              __typename?: 'Group';
              uuid: string;
              shortName: string;
              name: string;
              classFraction: number;
            }>;
            usedDivision?: {
              __typename?: 'Division';
              uuid: string;
              name: string;
              groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
              groupsConnection: {
                __typename?: 'DivisionGroupsConnection';
                edges: Array<{
                  __typename?: 'DivisionGroupsRelationship';
                  properties: { __typename?: 'OrderedRelationProperties'; order: number };
                  node: { __typename?: 'Group'; uuid: string; name: string };
                }>;
              };
            } | null;
          };
        }>;
      };
      lessonUnitConnection: {
        __typename?: 'LessonLessonUnitConnection';
        edges: Array<{
          __typename?: 'LessonLessonUnitRelationship';
          node: {
            __typename?: 'LessonUnit';
            uuid: string;
            duration?: number | null;
            count?: number | null;
            subjectContainer?: {
              __typename?: 'SubjectContainer';
              uuid: string;
              name: string;
              shortName: string;
            } | null;
          };
        }>;
      };
      teachersConnection: {
        __typename?: 'LessonTeachersConnection';
        edges: Array<{
          __typename?: 'LessonTeachersRelationship';
          properties: {
            __typename?: 'LessonTeacherRelationshipProperties';
            description?: string | null;
            present?: boolean | null;
            teachingLoad?: boolean | null;
            teachingLoadHours?: number | null;
            writesCertificate?: boolean | null;
          };
          node: {
            __typename?: 'Person';
            uuid: string;
            shortName: string;
            fullName: string;
            firstName: string;
            lastName: string;
            displayNameShort?: string | null;
            timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
          };
        }>;
      };
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
          node: { __typename?: 'Room'; uuid: string; name: string };
        }>;
      };
    }>;
  }>;
};

export type ClassAvailabilityMatrixQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ClassAvailabilityMatrixQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    classesConnection: {
      __typename?: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename?: 'Class'; uuid: string };
      }>;
    };
  }>;
};

export type ClassConstraintsQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type ClassConstraintsQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    classesConnection: {
      __typename?: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        properties: { __typename?: 'TimetableRelationshipProperties'; constraints?: string | null };
      }>;
    };
  }>;
};

export type SubjectAvailabilityMatrixQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SubjectAvailabilityMatrixQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    subjectsConnection: {
      __typename?: 'TimetableVersionSubjectsConnection';
      edges: Array<{
        __typename?: 'TimetableVersionSubjectsRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename?: 'Subject'; uuid: string };
      }>;
    };
  }>;
};

export type SubjectConstraintsQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type SubjectConstraintsQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    classesConnection: {
      __typename?: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        properties: { __typename?: 'TimetableRelationshipProperties'; constraints?: string | null };
      }>;
    };
  }>;
};

export type TeacherAvailabilityMatrixQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type TeacherAvailabilityMatrixQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    teachersConnection: {
      __typename?: 'TimetableVersionTeachersConnection';
      edges: Array<{
        __typename?: 'TimetableVersionTeachersRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename?: 'Person'; uuid: string };
      }>;
    };
  }>;
};

export type TeacherConstraintsQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type TeacherConstraintsQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    classesConnection: {
      __typename?: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        properties: { __typename?: 'TimetableRelationshipProperties'; constraints?: string | null };
      }>;
    };
  }>;
};

export type RoomAvailabilityMatrixQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type RoomAvailabilityMatrixQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    roomsConnection: {
      __typename?: 'TimetableVersionRoomsConnection';
      edges: Array<{
        __typename?: 'TimetableVersionRoomsRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename?: 'Room'; uuid: string };
      }>;
    };
  }>;
};

export type RoomConstraintsQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuid: Scalars['ID']['input'];
}>;

export type RoomConstraintsQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    classesConnection: {
      __typename?: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        properties: { __typename?: 'TimetableRelationshipProperties'; constraints?: string | null };
      }>;
    };
  }>;
};

export type ClassConstraintsForClassesQueryVariables = Exact<{
  versionUuid: Scalars['ID']['input'];
  uuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type ClassConstraintsForClassesQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    classesConnection: {
      __typename?: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        node: { __typename?: 'Class'; uuid: string };
        properties: { __typename?: 'TimetableRelationshipProperties'; constraints?: string | null };
      }>;
    };
  }>;
};

export type TimetableVersionClassesQueryVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type TimetableVersionClassesQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename: 'TimetableVersion';
    uuid: string;
    version: number;
    description?: string | null;
    active?: boolean | null;
    classes: Array<{
      __typename: 'Class';
      uuid: string;
      name: string;
      shortName: string;
      grade?: number | null;
      timetableConfig?: { __typename: 'TimetableConfig'; color?: string | null } | null;
      gradeGroup?: {
        __typename?: 'GradeGroup';
        uuid: string;
        name: string;
        shortName: string;
        description?: string | null;
        class: Array<{ __typename?: 'Class'; uuid: string }>;
      } | null;
    }>;
  }>;
};

export type AddUserMutationVariables = Exact<{
  frontendUri: Scalars['String']['input'];
  planungPersonUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  profileUuid?: InputMaybe<Scalars['ID']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type AddUserMutation = {
  __typename?: 'Mutation';
  addUser: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type UpdateGrantedProfilesMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  profiles: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
  frontendUri: Scalars['String']['input'];
}>;

export type UpdateGrantedProfilesMutation = {
  __typename?: 'Mutation';
  updateGrantedProfiles: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type UpdateUserPermissionsMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type UpdateUserPermissionsMutation = {
  __typename?: 'Mutation';
  updateUserPermissions: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type InviteUserMutationVariables = Exact<{
  frontendUri: Scalars['String']['input'];
  organizationUuid: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  profileUuid: Scalars['ID']['input'];
}>;

export type InviteUserMutation = {
  __typename?: 'Mutation';
  inviteUser: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type RemovePlanungAccessMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  profileUuid: Scalars['ID']['input'];
}>;

export type RemovePlanungAccessMutation = {
  __typename?: 'Mutation';
  removePlanungAccess: {
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  };
};

export type PimProfilesQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
}>;

export type PimProfilesQuery = {
  __typename?: 'Query';
  pimProfiles: Array<{
    __typename?: 'PimProfile';
    uuid: string;
    lastName: string;
    firstName: string;
    userStatus?: UserStatus | null;
    userEmail?: string | null;
    profileEmail?: string | null;
    role: string;
    permissions: Array<string>;
    accessGranted?: boolean | null;
    selectName?: string | null;
  }>;
};

export type _TimetablePrintConfigFragment = {
  __typename: 'TimetablePrintConfig';
  uuid: string;
  type: TimetableReportType;
  topLeft?: TimetablePrintLayoutOptions | null;
  topCenter?: TimetablePrintLayoutOptions | null;
  topRight?: TimetablePrintLayoutOptions | null;
  center?: TimetablePrintLayoutOptions | null;
  bottomLeft?: TimetablePrintLayoutOptions | null;
  bottomCenter?: TimetablePrintLayoutOptions | null;
  bottomRight?: TimetablePrintLayoutOptions | null;
  printColorOrigin?: TimetablePrintColorOrigins | null;
  printColorPosition?: TimetablePrintColorPositions | null;
  printClasses?: boolean | null;
  scaleText?: boolean | null;
  exactMinute?: boolean | null;
  printSubtitle?: boolean | null;
  printLogo?: boolean | null;
  largeFont?: boolean | null;
  showSchoolWeeks?: boolean | null;
  showCalendarWeeks?: boolean | null;
  showWeekSchoolDays?: boolean | null;
  timeHorizontal?: boolean | null;
};

export type _SchoolEventFragment = {
  __typename: 'SchoolEvent';
  uuid: string;
  start: any;
  end: any;
  canceled: boolean;
  comment?: string | null;
  isClassTrip: boolean;
  recurrenceUuid?: string | null;
  groupClassNames: string;
  groupClassNamesLong: string;
  persons: Array<{ __typename: 'MinimalPerson'; uuid: string; displayName: string; listName: string }>;
  rooms: Array<{ __typename: 'MinimalRoom'; uuid: string; name: string }>;
  subject: { __typename: 'MinimalSubject'; uuid: string; name: string; shortName: string };
  classesOrGroups: Array<{ __typename: 'MinimalClass'; uuid: string } | { __typename: 'MinimalGroup'; uuid: string }>;
};

export type _EventFragment = {
  __typename: 'Event';
  uuid: string;
  start: any;
  end: any;
  comment?: string | null;
  canceled: boolean;
  currentState?: string | null;
  isClassTrip?: boolean | null;
  isClassbookRelevant: boolean;
  substitutionReasons?: SubstitutionReason | null;
  substitutionComment?: string | null;
  print: boolean;
  isSchoolEvent: boolean;
  sourceTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string; name: string; shortName: string } | null;
  isAggregated?: { __typename: 'Event'; uuid: string } | null;
  personsConnection: {
    __typename: 'EventPersonsConnection';
    edges: Array<{
      __typename?: 'EventPersonsRelationship';
      properties: {
        __typename?: 'EventPersonRelationProperties';
        givenSubstituteHours?: number | null;
        isCoveringTeacher: boolean;
      };
      node: { __typename: 'Person'; uuid: string };
    }>;
  };
  originalPersons: Array<{ __typename: 'Person'; uuid: string }>;
  subject: { __typename: 'Subject'; uuid: string };
  rooms: Array<{ __typename: 'Room'; uuid: string }>;
  originalClassesOrGroups: Array<{ __typename: 'Class'; uuid: string } | { __typename: 'Group'; uuid: string }>;
  classesOrGroups: Array<{ __typename: 'Class'; uuid: string } | { __typename: 'Group'; uuid: string }>;
  originalSubject?: { __typename: 'Subject'; uuid: string; name: string; shortName: string } | null;
  originalRooms: Array<{ __typename: 'Room'; uuid: string; name: string }>;
};

export type _TimetableBlockFragment = {
  __typename: 'TimetableBlock';
  uuid: string;
  name: string;
  start: any;
  end: any;
  teachingLoadFactor?: number | null;
  teachingLoadComment?: string | null;
  teachingLoadCalculated?: number | null;
  timetables: Array<{ __typename: 'Timetable'; uuid: string }>;
  schoolYear: { __typename: 'SchoolYear'; uuid: string };
};

export type _SchoolYearFragmentFragment = {
  __typename: 'SchoolYear';
  uuid: string;
  name: string;
  start: any;
  end: any;
  createdAt?: any | null;
  updatedAt?: any | null;
};

export type _TeachingBlockFragmentFragment = {
  __typename: 'TeachingBlock';
  uuid: string;
  name: string;
  createdAt?: any | null;
  updatedAt: any;
  draft: boolean;
  comment?: string | null;
  schoolYear: { __typename: 'SchoolYear'; uuid: string };
  versions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string; active?: boolean | null }>;
  subjectContainer: { __typename: 'SubjectContainer'; uuid: string };
};

export type _TeachingBlockVersionsFragmentFragment = {
  __typename: 'TeachingBlockVersion';
  uuid: string;
  active?: boolean | null;
  version: number;
  availabilityExclusions: Array<{ __typename: 'TeachingBlockAvailabilityExclusion'; uuid: string }>;
  teachingBlock: { __typename: 'TeachingBlock'; uuid: string; name: string };
  subjectsConnection: {
    __typename: 'TeachingBlockVersionSubjectsConnection';
    edges: Array<{
      __typename?: 'TeachingBlockVersionSubjectsRelationship';
      properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
      node: { __typename: 'Subject'; uuid: string };
    }>;
  };
  classesConnection: {
    __typename: 'TeachingBlockVersionClassesConnection';
    edges: Array<{
      __typename?: 'TeachingBlockVersionClassesRelationship';
      properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
      node: { __typename: 'Class'; uuid: string };
    }>;
  };
  roomsConnection: {
    __typename: 'TeachingBlockVersionRoomsConnection';
    edges: Array<{
      __typename?: 'TeachingBlockVersionRoomsRelationship';
      properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
      node: { __typename: 'Room'; uuid: string };
    }>;
  };
  teachersConnection: {
    __typename: 'TeachingBlockVersionTeachersConnection';
    edges: Array<{
      __typename?: 'TeachingBlockVersionTeachersRelationship';
      properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
      node: { __typename: 'Person'; uuid: string };
    }>;
  };
};

export type TimetableConfigFragmentFragment = { __typename: 'TimetableConfig'; uuid: string; color?: string | null };

export type _TimetableFragment = {
  __typename: 'Timetable';
  uuid: string;
  name: string;
  draft: boolean;
  comment?: string | null;
  updatedAt: any;
  createdAt?: any | null;
  monEnabled?: boolean | null;
  tueEnabled?: boolean | null;
  wedEnabled?: boolean | null;
  thuEnabled?: boolean | null;
  friEnabled?: boolean | null;
  satEnabled?: boolean | null;
  sunEnabled?: boolean | null;
  versions: Array<{ __typename: 'TimetableVersion'; uuid: string }>;
  schoolYear: { __typename: 'SchoolYear'; uuid: string };
  timetableBlocks: Array<{ __typename: 'TimetableBlock'; uuid: string }>;
  timegridConfigsConnection: {
    __typename: 'TimetableTimegridConfigsConnection';
    edges: Array<{
      __typename?: 'TimetableTimegridConfigsRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: {
        __typename: 'TimetableTimeGridConfig';
        classes: Array<{ __typename: 'Class'; uuid: string }>;
        timegrid?: { __typename: 'TimeGrid'; uuid: string } | null;
      };
    }>;
  };
};

export type _TimetableVersionFragment = {
  __typename: 'TimetableVersion';
  uuid: string;
  version: number;
  active?: boolean | null;
  editable?: boolean | null;
  description?: string | null;
  placedCardsCount?: number | null;
  generating?: boolean | null;
  isSnapshot?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  original?: { __typename?: 'TimetableVersion'; uuid: string } | null;
  timetable: { __typename: 'Timetable'; uuid: string; name: string };
  subjectsConnection: {
    __typename: 'TimetableVersionSubjectsConnection';
    edges: Array<{
      __typename?: 'TimetableVersionSubjectsRelationship';
      properties: {
        __typename?: 'TimetableRelationshipProperties';
        mon?: string | null;
        tue?: string | null;
        wed?: string | null;
        thu?: string | null;
        fri?: string | null;
        sat?: string | null;
        sun?: string | null;
      };
      node: { __typename: 'Subject'; uuid: string };
    }>;
  };
  classesConnection: {
    __typename: 'TimetableVersionClassesConnection';
    edges: Array<{
      __typename?: 'TimetableVersionClassesRelationship';
      properties: {
        __typename?: 'TimetableRelationshipProperties';
        mon?: string | null;
        tue?: string | null;
        wed?: string | null;
        thu?: string | null;
        fri?: string | null;
        sat?: string | null;
        sun?: string | null;
      };
      node: { __typename: 'Class'; uuid: string };
    }>;
  };
  roomsConnection: {
    __typename: 'TimetableVersionRoomsConnection';
    edges: Array<{
      __typename?: 'TimetableVersionRoomsRelationship';
      properties: {
        __typename?: 'TimetableRelationshipProperties';
        mon?: string | null;
        tue?: string | null;
        wed?: string | null;
        thu?: string | null;
        fri?: string | null;
        sat?: string | null;
        sun?: string | null;
      };
      node: { __typename: 'Room'; uuid: string };
    }>;
  };
  teachersConnection: {
    __typename: 'TimetableVersionTeachersConnection';
    edges: Array<{
      __typename?: 'TimetableVersionTeachersRelationship';
      properties: {
        __typename?: 'TimetableRelationshipProperties';
        mon?: string | null;
        tue?: string | null;
        wed?: string | null;
        thu?: string | null;
        fri?: string | null;
        sat?: string | null;
        sun?: string | null;
      };
      node: { __typename: 'Person'; uuid: string };
    }>;
  };
  dependencies: Array<{ __typename: 'Dependency'; uuid: string }>;
  locked?: { __typename: 'Locked'; duration?: number | null; lockedSince: any; lockedBy: string } | null;
};

export type _SubjectFragmentFragment = {
  __typename: 'Subject';
  uuid: string;
  name: string;
  shortName: string;
  active?: boolean | null;
  epochEnabled?: boolean | null;
  subjectHourEnabled?: boolean | null;
  other?: boolean | null;
  updatedAt?: any | null;
  createdAt?: any | null;
  defaultRoomsConnection: {
    __typename?: 'SubjectDefaultRoomsConnection';
    edges: Array<{
      __typename?: 'SubjectDefaultRoomsRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: { __typename: 'Room'; uuid: string };
    }>;
  };
  timetableConfig?: { __typename: 'TimetableConfig'; color?: string | null } | null;
};

export type _SubjectContainerFragmentFragment = {
  __typename: 'SubjectContainer';
  uuid: string;
  name: string;
  shortName: string;
  grades: Array<number>;
  createdAt?: any | null;
  updatedAt?: any | null;
  validFrom?: { __typename: 'SchoolYear'; uuid: string } | null;
  validUntil?: { __typename: 'SchoolYear'; uuid: string } | null;
  gradeGroup: Array<{ __typename: 'GradeGroup'; uuid: string }>;
  timetableConfig?: { __typename: 'TimetableConfig'; uuid: string; color?: string | null } | null;
};

export type _PersonFragmentFragment = {
  __typename: 'Person';
  uuid: string;
  firstName: string;
  lastName: string;
  displayName: string;
  displayNameShort?: string | null;
  fullName: string;
  selectName: string;
  pimProfileUuid?: string | null;
  listName: string;
  shortName: string;
  salutation?: string | null;
  birthday?: any | null;
  email?: string | null;
  personalId?: string | null;
  gender?: string | null;
  active?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  organizationConnection: {
    __typename?: 'PersonOrganizationConnection';
    edges: Array<{
      __typename?: 'PersonOrganizationRelationship';
      properties: { __typename?: 'RoleName'; name: PersonRole };
      node: { __typename: 'Organization'; uuid: string };
    }>;
  };
  qualifications: Array<{
    __typename: 'Qualification';
    maxGrade?: number | null;
    minGrade?: number | null;
    subject: { __typename: 'Subject'; uuid: string };
  }>;
  timetableConfig?: { __typename: 'TimetableConfig'; uuid: string; color?: string | null } | null;
  contracts: Array<{ __typename: 'Contract'; uuid: string }>;
  defaultRoom?: { __typename: 'Room'; uuid: string } | null;
};

export type _ContractFragmentFragment = {
  __typename: 'Contract';
  uuid: string;
  name: string;
  validFrom: any;
  validUntil?: any | null;
  hoursWeekly?: number | null;
  freelancer?: boolean | null;
  billingMethod?: BillingMethods | null;
  limitedToFullTime?: boolean | null;
  substituteHours?: number | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  person: { __typename: 'Person'; uuid: string };
};

export type _QualificationFragmentFragment = {
  __typename: 'Qualification';
  minGrade?: number | null;
  maxGrade?: number | null;
  maxTeachingLoad?: number | null;
  subject: { __typename?: 'Subject'; uuid: string; shortName: string };
  owner: { __typename: 'Person'; uuid: string };
};

export type _ClassFragmentFragment = {
  __typename: 'Class';
  uuid: string;
  name: string;
  sortName?: string | null;
  shortName: string;
  grade?: number | null;
  functionalClassSubstitutionBehavior?: FunctionalClassSubstitutionBehavior | null;
  relevantForSubstitution?: boolean | null;
  certificatesEnabled?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  gradeGroup?: { __typename: 'GradeGroup'; uuid: string } | null;
  divisions: Array<{ __typename: 'Division'; uuid: string }>;
  tutorsConnection: {
    __typename?: 'ClassTutorsConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'ClassTutorsRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: { __typename: 'Person'; uuid: string };
    }>;
  };
  timetableConfig?: {
    __typename: 'TimetableConfig';
    uuid: string;
    color?: string | null;
    colorLabel?: string | null;
    printPageNr?: number | null;
    printOrder?: number | null;
  } | null;
  defaultRoom?: { __typename?: 'Room'; uuid: string } | null;
  schoolYear: { __typename: 'SchoolYear'; uuid: string };
};

export type _DivisionFragmentFragment = {
  __typename: 'Division';
  uuid: string;
  name: string;
  createdAt?: any | null;
  updatedAt?: any | null;
  groupsConnection: {
    __typename?: 'DivisionGroupsConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'DivisionGroupsRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: { __typename: 'Group'; uuid: string };
    }>;
  };
  class?: { __typename?: 'Class'; uuid: string; name: string; shortName: string } | null;
};

export type _GroupFragmentFragment = {
  __typename: 'Group';
  uuid: string;
  name: string;
  shortName: string;
  entireClass?: boolean | null;
  classFraction: number;
  createdAt?: any | null;
  updatedAt?: any | null;
  divisionConnection: {
    __typename?: 'GroupDivisionConnection';
    edges: Array<{
      __typename?: 'GroupDivisionRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: { __typename: 'Division'; uuid: string };
    }>;
  };
};

export type _LessonClassFragmentFragment = {
  __typename: 'LessonClass';
  uuid: string;
  usedDivision?: { __typename: 'Division'; uuid: string } | null;
  groups: Array<{ __typename: 'Group'; uuid: string }>;
  class: { __typename: 'Class'; uuid: string };
};

export type _LessonUnitFragmentFragment = {
  __typename: 'LessonUnit';
  uuid: string;
  duration?: number | null;
  count?: number | null;
  subjectContainer?: { __typename: 'SubjectContainer'; uuid: string } | null;
};

export type _RoomFragmentFragment = {
  __typename: 'Room';
  uuid: string;
  name: string;
  roomNumber?: string | null;
  description?: string | null;
  classroom?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  building?: { __typename: 'Building'; uuid: string } | null;
  responsiblePersonsConnection: {
    __typename?: 'RoomResponsiblePersonsConnection';
    edges: Array<{
      __typename?: 'RoomResponsiblePersonsRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: { __typename: 'Person'; uuid: string };
    }>;
  };
};

export type _BuildingFragmentFragment = {
  __typename: 'Building';
  uuid: string;
  name: string;
  description?: string | null;
  active?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
};

export type _CurriculumFragmentFragment = {
  __typename: 'Curriculum';
  uuid: string;
  comment?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  personsConnection: {
    __typename?: 'CurriculumPersonsConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'CurriculumPersonsRelationship';
      properties: {
        __typename?: 'CurriculumPersonRelationshipProperties';
        description?: string | null;
        present?: boolean | null;
        teachingLoad?: boolean | null;
        order: number;
      };
      node: { __typename: 'CurriculumPerson'; uuid: string };
    }>;
  };
  lessons: Array<{ __typename: 'Lesson'; uuid: string }>;
  subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
  curriculumUnit: Array<{ __typename: 'CurriculumUnit'; uuid: string }>;
  curriculumUnitConnection: {
    __typename?: 'CurriculumCurriculumUnitConnection';
    edges: Array<{
      __typename?: 'CurriculumCurriculumUnitRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: { __typename: 'CurriculumUnit'; uuid: string };
    }>;
  };
};

export type _LessonFragmentFragment = {
  __typename: 'Lesson';
  uuid: string;
  subTitle?: string | null;
  comment?: string | null;
  onlyInTimetableVersion: boolean;
  elective?: boolean | null;
  isClassTrip?: boolean | null;
  teachingLoadEnabled?: boolean | null;
  timetableEnabled?: boolean | null;
  placedCardsCount?: number | null;
  teachingBlockPlacedCardsCount?: number | null;
  classSort: string;
  groupClassNames: string;
  gradeGroupUuid?: Array<string> | null;
  teachersSort: string;
  subjectName: string;
  createdAt?: any | null;
  updatedAt?: any | null;
  curriculum?: { __typename: 'Curriculum'; uuid: string } | null;
  lessonUnitConnection: {
    __typename?: 'LessonLessonUnitConnection';
    edges: Array<{
      __typename?: 'LessonLessonUnitRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: {
        __typename: 'LessonUnit';
        uuid: string;
        duration?: number | null;
        count?: number | null;
        subjectContainer?: { __typename: 'SubjectContainer'; uuid: string } | null;
      };
    }>;
  };
  lessonClassesConnection: {
    __typename?: 'LessonLessonClassesConnection';
    edges: Array<{
      __typename?: 'LessonLessonClassesRelationship';
      properties: { __typename?: 'OrderedRelationProperties'; order: number };
      node: {
        __typename: 'LessonClass';
        uuid: string;
        usedDivision?: { __typename: 'Division'; uuid: string } | null;
        groups: Array<{ __typename: 'Group'; uuid: string }>;
        class: { __typename: 'Class'; uuid: string };
      };
    }>;
  };
  teachersConnection: {
    __typename?: 'LessonTeachersConnection';
    edges: Array<{
      __typename?: 'LessonTeachersRelationship';
      properties: {
        __typename?: 'LessonTeacherRelationshipProperties';
        description?: string | null;
        order: number;
        present?: boolean | null;
        teachingLoad?: boolean | null;
        teachingLoadHours?: number | null;
        writesCertificate?: boolean | null;
      };
      node: { __typename: 'Person'; uuid: string };
    }>;
  };
  subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
  roomSupplyConnection: {
    __typename?: 'LessonRoomSupplyConnection';
    edges: Array<{
      __typename?: 'LessonRoomSupplyRelationship';
      properties: { __typename?: 'LessonRoomRelationshipProperties'; order: number; descriptions?: string | null };
      node: { __typename: 'Room'; uuid: string };
    }>;
  };
  versions: Array<{ __typename: 'TimetableVersion'; uuid: string }>;
  teachingBlockVersions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string }>;
  activeTimetables?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
  activeTeachingBlocks?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
};

export type _TimeGridFragmentFragment = {
  __typename: 'TimeGrid';
  uuid: string;
  name: string;
  description: string;
  createdAt?: any | null;
  updatedAt?: any | null;
  items: Array<{ __typename: 'TimeGridEntry'; uuid: string }>;
};

export type _TimeGridEntryFragmentFragment = {
  __typename: 'TimeGridEntry';
  uuid: string;
  start: any;
  pause: boolean;
  end: any;
  order: number;
  name: string;
  shortName: string;
  timeGrid?: { __typename: 'TimeGrid'; uuid: string } | null;
};

export type _TimetableCardFragmentFragment = {
  __typename: 'TimetableCard';
  uuid: string;
  duration?: number | null;
  weekday?: string | null;
  locked: boolean;
  startTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string } | null;
  endTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string } | null;
  rooms: Array<{ __typename: 'Room'; uuid: string }>;
  lessonClasses: Array<{
    __typename: 'LessonClass';
    uuid: string;
    usedDivision?: { __typename: 'Division'; uuid: string } | null;
    groups: Array<{ __typename: 'Group'; uuid: string }>;
    class: { __typename: 'Class'; uuid: string };
  }>;
  teachers: Array<{ __typename: 'Person'; uuid: string }>;
  lesson: { __typename: 'Lesson'; uuid: string };
  subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
};

export type _TeachingBlockCardFragmentFragment = {
  __typename: 'TeachingBlockCard';
  uuid: string;
  duration?: number | null;
  startDate?: any | null;
  endDate?: any | null;
  includeHoliday: boolean;
  locked: boolean;
  rooms: Array<{ __typename: 'Room'; uuid: string }>;
  teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
  lessonClasses: Array<{
    __typename: 'LessonClass';
    uuid: string;
    usedDivision?: { __typename: 'Division'; uuid: string } | null;
    groups: Array<{ __typename: 'Group'; uuid: string }>;
    class: { __typename: 'Class'; uuid: string };
  }>;
  teachers: Array<{ __typename: 'Person'; uuid: string }>;
  teachersPresent: Array<{ __typename: 'Person'; uuid: string }>;
  lesson: { __typename: 'Lesson'; uuid: string };
  subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
};

export type _GradeGroupFragmentFragment = {
  __typename: 'GradeGroup';
  uuid: string;
  name: string;
  shortName: string;
  class: Array<{ __typename?: 'Class'; uuid: string }>;
};

export type _TeachingBlockAvailabilityExclusionFragmentFragment = {
  __typename: 'TeachingBlockAvailabilityExclusion';
  uuid: string;
  from: any;
  to: any;
  priority: number;
  comment?: string | null;
  holder:
    | { __typename: 'Class'; uuid: string }
    | { __typename: 'Person'; uuid: string }
    | { __typename: 'Room'; uuid: string }
    | { __typename: 'Subject'; uuid: string };
  teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
};

export type _TimetableVersionsQueryVariables = Exact<{
  where?: InputMaybe<TimetableVersionWhere>;
  options?: InputMaybe<TimetableVersionOptions>;
}>;

export type _TimetableVersionsQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename: 'TimetableVersion';
    uuid: string;
    version: number;
    active?: boolean | null;
    editable?: boolean | null;
    description?: string | null;
    placedCardsCount?: number | null;
    generating?: boolean | null;
    isSnapshot?: boolean | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    original?: { __typename?: 'TimetableVersion'; uuid: string } | null;
    timetable: { __typename: 'Timetable'; uuid: string; name: string };
    subjectsConnection: {
      __typename: 'TimetableVersionSubjectsConnection';
      edges: Array<{
        __typename?: 'TimetableVersionSubjectsRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename: 'Subject'; uuid: string };
      }>;
    };
    classesConnection: {
      __typename: 'TimetableVersionClassesConnection';
      edges: Array<{
        __typename?: 'TimetableVersionClassesRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename: 'Class'; uuid: string };
      }>;
    };
    roomsConnection: {
      __typename: 'TimetableVersionRoomsConnection';
      edges: Array<{
        __typename?: 'TimetableVersionRoomsRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename: 'Room'; uuid: string };
      }>;
    };
    teachersConnection: {
      __typename: 'TimetableVersionTeachersConnection';
      edges: Array<{
        __typename?: 'TimetableVersionTeachersRelationship';
        properties: {
          __typename?: 'TimetableRelationshipProperties';
          mon?: string | null;
          tue?: string | null;
          wed?: string | null;
          thu?: string | null;
          fri?: string | null;
          sat?: string | null;
          sun?: string | null;
        };
        node: { __typename: 'Person'; uuid: string };
      }>;
    };
    dependencies: Array<{ __typename: 'Dependency'; uuid: string }>;
    locked?: { __typename: 'Locked'; duration?: number | null; lockedSince: any; lockedBy: string } | null;
  }>;
};

export type _SubstitutionFilterTimetableVersionsQueryVariables = Exact<{
  where?: InputMaybe<TimetableVersionWhere>;
  options?: InputMaybe<TimetableVersionOptions>;
}>;

export type _SubstitutionFilterTimetableVersionsQuery = {
  __typename?: 'Query';
  timetableVersions: Array<{
    __typename?: 'TimetableVersion';
    uuid: string;
    timetable: { __typename: 'Timetable'; uuid: string; name: string };
    classes: Array<{ __typename: 'Class'; uuid: string }>;
  }>;
};

export type _TeachingBlockAvailabilityExclusionsQueryVariables = Exact<{
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  options?: InputMaybe<TeachingBlockAvailabilityExclusionOptions>;
}>;

export type _TeachingBlockAvailabilityExclusionsQuery = {
  __typename?: 'Query';
  teachingBlockAvailabilityExclusions: Array<{
    __typename: 'TeachingBlockAvailabilityExclusion';
    uuid: string;
    from: any;
    to: any;
    priority: number;
    comment?: string | null;
    holder:
      | { __typename: 'Class'; uuid: string }
      | { __typename: 'Person'; uuid: string }
      | { __typename: 'Room'; uuid: string }
      | { __typename: 'Subject'; uuid: string };
    teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
  }>;
};

export type _TimeGridsQueryVariables = Exact<{
  where?: InputMaybe<TimeGridWhere>;
  options?: InputMaybe<TimeGridOptions>;
}>;

export type _TimeGridsQuery = {
  __typename?: 'Query';
  timeGrids: Array<{
    __typename: 'TimeGrid';
    uuid: string;
    name: string;
    description: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    items: Array<{ __typename: 'TimeGridEntry'; uuid: string }>;
  }>;
};

export type _TimeGridEntriesQueryVariables = Exact<{
  where?: InputMaybe<TimeGridEntryWhere>;
  options?: InputMaybe<TimeGridEntryOptions>;
}>;

export type _TimeGridEntriesQuery = {
  __typename?: 'Query';
  timeGridEntries: Array<{
    __typename: 'TimeGridEntry';
    uuid: string;
    start: any;
    pause: boolean;
    end: any;
    order: number;
    name: string;
    shortName: string;
    timeGrid?: { __typename: 'TimeGrid'; uuid: string } | null;
  }>;
};

export type _GradeGroupsQueryVariables = Exact<{
  where?: InputMaybe<GradeGroupWhere>;
  options?: InputMaybe<GradeGroupOptions>;
}>;

export type _GradeGroupsQuery = {
  __typename?: 'Query';
  gradeGroups: Array<{
    __typename: 'GradeGroup';
    uuid: string;
    name: string;
    shortName: string;
    class: Array<{ __typename?: 'Class'; uuid: string }>;
  }>;
};

export type _ClassesQueryVariables = Exact<{
  where?: InputMaybe<ClassWhere>;
  options?: InputMaybe<ClassOptions>;
}>;

export type _ClassesQuery = {
  __typename?: 'Query';
  classes: Array<{
    __typename: 'Class';
    uuid: string;
    name: string;
    sortName?: string | null;
    shortName: string;
    grade?: number | null;
    functionalClassSubstitutionBehavior?: FunctionalClassSubstitutionBehavior | null;
    relevantForSubstitution?: boolean | null;
    certificatesEnabled?: boolean | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    gradeGroup?: { __typename: 'GradeGroup'; uuid: string } | null;
    divisions: Array<{ __typename: 'Division'; uuid: string }>;
    tutorsConnection: {
      __typename?: 'ClassTutorsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'ClassTutorsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename: 'Person'; uuid: string };
      }>;
    };
    timetableConfig?: {
      __typename: 'TimetableConfig';
      uuid: string;
      color?: string | null;
      colorLabel?: string | null;
      printPageNr?: number | null;
      printOrder?: number | null;
    } | null;
    defaultRoom?: { __typename?: 'Room'; uuid: string } | null;
    schoolYear: { __typename: 'SchoolYear'; uuid: string };
  }>;
};

export type _SubjectsQueryVariables = Exact<{
  where?: InputMaybe<SubjectWhere>;
  options?: InputMaybe<SubjectOptions>;
}>;

export type _SubjectsQuery = {
  __typename?: 'Query';
  subjects: Array<{
    __typename: 'Subject';
    uuid: string;
    name: string;
    shortName: string;
    active?: boolean | null;
    epochEnabled?: boolean | null;
    subjectHourEnabled?: boolean | null;
    other?: boolean | null;
    updatedAt?: any | null;
    createdAt?: any | null;
    defaultRoomsConnection: {
      __typename?: 'SubjectDefaultRoomsConnection';
      edges: Array<{
        __typename?: 'SubjectDefaultRoomsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename: 'Room'; uuid: string };
      }>;
    };
    timetableConfig?: { __typename: 'TimetableConfig'; color?: string | null } | null;
  }>;
};

export type _SubjectContainersQueryVariables = Exact<{
  where?: InputMaybe<SubjectContainerWhere>;
  options?: InputMaybe<SubjectContainerOptions>;
}>;

export type _SubjectContainersQuery = {
  __typename?: 'Query';
  subjectContainers: Array<{
    __typename: 'SubjectContainer';
    uuid: string;
    name: string;
    shortName: string;
    grades: Array<number>;
    createdAt?: any | null;
    updatedAt?: any | null;
    validFrom?: { __typename: 'SchoolYear'; uuid: string } | null;
    validUntil?: { __typename: 'SchoolYear'; uuid: string } | null;
    gradeGroup: Array<{ __typename: 'GradeGroup'; uuid: string }>;
    timetableConfig?: { __typename: 'TimetableConfig'; uuid: string; color?: string | null } | null;
  }>;
};

export type _PeopleQueryVariables = Exact<{
  where?: InputMaybe<PersonWhere>;
  options?: InputMaybe<PersonOptions>;
}>;

export type _PeopleQuery = {
  __typename?: 'Query';
  people: Array<{
    __typename: 'Person';
    uuid: string;
    firstName: string;
    lastName: string;
    displayName: string;
    displayNameShort?: string | null;
    fullName: string;
    selectName: string;
    pimProfileUuid?: string | null;
    listName: string;
    shortName: string;
    salutation?: string | null;
    birthday?: any | null;
    email?: string | null;
    personalId?: string | null;
    gender?: string | null;
    active?: boolean | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    organizationConnection: {
      __typename?: 'PersonOrganizationConnection';
      edges: Array<{
        __typename?: 'PersonOrganizationRelationship';
        properties: { __typename?: 'RoleName'; name: PersonRole };
        node: { __typename: 'Organization'; uuid: string };
      }>;
    };
    qualifications: Array<{
      __typename: 'Qualification';
      maxGrade?: number | null;
      minGrade?: number | null;
      subject: { __typename: 'Subject'; uuid: string };
    }>;
    timetableConfig?: { __typename: 'TimetableConfig'; uuid: string; color?: string | null } | null;
    contracts: Array<{ __typename: 'Contract'; uuid: string }>;
    defaultRoom?: { __typename: 'Room'; uuid: string } | null;
  }>;
};

export type _UsedInVersionLessonsQueryVariables = Exact<{
  uuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type _UsedInVersionLessonsQuery = {
  __typename?: 'Query';
  lessons: Array<{
    __typename: 'Lesson';
    uuid: string;
    versions: Array<{ __typename: 'TimetableVersion'; uuid: string }>;
    activeTimetables?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
  }>;
};

export type _LessonsQueryVariables = Exact<{
  where?: InputMaybe<LessonWhere>;
  options?: InputMaybe<LessonOptions>;
}>;

export type _LessonsQuery = {
  __typename?: 'Query';
  lessons: Array<{
    __typename: 'Lesson';
    uuid: string;
    subTitle?: string | null;
    comment?: string | null;
    onlyInTimetableVersion: boolean;
    elective?: boolean | null;
    isClassTrip?: boolean | null;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    placedCardsCount?: number | null;
    teachingBlockPlacedCardsCount?: number | null;
    classSort: string;
    groupClassNames: string;
    gradeGroupUuid?: Array<string> | null;
    teachersSort: string;
    subjectName: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    curriculum?: { __typename: 'Curriculum'; uuid: string } | null;
    lessonUnitConnection: {
      __typename?: 'LessonLessonUnitConnection';
      edges: Array<{
        __typename?: 'LessonLessonUnitRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: {
          __typename: 'LessonUnit';
          uuid: string;
          duration?: number | null;
          count?: number | null;
          subjectContainer?: { __typename: 'SubjectContainer'; uuid: string } | null;
        };
      }>;
    };
    lessonClassesConnection: {
      __typename?: 'LessonLessonClassesConnection';
      edges: Array<{
        __typename?: 'LessonLessonClassesRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: {
          __typename: 'LessonClass';
          uuid: string;
          usedDivision?: { __typename: 'Division'; uuid: string } | null;
          groups: Array<{ __typename: 'Group'; uuid: string }>;
          class: { __typename: 'Class'; uuid: string };
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'LessonTeachersConnection';
      edges: Array<{
        __typename?: 'LessonTeachersRelationship';
        properties: {
          __typename?: 'LessonTeacherRelationshipProperties';
          description?: string | null;
          order: number;
          present?: boolean | null;
          teachingLoad?: boolean | null;
          teachingLoadHours?: number | null;
          writesCertificate?: boolean | null;
        };
        node: { __typename: 'Person'; uuid: string };
      }>;
    };
    subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        properties: { __typename?: 'LessonRoomRelationshipProperties'; order: number; descriptions?: string | null };
        node: { __typename: 'Room'; uuid: string };
      }>;
    };
    versions: Array<{ __typename: 'TimetableVersion'; uuid: string }>;
    teachingBlockVersions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string }>;
    activeTimetables?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
    activeTeachingBlocks?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
  }>;
};

export type _TimetableCardsQueryVariables = Exact<{
  where?: InputMaybe<TimetableCardWhere>;
  options?: InputMaybe<TimetableCardOptions>;
}>;

export type _TimetableCardsQuery = {
  __typename?: 'Query';
  timetableCards: Array<{
    __typename: 'TimetableCard';
    uuid: string;
    duration?: number | null;
    weekday?: string | null;
    locked: boolean;
    startTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string } | null;
    endTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string } | null;
    rooms: Array<{ __typename: 'Room'; uuid: string }>;
    lessonClasses: Array<{
      __typename: 'LessonClass';
      uuid: string;
      usedDivision?: { __typename: 'Division'; uuid: string } | null;
      groups: Array<{ __typename: 'Group'; uuid: string }>;
      class: { __typename: 'Class'; uuid: string };
    }>;
    teachers: Array<{ __typename: 'Person'; uuid: string }>;
    lesson: { __typename: 'Lesson'; uuid: string };
    subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
  }>;
};

export type _TeachingBlockCardsQueryVariables = Exact<{
  where?: InputMaybe<TeachingBlockCardWhere>;
  options?: InputMaybe<TeachingBlockCardOptions>;
}>;

export type _TeachingBlockCardsQuery = {
  __typename?: 'Query';
  teachingBlockCards: Array<{
    __typename: 'TeachingBlockCard';
    uuid: string;
    duration?: number | null;
    startDate?: any | null;
    endDate?: any | null;
    includeHoliday: boolean;
    locked: boolean;
    rooms: Array<{ __typename: 'Room'; uuid: string }>;
    teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
    lessonClasses: Array<{
      __typename: 'LessonClass';
      uuid: string;
      usedDivision?: { __typename: 'Division'; uuid: string } | null;
      groups: Array<{ __typename: 'Group'; uuid: string }>;
      class: { __typename: 'Class'; uuid: string };
    }>;
    teachers: Array<{ __typename: 'Person'; uuid: string }>;
    teachersPresent: Array<{ __typename: 'Person'; uuid: string }>;
    lesson: { __typename: 'Lesson'; uuid: string };
    subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
  }>;
};

export type _TeachingBlockVersionsQueryVariables = Exact<{
  where?: InputMaybe<TeachingBlockVersionWhere>;
}>;

export type _TeachingBlockVersionsQuery = {
  __typename?: 'Query';
  teachingBlockVersions: Array<{
    __typename: 'TeachingBlockVersion';
    uuid: string;
    active?: boolean | null;
    version: number;
    availabilityExclusions: Array<{ __typename: 'TeachingBlockAvailabilityExclusion'; uuid: string }>;
    teachingBlock: { __typename: 'TeachingBlock'; uuid: string; name: string };
    subjectsConnection: {
      __typename: 'TeachingBlockVersionSubjectsConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionSubjectsRelationship';
        properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        node: { __typename: 'Subject'; uuid: string };
      }>;
    };
    classesConnection: {
      __typename: 'TeachingBlockVersionClassesConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionClassesRelationship';
        properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        node: { __typename: 'Class'; uuid: string };
      }>;
    };
    roomsConnection: {
      __typename: 'TeachingBlockVersionRoomsConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionRoomsRelationship';
        properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        node: { __typename: 'Room'; uuid: string };
      }>;
    };
    teachersConnection: {
      __typename: 'TeachingBlockVersionTeachersConnection';
      edges: Array<{
        __typename?: 'TeachingBlockVersionTeachersRelationship';
        properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
        node: { __typename: 'Person'; uuid: string };
      }>;
    };
  }>;
};

export type _TeachingBlocksQueryVariables = Exact<{
  where?: InputMaybe<TeachingBlockWhere>;
  options?: InputMaybe<TeachingBlockOptions>;
}>;

export type _TeachingBlocksQuery = {
  __typename?: 'Query';
  teachingBlocks: Array<{
    __typename: 'TeachingBlock';
    uuid: string;
    name: string;
    createdAt?: any | null;
    updatedAt: any;
    draft: boolean;
    comment?: string | null;
    schoolYear: { __typename: 'SchoolYear'; uuid: string };
    versions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string; active?: boolean | null }>;
    subjectContainer: { __typename: 'SubjectContainer'; uuid: string };
  }>;
};

export type _RoomsQueryVariables = Exact<{
  where?: InputMaybe<RoomWhere>;
  options?: InputMaybe<RoomOptions>;
}>;

export type _RoomsQuery = {
  __typename?: 'Query';
  rooms: Array<{
    __typename: 'Room';
    uuid: string;
    name: string;
    roomNumber?: string | null;
    description?: string | null;
    classroom?: boolean | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    building?: { __typename: 'Building'; uuid: string } | null;
    responsiblePersonsConnection: {
      __typename?: 'RoomResponsiblePersonsConnection';
      edges: Array<{
        __typename?: 'RoomResponsiblePersonsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename: 'Person'; uuid: string };
      }>;
    };
  }>;
};

export type _BuildingsQueryVariables = Exact<{
  where?: InputMaybe<BuildingWhere>;
  options?: InputMaybe<BuildingOptions>;
}>;

export type _BuildingsQuery = {
  __typename?: 'Query';
  buildings: Array<{
    __typename: 'Building';
    uuid: string;
    name: string;
    description?: string | null;
    active?: boolean | null;
    createdAt?: any | null;
    updatedAt?: any | null;
  }>;
};

export type _LessonUnitQueryVariables = Exact<{
  where?: InputMaybe<LessonUnitWhere>;
  options?: InputMaybe<LessonUnitOptions>;
}>;

export type _LessonUnitQuery = {
  __typename?: 'Query';
  lessonUnits: Array<{
    __typename: 'LessonUnit';
    uuid: string;
    duration?: number | null;
    count?: number | null;
    subjectContainer?: { __typename: 'SubjectContainer'; uuid: string } | null;
  }>;
};

export type _DivisionsQueryVariables = Exact<{
  where?: InputMaybe<DivisionWhere>;
  options?: InputMaybe<DivisionOptions>;
}>;

export type _DivisionsQuery = {
  __typename?: 'Query';
  divisions: Array<{
    __typename: 'Division';
    uuid: string;
    name: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    groupsConnection: {
      __typename?: 'DivisionGroupsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'DivisionGroupsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename: 'Group'; uuid: string };
      }>;
    };
    class?: { __typename?: 'Class'; uuid: string; name: string; shortName: string } | null;
  }>;
};

export type _GroupsQueryVariables = Exact<{
  where?: InputMaybe<GroupWhere>;
  options?: InputMaybe<GroupOptions>;
}>;

export type _GroupsQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename: 'Group';
    uuid: string;
    name: string;
    shortName: string;
    entireClass?: boolean | null;
    classFraction: number;
    createdAt?: any | null;
    updatedAt?: any | null;
    divisionConnection: {
      __typename?: 'GroupDivisionConnection';
      edges: Array<{
        __typename?: 'GroupDivisionRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename: 'Division'; uuid: string };
      }>;
    };
  }>;
};

export type _TimetableConfigQueryVariables = Exact<{
  where?: InputMaybe<TimetableConfigWhere>;
  options?: InputMaybe<TimetableConfigOptions>;
}>;

export type _TimetableConfigQuery = {
  __typename?: 'Query';
  timetableConfigs: Array<{ __typename: 'TimetableConfig'; uuid: string; color?: string | null }>;
};

export type _ContractsQueryVariables = Exact<{
  where?: InputMaybe<ContractWhere>;
  options?: InputMaybe<ContractOptions>;
}>;

export type _ContractsQuery = {
  __typename?: 'Query';
  contracts: Array<{
    __typename: 'Contract';
    uuid: string;
    name: string;
    validFrom: any;
    validUntil?: any | null;
    hoursWeekly?: number | null;
    freelancer?: boolean | null;
    billingMethod?: BillingMethods | null;
    limitedToFullTime?: boolean | null;
    substituteHours?: number | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    person: { __typename: 'Person'; uuid: string };
  }>;
};

export type _QualificationsQueryVariables = Exact<{
  where?: InputMaybe<QualificationWhere>;
  options?: InputMaybe<QualificationOptions>;
}>;

export type _QualificationsQuery = {
  __typename?: 'Query';
  qualifications: Array<{
    __typename: 'Qualification';
    minGrade?: number | null;
    maxGrade?: number | null;
    maxTeachingLoad?: number | null;
    subject: { __typename?: 'Subject'; uuid: string; shortName: string };
    owner: { __typename: 'Person'; uuid: string };
  }>;
};

export type _TimetablesQueryVariables = Exact<{
  where?: InputMaybe<TimetableWhere>;
  options?: InputMaybe<TimetableOptions>;
}>;

export type _TimetablesQuery = {
  __typename?: 'Query';
  timetables: Array<{
    __typename: 'Timetable';
    uuid: string;
    name: string;
    draft: boolean;
    comment?: string | null;
    updatedAt: any;
    createdAt?: any | null;
    monEnabled?: boolean | null;
    tueEnabled?: boolean | null;
    wedEnabled?: boolean | null;
    thuEnabled?: boolean | null;
    friEnabled?: boolean | null;
    satEnabled?: boolean | null;
    sunEnabled?: boolean | null;
    versions: Array<{ __typename: 'TimetableVersion'; uuid: string }>;
    schoolYear: { __typename: 'SchoolYear'; uuid: string };
    timetableBlocks: Array<{ __typename: 'TimetableBlock'; uuid: string }>;
    timegridConfigsConnection: {
      __typename: 'TimetableTimegridConfigsConnection';
      edges: Array<{
        __typename?: 'TimetableTimegridConfigsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: {
          __typename: 'TimetableTimeGridConfig';
          classes: Array<{ __typename: 'Class'; uuid: string }>;
          timegrid?: { __typename: 'TimeGrid'; uuid: string } | null;
        };
      }>;
    };
  }>;
};

export type _LessonUnitsQueryVariables = Exact<{
  where?: InputMaybe<LessonUnitWhere>;
  options?: InputMaybe<LessonUnitOptions>;
}>;

export type _LessonUnitsQuery = {
  __typename?: 'Query';
  lessonUnits: Array<{
    __typename: 'LessonUnit';
    uuid: string;
    duration?: number | null;
    count?: number | null;
    subjectContainer?: { __typename: 'SubjectContainer'; uuid: string } | null;
  }>;
};

export type _SchoolYearsQueryVariables = Exact<{
  where?: InputMaybe<SchoolYearWhere>;
  options?: InputMaybe<SchoolYearOptions>;
}>;

export type _SchoolYearsQuery = {
  __typename?: 'Query';
  schoolYears: Array<{
    __typename: 'SchoolYear';
    uuid: string;
    name: string;
    start: any;
    end: any;
    createdAt?: any | null;
    updatedAt?: any | null;
  }>;
};

export type _TimetableBlocksQueryVariables = Exact<{
  where?: InputMaybe<TimetableBlockWhere>;
  options?: InputMaybe<TimetableBlockOptions>;
}>;

export type _TimetableBlocksQuery = {
  __typename?: 'Query';
  timetableBlocks: Array<{
    __typename: 'TimetableBlock';
    uuid: string;
    name: string;
    start: any;
    end: any;
    teachingLoadFactor?: number | null;
    teachingLoadComment?: string | null;
    teachingLoadCalculated?: number | null;
    timetables: Array<{ __typename: 'Timetable'; uuid: string }>;
    schoolYear: { __typename: 'SchoolYear'; uuid: string };
  }>;
};

export type _TimetablePrintConfigsQueryVariables = Exact<{
  where?: InputMaybe<TimetablePrintConfigWhere>;
  options?: InputMaybe<TimetablePrintConfigOptions>;
}>;

export type _TimetablePrintConfigsQuery = {
  __typename?: 'Query';
  timetablePrintConfigs: Array<{
    __typename: 'TimetablePrintConfig';
    uuid: string;
    type: TimetableReportType;
    topLeft?: TimetablePrintLayoutOptions | null;
    topCenter?: TimetablePrintLayoutOptions | null;
    topRight?: TimetablePrintLayoutOptions | null;
    center?: TimetablePrintLayoutOptions | null;
    bottomLeft?: TimetablePrintLayoutOptions | null;
    bottomCenter?: TimetablePrintLayoutOptions | null;
    bottomRight?: TimetablePrintLayoutOptions | null;
    printColorOrigin?: TimetablePrintColorOrigins | null;
    printColorPosition?: TimetablePrintColorPositions | null;
    printClasses?: boolean | null;
    scaleText?: boolean | null;
    exactMinute?: boolean | null;
    printSubtitle?: boolean | null;
    printLogo?: boolean | null;
    largeFont?: boolean | null;
    showSchoolWeeks?: boolean | null;
    showCalendarWeeks?: boolean | null;
    showWeekSchoolDays?: boolean | null;
    timeHorizontal?: boolean | null;
  }>;
};

export type _CurriculumsQueryVariables = Exact<{
  where?: InputMaybe<CurriculumWhere>;
  options?: InputMaybe<CurriculumOptions>;
}>;

export type _CurriculumsQuery = {
  __typename?: 'Query';
  curricula: Array<{
    __typename: 'Curriculum';
    uuid: string;
    comment?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    personsConnection: {
      __typename?: 'CurriculumPersonsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'CurriculumPersonsRelationship';
        properties: {
          __typename?: 'CurriculumPersonRelationshipProperties';
          description?: string | null;
          present?: boolean | null;
          teachingLoad?: boolean | null;
          order: number;
        };
        node: { __typename: 'CurriculumPerson'; uuid: string };
      }>;
    };
    lessons: Array<{ __typename: 'Lesson'; uuid: string }>;
    subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
    curriculumUnit: Array<{ __typename: 'CurriculumUnit'; uuid: string }>;
    curriculumUnitConnection: {
      __typename?: 'CurriculumCurriculumUnitConnection';
      edges: Array<{
        __typename?: 'CurriculumCurriculumUnitRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename: 'CurriculumUnit'; uuid: string };
      }>;
    };
  }>;
};

export type _EventsQueryVariables = Exact<{
  where?: InputMaybe<EventWhere>;
  options?: InputMaybe<EventOptions>;
}>;

export type _EventsQuery = {
  __typename?: 'Query';
  events: Array<{
    __typename: 'Event';
    uuid: string;
    start: any;
    end: any;
    comment?: string | null;
    canceled: boolean;
    currentState?: string | null;
    isClassTrip?: boolean | null;
    isClassbookRelevant: boolean;
    substitutionReasons?: SubstitutionReason | null;
    substitutionComment?: string | null;
    print: boolean;
    isSchoolEvent: boolean;
    sourceTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string; name: string; shortName: string } | null;
    isAggregated?: { __typename: 'Event'; uuid: string } | null;
    personsConnection: {
      __typename: 'EventPersonsConnection';
      edges: Array<{
        __typename?: 'EventPersonsRelationship';
        properties: {
          __typename?: 'EventPersonRelationProperties';
          givenSubstituteHours?: number | null;
          isCoveringTeacher: boolean;
        };
        node: { __typename: 'Person'; uuid: string };
      }>;
    };
    originalPersons: Array<{ __typename: 'Person'; uuid: string }>;
    subject: { __typename: 'Subject'; uuid: string };
    rooms: Array<{ __typename: 'Room'; uuid: string }>;
    originalClassesOrGroups: Array<{ __typename: 'Class'; uuid: string } | { __typename: 'Group'; uuid: string }>;
    classesOrGroups: Array<{ __typename: 'Class'; uuid: string } | { __typename: 'Group'; uuid: string }>;
    originalSubject?: { __typename: 'Subject'; uuid: string; name: string; shortName: string } | null;
    originalRooms: Array<{ __typename: 'Room'; uuid: string; name: string }>;
  }>;
};

export type _EventsCountQueryVariables = Exact<{
  where?: InputMaybe<EventWhere>;
}>;

export type _EventsCountQuery = {
  __typename?: 'Query';
  eventsConnection: { __typename?: 'EventsConnection'; totalCount: number };
};

export type _SchoolEventsQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;

export type _SchoolEventsQuery = {
  __typename?: 'Query';
  schoolEvents: Array<{
    __typename: 'SchoolEvent';
    uuid: string;
    start: any;
    end: any;
    canceled: boolean;
    comment?: string | null;
    isClassTrip: boolean;
    recurrenceUuid?: string | null;
    groupClassNames: string;
    groupClassNamesLong: string;
    persons: Array<{ __typename: 'MinimalPerson'; uuid: string; displayName: string; listName: string }>;
    rooms: Array<{ __typename: 'MinimalRoom'; uuid: string; name: string }>;
    subject: { __typename: 'MinimalSubject'; uuid: string; name: string; shortName: string };
    classesOrGroups: Array<{ __typename: 'MinimalClass'; uuid: string } | { __typename: 'MinimalGroup'; uuid: string }>;
  }>;
};

export type _RecurringEventQueryVariables = Exact<{
  where?: InputMaybe<RecurringEventWhere>;
  options?: InputMaybe<RecurringEventOptions>;
}>;

export type _RecurringEventQuery = {
  __typename?: 'Query';
  recurringEvents: Array<{
    __typename: 'RecurringEvent';
    uuid: string;
    futureEvents: Array<{ __typename?: 'Event'; uuid: string }>;
  }>;
};

export type _CreateSingleSchoolEventMutationVariables = Exact<{
  input: SchoolEventCreateInput;
}>;

export type _CreateSingleSchoolEventMutation = {
  __typename?: 'Mutation';
  createSchoolEvent: { __typename: 'CreateResponse'; nodesCreated: number; nodeUuids: Array<string> };
};

export type _CreateRecurringSchoolEventMutationVariables = Exact<{
  input: RecurrenceSchoolEventCreateInput;
}>;

export type _CreateRecurringSchoolEventMutation = {
  __typename?: 'Mutation';
  createRecurrenceSchoolEvents: { __typename?: 'CreateResponse'; nodeUuids: Array<string> };
};

export type _DeleteSchoolEventsMutationVariables = Exact<{
  uuids: OnlyUuids;
}>;

export type _DeleteSchoolEventsMutation = {
  __typename?: 'Mutation';
  deleteSchoolEvents: { __typename: 'DeleteInfo'; nodesDeleted: number };
};

export type _DeleteRecurrenceSchoolEventsMutationVariables = Exact<{
  recurrenceUuid: Scalars['ID']['input'];
}>;

export type _DeleteRecurrenceSchoolEventsMutation = {
  __typename?: 'Mutation';
  deleteRecurrenceSchoolEvents: { __typename: 'DeleteInfo'; nodesDeleted: number };
};

export type _SetPrintEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  print: Scalars['Boolean']['input'];
}>;

export type _SetPrintEventMutation = {
  __typename?: 'Mutation';
  setPrintEvent: { __typename: 'EntitiesUpdateInfo'; entitiesUpdated: number };
};

export type _SetSubstitutionMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  coveringTeachers: Array<SetCoveringTeachersInput> | SetCoveringTeachersInput;
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  rooms: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type _SetSubstitutionMutation = {
  __typename?: 'Mutation';
  setSubstitution: { __typename: 'EntitiesUpdateInfo' };
};

export type _CancelEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
}>;

export type _CancelEventMutation = { __typename?: 'Mutation'; cancelEvent: { __typename: 'EntitiesUpdateInfo' } };

export type _SetSelfWorkEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
  rooms: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type _SetSelfWorkEventMutation = {
  __typename?: 'Mutation';
  setSelfWorkForEvent: { __typename: 'EntitiesUpdateInfo' };
};

export type _ResetEventMutationVariables = Exact<{
  eventUuid: Scalars['ID']['input'];
}>;

export type _ResetEventMutation = { __typename?: 'Mutation'; resetEvent: { __typename: 'EntitiesUpdateInfo' } };

export type _MergeEventsMutationVariables = Exact<{
  eventsToMerge: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  targetEvent: Scalars['ID']['input'];
  rooms: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  substitutionComment?: InputMaybe<Scalars['String']['input']>;
}>;

export type _MergeEventsMutation = { __typename?: 'Mutation'; mergeEvents: { __typename: 'EntitiesUpdateInfo' } };

export type _CreateTimetablePrintConfigsMutationVariables = Exact<{
  input: Array<TimetablePrintConfigCreateInput> | TimetablePrintConfigCreateInput;
}>;

export type _CreateTimetablePrintConfigsMutation = {
  __typename?: 'Mutation';
  createTimetablePrintConfigs: {
    __typename?: 'CreateTimetablePrintConfigsMutationResponse';
    timetablePrintConfigs: Array<{
      __typename: 'TimetablePrintConfig';
      uuid: string;
      type: TimetableReportType;
      topLeft?: TimetablePrintLayoutOptions | null;
      topCenter?: TimetablePrintLayoutOptions | null;
      topRight?: TimetablePrintLayoutOptions | null;
      center?: TimetablePrintLayoutOptions | null;
      bottomLeft?: TimetablePrintLayoutOptions | null;
      bottomCenter?: TimetablePrintLayoutOptions | null;
      bottomRight?: TimetablePrintLayoutOptions | null;
      printColorOrigin?: TimetablePrintColorOrigins | null;
      printColorPosition?: TimetablePrintColorPositions | null;
      printClasses?: boolean | null;
      scaleText?: boolean | null;
      exactMinute?: boolean | null;
      printSubtitle?: boolean | null;
      printLogo?: boolean | null;
      largeFont?: boolean | null;
      showSchoolWeeks?: boolean | null;
      showCalendarWeeks?: boolean | null;
      showWeekSchoolDays?: boolean | null;
      timeHorizontal?: boolean | null;
    }>;
  };
};

export type _UpdateTimetablePrintConfigsMutationVariables = Exact<{
  where?: InputMaybe<TimetablePrintConfigWhere>;
  update?: InputMaybe<TimetablePrintConfigUpdateInput>;
}>;

export type _UpdateTimetablePrintConfigsMutation = {
  __typename?: 'Mutation';
  updateTimetablePrintConfigs: {
    __typename?: 'UpdateTimetablePrintConfigsMutationResponse';
    timetablePrintConfigs: Array<{
      __typename: 'TimetablePrintConfig';
      uuid: string;
      type: TimetableReportType;
      topLeft?: TimetablePrintLayoutOptions | null;
      topCenter?: TimetablePrintLayoutOptions | null;
      topRight?: TimetablePrintLayoutOptions | null;
      center?: TimetablePrintLayoutOptions | null;
      bottomLeft?: TimetablePrintLayoutOptions | null;
      bottomCenter?: TimetablePrintLayoutOptions | null;
      bottomRight?: TimetablePrintLayoutOptions | null;
      printColorOrigin?: TimetablePrintColorOrigins | null;
      printColorPosition?: TimetablePrintColorPositions | null;
      printClasses?: boolean | null;
      scaleText?: boolean | null;
      exactMinute?: boolean | null;
      printSubtitle?: boolean | null;
      printLogo?: boolean | null;
      largeFont?: boolean | null;
      showSchoolWeeks?: boolean | null;
      showCalendarWeeks?: boolean | null;
      showWeekSchoolDays?: boolean | null;
      timeHorizontal?: boolean | null;
    }>;
  };
};

export type _CreateTeachingBlockAvailabilityExclusionsMutationVariables = Exact<{
  input: Array<TeachingBlockAvailabilityExclusionCreateInput> | TeachingBlockAvailabilityExclusionCreateInput;
}>;

export type _CreateTeachingBlockAvailabilityExclusionsMutation = {
  __typename?: 'Mutation';
  createTeachingBlockAvailabilityExclusions: {
    __typename?: 'CreateTeachingBlockAvailabilityExclusionsMutationResponse';
    teachingBlockAvailabilityExclusions: Array<{
      __typename: 'TeachingBlockAvailabilityExclusion';
      uuid: string;
      from: any;
      to: any;
      priority: number;
      comment?: string | null;
      holder:
        | { __typename: 'Class'; uuid: string }
        | { __typename: 'Person'; uuid: string }
        | { __typename: 'Room'; uuid: string }
        | { __typename: 'Subject'; uuid: string };
      teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
    }>;
  };
};

export type _UpdateTeachingBlockAvailabilityExclusionsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  update?: InputMaybe<TeachingBlockAvailabilityExclusionUpdateInput>;
}>;

export type _UpdateTeachingBlockAvailabilityExclusionsMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockAvailabilityExclusions: {
    __typename?: 'UpdateTeachingBlockAvailabilityExclusionsMutationResponse';
    teachingBlockAvailabilityExclusions: Array<{
      __typename: 'TeachingBlockAvailabilityExclusion';
      uuid: string;
      from: any;
      to: any;
      priority: number;
      comment?: string | null;
      holder:
        | { __typename: 'Class'; uuid: string }
        | { __typename: 'Person'; uuid: string }
        | { __typename: 'Room'; uuid: string }
        | { __typename: 'Subject'; uuid: string };
      teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
    }>;
  };
};

export type _DeleteTeachingBlockAvailabilityExclusionsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionDeleteInput>;
}>;

export type _DeleteTeachingBlockAvailabilityExclusionsMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockAvailabilityExclusions: { __typename: 'DeleteInfo' };
};

export type _CreateTeachingBlockCardsMutationVariables = Exact<{
  input: Array<TeachingBlockCardCreateInput> | TeachingBlockCardCreateInput;
}>;

export type _CreateTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  createTeachingBlockCards: {
    __typename?: 'CreateTeachingBlockCardsMutationResponse';
    teachingBlockCards: Array<{
      __typename: 'TeachingBlockCard';
      uuid: string;
      duration?: number | null;
      startDate?: any | null;
      endDate?: any | null;
      includeHoliday: boolean;
      locked: boolean;
      rooms: Array<{ __typename: 'Room'; uuid: string }>;
      teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
      lessonClasses: Array<{
        __typename: 'LessonClass';
        uuid: string;
        usedDivision?: { __typename: 'Division'; uuid: string } | null;
        groups: Array<{ __typename: 'Group'; uuid: string }>;
        class: { __typename: 'Class'; uuid: string };
      }>;
      teachers: Array<{ __typename: 'Person'; uuid: string }>;
      teachersPresent: Array<{ __typename: 'Person'; uuid: string }>;
      lesson: { __typename: 'Lesson'; uuid: string };
      subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
    }>;
  };
};

export type _DeleteTeachingBlockCardsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockCardWhere>;
  delete?: InputMaybe<TeachingBlockCardDeleteInput>;
}>;

export type _DeleteTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockCards: { __typename: 'DeleteInfo' };
};

export type _UpdateTeachingBlockCardsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockCardWhere>;
  update?: InputMaybe<TeachingBlockCardUpdateInput>;
}>;

export type _UpdateTeachingBlockCardsMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockCards: {
    __typename?: 'UpdateTeachingBlockCardsMutationResponse';
    teachingBlockCards: Array<{
      __typename: 'TeachingBlockCard';
      uuid: string;
      duration?: number | null;
      startDate?: any | null;
      endDate?: any | null;
      includeHoliday: boolean;
      locked: boolean;
      rooms: Array<{ __typename: 'Room'; uuid: string }>;
      teachingBlockVersion: { __typename: 'TeachingBlockVersion'; uuid: string };
      lessonClasses: Array<{
        __typename: 'LessonClass';
        uuid: string;
        usedDivision?: { __typename: 'Division'; uuid: string } | null;
        groups: Array<{ __typename: 'Group'; uuid: string }>;
        class: { __typename: 'Class'; uuid: string };
      }>;
      teachers: Array<{ __typename: 'Person'; uuid: string }>;
      teachersPresent: Array<{ __typename: 'Person'; uuid: string }>;
      lesson: { __typename: 'Lesson'; uuid: string };
      subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
    }>;
  };
};

export type _DeleteTimetableCardsMutationVariables = Exact<{
  where?: InputMaybe<TimetableCardWhere>;
  delete?: InputMaybe<TimetableCardDeleteInput>;
}>;

export type _DeleteTimetableCardsMutation = {
  __typename?: 'Mutation';
  deleteTimetableCards: { __typename: 'DeleteInfo' };
};

export type _CreateTimetableCardsMutationVariables = Exact<{
  input: Array<TimetableCardCreateInput> | TimetableCardCreateInput;
}>;

export type _CreateTimetableCardsMutation = {
  __typename?: 'Mutation';
  createTimetableCards: {
    __typename?: 'CreateTimetableCardsMutationResponse';
    timetableCards: Array<{
      __typename: 'TimetableCard';
      uuid: string;
      duration?: number | null;
      weekday?: string | null;
      locked: boolean;
      startTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string } | null;
      endTimeGridEntry?: { __typename: 'TimeGridEntry'; uuid: string } | null;
      rooms: Array<{ __typename: 'Room'; uuid: string }>;
      lessonClasses: Array<{
        __typename: 'LessonClass';
        uuid: string;
        usedDivision?: { __typename: 'Division'; uuid: string } | null;
        groups: Array<{ __typename: 'Group'; uuid: string }>;
        class: { __typename: 'Class'; uuid: string };
      }>;
      teachers: Array<{ __typename: 'Person'; uuid: string }>;
      lesson: { __typename: 'Lesson'; uuid: string };
      subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
    }>;
  };
};

export type _UpdateLessonsMutationVariables = Exact<{
  where?: InputMaybe<LessonWhere>;
  update?: InputMaybe<LessonUpdateInput>;
}>;

export type _UpdateLessonsMutation = {
  __typename?: 'Mutation';
  updateLessons: {
    __typename?: 'UpdateLessonsMutationResponse';
    lessons: Array<{
      __typename: 'Lesson';
      uuid: string;
      subTitle?: string | null;
      comment?: string | null;
      onlyInTimetableVersion: boolean;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      placedCardsCount?: number | null;
      teachingBlockPlacedCardsCount?: number | null;
      classSort: string;
      groupClassNames: string;
      gradeGroupUuid?: Array<string> | null;
      teachersSort: string;
      subjectName: string;
      createdAt?: any | null;
      updatedAt?: any | null;
      curriculum?: { __typename: 'Curriculum'; uuid: string } | null;
      lessonUnitConnection: {
        __typename?: 'LessonLessonUnitConnection';
        edges: Array<{
          __typename?: 'LessonLessonUnitRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: {
            __typename: 'LessonUnit';
            uuid: string;
            duration?: number | null;
            count?: number | null;
            subjectContainer?: { __typename: 'SubjectContainer'; uuid: string } | null;
          };
        }>;
      };
      lessonClassesConnection: {
        __typename?: 'LessonLessonClassesConnection';
        edges: Array<{
          __typename?: 'LessonLessonClassesRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: {
            __typename: 'LessonClass';
            uuid: string;
            usedDivision?: { __typename: 'Division'; uuid: string } | null;
            groups: Array<{ __typename: 'Group'; uuid: string }>;
            class: { __typename: 'Class'; uuid: string };
          };
        }>;
      };
      teachersConnection: {
        __typename?: 'LessonTeachersConnection';
        edges: Array<{
          __typename?: 'LessonTeachersRelationship';
          properties: {
            __typename?: 'LessonTeacherRelationshipProperties';
            description?: string | null;
            order: number;
            present?: boolean | null;
            teachingLoad?: boolean | null;
            teachingLoadHours?: number | null;
            writesCertificate?: boolean | null;
          };
          node: { __typename: 'Person'; uuid: string };
        }>;
      };
      subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          properties: { __typename?: 'LessonRoomRelationshipProperties'; order: number; descriptions?: string | null };
          node: { __typename: 'Room'; uuid: string };
        }>;
      };
      versions: Array<{ __typename: 'TimetableVersion'; uuid: string }>;
      teachingBlockVersions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string }>;
      activeTimetables?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
      activeTeachingBlocks?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
    }>;
  };
};

export type _DeleteLessonsMutationVariables = Exact<{
  where?: InputMaybe<LessonWhere>;
  delete?: InputMaybe<LessonDeleteInput>;
}>;

export type _DeleteLessonsMutation = { __typename?: 'Mutation'; deleteLessons: { __typename: 'DeleteInfo' } };

export type _CreateLessonsMutationVariables = Exact<{
  input: Array<LessonCreateInput> | LessonCreateInput;
}>;

export type _CreateLessonsMutation = {
  __typename?: 'Mutation';
  createLessons: {
    __typename?: 'CreateLessonsMutationResponse';
    lessons: Array<{
      __typename: 'Lesson';
      uuid: string;
      subTitle?: string | null;
      comment?: string | null;
      onlyInTimetableVersion: boolean;
      elective?: boolean | null;
      isClassTrip?: boolean | null;
      teachingLoadEnabled?: boolean | null;
      timetableEnabled?: boolean | null;
      placedCardsCount?: number | null;
      teachingBlockPlacedCardsCount?: number | null;
      classSort: string;
      groupClassNames: string;
      gradeGroupUuid?: Array<string> | null;
      teachersSort: string;
      subjectName: string;
      createdAt?: any | null;
      updatedAt?: any | null;
      curriculum?: { __typename: 'Curriculum'; uuid: string } | null;
      lessonUnitConnection: {
        __typename?: 'LessonLessonUnitConnection';
        edges: Array<{
          __typename?: 'LessonLessonUnitRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: {
            __typename: 'LessonUnit';
            uuid: string;
            duration?: number | null;
            count?: number | null;
            subjectContainer?: { __typename: 'SubjectContainer'; uuid: string } | null;
          };
        }>;
      };
      lessonClassesConnection: {
        __typename?: 'LessonLessonClassesConnection';
        edges: Array<{
          __typename?: 'LessonLessonClassesRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: {
            __typename: 'LessonClass';
            uuid: string;
            usedDivision?: { __typename: 'Division'; uuid: string } | null;
            groups: Array<{ __typename: 'Group'; uuid: string }>;
            class: { __typename: 'Class'; uuid: string };
          };
        }>;
      };
      teachersConnection: {
        __typename?: 'LessonTeachersConnection';
        edges: Array<{
          __typename?: 'LessonTeachersRelationship';
          properties: {
            __typename?: 'LessonTeacherRelationshipProperties';
            description?: string | null;
            order: number;
            present?: boolean | null;
            teachingLoad?: boolean | null;
            teachingLoadHours?: number | null;
            writesCertificate?: boolean | null;
          };
          node: { __typename: 'Person'; uuid: string };
        }>;
      };
      subject: { __typename: 'Subject'; uuid: string } | { __typename: 'SubjectContainer'; uuid: string };
      roomSupplyConnection: {
        __typename?: 'LessonRoomSupplyConnection';
        edges: Array<{
          __typename?: 'LessonRoomSupplyRelationship';
          properties: { __typename?: 'LessonRoomRelationshipProperties'; order: number; descriptions?: string | null };
          node: { __typename: 'Room'; uuid: string };
        }>;
      };
      versions: Array<{ __typename: 'TimetableVersion'; uuid: string }>;
      teachingBlockVersions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string }>;
      activeTimetables?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
      activeTeachingBlocks?: Array<{ __typename: 'Timetable'; uuid: string }> | null;
    }>;
  };
};

export type _UpdateTeachingBlockVersionsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockVersionWhere>;
  update?: InputMaybe<TeachingBlockVersionUpdateInput>;
}>;

export type _UpdateTeachingBlockVersionsMutation = {
  __typename?: 'Mutation';
  updateTeachingBlockVersions: {
    __typename?: 'UpdateTeachingBlockVersionsMutationResponse';
    teachingBlockVersions: Array<{
      __typename: 'TeachingBlockVersion';
      uuid: string;
      active?: boolean | null;
      version: number;
      availabilityExclusions: Array<{ __typename: 'TeachingBlockAvailabilityExclusion'; uuid: string }>;
      teachingBlock: { __typename: 'TeachingBlock'; uuid: string; name: string };
      subjectsConnection: {
        __typename: 'TeachingBlockVersionSubjectsConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionSubjectsRelationship';
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
          node: { __typename: 'Subject'; uuid: string };
        }>;
      };
      classesConnection: {
        __typename: 'TeachingBlockVersionClassesConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionClassesRelationship';
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
          node: { __typename: 'Class'; uuid: string };
        }>;
      };
      roomsConnection: {
        __typename: 'TeachingBlockVersionRoomsConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionRoomsRelationship';
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
          node: { __typename: 'Room'; uuid: string };
        }>;
      };
      teachersConnection: {
        __typename: 'TeachingBlockVersionTeachersConnection';
        edges: Array<{
          __typename?: 'TeachingBlockVersionTeachersRelationship';
          properties: { __typename?: 'TeachingBlockRelationshipProperties'; constraints?: string | null };
          node: { __typename: 'Person'; uuid: string };
        }>;
      };
    }>;
  };
};

export type _DeleteTeachingBlockVersionsMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockVersionWhere>;
  delete?: InputMaybe<TeachingBlockVersionDeleteInput>;
}>;

export type _DeleteTeachingBlockVersionsMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockVersions: { __typename: 'DeleteInfo' };
};

export type _DeleteTeachingBlockAvailabilityExclusionMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockAvailabilityExclusionWhere>;
  delete?: InputMaybe<TeachingBlockAvailabilityExclusionDeleteInput>;
}>;

export type _DeleteTeachingBlockAvailabilityExclusionMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlockAvailabilityExclusions: { __typename: 'DeleteInfo' };
};

export type _UpdateTeachingBlocksMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockWhere>;
  update?: InputMaybe<TeachingBlockUpdateInput>;
}>;

export type _UpdateTeachingBlocksMutation = {
  __typename?: 'Mutation';
  updateTeachingBlocks: {
    __typename?: 'UpdateTeachingBlocksMutationResponse';
    teachingBlocks: Array<{
      __typename: 'TeachingBlock';
      uuid: string;
      name: string;
      createdAt?: any | null;
      updatedAt: any;
      draft: boolean;
      comment?: string | null;
      schoolYear: { __typename: 'SchoolYear'; uuid: string };
      versions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string; active?: boolean | null }>;
      subjectContainer: { __typename: 'SubjectContainer'; uuid: string };
    }>;
  };
};

export type _CreateTeachingBlocksMutationVariables = Exact<{
  input: Array<TeachingBlockCreateInput> | TeachingBlockCreateInput;
}>;

export type _CreateTeachingBlocksMutation = {
  __typename?: 'Mutation';
  createTeachingBlocks: {
    __typename?: 'CreateTeachingBlocksMutationResponse';
    teachingBlocks: Array<{
      __typename: 'TeachingBlock';
      uuid: string;
      name: string;
      createdAt?: any | null;
      updatedAt: any;
      draft: boolean;
      comment?: string | null;
      schoolYear: { __typename: 'SchoolYear'; uuid: string };
      versions: Array<{ __typename: 'TeachingBlockVersion'; uuid: string; active?: boolean | null }>;
      subjectContainer: { __typename: 'SubjectContainer'; uuid: string };
    }>;
  };
};

export type _DeleteTeachingBlocksMutationVariables = Exact<{
  where?: InputMaybe<TeachingBlockWhere>;
  delete?: InputMaybe<TeachingBlockDeleteInput>;
}>;

export type _DeleteTeachingBlocksMutation = {
  __typename?: 'Mutation';
  deleteTeachingBlocks: { __typename: 'DeleteInfo' };
};

export type _CreateSubjectContainersMutationVariables = Exact<{
  input: Array<SubjectContainerCreateInput> | SubjectContainerCreateInput;
}>;

export type _CreateSubjectContainersMutation = {
  __typename?: 'Mutation';
  createSubjectContainers: {
    __typename?: 'CreateSubjectContainersMutationResponse';
    subjectContainers: Array<{
      __typename: 'SubjectContainer';
      uuid: string;
      name: string;
      shortName: string;
      grades: Array<number>;
      createdAt?: any | null;
      updatedAt?: any | null;
      validFrom?: { __typename: 'SchoolYear'; uuid: string } | null;
      validUntil?: { __typename: 'SchoolYear'; uuid: string } | null;
      gradeGroup: Array<{ __typename: 'GradeGroup'; uuid: string }>;
      timetableConfig?: { __typename: 'TimetableConfig'; uuid: string; color?: string | null } | null;
    }>;
  };
};

export type _UpdateTimetableVersionsMutationVariables = Exact<{
  where?: InputMaybe<TimetableVersionWhere>;
  update?: InputMaybe<TimetableVersionUpdateInput>;
}>;

export type _UpdateTimetableVersionsMutation = {
  __typename?: 'Mutation';
  updateTimetableVersions: {
    __typename?: 'UpdateTimetableVersionsMutationResponse';
    timetableVersions: Array<{
      __typename: 'TimetableVersion';
      uuid: string;
      version: number;
      active?: boolean | null;
      editable?: boolean | null;
      description?: string | null;
      placedCardsCount?: number | null;
      generating?: boolean | null;
      isSnapshot?: boolean | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      original?: { __typename?: 'TimetableVersion'; uuid: string } | null;
      timetable: { __typename: 'Timetable'; uuid: string; name: string };
      subjectsConnection: {
        __typename: 'TimetableVersionSubjectsConnection';
        edges: Array<{
          __typename?: 'TimetableVersionSubjectsRelationship';
          properties: {
            __typename?: 'TimetableRelationshipProperties';
            mon?: string | null;
            tue?: string | null;
            wed?: string | null;
            thu?: string | null;
            fri?: string | null;
            sat?: string | null;
            sun?: string | null;
          };
          node: { __typename: 'Subject'; uuid: string };
        }>;
      };
      classesConnection: {
        __typename: 'TimetableVersionClassesConnection';
        edges: Array<{
          __typename?: 'TimetableVersionClassesRelationship';
          properties: {
            __typename?: 'TimetableRelationshipProperties';
            mon?: string | null;
            tue?: string | null;
            wed?: string | null;
            thu?: string | null;
            fri?: string | null;
            sat?: string | null;
            sun?: string | null;
          };
          node: { __typename: 'Class'; uuid: string };
        }>;
      };
      roomsConnection: {
        __typename: 'TimetableVersionRoomsConnection';
        edges: Array<{
          __typename?: 'TimetableVersionRoomsRelationship';
          properties: {
            __typename?: 'TimetableRelationshipProperties';
            mon?: string | null;
            tue?: string | null;
            wed?: string | null;
            thu?: string | null;
            fri?: string | null;
            sat?: string | null;
            sun?: string | null;
          };
          node: { __typename: 'Room'; uuid: string };
        }>;
      };
      teachersConnection: {
        __typename: 'TimetableVersionTeachersConnection';
        edges: Array<{
          __typename?: 'TimetableVersionTeachersRelationship';
          properties: {
            __typename?: 'TimetableRelationshipProperties';
            mon?: string | null;
            tue?: string | null;
            wed?: string | null;
            thu?: string | null;
            fri?: string | null;
            sat?: string | null;
            sun?: string | null;
          };
          node: { __typename: 'Person'; uuid: string };
        }>;
      };
      dependencies: Array<{ __typename: 'Dependency'; uuid: string }>;
      locked?: { __typename: 'Locked'; duration?: number | null; lockedSince: any; lockedBy: string } | null;
    }>;
  };
};

export type _DeleteTimetableVersionsMutationVariables = Exact<{
  where?: InputMaybe<TimetableVersionWhere>;
  delete: TimetableVersionDeleteInput;
}>;

export type _DeleteTimetableVersionsMutation = {
  __typename?: 'Mutation';
  deleteTimetableVersions: { __typename: 'DeleteInfo' };
};

export type _DeleteTimetablesMutationVariables = Exact<{
  where?: InputMaybe<TimetableWhere>;
  delete?: InputMaybe<TimetableDeleteInput>;
}>;

export type _DeleteTimetablesMutation = { __typename?: 'Mutation'; deleteTimetables: { __typename: 'DeleteInfo' } };

export type GradeGroupFragment = {
  __typename?: 'GradeGroup';
  uuid: string;
  name: string;
  shortName: string;
  description?: string | null;
  class: Array<{ __typename?: 'Class'; uuid: string }>;
};

export type UserConfigFragmentFragment = {
  __typename?: 'UserConfig';
  pimProfileUuid: string;
  schoolYear?: {
    __typename?: 'SchoolYear';
    uuid: string;
    name: string;
    shortName: string;
    start: any;
    end: any;
    fullTimeHours?: number | null;
  } | null;
  tableConfigs: Array<{
    __typename?: 'TableConfig';
    table: string;
    hiddenColumns: Array<string>;
    columnsSortConnection: {
      __typename?: 'TableConfigColumnsSortConnection';
      edges: Array<{
        __typename?: 'TableConfigColumnsSortRelationship';
        node: { __typename?: 'ColumnSort'; id: string; desc: boolean };
      }>;
    };
  }>;
};

export type LessonClassFragmentFragment = {
  __typename?: 'LessonClass';
  uuid: string;
  class: {
    __typename?: 'Class';
    uuid: string;
    name: string;
    shortName: string;
    grade?: number | null;
    defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
    gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
    divisions: Array<{ __typename?: 'Division'; uuid: string; groups: Array<{ __typename?: 'Group'; uuid: string }> }>;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
  };
  groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
  groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
  usedDivision?: {
    __typename?: 'Division';
    uuid: string;
    name: string;
    groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
    groupsConnection: {
      __typename?: 'DivisionGroupsConnection';
      edges: Array<{
        __typename?: 'DivisionGroupsRelationship';
        properties: { __typename?: 'OrderedRelationProperties'; order: number };
        node: { __typename?: 'Group'; uuid: string; name: string };
      }>;
    };
  } | null;
};

export type LessonClassInterfaceFragmentFragment = {
  __typename?: 'LessonClassInterface';
  class: {
    __typename?: 'ClassInterface';
    uuid: string;
    name: string;
    shortName: string;
    grade?: number | null;
    gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
  };
  groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
};

export type LessonFragmentFragment = {
  __typename?: 'Lesson';
  uuid: string;
  groupClassNames: string;
  gradeGroupUuid?: Array<string> | null;
  onlyInTimetableVersion: boolean;
  classSort: string;
  teachersSort: string;
  placedCardsCount?: number | null;
  teachingBlockPlacedCardsCount?: number | null;
  subTitle?: string | null;
  comment?: string | null;
  elective?: boolean | null;
  isClassTrip?: boolean | null;
  teachingLoadEnabled?: boolean | null;
  timetableEnabled?: boolean | null;
  curriculum?: {
    __typename?: 'Curriculum';
    uuid: string;
    personsConnection: {
      __typename?: 'CurriculumPersonsConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'CurriculumPersonsRelationship';
        properties: {
          __typename?: 'CurriculumPersonRelationshipProperties';
          description?: string | null;
          order: number;
          present?: boolean | null;
          teachingLoad?: boolean | null;
        };
        node: { __typename?: 'CurriculumPerson'; uuid: string };
      }>;
    };
  } | null;
  schoolYear: { __typename?: 'SchoolYear'; uuid: string };
  subject:
    | {
        __typename: 'Subject';
        uuid: string;
        name: string;
        shortName: string;
        epochEnabled?: boolean | null;
        subjectHourEnabled?: boolean | null;
        active?: boolean | null;
        defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      }
    | { __typename: 'SubjectContainer'; uuid: string; name: string; shortName: string };
  versions: Array<{
    __typename?: 'TimetableVersion';
    uuid: string;
    active?: boolean | null;
    editable?: boolean | null;
    version: number;
    timetable: { __typename?: 'Timetable'; uuid: string; name: string };
  }>;
  teachingBlockVersions: Array<{
    __typename?: 'TeachingBlockVersion';
    uuid: string;
    active?: boolean | null;
    version: number;
    teachingBlock: { __typename?: 'TeachingBlock'; uuid: string; name: string };
  }>;
  activeTeachingBlocks?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
  activeTimetables?: Array<{ __typename?: 'Timetable'; uuid: string }> | null;
  lessonClassesConnection: {
    __typename?: 'LessonLessonClassesConnection';
    edges: Array<{
      __typename?: 'LessonLessonClassesRelationship';
      node: {
        __typename?: 'LessonClass';
        uuid: string;
        class: {
          __typename?: 'Class';
          uuid: string;
          name: string;
          shortName: string;
          grade?: number | null;
          defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
          gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
          divisions: Array<{
            __typename?: 'Division';
            uuid: string;
            groups: Array<{ __typename?: 'Group'; uuid: string }>;
          }>;
          timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
        };
        groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
        groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
        usedDivision?: {
          __typename?: 'Division';
          uuid: string;
          name: string;
          groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
          groupsConnection: {
            __typename?: 'DivisionGroupsConnection';
            edges: Array<{
              __typename?: 'DivisionGroupsRelationship';
              properties: { __typename?: 'OrderedRelationProperties'; order: number };
              node: { __typename?: 'Group'; uuid: string; name: string };
            }>;
          };
        } | null;
      };
    }>;
  };
  lessonUnitConnection: {
    __typename?: 'LessonLessonUnitConnection';
    edges: Array<{
      __typename?: 'LessonLessonUnitRelationship';
      node: {
        __typename?: 'LessonUnit';
        uuid: string;
        duration?: number | null;
        count?: number | null;
        subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
      };
    }>;
  };
  teachersConnection: {
    __typename?: 'LessonTeachersConnection';
    edges: Array<{
      __typename?: 'LessonTeachersRelationship';
      properties: {
        __typename?: 'LessonTeacherRelationshipProperties';
        description?: string | null;
        present?: boolean | null;
        teachingLoad?: boolean | null;
        teachingLoadHours?: number | null;
        writesCertificate?: boolean | null;
      };
      node: {
        __typename?: 'Person';
        uuid: string;
        shortName: string;
        fullName: string;
        firstName: string;
        lastName: string;
        displayNameShort?: string | null;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      };
    }>;
  };
  roomSupplyConnection: {
    __typename?: 'LessonRoomSupplyConnection';
    edges: Array<{
      __typename?: 'LessonRoomSupplyRelationship';
      properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
      node: { __typename?: 'Room'; uuid: string; name: string };
    }>;
  };
};

export type SubjectContainerFragment = {
  __typename?: 'SubjectContainer';
  uuid: string;
  name: string;
  shortName: string;
  order?: number | null;
  grades: Array<number>;
  createdAt?: any | null;
  updatedAt?: any | null;
};

export type SubjectFragment = {
  __typename?: 'Subject';
  uuid: string;
  name: string;
  shortName: string;
  epochEnabled?: boolean | null;
  subjectHourEnabled?: boolean | null;
  active?: boolean | null;
  other?: boolean | null;
  createdAt?: any | null;
  updatedAt?: any | null;
};

export type CurriculumFragment = {
  __typename?: 'Curriculum';
  comment?: string | null;
  createdAt?: any | null;
  displayName: Array<string>;
  elective?: boolean | null;
  isClassTrip?: boolean | null;
  subTitle?: string | null;
  uuid: string;
  timetableEnabled?: boolean | null;
  teachingLoadEnabled?: boolean | null;
  groupGradeNames: Array<string>;
  lessons: Array<{
    __typename?: 'Lesson';
    uuid: string;
    lessonClassesAggregate?: {
      __typename?: 'LessonLessonClassLessonClassesAggregationSelection';
      count: number;
    } | null;
    schoolYear: { __typename?: 'SchoolYear'; uuid: string };
  }>;
  subject:
    | {
        __typename?: 'Subject';
        uuid: string;
        name: string;
        shortName: string;
        epochEnabled?: boolean | null;
        subjectHourEnabled?: boolean | null;
        active?: boolean | null;
        other?: boolean | null;
        createdAt?: any | null;
        updatedAt?: any | null;
      }
    | {
        __typename?: 'SubjectContainer';
        uuid: string;
        name: string;
        shortName: string;
        order?: number | null;
        grades: Array<number>;
        createdAt?: any | null;
        updatedAt?: any | null;
      };
  curriculumUnit: Array<{
    __typename?: 'CurriculumUnit';
    uuid: string;
    duration?: number | null;
    count?: number | null;
    subjectContainer?: {
      __typename?: 'SubjectContainer';
      uuid: string;
      name: string;
      shortName: string;
      order?: number | null;
      grades: Array<number>;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null;
  }>;
  curriculumUnitConnection: {
    __typename?: 'CurriculumCurriculumUnitConnection';
    edges: Array<{
      __typename?: 'CurriculumCurriculumUnitRelationship';
      node: {
        __typename?: 'CurriculumUnit';
        uuid: string;
        subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string } | null;
      };
    }>;
  };
  curriculumGrades: Array<{
    __typename?: 'CurriculumClass';
    uuid: string;
    grades: Array<number>;
    gradeGroups: Array<{
      __typename?: 'GradeGroup';
      uuid: string;
      name: string;
      shortName: string;
      description?: string | null;
      class: Array<{ __typename?: 'Class'; uuid: string }>;
    }>;
    groups: Array<{ __typename?: 'Group'; uuid: string; name: string; classFraction: number }>;
    lessonClasses: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        name: string;
        shortName: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string; shortName: string } | null;
      };
      groups: Array<{
        __typename?: 'Group';
        uuid: string;
        name: string;
        shortName: string;
        classFraction: number;
        division?: {
          __typename?: 'Division';
          uuid: string;
          name: string;
          groups: Array<{ __typename?: 'Group'; uuid: string; name: string; shortName: string }>;
        } | null;
      }>;
    }>;
  }>;
  roomSupply: Array<{ __typename?: 'Room'; uuid: string; roomNumber?: string | null; description?: string | null }>;
  roomSupplyConnection: {
    __typename?: 'CurriculumRoomSupplyConnection';
    edges: Array<{
      __typename?: 'CurriculumRoomSupplyRelationship';
      node: { __typename?: 'Room'; uuid: string };
      properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
    }>;
  };
  persons: Array<{ __typename?: 'CurriculumPerson'; name?: string | null; uuid: string }>;
  personsConnection: {
    __typename?: 'CurriculumPersonsConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'CurriculumPersonsRelationship';
      node: { __typename?: 'CurriculumPerson'; uuid: string; name?: string | null };
      properties: {
        __typename?: 'CurriculumPersonRelationshipProperties';
        description?: string | null;
        order: number;
        present?: boolean | null;
        teachingLoad?: boolean | null;
      };
    }>;
  };
  labels: Array<{ __typename?: 'Label'; uuid: string; color?: string | null; name: string }>;
  lessonBlueprints: Array<{
    __typename?: 'LessonInterface';
    uuid: string;
    foreignId?: string | null;
    subTitle?: string | null;
    comment?: string | null;
    displayName: Array<string>;
    teachingLoadEnabled?: boolean | null;
    timetableEnabled?: boolean | null;
    elective?: boolean | null;
    onlyInTimetableVersion: boolean;
    lessonClasses: Array<{
      __typename?: 'LessonClassInterface';
      class: {
        __typename?: 'ClassInterface';
        uuid: string;
        name: string;
        shortName: string;
        grade?: number | null;
        gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
      };
      groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
    }>;
    teachers: Array<{
      __typename?: 'Person';
      uuid: string;
      pimProfileUuid?: string | null;
      displayNameShort?: string | null;
      timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
    }>;
    lessonUnit: Array<{
      __typename?: 'LessonUnit';
      uuid: string;
      duration?: number | null;
      count?: number | null;
      subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string; name: string; shortName: string } | null;
    }>;
    roomSupply: Array<{ __typename?: 'Room'; uuid: string; roomNumber?: string | null; description?: string | null }>;
  }>;
};

export type CardsFragment = {
  __typename?: 'TimetableCard';
  uuid: string;
  weekday?: string | null;
  duration?: number | null;
  locked: boolean;
  timetableVersion: {
    __typename?: 'TimetableVersion';
    version: number;
    uuid: string;
    timetable: { __typename?: 'Timetable'; name: string };
  };
  rooms: Array<{ __typename?: 'Room'; name: string; uuid: string }>;
  teachers: Array<{
    __typename?: 'Person';
    uuid: string;
    pimProfileUuid?: string | null;
    displayNameShort?: string | null;
    defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
  }>;
  lesson: {
    __typename?: 'Lesson';
    uuid: string;
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        node: {
          __typename?: 'Room';
          uuid: string;
          name: string;
          building?: { __typename?: 'Building'; name: string } | null;
        };
      }>;
    };
  };
  subject:
    | {
        __typename?: 'Subject';
        uuid: string;
        name: string;
        shortName: string;
        defaultRooms: Array<{ __typename?: 'Room'; uuid: string; name: string }>;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      }
    | {
        __typename?: 'SubjectContainer';
        uuid: string;
        name: string;
        shortName: string;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      };
  lessonClasses: Array<{
    __typename?: 'LessonClass';
    uuid: string;
    class: {
      __typename?: 'Class';
      uuid: string;
      name: string;
      shortName: string;
      grade?: number | null;
      defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
      gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
      divisions: Array<{
        __typename?: 'Division';
        uuid: string;
        groups: Array<{ __typename?: 'Group'; uuid: string }>;
      }>;
      timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
    };
    groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
    groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
    usedDivision?: {
      __typename?: 'Division';
      uuid: string;
      name: string;
      groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
      groupsConnection: {
        __typename?: 'DivisionGroupsConnection';
        edges: Array<{
          __typename?: 'DivisionGroupsRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: { __typename?: 'Group'; uuid: string; name: string };
        }>;
      };
    } | null;
  }>;
  subjectContainer?: {
    __typename?: 'SubjectContainer';
    uuid: string;
    name: string;
    shortName: string;
    order?: number | null;
    lessons: Array<{ __typename?: 'Lesson'; uuid: string }>;
  } | null;
  startTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
  endTimeGridEntry?: { __typename?: 'TimeGridEntry'; uuid: string; name: string } | null;
};

export type TeachingBlockCardsFragment = {
  __typename?: 'TeachingBlockCard';
  uuid: string;
  duration?: number | null;
  startDate?: any | null;
  includeHoliday: boolean;
  endDate?: any | null;
  locked: boolean;
  rooms: Array<{ __typename?: 'Room'; name: string; uuid: string }>;
  teachingBlockVersion: { __typename?: 'TeachingBlockVersion'; version: number };
  teachers: Array<{
    __typename?: 'Person';
    uuid: string;
    pimProfileUuid?: string | null;
    displayNameShort?: string | null;
    timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
  }>;
  lesson: {
    __typename?: 'Lesson';
    uuid: string;
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        node: {
          __typename?: 'Room';
          uuid: string;
          name: string;
          building?: { __typename?: 'Building'; name: string } | null;
        };
      }>;
    };
  };
  subject:
    | {
        __typename?: 'Subject';
        uuid: string;
        name: string;
        shortName: string;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      }
    | {
        __typename?: 'SubjectContainer';
        uuid: string;
        name: string;
        shortName: string;
        timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
      };
  lessonClasses: Array<{
    __typename?: 'LessonClass';
    uuid: string;
    class: {
      __typename?: 'Class';
      uuid: string;
      name: string;
      shortName: string;
      grade?: number | null;
      defaultRoom?: { __typename?: 'Room'; uuid: string; name: string } | null;
      gradeGroup?: { __typename?: 'GradeGroup'; uuid: string; name: string } | null;
      divisions: Array<{
        __typename?: 'Division';
        uuid: string;
        groups: Array<{ __typename?: 'Group'; uuid: string }>;
      }>;
      timetableConfig?: { __typename?: 'TimetableConfig'; color?: string | null } | null;
    };
    groupsAggregate?: { __typename?: 'LessonClassGroupGroupsAggregationSelection'; count: number } | null;
    groups: Array<{ __typename?: 'Group'; uuid: string; shortName: string; name: string; classFraction: number }>;
    usedDivision?: {
      __typename?: 'Division';
      uuid: string;
      name: string;
      groupsAggregate?: { __typename?: 'DivisionGroupGroupsAggregationSelection'; count: number } | null;
      groupsConnection: {
        __typename?: 'DivisionGroupsConnection';
        edges: Array<{
          __typename?: 'DivisionGroupsRelationship';
          properties: { __typename?: 'OrderedRelationProperties'; order: number };
          node: { __typename?: 'Group'; uuid: string; name: string };
        }>;
      };
    } | null;
  }>;
};

export type UsedInLessonQueryVariables = Exact<{
  lessonWhere?: InputMaybe<LessonWhere>;
}>;

export type UsedInLessonQuery = {
  __typename?: 'Query';
  lessons: Array<{
    __typename?: 'Lesson';
    onlyInTimetableVersion: boolean;
    uuid: string;
    subject:
      | { __typename?: 'Subject'; uuid: string; name: string }
      | { __typename?: 'SubjectContainer'; uuid: string; name: string };
    versions: Array<{
      __typename?: 'TimetableVersion';
      uuid: string;
      version: number;
      timetable: { __typename?: 'Timetable'; uuid: string; name: string };
    }>;
    lessonUnitConnection: {
      __typename?: 'LessonLessonUnitConnection';
      edges: Array<{
        __typename?: 'LessonLessonUnitRelationship';
        node: {
          __typename?: 'LessonUnit';
          uuid: string;
          subjectContainer?: { __typename?: 'SubjectContainer'; uuid: string } | null;
        };
      }>;
    };
    lessonClassesConnection: {
      __typename?: 'LessonLessonClassesConnection';
      edges: Array<{
        __typename?: 'LessonLessonClassesRelationship';
        node: {
          __typename?: 'LessonClass';
          class: { __typename?: 'Class'; uuid: string; shortName: string };
          usedDivision?: { __typename?: 'Division'; uuid: string } | null;
          groups: Array<{ __typename?: 'Group'; uuid: string }>;
        };
      }>;
    };
    teachersConnection: {
      __typename?: 'LessonTeachersConnection';
      edges: Array<{ __typename?: 'LessonTeachersRelationship'; node: { __typename?: 'Person'; uuid: string } }>;
    };
    roomSupplyConnection: {
      __typename?: 'LessonRoomSupplyConnection';
      edges: Array<{
        __typename?: 'LessonRoomSupplyRelationship';
        properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
        node: { __typename?: 'Room'; uuid: string; name: string };
      }>;
    };
  }>;
};

export type UsedInCurriculaQueryVariables = Exact<{
  curriculaWhere?: InputMaybe<CurriculumWhere>;
}>;

export type UsedInCurriculaQuery = {
  __typename?: 'Query';
  curricula: Array<{
    __typename?: 'Curriculum';
    uuid: string;
    subject:
      | { __typename?: 'Subject'; uuid: string; name: string }
      | { __typename?: 'SubjectContainer'; uuid: string; name: string };
    roomSupplyConnection: {
      __typename?: 'CurriculumRoomSupplyConnection';
      edges: Array<{
        __typename?: 'CurriculumRoomSupplyRelationship';
        properties: { __typename?: 'LessonRoomRelationshipProperties'; descriptions?: string | null };
        node: { __typename?: 'Room'; uuid: string; name: string };
      }>;
    };
  }>;
};

export type EventJobsQueryVariables = Exact<{
  where?: InputMaybe<EventJobWhere>;
  options?: InputMaybe<EventJobOptions>;
}>;

export type EventJobsQuery = {
  __typename?: 'Query';
  eventJobs: Array<{
    __typename?: 'EventJob';
    uuid: string;
    organizationUuid: string;
    to: any;
    from: any;
    processed?: number | null;
    status: EventJobStatus;
    createdAt?: any | null;
  }>;
};

export type CountOrganisationEventsForRangeQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;

export type CountOrganisationEventsForRangeQuery = {
  __typename?: 'Query';
  eventsConnection: { __typename?: 'EventsConnection'; totalCount: number };
};

export type DeleteLessonClassesMutationVariables = Exact<{
  where?: InputMaybe<LessonClassWhere>;
  delete?: InputMaybe<LessonClassDeleteInput>;
}>;

export type DeleteLessonClassesMutation = {
  __typename?: 'Mutation';
  deleteLessonClasses: { __typename: 'DeleteInfo' };
};

export type DeleteAdditionalTeachingLoadsMutationVariables = Exact<{
  uuid: Scalars['ID']['input'];
}>;

export type DeleteAdditionalTeachingLoadsMutation = {
  __typename?: 'Mutation';
  deleteAdditionalTeachingLoads: { __typename?: 'DeleteInfo'; relationshipsDeleted: number; nodesDeleted: number };
};

export type CreateAdditionalTeachingLoadsMutationVariables = Exact<{
  input: Array<AdditionalTeachingLoadCreateInput> | AdditionalTeachingLoadCreateInput;
}>;

export type CreateAdditionalTeachingLoadsMutation = {
  __typename?: 'Mutation';
  createAdditionalTeachingLoads: {
    __typename?: 'CreateAdditionalTeachingLoadsMutationResponse';
    info: { __typename?: 'CreateInfo'; nodesCreated: number; relationshipsCreated: number };
  };
};

export type UpdateAdditionalTeachingLoadMutationVariables = Exact<{
  update: AdditionalTeachingLoadUpdateInput;
  uuid: Scalars['ID']['input'];
}>;

export type UpdateAdditionalTeachingLoadMutation = {
  __typename?: 'Mutation';
  updateAdditionalTeachingLoads: {
    __typename?: 'UpdateAdditionalTeachingLoadsMutationResponse';
    info: { __typename?: 'UpdateInfo'; nodesCreated: number; relationshipsCreated: number; nodesDeleted: number };
  };
};

export type AdditionalTeachingLoadsListQueryVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  schoolyear: Scalars['ID']['input'];
  teacherUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AdditionalTeachingLoadsListQuery = {
  __typename?: 'Query';
  additionalTeachingLoads: Array<{
    __typename?: 'AdditionalTeachingLoad';
    uuid: string;
    comment?: string | null;
    hours: number;
    hoursRaw?: string | null;
    teacherListName?: string | null;
    class?: { __typename?: 'Class'; uuid: string; name: string } | null;
    teacher: { __typename?: 'Person'; uuid: string; listName: string };
    subject?: { __typename?: 'Subject'; uuid: string; name: string } | null;
  }>;
};

export type ConnectEntityWithVersionMutationVariables = Exact<{
  organizationUuid: Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
}>;

export type ConnectEntityWithVersionMutation = {
  __typename?: 'Mutation';
  connectEntityWithVersion?: { __typename?: 'EntitiesUpdateInfo'; entitiesUpdated: number } | null;
};

export type CreateUserConfigMutationVariables = Exact<{
  pimProfileUuid: Scalars['ID']['input'];
}>;

export type CreateUserConfigMutation = {
  __typename?: 'Mutation';
  createUserConfigs: {
    __typename?: 'CreateUserConfigsMutationResponse';
    userConfigs: Array<{
      __typename?: 'UserConfig';
      pimProfileUuid: string;
      schoolYear?: {
        __typename?: 'SchoolYear';
        uuid: string;
        name: string;
        shortName: string;
        start: any;
        end: any;
        fullTimeHours?: number | null;
      } | null;
      tableConfigs: Array<{
        __typename?: 'TableConfig';
        table: string;
        hiddenColumns: Array<string>;
        columnsSortConnection: {
          __typename?: 'TableConfigColumnsSortConnection';
          edges: Array<{
            __typename?: 'TableConfigColumnsSortRelationship';
            node: { __typename?: 'ColumnSort'; id: string; desc: boolean };
          }>;
        };
      }>;
    }>;
  };
};

export type UpdateUserConfigSchoolYearMutationVariables = Exact<{
  schoolYearUuid: Scalars['ID']['input'];
  pimProfileUuid: Scalars['ID']['input'];
}>;

export type UpdateUserConfigSchoolYearMutation = {
  __typename?: 'Mutation';
  updateUserConfigs: {
    __typename?: 'UpdateUserConfigsMutationResponse';
    info: { __typename?: 'UpdateInfo'; relationshipsCreated: number };
  };
};

export type UpdateUserConfigMutationVariables = Exact<{
  pimProfileUuid: Scalars['ID']['input'];
  update?: InputMaybe<UserConfigUpdateInput>;
}>;

export type UpdateUserConfigMutation = {
  __typename?: 'Mutation';
  updateUserConfigs: {
    __typename?: 'UpdateUserConfigsMutationResponse';
    userConfigs: Array<{
      __typename?: 'UserConfig';
      pimProfileUuid: string;
      schoolYear?: {
        __typename?: 'SchoolYear';
        uuid: string;
        name: string;
        shortName: string;
        start: any;
        end: any;
        fullTimeHours?: number | null;
      } | null;
      tableConfigs: Array<{
        __typename?: 'TableConfig';
        table: string;
        hiddenColumns: Array<string>;
        columnsSortConnection: {
          __typename?: 'TableConfigColumnsSortConnection';
          edges: Array<{
            __typename?: 'TableConfigColumnsSortRelationship';
            node: { __typename?: 'ColumnSort'; id: string; desc: boolean };
          }>;
        };
      }>;
    }>;
  };
};

export type ClassGridCardsQueryVariables = Exact<{
  where?: InputMaybe<TimetableCardWhere>;
}>;

export type ClassGridCardsQuery = {
  __typename?: 'Query';
  classGridCards: Array<{
    __typename?: 'ClassGridCard';
    uuid: string;
    timetableCardUuid: string;
    classUuid: string;
    lessonUuid: string;
    divisionsCount?: number | null;
    colors: Array<string>;
    locked?: boolean | null;
    duration?: number | null;
    endTimeGridEntryUuid?: string | null;
    startTimeGridEntryUuid?: string | null;
    weekday?: string | null;
    cssHeight?: string | null;
    cssGradientString?: string | null;
    usedPosition: number;
    cssTop?: string | null;
    textColor?: string | null;
  }>;
};

export type TimetableCardAvailabilitiesQueryVariables = Exact<{
  timetableCardUuids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  versionUuid: Scalars['ID']['input'];
}>;

export type TimetableCardAvailabilitiesQuery = {
  __typename?: 'Query';
  timetableCardAvailabilities: Array<{
    __typename?: 'TimetableCardAvailability';
    mon?: string | null;
    tue?: string | null;
    wed?: string | null;
    thu?: string | null;
    fri?: string | null;
    sat?: string | null;
    sun?: string | null;
    timetableCardUuid: string;
  }>;
};

export type GetUserConfigsQueryVariables = Exact<{
  pimProfileUuid?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetUserConfigsQuery = {
  __typename?: 'Query';
  userConfigs: Array<{
    __typename?: 'UserConfig';
    pimProfileUuid: string;
    schoolYear?: {
      __typename?: 'SchoolYear';
      uuid: string;
      name: string;
      shortName: string;
      start: any;
      end: any;
      fullTimeHours?: number | null;
    } | null;
    tableConfigs: Array<{
      __typename?: 'TableConfig';
      table: string;
      hiddenColumns: Array<string>;
      columnsSortConnection: {
        __typename?: 'TableConfigColumnsSortConnection';
        edges: Array<{
          __typename?: 'TableConfigColumnsSortRelationship';
          node: { __typename?: 'ColumnSort'; id: string; desc: boolean };
        }>;
      };
    }>;
  }>;
};

export const SubjectFragmentFragmentDoc = gql`
    fragment SubjectFragment on Subject {
  name
  uuid
  shortName
  subjectHourEnabled
  epochEnabled
  active
  other
  defaultRoomsConnection(sort: {edge: {order: ASC}}) {
    edges {
      node {
        uuid
        name
      }
    }
  }
  subjectGroup {
    uuid
    name
  }
  timetableConfig {
    uuid
    color
    colorLabel
  }
}
    `;
export const TimeGridEntryFragmentDoc = gql`
    fragment timeGridEntry on TimeGridEntry {
  uuid
  name
  shortName
  start
  end
  order
  reliable
  pause
  print
}
    `;
export const TimeGridFragmentDoc = gql`
    fragment timeGrid on TimeGrid {
  uuid
  name
  description
  itemsConnection(sort: {node: {start: ASC}}) {
    edges {
      node {
        ...timeGridEntry
      }
    }
  }
  itemsWithoutPause: itemsConnection(
    where: {node: {pause: false}}
    sort: {node: {start: ASC}}
  ) {
    edges {
      node {
        ...timeGridEntry
      }
    }
  }
}
    ${TimeGridEntryFragmentDoc}`;
export const _TimetablePrintConfigFragmentDoc = gql`
    fragment _TimetablePrintConfig on TimetablePrintConfig {
  __typename
  uuid
  type
  topLeft
  topCenter
  topRight
  center
  bottomLeft
  bottomCenter
  bottomRight
  printColorOrigin
  printColorPosition
  printClasses
  scaleText
  exactMinute
  printSubtitle
  printLogo
  largeFont
  showSchoolWeeks
  showCalendarWeeks
  showWeekSchoolDays
  timeHorizontal
}
    `;
export const _SchoolEventFragmentDoc = gql`
    fragment _SchoolEvent on SchoolEvent {
  __typename
  uuid
  start
  end
  canceled
  comment
  isClassTrip
  recurrenceUuid
  persons {
    __typename
    uuid
    displayName
    listName
  }
  rooms {
    __typename
    uuid
    name
  }
  subject {
    __typename
    uuid
    name
    shortName
  }
  classesOrGroups {
    ... on MinimalClass {
      __typename
      uuid
    }
    ... on MinimalGroup {
      __typename
      uuid
    }
  }
  groupClassNames
  groupClassNamesLong
}
    `;
export const _EventFragmentDoc = gql`
    fragment _Event on Event {
  __typename
  uuid
  start
  end
  comment
  canceled
  currentState
  isClassTrip
  isClassbookRelevant
  substitutionReasons
  substitutionComment
  print
  sourceTimeGridEntry {
    __typename
    uuid
    name
    shortName
  }
  isAggregated {
    __typename
    uuid
  }
  personsConnection {
    __typename
    edges {
      properties {
        givenSubstituteHours
        isCoveringTeacher
      }
      node {
        __typename
        uuid
      }
    }
  }
  originalPersons {
    __typename
    uuid
  }
  subject {
    __typename
    uuid
  }
  rooms {
    __typename
    uuid
  }
  isSchoolEvent
  originalClassesOrGroups {
    ... on Class {
      __typename
      uuid
    }
    ... on Group {
      __typename
      uuid
    }
  }
  classesOrGroups {
    ... on Class {
      __typename
      uuid
    }
    ... on Group {
      __typename
      uuid
    }
  }
  originalSubject {
    __typename
    uuid
    name
    shortName
  }
  originalRooms {
    __typename
    uuid
    name
  }
}
    `;
export const _TimetableBlockFragmentDoc = gql`
    fragment _TimetableBlock on TimetableBlock {
  __typename
  uuid
  name
  start
  end
  teachingLoadFactor
  teachingLoadComment
  teachingLoadCalculated
  timetables {
    __typename
    uuid
  }
  schoolYear {
    __typename
    uuid
  }
}
    `;
export const _SchoolYearFragmentFragmentDoc = gql`
    fragment _SchoolYearFragment on SchoolYear {
  __typename
  uuid
  name
  start
  end
  createdAt
  updatedAt
}
    `;
export const _TeachingBlockFragmentFragmentDoc = gql`
    fragment _TeachingBlockFragment on TeachingBlock {
  __typename
  uuid
  name
  createdAt
  updatedAt
  draft
  comment
  schoolYear {
    __typename
    uuid
  }
  versions {
    __typename
    uuid
    active
  }
  subjectContainer {
    __typename
    uuid
  }
}
    `;
export const _TeachingBlockVersionsFragmentFragmentDoc = gql`
    fragment _TeachingBlockVersionsFragment on TeachingBlockVersion {
  __typename
  uuid
  active
  version
  availabilityExclusions {
    __typename
    uuid
  }
  teachingBlock {
    __typename
    uuid
    name
  }
  subjectsConnection {
    __typename
    edges {
      properties {
        constraints
      }
      node {
        __typename
        uuid
      }
    }
  }
  classesConnection {
    __typename
    edges {
      properties {
        constraints
      }
      node {
        __typename
        uuid
      }
    }
  }
  roomsConnection {
    __typename
    edges {
      properties {
        constraints
      }
      node {
        __typename
        uuid
      }
    }
  }
  teachersConnection {
    __typename
    edges {
      properties {
        constraints
      }
      node {
        __typename
        uuid
      }
    }
  }
}
    `;
export const TimetableConfigFragmentFragmentDoc = gql`
    fragment TimetableConfigFragment on TimetableConfig {
  __typename
  uuid
  color
}
    `;
export const _TimetableFragmentDoc = gql`
    fragment _Timetable on Timetable {
  __typename
  uuid
  name
  draft
  comment
  updatedAt
  createdAt
  monEnabled
  tueEnabled
  wedEnabled
  thuEnabled
  friEnabled
  satEnabled
  sunEnabled
  versions {
    __typename
    uuid
  }
  schoolYear {
    __typename
    uuid
  }
  timetableBlocks {
    __typename
    uuid
  }
  timegridConfigsConnection {
    __typename
    edges {
      properties {
        order
      }
      node {
        __typename
        classes {
          __typename
          uuid
        }
        timegrid {
          __typename
          uuid
        }
      }
    }
  }
  createdAt
  updatedAt
}
    `;
export const _TimetableVersionFragmentDoc = gql`
    fragment _TimetableVersion on TimetableVersion {
  __typename
  uuid
  version
  active
  editable
  description
  placedCardsCount
  generating
  original {
    uuid
  }
  isSnapshot
  timetable {
    __typename
    uuid
    name
  }
  createdAt
  updatedAt
  subjectsConnection {
    __typename
    edges {
      properties {
        mon
        tue
        wed
        thu
        fri
        sat
        sun
      }
      node {
        __typename
        uuid
      }
    }
  }
  classesConnection {
    __typename
    edges {
      properties {
        mon
        tue
        wed
        thu
        fri
        sat
        sun
      }
      node {
        __typename
        uuid
      }
    }
  }
  roomsConnection {
    __typename
    edges {
      properties {
        mon
        tue
        wed
        thu
        fri
        sat
        sun
      }
      node {
        __typename
        uuid
      }
    }
  }
  teachersConnection {
    __typename
    edges {
      properties {
        mon
        tue
        wed
        thu
        fri
        sat
        sun
      }
      node {
        __typename
        uuid
      }
    }
  }
  dependencies {
    __typename
    uuid
  }
  locked {
    __typename
    duration
    lockedSince
    lockedBy
  }
}
    `;
export const _SubjectFragmentFragmentDoc = gql`
    fragment _SubjectFragment on Subject {
  __typename
  uuid
  name
  shortName
  active
  defaultRoomsConnection {
    edges {
      properties {
        order
      }
      node {
        __typename
        uuid
      }
    }
  }
  epochEnabled
  subjectHourEnabled
  other
  updatedAt
  createdAt
  timetableConfig {
    __typename
    color
  }
  createdAt
  updatedAt
}
    `;
export const _SubjectContainerFragmentFragmentDoc = gql`
    fragment _SubjectContainerFragment on SubjectContainer {
  __typename
  uuid
  name
  shortName
  grades
  validFrom {
    __typename
    uuid
  }
  validUntil {
    __typename
    uuid
  }
  gradeGroup {
    __typename
    uuid
  }
  timetableConfig {
    __typename
    uuid
    color
  }
  createdAt
  updatedAt
}
    `;
export const _PersonFragmentFragmentDoc = gql`
    fragment _PersonFragment on Person {
  __typename
  uuid
  firstName
  lastName
  displayName
  displayNameShort
  fullName
  selectName
  pimProfileUuid
  listName
  shortName
  salutation
  birthday
  email
  personalId
  gender
  active
  organizationConnection {
    edges {
      properties {
        name
      }
      node {
        __typename
        uuid
      }
    }
  }
  qualifications {
    __typename
    subject {
      __typename
      uuid
    }
    maxGrade
    minGrade
  }
  timetableConfig {
    __typename
    uuid
    color
  }
  contracts {
    __typename
    uuid
  }
  defaultRoom {
    __typename
    uuid
  }
  createdAt
  updatedAt
}
    `;
export const _ContractFragmentFragmentDoc = gql`
    fragment _ContractFragment on Contract {
  __typename
  uuid
  name
  validFrom
  validUntil
  hoursWeekly
  freelancer
  billingMethod
  limitedToFullTime
  substituteHours
  createdAt
  updatedAt
  person {
    __typename
    uuid
  }
}
    `;
export const _QualificationFragmentFragmentDoc = gql`
    fragment _QualificationFragment on Qualification {
  __typename
  minGrade
  maxGrade
  maxTeachingLoad
  subject {
    uuid
    shortName
  }
  owner {
    __typename
    uuid
  }
}
    `;
export const _ClassFragmentFragmentDoc = gql`
    fragment _ClassFragment on Class {
  __typename
  uuid
  name
  sortName
  shortName
  grade
  gradeGroup {
    __typename
    uuid
  }
  functionalClassSubstitutionBehavior
  relevantForSubstitution
  certificatesEnabled
  divisions {
    __typename
    uuid
  }
  tutorsConnection(sort: {edge: {order: ASC}}) {
    totalCount
    edges {
      properties {
        order
      }
      node {
        __typename
        uuid
      }
    }
  }
  timetableConfig {
    __typename
    uuid
    color
    colorLabel
    printPageNr
    printOrder
  }
  createdAt
  updatedAt
  defaultRoom {
    uuid
  }
  schoolYear {
    __typename
    uuid
  }
}
    `;
export const _DivisionFragmentFragmentDoc = gql`
    fragment _DivisionFragment on Division {
  __typename
  uuid
  name
  groupsConnection {
    totalCount
    edges {
      properties {
        order
      }
      node {
        __typename
        uuid
      }
    }
  }
  class {
    uuid
    name
    shortName
  }
  createdAt
  updatedAt
}
    `;
export const _GroupFragmentFragmentDoc = gql`
    fragment _GroupFragment on Group {
  __typename
  uuid
  name
  shortName
  entireClass
  classFraction
  createdAt
  updatedAt
  divisionConnection {
    edges {
      properties {
        order
      }
      node {
        __typename
        uuid
      }
    }
  }
}
    `;
export const _LessonUnitFragmentFragmentDoc = gql`
    fragment _LessonUnitFragment on LessonUnit {
  __typename
  uuid
  duration
  count
  subjectContainer {
    __typename
    uuid
  }
}
    `;
export const _RoomFragmentFragmentDoc = gql`
    fragment _RoomFragment on Room {
  __typename
  uuid
  name
  roomNumber
  description
  classroom
  building {
    __typename
    uuid
  }
  responsiblePersonsConnection {
    edges {
      properties {
        order
      }
      node {
        __typename
        uuid
      }
    }
  }
  createdAt
  updatedAt
}
    `;
export const _BuildingFragmentFragmentDoc = gql`
    fragment _BuildingFragment on Building {
  __typename
  uuid
  name
  description
  active
  createdAt
  updatedAt
}
    `;
export const _CurriculumFragmentFragmentDoc = gql`
    fragment _CurriculumFragment on Curriculum {
  __typename
  uuid
  comment
  createdAt
  updatedAt
  personsConnection {
    totalCount
    edges {
      properties {
        description
        present
        teachingLoad
        order
      }
      node {
        __typename
        uuid
      }
    }
  }
  lessons {
    __typename
    uuid
  }
  subject {
    __typename
    ... on Subject {
      __typename
      uuid
    }
    ... on SubjectContainer {
      __typename
      uuid
    }
  }
  curriculumUnit {
    __typename
    uuid
  }
  curriculumUnitConnection {
    edges {
      properties {
        order
      }
      node {
        __typename
        uuid
      }
    }
  }
}
    `;
export const _LessonClassFragmentFragmentDoc = gql`
    fragment _LessonClassFragment on LessonClass {
  __typename
  uuid
  usedDivision {
    __typename
    uuid
  }
  groups {
    __typename
    uuid
  }
  class {
    __typename
    uuid
  }
}
    `;
export const _LessonFragmentFragmentDoc = gql`
    fragment _LessonFragment on Lesson {
  __typename
  uuid
  subTitle
  comment
  onlyInTimetableVersion
  elective
  isClassTrip
  teachingLoadEnabled
  timetableEnabled
  placedCardsCount
  teachingBlockPlacedCardsCount
  classSort
  groupClassNames
  gradeGroupUuid
  teachersSort
  subjectName
  curriculum {
    __typename
    uuid
  }
  lessonUnitConnection {
    edges {
      properties {
        order
      }
      node {
        __typename
        uuid
        duration
        count
        subjectContainer {
          __typename
          uuid
        }
      }
    }
  }
  lessonClassesConnection {
    edges {
      properties {
        order
      }
      node {
        ..._LessonClassFragment
      }
    }
  }
  teachersConnection {
    edges {
      properties {
        description
        order
        present
        teachingLoad
        teachingLoadHours
        writesCertificate
      }
      node {
        __typename
        uuid
      }
    }
  }
  subject {
    __typename
    ... on Subject {
      __typename
      uuid
    }
    ... on SubjectContainer {
      __typename
      uuid
    }
  }
  roomSupplyConnection {
    edges {
      properties {
        order
        descriptions
      }
      node {
        __typename
        uuid
      }
    }
  }
  versions {
    __typename
    uuid
  }
  teachingBlockVersions {
    __typename
    uuid
  }
  activeTimetables {
    __typename
    uuid
  }
  activeTeachingBlocks {
    __typename
    uuid
  }
  timetableEnabled
  createdAt
  updatedAt
}
    ${_LessonClassFragmentFragmentDoc}`;
export const _TimeGridFragmentFragmentDoc = gql`
    fragment _TimeGridFragment on TimeGrid {
  __typename
  uuid
  name
  description
  createdAt
  updatedAt
  items {
    __typename
    uuid
  }
}
    `;
export const _TimeGridEntryFragmentFragmentDoc = gql`
    fragment _TimeGridEntryFragment on TimeGridEntry {
  __typename
  uuid
  start
  pause
  end
  order
  name
  shortName
  timeGrid {
    __typename
    uuid
  }
}
    `;
export const _TimetableCardFragmentFragmentDoc = gql`
    fragment _TimetableCardFragment on TimetableCard {
  __typename
  uuid
  duration
  weekday
  startTimeGridEntry {
    __typename
    uuid
  }
  endTimeGridEntry {
    __typename
    uuid
  }
  locked
  rooms {
    __typename
    uuid
  }
  lessonClasses {
    ..._LessonClassFragment
  }
  teachers {
    __typename
    uuid
  }
  lesson {
    __typename
    uuid
  }
  subject {
    ... on Subject {
      __typename
      uuid
    }
    ... on SubjectContainer {
      __typename
      uuid
    }
  }
}
    ${_LessonClassFragmentFragmentDoc}`;
export const _TeachingBlockCardFragmentFragmentDoc = gql`
    fragment _TeachingBlockCardFragment on TeachingBlockCard {
  __typename
  uuid
  duration
  startDate
  endDate
  includeHoliday
  locked
  rooms {
    __typename
    uuid
  }
  includeHoliday
  teachingBlockVersion {
    __typename
    uuid
  }
  lessonClasses {
    ..._LessonClassFragment
  }
  teachers {
    __typename
    uuid
  }
  teachersPresent {
    __typename
    uuid
  }
  lesson {
    __typename
    uuid
  }
  subject {
    ... on Subject {
      __typename
      uuid
    }
    ... on SubjectContainer {
      __typename
      uuid
    }
  }
}
    ${_LessonClassFragmentFragmentDoc}`;
export const _GradeGroupFragmentFragmentDoc = gql`
    fragment _GradeGroupFragment on GradeGroup {
  __typename
  uuid
  name
  shortName
  class {
    uuid
  }
}
    `;
export const _TeachingBlockAvailabilityExclusionFragmentFragmentDoc = gql`
    fragment _TeachingBlockAvailabilityExclusionFragment on TeachingBlockAvailabilityExclusion {
  __typename
  uuid
  from
  to
  priority
  comment
  holder {
    __typename
    ... on Class {
      __typename
      uuid
    }
    ... on Room {
      __typename
      uuid
    }
    ... on Subject {
      __typename
      uuid
    }
    ... on Person {
      __typename
      uuid
    }
  }
  teachingBlockVersion {
    __typename
    uuid
  }
}
    `;
export const UserConfigFragmentFragmentDoc = gql`
    fragment UserConfigFragment on UserConfig {
  pimProfileUuid
  schoolYear {
    uuid
    name
    shortName
    start
    end
    fullTimeHours
  }
  tableConfigs {
    table
    hiddenColumns
    columnsSortConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          id
          desc
        }
      }
    }
  }
}
    `;
export const LessonClassFragmentFragmentDoc = gql`
    fragment LessonClassFragment on LessonClass {
  uuid
  class {
    uuid
    name
    shortName
    grade
    defaultRoom {
      uuid
      name
    }
    gradeGroup {
      uuid
      name
    }
    divisions {
      uuid
      groups(options: {sort: [{name: ASC}]}) {
        uuid
      }
    }
    timetableConfig {
      color
    }
  }
  groupsAggregate {
    count
  }
  groups {
    uuid
    shortName
    name
    classFraction
  }
  usedDivision {
    uuid
    name
    groupsAggregate {
      count
    }
    groupsConnection(sort: {edge: {order: ASC}}) {
      edges {
        properties {
          order
        }
        node {
          uuid
          name
        }
      }
    }
  }
}
    `;
export const LessonFragmentFragmentDoc = gql`
    fragment LessonFragment on Lesson {
  uuid
  groupClassNames
  gradeGroupUuid
  onlyInTimetableVersion
  classSort
  teachersSort
  curriculum {
    uuid
    personsConnection {
      totalCount
      edges {
        properties {
          description
          order
          present
          teachingLoad
        }
        node {
          uuid
        }
      }
    }
  }
  schoolYear {
    uuid
  }
  subject {
    __typename
    ... on Subject {
      __typename
      uuid
      name
      shortName
      epochEnabled
      subjectHourEnabled
      active
      defaultRooms {
        uuid
        name
      }
      timetableConfig {
        color
      }
    }
    ... on SubjectContainer {
      __typename
      uuid
      name
      shortName
    }
  }
  versions {
    uuid
    active
    editable
    version
    timetable {
      uuid
      name
    }
  }
  teachingBlockVersions {
    uuid
    active
    version
    teachingBlock {
      uuid
      name
    }
  }
  activeTeachingBlocks {
    uuid
  }
  placedCardsCount
  teachingBlockPlacedCardsCount
  activeTimetables {
    uuid
  }
  lessonClassesConnection(sort: [{edge: {order: ASC}}]) {
    edges {
      node {
        ...LessonClassFragment
      }
    }
  }
  lessonUnitConnection(sort: [{edge: {order: ASC}}]) {
    edges {
      node {
        uuid
        duration
        count
        subjectContainer {
          uuid
          name
          shortName
        }
      }
    }
  }
  subTitle
  comment
  elective
  isClassTrip
  teachingLoadEnabled
  timetableEnabled
  teachersConnection(sort: [{edge: {order: ASC}}]) {
    edges {
      properties {
        description
        present
        teachingLoad
        teachingLoadHours
        writesCertificate
      }
      node {
        uuid
        shortName
        fullName
        firstName
        lastName
        displayNameShort
        timetableConfig {
          color
        }
      }
    }
  }
  roomSupplyConnection(sort: [{edge: {order: ASC}}]) {
    edges {
      properties {
        descriptions
      }
      node {
        uuid
        name
      }
    }
  }
}
    ${LessonClassFragmentFragmentDoc}`;
export const SubjectFragmentDoc = gql`
    fragment Subject on Subject {
  uuid
  name
  shortName
  epochEnabled
  subjectHourEnabled
  active
  other
  createdAt
  updatedAt
}
    `;
export const SubjectContainerFragmentDoc = gql`
    fragment SubjectContainer on SubjectContainer {
  uuid
  name
  shortName
  order
  grades
  createdAt
  updatedAt
}
    `;
export const GradeGroupFragmentDoc = gql`
    fragment GradeGroup on GradeGroup {
  uuid
  name
  shortName
  description
  class {
    uuid
  }
}
    `;
export const LessonClassInterfaceFragmentFragmentDoc = gql`
    fragment LessonClassInterfaceFragment on LessonClassInterface {
  class {
    uuid
    name
    shortName
    grade
    gradeGroup {
      uuid
      name
    }
  }
  groups {
    uuid
    shortName
    name
    classFraction
  }
}
    `;
export const CurriculumFragmentDoc = gql`
    fragment Curriculum on Curriculum {
  comment
  createdAt
  lessons {
    uuid
    lessonClassesAggregate {
      count
    }
    schoolYear {
      uuid
    }
  }
  subject {
    ... on Subject {
      ...Subject
    }
    ... on SubjectContainer {
      ...SubjectContainer
    }
  }
  curriculumUnit {
    uuid
    duration
    count
    subjectContainer {
      ...SubjectContainer
    }
  }
  curriculumUnitConnection {
    edges {
      node {
        uuid
        subjectContainer {
          uuid
        }
      }
    }
  }
  curriculumGrades {
    uuid
    grades
    gradeGroups {
      ...GradeGroup
    }
    groups {
      uuid
      name
      classFraction
    }
    lessonClasses {
      class {
        name
        shortName
        grade
        gradeGroup {
          uuid
          name
          shortName
        }
      }
      groups {
        uuid
        name
        shortName
        classFraction
        division {
          uuid
          name
          groups {
            uuid
            name
            shortName
          }
        }
      }
    }
  }
  displayName
  elective
  isClassTrip
  roomSupply {
    uuid
    roomNumber
    description
  }
  roomSupplyConnection {
    edges {
      node {
        uuid
      }
      properties {
        descriptions
      }
    }
  }
  persons {
    name
    uuid
  }
  personsConnection {
    edges {
      node {
        uuid
        name
      }
      properties {
        description
        order
        present
        teachingLoad
      }
    }
    totalCount
  }
  subTitle
  uuid
  timetableEnabled
  teachingLoadEnabled
  labels {
    uuid
    color
    name
  }
  groupGradeNames
  lessonBlueprints {
    uuid
    foreignId
    subTitle
    comment
    displayName
    teachingLoadEnabled
    timetableEnabled
    elective
    onlyInTimetableVersion
    lessonClasses {
      ...LessonClassInterfaceFragment
    }
    teachers {
      uuid
      pimProfileUuid
      displayNameShort
      timetableConfig {
        color
      }
    }
    lessonUnit {
      uuid
      duration
      count
      subjectContainer {
        uuid
        name
        shortName
      }
    }
    roomSupply {
      uuid
      roomNumber
      description
    }
  }
}
    ${SubjectFragmentDoc}
${SubjectContainerFragmentDoc}
${GradeGroupFragmentDoc}
${LessonClassInterfaceFragmentFragmentDoc}`;
export const CardsFragmentDoc = gql`
    fragment Cards on TimetableCard {
  uuid
  weekday
  duration
  timetableVersion {
    version
    uuid
    timetable {
      name
    }
  }
  rooms {
    name
    uuid
  }
  teachers {
    uuid
    pimProfileUuid
    displayNameShort
    defaultRoom {
      uuid
      name
    }
    timetableConfig {
      color
    }
  }
  lesson {
    uuid
    roomSupplyConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          uuid
          name
          building {
            name
          }
        }
      }
    }
  }
  subject {
    ... on Subject {
      uuid
      name
      shortName
      defaultRooms {
        uuid
        name
      }
      timetableConfig {
        color
      }
    }
    ... on SubjectContainer {
      uuid
      name
      shortName
      timetableConfig {
        color
      }
    }
  }
  lessonClasses {
    ...LessonClassFragment
  }
  subjectContainer {
    uuid
    name
    shortName
    order
    lessons {
      uuid
    }
  }
  startTimeGridEntry {
    uuid
    name
  }
  endTimeGridEntry {
    uuid
    name
  }
  locked
}
    ${LessonClassFragmentFragmentDoc}`;
export const TeachingBlockCardsFragmentDoc = gql`
    fragment TeachingBlockCards on TeachingBlockCard {
  uuid
  duration
  startDate
  includeHoliday
  endDate
  rooms {
    name
    uuid
  }
  teachingBlockVersion {
    version
  }
  teachers {
    uuid
    pimProfileUuid
    displayNameShort
    timetableConfig {
      color
    }
  }
  lesson {
    uuid
    roomSupplyConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          uuid
          name
          building {
            name
          }
        }
      }
    }
  }
  subject {
    ... on Subject {
      uuid
      name
      shortName
      timetableConfig {
        color
      }
    }
    ... on SubjectContainer {
      uuid
      name
      shortName
      timetableConfig {
        color
      }
    }
  }
  lessonClasses {
    ...LessonClassFragment
  }
  locked
}
    ${LessonClassFragmentFragmentDoc}`;
export const AbsencesDocument = gql`
    query Absences($where: AbsenceWhere!) {
  absences(where: $where, options: {sort: [{start: ASC}]}) {
    uuid
    person {
      uuid
      listName
      displayNameShort
    }
    reason
    start
    end
    comment
  }
}
    `;

export function useAbsencesQuery(options: Omit<Urql.UseQueryArgs<AbsencesQueryVariables>, 'query'>) {
  return Urql.useQuery<AbsencesQuery, AbsencesQueryVariables>({ query: AbsencesDocument, ...options });
}
export const CreateAbsenceDocument = gql`
    mutation createAbsence($input: CreateAbsenceInput!) {
  createAbsence(input: $input) {
    nodeUuids
  }
}
    `;

export function useCreateAbsenceMutation() {
  return Urql.useMutation<CreateAbsenceMutation, CreateAbsenceMutationVariables>(CreateAbsenceDocument);
}
export const DeleteAbsenceDocument = gql`
    mutation deleteAbsence($input: OnlyUuids!, $removeSubstitutions: Boolean!) {
  deleteAbsence(where: $input, removeSubstitutions: $removeSubstitutions) {
    nodesDeleted
  }
}
    `;

export function useDeleteAbsenceMutation() {
  return Urql.useMutation<DeleteAbsenceMutation, DeleteAbsenceMutationVariables>(DeleteAbsenceDocument);
}
export const UpdateAbsenceDocument = gql`
    mutation updateAbsence($input: OnlyUuids!, $update: UpdateAbsenceInput!) {
  updateAbsence(where: $input, update: $update) {
    nodeUuids
  }
}
    `;

export function useUpdateAbsenceMutation() {
  return Urql.useMutation<UpdateAbsenceMutation, UpdateAbsenceMutationVariables>(UpdateAbsenceDocument);
}
export const CreateBuildingsDocument = gql`
    mutation createBuildings($input: [BuildingCreateInput!]!) {
  createBuildings(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateBuildingsMutation() {
  return Urql.useMutation<CreateBuildingsMutation, CreateBuildingsMutationVariables>(CreateBuildingsDocument);
}
export const UpdateBuildingsDocument = gql`
    mutation updateBuildings($where: BuildingWhere, $update: BuildingUpdateInput) {
  updateBuildings(where: $where, update: $update) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateBuildingsMutation() {
  return Urql.useMutation<UpdateBuildingsMutation, UpdateBuildingsMutationVariables>(UpdateBuildingsDocument);
}
export const DeleteBuildingsDocument = gql`
    mutation deleteBuildings($uuid: ID!) {
  deleteBuildings(where: {uuid: $uuid}) {
    nodesDeleted
  }
}
    `;

export function useDeleteBuildingsMutation() {
  return Urql.useMutation<DeleteBuildingsMutation, DeleteBuildingsMutationVariables>(DeleteBuildingsDocument);
}
export const BuildingsListDocument = gql`
    query BuildingsList($organizationUuid: ID!, $buildingUuid: ID) {
  buildings(
    where: {organization: {uuid: $organizationUuid}, uuid: $buildingUuid}
    options: {sort: [{active: ASC}, {name: ASC}]}
  ) {
    uuid
    name
    description
    active
  }
}
    `;

export function useBuildingsListQuery(options: Omit<Urql.UseQueryArgs<BuildingsListQueryVariables>, 'query'>) {
  return Urql.useQuery<BuildingsListQuery, BuildingsListQueryVariables>({ query: BuildingsListDocument, ...options });
}
export const DeleteClassDivisionsDocument = gql`
    mutation deleteClassDivisions($where: DivisionWhere) {
  deleteDivisions(where: $where) {
    nodesDeleted
  }
}
    `;

export function useDeleteClassDivisionsMutation() {
  return Urql.useMutation<DeleteClassDivisionsMutation, DeleteClassDivisionsMutationVariables>(
    DeleteClassDivisionsDocument,
  );
}
export const CreateClassDivisionsDocument = gql`
    mutation createClassDivisions($input: [DivisionCreateInput!]!) {
  createDivisions(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateClassDivisionsMutation() {
  return Urql.useMutation<CreateClassDivisionsMutation, CreateClassDivisionsMutationVariables>(
    CreateClassDivisionsDocument,
  );
}
export const UpdateClassDivisionsDocument = gql`
    mutation updateClassDivisions($where: DivisionWhere, $update: DivisionUpdateInput) {
  updateDivisions(where: $where, update: $update) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateClassDivisionsMutation() {
  return Urql.useMutation<UpdateClassDivisionsMutation, UpdateClassDivisionsMutationVariables>(
    UpdateClassDivisionsDocument,
  );
}
export const ClassDivisionsClassesListDocument = gql`
    query ClassDivisionsClassesList($where: ClassWhere) {
  classes(where: $where, options: {sort: [{grade: ASC}, {name: ASC}]}) {
    uuid
    name
    shortName
    grade
    timetableConfig {
      color
      colorLabel
    }
    divisionsAggregate {
      count
    }
  }
}
    `;

export function useClassDivisionsClassesListQuery(
  options?: Omit<Urql.UseQueryArgs<ClassDivisionsClassesListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ClassDivisionsClassesListQuery, ClassDivisionsClassesListQueryVariables>({
    query: ClassDivisionsClassesListDocument,
    ...options,
  });
}
export const ClassDivisionsListDocument = gql`
    query ClassDivisionsList($organizationUuid: ID!, $classUuid: ID) {
  divisions(
    where: {class: {uuid: $classUuid}, organization: {uuid: $organizationUuid}}
    options: {sort: [{name: ASC}]}
  ) {
    name
    uuid
    groupsConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          uuid
          shortName
          name
        }
        properties {
          order
        }
      }
    }
  }
  classes(where: {uuid: $classUuid, organization: {uuid: $organizationUuid}}) {
    name
    uuid
  }
}
    `;

export function useClassDivisionsListQuery(
  options: Omit<Urql.UseQueryArgs<ClassDivisionsListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ClassDivisionsListQuery, ClassDivisionsListQueryVariables>({
    query: ClassDivisionsListDocument,
    ...options,
  });
}
export const DeleteClassesDocument = gql`
    mutation deleteClasses($uuid: ID) {
  deleteClasses(
    where: {uuid: $uuid}
    delete: {timetableConfig: {where: {node: {ownerConnection: {Class: {node: {uuid: $uuid}}}}}}, divisions: {where: {node: {class: {uuid: $uuid}}}}}
  ) {
    nodesDeleted
  }
}
    `;

export function useDeleteClassesMutation() {
  return Urql.useMutation<DeleteClassesMutation, DeleteClassesMutationVariables>(DeleteClassesDocument);
}
export const UpdateClassesDocument = gql`
    mutation updateClasses($where: ClassWhere, $update: ClassUpdateInput, $resultTutorsSort: [ClassTutorsConnectionSort!]) {
  updateClasses(where: $where, update: $update) {
    classes {
      uuid
      name
      shortName
      grade
      gradeGroup {
        ...GradeGroup
      }
      certificatesEnabled
      timetableConfig {
        color
        colorLabel
        printOrder
        printPageNr
      }
      tutorsConnection(sort: $resultTutorsSort) {
        edges {
          properties {
            order
          }
          node {
            uuid
            personalId
            email
            birthday
            firstName
            lastName
            fullName
            shortName
          }
        }
      }
    }
  }
}
    ${GradeGroupFragmentDoc}`;

export function useUpdateClassesMutation() {
  return Urql.useMutation<UpdateClassesMutation, UpdateClassesMutationVariables>(UpdateClassesDocument);
}
export const CreateClassDocument = gql`
    mutation createClass($input: [ClassCreateInput!]!, $resultTutorsSort: [ClassTutorsConnectionSort!]) {
  createClasses(input: $input) {
    classes {
      uuid
      name
      shortName
      grade
      gradeGroup {
        ...GradeGroup
      }
      certificatesEnabled
      schoolYear {
        uuid
        name
      }
      timetableConfig {
        color
        colorLabel
        printOrder
        printPageNr
      }
      tutorsConnection(sort: $resultTutorsSort) {
        edges {
          properties {
            order
          }
          node {
            uuid
            personalId
            email
            birthday
            firstName
            lastName
            fullName
            shortName
          }
        }
      }
    }
  }
}
    ${GradeGroupFragmentDoc}`;

export function useCreateClassMutation() {
  return Urql.useMutation<CreateClassMutation, CreateClassMutationVariables>(CreateClassDocument);
}
export const _UpdateClassesColorsDocument = gql`
    mutation _updateClassesColors($uuid: ID!, $color: String!) {
  updateClasses(
    where: {uuid: $uuid}
    update: {timetableConfig: {update: {node: {color: $color}}}}
  ) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function use_UpdateClassesColorsMutation() {
  return Urql.useMutation<_UpdateClassesColorsMutation, _UpdateClassesColorsMutationVariables>(
    _UpdateClassesColorsDocument,
  );
}
export const _UpdateClassesAttendancePlanShowInSubstitutionPlanDocument = gql`
    mutation _updateClassesAttendancePlanShowInSubstitutionPlan($uuids: [ID!]!, $functionalClassSubstitutionBehavior: FunctionalClassSubstitutionBehavior) {
  updateClasses(
    where: {uuid_IN: $uuids}
    update: {functionalClassSubstitutionBehavior: $functionalClassSubstitutionBehavior}
  ) {
    info {
      nodesCreated
      __typename
    }
  }
}
    `;

export function use_UpdateClassesAttendancePlanShowInSubstitutionPlanMutation() {
  return Urql.useMutation<
    _UpdateClassesAttendancePlanShowInSubstitutionPlanMutation,
    _UpdateClassesAttendancePlanShowInSubstitutionPlanMutationVariables
  >(_UpdateClassesAttendancePlanShowInSubstitutionPlanDocument);
}
export const ClassesListDocument = gql`
    query ClassesList($organizationUuid: ID, $schoolYearUuid: ID, $classUuid: ID, $sort: [ClassSort!] = [{grade: ASC}, {name: ASC}]) {
  classes(
    where: {uuid: $classUuid, schoolYear: {uuid: $schoolYearUuid}, organization: {uuid: $organizationUuid}}
    options: {sort: $sort}
  ) {
    uuid
    name
    shortName
    grade
    defaultRoom {
      uuid
    }
    schoolYear {
      uuid
    }
    divisions {
      uuid
      name
      groupsConnection(sort: {edge: {order: ASC}}) {
        edges {
          node {
            uuid
            name
            shortName
            classFraction
          }
        }
        totalCount
      }
      class {
        uuid
      }
    }
    gradeGroup {
      ...GradeGroup
    }
    certificatesEnabled
    timetableConfig {
      color
      colorLabel
      printOrder
      printPageNr
    }
    tutorsConnection(sort: {edge: {order: ASC}}) {
      edges {
        properties {
          order
        }
        node {
          uuid
          personalId
          email
          birthday
          firstName
          lastName
          fullName
          shortName
          displayNameShort
          listName
          selectName
        }
      }
    }
  }
  people(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {lastName: ASC}}
  ) {
    uuid
    firstName
    lastName
    fullName
    displayNameShort
    selectName
  }
}
    ${GradeGroupFragmentDoc}`;

export function useClassesListQuery(options?: Omit<Urql.UseQueryArgs<ClassesListQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassesListQuery, ClassesListQueryVariables>({ query: ClassesListDocument, ...options });
}
export const ClassesDocument = gql`
    query Classes($where: ClassWhere) {
  classes(where: $where, options: {sort: [{grade: ASC}, {name: ASC}]}) {
    uuid
    name
    shortName
    grade
    gradeGroup {
      ...GradeGroup
    }
    schoolYear {
      uuid
    }
  }
}
    ${GradeGroupFragmentDoc}`;

export function useClassesQuery(options?: Omit<Urql.UseQueryArgs<ClassesQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassesQuery, ClassesQueryVariables>({ query: ClassesDocument, ...options });
}
export const CreateCurriculaDocument = gql`
    mutation CreateCurricula($input: [CurriculumCreateInput!]!) {
  createCurricula(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateCurriculaMutation() {
  return Urql.useMutation<CreateCurriculaMutation, CreateCurriculaMutationVariables>(CreateCurriculaDocument);
}
export const CreateCurriculumVersionDocument = gql`
    mutation CreateCurriculumVersion($input: [CurriculumVersionCreateInput!]!) {
  createCurriculumVersions(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateCurriculumVersionMutation() {
  return Urql.useMutation<CreateCurriculumVersionMutation, CreateCurriculumVersionMutationVariables>(
    CreateCurriculumVersionDocument,
  );
}
export const DeleteCurriculumVersionDocument = gql`
    mutation DeleteCurriculumVersion($where: CurriculumVersionWhere!) {
  deleteCurriculumVersions(where: $where) {
    nodesDeleted
  }
}
    `;

export function useDeleteCurriculumVersionMutation() {
  return Urql.useMutation<DeleteCurriculumVersionMutation, DeleteCurriculumVersionMutationVariables>(
    DeleteCurriculumVersionDocument,
  );
}
export const CreateLabelsDocument = gql`
    mutation CreateLabels($input: [LabelCreateInput!]!) {
  createLabels(input: $input) {
    labels {
      uuid
    }
  }
}
    `;

export function useCreateLabelsMutation() {
  return Urql.useMutation<CreateLabelsMutation, CreateLabelsMutationVariables>(CreateLabelsDocument);
}
export const UpdateCurriculumVersionsDocument = gql`
    mutation UpdateCurriculumVersions($update: CurriculumVersionUpdateInput, $where: CurriculumVersionWhere) {
  updateCurriculumVersions(update: $update, where: $where) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateCurriculumVersionsMutation() {
  return Urql.useMutation<UpdateCurriculumVersionsMutation, UpdateCurriculumVersionsMutationVariables>(
    UpdateCurriculumVersionsDocument,
  );
}
export const UpdateCurriculaDocument = gql`
    mutation UpdateCurricula($where: CurriculumWhere, $update: CurriculumUpdateInput) {
  updateCurricula(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateCurriculaMutation() {
  return Urql.useMutation<UpdateCurriculaMutation, UpdateCurriculaMutationVariables>(UpdateCurriculaDocument);
}
export const DeleteCurriculaDocument = gql`
    mutation DeleteCurricula($where: CurriculumWhere, $delete: CurriculumDeleteInput) {
  deleteCurricula(where: $where, delete: $delete) {
    nodesDeleted
    relationshipsDeleted
  }
}
    `;

export function useDeleteCurriculaMutation() {
  return Urql.useMutation<DeleteCurriculaMutation, DeleteCurriculaMutationVariables>(DeleteCurriculaDocument);
}
export const CurriculumVersionsListDocument = gql`
    query CurriculumVersionsList($where: CurriculumVersionWhere) {
  curriculumVersions(where: $where) {
    uuid
    name
    description
    curricula {
      ...Curriculum
    }
  }
}
    ${CurriculumFragmentDoc}`;

export function useCurriculumVersionsListQuery(
  options?: Omit<Urql.UseQueryArgs<CurriculumVersionsListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CurriculumVersionsListQuery, CurriculumVersionsListQueryVariables>({
    query: CurriculumVersionsListDocument,
    ...options,
  });
}
export const CurriculaListDocument = gql`
    query CurriculaList($where: CurriculumWhere, $organizationUuid: ID!, $sort: [CurriculumSort!]) {
  curricula(where: $where, options: {sort: $sort}) {
    ...Curriculum
  }
  subjects(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    timetableConfig {
      color
    }
  }
  curriculumUnits {
    uuid
    count
    duration
    subjectContainer {
      ...SubjectContainer
    }
  }
  classes(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: [{grade: ASC}, {gradeGroupShortName: ASC}, {shortName: ASC}]}
  ) {
    uuid
    name
  }
  curriculumClasses {
    uuid
    gradeGroups {
      ...GradeGroup
    }
    grades
    groups {
      uuid
      name
      shortName
    }
    lessonClasses {
      class {
        name
        shortName
        grade
        gradeGroup {
          shortName
        }
      }
      groups {
        uuid
        name
        shortName
      }
    }
  }
  rooms(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    roomNumber
  }
}
    ${CurriculumFragmentDoc}
${SubjectContainerFragmentDoc}
${GradeGroupFragmentDoc}`;

export function useCurriculaListQuery(options: Omit<Urql.UseQueryArgs<CurriculaListQueryVariables>, 'query'>) {
  return Urql.useQuery<CurriculaListQuery, CurriculaListQueryVariables>({ query: CurriculaListDocument, ...options });
}
export const CurriculumPersonsListDocument = gql`
    query CurriculumPersonsList($where: CurriculumPersonWhere) {
  curriculumPeople(where: $where) {
    uuid
    name
  }
}
    `;

export function useCurriculumPersonsListQuery(
  options?: Omit<Urql.UseQueryArgs<CurriculumPersonsListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CurriculumPersonsListQuery, CurriculumPersonsListQueryVariables>({
    query: CurriculumPersonsListDocument,
    ...options,
  });
}
export const CurriculumClassesListDocument = gql`
    query CurriculumClassesList($where: CurriculumClassWhere) {
  curriculumClasses(where: $where) {
    uuid
    groups {
      uuid
      name
    }
    grades
    gradeGroups {
      ...GradeGroup
    }
    usedDivision {
      uuid
      name
      labels {
        uuid
        name
        color
      }
    }
  }
}
    ${GradeGroupFragmentDoc}`;

export function useCurriculumClassesListQuery(
  options?: Omit<Urql.UseQueryArgs<CurriculumClassesListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CurriculumClassesListQuery, CurriculumClassesListQueryVariables>({
    query: CurriculumClassesListDocument,
    ...options,
  });
}
export const GroupsListDocument = gql`
    query GroupsList($where: GroupWhere) {
  groups(where: $where) {
    uuid
    shortName
    name
  }
}
    `;

export function useGroupsListQuery(options?: Omit<Urql.UseQueryArgs<GroupsListQueryVariables>, 'query'>) {
  return Urql.useQuery<GroupsListQuery, GroupsListQueryVariables>({ query: GroupsListDocument, ...options });
}
export const CreateDependenciesDocument = gql`
    mutation createDependencies($input: [DependencyCreateInput!]!) {
  createDependencies(input: $input) {
    dependencies {
      uuid
    }
  }
}
    `;

export function useCreateDependenciesMutation() {
  return Urql.useMutation<CreateDependenciesMutation, CreateDependenciesMutationVariables>(CreateDependenciesDocument);
}
export const UpdateDependenciesDocument = gql`
    mutation updateDependencies($update: DependencyUpdateInput!, $where: DependencyWhere) {
  updateDependencies(update: $update, where: $where) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateDependenciesMutation() {
  return Urql.useMutation<UpdateDependenciesMutation, UpdateDependenciesMutationVariables>(UpdateDependenciesDocument);
}
export const DependenciesDocument = gql`
    query dependencies($timetableVersion: ID, $uuid: ID, $alias: String) {
  dependencies(
    where: {timetableVersion: {uuid: $timetableVersion}, uuid: $uuid, alias: $alias}
  ) {
    uuid
    priority
    comment
    active
    alias
    otherData
    subjects {
      uuid
      uuid
      name
      shortName
    }
    classes {
      uuid
      name
      shortName
    }
    teachers {
      uuid
      displayName
    }
  }
}
    `;

export function useDependenciesQuery(options?: Omit<Urql.UseQueryArgs<DependenciesQueryVariables>, 'query'>) {
  return Urql.useQuery<DependenciesQuery, DependenciesQueryVariables>({ query: DependenciesDocument, ...options });
}
export const DeleteDependenciesDocument = gql`
    mutation DeleteDependencies($uuid: ID!) {
  deleteDependencies(where: {uuid: $uuid}) {
    nodesDeleted
  }
}
    `;

export function useDeleteDependenciesMutation() {
  return Urql.useMutation<DeleteDependenciesMutation, DeleteDependenciesMutationVariables>(DeleteDependenciesDocument);
}
export const ListPlannedTeacherTeachingLoadDocument = gql`
    query ListPlannedTeacherTeachingLoad($organizationUuid: ID!, $schoolYearUuid: ID!, $teacherUuid: ID) {
  plannedTeachingLoadByTeacher(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    teacherUuid: $teacherUuid
  ) {
    organization {
      uuid
    }
    schoolYear {
      uuid
      name
    }
    teacherUuid
    teacherDisplayName
    lessonUuid
    subjectUuid
    subjectDisplayName
    subjectContainerUuid
    subjectContainerDisplayName
    partialClasses
    lessonClass {
      class {
        uuid
        grade
        gradeGroup {
          uuid
          name
          shortName
        }
      }
      groups {
        uuid
        name
        shortName
      }
    }
    lessonClassesDisplayName
    countClasses
    countTeacher
    studentCards
    teacherCards
    studentHours
    teacherHours
    teachingBlockWeeks
    teachingBlocks
    relevantFactors {
      uuid
      value
      valueRaw
      valuePartial
      valuePartialRaw
    }
    factor
    deputat
  }
}
    `;

export function useListPlannedTeacherTeachingLoadQuery(
  options: Omit<Urql.UseQueryArgs<ListPlannedTeacherTeachingLoadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListPlannedTeacherTeachingLoadQuery, ListPlannedTeacherTeachingLoadQueryVariables>({
    query: ListPlannedTeacherTeachingLoadDocument,
    ...options,
  });
}
export const ListPlannedClassesTeachingLoadDocument = gql`
    query ListPlannedClassesTeachingLoad($organizationUuid: ID!, $schoolYearUuid: ID!, $classUuid: ID) {
  plannedTeachingLoadByClass(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    classUuid: $classUuid
  ) {
    organization {
      uuid
    }
    schoolYear {
      uuid
      name
    }
    classUuid
    classDisplayName
    lessonUuid
    subjectUuid
    subjectDisplayName
    subjectContainerUuid
    subjectContainerDisplayName
    partialClasses
    lessonClass {
      class {
        uuid
        grade
        gradeGroup {
          uuid
          name
          shortName
        }
      }
      groups {
        uuid
        name
        shortName
      }
    }
    lessonClassesDisplayName
    countClasses
    countTeacher
    studentCards
    teacherCards
    studentHours
    teacherHours
    teachingBlockWeeks
    teachingBlocks
    relevantFactors {
      uuid
      value
      valueRaw
      valuePartial
      valuePartialRaw
    }
    factor
    deputat
  }
}
    `;

export function useListPlannedClassesTeachingLoadQuery(
  options: Omit<Urql.UseQueryArgs<ListPlannedClassesTeachingLoadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListPlannedClassesTeachingLoadQuery, ListPlannedClassesTeachingLoadQueryVariables>({
    query: ListPlannedClassesTeachingLoadDocument,
    ...options,
  });
}
export const ListTeacherTeachingLoadDocument = gql`
    query ListTeacherTeachingLoad($organizationUuid: ID!, $schoolYearUuid: ID!, $timetableBlockUuid: ID!, $teacherUuid: ID) {
  teachingLoadByTeacher(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    timetableBlockUuid: $timetableBlockUuid
    teacherUuid: $teacherUuid
  ) {
    organization {
      uuid
    }
    schoolYear {
      uuid
      name
    }
    teacherUuid
    teacherDisplayName
    subjectUuid
    subjectDisplayName
    subjectContainerUuid
    subjectContainerDisplayName
    partialClasses
    lessonClass {
      class {
        uuid
        grade
        gradeGroup {
          uuid
          name
          shortName
        }
      }
      groups {
        uuid
        name
        shortName
      }
    }
    lessonClassesDisplayName
    countClasses
    countTeacher
    studentCards
    teacherCards
    studentHours
    teacherHours
    teachingBlockWeeks
    teachingBlocks
    relevantFactors {
      uuid
      value
      valueRaw
      valuePartial
      valuePartialRaw
    }
    factor
    deputat
    timetableBlockUuid
    timetableBlockDisplayName
    timetableBlockSortName
  }
}
    `;

export function useListTeacherTeachingLoadQuery(
  options: Omit<Urql.UseQueryArgs<ListTeacherTeachingLoadQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ListTeacherTeachingLoadQuery, ListTeacherTeachingLoadQueryVariables>({
    query: ListTeacherTeachingLoadDocument,
    ...options,
  });
}
export const DeleteDivisionsDocument = gql`
    mutation deleteDivisions($where: DivisionWhere) {
  deleteDivisions(where: $where) {
    nodesDeleted
  }
}
    `;

export function useDeleteDivisionsMutation() {
  return Urql.useMutation<DeleteDivisionsMutation, DeleteDivisionsMutationVariables>(DeleteDivisionsDocument);
}
export const CreateDivisionsDocument = gql`
    mutation createDivisions($divisionName: String!, $organizationUuid: ID!, $groups: [DivisionGroupsCreateFieldInput!], $classUuid: ID) {
  createDivisions(
    input: {groups: {create: $groups}, class: {connect: {where: {node: {uuid: $classUuid}}}}, name: $divisionName, organization: {connect: {where: {node: {uuid: $organizationUuid}}}}}
  ) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateDivisionsMutation() {
  return Urql.useMutation<CreateDivisionsMutation, CreateDivisionsMutationVariables>(CreateDivisionsDocument);
}
export const UpdateDivisionsDocument = gql`
    mutation updateDivisions($divisionName: String!, $divisionUuid: ID!, $groups: [DivisionGroupsUpdateFieldInput!]) {
  updateDivisions(
    where: {uuid: $divisionUuid}
    update: {name: $divisionName, groups: $groups}
  ) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateDivisionsMutation() {
  return Urql.useMutation<UpdateDivisionsMutation, UpdateDivisionsMutationVariables>(UpdateDivisionsDocument);
}
export const AddDivisionGroupsDocument = gql`
    mutation addDivisionGroups($divisionUuid: ID!, $groups: [DivisionGroupsCreateFieldInput!]) {
  updateDivisions(
    where: {uuid: $divisionUuid}
    update: {groups: {create: $groups}}
  ) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useAddDivisionGroupsMutation() {
  return Urql.useMutation<AddDivisionGroupsMutation, AddDivisionGroupsMutationVariables>(AddDivisionGroupsDocument);
}
export const DivisionsFormDocument = gql`
    query DivisionsForm($organizationUuid: ID!, $divisionUuid: ID) {
  currentDivision: divisions(
    where: {uuid: $divisionUuid, organization: {uuid: $organizationUuid}}
  ) {
    uuid
    name
    createdAt
    updatedAt
    groupsConnection(sort: [{edge: {order: ASC}}]) {
      edges {
        properties {
          order
        }
        node {
          uuid
          name
          shortName
        }
      }
      totalCount
    }
    class {
      uuid
    }
  }
  divisions(
    where: {organization: {uuid: $organizationUuid}, classAggregate: {count_GT: 0}}
  ) {
    uuid
    name
    createdAt
    updatedAt
    groupsConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          name
          shortName
        }
      }
      totalCount
    }
    class {
      uuid
    }
  }
  defaultDivisions: divisions(
    where: {organization: {uuid: $organizationUuid}, classAggregate: {count: 0}}
  ) {
    uuid
    name
    createdAt
    updatedAt
    groupsConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          name
          shortName
        }
      }
      totalCount
    }
  }
}
    `;

export function useDivisionsFormQuery(options: Omit<Urql.UseQueryArgs<DivisionsFormQueryVariables>, 'query'>) {
  return Urql.useQuery<DivisionsFormQuery, DivisionsFormQueryVariables>({ query: DivisionsFormDocument, ...options });
}
export const DivisionsDocument = gql`
    query Divisions($organizationUuid: ID, $classCount: Int) {
  divisions(
    where: {organization: {uuid: $organizationUuid}, classAggregate: {count: $classCount}}
    options: {sort: [{name: ASC}]}
  ) {
    uuid
    name
    createdAt
    updatedAt
    groupsConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          uuid
          name
          shortName
        }
      }
      totalCount
    }
    classAggregate {
      count
    }
  }
}
    `;

export function useDivisionsQuery(options?: Omit<Urql.UseQueryArgs<DivisionsQueryVariables>, 'query'>) {
  return Urql.useQuery<DivisionsQuery, DivisionsQueryVariables>({ query: DivisionsDocument, ...options });
}
export const TimetableReportsDocument = gql`
    query TimetableReports($where: TimetableReportWhere, $options: TimetableReportOptions) {
  timetableReports(where: $where, options: $options) {
    uuid
    title
    type
    jobCreated
    jobFinished
    context {
      ... on TeachingBlock {
        uuid
        name
      }
      ... on SchoolYear {
        uuid
        name
      }
      ... on TimetableBlock {
        uuid
        name
      }
    }
    fileEntries {
      uuid
      filename
      created
      updated
    }
  }
}
    `;

export function useTimetableReportsQuery(options?: Omit<Urql.UseQueryArgs<TimetableReportsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableReportsQuery, TimetableReportsQueryVariables>({
    query: TimetableReportsDocument,
    ...options,
  });
}
export const TeachingLoadReportsDocument = gql`
    query TeachingLoadReports($where: TeachingLoadReportWhere, $options: TeachingLoadReportOptions) {
  teachingLoadReports(where: $where, options: $options) {
    uuid
    title
    type
    jobCreated
    jobFinished
    context {
      ... on TeachingBlock {
        __typename
        uuid
        name
        schoolYear {
          uuid
        }
      }
      ... on SchoolYear {
        __typename
        uuid
        name
      }
      ... on TimetableBlock {
        __typename
        uuid
        name
        schoolYear {
          uuid
        }
      }
    }
    fileEntries {
      uuid
      filename
      created
      updated
    }
  }
}
    `;

export function useTeachingLoadReportsQuery(
  options?: Omit<Urql.UseQueryArgs<TeachingLoadReportsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingLoadReportsQuery, TeachingLoadReportsQueryVariables>({
    query: TeachingLoadReportsDocument,
    ...options,
  });
}
export const UpdateTeachingBlockAvailabilityExclusionDocument = gql`
    mutation updateTeachingBlockAvailabilityExclusion($where: TeachingBlockAvailabilityExclusionWhere, $update: TeachingBlockAvailabilityExclusionUpdateInput) {
  updateTeachingBlockAvailabilityExclusions(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateTeachingBlockAvailabilityExclusionMutation() {
  return Urql.useMutation<
    UpdateTeachingBlockAvailabilityExclusionMutation,
    UpdateTeachingBlockAvailabilityExclusionMutationVariables
  >(UpdateTeachingBlockAvailabilityExclusionDocument);
}
export const CreateTeachingBlockAvailabilityExclusionDocument = gql`
    mutation createTeachingBlockAvailabilityExclusion($input: [TeachingBlockAvailabilityExclusionCreateInput!]!) {
  createTeachingBlockAvailabilityExclusions(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateTeachingBlockAvailabilityExclusionMutation() {
  return Urql.useMutation<
    CreateTeachingBlockAvailabilityExclusionMutation,
    CreateTeachingBlockAvailabilityExclusionMutationVariables
  >(CreateTeachingBlockAvailabilityExclusionDocument);
}
export const DeleteTeachingBlockAvailabilityExclusionDocument = gql`
    mutation deleteTeachingBlockAvailabilityExclusion($where: TeachingBlockAvailabilityExclusionWhere) {
  deleteTeachingBlockAvailabilityExclusions(where: $where) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockAvailabilityExclusionMutation() {
  return Urql.useMutation<
    DeleteTeachingBlockAvailabilityExclusionMutation,
    DeleteTeachingBlockAvailabilityExclusionMutationVariables
  >(DeleteTeachingBlockAvailabilityExclusionDocument);
}
export const DeleteTeachingLoadFactorDocument = gql`
    mutation deleteTeachingLoadFactor($where: TeachingLoadFactorWhere, $delete: TeachingLoadFactorDeleteInput) {
  deleteTeachingLoadFactors(where: $where, delete: $delete) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingLoadFactorMutation() {
  return Urql.useMutation<DeleteTeachingLoadFactorMutation, DeleteTeachingLoadFactorMutationVariables>(
    DeleteTeachingLoadFactorDocument,
  );
}
export const CreateTeachingLoadFactorDocument = gql`
    mutation createTeachingLoadFactor($input: [TeachingLoadFactorCreateInput!]!) {
  createTeachingLoadFactors(input: $input) {
    info {
      nodesCreated
      relationshipsCreated
    }
  }
}
    `;

export function useCreateTeachingLoadFactorMutation() {
  return Urql.useMutation<CreateTeachingLoadFactorMutation, CreateTeachingLoadFactorMutationVariables>(
    CreateTeachingLoadFactorDocument,
  );
}
export const UpdateTeachingLoadFactorDocument = gql`
    mutation updateTeachingLoadFactor($where: TeachingLoadFactorWhere, $update: TeachingLoadFactorUpdateInput) {
  updateTeachingLoadFactors(where: $where, update: $update) {
    info {
      nodesCreated
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateTeachingLoadFactorMutation() {
  return Urql.useMutation<UpdateTeachingLoadFactorMutation, UpdateTeachingLoadFactorMutationVariables>(
    UpdateTeachingLoadFactorDocument,
  );
}
export const TeachingLoadFactorsDocument = gql`
    query TeachingLoadFactors($where: TeachingLoadFactorWhere, $options: TeachingLoadFactorOptions) {
  teachingLoadFactors(where: $where, options: $options) {
    uuid
    active
    scenario {
      uuid
      foreignId
      name
      comment
    }
    factorType
    subjectContainer {
      uuid
      name
      shortName
      order
      createdAt
      updatedAt
    }
    teachers {
      uuid
      fullName
      shortName
      displayName
      displayNameShort
      listName
    }
    subject {
      uuid
      foreignId
      name
      shortName
      subjectHourEnabled
      epochEnabled
      active
      other
      createdAt
      updatedAt
    }
    schoolYear {
      uuid
    }
    grades
    gradeGroup {
      ...GradeGroup
    }
    value
    valueRaw
    valuePartial
    valuePartialRaw
    valueMode
    comment
    timeGridEntries {
      uuid
      name
    }
  }
}
    ${GradeGroupFragmentDoc}`;

export function useTeachingLoadFactorsQuery(
  options?: Omit<Urql.UseQueryArgs<TeachingLoadFactorsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingLoadFactorsQuery, TeachingLoadFactorsQueryVariables>({
    query: TeachingLoadFactorsDocument,
    ...options,
  });
}
export const TeachingLoadScenariosDocument = gql`
    query TeachingLoadScenarios($where: TeachingLoadScenarioWhere, $options: TeachingLoadScenarioOptions) {
  teachingLoadScenarios(where: $where, options: $options) {
    comment
    name
    uuid
  }
}
    `;

export function useTeachingLoadScenariosQuery(
  options?: Omit<Urql.UseQueryArgs<TeachingLoadScenariosQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingLoadScenariosQuery, TeachingLoadScenariosQueryVariables>({
    query: TeachingLoadScenariosDocument,
    ...options,
  });
}
export const CreateGradeGroupsDocument = gql`
    mutation createGradeGroups($input: [GradeGroupCreateInput!]!) {
  createGradeGroups(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateGradeGroupsMutation() {
  return Urql.useMutation<CreateGradeGroupsMutation, CreateGradeGroupsMutationVariables>(CreateGradeGroupsDocument);
}
export const DeleteGradeGroupsDocument = gql`
    mutation deleteGradeGroups($where: GradeGroupWhere, $delete: GradeGroupDeleteInput) {
  deleteGradeGroups(where: $where, delete: $delete) {
    nodesDeleted
  }
}
    `;

export function useDeleteGradeGroupsMutation() {
  return Urql.useMutation<DeleteGradeGroupsMutation, DeleteGradeGroupsMutationVariables>(DeleteGradeGroupsDocument);
}
export const UpdateGradeGroupsDocument = gql`
    mutation updateGradeGroups($where: GradeGroupWhere, $update: GradeGroupUpdateInput) {
  updateGradeGroups(where: $where, update: $update) {
    info {
      nodesCreated
      nodesDeleted
      relationshipsCreated
      relationshipsDeleted
    }
  }
}
    `;

export function useUpdateGradeGroupsMutation() {
  return Urql.useMutation<UpdateGradeGroupsMutation, UpdateGradeGroupsMutationVariables>(UpdateGradeGroupsDocument);
}
export const GradeGroupsListDocument = gql`
    query GradeGroupsList($organizationUuid: ID, $uuid: ID) {
  gradeGroups(
    where: {organization: {uuid: $organizationUuid}, uuid: $uuid}
    options: {sort: [{name: ASC}, {shortName: ASC}]}
  ) {
    uuid
    name
    shortName
    description
  }
}
    `;

export function useGradeGroupsListQuery(options?: Omit<Urql.UseQueryArgs<GradeGroupsListQueryVariables>, 'query'>) {
  return Urql.useQuery<GradeGroupsListQuery, GradeGroupsListQueryVariables>({
    query: GradeGroupsListDocument,
    ...options,
  });
}
export const DeleteHolidaysDocument = gql`
    mutation deleteHolidays($uuid: ID) {
  deleteHolidays(where: {uuid: $uuid}) {
    nodesDeleted
  }
}
    `;

export function useDeleteHolidaysMutation() {
  return Urql.useMutation<DeleteHolidaysMutation, DeleteHolidaysMutationVariables>(DeleteHolidaysDocument);
}
export const UpdateHolidaysDocument = gql`
    mutation updateHolidays($where: HolidayWhere, $update: HolidayUpdateInput) {
  updateHolidays(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateHolidaysMutation() {
  return Urql.useMutation<UpdateHolidaysMutation, UpdateHolidaysMutationVariables>(UpdateHolidaysDocument);
}
export const CreateHolidaysDocument = gql`
    mutation createHolidays($input: [HolidayCreateInput!]!) {
  createHolidays(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateHolidaysMutation() {
  return Urql.useMutation<CreateHolidaysMutation, CreateHolidaysMutationVariables>(CreateHolidaysDocument);
}
export const HolidaysDocument = gql`
    query Holidays($where: HolidayWhere, $options: HolidayOptions) {
  holidays(where: $where, options: $options) {
    uuid
    name
    start
    end
  }
}
    `;

export function useHolidaysQuery(options?: Omit<Urql.UseQueryArgs<HolidaysQueryVariables>, 'query'>) {
  return Urql.useQuery<HolidaysQuery, HolidaysQueryVariables>({ query: HolidaysDocument, ...options });
}
export const CreateLessonsDocument = gql`
    mutation createLessons($input: [LessonCreateInput!]!) {
  createLessons(input: $input) {
    lessons {
      ...LessonFragment
    }
  }
}
    ${LessonFragmentFragmentDoc}`;

export function useCreateLessonsMutation() {
  return Urql.useMutation<CreateLessonsMutation, CreateLessonsMutationVariables>(CreateLessonsDocument);
}
export const UpdateLessonsDocument = gql`
    mutation updateLessons($where: LessonWhere, $update: LessonUpdateInput) {
  updateLessons(where: $where, update: $update) {
    lessons {
      ...LessonFragment
    }
  }
}
    ${LessonFragmentFragmentDoc}`;

export function useUpdateLessonsMutation() {
  return Urql.useMutation<UpdateLessonsMutation, UpdateLessonsMutationVariables>(UpdateLessonsDocument);
}
export const DeleteLessonsDocument = gql`
    mutation deleteLessons($where: LessonWhere, $delete: LessonDeleteInput) {
  deleteLessons(where: $where, delete: $delete) {
    nodesDeleted
  }
}
    `;

export function useDeleteLessonsMutation() {
  return Urql.useMutation<DeleteLessonsMutation, DeleteLessonsMutationVariables>(DeleteLessonsDocument);
}
export const ConnectLessonsToTimetableVersionDocument = gql`
    mutation connectLessonsToTimetableVersion($organizationUuid: ID!, $timetableVersionUuid: ID!, $lessonUuids: [ID!]!) {
  connectLessonsToTimetableVersion(
    organizationUuid: $organizationUuid
    timetableVersionUuid: $timetableVersionUuid
    lessonUuids: $lessonUuids
  ) {
    nodesUpdated
    nodeUuids
  }
}
    `;

export function useConnectLessonsToTimetableVersionMutation() {
  return Urql.useMutation<ConnectLessonsToTimetableVersionMutation, ConnectLessonsToTimetableVersionMutationVariables>(
    ConnectLessonsToTimetableVersionDocument,
  );
}
export const InheritLessonTeachersDocument = gql`
    mutation inheritLessonTeachers($lessonUuids: [ID!]!, $type: InheritLessonTeachersType!) {
  inheritLessonTeachers(lessonUuids: $lessonUuids, type: $type) {
    entitiesUpdated
  }
}
    `;

export function useInheritLessonTeachersMutation() {
  return Urql.useMutation<InheritLessonTeachersMutation, InheritLessonTeachersMutationVariables>(
    InheritLessonTeachersDocument,
  );
}
export const CopyLessonsToTimetableVersionDocument = gql`
    mutation copyLessonsToTimetableVersion($organizationUuid: ID!, $timetableVersionUuid: ID!, $lessonUuids: [ID!]!) {
  copyLessonsToTimetableVersion(
    organizationUuid: $organizationUuid
    timetableVersionUuid: $timetableVersionUuid
    lessonUuids: $lessonUuids
  ) {
    nodesCreated
    nodeUuids
  }
}
    `;

export function useCopyLessonsToTimetableVersionMutation() {
  return Urql.useMutation<CopyLessonsToTimetableVersionMutation, CopyLessonsToTimetableVersionMutationVariables>(
    CopyLessonsToTimetableVersionDocument,
  );
}
export const MergeLessonsDocument = gql`
    mutation mergeLessons($cardsFromLesson: ID, $lessonUuids: [ID!]!, $newCards: [MergeLessonNewCardsInput!]!, $removePlacedCards: Boolean!, $timetableVersion: ID) {
  mergeLessons(
    cardsFromLesson: $cardsFromLesson
    lessonUuids: $lessonUuids
    newCards: $newCards
    removePlacedCards: $removePlacedCards
    timetableVersion: $timetableVersion
  ) {
    nodeUuids
    nodesCreated
  }
}
    `;

export function useMergeLessonsMutation() {
  return Urql.useMutation<MergeLessonsMutation, MergeLessonsMutationVariables>(MergeLessonsDocument);
}
export const LessonsDocument = gql`
    query Lessons($lessonWhere: LessonWhere, $timetableCardsWhere: TimetableCardWhere, $organizationUuid: ID!, $options: LessonOptions) {
  lessons(where: $lessonWhere, options: $options) {
    ...LessonFragment
  }
  timetableCards(where: $timetableCardsWhere) {
    ...Cards
  }
  people(
    where: {organizationConnection: {edge: {name: TEACHER}, node: {uuid: $organizationUuid}}}
    options: {sort: [{lastName: ASC}, {firstName: ASC}]}
  ) {
    uuid
    selectName
    qualifications {
      subject {
        uuid
      }
    }
  }
  subjects(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    timetableConfig {
      color
    }
  }
  classes(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: [{grade: ASC}, {gradeGroupShortName: ASC}, {shortName: ASC}]}
  ) {
    uuid
    name
  }
  rooms(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    roomNumber
  }
}
    ${LessonFragmentFragmentDoc}
${CardsFragmentDoc}`;

export function useLessonsQuery(options: Omit<Urql.UseQueryArgs<LessonsQueryVariables>, 'query'>) {
  return Urql.useQuery<LessonsQuery, LessonsQueryVariables>({ query: LessonsDocument, ...options });
}
export const TimetableVersionLessonsDocument = gql`
    query TimetableVersionLessons($lessonWhere: LessonWhere, $options: LessonOptions) {
  lessons(where: $lessonWhere, options: $options) {
    ...LessonFragment
  }
}
    ${LessonFragmentFragmentDoc}`;

export function useTimetableVersionLessonsQuery(
  options?: Omit<Urql.UseQueryArgs<TimetableVersionLessonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionLessonsQuery, TimetableVersionLessonsQueryVariables>({
    query: TimetableVersionLessonsDocument,
    ...options,
  });
}
export const LessonsWithoutCardsDocument = gql`
    query LessonsWithoutCards($lessonWhere: LessonWhere, $organizationUuid: ID!, $options: LessonOptions) {
  lessons(where: $lessonWhere, options: $options) {
    ...LessonFragment
  }
  people(
    where: {organizationConnection: {edge: {name: TEACHER}, node: {uuid: $organizationUuid}}}
    options: {sort: {lastName: ASC}}
  ) {
    uuid
    selectName
    qualifications {
      subject {
        uuid
      }
    }
  }
  subjects(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    timetableConfig {
      color
    }
  }
  classes(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: [{grade: ASC}, {gradeGroupShortName: ASC}, {shortName: ASC}]}
  ) {
    uuid
    name
  }
  rooms(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    roomNumber
  }
}
    ${LessonFragmentFragmentDoc}`;

export function useLessonsWithoutCardsQuery(
  options: Omit<Urql.UseQueryArgs<LessonsWithoutCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LessonsWithoutCardsQuery, LessonsWithoutCardsQueryVariables>({
    query: LessonsWithoutCardsDocument,
    ...options,
  });
}
export const TeachingBlockLessonsDocument = gql`
    query TeachingBlockLessons($lessonWhere: LessonWhere, $options: LessonOptions, $organizationUuid: ID!) {
  lessons(where: $lessonWhere, options: $options) {
    ...LessonFragment
  }
  people(
    where: {organizationConnection: {edge: {name: TEACHER}, node: {uuid: $organizationUuid}}}
    options: {sort: [{lastName: ASC}, {firstName: ASC}]}
  ) {
    uuid
    selectName
    qualifications {
      subject {
        uuid
      }
    }
  }
  subjects(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    timetableConfig {
      color
    }
  }
  classes(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: [{grade: ASC}, {gradeGroupShortName: ASC}, {shortName: ASC}]}
  ) {
    uuid
    name
  }
  rooms(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
    roomNumber
  }
}
    ${LessonFragmentFragmentDoc}`;

export function useTeachingBlockLessonsQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockLessonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockLessonsQuery, TeachingBlockLessonsQueryVariables>({
    query: TeachingBlockLessonsDocument,
    ...options,
  });
}
export const MathplanJobDocument = gql`
    query MathplanJob($where: MathplanJobWhere!, $options: MathplanJobOptions) {
  mathplanJobs(where: $where, options: $options) {
    jobId
    timetableVersion {
      uuid
      version
      timetable {
        uuid
        name
        schoolYear {
          uuid
          name
        }
      }
      active
    }
    createdAt
    updatedAt
    status
    gap
    solutionFound
    solution
    problem
    log
    errors
  }
}
    `;

export function useMathplanJobQuery(options: Omit<Urql.UseQueryArgs<MathplanJobQueryVariables>, 'query'>) {
  return Urql.useQuery<MathplanJobQuery, MathplanJobQueryVariables>({ query: MathplanJobDocument, ...options });
}
export const PimOrganizationsDocument = gql`
    query PimOrganizations($where: PimOrganizationWhere) {
  pimOrganizations(where: $where) {
    uuid
    name
    planungEnabled
    iphisVplanEnabled
    vpoEnabled
  }
}
    `;

export function usePimOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<PimOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<PimOrganizationsQuery, PimOrganizationsQueryVariables>({
    query: PimOrganizationsDocument,
    ...options,
  });
}
export const OrganizationsDocument = gql`
    query Organizations($where: OrganizationWhere) {
  organizations(where: $where) {
    uuid
    vpoSubstitutionProps
    iphisSubstitutionProps
  }
}
    `;

export function useOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<OrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationsQuery, OrganizationsQueryVariables>({ query: OrganizationsDocument, ...options });
}
export const CreatePeopleDocument = gql`
    mutation createPeople($input: [PersonCreateInput!]!) {
  createPeople(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreatePeopleMutation() {
  return Urql.useMutation<CreatePeopleMutation, CreatePeopleMutationVariables>(CreatePeopleDocument);
}
export const UpdatePeopleDocument = gql`
    mutation updatePeople($where: PersonWhere, $update: PersonUpdateInput) {
  updatePeople(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdatePeopleMutation() {
  return Urql.useMutation<UpdatePeopleMutation, UpdatePeopleMutationVariables>(UpdatePeopleDocument);
}
export const DeletePeopleDocument = gql`
    mutation deletePeople($uuids: [ID!]!) {
  deletePeople(
    where: {uuid_IN: $uuids}
    delete: {timetableConfig: {where: {node: {ownerConnection: {Person: {node: {uuid_IN: $uuids}}}}}}, contracts: {where: {node: {personConnection: {node: {uuid_IN: $uuids}}}}}}
  ) {
    nodesDeleted
  }
}
    `;

export function useDeletePeopleMutation() {
  return Urql.useMutation<DeletePeopleMutation, DeletePeopleMutationVariables>(DeletePeopleDocument);
}
export const UpdateShortNamesDocument = gql`
    mutation updateShortNames($organizationUuid: ID!) {
  updateShortNames(organizationUuid: $organizationUuid) {
    updated
  }
}
    `;

export function useUpdateShortNamesMutation() {
  return Urql.useMutation<UpdateShortNamesMutation, UpdateShortNamesMutationVariables>(UpdateShortNamesDocument);
}
export const UpdateActivePeopleDocument = gql`
    mutation updateActivePeople($uuids: [ID!]!, $active: Boolean) {
  updatePeople(where: {uuid_IN: $uuids}, update: {active: $active}) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateActivePeopleMutation() {
  return Urql.useMutation<UpdateActivePeopleMutation, UpdateActivePeopleMutationVariables>(UpdateActivePeopleDocument);
}
export const UpdatePeopleColorDocument = gql`
    mutation updatePeopleColor($uuid: ID!, $color: String!) {
  updatePeople(
    where: {uuid: $uuid}
    update: {timetableConfig: {update: {node: {color: $color}}}}
  ) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdatePeopleColorMutation() {
  return Urql.useMutation<UpdatePeopleColorMutation, UpdatePeopleColorMutationVariables>(UpdatePeopleColorDocument);
}
export const PersonsDocument = gql`
    query Persons($where: PersonWhere, $contractOptions: ContractOptions, $subjectsWhere: SubjectWhere, $currentDate: Date, $schoolYearUuid: String!, $sortOptions: [PersonSort!] = [{active: DESC}, {lastName: ASC}, {firstName: ASC}]) {
  people(where: $where, options: {sort: $sortOptions}) {
    uuid
    pimProfileUuid
    personalId
    listName
    firstName
    lastName
    fullName
    selectName
    shortName
    uniqueFirstName
    callingName
    prefixName
    salutation
    title
    email
    birthday
    gender
    active
    displayNameShort
    displayName
    defaultRoom {
      uuid
    }
    contractsAggregate {
      count
    }
    organizationConnection {
      edges {
        properties {
          name
        }
      }
    }
    timetableConfig {
      color
      colorLabel
    }
    contracts(options: $contractOptions) {
      uuid
      name
      validFrom
      validUntil
      hoursWeekly
      freelancer
      billingMethod
      limitedToFullTime
      substituteHours
    }
    currentContract(schoolYearUuid: $schoolYearUuid) {
      uuid
      name
      validFrom
      validUntil
      hoursWeekly
      freelancer
      billingMethod
      limitedToFullTime
      substituteHours
    }
    currentContractOpenEnd: contracts(
      where: {validFrom_LT: $currentDate, validUntil_GT: null}
      options: {limit: 1}
    ) {
      uuid
      name
      validFrom
      validUntil
      hoursWeekly
      freelancer
      billingMethod
      limitedToFullTime
      substituteHours
    }
    qualificationsAggregate {
      count
    }
    qualifications {
      maxGrade
      minGrade
      maxTeachingLoad
      subject {
        uuid
        name
        shortName
      }
    }
  }
  subjects(where: $subjectsWhere, options: {sort: {name: ASC}}) {
    uuid
    name
  }
}
    `;

export function usePersonsQuery(options: Omit<Urql.UseQueryArgs<PersonsQueryVariables>, 'query'>) {
  return Urql.useQuery<PersonsQuery, PersonsQueryVariables>({ query: PersonsDocument, ...options });
}
export const _PublishedSubstitutionsDocument = gql`
    query _PublishedSubstitutions($where: PublishedSubstitutionsWhere, $options: PublishedSubstitutionsOptions) {
  publishedSubstitutions(where: $where, options: $options) {
    uuid
    date
    lastPublished
    teachers
    classes
    substitutions
    notifications
  }
}
    `;

export function use_PublishedSubstitutionsQuery(
  options?: Omit<Urql.UseQueryArgs<_PublishedSubstitutionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_PublishedSubstitutionsQuery, _PublishedSubstitutionsQueryVariables>({
    query: _PublishedSubstitutionsDocument,
    ...options,
  });
}
export const CreateRoomsDocument = gql`
    mutation createRooms($input: [RoomCreateInput!]!) {
  createRooms(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateRoomsMutation() {
  return Urql.useMutation<CreateRoomsMutation, CreateRoomsMutationVariables>(CreateRoomsDocument);
}
export const UpdateRoomsDocument = gql`
    mutation updateRooms($where: RoomWhere, $update: RoomUpdateInput) {
  updateRooms(where: $where, update: $update) {
    info {
      nodesCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateRoomsMutation() {
  return Urql.useMutation<UpdateRoomsMutation, UpdateRoomsMutationVariables>(UpdateRoomsDocument);
}
export const DeleteRoomsDocument = gql`
    mutation deleteRooms($uuids: [ID!]!) {
  deleteRooms(where: {uuid_IN: $uuids}) {
    nodesDeleted
  }
}
    `;

export function useDeleteRoomsMutation() {
  return Urql.useMutation<DeleteRoomsMutation, DeleteRoomsMutationVariables>(DeleteRoomsDocument);
}
export const RoomsListDocument = gql`
    query RoomsList($organizationUuid: ID!, $uuid: ID) {
  rooms(
    where: {organization: {uuid: $organizationUuid}, uuid: $uuid}
    options: {sort: {roomNumber: ASC}}
  ) {
    uuid
    name
    building {
      uuid
      name
    }
    position
    roomNumber
    description
    classroom
    canBeLeased
    capacity
    chairs
    tables
    size
    responsiblePersonsConnection(sort: {edge: {order: ASC}}) {
      edges {
        properties {
          order
        }
        node {
          uuid
          displayNameShort
        }
      }
    }
    otherInventory
    barrierFree
    canBeDarkened
    hasProjector
    hasScreen
    hasMediaCabinet
    hasPiano
  }
  buildings(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
  }
  people(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {lastName: ASC}}
  ) {
    uuid
    firstName
    lastName
    displayNameShort
  }
}
    `;

export function useRoomsListQuery(options: Omit<Urql.UseQueryArgs<RoomsListQueryVariables>, 'query'>) {
  return Urql.useQuery<RoomsListQuery, RoomsListQueryVariables>({ query: RoomsListDocument, ...options });
}
export const CreateSchoolYearsDocument = gql`
    mutation createSchoolYears($input: [SchoolYearCreateInput!]!) {
  createSchoolYears(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateSchoolYearsMutation() {
  return Urql.useMutation<CreateSchoolYearsMutation, CreateSchoolYearsMutationVariables>(CreateSchoolYearsDocument);
}
export const UpdateSchoolYearsDocument = gql`
    mutation updateSchoolYears($where: SchoolYearWhere, $update: SchoolYearUpdateInput) {
  updateSchoolYears(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateSchoolYearsMutation() {
  return Urql.useMutation<UpdateSchoolYearsMutation, UpdateSchoolYearsMutationVariables>(UpdateSchoolYearsDocument);
}
export const DeleteSchoolYearsDocument = gql`
    mutation deleteSchoolYears($uuid: ID) {
  deleteSchoolYears(where: {uuid: $uuid}) {
    nodesDeleted
  }
}
    `;

export function useDeleteSchoolYearsMutation() {
  return Urql.useMutation<DeleteSchoolYearsMutation, DeleteSchoolYearsMutationVariables>(DeleteSchoolYearsDocument);
}
export const SchoolYearsDocument = gql`
    query SchoolYears($organizationUuid: ID!) {
  schoolYears(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {start: ASC}}
  ) {
    uuid
    name
    shortName
    start
    end
    fullTimeHours
    holidays {
      uuid
      name
      start
      end
    }
  }
}
    `;

export function useSchoolYearsQuery(options: Omit<Urql.UseQueryArgs<SchoolYearsQueryVariables>, 'query'>) {
  return Urql.useQuery<SchoolYearsQuery, SchoolYearsQueryVariables>({ query: SchoolYearsDocument, ...options });
}
export const DeleteSubjectContainerDocument = gql`
    mutation deleteSubjectContainer($uuid: ID) {
  deleteSubjectContainers(
    where: {uuid: $uuid}
    delete: {timetableConfig: {where: {node: {ownerConnection: {SubjectContainer: {node: {uuid: $uuid}}}}}}}
  ) {
    nodesDeleted
  }
}
    `;

export function useDeleteSubjectContainerMutation() {
  return Urql.useMutation<DeleteSubjectContainerMutation, DeleteSubjectContainerMutationVariables>(
    DeleteSubjectContainerDocument,
  );
}
export const UpdateSubjectContainerDocument = gql`
    mutation updateSubjectContainer($uuid: ID!, $update: SubjectContainerUpdateInput) {
  updateSubjectContainers(where: {uuid: $uuid}, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateSubjectContainerMutation() {
  return Urql.useMutation<UpdateSubjectContainerMutation, UpdateSubjectContainerMutationVariables>(
    UpdateSubjectContainerDocument,
  );
}
export const CreateSubjectContainersDocument = gql`
    mutation CreateSubjectContainers($input: [SubjectContainerCreateInput!]!) {
  createSubjectContainers(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateSubjectContainersMutation() {
  return Urql.useMutation<CreateSubjectContainersMutation, CreateSubjectContainersMutationVariables>(
    CreateSubjectContainersDocument,
  );
}
export const SubjectContainersListDocument = gql`
    query SubjectContainersList($organizationUuid: ID, $subjectContainerUuid: ID, $options: SubjectContainerOptions = {sort: {order: ASC}}) {
  subjectContainers(
    where: {organization: {uuid: $organizationUuid}, uuid: $subjectContainerUuid}
    options: $options
  ) {
    uuid
    name
    gradeGroup {
      uuid
      name
      shortName
    }
    grades
    shortName
    order
    validFrom {
      uuid
      name
      shortName
      start
      end
    }
    validUntil {
      uuid
      name
      shortName
      start
      end
    }
    timetableConfig {
      color
      colorLabel
    }
  }
  schoolYears(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {start: ASC}}
  ) {
    uuid
    name
    shortName
    start
    end
  }
}
    `;

export function useSubjectContainersListQuery(
  options?: Omit<Urql.UseQueryArgs<SubjectContainersListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubjectContainersListQuery, SubjectContainersListQueryVariables>({
    query: SubjectContainersListDocument,
    ...options,
  });
}
export const _SubjectContainersUsedInDocument = gql`
    query _SubjectContainersUsedIn($uuids: [ID!]!, $options: SubjectContainerOptions) {
  subjectContainers(
    where: {uuid_IN: $uuids, OR: [{curriculaAggregate: {count_GT: 0}}, {lessonsAggregate: {count_GT: 0}}, {lessonUnitsAggregate: {count_GT: 0}}]}
    options: $options
  ) {
    __typename
    uuid
    name
    teachingBlocksAggregate {
      count
    }
    lessonUnitsAggregate {
      count
    }
    lessons(options: {sort: {classSort: ASC}}) {
      uuid
      displayName
      versions {
        uuid
        timetable {
          name
        }
        version
        description
      }
    }
    curricula(options: {sort: {curriculumClassesNames: ASC}}) {
      uuid
      displayName
    }
  }
}
    `;

export function use_SubjectContainersUsedInQuery(
  options: Omit<Urql.UseQueryArgs<_SubjectContainersUsedInQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_SubjectContainersUsedInQuery, _SubjectContainersUsedInQueryVariables>({
    query: _SubjectContainersUsedInDocument,
    ...options,
  });
}
export const DeleteSubjectGroupDocument = gql`
    mutation deleteSubjectGroup($uuid: ID) {
  deleteSubjectGroups(where: {uuid: $uuid}) {
    nodesDeleted
  }
}
    `;

export function useDeleteSubjectGroupMutation() {
  return Urql.useMutation<DeleteSubjectGroupMutation, DeleteSubjectGroupMutationVariables>(DeleteSubjectGroupDocument);
}
export const UpdateSubjectGroupDocument = gql`
    mutation updateSubjectGroup($uuid: ID!, $update: SubjectGroupUpdateInput) {
  updateSubjectGroups(where: {uuid: $uuid}, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateSubjectGroupMutation() {
  return Urql.useMutation<UpdateSubjectGroupMutation, UpdateSubjectGroupMutationVariables>(UpdateSubjectGroupDocument);
}
export const CreateSubjectGroupDocument = gql`
    mutation CreateSubjectGroup($input: [SubjectGroupCreateInput!]!) {
  createSubjectGroups(input: $input) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateSubjectGroupMutation() {
  return Urql.useMutation<CreateSubjectGroupMutation, CreateSubjectGroupMutationVariables>(CreateSubjectGroupDocument);
}
export const SubjectGroupsDocument = gql`
    query SubjectGroups($organizationUuid: ID!, $subjectGroupUuid: ID) {
  subjectGroups(
    where: {organization: {uuid: $organizationUuid}, uuid: $subjectGroupUuid}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
  }
}
    `;

export function useSubjectGroupsQuery(options: Omit<Urql.UseQueryArgs<SubjectGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<SubjectGroupsQuery, SubjectGroupsQueryVariables>({ query: SubjectGroupsDocument, ...options });
}
export const DeleteSubjectsDocument = gql`
    mutation deleteSubjects($where: SubjectWhere) {
  deleteSubjects(
    where: $where
    delete: {timetableConfig: {where: {node: {ownerConnection: {Subject: {node: $where}}}}}}
  ) {
    nodesDeleted
  }
}
    `;

export function useDeleteSubjectsMutation() {
  return Urql.useMutation<DeleteSubjectsMutation, DeleteSubjectsMutationVariables>(DeleteSubjectsDocument);
}
export const DeleteQualificationDocument = gql`
    mutation deleteQualification($where: QualificationWhere) {
  deleteQualifications(where: $where) {
    nodesDeleted
  }
}
    `;

export function useDeleteQualificationMutation() {
  return Urql.useMutation<DeleteQualificationMutation, DeleteQualificationMutationVariables>(
    DeleteQualificationDocument,
  );
}
export const UpdateSubjectsDocument = gql`
    mutation updateSubjects($where: SubjectWhere, $update: SubjectUpdateInput) {
  updateSubjects(where: $where, update: $update) {
    subjects {
      ...SubjectFragment
    }
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useUpdateSubjectsMutation() {
  return Urql.useMutation<UpdateSubjectsMutation, UpdateSubjectsMutationVariables>(UpdateSubjectsDocument);
}
export const CreateSubjectDocument = gql`
    mutation createSubject($input: [SubjectCreateInput!]!) {
  createSubjects(input: $input) {
    subjects {
      ...SubjectFragment
    }
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useCreateSubjectMutation() {
  return Urql.useMutation<CreateSubjectMutation, CreateSubjectMutationVariables>(CreateSubjectDocument);
}
export const SubjectsListDocument = gql`
    query SubjectsList($where: SubjectWhere, $options: SubjectOptions) {
  subjects(where: $where, options: $options) {
    ...SubjectFragment
    timetableConfig {
      color
      colorLabel
      printOrder
      printPageNr
    }
  }
}
    ${SubjectFragmentFragmentDoc}`;

export function useSubjectsListQuery(options?: Omit<Urql.UseQueryArgs<SubjectsListQueryVariables>, 'query'>) {
  return Urql.useQuery<SubjectsListQuery, SubjectsListQueryVariables>({ query: SubjectsListDocument, ...options });
}
export const UpdateSubstitutionSettingsDocument = gql`
    mutation updateSubstitutionSettings($organizationUuid: ID!, $update: OrganizationUpdateInput) {
  updateOrganizations(where: {uuid: $organizationUuid}, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateSubstitutionSettingsMutation() {
  return Urql.useMutation<UpdateSubstitutionSettingsMutation, UpdateSubstitutionSettingsMutationVariables>(
    UpdateSubstitutionSettingsDocument,
  );
}
export const TeachersSubstitutionsDocument = gql`
    query TeachersSubstitutions($organizationUuid: ID!, $classUuids: [ID!]!, $schoolYearUuid: ID!, $subjectUuid: String) {
  teachersSubstitutions(
    organizationUuid: $organizationUuid
    classUuids: $classUuids
    schoolYearUuid: $schoolYearUuid
    subjectUuid: $subjectUuid
  ) {
    givenSubstituteHours
    sameClass
    sameSubject
    substituteHours
    teacherUuid
  }
}
    `;

export function useTeachersSubstitutionsQuery(
  options: Omit<Urql.UseQueryArgs<TeachersSubstitutionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachersSubstitutionsQuery, TeachersSubstitutionsQueryVariables>({
    query: TeachersSubstitutionsDocument,
    ...options,
  });
}
export const SubstitutionAnnouncementsDocument = gql`
    query SubstitutionAnnouncements($selectedDay: Date!) {
  substitutionAnnouncements(where: {date: $selectedDay}) {
    uuid
    date
    publicAnnouncement
    internalAnnouncement
  }
}
    `;

export function useSubstitutionAnnouncementsQuery(
  options: Omit<Urql.UseQueryArgs<SubstitutionAnnouncementsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionAnnouncementsQuery, SubstitutionAnnouncementsQueryVariables>({
    query: SubstitutionAnnouncementsDocument,
    ...options,
  });
}
export const CreateSubstitutionAnnouncementsDocument = gql`
    mutation CreateSubstitutionAnnouncements($input: SubstitutionAnnouncementCreateInput!) {
  createSubstitutionAnnouncements(input: [$input]) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateSubstitutionAnnouncementsMutation() {
  return Urql.useMutation<CreateSubstitutionAnnouncementsMutation, CreateSubstitutionAnnouncementsMutationVariables>(
    CreateSubstitutionAnnouncementsDocument,
  );
}
export const UpdateSubstitutionAnnouncementsDocument = gql`
    mutation UpdateSubstitutionAnnouncements($where: SubstitutionAnnouncementWhere!, $update: SubstitutionAnnouncementUpdateInput!) {
  updateSubstitutionAnnouncements(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateSubstitutionAnnouncementsMutation() {
  return Urql.useMutation<UpdateSubstitutionAnnouncementsMutation, UpdateSubstitutionAnnouncementsMutationVariables>(
    UpdateSubstitutionAnnouncementsDocument,
  );
}
export const SubstitutionPrintConfigsDocument = gql`
    query SubstitutionPrintConfigs($where: SubstitutionPrintConfigWhere!) {
  substitutionPrintConfigs(where: $where) {
    uuid
    showMissingTeachers
    showMissingTeachersShortName
    showAnnouncements
    showSchoolEvents
    useTeacherShortname
    pageOrientation
    printImages
    useLessonName
    lineScale
    fontScale
    columnConfigs {
      position
      column
      print
      width
      sortOrder
      sortDirection
    }
  }
}
    `;

export function useSubstitutionPrintConfigsQuery(
  options: Omit<Urql.UseQueryArgs<SubstitutionPrintConfigsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionPrintConfigsQuery, SubstitutionPrintConfigsQueryVariables>({
    query: SubstitutionPrintConfigsDocument,
    ...options,
  });
}
export const CreateSubstitutionPrintConfigsDocument = gql`
    mutation CreateSubstitutionPrintConfigs($input: SubstitutionPrintConfigCreateInput!) {
  createSubstitutionPrintConfigs(input: [$input]) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateSubstitutionPrintConfigsMutation() {
  return Urql.useMutation<CreateSubstitutionPrintConfigsMutation, CreateSubstitutionPrintConfigsMutationVariables>(
    CreateSubstitutionPrintConfigsDocument,
  );
}
export const UpdateSubstitutionPrintConfigsDocument = gql`
    mutation UpdateSubstitutionPrintConfigs($where: SubstitutionPrintConfigWhere!, $update: SubstitutionPrintConfigUpdateInput!) {
  updateSubstitutionPrintConfigs(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateSubstitutionPrintConfigsMutation() {
  return Urql.useMutation<UpdateSubstitutionPrintConfigsMutation, UpdateSubstitutionPrintConfigsMutationVariables>(
    UpdateSubstitutionPrintConfigsDocument,
  );
}
export const SubstitutionAppConfigsDocument = gql`
    query SubstitutionAppConfigs($where: SubstitutionAppConfigWhere!) {
  substitutionAppConfigs(where: $where) {
    uuid
    teacherPassword
    studentPassword
    allowIndividualLogins
    useTeacherShortname
    useClassShortname
    useRoomShortname
    timeDisplayMode
    showClassGroups
    showOriginalSubject
    showCurrentSubject
    showHolidays
  }
}
    `;

export function useSubstitutionAppConfigsQuery(
  options: Omit<Urql.UseQueryArgs<SubstitutionAppConfigsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionAppConfigsQuery, SubstitutionAppConfigsQueryVariables>({
    query: SubstitutionAppConfigsDocument,
    ...options,
  });
}
export const CreateSubstitutionAppConfigsDocument = gql`
    mutation CreateSubstitutionAppConfigs($input: SubstitutionAppConfigCreateInput!) {
  createSubstitutionAppConfigs(input: [$input]) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateSubstitutionAppConfigsMutation() {
  return Urql.useMutation<CreateSubstitutionAppConfigsMutation, CreateSubstitutionAppConfigsMutationVariables>(
    CreateSubstitutionAppConfigsDocument,
  );
}
export const UpdateSubstitutionAppConfigsDocument = gql`
    mutation UpdateSubstitutionAppConfigs($where: SubstitutionAppConfigWhere!, $update: SubstitutionAppConfigUpdateInput!) {
  updateSubstitutionAppConfigs(where: $where, update: $update) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useUpdateSubstitutionAppConfigsMutation() {
  return Urql.useMutation<UpdateSubstitutionAppConfigsMutation, UpdateSubstitutionAppConfigsMutationVariables>(
    UpdateSubstitutionAppConfigsDocument,
  );
}
export const SubstitutionReportDocument = gql`
    query SubstitutionReport($where: SubstitutionReportWhere!, $options: SubstitutionReportOptions) {
  substitutionReports(where: $where, options: $options) {
    uuid
    type
    title
    jobCreated
    jobFinished
    jobConfiguration
    context {
      ... on TeachingBlock {
        uuid
        name
      }
      ... on SchoolYear {
        uuid
        name
      }
      ... on TimetableBlock {
        uuid
        name
      }
    }
    fileEntries {
      uuid
      filename
      created
      updated
    }
  }
}
    `;

export function useSubstitutionReportQuery(
  options: Omit<Urql.UseQueryArgs<SubstitutionReportQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubstitutionReportQuery, SubstitutionReportQueryVariables>({
    query: SubstitutionReportDocument,
    ...options,
  });
}
export const AttendancePlanEventsDocument = gql`
    query AttendancePlanEvents($organizationUuid: ID!, $day: Date!) {
  attendancePlanEvents(organizationUuid: $organizationUuid, day: $day) {
    uuid
    start
    end
    subject {
      uuid
      shortName
      name
    }
    persons {
      __typename
      uuid
      displayName
      firstName
      lastName
      listName
      selectName
    }
    rooms {
      uuid
      name
    }
    class {
      uuid
      shortName
      name
    }
  }
}
    `;

export function useAttendancePlanEventsQuery(
  options: Omit<Urql.UseQueryArgs<AttendancePlanEventsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AttendancePlanEventsQuery, AttendancePlanEventsQueryVariables>({
    query: AttendancePlanEventsDocument,
    ...options,
  });
}
export const _CancelSynchronisationEventDocument = gql`
    mutation _CancelSynchronisationEvent($uuid: ID!, $update: EventJobUpdateInput) {
  updateEventJobs(where: {uuid: $uuid}, update: $update) {
    eventJobs {
      uuid
    }
  }
}
    `;

export function use_CancelSynchronisationEventMutation() {
  return Urql.useMutation<_CancelSynchronisationEventMutation, _CancelSynchronisationEventMutationVariables>(
    _CancelSynchronisationEventDocument,
  );
}
export const TeachingBlockClassGridCardsDocument = gql`
    query teachingBlockClassGridCards($teachingBlockVersionUuid: ID) {
  teachingBlockClassGridCards(
    where: {teachingBlockVersion: {uuid: $teachingBlockVersionUuid}}
  ) {
    uuid
    teachingBlockCardUuid
    classUuid
    lessonUuid
    divisionsCount
    usedPosition
    cssGradientString
    cssHeight
    cssTop
    textColor
    colors
    locked
    startDate
    endDate
    duration
    includeHoliday
  }
}
    `;

export function useTeachingBlockClassGridCardsQuery(
  options?: Omit<Urql.UseQueryArgs<TeachingBlockClassGridCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockClassGridCardsQuery, TeachingBlockClassGridCardsQueryVariables>({
    query: TeachingBlockClassGridCardsDocument,
    ...options,
  });
}
export const CreateTeachingBlockDocument = gql`
    mutation CreateTeachingBlock($input: [TeachingBlockCreateInput!]!) {
  createTeachingBlocks(input: $input) {
    teachingBlocks {
      uuid
    }
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateTeachingBlockMutation() {
  return Urql.useMutation<CreateTeachingBlockMutation, CreateTeachingBlockMutationVariables>(
    CreateTeachingBlockDocument,
  );
}
export const DeleteTeachingBlockDocument = gql`
    mutation DeleteTeachingBlock($delete: TeachingBlockDeleteInput) {
  deleteTeachingBlocks(delete: $delete) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockMutation() {
  return Urql.useMutation<DeleteTeachingBlockMutation, DeleteTeachingBlockMutationVariables>(
    DeleteTeachingBlockDocument,
  );
}
export const UpdateTeachingBlockDocument = gql`
    mutation UpdateTeachingBlock($update: TeachingBlockUpdateInput, $uuids: [ID!]!) {
  updateTeachingBlocks(update: $update, where: {uuid_IN: $uuids}) {
    teachingBlocks {
      uuid
      updatedAt
    }
  }
}
    `;

export function useUpdateTeachingBlockMutation() {
  return Urql.useMutation<UpdateTeachingBlockMutation, UpdateTeachingBlockMutationVariables>(
    UpdateTeachingBlockDocument,
  );
}
export const CreateTeachingBlockVersionsDocument = gql`
    mutation CreateTeachingBlockVersions($version: Int!, $rooms: TeachingBlockVersionRoomsFieldInput, $teachers: TeachingBlockVersionTeachersFieldInput, $classes: TeachingBlockVersionClassesFieldInput, $subjects: TeachingBlockVersionSubjectsFieldInput, $teachingBlock: TeachingBlockVersionTeachingBlockFieldInput, $cards: TeachingBlockVersionCardsFieldInput) {
  createTeachingBlockVersions(
    input: {version: $version, subjects: $subjects, rooms: $rooms, teachers: $teachers, classes: $classes, teachingBlock: $teachingBlock, cards: $cards}
  ) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateTeachingBlockVersionsMutation() {
  return Urql.useMutation<CreateTeachingBlockVersionsMutation, CreateTeachingBlockVersionsMutationVariables>(
    CreateTeachingBlockVersionsDocument,
  );
}
export const CreateBackendTeachingBlockVersionDocument = gql`
    mutation CreateBackendTeachingBlockVersion($subjectContainerUuid: ID!, $schoolYearUuid: ID!, $organizationUuid: ID!, $connectLessons: Boolean) {
  createBackendTeachingBlockVersion(
    organizationUuid: $organizationUuid
    schoolYearUuid: $schoolYearUuid
    subjectContainerUuid: $subjectContainerUuid
    connectLessons: $connectLessons
  ) {
    info {
      nodesCreated
    }
    teachingBlockVersions {
      uuid
    }
  }
}
    `;

export function useCreateBackendTeachingBlockVersionMutation() {
  return Urql.useMutation<
    CreateBackendTeachingBlockVersionMutation,
    CreateBackendTeachingBlockVersionMutationVariables
  >(CreateBackendTeachingBlockVersionDocument);
}
export const UpdateTeachingBlockVersionsDocument = gql`
    mutation UpdateTeachingBlockVersions($where: TeachingBlockVersionWhere!, $update: TeachingBlockVersionUpdateInput!) {
  updateTeachingBlockVersions(where: $where, update: $update) {
    teachingBlockVersions {
      uuid
    }
  }
}
    `;

export function useUpdateTeachingBlockVersionsMutation() {
  return Urql.useMutation<UpdateTeachingBlockVersionsMutation, UpdateTeachingBlockVersionsMutationVariables>(
    UpdateTeachingBlockVersionsDocument,
  );
}
export const DeleteTeachingBlockVersionsDocument = gql`
    mutation DeleteTeachingBlockVersions($versionUuids: [ID!]) {
  deleteTeachingBlockVersions(
    where: {uuid_IN: $versionUuids}
    delete: {cards: {where: {node: {teachingBlockVersion: {uuid_IN: $versionUuids}}}}, availabilityExclusions: {where: {node: {teachingBlockVersion: {uuid_IN: $versionUuids}}}}}
  ) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockVersionsMutation() {
  return Urql.useMutation<DeleteTeachingBlockVersionsMutation, DeleteTeachingBlockVersionsMutationVariables>(
    DeleteTeachingBlockVersionsDocument,
  );
}
export const DeleteTeachingBlockCardsDocument = gql`
    mutation DeleteTeachingBlockCards($where: TeachingBlockCardWhere, $delete: TeachingBlockCardDeleteInput) {
  deleteTeachingBlockCards(where: $where, delete: $delete) {
    nodesDeleted
  }
}
    `;

export function useDeleteTeachingBlockCardsMutation() {
  return Urql.useMutation<DeleteTeachingBlockCardsMutation, DeleteTeachingBlockCardsMutationVariables>(
    DeleteTeachingBlockCardsDocument,
  );
}
export const CreateTeachingBlockCardDocument = gql`
    mutation CreateTeachingBlockCard($versionUuid: ID!, $lessonUuid: ID!, $duration: Int!) {
  createTeachingBlockCards(
    input: {includeHoliday: false, teachingBlockVersion: {connect: {where: {node: {uuid: $versionUuid}}}}, lesson: {connect: {where: {node: {uuid: $lessonUuid}}}}, locked: false, duration: $duration}
  ) {
    teachingBlockCards {
      uuid
    }
  }
}
    `;

export function useCreateTeachingBlockCardMutation() {
  return Urql.useMutation<CreateTeachingBlockCardMutation, CreateTeachingBlockCardMutationVariables>(
    CreateTeachingBlockCardDocument,
  );
}
export const UpdateTeachingBlockCardsDocument = gql`
    mutation UpdateTeachingBlockCards($where: TeachingBlockCardWhere, $update: TeachingBlockCardUpdateInput) {
  updateTeachingBlockCards(where: $where, update: $update) {
    teachingBlockCards {
      uuid
    }
  }
}
    `;

export function useUpdateTeachingBlockCardsMutation() {
  return Urql.useMutation<UpdateTeachingBlockCardsMutation, UpdateTeachingBlockCardsMutationVariables>(
    UpdateTeachingBlockCardsDocument,
  );
}
export const DuplicateTeachingBlockVersionDocument = gql`
    mutation DuplicateTeachingBlockVersion($teachingBlockVersionUuid: ID!, $organizationUuid: ID!, $options: DuplicateTeachingBlockVersionOptions!) {
  duplicateTeachingBlockVersion(
    organizationUuid: $organizationUuid
    teachingBlockVersionUuid: $teachingBlockVersionUuid
    options: $options
  ) {
    active
    description
    uuid
    version
  }
}
    `;

export function useDuplicateTeachingBlockVersionMutation() {
  return Urql.useMutation<DuplicateTeachingBlockVersionMutation, DuplicateTeachingBlockVersionMutationVariables>(
    DuplicateTeachingBlockVersionDocument,
  );
}
export const TeachingBlockDraftDocument = gql`
    query TeachingBlockDraft($where: TeachingBlockWhere) {
  teachingBlocks(where: $where, options: {sort: [{updatedAt: DESC}]}) {
    uuid
    name
    subjectContainer {
      uuid
    }
    versions {
      uuid
      active
      version
      updatedAt
      createdAt
      description
      cardsAggregate {
        count
      }
    }
  }
}
    `;

export function useTeachingBlockDraftQuery(
  options?: Omit<Urql.UseQueryArgs<TeachingBlockDraftQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockDraftQuery, TeachingBlockDraftQueryVariables>({
    query: TeachingBlockDraftDocument,
    ...options,
  });
}
export const TeachingBlockCardsDocument = gql`
    query TeachingBlockCards($where: TeachingBlockCardWhere!) {
  teachingBlockCards(where: $where, options: {sort: [{duration: ASC}]}) {
    ...TeachingBlockCards
  }
}
    ${TeachingBlockCardsFragmentDoc}`;

export function useTeachingBlockCardsQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockCardsQuery, TeachingBlockCardsQueryVariables>({
    query: TeachingBlockCardsDocument,
    ...options,
  });
}
export const TeachingBlockVersionsDocument = gql`
    query TeachingBlockVersions($uuid: ID!) {
  teachingBlockVersions(where: {uuid: $uuid}) {
    uuid
    version
    description
    active
    cards(options: {sort: [{duration: ASC}]}) {
      ...TeachingBlockCards
    }
    teachingBlock {
      uuid
      name
      subjectContainer {
        uuid
      }
    }
    availabilityExclusions {
      uuid
      holder {
        __typename
        ... on Subject {
          uuid
        }
        ... on Person {
          uuid
        }
        ... on Class {
          uuid
        }
        ... on Room {
          uuid
        }
      }
      from
      to
      priority
      comment
    }
    classesConnection(
      sort: [{node: {grade: ASC}}, {node: {gradeGroupShortName: ASC}}, {node: {shortName: ASC}}]
    ) {
      edges {
        node {
          uuid
          name
          shortName
          grade
          gradeGroup {
            ...GradeGroup
          }
          certificatesEnabled
          timetableConfig {
            color
            colorLabel
            printOrder
            printPageNr
          }
          tutorsConnection(sort: {edge: {order: ASC}}) {
            edges {
              properties {
                order
              }
              node {
                uuid
                personalId
                email
                birthday
                firstName
                lastName
                fullName
                shortName
                displayNameShort
              }
            }
          }
        }
      }
    }
    subjectsConnection(sort: {node: {name: ASC}}) {
      edges {
        node {
          name
          uuid
          shortName
          subjectHourEnabled
          epochEnabled
          active
          other
          subjectGroup {
            name
          }
          timetableConfig {
            color
            colorLabel
          }
        }
      }
    }
    teachersConnection(sort: {node: {lastName: ASC}}) {
      edges {
        node {
          uuid
          personalId
          firstName
          lastName
          fullName
          shortName
          callingName
          prefixName
          uniqueFirstName
          salutation
          title
          email
          birthday
          gender
          active
          displayName
          displayNameShort
          timetableConfig {
            color
            colorLabel
          }
        }
      }
    }
    roomsConnection(sort: {node: {name: ASC}}) {
      edges {
        node {
          uuid
          name
          building {
            uuid
            name
          }
          position
          roomNumber
          description
          classroom
          canBeLeased
          capacity
          chairs
          tables
          size
          otherInventory
          barrierFree
          canBeDarkened
          hasProjector
          hasScreen
          hasMediaCabinet
          hasPiano
        }
      }
    }
    lessons {
      ...LessonFragment
    }
  }
}
    ${TeachingBlockCardsFragmentDoc}
${GradeGroupFragmentDoc}
${LessonFragmentFragmentDoc}`;

export function useTeachingBlockVersionsQuery(
  options: Omit<Urql.UseQueryArgs<TeachingBlockVersionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeachingBlockVersionsQuery, TeachingBlockVersionsQueryVariables>({
    query: TeachingBlockVersionsDocument,
    ...options,
  });
}
export const TeachingBlockDocument = gql`
    query TeachingBlock($where: TeachingBlockWhere, $organizationUuid: ID, $schoolyearUuid: ID) {
  teachingBlocks(where: $where) {
    __typename
    uuid
    name
    createdAt
    updatedAt
    draft
    comment
    schoolYear {
      uuid
    }
    subjectContainer {
      uuid
      name
      shortName
    }
    versions(options: {sort: {version: DESC}}) {
      __typename
      uuid
      version
      classes {
        uuid
      }
      classesConnection {
        edges {
          node {
            uuid
          }
          properties {
            constraints
          }
        }
      }
      lessons {
        uuid
      }
      teachers {
        uuid
      }
      teachersConnection {
        edges {
          node {
            uuid
          }
          properties {
            constraints
          }
        }
      }
      rooms {
        uuid
      }
      roomsConnection {
        edges {
          node {
            uuid
          }
          properties {
            constraints
          }
        }
      }
      subjectsConnection {
        edges {
          node {
            uuid
          }
          properties {
            constraints
          }
        }
      }
      subjects {
        uuid
      }
      availabilityExclusions {
        uuid
      }
    }
  }
  schoolYears(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {start: ASC}}
  ) {
    uuid
    name
    shortName
    start
    end
  }
  classes(
    where: {organization: {uuid: $organizationUuid}, schoolYear: {uuid: $schoolyearUuid}}
    options: {sort: {grade: ASC}}
  ) {
    grade
    uuid
    name
    shortName
  }
  rooms(where: {organization: {uuid: $organizationUuid}}) {
    uuid
    name
  }
  people(
    where: {organization: {uuid: $organizationUuid}, active: true}
    options: {sort: {lastName: ASC}}
  ) {
    uuid
    fullName
    displayNameShort
  }
  subjects(
    where: {organization: {uuid: $organizationUuid}, active: true}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
  }
  lessons(
    where: {organization: {uuid: $organizationUuid}, schoolYear: {uuid: $schoolyearUuid}}
  ) {
    uuid
    roomSupplyAggregate {
      count
    }
    roomSupply {
      uuid
    }
    lessonUnit {
      count
      duration
      uuid
      subjectContainer {
        uuid
      }
    }
  }
}
    `;

export function useTeachingBlockQuery(options?: Omit<Urql.UseQueryArgs<TeachingBlockQueryVariables>, 'query'>) {
  return Urql.useQuery<TeachingBlockQuery, TeachingBlockQueryVariables>({ query: TeachingBlockDocument, ...options });
}
export const DeleteTimeGridEntryDocument = gql`
    mutation deleteTimeGridEntry($uuid: ID!) {
  deleteTimeGridEntries(where: {uuid: $uuid}) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimeGridEntryMutation() {
  return Urql.useMutation<DeleteTimeGridEntryMutation, DeleteTimeGridEntryMutationVariables>(
    DeleteTimeGridEntryDocument,
  );
}
export const UpdateTimeGridEntryDocument = gql`
    mutation updateTimeGridEntry($uuid: ID!, $update: TimeGridEntryUpdateInput!) {
  updateTimeGridEntries(where: {uuid: $uuid}, update: $update) {
    timeGridEntries {
      ...timeGridEntry
    }
  }
}
    ${TimeGridEntryFragmentDoc}`;

export function useUpdateTimeGridEntryMutation() {
  return Urql.useMutation<UpdateTimeGridEntryMutation, UpdateTimeGridEntryMutationVariables>(
    UpdateTimeGridEntryDocument,
  );
}
export const UpdateTimeGridEntriesDocument = gql`
    mutation updateTimeGridEntries($where: TimeGridEntryWhere, $update: TimeGridEntryUpdateInput!) {
  updateTimeGridEntries(where: $where, update: $update) {
    timeGridEntries {
      ...timeGridEntry
    }
  }
}
    ${TimeGridEntryFragmentDoc}`;

export function useUpdateTimeGridEntriesMutation() {
  return Urql.useMutation<UpdateTimeGridEntriesMutation, UpdateTimeGridEntriesMutationVariables>(
    UpdateTimeGridEntriesDocument,
  );
}
export const CreateTimeGridEntryDocument = gql`
    mutation createTimeGridEntry($input: [TimeGridEntryCreateInput!]!) {
  createTimeGridEntries(input: $input) {
    timeGridEntries {
      ...timeGridEntry
    }
  }
}
    ${TimeGridEntryFragmentDoc}`;

export function useCreateTimeGridEntryMutation() {
  return Urql.useMutation<CreateTimeGridEntryMutation, CreateTimeGridEntryMutationVariables>(
    CreateTimeGridEntryDocument,
  );
}
export const DeleteTimeGridDocument = gql`
    mutation deleteTimeGrid($uuid: ID!) {
  deleteTimeGrids(where: {uuid: $uuid}) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimeGridMutation() {
  return Urql.useMutation<DeleteTimeGridMutation, DeleteTimeGridMutationVariables>(DeleteTimeGridDocument);
}
export const UpdateTimeGridDocument = gql`
    mutation updateTimeGrid($uuid: ID!, $update: TimeGridUpdateInput!) {
  updateTimeGrids(where: {uuid: $uuid}, update: $update) {
    timeGrids {
      ...timeGrid
    }
  }
}
    ${TimeGridFragmentDoc}`;

export function useUpdateTimeGridMutation() {
  return Urql.useMutation<UpdateTimeGridMutation, UpdateTimeGridMutationVariables>(UpdateTimeGridDocument);
}
export const CreateTimeGridDocument = gql`
    mutation createTimeGrid($input: [TimeGridCreateInput!]!) {
  createTimeGrids(input: $input) {
    timeGrids {
      ...timeGrid
    }
  }
}
    ${TimeGridFragmentDoc}`;

export function useCreateTimeGridMutation() {
  return Urql.useMutation<CreateTimeGridMutation, CreateTimeGridMutationVariables>(CreateTimeGridDocument);
}
export const TimeGridEntriesByTimeGridDocument = gql`
    query TimeGridEntriesByTimeGrid($timeGridUuid: ID) {
  timeGridEntries(
    where: {timeGrid: {uuid: $timeGridUuid}}
    options: {sort: {start: ASC}}
  ) {
    ...timeGridEntry
  }
}
    ${TimeGridEntryFragmentDoc}`;

export function useTimeGridEntriesByTimeGridQuery(
  options?: Omit<Urql.UseQueryArgs<TimeGridEntriesByTimeGridQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimeGridEntriesByTimeGridQuery, TimeGridEntriesByTimeGridQueryVariables>({
    query: TimeGridEntriesByTimeGridDocument,
    ...options,
  });
}
export const TimeGridEntryDocument = gql`
    query TimeGridEntry($timeGridEntriesUuids: [ID!]!) {
  timeGridEntries(where: {uuid_IN: $timeGridEntriesUuids}) {
    ...timeGridEntry
  }
}
    ${TimeGridEntryFragmentDoc}`;

export function useTimeGridEntryQuery(options: Omit<Urql.UseQueryArgs<TimeGridEntryQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeGridEntryQuery, TimeGridEntryQueryVariables>({ query: TimeGridEntryDocument, ...options });
}
export const TimeGridDocument = gql`
    query TimeGrid($organizationUuid: ID, $timeGridUuid: ID) {
  timeGrids(
    where: {organization: {uuid: $organizationUuid}, uuid: $timeGridUuid}
    options: {sort: {name: ASC}}
  ) {
    ...timeGrid
  }
}
    ${TimeGridFragmentDoc}`;

export function useTimeGridQuery(options?: Omit<Urql.UseQueryArgs<TimeGridQueryVariables>, 'query'>) {
  return Urql.useQuery<TimeGridQuery, TimeGridQueryVariables>({ query: TimeGridDocument, ...options });
}
export const CreateTimetableDocument = gql`
    mutation createTimetable($input: [TimetableCreateInput!]!) {
  createTimetables(input: $input) {
    timetables {
      uuid
    }
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateTimetableMutation() {
  return Urql.useMutation<CreateTimetableMutation, CreateTimetableMutationVariables>(CreateTimetableDocument);
}
export const DeleteTimetableDocument = gql`
    mutation deleteTimetable($uuids: [ID!]!) {
  deleteTimetables(
    where: {uuid_IN: $uuids}
    delete: {versions: {where: {node: {timetable: {uuid_IN: $uuids}}}, delete: {cards: {where: {node: {timetableVersion: {timetable: {uuid_IN: $uuids}}}}}}}}
  ) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimetableMutation() {
  return Urql.useMutation<DeleteTimetableMutation, DeleteTimetableMutationVariables>(DeleteTimetableDocument);
}
export const UpdateTimetableDocument = gql`
    mutation updateTimetable($uuids: [ID!]!, $update: TimetableUpdateInput) {
  updateTimetables(where: {uuid_IN: $uuids}, update: $update) {
    timetables {
      uuid
      draft
      name
      comment
      schoolYear {
        uuid
      }
      versions {
        uuid
      }
    }
  }
}
    `;

export function useUpdateTimetableMutation() {
  return Urql.useMutation<UpdateTimetableMutation, UpdateTimetableMutationVariables>(UpdateTimetableDocument);
}
export const TimetableDocument = gql`
    query Timetable($where: TimetableWhere, $organizationUuid: ID, $schoolyearUuid: ID) {
  timetables(where: $where, options: {sort: [{updatedAt: DESC}]}) {
    uuid
    draft
    name
    comment
    createdAt
    updatedAt
    schoolYear {
      uuid
      name
      start
      end
    }
    timegridConfigs {
      timegrid {
        uuid
        name
      }
      classes {
        uuid
        name
        shortName
        grade
      }
    }
    versions(options: {sort: {version: DESC}}) {
      uuid
      version
      description
      classes {
        uuid
      }
      lessons {
        uuid
      }
      teachers {
        uuid
      }
      rooms {
        uuid
      }
      subjects {
        uuid
      }
    }
  }
  schoolYears(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {start: ASC}}
  ) {
    uuid
    name
    shortName
    start
    end
  }
  timeGrids(
    where: {organization: {uuid: $organizationUuid}}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
  }
  classes(
    where: {organization: {uuid: $organizationUuid}, schoolYear: {uuid: $schoolyearUuid}}
    options: {sort: {grade: ASC}}
  ) {
    grade
    uuid
    name
    shortName
  }
  rooms(where: {organization: {uuid: $organizationUuid}}) {
    uuid
    name
  }
  people(
    where: {organization: {uuid: $organizationUuid}, active: true}
    options: {sort: {lastName: ASC}}
  ) {
    uuid
    fullName
    displayNameShort
  }
  subjects(
    where: {organization: {uuid: $organizationUuid}, active: true}
    options: {sort: {name: ASC}}
  ) {
    uuid
    name
  }
  lessons(
    where: {organization: {uuid: $organizationUuid}, schoolYear: {uuid: $schoolyearUuid}}
  ) {
    uuid
    roomSupplyAggregate {
      count
    }
    roomSupply {
      uuid
    }
    lessonUnit {
      count
      duration
      uuid
      subjectContainer {
        uuid
      }
    }
  }
}
    `;

export function useTimetableQuery(options?: Omit<Urql.UseQueryArgs<TimetableQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableQuery, TimetableQueryVariables>({ query: TimetableDocument, ...options });
}
export const TimetableDraftDocument = gql`
    query TimetableDraft($draftUuid: ID!) {
  timetables(where: {uuid: $draftUuid}, options: {sort: [{updatedAt: DESC}]}) {
    uuid
    name
    timegridConfigsConnection {
      edges {
        properties {
          order
        }
        node {
          timegrid {
            uuid
          }
          classes {
            uuid
          }
        }
      }
    }
    versions {
      uuid
      active
      editable
      version
      updatedAt
      createdAt
      description
      isSnapshot
      cardsAggregate {
        count
      }
      original {
        uuid
      }
      placedCardsCount
      parent {
        uuid
      }
    }
  }
}
    `;

export function useTimetableDraftQuery(options: Omit<Urql.UseQueryArgs<TimetableDraftQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableDraftQuery, TimetableDraftQueryVariables>({
    query: TimetableDraftDocument,
    ...options,
  });
}
export const CreateTimetableBlocksDocument = gql`
    mutation createTimetableBlocks($input: [TimetableBlockCreateInput!]!) {
  createTimetableBlocks(input: $input) {
    info {
      nodesCreated
      relationshipsCreated
    }
  }
}
    `;

export function useCreateTimetableBlocksMutation() {
  return Urql.useMutation<CreateTimetableBlocksMutation, CreateTimetableBlocksMutationVariables>(
    CreateTimetableBlocksDocument,
  );
}
export const UpdateTimetableBlocksDocument = gql`
    mutation updateTimetableBlocks($update: TimetableBlockUpdateInput!, $uuid: ID!) {
  updateTimetableBlocks(update: $update, where: {uuid: $uuid}) {
    info {
      nodesCreated
      relationshipsCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateTimetableBlocksMutation() {
  return Urql.useMutation<UpdateTimetableBlocksMutation, UpdateTimetableBlocksMutationVariables>(
    UpdateTimetableBlocksDocument,
  );
}
export const DeleteTimetableBlocksDocument = gql`
    mutation deleteTimetableBlocks($where: TimetableBlockWhere) {
  deleteTimetableBlocks(where: $where) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimetableBlocksMutation() {
  return Urql.useMutation<DeleteTimetableBlocksMutation, DeleteTimetableBlocksMutationVariables>(
    DeleteTimetableBlocksDocument,
  );
}
export const TimetableBlocksDocument = gql`
    query TimetableBlocks($where: TimetableBlockWhere, $options: TimetableBlockOptions) {
  timetableBlocks(where: $where, options: $options) {
    uuid
    name
    schoolYear {
      uuid
      start
      end
    }
    end
    start
    teachingLoadFactor
    teachingLoadComment
    teachingLoadCalculated
    timetables {
      uuid
      name
      schoolYear {
        uuid
        start
        end
      }
      versions {
        uuid
        active
        classes {
          uuid
        }
      }
    }
  }
}
    `;

export function useTimetableBlocksQuery(options?: Omit<Urql.UseQueryArgs<TimetableBlocksQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableBlocksQuery, TimetableBlocksQueryVariables>({
    query: TimetableBlocksDocument,
    ...options,
  });
}
export const CreateTimetableVersionsDocument = gql`
    mutation CreateTimetableVersions($version: Int!, $rooms: TimetableVersionRoomsFieldInput, $teachers: TimetableVersionTeachersFieldInput, $classes: TimetableVersionClassesFieldInput, $subjects: TimetableVersionSubjectsFieldInput, $timetable: TimetableVersionTimetableFieldInput, $cards: TimetableVersionCardsFieldInput) {
  createTimetableVersions(
    input: {version: $version, subjects: $subjects, rooms: $rooms, teachers: $teachers, classes: $classes, timetable: $timetable, cards: $cards}
  ) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateTimetableVersionsMutation() {
  return Urql.useMutation<CreateTimetableVersionsMutation, CreateTimetableVersionsMutationVariables>(
    CreateTimetableVersionsDocument,
  );
}
export const UpdateTimetableVersionDocument = gql`
    mutation UpdateTimetableVersion($versionUuids: [ID!]!, $update: TimetableVersionUpdateInput) {
  updateTimetableVersions(where: {uuid_IN: $versionUuids}, update: $update) {
    info {
      __typename
    }
  }
}
    `;

export function useUpdateTimetableVersionMutation() {
  return Urql.useMutation<UpdateTimetableVersionMutation, UpdateTimetableVersionMutationVariables>(
    UpdateTimetableVersionDocument,
  );
}
export const SetTimetableVersionsInactiveDocument = gql`
    mutation SetTimetableVersionsInactive($timetableUuid: ID!) {
  updateTimetableVersions(
    where: {timetable: {uuid: $timetableUuid}}
    update: {active: false}
  ) {
    info {
      __typename
    }
  }
}
    `;

export function useSetTimetableVersionsInactiveMutation() {
  return Urql.useMutation<SetTimetableVersionsInactiveMutation, SetTimetableVersionsInactiveMutationVariables>(
    SetTimetableVersionsInactiveDocument,
  );
}
export const DeleteTimetableVersionsDocument = gql`
    mutation DeleteTimetableVersions($versionUuids: [ID!]) {
  deleteTimetableVersions(
    where: {uuid_IN: $versionUuids}
    delete: {cards: {where: {node: {timetableVersion: {uuid_IN: $versionUuids}}}}}
  ) {
    nodesDeleted
  }
}
    `;

export function useDeleteTimetableVersionsMutation() {
  return Urql.useMutation<DeleteTimetableVersionsMutation, DeleteTimetableVersionsMutationVariables>(
    DeleteTimetableVersionsDocument,
  );
}
export const UpdateTimetableVersionSubjectAvailabilityDocument = gql`
    mutation UpdateTimetableVersionSubjectAvailability($versionUuid: ID!, $subjectUuid: ID!, $data: TimetableRelationshipPropertiesUpdateInput) {
  updateTimetableVersions(
    where: {uuid: $versionUuid}
    update: {subjects: {where: {node: {uuid: $subjectUuid}}, update: {edge: $data}}}
  ) {
    info {
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateTimetableVersionSubjectAvailabilityMutation() {
  return Urql.useMutation<
    UpdateTimetableVersionSubjectAvailabilityMutation,
    UpdateTimetableVersionSubjectAvailabilityMutationVariables
  >(UpdateTimetableVersionSubjectAvailabilityDocument);
}
export const UpdateTimetableVersionRoomAvailabilityDocument = gql`
    mutation UpdateTimetableVersionRoomAvailability($versionUuid: ID!, $roomUuid: ID!, $data: TimetableRelationshipPropertiesUpdateInput) {
  updateTimetableVersions(
    where: {uuid: $versionUuid}
    update: {rooms: {where: {node: {uuid: $roomUuid}}, update: {edge: $data}}}
  ) {
    info {
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateTimetableVersionRoomAvailabilityMutation() {
  return Urql.useMutation<
    UpdateTimetableVersionRoomAvailabilityMutation,
    UpdateTimetableVersionRoomAvailabilityMutationVariables
  >(UpdateTimetableVersionRoomAvailabilityDocument);
}
export const UpdateTimetableVersionClassAvailabilityDocument = gql`
    mutation UpdateTimetableVersionClassAvailability($versionUuid: ID!, $classUuid: ID!, $data: TimetableRelationshipPropertiesUpdateInput) {
  updateTimetableVersions(
    where: {uuid: $versionUuid}
    update: {classes: {where: {node: {uuid: $classUuid}}, update: {edge: $data}}}
  ) {
    info {
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateTimetableVersionClassAvailabilityMutation() {
  return Urql.useMutation<
    UpdateTimetableVersionClassAvailabilityMutation,
    UpdateTimetableVersionClassAvailabilityMutationVariables
  >(UpdateTimetableVersionClassAvailabilityDocument);
}
export const UpdateTimetableVersionClassConditionsDocument = gql`
    mutation UpdateTimetableVersionClassConditions($versionUuid: ID!, $classUuid: ID!, $data: String!) {
  updateTimetableVersions(
    where: {uuid: $versionUuid}
    update: {classes: {where: {node: {uuid: $classUuid}}, update: {edge: {constraints: $data}}}}
  ) {
    info {
      __typename
    }
  }
}
    `;

export function useUpdateTimetableVersionClassConditionsMutation() {
  return Urql.useMutation<
    UpdateTimetableVersionClassConditionsMutation,
    UpdateTimetableVersionClassConditionsMutationVariables
  >(UpdateTimetableVersionClassConditionsDocument);
}
export const UpdateTimetableVersionTeachersAvailabilityDocument = gql`
    mutation UpdateTimetableVersionTeachersAvailability($versionUuid: ID!, $uuid: ID!, $data: TimetableRelationshipPropertiesUpdateInput) {
  updateTimetableVersions(
    where: {uuid: $versionUuid}
    update: {teachers: {where: {node: {uuid: $uuid}}, update: {edge: $data}}}
  ) {
    info {
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateTimetableVersionTeachersAvailabilityMutation() {
  return Urql.useMutation<
    UpdateTimetableVersionTeachersAvailabilityMutation,
    UpdateTimetableVersionTeachersAvailabilityMutationVariables
  >(UpdateTimetableVersionTeachersAvailabilityDocument);
}
export const UpdateCardDocument = gql`
    mutation UpdateCard($cardUuid: ID!, $card: TimetableCardUpdateInput) {
  updateTimetableCards(where: {uuid: $cardUuid}, update: $card) {
    info {
      __typename
    }
  }
}
    `;

export function useUpdateCardMutation() {
  return Urql.useMutation<UpdateCardMutation, UpdateCardMutationVariables>(UpdateCardDocument);
}
export const UpdateCardsDocument = gql`
    mutation UpdateCards($where: TimetableCardWhere, $update: TimetableCardUpdateInput) {
  updateTimetableCards(where: $where, update: $update) {
    info {
      __typename
    }
  }
}
    `;

export function useUpdateCardsMutation() {
  return Urql.useMutation<UpdateCardsMutation, UpdateCardsMutationVariables>(UpdateCardsDocument);
}
export const DeleteCardsByUuidDocument = gql`
    mutation DeleteCardsByUuid($cardUuids: [ID!]) {
  deleteTimetableCards(where: {uuid_IN: $cardUuids}) {
    nodesDeleted
  }
}
    `;

export function useDeleteCardsByUuidMutation() {
  return Urql.useMutation<DeleteCardsByUuidMutation, DeleteCardsByUuidMutationVariables>(DeleteCardsByUuidDocument);
}
export const DeleteCardsDocument = gql`
    mutation DeleteCards($where: TimetableCardWhere, $delete: TimetableCardDeleteInput) {
  deleteTimetableCards(where: $where, delete: $delete) {
    nodesDeleted
  }
}
    `;

export function useDeleteCardsMutation() {
  return Urql.useMutation<DeleteCardsMutation, DeleteCardsMutationVariables>(DeleteCardsDocument);
}
export const CreateCardDocument = gql`
    mutation CreateCard($versionUuid: ID!, $lessonUuid: ID!, $duration: Int!) {
  createTimetableCards(
    input: {timetableVersion: {connect: {where: {node: {uuid: $versionUuid}}}}, lesson: {connect: {where: {node: {uuid: $lessonUuid}}}}, locked: false, duration: $duration}
  ) {
    timetableCards {
      uuid
    }
  }
}
    `;

export function useCreateCardMutation() {
  return Urql.useMutation<CreateCardMutation, CreateCardMutationVariables>(CreateCardDocument);
}
export const CreateSubjectContainerCardDocument = gql`
    mutation CreateSubjectContainerCard($versionUuid: ID!, $lessonUuid: ID!, $duration: Int!, $subjectContainerUuid: ID!) {
  createTimetableCards(
    input: {timetableVersion: {connect: {where: {node: {uuid: $versionUuid}}}}, lesson: {connect: {where: {node: {uuid: $lessonUuid}}}}, locked: false, duration: $duration, subjectContainer: {connect: {where: {node: {uuid: $subjectContainerUuid}}}}}
  ) {
    timetableCards {
      uuid
    }
  }
}
    `;

export function useCreateSubjectContainerCardMutation() {
  return Urql.useMutation<CreateSubjectContainerCardMutation, CreateSubjectContainerCardMutationVariables>(
    CreateSubjectContainerCardDocument,
  );
}
export const CreateTimetableVersionDocument = gql`
    mutation CreateTimetableVersion($timetableUuid: ID!, $organizationUuid: ID!) {
  createTimetableVersion(
    timetableUuid: $timetableUuid
    organizationUuid: $organizationUuid
  ) {
    info {
      nodesCreated
    }
  }
}
    `;

export function useCreateTimetableVersionMutation() {
  return Urql.useMutation<CreateTimetableVersionMutation, CreateTimetableVersionMutationVariables>(
    CreateTimetableVersionDocument,
  );
}
export const DuplicateTimetableVersionDocument = gql`
    mutation DuplicateTimetableVersion($timetableVersionUuid: ID!, $organizationUuid: ID!, $options: DuplicateTimetableVersionOptions!) {
  duplicateTimetableVersion(
    timetableVersionUuid: $timetableVersionUuid
    options: $options
    organizationUuid: $organizationUuid
  ) {
    active
    description
    uuid
    version
  }
}
    `;

export function useDuplicateTimetableVersionMutation() {
  return Urql.useMutation<DuplicateTimetableVersionMutation, DuplicateTimetableVersionMutationVariables>(
    DuplicateTimetableVersionDocument,
  );
}
export const UpdateTimetableVersionClassesDocument = gql`
    mutation UpdateTimetableVersionClasses($versionUuid: ID!, $classes: [TimetableVersionClassesUpdateFieldInput!]) {
  updateTimetableVersions(
    where: {uuid: $versionUuid}
    update: {classes: $classes}
  ) {
    info {
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateTimetableVersionClassesMutation() {
  return Urql.useMutation<UpdateTimetableVersionClassesMutation, UpdateTimetableVersionClassesMutationVariables>(
    UpdateTimetableVersionClassesDocument,
  );
}
export const UpdateTimetableVersionSubjectsDocument = gql`
    mutation UpdateTimetableVersionSubjects($versionUuid: ID!, $subjects: [TimetableVersionSubjectsUpdateFieldInput!]) {
  updateTimetableVersions(
    where: {uuid: $versionUuid}
    update: {subjects: $subjects}
  ) {
    info {
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateTimetableVersionSubjectsMutation() {
  return Urql.useMutation<UpdateTimetableVersionSubjectsMutation, UpdateTimetableVersionSubjectsMutationVariables>(
    UpdateTimetableVersionSubjectsDocument,
  );
}
export const TimetableCardsDocument = gql`
    query timetableCards($where: TimetableCardWhere, $options: TimetableCardOptions) {
  timetableCards(where: $where, options: $options) {
    ...Cards
  }
}
    ${CardsFragmentDoc}`;

export function useTimetableCardsQuery(options?: Omit<Urql.UseQueryArgs<TimetableCardsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableCardsQuery, TimetableCardsQueryVariables>({
    query: TimetableCardsDocument,
    ...options,
  });
}
export const TimetableCardAggregateDocument = gql`
    query timetableCardAggregate($where: TimetableCardWhere) {
  timetableCardsAggregate(where: $where) {
    count
  }
}
    `;

export function useTimetableCardAggregateQuery(
  options?: Omit<Urql.UseQueryArgs<TimetableCardAggregateQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableCardAggregateQuery, TimetableCardAggregateQueryVariables>({
    query: TimetableCardAggregateDocument,
    ...options,
  });
}
export const TimetableVersionsDocument = gql`
    query timetableVersions($uuid: ID!) {
  timetableVersions(where: {uuid: $uuid}) {
    uuid
    version
    description
    active
    cards(options: {sort: [{duration: ASC}]}) {
      ...Cards
    }
    timetable {
      uuid
      schoolYear {
        uuid
      }
      name
      monEnabled
      tueEnabled
      wedEnabled
      thuEnabled
      friEnabled
      satEnabled
      sunEnabled
      timegridConfigs {
        timegrid {
          ...timeGrid
        }
      }
    }
    classesConnection(
      sort: [{node: {grade: ASC}}, {node: {gradeGroupShortName: ASC}}, {node: {shortName: ASC}}]
    ) {
      edges {
        node {
          uuid
          name
          shortName
          grade
          gradeGroup {
            ...GradeGroup
          }
          certificatesEnabled
          timetableConfig {
            color
            colorLabel
            printOrder
            printPageNr
          }
          tutorsConnection(sort: {edge: {order: ASC}}) {
            edges {
              properties {
                order
              }
              node {
                uuid
                personalId
                email
                birthday
                firstName
                lastName
                fullName
                shortName
                displayNameShort
              }
            }
          }
        }
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
      }
    }
    subjectsConnection(sort: {node: {name: ASC}}) {
      edges {
        node {
          name
          uuid
          shortName
          subjectHourEnabled
          epochEnabled
          active
          other
          subjectGroup {
            name
          }
          timetableConfig {
            color
            colorLabel
          }
        }
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
      }
    }
    teachersConnection(sort: {node: {lastName: ASC}}) {
      edges {
        node {
          uuid
          personalId
          firstName
          lastName
          fullName
          shortName
          callingName
          prefixName
          uniqueFirstName
          salutation
          title
          email
          birthday
          gender
          active
          displayName
          displayNameShort
          timetableConfig {
            color
            colorLabel
          }
        }
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
      }
    }
    roomsConnection(sort: {node: {name: ASC}}) {
      edges {
        node {
          uuid
          name
          building {
            uuid
            name
          }
          position
          roomNumber
          description
          classroom
          canBeLeased
          capacity
          chairs
          tables
          size
          otherInventory
          barrierFree
          canBeDarkened
          hasProjector
          hasScreen
          hasMediaCabinet
          hasPiano
        }
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
      }
    }
    lessons {
      ...LessonFragment
    }
  }
}
    ${CardsFragmentDoc}
${TimeGridFragmentDoc}
${GradeGroupFragmentDoc}
${LessonFragmentFragmentDoc}`;

export function useTimetableVersionsQuery(options: Omit<Urql.UseQueryArgs<TimetableVersionsQueryVariables>, 'query'>) {
  return Urql.useQuery<TimetableVersionsQuery, TimetableVersionsQueryVariables>({
    query: TimetableVersionsDocument,
    ...options,
  });
}
export const ClassAvailabilityMatrixDocument = gql`
    query ClassAvailabilityMatrix($versionUuid: ID!, $uuid: ID) {
  timetableVersions(where: {uuid: $versionUuid}) {
    classesConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
        node {
          uuid
        }
      }
    }
  }
}
    `;

export function useClassAvailabilityMatrixQuery(
  options: Omit<Urql.UseQueryArgs<ClassAvailabilityMatrixQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ClassAvailabilityMatrixQuery, ClassAvailabilityMatrixQueryVariables>({
    query: ClassAvailabilityMatrixDocument,
    ...options,
  });
}
export const ClassConstraintsDocument = gql`
    query ClassConstraints($versionUuid: ID!, $uuid: ID!) {
  timetableVersions(where: {uuid: $versionUuid}) {
    classesConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          constraints
        }
      }
    }
  }
}
    `;

export function useClassConstraintsQuery(options: Omit<Urql.UseQueryArgs<ClassConstraintsQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassConstraintsQuery, ClassConstraintsQueryVariables>({
    query: ClassConstraintsDocument,
    ...options,
  });
}
export const SubjectAvailabilityMatrixDocument = gql`
    query SubjectAvailabilityMatrix($versionUuid: ID!, $uuid: ID) {
  timetableVersions(where: {uuid: $versionUuid}) {
    subjectsConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
        node {
          uuid
        }
      }
    }
  }
}
    `;

export function useSubjectAvailabilityMatrixQuery(
  options: Omit<Urql.UseQueryArgs<SubjectAvailabilityMatrixQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubjectAvailabilityMatrixQuery, SubjectAvailabilityMatrixQueryVariables>({
    query: SubjectAvailabilityMatrixDocument,
    ...options,
  });
}
export const SubjectConstraintsDocument = gql`
    query SubjectConstraints($versionUuid: ID!, $uuid: ID!) {
  timetableVersions(where: {uuid: $versionUuid}) {
    classesConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          constraints
        }
      }
    }
  }
}
    `;

export function useSubjectConstraintsQuery(
  options: Omit<Urql.UseQueryArgs<SubjectConstraintsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SubjectConstraintsQuery, SubjectConstraintsQueryVariables>({
    query: SubjectConstraintsDocument,
    ...options,
  });
}
export const TeacherAvailabilityMatrixDocument = gql`
    query TeacherAvailabilityMatrix($versionUuid: ID!, $uuid: ID) {
  timetableVersions(where: {uuid: $versionUuid}) {
    teachersConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
        node {
          uuid
        }
      }
    }
  }
}
    `;

export function useTeacherAvailabilityMatrixQuery(
  options: Omit<Urql.UseQueryArgs<TeacherAvailabilityMatrixQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeacherAvailabilityMatrixQuery, TeacherAvailabilityMatrixQueryVariables>({
    query: TeacherAvailabilityMatrixDocument,
    ...options,
  });
}
export const TeacherConstraintsDocument = gql`
    query TeacherConstraints($versionUuid: ID!, $uuid: ID!) {
  timetableVersions(where: {uuid: $versionUuid}) {
    classesConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          constraints
        }
      }
    }
  }
}
    `;

export function useTeacherConstraintsQuery(
  options: Omit<Urql.UseQueryArgs<TeacherConstraintsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TeacherConstraintsQuery, TeacherConstraintsQueryVariables>({
    query: TeacherConstraintsDocument,
    ...options,
  });
}
export const RoomAvailabilityMatrixDocument = gql`
    query RoomAvailabilityMatrix($versionUuid: ID!, $uuid: ID) {
  timetableVersions(where: {uuid: $versionUuid}) {
    roomsConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          mon
          tue
          wed
          thu
          fri
          sat
          sun
        }
        node {
          uuid
        }
      }
    }
  }
}
    `;

export function useRoomAvailabilityMatrixQuery(
  options: Omit<Urql.UseQueryArgs<RoomAvailabilityMatrixQueryVariables>, 'query'>,
) {
  return Urql.useQuery<RoomAvailabilityMatrixQuery, RoomAvailabilityMatrixQueryVariables>({
    query: RoomAvailabilityMatrixDocument,
    ...options,
  });
}
export const RoomConstraintsDocument = gql`
    query RoomConstraints($versionUuid: ID!, $uuid: ID!) {
  timetableVersions(where: {uuid: $versionUuid}) {
    classesConnection(where: {node: {uuid: $uuid}}) {
      edges {
        properties {
          constraints
        }
      }
    }
  }
}
    `;

export function useRoomConstraintsQuery(options: Omit<Urql.UseQueryArgs<RoomConstraintsQueryVariables>, 'query'>) {
  return Urql.useQuery<RoomConstraintsQuery, RoomConstraintsQueryVariables>({
    query: RoomConstraintsDocument,
    ...options,
  });
}
export const ClassConstraintsForClassesDocument = gql`
    query ClassConstraintsForClasses($versionUuid: ID!, $uuids: [ID!]) {
  timetableVersions(where: {uuid: $versionUuid}) {
    classesConnection(where: {node: {uuid_IN: $uuids}}) {
      edges {
        node {
          uuid
        }
        properties {
          constraints
        }
      }
    }
  }
}
    `;

export function useClassConstraintsForClassesQuery(
  options: Omit<Urql.UseQueryArgs<ClassConstraintsForClassesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ClassConstraintsForClassesQuery, ClassConstraintsForClassesQueryVariables>({
    query: ClassConstraintsForClassesDocument,
    ...options,
  });
}
export const TimetableVersionClassesDocument = gql`
    query timetableVersionClasses($uuid: ID!) {
  timetableVersions(where: {uuid: $uuid}) {
    __typename
    uuid
    version
    description
    active
    classes(options: {sort: [{grade: ASC}, {name: ASC}]}) {
      __typename
      timetableConfig {
        __typename
        color
      }
      uuid
      name
      shortName
      grade
      gradeGroup {
        ...GradeGroup
      }
    }
  }
}
    ${GradeGroupFragmentDoc}`;

export function useTimetableVersionClassesQuery(
  options: Omit<Urql.UseQueryArgs<TimetableVersionClassesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableVersionClassesQuery, TimetableVersionClassesQueryVariables>({
    query: TimetableVersionClassesDocument,
    ...options,
  });
}
export const AddUserDocument = gql`
    mutation addUser($frontendUri: String!, $planungPersonUuid: ID!, $organizationUuid: ID!, $email: String!, $profileUuid: ID, $permissions: [String!]) {
  addUser(
    frontendUri: $frontendUri
    planungPersonUuid: $planungPersonUuid
    organizationUuid: $organizationUuid
    email: $email
    profileUuid: $profileUuid
    permissions: $permissions
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useAddUserMutation() {
  return Urql.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument);
}
export const UpdateGrantedProfilesDocument = gql`
    mutation updateGrantedProfiles($organizationUuid: ID!, $profiles: [ID!]!, $roles: [String!]!, $frontendUri: String!) {
  updateGrantedProfiles(
    organizationUuid: $organizationUuid
    profiles: $profiles
    roles: $roles
    frontendUri: $frontendUri
  ) {
    entitiesUpdated
  }
}
    `;

export function useUpdateGrantedProfilesMutation() {
  return Urql.useMutation<UpdateGrantedProfilesMutation, UpdateGrantedProfilesMutationVariables>(
    UpdateGrantedProfilesDocument,
  );
}
export const UpdateUserPermissionsDocument = gql`
    mutation updateUserPermissions($organizationUuid: ID!, $profileUuid: ID!, $permissions: [String!]!) {
  updateUserPermissions(
    organizationUuid: $organizationUuid
    profileUuid: $profileUuid
    permissions: $permissions
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useUpdateUserPermissionsMutation() {
  return Urql.useMutation<UpdateUserPermissionsMutation, UpdateUserPermissionsMutationVariables>(
    UpdateUserPermissionsDocument,
  );
}
export const InviteUserDocument = gql`
    mutation inviteUser($frontendUri: String!, $organizationUuid: ID!, $email: String!, $profileUuid: ID!) {
  inviteUser(
    frontendUri: $frontendUri
    organizationUuid: $organizationUuid
    email: $email
    profileUuid: $profileUuid
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useInviteUserMutation() {
  return Urql.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument);
}
export const RemovePlanungAccessDocument = gql`
    mutation removePlanungAccess($organizationUuid: ID!, $profileUuid: ID!) {
  removePlanungAccess(
    organizationUuid: $organizationUuid
    profileUuid: $profileUuid
  ) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function useRemovePlanungAccessMutation() {
  return Urql.useMutation<RemovePlanungAccessMutation, RemovePlanungAccessMutationVariables>(
    RemovePlanungAccessDocument,
  );
}
export const PimProfilesDocument = gql`
    query pimProfiles($organizationUuid: ID!) {
  pimProfiles(organizationUuid: $organizationUuid) {
    uuid
    lastName
    firstName
    userStatus
    userEmail
    profileEmail
    role
    permissions
    accessGranted
    selectName
  }
}
    `;

export function usePimProfilesQuery(options: Omit<Urql.UseQueryArgs<PimProfilesQueryVariables>, 'query'>) {
  return Urql.useQuery<PimProfilesQuery, PimProfilesQueryVariables>({ query: PimProfilesDocument, ...options });
}
export const _TimetableVersionsDocument = gql`
    query _TimetableVersions($where: TimetableVersionWhere, $options: TimetableVersionOptions) {
  timetableVersions(where: $where, options: $options) {
    ..._TimetableVersion
  }
}
    ${_TimetableVersionFragmentDoc}`;

export function use_TimetableVersionsQuery(
  options?: Omit<Urql.UseQueryArgs<_TimetableVersionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_TimetableVersionsQuery, _TimetableVersionsQueryVariables>({
    query: _TimetableVersionsDocument,
    ...options,
  });
}
export const _SubstitutionFilterTimetableVersionsDocument = gql`
    query _SubstitutionFilterTimetableVersions($where: TimetableVersionWhere, $options: TimetableVersionOptions) {
  timetableVersions(where: $where, options: $options) {
    uuid
    timetable {
      __typename
      uuid
      name
    }
    classes {
      __typename
      uuid
    }
  }
}
    `;

export function use_SubstitutionFilterTimetableVersionsQuery(
  options?: Omit<Urql.UseQueryArgs<_SubstitutionFilterTimetableVersionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_SubstitutionFilterTimetableVersionsQuery, _SubstitutionFilterTimetableVersionsQueryVariables>({
    query: _SubstitutionFilterTimetableVersionsDocument,
    ...options,
  });
}
export const _TeachingBlockAvailabilityExclusionsDocument = gql`
    query _TeachingBlockAvailabilityExclusions($where: TeachingBlockAvailabilityExclusionWhere, $options: TeachingBlockAvailabilityExclusionOptions) {
  teachingBlockAvailabilityExclusions(where: $where, options: $options) {
    ..._TeachingBlockAvailabilityExclusionFragment
  }
}
    ${_TeachingBlockAvailabilityExclusionFragmentFragmentDoc}`;

export function use_TeachingBlockAvailabilityExclusionsQuery(
  options?: Omit<Urql.UseQueryArgs<_TeachingBlockAvailabilityExclusionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_TeachingBlockAvailabilityExclusionsQuery, _TeachingBlockAvailabilityExclusionsQueryVariables>({
    query: _TeachingBlockAvailabilityExclusionsDocument,
    ...options,
  });
}
export const _TimeGridsDocument = gql`
    query _TimeGrids($where: TimeGridWhere, $options: TimeGridOptions) {
  timeGrids(where: $where, options: $options) {
    ..._TimeGridFragment
  }
}
    ${_TimeGridFragmentFragmentDoc}`;

export function use_TimeGridsQuery(options?: Omit<Urql.UseQueryArgs<_TimeGridsQueryVariables>, 'query'>) {
  return Urql.useQuery<_TimeGridsQuery, _TimeGridsQueryVariables>({ query: _TimeGridsDocument, ...options });
}
export const _TimeGridEntriesDocument = gql`
    query _TimeGridEntries($where: TimeGridEntryWhere, $options: TimeGridEntryOptions) {
  timeGridEntries(where: $where, options: $options) {
    ..._TimeGridEntryFragment
  }
}
    ${_TimeGridEntryFragmentFragmentDoc}`;

export function use_TimeGridEntriesQuery(options?: Omit<Urql.UseQueryArgs<_TimeGridEntriesQueryVariables>, 'query'>) {
  return Urql.useQuery<_TimeGridEntriesQuery, _TimeGridEntriesQueryVariables>({
    query: _TimeGridEntriesDocument,
    ...options,
  });
}
export const _GradeGroupsDocument = gql`
    query _GradeGroups($where: GradeGroupWhere, $options: GradeGroupOptions) {
  gradeGroups(where: $where, options: $options) {
    ..._GradeGroupFragment
  }
}
    ${_GradeGroupFragmentFragmentDoc}`;

export function use_GradeGroupsQuery(options?: Omit<Urql.UseQueryArgs<_GradeGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<_GradeGroupsQuery, _GradeGroupsQueryVariables>({ query: _GradeGroupsDocument, ...options });
}
export const _ClassesDocument = gql`
    query _Classes($where: ClassWhere, $options: ClassOptions) {
  classes(where: $where, options: $options) {
    ..._ClassFragment
  }
}
    ${_ClassFragmentFragmentDoc}`;

export function use_ClassesQuery(options?: Omit<Urql.UseQueryArgs<_ClassesQueryVariables>, 'query'>) {
  return Urql.useQuery<_ClassesQuery, _ClassesQueryVariables>({ query: _ClassesDocument, ...options });
}
export const _SubjectsDocument = gql`
    query _Subjects($where: SubjectWhere, $options: SubjectOptions) {
  subjects(where: $where, options: $options) {
    ..._SubjectFragment
  }
}
    ${_SubjectFragmentFragmentDoc}`;

export function use_SubjectsQuery(options?: Omit<Urql.UseQueryArgs<_SubjectsQueryVariables>, 'query'>) {
  return Urql.useQuery<_SubjectsQuery, _SubjectsQueryVariables>({ query: _SubjectsDocument, ...options });
}
export const _SubjectContainersDocument = gql`
    query _SubjectContainers($where: SubjectContainerWhere, $options: SubjectContainerOptions) {
  subjectContainers(where: $where, options: $options) {
    ..._SubjectContainerFragment
  }
}
    ${_SubjectContainerFragmentFragmentDoc}`;

export function use_SubjectContainersQuery(
  options?: Omit<Urql.UseQueryArgs<_SubjectContainersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_SubjectContainersQuery, _SubjectContainersQueryVariables>({
    query: _SubjectContainersDocument,
    ...options,
  });
}
export const _PeopleDocument = gql`
    query _People($where: PersonWhere, $options: PersonOptions) {
  people(where: $where, options: $options) {
    ..._PersonFragment
  }
}
    ${_PersonFragmentFragmentDoc}`;

export function use_PeopleQuery(options?: Omit<Urql.UseQueryArgs<_PeopleQueryVariables>, 'query'>) {
  return Urql.useQuery<_PeopleQuery, _PeopleQueryVariables>({ query: _PeopleDocument, ...options });
}
export const _UsedInVersionLessonsDocument = gql`
    query _usedInVersionLessons($uuids: [ID!]!) {
  lessons(
    where: {uuid_IN: $uuids, OR: [{teachingBlockCardsAggregate: {NOT: {count: 0}}}, {timetableCardsAggregate: {NOT: {count: 0}}}]}
  ) {
    __typename
    uuid
    versions {
      __typename
      uuid
    }
    activeTimetables {
      __typename
      uuid
    }
  }
}
    `;

export function use_UsedInVersionLessonsQuery(
  options: Omit<Urql.UseQueryArgs<_UsedInVersionLessonsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_UsedInVersionLessonsQuery, _UsedInVersionLessonsQueryVariables>({
    query: _UsedInVersionLessonsDocument,
    ...options,
  });
}
export const _LessonsDocument = gql`
    query _Lessons($where: LessonWhere, $options: LessonOptions) {
  lessons(where: $where, options: $options) {
    ..._LessonFragment
  }
}
    ${_LessonFragmentFragmentDoc}`;

export function use_LessonsQuery(options?: Omit<Urql.UseQueryArgs<_LessonsQueryVariables>, 'query'>) {
  return Urql.useQuery<_LessonsQuery, _LessonsQueryVariables>({ query: _LessonsDocument, ...options });
}
export const _TimetableCardsDocument = gql`
    query _TimetableCards($where: TimetableCardWhere, $options: TimetableCardOptions) {
  timetableCards(where: $where, options: $options) {
    ..._TimetableCardFragment
  }
}
    ${_TimetableCardFragmentFragmentDoc}`;

export function use_TimetableCardsQuery(options?: Omit<Urql.UseQueryArgs<_TimetableCardsQueryVariables>, 'query'>) {
  return Urql.useQuery<_TimetableCardsQuery, _TimetableCardsQueryVariables>({
    query: _TimetableCardsDocument,
    ...options,
  });
}
export const _TeachingBlockCardsDocument = gql`
    query _TeachingBlockCards($where: TeachingBlockCardWhere, $options: TeachingBlockCardOptions) {
  teachingBlockCards(where: $where, options: $options) {
    ..._TeachingBlockCardFragment
  }
}
    ${_TeachingBlockCardFragmentFragmentDoc}`;

export function use_TeachingBlockCardsQuery(
  options?: Omit<Urql.UseQueryArgs<_TeachingBlockCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_TeachingBlockCardsQuery, _TeachingBlockCardsQueryVariables>({
    query: _TeachingBlockCardsDocument,
    ...options,
  });
}
export const _TeachingBlockVersionsDocument = gql`
    query _TeachingBlockVersions($where: TeachingBlockVersionWhere) {
  teachingBlockVersions(where: $where) {
    ..._TeachingBlockVersionsFragment
  }
}
    ${_TeachingBlockVersionsFragmentFragmentDoc}`;

export function use_TeachingBlockVersionsQuery(
  options?: Omit<Urql.UseQueryArgs<_TeachingBlockVersionsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_TeachingBlockVersionsQuery, _TeachingBlockVersionsQueryVariables>({
    query: _TeachingBlockVersionsDocument,
    ...options,
  });
}
export const _TeachingBlocksDocument = gql`
    query _TeachingBlocks($where: TeachingBlockWhere, $options: TeachingBlockOptions) {
  teachingBlocks(where: $where, options: $options) {
    ..._TeachingBlockFragment
  }
}
    ${_TeachingBlockFragmentFragmentDoc}`;

export function use_TeachingBlocksQuery(options?: Omit<Urql.UseQueryArgs<_TeachingBlocksQueryVariables>, 'query'>) {
  return Urql.useQuery<_TeachingBlocksQuery, _TeachingBlocksQueryVariables>({
    query: _TeachingBlocksDocument,
    ...options,
  });
}
export const _RoomsDocument = gql`
    query _Rooms($where: RoomWhere, $options: RoomOptions) {
  rooms(where: $where, options: $options) {
    ..._RoomFragment
  }
}
    ${_RoomFragmentFragmentDoc}`;

export function use_RoomsQuery(options?: Omit<Urql.UseQueryArgs<_RoomsQueryVariables>, 'query'>) {
  return Urql.useQuery<_RoomsQuery, _RoomsQueryVariables>({ query: _RoomsDocument, ...options });
}
export const _BuildingsDocument = gql`
    query _Buildings($where: BuildingWhere, $options: BuildingOptions) {
  buildings(where: $where, options: $options) {
    ..._BuildingFragment
  }
}
    ${_BuildingFragmentFragmentDoc}`;

export function use_BuildingsQuery(options?: Omit<Urql.UseQueryArgs<_BuildingsQueryVariables>, 'query'>) {
  return Urql.useQuery<_BuildingsQuery, _BuildingsQueryVariables>({ query: _BuildingsDocument, ...options });
}
export const _LessonUnitDocument = gql`
    query _LessonUnit($where: LessonUnitWhere, $options: LessonUnitOptions) {
  lessonUnits(where: $where, options: $options) {
    ..._LessonUnitFragment
  }
}
    ${_LessonUnitFragmentFragmentDoc}`;

export function use_LessonUnitQuery(options?: Omit<Urql.UseQueryArgs<_LessonUnitQueryVariables>, 'query'>) {
  return Urql.useQuery<_LessonUnitQuery, _LessonUnitQueryVariables>({ query: _LessonUnitDocument, ...options });
}
export const _DivisionsDocument = gql`
    query _Divisions($where: DivisionWhere, $options: DivisionOptions) {
  divisions(where: $where, options: $options) {
    ..._DivisionFragment
  }
}
    ${_DivisionFragmentFragmentDoc}`;

export function use_DivisionsQuery(options?: Omit<Urql.UseQueryArgs<_DivisionsQueryVariables>, 'query'>) {
  return Urql.useQuery<_DivisionsQuery, _DivisionsQueryVariables>({ query: _DivisionsDocument, ...options });
}
export const _GroupsDocument = gql`
    query _Groups($where: GroupWhere, $options: GroupOptions) {
  groups(where: $where, options: $options) {
    ..._GroupFragment
  }
}
    ${_GroupFragmentFragmentDoc}`;

export function use_GroupsQuery(options?: Omit<Urql.UseQueryArgs<_GroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<_GroupsQuery, _GroupsQueryVariables>({ query: _GroupsDocument, ...options });
}
export const _TimetableConfigDocument = gql`
    query _TimetableConfig($where: TimetableConfigWhere, $options: TimetableConfigOptions) {
  timetableConfigs(where: $where, options: $options) {
    ...TimetableConfigFragment
  }
}
    ${TimetableConfigFragmentFragmentDoc}`;

export function use_TimetableConfigQuery(options?: Omit<Urql.UseQueryArgs<_TimetableConfigQueryVariables>, 'query'>) {
  return Urql.useQuery<_TimetableConfigQuery, _TimetableConfigQueryVariables>({
    query: _TimetableConfigDocument,
    ...options,
  });
}
export const _ContractsDocument = gql`
    query _Contracts($where: ContractWhere, $options: ContractOptions) {
  contracts(where: $where, options: $options) {
    ..._ContractFragment
  }
}
    ${_ContractFragmentFragmentDoc}`;

export function use_ContractsQuery(options?: Omit<Urql.UseQueryArgs<_ContractsQueryVariables>, 'query'>) {
  return Urql.useQuery<_ContractsQuery, _ContractsQueryVariables>({ query: _ContractsDocument, ...options });
}
export const _QualificationsDocument = gql`
    query _Qualifications($where: QualificationWhere, $options: QualificationOptions) {
  qualifications(where: $where, options: $options) {
    ..._QualificationFragment
  }
}
    ${_QualificationFragmentFragmentDoc}`;

export function use_QualificationsQuery(options?: Omit<Urql.UseQueryArgs<_QualificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<_QualificationsQuery, _QualificationsQueryVariables>({
    query: _QualificationsDocument,
    ...options,
  });
}
export const _TimetablesDocument = gql`
    query _Timetables($where: TimetableWhere, $options: TimetableOptions) {
  timetables(where: $where, options: $options) {
    ..._Timetable
  }
}
    ${_TimetableFragmentDoc}`;

export function use_TimetablesQuery(options?: Omit<Urql.UseQueryArgs<_TimetablesQueryVariables>, 'query'>) {
  return Urql.useQuery<_TimetablesQuery, _TimetablesQueryVariables>({ query: _TimetablesDocument, ...options });
}
export const _LessonUnitsDocument = gql`
    query _LessonUnits($where: LessonUnitWhere, $options: LessonUnitOptions) {
  lessonUnits(where: $where, options: $options) {
    ..._LessonUnitFragment
  }
}
    ${_LessonUnitFragmentFragmentDoc}`;

export function use_LessonUnitsQuery(options?: Omit<Urql.UseQueryArgs<_LessonUnitsQueryVariables>, 'query'>) {
  return Urql.useQuery<_LessonUnitsQuery, _LessonUnitsQueryVariables>({ query: _LessonUnitsDocument, ...options });
}
export const _SchoolYearsDocument = gql`
    query _SchoolYears($where: SchoolYearWhere, $options: SchoolYearOptions) {
  schoolYears(where: $where, options: $options) {
    ..._SchoolYearFragment
  }
}
    ${_SchoolYearFragmentFragmentDoc}`;

export function use_SchoolYearsQuery(options?: Omit<Urql.UseQueryArgs<_SchoolYearsQueryVariables>, 'query'>) {
  return Urql.useQuery<_SchoolYearsQuery, _SchoolYearsQueryVariables>({ query: _SchoolYearsDocument, ...options });
}
export const _TimetableBlocksDocument = gql`
    query _TimetableBlocks($where: TimetableBlockWhere, $options: TimetableBlockOptions) {
  timetableBlocks(where: $where, options: $options) {
    ..._TimetableBlock
  }
}
    ${_TimetableBlockFragmentDoc}`;

export function use_TimetableBlocksQuery(options?: Omit<Urql.UseQueryArgs<_TimetableBlocksQueryVariables>, 'query'>) {
  return Urql.useQuery<_TimetableBlocksQuery, _TimetableBlocksQueryVariables>({
    query: _TimetableBlocksDocument,
    ...options,
  });
}
export const _TimetablePrintConfigsDocument = gql`
    query _TimetablePrintConfigs($where: TimetablePrintConfigWhere, $options: TimetablePrintConfigOptions) {
  timetablePrintConfigs(where: $where, options: $options) {
    ..._TimetablePrintConfig
  }
}
    ${_TimetablePrintConfigFragmentDoc}`;

export function use_TimetablePrintConfigsQuery(
  options?: Omit<Urql.UseQueryArgs<_TimetablePrintConfigsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<_TimetablePrintConfigsQuery, _TimetablePrintConfigsQueryVariables>({
    query: _TimetablePrintConfigsDocument,
    ...options,
  });
}
export const _CurriculumsDocument = gql`
    query _Curriculums($where: CurriculumWhere, $options: CurriculumOptions) {
  curricula(where: $where, options: $options) {
    ..._CurriculumFragment
  }
}
    ${_CurriculumFragmentFragmentDoc}`;

export function use_CurriculumsQuery(options?: Omit<Urql.UseQueryArgs<_CurriculumsQueryVariables>, 'query'>) {
  return Urql.useQuery<_CurriculumsQuery, _CurriculumsQueryVariables>({ query: _CurriculumsDocument, ...options });
}
export const _EventsDocument = gql`
    query _Events($where: EventWhere, $options: EventOptions) {
  events(where: $where, options: $options) {
    ..._Event
  }
}
    ${_EventFragmentDoc}`;

export function use_EventsQuery(options?: Omit<Urql.UseQueryArgs<_EventsQueryVariables>, 'query'>) {
  return Urql.useQuery<_EventsQuery, _EventsQueryVariables>({ query: _EventsDocument, ...options });
}
export const _EventsCountDocument = gql`
    query _EventsCount($where: EventWhere) {
  eventsConnection(where: $where) {
    totalCount
  }
}
    `;

export function use_EventsCountQuery(options?: Omit<Urql.UseQueryArgs<_EventsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<_EventsCountQuery, _EventsCountQueryVariables>({ query: _EventsCountDocument, ...options });
}
export const _SchoolEventsDocument = gql`
    query _SchoolEvents($organizationUuid: ID!, $from: Date!, $to: Date!) {
  schoolEvents(organizationUuid: $organizationUuid, from: $from, to: $to) {
    ..._SchoolEvent
  }
}
    ${_SchoolEventFragmentDoc}`;

export function use_SchoolEventsQuery(options: Omit<Urql.UseQueryArgs<_SchoolEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<_SchoolEventsQuery, _SchoolEventsQueryVariables>({ query: _SchoolEventsDocument, ...options });
}
export const _RecurringEventDocument = gql`
    query _RecurringEvent($where: RecurringEventWhere, $options: RecurringEventOptions) {
  recurringEvents(where: $where, options: $options) {
    __typename
    uuid
    futureEvents {
      uuid
    }
  }
}
    `;

export function use_RecurringEventQuery(options?: Omit<Urql.UseQueryArgs<_RecurringEventQueryVariables>, 'query'>) {
  return Urql.useQuery<_RecurringEventQuery, _RecurringEventQueryVariables>({
    query: _RecurringEventDocument,
    ...options,
  });
}
export const _CreateSingleSchoolEventDocument = gql`
    mutation _CreateSingleSchoolEvent($input: SchoolEventCreateInput!) {
  createSchoolEvent(input: $input) {
    __typename
    nodesCreated
    nodeUuids
  }
}
    `;

export function use_CreateSingleSchoolEventMutation() {
  return Urql.useMutation<_CreateSingleSchoolEventMutation, _CreateSingleSchoolEventMutationVariables>(
    _CreateSingleSchoolEventDocument,
  );
}
export const _CreateRecurringSchoolEventDocument = gql`
    mutation _CreateRecurringSchoolEvent($input: RecurrenceSchoolEventCreateInput!) {
  createRecurrenceSchoolEvents(input: $input) {
    nodeUuids
  }
}
    `;

export function use_CreateRecurringSchoolEventMutation() {
  return Urql.useMutation<_CreateRecurringSchoolEventMutation, _CreateRecurringSchoolEventMutationVariables>(
    _CreateRecurringSchoolEventDocument,
  );
}
export const _DeleteSchoolEventsDocument = gql`
    mutation _DeleteSchoolEvents($uuids: OnlyUuids!) {
  deleteSchoolEvents(where: $uuids) {
    __typename
    nodesDeleted
  }
}
    `;

export function use_DeleteSchoolEventsMutation() {
  return Urql.useMutation<_DeleteSchoolEventsMutation, _DeleteSchoolEventsMutationVariables>(
    _DeleteSchoolEventsDocument,
  );
}
export const _DeleteRecurrenceSchoolEventsDocument = gql`
    mutation _DeleteRecurrenceSchoolEvents($recurrenceUuid: ID!) {
  deleteRecurrenceSchoolEvents(recurrenceUuid: $recurrenceUuid) {
    nodesDeleted
    __typename
  }
}
    `;

export function use_DeleteRecurrenceSchoolEventsMutation() {
  return Urql.useMutation<_DeleteRecurrenceSchoolEventsMutation, _DeleteRecurrenceSchoolEventsMutationVariables>(
    _DeleteRecurrenceSchoolEventsDocument,
  );
}
export const _SetPrintEventDocument = gql`
    mutation _SetPrintEvent($eventUuid: ID!, $print: Boolean!) {
  setPrintEvent(eventUuid: $eventUuid, print: $print) {
    __typename
    entitiesUpdated
  }
}
    `;

export function use_SetPrintEventMutation() {
  return Urql.useMutation<_SetPrintEventMutation, _SetPrintEventMutationVariables>(_SetPrintEventDocument);
}
export const _SetSubstitutionDocument = gql`
    mutation _SetSubstitution($eventUuid: ID!, $coveringTeachers: [SetCoveringTeachersInput!]!, $substitutionComment: String, $rooms: [ID!]!) {
  setSubstitution(
    eventUuid: $eventUuid
    coveringTeachers: $coveringTeachers
    substitutionComment: $substitutionComment
    rooms: $rooms
  ) {
    __typename
  }
}
    `;

export function use_SetSubstitutionMutation() {
  return Urql.useMutation<_SetSubstitutionMutation, _SetSubstitutionMutationVariables>(_SetSubstitutionDocument);
}
export const _CancelEventDocument = gql`
    mutation _CancelEvent($eventUuid: ID!, $substitutionComment: String) {
  cancelEvent(eventUuid: $eventUuid, substitutionComment: $substitutionComment) {
    __typename
  }
}
    `;

export function use_CancelEventMutation() {
  return Urql.useMutation<_CancelEventMutation, _CancelEventMutationVariables>(_CancelEventDocument);
}
export const _SetSelfWorkEventDocument = gql`
    mutation _SetSelfWorkEvent($eventUuid: ID!, $substitutionComment: String, $rooms: [ID!]!) {
  setSelfWorkForEvent(
    eventUuid: $eventUuid
    substitutionComment: $substitutionComment
    rooms: $rooms
  ) {
    __typename
  }
}
    `;

export function use_SetSelfWorkEventMutation() {
  return Urql.useMutation<_SetSelfWorkEventMutation, _SetSelfWorkEventMutationVariables>(_SetSelfWorkEventDocument);
}
export const _ResetEventDocument = gql`
    mutation _ResetEvent($eventUuid: ID!) {
  resetEvent(eventUuid: $eventUuid) {
    __typename
  }
}
    `;

export function use_ResetEventMutation() {
  return Urql.useMutation<_ResetEventMutation, _ResetEventMutationVariables>(_ResetEventDocument);
}
export const _MergeEventsDocument = gql`
    mutation _MergeEvents($eventsToMerge: [ID!]!, $targetEvent: ID!, $rooms: [ID!]!, $substitutionComment: String) {
  mergeEvents(
    eventsToMerge: $eventsToMerge
    targetEvent: $targetEvent
    rooms: $rooms
    substitutionComment: $substitutionComment
  ) {
    __typename
  }
}
    `;

export function use_MergeEventsMutation() {
  return Urql.useMutation<_MergeEventsMutation, _MergeEventsMutationVariables>(_MergeEventsDocument);
}
export const _CreateTimetablePrintConfigsDocument = gql`
    mutation _CreateTimetablePrintConfigs($input: [TimetablePrintConfigCreateInput!]!) {
  createTimetablePrintConfigs(input: $input) {
    timetablePrintConfigs {
      ..._TimetablePrintConfig
    }
  }
}
    ${_TimetablePrintConfigFragmentDoc}`;

export function use_CreateTimetablePrintConfigsMutation() {
  return Urql.useMutation<_CreateTimetablePrintConfigsMutation, _CreateTimetablePrintConfigsMutationVariables>(
    _CreateTimetablePrintConfigsDocument,
  );
}
export const _UpdateTimetablePrintConfigsDocument = gql`
    mutation _UpdateTimetablePrintConfigs($where: TimetablePrintConfigWhere, $update: TimetablePrintConfigUpdateInput) {
  updateTimetablePrintConfigs(where: $where, update: $update) {
    timetablePrintConfigs {
      ..._TimetablePrintConfig
    }
  }
}
    ${_TimetablePrintConfigFragmentDoc}`;

export function use_UpdateTimetablePrintConfigsMutation() {
  return Urql.useMutation<_UpdateTimetablePrintConfigsMutation, _UpdateTimetablePrintConfigsMutationVariables>(
    _UpdateTimetablePrintConfigsDocument,
  );
}
export const _CreateTeachingBlockAvailabilityExclusionsDocument = gql`
    mutation _CreateTeachingBlockAvailabilityExclusions($input: [TeachingBlockAvailabilityExclusionCreateInput!]!) {
  createTeachingBlockAvailabilityExclusions(input: $input) {
    teachingBlockAvailabilityExclusions {
      ..._TeachingBlockAvailabilityExclusionFragment
    }
  }
}
    ${_TeachingBlockAvailabilityExclusionFragmentFragmentDoc}`;

export function use_CreateTeachingBlockAvailabilityExclusionsMutation() {
  return Urql.useMutation<
    _CreateTeachingBlockAvailabilityExclusionsMutation,
    _CreateTeachingBlockAvailabilityExclusionsMutationVariables
  >(_CreateTeachingBlockAvailabilityExclusionsDocument);
}
export const _UpdateTeachingBlockAvailabilityExclusionsDocument = gql`
    mutation _UpdateTeachingBlockAvailabilityExclusions($where: TeachingBlockAvailabilityExclusionWhere, $update: TeachingBlockAvailabilityExclusionUpdateInput) {
  updateTeachingBlockAvailabilityExclusions(where: $where, update: $update) {
    teachingBlockAvailabilityExclusions {
      ..._TeachingBlockAvailabilityExclusionFragment
    }
  }
}
    ${_TeachingBlockAvailabilityExclusionFragmentFragmentDoc}`;

export function use_UpdateTeachingBlockAvailabilityExclusionsMutation() {
  return Urql.useMutation<
    _UpdateTeachingBlockAvailabilityExclusionsMutation,
    _UpdateTeachingBlockAvailabilityExclusionsMutationVariables
  >(_UpdateTeachingBlockAvailabilityExclusionsDocument);
}
export const _DeleteTeachingBlockAvailabilityExclusionsDocument = gql`
    mutation _DeleteTeachingBlockAvailabilityExclusions($where: TeachingBlockAvailabilityExclusionWhere, $delete: TeachingBlockAvailabilityExclusionDeleteInput) {
  deleteTeachingBlockAvailabilityExclusions(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTeachingBlockAvailabilityExclusionsMutation() {
  return Urql.useMutation<
    _DeleteTeachingBlockAvailabilityExclusionsMutation,
    _DeleteTeachingBlockAvailabilityExclusionsMutationVariables
  >(_DeleteTeachingBlockAvailabilityExclusionsDocument);
}
export const _CreateTeachingBlockCardsDocument = gql`
    mutation _CreateTeachingBlockCards($input: [TeachingBlockCardCreateInput!]!) {
  createTeachingBlockCards(input: $input) {
    teachingBlockCards {
      ..._TeachingBlockCardFragment
    }
  }
}
    ${_TeachingBlockCardFragmentFragmentDoc}`;

export function use_CreateTeachingBlockCardsMutation() {
  return Urql.useMutation<_CreateTeachingBlockCardsMutation, _CreateTeachingBlockCardsMutationVariables>(
    _CreateTeachingBlockCardsDocument,
  );
}
export const _DeleteTeachingBlockCardsDocument = gql`
    mutation _DeleteTeachingBlockCards($where: TeachingBlockCardWhere, $delete: TeachingBlockCardDeleteInput) {
  deleteTeachingBlockCards(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTeachingBlockCardsMutation() {
  return Urql.useMutation<_DeleteTeachingBlockCardsMutation, _DeleteTeachingBlockCardsMutationVariables>(
    _DeleteTeachingBlockCardsDocument,
  );
}
export const _UpdateTeachingBlockCardsDocument = gql`
    mutation _UpdateTeachingBlockCards($where: TeachingBlockCardWhere, $update: TeachingBlockCardUpdateInput) {
  updateTeachingBlockCards(where: $where, update: $update) {
    teachingBlockCards {
      ..._TeachingBlockCardFragment
    }
  }
}
    ${_TeachingBlockCardFragmentFragmentDoc}`;

export function use_UpdateTeachingBlockCardsMutation() {
  return Urql.useMutation<_UpdateTeachingBlockCardsMutation, _UpdateTeachingBlockCardsMutationVariables>(
    _UpdateTeachingBlockCardsDocument,
  );
}
export const _DeleteTimetableCardsDocument = gql`
    mutation _DeleteTimetableCards($where: TimetableCardWhere, $delete: TimetableCardDeleteInput) {
  deleteTimetableCards(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTimetableCardsMutation() {
  return Urql.useMutation<_DeleteTimetableCardsMutation, _DeleteTimetableCardsMutationVariables>(
    _DeleteTimetableCardsDocument,
  );
}
export const _CreateTimetableCardsDocument = gql`
    mutation _CreateTimetableCards($input: [TimetableCardCreateInput!]!) {
  createTimetableCards(input: $input) {
    timetableCards {
      ..._TimetableCardFragment
    }
  }
}
    ${_TimetableCardFragmentFragmentDoc}`;

export function use_CreateTimetableCardsMutation() {
  return Urql.useMutation<_CreateTimetableCardsMutation, _CreateTimetableCardsMutationVariables>(
    _CreateTimetableCardsDocument,
  );
}
export const _UpdateLessonsDocument = gql`
    mutation _UpdateLessons($where: LessonWhere, $update: LessonUpdateInput) {
  updateLessons(where: $where, update: $update) {
    lessons {
      ..._LessonFragment
    }
  }
}
    ${_LessonFragmentFragmentDoc}`;

export function use_UpdateLessonsMutation() {
  return Urql.useMutation<_UpdateLessonsMutation, _UpdateLessonsMutationVariables>(_UpdateLessonsDocument);
}
export const _DeleteLessonsDocument = gql`
    mutation _DeleteLessons($where: LessonWhere, $delete: LessonDeleteInput) {
  deleteLessons(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteLessonsMutation() {
  return Urql.useMutation<_DeleteLessonsMutation, _DeleteLessonsMutationVariables>(_DeleteLessonsDocument);
}
export const _CreateLessonsDocument = gql`
    mutation _CreateLessons($input: [LessonCreateInput!]!) {
  createLessons(input: $input) {
    lessons {
      ..._LessonFragment
    }
  }
}
    ${_LessonFragmentFragmentDoc}`;

export function use_CreateLessonsMutation() {
  return Urql.useMutation<_CreateLessonsMutation, _CreateLessonsMutationVariables>(_CreateLessonsDocument);
}
export const _UpdateTeachingBlockVersionsDocument = gql`
    mutation _UpdateTeachingBlockVersions($where: TeachingBlockVersionWhere, $update: TeachingBlockVersionUpdateInput) {
  updateTeachingBlockVersions(where: $where, update: $update) {
    teachingBlockVersions {
      ..._TeachingBlockVersionsFragment
    }
  }
}
    ${_TeachingBlockVersionsFragmentFragmentDoc}`;

export function use_UpdateTeachingBlockVersionsMutation() {
  return Urql.useMutation<_UpdateTeachingBlockVersionsMutation, _UpdateTeachingBlockVersionsMutationVariables>(
    _UpdateTeachingBlockVersionsDocument,
  );
}
export const _DeleteTeachingBlockVersionsDocument = gql`
    mutation _DeleteTeachingBlockVersions($where: TeachingBlockVersionWhere, $delete: TeachingBlockVersionDeleteInput) {
  deleteTeachingBlockVersions(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTeachingBlockVersionsMutation() {
  return Urql.useMutation<_DeleteTeachingBlockVersionsMutation, _DeleteTeachingBlockVersionsMutationVariables>(
    _DeleteTeachingBlockVersionsDocument,
  );
}
export const _DeleteTeachingBlockAvailabilityExclusionDocument = gql`
    mutation _DeleteTeachingBlockAvailabilityExclusion($where: TeachingBlockAvailabilityExclusionWhere, $delete: TeachingBlockAvailabilityExclusionDeleteInput) {
  deleteTeachingBlockAvailabilityExclusions(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTeachingBlockAvailabilityExclusionMutation() {
  return Urql.useMutation<
    _DeleteTeachingBlockAvailabilityExclusionMutation,
    _DeleteTeachingBlockAvailabilityExclusionMutationVariables
  >(_DeleteTeachingBlockAvailabilityExclusionDocument);
}
export const _UpdateTeachingBlocksDocument = gql`
    mutation _UpdateTeachingBlocks($where: TeachingBlockWhere, $update: TeachingBlockUpdateInput) {
  updateTeachingBlocks(where: $where, update: $update) {
    teachingBlocks {
      ..._TeachingBlockFragment
    }
  }
}
    ${_TeachingBlockFragmentFragmentDoc}`;

export function use_UpdateTeachingBlocksMutation() {
  return Urql.useMutation<_UpdateTeachingBlocksMutation, _UpdateTeachingBlocksMutationVariables>(
    _UpdateTeachingBlocksDocument,
  );
}
export const _CreateTeachingBlocksDocument = gql`
    mutation _CreateTeachingBlocks($input: [TeachingBlockCreateInput!]!) {
  createTeachingBlocks(input: $input) {
    teachingBlocks {
      ..._TeachingBlockFragment
    }
  }
}
    ${_TeachingBlockFragmentFragmentDoc}`;

export function use_CreateTeachingBlocksMutation() {
  return Urql.useMutation<_CreateTeachingBlocksMutation, _CreateTeachingBlocksMutationVariables>(
    _CreateTeachingBlocksDocument,
  );
}
export const _DeleteTeachingBlocksDocument = gql`
    mutation _DeleteTeachingBlocks($where: TeachingBlockWhere, $delete: TeachingBlockDeleteInput) {
  deleteTeachingBlocks(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTeachingBlocksMutation() {
  return Urql.useMutation<_DeleteTeachingBlocksMutation, _DeleteTeachingBlocksMutationVariables>(
    _DeleteTeachingBlocksDocument,
  );
}
export const _CreateSubjectContainersDocument = gql`
    mutation _CreateSubjectContainers($input: [SubjectContainerCreateInput!]!) {
  createSubjectContainers(input: $input) {
    subjectContainers {
      ..._SubjectContainerFragment
    }
  }
}
    ${_SubjectContainerFragmentFragmentDoc}`;

export function use_CreateSubjectContainersMutation() {
  return Urql.useMutation<_CreateSubjectContainersMutation, _CreateSubjectContainersMutationVariables>(
    _CreateSubjectContainersDocument,
  );
}
export const _UpdateTimetableVersionsDocument = gql`
    mutation _UpdateTimetableVersions($where: TimetableVersionWhere, $update: TimetableVersionUpdateInput) {
  updateTimetableVersions(where: $where, update: $update) {
    timetableVersions {
      ..._TimetableVersion
    }
  }
}
    ${_TimetableVersionFragmentDoc}`;

export function use_UpdateTimetableVersionsMutation() {
  return Urql.useMutation<_UpdateTimetableVersionsMutation, _UpdateTimetableVersionsMutationVariables>(
    _UpdateTimetableVersionsDocument,
  );
}
export const _DeleteTimetableVersionsDocument = gql`
    mutation _DeleteTimetableVersions($where: TimetableVersionWhere, $delete: TimetableVersionDeleteInput!) {
  deleteTimetableVersions(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTimetableVersionsMutation() {
  return Urql.useMutation<_DeleteTimetableVersionsMutation, _DeleteTimetableVersionsMutationVariables>(
    _DeleteTimetableVersionsDocument,
  );
}
export const _DeleteTimetablesDocument = gql`
    mutation _DeleteTimetables($where: TimetableWhere, $delete: TimetableDeleteInput) {
  deleteTimetables(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function use_DeleteTimetablesMutation() {
  return Urql.useMutation<_DeleteTimetablesMutation, _DeleteTimetablesMutationVariables>(_DeleteTimetablesDocument);
}
export const UsedInLessonDocument = gql`
    query UsedInLesson($lessonWhere: LessonWhere) {
  lessons(where: $lessonWhere) {
    onlyInTimetableVersion
    uuid
    subject {
      ... on Subject {
        uuid
        name
      }
      ... on SubjectContainer {
        uuid
        name
      }
    }
    versions {
      uuid
      version
      timetable {
        uuid
        name
      }
    }
    lessonUnitConnection {
      edges {
        node {
          uuid
          subjectContainer {
            uuid
          }
        }
      }
    }
    lessonClassesConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          class {
            uuid
            shortName
          }
          usedDivision {
            uuid
          }
          groups {
            uuid
          }
        }
      }
    }
    teachersConnection(sort: {edge: {order: ASC}}) {
      edges {
        node {
          uuid
        }
      }
    }
    roomSupplyConnection(sort: {edge: {order: ASC}}) {
      edges {
        properties {
          descriptions
        }
        node {
          uuid
          name
        }
      }
    }
  }
}
    `;

export function useUsedInLessonQuery(options?: Omit<Urql.UseQueryArgs<UsedInLessonQueryVariables>, 'query'>) {
  return Urql.useQuery<UsedInLessonQuery, UsedInLessonQueryVariables>({ query: UsedInLessonDocument, ...options });
}
export const UsedInCurriculaDocument = gql`
    query UsedInCurricula($curriculaWhere: CurriculumWhere) {
  curricula(where: $curriculaWhere) {
    uuid
    subject {
      ... on Subject {
        uuid
        name
      }
      ... on SubjectContainer {
        uuid
        name
      }
    }
    roomSupplyConnection(sort: {edge: {order: ASC}}) {
      edges {
        properties {
          descriptions
        }
        node {
          uuid
          name
        }
      }
    }
  }
}
    `;

export function useUsedInCurriculaQuery(options?: Omit<Urql.UseQueryArgs<UsedInCurriculaQueryVariables>, 'query'>) {
  return Urql.useQuery<UsedInCurriculaQuery, UsedInCurriculaQueryVariables>({
    query: UsedInCurriculaDocument,
    ...options,
  });
}
export const EventJobsDocument = gql`
    query EventJobs($where: EventJobWhere, $options: EventJobOptions) {
  eventJobs(where: $where, options: $options) {
    uuid
    organizationUuid
    to
    from
    processed
    status
    createdAt
  }
}
    `;

export function useEventJobsQuery(options?: Omit<Urql.UseQueryArgs<EventJobsQueryVariables>, 'query'>) {
  return Urql.useQuery<EventJobsQuery, EventJobsQueryVariables>({ query: EventJobsDocument, ...options });
}
export const CountOrganisationEventsForRangeDocument = gql`
    query CountOrganisationEventsForRange($organizationUuid: ID!, $start: DateTime!, $end: DateTime!) {
  eventsConnection(
    where: {start_LTE: $end, end_GTE: $start, organization: {uuid: $organizationUuid}}
  ) {
    totalCount
  }
}
    `;

export function useCountOrganisationEventsForRangeQuery(
  options: Omit<Urql.UseQueryArgs<CountOrganisationEventsForRangeQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CountOrganisationEventsForRangeQuery, CountOrganisationEventsForRangeQueryVariables>({
    query: CountOrganisationEventsForRangeDocument,
    ...options,
  });
}
export const DeleteLessonClassesDocument = gql`
    mutation DeleteLessonClasses($where: LessonClassWhere, $delete: LessonClassDeleteInput) {
  deleteLessonClasses(where: $where, delete: $delete) {
    __typename
  }
}
    `;

export function useDeleteLessonClassesMutation() {
  return Urql.useMutation<DeleteLessonClassesMutation, DeleteLessonClassesMutationVariables>(
    DeleteLessonClassesDocument,
  );
}
export const DeleteAdditionalTeachingLoadsDocument = gql`
    mutation DeleteAdditionalTeachingLoads($uuid: ID!) {
  deleteAdditionalTeachingLoads(where: {uuid: $uuid}) {
    relationshipsDeleted
    nodesDeleted
  }
}
    `;

export function useDeleteAdditionalTeachingLoadsMutation() {
  return Urql.useMutation<DeleteAdditionalTeachingLoadsMutation, DeleteAdditionalTeachingLoadsMutationVariables>(
    DeleteAdditionalTeachingLoadsDocument,
  );
}
export const CreateAdditionalTeachingLoadsDocument = gql`
    mutation CreateAdditionalTeachingLoads($input: [AdditionalTeachingLoadCreateInput!]!) {
  createAdditionalTeachingLoads(input: $input) {
    info {
      nodesCreated
      relationshipsCreated
    }
  }
}
    `;

export function useCreateAdditionalTeachingLoadsMutation() {
  return Urql.useMutation<CreateAdditionalTeachingLoadsMutation, CreateAdditionalTeachingLoadsMutationVariables>(
    CreateAdditionalTeachingLoadsDocument,
  );
}
export const UpdateAdditionalTeachingLoadDocument = gql`
    mutation UpdateAdditionalTeachingLoad($update: AdditionalTeachingLoadUpdateInput!, $uuid: ID!) {
  updateAdditionalTeachingLoads(update: $update, where: {uuid: $uuid}) {
    info {
      nodesCreated
      relationshipsCreated
      nodesDeleted
    }
  }
}
    `;

export function useUpdateAdditionalTeachingLoadMutation() {
  return Urql.useMutation<UpdateAdditionalTeachingLoadMutation, UpdateAdditionalTeachingLoadMutationVariables>(
    UpdateAdditionalTeachingLoadDocument,
  );
}
export const AdditionalTeachingLoadsListDocument = gql`
    query AdditionalTeachingLoadsList($organizationUuid: ID!, $schoolyear: ID!, $teacherUuid: ID) {
  additionalTeachingLoads(
    where: {organization: {uuid: $organizationUuid}, schoolYear: {uuid: $schoolyear}, teacher: {uuid: $teacherUuid}}
    options: {sort: {teacherListName: ASC}}
  ) {
    uuid
    comment
    hours
    hoursRaw
    class {
      uuid
      name
    }
    teacher {
      uuid
      listName
    }
    teacherListName
    subject {
      uuid
      name
    }
  }
}
    `;

export function useAdditionalTeachingLoadsListQuery(
  options: Omit<Urql.UseQueryArgs<AdditionalTeachingLoadsListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<AdditionalTeachingLoadsListQuery, AdditionalTeachingLoadsListQueryVariables>({
    query: AdditionalTeachingLoadsListDocument,
    ...options,
  });
}
export const ConnectEntityWithVersionDocument = gql`
    mutation ConnectEntityWithVersion($organizationUuid: ID!, $versionUuid: ID!, $entityType: String!) {
  connectEntityWithVersion(
    organizationUuid: $organizationUuid
    versionUuid: $versionUuid
    entityType: $entityType
  ) {
    entitiesUpdated
  }
}
    `;

export function useConnectEntityWithVersionMutation() {
  return Urql.useMutation<ConnectEntityWithVersionMutation, ConnectEntityWithVersionMutationVariables>(
    ConnectEntityWithVersionDocument,
  );
}
export const CreateUserConfigDocument = gql`
    mutation CreateUserConfig($pimProfileUuid: ID!) {
  createUserConfigs(input: {pimProfileUuid: $pimProfileUuid}) {
    userConfigs {
      ...UserConfigFragment
    }
  }
}
    ${UserConfigFragmentFragmentDoc}`;

export function useCreateUserConfigMutation() {
  return Urql.useMutation<CreateUserConfigMutation, CreateUserConfigMutationVariables>(CreateUserConfigDocument);
}
export const UpdateUserConfigSchoolYearDocument = gql`
    mutation UpdateUserConfigSchoolYear($schoolYearUuid: ID!, $pimProfileUuid: ID!) {
  updateUserConfigs(
    where: {pimProfileUuid: $pimProfileUuid}
    update: {schoolYear: {disconnect: {}, connect: {where: {node: {uuid: $schoolYearUuid}}}}}
  ) {
    info {
      relationshipsCreated
    }
  }
}
    `;

export function useUpdateUserConfigSchoolYearMutation() {
  return Urql.useMutation<UpdateUserConfigSchoolYearMutation, UpdateUserConfigSchoolYearMutationVariables>(
    UpdateUserConfigSchoolYearDocument,
  );
}
export const UpdateUserConfigDocument = gql`
    mutation UpdateUserConfig($pimProfileUuid: ID!, $update: UserConfigUpdateInput) {
  updateUserConfigs(where: {pimProfileUuid: $pimProfileUuid}, update: $update) {
    userConfigs {
      ...UserConfigFragment
    }
  }
}
    ${UserConfigFragmentFragmentDoc}`;

export function useUpdateUserConfigMutation() {
  return Urql.useMutation<UpdateUserConfigMutation, UpdateUserConfigMutationVariables>(UpdateUserConfigDocument);
}
export const ClassGridCardsDocument = gql`
    query ClassGridCards($where: TimetableCardWhere) {
  classGridCards(where: $where) {
    uuid
    timetableCardUuid
    classUuid
    lessonUuid
    divisionsCount
    colors
    locked
    duration
    endTimeGridEntryUuid
    startTimeGridEntryUuid
    weekday
    cssHeight
    cssGradientString
    usedPosition
    cssTop
    textColor
  }
}
    `;

export function useClassGridCardsQuery(options?: Omit<Urql.UseQueryArgs<ClassGridCardsQueryVariables>, 'query'>) {
  return Urql.useQuery<ClassGridCardsQuery, ClassGridCardsQueryVariables>({
    query: ClassGridCardsDocument,
    ...options,
  });
}
export const TimetableCardAvailabilitiesDocument = gql`
    query TimetableCardAvailabilities($timetableCardUuids: [ID!]!, $versionUuid: ID!) {
  timetableCardAvailabilities(
    timetableCardUuids: $timetableCardUuids
    versionUuid: $versionUuid
  ) {
    mon
    tue
    wed
    thu
    fri
    sat
    sun
    timetableCardUuid
  }
}
    `;

export function useTimetableCardAvailabilitiesQuery(
  options: Omit<Urql.UseQueryArgs<TimetableCardAvailabilitiesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<TimetableCardAvailabilitiesQuery, TimetableCardAvailabilitiesQueryVariables>({
    query: TimetableCardAvailabilitiesDocument,
    ...options,
  });
}
export const GetUserConfigsDocument = gql`
    query GetUserConfigs($pimProfileUuid: ID) {
  userConfigs(where: {pimProfileUuid: $pimProfileUuid}) {
    ...UserConfigFragment
  }
}
    ${UserConfigFragmentFragmentDoc}`;

export function useGetUserConfigsQuery(options?: Omit<Urql.UseQueryArgs<GetUserConfigsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserConfigsQuery, GetUserConfigsQueryVariables>({
    query: GetUserConfigsDocument,
    ...options,
  });
}
